
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea099"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea099"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4vwom", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $34832f06e1b6f7fc$export$ffb0004e005737fa; });
$parcel$export(module.exports, "jsx", function () { return $34832f06e1b6f7fc$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $34832f06e1b6f7fc$export$25062201e9e25d76; });

var $dRzna = parcelRequire("dRzna");

var $8ZuUP = parcelRequire("8ZuUP");
parcelRequire("eeH7J");
parcelRequire("gc3M0");
parcelRequire("eq7pw");
parcelRequire("6q2Od");

parcelRequire("3ojZ1");
parcelRequire("7sOZt");
parcelRequire("47KoV");
parcelRequire("5ziuZ");
var $34832f06e1b6f7fc$export$ffb0004e005737fa = $dRzna.Fragment;
function $34832f06e1b6f7fc$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $8ZuUP.h).call(props, "css")) return $dRzna.jsx(type, props, key);
    return $dRzna.jsx((0, $8ZuUP.E), (0, $8ZuUP.c)(type, props), key);
}
function $34832f06e1b6f7fc$export$25062201e9e25d76(type, props, key) {
    if (!(0, $8ZuUP.h).call(props, "css")) return $dRzna.jsxs(type, props, key);
    return $dRzna.jsxs((0, $8ZuUP.E), (0, $8ZuUP.c)(type, props), key);
}

});
parcelRegister("dRzna", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fYWky"));

});
parcelRegister("fYWky", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ba29b4d88c039d9b$export$ffb0004e005737fa; }, function (v) { return $ba29b4d88c039d9b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ba29b4d88c039d9b$export$34b9dba7ce09269b; }, function (v) { return $ba29b4d88c039d9b$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ba29b4d88c039d9b$export$25062201e9e25d76; }, function (v) { return $ba29b4d88c039d9b$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ba29b4d88c039d9b$export$ffb0004e005737fa;
var $ba29b4d88c039d9b$export$34b9dba7ce09269b;
var $ba29b4d88c039d9b$export$25062201e9e25d76;
"use strict";

var $eeH7J = parcelRequire("eeH7J");
var $ba29b4d88c039d9b$var$k = Symbol.for("react.element"), $ba29b4d88c039d9b$var$l = Symbol.for("react.fragment"), $ba29b4d88c039d9b$var$m = Object.prototype.hasOwnProperty, $ba29b4d88c039d9b$var$n = $eeH7J.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $ba29b4d88c039d9b$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ba29b4d88c039d9b$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$ba29b4d88c039d9b$var$m.call(a, b) && !$ba29b4d88c039d9b$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $ba29b4d88c039d9b$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $ba29b4d88c039d9b$var$n.current
    };
}
$ba29b4d88c039d9b$export$ffb0004e005737fa = $ba29b4d88c039d9b$var$l;
$ba29b4d88c039d9b$export$34b9dba7ce09269b = $ba29b4d88c039d9b$var$q;
$ba29b4d88c039d9b$export$25062201e9e25d76 = $ba29b4d88c039d9b$var$q;

});
parcelRegister("eeH7J", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7q6Dx"));

});
parcelRegister("7q6Dx", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $56701c02768f210b$export$dca3b0875bd9a954; }, function (v) { return $56701c02768f210b$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $56701c02768f210b$export$16fa2f45be04daa8; }, function (v) { return $56701c02768f210b$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $56701c02768f210b$export$ffb0004e005737fa; }, function (v) { return $56701c02768f210b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $56701c02768f210b$export$e2c29f18771995cb; }, function (v) { return $56701c02768f210b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $56701c02768f210b$export$221d75b3f55bb0bd; }, function (v) { return $56701c02768f210b$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $56701c02768f210b$export$5f8d39834fd61797; }, function (v) { return $56701c02768f210b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $56701c02768f210b$export$74bf444e3cd11ea5; }, function (v) { return $56701c02768f210b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $56701c02768f210b$export$ae55be85d98224ed; }, function (v) { return $56701c02768f210b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $56701c02768f210b$export$3ba232387fd5d6dd; }, function (v) { return $56701c02768f210b$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $56701c02768f210b$export$e530037191fcd5d7; }, function (v) { return $56701c02768f210b$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $56701c02768f210b$export$fd42f52fd3ae1109; }, function (v) { return $56701c02768f210b$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $56701c02768f210b$export$c8a8987d4410bf2d; }, function (v) { return $56701c02768f210b$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $56701c02768f210b$export$d38cd72104c1f0e9; }, function (v) { return $56701c02768f210b$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $56701c02768f210b$export$7d1e3a5e95ceca43; }, function (v) { return $56701c02768f210b$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $56701c02768f210b$export$257a8862b851cb5b; }, function (v) { return $56701c02768f210b$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $56701c02768f210b$export$a8257692ac88316c; }, function (v) { return $56701c02768f210b$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $56701c02768f210b$export$488013bae63b21da; }, function (v) { return $56701c02768f210b$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $56701c02768f210b$export$7c73462e0d25e514; }, function (v) { return $56701c02768f210b$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $56701c02768f210b$export$7568632d0d33d16d; }, function (v) { return $56701c02768f210b$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $56701c02768f210b$export$88948ce120ea2619; }, function (v) { return $56701c02768f210b$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $56701c02768f210b$export$35808ee640e87ca7; }, function (v) { return $56701c02768f210b$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $56701c02768f210b$export$fae74005e78b1a27; }, function (v) { return $56701c02768f210b$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $56701c02768f210b$export$dc8fbce3eb94dc1e; }, function (v) { return $56701c02768f210b$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $56701c02768f210b$export$6a7bc4e911dc01cf; }, function (v) { return $56701c02768f210b$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $56701c02768f210b$export$6d9c69b0de29b591; }, function (v) { return $56701c02768f210b$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $56701c02768f210b$export$f680877a34711e37; }, function (v) { return $56701c02768f210b$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $56701c02768f210b$export$d5a552a76deda3c2; }, function (v) { return $56701c02768f210b$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $56701c02768f210b$export$aaabe4eda9ed9969; }, function (v) { return $56701c02768f210b$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $56701c02768f210b$export$e5c5a5f917a5871c; }, function (v) { return $56701c02768f210b$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $56701c02768f210b$export$1538c33de8887b59; }, function (v) { return $56701c02768f210b$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $56701c02768f210b$export$13e3392192263954; }, function (v) { return $56701c02768f210b$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $56701c02768f210b$export$b8f5890fc79d6aca; }, function (v) { return $56701c02768f210b$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $56701c02768f210b$export$60241385465d0a34; }, function (v) { return $56701c02768f210b$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $56701c02768f210b$export$306c0aa65ff9ec16; }, function (v) { return $56701c02768f210b$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $56701c02768f210b$export$7b286972b8d8ccbf; }, function (v) { return $56701c02768f210b$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $56701c02768f210b$export$83d89fbfd8236492; }, function (v) { return $56701c02768f210b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $56701c02768f210b$export$dca3b0875bd9a954;
var $56701c02768f210b$export$16fa2f45be04daa8;
var $56701c02768f210b$export$ffb0004e005737fa;
var $56701c02768f210b$export$e2c29f18771995cb;
var $56701c02768f210b$export$221d75b3f55bb0bd;
var $56701c02768f210b$export$5f8d39834fd61797;
var $56701c02768f210b$export$74bf444e3cd11ea5;
var $56701c02768f210b$export$ae55be85d98224ed;
var $56701c02768f210b$export$3ba232387fd5d6dd;
var $56701c02768f210b$export$e530037191fcd5d7;
var $56701c02768f210b$export$fd42f52fd3ae1109;
var $56701c02768f210b$export$c8a8987d4410bf2d;
var $56701c02768f210b$export$d38cd72104c1f0e9;
var $56701c02768f210b$export$7d1e3a5e95ceca43;
var $56701c02768f210b$export$257a8862b851cb5b;
var $56701c02768f210b$export$a8257692ac88316c;
var $56701c02768f210b$export$488013bae63b21da;
var $56701c02768f210b$export$7c73462e0d25e514;
var $56701c02768f210b$export$7568632d0d33d16d;
var $56701c02768f210b$export$88948ce120ea2619;
var $56701c02768f210b$export$35808ee640e87ca7;
var $56701c02768f210b$export$fae74005e78b1a27;
var $56701c02768f210b$export$dc8fbce3eb94dc1e;
var $56701c02768f210b$export$6a7bc4e911dc01cf;
var $56701c02768f210b$export$6d9c69b0de29b591;
var $56701c02768f210b$export$f680877a34711e37;
var $56701c02768f210b$export$d5a552a76deda3c2;
var $56701c02768f210b$export$aaabe4eda9ed9969;
var $56701c02768f210b$export$e5c5a5f917a5871c;
var $56701c02768f210b$export$1538c33de8887b59;
var $56701c02768f210b$export$13e3392192263954;
var $56701c02768f210b$export$b8f5890fc79d6aca;
var $56701c02768f210b$export$60241385465d0a34;
var $56701c02768f210b$export$306c0aa65ff9ec16;
var $56701c02768f210b$export$7b286972b8d8ccbf;
var $56701c02768f210b$export$83d89fbfd8236492;
"use strict";
var $56701c02768f210b$var$l = Symbol.for("react.element"), $56701c02768f210b$var$n = Symbol.for("react.portal"), $56701c02768f210b$var$p = Symbol.for("react.fragment"), $56701c02768f210b$var$q = Symbol.for("react.strict_mode"), $56701c02768f210b$var$r = Symbol.for("react.profiler"), $56701c02768f210b$var$t = Symbol.for("react.provider"), $56701c02768f210b$var$u = Symbol.for("react.context"), $56701c02768f210b$var$v = Symbol.for("react.forward_ref"), $56701c02768f210b$var$w = Symbol.for("react.suspense"), $56701c02768f210b$var$x = Symbol.for("react.memo"), $56701c02768f210b$var$y = Symbol.for("react.lazy"), $56701c02768f210b$var$z = Symbol.iterator;
function $56701c02768f210b$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $56701c02768f210b$var$z && a[$56701c02768f210b$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $56701c02768f210b$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $56701c02768f210b$var$C = Object.assign, $56701c02768f210b$var$D = {};
function $56701c02768f210b$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $56701c02768f210b$var$D;
    this.updater = e || $56701c02768f210b$var$B;
}
$56701c02768f210b$var$E.prototype.isReactComponent = {};
$56701c02768f210b$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$56701c02768f210b$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $56701c02768f210b$var$F() {}
$56701c02768f210b$var$F.prototype = $56701c02768f210b$var$E.prototype;
function $56701c02768f210b$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $56701c02768f210b$var$D;
    this.updater = e || $56701c02768f210b$var$B;
}
var $56701c02768f210b$var$H = $56701c02768f210b$var$G.prototype = new $56701c02768f210b$var$F;
$56701c02768f210b$var$H.constructor = $56701c02768f210b$var$G;
$56701c02768f210b$var$C($56701c02768f210b$var$H, $56701c02768f210b$var$E.prototype);
$56701c02768f210b$var$H.isPureReactComponent = !0;
var $56701c02768f210b$var$I = Array.isArray, $56701c02768f210b$var$J = Object.prototype.hasOwnProperty, $56701c02768f210b$var$K = {
    current: null
}, $56701c02768f210b$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $56701c02768f210b$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$56701c02768f210b$var$J.call(b, d) && !$56701c02768f210b$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $56701c02768f210b$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $56701c02768f210b$var$K.current
    };
}
function $56701c02768f210b$var$N(a, b) {
    return {
        $$typeof: $56701c02768f210b$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $56701c02768f210b$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $56701c02768f210b$var$l;
}
function $56701c02768f210b$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $56701c02768f210b$var$P = /\/+/g;
function $56701c02768f210b$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $56701c02768f210b$var$escape("" + a.key) : b.toString(36);
}
function $56701c02768f210b$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $56701c02768f210b$var$l:
                case $56701c02768f210b$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $56701c02768f210b$var$Q(h, 0) : d, $56701c02768f210b$var$I(c) ? (e = "", null != a && (e = a.replace($56701c02768f210b$var$P, "$&/") + "/"), $56701c02768f210b$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($56701c02768f210b$var$O(c) && (c = $56701c02768f210b$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($56701c02768f210b$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($56701c02768f210b$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $56701c02768f210b$var$Q(k, g);
        h += $56701c02768f210b$var$R(k, b, e, f, c);
    }
    else if (f = $56701c02768f210b$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $56701c02768f210b$var$Q(k, g++), h += $56701c02768f210b$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $56701c02768f210b$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $56701c02768f210b$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $56701c02768f210b$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $56701c02768f210b$var$U = {
    current: null
}, $56701c02768f210b$var$V = {
    transition: null
}, $56701c02768f210b$var$W = {
    ReactCurrentDispatcher: $56701c02768f210b$var$U,
    ReactCurrentBatchConfig: $56701c02768f210b$var$V,
    ReactCurrentOwner: $56701c02768f210b$var$K
};
function $56701c02768f210b$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$56701c02768f210b$export$dca3b0875bd9a954 = {
    map: $56701c02768f210b$var$S,
    forEach: function(a, b, e) {
        $56701c02768f210b$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $56701c02768f210b$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $56701c02768f210b$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$56701c02768f210b$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$56701c02768f210b$export$16fa2f45be04daa8 = $56701c02768f210b$var$E;
$56701c02768f210b$export$ffb0004e005737fa = $56701c02768f210b$var$p;
$56701c02768f210b$export$e2c29f18771995cb = $56701c02768f210b$var$r;
$56701c02768f210b$export$221d75b3f55bb0bd = $56701c02768f210b$var$G;
$56701c02768f210b$export$5f8d39834fd61797 = $56701c02768f210b$var$q;
$56701c02768f210b$export$74bf444e3cd11ea5 = $56701c02768f210b$var$w;
$56701c02768f210b$export$ae55be85d98224ed = $56701c02768f210b$var$W;
$56701c02768f210b$export$3ba232387fd5d6dd = $56701c02768f210b$var$X;
$56701c02768f210b$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $56701c02768f210b$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $56701c02768f210b$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$56701c02768f210b$var$J.call(b, f) && !$56701c02768f210b$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $56701c02768f210b$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$56701c02768f210b$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $56701c02768f210b$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $56701c02768f210b$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$56701c02768f210b$export$c8a8987d4410bf2d = $56701c02768f210b$var$M;
$56701c02768f210b$export$d38cd72104c1f0e9 = function(a) {
    var b = $56701c02768f210b$var$M.bind(null, a);
    b.type = a;
    return b;
};
$56701c02768f210b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$56701c02768f210b$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $56701c02768f210b$var$v,
        render: a
    };
};
$56701c02768f210b$export$a8257692ac88316c = $56701c02768f210b$var$O;
$56701c02768f210b$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $56701c02768f210b$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $56701c02768f210b$var$T
    };
};
$56701c02768f210b$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $56701c02768f210b$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$56701c02768f210b$export$7568632d0d33d16d = function(a) {
    var b = $56701c02768f210b$var$V.transition;
    $56701c02768f210b$var$V.transition = {};
    try {
        a();
    } finally{
        $56701c02768f210b$var$V.transition = b;
    }
};
$56701c02768f210b$export$88948ce120ea2619 = $56701c02768f210b$var$X;
$56701c02768f210b$export$35808ee640e87ca7 = function(a, b) {
    return $56701c02768f210b$var$U.current.useCallback(a, b);
};
$56701c02768f210b$export$fae74005e78b1a27 = function(a) {
    return $56701c02768f210b$var$U.current.useContext(a);
};
$56701c02768f210b$export$dc8fbce3eb94dc1e = function() {};
$56701c02768f210b$export$6a7bc4e911dc01cf = function(a) {
    return $56701c02768f210b$var$U.current.useDeferredValue(a);
};
$56701c02768f210b$export$6d9c69b0de29b591 = function(a, b) {
    return $56701c02768f210b$var$U.current.useEffect(a, b);
};
$56701c02768f210b$export$f680877a34711e37 = function() {
    return $56701c02768f210b$var$U.current.useId();
};
$56701c02768f210b$export$d5a552a76deda3c2 = function(a, b, e) {
    return $56701c02768f210b$var$U.current.useImperativeHandle(a, b, e);
};
$56701c02768f210b$export$aaabe4eda9ed9969 = function(a, b) {
    return $56701c02768f210b$var$U.current.useInsertionEffect(a, b);
};
$56701c02768f210b$export$e5c5a5f917a5871c = function(a, b) {
    return $56701c02768f210b$var$U.current.useLayoutEffect(a, b);
};
$56701c02768f210b$export$1538c33de8887b59 = function(a, b) {
    return $56701c02768f210b$var$U.current.useMemo(a, b);
};
$56701c02768f210b$export$13e3392192263954 = function(a, b, e) {
    return $56701c02768f210b$var$U.current.useReducer(a, b, e);
};
$56701c02768f210b$export$b8f5890fc79d6aca = function(a) {
    return $56701c02768f210b$var$U.current.useRef(a);
};
$56701c02768f210b$export$60241385465d0a34 = function(a) {
    return $56701c02768f210b$var$U.current.useState(a);
};
$56701c02768f210b$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $56701c02768f210b$var$U.current.useSyncExternalStore(a, b, e);
};
$56701c02768f210b$export$7b286972b8d8ccbf = function() {
    return $56701c02768f210b$var$U.current.useTransition();
};
$56701c02768f210b$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("8ZuUP", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $68bc00712ca02027$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $68bc00712ca02027$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $68bc00712ca02027$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $68bc00712ca02027$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $68bc00712ca02027$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $68bc00712ca02027$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $68bc00712ca02027$export$a9c23c6ac3fc3eca; });

var $eeH7J = parcelRequire("eeH7J");

var $gc3M0 = parcelRequire("gc3M0");

var $h4XE0 = parcelRequire("h4XE0");

var $6q2Od = parcelRequire("6q2Od");

var $eU7V2 = parcelRequire("eU7V2");

var $7sOZt = parcelRequire("7sOZt");

var $47KoV = parcelRequire("47KoV");

var $5ziuZ = parcelRequire("5ziuZ");
var $68bc00712ca02027$export$23f2a1d2818174ef = true;
var $68bc00712ca02027$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $68bc00712ca02027$var$EmotionCacheContext = /* #__PURE__ */ $eeH7J.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $gc3M0.default)({
    key: "css"
}) : null);
var $68bc00712ca02027$export$e7094788287c5e9b = $68bc00712ca02027$var$EmotionCacheContext.Provider;
var $68bc00712ca02027$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $eeH7J.useContext)($68bc00712ca02027$var$EmotionCacheContext);
};
var $68bc00712ca02027$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $eeH7J.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $eeH7J.useContext)($68bc00712ca02027$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$68bc00712ca02027$export$23f2a1d2818174ef) $68bc00712ca02027$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $eeH7J.useContext)($68bc00712ca02027$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $gc3M0.default)({
                key: "css"
            });
            return /*#__PURE__*/ $eeH7J.createElement($68bc00712ca02027$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $68bc00712ca02027$export$971d5caa766a69d7 = /* #__PURE__ */ $eeH7J.createContext({});
var $68bc00712ca02027$export$3b14a55fb2447963 = function useTheme() {
    return $eeH7J.useContext($68bc00712ca02027$export$971d5caa766a69d7);
};
var $68bc00712ca02027$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $h4XE0.default)({}, outerTheme, theme);
};
var $68bc00712ca02027$var$createCacheWithTheme = /* #__PURE__ */ (0, $6q2Od.default)(function(outerTheme) {
    return (0, $6q2Od.default)(function(theme) {
        return $68bc00712ca02027$var$getTheme(outerTheme, theme);
    });
});
var $68bc00712ca02027$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $eeH7J.useContext($68bc00712ca02027$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $68bc00712ca02027$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $eeH7J.createElement($68bc00712ca02027$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $68bc00712ca02027$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $eeH7J.useContext($68bc00712ca02027$export$971d5caa766a69d7);
        return /*#__PURE__*/ $eeH7J.createElement(Component, (0, $h4XE0.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $eeH7J.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $eU7V2.default)(WithTheme, Component);
}
var $68bc00712ca02027$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $68bc00712ca02027$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $68bc00712ca02027$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $68bc00712ca02027$var$getLastPart(match[1]);
    return undefined;
};
var $68bc00712ca02027$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $68bc00712ca02027$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $68bc00712ca02027$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $68bc00712ca02027$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($68bc00712ca02027$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $68bc00712ca02027$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $68bc00712ca02027$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $68bc00712ca02027$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $68bc00712ca02027$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($68bc00712ca02027$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$68bc00712ca02027$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $68bc00712ca02027$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7sOZt.registerStyles)(cache, serialized, isStringTag);
    (0, $5ziuZ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7sOZt.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $68bc00712ca02027$var$Emotion = /* #__PURE__ */ $68bc00712ca02027$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$68bc00712ca02027$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $7sOZt.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $47KoV.serializeStyles)(registeredStyles, undefined, $eeH7J.useContext($68bc00712ca02027$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($68bc00712ca02027$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $68bc00712ca02027$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement($68bc00712ca02027$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $eeH7J.createElement(WrappedComponent, newProps));
});
var $68bc00712ca02027$export$a9c23c6ac3fc3eca = $68bc00712ca02027$var$Emotion;

});
parcelRegister("gc3M0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bca0b19df9b66c20$export$2e2bcd8739ae039; });

var $cjyHC = parcelRequire("cjyHC");

var $8SDLF = parcelRequire("8SDLF");
parcelRequire("6q2Od");
parcelRequire("d5hMW");
var $bca0b19df9b66c20$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $8SDLF.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $8SDLF.token)(character)) break;
        (0, $8SDLF.next)();
    }
    return (0, $8SDLF.slice)(begin, (0, $8SDLF.position));
};
var $bca0b19df9b66c20$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $8SDLF.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $8SDLF.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $bca0b19df9b66c20$var$identifierWithPointTracking((0, $8SDLF.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $8SDLF.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $8SDLF.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $8SDLF.from)(character);
    }
    while (character = (0, $8SDLF.next)());
    return parsed;
};
var $bca0b19df9b66c20$var$getRules = function getRules(value, points) {
    return (0, $8SDLF.dealloc)($bca0b19df9b66c20$var$toRules((0, $8SDLF.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $bca0b19df9b66c20$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $bca0b19df9b66c20$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$bca0b19df9b66c20$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $bca0b19df9b66c20$var$fixedElements.set(element, true);
    var points = [];
    var rules = $bca0b19df9b66c20$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $bca0b19df9b66c20$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $bca0b19df9b66c20$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $bca0b19df9b66c20$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($bca0b19df9b66c20$var$ignoreFlag) > -1;
};
var $bca0b19df9b66c20$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($bca0b19df9b66c20$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $bca0b19df9b66c20$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $bca0b19df9b66c20$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$bca0b19df9b66c20$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $bca0b19df9b66c20$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $bca0b19df9b66c20$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$bca0b19df9b66c20$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $bca0b19df9b66c20$var$nullifyElement(element);
    } else if ($bca0b19df9b66c20$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $bca0b19df9b66c20$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $bca0b19df9b66c20$var$prefix(value, length) {
    switch((0, $8SDLF.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $8SDLF.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $8SDLF.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MOZ) + value + (0, $8SDLF.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + value + value;
        // order
        case 6165:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.replace)(value, /(\w+).+(:[^]+)/, (0, $8SDLF.WEBKIT) + "box-$1$2" + (0, $8SDLF.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + "flex-item-" + (0, $8SDLF.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + "flex-line-pack" + (0, $8SDLF.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $8SDLF.WEBKIT) + "box-" + (0, $8SDLF.replace)(value, "-grow", "") + (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $8SDLF.WEBKIT) + (0, $8SDLF.replace)(value, /([^-])(transform)/g, "$1" + (0, $8SDLF.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $8SDLF.replace)((0, $8SDLF.replace)((0, $8SDLF.replace)(value, /(zoom-|grab)/, (0, $8SDLF.WEBKIT) + "$1"), /(image-set)/, (0, $8SDLF.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $8SDLF.replace)(value, /(image-set\([^]*)/, (0, $8SDLF.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $8SDLF.replace)((0, $8SDLF.replace)(value, /(.+:)(flex-)?(.*)/, (0, $8SDLF.WEBKIT) + "box-pack:$3" + (0, $8SDLF.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $8SDLF.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $8SDLF.replace)(value, /(.+)-inline(.+)/, (0, $8SDLF.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $8SDLF.strlen)(value) - 1 - length > 6) switch((0, $8SDLF.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $8SDLF.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $8SDLF.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $8SDLF.WEBKIT) + "$2-$3" + "$1" + (0, $8SDLF.MOZ) + ((0, $8SDLF.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $8SDLF.indexof)(value, "stretch") ? $bca0b19df9b66c20$var$prefix((0, $8SDLF.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $8SDLF.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $8SDLF.charat)(value, (0, $8SDLF.strlen)(value) - 3 - (~(0, $8SDLF.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $8SDLF.replace)(value, ":", ":" + (0, $8SDLF.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $8SDLF.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $8SDLF.WEBKIT) + ((0, $8SDLF.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $8SDLF.WEBKIT) + "$2$3" + "$1" + (0, $8SDLF.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $8SDLF.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + value + value;
    }
    return value;
}
var $bca0b19df9b66c20$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $8SDLF.DECLARATION:
                element["return"] = $bca0b19df9b66c20$var$prefix(element.value, element.length);
                break;
            case 0, $8SDLF.KEYFRAMES:
                return (0, $8SDLF.serialize)([
                    (0, $8SDLF.copy)(element, {
                        value: (0, $8SDLF.replace)(element.value, "@", "@" + (0, $8SDLF.WEBKIT))
                    })
                ], callback);
            case 0, $8SDLF.RULESET:
                if (element.length) return (0, $8SDLF.combine)(element.props, function(value) {
                    switch((0, $8SDLF.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $8SDLF.serialize)([
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(read-\w+)/, ":" + (0, $8SDLF.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $8SDLF.serialize)([
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(plac\w+)/, ":" + (0, $8SDLF.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(plac\w+)/, ":" + (0, $8SDLF.MOZ) + "$1")
                                    ]
                                }),
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(plac\w+)/, (0, $8SDLF.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $bca0b19df9b66c20$var$defaultStylisPlugins = [
    $bca0b19df9b66c20$var$prefixer
];
var $bca0b19df9b66c20$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $bca0b19df9b66c20$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $bca0b19df9b66c20$var$compat,
        $bca0b19df9b66c20$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $8SDLF.stringify),
        (0, $8SDLF.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $8SDLF.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $8SDLF.serialize)((0, $8SDLF.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $cjyHC.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("cjyHC", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $8f722d9af4d4d346$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $8f722d9af4d4d346$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $8f722d9af4d4d346$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $8f722d9af4d4d346$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($8f722d9af4d4d346$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $8f722d9af4d4d346$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("8SDLF", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $13b056f6b69c32bc$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $13b056f6b69c32bc$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $13b056f6b69c32bc$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $13b056f6b69c32bc$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $13b056f6b69c32bc$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $13b056f6b69c32bc$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $13b056f6b69c32bc$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $13b056f6b69c32bc$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $13b056f6b69c32bc$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $13b056f6b69c32bc$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $13b056f6b69c32bc$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $13b056f6b69c32bc$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $13b056f6b69c32bc$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $13b056f6b69c32bc$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $13b056f6b69c32bc$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $13b056f6b69c32bc$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $13b056f6b69c32bc$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $13b056f6b69c32bc$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $13b056f6b69c32bc$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $13b056f6b69c32bc$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $13b056f6b69c32bc$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $13b056f6b69c32bc$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $13b056f6b69c32bc$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $13b056f6b69c32bc$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $13b056f6b69c32bc$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $13b056f6b69c32bc$export$38bcb760f1d4871c; });
var $13b056f6b69c32bc$export$71ad59f2e432cfe8 = "-ms-";
var $13b056f6b69c32bc$export$2c0f367103c8d01c = "-moz-";
var $13b056f6b69c32bc$export$39dfd62a25e0fe93 = "-webkit-";
var $13b056f6b69c32bc$export$a29989082612d0d9 = "comm";
var $13b056f6b69c32bc$export$aa3a2e812ca8570d = "rule";
var $13b056f6b69c32bc$export$527d108ccf083c2b = "decl";
var $13b056f6b69c32bc$export$d3d35020fa5b54f0 = "@page";
var $13b056f6b69c32bc$export$500415a86c544f73 = "@media";
var $13b056f6b69c32bc$export$a763edbf796b780a = "@import";
var $13b056f6b69c32bc$export$2790aeb8b4e5c826 = "@charset";
var $13b056f6b69c32bc$export$1cc683e23b84b133 = "@viewport";
var $13b056f6b69c32bc$export$9447a5efea57e862 = "@supports";
var $13b056f6b69c32bc$export$ef011b4e114b1fba = "@document";
var $13b056f6b69c32bc$export$6aad947bda0f3f46 = "@namespace";
var $13b056f6b69c32bc$export$b44a8529a35fcb60 = "@keyframes";
var $13b056f6b69c32bc$export$2c16de31893252e6 = "@font-face";
var $13b056f6b69c32bc$export$3d846dd52e150c6f = "@counter-style";
var $13b056f6b69c32bc$export$22314bfbb57653fe = "@font-feature-values";
var $13b056f6b69c32bc$export$d773506282b3cfe6 = "@layer";
var $13b056f6b69c32bc$export$2335f513bbd82c6d = Math.abs;
var $13b056f6b69c32bc$export$6788812c4e6611e6 = String.fromCharCode;
var $13b056f6b69c32bc$export$e6e34fd1f2686227 = Object.assign;
function $13b056f6b69c32bc$export$d6af199866bfb566(e, r) {
    return $13b056f6b69c32bc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 0)) << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 1)) << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 2)) << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 3) : 0;
}
function $13b056f6b69c32bc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $13b056f6b69c32bc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $13b056f6b69c32bc$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $13b056f6b69c32bc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $13b056f6b69c32bc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $13b056f6b69c32bc$export$36776f635604f274(e) {
    return e.length;
}
function $13b056f6b69c32bc$export$f9084667e487ed46(e) {
    return e.length;
}
function $13b056f6b69c32bc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $13b056f6b69c32bc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $13b056f6b69c32bc$export$53f1d5ea8de3d7c = 1;
var $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1;
var $13b056f6b69c32bc$export$f24224f1c91d8156 = 0;
var $13b056f6b69c32bc$export$5880b8b5730aff45 = 0;
var $13b056f6b69c32bc$export$c0306caf338ac095 = 0;
var $13b056f6b69c32bc$export$30a86d91af8ff6e6 = "";
function $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $13b056f6b69c32bc$export$53f1d5ea8de3d7c,
        column: $13b056f6b69c32bc$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $13b056f6b69c32bc$export$784d13d8ee351f07(e, r) {
    return $13b056f6b69c32bc$export$e6e34fd1f2686227($13b056f6b69c32bc$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $13b056f6b69c32bc$export$eba6f6f03b0a92e7() {
    return $13b056f6b69c32bc$export$c0306caf338ac095;
}
function $13b056f6b69c32bc$export$232faf9add678146() {
    $13b056f6b69c32bc$export$c0306caf338ac095 = $13b056f6b69c32bc$export$5880b8b5730aff45 > 0 ? $13b056f6b69c32bc$export$a9db5e087081082d($13b056f6b69c32bc$export$30a86d91af8ff6e6, --$13b056f6b69c32bc$export$5880b8b5730aff45) : 0;
    if ($13b056f6b69c32bc$export$4e0c71f277ca26b3--, $13b056f6b69c32bc$export$c0306caf338ac095 === 10) $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1, $13b056f6b69c32bc$export$53f1d5ea8de3d7c--;
    return $13b056f6b69c32bc$export$c0306caf338ac095;
}
function $13b056f6b69c32bc$export$48cfd1e771a65c4f() {
    $13b056f6b69c32bc$export$c0306caf338ac095 = $13b056f6b69c32bc$export$5880b8b5730aff45 < $13b056f6b69c32bc$export$f24224f1c91d8156 ? $13b056f6b69c32bc$export$a9db5e087081082d($13b056f6b69c32bc$export$30a86d91af8ff6e6, $13b056f6b69c32bc$export$5880b8b5730aff45++) : 0;
    if ($13b056f6b69c32bc$export$4e0c71f277ca26b3++, $13b056f6b69c32bc$export$c0306caf338ac095 === 10) $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1, $13b056f6b69c32bc$export$53f1d5ea8de3d7c++;
    return $13b056f6b69c32bc$export$c0306caf338ac095;
}
function $13b056f6b69c32bc$export$4d3fb11e950abb9e() {
    return $13b056f6b69c32bc$export$a9db5e087081082d($13b056f6b69c32bc$export$30a86d91af8ff6e6, $13b056f6b69c32bc$export$5880b8b5730aff45);
}
function $13b056f6b69c32bc$export$e88cb2efb12ae807() {
    return $13b056f6b69c32bc$export$5880b8b5730aff45;
}
function $13b056f6b69c32bc$export$58adb3bec8346d0f(e, r) {
    return $13b056f6b69c32bc$export$2f35ab04d2335697($13b056f6b69c32bc$export$30a86d91af8ff6e6, e, r);
}
function $13b056f6b69c32bc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $13b056f6b69c32bc$export$2de70f21292aac9e(e) {
    return $13b056f6b69c32bc$export$53f1d5ea8de3d7c = $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1, $13b056f6b69c32bc$export$f24224f1c91d8156 = $13b056f6b69c32bc$export$36776f635604f274($13b056f6b69c32bc$export$30a86d91af8ff6e6 = e), $13b056f6b69c32bc$export$5880b8b5730aff45 = 0, [];
}
function $13b056f6b69c32bc$export$45918ac1574455b1(e) {
    return $13b056f6b69c32bc$export$30a86d91af8ff6e6 = "", e;
}
function $13b056f6b69c32bc$export$410ac95b9ec204b8(e) {
    return $13b056f6b69c32bc$export$87c2784dc9fc4ab($13b056f6b69c32bc$export$58adb3bec8346d0f($13b056f6b69c32bc$export$5880b8b5730aff45 - 1, $13b056f6b69c32bc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $13b056f6b69c32bc$export$660b2ee2d4fb4eff(e) {
    return $13b056f6b69c32bc$export$45918ac1574455b1($13b056f6b69c32bc$export$5f8c09e3ae6f64e1($13b056f6b69c32bc$export$2de70f21292aac9e(e)));
}
function $13b056f6b69c32bc$export$7af1228ff777d175(e) {
    while($13b056f6b69c32bc$export$c0306caf338ac095 = $13b056f6b69c32bc$export$4d3fb11e950abb9e())if ($13b056f6b69c32bc$export$c0306caf338ac095 < 33) $13b056f6b69c32bc$export$48cfd1e771a65c4f();
    else break;
    return $13b056f6b69c32bc$export$9e1725a4cfeada27(e) > 2 || $13b056f6b69c32bc$export$9e1725a4cfeada27($13b056f6b69c32bc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $13b056f6b69c32bc$export$5f8c09e3ae6f64e1(e) {
    while($13b056f6b69c32bc$export$48cfd1e771a65c4f())switch($13b056f6b69c32bc$export$9e1725a4cfeada27($13b056f6b69c32bc$export$c0306caf338ac095)){
        case 0:
            $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$c2ab62c7bf24634($13b056f6b69c32bc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$410ac95b9ec204b8($13b056f6b69c32bc$export$c0306caf338ac095), e);
            break;
        default:
            $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$6788812c4e6611e6($13b056f6b69c32bc$export$c0306caf338ac095), e);
    }
    return e;
}
function $13b056f6b69c32bc$export$955ba06d119e085e(e, r) {
    while(--r && $13b056f6b69c32bc$export$48cfd1e771a65c4f())if ($13b056f6b69c32bc$export$c0306caf338ac095 < 48 || $13b056f6b69c32bc$export$c0306caf338ac095 > 102 || $13b056f6b69c32bc$export$c0306caf338ac095 > 57 && $13b056f6b69c32bc$export$c0306caf338ac095 < 65 || $13b056f6b69c32bc$export$c0306caf338ac095 > 70 && $13b056f6b69c32bc$export$c0306caf338ac095 < 97) break;
    return $13b056f6b69c32bc$export$58adb3bec8346d0f(e, $13b056f6b69c32bc$export$e88cb2efb12ae807() + (r < 6 && $13b056f6b69c32bc$export$4d3fb11e950abb9e() == 32 && $13b056f6b69c32bc$export$48cfd1e771a65c4f() == 32));
}
function $13b056f6b69c32bc$export$c889f2fcc19dbf12(e) {
    while($13b056f6b69c32bc$export$48cfd1e771a65c4f())switch($13b056f6b69c32bc$export$c0306caf338ac095){
        case e:
            return $13b056f6b69c32bc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $13b056f6b69c32bc$export$c889f2fcc19dbf12($13b056f6b69c32bc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $13b056f6b69c32bc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $13b056f6b69c32bc$export$48cfd1e771a65c4f();
            break;
    }
    return $13b056f6b69c32bc$export$5880b8b5730aff45;
}
function $13b056f6b69c32bc$export$4254d4e2b3745c4c(e, r) {
    while($13b056f6b69c32bc$export$48cfd1e771a65c4f())if (e + $13b056f6b69c32bc$export$c0306caf338ac095 === 57) break;
    else if (e + $13b056f6b69c32bc$export$c0306caf338ac095 === 84 && $13b056f6b69c32bc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $13b056f6b69c32bc$export$58adb3bec8346d0f(r, $13b056f6b69c32bc$export$5880b8b5730aff45 - 1) + "*" + $13b056f6b69c32bc$export$6788812c4e6611e6(e === 47 ? e : $13b056f6b69c32bc$export$48cfd1e771a65c4f());
}
function $13b056f6b69c32bc$export$c2ab62c7bf24634(e) {
    while(!$13b056f6b69c32bc$export$9e1725a4cfeada27($13b056f6b69c32bc$export$4d3fb11e950abb9e()))$13b056f6b69c32bc$export$48cfd1e771a65c4f();
    return $13b056f6b69c32bc$export$58adb3bec8346d0f(e, $13b056f6b69c32bc$export$5880b8b5730aff45);
}
function $13b056f6b69c32bc$export$ef7acd7185315e22(e) {
    return $13b056f6b69c32bc$export$45918ac1574455b1($13b056f6b69c32bc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $13b056f6b69c32bc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $13b056f6b69c32bc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $13b056f6b69c32bc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $13b056f6b69c32bc$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($13b056f6b69c32bc$export$f8e21b1e77979a08(j += $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $13b056f6b69c32bc$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $13b056f6b69c32bc$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $13b056f6b69c32bc$export$955ba06d119e085e($13b056f6b69c32bc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($13b056f6b69c32bc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$4a34f930e789283c($13b056f6b69c32bc$export$4254d4e2b3745c4c($13b056f6b69c32bc$export$48cfd1e771a65c4f(), $13b056f6b69c32bc$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $13b056f6b69c32bc$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $13b056f6b69c32bc$export$36776f635604f274(j) - l) $13b056f6b69c32bc$export$10d8903dec122b9d(p > 32 ? $13b056f6b69c32bc$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $13b056f6b69c32bc$export$f8483753829ec8f3($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $13b056f6b69c32bc$export$10d8903dec122b9d(y = $13b056f6b69c32bc$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $13b056f6b69c32bc$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $13b056f6b69c32bc$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $13b056f6b69c32bc$export$98e6a39c04603d36(e, y, y, n && $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $13b056f6b69c32bc$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $13b056f6b69c32bc$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $13b056f6b69c32bc$export$232faf9add678146() == 125) continue;
            }
            switch(j += $13b056f6b69c32bc$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($13b056f6b69c32bc$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($13b056f6b69c32bc$export$4d3fb11e950abb9e() === 45) j += $13b056f6b69c32bc$export$410ac95b9ec204b8($13b056f6b69c32bc$export$48cfd1e771a65c4f());
                    v = $13b056f6b69c32bc$export$4d3fb11e950abb9e(), o = l = $13b056f6b69c32bc$export$36776f635604f274(g = j += $13b056f6b69c32bc$export$c2ab62c7bf24634($13b056f6b69c32bc$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $13b056f6b69c32bc$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $13b056f6b69c32bc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $13b056f6b69c32bc$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $13b056f6b69c32bc$export$2f35ab04d2335697(e, v + 1, v = $13b056f6b69c32bc$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $13b056f6b69c32bc$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, s === 0 ? $13b056f6b69c32bc$export$aa3a2e812ca8570d : i, f, o, l);
}
function $13b056f6b69c32bc$export$4a34f930e789283c(e, r, a) {
    return $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, $13b056f6b69c32bc$export$a29989082612d0d9, $13b056f6b69c32bc$export$6788812c4e6611e6($13b056f6b69c32bc$export$eba6f6f03b0a92e7()), $13b056f6b69c32bc$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $13b056f6b69c32bc$export$f8483753829ec8f3(e, r, a, n) {
    return $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, $13b056f6b69c32bc$export$527d108ccf083c2b, $13b056f6b69c32bc$export$2f35ab04d2335697(e, 0, n), $13b056f6b69c32bc$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $13b056f6b69c32bc$export$82e9f45cca5ba907(n, c, s) {
    switch($13b056f6b69c32bc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $13b056f6b69c32bc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$2c0f367103c8d01c + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "box-$1$2" + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-item-" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$13b056f6b69c32bc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "grid-row-" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-line-pack" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "box-" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "box-pack:$3" + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$13b056f6b69c32bc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "grid-column-align" + $13b056f6b69c32bc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $13b056f6b69c32bc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$13b056f6b69c32bc$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$13b056f6b69c32bc$export$f8e21b1e77979a08(s, "span") ? $13b056f6b69c32bc$export$4659b591c19bdf3d(s, /\d+/) : +$13b056f6b69c32bc$export$4659b591c19bdf3d(s, /\d+/) - +$13b056f6b69c32bc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $13b056f6b69c32bc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($13b056f6b69c32bc$export$36776f635604f274(n) - 1 - c > 6) switch($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $13b056f6b69c32bc$export$2c0f367103c8d01c + ($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$13b056f6b69c32bc$export$f8e21b1e77979a08(n, "stretch") ? $13b056f6b69c32bc$export$82e9f45cca5ba907($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $13b056f6b69c32bc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 6) === 121) return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, ":", ":" + $13b056f6b69c32bc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($13b056f6b69c32bc$export$a9db5e087081082d(n, $13b056f6b69c32bc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + ($13b056f6b69c32bc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, ":", ":" + $13b056f6b69c32bc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $13b056f6b69c32bc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $13b056f6b69c32bc$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $13b056f6b69c32bc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $13b056f6b69c32bc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $13b056f6b69c32bc$export$a763edbf796b780a:
        case $13b056f6b69c32bc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $13b056f6b69c32bc$export$a29989082612d0d9:
            return "";
        case $13b056f6b69c32bc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $13b056f6b69c32bc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $13b056f6b69c32bc$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $13b056f6b69c32bc$export$36776f635604f274(a = $13b056f6b69c32bc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $13b056f6b69c32bc$export$5a7767152ae0305f(e) {
    var r = $13b056f6b69c32bc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $13b056f6b69c32bc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $13b056f6b69c32bc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $13b056f6b69c32bc$export$527d108ccf083c2b:
                n.return = $13b056f6b69c32bc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $13b056f6b69c32bc$export$b44a8529a35fcb60:
                return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb([
                    $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                        value: $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $13b056f6b69c32bc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $13b056f6b69c32bc$export$aa3a2e812ca8570d:
                if (n.length) return $13b056f6b69c32bc$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($13b056f6b69c32bc$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb([
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $13b056f6b69c32bc$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb([
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $13b056f6b69c32bc$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $13b056f6b69c32bc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $13b056f6b69c32bc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $13b056f6b69c32bc$export$1be1fc439b849fdf($13b056f6b69c32bc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($13b056f6b69c32bc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $13b056f6b69c32bc$export$2f35ab04d2335697(r, 1, $13b056f6b69c32bc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $13b056f6b69c32bc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $13b056f6b69c32bc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $13b056f6b69c32bc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("6q2Od", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ac759958d9264be$export$2e2bcd8739ae039; });
var $4ac759958d9264be$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("d5hMW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98698a5e781a3a77$export$2e2bcd8739ae039; });
function $98698a5e781a3a77$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("h4XE0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6f1137fdd741ee5$export$2e2bcd8739ae039; });
function $c6f1137fdd741ee5$export$2e2bcd8739ae039() {
    return $c6f1137fdd741ee5$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c6f1137fdd741ee5$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("eU7V2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad9c7036cfd04fbc$export$2e2bcd8739ae039; });

var $3ojZ1 = parcelRequire("3ojZ1");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $ad9c7036cfd04fbc$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ojZ1)))(targetComponent, sourceComponent);
};

});
parcelRegister("3ojZ1", function(module, exports) {
"use strict";

var $BE9NW = parcelRequire("BE9NW");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $27831d414646f384$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $27831d414646f384$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $27831d414646f384$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $27831d414646f384$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $27831d414646f384$var$TYPE_STATICS = {};
$27831d414646f384$var$TYPE_STATICS[$BE9NW.ForwardRef] = $27831d414646f384$var$FORWARD_REF_STATICS;
$27831d414646f384$var$TYPE_STATICS[$BE9NW.Memo] = $27831d414646f384$var$MEMO_STATICS;
function $27831d414646f384$var$getStatics(component) {
    // React v16.11 and below
    if ($BE9NW.isMemo(component)) return $27831d414646f384$var$MEMO_STATICS;
     // React v16.12 and above
    return $27831d414646f384$var$TYPE_STATICS[component["$$typeof"]] || $27831d414646f384$var$REACT_STATICS;
}
var $27831d414646f384$var$defineProperty = Object.defineProperty;
var $27831d414646f384$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $27831d414646f384$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $27831d414646f384$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $27831d414646f384$var$getPrototypeOf = Object.getPrototypeOf;
var $27831d414646f384$var$objectPrototype = Object.prototype;
function $27831d414646f384$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($27831d414646f384$var$objectPrototype) {
            var inheritedComponent = $27831d414646f384$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $27831d414646f384$var$objectPrototype) $27831d414646f384$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $27831d414646f384$var$getOwnPropertyNames(sourceComponent);
        if ($27831d414646f384$var$getOwnPropertySymbols) keys = keys.concat($27831d414646f384$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $27831d414646f384$var$getStatics(targetComponent);
        var sourceStatics = $27831d414646f384$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$27831d414646f384$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $27831d414646f384$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $27831d414646f384$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $27831d414646f384$var$hoistNonReactStatics;

});
parcelRegister("BE9NW", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cymWn"));

});
parcelRegister("cymWn", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $923a7487eec9c745$export$2b8d127b894957b9; }, function (v) { return $923a7487eec9c745$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $923a7487eec9c745$export$cea3a54a6425200c; }, function (v) { return $923a7487eec9c745$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $923a7487eec9c745$export$a7c73072b1a182ae; }, function (v) { return $923a7487eec9c745$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $923a7487eec9c745$export$9f27bc3417b4524d; }, function (v) { return $923a7487eec9c745$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $923a7487eec9c745$export$db77ccec0bb4ccac; }, function (v) { return $923a7487eec9c745$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $923a7487eec9c745$export$8392c0c9d3dcbd35; }, function (v) { return $923a7487eec9c745$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $923a7487eec9c745$export$ffb0004e005737fa; }, function (v) { return $923a7487eec9c745$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $923a7487eec9c745$export$b624eff549462981; }, function (v) { return $923a7487eec9c745$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $923a7487eec9c745$export$7897aa7841a5380c; }, function (v) { return $923a7487eec9c745$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $923a7487eec9c745$export$602eac185826482c; }, function (v) { return $923a7487eec9c745$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $923a7487eec9c745$export$e2c29f18771995cb; }, function (v) { return $923a7487eec9c745$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $923a7487eec9c745$export$5f8d39834fd61797; }, function (v) { return $923a7487eec9c745$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $923a7487eec9c745$export$74bf444e3cd11ea5; }, function (v) { return $923a7487eec9c745$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $923a7487eec9c745$export$92387174baf9b227; }, function (v) { return $923a7487eec9c745$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $923a7487eec9c745$export$ec112efeb987d9c6; }, function (v) { return $923a7487eec9c745$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $923a7487eec9c745$export$b706b080d889d2c9; }, function (v) { return $923a7487eec9c745$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $923a7487eec9c745$export$5be5a87408f70ddc; }, function (v) { return $923a7487eec9c745$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $923a7487eec9c745$export$45a5e7f76e0caa8d; }, function (v) { return $923a7487eec9c745$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $923a7487eec9c745$export$455c2e768291efa6; }, function (v) { return $923a7487eec9c745$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $923a7487eec9c745$export$9522e17588c12572; }, function (v) { return $923a7487eec9c745$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $923a7487eec9c745$export$2110ac352bb060b9; }, function (v) { return $923a7487eec9c745$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $923a7487eec9c745$export$56885ab8b9c456ab; }, function (v) { return $923a7487eec9c745$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $923a7487eec9c745$export$d927fcb6adf8f9de; }, function (v) { return $923a7487eec9c745$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $923a7487eec9c745$export$b82d16f27459e05a; }, function (v) { return $923a7487eec9c745$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $923a7487eec9c745$export$522c17b4f5e123e8; }, function (v) { return $923a7487eec9c745$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $923a7487eec9c745$export$1aabd8a0274ecfd6; }, function (v) { return $923a7487eec9c745$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $923a7487eec9c745$export$9b621391a187a31a; }, function (v) { return $923a7487eec9c745$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $923a7487eec9c745$export$f5bbd400c2f4426f; }, function (v) { return $923a7487eec9c745$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $923a7487eec9c745$export$2b8d127b894957b9;
var $923a7487eec9c745$export$cea3a54a6425200c;
var $923a7487eec9c745$export$a7c73072b1a182ae;
var $923a7487eec9c745$export$9f27bc3417b4524d;
var $923a7487eec9c745$export$db77ccec0bb4ccac;
var $923a7487eec9c745$export$8392c0c9d3dcbd35;
var $923a7487eec9c745$export$ffb0004e005737fa;
var $923a7487eec9c745$export$b624eff549462981;
var $923a7487eec9c745$export$7897aa7841a5380c;
var $923a7487eec9c745$export$602eac185826482c;
var $923a7487eec9c745$export$e2c29f18771995cb;
var $923a7487eec9c745$export$5f8d39834fd61797;
var $923a7487eec9c745$export$74bf444e3cd11ea5;
var $923a7487eec9c745$export$92387174baf9b227;
var $923a7487eec9c745$export$ec112efeb987d9c6;
var $923a7487eec9c745$export$b706b080d889d2c9;
var $923a7487eec9c745$export$5be5a87408f70ddc;
var $923a7487eec9c745$export$45a5e7f76e0caa8d;
var $923a7487eec9c745$export$455c2e768291efa6;
var $923a7487eec9c745$export$9522e17588c12572;
var $923a7487eec9c745$export$2110ac352bb060b9;
var $923a7487eec9c745$export$56885ab8b9c456ab;
var $923a7487eec9c745$export$d927fcb6adf8f9de;
var $923a7487eec9c745$export$b82d16f27459e05a;
var $923a7487eec9c745$export$522c17b4f5e123e8;
var $923a7487eec9c745$export$1aabd8a0274ecfd6;
var $923a7487eec9c745$export$9b621391a187a31a;
var $923a7487eec9c745$export$f5bbd400c2f4426f;
"use strict";
var $923a7487eec9c745$var$b = "function" === typeof Symbol && Symbol.for, $923a7487eec9c745$var$c = $923a7487eec9c745$var$b ? Symbol.for("react.element") : 60103, $923a7487eec9c745$var$d = $923a7487eec9c745$var$b ? Symbol.for("react.portal") : 60106, $923a7487eec9c745$var$e = $923a7487eec9c745$var$b ? Symbol.for("react.fragment") : 60107, $923a7487eec9c745$var$f = $923a7487eec9c745$var$b ? Symbol.for("react.strict_mode") : 60108, $923a7487eec9c745$var$g = $923a7487eec9c745$var$b ? Symbol.for("react.profiler") : 60114, $923a7487eec9c745$var$h = $923a7487eec9c745$var$b ? Symbol.for("react.provider") : 60109, $923a7487eec9c745$var$k = $923a7487eec9c745$var$b ? Symbol.for("react.context") : 60110, $923a7487eec9c745$var$l = $923a7487eec9c745$var$b ? Symbol.for("react.async_mode") : 60111, $923a7487eec9c745$var$m = $923a7487eec9c745$var$b ? Symbol.for("react.concurrent_mode") : 60111, $923a7487eec9c745$var$n = $923a7487eec9c745$var$b ? Symbol.for("react.forward_ref") : 60112, $923a7487eec9c745$var$p = $923a7487eec9c745$var$b ? Symbol.for("react.suspense") : 60113, $923a7487eec9c745$var$q = $923a7487eec9c745$var$b ? Symbol.for("react.suspense_list") : 60120, $923a7487eec9c745$var$r = $923a7487eec9c745$var$b ? Symbol.for("react.memo") : 60115, $923a7487eec9c745$var$t = $923a7487eec9c745$var$b ? Symbol.for("react.lazy") : 60116, $923a7487eec9c745$var$v = $923a7487eec9c745$var$b ? Symbol.for("react.block") : 60121, $923a7487eec9c745$var$w = $923a7487eec9c745$var$b ? Symbol.for("react.fundamental") : 60117, $923a7487eec9c745$var$x = $923a7487eec9c745$var$b ? Symbol.for("react.responder") : 60118, $923a7487eec9c745$var$y = $923a7487eec9c745$var$b ? Symbol.for("react.scope") : 60119;
function $923a7487eec9c745$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $923a7487eec9c745$var$c:
                switch(a = a.type, a){
                    case $923a7487eec9c745$var$l:
                    case $923a7487eec9c745$var$m:
                    case $923a7487eec9c745$var$e:
                    case $923a7487eec9c745$var$g:
                    case $923a7487eec9c745$var$f:
                    case $923a7487eec9c745$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $923a7487eec9c745$var$k:
                            case $923a7487eec9c745$var$n:
                            case $923a7487eec9c745$var$t:
                            case $923a7487eec9c745$var$r:
                            case $923a7487eec9c745$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $923a7487eec9c745$var$d:
                return u;
        }
    }
}
function $923a7487eec9c745$var$A(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$m;
}
$923a7487eec9c745$export$2b8d127b894957b9 = $923a7487eec9c745$var$l;
$923a7487eec9c745$export$cea3a54a6425200c = $923a7487eec9c745$var$m;
$923a7487eec9c745$export$a7c73072b1a182ae = $923a7487eec9c745$var$k;
$923a7487eec9c745$export$9f27bc3417b4524d = $923a7487eec9c745$var$h;
$923a7487eec9c745$export$db77ccec0bb4ccac = $923a7487eec9c745$var$c;
$923a7487eec9c745$export$8392c0c9d3dcbd35 = $923a7487eec9c745$var$n;
$923a7487eec9c745$export$ffb0004e005737fa = $923a7487eec9c745$var$e;
$923a7487eec9c745$export$b624eff549462981 = $923a7487eec9c745$var$t;
$923a7487eec9c745$export$7897aa7841a5380c = $923a7487eec9c745$var$r;
$923a7487eec9c745$export$602eac185826482c = $923a7487eec9c745$var$d;
$923a7487eec9c745$export$e2c29f18771995cb = $923a7487eec9c745$var$g;
$923a7487eec9c745$export$5f8d39834fd61797 = $923a7487eec9c745$var$f;
$923a7487eec9c745$export$74bf444e3cd11ea5 = $923a7487eec9c745$var$p;
$923a7487eec9c745$export$92387174baf9b227 = function(a) {
    return $923a7487eec9c745$var$A(a) || $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$l;
};
$923a7487eec9c745$export$ec112efeb987d9c6 = $923a7487eec9c745$var$A;
$923a7487eec9c745$export$b706b080d889d2c9 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$k;
};
$923a7487eec9c745$export$5be5a87408f70ddc = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$h;
};
$923a7487eec9c745$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $923a7487eec9c745$var$c;
};
$923a7487eec9c745$export$455c2e768291efa6 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$n;
};
$923a7487eec9c745$export$9522e17588c12572 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$e;
};
$923a7487eec9c745$export$2110ac352bb060b9 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$t;
};
$923a7487eec9c745$export$56885ab8b9c456ab = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$r;
};
$923a7487eec9c745$export$d927fcb6adf8f9de = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$d;
};
$923a7487eec9c745$export$b82d16f27459e05a = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$g;
};
$923a7487eec9c745$export$522c17b4f5e123e8 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$f;
};
$923a7487eec9c745$export$1aabd8a0274ecfd6 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$p;
};
$923a7487eec9c745$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $923a7487eec9c745$var$e || a === $923a7487eec9c745$var$m || a === $923a7487eec9c745$var$g || a === $923a7487eec9c745$var$f || a === $923a7487eec9c745$var$p || a === $923a7487eec9c745$var$q || "object" === typeof a && null !== a && (a.$$typeof === $923a7487eec9c745$var$t || a.$$typeof === $923a7487eec9c745$var$r || a.$$typeof === $923a7487eec9c745$var$h || a.$$typeof === $923a7487eec9c745$var$k || a.$$typeof === $923a7487eec9c745$var$n || a.$$typeof === $923a7487eec9c745$var$w || a.$$typeof === $923a7487eec9c745$var$x || a.$$typeof === $923a7487eec9c745$var$y || a.$$typeof === $923a7487eec9c745$var$v);
};
$923a7487eec9c745$export$f5bbd400c2f4426f = $923a7487eec9c745$var$z;

});




parcelRegister("7sOZt", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $56f2b393162761c5$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $56f2b393162761c5$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $56f2b393162761c5$export$6f077d94b33a01aa; });
var $56f2b393162761c5$var$isBrowser = true;
function $56f2b393162761c5$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $56f2b393162761c5$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $56f2b393162761c5$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $56f2b393162761c5$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $56f2b393162761c5$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("47KoV", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $300bcf23a6ecee5a$export$6321afa313b251b5; });

var $g3tXG = parcelRequire("g3tXG");

var $3Lp5J = parcelRequire("3Lp5J");

var $d5hMW = parcelRequire("d5hMW");
var $300bcf23a6ecee5a$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $300bcf23a6ecee5a$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $300bcf23a6ecee5a$var$hyphenateRegex = /[A-Z]|^ms/g;
var $300bcf23a6ecee5a$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $300bcf23a6ecee5a$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $300bcf23a6ecee5a$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $300bcf23a6ecee5a$var$processStyleName = /* #__PURE__ */ (0, $d5hMW.default)(function(styleName) {
    return $300bcf23a6ecee5a$var$isCustomProperty(styleName) ? styleName : styleName.replace($300bcf23a6ecee5a$var$hyphenateRegex, "-$&").toLowerCase();
});
var $300bcf23a6ecee5a$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($300bcf23a6ecee5a$var$animationRegex, function(match, p1, p2) {
                $300bcf23a6ecee5a$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $300bcf23a6ecee5a$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3Lp5J.default)[key] !== 1 && !$300bcf23a6ecee5a$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $300bcf23a6ecee5a$var$contentValuePattern, $300bcf23a6ecee5a$var$contentValues, $300bcf23a6ecee5a$var$oldProcessStyleValue, $300bcf23a6ecee5a$var$msPattern, $300bcf23a6ecee5a$var$hyphenPattern, $300bcf23a6ecee5a$var$hyphenatedCache;
var $300bcf23a6ecee5a$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $300bcf23a6ecee5a$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $300bcf23a6ecee5a$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $300bcf23a6ecee5a$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $300bcf23a6ecee5a$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $300bcf23a6ecee5a$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $300bcf23a6ecee5a$var$cursor;
                var result = interpolation(mergedProps);
                $300bcf23a6ecee5a$var$cursor = previousCursor;
                return $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $300bcf23a6ecee5a$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($300bcf23a6ecee5a$var$isProcessableValue(value)) string += $300bcf23a6ecee5a$var$processStyleName(_key) + ":" + $300bcf23a6ecee5a$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($300bcf23a6ecee5a$var$isProcessableValue(value[_i])) string += $300bcf23a6ecee5a$var$processStyleName(_key) + ":" + $300bcf23a6ecee5a$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $300bcf23a6ecee5a$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $300bcf23a6ecee5a$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $300bcf23a6ecee5a$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $300bcf23a6ecee5a$var$cursor;
var $300bcf23a6ecee5a$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $300bcf23a6ecee5a$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $300bcf23a6ecee5a$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $300bcf23a6ecee5a$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $g3tXG.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $300bcf23a6ecee5a$var$cursor
    };
};

});
parcelRegister("g3tXG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb042aec4fffa986$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $bb042aec4fffa986$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("3Lp5J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bd939849740902a$export$2e2bcd8739ae039; });
var $2bd939849740902a$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("5ziuZ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $40de9220eaf38fe3$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $40de9220eaf38fe3$export$811a713a7276cb9d; });

var $eeH7J = parcelRequire("eeH7J");
var $40de9220eaf38fe3$var$syncFallback = function syncFallback(create) {
    return create();
};
var $40de9220eaf38fe3$var$useInsertionEffect = $eeH7J.useInsertionEffect ? $eeH7J.useInsertionEffect : false;
var $40de9220eaf38fe3$export$db21c7ffa21794e7 = $40de9220eaf38fe3$var$useInsertionEffect || $40de9220eaf38fe3$var$syncFallback;
var $40de9220eaf38fe3$export$811a713a7276cb9d = $40de9220eaf38fe3$var$useInsertionEffect || $eeH7J.useLayoutEffect;

});


parcelRegister("eq7pw", function(module, exports) {
function $a7f93e0248e9369b$var$_extends() {
    return module.exports = $a7f93e0248e9369b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a7f93e0248e9369b$var$_extends.apply(null, arguments);
}
module.exports = $a7f93e0248e9369b$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5K1mb", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $42e24d1152893e59$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $42e24d1152893e59$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $42e24d1152893e59$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("18Pjr")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("18Pjr")).useNavigate; });
/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $1ig10 = parcelRequire("1ig10");
var $18Pjr = parcelRequire("18Pjr");

var $1ig10 = parcelRequire("1ig10");
function $42e24d1152893e59$var$_extends() {
    $42e24d1152893e59$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $42e24d1152893e59$var$_extends.apply(this, arguments);
}
function $42e24d1152893e59$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $42e24d1152893e59$var$defaultMethod = "get";
const $42e24d1152893e59$var$defaultEncType = "application/x-www-form-urlencoded";
function $42e24d1152893e59$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $42e24d1152893e59$var$isButtonElement(object) {
    return $42e24d1152893e59$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $42e24d1152893e59$var$isFormElement(object) {
    return $42e24d1152893e59$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $42e24d1152893e59$var$isInputElement(object) {
    return $42e24d1152893e59$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $42e24d1152893e59$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $42e24d1152893e59$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$42e24d1152893e59$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $42e24d1152893e59$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $42e24d1152893e59$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $42e24d1152893e59$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $42e24d1152893e59$var$_formDataSupportsSubmitter = null;
function $42e24d1152893e59$var$isFormDataSubmitterSupported() {
    if ($42e24d1152893e59$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $42e24d1152893e59$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $42e24d1152893e59$var$_formDataSupportsSubmitter = true;
    }
    return $42e24d1152893e59$var$_formDataSupportsSubmitter;
}
const $42e24d1152893e59$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $42e24d1152893e59$var$getFormEncType(encType) {
    if (encType != null && !$42e24d1152893e59$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $42e24d1152893e59$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($42e24d1152893e59$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1ig10.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $42e24d1152893e59$var$defaultMethod;
        encType = $42e24d1152893e59$var$getFormEncType(target.getAttribute("enctype")) || $42e24d1152893e59$var$defaultEncType;
        formData = new FormData(target);
    } else if ($42e24d1152893e59$var$isButtonElement(target) || $42e24d1152893e59$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1ig10.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $42e24d1152893e59$var$defaultMethod;
        encType = $42e24d1152893e59$var$getFormEncType(target.getAttribute("formenctype")) || $42e24d1152893e59$var$getFormEncType(form.getAttribute("enctype")) || $42e24d1152893e59$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$42e24d1152893e59$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($42e24d1152893e59$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $42e24d1152893e59$var$defaultMethod;
        action = null;
        encType = $42e24d1152893e59$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $42e24d1152893e59$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $42e24d1152893e59$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $42e24d1152893e59$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $42e24d1152893e59$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $42e24d1152893e59$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $42e24d1152893e59$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1ig10.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $42e24d1152893e59$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ig10.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $42e24d1152893e59$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $18Pjr.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $42e24d1152893e59$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1ig10.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $42e24d1152893e59$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ig10.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $42e24d1152893e59$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $18Pjr.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $42e24d1152893e59$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $42e24d1152893e59$var$_extends({}, state, {
        errors: $42e24d1152893e59$var$deserializeErrors(state.errors)
    });
    return state;
}
function $42e24d1152893e59$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1ig10.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $42e24d1152893e59$export$7ad602f0e94e62d1 = /*#__PURE__*/ $eeH7J.createContext({
    isTransitioning: false
});
const $42e24d1152893e59$export$148fd98d095596d4 = /*#__PURE__*/ $eeH7J.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $42e24d1152893e59$var$START_TRANSITION = "startTransition";
const $42e24d1152893e59$var$startTransitionImpl = $eeH7J[$42e24d1152893e59$var$START_TRANSITION];
const $42e24d1152893e59$var$FLUSH_SYNC = "flushSync";
const $42e24d1152893e59$var$flushSyncImpl = $iMJCh[$42e24d1152893e59$var$FLUSH_SYNC];
const $42e24d1152893e59$var$USE_ID = "useId";
const $42e24d1152893e59$var$useIdImpl = $eeH7J[$42e24d1152893e59$var$USE_ID];
function $42e24d1152893e59$var$startTransitionSafe(cb) {
    if ($42e24d1152893e59$var$startTransitionImpl) $42e24d1152893e59$var$startTransitionImpl(cb);
    else cb();
}
function $42e24d1152893e59$var$flushSyncSafe(cb) {
    if ($42e24d1152893e59$var$flushSyncImpl) $42e24d1152893e59$var$flushSyncImpl(cb);
    else cb();
}
class $42e24d1152893e59$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $42e24d1152893e59$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eeH7J.useState(router.state);
    let [pendingState, setPendingState] = $eeH7J.useState();
    let [vtContext, setVtContext] = $eeH7J.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $eeH7J.useState();
    let [transition, setTransition] = $eeH7J.useState();
    let [interruption, setInterruption] = $eeH7J.useState();
    let fetcherData = $eeH7J.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $eeH7J.useCallback((cb)=>{
        if (v7_startTransition) $42e24d1152893e59$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $eeH7J.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $42e24d1152893e59$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $42e24d1152893e59$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $42e24d1152893e59$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $42e24d1152893e59$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $42e24d1152893e59$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eeH7J.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $eeH7J.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $42e24d1152893e59$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $eeH7J.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $eeH7J.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $eeH7J.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $eeH7J.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eeH7J.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eeH7J.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $42e24d1152893e59$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $18Pjr.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $42e24d1152893e59$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $eeH7J.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ig10.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $42e24d1152893e59$var$startTransitionImpl ? $42e24d1152893e59$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $42e24d1152893e59$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $eeH7J.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ig10.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $42e24d1152893e59$var$startTransitionImpl ? $42e24d1152893e59$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $42e24d1152893e59$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $42e24d1152893e59$var$startTransitionImpl ? $42e24d1152893e59$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $42e24d1152893e59$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $42e24d1152893e59$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $42e24d1152893e59$export$a6c7ac8248d6e38a = /*#__PURE__*/ $eeH7J.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $42e24d1152893e59$var$_objectWithoutPropertiesLoose(_ref7, $42e24d1152893e59$var$_excluded);
    let { basename: basename } = $eeH7J.useContext((0, $18Pjr.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $42e24d1152893e59$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($42e24d1152893e59$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1ig10.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $18Pjr.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $42e24d1152893e59$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $eeH7J.createElement("a", $42e24d1152893e59$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $42e24d1152893e59$export$b0d92dbee9b5b60d = /*#__PURE__*/ $eeH7J.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $42e24d1152893e59$var$_objectWithoutPropertiesLoose(_ref8, $42e24d1152893e59$var$_excluded2);
    let path = (0, $18Pjr.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $18Pjr.useLocation)();
    let routerState = $eeH7J.useContext((0, $18Pjr.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $eeH7J.useContext((0, $18Pjr.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $42e24d1152893e59$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1ig10.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$a6c7ac8248d6e38a, $42e24d1152893e59$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $42e24d1152893e59$export$a7fed597f4b8afd8 = /*#__PURE__*/ $eeH7J.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $42e24d1152893e59$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $42e24d1152893e59$var$_objectWithoutPropertiesLoose(_ref9, $42e24d1152893e59$var$_excluded3);
    let submit = $42e24d1152893e59$export$47c85c6e3a081d3();
    let formAction = $42e24d1152893e59$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $eeH7J.createElement("form", $42e24d1152893e59$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $42e24d1152893e59$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $42e24d1152893e59$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $42e24d1152893e59$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($42e24d1152893e59$var$DataRouterHook || ($42e24d1152893e59$var$DataRouterHook = {}));
var $42e24d1152893e59$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($42e24d1152893e59$var$DataRouterStateHook || ($42e24d1152893e59$var$DataRouterStateHook = {}));
// Internal hooks
function $42e24d1152893e59$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $42e24d1152893e59$var$useDataRouterContext(hookName) {
    let ctx = $eeH7J.useContext((0, $18Pjr.UNSAFE_DataRouterContext));
    !ctx && (0, $1ig10.UNSAFE_invariant)(false);
    return ctx;
}
function $42e24d1152893e59$var$useDataRouterState(hookName) {
    let state = $eeH7J.useContext((0, $18Pjr.UNSAFE_DataRouterStateContext));
    !state && (0, $1ig10.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $42e24d1152893e59$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $18Pjr.useNavigate)();
    let location = (0, $18Pjr.useLocation)();
    let path = (0, $18Pjr.useResolvedPath)(to, {
        relative: relative
    });
    return $eeH7J.useCallback((event)=>{
        if ($42e24d1152893e59$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1ig10.createPath)(location) === (0, $1ig10.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $42e24d1152893e59$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $eeH7J.useRef($42e24d1152893e59$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $eeH7J.useRef(false);
    let location = (0, $18Pjr.useLocation)();
    let searchParams = $eeH7J.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $42e24d1152893e59$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $18Pjr.useNavigate)();
    let setSearchParams = $eeH7J.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $42e24d1152893e59$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $42e24d1152893e59$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $42e24d1152893e59$var$fetcherId = 0;
let $42e24d1152893e59$var$getUniqueFetcherId = ()=>"__" + String(++$42e24d1152893e59$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $42e24d1152893e59$export$47c85c6e3a081d3() {
    let { router: router } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $eeH7J.useContext((0, $18Pjr.UNSAFE_NavigationContext));
    let currentRouteId = (0, $18Pjr.UNSAFE_useRouteId)();
    return $eeH7J.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $42e24d1152893e59$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $42e24d1152893e59$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $42e24d1152893e59$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $42e24d1152893e59$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $eeH7J.useContext((0, $18Pjr.UNSAFE_NavigationContext));
    let routeContext = $eeH7J.useContext((0, $18Pjr.UNSAFE_RouteContext));
    !routeContext && (0, $1ig10.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $42e24d1152893e59$var$_extends({}, (0, $18Pjr.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $18Pjr.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ig10.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $1ig10.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $42e24d1152893e59$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.UseFetcher);
    let state = $42e24d1152893e59$var$useDataRouterState($42e24d1152893e59$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $eeH7J.useContext($42e24d1152893e59$export$148fd98d095596d4);
    let route = $eeH7J.useContext((0, $18Pjr.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1ig10.UNSAFE_invariant)(false);
    !route && (0, $1ig10.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $1ig10.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $42e24d1152893e59$var$useIdImpl ? $42e24d1152893e59$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $eeH7J.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($42e24d1152893e59$var$getUniqueFetcherId());
    // Registration/cleanup
    $eeH7J.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $eeH7J.useCallback((href, opts)=>{
        !routeId && (0, $1ig10.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $42e24d1152893e59$export$47c85c6e3a081d3();
    let submit = $eeH7J.useCallback((target, opts)=>{
        submitImpl(target, $42e24d1152893e59$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $eeH7J.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $eeH7J.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$a7fed597f4b8afd8, $42e24d1152893e59$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1ig10.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $eeH7J.useMemo(()=>$42e24d1152893e59$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $42e24d1152893e59$export$fa996778a3a31087() {
    let state = $42e24d1152893e59$var$useDataRouterState($42e24d1152893e59$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $42e24d1152893e59$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $42e24d1152893e59$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $42e24d1152893e59$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $42e24d1152893e59$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $42e24d1152893e59$var$useDataRouterState($42e24d1152893e59$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $eeH7J.useContext((0, $18Pjr.UNSAFE_NavigationContext));
    let location = (0, $18Pjr.useLocation)();
    let matches = (0, $18Pjr.useMatches)();
    let navigation = (0, $18Pjr.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $eeH7J.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $42e24d1152893e59$var$usePageHide($eeH7J.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $42e24d1152893e59$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $42e24d1152893e59$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($42e24d1152893e59$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeH7J.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $42e24d1152893e59$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $42e24d1152893e59$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeH7J.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($42e24d1152893e59$var$_extends({}, location, {
                    pathname: (0, $1ig10.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($42e24d1152893e59$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeH7J.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $42e24d1152893e59$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $eeH7J.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $42e24d1152893e59$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $eeH7J.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $42e24d1152893e59$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $18Pjr.useBlocker)(when);
    $eeH7J.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $eeH7J.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $42e24d1152893e59$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $eeH7J.useContext($42e24d1152893e59$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1ig10.UNSAFE_invariant)(false);
    let { basename: basename } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.useViewTransitionState);
    let path = (0, $18Pjr.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1ig10.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1ig10.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1ig10.matchPath)(path.pathname, nextPath) != null || (0, $1ig10.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("iMJCh", function(module, exports) {
"use strict";
function $dad018249d59322c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($dad018249d59322c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$dad018249d59322c$var$checkDCE();

module.exports = (parcelRequire("2Wdaw"));

});
parcelRegister("2Wdaw", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $223b3691249701c4$export$ae55be85d98224ed; }, function (v) { return $223b3691249701c4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $223b3691249701c4$export$d39a5bbd09211389; }, function (v) { return $223b3691249701c4$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $223b3691249701c4$export$882461b6382ed46c; }, function (v) { return $223b3691249701c4$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $223b3691249701c4$export$466bfc07425424d5; }, function (v) { return $223b3691249701c4$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $223b3691249701c4$export$cd75ccfd720a3cd4; }, function (v) { return $223b3691249701c4$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $223b3691249701c4$export$fa8d919ba61d84db; }, function (v) { return $223b3691249701c4$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $223b3691249701c4$export$757ceba2d55c277e; }, function (v) { return $223b3691249701c4$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $223b3691249701c4$export$b3890eb0ae9dca99; }, function (v) { return $223b3691249701c4$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $223b3691249701c4$export$502457920280e6be; }, function (v) { return $223b3691249701c4$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $223b3691249701c4$export$c78a37762a8d58e1; }, function (v) { return $223b3691249701c4$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $223b3691249701c4$export$dc54d992c10e8a18; }, function (v) { return $223b3691249701c4$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $223b3691249701c4$export$83d89fbfd8236492; }, function (v) { return $223b3691249701c4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $223b3691249701c4$export$ae55be85d98224ed;
var $223b3691249701c4$export$d39a5bbd09211389;
var $223b3691249701c4$export$882461b6382ed46c;
var $223b3691249701c4$export$466bfc07425424d5;
var $223b3691249701c4$export$cd75ccfd720a3cd4;
var $223b3691249701c4$export$fa8d919ba61d84db;
var $223b3691249701c4$export$757ceba2d55c277e;
var $223b3691249701c4$export$b3890eb0ae9dca99;
var $223b3691249701c4$export$502457920280e6be;
var $223b3691249701c4$export$c78a37762a8d58e1;
var $223b3691249701c4$export$dc54d992c10e8a18;
var $223b3691249701c4$export$83d89fbfd8236492;
"use strict";

var $eeH7J = parcelRequire("eeH7J");

var $l7BOg = parcelRequire("l7BOg");
function $223b3691249701c4$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $223b3691249701c4$var$da = new Set, $223b3691249701c4$var$ea = {};
function $223b3691249701c4$var$fa(a, b) {
    $223b3691249701c4$var$ha(a, b);
    $223b3691249701c4$var$ha(a + "Capture", b);
}
function $223b3691249701c4$var$ha(a, b) {
    $223b3691249701c4$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$223b3691249701c4$var$da.add(b[a]);
}
var $223b3691249701c4$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $223b3691249701c4$var$ja = Object.prototype.hasOwnProperty, $223b3691249701c4$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $223b3691249701c4$var$la = {}, $223b3691249701c4$var$ma = {};
function $223b3691249701c4$var$oa(a) {
    if ($223b3691249701c4$var$ja.call($223b3691249701c4$var$ma, a)) return !0;
    if ($223b3691249701c4$var$ja.call($223b3691249701c4$var$la, a)) return !1;
    if ($223b3691249701c4$var$ka.test(a)) return $223b3691249701c4$var$ma[a] = !0;
    $223b3691249701c4$var$la[a] = !0;
    return !1;
}
function $223b3691249701c4$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $223b3691249701c4$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $223b3691249701c4$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $223b3691249701c4$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $223b3691249701c4$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $223b3691249701c4$var$z[b] = new $223b3691249701c4$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $223b3691249701c4$var$ra = /[\-:]([a-z])/g;
function $223b3691249701c4$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($223b3691249701c4$var$ra, $223b3691249701c4$var$sa);
    $223b3691249701c4$var$z[b] = new $223b3691249701c4$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($223b3691249701c4$var$ra, $223b3691249701c4$var$sa);
    $223b3691249701c4$var$z[b] = new $223b3691249701c4$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($223b3691249701c4$var$ra, $223b3691249701c4$var$sa);
    $223b3691249701c4$var$z[b] = new $223b3691249701c4$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$223b3691249701c4$var$z.xlinkHref = new $223b3691249701c4$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $223b3691249701c4$var$ta(a, b, c, d) {
    var e = $223b3691249701c4$var$z.hasOwnProperty(b) ? $223b3691249701c4$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $223b3691249701c4$var$qa(b, c, e, d) && (c = null), d || null === e ? $223b3691249701c4$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $223b3691249701c4$var$ua = $eeH7J.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $223b3691249701c4$var$va = Symbol.for("react.element"), $223b3691249701c4$var$wa = Symbol.for("react.portal"), $223b3691249701c4$var$ya = Symbol.for("react.fragment"), $223b3691249701c4$var$za = Symbol.for("react.strict_mode"), $223b3691249701c4$var$Aa = Symbol.for("react.profiler"), $223b3691249701c4$var$Ba = Symbol.for("react.provider"), $223b3691249701c4$var$Ca = Symbol.for("react.context"), $223b3691249701c4$var$Da = Symbol.for("react.forward_ref"), $223b3691249701c4$var$Ea = Symbol.for("react.suspense"), $223b3691249701c4$var$Fa = Symbol.for("react.suspense_list"), $223b3691249701c4$var$Ga = Symbol.for("react.memo"), $223b3691249701c4$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $223b3691249701c4$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $223b3691249701c4$var$Ja = Symbol.iterator;
function $223b3691249701c4$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $223b3691249701c4$var$Ja && a[$223b3691249701c4$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $223b3691249701c4$var$A = Object.assign, $223b3691249701c4$var$La;
function $223b3691249701c4$var$Ma(a) {
    if (void 0 === $223b3691249701c4$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $223b3691249701c4$var$La = b && b[1] || "";
    }
    return "\n" + $223b3691249701c4$var$La + a;
}
var $223b3691249701c4$var$Na = !1;
function $223b3691249701c4$var$Oa(a, b) {
    if (!a || $223b3691249701c4$var$Na) return "";
    $223b3691249701c4$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $223b3691249701c4$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $223b3691249701c4$var$Ma(a) : "";
}
function $223b3691249701c4$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $223b3691249701c4$var$Ma(a.type);
        case 16:
            return $223b3691249701c4$var$Ma("Lazy");
        case 13:
            return $223b3691249701c4$var$Ma("Suspense");
        case 19:
            return $223b3691249701c4$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $223b3691249701c4$var$Oa(a.type, !1), a;
        case 11:
            return a = $223b3691249701c4$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $223b3691249701c4$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $223b3691249701c4$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $223b3691249701c4$var$ya:
            return "Fragment";
        case $223b3691249701c4$var$wa:
            return "Portal";
        case $223b3691249701c4$var$Aa:
            return "Profiler";
        case $223b3691249701c4$var$za:
            return "StrictMode";
        case $223b3691249701c4$var$Ea:
            return "Suspense";
        case $223b3691249701c4$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $223b3691249701c4$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $223b3691249701c4$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $223b3691249701c4$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $223b3691249701c4$var$Ga:
            return b = a.displayName || null, null !== b ? b : $223b3691249701c4$var$Qa(a.type) || "Memo";
        case $223b3691249701c4$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $223b3691249701c4$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $223b3691249701c4$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $223b3691249701c4$var$Qa(b);
        case 8:
            return b === $223b3691249701c4$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $223b3691249701c4$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $223b3691249701c4$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $223b3691249701c4$var$Ua(a) {
    var b = $223b3691249701c4$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $223b3691249701c4$var$Va(a) {
    a._valueTracker || (a._valueTracker = $223b3691249701c4$var$Ua(a));
}
function $223b3691249701c4$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $223b3691249701c4$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $223b3691249701c4$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $223b3691249701c4$var$Ya(a, b) {
    var c = b.checked;
    return $223b3691249701c4$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $223b3691249701c4$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $223b3691249701c4$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $223b3691249701c4$var$ab(a, b) {
    b = b.checked;
    null != b && $223b3691249701c4$var$ta(a, "checked", b, !1);
}
function $223b3691249701c4$var$bb(a, b) {
    $223b3691249701c4$var$ab(a, b);
    var c = $223b3691249701c4$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $223b3691249701c4$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $223b3691249701c4$var$cb(a, b.type, $223b3691249701c4$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $223b3691249701c4$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $223b3691249701c4$var$cb(a, b, c) {
    if ("number" !== b || $223b3691249701c4$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $223b3691249701c4$var$eb = Array.isArray;
function $223b3691249701c4$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $223b3691249701c4$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $223b3691249701c4$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($223b3691249701c4$var$p(91));
    return $223b3691249701c4$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $223b3691249701c4$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($223b3691249701c4$var$p(92));
            if ($223b3691249701c4$var$eb(c)) {
                if (1 < c.length) throw Error($223b3691249701c4$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $223b3691249701c4$var$Sa(c)
    };
}
function $223b3691249701c4$var$ib(a, b) {
    var c = $223b3691249701c4$var$Sa(b.value), d = $223b3691249701c4$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $223b3691249701c4$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $223b3691249701c4$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $223b3691249701c4$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $223b3691249701c4$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $223b3691249701c4$var$mb, $223b3691249701c4$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $223b3691249701c4$var$mb = $223b3691249701c4$var$mb || document.createElement("div");
        $223b3691249701c4$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $223b3691249701c4$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $223b3691249701c4$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $223b3691249701c4$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $223b3691249701c4$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($223b3691249701c4$var$pb).forEach(function(a) {
    $223b3691249701c4$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $223b3691249701c4$var$pb[b] = $223b3691249701c4$var$pb[a];
    });
});
function $223b3691249701c4$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $223b3691249701c4$var$pb.hasOwnProperty(a) && $223b3691249701c4$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $223b3691249701c4$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $223b3691249701c4$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $223b3691249701c4$var$tb = $223b3691249701c4$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $223b3691249701c4$var$ub(a, b) {
    if (b) {
        if ($223b3691249701c4$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($223b3691249701c4$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($223b3691249701c4$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($223b3691249701c4$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($223b3691249701c4$var$p(62));
    }
}
function $223b3691249701c4$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $223b3691249701c4$var$wb = null;
function $223b3691249701c4$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $223b3691249701c4$var$yb = null, $223b3691249701c4$var$zb = null, $223b3691249701c4$var$Ab = null;
function $223b3691249701c4$var$Bb(a) {
    if (a = $223b3691249701c4$var$Cb(a)) {
        if ("function" !== typeof $223b3691249701c4$var$yb) throw Error($223b3691249701c4$var$p(280));
        var b = a.stateNode;
        b && (b = $223b3691249701c4$var$Db(b), $223b3691249701c4$var$yb(a.stateNode, a.type, b));
    }
}
function $223b3691249701c4$var$Eb(a) {
    $223b3691249701c4$var$zb ? $223b3691249701c4$var$Ab ? $223b3691249701c4$var$Ab.push(a) : $223b3691249701c4$var$Ab = [
        a
    ] : $223b3691249701c4$var$zb = a;
}
function $223b3691249701c4$var$Fb() {
    if ($223b3691249701c4$var$zb) {
        var a = $223b3691249701c4$var$zb, b = $223b3691249701c4$var$Ab;
        $223b3691249701c4$var$Ab = $223b3691249701c4$var$zb = null;
        $223b3691249701c4$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$223b3691249701c4$var$Bb(b[a]);
    }
}
function $223b3691249701c4$var$Gb(a, b) {
    return a(b);
}
function $223b3691249701c4$var$Hb() {}
var $223b3691249701c4$var$Ib = !1;
function $223b3691249701c4$var$Jb(a, b, c) {
    if ($223b3691249701c4$var$Ib) return a(b, c);
    $223b3691249701c4$var$Ib = !0;
    try {
        return $223b3691249701c4$var$Gb(a, b, c);
    } finally{
        if ($223b3691249701c4$var$Ib = !1, null !== $223b3691249701c4$var$zb || null !== $223b3691249701c4$var$Ab) $223b3691249701c4$var$Hb(), $223b3691249701c4$var$Fb();
    }
}
function $223b3691249701c4$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $223b3691249701c4$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($223b3691249701c4$var$p(231, b, typeof c));
    return c;
}
var $223b3691249701c4$var$Lb = !1;
if ($223b3691249701c4$var$ia) try {
    var $223b3691249701c4$var$Mb = {};
    Object.defineProperty($223b3691249701c4$var$Mb, "passive", {
        get: function() {
            $223b3691249701c4$var$Lb = !0;
        }
    });
    window.addEventListener("test", $223b3691249701c4$var$Mb, $223b3691249701c4$var$Mb);
    window.removeEventListener("test", $223b3691249701c4$var$Mb, $223b3691249701c4$var$Mb);
} catch (a) {
    $223b3691249701c4$var$Lb = !1;
}
function $223b3691249701c4$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $223b3691249701c4$var$Ob = !1, $223b3691249701c4$var$Pb = null, $223b3691249701c4$var$Qb = !1, $223b3691249701c4$var$Rb = null, $223b3691249701c4$var$Sb = {
    onError: function(a) {
        $223b3691249701c4$var$Ob = !0;
        $223b3691249701c4$var$Pb = a;
    }
};
function $223b3691249701c4$var$Tb(a, b, c, d, e, f, g, h, k) {
    $223b3691249701c4$var$Ob = !1;
    $223b3691249701c4$var$Pb = null;
    $223b3691249701c4$var$Nb.apply($223b3691249701c4$var$Sb, arguments);
}
function $223b3691249701c4$var$Ub(a, b, c, d, e, f, g, h, k) {
    $223b3691249701c4$var$Tb.apply(this, arguments);
    if ($223b3691249701c4$var$Ob) {
        if ($223b3691249701c4$var$Ob) {
            var l = $223b3691249701c4$var$Pb;
            $223b3691249701c4$var$Ob = !1;
            $223b3691249701c4$var$Pb = null;
        } else throw Error($223b3691249701c4$var$p(198));
        $223b3691249701c4$var$Qb || ($223b3691249701c4$var$Qb = !0, $223b3691249701c4$var$Rb = l);
    }
}
function $223b3691249701c4$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $223b3691249701c4$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $223b3691249701c4$var$Xb(a) {
    if ($223b3691249701c4$var$Vb(a) !== a) throw Error($223b3691249701c4$var$p(188));
}
function $223b3691249701c4$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $223b3691249701c4$var$Vb(a);
        if (null === b) throw Error($223b3691249701c4$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $223b3691249701c4$var$Xb(e), a;
                if (f === d) return $223b3691249701c4$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($223b3691249701c4$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($223b3691249701c4$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($223b3691249701c4$var$p(190));
    }
    if (3 !== c.tag) throw Error($223b3691249701c4$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $223b3691249701c4$var$Zb(a) {
    a = $223b3691249701c4$var$Yb(a);
    return null !== a ? $223b3691249701c4$var$$b(a) : null;
}
function $223b3691249701c4$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $223b3691249701c4$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $223b3691249701c4$var$ac = $l7BOg.unstable_scheduleCallback, $223b3691249701c4$var$bc = $l7BOg.unstable_cancelCallback, $223b3691249701c4$var$cc = $l7BOg.unstable_shouldYield, $223b3691249701c4$var$dc = $l7BOg.unstable_requestPaint, $223b3691249701c4$var$B = $l7BOg.unstable_now, $223b3691249701c4$var$ec = $l7BOg.unstable_getCurrentPriorityLevel, $223b3691249701c4$var$fc = $l7BOg.unstable_ImmediatePriority, $223b3691249701c4$var$gc = $l7BOg.unstable_UserBlockingPriority, $223b3691249701c4$var$hc = $l7BOg.unstable_NormalPriority, $223b3691249701c4$var$ic = $l7BOg.unstable_LowPriority, $223b3691249701c4$var$jc = $l7BOg.unstable_IdlePriority, $223b3691249701c4$var$kc = null, $223b3691249701c4$var$lc = null;
function $223b3691249701c4$var$mc(a) {
    if ($223b3691249701c4$var$lc && "function" === typeof $223b3691249701c4$var$lc.onCommitFiberRoot) try {
        $223b3691249701c4$var$lc.onCommitFiberRoot($223b3691249701c4$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $223b3691249701c4$var$oc = Math.clz32 ? Math.clz32 : $223b3691249701c4$var$nc, $223b3691249701c4$var$pc = Math.log, $223b3691249701c4$var$qc = Math.LN2;
function $223b3691249701c4$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($223b3691249701c4$var$pc(a) / $223b3691249701c4$var$qc | 0) | 0;
}
var $223b3691249701c4$var$rc = 64, $223b3691249701c4$var$sc = 4194304;
function $223b3691249701c4$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $223b3691249701c4$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $223b3691249701c4$var$tc(h) : (f &= g, 0 !== f && (d = $223b3691249701c4$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $223b3691249701c4$var$tc(g) : 0 !== f && (d = $223b3691249701c4$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $223b3691249701c4$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $223b3691249701c4$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $223b3691249701c4$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $223b3691249701c4$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $223b3691249701c4$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $223b3691249701c4$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $223b3691249701c4$var$yc() {
    var a = $223b3691249701c4$var$rc;
    $223b3691249701c4$var$rc <<= 1;
    0 === ($223b3691249701c4$var$rc & 4194240) && ($223b3691249701c4$var$rc = 64);
    return a;
}
function $223b3691249701c4$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $223b3691249701c4$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $223b3691249701c4$var$oc(b);
    a[b] = c;
}
function $223b3691249701c4$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $223b3691249701c4$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $223b3691249701c4$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $223b3691249701c4$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $223b3691249701c4$var$C = 0;
function $223b3691249701c4$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $223b3691249701c4$var$Ec, $223b3691249701c4$var$Fc, $223b3691249701c4$var$Gc, $223b3691249701c4$var$Hc, $223b3691249701c4$var$Ic, $223b3691249701c4$var$Jc = !1, $223b3691249701c4$var$Kc = [], $223b3691249701c4$var$Lc = null, $223b3691249701c4$var$Mc = null, $223b3691249701c4$var$Nc = null, $223b3691249701c4$var$Oc = new Map, $223b3691249701c4$var$Pc = new Map, $223b3691249701c4$var$Qc = [], $223b3691249701c4$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $223b3691249701c4$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $223b3691249701c4$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $223b3691249701c4$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $223b3691249701c4$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $223b3691249701c4$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $223b3691249701c4$var$Pc.delete(b.pointerId);
    }
}
function $223b3691249701c4$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $223b3691249701c4$var$Cb(b), null !== b && $223b3691249701c4$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $223b3691249701c4$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $223b3691249701c4$var$Lc = $223b3691249701c4$var$Tc($223b3691249701c4$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $223b3691249701c4$var$Mc = $223b3691249701c4$var$Tc($223b3691249701c4$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $223b3691249701c4$var$Nc = $223b3691249701c4$var$Tc($223b3691249701c4$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $223b3691249701c4$var$Oc.set(f, $223b3691249701c4$var$Tc($223b3691249701c4$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $223b3691249701c4$var$Pc.set(f, $223b3691249701c4$var$Tc($223b3691249701c4$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $223b3691249701c4$var$Vc(a) {
    var b = $223b3691249701c4$var$Wc(a.target);
    if (null !== b) {
        var c = $223b3691249701c4$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $223b3691249701c4$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $223b3691249701c4$var$Ic(a.priority, function() {
                        $223b3691249701c4$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $223b3691249701c4$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $223b3691249701c4$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $223b3691249701c4$var$wb = d;
            c.target.dispatchEvent(d);
            $223b3691249701c4$var$wb = null;
        } else return b = $223b3691249701c4$var$Cb(c), null !== b && $223b3691249701c4$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $223b3691249701c4$var$Zc(a, b, c) {
    $223b3691249701c4$var$Xc(a) && c.delete(b);
}
function $223b3691249701c4$var$$c() {
    $223b3691249701c4$var$Jc = !1;
    null !== $223b3691249701c4$var$Lc && $223b3691249701c4$var$Xc($223b3691249701c4$var$Lc) && ($223b3691249701c4$var$Lc = null);
    null !== $223b3691249701c4$var$Mc && $223b3691249701c4$var$Xc($223b3691249701c4$var$Mc) && ($223b3691249701c4$var$Mc = null);
    null !== $223b3691249701c4$var$Nc && $223b3691249701c4$var$Xc($223b3691249701c4$var$Nc) && ($223b3691249701c4$var$Nc = null);
    $223b3691249701c4$var$Oc.forEach($223b3691249701c4$var$Zc);
    $223b3691249701c4$var$Pc.forEach($223b3691249701c4$var$Zc);
}
function $223b3691249701c4$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $223b3691249701c4$var$Jc || ($223b3691249701c4$var$Jc = !0, $l7BOg.unstable_scheduleCallback($l7BOg.unstable_NormalPriority, $223b3691249701c4$var$$c)));
}
function $223b3691249701c4$var$bd(a) {
    function b(b) {
        return $223b3691249701c4$var$ad(b, a);
    }
    if (0 < $223b3691249701c4$var$Kc.length) {
        $223b3691249701c4$var$ad($223b3691249701c4$var$Kc[0], a);
        for(var c = 1; c < $223b3691249701c4$var$Kc.length; c++){
            var d = $223b3691249701c4$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $223b3691249701c4$var$Lc && $223b3691249701c4$var$ad($223b3691249701c4$var$Lc, a);
    null !== $223b3691249701c4$var$Mc && $223b3691249701c4$var$ad($223b3691249701c4$var$Mc, a);
    null !== $223b3691249701c4$var$Nc && $223b3691249701c4$var$ad($223b3691249701c4$var$Nc, a);
    $223b3691249701c4$var$Oc.forEach(b);
    $223b3691249701c4$var$Pc.forEach(b);
    for(c = 0; c < $223b3691249701c4$var$Qc.length; c++)d = $223b3691249701c4$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $223b3691249701c4$var$Qc.length && (c = $223b3691249701c4$var$Qc[0], null === c.blockedOn);)$223b3691249701c4$var$Vc(c), null === c.blockedOn && $223b3691249701c4$var$Qc.shift();
}
var $223b3691249701c4$var$cd = $223b3691249701c4$var$ua.ReactCurrentBatchConfig, $223b3691249701c4$var$dd = !0;
function $223b3691249701c4$var$ed(a, b, c, d) {
    var e = $223b3691249701c4$var$C, f = $223b3691249701c4$var$cd.transition;
    $223b3691249701c4$var$cd.transition = null;
    try {
        $223b3691249701c4$var$C = 1, $223b3691249701c4$var$fd(a, b, c, d);
    } finally{
        $223b3691249701c4$var$C = e, $223b3691249701c4$var$cd.transition = f;
    }
}
function $223b3691249701c4$var$gd(a, b, c, d) {
    var e = $223b3691249701c4$var$C, f = $223b3691249701c4$var$cd.transition;
    $223b3691249701c4$var$cd.transition = null;
    try {
        $223b3691249701c4$var$C = 4, $223b3691249701c4$var$fd(a, b, c, d);
    } finally{
        $223b3691249701c4$var$C = e, $223b3691249701c4$var$cd.transition = f;
    }
}
function $223b3691249701c4$var$fd(a, b, c, d) {
    if ($223b3691249701c4$var$dd) {
        var e = $223b3691249701c4$var$Yc(a, b, c, d);
        if (null === e) $223b3691249701c4$var$hd(a, b, d, $223b3691249701c4$var$id, c), $223b3691249701c4$var$Sc(a, d);
        else if ($223b3691249701c4$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($223b3691249701c4$var$Sc(a, d), b & 4 && -1 < $223b3691249701c4$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $223b3691249701c4$var$Cb(e);
                null !== f && $223b3691249701c4$var$Ec(f);
                f = $223b3691249701c4$var$Yc(a, b, c, d);
                null === f && $223b3691249701c4$var$hd(a, b, d, $223b3691249701c4$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $223b3691249701c4$var$hd(a, b, d, null, c);
    }
}
var $223b3691249701c4$var$id = null;
function $223b3691249701c4$var$Yc(a, b, c, d) {
    $223b3691249701c4$var$id = null;
    a = $223b3691249701c4$var$xb(d);
    a = $223b3691249701c4$var$Wc(a);
    if (null !== a) {
        if (b = $223b3691249701c4$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $223b3691249701c4$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $223b3691249701c4$var$id = a;
    return null;
}
function $223b3691249701c4$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($223b3691249701c4$var$ec()){
                case $223b3691249701c4$var$fc:
                    return 1;
                case $223b3691249701c4$var$gc:
                    return 4;
                case $223b3691249701c4$var$hc:
                case $223b3691249701c4$var$ic:
                    return 16;
                case $223b3691249701c4$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $223b3691249701c4$var$kd = null, $223b3691249701c4$var$ld = null, $223b3691249701c4$var$md = null;
function $223b3691249701c4$var$nd() {
    if ($223b3691249701c4$var$md) return $223b3691249701c4$var$md;
    var a, b = $223b3691249701c4$var$ld, c = b.length, d, e = "value" in $223b3691249701c4$var$kd ? $223b3691249701c4$var$kd.value : $223b3691249701c4$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $223b3691249701c4$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $223b3691249701c4$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $223b3691249701c4$var$pd() {
    return !0;
}
function $223b3691249701c4$var$qd() {
    return !1;
}
function $223b3691249701c4$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $223b3691249701c4$var$pd : $223b3691249701c4$var$qd;
        this.isPropagationStopped = $223b3691249701c4$var$qd;
        return this;
    }
    $223b3691249701c4$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $223b3691249701c4$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $223b3691249701c4$var$pd);
        },
        persist: function() {},
        isPersistent: $223b3691249701c4$var$pd
    });
    return b;
}
var $223b3691249701c4$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $223b3691249701c4$var$td = $223b3691249701c4$var$rd($223b3691249701c4$var$sd), $223b3691249701c4$var$ud = $223b3691249701c4$var$A({}, $223b3691249701c4$var$sd, {
    view: 0,
    detail: 0
}), $223b3691249701c4$var$vd = $223b3691249701c4$var$rd($223b3691249701c4$var$ud), $223b3691249701c4$var$wd, $223b3691249701c4$var$xd, $223b3691249701c4$var$yd, $223b3691249701c4$var$Ad = $223b3691249701c4$var$A({}, $223b3691249701c4$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $223b3691249701c4$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $223b3691249701c4$var$yd && ($223b3691249701c4$var$yd && "mousemove" === a.type ? ($223b3691249701c4$var$wd = a.screenX - $223b3691249701c4$var$yd.screenX, $223b3691249701c4$var$xd = a.screenY - $223b3691249701c4$var$yd.screenY) : $223b3691249701c4$var$xd = $223b3691249701c4$var$wd = 0, $223b3691249701c4$var$yd = a);
        return $223b3691249701c4$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $223b3691249701c4$var$xd;
    }
}), $223b3691249701c4$var$Bd = $223b3691249701c4$var$rd($223b3691249701c4$var$Ad), $223b3691249701c4$var$Cd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$Ad, {
    dataTransfer: 0
}), $223b3691249701c4$var$Dd = $223b3691249701c4$var$rd($223b3691249701c4$var$Cd), $223b3691249701c4$var$Ed = $223b3691249701c4$var$A({}, $223b3691249701c4$var$ud, {
    relatedTarget: 0
}), $223b3691249701c4$var$Fd = $223b3691249701c4$var$rd($223b3691249701c4$var$Ed), $223b3691249701c4$var$Gd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $223b3691249701c4$var$Hd = $223b3691249701c4$var$rd($223b3691249701c4$var$Gd), $223b3691249701c4$var$Id = $223b3691249701c4$var$A({}, $223b3691249701c4$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $223b3691249701c4$var$Jd = $223b3691249701c4$var$rd($223b3691249701c4$var$Id), $223b3691249701c4$var$Kd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$sd, {
    data: 0
}), $223b3691249701c4$var$Ld = $223b3691249701c4$var$rd($223b3691249701c4$var$Kd), $223b3691249701c4$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $223b3691249701c4$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $223b3691249701c4$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $223b3691249701c4$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $223b3691249701c4$var$Od[a]) ? !!b[a] : !1;
}
function $223b3691249701c4$var$zd() {
    return $223b3691249701c4$var$Pd;
}
var $223b3691249701c4$var$Qd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $223b3691249701c4$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $223b3691249701c4$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $223b3691249701c4$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $223b3691249701c4$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $223b3691249701c4$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $223b3691249701c4$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $223b3691249701c4$var$Rd = $223b3691249701c4$var$rd($223b3691249701c4$var$Qd), $223b3691249701c4$var$Sd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $223b3691249701c4$var$Td = $223b3691249701c4$var$rd($223b3691249701c4$var$Sd), $223b3691249701c4$var$Ud = $223b3691249701c4$var$A({}, $223b3691249701c4$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $223b3691249701c4$var$zd
}), $223b3691249701c4$var$Vd = $223b3691249701c4$var$rd($223b3691249701c4$var$Ud), $223b3691249701c4$var$Wd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $223b3691249701c4$var$Xd = $223b3691249701c4$var$rd($223b3691249701c4$var$Wd), $223b3691249701c4$var$Yd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $223b3691249701c4$var$Zd = $223b3691249701c4$var$rd($223b3691249701c4$var$Yd), $223b3691249701c4$var$$d = [
    9,
    13,
    27,
    32
], $223b3691249701c4$var$ae = $223b3691249701c4$var$ia && "CompositionEvent" in window, $223b3691249701c4$var$be = null;
$223b3691249701c4$var$ia && "documentMode" in document && ($223b3691249701c4$var$be = document.documentMode);
var $223b3691249701c4$var$ce = $223b3691249701c4$var$ia && "TextEvent" in window && !$223b3691249701c4$var$be, $223b3691249701c4$var$de = $223b3691249701c4$var$ia && (!$223b3691249701c4$var$ae || $223b3691249701c4$var$be && 8 < $223b3691249701c4$var$be && 11 >= $223b3691249701c4$var$be), $223b3691249701c4$var$ee = String.fromCharCode(32), $223b3691249701c4$var$fe = !1;
function $223b3691249701c4$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $223b3691249701c4$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $223b3691249701c4$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $223b3691249701c4$var$ie = !1;
function $223b3691249701c4$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $223b3691249701c4$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $223b3691249701c4$var$fe = !0;
            return $223b3691249701c4$var$ee;
        case "textInput":
            return a = b.data, a === $223b3691249701c4$var$ee && $223b3691249701c4$var$fe ? null : a;
        default:
            return null;
    }
}
function $223b3691249701c4$var$ke(a, b) {
    if ($223b3691249701c4$var$ie) return "compositionend" === a || !$223b3691249701c4$var$ae && $223b3691249701c4$var$ge(a, b) ? (a = $223b3691249701c4$var$nd(), $223b3691249701c4$var$md = $223b3691249701c4$var$ld = $223b3691249701c4$var$kd = null, $223b3691249701c4$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $223b3691249701c4$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $223b3691249701c4$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $223b3691249701c4$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$223b3691249701c4$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $223b3691249701c4$var$ne(a, b, c, d) {
    $223b3691249701c4$var$Eb(d);
    b = $223b3691249701c4$var$oe(b, "onChange");
    0 < b.length && (c = new $223b3691249701c4$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $223b3691249701c4$var$pe = null, $223b3691249701c4$var$qe = null;
function $223b3691249701c4$var$re(a) {
    $223b3691249701c4$var$se(a, 0);
}
function $223b3691249701c4$var$te(a) {
    var b = $223b3691249701c4$var$ue(a);
    if ($223b3691249701c4$var$Wa(b)) return a;
}
function $223b3691249701c4$var$ve(a, b) {
    if ("change" === a) return b;
}
var $223b3691249701c4$var$we = !1;
if ($223b3691249701c4$var$ia) {
    var $223b3691249701c4$var$xe;
    if ($223b3691249701c4$var$ia) {
        var $223b3691249701c4$var$ye = "oninput" in document;
        if (!$223b3691249701c4$var$ye) {
            var $223b3691249701c4$var$ze = document.createElement("div");
            $223b3691249701c4$var$ze.setAttribute("oninput", "return;");
            $223b3691249701c4$var$ye = "function" === typeof $223b3691249701c4$var$ze.oninput;
        }
        $223b3691249701c4$var$xe = $223b3691249701c4$var$ye;
    } else $223b3691249701c4$var$xe = !1;
    $223b3691249701c4$var$we = $223b3691249701c4$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $223b3691249701c4$var$Ae() {
    $223b3691249701c4$var$pe && ($223b3691249701c4$var$pe.detachEvent("onpropertychange", $223b3691249701c4$var$Be), $223b3691249701c4$var$qe = $223b3691249701c4$var$pe = null);
}
function $223b3691249701c4$var$Be(a) {
    if ("value" === a.propertyName && $223b3691249701c4$var$te($223b3691249701c4$var$qe)) {
        var b = [];
        $223b3691249701c4$var$ne(b, $223b3691249701c4$var$qe, a, $223b3691249701c4$var$xb(a));
        $223b3691249701c4$var$Jb($223b3691249701c4$var$re, b);
    }
}
function $223b3691249701c4$var$Ce(a, b, c) {
    "focusin" === a ? ($223b3691249701c4$var$Ae(), $223b3691249701c4$var$pe = b, $223b3691249701c4$var$qe = c, $223b3691249701c4$var$pe.attachEvent("onpropertychange", $223b3691249701c4$var$Be)) : "focusout" === a && $223b3691249701c4$var$Ae();
}
function $223b3691249701c4$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $223b3691249701c4$var$te($223b3691249701c4$var$qe);
}
function $223b3691249701c4$var$Ee(a, b) {
    if ("click" === a) return $223b3691249701c4$var$te(b);
}
function $223b3691249701c4$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $223b3691249701c4$var$te(b);
}
function $223b3691249701c4$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $223b3691249701c4$var$He = "function" === typeof Object.is ? Object.is : $223b3691249701c4$var$Ge;
function $223b3691249701c4$var$Ie(a, b) {
    if ($223b3691249701c4$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$223b3691249701c4$var$ja.call(b, e) || !$223b3691249701c4$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $223b3691249701c4$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $223b3691249701c4$var$Ke(a, b) {
    var c = $223b3691249701c4$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $223b3691249701c4$var$Je(c);
    }
}
function $223b3691249701c4$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $223b3691249701c4$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $223b3691249701c4$var$Me() {
    for(var a = window, b = $223b3691249701c4$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $223b3691249701c4$var$Xa(a.document);
    }
    return b;
}
function $223b3691249701c4$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $223b3691249701c4$var$Oe(a) {
    var b = $223b3691249701c4$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $223b3691249701c4$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $223b3691249701c4$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $223b3691249701c4$var$Ke(c, f);
                var g = $223b3691249701c4$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $223b3691249701c4$var$Pe = $223b3691249701c4$var$ia && "documentMode" in document && 11 >= document.documentMode, $223b3691249701c4$var$Qe = null, $223b3691249701c4$var$Re = null, $223b3691249701c4$var$Se = null, $223b3691249701c4$var$Te = !1;
function $223b3691249701c4$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $223b3691249701c4$var$Te || null == $223b3691249701c4$var$Qe || $223b3691249701c4$var$Qe !== $223b3691249701c4$var$Xa(d) || (d = $223b3691249701c4$var$Qe, "selectionStart" in d && $223b3691249701c4$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $223b3691249701c4$var$Se && $223b3691249701c4$var$Ie($223b3691249701c4$var$Se, d) || ($223b3691249701c4$var$Se = d, d = $223b3691249701c4$var$oe($223b3691249701c4$var$Re, "onSelect"), 0 < d.length && (b = new $223b3691249701c4$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $223b3691249701c4$var$Qe)));
}
function $223b3691249701c4$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $223b3691249701c4$var$We = {
    animationend: $223b3691249701c4$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $223b3691249701c4$var$Ve("Animation", "AnimationIteration"),
    animationstart: $223b3691249701c4$var$Ve("Animation", "AnimationStart"),
    transitionend: $223b3691249701c4$var$Ve("Transition", "TransitionEnd")
}, $223b3691249701c4$var$Xe = {}, $223b3691249701c4$var$Ye = {};
$223b3691249701c4$var$ia && ($223b3691249701c4$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $223b3691249701c4$var$We.animationend.animation, delete $223b3691249701c4$var$We.animationiteration.animation, delete $223b3691249701c4$var$We.animationstart.animation), "TransitionEvent" in window || delete $223b3691249701c4$var$We.transitionend.transition);
function $223b3691249701c4$var$Ze(a) {
    if ($223b3691249701c4$var$Xe[a]) return $223b3691249701c4$var$Xe[a];
    if (!$223b3691249701c4$var$We[a]) return a;
    var b = $223b3691249701c4$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $223b3691249701c4$var$Ye) return $223b3691249701c4$var$Xe[a] = b[c];
    return a;
}
var $223b3691249701c4$var$$e = $223b3691249701c4$var$Ze("animationend"), $223b3691249701c4$var$af = $223b3691249701c4$var$Ze("animationiteration"), $223b3691249701c4$var$bf = $223b3691249701c4$var$Ze("animationstart"), $223b3691249701c4$var$cf = $223b3691249701c4$var$Ze("transitionend"), $223b3691249701c4$var$df = new Map, $223b3691249701c4$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $223b3691249701c4$var$ff(a, b) {
    $223b3691249701c4$var$df.set(a, b);
    $223b3691249701c4$var$fa(b, [
        a
    ]);
}
for(var $223b3691249701c4$var$gf = 0; $223b3691249701c4$var$gf < $223b3691249701c4$var$ef.length; $223b3691249701c4$var$gf++){
    var $223b3691249701c4$var$hf = $223b3691249701c4$var$ef[$223b3691249701c4$var$gf], $223b3691249701c4$var$jf = $223b3691249701c4$var$hf.toLowerCase(), $223b3691249701c4$var$kf = $223b3691249701c4$var$hf[0].toUpperCase() + $223b3691249701c4$var$hf.slice(1);
    $223b3691249701c4$var$ff($223b3691249701c4$var$jf, "on" + $223b3691249701c4$var$kf);
}
$223b3691249701c4$var$ff($223b3691249701c4$var$$e, "onAnimationEnd");
$223b3691249701c4$var$ff($223b3691249701c4$var$af, "onAnimationIteration");
$223b3691249701c4$var$ff($223b3691249701c4$var$bf, "onAnimationStart");
$223b3691249701c4$var$ff("dblclick", "onDoubleClick");
$223b3691249701c4$var$ff("focusin", "onFocus");
$223b3691249701c4$var$ff("focusout", "onBlur");
$223b3691249701c4$var$ff($223b3691249701c4$var$cf, "onTransitionEnd");
$223b3691249701c4$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$223b3691249701c4$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$223b3691249701c4$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$223b3691249701c4$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$223b3691249701c4$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$223b3691249701c4$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$223b3691249701c4$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$223b3691249701c4$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$223b3691249701c4$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$223b3691249701c4$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $223b3691249701c4$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $223b3691249701c4$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($223b3691249701c4$var$lf));
function $223b3691249701c4$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $223b3691249701c4$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $223b3691249701c4$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $223b3691249701c4$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $223b3691249701c4$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($223b3691249701c4$var$Qb) throw a = $223b3691249701c4$var$Rb, $223b3691249701c4$var$Qb = !1, $223b3691249701c4$var$Rb = null, a;
}
function $223b3691249701c4$var$D(a, b) {
    var c = b[$223b3691249701c4$var$of];
    void 0 === c && (c = b[$223b3691249701c4$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($223b3691249701c4$var$pf(b, a, 2, !1), c.add(d));
}
function $223b3691249701c4$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $223b3691249701c4$var$pf(c, a, d, b);
}
var $223b3691249701c4$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $223b3691249701c4$var$sf(a) {
    if (!a[$223b3691249701c4$var$rf]) {
        a[$223b3691249701c4$var$rf] = !0;
        $223b3691249701c4$var$da.forEach(function(b) {
            "selectionchange" !== b && ($223b3691249701c4$var$mf.has(b) || $223b3691249701c4$var$qf(b, !1, a), $223b3691249701c4$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$223b3691249701c4$var$rf] || (b[$223b3691249701c4$var$rf] = !0, $223b3691249701c4$var$qf("selectionchange", !1, b));
    }
}
function $223b3691249701c4$var$pf(a, b, c, d) {
    switch($223b3691249701c4$var$jd(b)){
        case 1:
            var e = $223b3691249701c4$var$ed;
            break;
        case 4:
            e = $223b3691249701c4$var$gd;
            break;
        default:
            e = $223b3691249701c4$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$223b3691249701c4$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $223b3691249701c4$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $223b3691249701c4$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $223b3691249701c4$var$Jb(function() {
        var d = f, e = $223b3691249701c4$var$xb(c), g = [];
        a: {
            var h = $223b3691249701c4$var$df.get(a);
            if (void 0 !== h) {
                var k = $223b3691249701c4$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $223b3691249701c4$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $223b3691249701c4$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $223b3691249701c4$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $223b3691249701c4$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $223b3691249701c4$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $223b3691249701c4$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $223b3691249701c4$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $223b3691249701c4$var$Vd;
                        break;
                    case $223b3691249701c4$var$$e:
                    case $223b3691249701c4$var$af:
                    case $223b3691249701c4$var$bf:
                        k = $223b3691249701c4$var$Hd;
                        break;
                    case $223b3691249701c4$var$cf:
                        k = $223b3691249701c4$var$Xd;
                        break;
                    case "scroll":
                        k = $223b3691249701c4$var$vd;
                        break;
                    case "wheel":
                        k = $223b3691249701c4$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $223b3691249701c4$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $223b3691249701c4$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $223b3691249701c4$var$Kb(w, x), null != F && t.push($223b3691249701c4$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $223b3691249701c4$var$wb && (n = c.relatedTarget || c.fromElement) && ($223b3691249701c4$var$Wc(n) || n[$223b3691249701c4$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $223b3691249701c4$var$Wc(n) : null, null !== n && (J = $223b3691249701c4$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $223b3691249701c4$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $223b3691249701c4$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $223b3691249701c4$var$ue(k);
                        u = null == n ? h : $223b3691249701c4$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $223b3691249701c4$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $223b3691249701c4$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $223b3691249701c4$var$vf(F))u++;
                            for(; 0 < w - u;)t = $223b3691249701c4$var$vf(t), w--;
                            for(; 0 < u - w;)x = $223b3691249701c4$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $223b3691249701c4$var$vf(t);
                                x = $223b3691249701c4$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $223b3691249701c4$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $223b3691249701c4$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $223b3691249701c4$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $223b3691249701c4$var$ve;
                else if ($223b3691249701c4$var$me(h)) {
                    if ($223b3691249701c4$var$we) na = $223b3691249701c4$var$Fe;
                    else {
                        na = $223b3691249701c4$var$De;
                        var xa = $223b3691249701c4$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $223b3691249701c4$var$Ee);
                if (na && (na = na(a, d))) {
                    $223b3691249701c4$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $223b3691249701c4$var$cb(h, "number", h.value);
            }
            xa = d ? $223b3691249701c4$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($223b3691249701c4$var$me(xa) || "true" === xa.contentEditable) $223b3691249701c4$var$Qe = xa, $223b3691249701c4$var$Re = d, $223b3691249701c4$var$Se = null;
                    break;
                case "focusout":
                    $223b3691249701c4$var$Se = $223b3691249701c4$var$Re = $223b3691249701c4$var$Qe = null;
                    break;
                case "mousedown":
                    $223b3691249701c4$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $223b3691249701c4$var$Te = !1;
                    $223b3691249701c4$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($223b3691249701c4$var$Pe) break;
                case "keydown":
                case "keyup":
                    $223b3691249701c4$var$Ue(g, c, e);
            }
            var $a;
            if ($223b3691249701c4$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $223b3691249701c4$var$ie ? $223b3691249701c4$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($223b3691249701c4$var$de && "ko" !== c.locale && ($223b3691249701c4$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $223b3691249701c4$var$ie && ($a = $223b3691249701c4$var$nd()) : ($223b3691249701c4$var$kd = e, $223b3691249701c4$var$ld = "value" in $223b3691249701c4$var$kd ? $223b3691249701c4$var$kd.value : $223b3691249701c4$var$kd.textContent, $223b3691249701c4$var$ie = !0)), xa = $223b3691249701c4$var$oe(d, ba), 0 < xa.length && (ba = new $223b3691249701c4$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $223b3691249701c4$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $223b3691249701c4$var$ce ? $223b3691249701c4$var$je(a, c) : $223b3691249701c4$var$ke(a, c)) d = $223b3691249701c4$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $223b3691249701c4$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $223b3691249701c4$var$se(g, b);
    });
}
function $223b3691249701c4$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $223b3691249701c4$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $223b3691249701c4$var$Kb(a, c), null != f && d.unshift($223b3691249701c4$var$tf(a, f, e)), f = $223b3691249701c4$var$Kb(a, b), null != f && d.push($223b3691249701c4$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $223b3691249701c4$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $223b3691249701c4$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $223b3691249701c4$var$Kb(c, f), null != k && g.unshift($223b3691249701c4$var$tf(c, k, h))) : e || (k = $223b3691249701c4$var$Kb(c, f), null != k && g.push($223b3691249701c4$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $223b3691249701c4$var$xf = /\r\n?/g, $223b3691249701c4$var$yf = /\u0000|\uFFFD/g;
function $223b3691249701c4$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($223b3691249701c4$var$xf, "\n").replace($223b3691249701c4$var$yf, "");
}
function $223b3691249701c4$var$Af(a, b, c) {
    b = $223b3691249701c4$var$zf(b);
    if ($223b3691249701c4$var$zf(a) !== b && c) throw Error($223b3691249701c4$var$p(425));
}
function $223b3691249701c4$var$Bf() {}
var $223b3691249701c4$var$Cf = null, $223b3691249701c4$var$Df = null;
function $223b3691249701c4$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $223b3691249701c4$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $223b3691249701c4$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $223b3691249701c4$var$Hf = "function" === typeof Promise ? Promise : void 0, $223b3691249701c4$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $223b3691249701c4$var$Hf ? function(a) {
    return $223b3691249701c4$var$Hf.resolve(null).then(a).catch($223b3691249701c4$var$If);
} : $223b3691249701c4$var$Ff;
function $223b3691249701c4$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $223b3691249701c4$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $223b3691249701c4$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $223b3691249701c4$var$bd(b);
}
function $223b3691249701c4$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $223b3691249701c4$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $223b3691249701c4$var$Nf = Math.random().toString(36).slice(2), $223b3691249701c4$var$Of = "__reactFiber$" + $223b3691249701c4$var$Nf, $223b3691249701c4$var$Pf = "__reactProps$" + $223b3691249701c4$var$Nf, $223b3691249701c4$var$uf = "__reactContainer$" + $223b3691249701c4$var$Nf, $223b3691249701c4$var$of = "__reactEvents$" + $223b3691249701c4$var$Nf, $223b3691249701c4$var$Qf = "__reactListeners$" + $223b3691249701c4$var$Nf, $223b3691249701c4$var$Rf = "__reactHandles$" + $223b3691249701c4$var$Nf;
function $223b3691249701c4$var$Wc(a) {
    var b = a[$223b3691249701c4$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$223b3691249701c4$var$uf] || c[$223b3691249701c4$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $223b3691249701c4$var$Mf(a); null !== a;){
                if (c = a[$223b3691249701c4$var$Of]) return c;
                a = $223b3691249701c4$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $223b3691249701c4$var$Cb(a) {
    a = a[$223b3691249701c4$var$Of] || a[$223b3691249701c4$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $223b3691249701c4$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($223b3691249701c4$var$p(33));
}
function $223b3691249701c4$var$Db(a) {
    return a[$223b3691249701c4$var$Pf] || null;
}
var $223b3691249701c4$var$Sf = [], $223b3691249701c4$var$Tf = -1;
function $223b3691249701c4$var$Uf(a) {
    return {
        current: a
    };
}
function $223b3691249701c4$var$E(a) {
    0 > $223b3691249701c4$var$Tf || (a.current = $223b3691249701c4$var$Sf[$223b3691249701c4$var$Tf], $223b3691249701c4$var$Sf[$223b3691249701c4$var$Tf] = null, $223b3691249701c4$var$Tf--);
}
function $223b3691249701c4$var$G(a, b) {
    $223b3691249701c4$var$Tf++;
    $223b3691249701c4$var$Sf[$223b3691249701c4$var$Tf] = a.current;
    a.current = b;
}
var $223b3691249701c4$var$Vf = {}, $223b3691249701c4$var$H = $223b3691249701c4$var$Uf($223b3691249701c4$var$Vf), $223b3691249701c4$var$Wf = $223b3691249701c4$var$Uf(!1), $223b3691249701c4$var$Xf = $223b3691249701c4$var$Vf;
function $223b3691249701c4$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $223b3691249701c4$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $223b3691249701c4$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $223b3691249701c4$var$$f() {
    $223b3691249701c4$var$E($223b3691249701c4$var$Wf);
    $223b3691249701c4$var$E($223b3691249701c4$var$H);
}
function $223b3691249701c4$var$ag(a, b, c) {
    if ($223b3691249701c4$var$H.current !== $223b3691249701c4$var$Vf) throw Error($223b3691249701c4$var$p(168));
    $223b3691249701c4$var$G($223b3691249701c4$var$H, b);
    $223b3691249701c4$var$G($223b3691249701c4$var$Wf, c);
}
function $223b3691249701c4$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($223b3691249701c4$var$p(108, $223b3691249701c4$var$Ra(a) || "Unknown", e));
    return $223b3691249701c4$var$A({}, c, d);
}
function $223b3691249701c4$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $223b3691249701c4$var$Vf;
    $223b3691249701c4$var$Xf = $223b3691249701c4$var$H.current;
    $223b3691249701c4$var$G($223b3691249701c4$var$H, a);
    $223b3691249701c4$var$G($223b3691249701c4$var$Wf, $223b3691249701c4$var$Wf.current);
    return !0;
}
function $223b3691249701c4$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($223b3691249701c4$var$p(169));
    c ? (a = $223b3691249701c4$var$bg(a, b, $223b3691249701c4$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $223b3691249701c4$var$E($223b3691249701c4$var$Wf), $223b3691249701c4$var$E($223b3691249701c4$var$H), $223b3691249701c4$var$G($223b3691249701c4$var$H, a)) : $223b3691249701c4$var$E($223b3691249701c4$var$Wf);
    $223b3691249701c4$var$G($223b3691249701c4$var$Wf, c);
}
var $223b3691249701c4$var$eg = null, $223b3691249701c4$var$fg = !1, $223b3691249701c4$var$gg = !1;
function $223b3691249701c4$var$hg(a) {
    null === $223b3691249701c4$var$eg ? $223b3691249701c4$var$eg = [
        a
    ] : $223b3691249701c4$var$eg.push(a);
}
function $223b3691249701c4$var$ig(a) {
    $223b3691249701c4$var$fg = !0;
    $223b3691249701c4$var$hg(a);
}
function $223b3691249701c4$var$jg() {
    if (!$223b3691249701c4$var$gg && null !== $223b3691249701c4$var$eg) {
        $223b3691249701c4$var$gg = !0;
        var a = 0, b = $223b3691249701c4$var$C;
        try {
            var c = $223b3691249701c4$var$eg;
            for($223b3691249701c4$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $223b3691249701c4$var$eg = null;
            $223b3691249701c4$var$fg = !1;
        } catch (e) {
            throw null !== $223b3691249701c4$var$eg && ($223b3691249701c4$var$eg = $223b3691249701c4$var$eg.slice(a + 1)), $223b3691249701c4$var$ac($223b3691249701c4$var$fc, $223b3691249701c4$var$jg), e;
        } finally{
            $223b3691249701c4$var$C = b, $223b3691249701c4$var$gg = !1;
        }
    }
    return null;
}
var $223b3691249701c4$var$kg = [], $223b3691249701c4$var$lg = 0, $223b3691249701c4$var$mg = null, $223b3691249701c4$var$ng = 0, $223b3691249701c4$var$og = [], $223b3691249701c4$var$pg = 0, $223b3691249701c4$var$qg = null, $223b3691249701c4$var$rg = 1, $223b3691249701c4$var$sg = "";
function $223b3691249701c4$var$tg(a, b) {
    $223b3691249701c4$var$kg[$223b3691249701c4$var$lg++] = $223b3691249701c4$var$ng;
    $223b3691249701c4$var$kg[$223b3691249701c4$var$lg++] = $223b3691249701c4$var$mg;
    $223b3691249701c4$var$mg = a;
    $223b3691249701c4$var$ng = b;
}
function $223b3691249701c4$var$ug(a, b, c) {
    $223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$rg;
    $223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$sg;
    $223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$qg;
    $223b3691249701c4$var$qg = a;
    var d = $223b3691249701c4$var$rg;
    a = $223b3691249701c4$var$sg;
    var e = 32 - $223b3691249701c4$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $223b3691249701c4$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $223b3691249701c4$var$rg = 1 << 32 - $223b3691249701c4$var$oc(b) + e | c << e | d;
        $223b3691249701c4$var$sg = f + a;
    } else $223b3691249701c4$var$rg = 1 << f | c << e | d, $223b3691249701c4$var$sg = a;
}
function $223b3691249701c4$var$vg(a) {
    null !== a.return && ($223b3691249701c4$var$tg(a, 1), $223b3691249701c4$var$ug(a, 1, 0));
}
function $223b3691249701c4$var$wg(a) {
    for(; a === $223b3691249701c4$var$mg;)$223b3691249701c4$var$mg = $223b3691249701c4$var$kg[--$223b3691249701c4$var$lg], $223b3691249701c4$var$kg[$223b3691249701c4$var$lg] = null, $223b3691249701c4$var$ng = $223b3691249701c4$var$kg[--$223b3691249701c4$var$lg], $223b3691249701c4$var$kg[$223b3691249701c4$var$lg] = null;
    for(; a === $223b3691249701c4$var$qg;)$223b3691249701c4$var$qg = $223b3691249701c4$var$og[--$223b3691249701c4$var$pg], $223b3691249701c4$var$og[$223b3691249701c4$var$pg] = null, $223b3691249701c4$var$sg = $223b3691249701c4$var$og[--$223b3691249701c4$var$pg], $223b3691249701c4$var$og[$223b3691249701c4$var$pg] = null, $223b3691249701c4$var$rg = $223b3691249701c4$var$og[--$223b3691249701c4$var$pg], $223b3691249701c4$var$og[$223b3691249701c4$var$pg] = null;
}
var $223b3691249701c4$var$xg = null, $223b3691249701c4$var$yg = null, $223b3691249701c4$var$I = !1, $223b3691249701c4$var$zg = null;
function $223b3691249701c4$var$Ag(a, b) {
    var c = $223b3691249701c4$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $223b3691249701c4$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $223b3691249701c4$var$xg = a, $223b3691249701c4$var$yg = $223b3691249701c4$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $223b3691249701c4$var$xg = a, $223b3691249701c4$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $223b3691249701c4$var$qg ? {
                id: $223b3691249701c4$var$rg,
                overflow: $223b3691249701c4$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $223b3691249701c4$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $223b3691249701c4$var$xg = a, $223b3691249701c4$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $223b3691249701c4$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $223b3691249701c4$var$Eg(a) {
    if ($223b3691249701c4$var$I) {
        var b = $223b3691249701c4$var$yg;
        if (b) {
            var c = b;
            if (!$223b3691249701c4$var$Cg(a, b)) {
                if ($223b3691249701c4$var$Dg(a)) throw Error($223b3691249701c4$var$p(418));
                b = $223b3691249701c4$var$Lf(c.nextSibling);
                var d = $223b3691249701c4$var$xg;
                b && $223b3691249701c4$var$Cg(a, b) ? $223b3691249701c4$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $223b3691249701c4$var$I = !1, $223b3691249701c4$var$xg = a);
            }
        } else {
            if ($223b3691249701c4$var$Dg(a)) throw Error($223b3691249701c4$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $223b3691249701c4$var$I = !1;
            $223b3691249701c4$var$xg = a;
        }
    }
}
function $223b3691249701c4$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $223b3691249701c4$var$xg = a;
}
function $223b3691249701c4$var$Gg(a) {
    if (a !== $223b3691249701c4$var$xg) return !1;
    if (!$223b3691249701c4$var$I) return $223b3691249701c4$var$Fg(a), $223b3691249701c4$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$223b3691249701c4$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $223b3691249701c4$var$yg)) {
        if ($223b3691249701c4$var$Dg(a)) throw $223b3691249701c4$var$Hg(), Error($223b3691249701c4$var$p(418));
        for(; b;)$223b3691249701c4$var$Ag(a, b), b = $223b3691249701c4$var$Lf(b.nextSibling);
    }
    $223b3691249701c4$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($223b3691249701c4$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $223b3691249701c4$var$yg = $223b3691249701c4$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $223b3691249701c4$var$yg = null;
        }
    } else $223b3691249701c4$var$yg = $223b3691249701c4$var$xg ? $223b3691249701c4$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $223b3691249701c4$var$Hg() {
    for(var a = $223b3691249701c4$var$yg; a;)a = $223b3691249701c4$var$Lf(a.nextSibling);
}
function $223b3691249701c4$var$Ig() {
    $223b3691249701c4$var$yg = $223b3691249701c4$var$xg = null;
    $223b3691249701c4$var$I = !1;
}
function $223b3691249701c4$var$Jg(a) {
    null === $223b3691249701c4$var$zg ? $223b3691249701c4$var$zg = [
        a
    ] : $223b3691249701c4$var$zg.push(a);
}
var $223b3691249701c4$var$Kg = $223b3691249701c4$var$ua.ReactCurrentBatchConfig;
function $223b3691249701c4$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($223b3691249701c4$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($223b3691249701c4$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($223b3691249701c4$var$p(284));
        if (!c._owner) throw Error($223b3691249701c4$var$p(290, a));
    }
    return a;
}
function $223b3691249701c4$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($223b3691249701c4$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $223b3691249701c4$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $223b3691249701c4$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $223b3691249701c4$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $223b3691249701c4$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $223b3691249701c4$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $223b3691249701c4$var$Ha && $223b3691249701c4$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $223b3691249701c4$var$Lg(a, b, c), d.return = a, d;
        d = $223b3691249701c4$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $223b3691249701c4$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $223b3691249701c4$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $223b3691249701c4$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $223b3691249701c4$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $223b3691249701c4$var$va:
                    return c = $223b3691249701c4$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $223b3691249701c4$var$Lg(a, null, b), c.return = a, c;
                case $223b3691249701c4$var$wa:
                    return b = $223b3691249701c4$var$Sg(b, a.mode, c), b.return = a, b;
                case $223b3691249701c4$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($223b3691249701c4$var$eb(b) || $223b3691249701c4$var$Ka(b)) return b = $223b3691249701c4$var$Tg(b, a.mode, c, null), b.return = a, b;
            $223b3691249701c4$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $223b3691249701c4$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $223b3691249701c4$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $223b3691249701c4$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($223b3691249701c4$var$eb(c) || $223b3691249701c4$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $223b3691249701c4$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $223b3691249701c4$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $223b3691249701c4$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $223b3691249701c4$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($223b3691249701c4$var$eb(d) || $223b3691249701c4$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $223b3691249701c4$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $223b3691249701c4$var$Ka(h);
        if ("function" !== typeof l) throw Error($223b3691249701c4$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($223b3691249701c4$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $223b3691249701c4$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $223b3691249701c4$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $223b3691249701c4$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $223b3691249701c4$var$Ha && $223b3691249701c4$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $223b3691249701c4$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $223b3691249701c4$var$ya ? (d = $223b3691249701c4$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $223b3691249701c4$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $223b3691249701c4$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $223b3691249701c4$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $223b3691249701c4$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $223b3691249701c4$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($223b3691249701c4$var$eb(f)) return n(a, d, f, h);
            if ($223b3691249701c4$var$Ka(f)) return t(a, d, f, h);
            $223b3691249701c4$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $223b3691249701c4$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $223b3691249701c4$var$Ug = $223b3691249701c4$var$Og(!0), $223b3691249701c4$var$Vg = $223b3691249701c4$var$Og(!1), $223b3691249701c4$var$Wg = $223b3691249701c4$var$Uf(null), $223b3691249701c4$var$Xg = null, $223b3691249701c4$var$Yg = null, $223b3691249701c4$var$Zg = null;
function $223b3691249701c4$var$$g() {
    $223b3691249701c4$var$Zg = $223b3691249701c4$var$Yg = $223b3691249701c4$var$Xg = null;
}
function $223b3691249701c4$var$ah(a) {
    var b = $223b3691249701c4$var$Wg.current;
    $223b3691249701c4$var$E($223b3691249701c4$var$Wg);
    a._currentValue = b;
}
function $223b3691249701c4$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $223b3691249701c4$var$ch(a, b) {
    $223b3691249701c4$var$Xg = a;
    $223b3691249701c4$var$Zg = $223b3691249701c4$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($223b3691249701c4$var$dh = !0), a.firstContext = null);
}
function $223b3691249701c4$var$eh(a) {
    var b = a._currentValue;
    if ($223b3691249701c4$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $223b3691249701c4$var$Yg) {
            if (null === $223b3691249701c4$var$Xg) throw Error($223b3691249701c4$var$p(308));
            $223b3691249701c4$var$Yg = a;
            $223b3691249701c4$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $223b3691249701c4$var$Yg = $223b3691249701c4$var$Yg.next = a;
    }
    return b;
}
var $223b3691249701c4$var$fh = null;
function $223b3691249701c4$var$gh(a) {
    null === $223b3691249701c4$var$fh ? $223b3691249701c4$var$fh = [
        a
    ] : $223b3691249701c4$var$fh.push(a);
}
function $223b3691249701c4$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $223b3691249701c4$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $223b3691249701c4$var$ih(a, d);
}
function $223b3691249701c4$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $223b3691249701c4$var$jh = !1;
function $223b3691249701c4$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $223b3691249701c4$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $223b3691249701c4$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $223b3691249701c4$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($223b3691249701c4$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $223b3691249701c4$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $223b3691249701c4$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $223b3691249701c4$var$ih(a, c);
}
function $223b3691249701c4$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $223b3691249701c4$var$Cc(a, c);
    }
}
function $223b3691249701c4$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $223b3691249701c4$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $223b3691249701c4$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $223b3691249701c4$var$A({}, q, r);
                            break a;
                        case 2:
                            $223b3691249701c4$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $223b3691249701c4$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $223b3691249701c4$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($223b3691249701c4$var$p(191, e));
            e.call(d);
        }
    }
}
var $223b3691249701c4$var$th = {}, $223b3691249701c4$var$uh = $223b3691249701c4$var$Uf($223b3691249701c4$var$th), $223b3691249701c4$var$vh = $223b3691249701c4$var$Uf($223b3691249701c4$var$th), $223b3691249701c4$var$wh = $223b3691249701c4$var$Uf($223b3691249701c4$var$th);
function $223b3691249701c4$var$xh(a) {
    if (a === $223b3691249701c4$var$th) throw Error($223b3691249701c4$var$p(174));
    return a;
}
function $223b3691249701c4$var$yh(a, b) {
    $223b3691249701c4$var$G($223b3691249701c4$var$wh, b);
    $223b3691249701c4$var$G($223b3691249701c4$var$vh, a);
    $223b3691249701c4$var$G($223b3691249701c4$var$uh, $223b3691249701c4$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $223b3691249701c4$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $223b3691249701c4$var$lb(b, a);
    }
    $223b3691249701c4$var$E($223b3691249701c4$var$uh);
    $223b3691249701c4$var$G($223b3691249701c4$var$uh, b);
}
function $223b3691249701c4$var$zh() {
    $223b3691249701c4$var$E($223b3691249701c4$var$uh);
    $223b3691249701c4$var$E($223b3691249701c4$var$vh);
    $223b3691249701c4$var$E($223b3691249701c4$var$wh);
}
function $223b3691249701c4$var$Ah(a) {
    $223b3691249701c4$var$xh($223b3691249701c4$var$wh.current);
    var b = $223b3691249701c4$var$xh($223b3691249701c4$var$uh.current);
    var c = $223b3691249701c4$var$lb(b, a.type);
    b !== c && ($223b3691249701c4$var$G($223b3691249701c4$var$vh, a), $223b3691249701c4$var$G($223b3691249701c4$var$uh, c));
}
function $223b3691249701c4$var$Bh(a) {
    $223b3691249701c4$var$vh.current === a && ($223b3691249701c4$var$E($223b3691249701c4$var$uh), $223b3691249701c4$var$E($223b3691249701c4$var$vh));
}
var $223b3691249701c4$var$L = $223b3691249701c4$var$Uf(0);
function $223b3691249701c4$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $223b3691249701c4$var$Dh = [];
function $223b3691249701c4$var$Eh() {
    for(var a = 0; a < $223b3691249701c4$var$Dh.length; a++)$223b3691249701c4$var$Dh[a]._workInProgressVersionPrimary = null;
    $223b3691249701c4$var$Dh.length = 0;
}
var $223b3691249701c4$var$Fh = $223b3691249701c4$var$ua.ReactCurrentDispatcher, $223b3691249701c4$var$Gh = $223b3691249701c4$var$ua.ReactCurrentBatchConfig, $223b3691249701c4$var$Hh = 0, $223b3691249701c4$var$M = null, $223b3691249701c4$var$N = null, $223b3691249701c4$var$O = null, $223b3691249701c4$var$Ih = !1, $223b3691249701c4$var$Jh = !1, $223b3691249701c4$var$Kh = 0, $223b3691249701c4$var$Lh = 0;
function $223b3691249701c4$var$P() {
    throw Error($223b3691249701c4$var$p(321));
}
function $223b3691249701c4$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$223b3691249701c4$var$He(a[c], b[c])) return !1;
    return !0;
}
function $223b3691249701c4$var$Nh(a, b, c, d, e, f) {
    $223b3691249701c4$var$Hh = f;
    $223b3691249701c4$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $223b3691249701c4$var$Fh.current = null === a || null === a.memoizedState ? $223b3691249701c4$var$Oh : $223b3691249701c4$var$Ph;
    a = c(d, e);
    if ($223b3691249701c4$var$Jh) {
        f = 0;
        do {
            $223b3691249701c4$var$Jh = !1;
            $223b3691249701c4$var$Kh = 0;
            if (25 <= f) throw Error($223b3691249701c4$var$p(301));
            f += 1;
            $223b3691249701c4$var$O = $223b3691249701c4$var$N = null;
            b.updateQueue = null;
            $223b3691249701c4$var$Fh.current = $223b3691249701c4$var$Qh;
            a = c(d, e);
        }while ($223b3691249701c4$var$Jh);
    }
    $223b3691249701c4$var$Fh.current = $223b3691249701c4$var$Rh;
    b = null !== $223b3691249701c4$var$N && null !== $223b3691249701c4$var$N.next;
    $223b3691249701c4$var$Hh = 0;
    $223b3691249701c4$var$O = $223b3691249701c4$var$N = $223b3691249701c4$var$M = null;
    $223b3691249701c4$var$Ih = !1;
    if (b) throw Error($223b3691249701c4$var$p(300));
    return a;
}
function $223b3691249701c4$var$Sh() {
    var a = 0 !== $223b3691249701c4$var$Kh;
    $223b3691249701c4$var$Kh = 0;
    return a;
}
function $223b3691249701c4$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $223b3691249701c4$var$O ? $223b3691249701c4$var$M.memoizedState = $223b3691249701c4$var$O = a : $223b3691249701c4$var$O = $223b3691249701c4$var$O.next = a;
    return $223b3691249701c4$var$O;
}
function $223b3691249701c4$var$Uh() {
    if (null === $223b3691249701c4$var$N) {
        var a = $223b3691249701c4$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $223b3691249701c4$var$N.next;
    var b = null === $223b3691249701c4$var$O ? $223b3691249701c4$var$M.memoizedState : $223b3691249701c4$var$O.next;
    if (null !== b) $223b3691249701c4$var$O = b, $223b3691249701c4$var$N = a;
    else {
        if (null === a) throw Error($223b3691249701c4$var$p(310));
        $223b3691249701c4$var$N = a;
        a = {
            memoizedState: $223b3691249701c4$var$N.memoizedState,
            baseState: $223b3691249701c4$var$N.baseState,
            baseQueue: $223b3691249701c4$var$N.baseQueue,
            queue: $223b3691249701c4$var$N.queue,
            next: null
        };
        null === $223b3691249701c4$var$O ? $223b3691249701c4$var$M.memoizedState = $223b3691249701c4$var$O = a : $223b3691249701c4$var$O = $223b3691249701c4$var$O.next = a;
    }
    return $223b3691249701c4$var$O;
}
function $223b3691249701c4$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $223b3691249701c4$var$Wh(a) {
    var b = $223b3691249701c4$var$Uh(), c = b.queue;
    if (null === c) throw Error($223b3691249701c4$var$p(311));
    c.lastRenderedReducer = a;
    var d = $223b3691249701c4$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($223b3691249701c4$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $223b3691249701c4$var$M.lanes |= m;
                $223b3691249701c4$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $223b3691249701c4$var$He(d, b.memoizedState) || ($223b3691249701c4$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $223b3691249701c4$var$M.lanes |= f, $223b3691249701c4$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $223b3691249701c4$var$Xh(a) {
    var b = $223b3691249701c4$var$Uh(), c = b.queue;
    if (null === c) throw Error($223b3691249701c4$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $223b3691249701c4$var$He(f, b.memoizedState) || ($223b3691249701c4$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $223b3691249701c4$var$Yh() {}
function $223b3691249701c4$var$Zh(a, b) {
    var c = $223b3691249701c4$var$M, d = $223b3691249701c4$var$Uh(), e = b(), f = !$223b3691249701c4$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $223b3691249701c4$var$dh = !0);
    d = d.queue;
    $223b3691249701c4$var$$h($223b3691249701c4$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $223b3691249701c4$var$O && $223b3691249701c4$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $223b3691249701c4$var$bi(9, $223b3691249701c4$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $223b3691249701c4$var$Q) throw Error($223b3691249701c4$var$p(349));
        0 !== ($223b3691249701c4$var$Hh & 30) || $223b3691249701c4$var$di(c, b, e);
    }
    return e;
}
function $223b3691249701c4$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $223b3691249701c4$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $223b3691249701c4$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $223b3691249701c4$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $223b3691249701c4$var$ei(b) && $223b3691249701c4$var$fi(a);
}
function $223b3691249701c4$var$ai(a, b, c) {
    return c(function() {
        $223b3691249701c4$var$ei(b) && $223b3691249701c4$var$fi(a);
    });
}
function $223b3691249701c4$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$223b3691249701c4$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $223b3691249701c4$var$fi(a) {
    var b = $223b3691249701c4$var$ih(a, 1);
    null !== b && $223b3691249701c4$var$gi(b, a, 1, -1);
}
function $223b3691249701c4$var$hi(a) {
    var b = $223b3691249701c4$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $223b3691249701c4$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $223b3691249701c4$var$ii.bind(null, $223b3691249701c4$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $223b3691249701c4$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $223b3691249701c4$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $223b3691249701c4$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $223b3691249701c4$var$ji() {
    return $223b3691249701c4$var$Uh().memoizedState;
}
function $223b3691249701c4$var$ki(a, b, c, d) {
    var e = $223b3691249701c4$var$Th();
    $223b3691249701c4$var$M.flags |= a;
    e.memoizedState = $223b3691249701c4$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $223b3691249701c4$var$li(a, b, c, d) {
    var e = $223b3691249701c4$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $223b3691249701c4$var$N) {
        var g = $223b3691249701c4$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $223b3691249701c4$var$Mh(d, g.deps)) {
            e.memoizedState = $223b3691249701c4$var$bi(b, c, f, d);
            return;
        }
    }
    $223b3691249701c4$var$M.flags |= a;
    e.memoizedState = $223b3691249701c4$var$bi(1 | b, c, f, d);
}
function $223b3691249701c4$var$mi(a, b) {
    return $223b3691249701c4$var$ki(8390656, 8, a, b);
}
function $223b3691249701c4$var$$h(a, b) {
    return $223b3691249701c4$var$li(2048, 8, a, b);
}
function $223b3691249701c4$var$ni(a, b) {
    return $223b3691249701c4$var$li(4, 2, a, b);
}
function $223b3691249701c4$var$oi(a, b) {
    return $223b3691249701c4$var$li(4, 4, a, b);
}
function $223b3691249701c4$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $223b3691249701c4$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $223b3691249701c4$var$li(4, 4, $223b3691249701c4$var$pi.bind(null, b, a), c);
}
function $223b3691249701c4$var$ri() {}
function $223b3691249701c4$var$si(a, b) {
    var c = $223b3691249701c4$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $223b3691249701c4$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $223b3691249701c4$var$ti(a, b) {
    var c = $223b3691249701c4$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $223b3691249701c4$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $223b3691249701c4$var$ui(a, b, c) {
    if (0 === ($223b3691249701c4$var$Hh & 21)) return a.baseState && (a.baseState = !1, $223b3691249701c4$var$dh = !0), a.memoizedState = c;
    $223b3691249701c4$var$He(c, b) || (c = $223b3691249701c4$var$yc(), $223b3691249701c4$var$M.lanes |= c, $223b3691249701c4$var$rh |= c, a.baseState = !0);
    return b;
}
function $223b3691249701c4$var$vi(a, b) {
    var c = $223b3691249701c4$var$C;
    $223b3691249701c4$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $223b3691249701c4$var$Gh.transition;
    $223b3691249701c4$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $223b3691249701c4$var$C = c, $223b3691249701c4$var$Gh.transition = d;
    }
}
function $223b3691249701c4$var$wi() {
    return $223b3691249701c4$var$Uh().memoizedState;
}
function $223b3691249701c4$var$xi(a, b, c) {
    var d = $223b3691249701c4$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($223b3691249701c4$var$zi(a)) $223b3691249701c4$var$Ai(b, c);
    else if (c = $223b3691249701c4$var$hh(a, b, c, d), null !== c) {
        var e = $223b3691249701c4$var$R();
        $223b3691249701c4$var$gi(c, a, d, e);
        $223b3691249701c4$var$Bi(c, b, d);
    }
}
function $223b3691249701c4$var$ii(a, b, c) {
    var d = $223b3691249701c4$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($223b3691249701c4$var$zi(a)) $223b3691249701c4$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($223b3691249701c4$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $223b3691249701c4$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $223b3691249701c4$var$hh(a, b, e, d);
        null !== c && (e = $223b3691249701c4$var$R(), $223b3691249701c4$var$gi(c, a, d, e), $223b3691249701c4$var$Bi(c, b, d));
    }
}
function $223b3691249701c4$var$zi(a) {
    var b = a.alternate;
    return a === $223b3691249701c4$var$M || null !== b && b === $223b3691249701c4$var$M;
}
function $223b3691249701c4$var$Ai(a, b) {
    $223b3691249701c4$var$Jh = $223b3691249701c4$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $223b3691249701c4$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $223b3691249701c4$var$Cc(a, c);
    }
}
var $223b3691249701c4$var$Rh = {
    readContext: $223b3691249701c4$var$eh,
    useCallback: $223b3691249701c4$var$P,
    useContext: $223b3691249701c4$var$P,
    useEffect: $223b3691249701c4$var$P,
    useImperativeHandle: $223b3691249701c4$var$P,
    useInsertionEffect: $223b3691249701c4$var$P,
    useLayoutEffect: $223b3691249701c4$var$P,
    useMemo: $223b3691249701c4$var$P,
    useReducer: $223b3691249701c4$var$P,
    useRef: $223b3691249701c4$var$P,
    useState: $223b3691249701c4$var$P,
    useDebugValue: $223b3691249701c4$var$P,
    useDeferredValue: $223b3691249701c4$var$P,
    useTransition: $223b3691249701c4$var$P,
    useMutableSource: $223b3691249701c4$var$P,
    useSyncExternalStore: $223b3691249701c4$var$P,
    useId: $223b3691249701c4$var$P,
    unstable_isNewReconciler: !1
}, $223b3691249701c4$var$Oh = {
    readContext: $223b3691249701c4$var$eh,
    useCallback: function(a, b) {
        $223b3691249701c4$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $223b3691249701c4$var$eh,
    useEffect: $223b3691249701c4$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $223b3691249701c4$var$ki(4194308, 4, $223b3691249701c4$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $223b3691249701c4$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $223b3691249701c4$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $223b3691249701c4$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $223b3691249701c4$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $223b3691249701c4$var$xi.bind(null, $223b3691249701c4$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $223b3691249701c4$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $223b3691249701c4$var$hi,
    useDebugValue: $223b3691249701c4$var$ri,
    useDeferredValue: function(a) {
        return $223b3691249701c4$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $223b3691249701c4$var$hi(!1), b = a[0];
        a = $223b3691249701c4$var$vi.bind(null, a[1]);
        $223b3691249701c4$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $223b3691249701c4$var$M, e = $223b3691249701c4$var$Th();
        if ($223b3691249701c4$var$I) {
            if (void 0 === c) throw Error($223b3691249701c4$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $223b3691249701c4$var$Q) throw Error($223b3691249701c4$var$p(349));
            0 !== ($223b3691249701c4$var$Hh & 30) || $223b3691249701c4$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $223b3691249701c4$var$mi($223b3691249701c4$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $223b3691249701c4$var$bi(9, $223b3691249701c4$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $223b3691249701c4$var$Th(), b = $223b3691249701c4$var$Q.identifierPrefix;
        if ($223b3691249701c4$var$I) {
            var c = $223b3691249701c4$var$sg;
            var d = $223b3691249701c4$var$rg;
            c = (d & ~(1 << 32 - $223b3691249701c4$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $223b3691249701c4$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $223b3691249701c4$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $223b3691249701c4$var$Ph = {
    readContext: $223b3691249701c4$var$eh,
    useCallback: $223b3691249701c4$var$si,
    useContext: $223b3691249701c4$var$eh,
    useEffect: $223b3691249701c4$var$$h,
    useImperativeHandle: $223b3691249701c4$var$qi,
    useInsertionEffect: $223b3691249701c4$var$ni,
    useLayoutEffect: $223b3691249701c4$var$oi,
    useMemo: $223b3691249701c4$var$ti,
    useReducer: $223b3691249701c4$var$Wh,
    useRef: $223b3691249701c4$var$ji,
    useState: function() {
        return $223b3691249701c4$var$Wh($223b3691249701c4$var$Vh);
    },
    useDebugValue: $223b3691249701c4$var$ri,
    useDeferredValue: function(a) {
        var b = $223b3691249701c4$var$Uh();
        return $223b3691249701c4$var$ui(b, $223b3691249701c4$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $223b3691249701c4$var$Wh($223b3691249701c4$var$Vh)[0], b = $223b3691249701c4$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $223b3691249701c4$var$Yh,
    useSyncExternalStore: $223b3691249701c4$var$Zh,
    useId: $223b3691249701c4$var$wi,
    unstable_isNewReconciler: !1
}, $223b3691249701c4$var$Qh = {
    readContext: $223b3691249701c4$var$eh,
    useCallback: $223b3691249701c4$var$si,
    useContext: $223b3691249701c4$var$eh,
    useEffect: $223b3691249701c4$var$$h,
    useImperativeHandle: $223b3691249701c4$var$qi,
    useInsertionEffect: $223b3691249701c4$var$ni,
    useLayoutEffect: $223b3691249701c4$var$oi,
    useMemo: $223b3691249701c4$var$ti,
    useReducer: $223b3691249701c4$var$Xh,
    useRef: $223b3691249701c4$var$ji,
    useState: function() {
        return $223b3691249701c4$var$Xh($223b3691249701c4$var$Vh);
    },
    useDebugValue: $223b3691249701c4$var$ri,
    useDeferredValue: function(a) {
        var b = $223b3691249701c4$var$Uh();
        return null === $223b3691249701c4$var$N ? b.memoizedState = a : $223b3691249701c4$var$ui(b, $223b3691249701c4$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $223b3691249701c4$var$Xh($223b3691249701c4$var$Vh)[0], b = $223b3691249701c4$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $223b3691249701c4$var$Yh,
    useSyncExternalStore: $223b3691249701c4$var$Zh,
    useId: $223b3691249701c4$var$wi,
    unstable_isNewReconciler: !1
};
function $223b3691249701c4$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $223b3691249701c4$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $223b3691249701c4$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $223b3691249701c4$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $223b3691249701c4$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $223b3691249701c4$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $223b3691249701c4$var$R(), e = $223b3691249701c4$var$yi(a), f = $223b3691249701c4$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $223b3691249701c4$var$nh(a, f, e);
        null !== b && ($223b3691249701c4$var$gi(b, a, e, d), $223b3691249701c4$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $223b3691249701c4$var$R(), e = $223b3691249701c4$var$yi(a), f = $223b3691249701c4$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $223b3691249701c4$var$nh(a, f, e);
        null !== b && ($223b3691249701c4$var$gi(b, a, e, d), $223b3691249701c4$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $223b3691249701c4$var$R(), d = $223b3691249701c4$var$yi(a), e = $223b3691249701c4$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $223b3691249701c4$var$nh(a, e, d);
        null !== b && ($223b3691249701c4$var$gi(b, a, d, c), $223b3691249701c4$var$oh(b, a, d));
    }
};
function $223b3691249701c4$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$223b3691249701c4$var$Ie(c, d) || !$223b3691249701c4$var$Ie(e, f) : !0;
}
function $223b3691249701c4$var$Gi(a, b, c) {
    var d = !1, e = $223b3691249701c4$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $223b3691249701c4$var$eh(f) : (e = $223b3691249701c4$var$Zf(b) ? $223b3691249701c4$var$Xf : $223b3691249701c4$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $223b3691249701c4$var$Yf(a, e) : $223b3691249701c4$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $223b3691249701c4$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $223b3691249701c4$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $223b3691249701c4$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $223b3691249701c4$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $223b3691249701c4$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $223b3691249701c4$var$eh(f) : (f = $223b3691249701c4$var$Zf(b) ? $223b3691249701c4$var$Xf : $223b3691249701c4$var$H.current, e.context = $223b3691249701c4$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($223b3691249701c4$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $223b3691249701c4$var$Ei.enqueueReplaceState(e, e.state, null), $223b3691249701c4$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $223b3691249701c4$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $223b3691249701c4$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $223b3691249701c4$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $223b3691249701c4$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $223b3691249701c4$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $223b3691249701c4$var$Ni(a, b, c) {
    c = $223b3691249701c4$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $223b3691249701c4$var$Oi || ($223b3691249701c4$var$Oi = !0, $223b3691249701c4$var$Pi = d);
        $223b3691249701c4$var$Li(a, b);
    };
    return c;
}
function $223b3691249701c4$var$Qi(a, b, c) {
    c = $223b3691249701c4$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $223b3691249701c4$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $223b3691249701c4$var$Li(a, b);
        "function" !== typeof d && (null === $223b3691249701c4$var$Ri ? $223b3691249701c4$var$Ri = new Set([
            this
        ]) : $223b3691249701c4$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $223b3691249701c4$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $223b3691249701c4$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $223b3691249701c4$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $223b3691249701c4$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $223b3691249701c4$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $223b3691249701c4$var$mh(-1, 1), b.tag = 2, $223b3691249701c4$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $223b3691249701c4$var$Wi = $223b3691249701c4$var$ua.ReactCurrentOwner, $223b3691249701c4$var$dh = !1;
function $223b3691249701c4$var$Xi(a, b, c, d) {
    b.child = null === a ? $223b3691249701c4$var$Vg(b, null, c, d) : $223b3691249701c4$var$Ug(b, a.child, c, d);
}
function $223b3691249701c4$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $223b3691249701c4$var$ch(b, e);
    d = $223b3691249701c4$var$Nh(a, b, c, d, f, e);
    c = $223b3691249701c4$var$Sh();
    if (null !== a && !$223b3691249701c4$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $223b3691249701c4$var$Zi(a, b, e);
    $223b3691249701c4$var$I && c && $223b3691249701c4$var$vg(b);
    b.flags |= 1;
    $223b3691249701c4$var$Xi(a, b, d, e);
    return b.child;
}
function $223b3691249701c4$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$223b3691249701c4$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $223b3691249701c4$var$bj(a, b, f, d, e);
        a = $223b3691249701c4$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $223b3691249701c4$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $223b3691249701c4$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $223b3691249701c4$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $223b3691249701c4$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($223b3691249701c4$var$Ie(f, d) && a.ref === b.ref) {
            if ($223b3691249701c4$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($223b3691249701c4$var$dh = !0);
            else return b.lanes = a.lanes, $223b3691249701c4$var$Zi(a, b, e);
        }
    }
    return $223b3691249701c4$var$cj(a, b, c, d, e);
}
function $223b3691249701c4$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $223b3691249701c4$var$G($223b3691249701c4$var$ej, $223b3691249701c4$var$fj), $223b3691249701c4$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $223b3691249701c4$var$G($223b3691249701c4$var$ej, $223b3691249701c4$var$fj), $223b3691249701c4$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $223b3691249701c4$var$G($223b3691249701c4$var$ej, $223b3691249701c4$var$fj);
            $223b3691249701c4$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $223b3691249701c4$var$G($223b3691249701c4$var$ej, $223b3691249701c4$var$fj), $223b3691249701c4$var$fj |= d;
    $223b3691249701c4$var$Xi(a, b, e, c);
    return b.child;
}
function $223b3691249701c4$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $223b3691249701c4$var$cj(a, b, c, d, e) {
    var f = $223b3691249701c4$var$Zf(c) ? $223b3691249701c4$var$Xf : $223b3691249701c4$var$H.current;
    f = $223b3691249701c4$var$Yf(b, f);
    $223b3691249701c4$var$ch(b, e);
    c = $223b3691249701c4$var$Nh(a, b, c, d, f, e);
    d = $223b3691249701c4$var$Sh();
    if (null !== a && !$223b3691249701c4$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $223b3691249701c4$var$Zi(a, b, e);
    $223b3691249701c4$var$I && d && $223b3691249701c4$var$vg(b);
    b.flags |= 1;
    $223b3691249701c4$var$Xi(a, b, c, e);
    return b.child;
}
function $223b3691249701c4$var$hj(a, b, c, d, e) {
    if ($223b3691249701c4$var$Zf(c)) {
        var f = !0;
        $223b3691249701c4$var$cg(b);
    } else f = !1;
    $223b3691249701c4$var$ch(b, e);
    if (null === b.stateNode) $223b3691249701c4$var$ij(a, b), $223b3691249701c4$var$Gi(b, c, d), $223b3691249701c4$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $223b3691249701c4$var$eh(l) : (l = $223b3691249701c4$var$Zf(c) ? $223b3691249701c4$var$Xf : $223b3691249701c4$var$H.current, l = $223b3691249701c4$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $223b3691249701c4$var$Hi(b, g, d, l);
        $223b3691249701c4$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $223b3691249701c4$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $223b3691249701c4$var$Wf.current || $223b3691249701c4$var$jh ? ("function" === typeof m && ($223b3691249701c4$var$Di(b, c, m, d), k = b.memoizedState), (h = $223b3691249701c4$var$jh || $223b3691249701c4$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $223b3691249701c4$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $223b3691249701c4$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $223b3691249701c4$var$eh(k) : (k = $223b3691249701c4$var$Zf(c) ? $223b3691249701c4$var$Xf : $223b3691249701c4$var$H.current, k = $223b3691249701c4$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $223b3691249701c4$var$Hi(b, g, d, k);
        $223b3691249701c4$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $223b3691249701c4$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $223b3691249701c4$var$Wf.current || $223b3691249701c4$var$jh ? ("function" === typeof y && ($223b3691249701c4$var$Di(b, c, y, d), n = b.memoizedState), (l = $223b3691249701c4$var$jh || $223b3691249701c4$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $223b3691249701c4$var$jj(a, b, c, d, f, e);
}
function $223b3691249701c4$var$jj(a, b, c, d, e, f) {
    $223b3691249701c4$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $223b3691249701c4$var$dg(b, c, !1), $223b3691249701c4$var$Zi(a, b, f);
    d = b.stateNode;
    $223b3691249701c4$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $223b3691249701c4$var$Ug(b, a.child, null, f), b.child = $223b3691249701c4$var$Ug(b, null, h, f)) : $223b3691249701c4$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $223b3691249701c4$var$dg(b, c, !0);
    return b.child;
}
function $223b3691249701c4$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $223b3691249701c4$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $223b3691249701c4$var$ag(a, b.context, !1);
    $223b3691249701c4$var$yh(a, b.containerInfo);
}
function $223b3691249701c4$var$lj(a, b, c, d, e) {
    $223b3691249701c4$var$Ig();
    $223b3691249701c4$var$Jg(e);
    b.flags |= 256;
    $223b3691249701c4$var$Xi(a, b, c, d);
    return b.child;
}
var $223b3691249701c4$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $223b3691249701c4$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $223b3691249701c4$var$oj(a, b, c) {
    var d = b.pendingProps, e = $223b3691249701c4$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $223b3691249701c4$var$G($223b3691249701c4$var$L, e & 1);
    if (null === a) {
        $223b3691249701c4$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $223b3691249701c4$var$pj(g, d, 0, null), a = $223b3691249701c4$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $223b3691249701c4$var$nj(c), b.memoizedState = $223b3691249701c4$var$mj, a) : $223b3691249701c4$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $223b3691249701c4$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $223b3691249701c4$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $223b3691249701c4$var$Pg(h, f) : (f = $223b3691249701c4$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $223b3691249701c4$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $223b3691249701c4$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $223b3691249701c4$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $223b3691249701c4$var$qj(a, b) {
    b = $223b3691249701c4$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $223b3691249701c4$var$sj(a, b, c, d) {
    null !== d && $223b3691249701c4$var$Jg(d);
    $223b3691249701c4$var$Ug(b, a.child, null, c);
    a = $223b3691249701c4$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $223b3691249701c4$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $223b3691249701c4$var$Ki(Error($223b3691249701c4$var$p(422))), $223b3691249701c4$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $223b3691249701c4$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $223b3691249701c4$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $223b3691249701c4$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $223b3691249701c4$var$nj(g);
        b.memoizedState = $223b3691249701c4$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $223b3691249701c4$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($223b3691249701c4$var$p(419));
        d = $223b3691249701c4$var$Ki(f, d, void 0);
        return $223b3691249701c4$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($223b3691249701c4$var$dh || h) {
        d = $223b3691249701c4$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $223b3691249701c4$var$ih(a, e), $223b3691249701c4$var$gi(d, a, e, -1));
        }
        $223b3691249701c4$var$tj();
        d = $223b3691249701c4$var$Ki(Error($223b3691249701c4$var$p(421)));
        return $223b3691249701c4$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $223b3691249701c4$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $223b3691249701c4$var$yg = $223b3691249701c4$var$Lf(e.nextSibling);
    $223b3691249701c4$var$xg = b;
    $223b3691249701c4$var$I = !0;
    $223b3691249701c4$var$zg = null;
    null !== a && ($223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$rg, $223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$sg, $223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$qg, $223b3691249701c4$var$rg = a.id, $223b3691249701c4$var$sg = a.overflow, $223b3691249701c4$var$qg = b);
    b = $223b3691249701c4$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $223b3691249701c4$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $223b3691249701c4$var$bh(a.return, b, c);
}
function $223b3691249701c4$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $223b3691249701c4$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $223b3691249701c4$var$Xi(a, b, d.children, c);
    d = $223b3691249701c4$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $223b3691249701c4$var$vj(a, c, b);
            else if (19 === a.tag) $223b3691249701c4$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $223b3691249701c4$var$G($223b3691249701c4$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $223b3691249701c4$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $223b3691249701c4$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $223b3691249701c4$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $223b3691249701c4$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $223b3691249701c4$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $223b3691249701c4$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $223b3691249701c4$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $223b3691249701c4$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($223b3691249701c4$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $223b3691249701c4$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $223b3691249701c4$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $223b3691249701c4$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $223b3691249701c4$var$kj(b);
            $223b3691249701c4$var$Ig();
            break;
        case 5:
            $223b3691249701c4$var$Ah(b);
            break;
        case 1:
            $223b3691249701c4$var$Zf(b.type) && $223b3691249701c4$var$cg(b);
            break;
        case 4:
            $223b3691249701c4$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $223b3691249701c4$var$G($223b3691249701c4$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $223b3691249701c4$var$G($223b3691249701c4$var$L, $223b3691249701c4$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $223b3691249701c4$var$oj(a, b, c);
                $223b3691249701c4$var$G($223b3691249701c4$var$L, $223b3691249701c4$var$L.current & 1);
                a = $223b3691249701c4$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $223b3691249701c4$var$G($223b3691249701c4$var$L, $223b3691249701c4$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $223b3691249701c4$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $223b3691249701c4$var$G($223b3691249701c4$var$L, $223b3691249701c4$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $223b3691249701c4$var$dj(a, b, c);
    }
    return $223b3691249701c4$var$Zi(a, b, c);
}
var $223b3691249701c4$var$zj, $223b3691249701c4$var$Aj, $223b3691249701c4$var$Bj, $223b3691249701c4$var$Cj;
$223b3691249701c4$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$223b3691249701c4$var$Aj = function() {};
$223b3691249701c4$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $223b3691249701c4$var$xh($223b3691249701c4$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $223b3691249701c4$var$Ya(a, e);
                d = $223b3691249701c4$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $223b3691249701c4$var$A({}, e, {
                    value: void 0
                });
                d = $223b3691249701c4$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $223b3691249701c4$var$gb(a, e);
                d = $223b3691249701c4$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $223b3691249701c4$var$Bf);
        }
        $223b3691249701c4$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($223b3691249701c4$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($223b3691249701c4$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $223b3691249701c4$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$223b3691249701c4$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $223b3691249701c4$var$Dj(a, b) {
    if (!$223b3691249701c4$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $223b3691249701c4$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $223b3691249701c4$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $223b3691249701c4$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $223b3691249701c4$var$S(b), null;
        case 1:
            return $223b3691249701c4$var$Zf(b.type) && $223b3691249701c4$var$$f(), $223b3691249701c4$var$S(b), null;
        case 3:
            d = b.stateNode;
            $223b3691249701c4$var$zh();
            $223b3691249701c4$var$E($223b3691249701c4$var$Wf);
            $223b3691249701c4$var$E($223b3691249701c4$var$H);
            $223b3691249701c4$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $223b3691249701c4$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $223b3691249701c4$var$zg && ($223b3691249701c4$var$Fj($223b3691249701c4$var$zg), $223b3691249701c4$var$zg = null));
            $223b3691249701c4$var$Aj(a, b);
            $223b3691249701c4$var$S(b);
            return null;
        case 5:
            $223b3691249701c4$var$Bh(b);
            var e = $223b3691249701c4$var$xh($223b3691249701c4$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $223b3691249701c4$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($223b3691249701c4$var$p(166));
                    $223b3691249701c4$var$S(b);
                    return null;
                }
                a = $223b3691249701c4$var$xh($223b3691249701c4$var$uh.current);
                if ($223b3691249701c4$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$223b3691249701c4$var$Of] = b;
                    d[$223b3691249701c4$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $223b3691249701c4$var$D("cancel", d);
                            $223b3691249701c4$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $223b3691249701c4$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $223b3691249701c4$var$lf.length; e++)$223b3691249701c4$var$D($223b3691249701c4$var$lf[e], d);
                            break;
                        case "source":
                            $223b3691249701c4$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $223b3691249701c4$var$D("error", d);
                            $223b3691249701c4$var$D("load", d);
                            break;
                        case "details":
                            $223b3691249701c4$var$D("toggle", d);
                            break;
                        case "input":
                            $223b3691249701c4$var$Za(d, f);
                            $223b3691249701c4$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $223b3691249701c4$var$D("invalid", d);
                            break;
                        case "textarea":
                            $223b3691249701c4$var$hb(d, f), $223b3691249701c4$var$D("invalid", d);
                    }
                    $223b3691249701c4$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $223b3691249701c4$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $223b3691249701c4$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $223b3691249701c4$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $223b3691249701c4$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $223b3691249701c4$var$Va(d);
                            $223b3691249701c4$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $223b3691249701c4$var$Va(d);
                            $223b3691249701c4$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $223b3691249701c4$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $223b3691249701c4$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$223b3691249701c4$var$Of] = b;
                    a[$223b3691249701c4$var$Pf] = d;
                    $223b3691249701c4$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $223b3691249701c4$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $223b3691249701c4$var$D("cancel", a);
                                $223b3691249701c4$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $223b3691249701c4$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $223b3691249701c4$var$lf.length; e++)$223b3691249701c4$var$D($223b3691249701c4$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $223b3691249701c4$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $223b3691249701c4$var$D("error", a);
                                $223b3691249701c4$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $223b3691249701c4$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $223b3691249701c4$var$Za(a, d);
                                e = $223b3691249701c4$var$Ya(a, d);
                                $223b3691249701c4$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $223b3691249701c4$var$A({}, d, {
                                    value: void 0
                                });
                                $223b3691249701c4$var$D("invalid", a);
                                break;
                            case "textarea":
                                $223b3691249701c4$var$hb(a, d);
                                e = $223b3691249701c4$var$gb(a, d);
                                $223b3691249701c4$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $223b3691249701c4$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $223b3691249701c4$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $223b3691249701c4$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $223b3691249701c4$var$ob(a, k) : "number" === typeof k && $223b3691249701c4$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($223b3691249701c4$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $223b3691249701c4$var$D("scroll", a) : null != k && $223b3691249701c4$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $223b3691249701c4$var$Va(a);
                                $223b3691249701c4$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $223b3691249701c4$var$Va(a);
                                $223b3691249701c4$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $223b3691249701c4$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $223b3691249701c4$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $223b3691249701c4$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $223b3691249701c4$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $223b3691249701c4$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $223b3691249701c4$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($223b3691249701c4$var$p(166));
                c = $223b3691249701c4$var$xh($223b3691249701c4$var$wh.current);
                $223b3691249701c4$var$xh($223b3691249701c4$var$uh.current);
                if ($223b3691249701c4$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$223b3691249701c4$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $223b3691249701c4$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $223b3691249701c4$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $223b3691249701c4$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$223b3691249701c4$var$Of] = b, b.stateNode = d;
            }
            $223b3691249701c4$var$S(b);
            return null;
        case 13:
            $223b3691249701c4$var$E($223b3691249701c4$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($223b3691249701c4$var$I && null !== $223b3691249701c4$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $223b3691249701c4$var$Hg(), $223b3691249701c4$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $223b3691249701c4$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($223b3691249701c4$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($223b3691249701c4$var$p(317));
                        f[$223b3691249701c4$var$Of] = b;
                    } else $223b3691249701c4$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $223b3691249701c4$var$S(b);
                    f = !1;
                } else null !== $223b3691249701c4$var$zg && ($223b3691249701c4$var$Fj($223b3691249701c4$var$zg), $223b3691249701c4$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($223b3691249701c4$var$L.current & 1) ? 0 === $223b3691249701c4$var$T && ($223b3691249701c4$var$T = 3) : $223b3691249701c4$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $223b3691249701c4$var$S(b);
            return null;
        case 4:
            return $223b3691249701c4$var$zh(), $223b3691249701c4$var$Aj(a, b), null === a && $223b3691249701c4$var$sf(b.stateNode.containerInfo), $223b3691249701c4$var$S(b), null;
        case 10:
            return $223b3691249701c4$var$ah(b.type._context), $223b3691249701c4$var$S(b), null;
        case 17:
            return $223b3691249701c4$var$Zf(b.type) && $223b3691249701c4$var$$f(), $223b3691249701c4$var$S(b), null;
        case 19:
            $223b3691249701c4$var$E($223b3691249701c4$var$L);
            f = b.memoizedState;
            if (null === f) return $223b3691249701c4$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $223b3691249701c4$var$Dj(f, !1);
                else {
                    if (0 !== $223b3691249701c4$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $223b3691249701c4$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $223b3691249701c4$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $223b3691249701c4$var$G($223b3691249701c4$var$L, $223b3691249701c4$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $223b3691249701c4$var$B() > $223b3691249701c4$var$Gj && (b.flags |= 128, d = !0, $223b3691249701c4$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $223b3691249701c4$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $223b3691249701c4$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$223b3691249701c4$var$I) return $223b3691249701c4$var$S(b), null;
                    } else 2 * $223b3691249701c4$var$B() - f.renderingStartTime > $223b3691249701c4$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $223b3691249701c4$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $223b3691249701c4$var$B(), b.sibling = null, c = $223b3691249701c4$var$L.current, $223b3691249701c4$var$G($223b3691249701c4$var$L, d ? c & 1 | 2 : c & 1), b;
            $223b3691249701c4$var$S(b);
            return null;
        case 22:
        case 23:
            return $223b3691249701c4$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($223b3691249701c4$var$fj & 1073741824) && ($223b3691249701c4$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $223b3691249701c4$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($223b3691249701c4$var$p(156, b.tag));
}
function $223b3691249701c4$var$Ij(a, b) {
    $223b3691249701c4$var$wg(b);
    switch(b.tag){
        case 1:
            return $223b3691249701c4$var$Zf(b.type) && $223b3691249701c4$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $223b3691249701c4$var$zh(), $223b3691249701c4$var$E($223b3691249701c4$var$Wf), $223b3691249701c4$var$E($223b3691249701c4$var$H), $223b3691249701c4$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $223b3691249701c4$var$Bh(b), null;
        case 13:
            $223b3691249701c4$var$E($223b3691249701c4$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($223b3691249701c4$var$p(340));
                $223b3691249701c4$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $223b3691249701c4$var$E($223b3691249701c4$var$L), null;
        case 4:
            return $223b3691249701c4$var$zh(), null;
        case 10:
            return $223b3691249701c4$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $223b3691249701c4$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $223b3691249701c4$var$Jj = !1, $223b3691249701c4$var$U = !1, $223b3691249701c4$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $223b3691249701c4$var$V = null;
function $223b3691249701c4$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $223b3691249701c4$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $223b3691249701c4$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $223b3691249701c4$var$W(a, b, d);
    }
}
var $223b3691249701c4$var$Nj = !1;
function $223b3691249701c4$var$Oj(a, b) {
    $223b3691249701c4$var$Cf = $223b3691249701c4$var$dd;
    a = $223b3691249701c4$var$Me();
    if ($223b3691249701c4$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $223b3691249701c4$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $223b3691249701c4$var$dd = !1;
    for($223b3691249701c4$var$V = b; null !== $223b3691249701c4$var$V;)if (b = $223b3691249701c4$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $223b3691249701c4$var$V = a;
    else for(; null !== $223b3691249701c4$var$V;){
        b = $223b3691249701c4$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $223b3691249701c4$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($223b3691249701c4$var$p(163));
            }
        } catch (F) {
            $223b3691249701c4$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $223b3691249701c4$var$V = a;
            break;
        }
        $223b3691249701c4$var$V = b.return;
    }
    n = $223b3691249701c4$var$Nj;
    $223b3691249701c4$var$Nj = !1;
    return n;
}
function $223b3691249701c4$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $223b3691249701c4$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $223b3691249701c4$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $223b3691249701c4$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $223b3691249701c4$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $223b3691249701c4$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$223b3691249701c4$var$Of], delete b[$223b3691249701c4$var$Pf], delete b[$223b3691249701c4$var$of], delete b[$223b3691249701c4$var$Qf], delete b[$223b3691249701c4$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $223b3691249701c4$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $223b3691249701c4$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $223b3691249701c4$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $223b3691249701c4$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $223b3691249701c4$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($223b3691249701c4$var$Vj(a, b, c), a = a.sibling; null !== a;)$223b3691249701c4$var$Vj(a, b, c), a = a.sibling;
}
function $223b3691249701c4$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($223b3691249701c4$var$Wj(a, b, c), a = a.sibling; null !== a;)$223b3691249701c4$var$Wj(a, b, c), a = a.sibling;
}
var $223b3691249701c4$var$X = null, $223b3691249701c4$var$Xj = !1;
function $223b3691249701c4$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$223b3691249701c4$var$Zj(a, b, c), c = c.sibling;
}
function $223b3691249701c4$var$Zj(a, b, c) {
    if ($223b3691249701c4$var$lc && "function" === typeof $223b3691249701c4$var$lc.onCommitFiberUnmount) try {
        $223b3691249701c4$var$lc.onCommitFiberUnmount($223b3691249701c4$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $223b3691249701c4$var$U || $223b3691249701c4$var$Lj(c, b);
        case 6:
            var d = $223b3691249701c4$var$X, e = $223b3691249701c4$var$Xj;
            $223b3691249701c4$var$X = null;
            $223b3691249701c4$var$Yj(a, b, c);
            $223b3691249701c4$var$X = d;
            $223b3691249701c4$var$Xj = e;
            null !== $223b3691249701c4$var$X && ($223b3691249701c4$var$Xj ? (a = $223b3691249701c4$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $223b3691249701c4$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $223b3691249701c4$var$X && ($223b3691249701c4$var$Xj ? (a = $223b3691249701c4$var$X, c = c.stateNode, 8 === a.nodeType ? $223b3691249701c4$var$Kf(a.parentNode, c) : 1 === a.nodeType && $223b3691249701c4$var$Kf(a, c), $223b3691249701c4$var$bd(a)) : $223b3691249701c4$var$Kf($223b3691249701c4$var$X, c.stateNode));
            break;
        case 4:
            d = $223b3691249701c4$var$X;
            e = $223b3691249701c4$var$Xj;
            $223b3691249701c4$var$X = c.stateNode.containerInfo;
            $223b3691249701c4$var$Xj = !0;
            $223b3691249701c4$var$Yj(a, b, c);
            $223b3691249701c4$var$X = d;
            $223b3691249701c4$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$223b3691249701c4$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $223b3691249701c4$var$Mj(c, b, g) : 0 !== (f & 4) && $223b3691249701c4$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $223b3691249701c4$var$Yj(a, b, c);
            break;
        case 1:
            if (!$223b3691249701c4$var$U && ($223b3691249701c4$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $223b3691249701c4$var$W(c, b, h);
            }
            $223b3691249701c4$var$Yj(a, b, c);
            break;
        case 21:
            $223b3691249701c4$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($223b3691249701c4$var$U = (d = $223b3691249701c4$var$U) || null !== c.memoizedState, $223b3691249701c4$var$Yj(a, b, c), $223b3691249701c4$var$U = d) : $223b3691249701c4$var$Yj(a, b, c);
            break;
        default:
            $223b3691249701c4$var$Yj(a, b, c);
    }
}
function $223b3691249701c4$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $223b3691249701c4$var$Kj);
        b.forEach(function(b) {
            var d = $223b3691249701c4$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $223b3691249701c4$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $223b3691249701c4$var$X = h.stateNode;
                        $223b3691249701c4$var$Xj = !1;
                        break a;
                    case 3:
                        $223b3691249701c4$var$X = h.stateNode.containerInfo;
                        $223b3691249701c4$var$Xj = !0;
                        break a;
                    case 4:
                        $223b3691249701c4$var$X = h.stateNode.containerInfo;
                        $223b3691249701c4$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $223b3691249701c4$var$X) throw Error($223b3691249701c4$var$p(160));
            $223b3691249701c4$var$Zj(f, g, e);
            $223b3691249701c4$var$X = null;
            $223b3691249701c4$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $223b3691249701c4$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$223b3691249701c4$var$dk(b, a), b = b.sibling;
}
function $223b3691249701c4$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            if (d & 4) {
                try {
                    $223b3691249701c4$var$Pj(3, a, a.return), $223b3691249701c4$var$Qj(3, a);
                } catch (t) {
                    $223b3691249701c4$var$W(a, a.return, t);
                }
                try {
                    $223b3691249701c4$var$Pj(5, a, a.return);
                } catch (t) {
                    $223b3691249701c4$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            d & 512 && null !== c && $223b3691249701c4$var$Lj(c, c.return);
            break;
        case 5:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            d & 512 && null !== c && $223b3691249701c4$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $223b3691249701c4$var$ob(e, "");
                } catch (t) {
                    $223b3691249701c4$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $223b3691249701c4$var$ab(e, f);
                    $223b3691249701c4$var$vb(h, g);
                    var l = $223b3691249701c4$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $223b3691249701c4$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $223b3691249701c4$var$nb(e, q) : "children" === m ? $223b3691249701c4$var$ob(e, q) : $223b3691249701c4$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $223b3691249701c4$var$bb(e, f);
                            break;
                        case "textarea":
                            $223b3691249701c4$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $223b3691249701c4$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $223b3691249701c4$var$fb(e, !!f.multiple, f.defaultValue, !0) : $223b3691249701c4$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$223b3691249701c4$var$Pf] = f;
                } catch (t) {
                    $223b3691249701c4$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($223b3691249701c4$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $223b3691249701c4$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $223b3691249701c4$var$bd(b.containerInfo);
            } catch (t) {
                $223b3691249701c4$var$W(a, a.return, t);
            }
            break;
        case 4:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            break;
        case 13:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($223b3691249701c4$var$fk = $223b3691249701c4$var$B()));
            d & 4 && $223b3691249701c4$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($223b3691249701c4$var$U = (l = $223b3691249701c4$var$U) || m, $223b3691249701c4$var$ck(b, a), $223b3691249701c4$var$U = l) : $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($223b3691249701c4$var$V = a, m = a.child; null !== m;){
                    for(q = $223b3691249701c4$var$V = m; null !== $223b3691249701c4$var$V;){
                        r = $223b3691249701c4$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $223b3691249701c4$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $223b3691249701c4$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $223b3691249701c4$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $223b3691249701c4$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $223b3691249701c4$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $223b3691249701c4$var$V = y) : $223b3691249701c4$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $223b3691249701c4$var$rb("display", g));
                            } catch (t) {
                                $223b3691249701c4$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $223b3691249701c4$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            d & 4 && $223b3691249701c4$var$ak(a);
            break;
        case 21:
            break;
        default:
            $223b3691249701c4$var$ck(b, a), $223b3691249701c4$var$ek(a);
    }
}
function $223b3691249701c4$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($223b3691249701c4$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($223b3691249701c4$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($223b3691249701c4$var$ob(e, ""), d.flags &= -33);
                    var f = $223b3691249701c4$var$Uj(a);
                    $223b3691249701c4$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $223b3691249701c4$var$Uj(a);
                    $223b3691249701c4$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($223b3691249701c4$var$p(161));
            }
        } catch (k) {
            $223b3691249701c4$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $223b3691249701c4$var$hk(a, b, c) {
    $223b3691249701c4$var$V = a;
    $223b3691249701c4$var$ik(a, b, c);
}
function $223b3691249701c4$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $223b3691249701c4$var$V;){
        var e = $223b3691249701c4$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $223b3691249701c4$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $223b3691249701c4$var$U;
                h = $223b3691249701c4$var$Jj;
                var l = $223b3691249701c4$var$U;
                $223b3691249701c4$var$Jj = g;
                if (($223b3691249701c4$var$U = k) && !l) for($223b3691249701c4$var$V = e; null !== $223b3691249701c4$var$V;)g = $223b3691249701c4$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $223b3691249701c4$var$jk(e) : null !== k ? (k.return = g, $223b3691249701c4$var$V = k) : $223b3691249701c4$var$jk(e);
                for(; null !== f;)$223b3691249701c4$var$V = f, $223b3691249701c4$var$ik(f, b, c), f = f.sibling;
                $223b3691249701c4$var$V = e;
                $223b3691249701c4$var$Jj = h;
                $223b3691249701c4$var$U = l;
            }
            $223b3691249701c4$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $223b3691249701c4$var$V = f) : $223b3691249701c4$var$kk(a, b, c);
    }
}
function $223b3691249701c4$var$kk(a) {
    for(; null !== $223b3691249701c4$var$V;){
        var b = $223b3691249701c4$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $223b3691249701c4$var$U || $223b3691249701c4$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$223b3691249701c4$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $223b3691249701c4$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $223b3691249701c4$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $223b3691249701c4$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $223b3691249701c4$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($223b3691249701c4$var$p(163));
                }
                $223b3691249701c4$var$U || b.flags & 512 && $223b3691249701c4$var$Rj(b);
            } catch (r) {
                $223b3691249701c4$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $223b3691249701c4$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $223b3691249701c4$var$V = c;
            break;
        }
        $223b3691249701c4$var$V = b.return;
    }
}
function $223b3691249701c4$var$gk(a) {
    for(; null !== $223b3691249701c4$var$V;){
        var b = $223b3691249701c4$var$V;
        if (b === a) {
            $223b3691249701c4$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $223b3691249701c4$var$V = c;
            break;
        }
        $223b3691249701c4$var$V = b.return;
    }
}
function $223b3691249701c4$var$jk(a) {
    for(; null !== $223b3691249701c4$var$V;){
        var b = $223b3691249701c4$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $223b3691249701c4$var$Qj(4, b);
                    } catch (k) {
                        $223b3691249701c4$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $223b3691249701c4$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $223b3691249701c4$var$Rj(b);
                    } catch (k) {
                        $223b3691249701c4$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $223b3691249701c4$var$Rj(b);
                    } catch (k) {
                        $223b3691249701c4$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $223b3691249701c4$var$W(b, b.return, k);
        }
        if (b === a) {
            $223b3691249701c4$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $223b3691249701c4$var$V = h;
            break;
        }
        $223b3691249701c4$var$V = b.return;
    }
}
var $223b3691249701c4$var$lk = Math.ceil, $223b3691249701c4$var$mk = $223b3691249701c4$var$ua.ReactCurrentDispatcher, $223b3691249701c4$var$nk = $223b3691249701c4$var$ua.ReactCurrentOwner, $223b3691249701c4$var$ok = $223b3691249701c4$var$ua.ReactCurrentBatchConfig, $223b3691249701c4$var$K = 0, $223b3691249701c4$var$Q = null, $223b3691249701c4$var$Y = null, $223b3691249701c4$var$Z = 0, $223b3691249701c4$var$fj = 0, $223b3691249701c4$var$ej = $223b3691249701c4$var$Uf(0), $223b3691249701c4$var$T = 0, $223b3691249701c4$var$pk = null, $223b3691249701c4$var$rh = 0, $223b3691249701c4$var$qk = 0, $223b3691249701c4$var$rk = 0, $223b3691249701c4$var$sk = null, $223b3691249701c4$var$tk = null, $223b3691249701c4$var$fk = 0, $223b3691249701c4$var$Gj = Infinity, $223b3691249701c4$var$uk = null, $223b3691249701c4$var$Oi = !1, $223b3691249701c4$var$Pi = null, $223b3691249701c4$var$Ri = null, $223b3691249701c4$var$vk = !1, $223b3691249701c4$var$wk = null, $223b3691249701c4$var$xk = 0, $223b3691249701c4$var$yk = 0, $223b3691249701c4$var$zk = null, $223b3691249701c4$var$Ak = -1, $223b3691249701c4$var$Bk = 0;
function $223b3691249701c4$var$R() {
    return 0 !== ($223b3691249701c4$var$K & 6) ? $223b3691249701c4$var$B() : -1 !== $223b3691249701c4$var$Ak ? $223b3691249701c4$var$Ak : $223b3691249701c4$var$Ak = $223b3691249701c4$var$B();
}
function $223b3691249701c4$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($223b3691249701c4$var$K & 2) && 0 !== $223b3691249701c4$var$Z) return $223b3691249701c4$var$Z & -$223b3691249701c4$var$Z;
    if (null !== $223b3691249701c4$var$Kg.transition) return 0 === $223b3691249701c4$var$Bk && ($223b3691249701c4$var$Bk = $223b3691249701c4$var$yc()), $223b3691249701c4$var$Bk;
    a = $223b3691249701c4$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $223b3691249701c4$var$jd(a.type);
    return a;
}
function $223b3691249701c4$var$gi(a, b, c, d) {
    if (50 < $223b3691249701c4$var$yk) throw $223b3691249701c4$var$yk = 0, $223b3691249701c4$var$zk = null, Error($223b3691249701c4$var$p(185));
    $223b3691249701c4$var$Ac(a, c, d);
    if (0 === ($223b3691249701c4$var$K & 2) || a !== $223b3691249701c4$var$Q) a === $223b3691249701c4$var$Q && (0 === ($223b3691249701c4$var$K & 2) && ($223b3691249701c4$var$qk |= c), 4 === $223b3691249701c4$var$T && $223b3691249701c4$var$Ck(a, $223b3691249701c4$var$Z)), $223b3691249701c4$var$Dk(a, d), 1 === c && 0 === $223b3691249701c4$var$K && 0 === (b.mode & 1) && ($223b3691249701c4$var$Gj = $223b3691249701c4$var$B() + 500, $223b3691249701c4$var$fg && $223b3691249701c4$var$jg());
}
function $223b3691249701c4$var$Dk(a, b) {
    var c = a.callbackNode;
    $223b3691249701c4$var$wc(a, b);
    var d = $223b3691249701c4$var$uc(a, a === $223b3691249701c4$var$Q ? $223b3691249701c4$var$Z : 0);
    if (0 === d) null !== c && $223b3691249701c4$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $223b3691249701c4$var$bc(c);
        if (1 === b) 0 === a.tag ? $223b3691249701c4$var$ig($223b3691249701c4$var$Ek.bind(null, a)) : $223b3691249701c4$var$hg($223b3691249701c4$var$Ek.bind(null, a)), $223b3691249701c4$var$Jf(function() {
            0 === ($223b3691249701c4$var$K & 6) && $223b3691249701c4$var$jg();
        }), c = null;
        else {
            switch($223b3691249701c4$var$Dc(d)){
                case 1:
                    c = $223b3691249701c4$var$fc;
                    break;
                case 4:
                    c = $223b3691249701c4$var$gc;
                    break;
                case 16:
                    c = $223b3691249701c4$var$hc;
                    break;
                case 536870912:
                    c = $223b3691249701c4$var$jc;
                    break;
                default:
                    c = $223b3691249701c4$var$hc;
            }
            c = $223b3691249701c4$var$Fk(c, $223b3691249701c4$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $223b3691249701c4$var$Gk(a, b) {
    $223b3691249701c4$var$Ak = -1;
    $223b3691249701c4$var$Bk = 0;
    if (0 !== ($223b3691249701c4$var$K & 6)) throw Error($223b3691249701c4$var$p(327));
    var c = a.callbackNode;
    if ($223b3691249701c4$var$Hk() && a.callbackNode !== c) return null;
    var d = $223b3691249701c4$var$uc(a, a === $223b3691249701c4$var$Q ? $223b3691249701c4$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $223b3691249701c4$var$Ik(a, d);
    else {
        b = d;
        var e = $223b3691249701c4$var$K;
        $223b3691249701c4$var$K |= 2;
        var f = $223b3691249701c4$var$Jk();
        if ($223b3691249701c4$var$Q !== a || $223b3691249701c4$var$Z !== b) $223b3691249701c4$var$uk = null, $223b3691249701c4$var$Gj = $223b3691249701c4$var$B() + 500, $223b3691249701c4$var$Kk(a, b);
        for(;;)try {
            $223b3691249701c4$var$Lk();
            break;
        } catch (h) {
            $223b3691249701c4$var$Mk(a, h);
        }
        $223b3691249701c4$var$$g();
        $223b3691249701c4$var$mk.current = f;
        $223b3691249701c4$var$K = e;
        null !== $223b3691249701c4$var$Y ? b = 0 : ($223b3691249701c4$var$Q = null, $223b3691249701c4$var$Z = 0, b = $223b3691249701c4$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $223b3691249701c4$var$xc(a), 0 !== e && (d = e, b = $223b3691249701c4$var$Nk(a, e)));
        if (1 === b) throw c = $223b3691249701c4$var$pk, $223b3691249701c4$var$Kk(a, 0), $223b3691249701c4$var$Ck(a, d), $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B()), c;
        if (6 === b) $223b3691249701c4$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$223b3691249701c4$var$Ok(e) && (b = $223b3691249701c4$var$Ik(a, d), 2 === b && (f = $223b3691249701c4$var$xc(a), 0 !== f && (d = f, b = $223b3691249701c4$var$Nk(a, f))), 1 === b)) throw c = $223b3691249701c4$var$pk, $223b3691249701c4$var$Kk(a, 0), $223b3691249701c4$var$Ck(a, d), $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($223b3691249701c4$var$p(345));
                case 2:
                    $223b3691249701c4$var$Pk(a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk);
                    break;
                case 3:
                    $223b3691249701c4$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $223b3691249701c4$var$fk + 500 - $223b3691249701c4$var$B(), 10 < b)) {
                        if (0 !== $223b3691249701c4$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $223b3691249701c4$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $223b3691249701c4$var$Ff($223b3691249701c4$var$Pk.bind(null, a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk), b);
                        break;
                    }
                    $223b3691249701c4$var$Pk(a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk);
                    break;
                case 4:
                    $223b3691249701c4$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $223b3691249701c4$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $223b3691249701c4$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $223b3691249701c4$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $223b3691249701c4$var$Ff($223b3691249701c4$var$Pk.bind(null, a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk), d);
                        break;
                    }
                    $223b3691249701c4$var$Pk(a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk);
                    break;
                case 5:
                    $223b3691249701c4$var$Pk(a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk);
                    break;
                default:
                    throw Error($223b3691249701c4$var$p(329));
            }
        }
    }
    $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B());
    return a.callbackNode === c ? $223b3691249701c4$var$Gk.bind(null, a) : null;
}
function $223b3691249701c4$var$Nk(a, b) {
    var c = $223b3691249701c4$var$sk;
    a.current.memoizedState.isDehydrated && ($223b3691249701c4$var$Kk(a, b).flags |= 256);
    a = $223b3691249701c4$var$Ik(a, b);
    2 !== a && (b = $223b3691249701c4$var$tk, $223b3691249701c4$var$tk = c, null !== b && $223b3691249701c4$var$Fj(b));
    return a;
}
function $223b3691249701c4$var$Fj(a) {
    null === $223b3691249701c4$var$tk ? $223b3691249701c4$var$tk = a : $223b3691249701c4$var$tk.push.apply($223b3691249701c4$var$tk, a);
}
function $223b3691249701c4$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$223b3691249701c4$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $223b3691249701c4$var$Ck(a, b) {
    b &= ~$223b3691249701c4$var$rk;
    b &= ~$223b3691249701c4$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $223b3691249701c4$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $223b3691249701c4$var$Ek(a) {
    if (0 !== ($223b3691249701c4$var$K & 6)) throw Error($223b3691249701c4$var$p(327));
    $223b3691249701c4$var$Hk();
    var b = $223b3691249701c4$var$uc(a, 0);
    if (0 === (b & 1)) return $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B()), null;
    var c = $223b3691249701c4$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $223b3691249701c4$var$xc(a);
        0 !== d && (b = d, c = $223b3691249701c4$var$Nk(a, d));
    }
    if (1 === c) throw c = $223b3691249701c4$var$pk, $223b3691249701c4$var$Kk(a, 0), $223b3691249701c4$var$Ck(a, b), $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B()), c;
    if (6 === c) throw Error($223b3691249701c4$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $223b3691249701c4$var$Pk(a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk);
    $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B());
    return null;
}
function $223b3691249701c4$var$Qk(a, b) {
    var c = $223b3691249701c4$var$K;
    $223b3691249701c4$var$K |= 1;
    try {
        return a(b);
    } finally{
        $223b3691249701c4$var$K = c, 0 === $223b3691249701c4$var$K && ($223b3691249701c4$var$Gj = $223b3691249701c4$var$B() + 500, $223b3691249701c4$var$fg && $223b3691249701c4$var$jg());
    }
}
function $223b3691249701c4$var$Rk(a) {
    null !== $223b3691249701c4$var$wk && 0 === $223b3691249701c4$var$wk.tag && 0 === ($223b3691249701c4$var$K & 6) && $223b3691249701c4$var$Hk();
    var b = $223b3691249701c4$var$K;
    $223b3691249701c4$var$K |= 1;
    var c = $223b3691249701c4$var$ok.transition, d = $223b3691249701c4$var$C;
    try {
        if ($223b3691249701c4$var$ok.transition = null, $223b3691249701c4$var$C = 1, a) return a();
    } finally{
        $223b3691249701c4$var$C = d, $223b3691249701c4$var$ok.transition = c, $223b3691249701c4$var$K = b, 0 === ($223b3691249701c4$var$K & 6) && $223b3691249701c4$var$jg();
    }
}
function $223b3691249701c4$var$Hj() {
    $223b3691249701c4$var$fj = $223b3691249701c4$var$ej.current;
    $223b3691249701c4$var$E($223b3691249701c4$var$ej);
}
function $223b3691249701c4$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $223b3691249701c4$var$Gf(c));
    if (null !== $223b3691249701c4$var$Y) for(c = $223b3691249701c4$var$Y.return; null !== c;){
        var d = c;
        $223b3691249701c4$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $223b3691249701c4$var$$f();
                break;
            case 3:
                $223b3691249701c4$var$zh();
                $223b3691249701c4$var$E($223b3691249701c4$var$Wf);
                $223b3691249701c4$var$E($223b3691249701c4$var$H);
                $223b3691249701c4$var$Eh();
                break;
            case 5:
                $223b3691249701c4$var$Bh(d);
                break;
            case 4:
                $223b3691249701c4$var$zh();
                break;
            case 13:
                $223b3691249701c4$var$E($223b3691249701c4$var$L);
                break;
            case 19:
                $223b3691249701c4$var$E($223b3691249701c4$var$L);
                break;
            case 10:
                $223b3691249701c4$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $223b3691249701c4$var$Hj();
        }
        c = c.return;
    }
    $223b3691249701c4$var$Q = a;
    $223b3691249701c4$var$Y = a = $223b3691249701c4$var$Pg(a.current, null);
    $223b3691249701c4$var$Z = $223b3691249701c4$var$fj = b;
    $223b3691249701c4$var$T = 0;
    $223b3691249701c4$var$pk = null;
    $223b3691249701c4$var$rk = $223b3691249701c4$var$qk = $223b3691249701c4$var$rh = 0;
    $223b3691249701c4$var$tk = $223b3691249701c4$var$sk = null;
    if (null !== $223b3691249701c4$var$fh) {
        for(b = 0; b < $223b3691249701c4$var$fh.length; b++)if (c = $223b3691249701c4$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $223b3691249701c4$var$fh = null;
    }
    return a;
}
function $223b3691249701c4$var$Mk(a, b) {
    do {
        var c = $223b3691249701c4$var$Y;
        try {
            $223b3691249701c4$var$$g();
            $223b3691249701c4$var$Fh.current = $223b3691249701c4$var$Rh;
            if ($223b3691249701c4$var$Ih) {
                for(var d = $223b3691249701c4$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $223b3691249701c4$var$Ih = !1;
            }
            $223b3691249701c4$var$Hh = 0;
            $223b3691249701c4$var$O = $223b3691249701c4$var$N = $223b3691249701c4$var$M = null;
            $223b3691249701c4$var$Jh = !1;
            $223b3691249701c4$var$Kh = 0;
            $223b3691249701c4$var$nk.current = null;
            if (null === c || null === c.return) {
                $223b3691249701c4$var$T = 1;
                $223b3691249701c4$var$pk = b;
                $223b3691249701c4$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $223b3691249701c4$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $223b3691249701c4$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $223b3691249701c4$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $223b3691249701c4$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $223b3691249701c4$var$Si(f, l, b);
                            $223b3691249701c4$var$tj();
                            break a;
                        }
                        k = Error($223b3691249701c4$var$p(426));
                    }
                } else if ($223b3691249701c4$var$I && h.mode & 1) {
                    var J = $223b3691249701c4$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $223b3691249701c4$var$Vi(J, g, h, f, b);
                        $223b3691249701c4$var$Jg($223b3691249701c4$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $223b3691249701c4$var$Ji(k, h);
                4 !== $223b3691249701c4$var$T && ($223b3691249701c4$var$T = 2);
                null === $223b3691249701c4$var$sk ? $223b3691249701c4$var$sk = [
                    f
                ] : $223b3691249701c4$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $223b3691249701c4$var$Ni(f, k, b);
                            $223b3691249701c4$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $223b3691249701c4$var$Ri || !$223b3691249701c4$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $223b3691249701c4$var$Qi(f, h, b);
                                $223b3691249701c4$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $223b3691249701c4$var$Sk(c);
        } catch (na) {
            b = na;
            $223b3691249701c4$var$Y === c && null !== c && ($223b3691249701c4$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $223b3691249701c4$var$Jk() {
    var a = $223b3691249701c4$var$mk.current;
    $223b3691249701c4$var$mk.current = $223b3691249701c4$var$Rh;
    return null === a ? $223b3691249701c4$var$Rh : a;
}
function $223b3691249701c4$var$tj() {
    if (0 === $223b3691249701c4$var$T || 3 === $223b3691249701c4$var$T || 2 === $223b3691249701c4$var$T) $223b3691249701c4$var$T = 4;
    null === $223b3691249701c4$var$Q || 0 === ($223b3691249701c4$var$rh & 268435455) && 0 === ($223b3691249701c4$var$qk & 268435455) || $223b3691249701c4$var$Ck($223b3691249701c4$var$Q, $223b3691249701c4$var$Z);
}
function $223b3691249701c4$var$Ik(a, b) {
    var c = $223b3691249701c4$var$K;
    $223b3691249701c4$var$K |= 2;
    var d = $223b3691249701c4$var$Jk();
    if ($223b3691249701c4$var$Q !== a || $223b3691249701c4$var$Z !== b) $223b3691249701c4$var$uk = null, $223b3691249701c4$var$Kk(a, b);
    for(;;)try {
        $223b3691249701c4$var$Tk();
        break;
    } catch (e) {
        $223b3691249701c4$var$Mk(a, e);
    }
    $223b3691249701c4$var$$g();
    $223b3691249701c4$var$K = c;
    $223b3691249701c4$var$mk.current = d;
    if (null !== $223b3691249701c4$var$Y) throw Error($223b3691249701c4$var$p(261));
    $223b3691249701c4$var$Q = null;
    $223b3691249701c4$var$Z = 0;
    return $223b3691249701c4$var$T;
}
function $223b3691249701c4$var$Tk() {
    for(; null !== $223b3691249701c4$var$Y;)$223b3691249701c4$var$Uk($223b3691249701c4$var$Y);
}
function $223b3691249701c4$var$Lk() {
    for(; null !== $223b3691249701c4$var$Y && !$223b3691249701c4$var$cc();)$223b3691249701c4$var$Uk($223b3691249701c4$var$Y);
}
function $223b3691249701c4$var$Uk(a) {
    var b = $223b3691249701c4$var$Vk(a.alternate, a, $223b3691249701c4$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $223b3691249701c4$var$Sk(a) : $223b3691249701c4$var$Y = b;
    $223b3691249701c4$var$nk.current = null;
}
function $223b3691249701c4$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $223b3691249701c4$var$Ej(c, b, $223b3691249701c4$var$fj), null !== c) {
                $223b3691249701c4$var$Y = c;
                return;
            }
        } else {
            c = $223b3691249701c4$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $223b3691249701c4$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $223b3691249701c4$var$T = 6;
                $223b3691249701c4$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $223b3691249701c4$var$Y = b;
            return;
        }
        $223b3691249701c4$var$Y = b = a;
    }while (null !== b);
    0 === $223b3691249701c4$var$T && ($223b3691249701c4$var$T = 5);
}
function $223b3691249701c4$var$Pk(a, b, c) {
    var d = $223b3691249701c4$var$C, e = $223b3691249701c4$var$ok.transition;
    try {
        $223b3691249701c4$var$ok.transition = null, $223b3691249701c4$var$C = 1, $223b3691249701c4$var$Wk(a, b, c, d);
    } finally{
        $223b3691249701c4$var$ok.transition = e, $223b3691249701c4$var$C = d;
    }
    return null;
}
function $223b3691249701c4$var$Wk(a, b, c, d) {
    do $223b3691249701c4$var$Hk();
    while (null !== $223b3691249701c4$var$wk);
    if (0 !== ($223b3691249701c4$var$K & 6)) throw Error($223b3691249701c4$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($223b3691249701c4$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $223b3691249701c4$var$Bc(a, f);
    a === $223b3691249701c4$var$Q && ($223b3691249701c4$var$Y = $223b3691249701c4$var$Q = null, $223b3691249701c4$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $223b3691249701c4$var$vk || ($223b3691249701c4$var$vk = !0, $223b3691249701c4$var$Fk($223b3691249701c4$var$hc, function() {
        $223b3691249701c4$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $223b3691249701c4$var$ok.transition;
        $223b3691249701c4$var$ok.transition = null;
        var g = $223b3691249701c4$var$C;
        $223b3691249701c4$var$C = 1;
        var h = $223b3691249701c4$var$K;
        $223b3691249701c4$var$K |= 4;
        $223b3691249701c4$var$nk.current = null;
        $223b3691249701c4$var$Oj(a, c);
        $223b3691249701c4$var$dk(c, a);
        $223b3691249701c4$var$Oe($223b3691249701c4$var$Df);
        $223b3691249701c4$var$dd = !!$223b3691249701c4$var$Cf;
        $223b3691249701c4$var$Df = $223b3691249701c4$var$Cf = null;
        a.current = c;
        $223b3691249701c4$var$hk(c, a, e);
        $223b3691249701c4$var$dc();
        $223b3691249701c4$var$K = h;
        $223b3691249701c4$var$C = g;
        $223b3691249701c4$var$ok.transition = f;
    } else a.current = c;
    $223b3691249701c4$var$vk && ($223b3691249701c4$var$vk = !1, $223b3691249701c4$var$wk = a, $223b3691249701c4$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($223b3691249701c4$var$Ri = null);
    $223b3691249701c4$var$mc(c.stateNode, d);
    $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($223b3691249701c4$var$Oi) throw $223b3691249701c4$var$Oi = !1, a = $223b3691249701c4$var$Pi, $223b3691249701c4$var$Pi = null, a;
    0 !== ($223b3691249701c4$var$xk & 1) && 0 !== a.tag && $223b3691249701c4$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $223b3691249701c4$var$zk ? $223b3691249701c4$var$yk++ : ($223b3691249701c4$var$yk = 0, $223b3691249701c4$var$zk = a) : $223b3691249701c4$var$yk = 0;
    $223b3691249701c4$var$jg();
    return null;
}
function $223b3691249701c4$var$Hk() {
    if (null !== $223b3691249701c4$var$wk) {
        var a = $223b3691249701c4$var$Dc($223b3691249701c4$var$xk), b = $223b3691249701c4$var$ok.transition, c = $223b3691249701c4$var$C;
        try {
            $223b3691249701c4$var$ok.transition = null;
            $223b3691249701c4$var$C = 16 > a ? 16 : a;
            if (null === $223b3691249701c4$var$wk) var d = !1;
            else {
                a = $223b3691249701c4$var$wk;
                $223b3691249701c4$var$wk = null;
                $223b3691249701c4$var$xk = 0;
                if (0 !== ($223b3691249701c4$var$K & 6)) throw Error($223b3691249701c4$var$p(331));
                var e = $223b3691249701c4$var$K;
                $223b3691249701c4$var$K |= 4;
                for($223b3691249701c4$var$V = a.current; null !== $223b3691249701c4$var$V;){
                    var f = $223b3691249701c4$var$V, g = f.child;
                    if (0 !== ($223b3691249701c4$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($223b3691249701c4$var$V = l; null !== $223b3691249701c4$var$V;){
                                    var m = $223b3691249701c4$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $223b3691249701c4$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $223b3691249701c4$var$V = q;
                                    else for(; null !== $223b3691249701c4$var$V;){
                                        m = $223b3691249701c4$var$V;
                                        var r = m.sibling, y = m.return;
                                        $223b3691249701c4$var$Sj(m);
                                        if (m === l) {
                                            $223b3691249701c4$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $223b3691249701c4$var$V = r;
                                            break;
                                        }
                                        $223b3691249701c4$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $223b3691249701c4$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $223b3691249701c4$var$V = g;
                    else b: for(; null !== $223b3691249701c4$var$V;){
                        f = $223b3691249701c4$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $223b3691249701c4$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $223b3691249701c4$var$V = x;
                            break b;
                        }
                        $223b3691249701c4$var$V = f.return;
                    }
                }
                var w = a.current;
                for($223b3691249701c4$var$V = w; null !== $223b3691249701c4$var$V;){
                    g = $223b3691249701c4$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $223b3691249701c4$var$V = u;
                    else b: for(g = w; null !== $223b3691249701c4$var$V;){
                        h = $223b3691249701c4$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $223b3691249701c4$var$Qj(9, h);
                            }
                        } catch (na) {
                            $223b3691249701c4$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $223b3691249701c4$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $223b3691249701c4$var$V = F;
                            break b;
                        }
                        $223b3691249701c4$var$V = h.return;
                    }
                }
                $223b3691249701c4$var$K = e;
                $223b3691249701c4$var$jg();
                if ($223b3691249701c4$var$lc && "function" === typeof $223b3691249701c4$var$lc.onPostCommitFiberRoot) try {
                    $223b3691249701c4$var$lc.onPostCommitFiberRoot($223b3691249701c4$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $223b3691249701c4$var$C = c, $223b3691249701c4$var$ok.transition = b;
        }
    }
    return !1;
}
function $223b3691249701c4$var$Xk(a, b, c) {
    b = $223b3691249701c4$var$Ji(c, b);
    b = $223b3691249701c4$var$Ni(a, b, 1);
    a = $223b3691249701c4$var$nh(a, b, 1);
    b = $223b3691249701c4$var$R();
    null !== a && ($223b3691249701c4$var$Ac(a, 1, b), $223b3691249701c4$var$Dk(a, b));
}
function $223b3691249701c4$var$W(a, b, c) {
    if (3 === a.tag) $223b3691249701c4$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $223b3691249701c4$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $223b3691249701c4$var$Ri || !$223b3691249701c4$var$Ri.has(d))) {
                a = $223b3691249701c4$var$Ji(c, a);
                a = $223b3691249701c4$var$Qi(b, a, 1);
                b = $223b3691249701c4$var$nh(b, a, 1);
                a = $223b3691249701c4$var$R();
                null !== b && ($223b3691249701c4$var$Ac(b, 1, a), $223b3691249701c4$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $223b3691249701c4$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $223b3691249701c4$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $223b3691249701c4$var$Q === a && ($223b3691249701c4$var$Z & c) === c && (4 === $223b3691249701c4$var$T || 3 === $223b3691249701c4$var$T && ($223b3691249701c4$var$Z & 130023424) === $223b3691249701c4$var$Z && 500 > $223b3691249701c4$var$B() - $223b3691249701c4$var$fk ? $223b3691249701c4$var$Kk(a, 0) : $223b3691249701c4$var$rk |= c);
    $223b3691249701c4$var$Dk(a, b);
}
function $223b3691249701c4$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $223b3691249701c4$var$sc, $223b3691249701c4$var$sc <<= 1, 0 === ($223b3691249701c4$var$sc & 130023424) && ($223b3691249701c4$var$sc = 4194304)));
    var c = $223b3691249701c4$var$R();
    a = $223b3691249701c4$var$ih(a, b);
    null !== a && ($223b3691249701c4$var$Ac(a, b, c), $223b3691249701c4$var$Dk(a, c));
}
function $223b3691249701c4$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $223b3691249701c4$var$Yk(a, c);
}
function $223b3691249701c4$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($223b3691249701c4$var$p(314));
    }
    null !== d && d.delete(b);
    $223b3691249701c4$var$Yk(a, c);
}
var $223b3691249701c4$var$Vk;
$223b3691249701c4$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $223b3691249701c4$var$Wf.current) $223b3691249701c4$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $223b3691249701c4$var$dh = !1, $223b3691249701c4$var$yj(a, b, c);
            $223b3691249701c4$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $223b3691249701c4$var$dh = !1, $223b3691249701c4$var$I && 0 !== (b.flags & 1048576) && $223b3691249701c4$var$ug(b, $223b3691249701c4$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $223b3691249701c4$var$ij(a, b);
            a = b.pendingProps;
            var e = $223b3691249701c4$var$Yf(b, $223b3691249701c4$var$H.current);
            $223b3691249701c4$var$ch(b, c);
            e = $223b3691249701c4$var$Nh(null, b, d, a, e, c);
            var f = $223b3691249701c4$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $223b3691249701c4$var$Zf(d) ? (f = !0, $223b3691249701c4$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $223b3691249701c4$var$kh(b), e.updater = $223b3691249701c4$var$Ei, b.stateNode = e, e._reactInternals = b, $223b3691249701c4$var$Ii(b, d, a, c), b = $223b3691249701c4$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $223b3691249701c4$var$I && f && $223b3691249701c4$var$vg(b), $223b3691249701c4$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $223b3691249701c4$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $223b3691249701c4$var$Zk(d);
                a = $223b3691249701c4$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $223b3691249701c4$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $223b3691249701c4$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $223b3691249701c4$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $223b3691249701c4$var$$i(null, b, d, $223b3691249701c4$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($223b3691249701c4$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $223b3691249701c4$var$Ci(d, e), $223b3691249701c4$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $223b3691249701c4$var$Ci(d, e), $223b3691249701c4$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $223b3691249701c4$var$kj(b);
                if (null === a) throw Error($223b3691249701c4$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $223b3691249701c4$var$lh(a, b);
                $223b3691249701c4$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $223b3691249701c4$var$Ji(Error($223b3691249701c4$var$p(423)), b);
                        b = $223b3691249701c4$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $223b3691249701c4$var$Ji(Error($223b3691249701c4$var$p(424)), b);
                        b = $223b3691249701c4$var$lj(a, b, d, c, e);
                        break a;
                    } else for($223b3691249701c4$var$yg = $223b3691249701c4$var$Lf(b.stateNode.containerInfo.firstChild), $223b3691249701c4$var$xg = b, $223b3691249701c4$var$I = !0, $223b3691249701c4$var$zg = null, c = $223b3691249701c4$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $223b3691249701c4$var$Ig();
                    if (d === e) {
                        b = $223b3691249701c4$var$Zi(a, b, c);
                        break a;
                    }
                    $223b3691249701c4$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $223b3691249701c4$var$Ah(b), null === a && $223b3691249701c4$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $223b3691249701c4$var$Ef(d, e) ? g = null : null !== f && $223b3691249701c4$var$Ef(d, f) && (b.flags |= 32), $223b3691249701c4$var$gj(a, b), $223b3691249701c4$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $223b3691249701c4$var$Eg(b), null;
        case 13:
            return $223b3691249701c4$var$oj(a, b, c);
        case 4:
            return $223b3691249701c4$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $223b3691249701c4$var$Ug(b, null, d, c) : $223b3691249701c4$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $223b3691249701c4$var$Ci(d, e), $223b3691249701c4$var$Yi(a, b, d, e, c);
        case 7:
            return $223b3691249701c4$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $223b3691249701c4$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $223b3691249701c4$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $223b3691249701c4$var$G($223b3691249701c4$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($223b3691249701c4$var$He(f.value, g)) {
                        if (f.children === e.children && !$223b3691249701c4$var$Wf.current) {
                            b = $223b3691249701c4$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $223b3691249701c4$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $223b3691249701c4$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($223b3691249701c4$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $223b3691249701c4$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $223b3691249701c4$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $223b3691249701c4$var$ch(b, c), e = $223b3691249701c4$var$eh(e), d = d(e), b.flags |= 1, $223b3691249701c4$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $223b3691249701c4$var$Ci(d, b.pendingProps), e = $223b3691249701c4$var$Ci(d.type, e), $223b3691249701c4$var$$i(a, b, d, e, c);
        case 15:
            return $223b3691249701c4$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $223b3691249701c4$var$Ci(d, e), $223b3691249701c4$var$ij(a, b), b.tag = 1, $223b3691249701c4$var$Zf(d) ? (a = !0, $223b3691249701c4$var$cg(b)) : a = !1, $223b3691249701c4$var$ch(b, c), $223b3691249701c4$var$Gi(b, d, e), $223b3691249701c4$var$Ii(b, d, e, c), $223b3691249701c4$var$jj(null, b, d, !0, a, c);
        case 19:
            return $223b3691249701c4$var$xj(a, b, c);
        case 22:
            return $223b3691249701c4$var$dj(a, b, c);
    }
    throw Error($223b3691249701c4$var$p(156, b.tag));
};
function $223b3691249701c4$var$Fk(a, b) {
    return $223b3691249701c4$var$ac(a, b);
}
function $223b3691249701c4$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $223b3691249701c4$var$Bg(a, b, c, d) {
    return new $223b3691249701c4$var$$k(a, b, c, d);
}
function $223b3691249701c4$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $223b3691249701c4$var$Zk(a) {
    if ("function" === typeof a) return $223b3691249701c4$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $223b3691249701c4$var$Da) return 11;
        if (a === $223b3691249701c4$var$Ga) return 14;
    }
    return 2;
}
function $223b3691249701c4$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $223b3691249701c4$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $223b3691249701c4$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $223b3691249701c4$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $223b3691249701c4$var$ya:
            return $223b3691249701c4$var$Tg(c.children, e, f, b);
        case $223b3691249701c4$var$za:
            g = 8;
            e |= 8;
            break;
        case $223b3691249701c4$var$Aa:
            return a = $223b3691249701c4$var$Bg(12, c, b, e | 2), a.elementType = $223b3691249701c4$var$Aa, a.lanes = f, a;
        case $223b3691249701c4$var$Ea:
            return a = $223b3691249701c4$var$Bg(13, c, b, e), a.elementType = $223b3691249701c4$var$Ea, a.lanes = f, a;
        case $223b3691249701c4$var$Fa:
            return a = $223b3691249701c4$var$Bg(19, c, b, e), a.elementType = $223b3691249701c4$var$Fa, a.lanes = f, a;
        case $223b3691249701c4$var$Ia:
            return $223b3691249701c4$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $223b3691249701c4$var$Ba:
                    g = 10;
                    break a;
                case $223b3691249701c4$var$Ca:
                    g = 9;
                    break a;
                case $223b3691249701c4$var$Da:
                    g = 11;
                    break a;
                case $223b3691249701c4$var$Ga:
                    g = 14;
                    break a;
                case $223b3691249701c4$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($223b3691249701c4$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $223b3691249701c4$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $223b3691249701c4$var$Tg(a, b, c, d) {
    a = $223b3691249701c4$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $223b3691249701c4$var$pj(a, b, c, d) {
    a = $223b3691249701c4$var$Bg(22, a, d, b);
    a.elementType = $223b3691249701c4$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $223b3691249701c4$var$Qg(a, b, c) {
    a = $223b3691249701c4$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $223b3691249701c4$var$Sg(a, b, c) {
    b = $223b3691249701c4$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $223b3691249701c4$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $223b3691249701c4$var$zc(0);
    this.expirationTimes = $223b3691249701c4$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $223b3691249701c4$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $223b3691249701c4$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $223b3691249701c4$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $223b3691249701c4$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $223b3691249701c4$var$kh(f);
    return a;
}
function $223b3691249701c4$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $223b3691249701c4$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $223b3691249701c4$var$dl(a) {
    if (!a) return $223b3691249701c4$var$Vf;
    a = a._reactInternals;
    a: {
        if ($223b3691249701c4$var$Vb(a) !== a || 1 !== a.tag) throw Error($223b3691249701c4$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($223b3691249701c4$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($223b3691249701c4$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($223b3691249701c4$var$Zf(c)) return $223b3691249701c4$var$bg(a, c, b);
    }
    return b;
}
function $223b3691249701c4$var$el(a, b, c, d, e, f, g, h, k) {
    a = $223b3691249701c4$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $223b3691249701c4$var$dl(null);
    c = a.current;
    d = $223b3691249701c4$var$R();
    e = $223b3691249701c4$var$yi(c);
    f = $223b3691249701c4$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $223b3691249701c4$var$nh(c, f, e);
    a.current.lanes = e;
    $223b3691249701c4$var$Ac(a, e, d);
    $223b3691249701c4$var$Dk(a, d);
    return a;
}
function $223b3691249701c4$var$fl(a, b, c, d) {
    var e = b.current, f = $223b3691249701c4$var$R(), g = $223b3691249701c4$var$yi(e);
    c = $223b3691249701c4$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $223b3691249701c4$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $223b3691249701c4$var$nh(e, b, g);
    null !== a && ($223b3691249701c4$var$gi(a, e, g, f), $223b3691249701c4$var$oh(a, e, g));
    return g;
}
function $223b3691249701c4$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $223b3691249701c4$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $223b3691249701c4$var$il(a, b) {
    $223b3691249701c4$var$hl(a, b);
    (a = a.alternate) && $223b3691249701c4$var$hl(a, b);
}
function $223b3691249701c4$var$jl() {
    return null;
}
var $223b3691249701c4$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $223b3691249701c4$var$ll(a) {
    this._internalRoot = a;
}
$223b3691249701c4$var$ml.prototype.render = $223b3691249701c4$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($223b3691249701c4$var$p(409));
    $223b3691249701c4$var$fl(a, b, null, null);
};
$223b3691249701c4$var$ml.prototype.unmount = $223b3691249701c4$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $223b3691249701c4$var$Rk(function() {
            $223b3691249701c4$var$fl(null, a, null, null);
        });
        b[$223b3691249701c4$var$uf] = null;
    }
};
function $223b3691249701c4$var$ml(a) {
    this._internalRoot = a;
}
$223b3691249701c4$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $223b3691249701c4$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $223b3691249701c4$var$Qc.length && 0 !== b && b < $223b3691249701c4$var$Qc[c].priority; c++);
        $223b3691249701c4$var$Qc.splice(c, 0, a);
        0 === c && $223b3691249701c4$var$Vc(a);
    }
};
function $223b3691249701c4$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $223b3691249701c4$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $223b3691249701c4$var$pl() {}
function $223b3691249701c4$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $223b3691249701c4$var$gl(g);
                f.call(a);
            };
        }
        var g = $223b3691249701c4$var$el(b, d, a, 0, null, !1, !1, "", $223b3691249701c4$var$pl);
        a._reactRootContainer = g;
        a[$223b3691249701c4$var$uf] = g.current;
        $223b3691249701c4$var$sf(8 === a.nodeType ? a.parentNode : a);
        $223b3691249701c4$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $223b3691249701c4$var$gl(k);
            h.call(a);
        };
    }
    var k = $223b3691249701c4$var$bl(a, 0, !1, null, null, !1, !1, "", $223b3691249701c4$var$pl);
    a._reactRootContainer = k;
    a[$223b3691249701c4$var$uf] = k.current;
    $223b3691249701c4$var$sf(8 === a.nodeType ? a.parentNode : a);
    $223b3691249701c4$var$Rk(function() {
        $223b3691249701c4$var$fl(b, k, c, d);
    });
    return k;
}
function $223b3691249701c4$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $223b3691249701c4$var$gl(g);
                h.call(a);
            };
        }
        $223b3691249701c4$var$fl(b, g, a, e);
    } else g = $223b3691249701c4$var$ql(c, b, a, e, d);
    return $223b3691249701c4$var$gl(g);
}
$223b3691249701c4$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $223b3691249701c4$var$tc(b.pendingLanes);
                0 !== c && ($223b3691249701c4$var$Cc(b, c | 1), $223b3691249701c4$var$Dk(b, $223b3691249701c4$var$B()), 0 === ($223b3691249701c4$var$K & 6) && ($223b3691249701c4$var$Gj = $223b3691249701c4$var$B() + 500, $223b3691249701c4$var$jg()));
            }
            break;
        case 13:
            $223b3691249701c4$var$Rk(function() {
                var b = $223b3691249701c4$var$ih(a, 1);
                if (null !== b) {
                    var c = $223b3691249701c4$var$R();
                    $223b3691249701c4$var$gi(b, a, 1, c);
                }
            }), $223b3691249701c4$var$il(a, 1);
    }
};
$223b3691249701c4$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $223b3691249701c4$var$ih(a, 134217728);
        if (null !== b) {
            var c = $223b3691249701c4$var$R();
            $223b3691249701c4$var$gi(b, a, 134217728, c);
        }
        $223b3691249701c4$var$il(a, 134217728);
    }
};
$223b3691249701c4$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $223b3691249701c4$var$yi(a), c = $223b3691249701c4$var$ih(a, b);
        if (null !== c) {
            var d = $223b3691249701c4$var$R();
            $223b3691249701c4$var$gi(c, a, b, d);
        }
        $223b3691249701c4$var$il(a, b);
    }
};
$223b3691249701c4$var$Hc = function() {
    return $223b3691249701c4$var$C;
};
$223b3691249701c4$var$Ic = function(a, b) {
    var c = $223b3691249701c4$var$C;
    try {
        return $223b3691249701c4$var$C = a, b();
    } finally{
        $223b3691249701c4$var$C = c;
    }
};
$223b3691249701c4$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $223b3691249701c4$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $223b3691249701c4$var$Db(d);
                        if (!e) throw Error($223b3691249701c4$var$p(90));
                        $223b3691249701c4$var$Wa(d);
                        $223b3691249701c4$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $223b3691249701c4$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $223b3691249701c4$var$fb(a, !!c.multiple, b, !1);
    }
};
$223b3691249701c4$var$Gb = $223b3691249701c4$var$Qk;
$223b3691249701c4$var$Hb = $223b3691249701c4$var$Rk;
var $223b3691249701c4$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $223b3691249701c4$var$Cb,
        $223b3691249701c4$var$ue,
        $223b3691249701c4$var$Db,
        $223b3691249701c4$var$Eb,
        $223b3691249701c4$var$Fb,
        $223b3691249701c4$var$Qk
    ]
}, $223b3691249701c4$var$tl = {
    findFiberByHostInstance: $223b3691249701c4$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $223b3691249701c4$var$ul = {
    bundleType: $223b3691249701c4$var$tl.bundleType,
    version: $223b3691249701c4$var$tl.version,
    rendererPackageName: $223b3691249701c4$var$tl.rendererPackageName,
    rendererConfig: $223b3691249701c4$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $223b3691249701c4$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $223b3691249701c4$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $223b3691249701c4$var$tl.findFiberByHostInstance || $223b3691249701c4$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $223b3691249701c4$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$223b3691249701c4$var$vl.isDisabled && $223b3691249701c4$var$vl.supportsFiber) try {
        $223b3691249701c4$var$kc = $223b3691249701c4$var$vl.inject($223b3691249701c4$var$ul), $223b3691249701c4$var$lc = $223b3691249701c4$var$vl;
    } catch (a) {}
}
$223b3691249701c4$export$ae55be85d98224ed = $223b3691249701c4$var$sl;
$223b3691249701c4$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$223b3691249701c4$var$nl(b)) throw Error($223b3691249701c4$var$p(200));
    return $223b3691249701c4$var$cl(a, b, null, c);
};
$223b3691249701c4$export$882461b6382ed46c = function(a, b) {
    if (!$223b3691249701c4$var$nl(a)) throw Error($223b3691249701c4$var$p(299));
    var c = !1, d = "", e = $223b3691249701c4$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $223b3691249701c4$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$223b3691249701c4$var$uf] = b.current;
    $223b3691249701c4$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $223b3691249701c4$var$ll(b);
};
$223b3691249701c4$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($223b3691249701c4$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($223b3691249701c4$var$p(268, a));
    }
    a = $223b3691249701c4$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$223b3691249701c4$export$cd75ccfd720a3cd4 = function(a) {
    return $223b3691249701c4$var$Rk(a);
};
$223b3691249701c4$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$223b3691249701c4$var$ol(b)) throw Error($223b3691249701c4$var$p(200));
    return $223b3691249701c4$var$rl(null, a, b, !0, c);
};
$223b3691249701c4$export$757ceba2d55c277e = function(a, b, c) {
    if (!$223b3691249701c4$var$nl(a)) throw Error($223b3691249701c4$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $223b3691249701c4$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $223b3691249701c4$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$223b3691249701c4$var$uf] = b.current;
    $223b3691249701c4$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $223b3691249701c4$var$ml(b);
};
$223b3691249701c4$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$223b3691249701c4$var$ol(b)) throw Error($223b3691249701c4$var$p(200));
    return $223b3691249701c4$var$rl(null, a, b, !1, c);
};
$223b3691249701c4$export$502457920280e6be = function(a) {
    if (!$223b3691249701c4$var$ol(a)) throw Error($223b3691249701c4$var$p(40));
    return a._reactRootContainer ? ($223b3691249701c4$var$Rk(function() {
        $223b3691249701c4$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$223b3691249701c4$var$uf] = null;
        });
    }), !0) : !1;
};
$223b3691249701c4$export$c78a37762a8d58e1 = $223b3691249701c4$var$Qk;
$223b3691249701c4$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$223b3691249701c4$var$ol(c)) throw Error($223b3691249701c4$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($223b3691249701c4$var$p(38));
    return $223b3691249701c4$var$rl(a, b, c, !1, d);
};
$223b3691249701c4$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("l7BOg", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lSa6a"));

});
parcelRegister("lSa6a", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $fec67976f0e16090$export$c4744153514ff05d; }, function (v) { return $fec67976f0e16090$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $fec67976f0e16090$export$3e506c1ccc9cc1a7; }, function (v) { return $fec67976f0e16090$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $fec67976f0e16090$export$e26fe2ed2fa76875; }, function (v) { return $fec67976f0e16090$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $fec67976f0e16090$export$502329bbf4b505b1; }, function (v) { return $fec67976f0e16090$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $fec67976f0e16090$export$6e3807111c4874c4; }, function (v) { return $fec67976f0e16090$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $fec67976f0e16090$export$c27134553091fb3a; }, function (v) { return $fec67976f0e16090$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $fec67976f0e16090$export$33ee1acdc04fd2a2; }, function (v) { return $fec67976f0e16090$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $fec67976f0e16090$export$b00a404bbd5edef2; }, function (v) { return $fec67976f0e16090$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $fec67976f0e16090$export$8352ce38b91d0c62; }, function (v) { return $fec67976f0e16090$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $fec67976f0e16090$export$d66a1c1c77bd778b; }, function (v) { return $fec67976f0e16090$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $fec67976f0e16090$export$d3dfb8e4810cb555; }, function (v) { return $fec67976f0e16090$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $fec67976f0e16090$export$839f9183b0465a69; }, function (v) { return $fec67976f0e16090$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $fec67976f0e16090$export$72fdf0e06517287b; }, function (v) { return $fec67976f0e16090$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $fec67976f0e16090$export$4b844e58a3e414b4; }, function (v) { return $fec67976f0e16090$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $fec67976f0e16090$export$816d2913ae6b83b1; }, function (v) { return $fec67976f0e16090$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $fec67976f0e16090$export$61bcfe829111a1d0; }, function (v) { return $fec67976f0e16090$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $fec67976f0e16090$export$7ee8c9beb337bc3f; }, function (v) { return $fec67976f0e16090$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $fec67976f0e16090$export$b5836b71941fa3ed; }, function (v) { return $fec67976f0e16090$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $fec67976f0e16090$export$cf845f2c119da08a; }, function (v) { return $fec67976f0e16090$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fec67976f0e16090$export$c4744153514ff05d;
var $fec67976f0e16090$export$3e506c1ccc9cc1a7;
var $fec67976f0e16090$export$e26fe2ed2fa76875;
var $fec67976f0e16090$export$502329bbf4b505b1;
var $fec67976f0e16090$export$6e3807111c4874c4;
var $fec67976f0e16090$export$c27134553091fb3a;
var $fec67976f0e16090$export$33ee1acdc04fd2a2;
var $fec67976f0e16090$export$b00a404bbd5edef2;
var $fec67976f0e16090$export$8352ce38b91d0c62;
var $fec67976f0e16090$export$d66a1c1c77bd778b;
var $fec67976f0e16090$export$d3dfb8e4810cb555;
var $fec67976f0e16090$export$839f9183b0465a69;
var $fec67976f0e16090$export$72fdf0e06517287b;
var $fec67976f0e16090$export$4b844e58a3e414b4;
var $fec67976f0e16090$export$816d2913ae6b83b1;
var $fec67976f0e16090$export$61bcfe829111a1d0;
var $fec67976f0e16090$export$7ee8c9beb337bc3f;
var $fec67976f0e16090$export$b5836b71941fa3ed;
var $fec67976f0e16090$export$cf845f2c119da08a;
"use strict";
function $fec67976f0e16090$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $fec67976f0e16090$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $fec67976f0e16090$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $fec67976f0e16090$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $fec67976f0e16090$var$g(C, c)) n < e && 0 > $fec67976f0e16090$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $fec67976f0e16090$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $fec67976f0e16090$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $fec67976f0e16090$var$l = performance;
    $fec67976f0e16090$export$c4744153514ff05d = function() {
        return $fec67976f0e16090$var$l.now();
    };
} else {
    var $fec67976f0e16090$var$p = Date, $fec67976f0e16090$var$q = $fec67976f0e16090$var$p.now();
    $fec67976f0e16090$export$c4744153514ff05d = function() {
        return $fec67976f0e16090$var$p.now() - $fec67976f0e16090$var$q;
    };
}
var $fec67976f0e16090$var$r = [], $fec67976f0e16090$var$t = [], $fec67976f0e16090$var$u = 1, $fec67976f0e16090$var$v = null, $fec67976f0e16090$var$y = 3, $fec67976f0e16090$var$z = !1, $fec67976f0e16090$var$A = !1, $fec67976f0e16090$var$B = !1, $fec67976f0e16090$var$D = "function" === typeof setTimeout ? setTimeout : null, $fec67976f0e16090$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $fec67976f0e16090$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $fec67976f0e16090$var$G(a) {
    for(var b = $fec67976f0e16090$var$h($fec67976f0e16090$var$t); null !== b;){
        if (null === b.callback) $fec67976f0e16090$var$k($fec67976f0e16090$var$t);
        else if (b.startTime <= a) $fec67976f0e16090$var$k($fec67976f0e16090$var$t), b.sortIndex = b.expirationTime, $fec67976f0e16090$var$f($fec67976f0e16090$var$r, b);
        else break;
        b = $fec67976f0e16090$var$h($fec67976f0e16090$var$t);
    }
}
function $fec67976f0e16090$var$H(a) {
    $fec67976f0e16090$var$B = !1;
    $fec67976f0e16090$var$G(a);
    if (!$fec67976f0e16090$var$A) {
        if (null !== $fec67976f0e16090$var$h($fec67976f0e16090$var$r)) $fec67976f0e16090$var$A = !0, $fec67976f0e16090$var$I($fec67976f0e16090$var$J);
        else {
            var b = $fec67976f0e16090$var$h($fec67976f0e16090$var$t);
            null !== b && $fec67976f0e16090$var$K($fec67976f0e16090$var$H, b.startTime - a);
        }
    }
}
function $fec67976f0e16090$var$J(a, b) {
    $fec67976f0e16090$var$A = !1;
    $fec67976f0e16090$var$B && ($fec67976f0e16090$var$B = !1, $fec67976f0e16090$var$E($fec67976f0e16090$var$L), $fec67976f0e16090$var$L = -1);
    $fec67976f0e16090$var$z = !0;
    var c = $fec67976f0e16090$var$y;
    try {
        $fec67976f0e16090$var$G(b);
        for($fec67976f0e16090$var$v = $fec67976f0e16090$var$h($fec67976f0e16090$var$r); null !== $fec67976f0e16090$var$v && (!($fec67976f0e16090$var$v.expirationTime > b) || a && !$fec67976f0e16090$var$M());){
            var d = $fec67976f0e16090$var$v.callback;
            if ("function" === typeof d) {
                $fec67976f0e16090$var$v.callback = null;
                $fec67976f0e16090$var$y = $fec67976f0e16090$var$v.priorityLevel;
                var e = d($fec67976f0e16090$var$v.expirationTime <= b);
                b = $fec67976f0e16090$export$c4744153514ff05d();
                "function" === typeof e ? $fec67976f0e16090$var$v.callback = e : $fec67976f0e16090$var$v === $fec67976f0e16090$var$h($fec67976f0e16090$var$r) && $fec67976f0e16090$var$k($fec67976f0e16090$var$r);
                $fec67976f0e16090$var$G(b);
            } else $fec67976f0e16090$var$k($fec67976f0e16090$var$r);
            $fec67976f0e16090$var$v = $fec67976f0e16090$var$h($fec67976f0e16090$var$r);
        }
        if (null !== $fec67976f0e16090$var$v) var w = !0;
        else {
            var m = $fec67976f0e16090$var$h($fec67976f0e16090$var$t);
            null !== m && $fec67976f0e16090$var$K($fec67976f0e16090$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $fec67976f0e16090$var$v = null, $fec67976f0e16090$var$y = c, $fec67976f0e16090$var$z = !1;
    }
}
var $fec67976f0e16090$var$N = !1, $fec67976f0e16090$var$O = null, $fec67976f0e16090$var$L = -1, $fec67976f0e16090$var$P = 5, $fec67976f0e16090$var$Q = -1;
function $fec67976f0e16090$var$M() {
    return $fec67976f0e16090$export$c4744153514ff05d() - $fec67976f0e16090$var$Q < $fec67976f0e16090$var$P ? !1 : !0;
}
function $fec67976f0e16090$var$R() {
    if (null !== $fec67976f0e16090$var$O) {
        var a = $fec67976f0e16090$export$c4744153514ff05d();
        $fec67976f0e16090$var$Q = a;
        var b = !0;
        try {
            b = $fec67976f0e16090$var$O(!0, a);
        } finally{
            b ? $fec67976f0e16090$var$S() : ($fec67976f0e16090$var$N = !1, $fec67976f0e16090$var$O = null);
        }
    } else $fec67976f0e16090$var$N = !1;
}
var $fec67976f0e16090$var$S;
if ("function" === typeof $fec67976f0e16090$var$F) $fec67976f0e16090$var$S = function() {
    $fec67976f0e16090$var$F($fec67976f0e16090$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $fec67976f0e16090$var$T = new MessageChannel, $fec67976f0e16090$var$U = $fec67976f0e16090$var$T.port2;
    $fec67976f0e16090$var$T.port1.onmessage = $fec67976f0e16090$var$R;
    $fec67976f0e16090$var$S = function() {
        $fec67976f0e16090$var$U.postMessage(null);
    };
} else $fec67976f0e16090$var$S = function() {
    $fec67976f0e16090$var$D($fec67976f0e16090$var$R, 0);
};
function $fec67976f0e16090$var$I(a) {
    $fec67976f0e16090$var$O = a;
    $fec67976f0e16090$var$N || ($fec67976f0e16090$var$N = !0, $fec67976f0e16090$var$S());
}
function $fec67976f0e16090$var$K(a, b) {
    $fec67976f0e16090$var$L = $fec67976f0e16090$var$D(function() {
        a($fec67976f0e16090$export$c4744153514ff05d());
    }, b);
}
$fec67976f0e16090$export$3e506c1ccc9cc1a7 = 5;
$fec67976f0e16090$export$e26fe2ed2fa76875 = 1;
$fec67976f0e16090$export$502329bbf4b505b1 = 4;
$fec67976f0e16090$export$6e3807111c4874c4 = 3;
$fec67976f0e16090$export$c27134553091fb3a = null;
$fec67976f0e16090$export$33ee1acdc04fd2a2 = 2;
$fec67976f0e16090$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$fec67976f0e16090$export$8352ce38b91d0c62 = function() {
    $fec67976f0e16090$var$A || $fec67976f0e16090$var$z || ($fec67976f0e16090$var$A = !0, $fec67976f0e16090$var$I($fec67976f0e16090$var$J));
};
$fec67976f0e16090$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $fec67976f0e16090$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$fec67976f0e16090$export$d3dfb8e4810cb555 = function() {
    return $fec67976f0e16090$var$y;
};
$fec67976f0e16090$export$839f9183b0465a69 = function() {
    return $fec67976f0e16090$var$h($fec67976f0e16090$var$r);
};
$fec67976f0e16090$export$72fdf0e06517287b = function(a) {
    switch($fec67976f0e16090$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $fec67976f0e16090$var$y;
    }
    var c = $fec67976f0e16090$var$y;
    $fec67976f0e16090$var$y = b;
    try {
        return a();
    } finally{
        $fec67976f0e16090$var$y = c;
    }
};
$fec67976f0e16090$export$4b844e58a3e414b4 = function() {};
$fec67976f0e16090$export$816d2913ae6b83b1 = function() {};
$fec67976f0e16090$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $fec67976f0e16090$var$y;
    $fec67976f0e16090$var$y = a;
    try {
        return b();
    } finally{
        $fec67976f0e16090$var$y = c;
    }
};
$fec67976f0e16090$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $fec67976f0e16090$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $fec67976f0e16090$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $fec67976f0e16090$var$f($fec67976f0e16090$var$t, a), null === $fec67976f0e16090$var$h($fec67976f0e16090$var$r) && a === $fec67976f0e16090$var$h($fec67976f0e16090$var$t) && ($fec67976f0e16090$var$B ? ($fec67976f0e16090$var$E($fec67976f0e16090$var$L), $fec67976f0e16090$var$L = -1) : $fec67976f0e16090$var$B = !0, $fec67976f0e16090$var$K($fec67976f0e16090$var$H, c - d))) : (a.sortIndex = e, $fec67976f0e16090$var$f($fec67976f0e16090$var$r, a), $fec67976f0e16090$var$A || $fec67976f0e16090$var$z || ($fec67976f0e16090$var$A = !0, $fec67976f0e16090$var$I($fec67976f0e16090$var$J)));
    return a;
};
$fec67976f0e16090$export$b5836b71941fa3ed = $fec67976f0e16090$var$M;
$fec67976f0e16090$export$cf845f2c119da08a = function(a) {
    var b = $fec67976f0e16090$var$y;
    return function() {
        var c = $fec67976f0e16090$var$y;
        $fec67976f0e16090$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $fec67976f0e16090$var$y = c;
        }
    };
};

});




parcelRegister("1ig10", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $0f13e53339adf17f$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $0f13e53339adf17f$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $0f13e53339adf17f$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $0f13e53339adf17f$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $0f13e53339adf17f$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $0f13e53339adf17f$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $0f13e53339adf17f$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $0f13e53339adf17f$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $0f13e53339adf17f$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $0f13e53339adf17f$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $0f13e53339adf17f$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $0f13e53339adf17f$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $0f13e53339adf17f$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $0f13e53339adf17f$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $0f13e53339adf17f$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $0f13e53339adf17f$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $0f13e53339adf17f$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $0f13e53339adf17f$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $0f13e53339adf17f$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $0f13e53339adf17f$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $0f13e53339adf17f$var$_extends() {
    $0f13e53339adf17f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0f13e53339adf17f$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $0f13e53339adf17f$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($0f13e53339adf17f$export$e19cd5f9376f8cee || ($0f13e53339adf17f$export$e19cd5f9376f8cee = {}));
const $0f13e53339adf17f$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $0f13e53339adf17f$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $0f13e53339adf17f$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $0f13e53339adf17f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $0f13e53339adf17f$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $0f13e53339adf17f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to);
    }
    return $0f13e53339adf17f$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $0f13e53339adf17f$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $0f13e53339adf17f$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $0f13e53339adf17f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $0f13e53339adf17f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $0f13e53339adf17f$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $0f13e53339adf17f$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $0f13e53339adf17f$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $0f13e53339adf17f$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $0f13e53339adf17f$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $0f13e53339adf17f$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $0f13e53339adf17f$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $0f13e53339adf17f$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $0f13e53339adf17f$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $0f13e53339adf17f$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $0f13e53339adf17f$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($0f13e53339adf17f$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
        let location = $0f13e53339adf17f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $0f13e53339adf17f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
        let location = $0f13e53339adf17f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $0f13e53339adf17f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $0f13e53339adf17f$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($0f13e53339adf17f$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($0f13e53339adf17f$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $0f13e53339adf17f$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($0f13e53339adf17f$var$ResultType || ($0f13e53339adf17f$var$ResultType = {}));
const $0f13e53339adf17f$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $0f13e53339adf17f$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $0f13e53339adf17f$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $0f13e53339adf17f$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $0f13e53339adf17f$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($0f13e53339adf17f$var$isIndexRoute(route)) {
            let indexRoute = $0f13e53339adf17f$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $0f13e53339adf17f$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $0f13e53339adf17f$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $0f13e53339adf17f$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $0f13e53339adf17f$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $0f13e53339adf17f$var$flattenRoutes(routes);
    $0f13e53339adf17f$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $0f13e53339adf17f$var$decodePath(pathname);
        matches = $0f13e53339adf17f$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $0f13e53339adf17f$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $0f13e53339adf17f$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $0f13e53339adf17f$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $0f13e53339adf17f$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $0f13e53339adf17f$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $0f13e53339adf17f$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $0f13e53339adf17f$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $0f13e53339adf17f$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $0f13e53339adf17f$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $0f13e53339adf17f$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $0f13e53339adf17f$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $0f13e53339adf17f$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $0f13e53339adf17f$var$paramRe = /^:[\w-]+$/;
const $0f13e53339adf17f$var$dynamicSegmentValue = 3;
const $0f13e53339adf17f$var$indexRouteValue = 2;
const $0f13e53339adf17f$var$emptySegmentValue = 1;
const $0f13e53339adf17f$var$staticSegmentValue = 10;
const $0f13e53339adf17f$var$splatPenalty = -2;
const $0f13e53339adf17f$var$isSplat = (s)=>s === "*";
function $0f13e53339adf17f$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($0f13e53339adf17f$var$isSplat)) initialScore += $0f13e53339adf17f$var$splatPenalty;
    if (index) initialScore += $0f13e53339adf17f$var$indexRouteValue;
    return segments.filter((s)=>!$0f13e53339adf17f$var$isSplat(s)).reduce((score, segment)=>score + ($0f13e53339adf17f$var$paramRe.test(segment) ? $0f13e53339adf17f$var$dynamicSegmentValue : segment === "" ? $0f13e53339adf17f$var$emptySegmentValue : $0f13e53339adf17f$var$staticSegmentValue), initialScore);
}
function $0f13e53339adf17f$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $0f13e53339adf17f$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $0f13e53339adf17f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $0f13e53339adf17f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $0f13e53339adf17f$export$a5c6d149b50c1d86($0f13e53339adf17f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $0f13e53339adf17f$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $0f13e53339adf17f$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $0f13e53339adf17f$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $0f13e53339adf17f$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $0f13e53339adf17f$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $0f13e53339adf17f$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $0f13e53339adf17f$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $0f13e53339adf17f$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $0f13e53339adf17f$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $0f13e53339adf17f$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $0f13e53339adf17f$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $0f13e53339adf17f$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $0f13e53339adf17f$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $0f13e53339adf17f$var$normalizeSearch(search),
        hash: $0f13e53339adf17f$var$normalizeHash(hash)
    };
}
function $0f13e53339adf17f$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $0f13e53339adf17f$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $0f13e53339adf17f$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $0f13e53339adf17f$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $0f13e53339adf17f$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $0f13e53339adf17f$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $0f13e53339adf17f$export$8ccf933b0513f8d0(toArg);
    else {
        to = $0f13e53339adf17f$var$_extends({}, toArg);
        $0f13e53339adf17f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $0f13e53339adf17f$var$getInvalidPathError("?", "pathname", "search", to));
        $0f13e53339adf17f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $0f13e53339adf17f$var$getInvalidPathError("#", "pathname", "hash", to));
        $0f13e53339adf17f$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $0f13e53339adf17f$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $0f13e53339adf17f$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $0f13e53339adf17f$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $0f13e53339adf17f$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $0f13e53339adf17f$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $0f13e53339adf17f$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $0f13e53339adf17f$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $0f13e53339adf17f$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $0f13e53339adf17f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $0f13e53339adf17f$export$42a99a7a4bc0e76a extends Error {
}
class $0f13e53339adf17f$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $0f13e53339adf17f$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $0f13e53339adf17f$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $0f13e53339adf17f$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $0f13e53339adf17f$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $0f13e53339adf17f$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $0f13e53339adf17f$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $0f13e53339adf17f$var$unwrapTrackedPromise(value) {
    if (!$0f13e53339adf17f$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $0f13e53339adf17f$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $0f13e53339adf17f$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $0f13e53339adf17f$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $0f13e53339adf17f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $0f13e53339adf17f$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $0f13e53339adf17f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $0f13e53339adf17f$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $0f13e53339adf17f$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $0f13e53339adf17f$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $0f13e53339adf17f$var$validMutationMethods = new Set($0f13e53339adf17f$var$validMutationMethodsArr);
const $0f13e53339adf17f$var$validRequestMethodsArr = [
    "get",
    ...$0f13e53339adf17f$var$validMutationMethodsArr
];
const $0f13e53339adf17f$var$validRequestMethods = new Set($0f13e53339adf17f$var$validRequestMethodsArr);
const $0f13e53339adf17f$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $0f13e53339adf17f$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $0f13e53339adf17f$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $0f13e53339adf17f$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $0f13e53339adf17f$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $0f13e53339adf17f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $0f13e53339adf17f$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $0f13e53339adf17f$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $0f13e53339adf17f$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $0f13e53339adf17f$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $0f13e53339adf17f$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $0f13e53339adf17f$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $0f13e53339adf17f$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $0f13e53339adf17f$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $0f13e53339adf17f$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $0f13e53339adf17f$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $0f13e53339adf17f$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $0f13e53339adf17f$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $0f13e53339adf17f$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$0f13e53339adf17f$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($0f13e53339adf17f$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $0f13e53339adf17f$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $0f13e53339adf17f$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $0f13e53339adf17f$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $0f13e53339adf17f$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $0f13e53339adf17f$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($0f13e53339adf17f$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $0f13e53339adf17f$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $0f13e53339adf17f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $0f13e53339adf17f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $0f13e53339adf17f$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $0f13e53339adf17f$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $0f13e53339adf17f$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $0f13e53339adf17f$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $0f13e53339adf17f$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $0f13e53339adf17f$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $0f13e53339adf17f$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$0f13e53339adf17f$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $0f13e53339adf17f$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $0f13e53339adf17f$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $0f13e53339adf17f$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $0f13e53339adf17f$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $0f13e53339adf17f$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $0f13e53339adf17f$var$ResultType.error,
            error: $0f13e53339adf17f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $0f13e53339adf17f$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($0f13e53339adf17f$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($0f13e53339adf17f$var$isDeferredResult(result)) throw $0f13e53339adf17f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $0f13e53339adf17f$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $0f13e53339adf17f$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $0f13e53339adf17f$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $0f13e53339adf17f$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $0f13e53339adf17f$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($0f13e53339adf17f$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $0f13e53339adf17f$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $0f13e53339adf17f$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $0f13e53339adf17f$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $0f13e53339adf17f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $0f13e53339adf17f$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $0f13e53339adf17f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $0f13e53339adf17f$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $0f13e53339adf17f$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $0f13e53339adf17f$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $0f13e53339adf17f$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $0f13e53339adf17f$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($0f13e53339adf17f$var$isRedirectResult(actionResult) || $0f13e53339adf17f$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($0f13e53339adf17f$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $0f13e53339adf17f$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($0f13e53339adf17f$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($0f13e53339adf17f$var$isDeferredResult(actionResult)) throw $0f13e53339adf17f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $0f13e53339adf17f$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $0f13e53339adf17f$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $0f13e53339adf17f$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $0f13e53339adf17f$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $0f13e53339adf17f$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $0f13e53339adf17f$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $0f13e53339adf17f$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $0f13e53339adf17f$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $0f13e53339adf17f$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $0f13e53339adf17f$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $0f13e53339adf17f$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $0f13e53339adf17f$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $0f13e53339adf17f$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($0f13e53339adf17f$var$isDeferredResult(result)) result = await $0f13e53339adf17f$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($0f13e53339adf17f$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $0f13e53339adf17f$export$3e9cee6b33872309(!$0f13e53339adf17f$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $0f13e53339adf17f$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $0f13e53339adf17f$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($0f13e53339adf17f$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $0f13e53339adf17f$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace : $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $0f13e53339adf17f$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($0f13e53339adf17f$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $0f13e53339adf17f$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $0f13e53339adf17f$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $0f13e53339adf17f$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$0f13e53339adf17f$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $0f13e53339adf17f$var$callLoaderOrAction("loader", $0f13e53339adf17f$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $0f13e53339adf17f$var$ResultType.error,
                        error: $0f13e53339adf17f$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $0f13e53339adf17f$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $0f13e53339adf17f$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $0f13e53339adf17f$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $0f13e53339adf17f$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $0f13e53339adf17f$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $0f13e53339adf17f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $0f13e53339adf17f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $0f13e53339adf17f$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $0f13e53339adf17f$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $0f13e53339adf17f$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $0f13e53339adf17f$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $0f13e53339adf17f$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$0f13e53339adf17f$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $0f13e53339adf17f$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $0f13e53339adf17f$export$4d0306f8f6a4585b = Symbol("deferred");
function $0f13e53339adf17f$export$3336b097a6fbc59a(routes, opts) {
    $0f13e53339adf17f$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $0f13e53339adf17f$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $0f13e53339adf17f$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $0f13e53339adf17f$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $0f13e53339adf17f$var$createLocation("", $0f13e53339adf17f$export$fe53371bee54353d(url), null, "default");
        let matches = $0f13e53339adf17f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$0f13e53339adf17f$var$isValidMethod(method) && method !== "HEAD") {
            let error = $0f13e53339adf17f$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($0f13e53339adf17f$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $0f13e53339adf17f$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $0f13e53339adf17f$var$createLocation("", $0f13e53339adf17f$export$fe53371bee54353d(url), null, "default");
        let matches = $0f13e53339adf17f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$0f13e53339adf17f$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $0f13e53339adf17f$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $0f13e53339adf17f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $0f13e53339adf17f$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $0f13e53339adf17f$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $0f13e53339adf17f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($0f13e53339adf17f$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$0f13e53339adf17f$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $0f13e53339adf17f$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($0f13e53339adf17f$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $0f13e53339adf17f$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $0f13e53339adf17f$var$isResponse(result) ? result : $0f13e53339adf17f$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($0f13e53339adf17f$var$isQueryRouteResponse(e)) {
                if (e.type === $0f13e53339adf17f$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($0f13e53339adf17f$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $0f13e53339adf17f$var$ResultType.error,
                error: error
            };
        } else {
            result = await $0f13e53339adf17f$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $0f13e53339adf17f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($0f13e53339adf17f$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($0f13e53339adf17f$var$isDeferredResult(result)) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $0f13e53339adf17f$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($0f13e53339adf17f$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $0f13e53339adf17f$var$_extends({}, context, {
                statusCode: $0f13e53339adf17f$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $0f13e53339adf17f$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $0f13e53339adf17f$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $0f13e53339adf17f$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $0f13e53339adf17f$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $0f13e53339adf17f$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$0f13e53339adf17f$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $0f13e53339adf17f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $0f13e53339adf17f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $0f13e53339adf17f$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $0f13e53339adf17f$export$fec11da027c70692(routes, context, error) {
    let newContext = $0f13e53339adf17f$var$_extends({}, context, {
        statusCode: $0f13e53339adf17f$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $0f13e53339adf17f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $0f13e53339adf17f$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $0f13e53339adf17f$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $0f13e53339adf17f$export$cae722b0cc860f13(to ? to : ".", $0f13e53339adf17f$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $0f13e53339adf17f$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$0f13e53339adf17f$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $0f13e53339adf17f$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $0f13e53339adf17f$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $0f13e53339adf17f$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$0f13e53339adf17f$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$0f13e53339adf17f$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $0f13e53339adf17f$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $0f13e53339adf17f$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $0f13e53339adf17f$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$0f13e53339adf17f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$0f13e53339adf17f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $0f13e53339adf17f$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $0f13e53339adf17f$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $0f13e53339adf17f$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $0f13e53339adf17f$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $0f13e53339adf17f$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($0f13e53339adf17f$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $0f13e53339adf17f$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $0f13e53339adf17f$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $0f13e53339adf17f$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $0f13e53339adf17f$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $0f13e53339adf17f$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $0f13e53339adf17f$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($0f13e53339adf17f$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $0f13e53339adf17f$var$shouldRevalidateLoader(match, $0f13e53339adf17f$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $0f13e53339adf17f$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $0f13e53339adf17f$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $0f13e53339adf17f$var$shouldRevalidateLoader(fetcherMatch, $0f13e53339adf17f$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $0f13e53339adf17f$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $0f13e53339adf17f$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $0f13e53339adf17f$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $0f13e53339adf17f$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $0f13e53339adf17f$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $0f13e53339adf17f$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$0f13e53339adf17f$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $0f13e53339adf17f$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $0f13e53339adf17f$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $0f13e53339adf17f$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $0f13e53339adf17f$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $0f13e53339adf17f$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $0f13e53339adf17f$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $0f13e53339adf17f$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $0f13e53339adf17f$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $0f13e53339adf17f$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($0f13e53339adf17f$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($0f13e53339adf17f$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $0f13e53339adf17f$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$0f13e53339adf17f$var$ABSOLUTE_URL_REGEX.test(location)) location = $0f13e53339adf17f$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $0f13e53339adf17f$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $0f13e53339adf17f$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $0f13e53339adf17f$var$ResultType.error ? $0f13e53339adf17f$var$ResultType.error : $0f13e53339adf17f$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $0f13e53339adf17f$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $0f13e53339adf17f$var$ResultType.error) return {
            type: resultType,
            error: new $0f13e53339adf17f$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $0f13e53339adf17f$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $0f13e53339adf17f$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($0f13e53339adf17f$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $0f13e53339adf17f$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $0f13e53339adf17f$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $0f13e53339adf17f$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($0f13e53339adf17f$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $0f13e53339adf17f$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $0f13e53339adf17f$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $0f13e53339adf17f$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $0f13e53339adf17f$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $0f13e53339adf17f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $0f13e53339adf17f$export$3e9cee6b33872309(!$0f13e53339adf17f$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $0f13e53339adf17f$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($0f13e53339adf17f$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $0f13e53339adf17f$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $0f13e53339adf17f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $0f13e53339adf17f$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($0f13e53339adf17f$var$isErrorResult(result)) {
            let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $0f13e53339adf17f$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($0f13e53339adf17f$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $0f13e53339adf17f$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($0f13e53339adf17f$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $0f13e53339adf17f$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $0f13e53339adf17f$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $0f13e53339adf17f$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $0f13e53339adf17f$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $0f13e53339adf17f$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $0f13e53339adf17f$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $0f13e53339adf17f$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $0f13e53339adf17f$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $0f13e53339adf17f$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($0f13e53339adf17f$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $0f13e53339adf17f$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(path) : path;
    return $0f13e53339adf17f$export$fe53371bee54353d($0f13e53339adf17f$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $0f13e53339adf17f$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $0f13e53339adf17f$var$isDeferredResult(result) {
    return result.type === $0f13e53339adf17f$var$ResultType.deferred;
}
function $0f13e53339adf17f$var$isErrorResult(result) {
    return result.type === $0f13e53339adf17f$var$ResultType.error;
}
function $0f13e53339adf17f$var$isRedirectResult(result) {
    return (result && result.type) === $0f13e53339adf17f$var$ResultType.redirect;
}
function $0f13e53339adf17f$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $0f13e53339adf17f$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $0f13e53339adf17f$var$isRedirectResponse(result) {
    if (!$0f13e53339adf17f$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $0f13e53339adf17f$var$isQueryRouteResponse(obj) {
    return obj && $0f13e53339adf17f$var$isResponse(obj.response) && (obj.type === $0f13e53339adf17f$var$ResultType.data || obj.type === $0f13e53339adf17f$var$ResultType.error);
}
function $0f13e53339adf17f$var$isValidMethod(method) {
    return $0f13e53339adf17f$var$validRequestMethods.has(method.toLowerCase());
}
function $0f13e53339adf17f$var$isMutationMethod(method) {
    return $0f13e53339adf17f$var$validMutationMethods.has(method.toLowerCase());
}
async function $0f13e53339adf17f$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$0f13e53339adf17f$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($0f13e53339adf17f$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $0f13e53339adf17f$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $0f13e53339adf17f$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $0f13e53339adf17f$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $0f13e53339adf17f$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $0f13e53339adf17f$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $0f13e53339adf17f$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $0f13e53339adf17f$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $0f13e53339adf17f$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $0f13e53339adf17f$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $0f13e53339adf17f$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $0f13e53339adf17f$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $0f13e53339adf17f$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $0f13e53339adf17f$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $0f13e53339adf17f$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $0f13e53339adf17f$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $0f13e53339adf17f$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $0f13e53339adf17f$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($0f13e53339adf17f$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $0f13e53339adf17f$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($0f13e53339adf17f$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $0f13e53339adf17f$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("18Pjr", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $0d4e57672a3dc010$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $0d4e57672a3dc010$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $0d4e57672a3dc010$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $0d4e57672a3dc010$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $0d4e57672a3dc010$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $0d4e57672a3dc010$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $0d4e57672a3dc010$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $0d4e57672a3dc010$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $0d4e57672a3dc010$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $0d4e57672a3dc010$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $0d4e57672a3dc010$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $0d4e57672a3dc010$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $0d4e57672a3dc010$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $0d4e57672a3dc010$export$b273b3273281a049; });
$parcel$export(module.exports, "Router", function () { return $0d4e57672a3dc010$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Outlet", function () { return $0d4e57672a3dc010$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $0d4e57672a3dc010$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $0d4e57672a3dc010$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $0d4e57672a3dc010$export$52b333d321859367; });
/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eeH7J = parcelRequire("eeH7J");

var $1ig10 = parcelRequire("1ig10");
function $0d4e57672a3dc010$var$_extends() {
    $0d4e57672a3dc010$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0d4e57672a3dc010$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $0d4e57672a3dc010$export$3add0d5dce533e2e = /*#__PURE__*/ $eeH7J.createContext(null);
const $0d4e57672a3dc010$export$145dfa71566a64dc = /*#__PURE__*/ $eeH7J.createContext(null);
const $0d4e57672a3dc010$var$AwaitContext = /*#__PURE__*/ $eeH7J.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $0d4e57672a3dc010$export$26749e8557646306 = /*#__PURE__*/ $eeH7J.createContext(null);
const $0d4e57672a3dc010$export$c7914228fb69b0f5 = /*#__PURE__*/ $eeH7J.createContext(null);
const $0d4e57672a3dc010$export$9072aa6dd1f93057 = /*#__PURE__*/ $eeH7J.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $0d4e57672a3dc010$var$RouteErrorContext = /*#__PURE__*/ $eeH7J.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $0d4e57672a3dc010$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $0d4e57672a3dc010$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1ig10.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $0d4e57672a3dc010$export$9c954a9d03d32f4a() {
    return $eeH7J.useContext($0d4e57672a3dc010$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $0d4e57672a3dc010$export$45d76561a5302f2b() {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    return $eeH7J.useContext($0d4e57672a3dc010$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $0d4e57672a3dc010$export$1b3f31771c5d07c() {
    return $eeH7J.useContext($0d4e57672a3dc010$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $0d4e57672a3dc010$export$6c330e8992e8a295(pattern) {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    let { pathname: pathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    return $eeH7J.useMemo(()=>(0, $1ig10.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $0d4e57672a3dc010$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $0d4e57672a3dc010$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eeH7J.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $0d4e57672a3dc010$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $0d4e57672a3dc010$var$useNavigateStable() : $0d4e57672a3dc010$var$useNavigateUnstable();
}
function $0d4e57672a3dc010$var$useNavigateUnstable() {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    let dataRouterContext = $eeH7J.useContext($0d4e57672a3dc010$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ig10.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $eeH7J.useRef(false);
    $0d4e57672a3dc010$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eeH7J.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1ig10.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ig10.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $0d4e57672a3dc010$var$OutletContext = /*#__PURE__*/ $eeH7J.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $0d4e57672a3dc010$export$4138103a3ae699cc() {
    return $eeH7J.useContext($0d4e57672a3dc010$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $0d4e57672a3dc010$export$a3be3530d8e40d0b(context) {
    let outlet = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $0d4e57672a3dc010$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $0d4e57672a3dc010$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ig10.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $eeH7J.useMemo(()=>(0, $1ig10.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $0d4e57672a3dc010$export$5d3fca4a98652595(routes, locationArg) {
    return $0d4e57672a3dc010$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $0d4e57672a3dc010$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    let { navigator: navigator } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { matches: parentMatches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1ig10.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1ig10.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1ig10.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $0d4e57672a3dc010$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1ig10.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1ig10.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $0d4e57672a3dc010$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1ig10.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $0d4e57672a3dc010$var$DefaultErrorComponent() {
    let error = $0d4e57672a3dc010$export$ed527bf60f6e05f2();
    let message = (0, $1ig10.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eeH7J.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eeH7J.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $0d4e57672a3dc010$var$defaultErrorElement = /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$DefaultErrorComponent, null);
class $0d4e57672a3dc010$var$RenderErrorBoundary extends $eeH7J.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $0d4e57672a3dc010$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eeH7J.useContext($0d4e57672a3dc010$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $0d4e57672a3dc010$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1ig10.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $0d4e57672a3dc010$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $0d4e57672a3dc010$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eeH7J.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $0d4e57672a3dc010$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($0d4e57672a3dc010$var$DataRouterHook || {});
var $0d4e57672a3dc010$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($0d4e57672a3dc010$var$DataRouterStateHook || {});
function $0d4e57672a3dc010$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0d4e57672a3dc010$var$useDataRouterContext(hookName) {
    let ctx = $eeH7J.useContext($0d4e57672a3dc010$export$3add0d5dce533e2e);
    !ctx && (0, $1ig10.UNSAFE_invariant)(false);
    return ctx;
}
function $0d4e57672a3dc010$var$useDataRouterState(hookName) {
    let state = $eeH7J.useContext($0d4e57672a3dc010$export$145dfa71566a64dc);
    !state && (0, $1ig10.UNSAFE_invariant)(false);
    return state;
}
function $0d4e57672a3dc010$var$useRouteContext(hookName) {
    let route = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    !route && (0, $1ig10.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $0d4e57672a3dc010$var$useCurrentRouteId(hookName) {
    let route = $0d4e57672a3dc010$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1ig10.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $0d4e57672a3dc010$export$5fc8298006ad9e58() {
    return $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $0d4e57672a3dc010$export$d0fd4b7106de2769() {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $0d4e57672a3dc010$export$600dc272ed516c15() {
    let dataRouterContext = $0d4e57672a3dc010$var$useDataRouterContext($0d4e57672a3dc010$var$DataRouterHook.UseRevalidator);
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseRevalidator);
    return $eeH7J.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $0d4e57672a3dc010$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseMatches);
    return $eeH7J.useMemo(()=>matches.map((m)=>(0, $1ig10.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $0d4e57672a3dc010$export$1448a5050d252c4d() {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseLoaderData);
    let routeId = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $0d4e57672a3dc010$export$fd5d37484eab868d(routeId) {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $0d4e57672a3dc010$export$fdc00f3f26066d5e() {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseActionData);
    let routeId = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $0d4e57672a3dc010$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eeH7J.useContext($0d4e57672a3dc010$var$RouteErrorContext);
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteError);
    let routeId = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $0d4e57672a3dc010$export$78a72ddb39bdd145() {
    let value = $eeH7J.useContext($0d4e57672a3dc010$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $0d4e57672a3dc010$export$17f53340677d5831() {
    let value = $eeH7J.useContext($0d4e57672a3dc010$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $0d4e57672a3dc010$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $0d4e57672a3dc010$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $0d4e57672a3dc010$var$useDataRouterContext($0d4e57672a3dc010$var$DataRouterHook.UseBlocker);
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $eeH7J.useState("");
    let blockerFunction = $eeH7J.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $0d4e57672a3dc010$var$_extends({}, currentLocation, {
                pathname: (0, $1ig10.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $0d4e57672a3dc010$var$_extends({}, nextLocation, {
                pathname: (0, $1ig10.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eeH7J.useEffect(()=>{
        let key = String(++$0d4e57672a3dc010$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eeH7J.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1ig10.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $0d4e57672a3dc010$var$useNavigateStable() {
    let { router: router } = $0d4e57672a3dc010$var$useDataRouterContext($0d4e57672a3dc010$var$DataRouterHook.UseNavigateStable);
    let id = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $eeH7J.useRef(false);
    $0d4e57672a3dc010$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eeH7J.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $0d4e57672a3dc010$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $0d4e57672a3dc010$var$alreadyWarned = {};
function $0d4e57672a3dc010$var$warningOnce(key, cond, message) {
    if (!cond && !$0d4e57672a3dc010$var$alreadyWarned[key]) $0d4e57672a3dc010$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0d4e57672a3dc010$var$START_TRANSITION = "startTransition";
const $0d4e57672a3dc010$var$startTransitionImpl = $eeH7J[$0d4e57672a3dc010$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0d4e57672a3dc010$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eeH7J.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        if (v7_startTransition && $0d4e57672a3dc010$var$startTransitionImpl) $0d4e57672a3dc010$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eeH7J.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eeH7J.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eeH7J.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eeH7J.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $0d4e57672a3dc010$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $0d4e57672a3dc010$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $0d4e57672a3dc010$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $eeH7J.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ig10.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $0d4e57672a3dc010$var$startTransitionImpl ? $0d4e57672a3dc010$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $0d4e57672a3dc010$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let navigate = $0d4e57672a3dc010$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1ig10.resolveTo)(to, (0, $1ig10.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eeH7J.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $0d4e57672a3dc010$export$910ae8079b2c2852(props) {
    return $0d4e57672a3dc010$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $0d4e57672a3dc010$export$e7b0ac011bb776c6(_props) {
    (0, $1ig10.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $0d4e57672a3dc010$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1ig10.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eeH7J.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $0d4e57672a3dc010$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1ig10.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eeH7J.useMemo(()=>{
        let trailingPathname = (0, $1ig10.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $0d4e57672a3dc010$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $0d4e57672a3dc010$export$5d3fca4a98652595($0d4e57672a3dc010$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $0d4e57672a3dc010$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$ResolveAwait, null, children));
}
var $0d4e57672a3dc010$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($0d4e57672a3dc010$var$AwaitRenderStatus || {});
const $0d4e57672a3dc010$var$neverSettledPromise = new Promise(()=>{});
class $0d4e57672a3dc010$var$AwaitErrorBoundary extends $eeH7J.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $0d4e57672a3dc010$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $0d4e57672a3dc010$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $0d4e57672a3dc010$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $0d4e57672a3dc010$var$AwaitRenderStatus.error : promise._data !== undefined ? $0d4e57672a3dc010$var$AwaitRenderStatus.success : $0d4e57672a3dc010$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $0d4e57672a3dc010$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.error && promise._error instanceof (0, $1ig10.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $0d4e57672a3dc010$var$neverSettledPromise;
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $0d4e57672a3dc010$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $0d4e57672a3dc010$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $0d4e57672a3dc010$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eeH7J.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eeH7J.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eeH7J.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $0d4e57672a3dc010$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $0d4e57672a3dc010$export$e7b0ac011bb776c6) && (0, $1ig10.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $1ig10.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $0d4e57672a3dc010$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $0d4e57672a3dc010$export$daf73786167a7f72(matches) {
    return $0d4e57672a3dc010$var$_renderMatches(matches);
}
function $0d4e57672a3dc010$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $eeH7J.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $eeH7J.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $eeH7J.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $0d4e57672a3dc010$export$f30f7e456d254e83(routes, opts) {
    return (0, $1ig10.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0d4e57672a3dc010$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ig10.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $0d4e57672a3dc010$export$52b333d321859367
    }).initialize();
}

});


parcelRegister("4DHNO", function(module, exports) {

$parcel$export(module.exports, "Login", function () { return $360cc831837a6621$export$21a94553ffa41578; });
$parcel$export(module.exports, "login", function () { return $360cc831837a6621$export$596d806903d1f59e; });
$parcel$export(module.exports, "logout", function () { return $360cc831837a6621$export$a0973bcfe11b05c9; });

var $4vwom = parcelRequire("4vwom");

var $lDBHC = parcelRequire("lDBHC");

var $eeH7J = parcelRequire("eeH7J");

var $8jB4x = parcelRequire("8jB4x");

var $18Pjr = parcelRequire("18Pjr");

var $cNfXq = parcelRequire("cNfXq");
parcelRequire("dbwyW");
var $dAwef = parcelRequire("dAwef");
const $360cc831837a6621$var$LoginContext = /*#__PURE__*/ (0, $eeH7J.createContext)({
    isLoggedIn: false
});
function $360cc831837a6621$export$79c3258edc7d1573() {
    return (0, $eeH7J.useContext)($360cc831837a6621$var$LoginContext).isLoggedIn;
}
function $360cc831837a6621$var$parseJwt(token) {
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        return JSON.parse(jsonPayload);
    } catch (_a) {
        return {};
    }
}
/** If we got an error from the auth callback, it is set here so it is
 * immediately visible to the error handler below, so we avoid infinite retry
 * loops. */ let $360cc831837a6621$var$callbackError;
let $360cc831837a6621$var$clearTokens;
function $360cc831837a6621$export$21a94553ffa41578(props) {
    const [expiry, setExpiry] = (0, $eeH7J.useState)(undefined);
    const [isLoggedIn, setIsLoggedIn] = (0, $eeH7J.useState)(false);
    $360cc831837a6621$var$useLogin(props.always, (token)=>{
        props.tokenReady(token);
        const exp = $360cc831837a6621$var$parseJwt(token).exp;
        if (expiry !== exp) setExpiry(exp);
        if (isLoggedIn === false) setIsLoggedIn(true);
    });
    $360cc831837a6621$var$clearTokens = props.clearTokens;
    (0, $eeH7J.useEffect)(()=>{
        const handler = async (e)=>{
            var _a, _b;
            // If we got a low-level error from the auth callback - don't handle
            // it. This is e.g. unverified email address.
            if ($360cc831837a6621$var$callbackError) return {
                handled: false
            };
            if (e.status === 401) {
                if (expiry) {
                    if (expiry < Date.now() / 1000) {
                        if (await $360cc831837a6621$var$hiddenTokenRefresh()) return {
                            handled: true,
                            retry: true
                        };
                        else alert("Your login session has expired and cannot be restored.\n\nClick OK to log in again.");
                    }
                }
                setExpiry(undefined);
                setIsLoggedIn(false);
                const defaultReturnTo = typeof window === "undefined" ? "/" : `${window.location.pathname}${window.location.search}`;
                if (props.login) await props.login($360cc831837a6621$export$596d806903d1f59e, (_a = props.returnTo) !== null && _a !== void 0 ? _a : defaultReturnTo, e);
                else $360cc831837a6621$export$596d806903d1f59e((_b = props.returnTo) !== null && _b !== void 0 ? _b : defaultReturnTo);
                return {
                    handled: true
                };
            }
            return {
                handled: false
            };
        };
        /** Catch all 401's and send us to the login page */ (0, $8jB4x.SSRHook).errorHandlers.push(handler);
        return ()=>{
            (0, $8jB4x.SSRHook).errorHandlers.splice((0, $8jB4x.SSRHook).errorHandlers.indexOf(handler), 1);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expiry,
        props.returnTo
    ]);
    if ($360cc831837a6621$var$callbackError) {
        if (props.errorDisplay) return props.errorDisplay($360cc831837a6621$var$callbackError);
        return (0, $4vwom.jsxs)("div", {
            style: {
                padding: 32
            },
            children: [
                (0, $4vwom.jsx)("h1", {
                    children: "Authentication error"
                }),
                (0, $4vwom.jsx)("p", {
                    children: $360cc831837a6621$var$callbackError
                })
            ]
        });
    }
    return (0, $4vwom.jsx)($360cc831837a6621$var$LoginContext.Provider, {
        value: {
            isLoggedIn: isLoggedIn
        },
        children: props.children
    });
}
let $360cc831837a6621$var$_tokenReady;
/** When used in a component, it indicates that the component and its subtree may be dependent on
 *  login to function.
 *
 *  The hook stores the access token in local storage, so a session can persist across page reloads.
 */ function $360cc831837a6621$var$useLogin(/** Whether to always log in eagerly, or only log in when a 401 is detected. */ always, /** Callback you receive when a new access token is available.
 *  This would be a good place to set the `Authorization` header on your API calls, e.g.
 * ```
 *  import { defaults } from "./client" // The client generated by Reactor
 *
 *  defaults.headers["Authorization"] = `Bearer ${access_token}`
 * ```
 */ tokenReady) {
    if ((0, $lDBHC.IsNode)()) throw new Error("useLogin should not be called on the server");
    $360cc831837a6621$var$_tokenReady = tokenReady;
    try {
        const { access_token: access_token, state: state } = $360cc831837a6621$var$getAuthCallback();
        if (access_token) {
            tokenReady(access_token);
            localStorage.setItem("Authorization", access_token);
            // If we are a hidden child iframe, send the hash to the parent window
            if (window.parent !== window) window.parent.postMessage({
                type: "hash",
                hash: window.location.hash
            }, "*");
            $360cc831837a6621$var$consumeHash(state);
        }
        const token = localStorage.getItem("Authorization");
        if (token) {
            const { exp: exp } = $360cc831837a6621$var$parseJwt(token);
            if (exp > Date.now() / 1000) {
                tokenReady(token);
                return;
            } else if (!exp) {
                // We probably have a demo auth token, or other token that doesn't expire
                // so we'll just use it. If it fails, we will get a 401 and log in again.
                tokenReady(token);
                return;
            } else localStorage.removeItem("Authorization");
        }
        if (always) $360cc831837a6621$export$596d806903d1f59e();
    } catch (e) {
        if (e instanceof Error) $360cc831837a6621$var$callbackError = e.message;
    }
}
function $360cc831837a6621$var$consumeHash(state) {
    if (!state) return;
    const authCallback = localStorage.getItem("authState");
    if (!authCallback) throw new Error("No auth callback state");
    const { key: key, returnTo: returnTo } = JSON.parse(authCallback);
    if (key !== state) throw new Error("Invalid auth callback state");
    window.location.replace(window.location.origin + (returnTo !== null && returnTo !== void 0 ? returnTo : window.location.pathname));
}
function $360cc831837a6621$var$getAuthCallback() {
    if ((0, $lDBHC.IsNode)()) return {};
    return $360cc831837a6621$var$parseHash(window.location.hash);
}
function $360cc831837a6621$var$parseHash(hash) {
    var _a, _b, _c, _d, _e, _f, _g;
    const hashKeys = hash.slice(1).split("&").map((x)=>x.split("=")).map((x)=>({
            key: x[0],
            value: x[1]
        }));
    if (hashKeys.find((x)=>x.key === "error")) {
        const errorDescription = (_a = hashKeys.find((x)=>x.key === "error_description")) === null || _a === void 0 ? void 0 : _a.value;
        throw new Error(errorDescription ? decodeURIComponent(errorDescription) : "Unknown error");
    }
    const id_token = (_b = hashKeys.find((x)=>x.key === "id_token")) === null || _b === void 0 ? void 0 : _b.value;
    if (id_token) {
        const { nonce: nonce } = $360cc831837a6621$var$parseJwt(id_token);
        const id = localStorage.getItem("authNonce");
        if (nonce !== id) throw new Error("Invalid id_token nonce");
        localStorage.setItem("id_token", id_token);
    }
    return {
        access_token: (_c = hashKeys.find((x)=>x.key === "access_token")) === null || _c === void 0 ? void 0 : _c.value,
        id_token: id_token,
        scope: (_d = hashKeys.find((x)=>x.key === "scope")) === null || _d === void 0 ? void 0 : _d.value,
        expires_in: (_e = hashKeys.find((x)=>x.key === "expires_in")) === null || _e === void 0 ? void 0 : _e.value,
        token_type: (_f = hashKeys.find((x)=>x.key === "token_type")) === null || _f === void 0 ? void 0 : _f.value,
        state: (_g = hashKeys.find((x)=>x.key === "state")) === null || _g === void 0 ? void 0 : _g.value
    };
}
function $360cc831837a6621$var$whenAuthReady(callback) {
    // In the SSR happy path, the authConfig should be synchronously available
    const auth = typeof authConfig !== "undefined" ? authConfig : undefined;
    if (auth) callback(auth);
    else (0, $cNfXq.whenReflectionReady)((ref)=>{
        authConfig = ref.model.authConfig;
        callback(authConfig);
    });
}
function $360cc831837a6621$export$596d806903d1f59e(returnTo = "/") {
    $360cc831837a6621$var$whenAuthReady((auth)=>{
        const url = $360cc831837a6621$var$makeAuthUrl(auth, returnTo);
        window.location.replace(url);
    });
}
function $360cc831837a6621$export$a0973bcfe11b05c9(returnTo) {
    $360cc831837a6621$var$whenAuthReady((auth)=>{
        const id_token = localStorage.getItem("id_token");
        localStorage.removeItem("id_token");
        localStorage.removeItem("Authorization");
        if ($360cc831837a6621$var$clearTokens !== undefined) $360cc831837a6621$var$clearTokens();
        if (auth === "studio-auth") {
            window.location.replace("/");
            return;
        }
        const endSessionEndpoint = auth.endSessionEndpoint ? auth.endSessionEndpoint : `https://${auth.domain}/v2/logout`;
        const url = `${endSessionEndpoint}?${[
            `client_id=${auth.clientId}`,
            `id_token_hint=${id_token}`,
            `post_logout_redirect_uri=${encodeURIComponent(window.location.origin + returnTo)}`
        ].join("&")}`;
        window.location.replace(url);
    });
}
function $360cc831837a6621$var$hiddenTokenRefresh() {
    return new Promise((resolve)=>{
        let resolved = false;
        const iframe = document.createElement("iframe");
        function listener(event) {
            if (event.data) try {
                if (event.data.type === "hash") {
                    const { access_token: access_token } = $360cc831837a6621$var$parseHash(event.data.hash);
                    if (access_token) {
                        $360cc831837a6621$var$_tokenReady(access_token);
                        localStorage.setItem("Authorization", access_token);
                        window.removeEventListener("message", listener);
                        if (!resolved) {
                            resolved = true;
                            document.body.removeChild(iframe);
                            resolve(true);
                        }
                        return;
                    }
                }
            } catch (e) {}
        }
        window.addEventListener("message", listener);
        $360cc831837a6621$var$whenAuthReady((auth)=>{
            iframe.setAttribute("src", $360cc831837a6621$var$makeAuthUrl(auth, "/"));
            iframe.style.display = "hidden";
            document.body.appendChild(iframe);
            // If we don't receive a callback in reasonable time, assume the refresh failed
            setTimeout(()=>{
                if (!resolved) {
                    document.body.removeChild(iframe);
                    resolved = true;
                    resolve(false);
                }
            }, 10000);
        });
    });
}
function $360cc831837a6621$var$makeAuthUrl(auth, returnTo = "/") {
    if (auth === "studio-auth") return "/login?redirect=" + encodeURIComponent(window.location.pathname);
    const key = (0, $dAwef.Uuid)();
    localStorage.setItem("authState", JSON.stringify({
        key: key,
        returnTo: window.location.pathname
    }));
    const nonce = (0, $dAwef.Uuid)();
    localStorage.setItem("authNonce", nonce.valueOf());
    const authorizationEndpoint = auth.authorizationEndpoint ? auth.authorizationEndpoint : `https://${auth.domain}/authorize`;
    return `${authorizationEndpoint}?${[
        `response_type=id_token token`,
        `client_id=${auth.clientId}`,
        `redirect_uri=${encodeURIComponent(window.location.origin + returnTo)}`,
        `scope=openid email`,
        `state=${key}`,
        `audience=${encodeURIComponent(auth.audience)}`,
        `nonce=${nonce}`
    ].join("&")}`;
}
function $360cc831837a6621$export$b389d8ae4cb5c835(props) {
    return (0, $4vwom.jsx)((0, $18Pjr.Route), {
        path: `${props.path}/:token`,
        element: (0, $4vwom.jsx)($360cc831837a6621$var$LoginLinkPage, {
            redirectUrl: props.redirectUrl
        })
    });
}
function $360cc831837a6621$var$LoginLinkPage(props) {
    const token = (0, $18Pjr.useParams)().token;
    if (!token) return (0, $4vwom.jsx)("div", {
        children: "Invalid token"
    });
    if (!(0, $lDBHC.IsNode)()) {
        localStorage.setItem("Authorization", token);
        $360cc831837a6621$var$_tokenReady(token);
        window.location.pathname = props.redirectUrl;
    }
    return (0, $4vwom.jsx)("div", {
        children: "Authenticating..."
    });
}

});
parcelRegister("lDBHC", function(module, exports) {

$parcel$export(module.exports, "IsNode", function () { return $fc0a7c701e6faca7$export$3c2e381ecfd10bd9; });

var $2IVpK = parcelRequire("2IVpK");
const $fc0a7c701e6faca7$var$isNode = !!(typeof $2IVpK === "object" && typeof $2IVpK.versions === "object" && $2IVpK.versions.node);
function $fc0a7c701e6faca7$export$3c2e381ecfd10bd9() {
    return $fc0a7c701e6faca7$var$isNode;
}
function $fc0a7c701e6faca7$export$28bab5e896b9506e() {
    if (!$fc0a7c701e6faca7$export$3c2e381ecfd10bd9()) throw new Error("This code is only meant for a Node.js environment. Did you accidentally import it?");
}

});
parcelRegister("2IVpK", function(module, exports) {
// shim for using process in browser
var $1fbc3a1ae3c79101$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $1fbc3a1ae3c79101$var$cachedSetTimeout;
var $1fbc3a1ae3c79101$var$cachedClearTimeout;
function $1fbc3a1ae3c79101$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $1fbc3a1ae3c79101$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $1fbc3a1ae3c79101$var$cachedSetTimeout = setTimeout;
        else $1fbc3a1ae3c79101$var$cachedSetTimeout = $1fbc3a1ae3c79101$var$defaultSetTimout;
    } catch (e) {
        $1fbc3a1ae3c79101$var$cachedSetTimeout = $1fbc3a1ae3c79101$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $1fbc3a1ae3c79101$var$cachedClearTimeout = clearTimeout;
        else $1fbc3a1ae3c79101$var$cachedClearTimeout = $1fbc3a1ae3c79101$var$defaultClearTimeout;
    } catch (e) {
        $1fbc3a1ae3c79101$var$cachedClearTimeout = $1fbc3a1ae3c79101$var$defaultClearTimeout;
    }
})();
function $1fbc3a1ae3c79101$var$runTimeout(fun) {
    if ($1fbc3a1ae3c79101$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($1fbc3a1ae3c79101$var$cachedSetTimeout === $1fbc3a1ae3c79101$var$defaultSetTimout || !$1fbc3a1ae3c79101$var$cachedSetTimeout) && setTimeout) {
        $1fbc3a1ae3c79101$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $1fbc3a1ae3c79101$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $1fbc3a1ae3c79101$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $1fbc3a1ae3c79101$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $1fbc3a1ae3c79101$var$runClearTimeout(marker) {
    if ($1fbc3a1ae3c79101$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($1fbc3a1ae3c79101$var$cachedClearTimeout === $1fbc3a1ae3c79101$var$defaultClearTimeout || !$1fbc3a1ae3c79101$var$cachedClearTimeout) && clearTimeout) {
        $1fbc3a1ae3c79101$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $1fbc3a1ae3c79101$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $1fbc3a1ae3c79101$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $1fbc3a1ae3c79101$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $1fbc3a1ae3c79101$var$queue = [];
var $1fbc3a1ae3c79101$var$draining = false;
var $1fbc3a1ae3c79101$var$currentQueue;
var $1fbc3a1ae3c79101$var$queueIndex = -1;
function $1fbc3a1ae3c79101$var$cleanUpNextTick() {
    if (!$1fbc3a1ae3c79101$var$draining || !$1fbc3a1ae3c79101$var$currentQueue) return;
    $1fbc3a1ae3c79101$var$draining = false;
    if ($1fbc3a1ae3c79101$var$currentQueue.length) $1fbc3a1ae3c79101$var$queue = $1fbc3a1ae3c79101$var$currentQueue.concat($1fbc3a1ae3c79101$var$queue);
    else $1fbc3a1ae3c79101$var$queueIndex = -1;
    if ($1fbc3a1ae3c79101$var$queue.length) $1fbc3a1ae3c79101$var$drainQueue();
}
function $1fbc3a1ae3c79101$var$drainQueue() {
    if ($1fbc3a1ae3c79101$var$draining) return;
    var timeout = $1fbc3a1ae3c79101$var$runTimeout($1fbc3a1ae3c79101$var$cleanUpNextTick);
    $1fbc3a1ae3c79101$var$draining = true;
    var len = $1fbc3a1ae3c79101$var$queue.length;
    while(len){
        $1fbc3a1ae3c79101$var$currentQueue = $1fbc3a1ae3c79101$var$queue;
        $1fbc3a1ae3c79101$var$queue = [];
        while(++$1fbc3a1ae3c79101$var$queueIndex < len)if ($1fbc3a1ae3c79101$var$currentQueue) $1fbc3a1ae3c79101$var$currentQueue[$1fbc3a1ae3c79101$var$queueIndex].run();
        $1fbc3a1ae3c79101$var$queueIndex = -1;
        len = $1fbc3a1ae3c79101$var$queue.length;
    }
    $1fbc3a1ae3c79101$var$currentQueue = null;
    $1fbc3a1ae3c79101$var$draining = false;
    $1fbc3a1ae3c79101$var$runClearTimeout(timeout);
}
$1fbc3a1ae3c79101$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $1fbc3a1ae3c79101$var$queue.push(new $1fbc3a1ae3c79101$var$Item(fun, args));
    if ($1fbc3a1ae3c79101$var$queue.length === 1 && !$1fbc3a1ae3c79101$var$draining) $1fbc3a1ae3c79101$var$runTimeout($1fbc3a1ae3c79101$var$drainQueue);
};
// v8 likes predictible objects
function $1fbc3a1ae3c79101$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$1fbc3a1ae3c79101$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$1fbc3a1ae3c79101$var$process.title = "browser";
$1fbc3a1ae3c79101$var$process.browser = true;
$1fbc3a1ae3c79101$var$process.env = {};
$1fbc3a1ae3c79101$var$process.argv = [];
$1fbc3a1ae3c79101$var$process.version = ""; // empty string to avoid regexp issues
$1fbc3a1ae3c79101$var$process.versions = {};
function $1fbc3a1ae3c79101$var$noop() {}
$1fbc3a1ae3c79101$var$process.on = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.addListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.once = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.off = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.removeListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.removeAllListeners = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.emit = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.prependListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.prependOnceListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.listeners = function(name) {
    return [];
};
$1fbc3a1ae3c79101$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$1fbc3a1ae3c79101$var$process.cwd = function() {
    return "/";
};
$1fbc3a1ae3c79101$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$1fbc3a1ae3c79101$var$process.umask = function() {
    return 0;
};

});


parcelRegister("8jB4x", function(module, exports) {

$parcel$export(module.exports, "useDataFrom", function () { return $60dcdada2782d151$export$87b9d1c66cb4ea2d; });
$parcel$export(module.exports, "SSRHook", function () { return $60dcdada2782d151$export$f02391734a1b9120; });
/* eslint-disable react-hooks/rules-of-hooks */ 
var $eeH7J = parcelRequire("eeH7J");

var $lDBHC = parcelRequire("lDBHC");

var $3SKqX = parcelRequire("3SKqX");

var $5JGam = parcelRequire("5JGam");

var $knIBr = parcelRequire("knIBr");
function $60dcdada2782d151$export$87b9d1c66cb4ea2d(hook) {
    const [data, setData] = (0, $eeH7J.useState)(undefined);
    (0, $eeH7J.useEffect)(()=>{
        const listener = (response, args)=>{
            setData({
                args: args,
                response: response
            });
        };
        hook.addDataListener(listener);
        return ()=>hook.removeDataListener(listener);
    }, [
        hook
    ]);
    return data;
}
globalThis.ssrEndpoints = (0, $lDBHC.IsNode)() ? {} : null;

function $60dcdada2782d151$export$f02391734a1b9120(/** Name of the server side getter-function this hook maps to */ funcName, /** Name of the DTO type that this hook GETs. */ dtoName, /** Name of the DTO type that this hook PUTs.
 *
 *  This limits what properties from the GET DTO will be displayed as
 *  editable in WYSIWYG editors. Only properties that are present in both
 *  the PUT and GET DTOs will be editable.
 */ putDtoName, /** The client side getter function */ getter, /** The names of the arguments to the getter function. */ argNames, /** A function that saves the resource back to its origin. If provided, the resource will be
 * editable. */ putter) {
    const listeners = [];
    /** Returns the inputs that we are still waiting for in order for the hook
     *  to be able to resolve its data.
     *
     *  If `null` is passed for any of the arguments, this indicates the hook is
     *  waiting for an input to become available and should not evaluate yet. We
     *  still need to call all of the React hooks to get the same number of
     *  hooks per render.
     **/ function getWaitingForInputs(args) {
        return args.map((a, i)=>i).filter((i)=>args[i] === null).map((i)=>argNames[i]);
    }
    /** Returns the SSR results on the client side */ function clientSideResolve(query) {
        var _a, _b, _c;
        return {
            data: "ssrResults" in globalThis && ssrResults && ((_a = ssrResults[query]) === null || _a === void 0 ? void 0 : _a.result) || undefined,
            needsAuthenticatedRefresh: "ssrResults" in globalThis && ssrResults && ((_b = ssrResults[query]) === null || _b === void 0 ? void 0 : _b.needsAuthenticatedRefresh) ? true : false,
            error: "ssrResults" in globalThis && ssrResults && ((_c = ssrResults[query]) === null || _c === void 0 ? void 0 : _c.error) || undefined
        };
    }
    /** Resolves the SSR results on the server side. On the client side, this
     * returns `undefined`. */ function serverSideResolve(waitingForInputs, args) {
        if (ssrEndpoints && !(funcName in ssrEndpoints)) {
            $60dcdada2782d151$var$needsAuthenticatedRefresh = true;
            // Not an SSR-compatible endpoint, try again when authenticated
            return {
                data: undefined,
                originalData: undefined,
                error: {
                    type: "Unauthorized",
                    status: 401
                },
                loading: false,
                needsAuthenticatedRefresh: true,
                // Dummy, refresh not possible in SSR mode
                refresh: ()=>Promise.resolve()
            };
        }
        if (ssrEndpoints && ssrEndpoints[funcName] && ssrTransaction && ssrTransaction.current) {
            const query = JSON.stringify({
                name: funcName,
                args: args
            });
            if (waitingForInputs.length) return {
                waitingForInputs: waitingForInputs,
                data: undefined,
                loading: false,
                originalData: undefined,
                refresh: async ()=>{}
            };
            const existingError = query in ssrTransaction.current ? ssrTransaction.current[query].error : undefined;
            if (existingError) return {
                data: undefined,
                originalData: undefined,
                error: existingError,
                loading: false,
                // Dummy, refresh not possible in SSR mode
                refresh: ()=>Promise.resolve()
            };
            const existingPromise = query in ssrTransaction.current ? ssrTransaction.current[query] : undefined;
            const existingResult = existingPromise === null || existingPromise === void 0 ? void 0 : existingPromise.result;
            if (existingResult) return {
                data: existingResult,
                originalData: existingResult,
                loading: false,
                // Dummy, refresh not possible in SSR mode
                refresh: ()=>Promise.resolve()
            };
            if (existingPromise) return {
                data: undefined,
                originalData: undefined,
                loading: true,
                // Dummy, refresh not possible in SSR mode
                refresh: ()=>Promise.resolve()
            };
            try {
                $60dcdada2782d151$var$needsAuthenticatedRefresh = false;
                const promise = ssrEndpoints[funcName](...args);
                let synchronousCrash;
                if (typeof promise === "object" && "catch" in promise) {
                    // We got an asynchronous result - wait for it
                    promise.catch((e)=>{
                        synchronousCrash = e;
                    });
                    ssrTransaction.current[query] = {
                        promise: promise,
                        needsAuthenticatedRefresh: $60dcdada2782d151$var$needsAuthenticatedRefresh ? true : undefined
                    };
                } else {
                    // We got a synchronous result - hooraay!
                    ssrTransaction.current[query] = {
                        result: promise,
                        needsAuthenticatedRefresh: $60dcdada2782d151$var$needsAuthenticatedRefresh ? true : undefined
                    };
                    return {
                        data: promise,
                        originalData: promise,
                        loading: false,
                        // Dummy, refresh not possible in SSR mode
                        refresh: ()=>Promise.resolve()
                    };
                }
                if (synchronousCrash) return {
                    data: undefined,
                    originalData: undefined,
                    error: synchronousCrash,
                    loading: false,
                    // Dummy, refresh not possible in SSR mode
                    refresh: ()=>Promise.resolve()
                };
                return {
                    data: undefined,
                    originalData: undefined,
                    loading: true,
                    // Dummy, refresh not possible in SSR mode
                    refresh: ()=>Promise.resolve()
                };
            } catch (e) {
                // Failed synchronously
                return {
                    data: undefined,
                    originalData: undefined,
                    error: e,
                    loading: false,
                    // Dummy, refresh not possible in SSR mode
                    refresh: ()=>Promise.resolve()
                };
            }
        }
    }
    function hook(...args) {
        var _a;
        const waitingForInputs = getWaitingForInputs(args);
        // Shortcut for fetching data on the server as part of SSR
        const serverSideResult = serverSideResolve(waitingForInputs, args);
        if (serverSideResult) return serverSideResult;
        const query = (0, $eeH7J.useMemo)(()=>JSON.stringify({
                name: funcName,
                args: args
            }), [
            funcName,
            ...args
        ]);
        const ssr = clientSideResolve(query);
        const firstRender = (0, $eeH7J.useRef)(true);
        const [version, setVersion] = (0, $eeH7J.useState)({});
        const [originalData, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(ssr.data || undefined);
        const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(ssr.error || undefined);
        const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(originalData === undefined);
        if (error) console.error(`Error while fetching ${funcName}(${args.join(", ")}):`, error);
        const [yEditor, setYEditor] = (0, $eeH7J.useState)(undefined);
        const currentResource = {
            query: query,
            endpoint: funcName,
            data: yEditor ? yEditor.proxy : originalData,
            dtoName: dtoName !== null && dtoName !== void 0 ? dtoName : "unknown",
            putDtoName: putDtoName
        };
        const resource = (0, $eeH7J.useRef)(currentResource);
        Object.assign(resource.current, currentResource);
        const isEditing = (0, $eeH7J.useContext)((0, $5JGam.IsEditingContext));
        const refresh = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useCallback(async ()=>{
            if (waitingForInputs.length) return;
            setLoading(true);
            try {
                const d = await getter(...args);
                listeners.forEach((l)=>l(d, args));
                setData(d);
                setError(undefined);
                setLoading(false);
            } catch (e) {
                // No need to handle errors or retry here, since this is handled
                // internally in the `getter` function.
                const problem = typeof e === "object" && "type" in e ? e : {
                    type: "Unknown",
                    error: e
                };
                setError(problem);
                setLoading(false);
            }
        }, [
            query
        ]);
        const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useCallback(async (type)=>{
            if (type === "change") await (yEditor === null || yEditor === void 0 ? void 0 : yEditor.fetchUpdates());
            if (type === "discard" || type === "save") await refresh();
        }, [
            yEditor,
            refresh
        ]);
        const selectionContext = (0, $eeH7J.useContext)((0, $knIBr.SelectionContext));
        if (putter) {
            const argList = JSON.stringify(args);
            (0, $3SKqX.useChangeNotifications)(funcName, argList, "draft", onChange, isEditing);
            (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useEffect(()=>{
                if (waitingForInputs.length) return;
                function invalidate() {
                    setVersion({});
                }
                function reset() {
                    // In case the selection was inside the editor that was
                    // reset, we need to clear it
                    selectionContext === null || selectionContext === void 0 || selectionContext.clearSelectedObject();
                }
                let ye;
                async function initEditor() {
                    if (!originalData) return;
                    if (isEditing) {
                        const { YEditor: YEditor } = await (parcelRequire("hafxL"));
                        ye = new YEditor(funcName, argList, "draft", dtoName !== null && dtoName !== void 0 ? dtoName : "unknown", putDtoName, invalidate, reset);
                        const originalDiscard = ye.discardChanges;
                        ye.discardChanges = async ()=>{
                            await originalDiscard();
                            reset();
                        };
                        await ye.initInteractive(originalData);
                        setYEditor(ye);
                    } else {
                        yEditor === null || yEditor === void 0 || yEditor.destroy();
                        ye = undefined;
                        setYEditor(undefined);
                    }
                }
                if (isEditing) initEditor();
                return ()=>{
                    ye === null || ye === void 0 || ye.destroy();
                    ye = undefined;
                };
            }, [
                originalData,
                isEditing,
                argList,
                funcName,
                waitingForInputs.length
            ]);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useEffect(()=>{
            if ((ssr.error || ssr.data) && firstRender.current) {
                // No need to fetch, we have SSR data
                firstRender.current = false;
                if (ssr.needsAuthenticatedRefresh) // The SSR data needs to be refreshed with an authenticated request
                refresh();
                return;
            }
            refresh();
        }, [
            query
        ]);
        if (waitingForInputs.length) // While waiting for inputs, we should not display any data, even if
        // we have some data cached from a previously valid set of inputs.
        // Displaying cached data that are not based on the current inputs
        // is potentially erroneous and hazardous, since the state being
        // displayed would now be inconsistent. This could mislead the user
        // into making wrong actions in the UI.
        //
        // This manifested in bugs like #1533.
        //
        return {
            data: undefined,
            originalData: undefined,
            error: error,
            loading: false,
            waitingForInputs: waitingForInputs,
            refresh: refresh
        };
        const waitingForAuthenticatedRefresh = ssr.needsAuthenticatedRefresh && firstRender.current;
        return {
            data: (_a = yEditor === null || yEditor === void 0 ? void 0 : yEditor.proxy) !== null && _a !== void 0 ? _a : originalData,
            originalData: originalData,
            error: waitingForAuthenticatedRefresh ? undefined : error,
            loading: waitingForAuthenticatedRefresh || loading,
            refresh: refresh
        };
    }
    hook.addDataListener = (listener)=>{
        listeners.push(listener);
    };
    hook.removeDataListener = (listener)=>{
        const index = listeners.indexOf(listener);
        if (index >= 0) listeners.splice(index, 1);
    };
    return hook;
}
let $60dcdada2782d151$var$needsAuthenticatedRefresh = false;
/** If called from an endpoint, it indicates that an endpoint that was read
 * during SSR will require an authenticated refresh from the client side to
 * produce the correct result. This allows the page to render the rest of its
 * content (that does not require authentication.)  */ $60dcdada2782d151$export$f02391734a1b9120.requireAuthenticatedRefresh = function() {
    $60dcdada2782d151$var$needsAuthenticatedRefresh = true;
};
$60dcdada2782d151$export$f02391734a1b9120.errorHandlers = [];
/** Handles an error from a failed fetch(). This is used by generated clients.
 *
 *  This will invoke the registered error handlers in turn to see if any of them can handle the
 *  error. If so, the error may trigger some side effect, such as refreshing the access token.
 *
 *
 *
 *  Regardless of whether the error is handled or not, it will typically throw the error, but may
 *  also (in the future) return a valid response provided by one of the handlers.
 */ $60dcdada2782d151$export$f02391734a1b9120.handleError = async (res)=>{
    const contentType = res.headers.get("Content-Type");
    if (contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/problem+json")) {
        const problem = await res.json();
        for (const handler of $60dcdada2782d151$export$f02391734a1b9120.errorHandlers){
            const handledResponse = await handler(problem);
            if (handledResponse.retry) return handledResponse;
            if (handledResponse.handled) break;
        }
        throw problem;
    }
    throw new Error("Unhandled fetch error");
};
/** A registry of all the generated client endpoints. */ $60dcdada2782d151$export$f02391734a1b9120.clientEndpoints = [];

});
parcelRegister("3SKqX", function(module, exports) {

$parcel$export(module.exports, "WebSocketContext", function () { return $2d3a6f0aa124c997$export$c6437728a0fc8cc2; });
$parcel$export(module.exports, "WebSocketContextProvider", function () { return $2d3a6f0aa124c997$export$fdc07ca4b6d6eb42; });
$parcel$export(module.exports, "useChangeNotifications", function () { return $2d3a6f0aa124c997$export$5f82016abe5cb42; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $dAwef = parcelRequire("dAwef");

var $8h5s0 = parcelRequire("8h5s0");

var $3Ixuz = parcelRequire("3Ixuz");
const $2d3a6f0aa124c997$export$c6437728a0fc8cc2 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
let $2d3a6f0aa124c997$var$reconnectBackoff = 0.25;

function $2d3a6f0aa124c997$export$fdc07ca4b6d6eb42({ children: children }) {
    const [connectionKey, setConnectionKey] = (0, $eeH7J.useState)((0, $dAwef.Uuid)());
    const [status, setStatus] = (0, $eeH7J.useState)("disconnected");
    const [subscribers] = (0, $eeH7J.useState)([]);
    const socketPromise = (0, $eeH7J.useRef)(undefined);
    const [socket, setSocket] = (0, $eeH7J.useState)(undefined);
    function onMessage({ data: data }) {
        const msg = JSON.parse(data.toString());
        if (typeof msg === "object" && "changed" in msg) {
            const type = (0, $3Ixuz.IsResourceNotificationType)(msg.type) ? msg.type : "change";
            for (const { res: res, key: key, onChanged: onChanged } of subscribers)if (msg.changed === res && (key === undefined || msg.key === key)) onChanged(type);
        }
    }
    function onClose() {
        this.removeEventListener("open", onOpen);
        this.removeEventListener("message", onMessage);
        this.removeEventListener("close", onClose);
        this.removeEventListener("error", onClose);
        setConnectionKey(undefined);
        reconnectWithBackoff();
    }
    function reconnectWithBackoff() {
        socketPromise.current = undefined;
        setSocket(undefined);
        // automatically reconnect, with exponential backoff
        setTimeout(connect, $2d3a6f0aa124c997$var$reconnectBackoff);
        $2d3a6f0aa124c997$var$reconnectBackoff = Math.min($2d3a6f0aa124c997$var$reconnectBackoff * 2, 3000);
    }
    function onOpen() {
        var _a;
        this.addEventListener("message", onMessage);
        this.addEventListener("close", onClose);
        (_a = socketPromise.current) === null || _a === void 0 || _a.resolve(this);
        this.send(JSON.stringify({
            clientId: $2d3a6f0aa124c997$export$5f82016abe5cb42.clientId
        }));
        setSocket(this);
        setStatus("connected");
        setConnectionKey((old)=>{
            if (old) return old;
            return (0, $dAwef.Uuid)();
        });
    }
    const connect = (0, $eeH7J.useCallback)(async ()=>{
        if (socketPromise.current) return await socketPromise.current.socket;
        let resolve;
        const promise = new Promise((r)=>{
            resolve = r;
        });
        socketPromise.current = {
            socket: promise,
            resolve: (0, $8h5s0.Assert)(resolve)
        };
        setStatus("connecting");
        const { getWebSocketTicketForStudioUser: getWebSocketTicketForStudioUser } = await Promise.resolve((parcelRequire("dUDPg")));
        try {
            const ticket = await getWebSocketTicketForStudioUser();
            const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
            const host = window.location.hostname;
            let port = window.location.port;
            if (port === "3001") port = "3000";
            const newSocket = new WebSocket(`${proto}//${host}:${port}/api/studio/documents/changed?ticket=${ticket.ticket}`);
            if (newSocket.readyState !== newSocket.OPEN) newSocket.addEventListener("open", onOpen);
            else onOpen.call(newSocket);
        } catch (e) {
            reconnectWithBackoff();
            return promise;
        }
        return promise;
    }, []);
    const addSubscriber = (0, $eeH7J.useCallback)(async (s)=>{
        subscribers.push(s);
        const socket = await connect();
        socket.send(JSON.stringify({
            subscribe: s.res,
            key: s.key,
            layer: s.layer
        }));
    }, [
        connect,
        subscribers
    ]);
    const removeSubscriber = (0, $eeH7J.useCallback)(async (s)=>{
        const idx = subscribers.indexOf(s);
        if (idx !== -1) subscribers.splice(idx, 1);
        const socket = await connect();
        socket.send(JSON.stringify({
            unsubscribe: s.res,
            key: s.key,
            layer: s.layer
        }));
    }, [
        connect,
        subscribers
    ]);
    const context = (0, $eeH7J.useMemo)(()=>({
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber,
            status: status,
            connectionKey: connectionKey
        }), [
        addSubscriber,
        removeSubscriber,
        status,
        connectionKey
    ]);
    // Ping the server every 30 seconds to keep the connection alive
    (0, $eeH7J.useEffect)(()=>{
        if (!socket) return;
        const pingInterval = setInterval(()=>{
            if (socket.readyState === socket.OPEN) socket.send(JSON.stringify({
                ping: true
            }));
        }, 30000);
        return ()=>clearInterval(pingInterval);
    }, [
        socket
    ]);
    return (0, $4vwom.jsx)($2d3a6f0aa124c997$export$c6437728a0fc8cc2.Provider, {
        value: context,
        children: children
    });
}
function $2d3a6f0aa124c997$export$5f82016abe5cb42(resource, /**
 * The key to listen for changes in. If not provided, the entire
 * resource will be listened to.
 *
 * For collections, this is the primary key of the item.
 *
 * For endpoints, this is the stringified arguments to the endpoint.
 */ key, /**
 * The layer to listen for changes in. If not provided, the base layer
 * (commited changes) will be listened to.
 */ layer, onChanged, /** Enables or disables this hook, without changing the number of hooks
 * created in the React render. */ canUseChangeNotifications = true) {
    const wsc = (0, $eeH7J.useContext)($2d3a6f0aa124c997$export$c6437728a0fc8cc2);
    // Listen for Change Stream
    (0, $eeH7J.useEffect)(()=>{
        if (!canUseChangeNotifications) return;
        if (!wsc) throw new Error("WebSocketContext not found " + resource);
        const sub = {
            res: resource,
            key: key,
            layer: layer,
            onChanged: onChanged
        };
        wsc.addSubscriber(sub);
        return ()=>{
            wsc.removeSubscriber(sub);
        };
    }, [
        resource,
        key,
        layer,
        onChanged,
        wsc,
        canUseChangeNotifications
    ]);
}
$2d3a6f0aa124c997$export$5f82016abe5cb42.clientId = (0, $dAwef.Uuid)();

});
parcelRegister("dAwef", function(module, exports) {

$parcel$export(module.exports, "Uuid", function () { return $9e47a31fa2352815$export$246bd50017fc40d5; });
$parcel$export(module.exports, "IsUuidType", function () { return $9e47a31fa2352815$export$13fa69b473ae7bd9; });

var $elTi9 = parcelRequire("elTi9");

var $hcjDr = parcelRequire("hcjDr");

var $5cQqO = parcelRequire("5cQqO");
(0, $5cQqO.TSQFunction)($9e47a31fa2352815$export$246bd50017fc40d5);
function $9e47a31fa2352815$export$246bd50017fc40d5(value) {
    if (value) return value;
    return (0, $elTi9.default)();
}
/**
 * Generates a UUID (v4) from a seed string. This is useful in testing, for
 * generating a UUID deterministically from a string, which in turn e.g. is used
 * for snapshot testing. The generated UUID is guaranteed to be the same for the
 * same seed string.
 *
 * This is NOT suitable for generating UUIDs for production use. UUIDs are meant
 * to be Universally Unique Identifiers, and introducing a seed value
 * contradicts this concept because it would cause the same "random" values to
 * be produced under the same seed.
 *
 */ $9e47a31fa2352815$export$246bd50017fc40d5.fromSeed = (seed)=>{
    const rng = new (0, $hcjDr.default)(seed);
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        const r = rng.next() * 16 | 0;
        const v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/** UUID pattern: 8-4-4-4-12 hexadecimal digits separated by hyphens */ $9e47a31fa2352815$export$246bd50017fc40d5.pattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
/** Checks that the provided string is a valid Uuid, as produced by Uuid().
 *
 *  It must match the pattern in `Uuid.pattern`.
 */ $9e47a31fa2352815$export$246bd50017fc40d5.validate = (value)=>{
    return $9e47a31fa2352815$export$246bd50017fc40d5.pattern.test(value.valueOf());
};
function $9e47a31fa2352815$export$13fa69b473ae7bd9(type) {
    return typeof type === "object" && type.alias === "Uuid";
}

});
parcelRegister("elTi9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a72deaa1b71be5bc$export$2e2bcd8739ae039; });

var $4TGnr = parcelRequire("4TGnr");

var $eO0tT = parcelRequire("eO0tT");

var $hhC3D = parcelRequire("hhC3D");
function $a72deaa1b71be5bc$var$v4(options, buf, offset) {
    if ((0, $4TGnr.default).randomUUID && !buf && !options) return (0, $4TGnr.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $eO0tT.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $hhC3D.unsafeStringify)(rnds);
}
var $a72deaa1b71be5bc$export$2e2bcd8739ae039 = $a72deaa1b71be5bc$var$v4;

});
parcelRegister("4TGnr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $390d2bb43880bed0$export$2e2bcd8739ae039; });
const $390d2bb43880bed0$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $390d2bb43880bed0$export$2e2bcd8739ae039 = {
    randomUUID: $390d2bb43880bed0$var$randomUUID
};

});

parcelRegister("eO0tT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac761bc26cafc6c5$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $ac761bc26cafc6c5$var$getRandomValues;
const $ac761bc26cafc6c5$var$rnds8 = new Uint8Array(16);
function $ac761bc26cafc6c5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ac761bc26cafc6c5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $ac761bc26cafc6c5$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$ac761bc26cafc6c5$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $ac761bc26cafc6c5$var$getRandomValues($ac761bc26cafc6c5$var$rnds8);
}

});

parcelRegister("hhC3D", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $c9518ba92fa242e9$export$8fb373d660548968; });

var $kYtw9 = parcelRequire("kYtw9");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $c9518ba92fa242e9$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$c9518ba92fa242e9$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $c9518ba92fa242e9$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $c9518ba92fa242e9$var$byteToHex[arr[offset + 0]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 1]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 2]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 3]] + "-" + $c9518ba92fa242e9$var$byteToHex[arr[offset + 4]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 5]] + "-" + $c9518ba92fa242e9$var$byteToHex[arr[offset + 6]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 7]] + "-" + $c9518ba92fa242e9$var$byteToHex[arr[offset + 8]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 9]] + "-" + $c9518ba92fa242e9$var$byteToHex[arr[offset + 10]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 11]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 12]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 13]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 14]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 15]];
}
function $c9518ba92fa242e9$var$stringify(arr, offset = 0) {
    const uuid = $c9518ba92fa242e9$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $kYtw9.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $c9518ba92fa242e9$export$2e2bcd8739ae039 = $c9518ba92fa242e9$var$stringify;

});
parcelRegister("kYtw9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4504ed462a60e9d$export$2e2bcd8739ae039; });

var $fdMZd = parcelRequire("fdMZd");
function $f4504ed462a60e9d$var$validate(uuid) {
    return typeof uuid === "string" && (0, $fdMZd.default).test(uuid);
}
var $f4504ed462a60e9d$export$2e2bcd8739ae039 = $f4504ed462a60e9d$var$validate;

});
parcelRegister("fdMZd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b14e1195d6a35c07$export$2e2bcd8739ae039; });
var $b14e1195d6a35c07$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("hcjDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c852c9d043b7a6f7$export$2e2bcd8739ae039; });
var $c852c9d043b7a6f7$var$Prando = /** @class */ function() {
    // ================================================================================================================
    // CONSTRUCTOR ----------------------------------------------------------------------------------------------------
    /**
     * Generate a new Prando pseudo-random number generator.
     *
     * @param seed - A number or string seed that determines which pseudo-random number sequence will be created. Defaults to a random seed based on `Math.random()`.
     */ function Prando(seed) {
        this._value = NaN;
        if (typeof seed === "string") // String seed
        this._seed = this.hashCode(seed);
        else if (typeof seed === "number") // Numeric seed
        this._seed = this.getSafeSeed(seed);
        else // Pseudo-random seed
        this._seed = this.getSafeSeed(Prando.MIN + Math.floor((Prando.MAX - Prando.MIN) * Math.random()));
        this.reset();
    }
    // ================================================================================================================
    // PUBLIC INTERFACE -----------------------------------------------------------------------------------------------
    /**
     * Generates a pseudo-random number between a lower (inclusive) and a higher (exclusive) bounds.
     *
     * @param min - The minimum number that can be randomly generated.
     * @param pseudoMax - The maximum number that can be randomly generated (exclusive).
     * @return The generated pseudo-random number.
     */ Prando.prototype.next = function(min, pseudoMax) {
        if (min === void 0) min = 0;
        if (pseudoMax === void 0) pseudoMax = 1;
        this.recalculate();
        return this.map(this._value, Prando.MIN, Prando.MAX, min, pseudoMax);
    };
    /**
     * Generates a pseudo-random integer number in a range (inclusive).
     *
     * @param min - The minimum number that can be randomly generated.
     * @param max - The maximum number that can be randomly generated.
     * @return The generated pseudo-random number.
     */ Prando.prototype.nextInt = function(min, max) {
        if (min === void 0) min = 10;
        if (max === void 0) max = 100;
        this.recalculate();
        return Math.floor(this.map(this._value, Prando.MIN, Prando.MAX, min, max + 1));
    };
    /**
     * Generates a pseudo-random string sequence of a particular length from a specific character range.
     *
     * Note: keep in mind that creating a random string sequence does not guarantee uniqueness; there is always a
     * 1 in (char_length^string_length) chance of collision. For real unique string ids, always check for
     * pre-existing ids, or employ a robust GUID/UUID generator.
     *
     * @param length - Length of the string to be generated.
     * @param chars - Characters that are used when creating the random string. Defaults to all alphanumeric chars (A-Z, a-z, 0-9).
     * @return The generated string sequence.
     */ Prando.prototype.nextString = function(length, chars) {
        if (length === void 0) length = 16;
        if (chars === void 0) chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var str = "";
        while(str.length < length)str += this.nextChar(chars);
        return str;
    };
    /**
     * Generates a pseudo-random string of 1 character specific character range.
     *
     * @param chars - Characters that are used when creating the random string. Defaults to all alphanumeric chars (A-Z, a-z, 0-9).
     * @return The generated character.
     */ Prando.prototype.nextChar = function(chars) {
        if (chars === void 0) chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        return chars.substr(this.nextInt(0, chars.length - 1), 1);
    };
    /**
     * Picks a pseudo-random item from an array. The array is left unmodified.
     *
     * Note: keep in mind that while the returned item will be random enough, picking one item from the array at a time
     * does not guarantee nor imply that a sequence of random non-repeating items will be picked. If you want to
     * *pick items in a random order* from an array, instead of *pick one random item from an array*, it's best to
     * apply a *shuffle* transformation to the array instead, then read it linearly.
     *
     * @param array - Array of any type containing one or more candidates for random picking.
     * @return An item from the array.
     */ Prando.prototype.nextArrayItem = function(array) {
        return array[this.nextInt(0, array.length - 1)];
    };
    /**
     * Generates a pseudo-random boolean.
     *
     * @return A value of true or false.
     */ Prando.prototype.nextBoolean = function() {
        this.recalculate();
        return this._value > 0.5;
    };
    /**
     * Skips ahead in the sequence of numbers that are being generated. This is equivalent to
     * calling next() a specified number of times, but faster since it doesn't need to map the
     * new random numbers to a range and return it.
     *
     * @param iterations - The number of items to skip ahead.
     */ Prando.prototype.skip = function(iterations) {
        if (iterations === void 0) iterations = 1;
        while(iterations-- > 0)this.recalculate();
    };
    /**
     * Reset the pseudo-random number sequence back to its starting seed. Further calls to next()
     * will then produce the same sequence of numbers it had produced before. This is equivalent to
     * creating a new Prando instance with the same seed as another Prando instance.
     *
     * Example:
     * let rng = new Prando(12345678);
     * console.log(rng.next()); // 0.6177754114889017
     * console.log(rng.next()); // 0.5784605181725837
     * rng.reset();
     * console.log(rng.next()); // 0.6177754114889017 again
     * console.log(rng.next()); // 0.5784605181725837 again
     */ Prando.prototype.reset = function() {
        this._value = this._seed;
    };
    // ================================================================================================================
    // PRIVATE INTERFACE ----------------------------------------------------------------------------------------------
    Prando.prototype.recalculate = function() {
        this._value = this.xorshift(this._value);
    };
    Prando.prototype.xorshift = function(value) {
        // Xorshift*32
        // Based on George Marsaglia's work: http://www.jstatsoft.org/v08/i14/paper
        value ^= value << 13;
        value ^= value >> 17;
        value ^= value << 5;
        return value;
    };
    Prando.prototype.map = function(val, minFrom, maxFrom, minTo, maxTo) {
        return (val - minFrom) / (maxFrom - minFrom) * (maxTo - minTo) + minTo;
    };
    Prando.prototype.hashCode = function(str) {
        var hash = 0;
        if (str) {
            var l = str.length;
            for(var i = 0; i < l; i++){
                hash = (hash << 5) - hash + str.charCodeAt(i);
                hash |= 0;
                hash = this.xorshift(hash);
            }
        }
        return this.getSafeSeed(hash);
    };
    Prando.prototype.getSafeSeed = function(seed) {
        if (seed === 0) return 1;
        return seed;
    };
    Prando.MIN = -2147483648; // Int32 min
    Prando.MAX = 2147483647; // Int32 max
    return Prando;
}();
var $c852c9d043b7a6f7$export$2e2bcd8739ae039 = $c852c9d043b7a6f7$var$Prando;

});

parcelRegister("5cQqO", function(module, exports) {

$parcel$export(module.exports, "TSQFunction", function () { return $3ca6be865b9092ac$export$f3177a28d7587bca; });
/** Registers a function that is available to TSQ queries. */ function $3ca6be865b9092ac$export$f3177a28d7587bca(f) {
    $3ca6be865b9092ac$export$f3177a28d7587bca.functions.push(f);
}
$3ca6be865b9092ac$export$f3177a28d7587bca.functions = [];

});


parcelRegister("8h5s0", function(module, exports) {

$parcel$export(module.exports, "Assert", function () { return $606423a834dbcee1$export$14647bdf767968d3; });
$parcel$export(module.exports, "prettyCamel", function () { return $606423a834dbcee1$export$d0cc5e3b1954404f; });
$parcel$export(module.exports, "capitalizeFirstLetter", function () { return $606423a834dbcee1$export$d07f57595c356899; });
$parcel$export(module.exports, "lowercaseFirstLetter", function () { return $606423a834dbcee1$export$f08459d87829d2ee; });
$parcel$export(module.exports, "GroupBy", function () { return $606423a834dbcee1$export$9abad2bb8d934a7f; });
$parcel$export(module.exports, "ellipsize", function () { return $606423a834dbcee1$export$e03532b139e1514; });
/* eslint-disable no-useless-escape */ 
var $c3m5j = parcelRequire("c3m5j");

var $hcjDr = parcelRequire("hcjDr");

var $5cQqO = parcelRequire("5cQqO");
function $606423a834dbcee1$export$44418d23d2ff779d(func) {
    const code = func.toString();
    const match = code.startsWith("async function") ? /^async\s*function\s*[^\(]*\(\s*([^\)]*)\)/m : /^function\s*[^\(]*\(\s*([^\)]*)\)/m;
    const m = func.toString().replace(/((\/\/.*$)|(\/\*[\s\S]*?\*\/)|(\s))/gm, "").match(match);
    if (!m) return [];
    return m[1].split(/,/).filter((x)=>x.length).map((x)=>x.split("=")[0]); // Remove default values
}
const $606423a834dbcee1$var$whitelistedCamels = [
    "iOS",
    "undefined",
    "null"
];
function $606423a834dbcee1$export$14647bdf767968d3(value, errorMessage) {
    if (value === undefined) throw new Error(errorMessage !== null && errorMessage !== void 0 ? errorMessage : "Unexpected undefined");
    if (value === null) throw new Error(errorMessage !== null && errorMessage !== void 0 ? errorMessage : "Unexpected null");
    return value;
}
function $606423a834dbcee1$export$469e6493debd2244(pascalStr) {
    return pascalStr.replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2") // Handle transition from a group of capital letters to a single capital followed by lowercase
    .replace(/([a-z\d])([A-Z])/g, "$1_$2") // Handle transition from lowercase or digits to uppercase
    .toLowerCase(); // Convert the entire string to lowercase
}
async function $606423a834dbcee1$export$a04bb40c982411b3(arr, mapper) {
    const res = [];
    for(let i = 0; i < arr.length; i++)res.push(await mapper(arr[i], i));
    return res;
}
function $606423a834dbcee1$export$d0cc5e3b1954404f(identifier, capitalizeFirstChar = true, count = 1) {
    if (!(typeof identifier === "string")) return identifier;
    if (identifier.indexOf("_") !== -1) return identifier;
    if (identifier.toUpperCase() === identifier) return identifier;
    if ($606423a834dbcee1$var$whitelistedCamels.some((x)=>x === identifier)) return identifier;
    if (identifier.toLowerCase() === "uuid") return "item";
    identifier = identifier.replace("<", " ");
    identifier = identifier.replace(">", "");
    const parts = $606423a834dbcee1$export$d3ee1fc871530e7e(identifier).map((x, i, arr)=>i === arr.length - 1 && count !== 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($c3m5j)))(x) : x).map((x, i)=>i === 0 && capitalizeFirstChar ? $606423a834dbcee1$export$d07f57595c356899(x) : x.toLocaleLowerCase()).map((x)=>{
        const abb = $606423a834dbcee1$export$d0cc5e3b1954404f.abbreviations.find((p)=>x.toLowerCase() === p.toLowerCase());
        if (abb) return abb;
        return x;
    });
    // Replace "Marketing airline i d" -> "Marketing airline ID"
    $606423a834dbcee1$export$d0cc5e3b1954404f.abbreviations.forEach((p)=>{
        for(let i = 0; i < parts.length - p.length + 1; i++){
            let match = true;
            for(let n = 0; n < p.length; n++)if (parts[i + n].toLowerCase() !== p[n].toLowerCase()) {
                match = false;
                break;
            }
            if (match) {
                parts.splice(i + 1, p.length - 1);
                parts[i] = p;
            }
        }
    });
    // Combine two or more individual characters back to uppercase abbreviation
    for(let i = 0; i < parts.length - 1; i++){
        if (parts[i].length === 1) for(let n = i + 1; n < parts.length; n++){
            if (parts[n].length === 1) {
                parts[i] = (parts[i] + parts[n]).toUpperCase();
                parts[n] = "";
            } else break;
        }
    }
    let res = parts.filter((x)=>!!x).join(" ");
    // Revert ugly spaces inserted after parens
    while(res.indexOf("( ") !== -1)res = res.replace("( ", "(");
    return res;
}
/** List of words that prettyCamel should not abbreviate */ $606423a834dbcee1$export$d0cc5e3b1954404f.abbreviations = [
    "ID",
    "API"
];
function $606423a834dbcee1$export$d3ee1fc871530e7e(identifier) {
    return identifier.split(/(?=[A-Z])/);
}
function $606423a834dbcee1$export$cbadc5a7223772a8(e) {
    throw new Error("Unhandled scenario (assertNever failed)");
}
function $606423a834dbcee1$export$d07f57595c356899(s) {
    if (s.length === 0) return s;
    return s[0].toUpperCase() + s.slice(1);
}
function $606423a834dbcee1$export$f08459d87829d2ee(s) {
    if (s.length === 0) return s;
    return s[0].toLowerCase() + s.slice(1);
}
function $606423a834dbcee1$export$ccdcb77276b6f861(arr) {
    return arr.length > 0 ? arr : undefined;
}
function $606423a834dbcee1$export$bffa455ba8c619a6(arr) {
    const res = [];
    arr.forEach((x)=>x instanceof Array ? x.forEach((y)=>res.push(y)) : res.push(x));
    return res;
}
function $606423a834dbcee1$export$5b8affa63fc6df16(arr, mapper) {
    return $606423a834dbcee1$export$bffa455ba8c619a6(arr.map(mapper));
}
function $606423a834dbcee1$export$534760f50726d5(arr) {
    return arr.reduce((a, b)=>a + b, 0);
}
function $606423a834dbcee1$export$bf78489a3eae0c4f(arr, selector) {
    const groups = new Map();
    arr.forEach((item)=>{
        const key = selector(item);
        if (!groups.has(key)) groups.set(key, []);
        $606423a834dbcee1$export$14647bdf767968d3(groups.get(key)).push(item);
    });
    return groups;
}
(0, $5cQqO.TSQFunction)($606423a834dbcee1$export$9abad2bb8d934a7f);
function $606423a834dbcee1$export$9abad2bb8d934a7f(/** The array of items to group */ arr, /** A function that selects the key of the group an item belongs to. */ selector) {
    return Array.from($606423a834dbcee1$export$bf78489a3eae0c4f(arr, selector)).map((e)=>({
            key: e[0],
            values: e[1]
        }));
}
function $606423a834dbcee1$export$ebbdf76816346a18(map, mapper) {
    const res = new Map();
    for (const [key, value] of map)res.set(key, mapper(value, key));
    return res;
}
function $606423a834dbcee1$export$a9ac1ae12bea2213(map) {
    const keys = Array.from(map.keys()).sort((a, b)=>a - b);
    return new Map(keys.map((key)=>[
            key,
            $606423a834dbcee1$export$14647bdf767968d3(map.get(key))
        ]));
}
function $606423a834dbcee1$export$e03532b139e1514(s, maxLength, ellipsis = "...") {
    if (s === undefined) return undefined;
    if (s.length > maxLength) {
        let i = maxLength - ellipsis.length;
        for(; i >= 0; i--){
            if (s[i] === " ") break;
        }
        if (i === 0) i = maxLength - ellipsis.length;
        return s.slice(0, i) + ellipsis;
    }
    return s;
}
function $606423a834dbcee1$export$8960430cfd85939f(arr, score) {
    if (!arr) return undefined;
    if (arr.length === 0) return undefined;
    let maxItem = arr[0];
    let maxValue = score(arr[0]);
    for(let i = 1; i < arr.length; i++){
        const s = score(arr[i]);
        if (s > maxValue) {
            maxValue = s;
            maxItem = arr[i];
        }
    }
    return maxItem;
}
function $606423a834dbcee1$export$96ec731ed4dcb222(arr, score) {
    if (!arr) return undefined;
    if (arr.length === 0) return undefined;
    let minItem = arr[0];
    let minValue = score(arr[0]);
    for(let i = 1; i < arr.length; i++){
        const s = score(arr[i]);
        if (s < minValue) {
            minValue = s;
            minItem = arr[i];
        }
    }
    return minItem;
}
function $606423a834dbcee1$export$62c3ee984ad46566(a, b) {
    return a.every((x)=>b.some((y)=>x === y)) && b.every((x)=>a.some((y)=>x === y));
}
const $606423a834dbcee1$var$rnd = new (0, $hcjDr.default)(3);
function $606423a834dbcee1$export$2e015b6955893291(arr, ...except) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, no-constant-condition
    while(true){
        const i = Math.floor($606423a834dbcee1$var$rnd.next() * arr.length);
        const it = arr[i];
        if (except.indexOf(it) !== -1) continue;
        return it;
    }
}
function $606423a834dbcee1$export$7efad0a738a24e31(arr, metric) {
    let maxValue = Number.NEGATIVE_INFINITY;
    let maxObj;
    arr.forEach((v)=>{
        const value = metric(v);
        if (value > maxValue) {
            maxValue = value;
            maxObj = v;
        }
    });
    return maxObj;
}
function $606423a834dbcee1$export$ac6c6bc5acd809c3(arr, metric) {
    let minValue = Number.POSITIVE_INFINITY;
    let minObj;
    arr.forEach((v)=>{
        const value = metric(v);
        if (minObj === undefined || value < minValue) {
            minValue = value;
            minObj = v;
        }
    });
    return minObj;
}
function $606423a834dbcee1$export$50c379d260c027b9(stringNumber, fmt = new Intl.NumberFormat()) {
    const thousandSeparator = fmt.format(11111).replace(/\p{Number}/gu, "");
    const decimalSeparator = fmt.format(1.1).replace(/\p{Number}/gu, "");
    return parseFloat(stringNumber.replace(new RegExp("\\" + thousandSeparator, "g"), "").replace(new RegExp("\\" + decimalSeparator), "."));
}
function $606423a834dbcee1$export$d02631cccf789723(fromInclusive, toInclusive, mapper) {
    const res = [];
    for(let i = fromInclusive; i <= toInclusive; i++)res.push(mapper(i));
    return res;
}
function $606423a834dbcee1$export$c3dba0d20b1d59bc(oldObj, newObj) {
    const changedFields = new Set();
    for(const key in newObj)if (JSON.stringify(newObj[key]) !== JSON.stringify(oldObj[key])) changedFields.add(key);
    for(const key in oldObj)if (JSON.stringify(newObj[key]) !== JSON.stringify(oldObj[key])) changedFields.add(key);
    return Array.from(changedFields);
}
function $606423a834dbcee1$export$dff351f039ed48c1(a, b) {
    const setB = new Set(b);
    return a.some((item)=>setB.has(item));
}
function $606423a834dbcee1$export$7c73462e0d25e514(func) {
    const cache = new Map();
    return (t)=>{
        if (cache.has(t)) return $606423a834dbcee1$export$14647bdf767968d3(cache.get(t));
        const res = func(t);
        cache.set(t, res);
        return res;
    };
}
function $606423a834dbcee1$export$a9bc1c069e5ad01e(keys, f) {
    const result = {};
    keys.forEach((key, i)=>{
        result[key] = f(key, i);
    });
    return result;
}
function $606423a834dbcee1$export$7a248539063f2353(items, selector) {
    const seen = new Set();
    return items.filter((item)=>{
        const key = selector(item);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}
function $606423a834dbcee1$export$5e2528d1ad4fe419(arr) {
    return arr.filter((item, index)=>arr.indexOf(item) === index);
}
function $606423a834dbcee1$export$88ac5871230bca78(value) {
    return value !== null && value !== undefined;
}
async function $606423a834dbcee1$export$db13390dd07e8c87(func, defaultValue) {
    try {
        return {
            result: await func(),
            error: null
        };
    } catch (e) {
        return {
            result: defaultValue,
            error: "detail" in e ? e.detail : "message" in e ? e.message : "Error"
        };
    }
}

});
parcelRegister("c3m5j", function(module, exports) {
/* global define */ (function(root, pluralize) {
    // Node.
    module.exports = pluralize();
})(module.exports, function() {
    // Rule storage - pluralize and singularize need to be run sequentially,
    // while other rules can be optimized using an object for instant lookups.
    var pluralRules = [];
    var singularRules = [];
    var uncountables = {};
    var irregularPlurals = {};
    var irregularSingles = {};
    /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */ function sanitizeRule(rule) {
        if (typeof rule === "string") return new RegExp("^" + rule + "$", "i");
        return rule;
    }
    /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */ function restoreCase(word, token) {
        // Tokens are an exact match.
        if (word === token) return token;
        // Lower cased words. E.g. "hello".
        if (word === word.toLowerCase()) return token.toLowerCase();
        // Upper cased words. E.g. "WHISKY".
        if (word === word.toUpperCase()) return token.toUpperCase();
        // Title cased words. E.g. "Title".
        if (word[0] === word[0].toUpperCase()) return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
        // Lower cased words. E.g. "test".
        return token.toLowerCase();
    }
    /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */ function interpolate(str, args) {
        return str.replace(/\$(\d{1,2})/g, function(match, index) {
            return args[index] || "";
        });
    }
    /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */ function replace(word, rule) {
        return word.replace(rule[0], function(match, index) {
            var result = interpolate(rule[1], arguments);
            if (match === "") return restoreCase(word[index - 1], result);
            return restoreCase(match, result);
        });
    }
    /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */ function sanitizeWord(token, word, rules) {
        // Empty string or doesn't need fixing.
        if (!token.length || uncountables.hasOwnProperty(token)) return word;
        var len = rules.length;
        // Iterate over the sanitization rules and use the first one to match.
        while(len--){
            var rule = rules[len];
            if (rule[0].test(word)) return replace(word, rule);
        }
        return word;
    }
    /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */ function replaceWord(replaceMap, keepMap, rules) {
        return function(word) {
            // Get the correct token and case restoration functions.
            var token = word.toLowerCase();
            // Check against the keep object map.
            if (keepMap.hasOwnProperty(token)) return restoreCase(word, token);
            // Check against the replacement map for a direct word replacement.
            if (replaceMap.hasOwnProperty(token)) return restoreCase(word, replaceMap[token]);
            // Run all the rules against the word.
            return sanitizeWord(token, word, rules);
        };
    }
    /**
   * Check if a word is part of the map.
   */ function checkWord(replaceMap, keepMap, rules, bool) {
        return function(word) {
            var token = word.toLowerCase();
            if (keepMap.hasOwnProperty(token)) return true;
            if (replaceMap.hasOwnProperty(token)) return false;
            return sanitizeWord(token, token, rules) === token;
        };
    }
    /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */ function pluralize(word, count, inclusive) {
        var pluralized = count === 1 ? pluralize.singular(word) : pluralize.plural(word);
        return (inclusive ? count + " " : "") + pluralized;
    }
    /**
   * Pluralize a word.
   *
   * @type {Function}
   */ pluralize.plural = replaceWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Check if a word is plural.
   *
   * @type {Function}
   */ pluralize.isPlural = checkWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Singularize a word.
   *
   * @type {Function}
   */ pluralize.singular = replaceWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Check if a word is singular.
   *
   * @type {Function}
   */ pluralize.isSingular = checkWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addPluralRule = function(rule, replacement) {
        pluralRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addSingularRule = function(rule, replacement) {
        singularRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */ pluralize.addUncountableRule = function(word) {
        if (typeof word === "string") {
            uncountables[word.toLowerCase()] = true;
            return;
        }
        // Set singular and plural references for the word.
        pluralize.addPluralRule(word, "$0");
        pluralize.addSingularRule(word, "$0");
    };
    /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */ pluralize.addIrregularRule = function(single, plural) {
        plural = plural.toLowerCase();
        single = single.toLowerCase();
        irregularSingles[single] = plural;
        irregularPlurals[plural] = single;
    };
    /**
   * Irregular rules.
   */ [
        // Pronouns.
        [
            "I",
            "we"
        ],
        [
            "me",
            "us"
        ],
        [
            "he",
            "they"
        ],
        [
            "she",
            "they"
        ],
        [
            "them",
            "them"
        ],
        [
            "myself",
            "ourselves"
        ],
        [
            "yourself",
            "yourselves"
        ],
        [
            "itself",
            "themselves"
        ],
        [
            "herself",
            "themselves"
        ],
        [
            "himself",
            "themselves"
        ],
        [
            "themself",
            "themselves"
        ],
        [
            "is",
            "are"
        ],
        [
            "was",
            "were"
        ],
        [
            "has",
            "have"
        ],
        [
            "this",
            "these"
        ],
        [
            "that",
            "those"
        ],
        // Words ending in with a consonant and `o`.
        [
            "echo",
            "echoes"
        ],
        [
            "dingo",
            "dingoes"
        ],
        [
            "volcano",
            "volcanoes"
        ],
        [
            "tornado",
            "tornadoes"
        ],
        [
            "torpedo",
            "torpedoes"
        ],
        // Ends with `us`.
        [
            "genus",
            "genera"
        ],
        [
            "viscus",
            "viscera"
        ],
        // Ends with `ma`.
        [
            "stigma",
            "stigmata"
        ],
        [
            "stoma",
            "stomata"
        ],
        [
            "dogma",
            "dogmata"
        ],
        [
            "lemma",
            "lemmata"
        ],
        [
            "schema",
            "schemata"
        ],
        [
            "anathema",
            "anathemata"
        ],
        // Other irregular rules.
        [
            "ox",
            "oxen"
        ],
        [
            "axe",
            "axes"
        ],
        [
            "die",
            "dice"
        ],
        [
            "yes",
            "yeses"
        ],
        [
            "foot",
            "feet"
        ],
        [
            "eave",
            "eaves"
        ],
        [
            "goose",
            "geese"
        ],
        [
            "tooth",
            "teeth"
        ],
        [
            "quiz",
            "quizzes"
        ],
        [
            "human",
            "humans"
        ],
        [
            "proof",
            "proofs"
        ],
        [
            "carve",
            "carves"
        ],
        [
            "valve",
            "valves"
        ],
        [
            "looey",
            "looies"
        ],
        [
            "thief",
            "thieves"
        ],
        [
            "groove",
            "grooves"
        ],
        [
            "pickaxe",
            "pickaxes"
        ],
        [
            "passerby",
            "passersby"
        ]
    ].forEach(function(rule) {
        return pluralize.addIrregularRule(rule[0], rule[1]);
    });
    /**
   * Pluralization rules.
   */ [
        [
            /s?$/i,
            "s"
        ],
        [
            /[^\u0000-\u007F]$/i,
            "$0"
        ],
        [
            /([^aeiou]ese)$/i,
            "$1"
        ],
        [
            /(ax|test)is$/i,
            "$1es"
        ],
        [
            /(alias|[^aou]us|t[lm]as|gas|ris)$/i,
            "$1es"
        ],
        [
            /(e[mn]u)s?$/i,
            "$1s"
        ],
        [
            /([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i,
            "$1"
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            "$1i"
        ],
        [
            /(alumn|alg|vertebr)(?:a|ae)$/i,
            "$1ae"
        ],
        [
            /(seraph|cherub)(?:im)?$/i,
            "$1im"
        ],
        [
            /(her|at|gr)o$/i,
            "$1oes"
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i,
            "$1a"
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i,
            "$1a"
        ],
        [
            /sis$/i,
            "ses"
        ],
        [
            /(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i,
            "$1$2ves"
        ],
        [
            /([^aeiouy]|qu)y$/i,
            "$1ies"
        ],
        [
            /([^ch][ieo][ln])ey$/i,
            "$1ies"
        ],
        [
            /(x|ch|ss|sh|zz)$/i,
            "$1es"
        ],
        [
            /(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i,
            "$1ices"
        ],
        [
            /\b((?:tit)?m|l)(?:ice|ouse)$/i,
            "$1ice"
        ],
        [
            /(pe)(?:rson|ople)$/i,
            "$1ople"
        ],
        [
            /(child)(?:ren)?$/i,
            "$1ren"
        ],
        [
            /eaux$/i,
            "$0"
        ],
        [
            /m[ae]n$/i,
            "men"
        ],
        [
            "thou",
            "you"
        ]
    ].forEach(function(rule) {
        return pluralize.addPluralRule(rule[0], rule[1]);
    });
    /**
   * Singularization rules.
   */ [
        [
            /s$/i,
            ""
        ],
        [
            /(ss)$/i,
            "$1"
        ],
        [
            /(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i,
            "$1fe"
        ],
        [
            /(ar|(?:wo|[ae])l|[eo][ao])ves$/i,
            "$1f"
        ],
        [
            /ies$/i,
            "y"
        ],
        [
            /\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i,
            "$1ie"
        ],
        [
            /\b(mon|smil)ies$/i,
            "$1ey"
        ],
        [
            /\b((?:tit)?m|l)ice$/i,
            "$1ouse"
        ],
        [
            /(seraph|cherub)im$/i,
            "$1"
        ],
        [
            /(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i,
            "$1"
        ],
        [
            /(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i,
            "$1sis"
        ],
        [
            /(movie|twelve|abuse|e[mn]u)s$/i,
            "$1"
        ],
        [
            /(test)(?:is|es)$/i,
            "$1is"
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            "$1us"
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i,
            "$1um"
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i,
            "$1on"
        ],
        [
            /(alumn|alg|vertebr)ae$/i,
            "$1a"
        ],
        [
            /(cod|mur|sil|vert|ind)ices$/i,
            "$1ex"
        ],
        [
            /(matr|append)ices$/i,
            "$1ix"
        ],
        [
            /(pe)(rson|ople)$/i,
            "$1rson"
        ],
        [
            /(child)ren$/i,
            "$1"
        ],
        [
            /(eau)x?$/i,
            "$1"
        ],
        [
            /men$/i,
            "man"
        ]
    ].forEach(function(rule) {
        return pluralize.addSingularRule(rule[0], rule[1]);
    });
    /**
   * Uncountable rules.
   */ [
        // Singular words with no plurals.
        "adulthood",
        "advice",
        "agenda",
        "aid",
        "aircraft",
        "alcohol",
        "ammo",
        "analytics",
        "anime",
        "athletics",
        "audio",
        "bison",
        "blood",
        "bream",
        "buffalo",
        "butter",
        "carp",
        "cash",
        "chassis",
        "chess",
        "clothing",
        "cod",
        "commerce",
        "cooperation",
        "corps",
        "debris",
        "diabetes",
        "digestion",
        "elk",
        "energy",
        "equipment",
        "excretion",
        "expertise",
        "firmware",
        "flounder",
        "fun",
        "gallows",
        "garbage",
        "graffiti",
        "hardware",
        "headquarters",
        "health",
        "herpes",
        "highjinks",
        "homework",
        "housework",
        "information",
        "jeans",
        "justice",
        "kudos",
        "labour",
        "literature",
        "machinery",
        "mackerel",
        "mail",
        "media",
        "mews",
        "moose",
        "music",
        "mud",
        "manga",
        "news",
        "only",
        "personnel",
        "pike",
        "plankton",
        "pliers",
        "police",
        "pollution",
        "premises",
        "rain",
        "research",
        "rice",
        "salmon",
        "scissors",
        "series",
        "sewage",
        "shambles",
        "shrimp",
        "software",
        "species",
        "staff",
        "swine",
        "tennis",
        "traffic",
        "transportation",
        "trout",
        "tuna",
        "wealth",
        "welfare",
        "whiting",
        "wildebeest",
        "wildlife",
        "you",
        /pok[eé]mon$/i,
        // Regexes.
        /[^aeiou]ese$/i,
        /deer$/i,
        /fish$/i,
        /measles$/i,
        /o[iu]s$/i,
        /pox$/i,
        /sheep$/i
    ].forEach(pluralize.addUncountableRule);
    return pluralize;
});

});


parcelRegister("3Ixuz", function(module, exports) {

$parcel$export(module.exports, "IsResourceNotificationType", function () { return $2b4f76025d36422c$export$643acd4da4561ce5; });
function $2b4f76025d36422c$export$643acd4da4561ce5(value) {
    return value === "change" || value === "discard" || value === "save";
}

});

parcelRegister("dUDPg", function(module, exports) {

$parcel$export(module.exports, "defaults", function () { return $a20f65ece6f6f454$export$ebe90cb607ad99e; });
$parcel$export(module.exports, "useDocumentObjectView", function () { return $a20f65ece6f6f454$export$6a6cde42dd9bf447; });
$parcel$export(module.exports, "useDocumentPropertyDeclarations", function () { return $a20f65ece6f6f454$export$a816c83cbfb18789; });
$parcel$export(module.exports, "postDocument", function () { return $a20f65ece6f6f454$export$3b85aa17d6c57f74; });
$parcel$export(module.exports, "postDocumentConfirmChanges", function () { return $a20f65ece6f6f454$export$8da18fb561862be0; });
$parcel$export(module.exports, "putDocument", function () { return $a20f65ece6f6f454$export$7cf35861e381352b; });
$parcel$export(module.exports, "useDocumentDiagnostics", function () { return $a20f65ece6f6f454$export$1bc5ec7bfd5c9048; });
$parcel$export(module.exports, "postDocumentRefresh", function () { return $a20f65ece6f6f454$export$8dfc238869663a5d; });
$parcel$export(module.exports, "useTemplates", function () { return $a20f65ece6f6f454$export$b0a9bce6cbec665b; });
$parcel$export(module.exports, "getStudioTemplate", function () { return $a20f65ece6f6f454$export$1b1a0d390a43af65; });
$parcel$export(module.exports, "postDocumentsFromTemplate", function () { return $a20f65ece6f6f454$export$a59e203e92242e87; });
$parcel$export(module.exports, "getNewDocumentFromExisting", function () { return $a20f65ece6f6f454$export$258c0bbb24fa819f; });
$parcel$export(module.exports, "postStudioTableFilter", function () { return $a20f65ece6f6f454$export$981017dc9445d28e; });
$parcel$export(module.exports, "putStudioTableFilter", function () { return $a20f65ece6f6f454$export$fbbdbc148ab47d31; });
$parcel$export(module.exports, "deleteStudioTableFilter", function () { return $a20f65ece6f6f454$export$f4ec934196d58832; });
$parcel$export(module.exports, "useStudioTableFilterDeclarationsEndpoint", function () { return $a20f65ece6f6f454$export$e7914309dfc0a298; });
$parcel$export(module.exports, "useStudioTableColumnFilterOptions", function () { return $a20f65ece6f6f454$export$498c8bb99019344; });
$parcel$export(module.exports, "useReactorMe", function () { return $a20f65ece6f6f454$export$41d666a5186a022a; });
$parcel$export(module.exports, "getWebSocketTicketForStudioUser", function () { return $a20f65ece6f6f454$export$142990fa462ec747; });
$parcel$export(module.exports, "putCookieConsents", function () { return $a20f65ece6f6f454$export$f60be4ab695c738e; });
$parcel$export(module.exports, "useCookieConsents", function () { return $a20f65ece6f6f454$export$a75ab29ac3c01498; });
$parcel$export(module.exports, "useLoginPageConfig", function () { return $a20f65ece6f6f454$export$8aa74261785944a3; });
$parcel$export(module.exports, "useProgressOperations", function () { return $a20f65ece6f6f454$export$45aefb6aa6313e9d; });
$parcel$export(module.exports, "deleteProgressOperation", function () { return $a20f65ece6f6f454$export$e12eab7db05d8979; });
$parcel$export(module.exports, "useStudioConsoleDeclarations", function () { return $a20f65ece6f6f454$export$fd5972893db4924a; });
$parcel$export(module.exports, "getStudioConsoleQuery", function () { return $a20f65ece6f6f454$export$a143c71caaab659; });
$parcel$export(module.exports, "postStudioConsoleQuery", function () { return $a20f65ece6f6f454$export$95c87f0e34c00a63; });
$parcel$export(module.exports, "postStudioConsoleQueryAction", function () { return $a20f65ece6f6f454$export$f96fb6f422ff336b; });
$parcel$export(module.exports, "postStudioPage", function () { return $a20f65ece6f6f454$export$e80bf8f4e06e76c; });
$parcel$export(module.exports, "postStudioPageAction", function () { return $a20f65ece6f6f454$export$8cdaf2e04bd1ce99; });
$parcel$export(module.exports, "putUserDefinedStudioPageCode", function () { return $a20f65ece6f6f454$export$89b5f5edc5db8ed2; });
$parcel$export(module.exports, "postDocumentPage", function () { return $a20f65ece6f6f454$export$9c07cfba7c1404f6; });
$parcel$export(module.exports, "useDocumentPage", function () { return $a20f65ece6f6f454$export$d8eb8c32826d9d8c; });
$parcel$export(module.exports, "postDocumentPageAction", function () { return $a20f65ece6f6f454$export$515f69f88088292f; });
$parcel$export(module.exports, "postDocumentDefaults", function () { return $a20f65ece6f6f454$export$186ce115a6f7851; });
$parcel$export(module.exports, "getReflection", function () { return $a20f65ece6f6f454$export$6c3e17132cc7c4b8; });
$parcel$export(module.exports, "useReflection", function () { return $a20f65ece6f6f454$export$f2693381791b225e; });
$parcel$export(module.exports, "getFileInfo", function () { return $a20f65ece6f6f454$export$ca39f27fe4f7d9b4; });
$parcel$export(module.exports, "useFileInfo", function () { return $a20f65ece6f6f454$export$ee3c5c6f3f6d9ce2; });
$parcel$export(module.exports, "useLocales", function () { return $a20f65ece6f6f454$export$7a920adec6f03cb7; });
$parcel$export(module.exports, "useDefaultLocale", function () { return $a20f65ece6f6f454$export$188ec29ebc2bdc3a; });
$parcel$export(module.exports, "useEditingTemplates", function () { return $a20f65ece6f6f454$export$3eb16646ca00f6c; });
$parcel$export(module.exports, "postEditingTemplate", function () { return $a20f65ece6f6f454$export$198d5e39b005a16f; });
$parcel$export(module.exports, "deleteEditingTemplate", function () { return $a20f65ece6f6f454$export$65d34dfbfc97ca7a; });
$parcel$export(module.exports, "postDatasetPartialPreview", function () { return $a20f65ece6f6f454$export$23c2cc16f804b25e; });
$parcel$export(module.exports, "postDatasetPartial", function () { return $a20f65ece6f6f454$export$c9f7c31b8b787c73; });
$parcel$export(module.exports, "useDatasetPartialStatus", function () { return $a20f65ece6f6f454$export$35b55dc3a8d2f44d; });
$parcel$export(module.exports, "postStudioTranslate", function () { return $a20f65ece6f6f454$export$2d8285d5bfbc57d6; });
$parcel$export(module.exports, "useMarkdownSnippet", function () { return $a20f65ece6f6f454$export$e1cb49632f1ee55f; });
$parcel$export(module.exports, "useStudioMenu", function () { return $a20f65ece6f6f454$export$61f5615d8059000; });
$parcel$export(module.exports, "putStudioMenuScope", function () { return $a20f65ece6f6f454$export$709d2a12f20d6799; });
$parcel$export(module.exports, "getPrimaryDataset", function () { return $a20f65ece6f6f454$export$84b2c1392edca245; });
$parcel$export(module.exports, "useDocumentEvents", function () { return $a20f65ece6f6f454$export$2395466cf3e3814b; });
$parcel$export(module.exports, "useStudioGlobalSearch", function () { return $a20f65ece6f6f454$export$c9b41d9889d33da1; });
$parcel$export(module.exports, "useStudioToasts", function () { return $a20f65ece6f6f454$export$99a23bc3fc1572fe; });
$parcel$export(module.exports, "deleteStudioToast", function () { return $a20f65ece6f6f454$export$1cc30c8a3cedab1a; });
$parcel$export(module.exports, "useAnalyticsEventStatus", function () { return $a20f65ece6f6f454$export$d7b1b5e2e146ee6e; });
$parcel$export(module.exports, "postAnalyticsEvent", function () { return $a20f65ece6f6f454$export$66670472b5285f48; });
$parcel$export(module.exports, "useSharedWidget", function () { return $a20f65ece6f6f454$export$5b5e67ffcf2ba41e; });
$parcel$export(module.exports, "getLayerUpdates", function () { return $a20f65ece6f6f454$export$4ec870344b7001ea; });
$parcel$export(module.exports, "postLayerUpdates", function () { return $a20f65ece6f6f454$export$3ba7ff34a452fa58; });
$parcel$export(module.exports, "discardLayerUpdates", function () { return $a20f65ece6f6f454$export$f758c4a492381d2; });
$parcel$export(module.exports, "useWebPage", function () { return $a20f65ece6f6f454$export$29c54f290673783c; });
$parcel$export(module.exports, "useWebPageInfo", function () { return $a20f65ece6f6f454$export$93409be67e487a17; });
$parcel$export(module.exports, "useWebPagesInfos", function () { return $a20f65ece6f6f454$export$e1cdd2f33e255b36; });
$parcel$export(module.exports, "useWebPermissions", function () { return $a20f65ece6f6f454$export$9516c399ad75603f; });
$parcel$export(module.exports, "usePaymentStatus", function () { return $a20f65ece6f6f454$export$e4818e90429e9873; });
$parcel$export(module.exports, "useMerchantConfig", function () { return $a20f65ece6f6f454$export$45f530d069573b0d; });
$parcel$export(module.exports, "getPaymentMethods", function () { return $a20f65ece6f6f454$export$ba33f6d94de735b7; });
$parcel$export(module.exports, "postPayment", function () { return $a20f65ece6f6f454$export$9f2dfacdd421cd58; });
$parcel$export(module.exports, "postAdditionalDetails", function () { return $a20f65ece6f6f454$export$34c8eb16ae69fac8; });
$parcel$export(module.exports, "useColorStyles", function () { return $a20f65ece6f6f454$export$2b7a08e331403047; });

var $8jB4x = parcelRequire("8jB4x");

var $7m9cQ = parcelRequire("7m9cQ");
var $a20f65ece6f6f454$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $a20f65ece6f6f454$var$__await ? (this.v = v, this) : new $a20f65ece6f6f454$var$__await(v);
};
var $a20f65ece6f6f454$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a20f65ece6f6f454$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
const $a20f65ece6f6f454$export$ebe90cb607ad99e = {
    baseUrl: (0, $7m9cQ.server)(),
    fetch (input, init) {
        // fetch() really wants to be called like this, treating it as a
        // value won't work
        return fetch(input, init);
    },
    headers: {
        "Content-Type": "application/json"
    }
};
// Creates an adapter so browser and node streams can be used interchangeably
function $a20f65ece6f6f454$var$readStream(stream) {
    return $a20f65ece6f6f454$var$__asyncGenerator(this, arguments, function* readStream_1() {
        const reader = stream.getReader();
        while(true){
            const { done: done, value: value } = yield $a20f65ece6f6f454$var$__await(reader.read());
            if (done) break;
            yield yield $a20f65ece6f6f454$var$__await(value);
        }
    });
}
/** Computes display views for the given objects, for use in studio. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentObjectView",
    func: $a20f65ece6f6f454$export$58aa662497f7fe86
});
async function $a20f65ece6f6f454$export$58aa662497f7fe86(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/object/views`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$64e2f73ebddf87ab(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $a20f65ece6f6f454$export$6a6cde42dd9bf447 = (0, $8jB4x.SSRHook)("postDocumentObjectView", "PostDocumentObjectViewDto", undefined, $a20f65ece6f6f454$export$58aa662497f7fe86, [
    "body"
], undefined);
/** Populates an object of a specific type with defaults, according to the model.

 Returns the object with defaults populated. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentObjectDefaults",
    func: $a20f65ece6f6f454$export$d8e75982836b0d
});
async function $a20f65ece6f6f454$export$d8e75982836b0d(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/object/defaults`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$78d2712e15bbab27(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
/** Computes declarations for script properties. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentPropertyDeclarations",
    func: $a20f65ece6f6f454$export$afd0bb72d6729fd8
});
async function $a20f65ece6f6f454$export$afd0bb72d6729fd8(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/property/declarations`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$a816c83cbfb18789 = (0, $8jB4x.SSRHook)("postDocumentPropertyDeclarations", "PostDocumentPropertyDeclarationsDto", undefined, $a20f65ece6f6f454$export$afd0bb72d6729fd8, [
    "body"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDocumentsCount",
    func: $a20f65ece6f6f454$export$ee723413f2516051
});
async function $a20f65ece6f6f454$export$ee723413f2516051(collection, filter, search, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (filter !== undefined) queryArgs.push("filter=" + encodeURIComponent(filter.valueOf()));
        if (search !== undefined) queryArgs.push("search=" + encodeURIComponent(search.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/documents/count${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$8c53b5022fe3515c(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $a20f65ece6f6f454$export$ee196065a6aa3eab = (0, $8jB4x.SSRHook)("getDocumentsCount", undefined, undefined, $a20f65ece6f6f454$export$ee723413f2516051, [
    "collection",
    "filter",
    "search"
], undefined);
/** Adds a new document to the given collection. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocument",
    func: $a20f65ece6f6f454$export$3b85aa17d6c57f74
});
async function $a20f65ece6f6f454$export$3b85aa17d6c57f74(collection, body, allowErrors, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (allowErrors !== undefined) queryArgs.push("allowErrors=" + encodeURIComponent(allowErrors.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$c7bae2476b61dc57(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "deleteDocument",
    func: $a20f65ece6f6f454$export$c00c16979ce15b0f
});
async function $a20f65ece6f6f454$export$c00c16979ce15b0f(collection, primaryKey, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (primaryKey !== undefined) queryArgs.push("primaryKey=" + encodeURIComponent(primaryKey.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$2a5d23346e716200(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden");
}
/** Returns confirm change modals that the user must confirm prior to saving
 (PUT'ing) the document. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentConfirmChanges",
    func: $a20f65ece6f6f454$export$8da18fb561862be0
});
async function $a20f65ece6f6f454$export$8da18fb561862be0(collection, primaryKey, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (primaryKey !== undefined) queryArgs.push("primaryKey=" + encodeURIComponent(primaryKey.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/confirmChanges${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Replaces an entire document. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putDocument",
    func: $a20f65ece6f6f454$export$7cf35861e381352b
});
async function $a20f65ece6f6f454$export$7cf35861e381352b(collection, primaryKey, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/${collection}/${primaryKey}`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$c30362b6f60aba56(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Conflict" || e.type === "BadRequest" || e.type === "Forbidden");
}
/** Retrieves a particular version of a document. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDocument",
    func: $a20f65ece6f6f454$export$f65ca476c09acec0
});
async function $a20f65ece6f6f454$export$f65ca476c09acec0(collection, key, version, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (key !== undefined) queryArgs.push("key=" + encodeURIComponent(key.valueOf()));
        if (version !== undefined) queryArgs.push("version=" + encodeURIComponent(version.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$fa352028383dc9cb(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $a20f65ece6f6f454$export$e71e2fb5c5c476d5 = (0, $8jB4x.SSRHook)("getDocument", undefined, undefined, $a20f65ece6f6f454$export$f65ca476c09acec0, [
    "collection",
    "key",
    "version"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDocumentDiagnostics",
    func: $a20f65ece6f6f454$export$59ac1a20d548c415
});
async function $a20f65ece6f6f454$export$59ac1a20d548c415(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/diagnostics`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$7a7cbe4edf7d5553(e) {
    return e && typeof e === "object" && "type" in e && e.type === "Unauthorized";
}
const $a20f65ece6f6f454$export$1bc5ec7bfd5c9048 = (0, $8jB4x.SSRHook)("getDocumentDiagnostics", undefined, undefined, $a20f65ece6f6f454$export$59ac1a20d548c415, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentRefresh",
    func: $a20f65ece6f6f454$export$8dfc238869663a5d
});
async function $a20f65ece6f6f454$export$8dfc238869663a5d(collection, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/refresh${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$38f25a68c7c373b7(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "TooManyRequests");
}
/** Returns all available templates that are compatible with a given type name. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getTemplates",
    func: $a20f65ece6f6f454$export$2112de27deb5cb2c
});
async function $a20f65ece6f6f454$export$2112de27deb5cb2c(typeName, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/templates/${typeName}/templates`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$b0a9bce6cbec665b = (0, $8jB4x.SSRHook)("getTemplates", "GetTemplatesDto", undefined, $a20f65ece6f6f454$export$2112de27deb5cb2c, [
    "typeName"
], undefined);
/** Returns a new document from a studio template.

If the template belongs to a collection, it will be migrated according to the
rules of the collection.

A new primary key will be generated for the document. It is required that the
type has a UUID primary key.

The document will not be inserted into any collection (yet), but rather
returned for further processing on the client, typically for manual
inspection and editing. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioTemplate",
    func: $a20f65ece6f6f454$export$1b1a0d390a43af65
});
async function $a20f65ece6f6f454$export$1b1a0d390a43af65(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/templates/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d735851e3f60b76d(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $a20f65ece6f6f454$export$e9c48dce02a15fed = (0, $8jB4x.SSRHook)("getStudioTemplate", undefined, undefined, $a20f65ece6f6f454$export$1b1a0d390a43af65, [
    "id"
], undefined);
/** Creates a batch of template instances a given type and template. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentsFromTemplate",
    func: $a20f65ece6f6f454$export$a59e203e92242e87
});
async function $a20f65ece6f6f454$export$a59e203e92242e87(typeName, templateName, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/templates/${typeName}/${templateName}/create`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3cd43abc16d0dfd(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getNewDocumentFromExisting",
    func: $a20f65ece6f6f454$export$258c0bbb24fa819f
});
async function $a20f65ece6f6f454$export$258c0bbb24fa819f(collectionName, primaryKey, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/new-from-existing/${collectionName}/${primaryKey}/new`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$22f8ea8a03b5f7d(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$87a88f82ac986a50 = (0, $8jB4x.SSRHook)("getNewDocumentFromExisting", undefined, undefined, $a20f65ece6f6f454$export$258c0bbb24fa819f, [
    "collectionName",
    "primaryKey"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioTableFilters",
    func: $a20f65ece6f6f454$export$ef5a7221fe05434a
});
async function $a20f65ece6f6f454$export$ef5a7221fe05434a(collectionName, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collectionName !== undefined) queryArgs.push("collectionName=" + encodeURIComponent(collectionName.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-filters${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$b20a96654acceceb(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$7a17b6381dbab7c8 = (0, $8jB4x.SSRHook)("getStudioTableFilters", "ReturnType", undefined, $a20f65ece6f6f454$export$ef5a7221fe05434a, [
    "collectionName"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioTableFilter",
    func: $a20f65ece6f6f454$export$981017dc9445d28e
});
async function $a20f65ece6f6f454$export$981017dc9445d28e(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-filters`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$73a91c6b7a0cf856(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putStudioTableFilter",
    func: $a20f65ece6f6f454$export$fbbdbc148ab47d31
});
async function $a20f65ece6f6f454$export$fbbdbc148ab47d31(id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-filters/${id}`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "deleteStudioTableFilter",
    func: $a20f65ece6f6f454$export$f4ec934196d58832
});
async function $a20f65ece6f6f454$export$f4ec934196d58832(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-filters/${id}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioTableFilterDeclarationsEndpoint",
    func: $a20f65ece6f6f454$export$a4eb9a764e2d22d3
});
async function $a20f65ece6f6f454$export$a4eb9a764e2d22d3(collectionName, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collectionName !== undefined) queryArgs.push("collectionName=" + encodeURIComponent(collectionName.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-filter-declarations${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$9473cbc40c071bc6(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "Forbidden");
}
const $a20f65ece6f6f454$export$e7914309dfc0a298 = (0, $8jB4x.SSRHook)("getStudioTableFilterDeclarationsEndpoint", "GetStudioTableFilterDeclarationsEndpointDto", undefined, $a20f65ece6f6f454$export$a4eb9a764e2d22d3, [
    "collectionName"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioTableColumns",
    func: $a20f65ece6f6f454$export$9705a41adfab725d
});
async function $a20f65ece6f6f454$export$9705a41adfab725d(collectionName, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collectionName !== undefined) queryArgs.push("collectionName=" + encodeURIComponent(collectionName.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-columns${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$a4e0ed3cbba541b6(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$a97c0f1053186c5 = (0, $8jB4x.SSRHook)("getStudioTableColumns", undefined, undefined, $a20f65ece6f6f454$export$9705a41adfab725d, [
    "collectionName"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioTableColumnFilterOptions",
    func: $a20f65ece6f6f454$export$70c34aa70222d24a
});
async function $a20f65ece6f6f454$export$70c34aa70222d24a(collectionName, columnName, search, offset, limit, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (search !== undefined) queryArgs.push("search=" + encodeURIComponent(search.valueOf()));
        if (offset !== undefined) queryArgs.push("offset=" + encodeURIComponent(offset.valueOf()));
        if (limit !== undefined) queryArgs.push("limit=" + encodeURIComponent(limit.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-columns/${collectionName}/filter-options/${columnName}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3e06652175b2c7ee(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest");
}
const $a20f65ece6f6f454$export$498c8bb99019344 = (0, $8jB4x.SSRHook)("getStudioTableColumnFilterOptions", "GetStudioTableColumnFilterOptionsDto", undefined, $a20f65ece6f6f454$export$70c34aa70222d24a, [
    "collectionName",
    "columnName",
    "search",
    "offset",
    "limit"
], undefined);
/** Returns the result of an async widget evaluation. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getAsyncWidget",
    func: $a20f65ece6f6f454$export$f99e65d22ed006d
});
async function $a20f65ece6f6f454$export$f99e65d22ed006d(secret, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/async-widget/${secret}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$f8c0cdfcace50cd2(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "RequestTimeout");
}
const $a20f65ece6f6f454$export$7d9c9223843f5a79 = (0, $8jB4x.SSRHook)("getAsyncWidget", "GetAsyncWidgetDto", undefined, $a20f65ece6f6f454$export$f99e65d22ed006d, [
    "secret"
], undefined);
/** Renders a named widget.

 The named widget must be registered with Widget() and marked with an
 `authorize` function.

 The calling user must be authorized to render the widget by the `authroize`
 function. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postWidget",
    func: $a20f65ece6f6f454$export$e6838830449d2b12
});
async function $a20f65ece6f6f454$export$e6838830449d2b12(name, param, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/widgets/${name}/${param}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$b335b75b93f3baaf(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "Forbidden");
}
/** Performs an action on a named widget tree

 The named widget must be registered with Widget() and marked with an
 `authorize` attribute.

 The calling user must be authorized to render the widget by the `authroize`
 function.

 The widget my specify an additional `actionAuthorization` function, which is
 called to authorize the particular action. If the widget does not specify an
 `actionAuthorization` function, the `StudioAuthorization` is used by
 default, meaning the action is limited to what the user is allowed to do in
 Studio. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postWidgetAction",
    func: $a20f65ece6f6f454$export$5c0787df35a2fdb1
});
async function $a20f65ece6f6f454$export$5c0787df35a2fdb1(name, param, widgetKey, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/widgets/${name}/${param}/${widgetKey}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$37e3ac86e8b94ca9(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "Forbidden" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getReactorMe",
    func: $a20f65ece6f6f454$export$73bfb6925bb6ca89
});
async function $a20f65ece6f6f454$export$73bfb6925bb6ca89(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/reactor/me`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$18cb3ec9e05d6733(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$41d666a5186a022a = (0, $8jB4x.SSRHook)("getReactorMe", "GetReactorMeDto", undefined, $a20f65ece6f6f454$export$73bfb6925bb6ca89, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebSocketTicketForStudioUser",
    func: $a20f65ece6f6f454$export$142990fa462ec747
});
async function $a20f65ece6f6f454$export$142990fa462ec747(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/reactor/ticket`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$c77bc68c9af3a491(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$9f8a4179437becf = (0, $8jB4x.SSRHook)("getWebSocketTicketForStudioUser", "GetWebSocketTicketForStudioUserDto", undefined, $a20f65ece6f6f454$export$142990fa462ec747, [], undefined);
/** Updates the cookie consents for the caller. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putCookieConsents",
    func: $a20f65ece6f6f454$export$f60be4ab695c738e
});
async function $a20f65ece6f6f454$export$f60be4ab695c738e(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/cookie-consents`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d56b7037a29601d4(e) {
    return e && typeof e === "object" && "type" in e && e.type === "Conflict";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getCookieConsents",
    func: $a20f65ece6f6f454$export$a3d5133891671b7f
});
async function $a20f65ece6f6f454$export$a3d5133891671b7f(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/cookie-consents`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$a75ab29ac3c01498 = (0, $8jB4x.SSRHook)("getCookieConsents", "GetCookieConsentsDto", "CookieConsents", $a20f65ece6f6f454$export$a3d5133891671b7f, [], (args, body)=>$a20f65ece6f6f454$export$f60be4ab695c738e.apply(null, [
        body
    ]));
/** Sends a login link to the given email address. The login link will be valid
for 1 hour.

This is typically intended for regular Studio users to send themselves a login
link, to log in on a new device or if they have logged out.

If the user exists, an email will be sent to them with a login link.
If the user does not exist, the caller will not be able to tell. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "sendLoginLink",
    func: $a20f65ece6f6f454$export$d5a84e6235b37970
});
async function $a20f65ece6f6f454$export$d5a84e6235b37970(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/auth/send-login-link`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$24385aaa90078f85(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
/** Completes a login attempt using a secret.

If successful, a session cookie will be set, and the user redirected to the
appropriate page. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "completeLogin",
    func: $a20f65ece6f6f454$export$16232f49ad72d562
});
async function $a20f65ece6f6f454$export$16232f49ad72d562(secret, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/auth/login/${secret}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$aef0329c26dbc4c5(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "logout",
    func: $a20f65ece6f6f454$export$a0973bcfe11b05c9
});
async function $a20f65ece6f6f454$export$a0973bcfe11b05c9(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/auth/logout`, {
            method: "post",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getLoginPageConfig",
    func: $a20f65ece6f6f454$export$f83068fa24f824e6
});
async function $a20f65ece6f6f454$export$f83068fa24f824e6(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/login-page-config`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$8aa74261785944a3 = (0, $8jB4x.SSRHook)("getLoginPageConfig", "GetLoginPageConfigDto", "PutLoginPageConfigRequestBodyDto", $a20f65ece6f6f454$export$f83068fa24f824e6, [], (args, body)=>$a20f65ece6f6f454$export$fa720151b94fc726.apply(null, [
        body
    ]));
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putLoginPageConfig",
    func: $a20f65ece6f6f454$export$fa720151b94fc726
});
async function $a20f65ece6f6f454$export$fa720151b94fc726(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/login-page-config`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getProgressOperations",
    func: $a20f65ece6f6f454$export$674500fd2dc73cbe
});
async function $a20f65ece6f6f454$export$674500fd2dc73cbe(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/progress-operations`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$836f032484deb9aa(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$45aefb6aa6313e9d = (0, $8jB4x.SSRHook)("getProgressOperations", undefined, undefined, $a20f65ece6f6f454$export$674500fd2dc73cbe, [], undefined);
/** Cancels an ongoing progress operation. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "deleteProgressOperation",
    func: $a20f65ece6f6f454$export$e12eab7db05d8979
});
async function $a20f65ece6f6f454$export$e12eab7db05d8979(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/progress-operations/${id}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$90564d9d7745ab04(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
/** Imports a CSV file into a collection using a StudioImporter. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioImport",
    func: $a20f65ece6f6f454$export$9cdd14240fa100e1
});
async function $a20f65ece6f6f454$export$9cdd14240fa100e1(importerId, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/importers/${importerId}/import`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3d5ff9a2baaa4fdb(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
/** Returns the TSQ declarations available to the current user. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioConsoleDeclarations",
    func: $a20f65ece6f6f454$export$bb07a6b381093870
});
async function $a20f65ece6f6f454$export$bb07a6b381093870(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/console/declarations`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$fd5972893db4924a = (0, $8jB4x.SSRHook)("getStudioConsoleDeclarations", "GetStudioConsoleDeclarationsDto", undefined, $a20f65ece6f6f454$export$bb07a6b381093870, [], undefined);
/** Retrieves a stored query by ID. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioConsoleQuery",
    func: $a20f65ece6f6f454$export$a143c71caaab659
});
async function $a20f65ece6f6f454$export$a143c71caaab659(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (id !== undefined) queryArgs.push("id=" + encodeURIComponent(id.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/console/query${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$94ceba2dc16e0fc3 = (0, $8jB4x.SSRHook)("getStudioConsoleQuery", "StudioConsoleQuery", undefined, $a20f65ece6f6f454$export$a143c71caaab659, [
    "id"
], undefined);
/** Evaluates a console query (TSQ expression).

If the code snippet has not been stored before, it is stored and given an ID.
If the code snippet has been stored before, the stored ID is returned. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioConsoleQuery",
    func: $a20f65ece6f6f454$export$95c87f0e34c00a63
});
async function $a20f65ece6f6f454$export$95c87f0e34c00a63(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/console`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$1ffc617dfcffd0e8(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "NotFound" || e.type === "Conflict");
}
/** Performs an action on the result of a console query (TSQ expression). */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioConsoleQueryAction",
    func: $a20f65ece6f6f454$export$f96fb6f422ff336b
});
async function $a20f65ece6f6f454$export$f96fb6f422ff336b(id, widgetKey, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/console/${id}/actions/${widgetKey}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$61b968f9f5926f2c(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "NotFound" || e.type === "Conflict" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
/** Renders a studio page into a widget tree.

 The page will be rendered using the calling user's Studio authorization. The call may fail fully
 or partially if the user is not authorized to read the necessary data to render the page. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioPage",
    func: $a20f65ece6f6f454$export$e80bf8f4e06e76c
});
async function $a20f65ece6f6f454$export$e80bf8f4e06e76c(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/page`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$8859d14dad5c6167(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing" || e.type === "NotFound" || e.type === "BadRequest" || e.type === "Conflict");
}
/** Performs one of the predefined actions in a widget tree returned by `postStudioPage`.

This typically means "pushing a button" in the widget tree.

The action will be performed using the calling user's Studio authorization. This means that the
user must be authorized to perform all the implied consequences of the action for the call to be
successful. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioPageAction",
    func: $a20f65ece6f6f454$export$8cdaf2e04bd1ce99
});
async function $a20f65ece6f6f454$export$8cdaf2e04bd1ce99(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/page/action`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$bf41fa9433d6b6b1(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing" || e.type === "NotFound" || e.type === "BadRequest" || e.type === "Conflict");
}
/** Allows updating the code of a user-defined studio page.

Implicitly requires permission to update the document through
StudioAuthorization. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putUserDefinedStudioPageCode",
    func: $a20f65ece6f6f454$export$89b5f5edc5db8ed2
});
async function $a20f65ece6f6f454$export$89b5f5edc5db8ed2(id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/user-defined-page/${id}/code`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Returns a single document along with all associated widget representations, making it easier to
render the document in Studio without performing additional network requests. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentPage",
    func: $a20f65ece6f6f454$export$9c07cfba7c1404f6
});
async function $a20f65ece6f6f454$export$9c07cfba7c1404f6(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/documents/page`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$8883d5bc8bb3bd6e(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$d8eb8c32826d9d8c = (0, $8jB4x.SSRHook)("postDocumentPage", "PostDocumentPageDto", undefined, $a20f65ece6f6f454$export$9c07cfba7c1404f6, [
    "body"
], undefined);
/** Performs one of the predefined actions in a widget tree returned by
`postDocumentPage`.

This typically means "pushing a button" in the widget tree.

The action will be performed using the calling user's Studio authorization.
This means that the user must be authorized to perform all the implied
consequences of the action for the call to be successful.

To avoid subtle bugs, `body.clientState` must be used with caution, as the
action will be performed against the canonized version of the document, and
is not able to take any client-side state into account. The user should either
save or discard their client-side changes before performing an action.

`body.clientState` may be used when creating new documents. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentPageAction",
    func: $a20f65ece6f6f454$export$515f69f88088292f
});
async function $a20f65ece6f6f454$export$515f69f88088292f(tab, widgetKey, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (tab !== undefined) queryArgs.push("tab=" + encodeURIComponent(tab.valueOf()));
        if (widgetKey !== undefined) queryArgs.push("widgetKey=" + encodeURIComponent(widgetKey.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/documents/page/action${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$434fefc19550a453(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "DocumentMustBeSavedPriorToAction" || e.type === "BadRequest" || e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentDefaults",
    func: $a20f65ece6f6f454$export$186ce115a6f7851
});
async function $a20f65ece6f6f454$export$186ce115a6f7851(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/documents/defaults`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Returns information about the data collections managed by this server. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getReflection",
    func: $a20f65ece6f6f454$export$6c3e17132cc7c4b8
});
async function $a20f65ece6f6f454$export$6c3e17132cc7c4b8(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/reflection`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$f2693381791b225e = (0, $8jB4x.SSRHook)("getReflection", "SerializedGraph", undefined, $a20f65ece6f6f454$export$6c3e17132cc7c4b8, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getSessionNew",
    func: $a20f65ece6f6f454$export$576698117f7f93b2
});
async function $a20f65ece6f6f454$export$576698117f7f93b2(className, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (className !== undefined) queryArgs.push("className=" + encodeURIComponent(className.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/session/new${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$93254169b95f1822(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $a20f65ece6f6f454$export$998b6d034b77c472 = (0, $8jB4x.SSRHook)("getSessionNew", undefined, undefined, $a20f65ece6f6f454$export$576698117f7f93b2, [
    "className"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postSessionMethod",
    func: $a20f65ece6f6f454$export$d52b56e35f0d4c29
});
async function $a20f65ece6f6f454$export$d52b56e35f0d4c29(className, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (className !== undefined) queryArgs.push("className=" + encodeURIComponent(className.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/session/method${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d7416ed4314b698f(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postFiles",
    func: $a20f65ece6f6f454$export$95da78a327b3e83c
});
async function $a20f65ece6f6f454$export$95da78a327b3e83c(folder, uploadedFiles, share, mimetype, temporaryFile, originalFileName, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (share !== undefined) queryArgs.push("share=" + encodeURIComponent(share.valueOf()));
        if (mimetype !== undefined) queryArgs.push("mimetype=" + encodeURIComponent(mimetype.valueOf()));
        if (temporaryFile !== undefined) queryArgs.push("temporaryFile=" + encodeURIComponent(temporaryFile.valueOf()));
        if (originalFileName !== undefined) queryArgs.push("originalFileName=" + encodeURIComponent(originalFileName.valueOf()));
        const formData = new FormData();
        for (const file of uploadedFiles)formData.append("file", file);
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        delete headers["Content-Type"];
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/folders/${folder}/files${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: formData
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$5cc45c11858fff49(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getFileInfo",
    func: $a20f65ece6f6f454$export$ca39f27fe4f7d9b4
});
async function $a20f65ece6f6f454$export$ca39f27fe4f7d9b4(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/files/${id}/info`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d7db1b28f9c31e3a(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$ee3c5c6f3f6d9ce2 = (0, $8jB4x.SSRHook)("getFileInfo", "FileRecord", undefined, $a20f65ece6f6f454$export$ca39f27fe4f7d9b4, [
    "id"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postSmsStatus",
    func: $a20f65ece6f6f454$export$4a5940fc022e5072
});
async function $a20f65ece6f6f454$export$4a5940fc022e5072(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/fuse-webhooks/sms-status`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$4dad33e3e2f99430(e) {
    return e && typeof e === "object" && "type" in e && e.type === "Unauthorized";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "unsubscribeEndpoint",
    func: $a20f65ece6f6f454$export$4a0e110f8230f4b2
});
async function $a20f65ece6f6f454$export$4a0e110f8230f4b2(secret, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/email-unsubscribe/${secret}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** A webhook for getting status updates on email delivery from Fuseops. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postEmailStatus",
    func: $a20f65ece6f6f454$export$23c810bd8c41062f
});
async function $a20f65ece6f6f454$export$23c810bd8c41062f(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/fuse-webhooks/email-status`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$5ae10059a7c0a42f(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "NotFound" || e.type === "BadRequest");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postEmailPreviewResult",
    func: $a20f65ece6f6f454$export$15460f7f997118be
});
async function $a20f65ece6f6f454$export$15460f7f997118be(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/fuse-webhooks/email-preview`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$904516fab6ba8863(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest");
}
/** Navigates to the link embedded in an email.

This registers the click in the database and redirects the user to the
link. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getEmailLink",
    func: $a20f65ece6f6f454$export$68142dc28e973edc
});
async function $a20f65ece6f6f454$export$68142dc28e973edc(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/email/links/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d55dbb4428fd8778(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest");
}
const $a20f65ece6f6f454$export$76396f9dc6eed503 = (0, $8jB4x.SSRHook)("getEmailLink", undefined, undefined, $a20f65ece6f6f454$export$68142dc28e973edc, [
    "id"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getLocales",
    func: $a20f65ece6f6f454$export$63967f17cb506053
});
async function $a20f65ece6f6f454$export$63967f17cb506053(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/locales`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$7a920adec6f03cb7 = (0, $8jB4x.SSRHook)("getLocales", undefined, undefined, $a20f65ece6f6f454$export$63967f17cb506053, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDefaultLocale",
    func: $a20f65ece6f6f454$export$f09106e7c6677ec5
});
async function $a20f65ece6f6f454$export$f09106e7c6677ec5(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/default-locale`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$188ec29ebc2bdc3a = (0, $8jB4x.SSRHook)("getDefaultLocale", "GetDefaultLocaleDto", undefined, $a20f65ece6f6f454$export$f09106e7c6677ec5, [], undefined);
/** Returns all available editing templates for a given type. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getEditingTemplates",
    func: $a20f65ece6f6f454$export$21236ecbfb784eda
});
async function $a20f65ece6f6f454$export$21236ecbfb784eda(type, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/editing-templates/${type}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$3eb16646ca00f6c = (0, $8jB4x.SSRHook)("getEditingTemplates", "GetEditingTemplatesDto", undefined, $a20f65ece6f6f454$export$21236ecbfb784eda, [
    "type"
], undefined);
/** Creates a new editing template.

Returns an error if a template with the same name already exists for the given type */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postEditingTemplate",
    func: $a20f65ece6f6f454$export$198d5e39b005a16f
});
async function $a20f65ece6f6f454$export$198d5e39b005a16f(type, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/editing-templates/${type}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d11d407836b0a284(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
/** Overwrites an existing editing template. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putEditingTemplate",
    func: $a20f65ece6f6f454$export$bc7bab6114223bff
});
async function $a20f65ece6f6f454$export$bc7bab6114223bff(type, id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/editing-templates/${type}/${id}`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Deletes an editing template. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "deleteEditingTemplate",
    func: $a20f65ece6f6f454$export$65d34dfbfc97ca7a
});
async function $a20f65ece6f6f454$export$65d34dfbfc97ca7a(type, id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/editing-templates/${type}/${id}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Previews what will happen if a partial dataset is imported with the given settings. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDatasetPartialPreview",
    func: $a20f65ece6f6f454$export$23c2cc16f804b25e
});
async function $a20f65ece6f6f454$export$23c2cc16f804b25e(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/dataset/partial/preview`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$ba8b3e2a11922016(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
/** Imports a partial dataset.

 The dataset will be downloaded asynchronously. You can poll `GET
 /studio/dataset/partial/:id/status` to get the progress. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDatasetPartial",
    func: $a20f65ece6f6f454$export$c9f7c31b8b787c73
});
async function $a20f65ece6f6f454$export$c9f7c31b8b787c73(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/dataset/partial`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$886b639dd5309e14(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Conflict" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDatasetPartialStatus",
    func: $a20f65ece6f6f454$export$5f591e763f89ee4b
});
async function $a20f65ece6f6f454$export$5f591e763f89ee4b(importId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/dataset/partial/${importId}/status`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$35b55dc3a8d2f44d = (0, $8jB4x.SSRHook)("getDatasetPartialStatus", "PartialDatasetImport", undefined, $a20f65ece6f6f454$export$5f591e763f89ee4b, [
    "importId"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioTranslate",
    func: $a20f65ece6f6f454$export$2d8285d5bfbc57d6
});
async function $a20f65ece6f6f454$export$2d8285d5bfbc57d6(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/translate`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$262ecb60feb54731(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getMarkdownSnippet",
    func: $a20f65ece6f6f454$export$c0cc98bd687a2fe3
});
async function $a20f65ece6f6f454$export$c0cc98bd687a2fe3(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/markdown-snippets/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$e1cb49632f1ee55f = (0, $8jB4x.SSRHook)("getMarkdownSnippet", "GetMarkdownSnippetDto", "PutMarkdownSnippetRequestBodyDto", $a20f65ece6f6f454$export$c0cc98bd687a2fe3, [
    "id"
], (args, body)=>$a20f65ece6f6f454$export$1dd477df5f9fd1d4.apply(null, [
        args[0],
        body
    ]));
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putMarkdownSnippet",
    func: $a20f65ece6f6f454$export$1dd477df5f9fd1d4
});
async function $a20f65ece6f6f454$export$1dd477df5f9fd1d4(id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/markdown-snippets/${id}`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Returns the studio menu for the current user. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioMenu",
    func: $a20f65ece6f6f454$export$b02fe8a117d5bb3f
});
async function $a20f65ece6f6f454$export$b02fe8a117d5bb3f(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/menu`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$ddbad3cc0db37bdf(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$61f5615d8059000 = (0, $8jB4x.SSRHook)("getStudioMenu", "GetStudioMenuDto", undefined, $a20f65ece6f6f454$export$b02fe8a117d5bb3f, [], undefined);
/** Sets the current scope selection for the current user.

This typically stores the preference in a cookie for subsequent requests. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putStudioMenuScope",
    func: $a20f65ece6f6f454$export$709d2a12f20d6799
});
async function $a20f65ece6f6f454$export$709d2a12f20d6799(slug, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/menu/scope/${slug}`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$4eb356684d2f6adc(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest");
}
/** Downloads the primary dataset from this Reactor instance.

This includes all collection data marked as `isPrimaryDataset`. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPrimaryDataset",
    func: $a20f65ece6f6f454$export$84b2c1392edca245
});
async function $a20f65ece6f6f454$export$84b2c1392edca245(includeFiles, secret, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (includeFiles !== undefined) queryArgs.push("includeFiles=" + encodeURIComponent(includeFiles.valueOf()));
        if (secret !== undefined) queryArgs.push("secret=" + encodeURIComponent(secret.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/primary-dataset${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$681bbf4e231943ce(e) {
    return e && typeof e === "object" && "type" in e && e.type === "Forbidden";
}
const $a20f65ece6f6f454$export$7129ae44733acd42 = (0, $8jB4x.SSRHook)("getPrimaryDataset", undefined, undefined, $a20f65ece6f6f454$export$84b2c1392edca245, [
    "includeFiles",
    "secret"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postPrimaryDataset",
    func: $a20f65ece6f6f454$export$c44d3c9f46f1b060
});
async function $a20f65ece6f6f454$export$c44d3c9f46f1b060(files, secret, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (secret !== undefined) queryArgs.push("secret=" + encodeURIComponent(secret.valueOf()));
        const formData = new FormData();
        for (const file of files)formData.append("file", file);
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        delete headers["Content-Type"];
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/primary-dataset${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: formData
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$88ac8cccf1f5ef02(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDocumentEvents",
    func: $a20f65ece6f6f454$export$176cf02bf5158edf
});
async function $a20f65ece6f6f454$export$176cf02bf5158edf(collection, document, count, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (document !== undefined) queryArgs.push("document=" + encodeURIComponent(document.valueOf()));
        if (count !== undefined) queryArgs.push("count=" + encodeURIComponent(count.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/documents/events${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$1cd2afbcd3c5435f(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "NotFound" || e.type === "Unauthorized" || e.type === "Forbidden");
}
const $a20f65ece6f6f454$export$2395466cf3e3814b = (0, $8jB4x.SSRHook)("getDocumentEvents", "GetDocumentEventsDto", undefined, $a20f65ece6f6f454$export$176cf02bf5158edf, [
    "collection",
    "document",
    "count"
], undefined);
/** Searches all collections that the current user has read and filter access to, and renders a
widget page with one table for each collection containing hits. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioGlobalSearch",
    func: $a20f65ece6f6f454$export$54e6a88438a044c2
});
async function $a20f65ece6f6f454$export$54e6a88438a044c2(searchString, body, searchCollection, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (searchString !== undefined) queryArgs.push("searchString=" + encodeURIComponent(searchString.valueOf()));
        if (searchCollection !== undefined) queryArgs.push("searchCollection=" + encodeURIComponent(searchCollection.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/search${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$c37d1723310d5234(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "NotFound" || e.type === "BadRequest" || e.type === "Conflict");
}
const $a20f65ece6f6f454$export$c9b41d9889d33da1 = (0, $8jB4x.SSRHook)("postStudioGlobalSearch", "PostStudioGlobalSearchDto", undefined, $a20f65ece6f6f454$export$54e6a88438a044c2, [
    "searchString",
    "body",
    "searchCollection"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getSendMailTrackingPixel",
    func: $a20f65ece6f6f454$export$6138f65f2a3c9b54
});
async function $a20f65ece6f6f454$export$6138f65f2a3c9b54(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/email-read/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$cf0c79a2fb47756e(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$8d1f5b8378bd70ae = (0, $8jB4x.SSRHook)("getSendMailTrackingPixel", undefined, undefined, $a20f65ece6f6f454$export$6138f65f2a3c9b54, [
    "id"
], undefined);
/** Returns the studio toasts for the current user. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioToasts",
    func: $a20f65ece6f6f454$export$675001882e68c4a
});
async function $a20f65ece6f6f454$export$675001882e68c4a(offset, limit, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (offset !== undefined) queryArgs.push("offset=" + encodeURIComponent(offset.valueOf()));
        if (limit !== undefined) queryArgs.push("limit=" + encodeURIComponent(limit.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/toasts${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$4b68536c9a4b905c(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$99a23bc3fc1572fe = (0, $8jB4x.SSRHook)("getStudioToasts", undefined, undefined, $a20f65ece6f6f454$export$675001882e68c4a, [
    "offset",
    "limit"
], undefined);
/** Deletes a studio toast.

This is typically called when the user dismisses the toast. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "deleteStudioToast",
    func: $a20f65ece6f6f454$export$1cc30c8a3cedab1a
});
async function $a20f65ece6f6f454$export$1cc30c8a3cedab1a(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/toasts/${id}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3c41bae14ae0bc28(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
/** Returns whether a particular analytics event is enabled.

If an event is disbaled, the clients should not bother sending it.

This is intended to be used during SSR to built into the SPA whether to
send certain analytics events or not. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getAnalyticsEventStatus",
    func: $a20f65ece6f6f454$export$9acf6305a4a41fa0
});
async function $a20f65ece6f6f454$export$9acf6305a4a41fa0(type, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/analytics-events/${type}/status`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$d7b1b5e2e146ee6e = (0, $8jB4x.SSRHook)("getAnalyticsEventStatus", "AnalyticsEventStatus", undefined, $a20f65ece6f6f454$export$9acf6305a4a41fa0, [
    "type"
], undefined);
/** Logs an analytics event.

Mobile apps should set two additional headers:
`Fuse-Install-Id` and `Fuse-App-Version`. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postAnalyticsEvent",
    func: $a20f65ece6f6f454$export$66670472b5285f48
});
async function $a20f65ece6f6f454$export$66670472b5285f48(type, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/analytics-events/${type}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$dbbb0eeb0b02f1cd(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postSharedWidget",
    func: $a20f65ece6f6f454$export$4cf04919850db7fd
});
async function $a20f65ece6f6f454$export$4cf04919850db7fd(urlSecret, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/shared-widget/${urlSecret}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$1f03f6241501e74c(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "BadRequest" || e.type === "NotFound" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$5b5e67ffcf2ba41e = (0, $8jB4x.SSRHook)("postSharedWidget", "PostSharedWidgetDto", undefined, $a20f65ece6f6f454$export$4cf04919850db7fd, [
    "urlSecret",
    "body"
], undefined);
/** Returns the updates in the given layer for the given document, from the given
version.

In order to call this endpoint, the user must have read access to the
document.

If the document doesn't exist yet, but represents an uncreated (draft)
document, the user must have insert access to the collection. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getLayerUpdates",
    func: $a20f65ece6f6f454$export$4ec870344b7001ea
});
async function $a20f65ece6f6f454$export$4ec870344b7001ea(res, key, layer, version, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (version !== undefined) queryArgs.push("version=" + encodeURIComponent(version.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/layers/${res}/${key}/${layer}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$ead5010fead26772(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "NotFound" || e.type === "Unauthorized");
}
const $a20f65ece6f6f454$export$629f24930275d49a = (0, $8jB4x.SSRHook)("getLayerUpdates", "GetLayerUpdatesDto", undefined, $a20f65ece6f6f454$export$4ec870344b7001ea, [
    "res",
    "key",
    "layer",
    "version"
], undefined);
/** Posts a new operation to the given document in the given layer.

If the document doesn't exist yet, but represents an uncreated (draft)
document, the user must have insert access to the collection.

If the document exists, the user must have update access to the document. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postLayerUpdates",
    func: $a20f65ece6f6f454$export$3ba7ff34a452fa58
});
async function $a20f65ece6f6f454$export$3ba7ff34a452fa58(res, key, layer, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/layers/${res}/${key}/${layer}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d76a1695c1d6ee6c(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
/** Deletes all updates in the given layer.

For uncreated drafts, this will effectively delete the draft, since it only
exists as uncommitted updates.

For existing documents, this will delete all updates in the given layer (i.e.
unpublished changes). The published document will be unaffected.

For existing documents, the user must have update access to the document to
discard the updates.

For uncreated drafts, the user must have insert access to the collection to
discard the uncreated draft. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "discardLayerUpdates",
    func: $a20f65ece6f6f454$export$f758c4a492381d2
});
async function $a20f65ece6f6f454$export$f758c4a492381d2(res, key, layer, clientId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (clientId !== undefined) queryArgs.push("clientId=" + encodeURIComponent(clientId.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/layers/${res}/${key}/${layer}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$37e5e152c35a81de(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "NotFound" || e.type === "Conflict");
}
/** Saves the operations in the given layer into the base layer, and updates the
target document. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "mergeLayer",
    func: $a20f65ece6f6f454$export$a45fc67a54b28134
});
async function $a20f65ece6f6f454$export$a45fc67a54b28134(res, key, layer, clientId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (clientId !== undefined) queryArgs.push("clientId=" + encodeURIComponent(clientId.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/layers/${res}/${key}/${layer}/merge${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$c0ba2c8930153e5(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "NotFound" || e.type === "Unauthorized" || e.type === "Conflict" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebPage",
    func: $a20f65ece6f6f454$export$a4ac49d5f0db027
});
async function $a20f65ece6f6f454$export$a4ac49d5f0db027(locale, slug, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()));
        if (slug !== undefined) queryArgs.push("slug=" + encodeURIComponent(slug.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/page${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$5ca6db9162f00d86(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$29c54f290673783c = (0, $8jB4x.SSRHook)("getWebPage", "GetWebPageDto", undefined, $a20f65ece6f6f454$export$a4ac49d5f0db027, [
    "locale",
    "slug"
], undefined);
/** Returns info about a web page by its ID.

This is useful if you don't have the slug of the page, but you know its ID. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebPageInfo",
    func: $a20f65ece6f6f454$export$d901911f8f9d3bc
});
async function $a20f65ece6f6f454$export$d901911f8f9d3bc(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/page-info/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$93409be67e487a17 = (0, $8jB4x.SSRHook)("getWebPageInfo", "GetWebPageInfoDto", undefined, $a20f65ece6f6f454$export$d901911f8f9d3bc, [
    "id"
], undefined);
/** Validates, checks avaialbility and calculates the price of a phone order. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postWebPagesInfos",
    func: $a20f65ece6f6f454$export$29568ed10563ee2d
});
async function $a20f65ece6f6f454$export$29568ed10563ee2d(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/pages-infos`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$e1cdd2f33e255b36 = (0, $8jB4x.SSRHook)("postWebPagesInfos", undefined, undefined, $a20f65ece6f6f454$export$29568ed10563ee2d, [
    "body"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebMenu",
    func: $a20f65ece6f6f454$export$9dc0d6d3f9d64228
});
async function $a20f65ece6f6f454$export$9dc0d6d3f9d64228(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/menu`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$8b2d152375c92a8 = (0, $8jB4x.SSRHook)("getWebMenu", "WebMenu", undefined, $a20f65ece6f6f454$export$9dc0d6d3f9d64228, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebFooter",
    func: $a20f65ece6f6f454$export$92bff06dc1482e6a
});
async function $a20f65ece6f6f454$export$92bff06dc1482e6a(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/footer`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$313ca8d12a7ed6c1 = (0, $8jB4x.SSRHook)("getWebFooter", "WebFooter", undefined, $a20f65ece6f6f454$export$92bff06dc1482e6a, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebPermissions",
    func: $a20f65ece6f6f454$export$111b1cf667438cea
});
async function $a20f65ece6f6f454$export$111b1cf667438cea(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/permissions`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$83a9e7971b0139fa(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$9516c399ad75603f = (0, $8jB4x.SSRHook)("getWebPermissions", "GetWebPermissionsDto", undefined, $a20f65ece6f6f454$export$111b1cf667438cea, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPaymentStatus",
    func: $a20f65ece6f6f454$export$62bb39aa76e51fe4
});
async function $a20f65ece6f6f454$export$62bb39aa76e51fe4(adyenOrder, adyenOrderId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/status/${adyenOrder}/${adyenOrderId}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$e4818e90429e9873 = (0, $8jB4x.SSRHook)("getPaymentStatus", "GetPaymentStatusDto", undefined, $a20f65ece6f6f454$export$62bb39aa76e51fe4, [
    "adyenOrder",
    "adyenOrderId"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getMerchantConfig",
    func: $a20f65ece6f6f454$export$2b8edcd677afcd27
});
async function $a20f65ece6f6f454$export$2b8edcd677afcd27(adyenOrder, adyenOrderId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (adyenOrder !== undefined) queryArgs.push("adyenOrder=" + encodeURIComponent(adyenOrder.valueOf()));
        if (adyenOrderId !== undefined) queryArgs.push("adyenOrderId=" + encodeURIComponent(adyenOrderId.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/merchant-config${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$45f530d069573b0d = (0, $8jB4x.SSRHook)("getMerchantConfig", "GetMerchantConfigDto", undefined, $a20f65ece6f6f454$export$2b8edcd677afcd27, [
    "adyenOrder",
    "adyenOrderId"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPaymentMethods",
    func: $a20f65ece6f6f454$export$ba33f6d94de735b7
});
async function $a20f65ece6f6f454$export$ba33f6d94de735b7(adyenOrder, adyenOrderId, locale, channel, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()));
        if (channel !== undefined) queryArgs.push("channel=" + encodeURIComponent(channel.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/methods/${adyenOrder}/${adyenOrderId}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3439326e0e9ec6c9(e) {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError";
}
const $a20f65ece6f6f454$export$a16567ce62387eb = (0, $8jB4x.SSRHook)("getPaymentMethods", "GetPaymentMethodsDto", undefined, $a20f65ece6f6f454$export$ba33f6d94de735b7, [
    "adyenOrder",
    "adyenOrderId",
    "locale",
    "channel"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postPayment",
    func: $a20f65ece6f6f454$export$9f2dfacdd421cd58
});
async function $a20f65ece6f6f454$export$9f2dfacdd421cd58(adyenOrder, adyenOrderId, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/payment/${adyenOrder}/${adyenOrderId}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$6480dbcacec9380e(e) {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postAdditionalDetails",
    func: $a20f65ece6f6f454$export$34c8eb16ae69fac8
});
async function $a20f65ece6f6f454$export$34c8eb16ae69fac8(adyenOrder, adyenOrderId, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (adyenOrder !== undefined) queryArgs.push("adyenOrder=" + encodeURIComponent(adyenOrder.valueOf()));
        if (adyenOrderId !== undefined) queryArgs.push("adyenOrderId=" + encodeURIComponent(adyenOrderId.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/additional-details${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$4864b7440fdac2e2(e) {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getShopperRedirect",
    func: $a20f65ece6f6f454$export$c8dfe59fd50aaff8
});
async function $a20f65ece6f6f454$export$c8dfe59fd50aaff8(paymentId, locale, redirectUrl, redirectResult, mD, paRes, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (paymentId !== undefined) queryArgs.push("paymentId=" + encodeURIComponent(paymentId.valueOf()));
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()));
        if (redirectUrl !== undefined) queryArgs.push("redirectUrl=" + encodeURIComponent(redirectUrl.valueOf()));
        if (redirectResult !== undefined) queryArgs.push("redirectResult=" + encodeURIComponent(redirectResult.valueOf()));
        if (mD !== undefined) queryArgs.push("mD=" + encodeURIComponent(mD.valueOf()));
        if (paRes !== undefined) queryArgs.push("paRes=" + encodeURIComponent(paRes.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/shopper-redirect${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$675b8321664d05da(e) {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError";
}
const $a20f65ece6f6f454$export$53c8a554c0f5bbf0 = (0, $8jB4x.SSRHook)("getShopperRedirect", undefined, undefined, $a20f65ece6f6f454$export$c8dfe59fd50aaff8, [
    "paymentId",
    "locale",
    "redirectUrl",
    "redirectResult",
    "mD",
    "paRes"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postShopperRedirect",
    func: $a20f65ece6f6f454$export$15c276420a05fe3e
});
async function $a20f65ece6f6f454$export$15c276420a05fe3e(paymentId, locale, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (paymentId !== undefined) queryArgs.push("paymentId=" + encodeURIComponent(paymentId.valueOf()));
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/shopper-redirect/${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$1e9f87ef2e3fb56f(e) {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postAdyenWebhook",
    func: $a20f65ece6f6f454$export$e11e52af077aed4e
});
async function $a20f65ece6f6f454$export$e11e52af077aed4e(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/adyen-webhook`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3377c1afdcc48e11(e) {
    return e && typeof e === "object" && "type" in e && e.type === "Unauthorized";
}
/** Internal Receipt endpoint, do not attempt to use this endpoint directly. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getReceiptHtml",
    func: $a20f65ece6f6f454$export$fb37bf727dcfdbd1
});
async function $a20f65ece6f6f454$export$fb37bf727dcfdbd1(secret, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (secret !== undefined) queryArgs.push("secret=" + encodeURIComponent(secret.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/receipts/html${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$218966a8a7868a92(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$1e7b91d42db791a9 = (0, $8jB4x.SSRHook)("getReceiptHtml", undefined, undefined, $a20f65ece6f6f454$export$fb37bf727dcfdbd1, [
    "secret"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getColorStyles",
    func: $a20f65ece6f6f454$export$aa42d30026ce41b9
});
async function $a20f65ece6f6f454$export$aa42d30026ce41b9(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/color-styles`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$2b7a08e331403047 = (0, $8jB4x.SSRHook)("getColorStyles", "GetColorStylesDto", undefined, $a20f65ece6f6f454$export$aa42d30026ce41b9, [], undefined);
/** Starts the login flow by generating a URL to redirect the user to.

The redirect URL will be validated by `options.validateRedirectUrl`

The returned url is valid for `options.attemptExpiry` milliseconds. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getAuthUrl",
    func: $a20f65ece6f6f454$export$1ecea9365b9c733c
});
async function $a20f65ece6f6f454$export$1ecea9365b9c733c(redirectUrl, failedRedirectUrl, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (redirectUrl !== undefined) queryArgs.push("redirectUrl=" + encodeURIComponent(redirectUrl.valueOf()));
        if (failedRedirectUrl !== undefined) queryArgs.push("failedRedirectUrl=" + encodeURIComponent(failedRedirectUrl.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/vipps/auth/url${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$7be6eb079516ba07(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $a20f65ece6f6f454$export$2f80ea4f94c459f0 = (0, $8jB4x.SSRHook)("getAuthUrl", "GetAuthUrlDto", undefined, $a20f65ece6f6f454$export$1ecea9365b9c733c, [
    "redirectUrl",
    "failedRedirectUrl"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getCallback",
    func: $a20f65ece6f6f454$export$2a88462d58de88be
});
async function $a20f65ece6f6f454$export$2a88462d58de88be(state, code, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (state !== undefined) queryArgs.push("state=" + encodeURIComponent(state.valueOf()));
        if (code !== undefined) queryArgs.push("code=" + encodeURIComponent(code.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/vipps/auth/callback${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$87c57a69f33fec19(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Unauthorized");
}
const $a20f65ece6f6f454$export$35808ee640e87ca7 = (0, $8jB4x.SSRHook)("getCallback", undefined, undefined, $a20f65ece6f6f454$export$2a88462d58de88be, [
    "state",
    "code"
], undefined);
/** Returns info about the current user from the OIDC provider. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getMe",
    func: $a20f65ece6f6f454$export$dd7946daa6163e94
});
async function $a20f65ece6f6f454$export$dd7946daa6163e94(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/vipps/me`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$c797c0a5952daefd(e) {
    return e && typeof e === "object" && "type" in e && e.type === "Unauthorized";
}
const $a20f65ece6f6f454$export$f637e1cf42d15a62 = (0, $8jB4x.SSRHook)("getMe", undefined, undefined, $a20f65ece6f6f454$export$dd7946daa6163e94, [], undefined);
/** Deletes the OIDC login cookies. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "deleteLogin",
    func: $a20f65ece6f6f454$export$177dba3035c9246e
});
async function $a20f65ece6f6f454$export$177dba3035c9246e(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/vipps/auth/session`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}

});
parcelRegister("7m9cQ", function(module, exports) {

$parcel$export(module.exports, "server", function () { return $55b1baa4410f7873$export$b4e470744154116f; });

var $lDBHC = parcelRequire("lDBHC");
var $55b1baa4410f7873$var$_a;
// This hack allows us to not have a hard dependency on async-hooks on the
// client side
let $55b1baa4410f7873$var$getServer = ()=>"<not-initialized>";
if ((0, $lDBHC.IsNode)()) $55b1baa4410f7873$var$getServer = ($55b1baa4410f7873$var$_a = globalThis.ReactorContext) === null || $55b1baa4410f7873$var$_a === void 0 ? void 0 : $55b1baa4410f7873$var$_a.getServer;
const $55b1baa4410f7873$var$serverBaseUrl = (0, $lDBHC.IsNode)() ? undefined : undefined;
function $55b1baa4410f7873$export$b4e470744154116f(/** If set to `true`, the local IP address will be used instead of localhost
 * when a local browser is accessing the local server.
 *
 * This makes it possible for external services (e.g. Gotenberg) to access
 * the local server.
 */ preferLocalIP = false) {
    const srv = (0, $lDBHC.IsNode)() ? $55b1baa4410f7873$var$serverBaseUrl !== null && $55b1baa4410f7873$var$serverBaseUrl !== void 0 ? $55b1baa4410f7873$var$serverBaseUrl : $55b1baa4410f7873$var$getServer() : window.location.origin;
    if (preferLocalIP && srv === "http://localhost:3000") {
        // In Node, this is set by `Context.ts`, to give access to the local
        // HTTP server through the local network IP address
        if ("localHttpServer" in globalThis) return globalThis.localHttpServer;
    }
    return srv;
}
globalThis.server = $55b1baa4410f7873$export$b4e470744154116f;

});



parcelRegister("5JGam", function(module, exports) {

$parcel$export(module.exports, "IsEditingContext", function () { return $42d1dd0e4df554d5$export$bbc49a069f6f507f; });
$parcel$export(module.exports, "useIsEditing", function () { return $42d1dd0e4df554d5$export$976ddc6b4d436815; });

var $eeH7J = parcelRequire("eeH7J");
const $42d1dd0e4df554d5$export$bbc49a069f6f507f = /*#__PURE__*/ (0, $eeH7J.createContext)(false);
function $42d1dd0e4df554d5$export$976ddc6b4d436815() {
    return (0, $eeH7J.useContext)($42d1dd0e4df554d5$export$bbc49a069f6f507f);
}

});

parcelRegister("knIBr", function(module, exports) {

$parcel$export(module.exports, "DummySelectionContext", function () { return $ed688dd11cc626d4$export$75cf08b1467b2706; });
$parcel$export(module.exports, "SelectionContext", function () { return $ed688dd11cc626d4$export$7c7a4fd7f1336e2c; });
$parcel$export(module.exports, "useSelectionContext", function () { return $ed688dd11cc626d4$export$e00efe24d2be88c3; });
$parcel$export(module.exports, "SelectionContextProvider", function () { return $ed688dd11cc626d4$export$48b9cc116e7155cb; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
const $ed688dd11cc626d4$export$75cf08b1467b2706 = {
    /** The object that is selected for inspection */ selectedObject: null,
    setSelectedObject (obj, type) {},
    clearSelectedObject () {}
};
const $ed688dd11cc626d4$export$7c7a4fd7f1336e2c = /*#__PURE__*/ (0, $eeH7J.createContext)(null);
function $ed688dd11cc626d4$export$e00efe24d2be88c3() {
    const context = (0, $eeH7J.useContext)($ed688dd11cc626d4$export$7c7a4fd7f1336e2c);
    if (!context) throw new Error("No selection context");
    return context;
}
function $ed688dd11cc626d4$export$48b9cc116e7155cb({ children: children }) {
    const [_selectedObject, _setSelectedObject] = (0, $eeH7J.useState)(undefined);
    return (0, $4vwom.jsx)($ed688dd11cc626d4$export$7c7a4fd7f1336e2c.Provider, {
        value: {
            selectedObject: _selectedObject === null || _selectedObject === void 0 ? void 0 : _selectedObject.obj,
            selectedObjectType: _selectedObject === null || _selectedObject === void 0 ? void 0 : _selectedObject.type,
            selectedObjectPutType: _selectedObject === null || _selectedObject === void 0 ? void 0 : _selectedObject.putType,
            setSelectedObject (obj, type, putType) {
                _setSelectedObject({
                    obj: obj,
                    type: type,
                    putType: putType
                });
            },
            clearSelectedObject () {
                _setSelectedObject(undefined);
            }
        },
        children: children
    });
}

});

parcelRegister("hafxL", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("kEDuT"),
    $Ks0wJ("bGtNJ"),
    $Ks0wJ("02XaR")
]).then(()=>parcelRequire("9ArIY"));

});
parcelRegister("Ks0wJ", function(module, exports) {
"use strict";

function $08ba05b2dae8864c$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("3ueMA")).resolve(id));
}
module.exports = $08ba05b2dae8864c$var$load;

});



parcelRegister("cNfXq", function(module, exports) {

$parcel$export(module.exports, "whenReflectionReady", function () { return $02675464fd8036f3$export$2b581c707b8786ee; });
$parcel$export(module.exports, "useReflectionReady", function () { return $02675464fd8036f3$export$1b57c3a8ac2e4ca; });

var $eeH7J = parcelRequire("eeH7J");

var $3oicm = parcelRequire("3oicm");

var $cwhCA = parcelRequire("cwhCA");
let $02675464fd8036f3$var$reflectionPromise;

function $02675464fd8036f3$export$2b581c707b8786ee(callback) {
    if ((0, $cwhCA.IsReflectionInfoReady)()) {
        callback((0, $cwhCA.GetReflectionInfo)());
        return;
    }
    if (!$02675464fd8036f3$var$reflectionPromise) {
        async function loadReflection() {
            const { getReflection: getReflection } = await Promise.resolve((parcelRequire("dUDPg")));
            // Could have been initialized while we were waiting for the import
            if (!$02675464fd8036f3$var$reflectionPromise) $02675464fd8036f3$var$reflectionPromise = getReflection();
            const ref = await $02675464fd8036f3$var$reflectionPromise;
            const info = (0, $3oicm.DeserializeGraph)(ref);
            (0, $cwhCA.SetReflectionInfo)(info);
            callback(info);
        }
        loadReflection();
    } else $02675464fd8036f3$var$reflectionPromise.then(()=>callback((0, $cwhCA.GetReflectionInfo)()));
}
function $02675464fd8036f3$export$1b57c3a8ac2e4ca(/** Whether the caller needs the reflection info now, or just want to
 * reserve the hook for later.
 *
 * Passing `false` will not download the reflection info yet.
 * */ needItYet) {
    const [ready, setReady] = (0, $eeH7J.useState)((0, $cwhCA.IsReflectionInfoReady)());
    if (!ready && needItYet) $02675464fd8036f3$export$2b581c707b8786ee(()=>setReady(true));
    if (!(0, $cwhCA.IsReflectionInfoReady)()) return undefined;
    return (0, $cwhCA.GetReflectionInfo)();
}

});
parcelRegister("3oicm", function(module, exports) {

$parcel$export(module.exports, "DeserializeGraph", function () { return $2781bacb23374681$export$562fe2de8f878a14; });
$parcel$export(module.exports, "CloneGraph", function () { return $2781bacb23374681$export$53e4bbf0b9578766; });
const $2781bacb23374681$var$handlePrefix = "\xa9#";
function $2781bacb23374681$var$isHandle(s) {
    return typeof s === "string" && s.startsWith($2781bacb23374681$var$handlePrefix);
}
function $2781bacb23374681$export$6ad0bf001fa83026(root) {
    const refCount = new Map();
    function countRefs(obj) {
        if (obj === undefined) return;
        if (obj === null) return;
        if (typeof obj === "object") {
            const o = obj;
            const ref = refCount.get(o);
            if (ref === undefined) {
                refCount.set(o, 1);
                if (obj instanceof Array) obj.forEach(countRefs);
                else Object.keys(obj).forEach((key)=>countRefs(obj[key]));
            } else refCount.set(o, ref + 1);
        }
        // Internalize long strings
        if (typeof obj === "string" && obj.length > 7) {
            const ref = refCount.get(obj);
            if (ref === undefined) refCount.set(obj, 1);
            else refCount.set(obj, ref + 1);
        }
    }
    countRefs(root);
    const nodes = Array.from(refCount).filter((x, i)=>i === 0 || x[1] > 1).map((x)=>x[0]);
    const ids = new Map();
    nodes.forEach((x, i)=>ids.set(x, i));
    function encode(key, value) {
        if (this === nodes) return value;
        const id = ids.get(value);
        if (id !== undefined) return $2781bacb23374681$var$handlePrefix + id;
        return value;
    }
    return JSON.stringify(nodes, encode);
}
function $2781bacb23374681$export$562fe2de8f878a14(graph) {
    const nodes = JSON.parse(graph.toString());
    function revive(obj) {
        if ($2781bacb23374681$var$isHandle(obj)) {
            const index = parseInt(obj.substr($2781bacb23374681$var$handlePrefix.length));
            return nodes[index];
        }
        if (obj instanceof Array) for(let i = 0; i < obj.length; i++)obj[i] = revive(obj[i]);
        else if (obj instanceof Object) for (const key of Object.keys(obj))obj[key] = revive(obj[key]);
        return obj;
    }
    nodes.forEach(revive);
    return nodes[0];
}
function $2781bacb23374681$export$53e4bbf0b9578766(graph) {
    if (typeof graph !== "object") return graph;
    return $2781bacb23374681$export$562fe2de8f878a14($2781bacb23374681$export$6ad0bf001fa83026(graph));
}

});

parcelRegister("cwhCA", function(module, exports) {

$parcel$export(module.exports, "SetReflectionInfo", function () { return $91d6246c2fad74b9$export$d9a88c5d97ffbf61; });
$parcel$export(module.exports, "GetReflectionInfo", function () { return $91d6246c2fad74b9$export$72743ac1fea589d5; });
$parcel$export(module.exports, "IsReflectionInfoReady", function () { return $91d6246c2fad74b9$export$fec01e36cfb8ed9b; });
$parcel$export(module.exports, "GetType", function () { return $91d6246c2fad74b9$export$3d7f8909aa61994; });
$parcel$export(module.exports, "SubstituteType", function () { return $91d6246c2fad74b9$export$bd5de6299d95aa3; });
$parcel$export(module.exports, "SubstituteAndDiscriminate", function () { return $91d6246c2fad74b9$export$91d57c864c7c6cf2; });
$parcel$export(module.exports, "GetPrimaryKey", function () { return $91d6246c2fad74b9$export$e976441c51ae56b5; });

var $43jhg = parcelRequire("43jhg");

var $8h5s0 = parcelRequire("8h5s0");
let $91d6246c2fad74b9$var$resolveReflectionInfo;
let $91d6246c2fad74b9$var$info;
function $91d6246c2fad74b9$export$d9a88c5d97ffbf61(ri) {
    $91d6246c2fad74b9$var$info = ri;
    $91d6246c2fad74b9$var$info.types.forEach((type)=>{
        // Don't add reference types to the dictionary
        if (typeof type === "object" && type.reference) return;
        const alias = (0, $43jhg.GetTypeAlias)(type);
        if (alias) $91d6246c2fad74b9$var$aliasToType.set(alias, type);
    });
    $91d6246c2fad74b9$var$resolveReflectionInfo(ri);
}
function $91d6246c2fad74b9$export$72743ac1fea589d5() {
    if ($91d6246c2fad74b9$var$info === undefined) throw new Error("Cannot GetReflectionInfo prior to SetReflectionInfo");
    return $91d6246c2fad74b9$var$info;
}
const $91d6246c2fad74b9$export$cade07fb2f9cd061 = new Promise((resolve)=>$91d6246c2fad74b9$var$resolveReflectionInfo = resolve);
function $91d6246c2fad74b9$export$fec01e36cfb8ed9b() {
    return !!$91d6246c2fad74b9$var$info;
}
const $91d6246c2fad74b9$var$aliasToType = new Map();
function $91d6246c2fad74b9$export$3d7f8909aa61994(locator) {
    var _a, _b;
    if (!$91d6246c2fad74b9$var$info) throw new Error("GetType(): No reflection info available");
    const alias = typeof locator === "string" ? locator : locator[0];
    const path = typeof locator === "string" ? [] : locator.slice(1);
    if (alias === "unknown") return "unknown";
    if (alias === "undefined") return "undefined";
    if (alias === "null") return "null";
    let type = (_b = (_a = $91d6246c2fad74b9$var$aliasToType.get(alias)) !== null && _a !== void 0 ? _a : $91d6246c2fad74b9$var$info.clientTypes.external.find((t)=>(0, $43jhg.GetTypeAlias)(t) === alias)) !== null && _b !== void 0 ? _b : $91d6246c2fad74b9$var$info.clientTypes.internal.find((t)=>(0, $43jhg.GetTypeAlias)(t) === alias);
    if (!type) throw new Error("GetType(): Type not found: " + alias);
    if (!path.length) return type;
    for (const part of path){
        if (typeof part === "string") {
            const props = (0, $43jhg.GetTypeProps)(type);
            const prop = props.find((p)=>p.name === part);
            if (!prop) throw new Error("GetType(): Property not found: " + part);
            type = prop.type;
        } else if (typeof part === "number") {
            if (!(0, $43jhg.IsArrayType)(type)) throw new Error("GetType(): Property is not an array: " + part);
            type = type.array;
        }
    }
    return type;
}
const $91d6246c2fad74b9$var$substituteTypesCache = new Map();
function $91d6246c2fad74b9$export$e73170052c4666d4(type) {
    if (!$91d6246c2fad74b9$var$substituteTypesCache.has(type)) $91d6246c2fad74b9$var$substituteTypesCache.set(type, $91d6246c2fad74b9$var$GetSubstituteTypesUncached(type));
    return (0, $8h5s0.Assert)($91d6246c2fad74b9$var$substituteTypesCache.get(type));
}
function $91d6246c2fad74b9$var$GetSubstituteTypesUncached(type) {
    const alias = (0, $43jhg.GetTypeAlias)(type);
    return alias ? $91d6246c2fad74b9$export$72743ac1fea589d5().types.filter((t)=>{
        var _a;
        return typeof t === "object" && ((_a = t.tags) === null || _a === void 0 ? void 0 : _a.substitute) === alias;
    }) : [];
}
const $91d6246c2fad74b9$var$sectionsCache = new Map();
function $91d6246c2fad74b9$export$bd5de6299d95aa3(value, type) {
    var _a;
    if (value === undefined) return type;
    let types = $91d6246c2fad74b9$export$e73170052c4666d4(type);
    if (types.length === 1) return types[0];
    // Special case for section types
    if ((0, $43jhg.GetTypeAlias)(type) === "Section") {
        if ("type" in value) {
            if (!$91d6246c2fad74b9$var$sectionsCache.size) $91d6246c2fad74b9$export$72743ac1fea589d5().sections.forEach((s)=>$91d6246c2fad74b9$var$sectionsCache.set(s.name, s.type));
            const section = $91d6246c2fad74b9$var$sectionsCache.get(value.type);
            if (section) return section;
        }
        types = [
            ...types,
            ...$91d6246c2fad74b9$export$72743ac1fea589d5().sections.map((s)=>s.type)
        ];
    }
    // Special case for section types
    if ((0, $43jhg.GetTypeAlias)(type) === "EmailSection") {
        if ("type" in value) {
            if (!$91d6246c2fad74b9$var$sectionsCache.size) $91d6246c2fad74b9$export$72743ac1fea589d5().emailSections.forEach((s)=>$91d6246c2fad74b9$var$sectionsCache.set(s.name, s.type));
            const section = $91d6246c2fad74b9$var$sectionsCache.get(value.type);
            if (section) return section;
        }
        types = [
            ...types,
            ...$91d6246c2fad74b9$export$72743ac1fea589d5().sections.map((s)=>s.type)
        ];
    }
    return (_a = types.find((t)=>(0, $43jhg.MatchesTypeTurbo)(value, t, false))) !== null && _a !== void 0 ? _a : type;
}
function $91d6246c2fad74b9$export$91d57c864c7c6cf2(value, type) {
    type = $91d6246c2fad74b9$export$bd5de6299d95aa3(value, type);
    return (0, $43jhg.IsUnionType)(type) ? (0, $43jhg.Discriminate)(value, type) : type;
}
function $91d6246c2fad74b9$export$e976441c51ae56b5(type) {
    var _a;
    const props = (0, $43jhg.GetTypeProps)(type);
    return (_a = props.find((p)=>{
        var _a;
        return ((_a = p.tags) === null || _a === void 0 ? void 0 : _a.primary) && p.isReadonly;
    })) !== null && _a !== void 0 ? _a : props.find((p)=>p.name === "id" && p.isReadonly);
}

});
parcelRegister("43jhg", function(module, exports) {

$parcel$export(module.exports, "IsOpaqueStringType", function () { return IsOpaqueStringType; });
$parcel$export(module.exports, "GetTypeAlias", function () { return GetTypeAlias; });
$parcel$export(module.exports, "UnionType", function () { return UnionType; });
$parcel$export(module.exports, "UndefinedType", function () { return UndefinedType; });
$parcel$export(module.exports, "IsFileType", function () { return IsFileType; });
$parcel$export(module.exports, "IsStringType", function () { return IsStringType; });
$parcel$export(module.exports, "IsNumberType", function () { return IsNumberType; });
$parcel$export(module.exports, "IsBooleanType", function () { return IsBooleanType; });
$parcel$export(module.exports, "IsLiteralType", function () { return IsLiteralType; });
$parcel$export(module.exports, "IsStringLiteral", function () { return IsStringLiteral; });
$parcel$export(module.exports, "IsNumberLiteral", function () { return IsNumberLiteral; });
$parcel$export(module.exports, "IsBooleanLiteral", function () { return IsBooleanLiteral; });
$parcel$export(module.exports, "IsNullType", function () { return IsNullType; });
$parcel$export(module.exports, "IsUndefinedType", function () { return IsUndefinedType; });
$parcel$export(module.exports, "IsAnyType", function () { return IsAnyType; });
$parcel$export(module.exports, "IsUnknownType", function () { return IsUnknownType; });
$parcel$export(module.exports, "IsUnionType", function () { return IsUnionType; });
$parcel$export(module.exports, "IsIntersectionType", function () { return IsIntersectionType; });
$parcel$export(module.exports, "IsArrayType", function () { return IsArrayType; });
$parcel$export(module.exports, "IsObjectType", function () { return IsObjectType; });
$parcel$export(module.exports, "IsVoidType", function () { return IsVoidType; });
$parcel$export(module.exports, "IsParameterType", function () { return IsParameterType; });
$parcel$export(module.exports, "IsAtomic", function () { return IsAtomic; });
$parcel$export(module.exports, "IsFunctionType", function () { return IsFunctionType; });
$parcel$export(module.exports, "IsPromiseType", function () { return IsPromiseType; });
$parcel$export(module.exports, "IsNeverType", function () { return IsNeverType; });
$parcel$export(module.exports, "IsAsyncGeneratorType", function () { return IsAsyncGeneratorType; });
$parcel$export(module.exports, "TypeToString", function () { return TypeToString; });
$parcel$export(module.exports, "GetTypeModel", function () { return GetTypeModel; });
$parcel$export(module.exports, "GetTypeProps", function () { return GetTypeProps; });
$parcel$export(module.exports, "Discriminate", function () { return Discriminate; });
$parcel$export(module.exports, "AreTypesAssignable", function () { return AreTypesAssignable; });
$parcel$export(module.exports, "TypeDiagnosticToString", function () { return TypeDiagnosticToString; });
$parcel$export(module.exports, "MatchesType", function () { return MatchesType; });
$parcel$export(module.exports, "GetTypeValidator", function () { return GetTypeValidator; });
$parcel$export(module.exports, "ValidateType", function () { return ValidateType; });
$parcel$export(module.exports, "MatchesTypeTurbo", function () { return MatchesTypeTurbo; });
$parcel$export(module.exports, "IsTypeOrUndefined", function () { return IsTypeOrUndefined; });
$parcel$export(module.exports, "IsNumberOrUndefinedType", function () { return IsNumberOrUndefinedType; });
$parcel$export(module.exports, "VisitType", function () { return VisitType; });
$parcel$export(module.exports, "ReplaceValuesByType", function () { return ReplaceValuesByType; });

var $lDBHC = parcelRequire("lDBHC");

var $3oicm = parcelRequire("3oicm");

var $14q7s = parcelRequire("14q7s");

var $g0jSz = parcelRequire("g0jSz");

var $lHoPV = parcelRequire("lHoPV");

var $dAwef = parcelRequire("dAwef");

var $cv7r0 = parcelRequire("cv7r0");

var $cwhCA = parcelRequire("cwhCA");
function OpaqueStringType(opaque) {
    return {
        string: null,
        opaque: opaque
    };
}
const TimestampType = {
    string: null,
    opaque: "Timestamp",
    alias: "Timestamp"
};
const TimestampWithoutTimezoneType = {
    string: null,
    opaque: "TimestampWithoutTimezone",
    alias: "TimestampWithoutTimezone"
};
function IsOpaqueStringType(type) {
    return typeof type === "object" && "string" in type && "opaque" in type;
}
function IsTimestampType(type) {
    return typeof type === "object" && type.alias === "Timestamp";
}
function HasDocumentation(type) {
    return typeof type === "object" && "documentation" in type;
}
function SetTypeAlias(alias, type) {
    if (typeof type === "object" && alias && !type.alias && !alias.startsWith("__") && alias !== "Array") type.alias = alias;
    return type;
}
function GetTypeAlias(type) {
    if (typeof type === "object") return type.alias;
}
function UnionType(...union) {
    return {
        union: union
    };
}
function IntersectionType(...intersection) {
    return {
        intersection: intersection
    };
}
const StringType = "string";
const NumberType = "number";
const IntegerType = "number";
const BooleanType = "boolean";
const NullType = "null";
const UndefinedType = "undefined";
const VoidType = "void";
const AnyType = "any";
const UnknownType = "unknown";
const NeverType = "never";
const FunctionType = "function";
function RangedIntegerType(alias, minValue, maxValue) {
    return {
        number: null,
        integer: true,
        alias: alias,
        minValue: minValue,
        maxValue: maxValue
    };
}
function StringLiteral(value) {
    return {
        string: value
    };
}
function NumberLiteral(value) {
    return {
        number: value
    };
}
function BooleanLiteral(value) {
    return {
        boolean: value
    };
}
function ArrayType(itemType = "unknown") {
    return {
        array: itemType
    };
}
const BufferType = {
    buffer: null
};
function PromiseType(payloadType) {
    return {
        promise: payloadType
    };
}
function ParameterType(name) {
    return {
        param: name
    };
}
function IsFileType(type) {
    return typeof type === "object" && "mimeType" in type;
}
function IsFileTypeCompatible(type) {
    if (typeof type === "object") {
        if ("mimeType" in type) return true;
        if ("union" in type) return type.union.every(IsFileTypeCompatible);
    }
    return false;
}
function IsStringType(type) {
    return Is(type, "string");
}
function IsNumberType(type) {
    return Is(type, "number") || Is(type, "integer");
}
function IsIntegerType(type) {
    return typeof type === "string" ? type === "integer" : "number" in type && !!type.integer;
}
function IsBooleanType(type) {
    return Is(type, "boolean");
}
function IsLiteralType(type) {
    return IsStringLiteral(type) || IsNumberLiteral(type) || IsBooleanLiteral(type) || IsNullType(type) || IsUndefinedType(type);
}
function IsStringLiteral(type) {
    return typeof type !== "string" && "string" in type && type.string !== null;
}
function IsNumberLiteral(type) {
    return typeof type !== "string" && "number" in type && type.number !== null;
}
function IsBooleanLiteral(type) {
    return typeof type !== "string" && "boolean" in type && type.boolean !== null;
}
function Is(a, keyword) {
    return typeof a === "string" ? a === keyword : typeof a === "object" && keyword in a;
}
function IsNullType(type) {
    return Is(type, "null");
}
function IsUndefinedType(type) {
    return Is(type, "undefined");
}
function IsAnyType(type) {
    return Is(type, "any");
}
function IsUnknownType(type) {
    return Is(type, "unknown");
}
function IsUnionType(type) {
    return Is(type, "union");
}
function IsIntersectionType(type) {
    return Is(type, "intersection");
}
function IsArrayType(type) {
    return Is(type, "array");
}
function IsObjectType(type) {
    return Is(type, "props");
}
function IsClassType(type, /** Specifies a class name that either must be equal to the alias of this
 * type, or one of its super types. */ className) {
    return IsObjectType(type) && "isClass" in type && !!type.isClass && (!className ? true : type.alias === className || !!type.super && IsClassType(type.super, className));
}
function IsVoidType(type) {
    return typeof type !== "string" ? "void" in type : type === "void";
}
function IsParameterType(type) {
    return Is(type, "param");
}
function IsAtomic(type) {
    return IsStringType(type) || IsNumberType(type) || IsBooleanType(type);
}
function IsFunctionType(type) {
    return Is(type, "function");
}
function IsPromiseType(type) {
    return Is(type, "promise");
}
function IsNeverType(type) {
    return Is(type, "never");
}
function GetTypeReference(type) {
    if (typeof type !== "object") return;
    if (type.reference) return type.reference;
    if (IsArrayType(type)) return GetTypeReference(type.array);
}
function AsyncGeneratorType(generator, returns, next) {
    return {
        generator: generator,
        returns: returns,
        next: next
    };
}
function IsAsyncGeneratorType(t) {
    return typeof t === "object" && "generator" in t;
}
const typeToStringCache = new WeakMap();
function TypeToString(t) {
    if (typeof t === "string") return t;
    let cached = typeToStringCache.get(t);
    if (cached === undefined) {
        cached = TypeToStringUncached(t, true, false);
        typeToStringCache.set(t, cached);
    }
    return cached;
}
function TypeToStringUncached(t, alias, docs, options) {
    var _a, _b;
    if (typeof t === "string") return t;
    if (t.opaque && t.alias) {
        if (IsOpaqueStringType(t) && "precision" in t && t.precision) {
            if (options === null || options === void 0 ? void 0 : options.aliasEncounter) options === null || options === void 0 || options.aliasEncounter(t);
            return `${t.alias}<"${t.precision}">`;
        }
        if ((_a = options === null || options === void 0 ? void 0 : options.preserveOpaques) === null || _a === void 0 ? void 0 : _a.includes(t.alias)) return t.alias + '<"' + t.opaque + '">';
    }
    if (((_b = t.typeArgs) === null || _b === void 0 ? void 0 : _b.length) && alias && GetTypeAlias(t) !== undefined && (options === null || options === void 0 ? void 0 : options.emitTypeArgs) !== false) return TypeToStringUncached(t, alias, docs, Object.assign(Object.assign({}, options), {
        emitTypeArgs: false
    })) + "<" + t.typeArgs.map((b)=>TypeToStringUncached(b, true, docs, options)) + ">";
    if (alias && t.alias && t.alias !== "Array") {
        if (options === null || options === void 0 ? void 0 : options.aliasEncounter) options === null || options === void 0 || options.aliasEncounter(t);
        return t.alias;
    } else if (IsStringType(t) && typeof t === "object") return t.string == null ? "string" : JSON.stringify(t.string);
    else if (IsNumberType(t)) return t.number === null ? "number" : "" + t.number;
    else if (IsBooleanType(t)) return t.boolean === null ? "boolean" : "" + t.boolean;
    else if (IsUndefinedType(t)) return "undefined";
    else if (IsNullType(t)) return "null";
    else if (IsAnyType(t)) return "any";
    else if (IsUnionType(t)) return "(" + t.union.map((x)=>TypeToStringUncached(x, true, docs, options)).join(" | ") + ")";
    else if (IsIntersectionType(t)) return "(" + t.intersection.map((x)=>TypeToStringUncached(x, true, docs, options)).join(" & ") + ")";
    else if (IsArrayType(t)) return TypeToStringUncached(t.array, true, docs, options) + "[]";
    else if (IsObjectType(t)) return "{ " + t.props.map((x)=>{
        var _a, _b;
        return (docs && ((_a = x.description) === null || _a === void 0 ? void 0 : _a.en) ? "/** " + ((_b = x.description) === null || _b === void 0 ? void 0 : _b.en) + "*/\n" : "") + JSON.stringify(x.name) + (x.optional ? "?" : "") + ": " + TypeToStringUncached(x.type, true, docs, options);
    }).join(",\n") + (t.additionalProps ? `\n[key: string]: ${TypeToStringUncached(t.additionalProps, true, docs, options)}` : "") + " }";
    else if (IsVoidType(t)) return "void";
    else if (IsParameterType(t)) return t.param;
    else if (IsNeverType(t)) return "never";
    else if (IsUnknownType(t)) return "unknown";
    else if (IsPromiseType(t)) return "Promise<" + TypeToString(t.promise) + ">";
    else if (IsAsyncGeneratorType(t)) return "AsyncIterable<" + TypeToString(t.generator) + ">";
    else if (IsFileType(t)) return 'File<"' + t.mimeType + '">';
    else throw new Error("Cannot stringify " + t);
}
function GetTypeModel(type) {
    if (typeof type !== "object") return;
    if (!type.sourceFile) return;
    if (!type.sourceFile.startsWith("/models/")) return;
    return type.sourceFile.split("/")[2];
}
const typePropsCache = new Map();
const emptyProps = Object.freeze([]);
function GetTypeProps(type, /** Optionally provide a value. If the type is a union, this will be used to attempt to
 * discriminate the union to get a more precise property set. */ value) {
    if (IsObjectType(type)) {
        if (!(type.props instanceof Array)) throw new Error();
        return type.props;
    }
    if (IsIntersectionType(type)) {
        const props = typePropsCache.get(type);
        if (props) return props;
        const newProps = type.intersection.map(GetTypeProps).reduce((a, b)=>a.concat(b), []);
        typePropsCache.set(type, newProps);
        return newProps;
    } else if (IsUnionType(type)) {
        if (value) {
            const discType = Discriminate(value, type);
            if (discType !== type) return GetTypeProps(discType);
        }
        const props = typePropsCache.get(type);
        if (props) return props;
        const u = type.union.map((x)=>GetTypeProps(x));
        if (u.length === 0) return emptyProps;
        const newProps = u[0].filter((x)=>u.every((y)=>y.some((z)=>z.name === x.name)));
        typePropsCache.set(type, newProps);
        return newProps;
    } else return emptyProps;
}
const areTypesAssignableCache = new WeakMap();
function AreTypesAssignable(dest, source) {
    if (source === dest) return true;
    if (source === "any") return true;
    if (dest === "any") return true;
    if (typeof dest === "string") {
        if (typeof source === "object") {
            if (source.opaque) return false;
        }
        if (dest === "string") return IsStringType(source);
        if (dest === "number") return IsNumberType(source);
        if (dest === "integer") return IsIntegerType(source);
        if (dest === "boolean") return IsBooleanType(source);
        return dest === source;
    }
    let cached;
    if (typeof source === "object") {
        cached = areTypesAssignableCache.get(dest);
        if (cached) {
            const value = cached.get(source);
            if (value !== undefined) return value;
        } else {
            cached = new Map();
            areTypesAssignableCache.set(dest, cached);
        }
    }
    const result = AreTypesAssignableUncached(dest, source);
    if (cached && typeof source === "object") cached.set(source, result);
    return result;
}
function AreTypesAssignableUncached(dest, source) {
    if (IsUnionType(source)) return source.union.every((x)=>AreTypesAssignable(dest, x));
    if (IsUnionType(dest)) return dest.union.some((d)=>AreTypesAssignable(d, source));
    if (IsFileType(source) && IsFileType(dest)) return source.mimeType === dest.mimeType;
    if (typeof source === "object" && typeof dest === "object") {
        if (dest.opaque !== source.opaque) return false;
        if (source.alias && source.alias === dest.alias) return true;
        if (source.alias && dest.alias && source.alias !== dest.alias) return false;
    }
    if (IsAnyType(dest)) return true;
    if (IsIntersectionType(dest)) return dest.intersection.every((d)=>AreTypesAssignable(d, source));
    if (IsFileType(dest)) return IsFileType(source) && (source.mimeType.startsWith(dest.mimeType) || dest.mimeType.startsWith(source.mimeType));
    if (IsStringType(dest)) {
        if (!IsStringType(source)) return false;
        if (dest === "string") return true;
        if (dest.string === null) return true;
        if (typeof source !== "object") return false;
        if (source.string === null) return false;
        else return dest.string === source.string;
    }
    if (IsNumberType(dest)) {
        if (!IsNumberType(source)) return false;
        if (dest === "number") return true;
        if (dest === "integer") return IsIntegerType(source);
        if (dest.number === null) return true;
        if (typeof source !== "object") return false;
        if (source.number === null) return false;
        else return dest.number === source.number;
    }
    if (IsBooleanType(dest)) {
        if (!IsBooleanType(source)) return false;
        if (dest === "boolean") return true;
        if (dest.boolean === null) return true;
        if (typeof source !== "object") return false;
        if (source.boolean === null) return false;
        else return dest.boolean === source.boolean;
    }
    if (IsNullType(dest)) return IsNullType(source);
    if (IsUndefinedType(dest)) return IsUndefinedType(source);
    if (IsArrayType(dest)) {
        if (!IsArrayType(source)) return false;
        return AreTypesAssignable(dest.array, source.array);
    }
    if (IsPromiseType(dest)) {
        if (!IsPromiseType(source)) return false;
        return AreTypesAssignable(dest.promise, source.promise);
    }
    if (IsObjectType(dest)) {
        if (!IsObjectType(source)) return false;
        return dest.props.every((pd)=>{
            const ps = source.props.find((p)=>p.name === pd.name);
            if (!ps) return pd.optional;
            return AreTypesAssignable(pd.type, ps.type);
        });
    }
    if (IsParameterType(dest)) {
        if (!IsParameterType(source)) return false;
        return dest.param === source.param;
    }
    if (IsUnknownType(dest)) return false;
    if (IsVoidType(dest)) {
        if (IsVoidType(source)) return true;
        if (IsUndefinedType(source)) return true;
        return false;
    }
    if (IsFunctionType(dest)) return false; // TODO
    if (IsNeverType(dest)) return false;
    throw new Error("Unhandled type: " + TypeToString(dest));
}
function AreTypesAssignableBothWays(a, b) {
    return AreTypesAssignable(a, b) && AreTypesAssignable(b, a);
}
function TypeDiagnosticToString(e, indent = 0) {
    if (e.subErrors && e.subErrors.length === 1) return TypeDiagnosticToString(e.subErrors[0], indent);
    return " ".repeat(indent) + e.path + ": " + e.error + (e.subErrors && e.subErrors.length ? e.subErrors.map((x)=>"\n" + TypeDiagnosticToString(x, indent + 1)).join("") : "");
}
function RepairDefaultTypes(v, type) {
    return RepairTypes(v, type, [
        (x, t)=>AreTypesAssignable(t, UndefinedType) && x === null ? undefined : x
    ]);
}
function RepairTypes(v, type, rules) {
    if (IsAnyType(type)) return v;
    if (rules.length) for (const rule of rules)v = rule(v, type);
    if (IsUnionType(type)) {
        const dt = Discriminate(v, type);
        if (IsUnionType(dt)) {
            if (dt.union.find((x)=>MatchesType(RepairTypes(v, x, rules), x) === true)) return v;
        } else type = dt;
    }
    if (IsIntersectionType(type)) for (const t of type.intersection)v = RepairTypes(v, t, rules);
    if (IsObjectType(type) && v && typeof v === "object") type.props.forEach((p)=>{
        if (p.name in v) v[p.name] = RepairTypes(v[p.name], p.type, rules);
    });
    if (IsArrayType(type) && v instanceof Array) for(let i = 0; i < v.length; i++)v[i] = RepairTypes(v[i], type.array, rules);
    if (IsFileType(type)) {
        if (typeof v === "string" && v.startsWith("http://") || v.startsWith("https://")) return (0, $14q7s.UndoImageToUrl)(v);
    }
    return v;
}
function typeOf(v) {
    if (v === null) return "null";
    return typeof v;
}
const validatorCache = new Map();
function GetTypeValidator(type) {
    if (typeof type === "object") {
        const alias = GetTypeAlias(type);
        if (type.validator) {
            if ((0, $lDBHC.IsNode)() && alias) return (0, $lHoPV.TypeValidator).functions.find((t)=>t.name === alias);
            else {
                let val = validatorCache.get(type);
                if (!val) {
                    // eslint-disable-next-line no-eval
                    val = eval("(" + type.validator + ")");
                    validatorCache.set(type, val);
                }
                return val;
            }
        }
    }
}
function ValidateType(value, type) {
    if (typeof type === "object" && type.validator) {
        const validator = GetTypeValidator(type);
        if (validator) return validator(value);
    }
    return value;
}
function MatchesTypeTurbo(value, type, validate = false) {
    // Fast paths for common cases
    const t = typeof value;
    if (t === type) return true;
    if (typeof type === "object") {
        if (validate && type.validator) try {
            value = ValidateType(value, type);
        } catch (e) {
            return false;
        }
        switch(t){
            case "string":
                if (type.string === null) return true;
                if (type.string === value) return true;
                break;
            case "number":
                if (IsNumberType(type)) {
                    if (type.minValue !== undefined) break;
                    if (type.maxValue !== undefined) break;
                    if (type.integer) break;
                }
                if (type.number === null) return true;
                if (type.number === value) return true;
                break;
            case "boolean":
                if (type.boolean === null) return true;
                if (type.boolean === value) return true;
                break;
        }
    } else if (typeof type === "string") switch(type){
        case "string":
            return t === "string";
        case "number":
            return t === "number";
        case "integer":
            return t === "number" && Number.isInteger(value);
        case "function":
            return t === "function";
        case "void":
            return t === "undefined";
        case "symbol":
            return t === "symbol";
        case "boolean":
            return t === "boolean";
        case "null":
            return value === null;
        case "undefined":
            return value === undefined;
        case "any":
            return true;
        case "unknown":
        case "never":
            return false;
    }
    // Fast path for successful matches using fast JIT'ed checker
    if (typeof type === "object" && (0, $g0jSz.MatchesTypeJIT)(type, value, validate)) return true;
    return false;
}
function MatchesType(value, type, /** If true, the function will return on the first error.
 *  If false, the function will find all errors before returning.
 */ fast = true, /** If true, this function will report overposting/superfluous props as errors.
 *  If false, superfluous props will be ignored.
 */ strict = false, /** If true, this function will include validator functions as part of asserting a value's
 *  conformance to a type. If false, validator functions will be ignored.
 */ validate = true, path = "") {
    const turboMatch = MatchesTypeTurbo(value, type, validate);
    if (turboMatch) return true;
    if (typeof type === "object") {
        if (validate && type.validator) try {
            value = ValidateType(value, type);
        } catch (e) {
            return {
                error: e.message,
                fields: e.fields,
                path: path
            };
        }
    }
    // Fast matcher failed, producing proper error message
    const t = typeof value;
    if (typeof t === "string") switch(type){
        case "string":
            return t === "string" ? true : {
                error: "Expected string, got " + t,
                path: path
            };
        case "number":
            return t === "number" ? true : {
                error: "Expected number, got " + t,
                path: path
            };
        case "boolean":
            return t === "boolean" ? true : {
                error: "Expected boolean, got " + t,
                path: path
            };
        case "null":
            return value === null ? true : {
                error: "Expected null, got " + t,
                path: path
            };
        case "undefined":
            return value === undefined ? true : {
                error: "Expected undefined, got " + t,
                path: path
            };
    }
    if (IsObjectType(type)) {
        if (value === null) return {
            error: "Expected object, got null",
            path: path
        };
        if (t !== "object") return {
            error: "Expected object, got " + typeOf(value),
            path: path
        };
        const props = type.props;
        const getSuperfluousProps = ()=>Object.keys(value).filter((x)=>!props.some((y)=>x === y.name));
        const subErrors = [];
        for (const p of props){
            const optional = p.optional || AreTypesAssignable(p.type, "undefined");
            if (optional && value[p.name] === undefined) continue;
            if (!optional && !(p.name in value)) {
                subErrors.push({
                    error: "Missing required property " + p.name,
                    subErrors: [],
                    path: path
                });
                if (fast) break;
            }
            const res = MatchesType(value[p.name], p.type, fast, strict, validate, path ? path + "." + p.name : p.name);
            if (res !== true) {
                subErrors.push({
                    error: "Property '" + p.name + "' did not match",
                    subErrors: [
                        res
                    ],
                    path: path
                });
                if (fast) break;
            }
        }
        if (strict) {
            const extraProps = getSuperfluousProps();
            if (extraProps.length > 0) subErrors.push({
                error: "The following props were present but not expected",
                subErrors: extraProps.map((x)=>({
                        error: x,
                        path: path
                    })),
                path: path
            });
        }
        if (subErrors.length > 0) return {
            error: "Did not match object type " + TypeToString(type),
            subErrors: subErrors,
            path: path
        };
        return true;
    } else if (IsArrayType(type)) {
        if (!(value instanceof Array)) return {
            error: "Expected array, got " + typeOf(value),
            path: path
        };
        const subErrors = [];
        const len = value.length;
        for(let i = 0; i < len; i++){
            const res = MatchesType(value[i], type.array, fast, strict, validate, path + "[" + i + "]");
            if (res !== true) {
                subErrors.push({
                    error: "Element at index " + i + " did not match",
                    subErrors: [
                        res
                    ],
                    path: path
                });
                if (fast) break;
            }
        }
        if (subErrors.length === 1) return {
            error: "An item does not match expected type " + TypeToString(type.array),
            subErrors: subErrors,
            path: path
        };
        else if (subErrors.length > 1 && subErrors.length < value.length) return {
            error: subErrors.length + " out of " + value.length + " items do not match expected type " + TypeToString(type.array),
            subErrors: subErrors,
            path: path
        };
        else if (subErrors.length) return {
            error: "None of the items match expected type " + TypeToString(type.array),
            subErrors: subErrors,
            path: path
        };
        return true;
    } else if (IsAnyType(type)) return true;
    else if (IsNullType(type)) return value === null ? true : {
        error: "Expected null, got " + typeOf(value),
        path: path
    };
    else if (IsUnionType(type)) {
        const d = Discriminate(value, type);
        if (d !== type) {
            const res = MatchesType(value, d, fast, strict, true, "(" + path + " as " + TypeToString(d) + ")");
            if (res === true) return true;
            else return {
                error: "Did not match discriminated type " + TypeToString(d),
                subErrors: [
                    res
                ],
                path: path
            };
        } else {
            const results = type.union.map((x)=>MatchesType(value, x, fast, strict, true, TypeToString(x)));
            if (results.some((x)=>x === true)) return true;
            else return {
                error: "Did not match any types in the union " + TypeToString(type),
                subErrors: results.filter((x)=>typeof x === "object"),
                path: path
            };
        }
    } else if (IsIntersectionType(type)) {
        const subErrors = [];
        for (const x of type.intersection){
            const err = MatchesType(value, x, fast, false, validate);
            if (err !== true) subErrors.push(err);
        }
        if (subErrors.length === 0 && strict && typeof value === "object" && value !== null) {
            const props = GetTypeProps(type);
            Object.keys(value).forEach((x)=>{
                if (!props.find((y)=>y.name === x)) subErrors.push({
                    error: "Property '" + x + "' was not expected in type " + TypeToString(type),
                    path: path
                });
            });
        }
        if (subErrors.length > 0) return {
            error: "Did not match intersection " + TypeToString(type),
            subErrors: subErrors,
            path: path
        };
        return true;
    } else if (IsVoidType(type)) return value === undefined ? true : {
        error: "Expected void, got a value",
        path: path
    };
    else if (IsUnknownType(type)) return {
        error: "No value is compatible with 'unknown'",
        path: path
    };
    else if (IsUndefinedType(type)) return t === "undefined" ? true : {
        error: "Expected undefined, got " + typeOf(value),
        path: path
    };
    else if (IsFileType(type)) {
        if (t !== "string") return {
            error: "Expected file handle, got " + JSON.stringify(value),
            path: path
        };
        if (value.startsWith("http://") || value.startsWith("https://")) return {
            error: "Expected file handle, got URL: " + value,
            path: path
        };
        if (!(0, $dAwef.Uuid).validate(value)) return {
            error: "Expected UUID file handle, got " + JSON.stringify(value),
            path: path
        };
        return true;
    } else if (IsStringType(type)) {
        if (typeof type === "object") {
            if (type.string !== null && value !== type.string) return {
                error: "Expected '" + type.string + "', got " + JSON.stringify(value),
                path: path
            };
            if (type.string === null) {
                if (t !== "string") return {
                    error: "Expected string, got " + typeOf(value),
                    path: path
                };
            }
        }
        return true;
    } else if (IsNumberType(type)) {
        if (type === "integer" || typeof type === "object" && type.integer) {
            if ((value | 0) !== value) return {
                error: "Expected integer, got " + JSON.stringify(value),
                path: path
            };
        }
        if (typeof type === "object") {
            if (type.number !== null) {
                if (value !== type.number) return {
                    error: "Expected " + type.number + ", got " + typeOf(value),
                    path: path
                };
            }
            if (type.maxValue !== undefined) {
                if (value > type.maxValue) return {
                    error: "Maximum value is " + type.maxValue + ", got " + value,
                    path: path
                };
            }
            if (type.minValue !== undefined) {
                if (value < type.minValue) return {
                    error: "Minimum value is " + type.minValue + ", got " + value,
                    path: path
                };
            }
        }
        if (t !== "number") return {
            error: "Expected number, got " + typeOf(value),
            path: path
        };
        return true;
    } else if (IsBooleanType(type)) {
        if (t !== "boolean") return {
            error: "Expected boolean, got " + typeOf(value),
            path: path
        };
        if (typeof type === "object" && type.boolean !== null) {
            if (type.boolean === value) return true;
            else return {
                error: "Expected '" + type.boolean + "', got " + value,
                path: path
            };
        } else return true;
    }
    throw new Error("Unhandled type: " + TypeToString(type));
}
function EnumerateTypeOptions(type, result = []) {
    if (IsUnionType(type)) type.union.forEach((t)=>EnumerateTypeOptions(t, result));
    else result.push(type);
    return result;
}
const isStringLiteralUnionCache = new Map();
let discriminateDepth = 0;
function Discriminate(value, union) {
    if (union.ifDefinedCache) {
        if (value === undefined) return "undefined";
        return union.ifDefinedCache;
    } else if (union.union.length === 2) {
        const t = union.union.filter((x)=>!IsUndefinedType(x));
        if (t.length === 1) {
            union.ifDefinedCache = t[0];
            if (value === undefined) return "undefined";
            return union.ifDefinedCache;
        }
    }
    const alias = GetTypeAlias(union);
    const plugin = alias && Discriminate.plugins.get(alias);
    if (plugin) return plugin(value, union);
    if (discriminateDepth > 8) {
        console.log("Warning - deep type recursion, unable to discriminate " + TypeToString(union));
        // Probably a recursive definition - unable to discriminate
        return union;
    }
    discriminateDepth++;
    try {
        if (typeof value === "object" && value !== null) {
            let d = discriminatorCache.get(union);
            if (!d) {
                const u = FlattenTypeIntersections(union);
                d = FindDiscriminator(u);
                if (d) discriminatorCache.set(union, d);
            }
            if (d) {
                const key = value[d.prop];
                return d.mapping[key] || union;
            }
        }
        // A common case that becomes a performance issue is to discriminate large string unions
        // (enums). This optimizes that case.
        let stringLiteralUnion = isStringLiteralUnionCache.get(union);
        if (stringLiteralUnion === undefined) {
            stringLiteralUnion = union.union.every(IsStringLiteral) ? new Map(union.union.map((t)=>[
                    t.string,
                    t
                ])) : false;
            isStringLiteralUnionCache.set(union, stringLiteralUnion);
        }
        if (stringLiteralUnion) {
            const stringLiteral = stringLiteralUnion.get(value);
            if (stringLiteral) return stringLiteral;
        }
        const types = union.union.filter((x)=>MatchesTypeTurbo(value, x, false));
        if (types.length === 1) return types[0];
        // Try resolving the ambiguous match by matching again in strict mode (#75)
        const types2 = union.union.filter((x)=>MatchesTypeTurbo(value, x, false));
        if (types2.length === 1) return types2[0];
        return union;
    } finally{
        discriminateDepth--;
    }
}
Discriminate.plugins = new Map();
function DiscriminatePlugin(alias, discriminate) {
    Discriminate.plugins.set(alias, discriminate);
}
const discriminatorCache = new WeakMap();
function FindDiscriminator(u) {
    let discriminator = discriminatorCache.get(u);
    if (!discriminator) {
        const t = u.union[0];
        if (IsObjectType(t)) {
            discriminator = t.props.map((p)=>buildDiscriminatorProp(u, {
                    prop: p.name,
                    mapping: {}
                })).find((x)=>!!x);
            if (discriminator) discriminatorCache.set(u, discriminator);
        }
    }
    return discriminator;
}
function buildDiscriminatorProp(t, context) {
    if (IsObjectType(t)) {
        const p = t.props.find((x)=>x.name === context.prop);
        return p && buildDiscriminatorMapping(p.type, t, context);
    } else if (IsUnionType(t)) {
        for (const u of t.union){
            if (!buildDiscriminatorProp(u, context)) return undefined;
        }
        return context;
    }
}
function buildDiscriminatorMapping(propType, targetType, context) {
    if (IsStringLiteral(propType)) {
        context.mapping[propType.string] = targetType;
        return context;
    } else if (IsUnionType(propType)) {
        if (propType.union.every((u)=>buildDiscriminatorMapping(u, targetType, context))) return context;
    }
}
const flattenedTypesCache = new WeakMap();
function FlattenTypeIntersections(type) {
    if (typeof type === "string") return type;
    let flat = flattenedTypesCache.get(type);
    if (!flat) {
        flat = FlattenTypeIntersectionsUncached(type);
        flattenedTypesCache.set(type, flat);
    }
    return flat;
}
function FlattenTypeIntersectionsUncached(type) {
    let t = typeof type === "string" ? type : (0, $3oicm.CloneGraph)(type);
    let keepGoing = true;
    while(keepGoing){
        keepGoing = false;
        t = new class extends (0, $cv7r0.Visitor) {
            intersection(i) {
                var _a;
                // (T & (T | undefined)) -> T
                if (i.intersection.length === 2) {
                    if (AreTypesAssignableBothWays(i.intersection[0], UnionType(i.intersection[1], UndefinedType))) return i.intersection[1];
                    if (AreTypesAssignableBothWays(i.intersection[1], UnionType(i.intersection[0], UndefinedType))) return i.intersection[0];
                }
                if (i.intersection.every(IsObjectType)) {
                    keepGoing = true;
                    const props = i.intersection.map((x)=>x.props).reduce((a, b)=>a.concat(b), [])// Shallow copy the props, as we will be modifying their optionality
                    .map((p)=>Object.assign({}, p));
                    // If properties occur multiple times in the intersection,
                    // compute the intersection of the property types and optionality
                    for(let n = 0; n < props.length; n++){
                        for(let m = n + 1; m < props.length; m++)if (props[m].name === props[n].name) {
                            if (!props[m].optional) props[n].optional = false;
                            props[n].type = FlattenTypeIntersections(IntersectionType(props[n].type, props[m].type));
                            props.splice(m, 1);
                        }
                    }
                    const objType = {
                        props: props,
                        additionalProps: (_a = i.intersection.find((x)=>x.additionalProps)) === null || _a === void 0 ? void 0 : _a.additionalProps,
                        alias: i.alias,
                        documentation: i.documentation
                    };
                    return objType;
                }
            }
        }().type(t) || t;
    }
    return t;
}
function IsTypeOrUndefined(type, isType) {
    if (IsUnionType(type) && type.union.length === 2) {
        if (isType(type.union[0]) && IsUndefinedType(type.union[1])) return type.union[0];
        else if (isType(type.union[1]) && IsUndefinedType(type.union[0])) return type.union[1];
    }
}
function IsStringOrUndefinedType(type) {
    return IsTypeOrUndefined(type, IsStringType);
}
function IsNumberOrUndefinedType(type) {
    return IsTypeOrUndefined(type, IsNumberType);
}
function VisitType(type, visitor, visitedSet = new Set(), path = []) {
    var _a;
    if (visitedSet.has(type)) return;
    visitedSet.add(type);
    visitor(type, path);
    if (typeof type === "object") (_a = type.typeArgs) === null || _a === void 0 || _a.forEach((x)=>VisitType(x, visitor, visitedSet, path));
    if (IsObjectType(type)) {
        type.props.forEach((x)=>VisitType(x.type, visitor, visitedSet, [
                ...path,
                x.name
            ]));
        if (type.additionalProps) VisitType(type.additionalProps, visitor, visitedSet, [
            ...path,
            "additionalProps"
        ]);
    } else if (IsArrayType(type)) VisitType(type.array, visitor, visitedSet, path);
    else if (IsUnionType(type)) {
        const disc = FindDiscriminator(type);
        type.union.forEach((x, i)=>{
            var _a;
            const dp = GetTypeProps(x).find((p)=>p.name === (disc === null || disc === void 0 ? void 0 : disc.prop));
            const name = dp ? IsStringLiteral(dp.type) ? dp.type.string : undefined : undefined;
            VisitType(x, visitor, visitedSet, [
                ...path,
                (_a = name !== null && name !== void 0 ? name : GetTypeAlias(x)) !== null && _a !== void 0 ? _a : i.toString()
            ]);
        });
    } else if (IsIntersectionType(type)) type.intersection.forEach((x, i)=>VisitType(x, visitor, visitedSet, [
            ...path,
            GetTypeAlias(x) || i.toString()
        ]));
}
function ContainsType(type, predicate) {
    let res = false;
    VisitType(type, (x)=>{
        if (predicate(x)) res = true;
    });
    return res;
}
function ReplaceTypes(t, replacer, visitedSet = new Map(), /**
 * Whether to continue recursing after a successful replacement.
 *
 * This can cause infinite recursion if the replacer function in some cases.
 * Defaults to true, can be turned off if problematic.
 */ recurseAfterReplace = true) {
    const visited = visitedSet.get(t);
    if (visited) return visited;
    const type = replacer(t);
    visitedSet.set(t, type);
    if (type !== t && !recurseAfterReplace) return type;
    if (typeof type === "object") {
        const args = type.typeArgs;
        if (args) for(let i = 0; i < args.length; i++)args[i] = ReplaceTypes(args[i], replacer, visitedSet, recurseAfterReplace);
    }
    if (IsObjectType(type)) {
        type.props.forEach((x, i)=>type.props[i].type = ReplaceTypes(x.type, replacer, visitedSet, recurseAfterReplace));
        if (type.additionalProps) type.additionalProps = ReplaceTypes(type.additionalProps, replacer, visitedSet, recurseAfterReplace);
    } else if (IsArrayType(type)) type.array = ReplaceTypes(type.array, replacer, visitedSet, recurseAfterReplace);
    else if (IsUnionType(type)) type.union.forEach((x, i)=>type.union[i] = ReplaceTypes(x, replacer, visitedSet, recurseAfterReplace));
    else if (IsIntersectionType(type)) type.intersection.forEach((x, i)=>type.intersection[i] = ReplaceTypes(x, replacer, visitedSet, recurseAfterReplace));
    return type;
}
function ReplaceValuesByType(value, type, /** Returns the new value to replace the existing one with.
 *  Return the incoming `value` to leave it unchanged.
 */ replacer, visitedObjects = new Set(), path = []) {
    const dt = (0, $cwhCA.SubstituteAndDiscriminate)(value, type);
    if (dt !== type) return ReplaceValuesByType(value, dt, replacer, visitedObjects, path);
    value = replacer(value, type, path);
    if ((IsObjectType(type) || IsIntersectionType(type)) && typeof value === "object") {
        if (visitedObjects.has(value)) return value;
        visitedObjects.add(value);
        const props = GetTypeProps(type);
        props.forEach((x)=>{
            if (x.name in value) value[x.name] = ReplaceValuesByType(value[x.name], x.type, replacer, visitedObjects, [
                ...path,
                x.name
            ]);
        });
        if (IsObjectType(type)) {
            const { additionalProps } = type;
            if (additionalProps) Object.keys(value).forEach((key)=>{
                if (!type.props.some((x)=>x.name === key)) value[key] = ReplaceValuesByType(value[key], additionalProps, replacer, visitedObjects, [
                    ...path,
                    key
                ]);
            });
        }
    } else if (IsArrayType(type) && value instanceof Array) {
        if (visitedObjects.has(value)) return value;
        visitedObjects.add(value);
        value.forEach((x, i)=>value[i] = ReplaceValuesByType(x, type.array, replacer, visitedObjects, [
                ...path,
                i
            ]));
    }
    return value;
}
function VisitPropertiesByType(value, type, /** Returns the new value to replace the existing one with.
 *  Return the incoming `value` to leave it unchanged.
 */ visitor, path = [], /** The property currently being visited. If unspecified, this root node will not be visited,
 * only its subtree. */ property, visitedObjects = new Set()) {
    property !== null && property !== void 0 ? property : property = {
        name: "$root",
        type: type
    };
    if (IsUnionType(type)) {
        const dt = Discriminate(value, type);
        if (dt !== type) {
            VisitPropertiesByType(value, dt, visitor, path, property, visitedObjects);
            return;
        }
    }
    if (property) visitor(value, property, path);
    // This allows visiting the subtree of WebPage sections
    type = (0, $cwhCA.SubstituteAndDiscriminate)(value, type);
    if ((IsObjectType(type) || IsIntersectionType(type)) && typeof value === "object") {
        if (visitedObjects.has(value)) return;
        visitedObjects.add(value);
        GetTypeProps(type).forEach((p)=>{
            if (p.name in value) VisitPropertiesByType(value[p.name], p.type, visitor, [
                ...path,
                p.name
            ], p, visitedObjects);
        });
        if (IsObjectType(type)) {
            const { additionalProps } = type;
            if (additionalProps) Object.keys(value).forEach((key)=>{
                if (!type.props.some((x)=>x.name === key)) VisitPropertiesByType(value[key], additionalProps, visitor, [
                    ...path,
                    key
                ], {
                    name: key,
                    type: additionalProps
                }, visitedObjects);
            });
        }
    } else if (IsArrayType(type) && value instanceof Array) {
        if (visitedObjects.has(value)) return;
        visitedObjects.add(value);
        value.forEach((x, i)=>VisitPropertiesByType(x, type.array, visitor, [
                ...path,
                i.toString()
            ], {
                name: i.toString(),
                type: type.array
            }, visitedObjects));
    }
    return;
}

});
parcelRegister("14q7s", function(module, exports) {

$parcel$export(module.exports, "GetFileTypeMimeTypes", function () { return $0c7a6cef28e734b1$export$d452d10e32b524e4; });
$parcel$export(module.exports, "ImageToUrl", function () { return $0c7a6cef28e734b1$export$d85247f7a9f240bc; });
$parcel$export(module.exports, "UndoImageToUrl", function () { return $0c7a6cef28e734b1$export$3699a36e09881599; });
$parcel$export(module.exports, "ImageToCSS", function () { return $0c7a6cef28e734b1$export$b6be8aee23e40625; });
$parcel$export(module.exports, "FileToUrl", function () { return $0c7a6cef28e734b1$export$6a9e367146026a4; });

var $7m9cQ = parcelRequire("7m9cQ");

var $43jhg = parcelRequire("43jhg");
function $0c7a6cef28e734b1$export$d452d10e32b524e4(type) {
    if ((0, $43jhg.IsUnionType)(type)) return type.union.map($0c7a6cef28e734b1$export$d452d10e32b524e4).reduce((a, b)=>[
            ...a,
            ...b
        ]);
    if ((0, $43jhg.IsFileType)(type)) return [
        type.mimeType
    ];
    return [];
}
function $0c7a6cef28e734b1$export$d85247f7a9f240bc(image, options, /** Optimization.
 *
 * Computing the server URL of the request can be slow (due to context-lookup), in
 * performance-critical code the URL for the current request can be precomputed and passed in
 * here. */ serverBaseUrl) {
    // This happens sometimes during WYSIWYG editing, when the image is not yet uploaded.
    if (!image) return "";
    // On the client, the image is already a full URL. We need to undo that to encode the new options.
    const url = $0c7a6cef28e734b1$export$3699a36e09881599(image);
    const width = (options === null || options === void 0 ? void 0 : options.width) || "";
    const height = (options === null || options === void 0 ? void 0 : options.height) ? "x" + options.height : "";
    const ext = (options === null || options === void 0 ? void 0 : options.format) ? "." + options.format : ".png";
    serverBaseUrl !== null && serverBaseUrl !== void 0 ? serverBaseUrl : serverBaseUrl = (0, $7m9cQ.server)();
    return (url.startsWith(serverBaseUrl) ? url : `${serverBaseUrl}/api/images/${url}`) + `_${width}${height}${ext}`;
}
function $0c7a6cef28e734b1$export$3699a36e09881599(/** An image handle that might be in a full URL form. */ image) {
    let str = image.valueOf();
    const lastSlash = str.lastIndexOf("/");
    if (lastSlash !== -1) str = str.slice(lastSlash + 1);
    const lastUnderscore = str.lastIndexOf("_");
    if (lastUnderscore !== -1) str = str.slice(0, lastUnderscore);
    return str;
}
function $0c7a6cef28e734b1$export$b6be8aee23e40625(image, options) {
    let str = image.valueOf();
    if (str.toString().startsWith("url(")) str = str.slice(4, -1);
    return "url(" + $0c7a6cef28e734b1$export$d85247f7a9f240bc(image, options) + ")";
}
function $0c7a6cef28e734b1$export$c88e32e07e07186b(video, options, /** Optimization.
 *
 * Computing the server URL of the request can be slow (due to context-lookup), in
 * performance-critical code the URL for the current request can be precomputed and passed in
 * here. */ serverBaseUrl) {
    // This happens sometimes during WYSIWYG editing, when the video is not yet uploaded.
    if (!video) return "";
    // On the client, the video is already a full URL. We need to undo that to encode the new options.
    const url = $0c7a6cef28e734b1$export$3699a36e09881599(video);
    const ext = (options === null || options === void 0 ? void 0 : options.format) ? "." + options.format : ".mp4";
    serverBaseUrl !== null && serverBaseUrl !== void 0 ? serverBaseUrl : serverBaseUrl = (0, $7m9cQ.server)();
    return (url.startsWith(serverBaseUrl) ? url : `${serverBaseUrl}/api/videos/${url}`) + `${ext}`;
}
function $0c7a6cef28e734b1$export$6a9e367146026a4(file, /** Optimization.
 *
 * Computing the server URL of the request can be slow (due to context-lookup), in
 * performance-critical code the URL for the current request can be precomputed and passed in
 * here. */ serverBaseUrl) {
    serverBaseUrl !== null && serverBaseUrl !== void 0 ? serverBaseUrl : serverBaseUrl = (0, $7m9cQ.server)();
    if (file.toString().startsWith(serverBaseUrl)) return file.toString();
    return `${serverBaseUrl}/api/files/${file.toString()}`;
}

});

parcelRegister("g0jSz", function(module, exports) {

$parcel$export(module.exports, "MatchesTypeJIT", function () { return MatchesTypeJIT; });

var $43jhg = parcelRequire("43jhg");
const cache = new WeakMap();
const noValidateCache = new WeakMap();
function MatchesTypeJIT(type, value, validate = true) {
    if (validate) {
        let jit = cache.get(type);
        if (!jit) {
            jit = JIT(type, true);
            cache.set(type, jit);
        }
        return jit(value);
    } else {
        let jit = noValidateCache.get(type);
        if (!jit) {
            jit = JIT(type, false);
            noValidateCache.set(type, jit);
        }
        return jit(value);
    }
}
function JIT(type, validate) {
    const args = [];
    const argNames = [];
    function registerArg(value, argName) {
        args.push(value);
        argNames.push(argName);
        return argName;
    }
    let varCount = 0;
    function variable() {
        varCount++;
        return "v" + varCount;
    }
    const inlineFuncs = new Map();
    function exp(t, p, ignoreValidator = false, ignoreAlias = false) {
        const alias = (0, $43jhg.GetTypeAlias)(t);
        if (!ignoreAlias && alias) {
            if (!inlineFuncs.has(alias)) {
                inlineFuncs.set(alias, "(temp)"); // prevent infinite recursion
                inlineFuncs.set(alias, `function ${alias}(v) { return ${exp(t, "v", ignoreValidator, true)} }`);
            }
            return `${alias}(${p})`;
        }
        if (validate && !ignoreValidator && typeof t === "object" && "validator" in t) {
            const arg = registerArg((0, $43jhg.GetTypeValidator)(t), t.alias + "_validator");
            return `( ${exp(t, p, true, ignoreAlias)} && try_validate(${p},${arg}))`;
        }
        if ((0, $43jhg.IsFileType)(t)) // Check that the value is a valid UUID file handle
        return `((typeof ${p}) === 'string' && /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i.test(${p}))`;
        if ((0, $43jhg.IsStringType)(t)) {
            if (t === "string" || t.string === null) return `((typeof ${p}) === 'string')`;
            else return `(${p} === ${JSON.stringify(t.string)})`;
        }
        if ((0, $43jhg.IsBooleanType)(t)) {
            if (t === "boolean" || t.boolean === null) return `((typeof ${p}) === 'boolean')`;
            else return `(${p} === ${JSON.stringify(t.boolean)})`;
        }
        if ((0, $43jhg.IsNumberType)(t)) {
            if (t === "number") return `((typeof ${p}) === 'number')`;
            const isInteger = `((${p}|0) === ${p})`;
            if (t === "integer") return `((typeof ${p}) === 'number' && ${isInteger})`;
            let ee = t.number === null ? `((typeof ${p}) === 'number')` : `(${p} === ${JSON.stringify(t.number)})`;
            if (t.minValue !== undefined) ee = `( ${ee} && ${p} >= ${t.minValue})`;
            if (t.maxValue !== undefined) ee = `( ${ee} && ${p} <= ${t.maxValue})`;
            if (t.integer) ee = `( ${ee} && ${isInteger} )`;
            return ee;
        }
        if ((0, $43jhg.IsIntersectionType)(t)) return "(" + t.intersection.map((x)=>exp(x, p)).reduce(and) + ")";
        if ((0, $43jhg.IsUnionType)(t)) return t.union.length ? `(${t.union.map((x)=>exp(x, p)).reduce(or)})` : // the type must match at least one of the union types.
        `false`;
        if ((0, $43jhg.IsObjectType)(t)) {
            const props = t.props.map((prop)=>prop.optional ? `((${p + `[${JSON.stringify(prop.name)}]`} === undefined) || ${exp(prop.type, p + `[${JSON.stringify(prop.name)}]`)})` : `('${prop.name}' in ${p} && ${exp(prop.type, p + `[${JSON.stringify(prop.name)}]`)})`);
            return `(${p} !== null && (typeof ${p}) === 'object'${props.length ? " && " + props.reduce(and) : ""})`;
        }
        if ((0, $43jhg.IsUndefinedType)(t)) return `(${p} === undefined)`;
        if ((0, $43jhg.IsNullType)(t)) return `(${p} === null)`;
        if ((0, $43jhg.IsAnyType)(t) || (0, $43jhg.IsUnknownType)(t)) return `true`;
        if ((0, $43jhg.IsArrayType)(t)) {
            const v = variable();
            return `((${p} instanceof Array) && ${p}.every(${v} => ${exp(t.array, v)}))`;
        }
        if ((0, $43jhg.IsVoidType)(t)) return `(${p} === undefined)`;
        throw new Error("Unhandled type in MatchesTypeJIT: " + (0, $43jhg.TypeToString)(t));
    }
    const res = exp(type, "v");
    const e = `(function(${argNames.join(",")})
{
    function try_validate(v, validator) {
        try {
            validator(v)
        }
        catch(e) {
            return false
        }
        return true
    }
    ${Array.from(inlineFuncs.values()).join("\n")}
    return function(v) { return ${res} }
})`;
    // eslint-disable-next-line no-eval
    return eval(e)(...args);
}
function and(a, b) {
    return a + " && " + b;
}
function or(a, b) {
    return a + " || " + b;
}

});

parcelRegister("lHoPV", function(module, exports) {

$parcel$export(module.exports, "TypeValidator", function () { return $fcc0e121744d5810$export$9ced0f77dc6abfd7; });
/** Registers a type validator function.
 *
 *  See `docs/Type validators.md`
 */ function $fcc0e121744d5810$export$9ced0f77dc6abfd7(func) {
    $fcc0e121744d5810$export$9ced0f77dc6abfd7.functions.push(func);
}
$fcc0e121744d5810$export$9ced0f77dc6abfd7.functions = [];

});

parcelRegister("cv7r0", function(module, exports) {

$parcel$export(module.exports, "Visitor", function () { return $919e25a5701e386b$export$9d54d4ec2dd4b364; });

var $43jhg = parcelRequire("43jhg");
class $919e25a5701e386b$export$9d54d4ec2dd4b364 {
    constructor(){
        this.visitedAliases = new Set();
        this.visited = new Set();
    }
    type(t) {
        if (this.visited.has(t)) return;
        this.visited.add(t);
        // For some reason, the above is not enough to prevent all forms of infinite recursion. Also
        // testing for aliases fixes the problems seen so far, but there is probably a better
        // fix(tm) waiting to be found.
        const alias = (0, $43jhg.GetTypeAlias)(t);
        if (alias) {
            if (this.visitedAliases.has(alias)) return;
            this.visitedAliases.add(alias);
        }
        if ((0, $43jhg.IsUnionType)(t)) return this.union(t);
        else if ((0, $43jhg.IsIntersectionType)(t)) return this.intersection(t);
        else if ((0, $43jhg.IsObjectType)(t)) return this.object(t);
        else if ((0, $43jhg.IsArrayType)(t)) return this.array(t);
        else if ((0, $43jhg.IsAtomic)(t)) return this.atomic(t);
        else if ((0, $43jhg.IsUndefinedType)(t)) return this.undefined(t);
        else if ((0, $43jhg.IsNullType)(t)) return this.null(t);
        else if ((0, $43jhg.IsAnyType)(t)) return this.any(t);
        else if ((0, $43jhg.IsVoidType)(t)) return this.void(t);
        else if ((0, $43jhg.IsParameterType)(t)) return this.parameter(t);
        else if ((0, $43jhg.IsNeverType)(t)) return this.never(t);
        else if ((0, $43jhg.IsUnknownType)(t)) return this.unknown(t);
        else if ((0, $43jhg.IsPromiseType)(t)) return this.promise(t);
        else if ((0, $43jhg.IsAsyncGeneratorType)(t)) return this.asyncGenerator(t);
        else if ((0, $43jhg.IsFunctionType)(t)) return this.func(t);
        else if ((0, $43jhg.IsFileType)(t)) return this.file(t);
        else if (t === "symbol") return;
        else throw new Error("Unhandled type in Visitor: " + (0, $43jhg.TypeToString)(t));
    }
    never(t) {}
    unknown(t) {}
    promise(t) {}
    asyncGenerator(t) {}
    func(t) {}
    parameter(t) {}
    void(v) {}
    any(t) {}
    null(n) {}
    undefined(u) {}
    file(f) {}
    union(u) {
        let anyChanged = false;
        const nu = {
            alias: u.alias,
            documentation: u.documentation,
            typeArgs: u.typeArgs,
            union: u.union.map((x, i)=>{
                const nt = this.type(x);
                if (nt) {
                    anyChanged = true;
                    return nt;
                } else return x;
            })
        };
        if (anyChanged) return nu;
    }
    intersection(i) {
        let anyChanged = false;
        const ni = {
            alias: i.alias,
            documentation: i.documentation,
            typeArgs: i.typeArgs,
            intersection: i.intersection.map((x)=>{
                const nt = this.type(x);
                if (nt) {
                    anyChanged = true;
                    return nt;
                } else return x;
            })
        };
        if (anyChanged) return ni;
    }
    object(o) {
        const nap = o.additionalProps && (this.type(o.additionalProps) || o.additionalProps);
        let anyChanged = nap !== o.additionalProps;
        const no = {
            alias: o.alias,
            documentation: o.documentation,
            isClass: o.isClass,
            super: o.super,
            typeArgs: o.typeArgs,
            props: o.props.map((p)=>{
                const np = this.property(p);
                if (np) {
                    anyChanged = true;
                    return np;
                } else return p;
            }),
            additionalProps: nap ? nap : undefined
        };
        if (anyChanged) return no;
    }
    property(p) {
        const type = this.type(p.type);
        if (type) return Object.assign(Object.assign({}, p), {
            type: type
        });
    }
    array(a) {
        const t = this.type(a.array);
        if (t) return Object.assign(Object.assign({}, a), {
            array: t
        });
    }
    atomic(a) {}
}

});




parcelRegister("dbwyW", function(module, exports) {
$parcel$export(module.exports, "CurrencyCode", function () { return (parcelRequire("2zTLn")).CurrencyCode; });
$parcel$export(module.exports, "CountryCode", function () { return (parcelRequire("97R5C")).CountryCode; });
$parcel$export(module.exports, "ParseDateTimePrecision", function () { return (parcelRequire("4vUfp")).ParseDateTimePrecision; });
$parcel$export(module.exports, "Timestamp", function () { return (parcelRequire("4vUfp")).Timestamp; });
$parcel$export(module.exports, "Email", function () { return (parcelRequire("2uVAW")).Email; });
$parcel$export(module.exports, "Markdown", function () { return (parcelRequire("gGZ2r")).Markdown; });
$parcel$export(module.exports, "NonNegativeInteger", function () { return (parcelRequire("fR074")).NonNegativeInteger; });
$parcel$export(module.exports, "PhoneNumber", function () { return (parcelRequire("4QAvl")).PhoneNumber; });
$parcel$export(module.exports, "Url", function () { return (parcelRequire("iXeBy")).Url; });
$parcel$export(module.exports, "Uuid", function () { return (parcelRequire("dAwef")).Uuid; });
parcelRequire("2zTLn");
parcelRequire("97R5C");
parcelRequire("4vUfp");
parcelRequire("2uVAW");
parcelRequire("6oG4E");
parcelRequire("gGZ2r");
parcelRequire("fR074");
parcelRequire("iDHvF");
parcelRequire("eHTbG");
parcelRequire("4QAvl");
parcelRequire("gBv4p");
parcelRequire("iXeBy");
parcelRequire("dAwef");

});
parcelRegister("2zTLn", function(module, exports) {

$parcel$export(module.exports, "CurrencyCode", function () { return $1e0a1b0afa9066a3$export$6e3fca9a737174b; });

var $lHoPV = parcelRequire("lHoPV");
function $1e0a1b0afa9066a3$export$6e3fca9a737174b(currency) {
    const currencyCode = currency;
    if ($1e0a1b0afa9066a3$export$a01df35ce0858603.includes(currencyCode)) return currencyCode;
    throw new Error(`${currency} is not a recognized currency code`);
}
const $1e0a1b0afa9066a3$export$a01df35ce0858603 = [
    "AFA",
    "ALL",
    "DZD",
    "AOA",
    "ARS",
    "AMD",
    "AWG",
    "AUD",
    "AZN",
    "BSD",
    "BHD",
    "BDT",
    "BBD",
    "BYR",
    "BEF",
    "BZD",
    "BMD",
    "BTN",
    "BTC",
    "BOB",
    "BAM",
    "BWP",
    "BRL",
    "GBP",
    "BND",
    "BGN",
    "BIF",
    "KHR",
    "CAD",
    "CVE",
    "KYD",
    "XOF",
    "XAF",
    "XPF",
    "CLP",
    "CNY",
    "COP",
    "KMF",
    "CDF",
    "CRC",
    "HRK",
    "CUC",
    "CZK",
    "DKK",
    "DJF",
    "DOP",
    "XCD",
    "EGP",
    "ERN",
    "EEK",
    "ETB",
    "EUR",
    "FKP",
    "FJD",
    "GMD",
    "GEL",
    "DEM",
    "GHS",
    "GIP",
    "GRD",
    "GTQ",
    "GNF",
    "GYD",
    "HTG",
    "HNL",
    "HKD",
    "HUF",
    "ISK",
    "INR",
    "IDR",
    "IRR",
    "IQD",
    "ILS",
    "ITL",
    "JMD",
    "JPY",
    "JOD",
    "KZT",
    "KES",
    "KWD",
    "KGS",
    "LAK",
    "LVL",
    "LBP",
    "LSL",
    "LRD",
    "LYD",
    "LTL",
    "MOP",
    "MKD",
    "MGA",
    "MWK",
    "MYR",
    "MVR",
    "MRO",
    "MUR",
    "MXN",
    "MDL",
    "MNT",
    "MAD",
    "MZM",
    "MMK",
    "NAD",
    "NPR",
    "ANG",
    "TWD",
    "NZD",
    "NIO",
    "NGN",
    "KPW",
    "NOK",
    "OMR",
    "PKR",
    "PAB",
    "PGK",
    "PYG",
    "PEN",
    "PHP",
    "PLN",
    "QAR",
    "RON",
    "RUB",
    "RWF",
    "SVC",
    "WST",
    "SAR",
    "RSD",
    "SCR",
    "SLL",
    "SGD",
    "SKK",
    "SBD",
    "SOS",
    "ZAR",
    "KRW",
    "XDR",
    "LKR",
    "SHP",
    "SDG",
    "SRD",
    "SZL",
    "SEK",
    "CHF",
    "SYP",
    "STD",
    "TJS",
    "TZS",
    "THB",
    "TOP",
    "TTD",
    "TND",
    "TRY",
    "TMT",
    "UGX",
    "UAH",
    "AED",
    "UYU",
    "USD",
    "UZS",
    "VUV",
    "VEF",
    "VND",
    "YER",
    "ZMK"
];
(0, $lHoPV.TypeValidator)($1e0a1b0afa9066a3$export$a943a6a971a692b0);
function $1e0a1b0afa9066a3$export$a943a6a971a692b0(minorUnits, rounding = Math.round) {
    if (typeof minorUnits !== "number") throw new Error(`CurrencyMinorUnits must be a number, got ${minorUnits}`);
    minorUnits = rounding(minorUnits);
    if (!Number.isInteger(minorUnits)) throw new Error(`CurrencyMinorUnits must be an integer, got ${minorUnits}`);
    return minorUnits;
}
(0, $lHoPV.TypeValidator)($1e0a1b0afa9066a3$export$8029ec46e65f5f2f);
function $1e0a1b0afa9066a3$export$8029ec46e65f5f2f(minorUnits, rounding = Math.round) {
    if (minorUnits < 0) throw new Error(`CurrencyMinorUnitsNonNegative must be non-negative, got ${minorUnits}`);
    return $1e0a1b0afa9066a3$export$a943a6a971a692b0(minorUnits, rounding);
}
function $1e0a1b0afa9066a3$export$abc4224b069a4365(a, currency) {
    switch(currency){
        case "BHD":
        case "IQD":
        case "JOD":
        case "KWD":
        case "LYD":
        case "OMR":
        case "TND":
            return $1e0a1b0afa9066a3$export$c04c0f410a62d82e(a.valueOf() / 1000);
    }
    return $1e0a1b0afa9066a3$export$c04c0f410a62d82e(a.valueOf() / 100);
}
(0, $lHoPV.TypeValidator)($1e0a1b0afa9066a3$export$c04c0f410a62d82e);
function $1e0a1b0afa9066a3$export$c04c0f410a62d82e(majorUnits) {
    if (typeof majorUnits !== "number") throw new Error(`CurencyMajorUnits must be a number, got ${majorUnits}`);
    return majorUnits;
}
(0, $lHoPV.TypeValidator)($1e0a1b0afa9066a3$export$87dfc6c52c55dafa);
function $1e0a1b0afa9066a3$export$87dfc6c52c55dafa(majorUnits) {
    if (majorUnits < 0) throw new Error(`CurrencyMajorUnitsNonNegative must be non-negative, got ${majorUnits}`);
    return majorUnits;
}
const $1e0a1b0afa9066a3$export$502c7752de83fe40 = 0;
function $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc(minorUnits, currency) {
    return Object.freeze({
        minorUnits: minorUnits,
        majorUnits: $1e0a1b0afa9066a3$export$abc4224b069a4365(minorUnits, currency),
        currency: currency
    });
}
$1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc.add = (a, b)=>{
    if (a.currency !== b.currency) throw new Error(`Cannot add amounts in different currencies: ${a.currency} and ${b.currency}`);
    const sum = a.minorUnits.valueOf() + b.minorUnits.valueOf();
    return $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc($1e0a1b0afa9066a3$export$a943a6a971a692b0(sum), a.currency);
};
$1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc.subtract = (a, b)=>{
    if (a.currency !== b.currency) throw new Error(`Cannot subtract amounts in different currencies: ${a.currency} and ${b.currency}`);
    const difference = a.minorUnits.valueOf() - b.minorUnits.valueOf();
    return $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc($1e0a1b0afa9066a3$export$a943a6a971a692b0(difference), a.currency);
};
$1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc.multiply = (a, b, /**
 * The rounding function to use to convert to an integer amount of minor
 * units. Defaults to Math.round, but can be set to e.g. Math.floor or
 * Math.ceil.
 */ rounding = Math.round)=>{
    const product = a.minorUnits.valueOf() * b;
    return $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc($1e0a1b0afa9066a3$export$a943a6a971a692b0(product, rounding), a.currency);
};
$1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc.divide = (a, b, /**
 * The rounding function to use to convert to an integer amount of minor
 * units. Defaults to Math.round, but can be set to e.g. Math.floor or Math.ceil.
 */ rounding = Math.round)=>{
    const quotient = a.minorUnits.valueOf() / b;
    return $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc($1e0a1b0afa9066a3$export$a943a6a971a692b0(quotient, rounding), a.currency);
};
/**
 * Formats a currency amount as a string (in major units) according to the
 * specified locale and options. If no locale or options are specified, the
 * runtime's default locale is used.
 */ $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc.format = (/**
 * The amount of currency.
 */ amount, /**
 * The locale to use for formatting. If not specified, the runtime's default
 * locale is used.
 */ locale, /**
 * Options to pass to the Intl.NumberFormat constructor.
 *
 * The defaults `{ style: "currency", currency: amount.currency }` will be
 * set unless overridden by this parameter.
 */ options)=>{
    const format = new Intl.NumberFormat(locale, Object.assign({
        style: "currency",
        currency: amount.currency
    }, options));
    return format.format(amount.majorUnits.valueOf());
};

});

parcelRegister("97R5C", function(module, exports) {

$parcel$export(module.exports, "CountryCode", function () { return $6a4df2fb9acfbc14$export$34a98f1791d1800e; });
function $6a4df2fb9acfbc14$export$34a98f1791d1800e(country) {
    const countryCode = country;
    if ($6a4df2fb9acfbc14$export$7bc41e2d36612b98.includes(countryCode)) return countryCode;
    throw new Error(`${country} is not a recognized country code`);
}
const $6a4df2fb9acfbc14$export$7bc41e2d36612b98 = [
    "AF",
    "AX",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AQ",
    "AG",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BQ",
    "BA",
    "BW",
    "BV",
    "BR",
    "IO",
    "BN",
    "BG",
    "BF",
    "BI",
    "KH",
    "CM",
    "CA",
    "CV",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CG",
    "CD",
    "CK",
    "CR",
    "CI",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "DK",
    "DJ",
    "DM",
    "DO",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "ET",
    "FK",
    "FO",
    "FJ",
    "FI",
    "FR",
    "GF",
    "PF",
    "TF",
    "GA",
    "GM",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GG",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "VA",
    "HN",
    "HK",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IM",
    "IL",
    "IT",
    "JM",
    "JP",
    "JE",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KP",
    "KR",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MO",
    "MK",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MQ",
    "MR",
    "MU",
    "YT",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "NC",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "MP",
    "NO",
    "OM",
    "PK",
    "PW",
    "PS",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "RE",
    "RO",
    "RU",
    "RW",
    "BL",
    "SH",
    "KN",
    "LC",
    "MF",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SX",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "GS",
    "SS",
    "ES",
    "LK",
    "SD",
    "SR",
    "SJ",
    "SZ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TL",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "UG",
    "UA",
    "AE",
    "GB",
    "US",
    "UM",
    "UY",
    "UZ",
    "VU",
    "VE",
    "VN",
    "VG",
    "VI",
    "WF",
    "EH",
    "YE",
    "ZM",
    "ZW"
];

});

parcelRegister("4vUfp", function(module, exports) {

$parcel$export(module.exports, "ParseDateTimePrecision", function () { return $3495b0420ba46046$export$ad5e9dd1497adaff; });
$parcel$export(module.exports, "Timestamp", function () { return $3495b0420ba46046$export$d9bcbd5e1ff81430; });

var $5cQqO = parcelRequire("5cQqO");

var $lHoPV = parcelRequire("lHoPV");
function $3495b0420ba46046$export$ad5e9dd1497adaff(s) {
    const parts = s.split(" ");
    const units = parts.length === 1 ? 1 : parseInt(parts[0]);
    let unit = parts[parts.length - 1].toLowerCase();
    // allow both plural and singular
    if (unit.endsWith("s")) unit = unit.substring(0, unit.length - 1);
    switch(unit){
        case "year":
        case "month":
        case "day":
        case "hour":
        case "minute":
        case "second":
        case "millisecond":
            return {
                unit: unit,
                units: units
            };
    }
    throw new Error("Invalid date time precision: " + JSON.stringify(s));
}
(0, $lHoPV.TypeValidator)($3495b0420ba46046$export$d9bcbd5e1ff81430);
(0, $5cQqO.TSQFunction)($3495b0420ba46046$export$d9bcbd5e1ff81430);
function $3495b0420ba46046$export$d9bcbd5e1ff81430(d = Date.now()) {
    return new Date(d.valueOf()).toISOString();
}
(0, $lHoPV.TypeValidator)($3495b0420ba46046$export$d37d00a93355eb5e);
(0, $5cQqO.TSQFunction)($3495b0420ba46046$export$d37d00a93355eb5e);
function $3495b0420ba46046$export$d37d00a93355eb5e(d) {
    return d.millisecond() ? d.format("YYYY-MM-DD HH:mm:ss.SSS") : d.format("YYYY-MM-DD HH:mm:ss");
}
/** Formats the string in YYYY[-MM[-DD[Thh:mm[:ss[.000]]]]] format in local time, according to the
 * specified precision. This is the format expected by HTML's <input> tag, conveniently. */ $3495b0420ba46046$export$d9bcbd5e1ff81430.toLocal = function(ds, precision) {
    function pad(s) {
        s = s.toString();
        if (s.length === 1) return "0" + s;
        return s;
    }
    const unit = typeof precision === "string" ? precision : precision.unit;
    const d = new Date(ds.valueOf());
    if (unit === "year") return `${d.getFullYear().toString()}`;
    else if (unit === "month") return `${d.getFullYear().toString()}-${pad(d.getMonth() + 1)}`;
    else {
        const date = `${d.getFullYear().toString()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        if (unit === "day") return date;
        else {
            const hourAndMinutes = pad(d.getHours()) + ":" + pad(d.getMinutes());
            if (unit === "minute") return date + "T" + hourAndMinutes;
            else {
                const hoursAndMinutesAndSeconds = `${hourAndMinutes}:${pad(d.getSeconds())}`;
                if (unit === "second") return date + "T" + hoursAndMinutesAndSeconds;
                else if (unit === "millisecond") {
                    let ms = d.getMilliseconds().toString();
                    while(ms.length < 3)ms = "0" + ms;
                    return `${date}T${hoursAndMinutesAndSeconds}.${ms}`;
                }
            }
        }
    }
    throw new Error("Invalid timestamp precision: " + JSON.stringify(precision));
};
/**
 * Checks if date `a` is after date `b`.
 */ $3495b0420ba46046$export$d9bcbd5e1ff81430.isAfter = function(a, b) {
    return new Date(a.valueOf()) > new Date(b.valueOf());
};
/**
 * Checks if date `a` is before date `b`.
 */ $3495b0420ba46046$export$d9bcbd5e1ff81430.isBefore = function(a, b) {
    return new Date(a.valueOf()) < new Date(b.valueOf());
};
/**
 * Checks if date `a` is identical to date `b` (milliseconds are the same)
 */ $3495b0420ba46046$export$d9bcbd5e1ff81430.isSame = function(a, b) {
    return new Date(a.valueOf()).getTime() === new Date(b.valueOf()).getTime();
};
/**
 * Sort function for Timestamps, sorts ascending
 */ $3495b0420ba46046$export$d9bcbd5e1ff81430.sortAscending = function(a, b) {
    return new Date(a.valueOf()).getTime() - new Date(b.valueOf()).getTime();
};
/**
 * Sort function for Timestamps, sorts descending
 */ $3495b0420ba46046$export$d9bcbd5e1ff81430.sortDescending = function(a, b) {
    return new Date(b.valueOf()).getTime() - new Date(a.valueOf()).getTime();
};

});

parcelRegister("2uVAW", function(module, exports) {

$parcel$export(module.exports, "Email", function () { return $1d1b0f43ef9f64df$export$5a6b8595f311cbb0; });

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($1d1b0f43ef9f64df$export$5a6b8595f311cbb0);
function $1d1b0f43ef9f64df$export$5a6b8595f311cbb0(email) {
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-\.]+\.[a-zA-Z0-9]{2,}$/.test(email)) return email;
    throw new Error("Invalid email address");
}
/** Abbreviates the email address, e.g. "foo.bar@email.com" => "FB" */ $1d1b0f43ef9f64df$export$5a6b8595f311cbb0.abbreviate = (e, maxLength = 2)=>{
    try {
        const i = e.indexOf("@");
        const n = e.slice(0, i);
        const r = n.split(/[^A-Za-z]/);
        return r.slice(0, maxLength).map((x)=>x[0].toUpperCase()).join("");
    } catch (_a) {
        return e.charAt(0);
    }
};

});

parcelRegister("6oG4E", function(module, exports) {
/** Converts the provided number to an Integer.
 *
 *  Throws an error if the provided number is not an integer
 */ function $4a859f034b88e15c$export$70ffa26850098d01(int) {
    if ((int | 0) !== int) throw new Error("Not an integer: " + int);
    return int;
}

});

parcelRegister("gGZ2r", function(module, exports) {

$parcel$export(module.exports, "Markdown", function () { return $c26fea84ff7eb781$export$7460c8b7e4ce9582; });

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($c26fea84ff7eb781$export$7460c8b7e4ce9582);
function $c26fea84ff7eb781$export$7460c8b7e4ce9582(md) {
    return md;
}
$c26fea84ff7eb781$export$7460c8b7e4ce9582.trim = (md)=>{
    return md.split("\n").map((x)=>x.trim()).join("\n");
};
const $c26fea84ff7eb781$var$regexMdLinks = /\[([^\[]+)\]\((.*)\)/gm;
$c26fea84ff7eb781$export$7460c8b7e4ce9582.transformLinks = (md, transform)=>{
    return $c26fea84ff7eb781$export$7460c8b7e4ce9582(md.replace($c26fea84ff7eb781$var$regexMdLinks, (substr, p1, p2)=>{
        const { alt: alt, link: link } = transform(p1, p2);
        return `[${alt}](${link})`;
    }));
};

});

parcelRegister("fR074", function(module, exports) {

$parcel$export(module.exports, "NonNegativeInteger", function () { return $b8abe4afef8ffe29$export$3aa437e0bb159f44; });
function $b8abe4afef8ffe29$export$9901fe19cc8242bc(nonNegativeNumber) {
    if (nonNegativeNumber >= 0) return nonNegativeNumber;
    throw new Error("NonNegativeNumber must be 0 or a positive number");
}
function $b8abe4afef8ffe29$export$3aa437e0bb159f44(nonNegativeInteger) {
    if (Number.isInteger(nonNegativeInteger) && nonNegativeInteger >= 0) return nonNegativeInteger;
    throw new Error("NonNegativeInteger must be 0 or a positive integer");
}

});

parcelRegister("iDHvF", function(module, exports) {

});

parcelRegister("eHTbG", function(module, exports) {

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($ab4fe3e65807cce1$export$cbc348af47898b5e);
function $ab4fe3e65807cce1$export$cbc348af47898b5e(pct, minValue, maxValue) {
    return pct;
}

});

parcelRegister("4QAvl", function(module, exports) {

$parcel$export(module.exports, "PhoneNumber", function () { return $387855cc94c1b07f$export$3d623a7758cab61e; });

var $hVoVD = parcelRequire("hVoVD");

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($387855cc94c1b07f$export$3d623a7758cab61e);
function $387855cc94c1b07f$export$3d623a7758cab61e(pn) {
    var _a;
    if (!pn.startsWith("+")) throw new Error("Phone number must start with a country code, e.g. +47");
    if (pn.includes(" ")) throw new Error("Phone number must not contain spaces");
    // Check for illegal characters, if found, throw an error with the illegal characters
    if (pn.match(/[^0-9+]/)) throw new $387855cc94c1b07f$export$c37555231a66b87c(`Phone number contains illegal characters: ${(_a = pn.match(/[^0-9+]/)) === null || _a === void 0 ? void 0 : _a.join(", ")}`);
    return pn;
}
class $387855cc94c1b07f$export$c37555231a66b87c extends (0, $hVoVD.BadRequest) {
    constructor(message = "Phone number is not in a valid format - Requires the phone number to be in E.164 format, with a leading +"){
        super(message);
    }
}

});
parcelRegister("hVoVD", function(module, exports) {

$parcel$export(module.exports, "BadRequest", function () { return $d0cb18d27936a491$export$99341f548497676e; });

var $8h5s0 = parcelRequire("8h5s0");
class $d0cb18d27936a491$export$d4e71bc0b80dc0fb extends Error {
    constructor(status, detail){
        super();
        this.status = status;
        this.detail = detail;
        /** The problem type. This is a string that uniquely identifies the problem
         * case. */ this.type = this.constructor.name;
    }
    get message() {
        return `${this.detail} (${this.status} ${this.description})`;
    }
    /** This serializes the ErrorCode exception as compliant with the `application/problem+json` mime
     * type, appropriate for returning in the HTTP response. */ toJSON() {
        return {
            type: this.type,
            detail: this.detail,
            status: this.status
        };
    }
    get description() {
        return this.constructor.description || this.type;
    }
}
class $d0cb18d27936a491$export$99341f548497676e extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(400, detail);
    }
}
$d0cb18d27936a491$export$99341f548497676e.description = "Bad Request";
class $d0cb18d27936a491$export$19c9d77d7b17be8 extends $d0cb18d27936a491$export$99341f548497676e {
    constructor(detail){
        super(detail);
    }
    withDiagnostic(diagnostic) {
        this.diagnostic = diagnostic;
        return this;
    }
}
class $d0cb18d27936a491$export$3ec1ce42a7e09129 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(401, detail);
    }
}
$d0cb18d27936a491$export$3ec1ce42a7e09129.description = "Unauthorized";
class $d0cb18d27936a491$export$19e402bf0a6cad34 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail = "Forbidden"){
        super(403, detail);
    }
}
$d0cb18d27936a491$export$19e402bf0a6cad34.description = "Forbidden";
class $d0cb18d27936a491$export$271f9f08425019c7 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail = "Not Found"){
        super(404, detail);
    }
    /**
     * Generates the default not found message returned by endpoints that use
     * the reference syntax for arguments.
     *
     * This is placed here to ensure consistency between the spec and
     * implementation.
     */ static referenceNotFoundMessage(typeName, paramName) {
        return `No ${(0, $8h5s0.prettyCamel)(typeName, false)} matching the specified ${paramName}`;
    }
}
$d0cb18d27936a491$export$271f9f08425019c7.description = "Not Found";
class $d0cb18d27936a491$export$5440db93490b0465 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(408, detail);
    }
}
class $d0cb18d27936a491$export$97a560b147cd48ee extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(409, detail);
    }
}
class $d0cb18d27936a491$export$803afdee88dc528c extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(410, detail);
    }
}
class $d0cb18d27936a491$export$40f5430a96d2cacf extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(412, detail);
    }
}
class $d0cb18d27936a491$export$74b671f8c35e14da extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(422, detail);
    }
}
class $d0cb18d27936a491$export$1e0c583012b77b4e extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(424, detail);
    }
}
class $d0cb18d27936a491$export$77ccdd88bc9a7bc extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(425, detail);
    }
}
class $d0cb18d27936a491$export$f2598bad29b0c174 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(429, detail);
    }
}
class $d0cb18d27936a491$export$2004b0625b599107 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(500, detail);
    }
}
$d0cb18d27936a491$export$2004b0625b599107.description = "Internal Server Error";
class $d0cb18d27936a491$export$236f3942bde1acd0 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(503, detail);
    }
}

});


parcelRegister("gBv4p", function(module, exports) {

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($c16833e72b319999$export$50792b0e93539fde);
function $c16833e72b319999$export$50792b0e93539fde(token) {
    let res = "";
    let run = false;
    for (const c of token){
        if (c === "	" || c === "\n" || c === "\r") {
            if (!run) {
                run = true;
                res += " ";
            }
        } else {
            run = false;
            res += c;
        }
    }
    return res;
}

});

parcelRegister("iXeBy", function(module, exports) {

$parcel$export(module.exports, "Url", function () { return $dcc910dd5223d4d2$export$59d795186a5d3f58; });

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($dcc910dd5223d4d2$export$59d795186a5d3f58);
function $dcc910dd5223d4d2$export$59d795186a5d3f58(url) {
    return url;
}

});



parcelRegister("lhaLc", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $f7d3884205bad6eb$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "Global", function () { return $f7d3884205bad6eb$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $f7d3884205bad6eb$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $f7d3884205bad6eb$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $f7d3884205bad6eb$export$c8a8987d4410bf2d; });

var $8ZuUP = parcelRequire("8ZuUP");

var $eeH7J = parcelRequire("eeH7J");

var $7sOZt = parcelRequire("7sOZt");

var $5ziuZ = parcelRequire("5ziuZ");

var $47KoV = parcelRequire("47KoV");
parcelRequire("gc3M0");
parcelRequire("eq7pw");
parcelRequire("6q2Od");

parcelRequire("3ojZ1");
var $f7d3884205bad6eb$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $f7d3884205bad6eb$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $8ZuUP.h).call(props, "css")) // $FlowFixMe
    return $eeH7J.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $8ZuUP.E);
    createElementArgArray[1] = (0, $8ZuUP.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $eeH7J.createElement.apply(null, createElementArgArray);
};
var $f7d3884205bad6eb$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $f7d3884205bad6eb$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $8ZuUP.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $47KoV.serializeStyles)([
        styles
    ], undefined, $eeH7J.useContext((0, $8ZuUP.T)));
    if (!(0, $8ZuUP.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $eeH7J.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $eeH7J.useRef();
    (0, $5ziuZ.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $5ziuZ.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $7sOZt.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $f7d3884205bad6eb$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $47KoV.serializeStyles)(args);
}
var $f7d3884205bad6eb$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $f7d3884205bad6eb$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $f7d3884205bad6eb$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $f7d3884205bad6eb$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $7sOZt.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f7d3884205bad6eb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $5ziuZ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $7sOZt.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $f7d3884205bad6eb$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $8ZuUP.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $47KoV.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $7sOZt.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $f7d3884205bad6eb$var$merge(cache.registered, css, $f7d3884205bad6eb$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $eeH7J.useContext((0, $8ZuUP.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement($f7d3884205bad6eb$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $f7d3884205bad6eb$var$isBrowser, $f7d3884205bad6eb$var$isTestEnv, $f7d3884205bad6eb$var$globalContext, $f7d3884205bad6eb$var$globalKey;

});

parcelRegister("aIeEI", function(module, exports) {

$parcel$export(module.exports, "useCurrentLocale", function () { return $7cc961c72a2c0f12$export$d9e9761b61d7319b; });
$parcel$export(module.exports, "useLocalize", function () { return $7cc961c72a2c0f12$export$917bfb70a1457f2; });

var $cSf8f = parcelRequire("cSf8f");

var $eeH7J = parcelRequire("eeH7J");

var $7FrRx = parcelRequire("7FrRx");
function $7cc961c72a2c0f12$export$d9e9761b61d7319b() {
    return (0, $eeH7J.useContext)((0, $7FrRx.CurrentLocaleContext)).locale;
}
function $7cc961c72a2c0f12$export$917bfb70a1457f2() {
    const locale = $7cc961c72a2c0f12$export$d9e9761b61d7319b();
    return (value, overrideLocale)=>(0, $cSf8f.ClientSideLocalize)(value, overrideLocale !== null && overrideLocale !== void 0 ? overrideLocale : locale);
}

});
parcelRegister("cSf8f", function(module, exports) {

$parcel$export(module.exports, "Strings", function () { return $95f644123f72f456$export$b261e9de8f5b6a97; });
$parcel$export(module.exports, "Dictionary", function () { return $95f644123f72f456$export$4ee70ab773570fb9; });
$parcel$export(module.exports, "Translations", function () { return $95f644123f72f456$export$1f12680e68c5100d; });
$parcel$export(module.exports, "ClientSideLocalize", function () { return $95f644123f72f456$export$13fb7ba1b775ff6b; });

var $34lt5 = parcelRequire("34lt5");

var $6NFIa = parcelRequire("6NFIa");
parcelRequire("2LTO8");
var $8h5s0 = parcelRequire("8h5s0");
const $95f644123f72f456$export$b261e9de8f5b6a97 = $95f644123f72f456$export$4ee70ab773570fb9({
    Edit: {
        no: "Rediger",
        sv: "Redigera"
    },
    "Done editing": {
        no: "Ferdig med redigering",
        sv: "Klar med redigering"
    },
    Show: {
        no: "Vis",
        sv: "Visa"
    },
    Hide: {
        no: "Skjul",
        sv: "D\xf6lj"
    },
    More: {
        no: "Mer",
        sv: "Mer"
    },
    Less: {
        no: "Mindre",
        sv: "Mindre"
    },
    Previous: {
        no: "Forrige",
        sv: "F\xf6reg\xe5ende"
    },
    Next: {
        no: "Neste",
        sv: "N\xe4sta"
    },
    Search: {
        no: "S\xf8k",
        sv: "S\xf6k"
    },
    matching: {
        no: "matcher",
        sv: "matchar"
    },
    "Order by": {
        no: "Sorter etter",
        sv: "Sortera efter"
    },
    ascending: {
        no: "stigende",
        sv: "stigande"
    },
    descending: {
        no: "synkende",
        sv: "synkande"
    },
    Ascending: {
        no: "Stigende",
        sv: "Stigande"
    },
    Descending: {
        no: "Synkende",
        sv: "Synkande"
    },
    "per page": {
        no: "per side",
        sv: "per sida"
    },
    "Last modified date": {
        no: "Sist endret",
        sv: "Senast \xe4ndrad"
    },
    "Created date": {
        no: "Opprettet",
        sv: "Skapad"
    },
    Download: {
        no: "Last ned",
        sv: "Ladda ner"
    },
    "Download as .JSON file": {
        no: "Last ned som .JSON-fil",
        sv: "Ladda ner som .JSON-fil"
    },
    "Download as .CSV file": {
        no: "Last ned som .CSV-fil",
        sv: "Ladda ner som .CSV-fil"
    },
    "Please enter a search string...": {
        no: "Skriv inn s\xf8kestreng...",
        sv: "Skriv in s\xf6kstr\xe4ng..."
    },
    "Please specify": {
        no: "Vennligst spesifiser",
        sv: "V\xe4nligen specificera"
    },
    Replace: {
        no: "Erstatt",
        sv: "Ers\xe4tt"
    },
    Cancel: {
        no: "Avbryt",
        sv: "Avbryt"
    },
    Delete: {
        no: "Slett",
        sv: "Ta bort"
    },
    Duplicate: {
        no: "Dupliser",
        sv: "Duplicera"
    },
    Export: {
        no: "Eksporter",
        sv: "Exportera"
    },
    "Are you sure you want to continue?": {
        no: "Er du sikker p\xe5 at du vil fortsette?",
        sv: "\xc4r du s\xe4ker p\xe5 att du vill forts\xe4tta?"
    },
    "Ignore and continue": {
        no: "Ignorer og fortsett",
        sv: "Ignorera och forts\xe4tt"
    }
});
const $95f644123f72f456$export$1f12680e68c5100d = {
    Open () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "\xc5pne";
            case "sv":
                return "\xd6ppna";
            default:
                return "Open";
        }
    },
    DeleteThis (x) {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                switch(x["no:genus"]){
                    case "neuter":
                        return `Slett dette ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x))}et`;
                    default:
                        return `Slett denne ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x))}en`;
                }
            case "sv":
                switch(x["sv:genus"]){
                    case "neuter":
                        return `Radera detta ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x))}`;
                    default:
                        return `Radera denna ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x))}`;
                }
            default:
                return `Delete this ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x))}`;
        }
    },
    SelectX (x) {
        const lx = (0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x));
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                switch(x["no:genus"]){
                    case "neuter":
                        return `Velg et ${lx}`;
                    default:
                        return `Velg en ${lx}`;
                }
            case "sv":
                switch(x["sv:genus"]){
                    case "neuter":
                        return `V\xe4lj et ${lx}`;
                    default:
                        return `V\xe4lj en ${lx}`;
                }
            default:
                return `Select a ${lx}`;
        }
    },
    SelectXToRepalceY (x, y) {
        const lx = (0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x));
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                switch(x["no:genus"]){
                    case "neuter":
                        return `Velg et ${lx} for \xe5 erstatte ${y}`;
                    default:
                        return `Velg en ${lx} for \xe5 erstatte ${y}`;
                }
            case "sv":
                switch(x["sv:genus"]){
                    case "neuter":
                        return `V\xe4lj ett ${lx} f\xf6r att ers\xe4tta ${y}`;
                    default:
                        return `V\xe4lj en ${lx} f\xf6r att ers\xe4tta ${y}`;
                }
            default:
                return `Please specify a ${lx} to replace ${y}`;
        }
    },
    DragAndDropAFileHereToInsert () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Dra og slipp en fil her for \xe5 sette inn";
            case "sv":
                return "Dra och sl\xe4pp en fil h\xe4r f\xf6r att s\xe4tta in";
            default:
                return "Drag and drop a file here to insert";
        }
    },
    LockedField () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "L\xe5st felt";
            case "sv":
                return "L\xe5st f\xe4lt";
            default:
                return "Locked field";
        }
    },
    Add () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Legg til";
            case "sv":
                return "L\xe4gg till";
            default:
                return "Add";
        }
    },
    Change () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Endre";
            case "sv":
                return "\xc4ndra";
            default:
                return "Change";
        }
    },
    Specify () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Velg";
            case "sv":
                return "V\xe4lj";
            default:
                return "Choose";
        }
    },
    Incomplete () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Mangler utfylling";
            case "sv":
                return "Saknar ifyllnad";
            default:
                return "Incomplete";
        }
    },
    New (noun, locale = (0, $6NFIa.getStudioLocale)()) {
        switch(locale){
            case "no":
                switch(noun["no:genus"]){
                    case "neuter":
                        return "Nytt";
                    default:
                        return "Ny";
                }
            case "sv":
                switch(noun["sv:genus"]){
                    case "neuter":
                        return "Nytt";
                    default:
                        return "Ny";
                }
            default:
                return "New";
        }
    },
    Create (noun, locale = (0, $6NFIa.getStudioLocale)()) {
        switch(locale){
            case "no":
                return "Opprett";
            case "sv":
                return "Skapa";
            case "en":
                return "Create";
        }
    },
    Blank (noun) {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                switch(noun["no:genus"]){
                    case "neuter":
                        return "Tomt";
                    default:
                        return "Tom";
                }
            case "sv":
                switch(noun["sv:genus"]){
                    case "neuter":
                        return "Blankt";
                    default:
                        return "Blank";
                }
            case "da":
                switch(noun["da:genus"]){
                    case "neuter":
                        return "Blankt";
                    default:
                        return "Blank";
                }
        }
        return "Blank";
    },
    ReplaceOnlyThisReference () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Erstatt bare denne referansen";
            case "sv":
                return "Ers\xe4tt bara denna referens";
            default:
                return "Replace only this reference";
        }
    },
    ReplaceAllReferencesInDocument (old) {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return `Erstatt alle referanser til ${old} i dokumentet`;
            case "sv":
                return `Ers\xe4tt alla referenser till ${old} i dokumentet`;
            default:
                return `Replace all references to ${old} in document`;
        }
    },
    ReplacedXReferences (count) {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return `Erstattet ${count} referanser`;
            case "sv":
                return `Ersatte ${count} referenser`;
            default:
                return `Replaced ${count} references`;
        }
    },
    NoItemMatchesTheSearch (noun) {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return `Ingen ${noun} matcher s\xf8ket`;
            case "sv":
                return `Ingen ${noun} matchar s\xf6ket`;
            case "en":
                return `No ${noun} matches the search`;
        }
    },
    NoItems (noun) {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return `Ingen ${noun}e${noun.endsWith("r") ? "" : "r"}`;
            case "sv":
                return `Ingen ${noun}ar`;
            case "en":
                return `No ${noun}s`;
        }
    },
    ShowingXtoYofZ (x, y, z) {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return `Viser ${x} ${y !== undefined ? "- " + y : ""} av ${z}`;
            case "sv":
                return `Visar ${x} ${y !== undefined ? "- " + y : ""} av ${z}`;
            default:
                return `Showing ${x} ${y !== undefined ? "- " + y : ""} of ${z}`;
        }
    },
    AreYouSureYouWantToDeleteThis (noun) {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                switch(noun["no:genus"]){
                    case "neuter":
                        return `Er du sikker p\xe5 at du vil slette dette ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(noun))}et?`;
                    default:
                        return `Er du sikker p\xe5 at du vil slette denne ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(noun))}en?`;
                }
            case "sv":
                switch(noun["sv:genus"]){
                    case "neuter":
                        return `\xc4r du s\xe4ker p\xe5 att du vill ta bort detta ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(noun))}?`;
                    default:
                        return `\xc4r du s\xe4ker p\xe5 att du vill ta bort denna ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(noun))}?`;
                }
            default:
                return `Are you sure you want to delete this ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(noun))}?`;
        }
    },
    AreYouSureYouWantToDeleteThisHistoryWillBeKept (noun) {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                switch(noun["no:genus"]){
                    case "neuter":
                        return `Er du sikker p\xe5 at du vil slette dette ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}et, men beholde historikken? Dersom dokumentet inneholder persondata, b\xf8r du heller slette dokumentet permanent.`;
                    default:
                        return `Er du sikker p\xe5 at du vil slette denne ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}en? Dersom dokumentet inneholder persondata, b\xf8r du heller slette dokumentet permanent.`;
                }
            case "sv":
                switch(noun["sv:genus"]){
                    case "neuter":
                        return `\xc4r du s\xe4ker p\xe5 att du vill ta bort detta ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}et, men beh\xe5lla historiken? Om dokumentet inneh\xe5ller personuppgifter b\xf6r du ist\xe4llet radera dokumentet permanent.`;
                    default:
                        return `\xc4r du s\xe4ker p\xe5 att du vill ta bort denna ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}? Om dokumentet inneh\xe5ller personuppgifter b\xf6r du ist\xe4llet radera dokumentet permanent.`;
                }
            default:
                return `Are you sure you want to delete this ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}, but keep its event history? If the document contains personal data, you should permanently delete the document instead.`;
        }
    },
    CanNotDeleteThis (noun) {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                switch(noun["no:genus"]){
                    case "neuter":
                        return `Kan ikke slette dette ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}et`;
                    default:
                        return `Kan ikke slette denne ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}en`;
                }
            case "sv":
                switch(noun["sv:genus"]){
                    case "neuter":
                        return `Kan inte ta bort detta ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}`;
                    default:
                        return `Kan inte ta bort denna ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}`;
                }
            default:
                return `Can not delete this ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}`;
        }
    },
    ShowAll () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Vis alle";
            case "sv":
                return "Visa alla";
            default:
                return "Show all";
        }
    },
    Save () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Lagre";
            case "sv":
                return "Spara";
            default:
                return "Save";
        }
    },
    Saved () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Lagret";
            case "sv":
                return "Sparad";
            default:
                return "Saved";
        }
    },
    SaveAsTemplate () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Lagre som mal";
            case "sv":
                return "Spara som mall";
            default:
                return "Save as template";
        }
    },
    Discard () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Forkast";
            case "sv":
                return "Sl\xe4ng";
            default:
                return "Discard";
        }
    },
    SaveChanges () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Lagre endringer";
            case "sv":
                return "Spara \xe4ndringar";
            default:
                return "Save changes";
        }
    },
    DiscardChanges () {
        switch((0, $6NFIa.getStudioLocale)()){
            case "no":
                return "Forkast endringer";
            case "sv":
                return "Sl\xe4ng \xe4ndringar";
            default:
                return "Discard changes";
        }
    }
};
function $95f644123f72f456$export$4ee70ab773570fb9(strings) {
    const res = {};
    for(const key in strings){
        const value = strings[key];
        Object.defineProperty(res, key, {
            get () {
                var _a;
                return (_a = value[(0, $6NFIa.getStudioLocale)()]) !== null && _a !== void 0 ? _a : key;
            }
        });
    }
    return res;
}
/** The available locales for client-side localization. */ $95f644123f72f456$export$4ee70ab773570fb9.locales = [
    {
        flag: "\uD83C\uDDEC\uD83C\uDDE7",
        key: (0, $34lt5.LocaleKey).en,
        displayName: {
            en: "English",
            no: "Engelsk",
            sv: "Engelska"
        }
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDF4",
        key: (0, $34lt5.LocaleKey).no,
        displayName: {
            en: "Norwegian",
            no: "Norsk",
            sv: "Norska"
        }
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDEA",
        key: (0, $34lt5.LocaleKey).sv,
        displayName: {
            en: "Swedish",
            no: "Svensk",
            sv: "Svenska"
        }
    }
];
$95f644123f72f456$export$4ee70ab773570fb9.chooseLocale = function(value, locale) {
    locale !== null && locale !== void 0 ? locale : locale = (0, $34lt5.LocaleKey)((0, $6NFIa.getStudioLocale)());
    if (value === undefined) return undefined;
    if (value[locale]) return locale;
    if (value.en) return (0, $34lt5.LocaleKey).en;
};
function $95f644123f72f456$export$13fb7ba1b775ff6b(value, locale) {
    if (value === undefined) return undefined;
    locale = $95f644123f72f456$export$4ee70ab773570fb9.chooseLocale(value, locale);
    if (locale) return value[locale.valueOf()];
    const keys = Object.keys(value)// Filter grammar metadata
    .filter((x)=>!x.includes(":"));
    return value[keys[0]];
}

});
parcelRegister("34lt5", function(module, exports) {

$parcel$export(module.exports, "LocaleKey", function () { return $23c265f07b7f1f26$export$8f9bd71e42971d18; });
$parcel$export(module.exports, "getLocaleKeyMoment", function () { return $23c265f07b7f1f26$export$aba88338213610b8; });
function $23c265f07b7f1f26$export$8f9bd71e42971d18(key) {
    return key;
}
/** International English locale (default). */ $23c265f07b7f1f26$export$8f9bd71e42971d18.en = $23c265f07b7f1f26$export$8f9bd71e42971d18("en");
/** Norwegian (bokmål). */ $23c265f07b7f1f26$export$8f9bd71e42971d18.no = $23c265f07b7f1f26$export$8f9bd71e42971d18("no");
/** Swedish. */ $23c265f07b7f1f26$export$8f9bd71e42971d18.sv = $23c265f07b7f1f26$export$8f9bd71e42971d18("sv");
const $23c265f07b7f1f26$export$aba88338213610b8 = (l)=>{
    // This can be easily extended with a switch to support multiple discrepancies
    return l === $23c265f07b7f1f26$export$8f9bd71e42971d18.no ? "nb" : (l === null || l === void 0 ? void 0 : l.valueOf()) || "en";
};

});

parcelRegister("6NFIa", function(module, exports) {

$parcel$export(module.exports, "setStudioLocaleKey", function () { return $4f37acb2c187b928$export$14d924aea281b5a0; });
$parcel$export(module.exports, "useStudioLocale", function () { return $4f37acb2c187b928$export$227065a72e40df58; });
$parcel$export(module.exports, "getStudioLocale", function () { return $4f37acb2c187b928$export$76f11bb6b2cff4b3; });

var $eeH7J = parcelRequire("eeH7J");

var $lDBHC = parcelRequire("lDBHC");

var $dUDPg = parcelRequire("dUDPg");

var $34lt5 = parcelRequire("34lt5");
const $4f37acb2c187b928$var$defaultLocale = (0, $34lt5.LocaleKey).en;
let $4f37acb2c187b928$var$currentLocale = "default";
const $4f37acb2c187b928$var$listeners = [];
if (!(0, $lDBHC.IsNode)()) // setTimeout to avoid touching `default` before it's initialized
setTimeout(()=>{
    const setting = window.localStorage.getItem("studio-locale");
    if (setting !== null) $4f37acb2c187b928$export$14d924aea281b5a0((0, $34lt5.LocaleKey)(setting));
    else $4f37acb2c187b928$export$14d924aea281b5a0($4f37acb2c187b928$var$defaultLocale);
}, 0);
function $4f37acb2c187b928$export$227065a72e40df58(/** Called when the locale changes. Since locale is passed as header, not an
 * explicit request parameter, some resources may require manual
 * invalidation to refresh correctly. */ callback) {
    const [locale, setLocale] = (0, $eeH7J.useState)($4f37acb2c187b928$var$currentLocale);
    (0, $eeH7J.useEffect)(()=>{
        $4f37acb2c187b928$var$listeners.push((newLocale)=>{
            setLocale(newLocale);
            if (callback) callback(newLocale);
        });
        return ()=>{
            const i = $4f37acb2c187b928$var$listeners.indexOf(setLocale);
            if (i >= 0) $4f37acb2c187b928$var$listeners.splice(i, 1);
        };
    }, []);
    if (locale === "default") return $4f37acb2c187b928$var$defaultLocale;
    return locale;
}
function $4f37acb2c187b928$export$14d924aea281b5a0(locale) {
    if (!(0, $lDBHC.IsNode)()) {
        window.localStorage.setItem("studio-locale", locale.valueOf());
        $4f37acb2c187b928$var$currentLocale = locale;
        (0, $dUDPg.defaults).headers["Accept-Language"] = locale.valueOf();
    }
    for (const listener of $4f37acb2c187b928$var$listeners)listener(locale);
}
function $4f37acb2c187b928$export$76f11bb6b2cff4b3() {
    return $4f37acb2c187b928$export$8eee6780d5b65d02().valueOf();
}
function $4f37acb2c187b928$export$8eee6780d5b65d02() {
    if ($4f37acb2c187b928$var$currentLocale === "default") return $4f37acb2c187b928$var$defaultLocale;
    else return $4f37acb2c187b928$var$currentLocale;
}

});

parcelRegister("2LTO8", function(module, exports) {
$parcel$export(module.exports, "CountryCode", function () { return (parcelRequire("97R5C")).CountryCode; });
$parcel$export(module.exports, "CurrencyCode", function () { return (parcelRequire("2zTLn")).CurrencyCode; });
$parcel$export(module.exports, "Email", function () { return (parcelRequire("2uVAW")).Email; });
$parcel$export(module.exports, "Markdown", function () { return (parcelRequire("gGZ2r")).Markdown; });
$parcel$export(module.exports, "NonNegativeInteger", function () { return (parcelRequire("fR074")).NonNegativeInteger; });
$parcel$export(module.exports, "ParseDateTimePrecision", function () { return (parcelRequire("4vUfp")).ParseDateTimePrecision; });
$parcel$export(module.exports, "PhoneNumber", function () { return (parcelRequire("4QAvl")).PhoneNumber; });
$parcel$export(module.exports, "Timestamp", function () { return (parcelRequire("4vUfp")).Timestamp; });
$parcel$export(module.exports, "Url", function () { return (parcelRequire("iXeBy")).Url; });
$parcel$export(module.exports, "Uuid", function () { return (parcelRequire("dAwef")).Uuid; });
$parcel$export(module.exports, "FileToUrl", function () { return (parcelRequire("14q7s")).FileToUrl; });
$parcel$export(module.exports, "ImageToCSS", function () { return (parcelRequire("14q7s")).ImageToCSS; });
$parcel$export(module.exports, "ImageToUrl", function () { return (parcelRequire("14q7s")).ImageToUrl; });
$parcel$export(module.exports, "Color", function () { return (parcelRequire("hsrrX")).Color; });
$parcel$export(module.exports, "IsNode", function () { return (parcelRequire("lDBHC")).IsNode; });
$parcel$export(module.exports, "Clone", function () { return (parcelRequire("6pFwm")).Clone; });
$parcel$export(module.exports, "CreateDefault", function () { return (parcelRequire("5c9Ym")).CreateDefault; });
$parcel$export(module.exports, "Default", function () { return (parcelRequire("5c9Ym")).Default; });
$parcel$export(module.exports, "UninitializedArrayValue", function () { return (parcelRequire("5c9Ym")).UninitializedArrayValue; });
$parcel$export(module.exports, "UninitializedDefaults", function () { return (parcelRequire("5c9Ym")).UninitializedDefaults; });
$parcel$export(module.exports, "GetPrimaryKey", function () { return (parcelRequire("cwhCA")).GetPrimaryKey; });
$parcel$export(module.exports, "GetReflectionInfo", function () { return (parcelRequire("cwhCA")).GetReflectionInfo; });
$parcel$export(module.exports, "GetType", function () { return (parcelRequire("cwhCA")).GetType; });
$parcel$export(module.exports, "SubstituteAndDiscriminate", function () { return (parcelRequire("cwhCA")).SubstituteAndDiscriminate; });
$parcel$export(module.exports, "DeserializeGraph", function () { return (parcelRequire("3oicm")).DeserializeGraph; });
$parcel$export(module.exports, "Assert", function () { return (parcelRequire("8h5s0")).Assert; });
$parcel$export(module.exports, "lowercaseFirstLetter", function () { return (parcelRequire("8h5s0")).lowercaseFirstLetter; });
$parcel$export(module.exports, "prettyCamel", function () { return (parcelRequire("8h5s0")).prettyCamel; });
$parcel$export(module.exports, "OrderBy", function () { return (parcelRequire("a1m73")).OrderBy; });
$parcel$export(module.exports, "GetIconForTypedValue", function () { return (parcelRequire("3LK53")).GetIconForTypedValue; });
parcelRequire("dbwyW");
parcelRequire("14q7s");
parcelRequire("hsrrX");
parcelRequire("lDBHC");
parcelRequire("6pFwm");
parcelRequire("hVoVD");

var $43jhg = parcelRequire("43jhg");
parcelRequire("5c9Ym");
parcelRequire("cwhCA");
parcelRequire("3oicm");
parcelRequire("8h5s0");
parcelRequire("4Zgmd");
parcelRequire("c9WcJ");
parcelRequire("a1m73");
parcelRequire("3LK53");
$parcel$exportWildcard(module.exports, $43jhg);

});
parcelRegister("hsrrX", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return $cb5a58304adaf600$export$892596cec99bc70e; });

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($cb5a58304adaf600$export$892596cec99bc70e);
function $cb5a58304adaf600$export$892596cec99bc70e(color) {
    return color;
}
/**
 * Returns the luminance of a hex color in the range [0, 255].
 *
 * Uses the formula from https://www.w3.org/TR/WCAG20/#relativeluminancedef
 */ $cb5a58304adaf600$export$892596cec99bc70e.getLuminance = (hex)=>{
    const rgb = parseInt(hex, 16);
    const r = rgb >> 16 & 0xff;
    const g = rgb >> 8 & 0xff;
    const b = rgb & 0xff;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
/**
 * Returns whether a hex color is dark (less than 50% luminance).
 *
 * This can e.g. be used to determine whether to use a light or dark text color
 * on top of a background color.
 */ $cb5a58304adaf600$export$892596cec99bc70e.isDark = (hex)=>$cb5a58304adaf600$export$892596cec99bc70e.getLuminance(hex) < 128;

});

parcelRegister("6pFwm", function(module, exports) {

$parcel$export(module.exports, "Clone", function () { return $4ab5490cf9310952$export$b5d07669a5562b23; });
function $4ab5490cf9310952$export$b5d07669a5562b23(obj) {
    if (typeof obj !== "object") return obj;
    return JSON.parse(JSON.stringify(obj));
}

});

parcelRegister("5c9Ym", function(module, exports) {

$parcel$export(module.exports, "CreateDefault", function () { return $3c85cf15e8f9fc08$export$64083afede9217e1; });
$parcel$export(module.exports, "DefaultDefaults", function () { return $3c85cf15e8f9fc08$export$73100be7e4e9cd6e; });
$parcel$export(module.exports, "UninitializedDefaults", function () { return $3c85cf15e8f9fc08$export$3e00805fcb1cfee7; });
$parcel$export(module.exports, "UninitializedArrayValue", function () { return $3c85cf15e8f9fc08$export$9948121d4484b3a3; });
$parcel$export(module.exports, "Default", function () { return $3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4; });

var $cwhCA = parcelRequire("cwhCA");

var $34lt5 = parcelRequire("34lt5");

var $fK1QV = parcelRequire("fK1QV");

var $dAwef = parcelRequire("dAwef");

var $43jhg = parcelRequire("43jhg");

var $8h5s0 = parcelRequire("8h5s0");

var $lyFh9 = parcelRequire("lyFh9");

var $k71sq = parcelRequire("k71sq");
function $3c85cf15e8f9fc08$export$fafc52a04a0a9d07(type, defaults, locale) {
    const res = {};
    (0, $43jhg.GetTypeProps)(type).forEach((prop)=>{
        const value = $3c85cf15e8f9fc08$export$609e8570bac5255e(prop, defaults, locale);
        if (value !== undefined) res[prop.name] = value;
    });
    return res;
}
function $3c85cf15e8f9fc08$export$609e8570bac5255e(prop, defaults, locale) {
    var _a, _b, _c, _d, _e;
    if ((_a = prop.tags) === null || _a === void 0 ? void 0 : _a.defaultFile) {
        const defaultFiles = (0, $cwhCA.GetReflectionInfo)().defaultFiles;
        if (!defaultFiles) throw new Error("No default files found");
        const file = (_b = defaultFiles[prop.tags.defaultFile]) === null || _b === void 0 ? void 0 : _b.file;
        if (!file) throw new Error(`No default file found for ${prop.tags.defaultFile}`);
        return file;
    }
    if ((_c = prop.tags) === null || _c === void 0 ? void 0 : _c.serial) // -1 = PGTable.SerialInteger default. We don't want to import
    // `PGTable` in this file, so hardcoding it.
    return -1;
    if (typeof prop.type === "object" && prop.type.reference) return; // Do not fill in bogus Uuid/key
    const def = ((_d = prop.tags) === null || _d === void 0 ? void 0 : _d.default) !== undefined ? (0, $fK1QV.ParseTagValue)("default", (_e = prop.tags) === null || _e === void 0 ? void 0 : _e.default, prop.type) : undefined;
    if (def !== undefined) return def;
    else {
        if (!prop.optional) return $3c85cf15e8f9fc08$export$64083afede9217e1(prop.type, defaults, locale);
    }
}
const $3c85cf15e8f9fc08$export$73100be7e4e9cd6e = {
    string: "",
    number: 0,
    boolean: false,
    null: null,
    array (item, defaults) {
        return [];
    },
    object (type, defaults, locale) {
        return $3c85cf15e8f9fc08$export$fafc52a04a0a9d07(type, defaults, locale);
    },
    intersection (type, defaults, locale) {
        return type.intersection.map((t)=>$3c85cf15e8f9fc08$export$64083afede9217e1(t, defaults, locale)).reduce((a, b)=>{
            if (a !== null && b !== null && typeof a === "object" && typeof b === "object") return Object.assign(a, b);
            else // Not an object - that means its some form of primitive type where both a and b
            // are valid values. Let's return one of them
            return a;
        });
    },
    uuid (type) {
        if (typeof type === "object" && type.reference) return undefined;
        return (0, $dAwef.Uuid)();
    }
};
const $3c85cf15e8f9fc08$export$ab9194fea8e5abfb = Object.assign(Object.assign({}, $3c85cf15e8f9fc08$export$73100be7e4e9cd6e), {
    string: "string",
    object (type, defaults, locale) {
        const props = $3c85cf15e8f9fc08$export$fafc52a04a0a9d07(type, defaults, locale);
        for (const p of (0, $43jhg.GetTypeProps)(type))if (props[p.name] === "" || props[p.name] === "string" || p.type === "string" && p.optional) props[p.name] = (0, $8h5s0.prettyCamel)(p.name, true);
        return props;
    }
});
const $3c85cf15e8f9fc08$export$3e00805fcb1cfee7 = {
    string: undefined,
    number: undefined,
    boolean: false,
    array () {
        return [];
    },
    object (type, defaults, locale) {
        return $3c85cf15e8f9fc08$export$fafc52a04a0a9d07(type, defaults, locale);
    },
    intersection (type, defaults, locale) {
        return type.intersection.map((t)=>$3c85cf15e8f9fc08$export$64083afede9217e1(t, defaults, locale)).reduce((a, b)=>{
            if (a !== null && b !== null && typeof a === "object" && typeof b === "object") return Object.assign(a, b);
            else // Not an object - that means its some form of primitive type where both a and b
            // are valid values. Let's return one of them
            return a;
        });
    },
    uuid (type) {
        if (typeof type === "object" && type.reference) return undefined;
        return (0, $dAwef.Uuid)();
    }
};
const $3c85cf15e8f9fc08$export$9948121d4484b3a3 = Object.assign(Object.assign({}, $3c85cf15e8f9fc08$export$3e00805fcb1cfee7), {
    string: "",
    number: 0
});
function $3c85cf15e8f9fc08$export$64083afede9217e1(type, defaults = $3c85cf15e8f9fc08$export$73100be7e4e9cd6e, /** The locale that will be used as the only initial key in any `Localized<T>` value. */ locale = (0, $34lt5.LocaleKey).en, ignoreDefaultFunctions = false) {
    const alias = (0, $43jhg.GetTypeAlias)(type);
    if (alias && alias in defaults) return defaults[alias];
    if (alias && !ignoreDefaultFunctions) {
        const func = $3c85cf15e8f9fc08$var$getDefaultFuncForType(alias);
        if (func) {
            // Get the defaults without invoking the function
            const t = $3c85cf15e8f9fc08$export$64083afede9217e1(type, defaults, locale, true);
            // Invoke the function
            const res = func(t);
            if (res !== undefined) return res;
            return t;
        }
    }
    if (alias === "Uuid") return defaults.uuid ? defaults.uuid(type) : (0, $dAwef.Uuid)();
    if (alias === "RichText") return (0, $lyFh9.RichText)();
    if (typeof type === "object" && alias === "Localized" && type.typeArgs) // Localized values must have at least one locale defined to be valid
    return {
        [locale]: $3c85cf15e8f9fc08$export$64083afede9217e1(type.typeArgs[0], defaults, locale)
    };
    if ((0, $43jhg.IsAnyType)(type) || (0, $43jhg.IsUnknownType)(type)) return {};
    else if ((0, $43jhg.IsStringType)(type)) {
        if (typeof type === "object" && type.string !== null) return type.string;
        return "string" in defaults ? defaults.string : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.string;
    } else if ((0, $43jhg.IsNumberType)(type)) {
        if (typeof type === "object" && type.number !== null) return type.number;
        return "number" in defaults ? defaults.number : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.number;
    } else if ((0, $43jhg.IsBooleanType)(type)) {
        if (typeof type === "object" && type.boolean !== null) return type.boolean;
        return "boolean" in defaults ? defaults.boolean : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.boolean;
    } else if ((0, $43jhg.IsNullType)(type)) return "null" in defaults ? defaults.null : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.null;
    else if ((0, $43jhg.IsUndefinedType)(type)) return undefined;
    else if ((0, $43jhg.IsUnionType)(type)) {
        // The TypeScript compiler sometimes re-uses union types internally,
        // e.g. if one type `"a" | "b"` is encountered first, and then `"b" |
        // "a"`, they will sometimes be merged into a single union type. This
        // means that the order of the union types in the source code definition
        // is not guaranteed to be the same as the order of the union types in
        // the reflection info. To make sure we generate consistent results, we
        // sort the union types by their string representation before picking
        // the first one.
        if (type.union.length > 0 && type.union.every((t)=>(0, $43jhg.IsStringType)(t) && typeof t === "object" && t.string !== null)) {
            const sortedUnion = type.union.slice().sort((a, b)=>a.string.localeCompare(b.string));
            return sortedUnion[0].string;
        }
        return $3c85cf15e8f9fc08$export$64083afede9217e1(type.union[0], defaults, locale);
    } else if ((0, $43jhg.IsIntersectionType)(type)) return defaults.intersection ? defaults.intersection(type, defaults, locale) : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.intersection(type, defaults, locale);
    else if ((0, $43jhg.IsArrayType)(type)) return defaults.array ? defaults.array(type.array, defaults, locale) : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.array(type.array, defaults);
    else if ((0, $43jhg.IsObjectType)(type)) return defaults.object ? defaults.object(type, defaults, locale) : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.object(type, defaults, locale);
    else if ((0, $43jhg.IsFileType)(type)) return defaults.file;
    else if ((0, $43jhg.IsVoidType)(type)) return undefined;
    else if ((0, $43jhg.IsNeverType)(type)) throw new Error("Cannot create a default value of type 'never'");
    throw new Error("CreateDefault: Unhandled type: " + (0, $43jhg.TypeToString)(type));
}
function $3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4(/**
 * The function that provides the default.
 *
 * Returns the default value, or `void` if the function mutates the input
 * value and does not return a new one.
 */ defaultProvider, /**
 * If provided, this registers the default provider for the given type name,
 * without relying on reflection.
 */ typeName) {
    Object.assign(defaultProvider, {
        fileName: (0, $k71sq.CallSites)()[1].getFileName()
    });
    $3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4.functions.push(defaultProvider);
    if (typeName) $3c85cf15e8f9fc08$var$defaultFuncForTypeCache.set(typeName, defaultProvider);
}
$3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4.functions = [];
const $3c85cf15e8f9fc08$var$defaultFuncForTypeCache = new Map();
function $3c85cf15e8f9fc08$var$getDefaultFuncForType(typeName) {
    const res = $3c85cf15e8f9fc08$var$defaultFuncForTypeCache.get(typeName);
    if (res === null) return undefined;
    if (res) return res;
    const defaults = (0, $cwhCA.IsReflectionInfoReady)() ? (0, $cwhCA.GetReflectionInfo)().defaults : [];
    // Match up the correct functions based on their declaration order in the source file
    for (const f of defaults){
        for(let i = 0; i < f.types.length; i++)if (f.types[i] === typeName) {
            let c = 0;
            for(let n = 0; n < $3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4.functions.length; n++){
                const fn = $3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4.functions[n];
                if (!fn.fileName) continue;
                const sourcePath = (0, $k71sq.ResolveTypeScriptSourceFile)(fn.fileName);
                const foo = (0, $k71sq.ResolveTypeScriptSourceFile)(f.sourcePath);
                if (sourcePath === foo) {
                    if (c === i) {
                        $3c85cf15e8f9fc08$var$defaultFuncForTypeCache.set(typeName, fn);
                        return fn;
                    }
                    c++;
                }
            }
        }
    }
    $3c85cf15e8f9fc08$var$defaultFuncForTypeCache.set(typeName, null);
}

});
parcelRegister("fK1QV", function(module, exports) {

$parcel$export(module.exports, "ParseTagValue", function () { return $b75c96ceff12131f$export$235e153031164642; });

var $43jhg = parcelRequire("43jhg");

var $dAwef = parcelRequire("dAwef");
function $b75c96ceff12131f$export$803216f325b64510(tags, tagName) {
    const defaultStrings = tags === null || tags === void 0 ? void 0 : tags.filter((t)=>t.title === tagName).map((t)=>t.description);
    if (defaultStrings === null || defaultStrings === void 0 ? void 0 : defaultStrings.length) {
        const res = {};
        for (let s of defaultStrings)if (s) {
            let locale;
            const i = s.indexOf(" ");
            if (i !== -1) {
                locale = s.slice(0, i);
                s = s.slice(i + 1);
            } else throw new Error("Invalid tag: Must specify locale key first");
            // Extract genus hints
            if (locale.includes(":")) {
                const [key, genus] = locale.split(":");
                locale = key;
                res[locale + ":genus"] = genus;
            }
            // Replaces all new lines in s with escaped new lines
            s = s.replace(/\n/g, "\\n");
            if (s.startsWith('"') && s.endsWith('"')) s = s.slice(1, -1);
            res[locale] = s;
        }
        return res;
    }
}
function $b75c96ceff12131f$export$235e153031164642(tagName, s, type) {
    function isCompatible(type, pred) {
        return pred(type) || (0, $43jhg.IsUnionType)(type) && type.union.every((t)=>isCompatible(t, pred));
    }
    let value;
    if (isCompatible(type, (0, $43jhg.IsStringType))) value = s.startsWith('"') ? JSON.parse(s) : s;
    else if (isCompatible(type, (0, $43jhg.IsNumberType))) value = parseFloat(s);
    else if (isCompatible(type, (0, $43jhg.IsBooleanType))) value = s === "true";
    else try {
        if (s.startsWith("'")) s = s.slice(1);
        if (s.endsWith("'")) s = s.slice(0, -1);
        while(s.includes("%UUID%"))s = s.replace("%UUID%", (0, $dAwef.Uuid)().valueOf());
        value = s ? JSON.parse(s) : null;
        const match = (0, $43jhg.MatchesType)(value, type);
        if (match !== true) throw new Error(`Type mismatch for @${tagName} value: ${(0, $43jhg.TypeDiagnosticToString)(match)}`);
    } catch (e) {
        throw new Error(`Unable to parse JSON for @${tagName} tag: ${e.message}, value: ${s}`);
    }
    return value;
}

});

parcelRegister("lyFh9", function(module, exports) {

$parcel$export(module.exports, "RichText", function () { return $fb1cca6845732ab8$export$f284d8638abd8920; });
$parcel$export(module.exports, "IsRichText", function () { return $fb1cca6845732ab8$export$e7443681c6b75de1; });
$parcel$export(module.exports, "Heading1", function () { return $fb1cca6845732ab8$export$c3c64e31852769d4; });
/*
 * This holds a general prupose structure for representing rich text, which is
 * compatible with the Slate.js editor.
 *
 * This can be used in model fields, whenever you want to store rich text that
 * can be manipulated using a WYSIWYG editor.
 */ /**
 * Converts a list of rich text elements into a rich text document.
 */ function $fb1cca6845732ab8$export$f284d8638abd8920(...elements) {
    // Rich text must have at least one element
    if (elements.length === 0) return $fb1cca6845732ab8$export$f284d8638abd8920("");
    return {
        $RichText: elements.map((e)=>typeof e === "string" ? $fb1cca6845732ab8$export$358a232cca1ab2ac(e) : e)
    };
}
function $fb1cca6845732ab8$export$e7443681c6b75de1(value) {
    return value && typeof value === "object" && "$RichText" in value;
}
function $fb1cca6845732ab8$export$c3c64e31852769d4(...args) {
    return {
        type: "Heading1",
        children: args.length === 1 ? [
            {
                text: args[0]
            }
        ] : args
    };
}
function $fb1cca6845732ab8$export$f5a7f5a165424d76(...args) {
    return {
        type: "Heading2",
        children: args.length === 1 ? [
            {
                text: args[0]
            }
        ] : args
    };
}
function $fb1cca6845732ab8$export$358a232cca1ab2ac(...args) {
    return {
        type: "Paragraph",
        children: args.length === 1 ? [
            {
                text: args[0]
            }
        ] : args
    };
}

});

parcelRegister("k71sq", function(module, exports) {

$parcel$export(module.exports, "CallSites", function () { return $ea4597855aa41024$export$33223852e6b80b5f; });
$parcel$export(module.exports, "ResolveTypeScriptSourceFile", function () { return $ea4597855aa41024$export$427395a5f76562ba; });

var $b9Wiv = parcelRequire("b9Wiv");

var $8Hv2S = parcelRequire("8Hv2S");
function $ea4597855aa41024$export$33223852e6b80b5f() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b9Wiv))).getSync().slice(1);
}
function $ea4597855aa41024$export$427395a5f76562ba(/** The file name as returned by `CallSites()` */ sourcePath) {
    sourcePath = (0, (/*@__PURE__*/$parcel$interopDefault($8Hv2S))).relative(".", sourcePath);
    // TODO: This is a hack to get the file name of the function's corresponding TS
    // file. Ideally there should be no knowledge of the `build/` folder here.
    if (sourcePath.startsWith("build/")) sourcePath = sourcePath.substring(6);
    if (sourcePath === null || sourcePath === void 0 ? void 0 : sourcePath.endsWith(".js")) sourcePath = sourcePath.substring(0, sourcePath.length - 3) + ".ts";
    return sourcePath;
}
function $ea4597855aa41024$export$d2224cd1e9618412() {
    const stack = $ea4597855aa41024$export$33223852e6b80b5f();
    for (const sf of stack){
        const fn = sf.getFileName();
        if (fn === null || fn === void 0 ? void 0 : fn.includes("/models/")) {
            const modelName = fn.split("/models/")[1].split("/")[0];
            return modelName;
        }
    }
}

});
parcelRegister("b9Wiv", function(module, exports) {



(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stacktrace", [
        "error-stack-parser",
        "stack-generator",
        "stacktrace-gps"
    ], factory);
    else module.exports = factory((parcelRequire("5q4Xp")), (parcelRequire("FwcmS")), (parcelRequire("lKzMa")));
})(module.exports, function StackTrace(ErrorStackParser, StackGenerator, StackTraceGPS) {
    var _options = {
        filter: function(stackframe) {
            // Filter out stackframes for this library by default
            return (stackframe.functionName || "").indexOf("StackTrace$$") === -1 && (stackframe.functionName || "").indexOf("ErrorStackParser$$") === -1 && (stackframe.functionName || "").indexOf("StackTraceGPS$$") === -1 && (stackframe.functionName || "").indexOf("StackGenerator$$") === -1;
        },
        sourceCache: {}
    };
    var _generateError = function StackTrace$$GenerateError() {
        try {
            // Error must be thrown to get stack in IE
            throw new Error();
        } catch (err) {
            return err;
        }
    };
    /**
     * Merge 2 given Objects. If a conflict occurs the second object wins.
     * Does not do deep merges.
     *
     * @param {Object} first base object
     * @param {Object} second overrides
     * @returns {Object} merged first and second
     * @private
     */ function _merge(first, second) {
        var target = {};
        [
            first,
            second
        ].forEach(function(obj) {
            for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) target[prop] = obj[prop];
            return target;
        });
        return target;
    }
    function _isShapedLikeParsableError(err) {
        return err.stack || err["opera#sourceloc"];
    }
    function _filtered(stackframes, filter) {
        if (typeof filter === "function") return stackframes.filter(filter);
        return stackframes;
    }
    return {
        /**
         * Get a backtrace from invocation point.
         *
         * @param {Object} opts
         * @returns {Array} of StackFrame
         */ get: function StackTrace$$get(opts) {
            var err = _generateError();
            return _isShapedLikeParsableError(err) ? this.fromError(err, opts) : this.generateArtificially(opts);
        },
        /**
         * Get a backtrace from invocation point.
         * IMPORTANT: Does not handle source maps or guess function names!
         *
         * @param {Object} opts
         * @returns {Array} of StackFrame
         */ getSync: function StackTrace$$getSync(opts) {
            opts = _merge(_options, opts);
            var err = _generateError();
            var stack = _isShapedLikeParsableError(err) ? ErrorStackParser.parse(err) : StackGenerator.backtrace(opts);
            return _filtered(stack, opts.filter);
        },
        /**
         * Given an error object, parse it.
         *
         * @param {Error} error object
         * @param {Object} opts
         * @returns {Promise} for Array[StackFrame}
         */ fromError: function StackTrace$$fromError(error, opts) {
            opts = _merge(_options, opts);
            var gps = new StackTraceGPS(opts);
            return new Promise((function(resolve) {
                var stackframes = _filtered(ErrorStackParser.parse(error), opts.filter);
                resolve(Promise.all(stackframes.map(function(sf) {
                    return new Promise(function(resolve) {
                        function resolveOriginal() {
                            resolve(sf);
                        }
                        gps.pinpoint(sf).then(resolve, resolveOriginal)["catch"](resolveOriginal);
                    });
                })));
            }).bind(this));
        },
        /**
         * Use StackGenerator to generate a backtrace.
         *
         * @param {Object} opts
         * @returns {Promise} of Array[StackFrame]
         */ generateArtificially: function StackTrace$$generateArtificially(opts) {
            opts = _merge(_options, opts);
            var stackFrames = StackGenerator.backtrace(opts);
            if (typeof opts.filter === "function") stackFrames = stackFrames.filter(opts.filter);
            return Promise.resolve(stackFrames);
        },
        /**
         * Given a function, wrap it such that invocations trigger a callback that
         * is called with a stack trace.
         *
         * @param {Function} fn to be instrumented
         * @param {Function} callback function to call with a stack trace on invocation
         * @param {Function} errback optional function to call with error if unable to get stack trace.
         * @param {Object} thisArg optional context object (e.g. window)
         */ instrument: function StackTrace$$instrument(fn, callback, errback, thisArg) {
            if (typeof fn !== "function") throw new Error("Cannot instrument non-function object");
            else if (typeof fn.__stacktraceOriginalFn === "function") // Already instrumented, return given Function
            return fn;
            var instrumented = (function StackTrace$$instrumented() {
                try {
                    this.get().then(callback, errback)["catch"](errback);
                    return fn.apply(thisArg || this, arguments);
                } catch (e) {
                    if (_isShapedLikeParsableError(e)) this.fromError(e).then(callback, errback)["catch"](errback);
                    throw e;
                }
            }).bind(this);
            instrumented.__stacktraceOriginalFn = fn;
            return instrumented;
        },
        /**
         * Given a function that has been instrumented,
         * revert the function to it's original (non-instrumented) state.
         *
         * @param {Function} fn to de-instrument
         */ deinstrument: function StackTrace$$deinstrument(fn) {
            if (typeof fn !== "function") throw new Error("Cannot de-instrument non-function object");
            else if (typeof fn.__stacktraceOriginalFn === "function") return fn.__stacktraceOriginalFn;
            else // Function not instrumented, return original
            return fn;
        },
        /**
         * Given an error message and Array of StackFrames, serialize and POST to given URL.
         *
         * @param {Array} stackframes
         * @param {String} url
         * @param {String} errorMsg
         * @param {Object} requestOptions
         */ report: function StackTrace$$report(stackframes, url, errorMsg, requestOptions) {
            return new Promise(function(resolve, reject) {
                var req = new XMLHttpRequest();
                req.onerror = reject;
                req.onreadystatechange = function onreadystatechange() {
                    if (req.readyState === 4) {
                        if (req.status >= 200 && req.status < 400) resolve(req.responseText);
                        else reject(new Error("POST to " + url + " failed with status: " + req.status));
                    }
                };
                req.open("post", url);
                // Set request headers
                req.setRequestHeader("Content-Type", "application/json");
                if (requestOptions && typeof requestOptions.headers === "object") {
                    var headers = requestOptions.headers;
                    for(var header in headers)if (Object.prototype.hasOwnProperty.call(headers, header)) req.setRequestHeader(header, headers[header]);
                }
                var reportPayload = {
                    stack: stackframes
                };
                if (errorMsg !== undefined && errorMsg !== null) reportPayload.message = errorMsg;
                req.send(JSON.stringify(reportPayload));
            });
        }
    };
});

});
parcelRegister("5q4Xp", function(module, exports) {

(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("error-stack-parser", [
        "stackframe"
    ], factory);
    else module.exports = factory((parcelRequire("2kV53")));
})(module.exports, function ErrorStackParser(StackFrame) {
    "use strict";
    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;
    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */ parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== "undefined" || typeof error["opera#sourceloc"] !== "undefined") return this.parseOpera(error);
            else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
            else if (error.stack) return this.parseFFOrSafari(error);
            else throw new Error("Cannot parse given Error object");
        },
        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(":") === -1) return [
                urlLike
            ];
            var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[()]/g, ""));
            return [
                parts[1],
                parts[2] || undefined,
                parts[3] || undefined
            ];
        },
        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);
            return filtered.map(function(line) {
                if (line.indexOf("(eval ") > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, "");
                var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "(");
                // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                // case it has spaces in it, as the string is split on \s+ later on
                var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);
                // remove the parenthesized location from the line, if it was matched
                sanitizedLine = location ? sanitizedLine.replace(location[0], "") : sanitizedLine;
                var tokens = sanitizedLine.split(/\s+/).slice(1);
                // if a location was matched, pass it to extractLocation() otherwise pop the last token
                var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                var functionName = tokens.join(" ") || undefined;
                var fileName = [
                    "eval",
                    "<anonymous>"
                ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                return new StackFrame({
                    functionName: functionName,
                    fileName: fileName,
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        },
        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);
            return filtered.map(function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(" > eval") > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1");
                if (line.indexOf("@") === -1 && line.indexOf(":") === -1) // Safari eval frames only have function names and nothing else
                return new StackFrame({
                    functionName: line
                });
                else {
                    var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                    var matches = line.match(functionNameRegex);
                    var functionName = matches && matches[1] ? matches[1] : undefined;
                    var locationParts = this.extractLocation(line.replace(functionNameRegex, ""));
                    return new StackFrame({
                        functionName: functionName,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }
            }, this);
        },
        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length) return this.parseOpera9(e);
            else if (!e.stack) return this.parseOpera10(e);
            else return this.parseOpera11(e);
        },
        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split("\n");
            var result = [];
            for(var i = 2, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame({
                    fileName: match[2],
                    lineNumber: match[1],
                    source: lines[i]
                }));
            }
            return result;
        },
        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split("\n");
            var result = [];
            for(var i = 0, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame({
                    functionName: match[3] || undefined,
                    fileName: match[2],
                    lineNumber: match[1],
                    source: lines[i]
                }));
            }
            return result;
        },
        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);
            return filtered.map(function(line) {
                var tokens = line.split("@");
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = tokens.shift() || "";
                var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^)]*)\)/)) argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, "$1");
                var args = argsRaw === undefined || argsRaw === "[arguments not available]" ? undefined : argsRaw.split(",");
                return new StackFrame({
                    functionName: functionName,
                    args: args,
                    fileName: locationParts[0],
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        }
    };
});

});
parcelRegister("2kV53", function(module, exports) {
(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stackframe", [], factory);
    else module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    function _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }
    function _getter(p) {
        return function() {
            return this[p];
        };
    }
    var booleanProps = [
        "isConstructor",
        "isEval",
        "isNative",
        "isToplevel"
    ];
    var numericProps = [
        "columnNumber",
        "lineNumber"
    ];
    var stringProps = [
        "fileName",
        "functionName",
        "source"
    ];
    var arrayProps = [
        "args"
    ];
    var objectProps = [
        "evalOrigin"
    ];
    var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);
    function StackFrame(obj) {
        if (!obj) return;
        for(var i = 0; i < props.length; i++)if (obj[props[i]] !== undefined) this["set" + _capitalize(props[i])](obj[props[i]]);
    }
    StackFrame.prototype = {
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== "[object Array]") throw new TypeError("Args must be an Array");
            this.args = v;
        },
        getEvalOrigin: function() {
            return this.evalOrigin;
        },
        setEvalOrigin: function(v) {
            if (v instanceof StackFrame) this.evalOrigin = v;
            else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
            else throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
            var fileName = this.getFileName() || "";
            var lineNumber = this.getLineNumber() || "";
            var columnNumber = this.getColumnNumber() || "";
            var functionName = this.getFunctionName() || "";
            if (this.getIsEval()) {
                if (fileName) return "[eval] (" + fileName + ":" + lineNumber + ":" + columnNumber + ")";
                return "[eval]:" + lineNumber + ":" + columnNumber;
            }
            if (functionName) return functionName + " (" + fileName + ":" + lineNumber + ":" + columnNumber + ")";
            return fileName + ":" + lineNumber + ":" + columnNumber;
        }
    };
    StackFrame.fromString = function StackFrame$$fromString(str) {
        var argsStartIndex = str.indexOf("(");
        var argsEndIndex = str.lastIndexOf(")");
        var functionName = str.substring(0, argsStartIndex);
        var args = str.substring(argsStartIndex + 1, argsEndIndex).split(",");
        var locationString = str.substring(argsEndIndex + 1);
        if (locationString.indexOf("@") === 0) {
            var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, "");
            var fileName = parts[1];
            var lineNumber = parts[2];
            var columnNumber = parts[3];
        }
        return new StackFrame({
            functionName: functionName,
            args: args || undefined,
            fileName: fileName,
            lineNumber: lineNumber || undefined,
            columnNumber: columnNumber || undefined
        });
    };
    for(var i = 0; i < booleanProps.length; i++){
        StackFrame.prototype["get" + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
        StackFrame.prototype["set" + _capitalize(booleanProps[i])] = function(p) {
            return function(v) {
                this[p] = Boolean(v);
            };
        }(booleanProps[i]);
    }
    for(var j = 0; j < numericProps.length; j++){
        StackFrame.prototype["get" + _capitalize(numericProps[j])] = _getter(numericProps[j]);
        StackFrame.prototype["set" + _capitalize(numericProps[j])] = function(p) {
            return function(v) {
                if (!_isNumber(v)) throw new TypeError(p + " must be a Number");
                this[p] = Number(v);
            };
        }(numericProps[j]);
    }
    for(var k = 0; k < stringProps.length; k++){
        StackFrame.prototype["get" + _capitalize(stringProps[k])] = _getter(stringProps[k]);
        StackFrame.prototype["set" + _capitalize(stringProps[k])] = function(p) {
            return function(v) {
                this[p] = String(v);
            };
        }(stringProps[k]);
    }
    return StackFrame;
});

});


parcelRegister("FwcmS", function(module, exports) {

(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stack-generator", [
        "stackframe"
    ], factory);
    else module.exports = factory((parcelRequire("2kV53")));
})(module.exports, function(StackFrame) {
    return {
        backtrace: function StackGenerator$$backtrace(opts) {
            var stack = [];
            var maxStackSize = 10;
            if (typeof opts === "object" && typeof opts.maxStackSize === "number") maxStackSize = opts.maxStackSize;
            var curr = arguments.callee;
            while(curr && stack.length < maxStackSize && curr["arguments"]){
                // Allow V8 optimizations
                var args = new Array(curr["arguments"].length);
                for(var i = 0; i < args.length; ++i)args[i] = curr["arguments"][i];
                if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(new StackFrame({
                    functionName: RegExp.$1 || undefined,
                    args: args
                }));
                else stack.push(new StackFrame({
                    args: args
                }));
                try {
                    curr = curr.caller;
                } catch (e) {
                    break;
                }
            }
            return stack;
        }
    };
});

});

parcelRegister("lKzMa", function(module, exports) {


(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stacktrace-gps", [
        "source-map",
        "stackframe"
    ], factory);
    else module.exports = factory((parcelRequire("1wJRr")), (parcelRequire("2kV53")));
})(module.exports, function(SourceMap, StackFrame) {
    "use strict";
    /**
     * Make a X-Domain request to url and callback.
     *
     * @param {String} url
     * @returns {Promise} with response text if fulfilled
     */ function _xdr(url) {
        return new Promise(function(resolve, reject) {
            var req = new XMLHttpRequest();
            req.open("get", url);
            req.onerror = reject;
            req.onreadystatechange = function onreadystatechange() {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 300 || url.substr(0, 7) === "file://" && req.responseText) resolve(req.responseText);
                    else reject(new Error("HTTP status: " + req.status + " retrieving " + url));
                }
            };
            req.send();
        });
    }
    /**
     * Convert a Base64-encoded string into its original representation.
     * Used for inline sourcemaps.
     *
     * @param {String} b64str Base-64 encoded string
     * @returns {String} original representation of the base64-encoded string.
     */ function _atob(b64str) {
        if (typeof window !== "undefined" && window.atob) return window.atob(b64str);
        else throw new Error("You must supply a polyfill for window.atob in this environment");
    }
    function _parseJson(string) {
        if (typeof JSON !== "undefined" && JSON.parse) return JSON.parse(string);
        else throw new Error("You must supply a polyfill for JSON.parse in this environment");
    }
    function _findFunctionName(source, lineNumber /*, columnNumber*/ ) {
        var syntaxes = [
            // {name} = function ({args}) TODO args capture
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*function\b/,
            // function {name}({args}) m[1]=name m[2]=args
            /function\s+([^('"`]*?)\s*\(([^)]*)\)/,
            // {name} = eval()
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*(?:eval|new Function)\b/,
            // fn_name() {
            /\b(?!(?:if|for|switch|while|with|catch)\b)(?:(?:static)\s+)?(\S+)\s*\(.*?\)\s*\{/,
            // {name} = () => {
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*\(.*?\)\s*=>/
        ];
        var lines = source.split("\n");
        // Walk backwards in the source lines until we find the line which matches one of the patterns above
        var code = "";
        var maxLines = Math.min(lineNumber, 20);
        for(var i = 0; i < maxLines; ++i){
            // lineNo is 1-based, source[] is 0-based
            var line = lines[lineNumber - i - 1];
            var commentPos = line.indexOf("//");
            if (commentPos >= 0) line = line.substr(0, commentPos);
            if (line) {
                code = line + code;
                var len = syntaxes.length;
                for(var index = 0; index < len; index++){
                    var m = syntaxes[index].exec(code);
                    if (m && m[1]) return m[1];
                }
            }
        }
        return undefined;
    }
    function _ensureSupportedEnvironment() {
        if (typeof Object.defineProperty !== "function" || typeof Object.create !== "function") throw new Error("Unable to consume source maps in older browsers");
    }
    function _ensureStackFrameIsLegit(stackframe) {
        if (typeof stackframe !== "object") throw new TypeError("Given StackFrame is not an object");
        else if (typeof stackframe.fileName !== "string") throw new TypeError("Given file name is not a String");
        else if (typeof stackframe.lineNumber !== "number" || stackframe.lineNumber % 1 !== 0 || stackframe.lineNumber < 1) throw new TypeError("Given line number must be a positive integer");
        else if (typeof stackframe.columnNumber !== "number" || stackframe.columnNumber % 1 !== 0 || stackframe.columnNumber < 0) throw new TypeError("Given column number must be a non-negative integer");
        return true;
    }
    function _findSourceMappingURL(source) {
        var sourceMappingUrlRegExp = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/mg;
        var lastSourceMappingUrl;
        var matchSourceMappingUrl;
        // eslint-disable-next-line no-cond-assign
        while(matchSourceMappingUrl = sourceMappingUrlRegExp.exec(source))lastSourceMappingUrl = matchSourceMappingUrl[1];
        if (lastSourceMappingUrl) return lastSourceMappingUrl;
        else throw new Error("sourceMappingURL not found");
    }
    function _extractLocationInfoFromSourceMapSource(stackframe, sourceMapConsumer, sourceCache) {
        return new Promise(function(resolve, reject) {
            var loc = sourceMapConsumer.originalPositionFor({
                line: stackframe.lineNumber,
                column: stackframe.columnNumber
            });
            if (loc.source) {
                // cache mapped sources
                var mappedSource = sourceMapConsumer.sourceContentFor(loc.source);
                if (mappedSource) sourceCache[loc.source] = mappedSource;
                resolve(// given stackframe and source location, update stackframe
                new StackFrame({
                    functionName: loc.name || stackframe.functionName,
                    args: stackframe.args,
                    fileName: loc.source,
                    lineNumber: loc.line,
                    columnNumber: loc.column
                }));
            } else reject(new Error("Could not get original source for given stackframe and source map"));
        });
    }
    /**
     * @constructor
     * @param {Object} opts
     *      opts.sourceCache = {url: "Source String"} => preload source cache
     *      opts.sourceMapConsumerCache = {/path/file.js.map: SourceMapConsumer}
     *      opts.offline = True to prevent network requests.
     *              Best effort without sources or source maps.
     *      opts.ajax = Promise returning function to make X-Domain requests
     */ return function StackTraceGPS(opts) {
        if (!(this instanceof StackTraceGPS)) return new StackTraceGPS(opts);
        opts = opts || {};
        this.sourceCache = opts.sourceCache || {};
        this.sourceMapConsumerCache = opts.sourceMapConsumerCache || {};
        this.ajax = opts.ajax || _xdr;
        this._atob = opts.atob || _atob;
        this._get = function _get(location) {
            return new Promise((function(resolve, reject) {
                var isDataUrl = location.substr(0, 5) === "data:";
                if (this.sourceCache[location]) resolve(this.sourceCache[location]);
                else if (opts.offline && !isDataUrl) reject(new Error("Cannot make network requests in offline mode"));
                else if (isDataUrl) {
                    // data URLs can have parameters.
                    // see http://tools.ietf.org/html/rfc2397
                    var supportedEncodingRegexp = /^data:application\/json;([\w=:"-]+;)*base64,/;
                    var match = location.match(supportedEncodingRegexp);
                    if (match) {
                        var sourceMapStart = match[0].length;
                        var encodedSource = location.substr(sourceMapStart);
                        var source = this._atob(encodedSource);
                        this.sourceCache[location] = source;
                        resolve(source);
                    } else reject(new Error("The encoding of the inline sourcemap is not supported"));
                } else {
                    var xhrPromise = this.ajax(location, {
                        method: "get"
                    });
                    // Cache the Promise to prevent duplicate in-flight requests
                    this.sourceCache[location] = xhrPromise;
                    xhrPromise.then(resolve, reject);
                }
            }).bind(this));
        };
        /**
         * Creating SourceMapConsumers is expensive, so this wraps the creation of a
         * SourceMapConsumer in a per-instance cache.
         *
         * @param {String} sourceMappingURL = URL to fetch source map from
         * @param {String} defaultSourceRoot = Default source root for source map if undefined
         * @returns {Promise} that resolves a SourceMapConsumer
         */ this._getSourceMapConsumer = function _getSourceMapConsumer(sourceMappingURL, defaultSourceRoot) {
            return new Promise((function(resolve) {
                if (this.sourceMapConsumerCache[sourceMappingURL]) resolve(this.sourceMapConsumerCache[sourceMappingURL]);
                else {
                    var sourceMapConsumerPromise = new Promise((function(resolve, reject) {
                        return this._get(sourceMappingURL).then(function(sourceMapSource) {
                            if (typeof sourceMapSource === "string") sourceMapSource = _parseJson(sourceMapSource.replace(/^\)\]\}'/, ""));
                            if (typeof sourceMapSource.sourceRoot === "undefined") sourceMapSource.sourceRoot = defaultSourceRoot;
                            resolve(new SourceMap.SourceMapConsumer(sourceMapSource));
                        }).catch(reject);
                    }).bind(this));
                    this.sourceMapConsumerCache[sourceMappingURL] = sourceMapConsumerPromise;
                    resolve(sourceMapConsumerPromise);
                }
            }).bind(this));
        };
        /**
         * Given a StackFrame, enhance function name and use source maps for a
         * better StackFrame.
         *
         * @param {StackFrame} stackframe object
         * @returns {Promise} that resolves with with source-mapped StackFrame
         */ this.pinpoint = function StackTraceGPS$$pinpoint(stackframe) {
            return new Promise((function(resolve, reject) {
                this.getMappedLocation(stackframe).then((function(mappedStackFrame) {
                    function resolveMappedStackFrame() {
                        resolve(mappedStackFrame);
                    }
                    this.findFunctionName(mappedStackFrame).then(resolve, resolveMappedStackFrame)["catch"](resolveMappedStackFrame);
                }).bind(this), reject);
            }).bind(this));
        };
        /**
         * Given a StackFrame, guess function name from location information.
         *
         * @param {StackFrame} stackframe
         * @returns {Promise} that resolves with enhanced StackFrame.
         */ this.findFunctionName = function StackTraceGPS$$findFunctionName(stackframe) {
            return new Promise((function(resolve, reject) {
                _ensureStackFrameIsLegit(stackframe);
                this._get(stackframe.fileName).then(function getSourceCallback(source) {
                    var lineNumber = stackframe.lineNumber;
                    var columnNumber = stackframe.columnNumber;
                    var guessedFunctionName = _findFunctionName(source, lineNumber, columnNumber);
                    // Only replace functionName if we found something
                    if (guessedFunctionName) resolve(new StackFrame({
                        functionName: guessedFunctionName,
                        args: stackframe.args,
                        fileName: stackframe.fileName,
                        lineNumber: lineNumber,
                        columnNumber: columnNumber
                    }));
                    else resolve(stackframe);
                }, reject)["catch"](reject);
            }).bind(this));
        };
        /**
         * Given a StackFrame, seek source-mapped location and return new enhanced StackFrame.
         *
         * @param {StackFrame} stackframe
         * @returns {Promise} that resolves with enhanced StackFrame.
         */ this.getMappedLocation = function StackTraceGPS$$getMappedLocation(stackframe) {
            return new Promise((function(resolve, reject) {
                _ensureSupportedEnvironment();
                _ensureStackFrameIsLegit(stackframe);
                var sourceCache = this.sourceCache;
                var fileName = stackframe.fileName;
                this._get(fileName).then((function(source) {
                    var sourceMappingURL = _findSourceMappingURL(source);
                    var isDataUrl = sourceMappingURL.substr(0, 5) === "data:";
                    var defaultSourceRoot = fileName.substring(0, fileName.lastIndexOf("/") + 1);
                    if (sourceMappingURL[0] !== "/" && !isDataUrl && !/^https?:\/\/|^\/\//i.test(sourceMappingURL)) sourceMappingURL = defaultSourceRoot + sourceMappingURL;
                    return this._getSourceMapConsumer(sourceMappingURL, defaultSourceRoot).then(function(sourceMapConsumer) {
                        return _extractLocationInfoFromSourceMapSource(stackframe, sourceMapConsumer, sourceCache).then(resolve)["catch"](function() {
                            resolve(stackframe);
                        });
                    });
                }).bind(this), reject)["catch"](reject);
            }).bind(this));
        };
    };
});

});
parcelRegister("1wJRr", function(module, exports) {

$parcel$export(module.exports, "SourceMapConsumer", function () { return $11cc5aa7ba07b448$export$194e92554d04abdd; }, function (v) { return $11cc5aa7ba07b448$export$194e92554d04abdd = v; });
$parcel$export(module.exports, "BasicSourceMapConsumer", function () { return $11cc5aa7ba07b448$export$bef6691594139a79; }, function (v) { return $11cc5aa7ba07b448$export$bef6691594139a79 = v; });
$parcel$export(module.exports, "IndexedSourceMapConsumer", function () { return $11cc5aa7ba07b448$export$823525094e5b803c; }, function (v) { return $11cc5aa7ba07b448$export$823525094e5b803c = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $11cc5aa7ba07b448$export$194e92554d04abdd;
var $11cc5aa7ba07b448$export$bef6691594139a79;
var $11cc5aa7ba07b448$export$823525094e5b803c;

var $jAnEU = parcelRequire("jAnEU");

var $9EEuM = parcelRequire("9EEuM");

var $lA9c0 = parcelRequire("lA9c0");
var $11cc5aa7ba07b448$require$ArraySet = $lA9c0.ArraySet;

var $40yPQ = parcelRequire("40yPQ");

var $e5fKN = parcelRequire("e5fKN");
var $11cc5aa7ba07b448$require$quickSort = $e5fKN.quickSort;
function $11cc5aa7ba07b448$var$SourceMapConsumer(aSourceMap) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
    return sourceMap.sections != null ? new $11cc5aa7ba07b448$var$IndexedSourceMapConsumer(sourceMap) : new $11cc5aa7ba07b448$var$BasicSourceMapConsumer(sourceMap);
}
$11cc5aa7ba07b448$var$SourceMapConsumer.fromSourceMap = function(aSourceMap) {
    return $11cc5aa7ba07b448$var$BasicSourceMapConsumer.fromSourceMap(aSourceMap);
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $11cc5aa7ba07b448$var$SourceMapConsumer.prototype._version = 3;
// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.
$11cc5aa7ba07b448$var$SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty($11cc5aa7ba07b448$var$SourceMapConsumer.prototype, "_generatedMappings", {
    get: function() {
        if (!this.__generatedMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__generatedMappings;
    }
});
$11cc5aa7ba07b448$var$SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty($11cc5aa7ba07b448$var$SourceMapConsumer.prototype, "_originalMappings", {
    get: function() {
        if (!this.__originalMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__originalMappings;
    }
});
$11cc5aa7ba07b448$var$SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $11cc5aa7ba07b448$var$SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
};
$11cc5aa7ba07b448$var$SourceMapConsumer.GENERATED_ORDER = 1;
$11cc5aa7ba07b448$var$SourceMapConsumer.ORIGINAL_ORDER = 2;
$11cc5aa7ba07b448$var$SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
$11cc5aa7ba07b448$var$SourceMapConsumer.LEAST_UPPER_BOUND = 2;
/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */ $11cc5aa7ba07b448$var$SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || $11cc5aa7ba07b448$var$SourceMapConsumer.GENERATED_ORDER;
    var mappings;
    switch(order){
        case $11cc5aa7ba07b448$var$SourceMapConsumer.GENERATED_ORDER:
            mappings = this._generatedMappings;
            break;
        case $11cc5aa7ba07b448$var$SourceMapConsumer.ORIGINAL_ORDER:
            mappings = this._originalMappings;
            break;
        default:
            throw new Error("Unknown order of iteration.");
    }
    var sourceRoot = this.sourceRoot;
    mappings.map(function(mapping) {
        var source = mapping.source === null ? null : this._sources.at(mapping.source);
        if (source != null && sourceRoot != null) source = $jAnEU.join(sourceRoot, source);
        return {
            source: source,
            generatedLine: mapping.generatedLine,
            generatedColumn: mapping.generatedColumn,
            originalLine: mapping.originalLine,
            originalColumn: mapping.originalColumn,
            name: mapping.name === null ? null : this._names.at(mapping.name)
        };
    }, this).forEach(aCallback, context);
};
/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: Optional. the column number in the original source.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */ $11cc5aa7ba07b448$var$SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = $jAnEU.getArg(aArgs, "line");
    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
        source: $jAnEU.getArg(aArgs, "source"),
        originalLine: line,
        originalColumn: $jAnEU.getArg(aArgs, "column", 0)
    };
    if (this.sourceRoot != null) needle.source = $jAnEU.relative(this.sourceRoot, needle.source);
    if (!this._sources.has(needle.source)) return [];
    needle.source = this._sources.indexOf(needle.source);
    var mappings = [];
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $jAnEU.compareByOriginalPositions, $9EEuM.LEAST_UPPER_BOUND);
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (aArgs.column === undefined) {
            var originalLine = mapping.originalLine;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we found. Since
            // mappings are sorted, this is guaranteed to find all mappings for
            // the line we found.
            while(mapping && mapping.originalLine === originalLine){
                mappings.push({
                    line: $jAnEU.getArg(mapping, "generatedLine", null),
                    column: $jAnEU.getArg(mapping, "generatedColumn", null),
                    lastColumn: $jAnEU.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        } else {
            var originalColumn = mapping.originalColumn;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we were searching for.
            // Since mappings are sorted, this is guaranteed to find all mappings for
            // the line we are searching for.
            while(mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn){
                mappings.push({
                    line: $jAnEU.getArg(mapping, "generatedLine", null),
                    column: $jAnEU.getArg(mapping, "generatedColumn", null),
                    lastColumn: $jAnEU.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        }
    }
    return mappings;
};
$11cc5aa7ba07b448$export$194e92554d04abdd = $11cc5aa7ba07b448$var$SourceMapConsumer;
/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The only parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */ function $11cc5aa7ba07b448$var$BasicSourceMapConsumer(aSourceMap) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
    var version = $jAnEU.getArg(sourceMap, "version");
    var sources = $jAnEU.getArg(sourceMap, "sources");
    // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
    // requires the array) to play nice here.
    var names = $jAnEU.getArg(sourceMap, "names", []);
    var sourceRoot = $jAnEU.getArg(sourceMap, "sourceRoot", null);
    var sourcesContent = $jAnEU.getArg(sourceMap, "sourcesContent", null);
    var mappings = $jAnEU.getArg(sourceMap, "mappings");
    var file = $jAnEU.getArg(sourceMap, "file", null);
    // Once again, Sass deviates from the spec and supplies the version as a
    // string rather than a number, so we use loose equality checking here.
    if (version != this._version) throw new Error("Unsupported version: " + version);
    sources = sources.map(String)// Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map($jAnEU.normalize)// Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function(source) {
        return sourceRoot && $jAnEU.isAbsolute(sourceRoot) && $jAnEU.isAbsolute(source) ? $jAnEU.relative(sourceRoot, source) : source;
    });
    // Pass `true` below to allow duplicate names and sources. While source maps
    // are intended to be compressed and deduplicated, the TypeScript compiler
    // sometimes generates source maps with duplicates in them. See Github issue
    // #72 and bugzil.la/889492.
    this._names = $11cc5aa7ba07b448$require$ArraySet.fromArray(names.map(String), true);
    this._sources = $11cc5aa7ba07b448$require$ArraySet.fromArray(sources, true);
    this.sourceRoot = sourceRoot;
    this.sourcesContent = sourcesContent;
    this._mappings = mappings;
    this.file = file;
}
$11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype = Object.create($11cc5aa7ba07b448$var$SourceMapConsumer.prototype);
$11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.consumer = $11cc5aa7ba07b448$var$SourceMapConsumer;
/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @returns BasicSourceMapConsumer
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap) {
    var smc = Object.create($11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype);
    var names = smc._names = $11cc5aa7ba07b448$require$ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = $11cc5aa7ba07b448$require$ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
    smc.file = aSourceMap._file;
    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.
    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];
    for(var i = 0, length = generatedMappings.length; i < length; i++){
        var srcMapping = generatedMappings[i];
        var destMapping = new $11cc5aa7ba07b448$var$Mapping;
        destMapping.generatedLine = srcMapping.generatedLine;
        destMapping.generatedColumn = srcMapping.generatedColumn;
        if (srcMapping.source) {
            destMapping.source = sources.indexOf(srcMapping.source);
            destMapping.originalLine = srcMapping.originalLine;
            destMapping.originalColumn = srcMapping.originalColumn;
            if (srcMapping.name) destMapping.name = names.indexOf(srcMapping.name);
            destOriginalMappings.push(destMapping);
        }
        destGeneratedMappings.push(destMapping);
    }
    $11cc5aa7ba07b448$require$quickSort(smc.__originalMappings, $jAnEU.compareByOriginalPositions);
    return smc;
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype, "sources", {
    get: function() {
        return this._sources.toArray().map(function(s) {
            return this.sourceRoot != null ? $jAnEU.join(this.sourceRoot, s) : s;
        }, this);
    }
});
/**
 * Provide the JIT with a nice shape / hidden class.
 */ function $11cc5aa7ba07b448$var$Mapping() {
    this.generatedLine = 0;
    this.generatedColumn = 0;
    this.source = null;
    this.originalLine = null;
    this.originalColumn = null;
    this.name = null;
}
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;
    while(index < length){
        if (aStr.charAt(index) === ";") {
            generatedLine++;
            index++;
            previousGeneratedColumn = 0;
        } else if (aStr.charAt(index) === ",") index++;
        else {
            mapping = new $11cc5aa7ba07b448$var$Mapping();
            mapping.generatedLine = generatedLine;
            // Because each offset is encoded relative to the previous one,
            // many segments often have the same encoding. We can exploit this
            // fact by caching the parsed variable length fields of each segment,
            // allowing us to avoid a second parse if we encounter the same
            // segment again.
            for(end = index; end < length; end++){
                if (this._charIsMappingSeparator(aStr, end)) break;
            }
            str = aStr.slice(index, end);
            segment = cachedSegments[str];
            if (segment) index += str.length;
            else {
                segment = [];
                while(index < end){
                    $40yPQ.decode(aStr, index, temp);
                    value = temp.value;
                    index = temp.rest;
                    segment.push(value);
                }
                if (segment.length === 2) throw new Error("Found a source, but no line and column");
                if (segment.length === 3) throw new Error("Found a source and line, but no column");
                cachedSegments[str] = segment;
            }
            // Generated column.
            mapping.generatedColumn = previousGeneratedColumn + segment[0];
            previousGeneratedColumn = mapping.generatedColumn;
            if (segment.length > 1) {
                // Original source.
                mapping.source = previousSource + segment[1];
                previousSource += segment[1];
                // Original line.
                mapping.originalLine = previousOriginalLine + segment[2];
                previousOriginalLine = mapping.originalLine;
                // Lines are stored 0-based
                mapping.originalLine += 1;
                // Original column.
                mapping.originalColumn = previousOriginalColumn + segment[3];
                previousOriginalColumn = mapping.originalColumn;
                if (segment.length > 4) {
                    // Original name.
                    mapping.name = previousName + segment[4];
                    previousName += segment[4];
                }
            }
            generatedMappings.push(mapping);
            if (typeof mapping.originalLine === "number") originalMappings.push(mapping);
        }
    }
    $11cc5aa7ba07b448$require$quickSort(generatedMappings, $jAnEU.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;
    $11cc5aa7ba07b448$require$quickSort(originalMappings, $jAnEU.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
};
/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.
    if (aNeedle[aLineName] <= 0) throw new TypeError("Line must be greater than or equal to 1, got " + aNeedle[aLineName]);
    if (aNeedle[aColumnName] < 0) throw new TypeError("Column must be greater than or equal to 0, got " + aNeedle[aColumnName]);
    return $9EEuM.search(aNeedle, aMappings, aComparator, aBias);
};
/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
    for(var index = 0; index < this._generatedMappings.length; ++index){
        var mapping = this._generatedMappings[index];
        // Mappings do not contain a field for the last generated columnt. We
        // can come up with an optimistic estimate, however, by assuming that
        // mappings are contiguous (i.e. given two consecutive mappings, the
        // first mapping ends where the second one starts).
        if (index + 1 < this._generatedMappings.length) {
            var nextMapping = this._generatedMappings[index + 1];
            if (mapping.generatedLine === nextMapping.generatedLine) {
                mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
                continue;
            }
        }
        // The last mapping for each line spans the entire line.
        mapping.lastGeneratedColumn = Infinity;
    }
};
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $jAnEU.getArg(aArgs, "line"),
        generatedColumn: $jAnEU.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", $jAnEU.compareByGeneratedPositionsDeflated, $jAnEU.getArg(aArgs, "bias", $11cc5aa7ba07b448$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._generatedMappings[index];
        if (mapping.generatedLine === needle.generatedLine) {
            var source = $jAnEU.getArg(mapping, "source", null);
            if (source !== null) {
                source = this._sources.at(source);
                if (this.sourceRoot != null) source = $jAnEU.join(this.sourceRoot, source);
            }
            var name = $jAnEU.getArg(mapping, "name", null);
            if (name !== null) name = this._names.at(name);
            return {
                source: source,
                line: $jAnEU.getArg(mapping, "originalLine", null),
                column: $jAnEU.getArg(mapping, "originalColumn", null),
                name: name
            };
        }
    }
    return {
        source: null,
        line: null,
        column: null,
        name: null
    };
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) return false;
    return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
        return sc == null;
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) return null;
    if (this.sourceRoot != null) aSource = $jAnEU.relative(this.sourceRoot, aSource);
    if (this._sources.has(aSource)) return this.sourcesContent[this._sources.indexOf(aSource)];
    var url;
    if (this.sourceRoot != null && (url = $jAnEU.urlParse(this.sourceRoot))) {
        // XXX: file:// URIs and absolute paths lead to unexpected behavior for
        // many users. We can help them out when they expect file:// URIs to
        // behave like it would if they were running a local HTTP server. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
        var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
        if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
        if ((!url.path || url.path == "/") && this._sources.has("/" + aSource)) return this.sourcesContent[this._sources.indexOf("/" + aSource)];
    }
    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) return null;
    else throw new Error('"' + aSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = $jAnEU.getArg(aArgs, "source");
    if (this.sourceRoot != null) source = $jAnEU.relative(this.sourceRoot, source);
    if (!this._sources.has(source)) return {
        line: null,
        column: null,
        lastColumn: null
    };
    source = this._sources.indexOf(source);
    var needle = {
        source: source,
        originalLine: $jAnEU.getArg(aArgs, "line"),
        originalColumn: $jAnEU.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $jAnEU.compareByOriginalPositions, $jAnEU.getArg(aArgs, "bias", $11cc5aa7ba07b448$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (mapping.source === needle.source) return {
            line: $jAnEU.getArg(mapping, "generatedLine", null),
            column: $jAnEU.getArg(mapping, "generatedColumn", null),
            lastColumn: $jAnEU.getArg(mapping, "lastGeneratedColumn", null)
        };
    }
    return {
        line: null,
        column: null,
        lastColumn: null
    };
};
$11cc5aa7ba07b448$export$bef6691594139a79 = $11cc5aa7ba07b448$var$BasicSourceMapConsumer;
/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The only parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */ function $11cc5aa7ba07b448$var$IndexedSourceMapConsumer(aSourceMap) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
    var version = $jAnEU.getArg(sourceMap, "version");
    var sections = $jAnEU.getArg(sourceMap, "sections");
    if (version != this._version) throw new Error("Unsupported version: " + version);
    this._sources = new $11cc5aa7ba07b448$require$ArraySet();
    this._names = new $11cc5aa7ba07b448$require$ArraySet();
    var lastOffset = {
        line: -1,
        column: 0
    };
    this._sections = sections.map(function(s) {
        if (s.url) // The url field will require support for asynchronicity.
        // See https://github.com/mozilla/source-map/issues/16
        throw new Error("Support for url field in sections not implemented.");
        var offset = $jAnEU.getArg(s, "offset");
        var offsetLine = $jAnEU.getArg(offset, "line");
        var offsetColumn = $jAnEU.getArg(offset, "column");
        if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) throw new Error("Section offsets must be ordered and non-overlapping.");
        lastOffset = offset;
        return {
            generatedOffset: {
                // The offset fields are 0-based, but we use 1-based indices when
                // encoding/decoding from VLQ.
                generatedLine: offsetLine + 1,
                generatedColumn: offsetColumn + 1
            },
            consumer: new $11cc5aa7ba07b448$var$SourceMapConsumer($jAnEU.getArg(s, "map"))
        };
    });
}
$11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype = Object.create($11cc5aa7ba07b448$var$SourceMapConsumer.prototype);
$11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype.constructor = $11cc5aa7ba07b448$var$SourceMapConsumer;
/**
 * The version of the source mapping spec that we are consuming.
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype, "sources", {
    get: function() {
        var sources = [];
        for(var i = 0; i < this._sections.length; i++)for(var j = 0; j < this._sections[i].consumer.sources.length; j++)sources.push(this._sections[i].consumer.sources[j]);
        return sources;
    }
});
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $jAnEU.getArg(aArgs, "line"),
        generatedColumn: $jAnEU.getArg(aArgs, "column")
    };
    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = $9EEuM.search(needle, this._sections, function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) return cmp;
        return needle.generatedColumn - section.generatedOffset.generatedColumn;
    });
    var section = this._sections[sectionIndex];
    if (!section) return {
        source: null,
        line: null,
        column: null,
        name: null
    };
    return section.consumer.originalPositionFor({
        line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
        column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
        bias: aArgs.bias
    });
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function(s) {
        return s.consumer.hasContentsOfAllSources();
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var content = section.consumer.sourceContentFor(aSource, true);
        if (content) return content;
    }
    if (nullOnMissing) return null;
    else throw new Error('"' + aSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        // Only consider this section if the requested source is in the list of
        // sources of the consumer.
        if (section.consumer.sources.indexOf($jAnEU.getArg(aArgs, "source")) === -1) continue;
        var generatedPosition = section.consumer.generatedPositionFor(aArgs);
        if (generatedPosition) {
            var ret = {
                line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
                column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
            };
            return ret;
        }
    }
    return {
        line: null,
        column: null
    };
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var sectionMappings = section.consumer._generatedMappings;
        for(var j = 0; j < sectionMappings.length; j++){
            var mapping = sectionMappings[j];
            var source = section.consumer._sources.at(mapping.source);
            if (section.consumer.sourceRoot !== null) source = $jAnEU.join(section.consumer.sourceRoot, source);
            this._sources.add(source);
            source = this._sources.indexOf(source);
            var name = section.consumer._names.at(mapping.name);
            this._names.add(name);
            name = this._names.indexOf(name);
            // The mappings coming from the consumer for the section have
            // generated positions relative to the start of the section, so we
            // need to offset them to be relative to the start of the concatenated
            // generated file.
            var adjustedMapping = {
                source: source,
                generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
                generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
                originalLine: mapping.originalLine,
                originalColumn: mapping.originalColumn,
                name: name
            };
            this.__generatedMappings.push(adjustedMapping);
            if (typeof adjustedMapping.originalLine === "number") this.__originalMappings.push(adjustedMapping);
        }
    }
    $11cc5aa7ba07b448$require$quickSort(this.__generatedMappings, $jAnEU.compareByGeneratedPositionsDeflated);
    $11cc5aa7ba07b448$require$quickSort(this.__originalMappings, $jAnEU.compareByOriginalPositions);
};
$11cc5aa7ba07b448$export$823525094e5b803c = $11cc5aa7ba07b448$var$IndexedSourceMapConsumer;

});
parcelRegister("jAnEU", function(module, exports) {

$parcel$export(module.exports, "getArg", function () { return $e423bb486a8e7861$export$6e45e70adce70bb2; }, function (v) { return $e423bb486a8e7861$export$6e45e70adce70bb2 = v; });
$parcel$export(module.exports, "urlParse", function () { return $e423bb486a8e7861$export$d6e833647f7f5f17; }, function (v) { return $e423bb486a8e7861$export$d6e833647f7f5f17 = v; });
$parcel$export(module.exports, "isAbsolute", function () { return $e423bb486a8e7861$export$e434c7255acda994; }, function (v) { return $e423bb486a8e7861$export$e434c7255acda994 = v; });
$parcel$export(module.exports, "normalize", function () { return $e423bb486a8e7861$export$a3295358bff77e; }, function (v) { return $e423bb486a8e7861$export$a3295358bff77e = v; });
$parcel$export(module.exports, "join", function () { return $e423bb486a8e7861$export$f7e2c8231c57a8bd; }, function (v) { return $e423bb486a8e7861$export$f7e2c8231c57a8bd = v; });
$parcel$export(module.exports, "relative", function () { return $e423bb486a8e7861$export$f0e7d1106eeabbe6; }, function (v) { return $e423bb486a8e7861$export$f0e7d1106eeabbe6 = v; });
$parcel$export(module.exports, "toSetString", function () { return $e423bb486a8e7861$export$be0fa1163fa7a4c; }, function (v) { return $e423bb486a8e7861$export$be0fa1163fa7a4c = v; });
$parcel$export(module.exports, "compareByOriginalPositions", function () { return $e423bb486a8e7861$export$273077902de92ff2; }, function (v) { return $e423bb486a8e7861$export$273077902de92ff2 = v; });
$parcel$export(module.exports, "compareByGeneratedPositionsDeflated", function () { return $e423bb486a8e7861$export$b7acf533941302f6; }, function (v) { return $e423bb486a8e7861$export$b7acf533941302f6 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */ var $e423bb486a8e7861$export$6e45e70adce70bb2;
var $e423bb486a8e7861$export$d6e833647f7f5f17;
var $e423bb486a8e7861$export$2ec9abc2d2cac192;
var $e423bb486a8e7861$export$a3295358bff77e;
var $e423bb486a8e7861$export$f7e2c8231c57a8bd;
var $e423bb486a8e7861$export$e434c7255acda994;
var $e423bb486a8e7861$export$f0e7d1106eeabbe6;
var $e423bb486a8e7861$export$be0fa1163fa7a4c;
var $e423bb486a8e7861$export$1fc47c3d4c3302a1;
var $e423bb486a8e7861$export$273077902de92ff2;
var $e423bb486a8e7861$export$b7acf533941302f6;
var $e423bb486a8e7861$export$f9c43907549d61f1;
function $e423bb486a8e7861$var$getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) return aArgs[aName];
    else if (arguments.length === 3) return aDefaultValue;
    else throw new Error('"' + aName + '" is a required argument.');
}
$e423bb486a8e7861$export$6e45e70adce70bb2 = $e423bb486a8e7861$var$getArg;
var $e423bb486a8e7861$var$urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
var $e423bb486a8e7861$var$dataUrlRegexp = /^data:.+\,.+$/;
function $e423bb486a8e7861$var$urlParse(aUrl) {
    var match = aUrl.match($e423bb486a8e7861$var$urlRegexp);
    if (!match) return null;
    return {
        scheme: match[1],
        auth: match[2],
        host: match[3],
        port: match[4],
        path: match[5]
    };
}
$e423bb486a8e7861$export$d6e833647f7f5f17 = $e423bb486a8e7861$var$urlParse;
function $e423bb486a8e7861$var$urlGenerate(aParsedUrl) {
    var url = "";
    if (aParsedUrl.scheme) url += aParsedUrl.scheme + ":";
    url += "//";
    if (aParsedUrl.auth) url += aParsedUrl.auth + "@";
    if (aParsedUrl.host) url += aParsedUrl.host;
    if (aParsedUrl.port) url += ":" + aParsedUrl.port;
    if (aParsedUrl.path) url += aParsedUrl.path;
    return url;
}
$e423bb486a8e7861$export$2ec9abc2d2cac192 = $e423bb486a8e7861$var$urlGenerate;
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */ function $e423bb486a8e7861$var$normalize(aPath) {
    var path = aPath;
    var url = $e423bb486a8e7861$var$urlParse(aPath);
    if (url) {
        if (!url.path) return aPath;
        path = url.path;
    }
    var isAbsolute = $e423bb486a8e7861$export$e434c7255acda994(path);
    var parts = path.split(/\/+/);
    for(var part, up = 0, i = parts.length - 1; i >= 0; i--){
        part = parts[i];
        if (part === ".") parts.splice(i, 1);
        else if (part === "..") up++;
        else if (up > 0) {
            if (part === "") {
                // The first part is blank if the path is absolute. Trying to go
                // above the root is a no-op. Therefore we can remove all '..' parts
                // directly after the root.
                parts.splice(i + 1, up);
                up = 0;
            } else {
                parts.splice(i, 2);
                up--;
            }
        }
    }
    path = parts.join("/");
    if (path === "") path = isAbsolute ? "/" : ".";
    if (url) {
        url.path = path;
        return $e423bb486a8e7861$var$urlGenerate(url);
    }
    return path;
}
$e423bb486a8e7861$export$a3295358bff77e = $e423bb486a8e7861$var$normalize;
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */ function $e423bb486a8e7861$var$join(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    if (aPath === "") aPath = ".";
    var aPathUrl = $e423bb486a8e7861$var$urlParse(aPath);
    var aRootUrl = $e423bb486a8e7861$var$urlParse(aRoot);
    if (aRootUrl) aRoot = aRootUrl.path || "/";
    // `join(foo, '//www.example.org')`
    if (aPathUrl && !aPathUrl.scheme) {
        if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
        return $e423bb486a8e7861$var$urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match($e423bb486a8e7861$var$dataUrlRegexp)) return aPath;
    // `join('http://', 'www.example.com')`
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
        aRootUrl.host = aPath;
        return $e423bb486a8e7861$var$urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === "/" ? aPath : $e423bb486a8e7861$var$normalize(aRoot.replace(/\/+$/, "") + "/" + aPath);
    if (aRootUrl) {
        aRootUrl.path = joined;
        return $e423bb486a8e7861$var$urlGenerate(aRootUrl);
    }
    return joined;
}
$e423bb486a8e7861$export$f7e2c8231c57a8bd = $e423bb486a8e7861$var$join;
$e423bb486a8e7861$export$e434c7255acda994 = function(aPath) {
    return aPath.charAt(0) === "/" || !!aPath.match($e423bb486a8e7861$var$urlRegexp);
};
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */ function $e423bb486a8e7861$var$relative(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    aRoot = aRoot.replace(/\/$/, "");
    // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.
    var level = 0;
    while(aPath.indexOf(aRoot + "/") !== 0){
        var index = aRoot.lastIndexOf("/");
        if (index < 0) return aPath;
        // If the only part of the root that is left is the scheme (i.e. http://,
        // file:///, etc.), one or more slashes (/), or simply nothing at all, we
        // have exhausted all components, so the path is not relative to the root.
        aRoot = aRoot.slice(0, index);
        if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
        ++level;
    }
    // Make sure we add a "../" for each component we removed from the root.
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
$e423bb486a8e7861$export$f0e7d1106eeabbe6 = $e423bb486a8e7861$var$relative;
var $e423bb486a8e7861$var$supportsNullProto = function() {
    var obj = Object.create(null);
    return !("__proto__" in obj);
}();
function $e423bb486a8e7861$var$identity(s) {
    return s;
}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */ function $e423bb486a8e7861$var$toSetString(aStr) {
    if ($e423bb486a8e7861$var$isProtoString(aStr)) return "$" + aStr;
    return aStr;
}
$e423bb486a8e7861$export$be0fa1163fa7a4c = $e423bb486a8e7861$var$supportsNullProto ? $e423bb486a8e7861$var$identity : $e423bb486a8e7861$var$toSetString;
function $e423bb486a8e7861$var$fromSetString(aStr) {
    if ($e423bb486a8e7861$var$isProtoString(aStr)) return aStr.slice(1);
    return aStr;
}
$e423bb486a8e7861$export$1fc47c3d4c3302a1 = $e423bb486a8e7861$var$supportsNullProto ? $e423bb486a8e7861$var$identity : $e423bb486a8e7861$var$fromSetString;
function $e423bb486a8e7861$var$isProtoString(s) {
    if (!s) return false;
    var length = s.length;
    if (length < 9 /* "__proto__".length */ ) return false;
    if (s.charCodeAt(length - 1) !== 95 /* '_' */  || s.charCodeAt(length - 2) !== 95 /* '_' */  || s.charCodeAt(length - 3) !== 111 /* 'o' */  || s.charCodeAt(length - 4) !== 116 /* 't' */  || s.charCodeAt(length - 5) !== 111 /* 'o' */  || s.charCodeAt(length - 6) !== 114 /* 'r' */  || s.charCodeAt(length - 7) !== 112 /* 'p' */  || s.charCodeAt(length - 8) !== 95 /* '_' */  || s.charCodeAt(length - 9) !== 95 /* '_' */ ) return false;
    for(var i = length - 10; i >= 0; i--){
        if (s.charCodeAt(i) !== 36 /* '$' */ ) return false;
    }
    return true;
}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */ function $e423bb486a8e7861$var$compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = mappingA.source - mappingB.source;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return mappingA.name - mappingB.name;
}
$e423bb486a8e7861$export$273077902de92ff2 = $e423bb486a8e7861$var$compareByOriginalPositions;
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */ function $e423bb486a8e7861$var$compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = mappingA.source - mappingB.source;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return mappingA.name - mappingB.name;
}
$e423bb486a8e7861$export$b7acf533941302f6 = $e423bb486a8e7861$var$compareByGeneratedPositionsDeflated;
function $e423bb486a8e7861$var$strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) return 0;
    if (aStr1 > aStr2) return 1;
    return -1;
}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */ function $e423bb486a8e7861$var$compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = $e423bb486a8e7861$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $e423bb486a8e7861$var$strcmp(mappingA.name, mappingB.name);
}
$e423bb486a8e7861$export$f9c43907549d61f1 = $e423bb486a8e7861$var$compareByGeneratedPositionsInflated;

});

parcelRegister("9EEuM", function(module, exports) {

$parcel$export(module.exports, "GREATEST_LOWER_BOUND", function () { return $707743081a8e9eb6$export$4ecd616dce182dff; }, function (v) { return $707743081a8e9eb6$export$4ecd616dce182dff = v; });
$parcel$export(module.exports, "LEAST_UPPER_BOUND", function () { return $707743081a8e9eb6$export$b99fbecff261243; }, function (v) { return $707743081a8e9eb6$export$b99fbecff261243 = v; });
$parcel$export(module.exports, "search", function () { return $707743081a8e9eb6$export$d76128d007d19019; }, function (v) { return $707743081a8e9eb6$export$d76128d007d19019 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $707743081a8e9eb6$export$4ecd616dce182dff;
var $707743081a8e9eb6$export$b99fbecff261243;
/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */ var $707743081a8e9eb6$export$d76128d007d19019;
$707743081a8e9eb6$export$4ecd616dce182dff = 1;
$707743081a8e9eb6$export$b99fbecff261243 = 2;
/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */ function $707743081a8e9eb6$var$recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
    // This function terminates when one of the following is true:
    //
    //   1. We find the exact element we are looking for.
    //
    //   2. We did not find the exact element, but we can return the index of
    //      the next-closest element.
    //
    //   3. We did not find the exact element, and there is no next-closest
    //      element than the one we are searching for, so we return -1.
    var mid = Math.floor((aHigh - aLow) / 2) + aLow;
    var cmp = aCompare(aNeedle, aHaystack[mid], true);
    if (cmp === 0) // Found the element we are looking for.
    return mid;
    else if (cmp > 0) {
        // Our needle is greater than aHaystack[mid].
        if (aHigh - mid > 1) // The element is in the upper half.
        return $707743081a8e9eb6$var$recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
        // The exact needle element was not found in this haystack. Determine if
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $707743081a8e9eb6$export$b99fbecff261243) return aHigh < aHaystack.length ? aHigh : -1;
        else return mid;
    } else {
        // Our needle is less than aHaystack[mid].
        if (mid - aLow > 1) // The element is in the lower half.
        return $707743081a8e9eb6$var$recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $707743081a8e9eb6$export$b99fbecff261243) return mid;
        else return aLow < 0 ? -1 : aLow;
    }
}
$707743081a8e9eb6$export$d76128d007d19019 = function search(aNeedle, aHaystack, aCompare, aBias) {
    if (aHaystack.length === 0) return -1;
    var index = $707743081a8e9eb6$var$recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || $707743081a8e9eb6$export$4ecd616dce182dff);
    if (index < 0) return -1;
    // We have found either the exact element, or the next-closest element than
    // the one we are searching for. However, there may be more than one such
    // element. Make sure we always return the smallest of these.
    while(index - 1 >= 0){
        if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) break;
        --index;
    }
    return index;
};

});

parcelRegister("lA9c0", function(module, exports) {

$parcel$export(module.exports, "ArraySet", function () { return $fb641740934ab1d2$export$605bbf5ea7b60ba3; }, function (v) { return $fb641740934ab1d2$export$605bbf5ea7b60ba3 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $fb641740934ab1d2$export$605bbf5ea7b60ba3;

var $jAnEU = parcelRequire("jAnEU");
var $fb641740934ab1d2$var$has = Object.prototype.hasOwnProperty;
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */ function $fb641740934ab1d2$var$ArraySet() {
    this._array = [];
    this._set = Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ $fb641740934ab1d2$var$ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
    var set = new $fb641740934ab1d2$var$ArraySet();
    for(var i = 0, len = aArray.length; i < len; i++)set.add(aArray[i], aAllowDuplicates);
    return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */ $fb641740934ab1d2$var$ArraySet.prototype.size = function ArraySet_size() {
    return Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */ $fb641740934ab1d2$var$ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
    var sStr = $jAnEU.toSetString(aStr);
    var isDuplicate = $fb641740934ab1d2$var$has.call(this._set, sStr);
    var idx = this._array.length;
    if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
    if (!isDuplicate) this._set[sStr] = idx;
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */ $fb641740934ab1d2$var$ArraySet.prototype.has = function ArraySet_has(aStr) {
    var sStr = $jAnEU.toSetString(aStr);
    return $fb641740934ab1d2$var$has.call(this._set, sStr);
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */ $fb641740934ab1d2$var$ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
    var sStr = $jAnEU.toSetString(aStr);
    if ($fb641740934ab1d2$var$has.call(this._set, sStr)) return this._set[sStr];
    throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */ $fb641740934ab1d2$var$ArraySet.prototype.at = function ArraySet_at(aIdx) {
    if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
    throw new Error("No element indexed by " + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */ $fb641740934ab1d2$var$ArraySet.prototype.toArray = function ArraySet_toArray() {
    return this._array.slice();
};
$fb641740934ab1d2$export$605bbf5ea7b60ba3 = $fb641740934ab1d2$var$ArraySet;

});

parcelRegister("40yPQ", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $2eb22f0d829d9688$export$2f872c0f2117be69; }, function (v) { return $2eb22f0d829d9688$export$2f872c0f2117be69 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * Returns the base 64 VLQ encoded value.
 */ var $2eb22f0d829d9688$export$c564cdbbe6da493;
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */ var $2eb22f0d829d9688$export$2f872c0f2117be69;

var $l5UhZ = parcelRequire("l5UhZ");
// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
var $2eb22f0d829d9688$var$VLQ_BASE_SHIFT = 5;
// binary: 100000
var $2eb22f0d829d9688$var$VLQ_BASE = 1 << $2eb22f0d829d9688$var$VLQ_BASE_SHIFT;
// binary: 011111
var $2eb22f0d829d9688$var$VLQ_BASE_MASK = $2eb22f0d829d9688$var$VLQ_BASE - 1;
// binary: 100000
var $2eb22f0d829d9688$var$VLQ_CONTINUATION_BIT = $2eb22f0d829d9688$var$VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */ function $2eb22f0d829d9688$var$toVLQSigned(aValue) {
    return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */ function $2eb22f0d829d9688$var$fromVLQSigned(aValue) {
    var isNegative = (aValue & 1) === 1;
    var shifted = aValue >> 1;
    return isNegative ? -shifted : shifted;
}
$2eb22f0d829d9688$export$c564cdbbe6da493 = function base64VLQ_encode(aValue) {
    var encoded = "";
    var digit;
    var vlq = $2eb22f0d829d9688$var$toVLQSigned(aValue);
    do {
        digit = vlq & $2eb22f0d829d9688$var$VLQ_BASE_MASK;
        vlq >>>= $2eb22f0d829d9688$var$VLQ_BASE_SHIFT;
        if (vlq > 0) // There are still more digits in this value, so we must make sure the
        // continuation bit is marked.
        digit |= $2eb22f0d829d9688$var$VLQ_CONTINUATION_BIT;
        encoded += $l5UhZ.encode(digit);
    }while (vlq > 0);
    return encoded;
};
$2eb22f0d829d9688$export$2f872c0f2117be69 = function base64VLQ_decode(aStr, aIndex, aOutParam) {
    var strLen = aStr.length;
    var result = 0;
    var shift = 0;
    var continuation, digit;
    do {
        if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
        digit = $l5UhZ.decode(aStr.charCodeAt(aIndex++));
        if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
        continuation = !!(digit & $2eb22f0d829d9688$var$VLQ_CONTINUATION_BIT);
        digit &= $2eb22f0d829d9688$var$VLQ_BASE_MASK;
        result = result + (digit << shift);
        shift += $2eb22f0d829d9688$var$VLQ_BASE_SHIFT;
    }while (continuation);
    aOutParam.value = $2eb22f0d829d9688$var$fromVLQSigned(result);
    aOutParam.rest = aIndex;
};

});
parcelRegister("l5UhZ", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $f5b5ba79f5f0b860$export$c564cdbbe6da493; }, function (v) { return $f5b5ba79f5f0b860$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $f5b5ba79f5f0b860$export$2f872c0f2117be69; }, function (v) { return $f5b5ba79f5f0b860$export$2f872c0f2117be69 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */ var $f5b5ba79f5f0b860$export$c564cdbbe6da493;
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */ var $f5b5ba79f5f0b860$export$2f872c0f2117be69;
var $f5b5ba79f5f0b860$var$intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
$f5b5ba79f5f0b860$export$c564cdbbe6da493 = function(number) {
    if (0 <= number && number < $f5b5ba79f5f0b860$var$intToCharMap.length) return $f5b5ba79f5f0b860$var$intToCharMap[number];
    throw new TypeError("Must be between 0 and 63: " + number);
};
$f5b5ba79f5f0b860$export$2f872c0f2117be69 = function(charCode) {
    var bigA = 65; // 'A'
    var bigZ = 90; // 'Z'
    var littleA = 97; // 'a'
    var littleZ = 122; // 'z'
    var zero = 48; // '0'
    var nine = 57; // '9'
    var plus = 43; // '+'
    var slash = 47; // '/'
    var littleOffset = 26;
    var numberOffset = 52;
    // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
    if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
    // 26 - 51: abcdefghijklmnopqrstuvwxyz
    if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
    // 52 - 61: 0123456789
    if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
    // 62: +
    if (charCode == plus) return 62;
    // 63: /
    if (charCode == slash) return 63;
    // Invalid base64 digit.
    return -1;
};

});


parcelRegister("e5fKN", function(module, exports) {

$parcel$export(module.exports, "quickSort", function () { return $a40dc0ad3bfcf5f0$export$866270269b9544a5; }, function (v) { return $a40dc0ad3bfcf5f0$export$866270269b9544a5 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ // It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.
/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */ /**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */ var $a40dc0ad3bfcf5f0$export$866270269b9544a5;
function $a40dc0ad3bfcf5f0$var$swap(ary, x, y) {
    var temp = ary[x];
    ary[x] = ary[y];
    ary[y] = temp;
}
/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */ function $a40dc0ad3bfcf5f0$var$randomIntInRange(low, high) {
    return Math.round(low + Math.random() * (high - low));
}
/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */ function $a40dc0ad3bfcf5f0$var$doQuickSort(ary, comparator, p, r) {
    // If our lower bound is less than our upper bound, we (1) partition the
    // array into two pieces and (2) recurse on each half. If it is not, this is
    // the empty array and our base case.
    if (p < r) {
        // (1) Partitioning.
        //
        // The partitioning chooses a pivot between `p` and `r` and moves all
        // elements that are less than or equal to the pivot to the before it, and
        // all the elements that are greater than it after it. The effect is that
        // once partition is done, the pivot is in the exact place it will be when
        // the array is put in sorted order, and it will not need to be moved
        // again. This runs in O(n) time.
        // Always choose a random pivot so that an input array which is reverse
        // sorted does not cause O(n^2) running time.
        var pivotIndex = $a40dc0ad3bfcf5f0$var$randomIntInRange(p, r);
        var i = p - 1;
        $a40dc0ad3bfcf5f0$var$swap(ary, pivotIndex, r);
        var pivot = ary[r];
        // Immediately after `j` is incremented in this loop, the following hold
        // true:
        //
        //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
        //
        //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
        for(var j = p; j < r; j++)if (comparator(ary[j], pivot) <= 0) {
            i += 1;
            $a40dc0ad3bfcf5f0$var$swap(ary, i, j);
        }
        $a40dc0ad3bfcf5f0$var$swap(ary, i + 1, j);
        var q = i + 1;
        // (2) Recurse on each half.
        $a40dc0ad3bfcf5f0$var$doQuickSort(ary, comparator, p, q - 1);
        $a40dc0ad3bfcf5f0$var$doQuickSort(ary, comparator, q + 1, r);
    }
}
$a40dc0ad3bfcf5f0$export$866270269b9544a5 = function(ary, comparator) {
    $a40dc0ad3bfcf5f0$var$doQuickSort(ary, comparator, 0, ary.length - 1);
};

});




parcelRegister("8Hv2S", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2IVpK = parcelRequire("2IVpK");
"use strict";
function $655a6bdb16b925e8$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $655a6bdb16b925e8$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $655a6bdb16b925e8$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $655a6bdb16b925e8$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $2IVpK.cwd();
                path = cwd;
            }
            $655a6bdb16b925e8$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $655a6bdb16b925e8$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $655a6bdb16b925e8$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $655a6bdb16b925e8$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $655a6bdb16b925e8$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $655a6bdb16b925e8$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $655a6bdb16b925e8$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $655a6bdb16b925e8$var$assertPath(from);
        $655a6bdb16b925e8$var$assertPath(to);
        if (from === to) return "";
        from = $655a6bdb16b925e8$var$posix.resolve(from);
        to = $655a6bdb16b925e8$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $655a6bdb16b925e8$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $655a6bdb16b925e8$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $655a6bdb16b925e8$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $655a6bdb16b925e8$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $655a6bdb16b925e8$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$655a6bdb16b925e8$var$posix.posix = $655a6bdb16b925e8$var$posix;
module.exports = $655a6bdb16b925e8$var$posix;

});



parcelRegister("4Zgmd", function(module, exports) {

});

parcelRegister("c9WcJ", function(module, exports) {

});

parcelRegister("a1m73", function(module, exports) {

$parcel$export(module.exports, "OrderBy", function () { return $74bb2681c2353b32$export$5792beb64642ec7a; });

var $43jhg = parcelRequire("43jhg");
function $74bb2681c2353b32$export$5297a33ad542842a(type) {
    return (0, $43jhg.IsStringType)(type) || (0, $43jhg.IsNumberType)(type) || (0, $43jhg.IsBooleanType)(type);
}
function $74bb2681c2353b32$export$5792beb64642ec7a(input, selector, mode = "ascending") {
    return $74bb2681c2353b32$export$f05254b67a915186(input, [
        [
            selector,
            mode
        ]
    ]);
}
function $74bb2681c2353b32$export$f05254b67a915186(input, orderings) {
    const res = input.slice().sort((a, b)=>{
        for(let i = 0; i < orderings.length; i++){
            const [selector, mode] = orderings[i];
            let xa = selector(a);
            let xb = selector(b);
            // Be a little pragmatic
            if (xa === xb) continue;
            if (xa === undefined && typeof xb === "string") xa = "";
            if (xb === undefined && typeof xa === "string") xb = "";
            if (xa === undefined && typeof xb === "number") xa = 0;
            if (xb === undefined && typeof xa === "number") xb = 0;
            if (xa === undefined && typeof xb === "boolean") xa = false;
            if (xb === undefined && typeof xa === "boolean") xb = false;
            if (xa === null && typeof xb === "string") xa = "";
            if (xb === null && typeof xa === "string") xb = "";
            if (xa === null && typeof xb === "number") xa = 0;
            if (xb === null && typeof xa === "number") xb = 0;
            if (xa === null && typeof xb === "boolean") xa = false;
            if (xb === null && typeof xa === "boolean") xb = false;
            let comparison = 0;
            if (typeof xa === "string" && typeof xb === "string") comparison = xa.localeCompare(xb);
            else if (typeof xa === "number" && typeof xb === "number") comparison = xa - xb;
            else if (xa instanceof Date && xb instanceof Date) comparison = xa.getTime() - xb.getTime();
            else if (typeof xa === "boolean" && typeof xb === "boolean") comparison = (xa ? 1 : 0) - (xb ? 1 : 0);
            else if (typeof xa === "undefined" && typeof xb === "undefined") continue;
            else throw new Error("Unsupported sort: " + JSON.stringify(xa) + " :: " + JSON.stringify(xb));
            if (mode === "descending") comparison *= -1;
            if (comparison !== 0) return comparison;
        }
        return 0;
    });
    return res;
}

});

parcelRegister("3LK53", function(module, exports) {

$parcel$export(module.exports, "GetIconForTypedValue", function () { return $2be98180cf52f065$export$3bf4b675ef577259; });

var $cwhCA = parcelRequire("cwhCA");

var $43jhg = parcelRequire("43jhg");
function $2be98180cf52f065$export$c202da2393745d77(value, property) {
    var _a;
    const icon = (_a = property.tags) === null || _a === void 0 ? void 0 : _a.icon;
    if (icon) return icon;
    return $2be98180cf52f065$export$3bf4b675ef577259(value, property.type);
}
function $2be98180cf52f065$export$3bf4b675ef577259(value, type) {
    var _a, _b, _c, _d;
    const discriminatedType = (0, $cwhCA.SubstituteAndDiscriminate)(value, type);
    if (typeof discriminatedType === "object") {
        const icon = (_a = discriminatedType.tags) === null || _a === void 0 ? void 0 : _a.icon;
        if (icon) return icon;
    }
    if (typeof type === "object") {
        const icon = (_b = type.tags) === null || _b === void 0 ? void 0 : _b.icon;
        if (icon) return icon;
        if (type.reference) {
            const refIcon = (_d = (_c = (0, $cwhCA.GetReflectionInfo)()) === null || _c === void 0 ? void 0 : _c.collections.find((c)=>{
                var _a;
                return (0, $43jhg.GetTypeAlias)(c.type.typeArgs[0]) === ((_a = type.reference) === null || _a === void 0 ? void 0 : _a.typeName);
            })) === null || _d === void 0 ? void 0 : _d.icon;
            if (refIcon) return refIcon;
        }
    }
}

});



parcelRegister("7FrRx", function(module, exports) {

$parcel$export(module.exports, "CurrentLocaleContext", function () { return $5951f9a34f46838c$export$51408e13a5fe5fdf; });
$parcel$export(module.exports, "CurrentLocaleProvider", function () { return $5951f9a34f46838c$export$ebf98238f79ad6b9; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $eK8Q4 = parcelRequire("eK8Q4");

var $dUDPg = parcelRequire("dUDPg");
const $5951f9a34f46838c$export$51408e13a5fe5fdf = /*#__PURE__*/ (0, $eeH7J.createContext)({
    locale: "en"
});
function $5951f9a34f46838c$export$ebf98238f79ad6b9(props) {
    const locales = (0, $dUDPg.useLocales)();
    const [locale, setLocale] = (0, $eK8Q4.usePreference)("editing-locale", "en");
    if (locales.data && !locales.data.some((x)=>x.key === locale)) setLocale(locales.data[0].key);
    return (0, $4vwom.jsx)($5951f9a34f46838c$export$51408e13a5fe5fdf.Provider, {
        value: {
            locale: locale,
            setLocale: setLocale
        },
        children: props.children
    });
}

});
parcelRegister("eK8Q4", function(module, exports) {

$parcel$export(module.exports, "usePreference", function () { return $abbc37c23b102598$export$e74c857c8e0242d6; });
$parcel$export(module.exports, "useSessionState", function () { return $abbc37c23b102598$export$8898ce2744bba29f; });

var $eeH7J = parcelRequire("eeH7J");

var $lDBHC = parcelRequire("lDBHC");
function $abbc37c23b102598$export$e74c857c8e0242d6(settingName, defaultValue, /**
 * The storage to use. Defaults to `localStorage`.
 */ storageClass) {
    if ((0, $lDBHC.IsNode)()) return (0, $eeH7J.useState)(defaultValue);
    const storage = storageClass !== null && storageClass !== void 0 ? storageClass : localStorage;
    const key = `user-preference[${settingName}]`;
    const item = storage.getItem(key);
    let value = defaultValue;
    if (typeof item === "string") try {
        value = JSON.parse(item);
    } catch (e) {
    // Invalid JSON, ignore and use default value
    }
    const [version, setVersion] = (0, $eeH7J.useState)({}); // Used to invalidate
    if (JSON.stringify(value) === JSON.stringify(defaultValue)) storage.removeItem(key);
    function setValue(v) {
        if (JSON.stringify(v) !== storage.getItem(key)) {
            if (JSON.stringify(v) === JSON.stringify(defaultValue)) storage.removeItem(key);
            else storage.setItem(key, JSON.stringify(v));
            setVersion({});
        }
    }
    (0, $eeH7J.useEffect)(()=>{
        function onStorage(e) {
            if (e.key === key) {
                if (e.newValue !== JSON.stringify(value)) setVersion({});
            }
        }
        window.addEventListener("storage", onStorage);
        return ()=>window.removeEventListener("storage", onStorage);
    }, [
        key,
        value
    ]);
    return [
        value,
        setValue
    ];
}
function $abbc37c23b102598$export$8898ce2744bba29f(key, defaultValue) {
    return $abbc37c23b102598$export$e74c857c8e0242d6(key, defaultValue, (0, $lDBHC.IsNode)() ? undefined : sessionStorage);
}

});



parcelRegister("eSiQ2", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $ad44b8bb0b5618ee$export$16fa2f45be04daa8; });
/**
 * Registers a component.
 *
 * Use the type `Component` to represent any of the registered component types. This avoids having
 * to declare a union type of all component types.
 *
 * @param type The type of component to render.
 * @param render A function component that renders the component.
 */ function $ad44b8bb0b5618ee$export$16fa2f45be04daa8(render, options) {
    let name = typeof options.name === "string" ? options.name : render.name;
    if (!render) throw new Error("Component render must be a function");
    if (name.includes("$")) {
        // This name has been changed by Parcel's scope hoisting. We need to extract the original
        // name.
        const parts = name.split("$");
        if (parts.includes("export")) throw new Error("Exported component function must specify name (the name is lost due to Parcel's scope hoisting)");
        name = parts[parts.length - 1];
    }
    const componentAlreadyRegistered = $ad44b8bb0b5618ee$export$16fa2f45be04daa8.all.has(name);
    $ad44b8bb0b5618ee$export$16fa2f45be04daa8.all.set(name, {
        render: render,
        options: options
    });
    const invalidateFuncs = $ad44b8bb0b5618ee$export$16fa2f45be04daa8.invalidators.get(name);
    if (componentAlreadyRegistered && invalidateFuncs) setTimeout(()=>{
        for (const invalidate of invalidateFuncs)invalidate();
    }, 1);
}
$ad44b8bb0b5618ee$export$16fa2f45be04daa8.all = new Map();
/**
 * Hot reload callbacks.
 *
 * Since component types are not components directly, their wrappers need to be
 * invalidated. This is done by calling the invalidate function when a component
 * type is re-registered.
 */ $ad44b8bb0b5618ee$export$16fa2f45be04daa8.invalidators = new Map();

});

parcelRegister("5qU69", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3f4ae55ee36fed82$export$83d89fbfd8236492; }, function (v) { return $3f4ae55ee36fed82$export$83d89fbfd8236492 = v; });
$parcel$export(module.exports, "renderToString", function () { return $3f4ae55ee36fed82$export$80e7718417253a51; }, function (v) { return $3f4ae55ee36fed82$export$80e7718417253a51 = v; });
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $3f4ae55ee36fed82$export$eb3a06aef9e6ee51; }, function (v) { return $3f4ae55ee36fed82$export$eb3a06aef9e6ee51 = v; });
$parcel$export(module.exports, "renderToNodeStream", function () { return $3f4ae55ee36fed82$export$307591e98609eddd; }, function (v) { return $3f4ae55ee36fed82$export$307591e98609eddd = v; });
$parcel$export(module.exports, "renderToStaticNodeStream", function () { return $3f4ae55ee36fed82$export$b23711c915539651; }, function (v) { return $3f4ae55ee36fed82$export$b23711c915539651 = v; });
$parcel$export(module.exports, "renderToReadableStream", function () { return $3f4ae55ee36fed82$export$7020a3240b287705; }, function (v) { return $3f4ae55ee36fed82$export$7020a3240b287705 = v; });
var $3f4ae55ee36fed82$export$83d89fbfd8236492;
var $3f4ae55ee36fed82$export$80e7718417253a51;
var $3f4ae55ee36fed82$export$eb3a06aef9e6ee51;
var $3f4ae55ee36fed82$export$307591e98609eddd;
var $3f4ae55ee36fed82$export$b23711c915539651;
var $3f4ae55ee36fed82$export$7020a3240b287705;
"use strict";
var $3f4ae55ee36fed82$var$l, $3f4ae55ee36fed82$var$s;

$3f4ae55ee36fed82$var$l = (parcelRequire("5tUvF"));

$3f4ae55ee36fed82$var$s = (parcelRequire("4UUdh"));
$3f4ae55ee36fed82$export$83d89fbfd8236492 = $3f4ae55ee36fed82$var$l.version;
$3f4ae55ee36fed82$export$80e7718417253a51 = $3f4ae55ee36fed82$var$l.renderToString;
$3f4ae55ee36fed82$export$eb3a06aef9e6ee51 = $3f4ae55ee36fed82$var$l.renderToStaticMarkup;
$3f4ae55ee36fed82$export$307591e98609eddd = $3f4ae55ee36fed82$var$l.renderToNodeStream;
$3f4ae55ee36fed82$export$b23711c915539651 = $3f4ae55ee36fed82$var$l.renderToStaticNodeStream;
$3f4ae55ee36fed82$export$7020a3240b287705 = $3f4ae55ee36fed82$var$s.renderToReadableStream;

});
parcelRegister("5tUvF", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", function () { return $3fdb7eddda9a9ee5$export$307591e98609eddd; }, function (v) { return $3fdb7eddda9a9ee5$export$307591e98609eddd = v; });
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $3fdb7eddda9a9ee5$export$eb3a06aef9e6ee51; }, function (v) { return $3fdb7eddda9a9ee5$export$eb3a06aef9e6ee51 = v; });
$parcel$export(module.exports, "renderToStaticNodeStream", function () { return $3fdb7eddda9a9ee5$export$b23711c915539651; }, function (v) { return $3fdb7eddda9a9ee5$export$b23711c915539651 = v; });
$parcel$export(module.exports, "renderToString", function () { return $3fdb7eddda9a9ee5$export$80e7718417253a51; }, function (v) { return $3fdb7eddda9a9ee5$export$80e7718417253a51 = v; });
$parcel$export(module.exports, "version", function () { return $3fdb7eddda9a9ee5$export$83d89fbfd8236492; }, function (v) { return $3fdb7eddda9a9ee5$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3fdb7eddda9a9ee5$export$307591e98609eddd;
var $3fdb7eddda9a9ee5$export$eb3a06aef9e6ee51;
var $3fdb7eddda9a9ee5$export$b23711c915539651;
var $3fdb7eddda9a9ee5$export$80e7718417253a51;
var $3fdb7eddda9a9ee5$export$83d89fbfd8236492;
"use strict";

var $eeH7J = parcelRequire("eeH7J");
function $3fdb7eddda9a9ee5$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3fdb7eddda9a9ee5$var$p = Object.prototype.hasOwnProperty, $3fdb7eddda9a9ee5$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3fdb7eddda9a9ee5$var$ha = {}, $3fdb7eddda9a9ee5$var$ia = {};
function $3fdb7eddda9a9ee5$var$ja(a) {
    if ($3fdb7eddda9a9ee5$var$p.call($3fdb7eddda9a9ee5$var$ia, a)) return !0;
    if ($3fdb7eddda9a9ee5$var$p.call($3fdb7eddda9a9ee5$var$ha, a)) return !1;
    if ($3fdb7eddda9a9ee5$var$fa.test(a)) return $3fdb7eddda9a9ee5$var$ia[a] = !0;
    $3fdb7eddda9a9ee5$var$ha[a] = !0;
    return !1;
}
function $3fdb7eddda9a9ee5$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $3fdb7eddda9a9ee5$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3fdb7eddda9a9ee5$var$t[b] = new $3fdb7eddda9a9ee5$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3fdb7eddda9a9ee5$var$ka = /[\-:]([a-z])/g;
function $3fdb7eddda9a9ee5$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3fdb7eddda9a9ee5$var$ka, $3fdb7eddda9a9ee5$var$la);
    $3fdb7eddda9a9ee5$var$t[b] = new $3fdb7eddda9a9ee5$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3fdb7eddda9a9ee5$var$ka, $3fdb7eddda9a9ee5$var$la);
    $3fdb7eddda9a9ee5$var$t[b] = new $3fdb7eddda9a9ee5$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3fdb7eddda9a9ee5$var$ka, $3fdb7eddda9a9ee5$var$la);
    $3fdb7eddda9a9ee5$var$t[b] = new $3fdb7eddda9a9ee5$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3fdb7eddda9a9ee5$var$t.xlinkHref = new $3fdb7eddda9a9ee5$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $3fdb7eddda9a9ee5$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3fdb7eddda9a9ee5$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3fdb7eddda9a9ee5$var$u).forEach(function(a) {
    $3fdb7eddda9a9ee5$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3fdb7eddda9a9ee5$var$u[b] = $3fdb7eddda9a9ee5$var$u[a];
    });
});
var $3fdb7eddda9a9ee5$var$na = /["'&<>]/;
function $3fdb7eddda9a9ee5$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $3fdb7eddda9a9ee5$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $3fdb7eddda9a9ee5$var$oa = /([A-Z])/g, $3fdb7eddda9a9ee5$var$pa = /^ms-/, $3fdb7eddda9a9ee5$var$qa = Array.isArray;
function $3fdb7eddda9a9ee5$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $3fdb7eddda9a9ee5$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $3fdb7eddda9a9ee5$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $3fdb7eddda9a9ee5$var$w(2, null);
        case "math":
            return $3fdb7eddda9a9ee5$var$w(3, null);
        case "foreignObject":
            return $3fdb7eddda9a9ee5$var$w(1, null);
        case "table":
            return $3fdb7eddda9a9ee5$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $3fdb7eddda9a9ee5$var$w(5, null);
        case "colgroup":
            return $3fdb7eddda9a9ee5$var$w(7, null);
        case "tr":
            return $3fdb7eddda9a9ee5$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $3fdb7eddda9a9ee5$var$w(1, null) : a;
}
var $3fdb7eddda9a9ee5$var$sa = new Map;
function $3fdb7eddda9a9ee5$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($3fdb7eddda9a9ee5$var$l(62));
    b = !0;
    for(var d in c)if ($3fdb7eddda9a9ee5$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $3fdb7eddda9a9ee5$var$v(d);
                f = $3fdb7eddda9a9ee5$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $3fdb7eddda9a9ee5$var$sa.get(e);
                void 0 !== g ? e = g : (g = $3fdb7eddda9a9ee5$var$v(e.replace($3fdb7eddda9a9ee5$var$oa, "-$1").toLowerCase().replace($3fdb7eddda9a9ee5$var$pa, "-ms-")), $3fdb7eddda9a9ee5$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $3fdb7eddda9a9ee5$var$p.call($3fdb7eddda9a9ee5$var$u, d) ? "" + f : f + "px" : $3fdb7eddda9a9ee5$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $3fdb7eddda9a9ee5$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $3fdb7eddda9a9ee5$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $3fdb7eddda9a9ee5$var$t.hasOwnProperty(c) ? $3fdb7eddda9a9ee5$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $3fdb7eddda9a9ee5$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $3fdb7eddda9a9ee5$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $3fdb7eddda9a9ee5$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $3fdb7eddda9a9ee5$var$v(d), '"');
            }
        } else if ($3fdb7eddda9a9ee5$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $3fdb7eddda9a9ee5$var$v(d), '"');
        }
    }
}
function $3fdb7eddda9a9ee5$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($3fdb7eddda9a9ee5$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($3fdb7eddda9a9ee5$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $3fdb7eddda9a9ee5$var$ua(a) {
    var b = "";
    $eeH7J.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $3fdb7eddda9a9ee5$var$va(a, b, c, d) {
    a.push($3fdb7eddda9a9ee5$var$A(c));
    var f = c = null, e;
    for(e in b)if ($3fdb7eddda9a9ee5$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $3fdb7eddda9a9ee5$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $3fdb7eddda9a9ee5$var$y(a, f, c);
    return "string" === typeof c ? (a.push($3fdb7eddda9a9ee5$var$v(c)), null) : c;
}
var $3fdb7eddda9a9ee5$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $3fdb7eddda9a9ee5$var$xa = new Map;
function $3fdb7eddda9a9ee5$var$A(a) {
    var b = $3fdb7eddda9a9ee5$var$xa.get(a);
    if (void 0 === b) {
        if (!$3fdb7eddda9a9ee5$var$wa.test(a)) throw Error($3fdb7eddda9a9ee5$var$l(65, a));
        b = "<" + a;
        $3fdb7eddda9a9ee5$var$xa.set(a, b);
    }
    return b;
}
function $3fdb7eddda9a9ee5$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($3fdb7eddda9a9ee5$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($3fdb7eddda9a9ee5$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $3fdb7eddda9a9ee5$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $3fdb7eddda9a9ee5$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($3fdb7eddda9a9ee5$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($3fdb7eddda9a9ee5$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $3fdb7eddda9a9ee5$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $3fdb7eddda9a9ee5$var$ua(h), $3fdb7eddda9a9ee5$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $3fdb7eddda9a9ee5$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($3fdb7eddda9a9ee5$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($3fdb7eddda9a9ee5$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($3fdb7eddda9a9ee5$var$l(91));
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($3fdb7eddda9a9ee5$var$l(92));
                if ($3fdb7eddda9a9ee5$var$qa(n) && 1 < n.length) throw Error($3fdb7eddda9a9ee5$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($3fdb7eddda9a9ee5$var$v("" + e));
            return null;
        case "input":
            a.push($3fdb7eddda9a9ee5$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($3fdb7eddda9a9ee5$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3fdb7eddda9a9ee5$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, g, m);
            }
            null !== n ? $3fdb7eddda9a9ee5$var$x(a, d, "checked", n) : null !== k && $3fdb7eddda9a9ee5$var$x(a, d, "checked", k);
            null !== e ? $3fdb7eddda9a9ee5$var$x(a, d, "value", e) : null !== h && $3fdb7eddda9a9ee5$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($3fdb7eddda9a9ee5$var$A("menuitem"));
            for(var C in c)if ($3fdb7eddda9a9ee5$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3fdb7eddda9a9ee5$var$l(400));
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($3fdb7eddda9a9ee5$var$A("title"));
            e = null;
            for(q in c)if ($3fdb7eddda9a9ee5$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($3fdb7eddda9a9ee5$var$l(434));
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($3fdb7eddda9a9ee5$var$A(b));
            g = e = null;
            for(k in c)if ($3fdb7eddda9a9ee5$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($3fdb7eddda9a9ee5$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($3fdb7eddda9a9ee5$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($3fdb7eddda9a9ee5$var$A(b));
            for(var D in c)if ($3fdb7eddda9a9ee5$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3fdb7eddda9a9ee5$var$l(399, b));
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $3fdb7eddda9a9ee5$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $3fdb7eddda9a9ee5$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $3fdb7eddda9a9ee5$var$va(a, c, b, d);
            a.push($3fdb7eddda9a9ee5$var$A(b));
            g = e = null;
            for(m in c)if ($3fdb7eddda9a9ee5$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $3fdb7eddda9a9ee5$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $3fdb7eddda9a9ee5$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $3fdb7eddda9a9ee5$var$v(h), '"');
            }
            a.push(">");
            $3fdb7eddda9a9ee5$var$y(a, g, e);
            return e;
    }
}
function $3fdb7eddda9a9ee5$var$za(a, b, c) {
    a.push('<!--$?--><template id="');
    if (null === c) throw Error($3fdb7eddda9a9ee5$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $3fdb7eddda9a9ee5$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($3fdb7eddda9a9ee5$var$l(397));
    }
}
function $3fdb7eddda9a9ee5$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($3fdb7eddda9a9ee5$var$l(397));
    }
}
var $3fdb7eddda9a9ee5$var$Ca = /[<\u2028\u2029]/g;
function $3fdb7eddda9a9ee5$var$Da(a) {
    return JSON.stringify(a).replace($3fdb7eddda9a9ee5$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $3fdb7eddda9a9ee5$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $3fdb7eddda9a9ee5$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($3fdb7eddda9a9ee5$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("<!-- -->"), a.push($3fdb7eddda9a9ee5$var$v(b)), a = !0);
    return a;
}
var $3fdb7eddda9a9ee5$var$B = Object.assign, $3fdb7eddda9a9ee5$var$Ga = Symbol.for("react.element"), $3fdb7eddda9a9ee5$var$Ha = Symbol.for("react.portal"), $3fdb7eddda9a9ee5$var$Ia = Symbol.for("react.fragment"), $3fdb7eddda9a9ee5$var$Ja = Symbol.for("react.strict_mode"), $3fdb7eddda9a9ee5$var$Ka = Symbol.for("react.profiler"), $3fdb7eddda9a9ee5$var$La = Symbol.for("react.provider"), $3fdb7eddda9a9ee5$var$Ma = Symbol.for("react.context"), $3fdb7eddda9a9ee5$var$Na = Symbol.for("react.forward_ref"), $3fdb7eddda9a9ee5$var$Oa = Symbol.for("react.suspense"), $3fdb7eddda9a9ee5$var$Pa = Symbol.for("react.suspense_list"), $3fdb7eddda9a9ee5$var$Qa = Symbol.for("react.memo"), $3fdb7eddda9a9ee5$var$Ra = Symbol.for("react.lazy"), $3fdb7eddda9a9ee5$var$Sa = Symbol.for("react.scope"), $3fdb7eddda9a9ee5$var$Ta = Symbol.for("react.debug_trace_mode"), $3fdb7eddda9a9ee5$var$Ua = Symbol.for("react.legacy_hidden"), $3fdb7eddda9a9ee5$var$Va = Symbol.for("react.default_value"), $3fdb7eddda9a9ee5$var$Wa = Symbol.iterator;
function $3fdb7eddda9a9ee5$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3fdb7eddda9a9ee5$var$Ia:
            return "Fragment";
        case $3fdb7eddda9a9ee5$var$Ha:
            return "Portal";
        case $3fdb7eddda9a9ee5$var$Ka:
            return "Profiler";
        case $3fdb7eddda9a9ee5$var$Ja:
            return "StrictMode";
        case $3fdb7eddda9a9ee5$var$Oa:
            return "Suspense";
        case $3fdb7eddda9a9ee5$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3fdb7eddda9a9ee5$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $3fdb7eddda9a9ee5$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $3fdb7eddda9a9ee5$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3fdb7eddda9a9ee5$var$Qa:
            return b = a.displayName || null, null !== b ? b : $3fdb7eddda9a9ee5$var$Xa(a.type) || "Memo";
        case $3fdb7eddda9a9ee5$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $3fdb7eddda9a9ee5$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $3fdb7eddda9a9ee5$var$Ya = {};
function $3fdb7eddda9a9ee5$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $3fdb7eddda9a9ee5$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $3fdb7eddda9a9ee5$var$E = null;
function $3fdb7eddda9a9ee5$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($3fdb7eddda9a9ee5$var$l(401));
        } else {
            if (null === c) throw Error($3fdb7eddda9a9ee5$var$l(401));
            $3fdb7eddda9a9ee5$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $3fdb7eddda9a9ee5$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $3fdb7eddda9a9ee5$var$$a(a);
}
function $3fdb7eddda9a9ee5$var$ab(a) {
    var b = a.parent;
    null !== b && $3fdb7eddda9a9ee5$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $3fdb7eddda9a9ee5$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($3fdb7eddda9a9ee5$var$l(402));
    a.depth === b.depth ? $3fdb7eddda9a9ee5$var$F(a, b) : $3fdb7eddda9a9ee5$var$bb(a, b);
}
function $3fdb7eddda9a9ee5$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($3fdb7eddda9a9ee5$var$l(402));
    a.depth === c.depth ? $3fdb7eddda9a9ee5$var$F(a, c) : $3fdb7eddda9a9ee5$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $3fdb7eddda9a9ee5$var$G(a) {
    var b = $3fdb7eddda9a9ee5$var$E;
    b !== a && (null === b ? $3fdb7eddda9a9ee5$var$ab(a) : null === a ? $3fdb7eddda9a9ee5$var$$a(b) : b.depth === a.depth ? $3fdb7eddda9a9ee5$var$F(b, a) : b.depth > a.depth ? $3fdb7eddda9a9ee5$var$bb(b, a) : $3fdb7eddda9a9ee5$var$cb(b, a), $3fdb7eddda9a9ee5$var$E = a);
}
var $3fdb7eddda9a9ee5$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $3fdb7eddda9a9ee5$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $3fdb7eddda9a9ee5$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $3fdb7eddda9a9ee5$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $3fdb7eddda9a9ee5$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $3fdb7eddda9a9ee5$var$B({}, e, h)) : $3fdb7eddda9a9ee5$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $3fdb7eddda9a9ee5$var$fb = {
    id: 1,
    overflow: ""
};
function $3fdb7eddda9a9ee5$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $3fdb7eddda9a9ee5$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $3fdb7eddda9a9ee5$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $3fdb7eddda9a9ee5$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $3fdb7eddda9a9ee5$var$H = Math.clz32 ? Math.clz32 : $3fdb7eddda9a9ee5$var$hb, $3fdb7eddda9a9ee5$var$ib = Math.log, $3fdb7eddda9a9ee5$var$jb = Math.LN2;
function $3fdb7eddda9a9ee5$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3fdb7eddda9a9ee5$var$ib(a) / $3fdb7eddda9a9ee5$var$jb | 0) | 0;
}
function $3fdb7eddda9a9ee5$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3fdb7eddda9a9ee5$var$lb = "function" === typeof Object.is ? Object.is : $3fdb7eddda9a9ee5$var$kb, $3fdb7eddda9a9ee5$var$I = null, $3fdb7eddda9a9ee5$var$ob = null, $3fdb7eddda9a9ee5$var$J = null, $3fdb7eddda9a9ee5$var$K = null, $3fdb7eddda9a9ee5$var$L = !1, $3fdb7eddda9a9ee5$var$M = !1, $3fdb7eddda9a9ee5$var$N = 0, $3fdb7eddda9a9ee5$var$O = null, $3fdb7eddda9a9ee5$var$P = 0;
function $3fdb7eddda9a9ee5$var$Q() {
    if (null === $3fdb7eddda9a9ee5$var$I) throw Error($3fdb7eddda9a9ee5$var$l(321));
    return $3fdb7eddda9a9ee5$var$I;
}
function $3fdb7eddda9a9ee5$var$pb() {
    if (0 < $3fdb7eddda9a9ee5$var$P) throw Error($3fdb7eddda9a9ee5$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $3fdb7eddda9a9ee5$var$qb() {
    null === $3fdb7eddda9a9ee5$var$K ? null === $3fdb7eddda9a9ee5$var$J ? ($3fdb7eddda9a9ee5$var$L = !1, $3fdb7eddda9a9ee5$var$J = $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$pb()) : ($3fdb7eddda9a9ee5$var$L = !0, $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$J) : null === $3fdb7eddda9a9ee5$var$K.next ? ($3fdb7eddda9a9ee5$var$L = !1, $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$K.next = $3fdb7eddda9a9ee5$var$pb()) : ($3fdb7eddda9a9ee5$var$L = !0, $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$K.next);
    return $3fdb7eddda9a9ee5$var$K;
}
function $3fdb7eddda9a9ee5$var$rb() {
    $3fdb7eddda9a9ee5$var$ob = $3fdb7eddda9a9ee5$var$I = null;
    $3fdb7eddda9a9ee5$var$M = !1;
    $3fdb7eddda9a9ee5$var$J = null;
    $3fdb7eddda9a9ee5$var$P = 0;
    $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$O = null;
}
function $3fdb7eddda9a9ee5$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3fdb7eddda9a9ee5$var$tb(a, b, c) {
    $3fdb7eddda9a9ee5$var$I = $3fdb7eddda9a9ee5$var$Q();
    $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$qb();
    if ($3fdb7eddda9a9ee5$var$L) {
        var d = $3fdb7eddda9a9ee5$var$K.queue;
        b = d.dispatch;
        if (null !== $3fdb7eddda9a9ee5$var$O && (c = $3fdb7eddda9a9ee5$var$O.get(d), void 0 !== c)) {
            $3fdb7eddda9a9ee5$var$O.delete(d);
            d = $3fdb7eddda9a9ee5$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $3fdb7eddda9a9ee5$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $3fdb7eddda9a9ee5$var$K.memoizedState,
            b
        ];
    }
    a = a === $3fdb7eddda9a9ee5$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $3fdb7eddda9a9ee5$var$K.memoizedState = a;
    a = $3fdb7eddda9a9ee5$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $3fdb7eddda9a9ee5$var$ub.bind(null, $3fdb7eddda9a9ee5$var$I, a);
    return [
        $3fdb7eddda9a9ee5$var$K.memoizedState,
        a
    ];
}
function $3fdb7eddda9a9ee5$var$vb(a, b) {
    $3fdb7eddda9a9ee5$var$I = $3fdb7eddda9a9ee5$var$Q();
    $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $3fdb7eddda9a9ee5$var$K) {
        var c = $3fdb7eddda9a9ee5$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$3fdb7eddda9a9ee5$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $3fdb7eddda9a9ee5$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3fdb7eddda9a9ee5$var$ub(a, b, c) {
    if (25 <= $3fdb7eddda9a9ee5$var$P) throw Error($3fdb7eddda9a9ee5$var$l(301));
    if (a === $3fdb7eddda9a9ee5$var$I) {
        if ($3fdb7eddda9a9ee5$var$M = !0, a = {
            action: c,
            next: null
        }, null === $3fdb7eddda9a9ee5$var$O && ($3fdb7eddda9a9ee5$var$O = new Map), c = $3fdb7eddda9a9ee5$var$O.get(b), void 0 === c) $3fdb7eddda9a9ee5$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $3fdb7eddda9a9ee5$var$wb() {
    throw Error($3fdb7eddda9a9ee5$var$l(394));
}
function $3fdb7eddda9a9ee5$var$R() {}
var $3fdb7eddda9a9ee5$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $3fdb7eddda9a9ee5$var$Q();
        return a._currentValue2;
    },
    useMemo: $3fdb7eddda9a9ee5$var$vb,
    useReducer: $3fdb7eddda9a9ee5$var$tb,
    useRef: function(a) {
        $3fdb7eddda9a9ee5$var$I = $3fdb7eddda9a9ee5$var$Q();
        $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$qb();
        var b = $3fdb7eddda9a9ee5$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $3fdb7eddda9a9ee5$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $3fdb7eddda9a9ee5$var$tb($3fdb7eddda9a9ee5$var$sb, a);
    },
    useInsertionEffect: $3fdb7eddda9a9ee5$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $3fdb7eddda9a9ee5$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $3fdb7eddda9a9ee5$var$R,
    useEffect: $3fdb7eddda9a9ee5$var$R,
    useDebugValue: $3fdb7eddda9a9ee5$var$R,
    useDeferredValue: function(a) {
        $3fdb7eddda9a9ee5$var$Q();
        return a;
    },
    useTransition: function() {
        $3fdb7eddda9a9ee5$var$Q();
        return [
            !1,
            $3fdb7eddda9a9ee5$var$wb
        ];
    },
    useId: function() {
        var a = $3fdb7eddda9a9ee5$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $3fdb7eddda9a9ee5$var$H(a) - 1)).toString(32) + b;
        var c = $3fdb7eddda9a9ee5$var$S;
        if (null === c) throw Error($3fdb7eddda9a9ee5$var$l(404));
        b = $3fdb7eddda9a9ee5$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $3fdb7eddda9a9ee5$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($3fdb7eddda9a9ee5$var$l(407));
        return c();
    }
}, $3fdb7eddda9a9ee5$var$S = null, $3fdb7eddda9a9ee5$var$yb = $eeH7J.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $3fdb7eddda9a9ee5$var$zb(a) {
    console.error(a);
    return null;
}
function $3fdb7eddda9a9ee5$var$T() {}
function $3fdb7eddda9a9ee5$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $3fdb7eddda9a9ee5$var$zb : f,
        onAllReady: void 0 === e ? $3fdb7eddda9a9ee5$var$T : e,
        onShellReady: void 0 === g ? $3fdb7eddda9a9ee5$var$T : g,
        onShellError: void 0 === h ? $3fdb7eddda9a9ee5$var$T : h,
        onFatalError: void 0 === k ? $3fdb7eddda9a9ee5$var$T : k
    };
    c = $3fdb7eddda9a9ee5$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $3fdb7eddda9a9ee5$var$Bb(b, a, null, c, n, $3fdb7eddda9a9ee5$var$Ya, null, $3fdb7eddda9a9ee5$var$fb);
    m.push(a);
    return b;
}
function $3fdb7eddda9a9ee5$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $3fdb7eddda9a9ee5$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $3fdb7eddda9a9ee5$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $3fdb7eddda9a9ee5$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $3fdb7eddda9a9ee5$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $3fdb7eddda9a9ee5$var$Db(a, b, c, d, f) {
    $3fdb7eddda9a9ee5$var$I = {};
    $3fdb7eddda9a9ee5$var$ob = b;
    $3fdb7eddda9a9ee5$var$N = 0;
    for(a = c(d, f); $3fdb7eddda9a9ee5$var$M;)$3fdb7eddda9a9ee5$var$M = !1, $3fdb7eddda9a9ee5$var$N = 0, $3fdb7eddda9a9ee5$var$P += 1, $3fdb7eddda9a9ee5$var$K = null, a = c(d, f);
    $3fdb7eddda9a9ee5$var$rb();
    return a;
}
function $3fdb7eddda9a9ee5$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($3fdb7eddda9a9ee5$var$l(108, $3fdb7eddda9a9ee5$var$Xa(d) || "Unknown", h));
            d = $3fdb7eddda9a9ee5$var$B({}, g, c);
        }
        b.legacyContext = d;
        $3fdb7eddda9a9ee5$var$X(a, b, f);
        b.legacyContext = g;
    } else $3fdb7eddda9a9ee5$var$X(a, b, f);
}
function $3fdb7eddda9a9ee5$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $3fdb7eddda9a9ee5$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $3fdb7eddda9a9ee5$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $3fdb7eddda9a9ee5$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $3fdb7eddda9a9ee5$var$eb(e, c, d, f);
            $3fdb7eddda9a9ee5$var$Eb(a, b, e, c);
        } else {
            e = $3fdb7eddda9a9ee5$var$Za(c, b.legacyContext);
            f = $3fdb7eddda9a9ee5$var$Db(a, b, c, d, e);
            var g = 0 !== $3fdb7eddda9a9ee5$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $3fdb7eddda9a9ee5$var$eb(f, c, d, e), $3fdb7eddda9a9ee5$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $3fdb7eddda9a9ee5$var$gb(d, 1, 0);
                try {
                    $3fdb7eddda9a9ee5$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $3fdb7eddda9a9ee5$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $3fdb7eddda9a9ee5$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $3fdb7eddda9a9ee5$var$ra(g, c, d);
        $3fdb7eddda9a9ee5$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $3fdb7eddda9a9ee5$var$Ua:
            case $3fdb7eddda9a9ee5$var$Ta:
            case $3fdb7eddda9a9ee5$var$Ja:
            case $3fdb7eddda9a9ee5$var$Ka:
            case $3fdb7eddda9a9ee5$var$Ia:
                $3fdb7eddda9a9ee5$var$X(a, b, d.children);
                return;
            case $3fdb7eddda9a9ee5$var$Pa:
                $3fdb7eddda9a9ee5$var$X(a, b, d.children);
                return;
            case $3fdb7eddda9a9ee5$var$Sa:
                throw Error($3fdb7eddda9a9ee5$var$l(343));
            case $3fdb7eddda9a9ee5$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $3fdb7eddda9a9ee5$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $3fdb7eddda9a9ee5$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($3fdb7eddda9a9ee5$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("<!-- -->"), m.status = 1, $3fdb7eddda9a9ee5$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $3fdb7eddda9a9ee5$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $3fdb7eddda9a9ee5$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $3fdb7eddda9a9ee5$var$Na:
                d = $3fdb7eddda9a9ee5$var$Db(a, b, c.render, d, f);
                if (0 !== $3fdb7eddda9a9ee5$var$N) {
                    c = b.treeContext;
                    b.treeContext = $3fdb7eddda9a9ee5$var$gb(c, 1, 0);
                    try {
                        $3fdb7eddda9a9ee5$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $3fdb7eddda9a9ee5$var$X(a, b, d);
                return;
            case $3fdb7eddda9a9ee5$var$Qa:
                c = c.type;
                d = $3fdb7eddda9a9ee5$var$Fb(c, d);
                $3fdb7eddda9a9ee5$var$Gb(a, b, c, d, f);
                return;
            case $3fdb7eddda9a9ee5$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $3fdb7eddda9a9ee5$var$E;
                $3fdb7eddda9a9ee5$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $3fdb7eddda9a9ee5$var$X(a, b, f);
                a = $3fdb7eddda9a9ee5$var$E;
                if (null === a) throw Error($3fdb7eddda9a9ee5$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $3fdb7eddda9a9ee5$var$Va ? a.context._defaultValue : d;
                a = $3fdb7eddda9a9ee5$var$E = a.parent;
                b.context = a;
                return;
            case $3fdb7eddda9a9ee5$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $3fdb7eddda9a9ee5$var$X(a, b, d);
                return;
            case $3fdb7eddda9a9ee5$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $3fdb7eddda9a9ee5$var$Fb(c, d);
                $3fdb7eddda9a9ee5$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($3fdb7eddda9a9ee5$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $3fdb7eddda9a9ee5$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $3fdb7eddda9a9ee5$var$Ga:
                $3fdb7eddda9a9ee5$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $3fdb7eddda9a9ee5$var$Ha:
                throw Error($3fdb7eddda9a9ee5$var$l(257));
            case $3fdb7eddda9a9ee5$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $3fdb7eddda9a9ee5$var$X(a, b, c);
                return;
        }
        if ($3fdb7eddda9a9ee5$var$qa(c)) {
            $3fdb7eddda9a9ee5$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $3fdb7eddda9a9ee5$var$Wa && c[$3fdb7eddda9a9ee5$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $3fdb7eddda9a9ee5$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($3fdb7eddda9a9ee5$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $3fdb7eddda9a9ee5$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $3fdb7eddda9a9ee5$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $3fdb7eddda9a9ee5$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $3fdb7eddda9a9ee5$var$gb(e, d, f);
        try {
            $3fdb7eddda9a9ee5$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $3fdb7eddda9a9ee5$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $3fdb7eddda9a9ee5$var$X(a, b, c);
    } catch (k) {
        if ($3fdb7eddda9a9ee5$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $3fdb7eddda9a9ee5$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $3fdb7eddda9a9ee5$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $3fdb7eddda9a9ee5$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $3fdb7eddda9a9ee5$var$G(e), k;
    }
}
function $3fdb7eddda9a9ee5$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $3fdb7eddda9a9ee5$var$Kb(this, b, a);
}
function $3fdb7eddda9a9ee5$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($3fdb7eddda9a9ee5$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $3fdb7eddda9a9ee5$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $3fdb7eddda9a9ee5$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $3fdb7eddda9a9ee5$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $3fdb7eddda9a9ee5$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($3fdb7eddda9a9ee5$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $3fdb7eddda9a9ee5$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $3fdb7eddda9a9ee5$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($3fdb7eddda9a9ee5$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($3fdb7eddda9a9ee5$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $3fdb7eddda9a9ee5$var$Cb(a) {
    if (2 !== a.status) {
        var b = $3fdb7eddda9a9ee5$var$E, c = $3fdb7eddda9a9ee5$var$yb.current;
        $3fdb7eddda9a9ee5$var$yb.current = $3fdb7eddda9a9ee5$var$xb;
        var d = $3fdb7eddda9a9ee5$var$S;
        $3fdb7eddda9a9ee5$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $3fdb7eddda9a9ee5$var$G(g.context);
                    try {
                        $3fdb7eddda9a9ee5$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("<!-- -->"), g.abortSet.delete(g), k.status = 1, $3fdb7eddda9a9ee5$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($3fdb7eddda9a9ee5$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $3fdb7eddda9a9ee5$var$V(h, q);
                            null === n ? $3fdb7eddda9a9ee5$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $3fdb7eddda9a9ee5$var$Mb(a, a.destination);
        } catch (z) {
            $3fdb7eddda9a9ee5$var$V(a, z), $3fdb7eddda9a9ee5$var$W(a, z);
        } finally{
            $3fdb7eddda9a9ee5$var$S = d, $3fdb7eddda9a9ee5$var$yb.current = c, c === $3fdb7eddda9a9ee5$var$xb && $3fdb7eddda9a9ee5$var$G(b);
        }
    }
}
function $3fdb7eddda9a9ee5$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $3fdb7eddda9a9ee5$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($3fdb7eddda9a9ee5$var$l(390));
    }
}
function $3fdb7eddda9a9ee5$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $3fdb7eddda9a9ee5$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("<!--$!-->"), b.push("<template"), d && (b.push(' data-dgst="'), d = $3fdb7eddda9a9ee5$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $3fdb7eddda9a9ee5$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $3fdb7eddda9a9ee5$var$za(b, a.responseState, d);
        $3fdb7eddda9a9ee5$var$Z(a, b, c);
        return b.push("<!--/$-->");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $3fdb7eddda9a9ee5$var$za(b, a.responseState, d.id), $3fdb7eddda9a9ee5$var$Z(a, b, c), b.push("<!--/$-->");
    a.responseState.generateStaticMarkup || b.push("<!--$-->");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($3fdb7eddda9a9ee5$var$l(391));
    $3fdb7eddda9a9ee5$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->");
    return a;
}
function $3fdb7eddda9a9ee5$var$Ob(a, b, c) {
    $3fdb7eddda9a9ee5$var$Aa(b, a.responseState, c.formatContext, c.id);
    $3fdb7eddda9a9ee5$var$Nb(a, b, c);
    return $3fdb7eddda9a9ee5$var$Ba(b, c.formatContext);
}
function $3fdb7eddda9a9ee5$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$3fdb7eddda9a9ee5$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($3fdb7eddda9a9ee5$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")</script>');
}
function $3fdb7eddda9a9ee5$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($3fdb7eddda9a9ee5$var$l(392));
        return $3fdb7eddda9a9ee5$var$Ob(a, b, d);
    }
    $3fdb7eddda9a9ee5$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")</script>');
}
function $3fdb7eddda9a9ee5$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $3fdb7eddda9a9ee5$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($3fdb7eddda9a9ee5$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $3fdb7eddda9a9ee5$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $3fdb7eddda9a9ee5$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $3fdb7eddda9a9ee5$var$Da(q);
                d.push(z);
            }
            if (!d.push(")</script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$3fdb7eddda9a9ee5$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$3fdb7eddda9a9ee5$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$3fdb7eddda9a9ee5$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $3fdb7eddda9a9ee5$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $3fdb7eddda9a9ee5$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $3fdb7eddda9a9ee5$var$Mb(a, a.destination);
    } catch (d) {
        $3fdb7eddda9a9ee5$var$V(a, d), $3fdb7eddda9a9ee5$var$W(a, d);
    }
}
function $3fdb7eddda9a9ee5$var$Sb() {}
function $3fdb7eddda9a9ee5$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $3fdb7eddda9a9ee5$var$Ab(a, $3fdb7eddda9a9ee5$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $3fdb7eddda9a9ee5$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $3fdb7eddda9a9ee5$var$Cb(a);
    $3fdb7eddda9a9ee5$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $3fdb7eddda9a9ee5$var$Mb(a, h);
        } catch (m) {
            $3fdb7eddda9a9ee5$var$V(a, m), $3fdb7eddda9a9ee5$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($3fdb7eddda9a9ee5$var$l(426));
    return g;
}
$3fdb7eddda9a9ee5$export$307591e98609eddd = function() {
    throw Error($3fdb7eddda9a9ee5$var$l(207));
};
$3fdb7eddda9a9ee5$export$eb3a06aef9e6ee51 = function(a, b) {
    return $3fdb7eddda9a9ee5$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$3fdb7eddda9a9ee5$export$b23711c915539651 = function() {
    throw Error($3fdb7eddda9a9ee5$var$l(208));
};
$3fdb7eddda9a9ee5$export$80e7718417253a51 = function(a, b) {
    return $3fdb7eddda9a9ee5$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$3fdb7eddda9a9ee5$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("4UUdh", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", function () { return $3947ff2ea3645b8c$export$7020a3240b287705; }, function (v) { return $3947ff2ea3645b8c$export$7020a3240b287705 = v; });
$parcel$export(module.exports, "version", function () { return $3947ff2ea3645b8c$export$83d89fbfd8236492; }, function (v) { return $3947ff2ea3645b8c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3947ff2ea3645b8c$export$7020a3240b287705;
var $3947ff2ea3645b8c$export$83d89fbfd8236492;
"use strict";

var $eeH7J = parcelRequire("eeH7J");
function $3947ff2ea3645b8c$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3947ff2ea3645b8c$var$l = null, $3947ff2ea3645b8c$var$n = 0;
function $3947ff2ea3645b8c$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $3947ff2ea3645b8c$var$n && (a.enqueue(new Uint8Array($3947ff2ea3645b8c$var$l.buffer, 0, $3947ff2ea3645b8c$var$n)), $3947ff2ea3645b8c$var$l = new Uint8Array(512), $3947ff2ea3645b8c$var$n = 0), a.enqueue(b);
        else {
            var c = $3947ff2ea3645b8c$var$l.length - $3947ff2ea3645b8c$var$n;
            c < b.length && (0 === c ? a.enqueue($3947ff2ea3645b8c$var$l) : ($3947ff2ea3645b8c$var$l.set(b.subarray(0, c), $3947ff2ea3645b8c$var$n), a.enqueue($3947ff2ea3645b8c$var$l), b = b.subarray(c)), $3947ff2ea3645b8c$var$l = new Uint8Array(512), $3947ff2ea3645b8c$var$n = 0);
            $3947ff2ea3645b8c$var$l.set(b, $3947ff2ea3645b8c$var$n);
            $3947ff2ea3645b8c$var$n += b.length;
        }
    }
}
function $3947ff2ea3645b8c$var$t(a, b) {
    $3947ff2ea3645b8c$var$p(a, b);
    return !0;
}
function $3947ff2ea3645b8c$var$ba(a) {
    $3947ff2ea3645b8c$var$l && 0 < $3947ff2ea3645b8c$var$n && (a.enqueue(new Uint8Array($3947ff2ea3645b8c$var$l.buffer, 0, $3947ff2ea3645b8c$var$n)), $3947ff2ea3645b8c$var$l = null, $3947ff2ea3645b8c$var$n = 0);
}
var $3947ff2ea3645b8c$var$ca = new TextEncoder;
function $3947ff2ea3645b8c$var$u(a) {
    return $3947ff2ea3645b8c$var$ca.encode(a);
}
function $3947ff2ea3645b8c$var$w(a) {
    return $3947ff2ea3645b8c$var$ca.encode(a);
}
function $3947ff2ea3645b8c$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $3947ff2ea3645b8c$var$x = Object.prototype.hasOwnProperty, $3947ff2ea3645b8c$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3947ff2ea3645b8c$var$fa = {}, $3947ff2ea3645b8c$var$ha = {};
function $3947ff2ea3645b8c$var$ia(a) {
    if ($3947ff2ea3645b8c$var$x.call($3947ff2ea3645b8c$var$ha, a)) return !0;
    if ($3947ff2ea3645b8c$var$x.call($3947ff2ea3645b8c$var$fa, a)) return !1;
    if ($3947ff2ea3645b8c$var$ea.test(a)) return $3947ff2ea3645b8c$var$ha[a] = !0;
    $3947ff2ea3645b8c$var$fa[a] = !0;
    return !1;
}
function $3947ff2ea3645b8c$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $3947ff2ea3645b8c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3947ff2ea3645b8c$var$z[b] = new $3947ff2ea3645b8c$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3947ff2ea3645b8c$var$ja = /[\-:]([a-z])/g;
function $3947ff2ea3645b8c$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3947ff2ea3645b8c$var$ja, $3947ff2ea3645b8c$var$ka);
    $3947ff2ea3645b8c$var$z[b] = new $3947ff2ea3645b8c$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3947ff2ea3645b8c$var$ja, $3947ff2ea3645b8c$var$ka);
    $3947ff2ea3645b8c$var$z[b] = new $3947ff2ea3645b8c$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3947ff2ea3645b8c$var$ja, $3947ff2ea3645b8c$var$ka);
    $3947ff2ea3645b8c$var$z[b] = new $3947ff2ea3645b8c$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3947ff2ea3645b8c$var$z.xlinkHref = new $3947ff2ea3645b8c$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $3947ff2ea3645b8c$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3947ff2ea3645b8c$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3947ff2ea3645b8c$var$B).forEach(function(a) {
    $3947ff2ea3645b8c$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3947ff2ea3645b8c$var$B[b] = $3947ff2ea3645b8c$var$B[a];
    });
});
var $3947ff2ea3645b8c$var$oa = /["'&<>]/;
function $3947ff2ea3645b8c$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $3947ff2ea3645b8c$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $3947ff2ea3645b8c$var$pa = /([A-Z])/g, $3947ff2ea3645b8c$var$qa = /^ms-/, $3947ff2ea3645b8c$var$ra = Array.isArray, $3947ff2ea3645b8c$var$sa = $3947ff2ea3645b8c$var$w("<script>"), $3947ff2ea3645b8c$var$ta = $3947ff2ea3645b8c$var$w("</script>"), $3947ff2ea3645b8c$var$ua = $3947ff2ea3645b8c$var$w('<script src="'), $3947ff2ea3645b8c$var$va = $3947ff2ea3645b8c$var$w('<script type="module" src="'), $3947ff2ea3645b8c$var$wa = $3947ff2ea3645b8c$var$w('" async=""></script>'), $3947ff2ea3645b8c$var$xa = /(<\/|<)(s)(cript)/gi;
function $3947ff2ea3645b8c$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $3947ff2ea3645b8c$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $3947ff2ea3645b8c$var$sa : $3947ff2ea3645b8c$var$w('<script nonce="' + $3947ff2ea3645b8c$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $3947ff2ea3645b8c$var$u(("" + c).replace($3947ff2ea3645b8c$var$xa, $3947ff2ea3645b8c$var$ya)), $3947ff2ea3645b8c$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($3947ff2ea3645b8c$var$ua, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d[c])), $3947ff2ea3645b8c$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($3947ff2ea3645b8c$var$va, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(f[d])), $3947ff2ea3645b8c$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $3947ff2ea3645b8c$var$w(a + "P:"),
        segmentPrefix: $3947ff2ea3645b8c$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $3947ff2ea3645b8c$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $3947ff2ea3645b8c$var$Aa(a) {
    return $3947ff2ea3645b8c$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $3947ff2ea3645b8c$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $3947ff2ea3645b8c$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $3947ff2ea3645b8c$var$D(2, null);
        case "math":
            return $3947ff2ea3645b8c$var$D(3, null);
        case "foreignObject":
            return $3947ff2ea3645b8c$var$D(1, null);
        case "table":
            return $3947ff2ea3645b8c$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $3947ff2ea3645b8c$var$D(5, null);
        case "colgroup":
            return $3947ff2ea3645b8c$var$D(7, null);
        case "tr":
            return $3947ff2ea3645b8c$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $3947ff2ea3645b8c$var$D(1, null) : a;
}
var $3947ff2ea3645b8c$var$Ca = $3947ff2ea3645b8c$var$w("<!-- -->");
function $3947ff2ea3645b8c$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($3947ff2ea3645b8c$var$Ca);
    a.push($3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(b)));
    return !0;
}
var $3947ff2ea3645b8c$var$Ea = new Map, $3947ff2ea3645b8c$var$Fa = $3947ff2ea3645b8c$var$w(' style="'), $3947ff2ea3645b8c$var$Ga = $3947ff2ea3645b8c$var$w(":"), $3947ff2ea3645b8c$var$Ha = $3947ff2ea3645b8c$var$w(";");
function $3947ff2ea3645b8c$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($3947ff2ea3645b8c$var$k(62));
    b = !0;
    for(var d in c)if ($3947ff2ea3645b8c$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d));
                f = $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $3947ff2ea3645b8c$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $3947ff2ea3645b8c$var$w($3947ff2ea3645b8c$var$C(e.replace($3947ff2ea3645b8c$var$pa, "-$1").toLowerCase().replace($3947ff2ea3645b8c$var$qa, "-ms-"))), $3947ff2ea3645b8c$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $3947ff2ea3645b8c$var$x.call($3947ff2ea3645b8c$var$B, d) ? $3947ff2ea3645b8c$var$u("" + f) : $3947ff2ea3645b8c$var$u(f + "px") : $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($3947ff2ea3645b8c$var$Fa, e, $3947ff2ea3645b8c$var$Ga, f)) : a.push($3947ff2ea3645b8c$var$Ha, e, $3947ff2ea3645b8c$var$Ga, f);
        }
    }
    b || a.push($3947ff2ea3645b8c$var$E);
}
var $3947ff2ea3645b8c$var$H = $3947ff2ea3645b8c$var$w(" "), $3947ff2ea3645b8c$var$I = $3947ff2ea3645b8c$var$w('="'), $3947ff2ea3645b8c$var$E = $3947ff2ea3645b8c$var$w('"'), $3947ff2ea3645b8c$var$Ja = $3947ff2ea3645b8c$var$w('=""');
function $3947ff2ea3645b8c$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $3947ff2ea3645b8c$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $3947ff2ea3645b8c$var$z.hasOwnProperty(c) ? $3947ff2ea3645b8c$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $3947ff2ea3645b8c$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$Ja) : !1 !== d && a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d)), $3947ff2ea3645b8c$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d)), $3947ff2ea3645b8c$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d)), $3947ff2ea3645b8c$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d)), $3947ff2ea3645b8c$var$E);
            }
        } else if ($3947ff2ea3645b8c$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($3947ff2ea3645b8c$var$H, $3947ff2ea3645b8c$var$u(c), $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d)), $3947ff2ea3645b8c$var$E);
        }
    }
}
var $3947ff2ea3645b8c$var$K = $3947ff2ea3645b8c$var$w(">"), $3947ff2ea3645b8c$var$Ka = $3947ff2ea3645b8c$var$w("/>");
function $3947ff2ea3645b8c$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($3947ff2ea3645b8c$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($3947ff2ea3645b8c$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($3947ff2ea3645b8c$var$u("" + b));
    }
}
function $3947ff2ea3645b8c$var$La(a) {
    var b = "";
    $eeH7J.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $3947ff2ea3645b8c$var$Ma = $3947ff2ea3645b8c$var$w(' selected=""');
function $3947ff2ea3645b8c$var$Na(a, b, c, d) {
    a.push($3947ff2ea3645b8c$var$M(c));
    var f = c = null, e;
    for(e in b)if ($3947ff2ea3645b8c$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $3947ff2ea3645b8c$var$J(a, d, e, g);
        }
    }
    a.push($3947ff2ea3645b8c$var$K);
    $3947ff2ea3645b8c$var$L(a, f, c);
    return "string" === typeof c ? (a.push($3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(c))), null) : c;
}
var $3947ff2ea3645b8c$var$Oa = $3947ff2ea3645b8c$var$w("\n"), $3947ff2ea3645b8c$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $3947ff2ea3645b8c$var$Qa = new Map;
function $3947ff2ea3645b8c$var$M(a) {
    var b = $3947ff2ea3645b8c$var$Qa.get(a);
    if (void 0 === b) {
        if (!$3947ff2ea3645b8c$var$Pa.test(a)) throw Error($3947ff2ea3645b8c$var$k(65, a));
        b = $3947ff2ea3645b8c$var$w("<" + a);
        $3947ff2ea3645b8c$var$Qa.set(a, b);
    }
    return b;
}
var $3947ff2ea3645b8c$var$Ra = $3947ff2ea3645b8c$var$w("<!DOCTYPE html>");
function $3947ff2ea3645b8c$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($3947ff2ea3645b8c$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($3947ff2ea3645b8c$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $3947ff2ea3645b8c$var$J(a, d, r, h);
                }
            }
            a.push($3947ff2ea3645b8c$var$K);
            $3947ff2ea3645b8c$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($3947ff2ea3645b8c$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($3947ff2ea3645b8c$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $3947ff2ea3645b8c$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $3947ff2ea3645b8c$var$La(h), $3947ff2ea3645b8c$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($3947ff2ea3645b8c$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($3947ff2ea3645b8c$var$Ma);
            } else q && a.push($3947ff2ea3645b8c$var$Ma);
            a.push($3947ff2ea3645b8c$var$K);
            $3947ff2ea3645b8c$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($3947ff2ea3645b8c$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($3947ff2ea3645b8c$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($3947ff2ea3645b8c$var$k(91));
                default:
                    $3947ff2ea3645b8c$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($3947ff2ea3645b8c$var$K);
            if (null != r) {
                if (null != e) throw Error($3947ff2ea3645b8c$var$k(92));
                if ($3947ff2ea3645b8c$var$ra(r) && 1 < r.length) throw Error($3947ff2ea3645b8c$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($3947ff2ea3645b8c$var$Oa);
            null !== e && a.push($3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C("" + e)));
            return null;
        case "input":
            a.push($3947ff2ea3645b8c$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($3947ff2ea3645b8c$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3947ff2ea3645b8c$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $3947ff2ea3645b8c$var$J(a, d, g, q);
            }
            null !== r ? $3947ff2ea3645b8c$var$J(a, d, "checked", r) : null !== m && $3947ff2ea3645b8c$var$J(a, d, "checked", m);
            null !== e ? $3947ff2ea3645b8c$var$J(a, d, "value", e) : null !== h && $3947ff2ea3645b8c$var$J(a, d, "value", h);
            a.push($3947ff2ea3645b8c$var$Ka);
            return null;
        case "menuitem":
            a.push($3947ff2ea3645b8c$var$M("menuitem"));
            for(var A in c)if ($3947ff2ea3645b8c$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3947ff2ea3645b8c$var$k(400));
                default:
                    $3947ff2ea3645b8c$var$J(a, d, A, e);
            }
            a.push($3947ff2ea3645b8c$var$K);
            return null;
        case "title":
            a.push($3947ff2ea3645b8c$var$M("title"));
            e = null;
            for(v in c)if ($3947ff2ea3645b8c$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($3947ff2ea3645b8c$var$k(434));
                default:
                    $3947ff2ea3645b8c$var$J(a, d, v, g);
            }
            a.push($3947ff2ea3645b8c$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($3947ff2ea3645b8c$var$M(b));
            g = e = null;
            for(m in c)if ($3947ff2ea3645b8c$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $3947ff2ea3645b8c$var$J(a, d, m, h);
            }
            a.push($3947ff2ea3645b8c$var$K);
            if (null != g) {
                if (null != e) throw Error($3947ff2ea3645b8c$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($3947ff2ea3645b8c$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($3947ff2ea3645b8c$var$Oa, $3947ff2ea3645b8c$var$u(c)) : a.push($3947ff2ea3645b8c$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($3947ff2ea3645b8c$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($3947ff2ea3645b8c$var$M(b));
            for(var F in c)if ($3947ff2ea3645b8c$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3947ff2ea3645b8c$var$k(399, b));
                default:
                    $3947ff2ea3645b8c$var$J(a, d, F, e);
            }
            a.push($3947ff2ea3645b8c$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $3947ff2ea3645b8c$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($3947ff2ea3645b8c$var$Ra), $3947ff2ea3645b8c$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $3947ff2ea3645b8c$var$Na(a, c, b, d);
            a.push($3947ff2ea3645b8c$var$M(b));
            g = e = null;
            for(q in c)if ($3947ff2ea3645b8c$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $3947ff2ea3645b8c$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $3947ff2ea3645b8c$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($3947ff2ea3645b8c$var$H, $3947ff2ea3645b8c$var$u(q), $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(h)), $3947ff2ea3645b8c$var$E);
            }
            a.push($3947ff2ea3645b8c$var$K);
            $3947ff2ea3645b8c$var$L(a, g, e);
            return e;
    }
}
var $3947ff2ea3645b8c$var$Ta = $3947ff2ea3645b8c$var$w("</"), $3947ff2ea3645b8c$var$Ua = $3947ff2ea3645b8c$var$w(">"), $3947ff2ea3645b8c$var$Va = $3947ff2ea3645b8c$var$w('<template id="'), $3947ff2ea3645b8c$var$Wa = $3947ff2ea3645b8c$var$w('"></template>'), $3947ff2ea3645b8c$var$Xa = $3947ff2ea3645b8c$var$w("<!--$-->"), $3947ff2ea3645b8c$var$Ya = $3947ff2ea3645b8c$var$w('<!--$?--><template id="'), $3947ff2ea3645b8c$var$Za = $3947ff2ea3645b8c$var$w('"></template>'), $3947ff2ea3645b8c$var$$a = $3947ff2ea3645b8c$var$w("<!--$!-->"), $3947ff2ea3645b8c$var$ab = $3947ff2ea3645b8c$var$w("<!--/$-->"), $3947ff2ea3645b8c$var$bb = $3947ff2ea3645b8c$var$w("<template"), $3947ff2ea3645b8c$var$cb = $3947ff2ea3645b8c$var$w('"'), $3947ff2ea3645b8c$var$db = $3947ff2ea3645b8c$var$w(' data-dgst="');
$3947ff2ea3645b8c$var$w(' data-msg="');
$3947ff2ea3645b8c$var$w(' data-stck="');
var $3947ff2ea3645b8c$var$eb = $3947ff2ea3645b8c$var$w("></template>");
function $3947ff2ea3645b8c$var$fb(a, b, c) {
    $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$Ya);
    if (null === c) throw Error($3947ff2ea3645b8c$var$k(395));
    $3947ff2ea3645b8c$var$p(a, c);
    return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$Za);
}
var $3947ff2ea3645b8c$var$gb = $3947ff2ea3645b8c$var$w('<div hidden id="'), $3947ff2ea3645b8c$var$hb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$ib = $3947ff2ea3645b8c$var$w("</div>"), $3947ff2ea3645b8c$var$jb = $3947ff2ea3645b8c$var$w('<svg aria-hidden="true" style="display:none" id="'), $3947ff2ea3645b8c$var$kb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$lb = $3947ff2ea3645b8c$var$w("</svg>"), $3947ff2ea3645b8c$var$mb = $3947ff2ea3645b8c$var$w('<math aria-hidden="true" style="display:none" id="'), $3947ff2ea3645b8c$var$nb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$ob = $3947ff2ea3645b8c$var$w("</math>"), $3947ff2ea3645b8c$var$pb = $3947ff2ea3645b8c$var$w('<table hidden id="'), $3947ff2ea3645b8c$var$qb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$rb = $3947ff2ea3645b8c$var$w("</table>"), $3947ff2ea3645b8c$var$sb = $3947ff2ea3645b8c$var$w('<table hidden><tbody id="'), $3947ff2ea3645b8c$var$tb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$ub = $3947ff2ea3645b8c$var$w("</tbody></table>"), $3947ff2ea3645b8c$var$vb = $3947ff2ea3645b8c$var$w('<table hidden><tr id="'), $3947ff2ea3645b8c$var$wb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$xb = $3947ff2ea3645b8c$var$w("</tr></table>"), $3947ff2ea3645b8c$var$yb = $3947ff2ea3645b8c$var$w('<table hidden><colgroup id="'), $3947ff2ea3645b8c$var$zb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$Ab = $3947ff2ea3645b8c$var$w("</colgroup></table>");
function $3947ff2ea3645b8c$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$gb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$hb);
        case 2:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$jb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$kb);
        case 3:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$mb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$nb);
        case 4:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$pb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$qb);
        case 5:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$sb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$tb);
        case 6:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$vb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$wb);
        case 7:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$yb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$zb);
        default:
            throw Error($3947ff2ea3645b8c$var$k(397));
    }
}
function $3947ff2ea3645b8c$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$ib);
        case 2:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$lb);
        case 3:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$ob);
        case 4:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$rb);
        case 5:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$ub);
        case 6:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$xb);
        case 7:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$Ab);
        default:
            throw Error($3947ff2ea3645b8c$var$k(397));
    }
}
var $3947ff2ea3645b8c$var$Db = $3947ff2ea3645b8c$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $3947ff2ea3645b8c$var$Eb = $3947ff2ea3645b8c$var$w('$RS("'), $3947ff2ea3645b8c$var$Gb = $3947ff2ea3645b8c$var$w('","'), $3947ff2ea3645b8c$var$Hb = $3947ff2ea3645b8c$var$w('")</script>'), $3947ff2ea3645b8c$var$Ib = $3947ff2ea3645b8c$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $3947ff2ea3645b8c$var$Jb = $3947ff2ea3645b8c$var$w('$RC("'), $3947ff2ea3645b8c$var$Kb = $3947ff2ea3645b8c$var$w('","'), $3947ff2ea3645b8c$var$Lb = $3947ff2ea3645b8c$var$w('")</script>'), $3947ff2ea3645b8c$var$Mb = $3947ff2ea3645b8c$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $3947ff2ea3645b8c$var$Nb = $3947ff2ea3645b8c$var$w('$RX("'), $3947ff2ea3645b8c$var$Ob = $3947ff2ea3645b8c$var$w('"'), $3947ff2ea3645b8c$var$Pb = $3947ff2ea3645b8c$var$w(")</script>"), $3947ff2ea3645b8c$var$Qb = $3947ff2ea3645b8c$var$w(","), $3947ff2ea3645b8c$var$Rb = /[<\u2028\u2029]/g;
function $3947ff2ea3645b8c$var$Sb(a) {
    return JSON.stringify(a).replace($3947ff2ea3645b8c$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $3947ff2ea3645b8c$var$N = Object.assign, $3947ff2ea3645b8c$var$Tb = Symbol.for("react.element"), $3947ff2ea3645b8c$var$Ub = Symbol.for("react.portal"), $3947ff2ea3645b8c$var$Vb = Symbol.for("react.fragment"), $3947ff2ea3645b8c$var$Wb = Symbol.for("react.strict_mode"), $3947ff2ea3645b8c$var$Xb = Symbol.for("react.profiler"), $3947ff2ea3645b8c$var$Yb = Symbol.for("react.provider"), $3947ff2ea3645b8c$var$Zb = Symbol.for("react.context"), $3947ff2ea3645b8c$var$$b = Symbol.for("react.forward_ref"), $3947ff2ea3645b8c$var$ac = Symbol.for("react.suspense"), $3947ff2ea3645b8c$var$bc = Symbol.for("react.suspense_list"), $3947ff2ea3645b8c$var$cc = Symbol.for("react.memo"), $3947ff2ea3645b8c$var$dc = Symbol.for("react.lazy"), $3947ff2ea3645b8c$var$ec = Symbol.for("react.scope"), $3947ff2ea3645b8c$var$fc = Symbol.for("react.debug_trace_mode"), $3947ff2ea3645b8c$var$gc = Symbol.for("react.legacy_hidden"), $3947ff2ea3645b8c$var$hc = Symbol.for("react.default_value"), $3947ff2ea3645b8c$var$ic = Symbol.iterator;
function $3947ff2ea3645b8c$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3947ff2ea3645b8c$var$Vb:
            return "Fragment";
        case $3947ff2ea3645b8c$var$Ub:
            return "Portal";
        case $3947ff2ea3645b8c$var$Xb:
            return "Profiler";
        case $3947ff2ea3645b8c$var$Wb:
            return "StrictMode";
        case $3947ff2ea3645b8c$var$ac:
            return "Suspense";
        case $3947ff2ea3645b8c$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3947ff2ea3645b8c$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $3947ff2ea3645b8c$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $3947ff2ea3645b8c$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3947ff2ea3645b8c$var$cc:
            return b = a.displayName || null, null !== b ? b : $3947ff2ea3645b8c$var$jc(a.type) || "Memo";
        case $3947ff2ea3645b8c$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $3947ff2ea3645b8c$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $3947ff2ea3645b8c$var$kc = {};
function $3947ff2ea3645b8c$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $3947ff2ea3645b8c$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $3947ff2ea3645b8c$var$O = null;
function $3947ff2ea3645b8c$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($3947ff2ea3645b8c$var$k(401));
        } else {
            if (null === c) throw Error($3947ff2ea3645b8c$var$k(401));
            $3947ff2ea3645b8c$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $3947ff2ea3645b8c$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $3947ff2ea3645b8c$var$mc(a);
}
function $3947ff2ea3645b8c$var$nc(a) {
    var b = a.parent;
    null !== b && $3947ff2ea3645b8c$var$nc(b);
    a.context._currentValue = a.value;
}
function $3947ff2ea3645b8c$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($3947ff2ea3645b8c$var$k(402));
    a.depth === b.depth ? $3947ff2ea3645b8c$var$P(a, b) : $3947ff2ea3645b8c$var$oc(a, b);
}
function $3947ff2ea3645b8c$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($3947ff2ea3645b8c$var$k(402));
    a.depth === c.depth ? $3947ff2ea3645b8c$var$P(a, c) : $3947ff2ea3645b8c$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $3947ff2ea3645b8c$var$Q(a) {
    var b = $3947ff2ea3645b8c$var$O;
    b !== a && (null === b ? $3947ff2ea3645b8c$var$nc(a) : null === a ? $3947ff2ea3645b8c$var$mc(b) : b.depth === a.depth ? $3947ff2ea3645b8c$var$P(b, a) : b.depth > a.depth ? $3947ff2ea3645b8c$var$oc(b, a) : $3947ff2ea3645b8c$var$pc(b, a), $3947ff2ea3645b8c$var$O = a);
}
var $3947ff2ea3645b8c$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $3947ff2ea3645b8c$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $3947ff2ea3645b8c$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $3947ff2ea3645b8c$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $3947ff2ea3645b8c$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $3947ff2ea3645b8c$var$N({}, e, h)) : $3947ff2ea3645b8c$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $3947ff2ea3645b8c$var$sc = {
    id: 1,
    overflow: ""
};
function $3947ff2ea3645b8c$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $3947ff2ea3645b8c$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $3947ff2ea3645b8c$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $3947ff2ea3645b8c$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $3947ff2ea3645b8c$var$uc = Math.clz32 ? Math.clz32 : $3947ff2ea3645b8c$var$vc, $3947ff2ea3645b8c$var$wc = Math.log, $3947ff2ea3645b8c$var$xc = Math.LN2;
function $3947ff2ea3645b8c$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3947ff2ea3645b8c$var$wc(a) / $3947ff2ea3645b8c$var$xc | 0) | 0;
}
function $3947ff2ea3645b8c$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3947ff2ea3645b8c$var$zc = "function" === typeof Object.is ? Object.is : $3947ff2ea3645b8c$var$yc, $3947ff2ea3645b8c$var$R = null, $3947ff2ea3645b8c$var$Ac = null, $3947ff2ea3645b8c$var$Bc = null, $3947ff2ea3645b8c$var$S = null, $3947ff2ea3645b8c$var$T = !1, $3947ff2ea3645b8c$var$Cc = !1, $3947ff2ea3645b8c$var$U = 0, $3947ff2ea3645b8c$var$V = null, $3947ff2ea3645b8c$var$Dc = 0;
function $3947ff2ea3645b8c$var$W() {
    if (null === $3947ff2ea3645b8c$var$R) throw Error($3947ff2ea3645b8c$var$k(321));
    return $3947ff2ea3645b8c$var$R;
}
function $3947ff2ea3645b8c$var$Ec() {
    if (0 < $3947ff2ea3645b8c$var$Dc) throw Error($3947ff2ea3645b8c$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $3947ff2ea3645b8c$var$Fc() {
    null === $3947ff2ea3645b8c$var$S ? null === $3947ff2ea3645b8c$var$Bc ? ($3947ff2ea3645b8c$var$T = !1, $3947ff2ea3645b8c$var$Bc = $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$Ec()) : ($3947ff2ea3645b8c$var$T = !0, $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$Bc) : null === $3947ff2ea3645b8c$var$S.next ? ($3947ff2ea3645b8c$var$T = !1, $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$S.next = $3947ff2ea3645b8c$var$Ec()) : ($3947ff2ea3645b8c$var$T = !0, $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$S.next);
    return $3947ff2ea3645b8c$var$S;
}
function $3947ff2ea3645b8c$var$Gc() {
    $3947ff2ea3645b8c$var$Ac = $3947ff2ea3645b8c$var$R = null;
    $3947ff2ea3645b8c$var$Cc = !1;
    $3947ff2ea3645b8c$var$Bc = null;
    $3947ff2ea3645b8c$var$Dc = 0;
    $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$V = null;
}
function $3947ff2ea3645b8c$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3947ff2ea3645b8c$var$Ic(a, b, c) {
    $3947ff2ea3645b8c$var$R = $3947ff2ea3645b8c$var$W();
    $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$Fc();
    if ($3947ff2ea3645b8c$var$T) {
        var d = $3947ff2ea3645b8c$var$S.queue;
        b = d.dispatch;
        if (null !== $3947ff2ea3645b8c$var$V && (c = $3947ff2ea3645b8c$var$V.get(d), void 0 !== c)) {
            $3947ff2ea3645b8c$var$V.delete(d);
            d = $3947ff2ea3645b8c$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $3947ff2ea3645b8c$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $3947ff2ea3645b8c$var$S.memoizedState,
            b
        ];
    }
    a = a === $3947ff2ea3645b8c$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $3947ff2ea3645b8c$var$S.memoizedState = a;
    a = $3947ff2ea3645b8c$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $3947ff2ea3645b8c$var$Jc.bind(null, $3947ff2ea3645b8c$var$R, a);
    return [
        $3947ff2ea3645b8c$var$S.memoizedState,
        a
    ];
}
function $3947ff2ea3645b8c$var$Kc(a, b) {
    $3947ff2ea3645b8c$var$R = $3947ff2ea3645b8c$var$W();
    $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $3947ff2ea3645b8c$var$S) {
        var c = $3947ff2ea3645b8c$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$3947ff2ea3645b8c$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $3947ff2ea3645b8c$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3947ff2ea3645b8c$var$Jc(a, b, c) {
    if (25 <= $3947ff2ea3645b8c$var$Dc) throw Error($3947ff2ea3645b8c$var$k(301));
    if (a === $3947ff2ea3645b8c$var$R) {
        if ($3947ff2ea3645b8c$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $3947ff2ea3645b8c$var$V && ($3947ff2ea3645b8c$var$V = new Map), c = $3947ff2ea3645b8c$var$V.get(b), void 0 === c) $3947ff2ea3645b8c$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $3947ff2ea3645b8c$var$Lc() {
    throw Error($3947ff2ea3645b8c$var$k(394));
}
function $3947ff2ea3645b8c$var$Mc() {}
var $3947ff2ea3645b8c$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $3947ff2ea3645b8c$var$W();
        return a._currentValue;
    },
    useMemo: $3947ff2ea3645b8c$var$Kc,
    useReducer: $3947ff2ea3645b8c$var$Ic,
    useRef: function(a) {
        $3947ff2ea3645b8c$var$R = $3947ff2ea3645b8c$var$W();
        $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$Fc();
        var b = $3947ff2ea3645b8c$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $3947ff2ea3645b8c$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $3947ff2ea3645b8c$var$Ic($3947ff2ea3645b8c$var$Hc, a);
    },
    useInsertionEffect: $3947ff2ea3645b8c$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $3947ff2ea3645b8c$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $3947ff2ea3645b8c$var$Mc,
    useEffect: $3947ff2ea3645b8c$var$Mc,
    useDebugValue: $3947ff2ea3645b8c$var$Mc,
    useDeferredValue: function(a) {
        $3947ff2ea3645b8c$var$W();
        return a;
    },
    useTransition: function() {
        $3947ff2ea3645b8c$var$W();
        return [
            !1,
            $3947ff2ea3645b8c$var$Lc
        ];
    },
    useId: function() {
        var a = $3947ff2ea3645b8c$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $3947ff2ea3645b8c$var$uc(a) - 1)).toString(32) + b;
        var c = $3947ff2ea3645b8c$var$Nc;
        if (null === c) throw Error($3947ff2ea3645b8c$var$k(404));
        b = $3947ff2ea3645b8c$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $3947ff2ea3645b8c$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($3947ff2ea3645b8c$var$k(407));
        return c();
    }
}, $3947ff2ea3645b8c$var$Nc = null, $3947ff2ea3645b8c$var$Pc = $eeH7J.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $3947ff2ea3645b8c$var$Qc(a) {
    console.error(a);
    return null;
}
function $3947ff2ea3645b8c$var$X() {}
function $3947ff2ea3645b8c$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $3947ff2ea3645b8c$var$Qc : f,
        onAllReady: void 0 === e ? $3947ff2ea3645b8c$var$X : e,
        onShellReady: void 0 === g ? $3947ff2ea3645b8c$var$X : g,
        onShellError: void 0 === h ? $3947ff2ea3645b8c$var$X : h,
        onFatalError: void 0 === m ? $3947ff2ea3645b8c$var$X : m
    };
    c = $3947ff2ea3645b8c$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $3947ff2ea3645b8c$var$Tc(b, a, null, c, r, $3947ff2ea3645b8c$var$kc, null, $3947ff2ea3645b8c$var$sc);
    q.push(a);
    return b;
}
function $3947ff2ea3645b8c$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $3947ff2ea3645b8c$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $3947ff2ea3645b8c$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $3947ff2ea3645b8c$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $3947ff2ea3645b8c$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $3947ff2ea3645b8c$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $3947ff2ea3645b8c$var$Wc(a, b, c, d, f) {
    $3947ff2ea3645b8c$var$R = {};
    $3947ff2ea3645b8c$var$Ac = b;
    $3947ff2ea3645b8c$var$U = 0;
    for(a = c(d, f); $3947ff2ea3645b8c$var$Cc;)$3947ff2ea3645b8c$var$Cc = !1, $3947ff2ea3645b8c$var$U = 0, $3947ff2ea3645b8c$var$Dc += 1, $3947ff2ea3645b8c$var$S = null, a = c(d, f);
    $3947ff2ea3645b8c$var$Gc();
    return a;
}
function $3947ff2ea3645b8c$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($3947ff2ea3645b8c$var$k(108, $3947ff2ea3645b8c$var$jc(d) || "Unknown", h));
            d = $3947ff2ea3645b8c$var$N({}, g, c);
        }
        b.legacyContext = d;
        $3947ff2ea3645b8c$var$Z(a, b, f);
        b.legacyContext = g;
    } else $3947ff2ea3645b8c$var$Z(a, b, f);
}
function $3947ff2ea3645b8c$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $3947ff2ea3645b8c$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $3947ff2ea3645b8c$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $3947ff2ea3645b8c$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $3947ff2ea3645b8c$var$rc(e, c, d, f);
            $3947ff2ea3645b8c$var$Xc(a, b, e, c);
        } else {
            e = $3947ff2ea3645b8c$var$lc(c, b.legacyContext);
            f = $3947ff2ea3645b8c$var$Wc(a, b, c, d, e);
            var g = 0 !== $3947ff2ea3645b8c$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $3947ff2ea3645b8c$var$rc(f, c, d, e), $3947ff2ea3645b8c$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $3947ff2ea3645b8c$var$tc(d, 1, 0);
                try {
                    $3947ff2ea3645b8c$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $3947ff2ea3645b8c$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $3947ff2ea3645b8c$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $3947ff2ea3645b8c$var$Ba(g, c, d);
        $3947ff2ea3645b8c$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($3947ff2ea3645b8c$var$Ta, $3947ff2ea3645b8c$var$u(c), $3947ff2ea3645b8c$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $3947ff2ea3645b8c$var$gc:
            case $3947ff2ea3645b8c$var$fc:
            case $3947ff2ea3645b8c$var$Wb:
            case $3947ff2ea3645b8c$var$Xb:
            case $3947ff2ea3645b8c$var$Vb:
                $3947ff2ea3645b8c$var$Z(a, b, d.children);
                return;
            case $3947ff2ea3645b8c$var$bc:
                $3947ff2ea3645b8c$var$Z(a, b, d.children);
                return;
            case $3947ff2ea3645b8c$var$ec:
                throw Error($3947ff2ea3645b8c$var$k(343));
            case $3947ff2ea3645b8c$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $3947ff2ea3645b8c$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $3947ff2ea3645b8c$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($3947ff2ea3645b8c$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($3947ff2ea3645b8c$var$Ca), q.status = 1, $3947ff2ea3645b8c$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $3947ff2ea3645b8c$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $3947ff2ea3645b8c$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $3947ff2ea3645b8c$var$$b:
                d = $3947ff2ea3645b8c$var$Wc(a, b, c.render, d, f);
                if (0 !== $3947ff2ea3645b8c$var$U) {
                    c = b.treeContext;
                    b.treeContext = $3947ff2ea3645b8c$var$tc(c, 1, 0);
                    try {
                        $3947ff2ea3645b8c$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $3947ff2ea3645b8c$var$Z(a, b, d);
                return;
            case $3947ff2ea3645b8c$var$cc:
                c = c.type;
                d = $3947ff2ea3645b8c$var$Yc(c, d);
                $3947ff2ea3645b8c$var$Zc(a, b, c, d, f);
                return;
            case $3947ff2ea3645b8c$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $3947ff2ea3645b8c$var$O;
                $3947ff2ea3645b8c$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $3947ff2ea3645b8c$var$Z(a, b, f);
                a = $3947ff2ea3645b8c$var$O;
                if (null === a) throw Error($3947ff2ea3645b8c$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $3947ff2ea3645b8c$var$hc ? a.context._defaultValue : d;
                a = $3947ff2ea3645b8c$var$O = a.parent;
                b.context = a;
                return;
            case $3947ff2ea3645b8c$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $3947ff2ea3645b8c$var$Z(a, b, d);
                return;
            case $3947ff2ea3645b8c$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $3947ff2ea3645b8c$var$Yc(c, d);
                $3947ff2ea3645b8c$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($3947ff2ea3645b8c$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $3947ff2ea3645b8c$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $3947ff2ea3645b8c$var$Tb:
                $3947ff2ea3645b8c$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $3947ff2ea3645b8c$var$Ub:
                throw Error($3947ff2ea3645b8c$var$k(257));
            case $3947ff2ea3645b8c$var$dc:
                var d = c._init;
                c = d(c._payload);
                $3947ff2ea3645b8c$var$Z(a, b, c);
                return;
        }
        if ($3947ff2ea3645b8c$var$ra(c)) {
            $3947ff2ea3645b8c$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $3947ff2ea3645b8c$var$ic && c[$3947ff2ea3645b8c$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $3947ff2ea3645b8c$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($3947ff2ea3645b8c$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $3947ff2ea3645b8c$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $3947ff2ea3645b8c$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $3947ff2ea3645b8c$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $3947ff2ea3645b8c$var$tc(e, d, f);
        try {
            $3947ff2ea3645b8c$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $3947ff2ea3645b8c$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $3947ff2ea3645b8c$var$Z(a, b, c);
    } catch (m) {
        if ($3947ff2ea3645b8c$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $3947ff2ea3645b8c$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $3947ff2ea3645b8c$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $3947ff2ea3645b8c$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $3947ff2ea3645b8c$var$Q(e), m;
    }
}
function $3947ff2ea3645b8c$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $3947ff2ea3645b8c$var$dd(this, b, a);
}
function $3947ff2ea3645b8c$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($3947ff2ea3645b8c$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $3947ff2ea3645b8c$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $3947ff2ea3645b8c$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $3947ff2ea3645b8c$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $3947ff2ea3645b8c$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($3947ff2ea3645b8c$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $3947ff2ea3645b8c$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $3947ff2ea3645b8c$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($3947ff2ea3645b8c$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($3947ff2ea3645b8c$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $3947ff2ea3645b8c$var$Uc(a) {
    if (2 !== a.status) {
        var b = $3947ff2ea3645b8c$var$O, c = $3947ff2ea3645b8c$var$Pc.current;
        $3947ff2ea3645b8c$var$Pc.current = $3947ff2ea3645b8c$var$Oc;
        var d = $3947ff2ea3645b8c$var$Nc;
        $3947ff2ea3645b8c$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $3947ff2ea3645b8c$var$Q(g.context);
                    try {
                        $3947ff2ea3645b8c$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($3947ff2ea3645b8c$var$Ca), g.abortSet.delete(g), m.status = 1, $3947ff2ea3645b8c$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($3947ff2ea3645b8c$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $3947ff2ea3645b8c$var$Y(h, v);
                            null === r ? $3947ff2ea3645b8c$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $3947ff2ea3645b8c$var$fd(a, a.destination);
        } catch (G) {
            $3947ff2ea3645b8c$var$Y(a, G), $3947ff2ea3645b8c$var$Vc(a, G);
        } finally{
            $3947ff2ea3645b8c$var$Nc = d, $3947ff2ea3645b8c$var$Pc.current = c, c === $3947ff2ea3645b8c$var$Oc && $3947ff2ea3645b8c$var$Q(b);
        }
    }
}
function $3947ff2ea3645b8c$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Va);
            $3947ff2ea3645b8c$var$p(b, a.placeholderPrefix);
            a = $3947ff2ea3645b8c$var$u(d.toString(16));
            $3947ff2ea3645b8c$var$p(b, a);
            return $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$3947ff2ea3645b8c$var$p(b, d[e]);
                f = $3947ff2ea3645b8c$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$3947ff2ea3645b8c$var$p(b, d[e]);
            e < d.length && (f = $3947ff2ea3645b8c$var$t(b, d[e]));
            return f;
        default:
            throw Error($3947ff2ea3645b8c$var$k(390));
    }
}
function $3947ff2ea3645b8c$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $3947ff2ea3645b8c$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$$a), $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$bb), d && ($3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$db), $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d))), $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$cb)), $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$eb), $3947ff2ea3645b8c$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $3947ff2ea3645b8c$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $3947ff2ea3645b8c$var$fb(b, a.responseState, d);
        $3947ff2ea3645b8c$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $3947ff2ea3645b8c$var$fb(b, a.responseState, d.id), $3947ff2ea3645b8c$var$gd(a, b, c);
    else {
        $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($3947ff2ea3645b8c$var$k(391));
        $3947ff2ea3645b8c$var$hd(a, b, c[0]);
    }
    return $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$ab);
}
function $3947ff2ea3645b8c$var$id(a, b, c) {
    $3947ff2ea3645b8c$var$Bb(b, a.responseState, c.formatContext, c.id);
    $3947ff2ea3645b8c$var$hd(a, b, c);
    return $3947ff2ea3645b8c$var$Cb(b, c.formatContext);
}
function $3947ff2ea3645b8c$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$3947ff2ea3645b8c$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $3947ff2ea3645b8c$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Ib));
    if (null === d) throw Error($3947ff2ea3645b8c$var$k(395));
    c = $3947ff2ea3645b8c$var$u(c.toString(16));
    $3947ff2ea3645b8c$var$p(b, d);
    $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Kb);
    $3947ff2ea3645b8c$var$p(b, a.segmentPrefix);
    $3947ff2ea3645b8c$var$p(b, c);
    return $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$Lb);
}
function $3947ff2ea3645b8c$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($3947ff2ea3645b8c$var$k(392));
        return $3947ff2ea3645b8c$var$id(a, b, d);
    }
    $3947ff2ea3645b8c$var$id(a, b, d);
    a = a.responseState;
    $3947ff2ea3645b8c$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Eb) : (a.sentCompleteSegmentFunction = !0, $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Db));
    $3947ff2ea3645b8c$var$p(b, a.segmentPrefix);
    f = $3947ff2ea3645b8c$var$u(f.toString(16));
    $3947ff2ea3645b8c$var$p(b, f);
    $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Gb);
    $3947ff2ea3645b8c$var$p(b, a.placeholderPrefix);
    $3947ff2ea3645b8c$var$p(b, f);
    return $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$Hb);
}
function $3947ff2ea3645b8c$var$fd(a, b) {
    $3947ff2ea3645b8c$var$l = new Uint8Array(512);
    $3947ff2ea3645b8c$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $3947ff2ea3645b8c$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$3947ff2ea3645b8c$var$p(b, d[c]);
            c < d.length && $3947ff2ea3645b8c$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $3947ff2ea3645b8c$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Nb) : (h.sentClientRenderFunction = !0, $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Mb));
            if (null === m) throw Error($3947ff2ea3645b8c$var$k(395));
            $3947ff2ea3645b8c$var$p(d, m);
            $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Ob);
            if (q || r || v) $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Qb), $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$Sb(q || "")));
            if (r || v) $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Qb), $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$Sb(r || "")));
            v && ($3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Qb), $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$Sb(v))));
            if (!$3947ff2ea3645b8c$var$t(d, $3947ff2ea3645b8c$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$3947ff2ea3645b8c$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $3947ff2ea3645b8c$var$ba(b);
        $3947ff2ea3645b8c$var$l = new Uint8Array(512);
        $3947ff2ea3645b8c$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$3947ff2ea3645b8c$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$3947ff2ea3645b8c$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $3947ff2ea3645b8c$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $3947ff2ea3645b8c$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $3947ff2ea3645b8c$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $3947ff2ea3645b8c$var$fd(a, a.destination);
    } catch (d) {
        $3947ff2ea3645b8c$var$Y(a, d), $3947ff2ea3645b8c$var$Vc(a, d);
    }
}
$3947ff2ea3645b8c$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $3947ff2ea3645b8c$var$Rc(a, $3947ff2ea3645b8c$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $3947ff2ea3645b8c$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $3947ff2ea3645b8c$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $3947ff2ea3645b8c$var$fd(h, a);
                        } catch (A) {
                            $3947ff2ea3645b8c$var$Y(h, A), $3947ff2ea3645b8c$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $3947ff2ea3645b8c$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $3947ff2ea3645b8c$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $3947ff2ea3645b8c$var$Uc(h);
    });
};
$3947ff2ea3645b8c$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("8MAXm", function(module, exports) {

$parcel$export(module.exports, "MarkdownView", function () { return $664f7939f52bdd5d$export$d5163f1ce1e6a5f9; });

var $4vwom = parcelRequire("4vwom");

var $f2yFo = parcelRequire("f2yFo");

var $hjid1 = parcelRequire("hjid1");

var $aIeEI = parcelRequire("aIeEI");

var $dUDPg = parcelRequire("dUDPg");
function $664f7939f52bdd5d$export$d5163f1ce1e6a5f9({ value: markdown, renderers: additionalRenderers = {} }) {
    const localize = (0, $aIeEI.useLocalize)();
    if (markdown && typeof markdown === "object") markdown = localize(markdown);
    return (0, $4vwom.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f2yFo))), {
        renderers: Object.assign(Object.assign({}, $664f7939f52bdd5d$var$renderers), additionalRenderers),
        plugins: [
            (0, (/*@__PURE__*/$parcel$interopDefault($hjid1)))
        ],
        children: markdown
    });
}
// Make images in Markdown not render outside their container
const $664f7939f52bdd5d$var$renderers = {
    image: ({ alt: alt, src: src, title: title })=>{
        if (alt && alt.startsWith("#MARKDOWN_SNIPPET")) {
            const id = src;
            return (0, $4vwom.jsx)($664f7939f52bdd5d$var$MarkdownSnippetView, {
                id: id
            });
        }
        if (alt && alt.startsWith("#IFRAME")) {
            // Styles are encoded like this: #IFRAME{"width":100,"height":400}
            const iframeStyle = alt.length > 7 ? JSON.parse(alt.slice(7)) : {};
            return (0, $4vwom.jsx)("iframe", {
                src: src,
                style: Object.assign({
                    width: "100%",
                    maxWidth: 480,
                    height: 500
                }, iframeStyle)
            });
        }
        return (0, $4vwom.jsx)("img", {
            alt: alt,
            src: src,
            title: title,
            style: {
                maxWidth: "100%"
            }
        });
    },
    link (props) {
        const href = props.href;
        if (href.startsWith("new-tab/")) return (0, $4vwom.jsx)("a", {
            href: "https://" + href.substr(8),
            target: "_blank",
            children: props.children
        });
        if (href.startsWith("new-tab-local/")) return (0, $4vwom.jsx)("a", {
            href: href.substr(14),
            target: "_blank",
            children: props.children
        });
        return (0, $4vwom.jsx)("a", Object.assign({}, props));
    }
};
function $664f7939f52bdd5d$var$MarkdownSnippetView({ id: id }) {
    const { data: snippet } = (0, $dUDPg.useMarkdownSnippet)(id);
    return (0, $4vwom.jsx)($664f7939f52bdd5d$export$d5163f1ce1e6a5f9, {
        value: snippet === null || snippet === void 0 ? void 0 : snippet.hydratedSnippet
    });
}

});
parcelRegister("f2yFo", function(module, exports) {
"use strict";

var $fv6YB = parcelRequire("fv6YB");

var $4uly0 = parcelRequire("4uly0");

var $bK6CN = parcelRequire("bK6CN");

var $4yBem = parcelRequire("4yBem");

var $dYNzc = parcelRequire("dYNzc");

var $kidYf = parcelRequire("kidYf");

var $ahrfr = parcelRequire("ahrfr");

var $2owNN = parcelRequire("2owNN");

var $9sKTW = parcelRequire("9sKTW");

var $6MxVG = parcelRequire("6MxVG");

var $g3q3g = parcelRequire("g3q3g");

var $k6xnT = parcelRequire("k6xnT");

var $28Nw1 = parcelRequire("28Nw1");
var $af31ef03bb71279c$var$allTypes = Object.keys($k6xnT);
var $af31ef03bb71279c$var$ReactMarkdown = function ReactMarkdown(props) {
    // To do in next major: remove `source`.
    var src = props.source || props.children || "";
    if (props.allowedTypes && props.disallowedTypes) throw new Error("Only one of `allowedTypes` and `disallowedTypes` should be defined");
    var renderers = $fv6YB($k6xnT, props.renderers);
    var processor = $4uly0().use($bK6CN).use(props.plugins || []); // eslint-disable-next-line no-sync
    var tree = processor.runSync(processor.parse(src));
    var renderProps = $fv6YB(props, {
        renderers: renderers,
        definitions: $6MxVG(tree)
    });
    $af31ef03bb71279c$var$determineAstToReactTransforms(props).forEach(function(transform) {
        tree = transform(tree, renderProps);
    });
    return tree;
};
function $af31ef03bb71279c$var$determineAstToReactTransforms(props) {
    var transforms = [
        $9sKTW,
        $dYNzc()
    ];
    var disallowedTypes = props.disallowedTypes;
    if (props.allowedTypes) disallowedTypes = $af31ef03bb71279c$var$allTypes.filter(function(type) {
        return type !== "root" && props.allowedTypes.indexOf(type) === -1;
    });
    var removalMethod = props.unwrapDisallowed ? "unwrap" : "remove";
    if (disallowedTypes && disallowedTypes.length > 0) transforms.push($ahrfr.ofType(disallowedTypes, removalMethod));
    if (props.allowNode) transforms.push($ahrfr.ifNotMatch(props.allowNode, removalMethod));
     // To do in next major: remove `escapeHtml`.
    var renderHtml = (props.allowDangerousHtml || props.escapeHtml === false) && !props.skipHtml;
    var hasHtmlParser = (props.astPlugins || []).some(function(transform) {
        return transform.identity === $28Nw1.HtmlParser;
    });
    if (renderHtml && !hasHtmlParser) transforms.push($kidYf);
    if (props.astPlugins) transforms = transforms.concat(props.astPlugins);
     // Add the final transform to turn everything into React.
    transforms.push($2owNN);
    return transforms;
}
$af31ef03bb71279c$var$ReactMarkdown.defaultProps = {
    transformLinkUri: $g3q3g
};
$af31ef03bb71279c$var$ReactMarkdown.propTypes = {
    className: $4yBem.string,
    source: $4yBem.string,
    children: $4yBem.string,
    sourcePos: $4yBem.bool,
    rawSourcePos: $4yBem.bool,
    escapeHtml: $4yBem.bool,
    allowDangerousHtml: $4yBem.bool,
    skipHtml: $4yBem.bool,
    allowNode: $4yBem.func,
    allowedTypes: $4yBem.arrayOf($4yBem.oneOf($af31ef03bb71279c$var$allTypes)),
    disallowedTypes: $4yBem.arrayOf($4yBem.oneOf($af31ef03bb71279c$var$allTypes)),
    transformLinkUri: $4yBem.oneOfType([
        $4yBem.func,
        $4yBem.bool
    ]),
    linkTarget: $4yBem.oneOfType([
        $4yBem.func,
        $4yBem.string
    ]),
    transformImageUri: $4yBem.func,
    astPlugins: $4yBem.arrayOf($4yBem.func),
    unwrapDisallowed: $4yBem.bool,
    renderers: $4yBem.object,
    plugins: $4yBem.array
};
$af31ef03bb71279c$var$ReactMarkdown.types = $af31ef03bb71279c$var$allTypes;
$af31ef03bb71279c$var$ReactMarkdown.renderers = $k6xnT;
$af31ef03bb71279c$var$ReactMarkdown.uriTransformer = $g3q3g;
module.exports = $af31ef03bb71279c$var$ReactMarkdown;

});
parcelRegister("fv6YB", function(module, exports) {
module.exports = $b48f299eee477116$var$extend;
var $b48f299eee477116$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $b48f299eee477116$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($b48f299eee477116$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});

parcelRegister("4uly0", function(module, exports) {
"use strict";

var $flvVI = parcelRequire("flvVI");

var $Wt5Sk = parcelRequire("Wt5Sk");

var $3BIJi = parcelRequire("3BIJi");

var $djWjq = parcelRequire("djWjq");

var $e1oqg = parcelRequire("e1oqg");

var $bsyhs = parcelRequire("bsyhs");
// Expose a frozen processor.
module.exports = $344aada288b13f4a$var$unified().freeze();
var $344aada288b13f4a$var$slice = [].slice;
var $344aada288b13f4a$var$own = {}.hasOwnProperty;
// Process pipeline.
var $344aada288b13f4a$var$pipeline = $e1oqg().use($344aada288b13f4a$var$pipelineParse).use($344aada288b13f4a$var$pipelineRun).use($344aada288b13f4a$var$pipelineStringify);
function $344aada288b13f4a$var$pipelineParse(p, ctx) {
    ctx.tree = p.parse(ctx.file);
}
function $344aada288b13f4a$var$pipelineRun(p, ctx, next) {
    p.run(ctx.tree, ctx.file, done);
    function done(error, tree, file) {
        if (error) next(error);
        else {
            ctx.tree = tree;
            ctx.file = file;
            next();
        }
    }
}
function $344aada288b13f4a$var$pipelineStringify(p, ctx) {
    var result = p.stringify(ctx.tree, ctx.file);
    if (result === undefined || result === null) ;
    else if (typeof result === "string" || $Wt5Sk(result)) {
        if ("value" in ctx.file) ctx.file.value = result;
        ctx.file.contents = result;
    } else ctx.file.result = result;
}
// Function to create the first processor.
function $344aada288b13f4a$var$unified() {
    var attachers = [];
    var transformers = $e1oqg();
    var namespace = {};
    var freezeIndex = -1;
    var frozen;
    // Data management.
    processor.data = data;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    processor.run = run;
    processor.runSync = runSync;
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    function processor() {
        var destination = $344aada288b13f4a$var$unified();
        var index = -1;
        while(++index < attachers.length)destination.use.apply(null, attachers[index]);
        destination.data($3BIJi(true, {}, namespace));
        return destination;
    }
    // Freeze: used to signal a processor that has finished configuration.
    //
    // For example, take unified itself: it’s frozen.
    // Plugins should not be added to it.
    // Rather, it should be extended, by invoking it, before modifying it.
    //
    // In essence, always invoke this when exporting a processor.
    function freeze() {
        var values;
        var transformer;
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            values = attachers[freezeIndex];
            if (values[1] === false) continue;
            if (values[1] === true) values[1] = undefined;
            transformer = values[0].apply(processor, values.slice(1));
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Infinity;
        return processor;
    }
    // Data management.
    // Getter / setter for processor-specific informtion.
    function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $344aada288b13f4a$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $344aada288b13f4a$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $344aada288b13f4a$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    // Plugin management.
    //
    // Pass it:
    // *   an attacher and options,
    // *   a preset,
    // *   a list of presets, attachers, and arguments (list of attachers and
    //     options).
    function use(value) {
        var settings;
        $344aada288b13f4a$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin.apply(null, arguments);
        else if (typeof value === "object") {
            if ("length" in value) addList(value);
            else addPreset(value);
        } else throw new Error("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = $3BIJi(namespace.settings || {}, settings);
        return processor;
        function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = $3BIJi(settings || {}, result.settings);
        }
        function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if ("length" in value) addPlugin.apply(null, value);
                else addPreset(value);
            } else throw new Error("Expected usable value, not `" + value + "`");
        }
        function addList(plugins) {
            var index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (typeof plugins === "object" && "length" in plugins) while(++index < plugins.length)add(plugins[index]);
            else throw new Error("Expected a list of plugins, not `" + plugins + "`");
        }
        function addPlugin(plugin, value) {
            var entry = find(plugin);
            if (entry) {
                if ($djWjq(entry[1]) && $djWjq(value)) value = $3BIJi(true, entry[1], value);
                entry[1] = value;
            } else attachers.push($344aada288b13f4a$var$slice.call(arguments));
        }
    }
    function find(plugin) {
        var index = -1;
        while(++index < attachers.length){
            if (attachers[index][0] === plugin) return attachers[index];
        }
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor.
    function parse(doc) {
        var file = $bsyhs(doc);
        var Parser;
        freeze();
        Parser = processor.Parser;
        $344aada288b13f4a$var$assertParser("parse", Parser);
        if ($344aada288b13f4a$var$newable(Parser, "parse")) return new Parser(String(file), file).parse();
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), async.
    function run(node, file, cb) {
        $344aada288b13f4a$var$assertNode(node);
        freeze();
        if (!cb && typeof file === "function") {
            cb = file;
            file = null;
        }
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            transformers.run(node, $bsyhs(file), done);
            function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else cb(null, tree, file);
            }
        }
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), sync.
    function runSync(node, file) {
        var result;
        var complete;
        run(node, file, done);
        $344aada288b13f4a$var$assertDone("runSync", "run", complete);
        return result;
        function done(error, tree) {
            complete = true;
            result = tree;
            $flvVI(error);
        }
    }
    // Stringify a unist node representation of a file (in string or vfile
    // representation) into a string using the `Compiler` on the processor.
    function stringify(node, doc) {
        var file = $bsyhs(doc);
        var Compiler;
        freeze();
        Compiler = processor.Compiler;
        $344aada288b13f4a$var$assertCompiler("stringify", Compiler);
        $344aada288b13f4a$var$assertNode(node);
        if ($344aada288b13f4a$var$newable(Compiler, "compile")) return new Compiler(node, file).compile();
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor, then run transforms on that node, and
    // compile the resulting node using the `Compiler` on the processor, and
    // store that result on the vfile.
    function process(doc, cb) {
        freeze();
        $344aada288b13f4a$var$assertParser("process", processor.Parser);
        $344aada288b13f4a$var$assertCompiler("process", processor.Compiler);
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            var file = $bsyhs(doc);
            $344aada288b13f4a$var$pipeline.run(processor, {
                file: file
            }, done);
            function done(error) {
                if (error) reject(error);
                else if (resolve) resolve(file);
                else cb(null, file);
            }
        }
    }
    // Process the given document (in string or vfile representation), sync.
    function processSync(doc) {
        var file;
        var complete;
        freeze();
        $344aada288b13f4a$var$assertParser("processSync", processor.Parser);
        $344aada288b13f4a$var$assertCompiler("processSync", processor.Compiler);
        file = $bsyhs(doc);
        process(file, done);
        $344aada288b13f4a$var$assertDone("processSync", "process", complete);
        return file;
        function done(error) {
            complete = true;
            $flvVI(error);
        }
    }
}
// Check if `value` is a constructor.
function $344aada288b13f4a$var$newable(value, name) {
    return typeof value === "function" && value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    ($344aada288b13f4a$var$keys(value.prototype) || name in value.prototype);
}
// Check if `value` is an object with keys.
function $344aada288b13f4a$var$keys(value) {
    var key;
    for(key in value)return true;
    return false;
}
// Assert a parser is available.
function $344aada288b13f4a$var$assertParser(name, Parser) {
    if (typeof Parser !== "function") throw new Error("Cannot `" + name + "` without `Parser`");
}
// Assert a compiler is available.
function $344aada288b13f4a$var$assertCompiler(name, Compiler) {
    if (typeof Compiler !== "function") throw new Error("Cannot `" + name + "` without `Compiler`");
}
// Assert the processor is not frozen.
function $344aada288b13f4a$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot invoke `" + name + "` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`.");
}
// Assert `node` is a unist node.
function $344aada288b13f4a$var$assertNode(node) {
    if (!node || typeof node.type !== "string") throw new Error("Expected node, got `" + node + "`");
}
// Assert that `complete` is `true`.
function $344aada288b13f4a$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}

});
parcelRegister("flvVI", function(module, exports) {
"use strict";
module.exports = $b2c195c98fc342f1$var$bail;
function $b2c195c98fc342f1$var$bail(err) {
    if (err) throw err;
}

});

parcelRegister("Wt5Sk", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};

});

parcelRegister("3BIJi", function(module, exports) {
"use strict";
var $2a07862fe96d60ca$var$hasOwn = Object.prototype.hasOwnProperty;
var $2a07862fe96d60ca$var$toStr = Object.prototype.toString;
var $2a07862fe96d60ca$var$defineProperty = Object.defineProperty;
var $2a07862fe96d60ca$var$gOPD = Object.getOwnPropertyDescriptor;
var $2a07862fe96d60ca$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $2a07862fe96d60ca$var$toStr.call(arr) === "[object Array]";
};
var $2a07862fe96d60ca$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $2a07862fe96d60ca$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $2a07862fe96d60ca$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $2a07862fe96d60ca$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $2a07862fe96d60ca$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $2a07862fe96d60ca$var$setProperty = function setProperty(target, options) {
    if ($2a07862fe96d60ca$var$defineProperty && options.name === "__proto__") $2a07862fe96d60ca$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $2a07862fe96d60ca$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$2a07862fe96d60ca$var$hasOwn.call(obj, name)) return void 0;
        else if ($2a07862fe96d60ca$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $2a07862fe96d60ca$var$gOPD(obj, name).value;
    }
    return obj[name];
};
module.exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $2a07862fe96d60ca$var$getProperty(target, name);
            copy = $2a07862fe96d60ca$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($2a07862fe96d60ca$var$isPlainObject(copy) || (copyIsArray = $2a07862fe96d60ca$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $2a07862fe96d60ca$var$isArray(src) ? src : [];
                    } else clone = src && $2a07862fe96d60ca$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $2a07862fe96d60ca$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $2a07862fe96d60ca$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};

});

parcelRegister("djWjq", function(module, exports) {
"use strict";
module.exports = (value)=>{
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};

});

parcelRegister("e1oqg", function(module, exports) {
"use strict";

var $1ydmx = parcelRequire("1ydmx");
module.exports = $a3541a83587eb408$var$trough;
$a3541a83587eb408$var$trough.wrap = $1ydmx;
var $a3541a83587eb408$var$slice = [].slice;
// Create new middleware.
function $a3541a83587eb408$var$trough() {
    var fns = [];
    var middleware = {};
    middleware.run = run;
    middleware.use = use;
    return middleware;
    // Run `fns`.  Last argument must be a completion handler.
    function run() {
        var index = -1;
        var input = $a3541a83587eb408$var$slice.call(arguments, 0, -1);
        var done = arguments[arguments.length - 1];
        if (typeof done !== "function") throw new Error("Expected function as last argument, not " + done);
        next.apply(null, [
            null
        ].concat(input));
        // Run the next `fn`, if any.
        function next(err) {
            var fn = fns[++index];
            var params = $a3541a83587eb408$var$slice.call(arguments, 0);
            var values = params.slice(1);
            var length = input.length;
            var pos = -1;
            if (err) {
                done(err);
                return;
            }
            // Copy non-nully input into values.
            while(++pos < length)if (values[pos] === null || values[pos] === undefined) values[pos] = input[pos];
            input = values;
            // Next or done.
            if (fn) $1ydmx(fn, next).apply(null, input);
            else done.apply(null, [
                null
            ].concat(input));
        }
    }
    // Add `fn` to the list.
    function use(fn) {
        if (typeof fn !== "function") throw new Error("Expected `fn` to be a function, not " + fn);
        fns.push(fn);
        return middleware;
    }
}

});
parcelRegister("1ydmx", function(module, exports) {
"use strict";
var $121354f466b0e59e$var$slice = [].slice;
module.exports = $121354f466b0e59e$var$wrap;
// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function $121354f466b0e59e$var$wrap(fn, callback) {
    var invoked;
    return wrapped;
    function wrapped() {
        var params = $121354f466b0e59e$var$slice.call(arguments, 0);
        var callback = fn.length > params.length;
        var result;
        if (callback) params.push(done);
        try {
            result = fn.apply(null, params);
        } catch (error) {
            // Well, this is quite the pickle.
            // `fn` received a callback and invoked it (thus continuing the pipeline),
            // but later also threw an error.
            // We’re not about to restart the pipeline again, so the only thing left
            // to do is to throw the thing instead.
            if (callback && invoked) throw error;
            return done(error);
        }
        if (!callback) {
            if (result && typeof result.then === "function") result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    // Invoke `next`, only once.
    function done() {
        if (!invoked) {
            invoked = true;
            callback.apply(null, arguments);
        }
    }
    // Invoke `done` with one value.
    // Tracks if an error is passed, too.
    function then(value) {
        done(null, value);
    }
}

});


parcelRegister("bsyhs", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lxTn2"));

});
parcelRegister("lxTn2", function(module, exports) {
"use strict";

var $ixGEn = parcelRequire("ixGEn");

var $gTpAy = parcelRequire("gTpAy");
module.exports = $gTpAy;
$gTpAy.prototype.message = $faf7a17e149609ff$var$message;
$gTpAy.prototype.info = $faf7a17e149609ff$var$info;
$gTpAy.prototype.fail = $faf7a17e149609ff$var$fail;
// Create a message with `reason` at `position`.
// When an error is passed in as `reason`, copies the stack.
function $faf7a17e149609ff$var$message(reason, position, origin) {
    var message = new $ixGEn(reason, position, origin);
    if (this.path) {
        message.name = this.path + ":" + message.name;
        message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
}
// Fail: creates a vmessage, associates it with the file, and throws it.
function $faf7a17e149609ff$var$fail() {
    var message = this.message.apply(this, arguments);
    message.fatal = true;
    throw message;
}
// Info: creates a vmessage, associates it with the file, and marks the fatality
// as null.
function $faf7a17e149609ff$var$info() {
    var message = this.message.apply(this, arguments);
    message.fatal = null;
    return message;
}

});
parcelRegister("ixGEn", function(module, exports) {
"use strict";

var $fQtvf = parcelRequire("fQtvf");
module.exports = $d7fc64844594b76b$var$VMessage;
// Inherit from `Error#`.
function $d7fc64844594b76b$var$VMessagePrototype() {}
$d7fc64844594b76b$var$VMessagePrototype.prototype = Error.prototype;
$d7fc64844594b76b$var$VMessage.prototype = new $d7fc64844594b76b$var$VMessagePrototype();
// Message properties.
var $d7fc64844594b76b$var$proto = $d7fc64844594b76b$var$VMessage.prototype;
$d7fc64844594b76b$var$proto.file = "";
$d7fc64844594b76b$var$proto.name = "";
$d7fc64844594b76b$var$proto.reason = "";
$d7fc64844594b76b$var$proto.message = "";
$d7fc64844594b76b$var$proto.stack = "";
$d7fc64844594b76b$var$proto.fatal = null;
$d7fc64844594b76b$var$proto.column = null;
$d7fc64844594b76b$var$proto.line = null;
// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function $d7fc64844594b76b$var$VMessage(reason, position, origin) {
    var parts;
    var range;
    var location;
    if (typeof position === "string") {
        origin = position;
        position = null;
    }
    parts = $d7fc64844594b76b$var$parseOrigin(origin);
    range = $fQtvf(position) || "1:1";
    location = {
        start: {
            line: null,
            column: null
        },
        end: {
            line: null,
            column: null
        }
    };
    // Node.
    if (position && position.position) position = position.position;
    if (position) {
        // Position.
        if (position.start) {
            location = position;
            position = position.start;
        } else // Point.
        location.start = position;
    }
    if (reason.stack) {
        this.stack = reason.stack;
        reason = reason.message;
    }
    this.message = reason;
    this.name = range;
    this.reason = reason;
    this.line = position ? position.line : null;
    this.column = position ? position.column : null;
    this.location = location;
    this.source = parts[0];
    this.ruleId = parts[1];
}
function $d7fc64844594b76b$var$parseOrigin(origin) {
    var result = [
        null,
        null
    ];
    var index;
    if (typeof origin === "string") {
        index = origin.indexOf(":");
        if (index === -1) result[1] = origin;
        else {
            result[0] = origin.slice(0, index);
            result[1] = origin.slice(index + 1);
        }
    }
    return result;
}

});
parcelRegister("fQtvf", function(module, exports) {
"use strict";
var $b89299013b57c39d$var$own = {}.hasOwnProperty;
module.exports = $b89299013b57c39d$var$stringify;
function $b89299013b57c39d$var$stringify(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ($b89299013b57c39d$var$own.call(value, "position") || $b89299013b57c39d$var$own.call(value, "type")) return $b89299013b57c39d$var$position(value.position);
    // Position.
    if ($b89299013b57c39d$var$own.call(value, "start") || $b89299013b57c39d$var$own.call(value, "end")) return $b89299013b57c39d$var$position(value);
    // Point.
    if ($b89299013b57c39d$var$own.call(value, "line") || $b89299013b57c39d$var$own.call(value, "column")) return $b89299013b57c39d$var$point(value);
    // ?
    return "";
}
function $b89299013b57c39d$var$point(point) {
    if (!point || typeof point !== "object") point = {};
    return $b89299013b57c39d$var$index(point.line) + ":" + $b89299013b57c39d$var$index(point.column);
}
function $b89299013b57c39d$var$position(pos) {
    if (!pos || typeof pos !== "object") pos = {};
    return $b89299013b57c39d$var$point(pos.start) + "-" + $b89299013b57c39d$var$point(pos.end);
}
function $b89299013b57c39d$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}

});


parcelRegister("gTpAy", function(module, exports) {
"use strict";

var $lTiTy = parcelRequire("lTiTy");

var $2qJZ2 = parcelRequire("2qJZ2");

var $Wt5Sk = parcelRequire("Wt5Sk");
module.exports = $c4c5a1beaa92482f$var$VFile;
var $c4c5a1beaa92482f$var$own = {}.hasOwnProperty;
// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
var $c4c5a1beaa92482f$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
$c4c5a1beaa92482f$var$VFile.prototype.toString = $c4c5a1beaa92482f$var$toString;
// Access full path (`~/index.min.js`).
Object.defineProperty($c4c5a1beaa92482f$var$VFile.prototype, "path", {
    get: $c4c5a1beaa92482f$var$getPath,
    set: $c4c5a1beaa92482f$var$setPath
});
// Access parent path (`~`).
Object.defineProperty($c4c5a1beaa92482f$var$VFile.prototype, "dirname", {
    get: $c4c5a1beaa92482f$var$getDirname,
    set: $c4c5a1beaa92482f$var$setDirname
});
// Access basename (`index.min.js`).
Object.defineProperty($c4c5a1beaa92482f$var$VFile.prototype, "basename", {
    get: $c4c5a1beaa92482f$var$getBasename,
    set: $c4c5a1beaa92482f$var$setBasename
});
// Access extname (`.js`).
Object.defineProperty($c4c5a1beaa92482f$var$VFile.prototype, "extname", {
    get: $c4c5a1beaa92482f$var$getExtname,
    set: $c4c5a1beaa92482f$var$setExtname
});
// Access stem (`index.min`).
Object.defineProperty($c4c5a1beaa92482f$var$VFile.prototype, "stem", {
    get: $c4c5a1beaa92482f$var$getStem,
    set: $c4c5a1beaa92482f$var$setStem
});
// Construct a new file.
function $c4c5a1beaa92482f$var$VFile(options) {
    var prop;
    var index;
    if (!options) options = {};
    else if (typeof options === "string" || $Wt5Sk(options)) options = {
        contents: options
    };
    else if ("message" in options && "messages" in options) return options;
    if (!(this instanceof $c4c5a1beaa92482f$var$VFile)) return new $c4c5a1beaa92482f$var$VFile(options);
    this.data = {};
    this.messages = [];
    this.history = [];
    this.cwd = $2qJZ2.cwd();
    // Set path related properties in the correct order.
    index = -1;
    while(++index < $c4c5a1beaa92482f$var$order.length){
        prop = $c4c5a1beaa92482f$var$order[index];
        if ($c4c5a1beaa92482f$var$own.call(options, prop)) this[prop] = options[prop];
    }
    // Set non-path related properties.
    for(prop in options)if ($c4c5a1beaa92482f$var$order.indexOf(prop) < 0) this[prop] = options[prop];
}
function $c4c5a1beaa92482f$var$getPath() {
    return this.history[this.history.length - 1];
}
function $c4c5a1beaa92482f$var$setPath(path) {
    $c4c5a1beaa92482f$var$assertNonEmpty(path, "path");
    if (this.path !== path) this.history.push(path);
}
function $c4c5a1beaa92482f$var$getDirname() {
    return typeof this.path === "string" ? $lTiTy.dirname(this.path) : undefined;
}
function $c4c5a1beaa92482f$var$setDirname(dirname) {
    $c4c5a1beaa92482f$var$assertPath(this.path, "dirname");
    this.path = $lTiTy.join(dirname || "", this.basename);
}
function $c4c5a1beaa92482f$var$getBasename() {
    return typeof this.path === "string" ? $lTiTy.basename(this.path) : undefined;
}
function $c4c5a1beaa92482f$var$setBasename(basename) {
    $c4c5a1beaa92482f$var$assertNonEmpty(basename, "basename");
    $c4c5a1beaa92482f$var$assertPart(basename, "basename");
    this.path = $lTiTy.join(this.dirname || "", basename);
}
function $c4c5a1beaa92482f$var$getExtname() {
    return typeof this.path === "string" ? $lTiTy.extname(this.path) : undefined;
}
function $c4c5a1beaa92482f$var$setExtname(extname) {
    $c4c5a1beaa92482f$var$assertPart(extname, "extname");
    $c4c5a1beaa92482f$var$assertPath(this.path, "extname");
    if (extname) {
        if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
        if (extname.indexOf(".", 1) > -1) throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = $lTiTy.join(this.dirname, this.stem + (extname || ""));
}
function $c4c5a1beaa92482f$var$getStem() {
    return typeof this.path === "string" ? $lTiTy.basename(this.path, this.extname) : undefined;
}
function $c4c5a1beaa92482f$var$setStem(stem) {
    $c4c5a1beaa92482f$var$assertNonEmpty(stem, "stem");
    $c4c5a1beaa92482f$var$assertPart(stem, "stem");
    this.path = $lTiTy.join(this.dirname || "", stem + (this.extname || ""));
}
// Get the value of the file.
function $c4c5a1beaa92482f$var$toString(encoding) {
    return (this.contents || "").toString(encoding);
}
// Assert that `part` is not a path (i.e., does not contain `p.sep`).
function $c4c5a1beaa92482f$var$assertPart(part, name) {
    if (part && part.indexOf($lTiTy.sep) > -1) throw new Error("`" + name + "` cannot be a path: did not expect `" + $lTiTy.sep + "`");
}
// Assert that `part` is not empty.
function $c4c5a1beaa92482f$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
// Assert `path` exists.
function $c4c5a1beaa92482f$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}

});
parcelRegister("lTiTy", function(module, exports) {

$parcel$export(module.exports, "basename", function () { return $fefd642f8649f47a$export$9bf319d8f74f51d1; }, function (v) { return $fefd642f8649f47a$export$9bf319d8f74f51d1 = v; });
$parcel$export(module.exports, "dirname", function () { return $fefd642f8649f47a$export$7f7b8152cc673abe; }, function (v) { return $fefd642f8649f47a$export$7f7b8152cc673abe = v; });
$parcel$export(module.exports, "extname", function () { return $fefd642f8649f47a$export$d0e86f3a75393fa3; }, function (v) { return $fefd642f8649f47a$export$d0e86f3a75393fa3 = v; });
$parcel$export(module.exports, "join", function () { return $fefd642f8649f47a$export$f7e2c8231c57a8bd; }, function (v) { return $fefd642f8649f47a$export$f7e2c8231c57a8bd = v; });
$parcel$export(module.exports, "sep", function () { return $fefd642f8649f47a$export$5aee1a5bd9743d8f; }, function (v) { return $fefd642f8649f47a$export$5aee1a5bd9743d8f = v; });
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $fefd642f8649f47a$export$9bf319d8f74f51d1;
var $fefd642f8649f47a$export$7f7b8152cc673abe;
var $fefd642f8649f47a$export$d0e86f3a75393fa3;
var $fefd642f8649f47a$export$f7e2c8231c57a8bd;
var $fefd642f8649f47a$export$5aee1a5bd9743d8f;
"use strict";
$fefd642f8649f47a$export$9bf319d8f74f51d1 = $fefd642f8649f47a$var$basename;
$fefd642f8649f47a$export$7f7b8152cc673abe = $fefd642f8649f47a$var$dirname;
$fefd642f8649f47a$export$d0e86f3a75393fa3 = $fefd642f8649f47a$var$extname;
$fefd642f8649f47a$export$f7e2c8231c57a8bd = $fefd642f8649f47a$var$join;
$fefd642f8649f47a$export$5aee1a5bd9743d8f = "/";
function $fefd642f8649f47a$var$basename(path, ext) {
    var start = 0;
    var end = -1;
    var index;
    var firstNonSlashEnd;
    var seenNonSlash;
    var extIndex;
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $fefd642f8649f47a$var$assertPath(path);
    index = path.length;
    if (ext === undefined || !ext.length || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    firstNonSlashEnd = -1;
    extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
function $fefd642f8649f47a$var$dirname(path) {
    var end;
    var unmatchedSlash;
    var index;
    $fefd642f8649f47a$var$assertPath(path);
    if (!path.length) return ".";
    end = -1;
    index = path.length;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
function $fefd642f8649f47a$var$extname(path) {
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    var preDotState = 0;
    var unmatchedSlash;
    var code;
    var index;
    $fefd642f8649f47a$var$assertPath(path);
    index = path.length;
    while(index--){
        code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
function $fefd642f8649f47a$var$join() {
    var index = -1;
    var joined;
    while(++index < arguments.length){
        $fefd642f8649f47a$var$assertPath(arguments[index]);
        if (arguments[index]) joined = joined === undefined ? arguments[index] : joined + "/" + arguments[index];
    }
    return joined === undefined ? "." : $fefd642f8649f47a$var$normalize(joined);
}
// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $fefd642f8649f47a$var$normalize(path) {
    var absolute;
    var value;
    $fefd642f8649f47a$var$assertPath(path);
    absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    value = $fefd642f8649f47a$var$normalizeString(path, !absolute);
    if (!value.length && !absolute) value = ".";
    if (value.length && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
// Resolve `.` and `..` elements in a path with directory names.
function $fefd642f8649f47a$var$normalizeString(path, allowAboveRoot) {
    var result = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var index = -1;
    var code;
    var lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        /* istanbul ignore else - No clue how to cover it. */ if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
function $fefd642f8649f47a$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}

});

parcelRegister("2qJZ2", function(module, exports) {

$parcel$export(module.exports, "cwd", function () { return $1c51add8544dece2$export$5f7bb87daeae59c1; }, function (v) { return $1c51add8544dece2$export$5f7bb87daeae59c1 = v; });
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
var $1c51add8544dece2$export$5f7bb87daeae59c1;
"use strict";
$1c51add8544dece2$export$5f7bb87daeae59c1 = $1c51add8544dece2$var$cwd;
function $1c51add8544dece2$var$cwd() {
    return "/";
}

});





parcelRegister("bK6CN", function(module, exports) {
"use strict";
module.exports = $88c9211f115d49d4$var$parse;

var $jdnWJ = parcelRequire("jdnWJ");
function $88c9211f115d49d4$var$parse(options) {
    var self = this;
    this.Parser = parse;
    function parse(doc) {
        return $jdnWJ(doc, Object.assign({}, self.data("settings"), options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data("micromarkExtensions") || [],
            mdastExtensions: self.data("fromMarkdownExtensions") || []
        }));
    }
}

});
parcelRegister("jdnWJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4UjLH"));

});
parcelRegister("4UjLH", function(module, exports) {
"use strict";
module.exports = $392bb9fab9df7560$var$fromMarkdown;

var $aEaBe = parcelRequire("aEaBe");

var $37cBN = parcelRequire("37cBN");

var $ffxyv = parcelRequire("ffxyv");

var $k6MDZ = parcelRequire("k6MDZ");

var $cQo6B = parcelRequire("cQo6B");

var $iAUDy = parcelRequire("iAUDy");

var $f7LfF = parcelRequire("f7LfF");

var $kmVDs = parcelRequire("kmVDs");

var $hKKfc = parcelRequire("hKKfc");

var $fQtvf = parcelRequire("fQtvf");
function $392bb9fab9df7560$var$fromMarkdown(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $392bb9fab9df7560$var$compiler(options)($kmVDs($iAUDy(options).document().write($f7LfF()(value, encoding, true))));
}
// Note this compiler only understand complete buffering, not streaming.
function $392bb9fab9df7560$var$compiler(options) {
    var settings = options || {};
    var config = $392bb9fab9df7560$var$configure({
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    }, settings.mdastExtensions || []);
    var data = {};
    return compile;
    function compile(events) {
        var tree = {
            type: "root",
            children: []
        };
        var stack = [
            tree
        ];
        var tokenStack = [];
        var listStack = [];
        var index = -1;
        var handler;
        var listStart;
        var context = {
            stack: stack,
            tokenStack: tokenStack,
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                listStart = listStack.pop(index);
                index = prepareList(events, listStart, index);
            }
        }
        index = -1;
        while(++index < events.length){
            handler = config[events[index][0]];
            if ($ffxyv.call(handler, events[index][1].type)) handler[events[index][1].type].call($37cBN({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        if (tokenStack.length) throw new Error("Cannot close document, a token (`" + tokenStack[tokenStack.length - 1].type + "`, " + $fQtvf({
            start: tokenStack[tokenStack.length - 1].start,
            end: tokenStack[tokenStack.length - 1].end
        }) + ") is still open");
        // Figure out `root` position.
        tree.position = {
            start: point(events.length ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: point(events.length ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    function prepareList(events, start, length) {
        var index = start - 1;
        var containerBalance = -1;
        var listSpread = false;
        var listItem;
        var tailIndex;
        var lineIndex;
        var tailEvent;
        var event;
        var firstBlankLineIndex;
        var atMarker;
        while(++index <= length){
            event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = point(lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: point(event[1].start)
                    };
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    function setData(key, value) {
        data[key] = value;
    }
    function getData(key) {
        return data[key];
    }
    function point(d) {
        return {
            line: d.line,
            column: d.column,
            offset: d.offset
        };
    }
    function opener(create, and) {
        return open;
        function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    function enter(node, token) {
        this.stack[this.stack.length - 1].children.push(node);
        this.stack.push(node);
        this.tokenStack.push(token);
        node.position = {
            start: point(token.start)
        };
        return node;
    }
    function closer(and) {
        return close;
        function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    function exit(token) {
        var node = this.stack.pop();
        var open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + $fQtvf({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open.type !== token.type) throw new Error("Cannot close `" + token.type + "` (" + $fQtvf({
            start: token.start,
            end: token.end
        }) + "): a different token (`" + open.type + "`, " + $fQtvf({
            start: open.start,
            end: open.end
        }) + ") is open");
        node.position.end = point(token.end);
        return node;
    }
    function resume() {
        return $aEaBe(this.stack.pop());
    }
    //
    // Handlers.
    //
    function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            this.stack[this.stack.length - 2].start = parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    function onexitcodefencedfenceinfo() {
        var data = this.resume();
        this.stack[this.stack.length - 1].lang = data;
    }
    function onexitcodefencedfencemeta() {
        var data = this.resume();
        this.stack[this.stack.length - 1].meta = data;
    }
    function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    function onexitcodefenced() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    function onexitcodeindented() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $k6MDZ(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitdefinitiontitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitdefinitiondestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitatxheadingsequence(token) {
        if (!this.stack[this.stack.length - 1].depth) this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).length;
    }
    function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    function onexitsetextheadinglinesequence(token) {
        this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    function onenterdata(token) {
        var siblings = this.stack[this.stack.length - 1].children;
        var tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: point(token.start)
            };
            this.stack[this.stack.length - 1].children.push(tail);
        }
        this.stack.push(tail);
    }
    function onexitdata(token) {
        var tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = point(token.end);
    }
    function onexitlineending(token) {
        var context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            context.children[context.children.length - 1].position.end = point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.indexOf(context.type) > -1) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    function onexithardbreak() {
        setData("atHardBreak", true);
    }
    function onexithtmlflow() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexithtmltext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitcodetext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitlink() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData("inReference")) {
            context.type += "Reference";
            context.referenceType = getData("referenceType") || "shortcut";
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData("referenceType");
    }
    function onexitimage() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData("inReference")) {
            context.type += "Reference";
            context.referenceType = getData("referenceType") || "shortcut";
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData("referenceType");
    }
    function onexitlabeltext(token) {
        this.stack[this.stack.length - 2].identifier = $k6MDZ(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitlabel() {
        var fragment = this.stack[this.stack.length - 1];
        var value = this.resume();
        this.stack[this.stack.length - 1].label = value;
        // Assume a reference.
        setData("inReference", true);
        if (this.stack[this.stack.length - 1].type === "link") this.stack[this.stack.length - 1].children = fragment.children;
        else this.stack[this.stack.length - 1].alt = value;
    }
    function onexitresourcedestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitresourcetitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitresource() {
        setData("inReference");
    }
    function onenterreference() {
        setData("referenceType", "collapsed");
    }
    function onexitreferencestring(token) {
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $k6MDZ(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    function onexitcharacterreferencevalue(token) {
        var data = this.sliceSerialize(token);
        var type = getData("characterReferenceType");
        var value;
        var tail;
        if (type) {
            value = $cQo6B(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else value = $hKKfc(data);
        tail = this.stack.pop();
        tail.value += value;
        tail.position.end = point(token.end);
    }
    function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = this.sliceSerialize(token);
    }
    function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    function heading() {
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    function hardBreak() {
        return {
            type: "break"
        };
    }
    function html() {
        return {
            type: "html",
            value: ""
        };
    }
    function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    function text() {
        return {
            type: "text",
            value: ""
        };
    }
    function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
function $392bb9fab9df7560$var$configure(config, extensions) {
    var index = -1;
    while(++index < extensions.length)$392bb9fab9df7560$var$extension(config, extensions[index]);
    return config;
}
function $392bb9fab9df7560$var$extension(config, extension) {
    var key;
    var left;
    for(key in extension){
        left = $ffxyv.call(config, key) ? config[key] : config[key] = {};
        if (key === "canContainEols" || key === "transforms") config[key] = [].concat(left, extension[key]);
        else Object.assign(left, extension[key]);
    }
}

});
parcelRegister("aEaBe", function(module, exports) {
"use strict";
module.exports = $7c05dca1f8f8b90f$var$toString;
// Get the text content of a node.
// Prefer the node’s plain-text fields, otherwise serialize its children,
// and if the given value is an array, serialize the nodes in it.
function $7c05dca1f8f8b90f$var$toString(node) {
    return node && (node.value || node.alt || node.title || "children" in node && $7c05dca1f8f8b90f$var$all(node.children) || "length" in node && $7c05dca1f8f8b90f$var$all(node)) || "";
}
function $7c05dca1f8f8b90f$var$all(values) {
    var result = [];
    var index = -1;
    while(++index < values.length)result[index] = $7c05dca1f8f8b90f$var$toString(values[index]);
    return result.join("");
}

});

parcelRegister("37cBN", function(module, exports) {
"use strict";
var $244bce53d23a3288$var$assign = Object.assign;
module.exports = $244bce53d23a3288$var$assign;

});

parcelRegister("ffxyv", function(module, exports) {
"use strict";
var $b1a2492dc6ebad8e$var$own = {}.hasOwnProperty;
module.exports = $b1a2492dc6ebad8e$var$own;

});

parcelRegister("k6MDZ", function(module, exports) {
"use strict";
function $ea3a19db581d28a6$var$normalizeIdentifier(value) {
    return value // Collapse Markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ") // Trim.
    .replace(/^ | $/g, "") // Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no object method is uppercase.
    .toLowerCase().toUpperCase();
}
module.exports = $ea3a19db581d28a6$var$normalizeIdentifier;

});

parcelRegister("cQo6B", function(module, exports) {
"use strict";

var $iaAMG = parcelRequire("iaAMG");
function $959d0a3b3afcb4a1$var$safeFromInt(value, base) {
    var code = parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of the basic block and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 || // Out of range
    code > 1114111) return "\uFFFD";
    return $iaAMG(code);
}
module.exports = $959d0a3b3afcb4a1$var$safeFromInt;

});
parcelRegister("iaAMG", function(module, exports) {
"use strict";
var $d3a5b1c46ac8904b$var$fromCharCode = String.fromCharCode;
module.exports = $d3a5b1c46ac8904b$var$fromCharCode;

});


parcelRegister("iAUDy", function(module, exports) {
"use strict";

var $hBIR9 = parcelRequire("hBIR9");

var $8Zcf1 = parcelRequire("8Zcf1");

var $3gHLf = parcelRequire("3gHLf");

var $7zJWl = parcelRequire("7zJWl");

var $jL26E = parcelRequire("jL26E");

var $i37N3 = parcelRequire("i37N3");

var $5EpjL = parcelRequire("5EpjL");

var $fgcfR = parcelRequire("fgcfR");
function $d89785b2e0910b71$var$parse(options) {
    var settings = options || {};
    var parser = {
        defined: [],
        constructs: $jL26E([
            $fgcfR
        ].concat($5EpjL(settings.extensions))),
        content: create($hBIR9),
        document: create($8Zcf1),
        flow: create($3gHLf),
        string: create($7zJWl.string),
        text: create($7zJWl.text)
    };
    return parser;
    function create(initializer) {
        return creator;
        function creator(from) {
            return $i37N3(parser, initializer, from);
        }
    }
}
module.exports = $d89785b2e0910b71$var$parse;

});
parcelRegister("hBIR9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bl5Ae = parcelRequire("bl5Ae");

var $10n72 = parcelRequire("10n72");
var $cd18afdfd7c33cab$var$tokenize = $cd18afdfd7c33cab$var$initializeContent;
function $cd18afdfd7c33cab$var$initializeContent(effects) {
    var contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    var previous;
    return contentStart;
    function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $10n72(effects, contentStart, "linePrefix");
    }
    function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    function lineStart(code) {
        var token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ($bl5Ae(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        } // Data.
        effects.consume(code);
        return data;
    }
}
module.exports.tokenize = $cd18afdfd7c33cab$var$tokenize;

});
parcelRegister("bl5Ae", function(module, exports) {
"use strict";
function $8415fca3c7e2efa3$var$markdownLineEnding(code) {
    return code < -2;
}
module.exports = $8415fca3c7e2efa3$var$markdownLineEnding;

});

parcelRegister("10n72", function(module, exports) {
"use strict";

var $5br2F = parcelRequire("5br2F");
function $0bb7b8360fcc21ae$var$spaceFactory(effects, ok, type, max) {
    var limit = max ? max - 1 : Infinity;
    var size = 0;
    return start;
    function start(code) {
        if ($5br2F(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    function prefix(code) {
        if ($5br2F(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}
module.exports = $0bb7b8360fcc21ae$var$spaceFactory;

});
parcelRegister("5br2F", function(module, exports) {
"use strict";
function $3c62f4d3140cd9e3$var$markdownSpace(code) {
    return code === -2 || code === -1 || code === 32;
}
module.exports = $3c62f4d3140cd9e3$var$markdownSpace;

});



parcelRegister("8Zcf1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bl5Ae = parcelRequire("bl5Ae");

var $10n72 = parcelRequire("10n72");

var $9em3z = parcelRequire("9em3z");
var $68ad841ab685197a$var$tokenize = $68ad841ab685197a$var$initializeDocument;
var $68ad841ab685197a$var$containerConstruct = {
    tokenize: $68ad841ab685197a$var$tokenizeContainer
};
var $68ad841ab685197a$var$lazyFlowConstruct = {
    tokenize: $68ad841ab685197a$var$tokenizeLazyFlow
};
function $68ad841ab685197a$var$initializeDocument(effects) {
    var self = this;
    var stack = [];
    var continued = 0;
    var inspectConstruct = {
        tokenize: tokenizeInspect,
        partial: true
    };
    var inspectResult;
    var childFlow;
    var childToken;
    return start;
    function start(code) {
        if (continued < stack.length) {
            self.containerState = stack[continued][1];
            return effects.attempt(stack[continued][0].continuation, documentContinue, documentContinued)(code);
        }
        return documentContinued(code);
    }
    function documentContinue(code) {
        continued++;
        return start(code);
    }
    function documentContinued(code) {
        // If we’re in a concrete construct (such as when expecting another line of
        // HTML, or we resulted in lazy content), we can immediately start flow.
        if (inspectResult && inspectResult.flowContinue) return flowStart(code);
        self.interrupt = childFlow && childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
        self.containerState = {};
        return effects.attempt($68ad841ab685197a$var$containerConstruct, containerContinue, flowStart)(code);
    }
    function containerContinue(code) {
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        self.containerState = undefined;
        return documentContinued(code);
    }
    function flowStart(code) {
        if (code === null) {
            exitContainers(0, true);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    function flowContinue(code) {
        if (code === null) {
            continueFlow(effects.exit("chunkFlow"));
            return flowStart(code);
        }
        if ($bl5Ae(code)) {
            effects.consume(code);
            continueFlow(effects.exit("chunkFlow"));
            return effects.check(inspectConstruct, documentAfterPeek);
        }
        effects.consume(code);
        return flowContinue;
    }
    function documentAfterPeek(code) {
        exitContainers(inspectResult.continued, inspectResult && inspectResult.flowEnd);
        continued = 0;
        return start(code);
    }
    function continueFlow(token) {
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.lazy = inspectResult && inspectResult.lazy;
        childFlow.defineSkip(token.start);
        childFlow.write(self.sliceStream(token));
    }
    function exitContainers(size, end) {
        var index = stack.length // Close the flow.
        ;
        if (childFlow && end) {
            childFlow.write([
                null
            ]);
            childToken = childFlow = undefined;
        } // Exit open containers.
        while(index-- > size){
            self.containerState = stack[index][1];
            stack[index][0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function tokenizeInspect(effects, ok) {
        var subcontinued = 0;
        inspectResult = {};
        return inspectStart;
        function inspectStart(code) {
            if (subcontinued < stack.length) {
                self.containerState = stack[subcontinued][1];
                return effects.attempt(stack[subcontinued][0].continuation, inspectContinue, inspectLess)(code);
            } // If we’re continued but in a concrete flow, we can’t have more
            // containers.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
                inspectResult.flowContinue = true;
                return inspectDone(code);
            }
            self.interrupt = childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
            self.containerState = {};
            return effects.attempt($68ad841ab685197a$var$containerConstruct, inspectFlowEnd, inspectDone)(code);
        }
        function inspectContinue(code) {
            subcontinued++;
            return self.containerState._closeFlow ? inspectFlowEnd(code) : inspectStart(code);
        }
        function inspectLess(code) {
            if (childFlow.currentConstruct && childFlow.currentConstruct.lazy) {
                // Maybe another container?
                self.containerState = {};
                return effects.attempt($68ad841ab685197a$var$containerConstruct, inspectFlowEnd, effects.attempt($68ad841ab685197a$var$lazyFlowConstruct, inspectFlowEnd, effects.check($9em3z, inspectFlowEnd, inspectLazy)))(code);
            } // Otherwise we’re interrupting.
            return inspectFlowEnd(code);
        }
        function inspectLazy(code) {
            // Act as if all containers are continued.
            subcontinued = stack.length;
            inspectResult.lazy = true;
            inspectResult.flowContinue = true;
            return inspectDone(code);
        } // We’re done with flow if we have more containers, or an interruption.
        function inspectFlowEnd(code) {
            inspectResult.flowEnd = true;
            return inspectDone(code);
        }
        function inspectDone(code) {
            inspectResult.continued = subcontinued;
            self.interrupt = self.containerState = undefined;
            return ok(code);
        }
    }
}
function $68ad841ab685197a$var$tokenizeContainer(effects, ok, nok) {
    return $10n72(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
}
function $68ad841ab685197a$var$tokenizeLazyFlow(effects, ok, nok) {
    return $10n72(effects, effects.lazy(this.parser.constructs.flow, ok, nok), "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
}
module.exports.tokenize = $68ad841ab685197a$var$tokenize;

});
parcelRegister("9em3z", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $10n72 = parcelRequire("10n72");
var $6b8687d77556d1c3$var$partialBlankLine = {
    tokenize: $6b8687d77556d1c3$var$tokenizePartialBlankLine,
    partial: true
};
function $6b8687d77556d1c3$var$tokenizePartialBlankLine(effects, ok, nok) {
    return $10n72(effects, afterWhitespace, "linePrefix");
    function afterWhitespace(code) {
        return code === null || $bl5Ae(code) ? ok(code) : nok(code);
    }
}
module.exports = $6b8687d77556d1c3$var$partialBlankLine;

});


parcelRegister("3gHLf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aCNuy = parcelRequire("aCNuy");

var $10n72 = parcelRequire("10n72");

var $9em3z = parcelRequire("9em3z");
var $2614cfc6acea6433$var$tokenize = $2614cfc6acea6433$var$initializeFlow;
function $2614cfc6acea6433$var$initializeFlow(effects) {
    var self = this;
    var initial = effects.attempt(// Try to parse a blank line.
    $9em3z, atBlankEnding, effects.attempt(this.parser.constructs.flowInitial, afterConstruct, $10n72(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt($aCNuy, afterConstruct)), "linePrefix")));
    return initial;
    function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}
module.exports.tokenize = $2614cfc6acea6433$var$tokenize;

});
parcelRegister("aCNuy", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $bUBdZ = parcelRequire("bUBdZ");

var $kzBoo = parcelRequire("kzBoo");

var $10n72 = parcelRequire("10n72");
// No name because it must not be turned off.
var $7bc3d80ea03d912e$var$content = {
    tokenize: $7bc3d80ea03d912e$var$tokenizeContent,
    resolve: $7bc3d80ea03d912e$var$resolveContent,
    interruptible: true,
    lazy: true
};
var $7bc3d80ea03d912e$var$continuationConstruct = {
    tokenize: $7bc3d80ea03d912e$var$tokenizeContinuation,
    partial: true
} // Content is transparent: it’s parsed right now. That way, definitions are also
;
// parsed right now: before text in paragraphs (specifically, media) are parsed.
function $7bc3d80ea03d912e$var$resolveContent(events) {
    $kzBoo(events);
    return events;
}
function $7bc3d80ea03d912e$var$tokenizeContent(effects, ok) {
    var previous;
    return start;
    function start(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return data(code);
    }
    function data(code) {
        if (code === null) return contentEnd(code);
        if ($bl5Ae(code)) return effects.check($7bc3d80ea03d912e$var$continuationConstruct, contentContinue, contentEnd)(code);
         // Data.
        effects.consume(code);
        return data;
    }
    function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous = previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        return data;
    }
}
function $7bc3d80ea03d912e$var$tokenizeContinuation(effects, ok, nok) {
    var self = this;
    return startLookahead;
    function startLookahead(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $10n72(effects, prefixed, "linePrefix");
    }
    function prefixed(code) {
        if (code === null || $bl5Ae(code)) return nok(code);
        if (self.parser.constructs.disable.null.indexOf("codeIndented") > -1 || $bUBdZ(self.events, "linePrefix") < 4) return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
        return ok(code);
    }
}
module.exports = $7bc3d80ea03d912e$var$content;

});
parcelRegister("bUBdZ", function(module, exports) {
"use strict";

var $5rIMu = parcelRequire("5rIMu");
function $8ac1ccb5a08e6c9e$var$prefixSize(events, type) {
    var tail = events[events.length - 1];
    if (!tail || tail[1].type !== type) return 0;
    return $5rIMu(tail[2].sliceStream(tail[1]));
}
module.exports = $8ac1ccb5a08e6c9e$var$prefixSize;

});
parcelRegister("5rIMu", function(module, exports) {
"use strict";
// Counts tabs based on their expanded size, and CR+LF as one character.
function $3f7235f71b6a2ad1$var$sizeChunks(chunks) {
    var index = -1;
    var size = 0;
    while(++index < chunks.length)size += typeof chunks[index] === "string" ? chunks[index].length : 1;
    return size;
}
module.exports = $3f7235f71b6a2ad1$var$sizeChunks;

});


parcelRegister("kzBoo", function(module, exports) {
"use strict";

var $37cBN = parcelRequire("37cBN");

var $9Q1oe = parcelRequire("9Q1oe");

var $1Gh3S = parcelRequire("1Gh3S");
function $efa414e392210bc3$var$subtokenize(events) {
    var jumps = {};
    var index = -1;
    var event;
    var lineIndex;
    var otherIndex;
    var otherEvent;
    var parameters;
    var subevents;
    var more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index] // Add a hook for the GFM tasklist extension, which needs to know if text
        ;
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1].isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        } // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                $37cBN(jumps, $efa414e392210bc3$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container || event[1]._movePreviousLineEndings) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = $1Gh3S(events[lineIndex][1].start) // Switch container exit w/ line endings.
                ;
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                $9Q1oe(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
function $efa414e392210bc3$var$subcontent(events, eventIndex) {
    var token = events[eventIndex][1];
    var context = events[eventIndex][2];
    var startPosition = eventIndex - 1;
    var startPositions = [];
    var tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    var childEvents = tokenizer.events;
    var jumps = [];
    var gaps = {};
    var stream;
    var previous;
    var index;
    var entered;
    var end;
    var adjust // Loop forward through the linked tokens to pass them in order to the
    ;
    // subtokenizer.
    while(token){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== token);
        startPositions.push(startPosition);
        if (!token._tokenizer) {
            stream = context.sliceStream(token);
            if (!token.next) stream.push(null);
            if (previous) tokenizer.defineSkip(token.start);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        } // Unravel the next token.
        previous = token;
        token = token.next;
    } // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    token = previous;
    index = childEvents.length;
    while(index--){
        // Make sure we’ve at least seen something (final eol is part of the last
        // token).
        if (childEvents[index][0] === "enter") entered = true;
        else if (// Find a void token that includes a break.
        entered && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
            add(childEvents.slice(index + 1, end));
            // Help GC.
            token._tokenizer = token.next = undefined;
            token = token.previous;
            end = index + 1;
        }
    }
    // Help GC.
    tokenizer.events = token._tokenizer = token.next = undefined // Do head:
    ;
    add(childEvents.slice(0, end));
    index = -1;
    adjust = 0;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
    function add(slice) {
        var start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        $9Q1oe(events, start, 2, slice);
    }
}
module.exports = $efa414e392210bc3$var$subtokenize;

});
parcelRegister("9Q1oe", function(module, exports) {
"use strict";

var $jpRg0 = parcelRequire("jpRg0");
// causes a stack overflow in V8 when trying to insert 100k items for instance.
function $729a0c6528f6e202$var$chunkedSplice(list, start, remove, items) {
    var end = list.length;
    var chunkStart = 0;
    var parameters // Make start between zero and `end` (included).
    ;
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0 // No need to chunk the items if there’s only a couple (10k) items.
    ;
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        $jpRg0.apply(list, parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) $jpRg0.apply(list, [
            start,
            remove
        ]) // Insert the items in chunks to not cause stack overflows.
        ;
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            $jpRg0.apply(list, parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
module.exports = $729a0c6528f6e202$var$chunkedSplice;

});
parcelRegister("jpRg0", function(module, exports) {
"use strict";
var $e229a9dcd185861d$var$splice = [].splice;
module.exports = $e229a9dcd185861d$var$splice;

});


parcelRegister("1Gh3S", function(module, exports) {
"use strict";

var $37cBN = parcelRequire("37cBN");
function $1396f2c03451bdda$var$shallow(object) {
    return $37cBN({}, object);
}
module.exports = $1396f2c03451bdda$var$shallow;

});




parcelRegister("7zJWl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $37cBN = parcelRequire("37cBN");

var $1Gh3S = parcelRequire("1Gh3S");
var $583f7005874c2006$var$text = $583f7005874c2006$var$initializeFactory("text");
var $583f7005874c2006$var$string = $583f7005874c2006$var$initializeFactory("string");
var $583f7005874c2006$var$resolver = {
    resolveAll: $583f7005874c2006$var$createResolver()
};
function $583f7005874c2006$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $583f7005874c2006$var$createResolver(field === "text" ? $583f7005874c2006$var$resolveAllLineSuffixes : undefined)
    };
    function initializeText(effects) {
        var self = this;
        var constructs = this.parser.constructs[field];
        var text = effects.attempt(constructs, start, notText);
        return start;
        function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            } // Data.
            effects.consume(code);
            return data;
        }
        function atBreak(code) {
            var list = constructs[code];
            var index = -1;
            if (code === null) return true;
            if (list) while(++index < list.length){
                if (!list[index].previous || list[index].previous.call(self, self.previous)) return true;
            }
        }
    }
}
function $583f7005874c2006$var$createResolver(extraResolver) {
    return resolveAllText;
    function resolveAllText(events, context) {
        var index = -1;
        var enter // A rather boring computation (to merge adjacent `data` events) which
        ;
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
} // A rather ugly set of instructions which again looks at chunks in the input
// stream.
// The reason to do this here is that it is *much* faster to parse in reverse.
// And that we can’t hook into `null` to split the line suffix before an EOF.
// To do: figure out if we can make this into a clean utility, or even in core.
// As it will be useful for GFMs literal autolink extension (and maybe even
// tables?)
function $583f7005874c2006$var$resolveAllLineSuffixes(events, context) {
    var eventIndex = -1;
    var chunks;
    var data;
    var chunk;
    var index;
    var bufferIndex;
    var size;
    var tabs;
    var token;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        data = events[eventIndex - 1][1];
        chunks = context.sliceStream(data);
        index = chunks.length;
        bufferIndex = -1;
        size = 0;
        tabs = undefined;
        while(index--){
            chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: $1Gh3S(data.end)
            };
            data.end = $1Gh3S(token.start);
            if (data.start.offset === data.end.offset) $37cBN(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}
module.exports.resolver = $583f7005874c2006$var$resolver;
module.exports.string = $583f7005874c2006$var$string;
module.exports.text = $583f7005874c2006$var$text;

});

parcelRegister("jL26E", function(module, exports) {
"use strict";

var $ffxyv = parcelRequire("ffxyv");

var $9Q1oe = parcelRequire("9Q1oe");

var $5EpjL = parcelRequire("5EpjL");
function $e6240a5d5b2dcf23$var$combineExtensions(extensions) {
    var all = {};
    var index = -1;
    while(++index < extensions.length)$e6240a5d5b2dcf23$var$extension(all, extensions[index]);
    return all;
}
function $e6240a5d5b2dcf23$var$extension(all, extension) {
    var hook;
    var left;
    var right;
    var code;
    for(hook in extension){
        left = $ffxyv.call(all, hook) ? all[hook] : all[hook] = {};
        right = extension[hook];
        for(code in right)left[code] = $e6240a5d5b2dcf23$var$constructs($5EpjL(right[code]), $ffxyv.call(left, code) ? left[code] : []);
    }
}
function $e6240a5d5b2dcf23$var$constructs(list, existing) {
    var index = -1;
    var before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    $9Q1oe(existing, 0, 0, before);
    return existing;
}
module.exports = $e6240a5d5b2dcf23$var$combineExtensions;

});
parcelRegister("5EpjL", function(module, exports) {
"use strict";
function $41d453c2d53c7900$var$miniflat(value) {
    return value === null || value === undefined ? [] : "length" in value ? value : [
        value
    ];
}
module.exports = $41d453c2d53c7900$var$miniflat;

});


parcelRegister("i37N3", function(module, exports) {
"use strict";

var $37cBN = parcelRequire("37cBN");

var $bl5Ae = parcelRequire("bl5Ae");

var $6jG9Y = parcelRequire("6jG9Y");

var $9Q1oe = parcelRequire("9Q1oe");

var $5EpjL = parcelRequire("5EpjL");

var $5ZU3u = parcelRequire("5ZU3u");

var $56FCn = parcelRequire("56FCn");

var $1Gh3S = parcelRequire("1Gh3S");

var $5Z1aC = parcelRequire("5Z1aC");
// Create a tokenizer.
// Tokenizers deal with one type of data (e.g., containers, flow, text).
// The parser is the object dealing with it all.
// `initialize` works like other constructs, except that only its `tokenize`
// function is used, in which case it doesn’t receive an `ok` or `nok`.
// `from` can be given to set the point before the first character, although
// when further lines are indented, they must be set with `defineSkip`.
function $d23e8ccdd317b177$var$createTokenizer(parser, initialize, from) {
    var point = from ? $1Gh3S(from) : {
        line: 1,
        column: 1,
        offset: 0
    };
    var columnStart = {};
    var resolveAllConstructs = [];
    var chunks = [];
    var stack = [];
    var effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        }),
        lazy: constructFactory(onsuccessfulcheck, {
            lazy: true
        })
    } // State and tools for resolving and serializing.
    ;
    var context = {
        previous: null,
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: skip,
        write: write
    } // The state function.
    ;
    var state = initialize.tokenize.call(context, effects) // Track which character we expect to be consumed, to catch bugs.
    ;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
     // Store where we are in the input stream.
    point._index = 0;
    point._bufferIndex = -1;
    return context;
    function write(slice) {
        chunks = $6jG9Y(chunks, slice);
        main() // Exit if we’re not done, resolve might change stuff.
        ;
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0) // Otherwise, resolve, and exit.
        ;
        context.events = $5ZU3u(resolveAllConstructs, context.events, context);
        return context.events;
    } //
    // Tools.
    //
    function sliceSerialize(token) {
        return $56FCn(sliceStream(token));
    }
    function sliceStream(token) {
        return $5Z1aC(chunks, token);
    }
    function now() {
        return $1Gh3S(point);
    }
    function skip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    } //
    // State management.
    //
    // Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
    // `consume`).
    // Here is where we walk through the chunks, which either include strings of
    // several characters, or numerical character codes.
    // The reason to do this in a loop instead of a call is so the stack can
    // drain.
    function main() {
        var chunkIndex;
        var chunk;
        while(point._index < chunks.length){
            chunk = chunks[point._index] // If we’re in a buffer chunk, loop through it.
            ;
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    } // Deal with one code.
    function go(code) {
        state = state(code);
    } // Move a character forward.
    function consume(code) {
        if ($bl5Ae(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        } // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++ // At end of string chunk.
            ;
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        } // Expose the previous character.
        context.previous = code // Mark as consumed.
        ;
    } // Start a token.
    function enter(type, fields) {
        var token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    } // Stop a token.
    function exit(type) {
        var token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    } // Use results.
    function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    } // Discard results.
    function onsuccessfulcheck(construct, info) {
        info.restore();
    } // Factory to attempt/check/interrupt.
    function constructFactory(onreturn, fields) {
        return hook // Handle either an object mapping codes to constructs, a list of
        ;
        // constructs, or a single construct.
        function hook(constructs, returnState, bogusState) {
            var listOfConstructs;
            var constructIndex;
            var currentConstruct;
            var info;
            return constructs.tokenize || "length" in constructs ? handleListOfConstructs($5EpjL(constructs)) : handleMapOfConstructs;
            function handleMapOfConstructs(code) {
                if (code in constructs || null in constructs) return handleListOfConstructs(constructs.null ? /* c8 ignore next */ $5EpjL(constructs[code]).concat($5EpjL(constructs.null)) : constructs[code])(code);
                return bogusState(code);
            }
            function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                return handleConstruct(list[constructIndex]);
            }
            function handleConstruct(construct) {
                return start;
                function start(code) {
                    // To do: not nede to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    if (construct.name && context.parser.constructs.disable.null.indexOf(construct.name) > -1) return nok();
                    return construct.tokenize.call(fields ? $37cBN({}, context, fields) : context, effects, ok, nok)(code);
                }
            }
            function ok(code) {
                onreturn(currentConstruct, info);
                return returnState;
            }
            function nok(code) {
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    function addResult(construct, from) {
        if (construct.resolveAll && resolveAllConstructs.indexOf(construct) < 0) resolveAllConstructs.push(construct);
        if (construct.resolve) $9Q1oe(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    function store() {
        var startPoint = now();
        var startPrevious = context.previous;
        var startCurrentConstruct = context.currentConstruct;
        var startEventsIndex = context.events.length;
        var startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
module.exports = $d23e8ccdd317b177$var$createTokenizer;

});
parcelRegister("6jG9Y", function(module, exports) {
"use strict";

var $9Q1oe = parcelRequire("9Q1oe");
function $49953878f965e6a4$var$chunkedPush(list, items) {
    if (list.length) {
        $9Q1oe(list, list.length, 0, items);
        return list;
    }
    return items;
}
module.exports = $49953878f965e6a4$var$chunkedPush;

});

parcelRegister("5ZU3u", function(module, exports) {
"use strict";
function $45de21ae342607c4$var$resolveAll(constructs, events, context) {
    var called = [];
    var index = -1;
    var resolve;
    while(++index < constructs.length){
        resolve = constructs[index].resolveAll;
        if (resolve && called.indexOf(resolve) < 0) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}
module.exports = $45de21ae342607c4$var$resolveAll;

});

parcelRegister("56FCn", function(module, exports) {
"use strict";

var $iaAMG = parcelRequire("iaAMG");
function $3b7dcbc2d450a56a$var$serializeChunks(chunks) {
    var index = -1;
    var result = [];
    var chunk;
    var value;
    var atTab;
    while(++index < chunks.length){
        chunk = chunks[index];
        if (typeof chunk === "string") value = chunk;
        else if (chunk === -5) value = "\r";
        else if (chunk === -4) value = "\n";
        else if (chunk === -3) value = "\r\n";
        else if (chunk === -2) value = "	";
        else if (chunk === -1) {
            if (atTab) continue;
            value = " ";
        } else // Currently only replacement character.
        value = $iaAMG(chunk);
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}
module.exports = $3b7dcbc2d450a56a$var$serializeChunks;

});

parcelRegister("5Z1aC", function(module, exports) {
"use strict";
function $45b38ea0e88b1150$var$sliceChunks(chunks, token) {
    var startIndex = token.start._index;
    var startBufferIndex = token.start._bufferIndex;
    var endIndex = token.end._index;
    var endBufferIndex = token.end._bufferIndex;
    var view;
    if (startIndex === endIndex) view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) view[0] = view[0].slice(startBufferIndex);
        if (endBufferIndex > 0) view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
module.exports = $45b38ea0e88b1150$var$sliceChunks;

});


parcelRegister("fgcfR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7zJWl = parcelRequire("7zJWl");

var $4M8lw = parcelRequire("4M8lw");

var $9j6SN = parcelRequire("9j6SN");

var $dbFbQ = parcelRequire("dbFbQ");

var $ivizM = parcelRequire("ivizM");

var $546s7 = parcelRequire("546s7");

var $7Tc0q = parcelRequire("7Tc0q");

var $gEZYG = parcelRequire("gEZYG");

var $cBoLz = parcelRequire("cBoLz");

var $49kdc = parcelRequire("49kdc");

var $4nvRC = parcelRequire("4nvRC");

var $j2t7S = parcelRequire("j2t7S");

var $hkodS = parcelRequire("hkodS");

var $5oF5S = parcelRequire("5oF5S");

var $9m5UN = parcelRequire("9m5UN");

var $7dco3 = parcelRequire("7dco3");

var $2fkxI = parcelRequire("2fkxI");

var $dkR72 = parcelRequire("dkR72");

var $hTP9P = parcelRequire("hTP9P");

var $1ncd9 = parcelRequire("1ncd9");

var $6JLsZ = parcelRequire("6JLsZ");
var $b1c1db36706ac8fd$var$document = {
    42: $hTP9P,
    // Asterisk
    43: $hTP9P,
    // Plus sign
    45: $hTP9P,
    // Dash
    48: $hTP9P,
    // 0
    49: $hTP9P,
    // 1
    50: $hTP9P,
    // 2
    51: $hTP9P,
    // 3
    52: $hTP9P,
    // 4
    53: $hTP9P,
    // 5
    54: $hTP9P,
    // 6
    55: $hTP9P,
    // 7
    56: $hTP9P,
    // 8
    57: $hTP9P,
    // 9
    62: $dbFbQ // Greater than
};
var $b1c1db36706ac8fd$var$contentInitial = {
    91: $49kdc // Left square bracket
};
var $b1c1db36706ac8fd$var$flowInitial = {
    "-2": $gEZYG,
    // Horizontal tab
    "-1": $gEZYG,
    // Virtual space
    32: $gEZYG // Space
};
var $b1c1db36706ac8fd$var$flow = {
    35: $j2t7S,
    // Number sign
    42: $6JLsZ,
    // Asterisk
    45: [
        $1ncd9,
        $6JLsZ
    ],
    // Dash
    60: $hkodS,
    // Less than
    61: $1ncd9,
    // Equals to
    95: $6JLsZ,
    // Underscore
    96: $7Tc0q,
    // Grave accent
    126: $7Tc0q // Tilde
};
var $b1c1db36706ac8fd$var$string = {
    38: $546s7,
    // Ampersand
    92: $ivizM // Backslash
};
var $b1c1db36706ac8fd$var$text = {
    "-5": $dkR72,
    // Carriage return
    "-4": $dkR72,
    // Line feed
    "-3": $dkR72,
    // Carriage return + line feed
    33: $7dco3,
    // Exclamation mark
    38: $546s7,
    // Ampersand
    42: $4M8lw,
    // Asterisk
    60: [
        $9j6SN,
        $5oF5S
    ],
    // Less than
    91: $2fkxI,
    // Left square bracket
    92: [
        $4nvRC,
        $ivizM
    ],
    // Backslash
    93: $9m5UN,
    // Right square bracket
    95: $4M8lw,
    // Underscore
    96: $cBoLz // Grave accent
};
var $b1c1db36706ac8fd$var$insideSpan = {
    null: [
        $4M8lw,
        $7zJWl.resolver
    ]
};
var $b1c1db36706ac8fd$var$disable = {
    null: []
};
module.exports.contentInitial = $b1c1db36706ac8fd$var$contentInitial;
module.exports.disable = $b1c1db36706ac8fd$var$disable;
module.exports.document = $b1c1db36706ac8fd$var$document;
module.exports.flow = $b1c1db36706ac8fd$var$flow;
module.exports.flowInitial = $b1c1db36706ac8fd$var$flowInitial;
module.exports.insideSpan = $b1c1db36706ac8fd$var$insideSpan;
module.exports.string = $b1c1db36706ac8fd$var$string;
module.exports.text = $b1c1db36706ac8fd$var$text;

});
parcelRegister("4M8lw", function(module, exports) {
"use strict";

var $6jG9Y = parcelRequire("6jG9Y");

var $9Q1oe = parcelRequire("9Q1oe");

var $372dT = parcelRequire("372dT");

var $ji9a7 = parcelRequire("ji9a7");

var $5ZU3u = parcelRequire("5ZU3u");

var $1Gh3S = parcelRequire("1Gh3S");
var $37a21e7e9322062d$var$attention = {
    name: "attention",
    tokenize: $37a21e7e9322062d$var$tokenizeAttention,
    resolveAll: $37a21e7e9322062d$var$resolveAllAttention
};
function $37a21e7e9322062d$var$resolveAllAttention(events, context) {
    var index = -1;
    var open;
    var group;
    var text;
    var openingSequence;
    var closingSequence;
    var use;
    var nextEvents;
    var offset // Walk through all events.
    ;
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index // Now walk back to find an opener.
        ;
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
             // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: $ji9a7($1Gh3S(events[open][1].end), -use),
                end: $1Gh3S(events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: $1Gh3S(events[index][1].start),
                end: $ji9a7($1Gh3S(events[index][1].start), use)
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: $1Gh3S(events[open][1].end),
                end: $1Gh3S(events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: $1Gh3S(openingSequence.start),
                end: $1Gh3S(closingSequence.end)
            };
            events[open][1].end = $1Gh3S(openingSequence.start);
            events[index][1].start = $1Gh3S(closingSequence.end);
            nextEvents = [] // If there are more markers in the opening, add them before.
            ;
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = $6jG9Y(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
             // Opening.
            nextEvents = $6jG9Y(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]) // Between.
            ;
            nextEvents = $6jG9Y(nextEvents, $5ZU3u(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context)) // Closing.
            ;
            nextEvents = $6jG9Y(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]) // If there are more markers in the closing, add them after.
            ;
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = $6jG9Y(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            $9Q1oe(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
     // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
function $37a21e7e9322062d$var$tokenizeAttention(effects, ok) {
    var before = $372dT(this.previous);
    var marker;
    return start;
    function start(code) {
        effects.enter("attentionSequence");
        marker = code;
        return sequence(code);
    }
    function sequence(code) {
        var token;
        var after;
        var open;
        var close;
        if (code === marker) {
            effects.consume(code);
            return sequence;
        }
        token = effects.exit("attentionSequence");
        after = $372dT(code);
        open = !after || after === 2 && before;
        close = !before || before === 2 && after;
        token._open = marker === 42 ? open : open && (before || !close);
        token._close = marker === 42 ? close : close && (after || !open);
        return ok(code);
    }
}
module.exports = $37a21e7e9322062d$var$attention;

});
parcelRegister("372dT", function(module, exports) {
"use strict";

var $5zMHo = parcelRequire("5zMHo");

var $eavH7 = parcelRequire("eavH7");

var $1mH0l = parcelRequire("1mH0l");
// Classify whether a character is unicode whitespace, unicode punctuation, or
// anything else.
// Used for attention (emphasis, strong), whose sequences can open or close
// based on the class of surrounding characters.
function $2443c00325c45520$var$classifyCharacter(code) {
    if (code === null || $5zMHo(code) || $1mH0l(code)) return 1;
    if ($eavH7(code)) return 2;
}
module.exports = $2443c00325c45520$var$classifyCharacter;

});
parcelRegister("5zMHo", function(module, exports) {
"use strict";
function $40f5ff3371a0baba$var$markdownLineEndingOrSpace(code) {
    return code < 0 || code === 32;
}
module.exports = $40f5ff3371a0baba$var$markdownLineEndingOrSpace;

});

parcelRegister("eavH7", function(module, exports) {
"use strict";

var $fwxdI = parcelRequire("fwxdI");

var $gx0ph = parcelRequire("gx0ph");
// In fact adds to the bundle size.
var $a50a95bb6596f49d$var$unicodePunctuation = $gx0ph($fwxdI);
module.exports = $a50a95bb6596f49d$var$unicodePunctuation;

});
parcelRegister("fwxdI", function(module, exports) {
"use strict";
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
var $b4d39d011099fe59$var$unicodePunctuation = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
module.exports = $b4d39d011099fe59$var$unicodePunctuation;

});

parcelRegister("gx0ph", function(module, exports) {
"use strict";

var $iaAMG = parcelRequire("iaAMG");
function $c0900b3390b0fde2$var$regexCheck(regex) {
    return check;
    function check(code) {
        return regex.test($iaAMG(code));
    }
}
module.exports = $c0900b3390b0fde2$var$regexCheck;

});


parcelRegister("1mH0l", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $0fe934530ac1d549$var$unicodeWhitespace = $gx0ph(/\s/);
module.exports = $0fe934530ac1d549$var$unicodeWhitespace;

});


parcelRegister("ji9a7", function(module, exports) {
"use strict";
// chunks (replacement characters, tabs, or line endings).
function $e0b6ce28e5c2ca8a$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
    return point;
}
module.exports = $e0b6ce28e5c2ca8a$var$movePoint;

});


parcelRegister("9j6SN", function(module, exports) {
"use strict";

var $gMacN = parcelRequire("gMacN");

var $ja7BD = parcelRequire("ja7BD");

var $aMtuc = parcelRequire("aMtuc");

var $glVfv = parcelRequire("glVfv");
var $6c6b3a2d2f203e72$var$autolink = {
    name: "autolink",
    tokenize: $6c6b3a2d2f203e72$var$tokenizeAutolink
};
function $6c6b3a2d2f203e72$var$tokenizeAutolink(effects, ok, nok) {
    var size = 1;
    return start;
    function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    function open(code) {
        if ($gMacN(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return $aMtuc(code) ? emailAtext(code) : nok(code);
    }
    function schemeOrEmailAtext(code) {
        return code === 43 || code === 45 || code === 46 || $ja7BD(code) ? schemeInsideOrEmailAtext(code) : emailAtext(code);
    }
    function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            return urlInside;
        }
        if ((code === 43 || code === 45 || code === 46 || $ja7BD(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        return emailAtext(code);
    }
    function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            return end(code);
        }
        if (code === 32 || code === 60 || $glVfv(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if ($aMtuc(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    function emailAtSignOrDot(code) {
        return $ja7BD(code) ? emailLabel(code) : nok(code);
    }
    function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            return end(code);
        }
        return emailValue(code);
    }
    function emailValue(code) {
        if ((code === 45 || $ja7BD(code)) && size++ < 63) {
            effects.consume(code);
            return code === 45 ? emailValue : emailLabel;
        }
        return nok(code);
    }
    function end(code) {
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.exit("autolink");
        return ok;
    }
}
module.exports = $6c6b3a2d2f203e72$var$autolink;

});
parcelRegister("gMacN", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $c3690b9a3abe7bd1$var$asciiAlpha = $gx0ph(/[A-Za-z]/);
module.exports = $c3690b9a3abe7bd1$var$asciiAlpha;

});

parcelRegister("ja7BD", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $df34d9e85411bbed$var$asciiAlphanumeric = $gx0ph(/[\dA-Za-z]/);
module.exports = $df34d9e85411bbed$var$asciiAlphanumeric;

});

parcelRegister("aMtuc", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $7d95426c886164e5$var$asciiAtext = $gx0ph(/[#-'*+\--9=?A-Z^-~]/);
module.exports = $7d95426c886164e5$var$asciiAtext;

});

parcelRegister("glVfv", function(module, exports) {
"use strict";
// Note: EOF is seen as ASCII control here, because `null < 32 == true`.
function $be7b0401cc55bc9f$var$asciiControl(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code < 32 || code === 127);
}
module.exports = $be7b0401cc55bc9f$var$asciiControl;

});


parcelRegister("dbFbQ", function(module, exports) {
"use strict";

var $5br2F = parcelRequire("5br2F");

var $10n72 = parcelRequire("10n72");
var $999c40ef1f48829d$var$blockQuote = {
    name: "blockQuote",
    tokenize: $999c40ef1f48829d$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $999c40ef1f48829d$var$tokenizeBlockQuoteContinuation
    },
    exit: $999c40ef1f48829d$var$exit
};
function $999c40ef1f48829d$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        if (code === 62) {
            if (!self.containerState.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                self.containerState.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    function after(code) {
        if ($5br2F(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
function $999c40ef1f48829d$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    return $10n72(effects, effects.attempt($999c40ef1f48829d$var$blockQuote, ok, nok), "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
}
function $999c40ef1f48829d$var$exit(effects) {
    effects.exit("blockQuote");
}
module.exports = $999c40ef1f48829d$var$blockQuote;

});

parcelRegister("ivizM", function(module, exports) {
"use strict";

var $8xApo = parcelRequire("8xApo");
var $d789880bd1227673$var$characterEscape = {
    name: "characterEscape",
    tokenize: $d789880bd1227673$var$tokenizeCharacterEscape
};
function $d789880bd1227673$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return open;
    }
    function open(code) {
        if ($8xApo(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}
module.exports = $d789880bd1227673$var$characterEscape;

});
parcelRegister("8xApo", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $637da5c63171a9af$var$asciiPunctuation = $gx0ph(/[!-/:-@[-`{-~]/);
module.exports = $637da5c63171a9af$var$asciiPunctuation;

});


parcelRegister("546s7", function(module, exports) {
"use strict";

var $hKKfc = parcelRequire("hKKfc");

var $ja7BD = parcelRequire("ja7BD");

var $kxhMS = parcelRequire("kxhMS");

var $avp72 = parcelRequire("avp72");
function $3b0254cb80f78831$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        default: e
    };
}
var $3b0254cb80f78831$var$decodeEntity__default = /*#__PURE__*/ $3b0254cb80f78831$var$_interopDefaultLegacy($hKKfc);
var $3b0254cb80f78831$var$characterReference = {
    name: "characterReference",
    tokenize: $3b0254cb80f78831$var$tokenizeCharacterReference
};
function $3b0254cb80f78831$var$tokenizeCharacterReference(effects, ok, nok) {
    var self = this;
    var size = 0;
    var max;
    var test;
    return start;
    function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = $ja7BD;
        return value(code);
    }
    function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = $avp72;
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = $kxhMS;
        return value(code);
    }
    function value(code) {
        var token;
        if (code === 59 && size) {
            token = effects.exit("characterReferenceValue");
            if (test === $ja7BD && !$3b0254cb80f78831$var$decodeEntity__default["default"](self.sliceSerialize(token))) return nok(code);
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}
module.exports = $3b0254cb80f78831$var$characterReference;

});
parcelRegister("hKKfc", function(module, exports) {
"use strict";
/* eslint-env browser */ var $ceca9aad1bf52f6f$var$el;
var $ceca9aad1bf52f6f$var$semicolon = 59 //  ';'
;
module.exports = $ceca9aad1bf52f6f$var$decodeEntity;
function $ceca9aad1bf52f6f$var$decodeEntity(characters) {
    var entity = "&" + characters + ";";
    var char;
    $ceca9aad1bf52f6f$var$el = $ceca9aad1bf52f6f$var$el || document.createElement("i");
    $ceca9aad1bf52f6f$var$el.innerHTML = entity;
    char = $ceca9aad1bf52f6f$var$el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === $ceca9aad1bf52f6f$var$semicolon && characters !== "semi") return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}

});

parcelRegister("kxhMS", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $ef34afe6845ea5a2$var$asciiDigit = $gx0ph(/\d/);
module.exports = $ef34afe6845ea5a2$var$asciiDigit;

});

parcelRegister("avp72", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $7a604771e2d8f62d$var$asciiHexDigit = $gx0ph(/[\dA-Fa-f]/);
module.exports = $7a604771e2d8f62d$var$asciiHexDigit;

});


parcelRegister("7Tc0q", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5zMHo = parcelRequire("5zMHo");

var $bUBdZ = parcelRequire("bUBdZ");

var $10n72 = parcelRequire("10n72");
var $5be6fb931dd02f83$var$codeFenced = {
    name: "codeFenced",
    tokenize: $5be6fb931dd02f83$var$tokenizeCodeFenced,
    concrete: true
};
function $5be6fb931dd02f83$var$tokenizeCodeFenced(effects, ok, nok) {
    var self = this;
    var closingFenceConstruct = {
        tokenize: tokenizeClosingFence,
        partial: true
    };
    var initialPrefix = $bUBdZ(this.events, "linePrefix");
    var sizeOpen = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        marker = code;
        return sequenceOpen(code);
    }
    function sequenceOpen(code) {
        if (code === marker) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeFencedFenceSequence");
        return sizeOpen < 3 ? nok(code) : $10n72(effects, infoOpen, "whitespace")(code);
    }
    function infoOpen(code) {
        if (code === null || $bl5Ae(code)) return openAfter(code);
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    function info(code) {
        if (code === null || $5zMHo(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return $10n72(effects, infoAfter, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    function infoAfter(code) {
        if (code === null || $bl5Ae(code)) return openAfter(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    function meta(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return openAfter(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    function openAfter(code) {
        effects.exit("codeFencedFence");
        return self.interrupt ? ok(code) : content(code);
    }
    function content(code) {
        if (code === null) return after(code);
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return effects.attempt(closingFenceConstruct, after, initialPrefix ? $10n72(effects, content, "linePrefix", initialPrefix + 1) : content);
        }
        effects.enter("codeFlowValue");
        return contentContinue(code);
    }
    function contentContinue(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("codeFlowValue");
            return content(code);
        }
        effects.consume(code);
        return contentContinue;
    }
    function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    function tokenizeClosingFence(effects, ok, nok) {
        var size = 0;
        return $10n72(effects, closingSequenceStart, "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
        function closingSequenceStart(code) {
            effects.enter("codeFencedFence");
            effects.enter("codeFencedFenceSequence");
            return closingSequence(code);
        }
        function closingSequence(code) {
            if (code === marker) {
                effects.consume(code);
                size++;
                return closingSequence;
            }
            if (size < sizeOpen) return nok(code);
            effects.exit("codeFencedFenceSequence");
            return $10n72(effects, closingSequenceEnd, "whitespace")(code);
        }
        function closingSequenceEnd(code) {
            if (code === null || $bl5Ae(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
module.exports = $5be6fb931dd02f83$var$codeFenced;

});

parcelRegister("gEZYG", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $9Q1oe = parcelRequire("9Q1oe");

var $bUBdZ = parcelRequire("bUBdZ");

var $10n72 = parcelRequire("10n72");
var $c2107547df49c8ad$var$codeIndented = {
    name: "codeIndented",
    tokenize: $c2107547df49c8ad$var$tokenizeCodeIndented,
    resolve: $c2107547df49c8ad$var$resolveCodeIndented
};
var $c2107547df49c8ad$var$indentedContentConstruct = {
    tokenize: $c2107547df49c8ad$var$tokenizeIndentedContent,
    partial: true
};
function $c2107547df49c8ad$var$resolveCodeIndented(events, context) {
    var code = {
        type: "codeIndented",
        start: events[0][1].start,
        end: events[events.length - 1][1].end
    };
    $9Q1oe(events, 0, 0, [
        [
            "enter",
            code,
            context
        ]
    ]);
    $9Q1oe(events, events.length, 0, [
        [
            "exit",
            code,
            context
        ]
    ]);
    return events;
}
function $c2107547df49c8ad$var$tokenizeCodeIndented(effects, ok, nok) {
    return effects.attempt($c2107547df49c8ad$var$indentedContentConstruct, afterPrefix, nok);
    function afterPrefix(code) {
        if (code === null) return ok(code);
        if ($bl5Ae(code)) return effects.attempt($c2107547df49c8ad$var$indentedContentConstruct, afterPrefix, ok)(code);
        effects.enter("codeFlowValue");
        return content(code);
    }
    function content(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("codeFlowValue");
            return afterPrefix(code);
        }
        effects.consume(code);
        return content;
    }
}
function $c2107547df49c8ad$var$tokenizeIndentedContent(effects, ok, nok) {
    var self = this;
    return $10n72(effects, afterPrefix, "linePrefix", 5);
    function afterPrefix(code) {
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return $10n72(effects, afterPrefix, "linePrefix", 5);
        }
        return $bUBdZ(self.events, "linePrefix") < 4 ? nok(code) : ok(code);
    }
}
module.exports = $c2107547df49c8ad$var$codeIndented;

});

parcelRegister("cBoLz", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");
var $92cc26cf44ecaea6$var$codeText = {
    name: "codeText",
    tokenize: $92cc26cf44ecaea6$var$tokenizeCodeText,
    resolve: $92cc26cf44ecaea6$var$resolveCodeText,
    previous: $92cc26cf44ecaea6$var$previous
};
function $92cc26cf44ecaea6$var$resolveCodeText(events) {
    var tailExitIndex = events.length - 4;
    var headEnterIndex = 3;
    var index;
    var enter // If we start and end with an EOL or a space.
    ;
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex // And we have data.
        ;
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[tailExitIndex][1].type = events[headEnterIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    } // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
function $92cc26cf44ecaea6$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function $92cc26cf44ecaea6$var$tokenizeCodeText(effects, ok, nok) {
    var sizeOpen = 0;
    var size;
    var token;
    return start;
    function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return openingSequence(code);
    }
    function openingSequence(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return openingSequence;
        }
        effects.exit("codeTextSequence");
        return gap(code);
    }
    function gap(code) {
        // EOF.
        if (code === null) return nok(code);
         // Closing fence?
        // Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return closingSequence(code);
        } // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return gap;
        }
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return gap;
        } // Data.
        effects.enter("codeTextData");
        return data(code);
    } // In code.
    function data(code) {
        if (code === null || code === 32 || code === 96 || $bl5Ae(code)) {
            effects.exit("codeTextData");
            return gap(code);
        }
        effects.consume(code);
        return data;
    } // Closing fence.
    function closingSequence(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return closingSequence;
        } // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        } // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}
module.exports = $92cc26cf44ecaea6$var$codeText;

});

parcelRegister("49kdc", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5zMHo = parcelRequire("5zMHo");

var $k6MDZ = parcelRequire("k6MDZ");

var $3QbhL = parcelRequire("3QbhL");

var $cp8tp = parcelRequire("cp8tp");

var $10n72 = parcelRequire("10n72");

var $l0Wff = parcelRequire("l0Wff");

var $gJHek = parcelRequire("gJHek");
var $3057ae5f411a85d3$var$definition = {
    name: "definition",
    tokenize: $3057ae5f411a85d3$var$tokenizeDefinition
};
var $3057ae5f411a85d3$var$titleConstruct = {
    tokenize: $3057ae5f411a85d3$var$tokenizeTitle,
    partial: true
};
function $3057ae5f411a85d3$var$tokenizeDefinition(effects, ok, nok) {
    var self = this;
    var identifier;
    return start;
    function start(code) {
        effects.enter("definition");
        return $cp8tp.call(self, effects, labelAfter, nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    function labelAfter(code) {
        identifier = $k6MDZ(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker") // Note: blank lines can’t exist in content.
            ;
            return $l0Wff(effects, $3QbhL(effects, effects.attempt($3057ae5f411a85d3$var$titleConstruct, $10n72(effects, after, "whitespace"), $10n72(effects, after, "whitespace")), nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString"));
        }
        return nok(code);
    }
    function after(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("definition");
            if (self.parser.defined.indexOf(identifier) < 0) self.parser.defined.push(identifier);
            return ok(code);
        }
        return nok(code);
    }
}
function $3057ae5f411a85d3$var$tokenizeTitle(effects, ok, nok) {
    return start;
    function start(code) {
        return $5zMHo(code) ? $l0Wff(effects, before)(code) : nok(code);
    }
    function before(code) {
        if (code === 34 || code === 39 || code === 40) return $gJHek(effects, $10n72(effects, after, "whitespace"), nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
        return nok(code);
    }
    function after(code) {
        return code === null || $bl5Ae(code) ? ok(code) : nok(code);
    }
}
module.exports = $3057ae5f411a85d3$var$definition;

});
parcelRegister("3QbhL", function(module, exports) {
"use strict";

var $glVfv = parcelRequire("glVfv");

var $5zMHo = parcelRequire("5zMHo");

var $bl5Ae = parcelRequire("bl5Ae");
// eslint-disable-next-line max-params
function $2cbefb80cf30fcdc$var$destinationFactory(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    var limit = max || Infinity;
    var balance = 0;
    return start;
    function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return destinationEnclosedBefore;
        }
        if ($glVfv(code) || code === 41) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return destinationRaw(code);
    }
    function destinationEnclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return destinationEnclosed(code);
    }
    function destinationEnclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return destinationEnclosedBefore(code);
        }
        if (code === null || code === 60 || $bl5Ae(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationEnclosedEscape : destinationEnclosed;
    }
    function destinationEnclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return destinationEnclosed;
        }
        return destinationEnclosed(code);
    }
    function destinationRaw(code) {
        if (code === 40) {
            if (++balance > limit) return nok(code);
            effects.consume(code);
            return destinationRaw;
        }
        if (code === 41) {
            if (!balance--) {
                effects.exit("chunkString");
                effects.exit(stringType);
                effects.exit(rawType);
                effects.exit(type);
                return ok(code);
            }
            effects.consume(code);
            return destinationRaw;
        }
        if (code === null || $5zMHo(code)) {
            if (balance) return nok(code);
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if ($glVfv(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationRawEscape : destinationRaw;
    }
    function destinationRawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return destinationRaw;
        }
        return destinationRaw(code);
    }
}
module.exports = $2cbefb80cf30fcdc$var$destinationFactory;

});

parcelRegister("cp8tp", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5br2F = parcelRequire("5br2F");
// eslint-disable-next-line max-params
function $907e647538d621c3$var$labelFactory(effects, ok, nok, type, markerType, stringType) {
    var self = this;
    var size = 0;
    var data;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    function atBreak(code) {
        if (code === null || code === 91 || code === 93 && !data || /* c8 ignore next */ code === 94 && /* c8 ignore next */ !size && /* c8 ignore next */ "_hiddenFootnoteSupport" in self.parser.constructs || size > 999) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return label(code);
    }
    function label(code) {
        if (code === null || code === 91 || code === 93 || $bl5Ae(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        data = data || !$5br2F(code);
        return code === 92 ? labelEscape : label;
    }
    function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return label;
        }
        return label(code);
    }
}
module.exports = $907e647538d621c3$var$labelFactory;

});

parcelRegister("l0Wff", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5br2F = parcelRequire("5br2F");

var $10n72 = parcelRequire("10n72");
function $f4c6c74a96b2f701$var$whitespaceFactory(effects, ok) {
    var seen;
    return start;
    function start(code) {
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ($5br2F(code)) return $10n72(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}
module.exports = $f4c6c74a96b2f701$var$whitespaceFactory;

});

parcelRegister("gJHek", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $10n72 = parcelRequire("10n72");
function $c2f261e348ca5972$var$titleFactory(effects, ok, nok, type, markerType, stringType) {
    var marker;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        marker = code === 40 ? 41 : code;
        return atFirstTitleBreak;
    }
    function atFirstTitleBreak(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atTitleBreak(code);
    }
    function atTitleBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return atFirstTitleBreak(marker);
        }
        if (code === null) return nok(code);
         // Note: blank lines can’t exist in content.
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return $10n72(effects, atTitleBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return title(code);
    }
    function title(code) {
        if (code === marker || code === null || $bl5Ae(code)) {
            effects.exit("chunkString");
            return atTitleBreak(code);
        }
        effects.consume(code);
        return code === 92 ? titleEscape : title;
    }
    function titleEscape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return title;
        }
        return title(code);
    }
}
module.exports = $c2f261e348ca5972$var$titleFactory;

});


parcelRegister("4nvRC", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");
var $330206e14bd3fe38$var$hardBreakEscape = {
    name: "hardBreakEscape",
    tokenize: $330206e14bd3fe38$var$tokenizeHardBreakEscape
};
function $330206e14bd3fe38$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("hardBreakEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        return open;
    }
    function open(code) {
        if ($bl5Ae(code)) {
            effects.exit("escapeMarker");
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $330206e14bd3fe38$var$hardBreakEscape;

});

parcelRegister("j2t7S", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5zMHo = parcelRequire("5zMHo");

var $5br2F = parcelRequire("5br2F");

var $9Q1oe = parcelRequire("9Q1oe");

var $10n72 = parcelRequire("10n72");
var $ddc4cc11b77cfe25$var$headingAtx = {
    name: "headingAtx",
    tokenize: $ddc4cc11b77cfe25$var$tokenizeHeadingAtx,
    resolve: $ddc4cc11b77cfe25$var$resolveHeadingAtx
};
function $ddc4cc11b77cfe25$var$resolveHeadingAtx(events, context) {
    var contentEnd = events.length - 2;
    var contentStart = 3;
    var content;
    var text // Prefix whitespace, part of the opening.
    ;
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
     // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        $9Q1oe(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
function $ddc4cc11b77cfe25$var$tokenizeHeadingAtx(effects, ok, nok) {
    var self = this;
    var size = 0;
    return start;
    function start(code) {
        effects.enter("atxHeading");
        effects.enter("atxHeadingSequence");
        return fenceOpenInside(code);
    }
    function fenceOpenInside(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return fenceOpenInside;
        }
        if (code === null || $5zMHo(code)) {
            effects.exit("atxHeadingSequence");
            return self.interrupt ? ok(code) : headingBreak(code);
        }
        return nok(code);
    }
    function headingBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequence(code);
        }
        if (code === null || $bl5Ae(code)) {
            effects.exit("atxHeading");
            return ok(code);
        }
        if ($5br2F(code)) return $10n72(effects, headingBreak, "whitespace")(code);
        effects.enter("atxHeadingText");
        return data(code);
    }
    function sequence(code) {
        if (code === 35) {
            effects.consume(code);
            return sequence;
        }
        effects.exit("atxHeadingSequence");
        return headingBreak(code);
    }
    function data(code) {
        if (code === null || code === 35 || $5zMHo(code)) {
            effects.exit("atxHeadingText");
            return headingBreak(code);
        }
        effects.consume(code);
        return data;
    }
}
module.exports = $ddc4cc11b77cfe25$var$headingAtx;

});

parcelRegister("hkodS", function(module, exports) {
"use strict";

var $gMacN = parcelRequire("gMacN");

var $ja7BD = parcelRequire("ja7BD");

var $bl5Ae = parcelRequire("bl5Ae");

var $5zMHo = parcelRequire("5zMHo");

var $5br2F = parcelRequire("5br2F");

var $iaAMG = parcelRequire("iaAMG");

var $aXmud = parcelRequire("aXmud");

var $gK7os = parcelRequire("gK7os");

var $9em3z = parcelRequire("9em3z");
var $c9d7181446c8a2d6$var$htmlFlow = {
    name: "htmlFlow",
    tokenize: $c9d7181446c8a2d6$var$tokenizeHtmlFlow,
    resolveTo: $c9d7181446c8a2d6$var$resolveToHtmlFlow,
    concrete: true
};
var $c9d7181446c8a2d6$var$nextBlankConstruct = {
    tokenize: $c9d7181446c8a2d6$var$tokenizeNextBlank,
    partial: true
};
function $c9d7181446c8a2d6$var$resolveToHtmlFlow(events) {
    var index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start // Add the prefix start to the HTML line token.
        ;
        events[index + 1][1].start = events[index - 2][1].start // Remove the line prefix.
        ;
        events.splice(index - 2, 2);
    }
    return events;
}
function $c9d7181446c8a2d6$var$tokenizeHtmlFlow(effects, ok, nok) {
    var self = this;
    var kind;
    var startTag;
    var buffer;
    var index;
    var marker;
    return start;
    function start(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationStart;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            kind = 3 // While we’re in an instruction instead of a declaration, we’re on a `?`
            ;
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        if ($gMacN(code)) {
            effects.consume(code);
            buffer = $iaAMG(code);
            startTag = true;
            return tagName;
        }
        return nok(code);
    }
    function declarationStart(code) {
        if (code === 45) {
            effects.consume(code);
            kind = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            kind = 5;
            buffer = "CDATA[";
            index = 0;
            return cdataOpenInside;
        }
        if ($gMacN(code)) {
            effects.consume(code);
            kind = 4;
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function cdataOpenInside(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? self.interrupt ? ok : continuation : cdataOpenInside;
        }
        return nok(code);
    }
    function tagCloseStart(code) {
        if ($gMacN(code)) {
            effects.consume(code);
            buffer = $iaAMG(code);
            return tagName;
        }
        return nok(code);
    }
    function tagName(code) {
        if (code === null || code === 47 || code === 62 || $5zMHo(code)) {
            if (code !== 47 && startTag && $gK7os.indexOf(buffer.toLowerCase()) > -1) {
                kind = 1;
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ($aXmud.indexOf(buffer.toLowerCase()) > -1) {
                kind = 6;
                if (code === 47) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                return self.interrupt ? ok(code) : continuation(code);
            }
            kind = 7 // Do not support complete HTML when interrupting.
            ;
            return self.interrupt ? nok(code) : startTag ? completeAttributeNameBefore(code) : completeClosingTagAfter(code);
        }
        if (code === 45 || $ja7BD(code)) {
            effects.consume(code);
            buffer += $iaAMG(code);
            return tagName;
        }
        return nok(code);
    }
    function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    function completeClosingTagAfter(code) {
        if ($5br2F(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        if (code === 58 || code === 95 || $gMacN(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    function completeAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $ja7BD(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return completeAttributeValueQuoted;
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        marker = undefined;
        return completeAttributeValueUnquoted(code);
    }
    function completeAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || $bl5Ae(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 62 || code === 96 || $5zMHo(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || $5br2F(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    function completeAfter(code) {
        if ($5br2F(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return code === null || $bl5Ae(code) ? continuation(code) : nok(code);
    }
    function continuation(code) {
        if (code === 45 && kind === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && kind === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && kind === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && kind === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && kind === 5) {
            effects.consume(code);
            return continuationCharacterDataInside;
        }
        if ($bl5Ae(code) && (kind === 6 || kind === 7)) return effects.check($c9d7181446c8a2d6$var$nextBlankConstruct, continuationClose, continuationAtLineEnding)(code);
        if (code === null || $bl5Ae(code)) return continuationAtLineEnding(code);
        effects.consume(code);
        return continuation;
    }
    function continuationAtLineEnding(code) {
        effects.exit("htmlFlowData");
        return htmlContinueStart(code);
    }
    function htmlContinueStart(code) {
        if (code === null) return done(code);
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return htmlContinueStart;
        }
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationRawEndTag(code) {
        if (code === 62 && $gK7os.indexOf(buffer.toLowerCase()) > -1) {
            effects.consume(code);
            return continuationClose;
        }
        if ($gMacN(code) && buffer.length < 8) {
            effects.consume(code);
            buffer += $iaAMG(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationCharacterDataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        return continuation(code);
    }
    function continuationClose(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("htmlFlowData");
            return done(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    function done(code) {
        effects.exit("htmlFlow");
        return ok(code);
    }
}
function $c9d7181446c8a2d6$var$tokenizeNextBlank(effects, ok, nok) {
    return start;
    function start(code) {
        effects.exit("htmlFlowData");
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        return effects.attempt($9em3z, ok, nok);
    }
}
module.exports = $c9d7181446c8a2d6$var$htmlFlow;

});
parcelRegister("aXmud", function(module, exports) {
"use strict";
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $7fa0db6510ed0c2b$var$basics = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "source",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
module.exports = $7fa0db6510ed0c2b$var$basics;

});

parcelRegister("gK7os", function(module, exports) {
"use strict";
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $c306ad6ba07cbb12$var$raws = [
    "pre",
    "script",
    "style",
    "textarea"
];
module.exports = $c306ad6ba07cbb12$var$raws;

});


parcelRegister("5oF5S", function(module, exports) {
"use strict";

var $gMacN = parcelRequire("gMacN");

var $ja7BD = parcelRequire("ja7BD");

var $bl5Ae = parcelRequire("bl5Ae");

var $5zMHo = parcelRequire("5zMHo");

var $5br2F = parcelRequire("5br2F");

var $10n72 = parcelRequire("10n72");
var $3edf11ff49cf25f9$var$htmlText = {
    name: "htmlText",
    tokenize: $3edf11ff49cf25f9$var$tokenizeHtmlText
};
function $3edf11ff49cf25f9$var$tokenizeHtmlText(effects, ok, nok) {
    var self = this;
    var marker;
    var buffer;
    var index;
    var returnState;
    return start;
    function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        if ($gMacN(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpen;
        }
        if (code === 91) {
            effects.consume(code);
            buffer = "CDATA[";
            index = 0;
            return cdataOpen;
        }
        if ($gMacN(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    function commentOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentStart;
        }
        return nok(code);
    }
    function commentStart(code) {
        if (code === null || code === 62) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentStartDash;
        }
        return comment(code);
    }
    function commentStartDash(code) {
        if (code === null || code === 62) return nok(code);
        return comment(code);
    }
    function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ($bl5Ae(code)) {
            returnState = comment;
            return atLineEnding(code);
        }
        effects.consume(code);
        return comment;
    }
    function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return end;
        }
        return comment(code);
    }
    function cdataOpen(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? cdata : cdataOpen;
        }
        return nok(code);
    }
    function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ($bl5Ae(code)) {
            returnState = cdata;
            return atLineEnding(code);
        }
        effects.consume(code);
        return cdata;
    }
    function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ($bl5Ae(code)) {
            returnState = declaration;
            return atLineEnding(code);
        }
        effects.consume(code);
        return declaration;
    }
    function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ($bl5Ae(code)) {
            returnState = instruction;
            return atLineEnding(code);
        }
        effects.consume(code);
        return instruction;
    }
    function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    function tagCloseStart(code) {
        if ($gMacN(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    function tagClose(code) {
        if (code === 45 || $ja7BD(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    function tagCloseBetween(code) {
        if ($bl5Ae(code)) {
            returnState = tagCloseBetween;
            return atLineEnding(code);
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    function tagOpen(code) {
        if (code === 45 || $ja7BD(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || $5zMHo(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        if (code === 58 || code === 95 || $gMacN(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ($bl5Ae(code)) {
            returnState = tagOpenBetween;
            return atLineEnding(code);
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    function tagOpenAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $ja7BD(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ($bl5Ae(code)) {
            returnState = tagOpenAttributeNameAfter;
            return atLineEnding(code);
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ($bl5Ae(code)) {
            returnState = tagOpenAttributeValueBefore;
            return atLineEnding(code);
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        marker = undefined;
        return tagOpenAttributeValueUnquoted;
    }
    function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ($bl5Ae(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return atLineEnding(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 62 || code === 47 || $5zMHo(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 62 || $5zMHo(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    } // We can’t have blank lines in content, so no need to worry about empty
    // tokens.
    function atLineEnding(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $10n72(effects, afterPrefix, "linePrefix", self.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
    }
    function afterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
    function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
}
module.exports = $3edf11ff49cf25f9$var$htmlText;

});

parcelRegister("9m5UN", function(module, exports) {
"use strict";

var $5zMHo = parcelRequire("5zMHo");

var $6jG9Y = parcelRequire("6jG9Y");

var $9Q1oe = parcelRequire("9Q1oe");

var $k6MDZ = parcelRequire("k6MDZ");

var $5ZU3u = parcelRequire("5ZU3u");

var $1Gh3S = parcelRequire("1Gh3S");

var $3QbhL = parcelRequire("3QbhL");

var $cp8tp = parcelRequire("cp8tp");

var $gJHek = parcelRequire("gJHek");

var $l0Wff = parcelRequire("l0Wff");
var $6cfac1bdb5c6ef63$var$labelEnd = {
    name: "labelEnd",
    tokenize: $6cfac1bdb5c6ef63$var$tokenizeLabelEnd,
    resolveTo: $6cfac1bdb5c6ef63$var$resolveToLabelEnd,
    resolveAll: $6cfac1bdb5c6ef63$var$resolveAllLabelEnd
};
var $6cfac1bdb5c6ef63$var$resourceConstruct = {
    tokenize: $6cfac1bdb5c6ef63$var$tokenizeResource
};
var $6cfac1bdb5c6ef63$var$fullReferenceConstruct = {
    tokenize: $6cfac1bdb5c6ef63$var$tokenizeFullReference
};
var $6cfac1bdb5c6ef63$var$collapsedReferenceConstruct = {
    tokenize: $6cfac1bdb5c6ef63$var$tokenizeCollapsedReference
};
function $6cfac1bdb5c6ef63$var$resolveAllLabelEnd(events) {
    var index = -1;
    var token;
    while(++index < events.length){
        token = events[index][1];
        if (!token._used && (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd")) {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
function $6cfac1bdb5c6ef63$var$resolveToLabelEnd(events, context) {
    var index = events.length;
    var offset = 0;
    var group;
    var label;
    var text;
    var token;
    var open;
    var close;
    var media // Find an opening.
    ;
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
             // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: $1Gh3S(events[open][1].start),
        end: $1Gh3S(events[events.length - 1][1].end)
    };
    label = {
        type: "label",
        start: $1Gh3S(events[open][1].start),
        end: $1Gh3S(events[close][1].end)
    };
    text = {
        type: "labelText",
        start: $1Gh3S(events[open + offset + 2][1].end),
        end: $1Gh3S(events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ] // Opening marker.
    ;
    media = $6jG9Y(media, events.slice(open + 1, open + offset + 3)) // Text open.
    ;
    media = $6jG9Y(media, [
        [
            "enter",
            text,
            context
        ]
    ]) // Between.
    ;
    media = $6jG9Y(media, $5ZU3u(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context)) // Text close, marker close, label close.
    ;
    media = $6jG9Y(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]) // Reference, resource, or so.
    ;
    media = $6jG9Y(media, events.slice(close + 1)) // Media close.
    ;
    media = $6jG9Y(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    $9Q1oe(events, open, events.length, media);
    return events;
}
function $6cfac1bdb5c6ef63$var$tokenizeLabelEnd(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var labelStart;
    var defined // Find an opening.
    ;
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    function start(code) {
        if (!labelStart) return nok(code);
         // It’s a balanced bracket, but contains a link.
        if (labelStart._inactive) return balanced(code);
        defined = self.parser.defined.indexOf($k6MDZ(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }))) > -1;
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return afterLabelEnd;
    }
    function afterLabelEnd(code) {
        // Resource: `[asd](fgh)`.
        if (code === 40) return effects.attempt($6cfac1bdb5c6ef63$var$resourceConstruct, ok, defined ? ok : balanced)(code);
         // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?
        if (code === 91) return effects.attempt($6cfac1bdb5c6ef63$var$fullReferenceConstruct, ok, defined ? effects.attempt($6cfac1bdb5c6ef63$var$collapsedReferenceConstruct, ok, balanced) : balanced)(code);
         // Shortcut reference: `[asd]`?
        return defined ? ok(code) : balanced(code);
    }
    function balanced(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
function $6cfac1bdb5c6ef63$var$tokenizeResource(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return $l0Wff(effects, open);
    }
    function open(code) {
        if (code === 41) return end(code);
        return $3QbhL(effects, destinationAfter, nok, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 3)(code);
    }
    function destinationAfter(code) {
        return $5zMHo(code) ? $l0Wff(effects, between)(code) : end(code);
    }
    function between(code) {
        if (code === 34 || code === 39 || code === 40) return $gJHek(effects, $l0Wff(effects, end), nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return end(code);
    }
    function end(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
function $6cfac1bdb5c6ef63$var$tokenizeFullReference(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        return $cp8tp.call(self, effects, afterLabel, nok, "reference", "referenceMarker", "referenceString")(code);
    }
    function afterLabel(code) {
        return self.parser.defined.indexOf($k6MDZ(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) < 0 ? nok(code) : ok(code);
    }
}
function $6cfac1bdb5c6ef63$var$tokenizeCollapsedReference(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return open;
    }
    function open(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}
module.exports = $6cfac1bdb5c6ef63$var$labelEnd;

});

parcelRegister("7dco3", function(module, exports) {
"use strict";

var $9m5UN = parcelRequire("9m5UN");
var $54035b17334f3e16$var$labelStartImage = {
    name: "labelStartImage",
    tokenize: $54035b17334f3e16$var$tokenizeLabelStartImage,
    resolveAll: $9m5UN.resolveAll
};
function $54035b17334f3e16$var$tokenizeLabelStartImage(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ "_hiddenFootnoteSupport" in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $54035b17334f3e16$var$labelStartImage;

});

parcelRegister("2fkxI", function(module, exports) {
"use strict";

var $9m5UN = parcelRequire("9m5UN");
var $1a2cead5cc13baa3$var$labelStartLink = {
    name: "labelStartLink",
    tokenize: $1a2cead5cc13baa3$var$tokenizeLabelStartLink,
    resolveAll: $9m5UN.resolveAll
};
function $1a2cead5cc13baa3$var$tokenizeLabelStartLink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ "_hiddenFootnoteSupport" in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $1a2cead5cc13baa3$var$labelStartLink;

});

parcelRegister("dkR72", function(module, exports) {
"use strict";

var $10n72 = parcelRequire("10n72");
var $9b5657ae6e2fc06a$var$lineEnding = {
    name: "lineEnding",
    tokenize: $9b5657ae6e2fc06a$var$tokenizeLineEnding
};
function $9b5657ae6e2fc06a$var$tokenizeLineEnding(effects, ok) {
    return start;
    function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $10n72(effects, ok, "linePrefix");
    }
}
module.exports = $9b5657ae6e2fc06a$var$lineEnding;

});

parcelRegister("hTP9P", function(module, exports) {
"use strict";

var $kxhMS = parcelRequire("kxhMS");

var $5br2F = parcelRequire("5br2F");

var $bUBdZ = parcelRequire("bUBdZ");

var $5rIMu = parcelRequire("5rIMu");

var $10n72 = parcelRequire("10n72");

var $9em3z = parcelRequire("9em3z");

var $6JLsZ = parcelRequire("6JLsZ");
var $035ce4274db96b0c$var$list = {
    name: "list",
    tokenize: $035ce4274db96b0c$var$tokenizeListStart,
    continuation: {
        tokenize: $035ce4274db96b0c$var$tokenizeListContinuation
    },
    exit: $035ce4274db96b0c$var$tokenizeListEnd
};
var $035ce4274db96b0c$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $035ce4274db96b0c$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
var $035ce4274db96b0c$var$indentConstruct = {
    tokenize: $035ce4274db96b0c$var$tokenizeIndent,
    partial: true
};
function $035ce4274db96b0c$var$tokenizeListStart(effects, ok, nok) {
    var self = this;
    var initialSize = $bUBdZ(self.events, "linePrefix");
    var size = 0;
    return start;
    function start(code) {
        var kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : $kxhMS(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check($6JLsZ, nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    function inside(code) {
        if ($kxhMS(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check($9em3z, self.interrupt ? nok : onBlank, effects.attempt($035ce4274db96b0c$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    function otherPrefix(code) {
        if ($5br2F(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    function endOfPrefix(code) {
        self.containerState.size = initialSize + $5rIMu(self.sliceStream(effects.exit("listItemPrefix")));
        return ok(code);
    }
}
function $035ce4274db96b0c$var$tokenizeListContinuation(effects, ok, nok) {
    var self = this;
    self.containerState._closeFlow = undefined;
    return effects.check($9em3z, onBlank, notBlank);
    function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine // We have a blank line.
        ;
        // Still, try to consume at most the items size.
        return $10n72(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    function notBlank(code) {
        if (self.containerState.furtherBlankLines || !$5br2F(code)) {
            self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
        return effects.attempt($035ce4274db96b0c$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true // As we’re closing flow, we’re no longer interrupting.
        ;
        self.interrupt = undefined;
        return $10n72(effects, effects.attempt($035ce4274db96b0c$var$list, ok, nok), "linePrefix", self.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4)(code);
    }
}
function $035ce4274db96b0c$var$tokenizeIndent(effects, ok, nok) {
    var self = this;
    return $10n72(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    function afterPrefix(code) {
        return $bUBdZ(self.events, "listItemIndent") === self.containerState.size ? ok(code) : nok(code);
    }
}
function $035ce4274db96b0c$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
function $035ce4274db96b0c$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    var self = this;
    return $10n72(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 5);
    function afterPrefix(code) {
        return $5br2F(code) || !$bUBdZ(self.events, "listItemPrefixWhitespace") ? nok(code) : ok(code);
    }
}
module.exports = $035ce4274db96b0c$var$list;

});
parcelRegister("6JLsZ", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5br2F = parcelRequire("5br2F");

var $10n72 = parcelRequire("10n72");
var $4e7bc3eab271186b$var$thematicBreak = {
    name: "thematicBreak",
    tokenize: $4e7bc3eab271186b$var$tokenizeThematicBreak
};
function $4e7bc3eab271186b$var$tokenizeThematicBreak(effects, ok, nok) {
    var size = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter("thematicBreak");
        marker = code;
        return atBreak(code);
    }
    function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if ($5br2F(code)) return $10n72(effects, atBreak, "whitespace")(code);
        if (size < 3 || code !== null && !$bl5Ae(code)) return nok(code);
        effects.exit("thematicBreak");
        return ok(code);
    }
    function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return atBreak(code);
    }
}
module.exports = $4e7bc3eab271186b$var$thematicBreak;

});


parcelRegister("1ncd9", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $1Gh3S = parcelRequire("1Gh3S");

var $10n72 = parcelRequire("10n72");
var $100169484653d90a$var$setextUnderline = {
    name: "setextUnderline",
    tokenize: $100169484653d90a$var$tokenizeSetextUnderline,
    resolveTo: $100169484653d90a$var$resolveToSetextUnderline
};
function $100169484653d90a$var$resolveToSetextUnderline(events, context) {
    var index = events.length;
    var content;
    var text;
    var definition;
    var heading // Find the opening of the content.
    ;
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    heading = {
        type: "setextHeading",
        start: $1Gh3S(events[text][1].start),
        end: $1Gh3S(events[events.length - 1][1].end)
    } // Change the paragraph to setext heading text.
    ;
    events[text][1].type = "setextHeadingText" // If we have definitions in the content, we’ll keep on having content,
    ;
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = $1Gh3S(events[definition][1].end);
    } else events[content][1] = heading;
     // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
function $100169484653d90a$var$tokenizeSetextUnderline(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var marker;
    var paragraph // Find an opening.
    ;
    while(index--)// Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
        paragraph = self.events[index][1].type === "paragraph";
        break;
    }
    return start;
    function start(code) {
        if (!self.lazy && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            effects.enter("setextHeadingLineSequence");
            marker = code;
            return closingSequence(code);
        }
        return nok(code);
    }
    function closingSequence(code) {
        if (code === marker) {
            effects.consume(code);
            return closingSequence;
        }
        effects.exit("setextHeadingLineSequence");
        return $10n72(effects, closingSequenceEnd, "lineSuffix")(code);
    }
    function closingSequenceEnd(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $100169484653d90a$var$setextUnderline;

});



parcelRegister("f7LfF", function(module, exports) {
"use strict";
var $b02c29acb33e7590$var$search = /[\0\t\n\r]/g;
function $b02c29acb33e7590$var$preprocess() {
    var start = true;
    var column = 1;
    var buffer = "";
    var atCarriageReturn;
    return preprocessor;
    function preprocessor(value, encoding, end) {
        var chunks = [];
        var match;
        var next;
        var startPosition;
        var endPosition;
        var code;
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $b02c29acb33e7590$var$search.lastIndex = startPosition;
            match = $b02c29acb33e7590$var$search.exec(value);
            endPosition = match ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                if (code === 0) {
                    chunks.push(65533);
                    column++;
                } else if (code === 9) {
                    next = Math.ceil(column / 4) * 4;
                    chunks.push(-2);
                    while(column++ < next)chunks.push(-1);
                } else if (code === 10) {
                    chunks.push(-4);
                    column = 1;
                } else {
                    atCarriageReturn = true;
                    column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}
module.exports = $b02c29acb33e7590$var$preprocess;

});

parcelRegister("kmVDs", function(module, exports) {
"use strict";

var $kzBoo = parcelRequire("kzBoo");
function $ed4291ec8b6df8c8$var$postprocess(events) {
    while(!$kzBoo(events));
    return events;
}
module.exports = $ed4291ec8b6df8c8$var$postprocess;

});




parcelRegister("4yBem", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $351737a4f5900595$var$ReactIs, $351737a4f5900595$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("3TnLK"))();

});
parcelRegister("3TnLK", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $e6VZV = parcelRequire("e6VZV");
function $2d58f23349affbc5$var$emptyFunction() {}
function $2d58f23349affbc5$var$emptyFunctionWithReset() {}
$2d58f23349affbc5$var$emptyFunctionWithReset.resetWarningCache = $2d58f23349affbc5$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $e6VZV) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $2d58f23349affbc5$var$emptyFunctionWithReset,
        resetWarningCache: $2d58f23349affbc5$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("e6VZV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $a45e9d61400164c5$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $a45e9d61400164c5$var$ReactPropTypesSecret;

});



parcelRegister("dYNzc", function(module, exports) {

var $k3YWX = parcelRequire("k3YWX");
function $a2d753de3e1149e5$var$addListMetadata() {
    return function(ast) {
        $k3YWX(ast, "list", function(listNode, parents) {
            var depth = 0, i, n;
            for(i = 0, n = parents.length; i < n; i++)if (parents[i].type === "list") depth += 1;
            for(i = 0, n = listNode.children.length; i < n; i++){
                var child = listNode.children[i];
                child.index = i;
                child.ordered = listNode.ordered;
            }
            listNode.depth = depth;
        });
        return ast;
    };
}
module.exports = $a2d753de3e1149e5$var$addListMetadata;

});
parcelRegister("k3YWX", function(module, exports) {
"use strict";
/* Expose. */ module.exports = $e9b35dd4951df554$var$visitParents;
/* Visit. */ function $e9b35dd4951df554$var$visitParents(tree, type, visitor) {
    var stack = [];
    if (typeof type === "function") {
        visitor = type;
        type = null;
    }
    one(tree);
    /* Visit a single node. */ function one(node) {
        var result;
        if (!type || node.type === type) result = visitor(node, stack.concat());
        if (node.children && result !== false) return all(node.children, node);
        return result;
    }
    /* Visit children in `parent`. */ function all(children, parent) {
        var length = children.length;
        var index = -1;
        var child;
        stack.push(parent);
        while(++index < length){
            child = children[index];
            if (child && one(child) === false) return false;
        }
        stack.pop();
        return true;
    }
}

});


parcelRegister("kidYf", function(module, exports) {
"use strict";

var $prIHh = parcelRequire("prIHh");
var $ec60536225a19932$var$type = "virtualHtml";
var $ec60536225a19932$var$selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
var $ec60536225a19932$var$simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;
module.exports = function(tree) {
    var open;
    var currentParent;
    $prIHh(tree, "html", function(node, index, parent) {
        if (currentParent !== parent) {
            open = [];
            currentParent = parent;
        }
        var selfClosing = $ec60536225a19932$var$getSelfClosing(node);
        if (selfClosing) {
            parent.children.splice(index, 1, {
                type: $ec60536225a19932$var$type,
                tag: selfClosing,
                position: node.position
            });
            return true;
        }
        var current = $ec60536225a19932$var$getSimpleTag(node, parent);
        if (!current) return true;
        var matching = $ec60536225a19932$var$findAndPull(open, current.tag);
        if (matching) parent.children.splice(index, 0, $ec60536225a19932$var$virtual(current, matching, parent));
        else if (!current.opening) open.push(current);
        return true;
    }, true // Iterate in reverse
    );
    return tree;
};
function $ec60536225a19932$var$findAndPull(open, matchingTag) {
    var i = open.length;
    while(i--){
        if (open[i].tag === matchingTag) return open.splice(i, 1)[0];
    }
    return false;
}
function $ec60536225a19932$var$getSimpleTag(node, parent) {
    var match = node.value.match($ec60536225a19932$var$simpleTagRe);
    return match ? {
        tag: match[2],
        opening: !match[1],
        node: node
    } : false;
}
function $ec60536225a19932$var$getSelfClosing(node) {
    var match = node.value.match($ec60536225a19932$var$selfClosingRe);
    return match ? match[1] : false;
}
function $ec60536225a19932$var$virtual(fromNode, toNode, parent) {
    var fromIndex = parent.children.indexOf(fromNode.node);
    var toIndex = parent.children.indexOf(toNode.node);
    var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
    var children = extracted.slice(1, -1);
    return {
        type: $ec60536225a19932$var$type,
        children: children,
        tag: fromNode.tag,
        position: {
            start: fromNode.node.position.start,
            end: toNode.node.position.end,
            indent: []
        }
    };
}

});
parcelRegister("prIHh", function(module, exports) {
"use strict";
module.exports = $04c7d6835fa8e392$var$visit;

var $9WECV = parcelRequire("9WECV");
var $04c7d6835fa8e392$var$CONTINUE = $9WECV.CONTINUE;
var $04c7d6835fa8e392$var$SKIP = $9WECV.SKIP;
var $04c7d6835fa8e392$var$EXIT = $9WECV.EXIT;
$04c7d6835fa8e392$var$visit.CONTINUE = $04c7d6835fa8e392$var$CONTINUE;
$04c7d6835fa8e392$var$visit.SKIP = $04c7d6835fa8e392$var$SKIP;
$04c7d6835fa8e392$var$visit.EXIT = $04c7d6835fa8e392$var$EXIT;
function $04c7d6835fa8e392$var$visit(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    $9WECV(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

});
parcelRegister("9WECV", function(module, exports) {
"use strict";
module.exports = $73d90b7f7f3a4777$var$visitParents;

var $bSiTt = parcelRequire("bSiTt");

var $8ZmB0 = parcelRequire("8ZmB0");
var $73d90b7f7f3a4777$var$CONTINUE = true;
var $73d90b7f7f3a4777$var$SKIP = "skip";
var $73d90b7f7f3a4777$var$EXIT = false;
$73d90b7f7f3a4777$var$visitParents.CONTINUE = $73d90b7f7f3a4777$var$CONTINUE;
$73d90b7f7f3a4777$var$visitParents.SKIP = $73d90b7f7f3a4777$var$SKIP;
$73d90b7f7f3a4777$var$visitParents.EXIT = $73d90b7f7f3a4777$var$EXIT;
function $73d90b7f7f3a4777$var$visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = $bSiTt(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === "object" && node !== null ? node : {};
        var name;
        if (typeof value.type === "string") {
            name = typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            visit.displayName = "node (" + $8ZmB0(value.type + (name ? "<" + name + ">" : "")) + ")";
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $73d90b7f7f3a4777$var$toResult(visitor(node, parents));
                if (result[0] === $73d90b7f7f3a4777$var$EXIT) return result;
            }
            if (node.children && result[0] !== $73d90b7f7f3a4777$var$SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $73d90b7f7f3a4777$var$EXIT) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function $73d90b7f7f3a4777$var$toResult(value) {
    if (value !== null && typeof value === "object" && "length" in value) return value;
    if (typeof value === "number") return [
        $73d90b7f7f3a4777$var$CONTINUE,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("bSiTt", function(module, exports) {
"use strict";
module.exports = $8a5364c0c5ee77df$var$convert;
function $8a5364c0c5ee77df$var$convert(test) {
    if (test == null) return $8a5364c0c5ee77df$var$ok;
    if (typeof test === "string") return $8a5364c0c5ee77df$var$typeFactory(test);
    if (typeof test === "object") return "length" in test ? $8a5364c0c5ee77df$var$anyFactory(test) : $8a5364c0c5ee77df$var$allFactory(test);
    if (typeof test === "function") return test;
    throw new Error("Expected function, string, or object as test");
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function $8a5364c0c5ee77df$var$allFactory(test) {
    return all;
    function all(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function $8a5364c0c5ee77df$var$anyFactory(tests) {
    var checks = [];
    var index = -1;
    while(++index < tests.length)checks[index] = $8a5364c0c5ee77df$var$convert(tests[index]);
    return any;
    function any() {
        var index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function $8a5364c0c5ee77df$var$typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function $8a5364c0c5ee77df$var$ok() {
    return true;
}

});

parcelRegister("8ZmB0", function(module, exports) {
module.exports = $68b58c5468c8bef0$var$identity;
function $68b58c5468c8bef0$var$identity(d) {
    return d;
}

});




parcelRegister("ahrfr", function(module, exports) {

$parcel$export(module.exports, "ofType", function () { return $77c0a0d2d9546f5a$export$5db8774c0df95fce; }, function (v) { return $77c0a0d2d9546f5a$export$5db8774c0df95fce = v; });
$parcel$export(module.exports, "ifNotMatch", function () { return $77c0a0d2d9546f5a$export$2062fb542207e794; }, function (v) { return $77c0a0d2d9546f5a$export$2062fb542207e794 = v; });
var $77c0a0d2d9546f5a$export$5db8774c0df95fce;
var $77c0a0d2d9546f5a$export$2062fb542207e794;
"use strict";

var $prIHh = parcelRequire("prIHh");
var $77c0a0d2d9546f5a$var$splice = [].splice;
$77c0a0d2d9546f5a$export$5db8774c0df95fce = function(types, mode) {
    return $77c0a0d2d9546f5a$var$ifNotMatch(allow, mode);
    function allow(node, index, parent) {
        return !types.includes(node.type);
    }
};
$77c0a0d2d9546f5a$export$2062fb542207e794 = $77c0a0d2d9546f5a$var$ifNotMatch;
function $77c0a0d2d9546f5a$var$ifNotMatch(allow, mode) {
    return transform;
    function transform(tree) {
        $prIHh(tree, filter);
        return tree;
    } // eslint-disable-next-line consistent-return
    function filter(node, index, parent) {
        if (parent && !allow(node, index, parent)) {
            var parameters = [
                index,
                1
            ];
            if (mode === "unwrap" && node.children) parameters = parameters.concat(node.children);
            $77c0a0d2d9546f5a$var$splice.apply(parent.children, parameters);
            return index;
        }
    }
}

});

parcelRegister("2owNN", function(module, exports) {
"use strict";

var $eeH7J = parcelRequire("eeH7J");

var $fv6YB = parcelRequire("fv6YB");

var $Pbw8Y = parcelRequire("Pbw8Y");
function $1be7447adf641cff$var$astToReact(node, options) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var renderer = options.renderers[node.type]; // Nodes created by plugins do not have positional info, in which case we set
    // an object that matches the positon interface.
    if (!node.position) node.position = {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    var pos = node.position.start;
    var key = [
        node.type,
        pos.line,
        pos.column,
        index
    ].join("-");
    if (!$Pbw8Y.isValidElementType(renderer)) throw new Error("Renderer for type `".concat(node.type, "` not defined or is not renderable"));
    var nodeProps = $1be7447adf641cff$var$getNodeProps(node, key, options, renderer, parent, index);
    return $eeH7J.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || undefined);
    function resolveChildren() {
        return node.children && node.children.map(function(childNode, i) {
            return $1be7447adf641cff$var$astToReact(childNode, options, {
                node: node,
                props: nodeProps
            }, i);
        });
    }
} // eslint-disable-next-line max-params, complexity
function $1be7447adf641cff$var$getNodeProps(node, key, opts, renderer, parent, index) {
    var props = {
        key: key
    };
    var isSimpleRenderer = typeof renderer === "string" || renderer === $eeH7J.Fragment; // `sourcePos` is true if the user wants source information (line/column info from markdown source)
    if (opts.sourcePos && node.position) props["data-sourcepos"] = $1be7447adf641cff$var$flattenPosition(node.position);
    if (opts.rawSourcePos && !isSimpleRenderer) props.sourcePosition = node.position;
     // If `includeNodeIndex` is true, pass node index info to all non-tag renderers
    if (opts.includeNodeIndex && parent.node && parent.node.children && !isSimpleRenderer) {
        props.index = parent.node.children.indexOf(node);
        props.parentChildCount = parent.node.children.length;
    }
    var ref = node.identifier !== null && node.identifier !== undefined ? /* istanbul ignore next - plugins could inject an undefined reference. */ opts.definitions[node.identifier.toUpperCase()] || {} : null;
    switch(node.type){
        case "root":
            $1be7447adf641cff$var$assignDefined(props, {
                className: opts.className
            });
            break;
        case "text":
            props.nodeKey = key;
            props.children = node.value;
            break;
        case "heading":
            props.level = node.depth;
            break;
        case "list":
            props.start = node.start;
            props.ordered = node.ordered;
            props.spread = node.spread;
            props.depth = node.depth;
            break;
        case "listItem":
            props.checked = node.checked;
            props.spread = node.spread;
            props.ordered = node.ordered;
            props.index = node.index;
            props.children = $1be7447adf641cff$var$getListItemChildren(node, parent).map(function(childNode, i) {
                return $1be7447adf641cff$var$astToReact(childNode, opts, {
                    node: node,
                    props: props
                }, i);
            });
            break;
        case "definition":
            $1be7447adf641cff$var$assignDefined(props, {
                identifier: node.identifier,
                title: node.title,
                url: node.url
            });
            break;
        case "code":
            $1be7447adf641cff$var$assignDefined(props, {
                language: node.lang && node.lang.split(/\s/, 1)[0]
            });
            break;
        case "inlineCode":
            props.children = node.value;
            props.inline = true;
            break;
        case "link":
            $1be7447adf641cff$var$assignDefined(props, {
                title: node.title || undefined,
                target: typeof opts.linkTarget === "function" ? opts.linkTarget(node.url, node.children, node.title) : opts.linkTarget,
                href: opts.transformLinkUri ? opts.transformLinkUri(node.url, node.children, node.title) : node.url
            });
            break;
        case "image":
            $1be7447adf641cff$var$assignDefined(props, {
                src: opts.transformImageUri ? opts.transformImageUri(node.url, node.children, node.title, node.alt) : node.url,
                alt: node.alt || "",
                title: node.title || undefined
            });
            break;
        case "linkReference":
            $1be7447adf641cff$var$assignDefined(props, $fv6YB(ref, {
                href: opts.transformLinkUri ? opts.transformLinkUri(ref.href) : ref.href
            }));
            break;
        case "imageReference":
            $1be7447adf641cff$var$assignDefined(props, {
                src: opts.transformImageUri && ref.href ? opts.transformImageUri(ref.href, node.children, ref.title, node.alt) : ref.href,
                alt: node.alt || "",
                title: ref.title || undefined
            });
            break;
        case "table":
        case "tableHead":
        case "tableBody":
            props.columnAlignment = node.align;
            break;
        case "tableRow":
            props.isHeader = parent.node.type === "tableHead";
            props.columnAlignment = parent.props.columnAlignment;
            break;
        case "tableCell":
            $1be7447adf641cff$var$assignDefined(props, {
                isHeader: parent.props.isHeader,
                align: parent.props.columnAlignment[index]
            });
            break;
        case "virtualHtml":
            props.tag = node.tag;
            break;
        case "html":
            // @todo find a better way than this
            props.isBlock = node.position.start.line !== node.position.end.line;
            props.allowDangerousHtml = opts.allowDangerousHtml;
            props.escapeHtml = opts.escapeHtml;
            props.skipHtml = opts.skipHtml;
            break;
        case "parsedHtml":
            var parsedChildren;
            if (node.children) parsedChildren = node.children.map(function(child, i) {
                return $1be7447adf641cff$var$astToReact(child, opts, {
                    node: node,
                    props: props
                }, i);
            });
            props.allowDangerousHtml = opts.allowDangerousHtml;
            props.escapeHtml = opts.escapeHtml;
            props.skipHtml = opts.skipHtml;
            props.element = node.element ? $1be7447adf641cff$var$mergeNodeChildren(node, parsedChildren) : null;
            break;
        default:
            $1be7447adf641cff$var$assignDefined(props, $fv6YB(node, {
                type: undefined,
                position: undefined,
                children: undefined
            }));
    }
    if (!isSimpleRenderer && node.value) props.value = node.value;
    if (!isSimpleRenderer) props.node = node;
    return props;
}
function $1be7447adf641cff$var$assignDefined(target, attrs) {
    for(var key in attrs)if (typeof attrs[key] !== "undefined") target[key] = attrs[key];
}
function $1be7447adf641cff$var$mergeNodeChildren(node, parsedChildren) {
    var el = node.element;
    if (Array.isArray(el)) {
        /* istanbul ignore next - `div` fallback for old React. */ var Fragment = $eeH7J.Fragment || "div";
        return $eeH7J.createElement(Fragment, null, el);
    }
    if (el.props.children || parsedChildren) {
        var children = $eeH7J.Children.toArray(el.props.children).concat(parsedChildren);
        return $eeH7J.cloneElement(el, null, children);
    }
    return $eeH7J.cloneElement(el, null);
}
function $1be7447adf641cff$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}
function $1be7447adf641cff$var$getListItemChildren(node, parent) {
    /* istanbul ignore next - list items are always in a list, but best to be sure. */ var loose = parent && parent.node ? $1be7447adf641cff$var$listLoose(parent.node) : $1be7447adf641cff$var$listItemLoose(node);
    return loose ? node.children : $1be7447adf641cff$var$unwrapParagraphs(node);
}
function $1be7447adf641cff$var$unwrapParagraphs(node) {
    return node.children.reduce(function(array, child) {
        return array.concat(child.type === "paragraph" ? child.children : [
            child
        ]);
    }, []);
}
function $1be7447adf641cff$var$listLoose(node) {
    var children = node.children;
    var loose = node.spread;
    var index = -1;
    while(!loose && ++index < children.length)loose = $1be7447adf641cff$var$listItemLoose(children[index]);
    return loose;
}
function $1be7447adf641cff$var$listItemLoose(node) {
    var spread = node.spread;
    /* istanbul ignore next - spread is present from remark-parse, but maybe plugins don’t set it. */ return spread === undefined || spread === null ? node.children.length > 1 : spread;
}
module.exports = $1be7447adf641cff$var$astToReact;

});
parcelRegister("Pbw8Y", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4mhCT"));

});
parcelRegister("4mhCT", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $32c6e3bbbd5b9a41$export$2b8d127b894957b9; }, function (v) { return $32c6e3bbbd5b9a41$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $32c6e3bbbd5b9a41$export$cea3a54a6425200c; }, function (v) { return $32c6e3bbbd5b9a41$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $32c6e3bbbd5b9a41$export$a7c73072b1a182ae; }, function (v) { return $32c6e3bbbd5b9a41$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $32c6e3bbbd5b9a41$export$9f27bc3417b4524d; }, function (v) { return $32c6e3bbbd5b9a41$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $32c6e3bbbd5b9a41$export$db77ccec0bb4ccac; }, function (v) { return $32c6e3bbbd5b9a41$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $32c6e3bbbd5b9a41$export$8392c0c9d3dcbd35; }, function (v) { return $32c6e3bbbd5b9a41$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $32c6e3bbbd5b9a41$export$ffb0004e005737fa; }, function (v) { return $32c6e3bbbd5b9a41$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $32c6e3bbbd5b9a41$export$b624eff549462981; }, function (v) { return $32c6e3bbbd5b9a41$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $32c6e3bbbd5b9a41$export$7897aa7841a5380c; }, function (v) { return $32c6e3bbbd5b9a41$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $32c6e3bbbd5b9a41$export$602eac185826482c; }, function (v) { return $32c6e3bbbd5b9a41$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $32c6e3bbbd5b9a41$export$e2c29f18771995cb; }, function (v) { return $32c6e3bbbd5b9a41$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $32c6e3bbbd5b9a41$export$5f8d39834fd61797; }, function (v) { return $32c6e3bbbd5b9a41$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $32c6e3bbbd5b9a41$export$74bf444e3cd11ea5; }, function (v) { return $32c6e3bbbd5b9a41$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $32c6e3bbbd5b9a41$export$92387174baf9b227; }, function (v) { return $32c6e3bbbd5b9a41$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $32c6e3bbbd5b9a41$export$ec112efeb987d9c6; }, function (v) { return $32c6e3bbbd5b9a41$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $32c6e3bbbd5b9a41$export$b706b080d889d2c9; }, function (v) { return $32c6e3bbbd5b9a41$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $32c6e3bbbd5b9a41$export$5be5a87408f70ddc; }, function (v) { return $32c6e3bbbd5b9a41$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $32c6e3bbbd5b9a41$export$45a5e7f76e0caa8d; }, function (v) { return $32c6e3bbbd5b9a41$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $32c6e3bbbd5b9a41$export$455c2e768291efa6; }, function (v) { return $32c6e3bbbd5b9a41$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $32c6e3bbbd5b9a41$export$9522e17588c12572; }, function (v) { return $32c6e3bbbd5b9a41$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $32c6e3bbbd5b9a41$export$2110ac352bb060b9; }, function (v) { return $32c6e3bbbd5b9a41$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $32c6e3bbbd5b9a41$export$56885ab8b9c456ab; }, function (v) { return $32c6e3bbbd5b9a41$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $32c6e3bbbd5b9a41$export$d927fcb6adf8f9de; }, function (v) { return $32c6e3bbbd5b9a41$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $32c6e3bbbd5b9a41$export$b82d16f27459e05a; }, function (v) { return $32c6e3bbbd5b9a41$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $32c6e3bbbd5b9a41$export$522c17b4f5e123e8; }, function (v) { return $32c6e3bbbd5b9a41$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $32c6e3bbbd5b9a41$export$1aabd8a0274ecfd6; }, function (v) { return $32c6e3bbbd5b9a41$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $32c6e3bbbd5b9a41$export$9b621391a187a31a; }, function (v) { return $32c6e3bbbd5b9a41$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $32c6e3bbbd5b9a41$export$f5bbd400c2f4426f; }, function (v) { return $32c6e3bbbd5b9a41$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $32c6e3bbbd5b9a41$export$2b8d127b894957b9;
var $32c6e3bbbd5b9a41$export$cea3a54a6425200c;
var $32c6e3bbbd5b9a41$export$a7c73072b1a182ae;
var $32c6e3bbbd5b9a41$export$9f27bc3417b4524d;
var $32c6e3bbbd5b9a41$export$db77ccec0bb4ccac;
var $32c6e3bbbd5b9a41$export$8392c0c9d3dcbd35;
var $32c6e3bbbd5b9a41$export$ffb0004e005737fa;
var $32c6e3bbbd5b9a41$export$b624eff549462981;
var $32c6e3bbbd5b9a41$export$7897aa7841a5380c;
var $32c6e3bbbd5b9a41$export$602eac185826482c;
var $32c6e3bbbd5b9a41$export$e2c29f18771995cb;
var $32c6e3bbbd5b9a41$export$5f8d39834fd61797;
var $32c6e3bbbd5b9a41$export$74bf444e3cd11ea5;
var $32c6e3bbbd5b9a41$export$92387174baf9b227;
var $32c6e3bbbd5b9a41$export$ec112efeb987d9c6;
var $32c6e3bbbd5b9a41$export$b706b080d889d2c9;
var $32c6e3bbbd5b9a41$export$5be5a87408f70ddc;
var $32c6e3bbbd5b9a41$export$45a5e7f76e0caa8d;
var $32c6e3bbbd5b9a41$export$455c2e768291efa6;
var $32c6e3bbbd5b9a41$export$9522e17588c12572;
var $32c6e3bbbd5b9a41$export$2110ac352bb060b9;
var $32c6e3bbbd5b9a41$export$56885ab8b9c456ab;
var $32c6e3bbbd5b9a41$export$d927fcb6adf8f9de;
var $32c6e3bbbd5b9a41$export$b82d16f27459e05a;
var $32c6e3bbbd5b9a41$export$522c17b4f5e123e8;
var $32c6e3bbbd5b9a41$export$1aabd8a0274ecfd6;
var $32c6e3bbbd5b9a41$export$9b621391a187a31a;
var $32c6e3bbbd5b9a41$export$f5bbd400c2f4426f;
"use strict";
var $32c6e3bbbd5b9a41$var$b = "function" === typeof Symbol && Symbol.for, $32c6e3bbbd5b9a41$var$c = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.element") : 60103, $32c6e3bbbd5b9a41$var$d = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.portal") : 60106, $32c6e3bbbd5b9a41$var$e = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.fragment") : 60107, $32c6e3bbbd5b9a41$var$f = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.strict_mode") : 60108, $32c6e3bbbd5b9a41$var$g = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.profiler") : 60114, $32c6e3bbbd5b9a41$var$h = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.provider") : 60109, $32c6e3bbbd5b9a41$var$k = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.context") : 60110, $32c6e3bbbd5b9a41$var$l = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.async_mode") : 60111, $32c6e3bbbd5b9a41$var$m = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.concurrent_mode") : 60111, $32c6e3bbbd5b9a41$var$n = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.forward_ref") : 60112, $32c6e3bbbd5b9a41$var$p = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.suspense") : 60113, $32c6e3bbbd5b9a41$var$q = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.suspense_list") : 60120, $32c6e3bbbd5b9a41$var$r = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.memo") : 60115, $32c6e3bbbd5b9a41$var$t = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.lazy") : 60116, $32c6e3bbbd5b9a41$var$v = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.block") : 60121, $32c6e3bbbd5b9a41$var$w = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.fundamental") : 60117, $32c6e3bbbd5b9a41$var$x = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.responder") : 60118, $32c6e3bbbd5b9a41$var$y = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.scope") : 60119;
function $32c6e3bbbd5b9a41$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $32c6e3bbbd5b9a41$var$c:
                switch(a = a.type, a){
                    case $32c6e3bbbd5b9a41$var$l:
                    case $32c6e3bbbd5b9a41$var$m:
                    case $32c6e3bbbd5b9a41$var$e:
                    case $32c6e3bbbd5b9a41$var$g:
                    case $32c6e3bbbd5b9a41$var$f:
                    case $32c6e3bbbd5b9a41$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $32c6e3bbbd5b9a41$var$k:
                            case $32c6e3bbbd5b9a41$var$n:
                            case $32c6e3bbbd5b9a41$var$t:
                            case $32c6e3bbbd5b9a41$var$r:
                            case $32c6e3bbbd5b9a41$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $32c6e3bbbd5b9a41$var$d:
                return u;
        }
    }
}
function $32c6e3bbbd5b9a41$var$A(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$m;
}
$32c6e3bbbd5b9a41$export$2b8d127b894957b9 = $32c6e3bbbd5b9a41$var$l;
$32c6e3bbbd5b9a41$export$cea3a54a6425200c = $32c6e3bbbd5b9a41$var$m;
$32c6e3bbbd5b9a41$export$a7c73072b1a182ae = $32c6e3bbbd5b9a41$var$k;
$32c6e3bbbd5b9a41$export$9f27bc3417b4524d = $32c6e3bbbd5b9a41$var$h;
$32c6e3bbbd5b9a41$export$db77ccec0bb4ccac = $32c6e3bbbd5b9a41$var$c;
$32c6e3bbbd5b9a41$export$8392c0c9d3dcbd35 = $32c6e3bbbd5b9a41$var$n;
$32c6e3bbbd5b9a41$export$ffb0004e005737fa = $32c6e3bbbd5b9a41$var$e;
$32c6e3bbbd5b9a41$export$b624eff549462981 = $32c6e3bbbd5b9a41$var$t;
$32c6e3bbbd5b9a41$export$7897aa7841a5380c = $32c6e3bbbd5b9a41$var$r;
$32c6e3bbbd5b9a41$export$602eac185826482c = $32c6e3bbbd5b9a41$var$d;
$32c6e3bbbd5b9a41$export$e2c29f18771995cb = $32c6e3bbbd5b9a41$var$g;
$32c6e3bbbd5b9a41$export$5f8d39834fd61797 = $32c6e3bbbd5b9a41$var$f;
$32c6e3bbbd5b9a41$export$74bf444e3cd11ea5 = $32c6e3bbbd5b9a41$var$p;
$32c6e3bbbd5b9a41$export$92387174baf9b227 = function(a) {
    return $32c6e3bbbd5b9a41$var$A(a) || $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$l;
};
$32c6e3bbbd5b9a41$export$ec112efeb987d9c6 = $32c6e3bbbd5b9a41$var$A;
$32c6e3bbbd5b9a41$export$b706b080d889d2c9 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$k;
};
$32c6e3bbbd5b9a41$export$5be5a87408f70ddc = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$h;
};
$32c6e3bbbd5b9a41$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $32c6e3bbbd5b9a41$var$c;
};
$32c6e3bbbd5b9a41$export$455c2e768291efa6 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$n;
};
$32c6e3bbbd5b9a41$export$9522e17588c12572 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$e;
};
$32c6e3bbbd5b9a41$export$2110ac352bb060b9 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$t;
};
$32c6e3bbbd5b9a41$export$56885ab8b9c456ab = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$r;
};
$32c6e3bbbd5b9a41$export$d927fcb6adf8f9de = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$d;
};
$32c6e3bbbd5b9a41$export$b82d16f27459e05a = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$g;
};
$32c6e3bbbd5b9a41$export$522c17b4f5e123e8 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$f;
};
$32c6e3bbbd5b9a41$export$1aabd8a0274ecfd6 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$p;
};
$32c6e3bbbd5b9a41$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $32c6e3bbbd5b9a41$var$e || a === $32c6e3bbbd5b9a41$var$m || a === $32c6e3bbbd5b9a41$var$g || a === $32c6e3bbbd5b9a41$var$f || a === $32c6e3bbbd5b9a41$var$p || a === $32c6e3bbbd5b9a41$var$q || "object" === typeof a && null !== a && (a.$$typeof === $32c6e3bbbd5b9a41$var$t || a.$$typeof === $32c6e3bbbd5b9a41$var$r || a.$$typeof === $32c6e3bbbd5b9a41$var$h || a.$$typeof === $32c6e3bbbd5b9a41$var$k || a.$$typeof === $32c6e3bbbd5b9a41$var$n || a.$$typeof === $32c6e3bbbd5b9a41$var$w || a.$$typeof === $32c6e3bbbd5b9a41$var$x || a.$$typeof === $32c6e3bbbd5b9a41$var$y || a.$$typeof === $32c6e3bbbd5b9a41$var$v);
};
$32c6e3bbbd5b9a41$export$f5bbd400c2f4426f = $32c6e3bbbd5b9a41$var$z;

});



parcelRegister("9sKTW", function(module, exports) {
"use strict";

var $prIHh = parcelRequire("prIHh");
module.exports = function(node) {
    $prIHh(node, "table", $6e3b1c371543f66e$var$wrap);
    return node;
};
function $6e3b1c371543f66e$var$wrap(table) {
    var children = table.children;
    table.children = [
        {
            type: "tableHead",
            align: table.align,
            children: [
                children[0]
            ],
            position: children[0].position
        }
    ];
    if (children.length > 1) table.children.push({
        type: "tableBody",
        align: table.align,
        children: children.slice(1),
        position: {
            start: children[1].position.start,
            end: children[children.length - 1].position.end
        }
    });
}

});

parcelRegister("6MxVG", function(module, exports) {
"use strict";

var $prIHh = parcelRequire("prIHh");
module.exports = function getDefinitions(tree) {
    var definitions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $prIHh(tree, "definition", function(node) {
        var identifier = node.identifier.toUpperCase();
        if (identifier in definitions) return;
        definitions[identifier] = {
            href: node.url,
            title: node.title
        };
    });
    return definitions;
};

});

parcelRegister("g3q3g", function(module, exports) {
"use strict";
var $bb01227df617c8df$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
module.exports = function uriTransformer(uri) {
    var url = (uri || "").trim();
    var first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    var colon = url.indexOf(":");
    if (colon === -1) return url;
    var length = $bb01227df617c8df$var$protocols.length;
    var index = -1;
    while(++index < length){
        var protocol = $bb01227df617c8df$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
     // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
};

});

parcelRegister("k6xnT", function(module, exports) {
/* eslint-disable react/prop-types, react/no-multi-comp */ "use strict";

var $fv6YB = parcelRequire("fv6YB");

var $eeH7J = parcelRequire("eeH7J");
/* istanbul ignore next - Don’t crash on old React. */ var $ea2e43a448bbe55e$var$supportsStringRender = parseInt(($eeH7J.version || "16").slice(0, 2), 10) >= 16;
var $ea2e43a448bbe55e$var$createElement = $eeH7J.createElement;
module.exports = {
    break: "br",
    paragraph: "p",
    emphasis: "em",
    strong: "strong",
    thematicBreak: "hr",
    blockquote: "blockquote",
    delete: "del",
    link: "a",
    image: "img",
    linkReference: "a",
    imageReference: "img",
    table: $ea2e43a448bbe55e$var$SimpleRenderer.bind(null, "table"),
    tableHead: $ea2e43a448bbe55e$var$SimpleRenderer.bind(null, "thead"),
    tableBody: $ea2e43a448bbe55e$var$SimpleRenderer.bind(null, "tbody"),
    tableRow: $ea2e43a448bbe55e$var$SimpleRenderer.bind(null, "tr"),
    tableCell: $ea2e43a448bbe55e$var$TableCell,
    root: $ea2e43a448bbe55e$var$Root,
    text: $ea2e43a448bbe55e$var$TextRenderer,
    list: $ea2e43a448bbe55e$var$List,
    listItem: $ea2e43a448bbe55e$var$ListItem,
    definition: $ea2e43a448bbe55e$var$NullRenderer,
    heading: $ea2e43a448bbe55e$var$Heading,
    inlineCode: $ea2e43a448bbe55e$var$InlineCode,
    code: $ea2e43a448bbe55e$var$CodeBlock,
    html: $ea2e43a448bbe55e$var$Html,
    virtualHtml: $ea2e43a448bbe55e$var$VirtualHtml,
    parsedHtml: $ea2e43a448bbe55e$var$ParsedHtml
};
function $ea2e43a448bbe55e$var$TextRenderer(props) {
    /* istanbul ignore next - a text node w/o a value could be injected by plugins */ var children = props.children || "";
    /* istanbul ignore next - `span` is a fallback for old React. */ return $ea2e43a448bbe55e$var$supportsStringRender ? children : $ea2e43a448bbe55e$var$createElement("span", null, children);
}
function $ea2e43a448bbe55e$var$Root(props) {
    var className = props.className;
    var root = !className && $eeH7J.Fragment || "div";
    return $ea2e43a448bbe55e$var$createElement(root, className ? {
        className: className
    } : null, props.children);
}
function $ea2e43a448bbe55e$var$SimpleRenderer(tag, props) {
    return $ea2e43a448bbe55e$var$createElement(tag, $ea2e43a448bbe55e$var$getCoreProps(props), props.children);
}
function $ea2e43a448bbe55e$var$TableCell(props) {
    var style = props.align ? {
        textAlign: props.align
    } : undefined;
    var coreProps = $ea2e43a448bbe55e$var$getCoreProps(props);
    return $ea2e43a448bbe55e$var$createElement(props.isHeader ? "th" : "td", style ? $fv6YB({
        style: style
    }, coreProps) : coreProps, props.children);
}
function $ea2e43a448bbe55e$var$Heading(props) {
    return $ea2e43a448bbe55e$var$createElement("h".concat(props.level), $ea2e43a448bbe55e$var$getCoreProps(props), props.children);
}
function $ea2e43a448bbe55e$var$List(props) {
    var attrs = $ea2e43a448bbe55e$var$getCoreProps(props);
    if (props.start !== null && props.start !== 1 && props.start !== undefined) attrs.start = props.start.toString();
    return $ea2e43a448bbe55e$var$createElement(props.ordered ? "ol" : "ul", attrs, props.children);
}
function $ea2e43a448bbe55e$var$ListItem(props) {
    var checkbox = null;
    if (props.checked !== null && props.checked !== undefined) {
        var checked = props.checked;
        checkbox = $ea2e43a448bbe55e$var$createElement("input", {
            type: "checkbox",
            checked: checked,
            readOnly: true
        });
    }
    return $ea2e43a448bbe55e$var$createElement("li", $ea2e43a448bbe55e$var$getCoreProps(props), checkbox, props.children);
}
function $ea2e43a448bbe55e$var$CodeBlock(props) {
    var className = props.language && "language-".concat(props.language);
    var code = $ea2e43a448bbe55e$var$createElement("code", className ? {
        className: className
    } : null, props.value);
    return $ea2e43a448bbe55e$var$createElement("pre", $ea2e43a448bbe55e$var$getCoreProps(props), code);
}
function $ea2e43a448bbe55e$var$InlineCode(props) {
    return $ea2e43a448bbe55e$var$createElement("code", $ea2e43a448bbe55e$var$getCoreProps(props), props.children);
}
function $ea2e43a448bbe55e$var$Html(props) {
    if (props.skipHtml) return null;
    var dangerous = props.allowDangerousHtml || props.escapeHtml === false;
    var tag = props.isBlock ? "div" : "span";
    if (!dangerous) /* istanbul ignore next - `tag` is a fallback for old React. */ return $ea2e43a448bbe55e$var$createElement($eeH7J.Fragment || tag, null, props.value);
    var nodeProps = {
        dangerouslySetInnerHTML: {
            __html: props.value
        }
    };
    return $ea2e43a448bbe55e$var$createElement(tag, nodeProps);
}
function $ea2e43a448bbe55e$var$ParsedHtml(props) {
    /* To do: `React.cloneElement` is slow, is it really needed? */ return props["data-sourcepos"] ? $eeH7J.cloneElement(props.element, {
        "data-sourcepos": props["data-sourcepos"]
    }) : props.element;
}
function $ea2e43a448bbe55e$var$VirtualHtml(props) {
    return $ea2e43a448bbe55e$var$createElement(props.tag, $ea2e43a448bbe55e$var$getCoreProps(props), props.children);
}
function $ea2e43a448bbe55e$var$NullRenderer() {
    return null;
}
function $ea2e43a448bbe55e$var$getCoreProps(props) {
    var source = props["data-sourcepos"];
    /* istanbul ignore next - nodes from plugins w/o position */ return source ? {
        "data-sourcepos": source
    } : {};
}

});

parcelRegister("28Nw1", function(module, exports) {

$parcel$export(module.exports, "HtmlParser", function () { return $18f2bce0cfb1d3dd$export$cd4d4c3e9818d120; }, function (v) { return $18f2bce0cfb1d3dd$export$cd4d4c3e9818d120 = v; });
/* istanbul ignore next - Fallback for `Symbol`. */ var $18f2bce0cfb1d3dd$export$cd4d4c3e9818d120;
"use strict";
var $18f2bce0cfb1d3dd$var$HtmlParser = "__RMD_HTML_PARSER__";
$18f2bce0cfb1d3dd$export$cd4d4c3e9818d120 = typeof Symbol === "undefined" ? $18f2bce0cfb1d3dd$var$HtmlParser : Symbol($18f2bce0cfb1d3dd$var$HtmlParser);

});


parcelRegister("hjid1", function(module, exports) {
"use strict";

var $eomYt = parcelRequire("eomYt");

var $1sn4o = parcelRequire("1sn4o");

var $29uTM = parcelRequire("29uTM");
var $c9a255f05f3396ab$var$warningIssued;
module.exports = $c9a255f05f3396ab$var$gfm;
function $c9a255f05f3396ab$var$gfm(options) {
    var data = this.data();
    /* istanbul ignore next - old remark. */ if (!$c9a255f05f3396ab$var$warningIssued && (this.Parser && this.Parser.prototype && this.Parser.prototype.blockTokenizers || this.Compiler && this.Compiler.prototype && this.Compiler.prototype.visitors)) {
        $c9a255f05f3396ab$var$warningIssued = true;
        console.warn("[remark-gfm] Warning: please upgrade to remark 13 to use this plugin");
    }
    add("micromarkExtensions", $eomYt(options));
    add("fromMarkdownExtensions", $1sn4o);
    add("toMarkdownExtensions", $29uTM(options));
    function add(field, value) {
        /* istanbul ignore if - other extensions. */ if (data[field]) data[field].push(value);
        else data[field] = [
            value
        ];
    }
}

});
parcelRegister("eomYt", function(module, exports) {

module.exports = (parcelRequire("3dDsR"));

});
parcelRegister("3dDsR", function(module, exports) {

var $jL26E = parcelRequire("jL26E");

var $cBdJZ = parcelRequire("cBdJZ");

var $hyn7t = parcelRequire("hyn7t");

var $4Sxls = parcelRequire("4Sxls");

var $ljA2K = parcelRequire("ljA2K");
module.exports = $258132cc1f8b076c$var$create;
function $258132cc1f8b076c$var$create(options) {
    return $jL26E([
        $cBdJZ,
        $hyn7t(options),
        $4Sxls,
        $ljA2K
    ]);
}

});
parcelRegister("cBdJZ", function(module, exports) {

module.exports = (parcelRequire("agBAc"));

});
parcelRegister("agBAc", function(module, exports) {

$parcel$export(module.exports, "text", function () { return $77988d2c8a5d74ba$export$6f093cfa640b7166; }, function (v) { return $77988d2c8a5d74ba$export$6f093cfa640b7166 = v; });
// Export hooked constructs.
var $77988d2c8a5d74ba$export$6f093cfa640b7166;

var $gMacN = parcelRequire("gMacN");

var $ja7BD = parcelRequire("ja7BD");

var $glVfv = parcelRequire("glVfv");

var $bl5Ae = parcelRequire("bl5Ae");

var $eavH7 = parcelRequire("eavH7");

var $1mH0l = parcelRequire("1mH0l");
var $77988d2c8a5d74ba$var$www = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeWww,
    partial: true
};
var $77988d2c8a5d74ba$var$domain = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeDomain,
    partial: true
};
var $77988d2c8a5d74ba$var$path = {
    tokenize: $77988d2c8a5d74ba$var$tokenizePath,
    partial: true
};
var $77988d2c8a5d74ba$var$punctuation = {
    tokenize: $77988d2c8a5d74ba$var$tokenizePunctuation,
    partial: true
};
var $77988d2c8a5d74ba$var$namedCharacterReference = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeNamedCharacterReference,
    partial: true
};
var $77988d2c8a5d74ba$var$wwwAutolink = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeWwwAutolink,
    previous: $77988d2c8a5d74ba$var$previousWww
};
var $77988d2c8a5d74ba$var$httpAutolink = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeHttpAutolink,
    previous: $77988d2c8a5d74ba$var$previousHttp
};
var $77988d2c8a5d74ba$var$emailAutolink = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeEmailAutolink,
    previous: $77988d2c8a5d74ba$var$previousEmail
};
var $77988d2c8a5d74ba$var$text = {};
$77988d2c8a5d74ba$export$6f093cfa640b7166 = $77988d2c8a5d74ba$var$text;
// `0`
var $77988d2c8a5d74ba$var$code = 48;
// While the code is smaller than `{`.
while($77988d2c8a5d74ba$var$code < 123){
    $77988d2c8a5d74ba$var$text[$77988d2c8a5d74ba$var$code] = $77988d2c8a5d74ba$var$emailAutolink;
    $77988d2c8a5d74ba$var$code++;
    // Jump from `:` -> `A`
    if ($77988d2c8a5d74ba$var$code === 58) $77988d2c8a5d74ba$var$code = 65;
    else if ($77988d2c8a5d74ba$var$code === 91) $77988d2c8a5d74ba$var$code = 97;
}
// `+`
$77988d2c8a5d74ba$var$text[43] = $77988d2c8a5d74ba$var$emailAutolink;
// `-`
$77988d2c8a5d74ba$var$text[45] = $77988d2c8a5d74ba$var$emailAutolink;
// `.`
$77988d2c8a5d74ba$var$text[46] = $77988d2c8a5d74ba$var$emailAutolink;
// `_`
$77988d2c8a5d74ba$var$text[95] = $77988d2c8a5d74ba$var$emailAutolink;
// `h`.
$77988d2c8a5d74ba$var$text[72] = [
    $77988d2c8a5d74ba$var$emailAutolink,
    $77988d2c8a5d74ba$var$httpAutolink
];
$77988d2c8a5d74ba$var$text[104] = [
    $77988d2c8a5d74ba$var$emailAutolink,
    $77988d2c8a5d74ba$var$httpAutolink
];
// `w`.
$77988d2c8a5d74ba$var$text[87] = [
    $77988d2c8a5d74ba$var$emailAutolink,
    $77988d2c8a5d74ba$var$wwwAutolink
];
$77988d2c8a5d74ba$var$text[119] = [
    $77988d2c8a5d74ba$var$emailAutolink,
    $77988d2c8a5d74ba$var$wwwAutolink
];
function $77988d2c8a5d74ba$var$tokenizeEmailAutolink(effects, ok, nok) {
    var self = this;
    var hasDot;
    return start;
    function start(code) {
        /* istanbul ignore next - hooks. */ if (!$77988d2c8a5d74ba$var$gfmAtext(code) || !$77988d2c8a5d74ba$var$previousEmail(self.previous) || $77988d2c8a5d74ba$var$previous(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkEmail");
        return atext(code);
    }
    function atext(code) {
        if ($77988d2c8a5d74ba$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        // `@`
        if (code === 64) {
            effects.consume(code);
            return label;
        }
        return nok(code);
    }
    function label(code) {
        // `.`
        if (code === 46) return effects.check($77988d2c8a5d74ba$var$punctuation, done, dotContinuation)(code);
        if (// `-`
        code === 45 || // `_`
        code === 95) return effects.check($77988d2c8a5d74ba$var$punctuation, nok, dashOrUnderscoreContinuation)(code);
        if ($ja7BD(code)) {
            effects.consume(code);
            return label;
        }
        return done(code);
    }
    function dotContinuation(code) {
        effects.consume(code);
        hasDot = true;
        return label;
    }
    function dashOrUnderscoreContinuation(code) {
        effects.consume(code);
        return afterDashOrUnderscore;
    }
    function afterDashOrUnderscore(code) {
        // `.`
        if (code === 46) return effects.check($77988d2c8a5d74ba$var$punctuation, nok, dotContinuation)(code);
        return label(code);
    }
    function done(code) {
        if (hasDot) {
            effects.exit("literalAutolinkEmail");
            effects.exit("literalAutolink");
            return ok(code);
        }
        return nok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizeWwwAutolink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        /* istanbul ignore next - hooks. */ if (code !== 87 && code - 32 !== 87 || !$77988d2c8a5d74ba$var$previousWww(self.previous) || $77988d2c8a5d74ba$var$previous(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkWww");
        // For `www.` we check instead of attempt, because when it matches, GH
        // treats it as part of a domain (yes, it says a valid domain must come
        // after `www.`, but that’s not how it’s implemented by them).
        return effects.check($77988d2c8a5d74ba$var$www, effects.attempt($77988d2c8a5d74ba$var$domain, effects.attempt($77988d2c8a5d74ba$var$path, done), nok), nok)(code);
    }
    function done(code) {
        effects.exit("literalAutolinkWww");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizeHttpAutolink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        /* istanbul ignore next - hooks. */ if (code !== 72 && code - 32 !== 72 || !$77988d2c8a5d74ba$var$previousHttp(self.previous) || $77988d2c8a5d74ba$var$previous(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkHttp");
        effects.consume(code);
        return t1;
    }
    function t1(code) {
        // `t`
        if (code === 84 || code - 32 === 84) {
            effects.consume(code);
            return t2;
        }
        return nok(code);
    }
    function t2(code) {
        // `t`
        if (code === 84 || code - 32 === 84) {
            effects.consume(code);
            return p;
        }
        return nok(code);
    }
    function p(code) {
        // `p`
        if (code === 80 || code - 32 === 80) {
            effects.consume(code);
            return s;
        }
        return nok(code);
    }
    function s(code) {
        // `s`
        if (code === 83 || code - 32 === 83) {
            effects.consume(code);
            return colon;
        }
        return colon(code);
    }
    function colon(code) {
        // `:`
        if (code === 58) {
            effects.consume(code);
            return slash1;
        }
        return nok(code);
    }
    function slash1(code) {
        // `/`
        if (code === 47) {
            effects.consume(code);
            return slash2;
        }
        return nok(code);
    }
    function slash2(code) {
        // `/`
        if (code === 47) {
            effects.consume(code);
            return after;
        }
        return nok(code);
    }
    function after(code) {
        return $glVfv(code) || $1mH0l(code) || $eavH7(code) ? nok(code) : effects.attempt($77988d2c8a5d74ba$var$domain, effects.attempt($77988d2c8a5d74ba$var$path, done), nok)(code);
    }
    function done(code) {
        effects.exit("literalAutolinkHttp");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizeWww(effects, ok, nok) {
    return start;
    function start(code) {
        // Assume a `w`.
        effects.consume(code);
        return w2;
    }
    function w2(code) {
        // `w`
        if (code === 87 || code - 32 === 87) {
            effects.consume(code);
            return w3;
        }
        return nok(code);
    }
    function w3(code) {
        // `w`
        if (code === 87 || code - 32 === 87) {
            effects.consume(code);
            return dot;
        }
        return nok(code);
    }
    function dot(code) {
        // `.`
        if (code === 46) {
            effects.consume(code);
            return after;
        }
        return nok(code);
    }
    function after(code) {
        return code === null || $bl5Ae(code) ? nok(code) : ok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizeDomain(effects, ok, nok) {
    var hasUnderscoreInLastSegment;
    var hasUnderscoreInLastLastSegment;
    return domain;
    function domain(code) {
        // `&`
        if (code === 38) return effects.check($77988d2c8a5d74ba$var$namedCharacterReference, done, punctuationContinuation)(code);
        if (code === 46 /* `.` */  || code === 95 /* `_` */ ) return effects.check($77988d2c8a5d74ba$var$punctuation, done, punctuationContinuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        if ($glVfv(code) || $1mH0l(code) || code !== 45 /* `-` */  && $eavH7(code)) return done(code);
        effects.consume(code);
        return domain;
    }
    function punctuationContinuation(code) {
        // `.`
        if (code === 46) {
            hasUnderscoreInLastLastSegment = hasUnderscoreInLastSegment;
            hasUnderscoreInLastSegment = undefined;
            effects.consume(code);
            return domain;
        }
        // `_`
        if (code === 95) hasUnderscoreInLastSegment = true;
        effects.consume(code);
        return domain;
    }
    function done(code) {
        if (!hasUnderscoreInLastLastSegment && !hasUnderscoreInLastSegment) return ok(code);
        return nok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizePath(effects, ok) {
    var balance = 0;
    return inPath;
    function inPath(code) {
        // `&`
        if (code === 38) return effects.check($77988d2c8a5d74ba$var$namedCharacterReference, ok, continuedPunctuation)(code);
        // `(`
        if (code === 40) balance++;
        // `)`
        if (code === 41) return effects.check($77988d2c8a5d74ba$var$punctuation, parenAtPathEnd, continuedPunctuation)(code);
        if ($77988d2c8a5d74ba$var$pathEnd(code)) return ok(code);
        if ($77988d2c8a5d74ba$var$trailingPunctuation(code)) return effects.check($77988d2c8a5d74ba$var$punctuation, ok, continuedPunctuation)(code);
        effects.consume(code);
        return inPath;
    }
    function continuedPunctuation(code) {
        effects.consume(code);
        return inPath;
    }
    function parenAtPathEnd(code) {
        balance--;
        return balance < 0 ? ok(code) : continuedPunctuation(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizeNamedCharacterReference(effects, ok, nok) {
    return start;
    function start(code) {
        // Assume an ampersand.
        effects.consume(code);
        return inside;
    }
    function inside(code) {
        if ($gMacN(code)) {
            effects.consume(code);
            return inside;
        }
        // `;`
        if (code === 59) {
            effects.consume(code);
            return after;
        }
        return nok(code);
    }
    function after(code) {
        // If the named character reference is followed by the end of the path, it’s
        // not continued punctuation.
        return $77988d2c8a5d74ba$var$pathEnd(code) ? ok(code) : nok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizePunctuation(effects, ok, nok) {
    return start;
    function start(code) {
        // Always a valid trailing punctuation marker.
        effects.consume(code);
        return after;
    }
    function after(code) {
        // Check the next.
        if ($77988d2c8a5d74ba$var$trailingPunctuation(code)) {
            effects.consume(code);
            return after;
        }
        // If the punctuation marker is followed by the end of the path, it’s not
        // continued punctuation.
        return $77988d2c8a5d74ba$var$pathEnd(code) ? ok(code) : nok(code);
    }
}
function $77988d2c8a5d74ba$var$trailingPunctuation(code) {
    return(// `!`
    code === 33 || // `"`
    code === 34 || // `'`
    code === 39 || // `)`
    code === 41 || // `*`
    code === 42 || // `,`
    code === 44 || // `.`
    code === 46 || // `:`
    code === 58 || // `;`
    code === 59 || // `<`
    code === 60 || // `?`
    code === 63 || // `_`.
    code === 95 || // `~`
    code === 126);
}
function $77988d2c8a5d74ba$var$pathEnd(code) {
    return(// EOF.
    code === null || // CR, LF, CRLF, HT, VS.
    code < 0 || // Space.
    code === 32 || // `<`
    code === 60);
}
function $77988d2c8a5d74ba$var$gfmAtext(code) {
    return code === 43 /* `+` */  || code === 45 /* `-` */  || code === 46 /* `.` */  || code === 95 /* `_` */  || $ja7BD(code);
}
function $77988d2c8a5d74ba$var$previousWww(code) {
    return code === null || code < 0 || code === 32 /* ` ` */  || code === 40 /* `(` */  || code === 42 /* `*` */  || code === 95 /* `_` */  || code === 126 /* `~` */ ;
}
function $77988d2c8a5d74ba$var$previousHttp(code) {
    return code === null || !$gMacN(code);
}
function $77988d2c8a5d74ba$var$previousEmail(code) {
    return code !== 47 /* `/` */  && $77988d2c8a5d74ba$var$previousHttp(code);
}
function $77988d2c8a5d74ba$var$previous(events) {
    var index = events.length;
    while(index--){
        if ((events[index][1].type === "labelLink" || events[index][1].type === "labelImage") && !events[index][1]._balanced) return true;
    }
}

});


parcelRegister("hyn7t", function(module, exports) {
module.exports = $cc778bb6820bed29$var$create;

var $372dT = parcelRequire("372dT");

var $9Q1oe = parcelRequire("9Q1oe");

var $5ZU3u = parcelRequire("5ZU3u");

var $1Gh3S = parcelRequire("1Gh3S");
function $cc778bb6820bed29$var$create(options) {
    var settings = options || {};
    var single = settings.singleTilde;
    var tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            126: tokenizer
        },
        insideSpan: {
            null: tokenizer
        }
    };
    // Take events and resolve strikethrough.
    function resolveAllStrikethrough(events, context) {
        var index = -1;
        var strikethrough;
        var text;
        var open;
        var nextEvents;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
            open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = "strikethroughSequence";
                events[open][1].type = "strikethroughSequence";
                strikethrough = {
                    type: "strikethrough",
                    start: $1Gh3S(events[open][1].start),
                    end: $1Gh3S(events[index][1].end)
                };
                text = {
                    type: "strikethroughText",
                    start: $1Gh3S(events[open][1].end),
                    end: $1Gh3S(events[index][1].start)
                };
                // Opening.
                nextEvents = [
                    [
                        "enter",
                        strikethrough,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                // Between.
                $9Q1oe(nextEvents, nextEvents.length, 0, $5ZU3u(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
                // Closing.
                $9Q1oe(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        strikethrough,
                        context
                    ]
                ]);
                $9Q1oe(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        return removeRemainingSequences(events);
    }
    function removeRemainingSequences(events) {
        var index = -1;
        var length = events.length;
        while(++index < length)if (events[index][1].type === "strikethroughSequenceTemporary") events[index][1].type = "data";
        return events;
    }
    function tokenizeStrikethrough(effects, ok, nok) {
        var previous = this.previous;
        var events = this.events;
        var size = 0;
        return start;
        function start(code) {
            if (code !== 126 || previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter("strikethroughSequenceTemporary");
            return more(code);
        }
        function more(code) {
            var before = $372dT(previous);
            var token;
            var after;
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            token = effects.exit("strikethroughSequenceTemporary");
            after = $372dT(code);
            token._open = !after || after === 2 && before;
            token._close = !before || before === 2 && after;
            return ok(code);
        }
    }
}

});

parcelRegister("4Sxls", function(module, exports) {

module.exports = (parcelRequire("sBlC2"));

});
parcelRegister("sBlC2", function(module, exports) {

$parcel$export(module.exports, "flow", function () { return $055f9617ca75eeb3$export$ccc7b0636abaffc3; }, function (v) { return $055f9617ca75eeb3$export$ccc7b0636abaffc3 = v; });
var $055f9617ca75eeb3$export$ccc7b0636abaffc3;
$055f9617ca75eeb3$export$ccc7b0636abaffc3 = {
    null: {
        tokenize: $055f9617ca75eeb3$var$tokenizeTable,
        resolve: $055f9617ca75eeb3$var$resolveTable,
        interruptible: true
    }
};

var $10n72 = parcelRequire("10n72");
var $055f9617ca75eeb3$var$setextUnderlineMini = {
    tokenize: $055f9617ca75eeb3$var$tokenizeSetextUnderlineMini,
    partial: true
};
var $055f9617ca75eeb3$var$nextPrefixedOrBlank = {
    tokenize: $055f9617ca75eeb3$var$tokenizeNextPrefixedOrBlank,
    partial: true
};
function $055f9617ca75eeb3$var$resolveTable(events, context) {
    var length = events.length;
    var index = -1;
    var token;
    var inHead;
    var inDelimiterRow;
    var inRow;
    var cell;
    var content;
    var text;
    var contentStart;
    var contentEnd;
    var cellStart;
    while(++index < length){
        token = events[index][1];
        if (inRow) {
            if (token.type === "temporaryTableCellContent") {
                contentStart = contentStart || index;
                contentEnd = index;
            }
            if (// Combine separate content parts into one.
            (token.type === "tableCellDivider" || token.type === "tableRow") && contentEnd) {
                content = {
                    type: "tableContent",
                    start: events[contentStart][1].start,
                    end: events[contentEnd][1].end
                };
                text = {
                    type: "chunkText",
                    start: content.start,
                    end: content.end,
                    contentType: "text"
                };
                events.splice(contentStart, contentEnd - contentStart + 1, [
                    "enter",
                    content,
                    context
                ], [
                    "enter",
                    text,
                    context
                ], [
                    "exit",
                    text,
                    context
                ], [
                    "exit",
                    content,
                    context
                ]);
                index -= contentEnd - contentStart - 3;
                length = events.length;
                contentStart = undefined;
                contentEnd = undefined;
            }
        }
        if (events[index][0] === "exit" && cellStart && cellStart + 1 < index && (token.type === "tableCellDivider" || token.type === "tableRow" && (cellStart + 3 < index || events[cellStart][1].type !== "whitespace"))) {
            cell = {
                type: inDelimiterRow ? "tableDelimiter" : inHead ? "tableHeader" : "tableData",
                start: events[cellStart][1].start,
                end: events[index][1].end
            };
            events.splice(index + (token.type === "tableCellDivider" ? 1 : 0), 0, [
                "exit",
                cell,
                context
            ]);
            events.splice(cellStart, 0, [
                "enter",
                cell,
                context
            ]);
            index += 2;
            length = events.length;
            cellStart = index + 1;
        }
        if (token.type === "tableRow") {
            inRow = events[index][0] === "enter";
            if (inRow) cellStart = index + 1;
        }
        if (token.type === "tableDelimiterRow") {
            inDelimiterRow = events[index][0] === "enter";
            if (inDelimiterRow) cellStart = index + 1;
        }
        if (token.type === "tableHead") inHead = events[index][0] === "enter";
    }
    return events;
}
function $055f9617ca75eeb3$var$tokenizeTable(effects, ok, nok) {
    var align = [];
    var tableHeaderCount = 0;
    var seenDelimiter;
    var hasDash;
    return start;
    function start(code) {
        /* istanbul ignore if - used to be passed in beta micromark versions. */ if (code === null || code === -5 || code === -4 || code === -3) return nok(code);
        effects.enter("table")._align = align;
        effects.enter("tableHead");
        effects.enter("tableRow");
        // If we start with a pipe, we open a cell marker.
        if (code === 124) return cellDividerHead(code);
        tableHeaderCount++;
        effects.enter("temporaryTableCellContent");
        // Can’t be space or eols at the start of a construct, so we’re in a cell.
        return inCellContentHead(code);
    }
    function cellDividerHead(code) {
        // Always a pipe.
        effects.enter("tableCellDivider");
        effects.consume(code);
        effects.exit("tableCellDivider");
        seenDelimiter = true;
        return cellBreakHead;
    }
    function cellBreakHead(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return atRowEndHead(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter("whitespace");
            effects.consume(code);
            return inWhitespaceHead;
        }
        if (seenDelimiter) {
            seenDelimiter = undefined;
            tableHeaderCount++;
        }
        // `|`
        if (code === 124) return cellDividerHead(code);
        // Anything else is cell content.
        effects.enter("temporaryTableCellContent");
        return inCellContentHead(code);
    }
    function inWhitespaceHead(code) {
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return inWhitespaceHead;
        }
        effects.exit("whitespace");
        return cellBreakHead(code);
    }
    function inCellContentHead(code) {
        // EOF, whitespace, pipe
        if (code === null || code < 0 || code === 32 || code === 124) {
            effects.exit("temporaryTableCellContent");
            return cellBreakHead(code);
        }
        effects.consume(code);
        // `\`
        return code === 92 ? inCellContentEscapeHead : inCellContentHead;
    }
    function inCellContentEscapeHead(code) {
        // `\` or `|`
        if (code === 92 || code === 124) {
            effects.consume(code);
            return inCellContentHead;
        }
        // Anything else.
        return inCellContentHead(code);
    }
    function atRowEndHead(code) {
        if (code === null) return nok(code);
        effects.exit("tableRow");
        effects.exit("tableHead");
        // Always a line ending.
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        // If a setext heading, exit.
        return effects.check($055f9617ca75eeb3$var$setextUnderlineMini, nok, // Support an indent before the delimiter row.
        $10n72(effects, rowStartDelimiter, "linePrefix", 4));
    }
    function rowStartDelimiter(code) {
        // If there’s another space, or we’re at the EOL/EOF, exit.
        if (code === null || code < 0 || code === 32) return nok(code);
        effects.enter("tableDelimiterRow");
        return atDelimiterRowBreak(code);
    }
    function atDelimiterRowBreak(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return rowEndDelimiter(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter("whitespace");
            effects.consume(code);
            return inWhitespaceDelimiter;
        }
        // `-`
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            effects.consume(code);
            hasDash = true;
            align.push(null);
            return inFillerDelimiter;
        }
        // `:`
        if (code === 58) {
            effects.enter("tableDelimiterAlignment");
            effects.consume(code);
            effects.exit("tableDelimiterAlignment");
            align.push("left");
            return afterLeftAlignment;
        }
        // If we start with a pipe, we open a cell marker.
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return atDelimiterRowBreak;
        }
        return nok(code);
    }
    function inWhitespaceDelimiter(code) {
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return inWhitespaceDelimiter;
        }
        effects.exit("whitespace");
        return atDelimiterRowBreak(code);
    }
    function inFillerDelimiter(code) {
        // `-`
        if (code === 45) {
            effects.consume(code);
            return inFillerDelimiter;
        }
        effects.exit("tableDelimiterFiller");
        // `:`
        if (code === 58) {
            effects.enter("tableDelimiterAlignment");
            effects.consume(code);
            effects.exit("tableDelimiterAlignment");
            align[align.length - 1] = align[align.length - 1] === "left" ? "center" : "right";
            return afterRightAlignment;
        }
        return atDelimiterRowBreak(code);
    }
    function afterLeftAlignment(code) {
        // `-`
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            effects.consume(code);
            hasDash = true;
            return inFillerDelimiter;
        }
        // Anything else is not ok.
        return nok(code);
    }
    function afterRightAlignment(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return rowEndDelimiter(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter("whitespace");
            effects.consume(code);
            return inWhitespaceDelimiter;
        }
        // `|`
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return atDelimiterRowBreak;
        }
        return nok(code);
    }
    function rowEndDelimiter(code) {
        effects.exit("tableDelimiterRow");
        // Exit if there was no dash at all, or if the header cell count is not the
        // delimiter cell count.
        if (!hasDash || tableHeaderCount !== align.length) return nok(code);
        if (code === null) return tableClose(code);
        return effects.check($055f9617ca75eeb3$var$nextPrefixedOrBlank, tableClose, tableContinue)(code);
    }
    function tableClose(code) {
        effects.exit("table");
        return ok(code);
    }
    function tableContinue(code) {
        // Always a line ending.
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        // We checked that it’s not a prefixed or blank line, so we’re certain a
        // body is coming, though it may be indented.
        return $10n72(effects, bodyStart, "linePrefix", 4);
    }
    function bodyStart(code) {
        effects.enter("tableBody");
        return rowStartBody(code);
    }
    function rowStartBody(code) {
        effects.enter("tableRow");
        // If we start with a pipe, we open a cell marker.
        if (code === 124) return cellDividerBody(code);
        effects.enter("temporaryTableCellContent");
        // Can’t be space or eols at the start of a construct, so we’re in a cell.
        return inCellContentBody(code);
    }
    function cellDividerBody(code) {
        // Always a pipe.
        effects.enter("tableCellDivider");
        effects.consume(code);
        effects.exit("tableCellDivider");
        return cellBreakBody;
    }
    function cellBreakBody(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return atRowEndBody(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter("whitespace");
            effects.consume(code);
            return inWhitespaceBody;
        }
        // `|`
        if (code === 124) return cellDividerBody(code);
        // Anything else is cell content.
        effects.enter("temporaryTableCellContent");
        return inCellContentBody(code);
    }
    function inWhitespaceBody(code) {
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return inWhitespaceBody;
        }
        effects.exit("whitespace");
        return cellBreakBody(code);
    }
    function inCellContentBody(code) {
        // EOF, whitespace, pipe
        if (code === null || code < 0 || code === 32 || code === 124) {
            effects.exit("temporaryTableCellContent");
            return cellBreakBody(code);
        }
        effects.consume(code);
        // `\`
        return code === 92 ? inCellContentEscapeBody : inCellContentBody;
    }
    function inCellContentEscapeBody(code) {
        // `\` or `|`
        if (code === 92 || code === 124) {
            effects.consume(code);
            return inCellContentBody;
        }
        // Anything else.
        return inCellContentBody(code);
    }
    function atRowEndBody(code) {
        effects.exit("tableRow");
        if (code === null) return tableBodyClose(code);
        return effects.check($055f9617ca75eeb3$var$nextPrefixedOrBlank, tableBodyClose, tableBodyContinue)(code);
    }
    function tableBodyClose(code) {
        effects.exit("tableBody");
        return tableClose(code);
    }
    function tableBodyContinue(code) {
        // Always a line ending.
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        // Support an optional prefix, then start a body row.
        return $10n72(effects, rowStartBody, "linePrefix", 4);
    }
}
// Based on micromark, but that won’t work as we’re in a table, and that expects
// content.
// <https://github.com/micromark/micromark/blob/main/lib/tokenize/setext-underline.js>
function $055f9617ca75eeb3$var$tokenizeSetextUnderlineMini(effects, ok, nok) {
    return start;
    function start(code) {
        // `-`
        if (code !== 45) return nok(code);
        effects.enter("setextUnderline");
        return sequence(code);
    }
    function sequence(code) {
        if (code === 45) {
            effects.consume(code);
            return sequence;
        }
        return whitespace(code);
    }
    function whitespace(code) {
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return whitespace;
        }
        if (code === null || code === -5 || code === -4 || code === -3) return ok(code);
        return nok(code);
    }
}
function $055f9617ca75eeb3$var$tokenizeNextPrefixedOrBlank(effects, ok, nok) {
    var size = 0;
    return start;
    function start(code) {
        // This is a check, so we don’t care about tokens, but we open a bogus one
        // so we’re valid.
        effects.enter("check");
        // EOL.
        effects.consume(code);
        return whitespace;
    }
    function whitespace(code) {
        // VS or SP.
        if (code === -1 || code === 32) {
            effects.consume(code);
            size++;
            return size === 4 ? ok : whitespace;
        }
        // EOF or whitespace
        if (code === null || code < 0) return ok(code);
        // Anything else.
        return nok(code);
    }
}

});


parcelRegister("ljA2K", function(module, exports) {

module.exports = (parcelRequire("l5ckF"));

});
parcelRegister("l5ckF", function(module, exports) {

$parcel$export(module.exports, "text", function () { return $f593a18e09975456$export$6f093cfa640b7166; }, function (v) { return $f593a18e09975456$export$6f093cfa640b7166 = v; });
var $f593a18e09975456$export$6f093cfa640b7166;

var $5zMHo = parcelRequire("5zMHo");

var $10n72 = parcelRequire("10n72");

var $bUBdZ = parcelRequire("bUBdZ");
var $f593a18e09975456$var$tasklistCheck = {
    tokenize: $f593a18e09975456$var$tokenizeTasklistCheck
};
$f593a18e09975456$export$6f093cfa640b7166 = {
    91: $f593a18e09975456$var$tasklistCheck
};
function $f593a18e09975456$var$tokenizeTasklistCheck(effects, ok, nok) {
    var self = this;
    return open;
    function open(code) {
        if (// Exit if not `[`.
        code !== 91 || // Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter("taskListCheck");
        effects.enter("taskListCheckMarker");
        effects.consume(code);
        effects.exit("taskListCheckMarker");
        return inside;
    }
    function inside(code) {
        // Tab or space.
        if (code === -2 || code === 32) {
            effects.enter("taskListCheckValueUnchecked");
            effects.consume(code);
            effects.exit("taskListCheckValueUnchecked");
            return close;
        }
        // Upper- and lower `x`.
        if (code === 88 || code === 120) {
            effects.enter("taskListCheckValueChecked");
            effects.consume(code);
            effects.exit("taskListCheckValueChecked");
            return close;
        }
        return nok(code);
    }
    function close(code) {
        // `]`
        if (code === 93) {
            effects.enter("taskListCheckMarker");
            effects.consume(code);
            effects.exit("taskListCheckMarker");
            effects.exit("taskListCheck");
            return effects.check({
                tokenize: $f593a18e09975456$var$spaceThenNonSpace
            }, ok, nok);
        }
        return nok(code);
    }
}
function $f593a18e09975456$var$spaceThenNonSpace(effects, ok, nok) {
    var self = this;
    return $10n72(effects, after, "whitespace");
    function after(code) {
        return $bUBdZ(self.events, "whitespace") && code !== null && !$5zMHo(code) ? ok(code) : nok(code);
    }
}

});




parcelRegister("1sn4o", function(module, exports) {

var $9MVet = parcelRequire("9MVet");

var $dq6Cs = parcelRequire("dq6Cs");

var $4XvDl = parcelRequire("4XvDl");

var $jQVtx = parcelRequire("jQVtx");
var $10fa4d2841b41a6a$var$own = {}.hasOwnProperty;
module.exports = $10fa4d2841b41a6a$var$configure([
    $9MVet,
    $dq6Cs,
    $4XvDl,
    $jQVtx
]);
function $10fa4d2841b41a6a$var$configure(extensions) {
    var config = {
        transforms: [],
        canContainEols: []
    };
    var length = extensions.length;
    var index = -1;
    while(++index < length)$10fa4d2841b41a6a$var$extension(config, extensions[index]);
    return config;
}
function $10fa4d2841b41a6a$var$extension(config, extension) {
    var key;
    var left;
    var right;
    for(key in extension){
        left = $10fa4d2841b41a6a$var$own.call(config, key) ? config[key] : config[key] = {};
        right = extension[key];
        if (key === "canContainEols" || key === "transforms") config[key] = [].concat(left, right);
        else Object.assign(left, right);
    }
}

});
parcelRegister("9MVet", function(module, exports) {

var $5SUaO = parcelRequire("5SUaO");

var $2rIvq = parcelRequire("2rIvq");

var $eavH7 = parcelRequire("eavH7");

var $1mH0l = parcelRequire("1mH0l");
exports.transforms = [
    transformGfmAutolinkLiterals
];
exports.enter = {
    literalAutolink: enterLiteralAutolink,
    literalAutolinkEmail: enterLiteralAutolinkValue,
    literalAutolinkHttp: enterLiteralAutolinkValue,
    literalAutolinkWww: enterLiteralAutolinkValue
};
exports.exit = {
    literalAutolink: exitLiteralAutolink,
    literalAutolinkEmail: exitLiteralAutolinkEmail,
    literalAutolinkHttp: exitLiteralAutolinkHttp,
    literalAutolinkWww: exitLiteralAutolinkWww
};
function enterLiteralAutolink(token) {
    this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
    }, token);
}
function enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    this.stack[this.stack.length - 1].url = "http://" + this.sliceSerialize(token);
}
function exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
function exitLiteralAutolink(token) {
    this.exit(token);
}
function transformGfmAutolinkLiterals(tree) {
    $2rIvq(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/i,
            findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/,
            findEmail
        ]
    ], {
        ignore: [
            "link",
            "linkReference"
        ]
    });
}
function findUrl($0, protocol, domain, path, match) {
    var prefix = "";
    var parts;
    var result;
    // Not an expected previous character.
    if (!previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = "";
        prefix = "http://";
    }
    if (!isCorrectDomain(domain)) return false;
    parts = splitUrl(domain + path);
    if (!parts[0]) return false;
    result = {
        type: "link",
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: "text",
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) result = [
        result,
        {
            type: "text",
            value: parts[1]
        }
    ];
    return result;
}
function findEmail($0, atext, label, match) {
    // Not an expected previous character.
    if (!previous(match, true) || /[_-]$/.test(label)) return false;
    return {
        type: "link",
        title: null,
        url: "mailto:" + atext + "@" + label,
        children: [
            {
                type: "text",
                value: atext + "@" + label
            }
        ]
    };
}
function isCorrectDomain(domain) {
    var parts = domain.split(".");
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
function splitUrl(url) {
    var trail = /[!"&'),.:;<>?\]}]+$/.exec(url);
    var closingParenIndex;
    var openingParens;
    var closingParens;
    if (trail) {
        url = url.slice(0, trail.index);
        trail = trail[0];
        closingParenIndex = trail.indexOf(")");
        openingParens = $5SUaO(url, "(");
        closingParens = $5SUaO(url, ")");
        while(closingParenIndex !== -1 && openingParens > closingParens){
            url += trail.slice(0, closingParenIndex + 1);
            trail = trail.slice(closingParenIndex + 1);
            closingParenIndex = trail.indexOf(")");
            closingParens++;
        }
    }
    return [
        url,
        trail
    ];
}
function previous(match, email) {
    var code = match.input.charCodeAt(match.index - 1);
    return (code !== code || $1mH0l(code) || $eavH7(code)) && (!email || code !== 47);
}

});
parcelRegister("5SUaO", function(module, exports) {
"use strict";
module.exports = $448d91beea0a8d5d$var$ccount;
function $448d91beea0a8d5d$var$ccount(source, character) {
    var value = String(source);
    var count = 0;
    var index;
    if (typeof character !== "string") throw new Error("Expected character");
    index = value.indexOf(character);
    while(index !== -1){
        count++;
        index = value.indexOf(character, index + character.length);
    }
    return count;
}

});

parcelRegister("2rIvq", function(module, exports) {
"use strict";
module.exports = $1c80a056a5dc9d82$var$findAndReplace;

var $98N75 = parcelRequire("98N75");

var $bSiTt = parcelRequire("bSiTt");

var $fPH5C = parcelRequire("fPH5C");
var $1c80a056a5dc9d82$var$splice = [].splice;
function $1c80a056a5dc9d82$var$findAndReplace(tree, find, replace, options) {
    var settings;
    var schema;
    if (typeof find === "string" || find && typeof find.exec === "function") schema = [
        [
            find,
            replace
        ]
    ];
    else {
        schema = find;
        options = replace;
    }
    settings = options || {};
    $1c80a056a5dc9d82$var$search(tree, settings, handlerFactory($1c80a056a5dc9d82$var$toPairs(schema)));
    return tree;
    function handlerFactory(pairs) {
        var pair = pairs[0];
        return handler;
        function handler(node, parent) {
            var find = pair[0];
            var replace = pair[1];
            var nodes = [];
            var start = 0;
            var index = parent.children.indexOf(node);
            var position;
            var match;
            var subhandler;
            var value;
            find.lastIndex = 0;
            match = find.exec(node.value);
            while(match){
                position = match.index;
                value = replace.apply(null, [].concat(match, {
                    index: match.index,
                    input: match.input
                }));
                if (value !== false) {
                    if (start !== position) nodes.push({
                        type: "text",
                        value: node.value.slice(start, position)
                    });
                    if (typeof value === "string" && value.length > 0) value = {
                        type: "text",
                        value: value
                    };
                    if (value) nodes = [].concat(nodes, value);
                    start = position + match[0].length;
                }
                if (!find.global) break;
                match = find.exec(node.value);
            }
            if (position === undefined) {
                nodes = [
                    node
                ];
                index--;
            } else {
                if (start < node.value.length) nodes.push({
                    type: "text",
                    value: node.value.slice(start)
                });
                nodes.unshift(index, 1);
                $1c80a056a5dc9d82$var$splice.apply(parent.children, nodes);
            }
            if (pairs.length > 1) {
                subhandler = handlerFactory(pairs.slice(1));
                position = -1;
                while(++position < nodes.length){
                    node = nodes[position];
                    if (node.type === "text") subhandler(node, parent);
                    else $1c80a056a5dc9d82$var$search(node, settings, subhandler);
                }
            }
            return index + nodes.length + 1;
        }
    }
}
function $1c80a056a5dc9d82$var$search(tree, settings, handler) {
    var ignored = $bSiTt(settings.ignore || []);
    var result = [];
    $98N75(tree, "text", visitor);
    return result;
    function visitor(node, parents) {
        var index = -1;
        var parent;
        var grandparent;
        while(++index < parents.length){
            parent = parents[index];
            if (ignored(parent, grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        return handler(node, grandparent);
    }
}
function $1c80a056a5dc9d82$var$toPairs(schema) {
    var result = [];
    var key;
    var index;
    if (typeof schema !== "object") throw new Error("Expected array or object as schema");
    if ("length" in schema) {
        index = -1;
        while(++index < schema.length)result.push([
            $1c80a056a5dc9d82$var$toExpression(schema[index][0]),
            $1c80a056a5dc9d82$var$toFunction(schema[index][1])
        ]);
    } else for(key in schema)result.push([
        $1c80a056a5dc9d82$var$toExpression(key),
        $1c80a056a5dc9d82$var$toFunction(schema[key])
    ]);
    return result;
}
function $1c80a056a5dc9d82$var$toExpression(find) {
    return typeof find === "string" ? new RegExp($fPH5C(find), "g") : find;
}
function $1c80a056a5dc9d82$var$toFunction(replace) {
    return typeof replace === "function" ? replace : returner;
    function returner() {
        return replace;
    }
}

});
parcelRegister("98N75", function(module, exports) {
"use strict";
module.exports = $6a7af54f30181eb9$var$visitParents;

var $bSiTt = parcelRequire("bSiTt");

var $jCloK = parcelRequire("jCloK");
var $6a7af54f30181eb9$var$CONTINUE = true;
var $6a7af54f30181eb9$var$SKIP = "skip";
var $6a7af54f30181eb9$var$EXIT = false;
$6a7af54f30181eb9$var$visitParents.CONTINUE = $6a7af54f30181eb9$var$CONTINUE;
$6a7af54f30181eb9$var$visitParents.SKIP = $6a7af54f30181eb9$var$SKIP;
$6a7af54f30181eb9$var$visitParents.EXIT = $6a7af54f30181eb9$var$EXIT;
function $6a7af54f30181eb9$var$visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = $bSiTt(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === "object" && node !== null ? node : {};
        var name;
        if (typeof value.type === "string") {
            name = typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            visit.displayName = "node (" + $jCloK(value.type + (name ? "<" + name + ">" : "")) + ")";
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $6a7af54f30181eb9$var$toResult(visitor(node, parents));
                if (result[0] === $6a7af54f30181eb9$var$EXIT) return result;
            }
            if (node.children && result[0] !== $6a7af54f30181eb9$var$SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $6a7af54f30181eb9$var$EXIT) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function $6a7af54f30181eb9$var$toResult(value) {
    if (value !== null && typeof value === "object" && "length" in value) return value;
    if (typeof value === "number") return [
        $6a7af54f30181eb9$var$CONTINUE,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("jCloK", function(module, exports) {
module.exports = $e4822a2ac7d40dfe$var$identity;
function $e4822a2ac7d40dfe$var$identity(d) {
    return d;
}

});


parcelRegister("fPH5C", function(module, exports) {
"use strict";
module.exports = (string)=>{
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};

});



parcelRegister("dq6Cs", function(module, exports) {
exports.canContainEols = [
    "delete"
];
exports.enter = {
    strikethrough: enterStrikethrough
};
exports.exit = {
    strikethrough: exitStrikethrough
};
function enterStrikethrough(token) {
    this.enter({
        type: "delete",
        children: []
    }, token);
}
function exitStrikethrough(token) {
    this.exit(token);
}

});

parcelRegister("4XvDl", function(module, exports) {
exports.enter = {
    table: enterTable,
    tableData: enterCell,
    tableHeader: enterCell,
    tableRow: enterRow
};
exports.exit = {
    codeText: exitCodeText,
    table: exitTable,
    tableData: exit,
    tableHeader: exit,
    tableRow: exit
};
function enterTable(token) {
    this.enter({
        type: "table",
        align: token._align,
        children: []
    }, token);
    this.setData("inTable", true);
}
function exitTable(token) {
    this.exit(token);
    this.setData("inTable");
}
function enterRow(token) {
    this.enter({
        type: "tableRow",
        children: []
    }, token);
}
function exit(token) {
    this.exit(token);
}
function enterCell(token) {
    this.enter({
        type: "tableCell",
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
function exitCodeText(token) {
    var value = this.resume();
    if (this.getData("inTable")) value = value.replace(/\\([\\|])/g, replace);
    this.stack[this.stack.length - 1].value = value;
    this.exit(token);
}
function replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}

});

parcelRegister("jQVtx", function(module, exports) {
exports.exit = {
    taskListCheckValueChecked: exitCheck,
    taskListCheckValueUnchecked: exitCheck,
    paragraph: exitParagraphWithTaskListItem
};
function exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    this.stack[this.stack.length - 2].checked = token.type === "taskListCheckValueChecked";
}
function exitParagraphWithTaskListItem(token) {
    var parent = this.stack[this.stack.length - 2];
    var node = this.stack[this.stack.length - 1];
    var siblings = parent.children;
    var head = node.children[0];
    var index = -1;
    var firstParaghraph;
    if (parent && parent.type === "listItem" && typeof parent.checked === "boolean" && head && head.type === "text") {
        while(++index < siblings.length)if (siblings[index].type === "paragraph") {
            firstParaghraph = siblings[index];
            break;
        }
        if (firstParaghraph === node) {
            // Must start with a space or a tab.
            head.value = head.value.slice(1);
            if (head.value.length === 0) node.children.shift();
            else {
                head.position.start.column++;
                head.position.start.offset++;
                node.position.start = Object.assign({}, head.position.start);
            }
        }
    }
    this.exit(token);
}

});


parcelRegister("29uTM", function(module, exports) {

var $866so = parcelRequire("866so");

var $e1dSi = parcelRequire("e1dSi");

var $gnFm6 = parcelRequire("gnFm6");

var $bXqDO = parcelRequire("bXqDO");

var $37Ars = parcelRequire("37Ars");
module.exports = $191463da3c1b9a4b$var$toMarkdown;
function $191463da3c1b9a4b$var$toMarkdown(options) {
    var config = $37Ars({
        handlers: {},
        join: [],
        unsafe: [],
        options: {}
    }, {
        extensions: [
            $866so,
            $e1dSi,
            $gnFm6(options),
            $bXqDO
        ]
    });
    return Object.assign(config.options, {
        handlers: config.handlers,
        join: config.join,
        unsafe: config.unsafe
    });
}

});
parcelRegister("866so", function(module, exports) {

$parcel$export(module.exports, "unsafe", function () { return $5e53e476fb3c530e$export$aa1c11b655786597; }, function (v) { return $5e53e476fb3c530e$export$aa1c11b655786597 = v; });
var $5e53e476fb3c530e$export$aa1c11b655786597;
var $5e53e476fb3c530e$var$inConstruct = "phrasing";
var $5e53e476fb3c530e$var$notInConstruct = [
    "autolink",
    "link",
    "image",
    "label"
];
$5e53e476fb3c530e$export$aa1c11b655786597 = [
    {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: $5e53e476fb3c530e$var$inConstruct,
        notInConstruct: $5e53e476fb3c530e$var$notInConstruct
    },
    {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: $5e53e476fb3c530e$var$inConstruct,
        notInConstruct: $5e53e476fb3c530e$var$notInConstruct
    },
    {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: $5e53e476fb3c530e$var$inConstruct,
        notInConstruct: $5e53e476fb3c530e$var$notInConstruct
    }
];

});

parcelRegister("e1dSi", function(module, exports) {

$parcel$export(module.exports, "unsafe", function () { return $a34bebe5a54cf49c$export$aa1c11b655786597; }, function (v) { return $a34bebe5a54cf49c$export$aa1c11b655786597 = v; });
$parcel$export(module.exports, "handlers", function () { return $a34bebe5a54cf49c$export$455ce229eb3d2472; }, function (v) { return $a34bebe5a54cf49c$export$455ce229eb3d2472 = v; });
var $a34bebe5a54cf49c$export$aa1c11b655786597;
var $a34bebe5a54cf49c$export$455ce229eb3d2472;

var $3xOye = parcelRequire("3xOye");
$a34bebe5a54cf49c$export$aa1c11b655786597 = [
    {
        character: "~",
        inConstruct: "phrasing"
    }
];
$a34bebe5a54cf49c$export$455ce229eb3d2472 = {
    delete: $a34bebe5a54cf49c$var$handleDelete
};
$a34bebe5a54cf49c$var$handleDelete.peek = $a34bebe5a54cf49c$var$peekDelete;
function $a34bebe5a54cf49c$var$handleDelete(node, _, context) {
    var exit = context.enter("emphasis");
    var value = $3xOye(node, context, {
        before: "~",
        after: "~"
    });
    exit();
    return "~~" + value + "~~";
}
function $a34bebe5a54cf49c$var$peekDelete() {
    return "~";
}

});
parcelRegister("3xOye", function(module, exports) {
module.exports = $294baa9378c72607$var$phrasing;
function $294baa9378c72607$var$phrasing(parent, context, safeOptions) {
    var children = parent.children || [];
    var results = [];
    var index = -1;
    var before = safeOptions.before;
    var after;
    var handle;
    var child;
    while(++index < children.length){
        child = children[index];
        if (index + 1 < children.length) {
            handle = context.handle.handlers[children[index + 1].type];
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, context, {
                before: "",
                after: ""
            }).charAt(0) : "";
        } else after = safeOptions.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === "\r" || before === "\n") && child.type === "html") {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, " ");
            before = " ";
        }
        results.push(context.handle(child, parent, context, {
            before: before,
            after: after
        }));
        before = results[results.length - 1].slice(-1);
    }
    return results.join("");
}

});


parcelRegister("gnFm6", function(module, exports) {

var $3xOye = parcelRequire("3xOye");

var $dxHLu = parcelRequire("dxHLu");

var $4rE2d = parcelRequire("4rE2d");
module.exports = $becedfaa20db30e7$var$toMarkdown;
function $becedfaa20db30e7$var$toMarkdown(options) {
    var settings = options || {};
    var padding = settings.tableCellPadding;
    var alignDelimiters = settings.tablePipeAlign;
    var stringLength = settings.stringLength;
    var around = padding ? " " : "|";
    return {
        unsafe: [
            {
                character: "\r",
                inConstruct: "tableCell"
            },
            {
                character: "\n",
                inConstruct: "tableCell"
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: "|",
                after: "[	 :-]"
            },
            // A pipe in a cell must be encoded.
            {
                character: "|",
                inConstruct: "tableCell"
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ":",
                after: "-"
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            table: handleTable,
            tableRow: handleTableRow,
            tableCell: handleTableCell,
            inlineCode: inlineCodeWithTable
        }
    };
    function handleTable(node, _, context) {
        return serializeData(handleTableAsData(node, context), node.align);
    }
    // This function isn’t really used normally, because we handle rows at the
    // table level.
    // But, if someone passes in a table row, this ensures we make somewhat sense.
    function handleTableRow(node, _, context) {
        var row = handleTableRowAsData(node, context);
        // `markdown-table` will always add an align row
        var value = serializeData([
            row
        ]);
        return value.slice(0, value.indexOf("\n"));
    }
    function handleTableCell(node, _, context) {
        var exit = context.enter("tableCell");
        var value = $3xOye(node, context, {
            before: around,
            after: around
        });
        exit();
        return value;
    }
    function serializeData(matrix, align) {
        return $4rE2d(matrix, {
            align: align,
            alignDelimiters: alignDelimiters,
            padding: padding,
            stringLength: stringLength
        });
    }
    function handleTableAsData(node, context) {
        var children = node.children;
        var index = -1;
        var length = children.length;
        var result = [];
        var subexit = context.enter("table");
        while(++index < length)result[index] = handleTableRowAsData(children[index], context);
        subexit();
        return result;
    }
    function handleTableRowAsData(node, context) {
        var children = node.children;
        var index = -1;
        var length = children.length;
        var result = [];
        var subexit = context.enter("tableRow");
        while(++index < length)result[index] = handleTableCell(children[index], node, context);
        subexit();
        return result;
    }
    function inlineCodeWithTable(node, parent, context) {
        var value = $dxHLu(node, parent, context);
        if (context.stack.indexOf("tableCell") !== -1) value = value.replace(/\|/g, "\\$&");
        return value;
    }
}

});
parcelRegister("dxHLu", function(module, exports) {
module.exports = $9dc04e3a808d2eea$var$inlineCode;
$9dc04e3a808d2eea$var$inlineCode.peek = $9dc04e3a808d2eea$var$inlineCodePeek;

var $hCaIb = parcelRequire("hCaIb");
function $9dc04e3a808d2eea$var$inlineCode(node, parent, context) {
    var value = node.value || "";
    var sequence = "`";
    var index = -1;
    var pattern;
    var expression;
    var match;
    var position;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value))sequence += "`";
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/[ \r\n`]/.test(value.charAt(0)) || /[ \r\n`]/.test(value.charAt(value.length - 1)))) value = " " + value + " ";
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < context.unsafe.length){
        pattern = context.unsafe[index];
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        expression = $hCaIb(pattern);
        while(match = expression.exec(value)){
            position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + " " + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
function $9dc04e3a808d2eea$var$inlineCodePeek() {
    return "`";
}

});
parcelRegister("hCaIb", function(module, exports) {
module.exports = $cd2e4b652c94a62e$var$patternCompile;
function $cd2e4b652c94a62e$var$patternCompile(pattern) {
    var before;
    var after;
    if (!pattern._compiled) {
        before = pattern.before ? "(?:" + pattern.before + ")" : "";
        after = pattern.after ? "(?:" + pattern.after + ")" : "";
        if (pattern.atBreak) before = "[\\r\\n][\\t ]*" + before;
        pattern._compiled = new RegExp((before ? "(" + before + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? "\\" : "") + pattern.character + (after || ""), "g");
    }
    return pattern._compiled;
}

});


parcelRegister("4rE2d", function(module, exports) {
"use strict";

var $5VIIE = parcelRequire("5VIIE");
module.exports = $33c8bd16d642ae78$var$markdownTable;
var $33c8bd16d642ae78$var$trailingWhitespace = / +$/;
// Characters.
var $33c8bd16d642ae78$var$space = " ";
var $33c8bd16d642ae78$var$lineFeed = "\n";
var $33c8bd16d642ae78$var$dash = "-";
var $33c8bd16d642ae78$var$colon = ":";
var $33c8bd16d642ae78$var$verticalBar = "|";
var $33c8bd16d642ae78$var$x = 0;
var $33c8bd16d642ae78$var$C = 67;
var $33c8bd16d642ae78$var$L = 76;
var $33c8bd16d642ae78$var$R = 82;
var $33c8bd16d642ae78$var$c = 99;
var $33c8bd16d642ae78$var$l = 108;
var $33c8bd16d642ae78$var$r = 114;
// Create a table from a matrix of strings.
function $33c8bd16d642ae78$var$markdownTable(table, options) {
    var settings = options || {};
    var padding = settings.padding !== false;
    var start = settings.delimiterStart !== false;
    var end = settings.delimiterEnd !== false;
    var align = (settings.align || []).concat();
    var alignDelimiters = settings.alignDelimiters !== false;
    var alignments = [];
    var stringLength = settings.stringLength || $33c8bd16d642ae78$var$defaultStringLength;
    var rowIndex = -1;
    var rowLength = table.length;
    var cellMatrix = [];
    var sizeMatrix = [];
    var row = [];
    var sizes = [];
    var longestCellByColumn = [];
    var mostCellsPerRow = 0;
    var cells;
    var columnIndex;
    var columnLength;
    var largest;
    var size;
    var cell;
    var lines;
    var line;
    var before;
    var after;
    var code;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < rowLength){
        cells = table[rowIndex];
        columnIndex = -1;
        columnLength = cells.length;
        row = [];
        sizes = [];
        if (columnLength > mostCellsPerRow) mostCellsPerRow = columnLength;
        while(++columnIndex < columnLength){
            cell = $33c8bd16d642ae78$var$serialize(cells[columnIndex]);
            if (alignDelimiters === true) {
                size = stringLength(cell);
                sizes[columnIndex] = size;
                largest = longestCellByColumn[columnIndex];
                if (largest === undefined || size > largest) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    columnIndex = -1;
    columnLength = mostCellsPerRow;
    if (typeof align === "object" && "length" in align) while(++columnIndex < columnLength)alignments[columnIndex] = $33c8bd16d642ae78$var$toAlignment(align[columnIndex]);
    else {
        code = $33c8bd16d642ae78$var$toAlignment(align);
        while(++columnIndex < columnLength)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    columnLength = mostCellsPerRow;
    row = [];
    sizes = [];
    while(++columnIndex < columnLength){
        code = alignments[columnIndex];
        before = "";
        after = "";
        if (code === $33c8bd16d642ae78$var$l) before = $33c8bd16d642ae78$var$colon;
        else if (code === $33c8bd16d642ae78$var$r) after = $33c8bd16d642ae78$var$colon;
        else if (code === $33c8bd16d642ae78$var$c) {
            before = $33c8bd16d642ae78$var$colon;
            after = $33c8bd16d642ae78$var$colon;
        }
        // There *must* be at least one hyphen-minus in each alignment cell.
        size = alignDelimiters ? Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length) : 1;
        cell = before + $5VIIE($33c8bd16d642ae78$var$dash, size) + after;
        if (alignDelimiters === true) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    rowLength = cellMatrix.length;
    lines = [];
    while(++rowIndex < rowLength){
        row = cellMatrix[rowIndex];
        sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        columnLength = mostCellsPerRow;
        line = [];
        while(++columnIndex < columnLength){
            cell = row[columnIndex] || "";
            before = "";
            after = "";
            if (alignDelimiters === true) {
                size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                code = alignments[columnIndex];
                if (code === $33c8bd16d642ae78$var$r) before = $5VIIE($33c8bd16d642ae78$var$space, size);
                else if (code === $33c8bd16d642ae78$var$c) {
                    if (size % 2 === 0) {
                        before = $5VIIE($33c8bd16d642ae78$var$space, size / 2);
                        after = before;
                    } else {
                        before = $5VIIE($33c8bd16d642ae78$var$space, size / 2 + 0.5);
                        after = $5VIIE($33c8bd16d642ae78$var$space, size / 2 - 0.5);
                    }
                } else after = $5VIIE($33c8bd16d642ae78$var$space, size);
            }
            if (start === true && columnIndex === 0) line.push($33c8bd16d642ae78$var$verticalBar);
            if (padding === true && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(alignDelimiters === false && cell === "") && (start === true || columnIndex !== 0)) line.push($33c8bd16d642ae78$var$space);
            if (alignDelimiters === true) line.push(before);
            line.push(cell);
            if (alignDelimiters === true) line.push(after);
            if (padding === true) line.push($33c8bd16d642ae78$var$space);
            if (end === true || columnIndex !== columnLength - 1) line.push($33c8bd16d642ae78$var$verticalBar);
        }
        line = line.join("");
        if (end === false) line = line.replace($33c8bd16d642ae78$var$trailingWhitespace, "");
        lines.push(line);
    }
    return lines.join($33c8bd16d642ae78$var$lineFeed);
}
function $33c8bd16d642ae78$var$serialize(value) {
    return value === null || value === undefined ? "" : String(value);
}
function $33c8bd16d642ae78$var$defaultStringLength(value) {
    return value.length;
}
function $33c8bd16d642ae78$var$toAlignment(value) {
    var code = typeof value === "string" ? value.charCodeAt(0) : $33c8bd16d642ae78$var$x;
    return code === $33c8bd16d642ae78$var$L || code === $33c8bd16d642ae78$var$l ? $33c8bd16d642ae78$var$l : code === $33c8bd16d642ae78$var$R || code === $33c8bd16d642ae78$var$r ? $33c8bd16d642ae78$var$r : code === $33c8bd16d642ae78$var$C || code === $33c8bd16d642ae78$var$c ? $33c8bd16d642ae78$var$c : $33c8bd16d642ae78$var$x;
}

});
parcelRegister("5VIIE", function(module, exports) {
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ "use strict";
/**
 * Results cache
 */ var $4514f6e71694d187$var$res = "";
var $4514f6e71694d187$var$cache;
/**
 * Expose `repeat`
 */ module.exports = $4514f6e71694d187$var$repeat;
/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */ function $4514f6e71694d187$var$repeat(str, num) {
    if (typeof str !== "string") throw new TypeError("expected a string");
    // cover common, quick use cases
    if (num === 1) return str;
    if (num === 2) return str + str;
    var max = str.length * num;
    if ($4514f6e71694d187$var$cache !== str || typeof $4514f6e71694d187$var$cache === "undefined") {
        $4514f6e71694d187$var$cache = str;
        $4514f6e71694d187$var$res = "";
    } else if ($4514f6e71694d187$var$res.length >= max) return $4514f6e71694d187$var$res.substr(0, max);
    while(max > $4514f6e71694d187$var$res.length && num > 1){
        if (num & 1) $4514f6e71694d187$var$res += str;
        num >>= 1;
        str += str;
    }
    $4514f6e71694d187$var$res += str;
    $4514f6e71694d187$var$res = $4514f6e71694d187$var$res.substr(0, max);
    return $4514f6e71694d187$var$res;
}

});



parcelRegister("bXqDO", function(module, exports) {

$parcel$export(module.exports, "unsafe", function () { return $8b49debf51c2f7dc$export$aa1c11b655786597; }, function (v) { return $8b49debf51c2f7dc$export$aa1c11b655786597 = v; });
$parcel$export(module.exports, "handlers", function () { return $8b49debf51c2f7dc$export$455ce229eb3d2472; }, function (v) { return $8b49debf51c2f7dc$export$455ce229eb3d2472 = v; });
var $8b49debf51c2f7dc$export$aa1c11b655786597;
var $8b49debf51c2f7dc$export$455ce229eb3d2472;

var $1aLjY = parcelRequire("1aLjY");
$8b49debf51c2f7dc$export$aa1c11b655786597 = [
    {
        atBreak: true,
        character: "-",
        after: "[:|-]"
    }
];
$8b49debf51c2f7dc$export$455ce229eb3d2472 = {
    listItem: $8b49debf51c2f7dc$var$listItemWithTaskListItem
};
function $8b49debf51c2f7dc$var$listItemWithTaskListItem(node, parent, context) {
    var value = $1aLjY(node, parent, context);
    var head = node.children[0];
    if (typeof node.checked === "boolean" && head && head.type === "paragraph") value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    function check($0) {
        return $0 + "[" + (node.checked ? "x" : " ") + "] ";
    }
}

});
parcelRegister("1aLjY", function(module, exports) {
module.exports = $0dab6e9a06227ea4$var$listItem;

var $5VIIE = parcelRequire("5VIIE");

var $dZoOx = parcelRequire("dZoOx");

var $e1H89 = parcelRequire("e1H89");

var $hEHW2 = parcelRequire("hEHW2");

var $2vwHk = parcelRequire("2vwHk");
function $0dab6e9a06227ea4$var$listItem(node, parent, context) {
    var bullet = $dZoOx(context);
    var listItemIndent = $e1H89(context);
    var size;
    var value;
    var exit;
    if (parent && parent.ordered) bullet = (parent.start > -1 ? parent.start : 1) + (context.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + ".";
    size = bullet.length + 1;
    if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    exit = context.enter("listItem");
    value = $2vwHk($hEHW2(node, context), map);
    exit();
    return value;
    function map(line, index, blank) {
        if (index) return (blank ? "" : $5VIIE(" ", size)) + line;
        return (blank ? bullet : bullet + $5VIIE(" ", size - bullet.length)) + line;
    }
}

});
parcelRegister("dZoOx", function(module, exports) {
module.exports = $a2f4386965b488b3$var$checkBullet;
function $a2f4386965b488b3$var$checkBullet(context) {
    var marker = context.options.bullet || "*";
    if (marker !== "*" && marker !== "+" && marker !== "-") throw new Error("Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return marker;
}

});

parcelRegister("e1H89", function(module, exports) {
module.exports = $a3629d823c402b87$var$checkListItemIndent;
function $a3629d823c402b87$var$checkListItemIndent(context) {
    var style = context.options.listItemIndent || "tab";
    if (style === 1 || style === "1") return "one";
    if (style !== "tab" && style !== "one" && style !== "mixed") throw new Error("Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return style;
}

});

parcelRegister("hEHW2", function(module, exports) {
module.exports = $cda840b21d39d156$var$flow;

var $5VIIE = parcelRequire("5VIIE");
function $cda840b21d39d156$var$flow(parent, context) {
    var children = parent.children || [];
    var results = [];
    var index = -1;
    var child;
    while(++index < children.length){
        child = children[index];
        results.push(context.handle(child, parent, context, {
            before: "\n",
            after: "\n"
        }));
        if (index + 1 < children.length) results.push(between(child, children[index + 1]));
    }
    return results.join("");
    function between(left, right) {
        var index = -1;
        var result;
        while(++index < context.join.length){
            result = context.join[index](left, right, parent, context);
            if (result === true || result === 1) break;
            if (typeof result === "number") return $5VIIE("\n", 1 + Number(result));
            if (result === false) return "\n\n<!---->\n\n";
        }
        return "\n\n";
    }
}

});

parcelRegister("2vwHk", function(module, exports) {
module.exports = $1d37d7237b62dbb7$var$indentLines;
var $1d37d7237b62dbb7$var$eol = /\r?\n|\r/g;
function $1d37d7237b62dbb7$var$indentLines(value, map) {
    var result = [];
    var start = 0;
    var line = 0;
    var match;
    while(match = $1d37d7237b62dbb7$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join("");
    function one(value) {
        result.push(map(value, line, !value));
    }
}

});



parcelRegister("37Ars", function(module, exports) {
module.exports = $245e4b21843bd8d7$var$configure;
function $245e4b21843bd8d7$var$configure(base, extension) {
    var index = -1;
    var key;
    // First do subextensions.
    if (extension.extensions) while(++index < extension.extensions.length)$245e4b21843bd8d7$var$configure(base, extension.extensions[index]);
    for(key in extension){
        if (key === "extensions") ;
        else if (key === "unsafe" || key === "join") base[key] = base[key].concat(extension[key] || []);
        else if (key === "handlers") base[key] = Object.assign(base[key], extension[key] || {});
        else base.options[key] = extension[key];
    }
    return base;
}

});




parcelRegister("alVaN", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("7KZCj", function(module, exports) {

$parcel$export(module.exports, "SectionView", function () { return SectionView; });
$parcel$export(module.exports, "EditableSections", function () { return EditableSections; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $ikBJm = parcelRequire("ikBJm");

var $21l71 = parcelRequire("21l71");

var $2uIvI = parcelRequire("2uIvI");

var $9G56J = parcelRequire("9G56J");
function SectionView({ section, index, totalCount }) {
    const [state, setState] = (0, $eeH7J.useState)({});
    (0, $eeH7J.useEffect)(()=>{
        const invalidate = ()=>{
            componentFuncs.delete(section.type);
            setState({});
        };
        let funcs = (0, $9G56J.Section).invalidators.get(section.type);
        if (!funcs) {
            funcs = [
                invalidate
            ];
            (0, $9G56J.Section).invalidators.set(section.type, funcs);
        } else funcs.push(invalidate);
        return ()=>{
            funcs.splice(funcs.indexOf(invalidate), 1);
        };
    }, [
        section.type
    ]);
    const func = (0, $9G56J.Section).types.get(section.type);
    if (func) {
        let ComponentFunc = componentFuncs.get(section.type);
        if (!ComponentFunc) {
            // Dynamically create a function that has the right name, for debugging purposes
            // eslint-disable-next-line no-eval
            ComponentFunc = eval(`((impl) => function ${section.type}(props) { 
                    return impl(props.section, props.index, props.totalCount) 
                })`)(func);
            componentFuncs.set(section.type, ComponentFunc);
        }
        return (0, $4vwom.jsx)(ComponentFunc, {
            section: section,
            index: index,
            totalCount: totalCount,
            state: state
        });
    }
    return (0, $4vwom.jsxs)("div", {
        children: [
            "Unknown section type: ",
            section.type
        ]
    });
}
const componentFuncs = new Map();


function EditableSections(props) {
    var _a, _b;
    const typeName = (_a = props.sectionTypeName) !== null && _a !== void 0 ? _a : "Section";
    const { modal, showModal } = (0, $ikBJm.useContextualModal)();
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            modal,
            (0, $4vwom.jsx)((0, $21l71.EditableArray), {
                arr: props.sections,
                direction: (_b = props.direction) !== null && _b !== void 0 ? _b : "column",
                itemClassName: props.itemClassName,
                itemStyle: props.itemStyle,
                itemCss: props.itemCss,
                itemTypeName: typeName,
                createInstance: async ()=>{
                    const { PickEditingTemplate } = await (parcelRequire("kPHAc"));
                    return PickEditingTemplate(typeName, showModal);
                },
                children: (section, index)=>{
                    var _a;
                    return (0, $4vwom.jsx)((0, $2uIvI.EditableObject), {
                        obj: section,
                        typeName: typeName,
                        style: (_a = props.innerItemStyle) === null || _a === void 0 ? void 0 : _a.call(props, index),
                        actions: {
                            deleteThis () {
                                props.sections.splice(index, 1);
                            },
                            async saveAsTemplate () {
                                const { SaveAsEditingTemplate } = await (parcelRequire("kPHAc"));
                                await SaveAsEditingTemplate(typeName, section, showModal);
                            }
                        },
                        children: (0, $4vwom.jsx)(SectionView, {
                            section: section,
                            index: index,
                            totalCount: props.sections.length
                        })
                    }, index);
                }
            })
        ]
    });
}

});
parcelRegister("ikBJm", function(module, exports) {

$parcel$export(module.exports, "ModalContext", function () { return $d5875cc29dc443c7$export$ab57792b9b6974a6; });
$parcel$export(module.exports, "ModalProvider", function () { return $d5875cc29dc443c7$export$178405afcd8c5eb; });
$parcel$export(module.exports, "Modal", function () { return $d5875cc29dc443c7$export$2b77a92f1a5ad772; });
$parcel$export(module.exports, "useContextualModal", function () { return $d5875cc29dc443c7$export$d8d2fc9be59e6858; });
$parcel$export(module.exports, "closeContextualModal", function () { return $d5875cc29dc443c7$export$fd5a43132b1bbce7; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");
let $d5875cc29dc443c7$var$setRoot;
let $d5875cc29dc443c7$var$root;
let $d5875cc29dc443c7$var$close;
const $d5875cc29dc443c7$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $d5875cc29dc443c7$export$178405afcd8c5eb(props) {
    const state = (0, $eeH7J.useState)(undefined);
    $d5875cc29dc443c7$var$root = state[0];
    $d5875cc29dc443c7$var$setRoot = state[1];
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            props.children,
            $d5875cc29dc443c7$var$root && (0, $4vwom.jsx)($d5875cc29dc443c7$export$ab57792b9b6974a6.Provider, {
                value: $d5875cc29dc443c7$var$root ? {
                    close: $d5875cc29dc443c7$var$close
                } : undefined,
                children: (0, $4vwom.jsx)("div", {
                    onClick: (e)=>{
                        if (e.target === e.currentTarget) // Only trigger this if the user clicked outside of
                        // the modal, not inside the modal (got here by
                        // bubbling)
                        $d5875cc29dc443c7$var$close(undefined);
                        else if (// Don't stop event propagation when clicking on normal links,
                        // otherwise they don't work (#1093)
                        Object.getPrototypeOf(e.target) !== HTMLAnchorElement.prototype) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    },
                    style: {
                        backgroundColor: "#0008",
                        position: "fixed",
                        zIndex: 100,
                        width: "100%",
                        height: "100%",
                        top: 0,
                        left: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: (0, $4vwom.jsx)("div", {
                        style: {
                            maxHeight: "100%",
                            overflowY: "auto"
                        },
                        children: $d5875cc29dc443c7$var$root
                    })
                })
            })
        ]
    });
}
function $d5875cc29dc443c7$export$2b77a92f1a5ad772(render) {
    const _setRoot = $d5875cc29dc443c7$var$setRoot;
    if (!_setRoot) throw new Error("Modal must be used inside a ModalProvider");
    return new Promise((resolve)=>{
        $d5875cc29dc443c7$var$close = (result)=>{
            _setRoot(undefined);
            resolve(result);
        };
        _setRoot(render($d5875cc29dc443c7$var$close));
    });
}
function $d5875cc29dc443c7$export$d8d2fc9be59e6858() {
    const [root, setRoot] = (0, $eeH7J.useState)(null);
    const [portal, setPortal] = (0, $eeH7J.useState)(null);
    const modal = root && portal && /*#__PURE__*/ (0, $iMJCh.createPortal)(root, portal);
    function Portal() {
        return (0, $4vwom.jsx)("div", {
            ref: (r)=>setPortal(r),
            children: (0, $4vwom.jsx)("div", {
                style: {
                    height: 0,
                    width: 0
                }
            })
        });
    }
    const showModal = async (render)=>{
        return await $d5875cc29dc443c7$export$2b77a92f1a5ad772((close)=>{
            setRoot(render(close));
            return (0, $4vwom.jsx)(Portal, {});
        });
    };
    return {
        modal: modal,
        showModal: showModal,
        showingModal: !!root
    };
}
function $d5875cc29dc443c7$export$fd5a43132b1bbce7() {
    if ($d5875cc29dc443c7$var$close) $d5875cc29dc443c7$var$close(undefined);
}

});

parcelRegister("21l71", function(module, exports) {

$parcel$export(module.exports, "ArrayContext", function () { return $178c0d38bf9b310d$export$935d8dc970c35362; });
$parcel$export(module.exports, "EditableArray", function () { return $178c0d38bf9b310d$export$9bef545abb0cd5cc; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5c9Ym = parcelRequire("5c9Ym");

var $5JGam = parcelRequire("5JGam");

var $fz3r9 = parcelRequire("fz3r9");

var $cwhCA = parcelRequire("cwhCA");

var $cNfXq = parcelRequire("cNfXq");

var $8h5s0 = parcelRequire("8h5s0");

var $43jhg = parcelRequire("43jhg");

var $ikBJm = parcelRequire("ikBJm");

var $5iV0P = parcelRequire("5iV0P");

var $9Q5xE = parcelRequire("9Q5xE");

var $knIBr = parcelRequire("knIBr");

var $dOFTp = parcelRequire("dOFTp");
const $178c0d38bf9b310d$export$935d8dc970c35362 = /*#__PURE__*/ (0, $eeH7J.createContext)({
    arr: []
});

function $178c0d38bf9b310d$export$9bef545abb0cd5cc({ arr: arr, direction: direction, children: children, itemTypeName: itemTypeName, itemStyle: itemStyle, itemClassName: itemClassName, itemCss: itemCss, createInstance: createInstance }) {
    var _a;
    const sc = (0, $knIBr.useSelectionContext)();
    (0, $dOFTp.useObserveYProxy)(arr);
    const editing = (0, $5JGam.useIsEditing)();
    const reflectionReady = (0, $cNfXq.useReflectionReady)(editing);
    const type = (_a = editing && reflectionReady && (0, $cwhCA.GetType)(itemTypeName)) !== null && _a !== void 0 ? _a : undefined;
    async function deleteAt(index) {
        arr.splice(index, 1);
    }
    const createNew = createInstance !== null && createInstance !== void 0 ? createInstance : async ()=>{
        async function findInstanceType() {
            if (type && (0, $43jhg.IsUnionType)(type)) {
                const union = (0, $43jhg.GetTypeAlias)(type);
                if (union) {
                    const { DocumentPicker: DocumentPicker } = await (parcelRequire("e2IHD"));
                    const res = await (0, $ikBJm.Modal)((close)=>(0, $4vwom.jsx)(DocumentPicker, {
                            collection: union,
                            current: undefined,
                            cancel: ()=>close(undefined),
                            itemName: {
                                en: (0, $8h5s0.prettyCamel)(union, false) + " type"
                            },
                            itemSelected: (row)=>close(row)
                        }));
                    if (res === undefined) return; // User cancelled
                    const alias = res === null || res === void 0 ? void 0 : res._primaryKey;
                    if (typeof alias === "string") return (0, $cwhCA.GetType)(alias);
                }
            }
            return type;
        }
        const newType = await findInstanceType();
        if (newType) return (0, $5c9Ym.CreateDefault)(newType);
    };
    async function addAt(index) {
        const obj = await createNew();
        if (obj !== undefined && type) {
            arr.splice(index, 0, obj);
            sc.setSelectedObject(obj, type);
            (0, $5iV0P.SetEditableActions)(obj, {
                deleteThis () {
                    deleteAt(index);
                }
            });
        }
    }
    return (0, $4vwom.jsx)($178c0d38bf9b310d$export$935d8dc970c35362.Provider, {
        value: {
            arr: arr
        },
        children: (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
            children: [
                arr.map((item, index)=>{
                    var _a;
                    return (0, $4vwom.jsx)($178c0d38bf9b310d$var$ArrayItem, {
                        itemClassName: typeof itemClassName === "string" ? itemClassName : itemClassName === null || itemClassName === void 0 ? void 0 : itemClassName(index),
                        itemStyle: itemStyle === null || itemStyle === void 0 ? void 0 : itemStyle(index),
                        itemCss: itemCss === null || itemCss === void 0 ? void 0 : itemCss(index),
                        sectionId: (_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.valueOf(),
                        insertAfter: ()=>addAt(index + 1),
                        insertBefore: ()=>addAt(index),
                        editing: editing,
                        direction: direction,
                        isLast: index === arr.length - 1,
                        children: children(item, index)
                    }, index);
                }),
                arr.length === 0 && editing && type ? (0, $4vwom.jsxs)("button", {
                    onClick: ()=>addAt(0),
                    children: [
                        "Add first ",
                        (0, $8h5s0.prettyCamel)(itemTypeName, false)
                    ]
                }) : undefined
            ]
        })
    });
}
function $178c0d38bf9b310d$var$ArrayItem(props) {
    const ref = (0, $eeH7J.useRef)(null);
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const [showA, setShowA] = (0, $eeH7J.useState)(false);
    const [showB, setShowB] = (0, $eeH7J.useState)(false);
    return (0, $4vwom.jsxs)("div", Object.assign({
        id: props.sectionId,
        ref: ref,
        className: props.itemClassName,
        onMouseMove: (e)=>{
            e.stopPropagation();
            if (!ref.current) return;
            if (e.currentTarget !== ref.current) return;
            const rect = ref.current.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            let a = false;
            let b = false;
            if (props.direction === "row") {
                if (x < 40) a = true;
                if (ref.current && x > rect.width - 40) b = true;
                if (y < -20 || y > rect.height + 20) {
                    a = false;
                    b = false;
                }
            }
            if (props.direction === "column") {
                if (y < 40) a = true;
                if (ref.current && y > rect.height - 40) b = true;
                if (x < -20 || x > rect.width + 20) {
                    a = false;
                    b = false;
                }
            }
            setShowA(a);
            setShowB(b);
        }
    }, hoverProps, {
        style: Object.assign({
            display: "flex",
            flexDirection: props.direction,
            position: "relative"
        }, props.itemStyle),
        css: props.itemCss,
        children: [
            props.editing && (0, $4vwom.jsx)($178c0d38bf9b310d$var$AddBar, {
                direction: props.direction,
                position: "before",
                show: hover && showA,
                onClick: props.insertBefore
            }),
            props.children,
            props.editing && hover && props.isLast && (0, $4vwom.jsx)($178c0d38bf9b310d$var$AddBar, {
                direction: props.direction,
                position: "after",
                show: hover && showB,
                onClick: props.insertAfter
            })
        ]
    }));
}
function $178c0d38bf9b310d$var$AddBar(props) {
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    return (0, $4vwom.jsx)("div", Object.assign({
        onClick: (e)=>{
            e.stopPropagation();
            props.onClick();
        }
    }, hoverProps, {
        style: {
            position: "absolute",
            zIndex: 20,
            display: "flex",
            flexDirection: props.direction === "row" ? "column" : "row",
            justifyContent: "center",
            alignItems: "center",
            opacity: props.show ? 0.9 : 0,
            transition: "opacity 0.2s",
            top: props.direction === "column" && props.position === "before" ? -1.5 : undefined,
            bottom: props.direction === "column" && props.position === "after" ? -1.5 : undefined,
            left: props.direction === "row" && props.position === "before" ? -1.5 : undefined,
            right: props.direction === "row" && props.position === "after" ? -1.5 : undefined,
            width: props.direction === "column" ? "100%" : 2,
            height: props.direction === "row" ? "100%" : 2,
            backgroundColor: hover ? (0, $9Q5xE.ColorStyles).primary[500] : (0, $9Q5xE.ColorStyles).primary[600],
            fontFamily: "Arial"
        },
        children: (0, $4vwom.jsx)("div", {
            style: {
                width: 24,
                height: 24,
                backgroundColor: hover ? (0, $9Q5xE.ColorStyles).primary[500] : (0, $9Q5xE.ColorStyles).primary[600],
                borderRadius: 16,
                fontSize: 24,
                color: "white",
                display: "flex",
                flexDirection: props.direction === "row" ? "column" : "row",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                cursor: "pointer"
            },
            children: (0, $4vwom.jsx)("div", {
                style: {
                    marginLeft: 1.25,
                    marginTop: 0.25
                },
                children: "+"
            })
        })
    }));
}

});
parcelRegister("fz3r9", function(module, exports) {

$parcel$export(module.exports, "useHover", function () { return $b54cca65c87cf2f5$export$ae780daf29e6d456; });

var $eeH7J = parcelRequire("eeH7J");
function $b54cca65c87cf2f5$export$ae780daf29e6d456() {
    const [hover, setHover] = (0, $eeH7J.useState)(false);
    return {
        hover: hover,
        setHover: setHover,
        hoverProps: {
            onMouseEnter () {
                setHover(true);
            },
            onMouseLeave () {
                setHover(false);
            }
        }
    };
}

});

parcelRegister("5iV0P", function(module, exports) {

$parcel$export(module.exports, "SetEditableActions", function () { return $3dcadba765062a82$export$40511102a539d165; });
$parcel$export(module.exports, "GetEditableActions", function () { return $3dcadba765062a82$export$d9ce39e30c4ca3d2; });
const $3dcadba765062a82$var$actionHooks = new WeakMap();
function $3dcadba765062a82$export$40511102a539d165(obj, actions) {
    try {
        $3dcadba765062a82$var$actionHooks.set(obj, actions);
    } catch (error) {
        // This happens sometimes when navigating back (#2418)
        console.error("SetEditableActions", error);
    }
}
function $3dcadba765062a82$export$d9ce39e30c4ca3d2(obj) {
    return $3dcadba765062a82$var$actionHooks.get(obj);
}

});

parcelRegister("9Q5xE", function(module, exports) {

$parcel$export(module.exports, "ColorStyles", function () { return $729d44d6c5bbc062$export$bb593cab2c3c47ba; });
$parcel$export(module.exports, "OverlayShadow", function () { return $729d44d6c5bbc062$export$9314c39552ab0f3e; });

var $l079f = parcelRequire("l079f");
const $729d44d6c5bbc062$export$bb593cab2c3c47ba = (0, $l079f.UntitledUI).colorStyles;
const $729d44d6c5bbc062$export$9314c39552ab0f3e = "2px 2px 10px #bbb";

});
parcelRegister("l079f", function(module, exports) {

$parcel$export(module.exports, "UntitledUI", function () { return $f49f248341bf3308$export$3069487f41ab5fbf; });

var $hcjDr = parcelRequire("hcjDr");
var $f49f248341bf3308$export$3069487f41ab5fbf;
(function(UntitledUI) {
    /** Along with primary colors, it's helpful to have a selection of secondary colors to use in components such as pills, alerts and labels. These secondary colors should be used sparingly or as accents, while the primary color(s) should take precendence. */ UntitledUI.secondaryColors = [
        "gray-blue",
        "gray-cool",
        "gray-modern",
        "gray-neutral",
        "gray-iron",
        "gray-true",
        "gray-warm",
        "moss",
        "green-light",
        "green",
        "teal",
        "cyan",
        "blue-light",
        "blue",
        "blue-dark",
        "indigo",
        "violet",
        "purple",
        "fuchsia",
        "pink",
        "ros\xe9",
        "orange-dark",
        "orange",
        "yellow"
    ];
    /** A selection from the secondary colors that gives a balanced mix of colors when randomized.
     * */ UntitledUI.secondaryColorBalanced = [
        "gray-neutral",
        "moss",
        "green-light",
        "green",
        "teal",
        "cyan",
        "blue-light",
        "blue",
        "blue-dark",
        "indigo",
        "violet",
        "purple",
        "fuchsia",
        "pink",
        "ros\xe9",
        "orange-dark",
        "orange",
        "yellow"
    ];
    UntitledUI.secondaryColorsDistinct = [
        "ros\xe9",
        "gray-neutral",
        "moss",
        "orange",
        "cyan",
        "yellow",
        "orange",
        "orange-dark",
        "purple",
        "fuchsia",
        "pink",
        "blue",
        "indigo",
        "yellow",
        "green",
        "violet",
        "teal"
    ];
    function randomSecondaryColorNameDistinct(seed) {
        if (typeof seed === "string") {
            const rnd = new (0, $hcjDr.default)(seed);
            seed = rnd.nextInt();
        }
        return UntitledUI.secondaryColorsDistinct[seed % UntitledUI.secondaryColorsDistinct.length];
    }
    UntitledUI.randomSecondaryColorNameDistinct = randomSecondaryColorNameDistinct;
    function randomSecondaryColorName(seed) {
        const rnd = new (0, $hcjDr.default)(seed);
        return UntitledUI.secondaryColorBalanced[rnd.nextInt(0, UntitledUI.secondaryColorBalanced.length - 1)];
    }
    UntitledUI.randomSecondaryColorName = randomSecondaryColorName;
    function randomSecondaryColor(seed) {
        return UntitledUI.colorStyles[randomSecondaryColorName(seed)];
    }
    UntitledUI.randomSecondaryColor = randomSecondaryColor;
    function isColorStyle(s) {
        return s in UntitledUI.colorStyles;
    }
    UntitledUI.isColorStyle = isColorStyle;
    UntitledUI.colorStyles = {
        gray: {
            25: "#FCFCFD",
            50: "#F9FAFB",
            100: "#F2F4F7",
            200: "#EAECF0",
            300: "#D0D5DD",
            400: "#98A2B3",
            500: "#667085",
            600: "#475467",
            700: "#344054",
            800: "#1D2939",
            900: "#101828"
        },
        primary: {
            25: "#FCFAFF",
            50: "#F9F5FF",
            100: "#F4EBFF",
            200: "#E9D7FE",
            300: "#D6BBFB",
            400: "#B692F6",
            500: "#9E77ED",
            600: "#7F56D9",
            700: "#6941C6",
            800: "#53389E",
            900: "#42307D"
        },
        error: {
            25: "#FFFBFA",
            50: "#FEF3F2",
            100: "#FEE4E2",
            200: "#FECDCA",
            300: "#FDA29B",
            400: "#F97066",
            500: "#F04438",
            600: "#D92D20",
            700: "#B42318",
            800: "#912018",
            900: "#7A271A"
        },
        warning: {
            25: "#FFFCF5",
            50: "#FFFAEB",
            100: "#FEF0C7",
            200: "#FEDF89",
            300: "#FEC84B",
            400: "#FDB022",
            500: "#F79009",
            600: "#DC6803",
            700: "#B54708",
            800: "#93370D",
            900: "#7A2E0E"
        },
        success: {
            25: "#F6FEF9",
            50: "#ECFDF3",
            100: "#D1FADF",
            200: "#A6F4C5",
            300: "#6CE9A6",
            400: "#32D583",
            500: "#12B76A",
            600: "#039855",
            700: "#027A48",
            800: "#05603A",
            900: "#054F31"
        },
        "gray-blue": {
            25: "#FCFCFD",
            50: "#F8F9FC",
            100: "#EAECF5",
            200: "#D5D9EB",
            300: "#B3B8DB",
            400: "#717BBC",
            500: "#4E5BA6",
            600: "#3E4784",
            700: "#363F72",
            800: "#293056",
            900: "#101323"
        },
        "gray-cool": {
            25: "#FCFCFD",
            50: "#F9F9FB",
            100: "#EFF1F5",
            200: "#DCDFEA",
            300: "#B9C0D4",
            400: "#7D89B0",
            500: "#5D6B98",
            600: "#4A5578",
            700: "#404968",
            800: "#30374F",
            900: "#111322"
        },
        "gray-modern": {
            25: "#FCFCFD",
            50: "#F8FAFC",
            100: "#EEF2F6",
            200: "#E3E8EF",
            300: "#CDD5DF",
            400: "#9AA4B2",
            500: "#697586",
            600: "#4B5565",
            700: "#364152",
            800: "#202939",
            900: "#121926"
        },
        "gray-neutral": {
            25: "#FCFCFD",
            50: "#F9FAFB",
            100: "#F3F4F6",
            200: "#E5E7EB",
            300: "#D2D6DB",
            400: "#9DA4AE",
            500: "#6C737F",
            600: "#4D5761",
            700: "#384250",
            800: "#1F2A37",
            900: "#111927"
        },
        "gray-iron": {
            25: "#FCFCFC",
            50: "#FAFAFA",
            100: "#F4F4F5",
            200: "#E4E4E7",
            300: "#D1D1D6",
            400: "#A0A0AB",
            500: "#70707B",
            600: "#51525C",
            700: "#3F3F46",
            800: "#26272B",
            900: "#18181B"
        },
        "gray-true": {
            25: "#FCFCFC",
            50: "#FAFAFA",
            100: "#F5F5F5",
            200: "#E5E5E5",
            300: "#D6D6D6",
            400: "#A3A3A3",
            500: "#737373",
            600: "#525252",
            700: "#424242",
            800: "#292929",
            900: "#141414"
        },
        "gray-warm": {
            25: "#FDFDFC",
            50: "#FAFAF9",
            100: "#F5F5F4",
            200: "#E7E5E4",
            300: "#D7D3D0",
            400: "#A9A29D",
            500: "#79716B",
            600: "#57534E",
            700: "#44403C",
            800: "#292524",
            900: "#1C1917"
        },
        moss: {
            25: "#FAFDF7",
            50: "#F5FBEE",
            100: "#E6F4D7",
            200: "#CEEAB0",
            300: "#ACDC79",
            400: "#86CB3C",
            500: "#669F2A",
            600: "#4F7A21",
            700: "#3F621A",
            800: "#335015",
            900: "#2B4212"
        },
        "green-light": {
            25: "#FAFEF5",
            50: "#F3FEE7",
            100: "#E3FBCC",
            200: "#D0F8AB",
            300: "#A6EF67",
            400: "#85E13A",
            500: "#66C61C",
            600: "#4CA30D",
            700: "#3B7C0F",
            800: "#326212",
            900: "#2B5314"
        },
        green: {
            25: "#F6FEF9",
            50: "#EDFCF2",
            100: "#D3F8DF",
            200: "#AAF0C4",
            300: "#73E2A3",
            400: "#3CCB7F",
            500: "#16B364",
            600: "#099250",
            700: "#087443",
            800: "#095C37",
            900: "#084C2E"
        },
        teal: {
            25: "#F6FEFC",
            50: "#F0FDF9",
            100: "#CCFBEF",
            200: "#99F6E0",
            300: "#5FE9D0",
            400: "#2ED3B7",
            500: "#15B79E",
            600: "#0E9384",
            700: "#107569",
            800: "#125D56",
            900: "#134E48"
        },
        cyan: {
            25: "#F5FEFF",
            50: "#ECFDFF",
            100: "#CFF9FE",
            200: "#A5F0FC",
            300: "#67E3F9",
            400: "#22CCEE",
            500: "#06AED4",
            600: "#088AB2",
            700: "#0E7090",
            800: "#155B75",
            900: "#164C63"
        },
        "blue-light": {
            25: "#F5FBFF",
            50: "#F0F9FF",
            100: "#E0F2FE",
            200: "#B9E6FE",
            300: "#7CD4FD",
            400: "#36BFFA",
            500: "#0BA5EC",
            600: "#0086C9",
            700: "#026AA2",
            800: "#065986",
            900: "#0B4A6F"
        },
        blue: {
            25: "#F5FAFF",
            50: "#EFF8FF",
            100: "#D1E9FF",
            200: "#B2DDFF",
            300: "#84CAFF",
            400: "#53B1FD",
            500: "#2E90FA",
            600: "#1570EF",
            700: "#175CD3",
            800: "#1849A9",
            900: "#194185"
        },
        "blue-dark": {
            25: "#F5F8FF",
            50: "#EFF4FF",
            100: "#D1E0FF",
            200: "#B2CCFF",
            300: "#84ADFF",
            400: "#528BFF",
            500: "#2970FF",
            600: "#155EEF",
            700: "#004EEB",
            800: "#0040C1",
            900: "#00359E"
        },
        indigo: {
            25: "#F5F8FF",
            50: "#EEF4FF",
            100: "#E0EAFF",
            200: "#C7D7FE",
            300: "#A4BCFD",
            400: "#8098F9",
            500: "#6172F3",
            600: "#444CE7",
            700: "#3538CD",
            800: "#2D31A6",
            900: "#2D3282"
        },
        violet: {
            25: "#FBFAFF",
            50: "#F5F3FF",
            100: "#ECE9FE",
            200: "#DDD6FE",
            300: "#C3B5FD",
            400: "#A48AFB",
            500: "#875BF7",
            600: "#7839EE",
            700: "#6927DA",
            800: "#5720B7",
            900: "#491C96"
        },
        purple: {
            25: "#FAFAFF",
            50: "#F4F3FF",
            100: "#EBE9FE",
            200: "#D9D6FE",
            300: "#BDB4FE",
            400: "#9B8AFB",
            500: "#7A5AF8",
            600: "#6938EF",
            700: "#5925DC",
            800: "#4A1FB8",
            900: "#3E1C96"
        },
        fuchsia: {
            25: "#FEFAFF",
            50: "#FDF4FF",
            100: "#FBE8FF",
            200: "#F6D0FE",
            300: "#EEAAFD",
            400: "#E478FA",
            500: "#D444F1",
            600: "#BA24D5",
            700: "#9F1AB1",
            800: "#821890",
            900: "#6F1877"
        },
        pink: {
            25: "#FEF6FB",
            50: "#FDF2FA",
            100: "#FCE7F6",
            200: "#FCCEEE",
            300: "#FAA7E0",
            400: "#F670C7",
            500: "#EE46BC",
            600: "#DD2590",
            700: "#C11574",
            800: "#9E165F",
            900: "#851651"
        },
        "ros\xe9": {
            25: "#FFF5F6",
            50: "#FFF1F3",
            100: "#FFE4E8",
            200: "#FECDD6",
            300: "#FEA3B4",
            400: "#FD6F8E",
            500: "#F63D68",
            600: "#E31B54",
            700: "#C01048",
            800: "#A11043",
            900: "#89123E"
        },
        "orange-dark": {
            25: "#FFF9F5",
            50: "#FFF4ED",
            100: "#FFE6D5",
            200: "#FFD6AE",
            300: "#FF9C66",
            400: "#FF692E",
            500: "#FF4405",
            600: "#E62E05",
            700: "#BC1B06",
            800: "#97180C",
            900: "#771A0D"
        },
        orange: {
            25: "#FEFAF5",
            50: "#FEF6EE",
            100: "#FDEAD7",
            200: "#F9DBAF",
            300: "#F7B27A",
            400: "#F38744",
            500: "#EF6820",
            600: "#E04F16",
            700: "#B93815",
            800: "#932F19",
            900: "#772917"
        },
        yellow: {
            25: "#FEFDF0",
            50: "#FEFBE8",
            100: "#FEF7C3",
            200: "#FEEE95",
            300: "#FDE272",
            400: "#FAC515",
            500: "#EAAA08",
            600: "#CA8504",
            700: "#A15C07",
            800: "#854A0E",
            900: "#713B12"
        }
    };
})($f49f248341bf3308$export$3069487f41ab5fbf || ($f49f248341bf3308$export$3069487f41ab5fbf = {}));

});


parcelRegister("dOFTp", function(module, exports) {

$parcel$export(module.exports, "useObserveYProxy", function () { return $a0f070ded9e41b96$export$8f19772320aefea7; });
$parcel$export(module.exports, "useObserveYObject", function () { return $a0f070ded9e41b96$export$511fc6e9270ba89; });

var $eeH7J = parcelRequire("eeH7J");

var $4FdkC = parcelRequire("4FdkC");
function $a0f070ded9e41b96$export$8f19772320aefea7(proxy, deep = false) {
    const target = (0, $4FdkC.GetYProxyTarget)(proxy);
    $a0f070ded9e41b96$export$511fc6e9270ba89(target, deep);
    return target;
}

function $a0f070ded9e41b96$export$511fc6e9270ba89(target, deep = false) {
    const [, setVersion] = (0, $eeH7J.useState)({});
    const editing = !!target;
    (0, $eeH7J.useEffect)(()=>{
        if (!target) return;
        let unmounted = false;
        let observing = false;
        function onChange() {
            setVersion({});
        }
        async function observe() {
            const Y = await (parcelRequire("c1MwG"));
            if (target instanceof Y.Array || target instanceof Y.Map) {
                if (!unmounted && !observing) {
                    if (deep) target.observeDeep(onChange);
                    else target.observe(onChange);
                    observing = true;
                }
            }
        }
        observe();
        onChange();
        return ()=>{
            var _a;
            unmounted = true;
            if (observing && !((_a = target.doc) === null || _a === void 0 ? void 0 : _a.isDestroyed)) target.unobserve(onChange);
        };
    }, [
        editing,
        target,
        deep
    ]);
    return target;
}

});
parcelRegister("4FdkC", function(module, exports) {

$parcel$export(module.exports, "YProxyTarget", function () { return $3655551c6310b583$export$1416164d941e528f; });
$parcel$export(module.exports, "GetYProxyTarget", function () { return $3655551c6310b583$export$8d965473a46a1c61; });
// To avoid importing all of Y.js prematurely, this file contains the utilities needed
// for detecting whether a given object is a YProxy object
const $3655551c6310b583$export$1416164d941e528f = Symbol("proxy-target");
function $3655551c6310b583$export$b4a63b144ecf4f6f(obj) {
    return $3655551c6310b583$export$8d965473a46a1c61(obj) !== undefined;
}
function $3655551c6310b583$export$8d965473a46a1c61(obj) {
    return obj && typeof obj === "object" && obj[$3655551c6310b583$export$1416164d941e528f] || undefined;
}

});

parcelRegister("c1MwG", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("bGtNJ").then(()=>parcelRequire("aw3rr"));

});


parcelRegister("e2IHD", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("cPuQK"),
    $Ks0wJ("7twdE"),
    $Ks0wJ("2Hd1P"),
    $Ks0wJ("2tSsB"),
    $Ks0wJ("kEDuT"),
    $Ks0wJ("bGtNJ"),
    $Ks0wJ("02XaR"),
    $Ks0wJ("80vMu")
]).then(()=>parcelRequire("7c6pE"));

});


parcelRegister("2uIvI", function(module, exports) {

$parcel$export(module.exports, "EditableObject", function () { return $1d10e900091f309a$export$83a1fac83827d11a; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $fz3r9 = parcelRequire("fz3r9");

var $dOFTp = parcelRequire("dOFTp");

var $5JGam = parcelRequire("5JGam");

var $cwhCA = parcelRequire("cwhCA");

var $5iV0P = parcelRequire("5iV0P");

var $knIBr = parcelRequire("knIBr");
function $1d10e900091f309a$export$83a1fac83827d11a({ obj: obj, children: children, typeName: typeName, putType: putType, style: style, actions: actions, className: className }) {
    const { hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const { selectedObject: selectedObject, setSelectedObject: setSelectedObject } = (0, $knIBr.useSelectionContext)();
    const editing = (0, $5JGam.useIsEditing)();
    (0, $dOFTp.useObserveYProxy)(obj);
    const active = selectedObject === obj;
    const elementTarget = (0, $eeH7J.useRef)(null);
    (0, $5iV0P.SetEditableActions)(obj, actions);
    if (editing) return (0, $4vwom.jsx)("div", Object.assign({
        ref: elementTarget
    }, hoverProps, {
        onClick: (e)=>{
            setSelectedObject(obj, (0, $cwhCA.GetType)(typeName), putType ? (0, $cwhCA.GetType)(putType) : undefined);
            e.stopPropagation();
        },
        className: className,
        style: Object.assign({
            outline: active ? "1px solid #007bff" : "none"
        }, style),
        children: children
    }));
    else {
        if (style || className) return (0, $4vwom.jsx)("div", {
            style: style,
            className: className,
            children: children
        });
        else return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
            children: children
        });
    }
}

});

parcelRegister("9G56J", function(module, exports) {

$parcel$export(module.exports, "Section", function () { return $70bbff91a6fc8d69$export$6e2c8f0811a474ce; });
function $70bbff91a6fc8d69$export$6e2c8f0811a474ce(arg0, arg1) {
    const renderer = typeof arg1 === "function" ? arg1 : typeof arg0 === "function" ? arg0 : undefined;
    if (!renderer) throw new Error("Section renderer must be a function");
    let name = typeof arg0 === "string" ? arg0 : renderer.name;
    if (!renderer) throw new Error("Section renderer must be a function");
    if (name.includes("$")) {
        // This name has been changed by Parcel's scope hoisting. We need to
        // extract the original name.
        const parts = name.split("$");
        if (parts.includes("export")) throw new Error("Exported section function must specify name (the name is lost due to Parcel's scope hoisting)");
        name = parts[parts.length - 1];
    }
    const hadSection = $70bbff91a6fc8d69$export$6e2c8f0811a474ce.types.has(name);
    $70bbff91a6fc8d69$export$6e2c8f0811a474ce.types.set(name, renderer);
    const invalidateFuncs = $70bbff91a6fc8d69$export$6e2c8f0811a474ce.invalidators.get(name);
    if (hadSection && invalidateFuncs) setTimeout(()=>{
        for (const invalidate of invalidateFuncs)invalidate();
    }, 1);
}
$70bbff91a6fc8d69$export$6e2c8f0811a474ce.types = new Map();
/** Hot reload callbacks.
 *
 *  Since section types are not components directly, their wrappers need to be
 *  invalidated. This is done by calling the invalidate function when a section
 *  type is re-registered.
 */ $70bbff91a6fc8d69$export$6e2c8f0811a474ce.invalidators = new Map();

});

parcelRegister("kPHAc", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("kEDuT"),
    $Ks0wJ("bGtNJ"),
    $Ks0wJ("izP8j")
]).then(()=>parcelRequire("i9xRR"));

});


parcelRegister("jzNZd", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("hWXli").then(()=>parcelRequire("7YxHT"));

});

parcelRegister("8Xuux", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("bC65B").then(()=>parcelRequire("rpHX0"));

});

parcelRegister("hiCoo", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("i7Ut5").then(()=>parcelRequire("2WG1z"));

});

parcelRegister("jniej", function(module, exports) {
$parcel$export(module.exports, "getQuery", function () { return (parcelRequire("cWF8g")).getQuery; });
$parcel$export(module.exports, "useQueryNumber", function () { return (parcelRequire("cWF8g")).useQueryNumber; });
$parcel$export(module.exports, "useQueryString", function () { return (parcelRequire("cWF8g")).useQueryString; });
$parcel$export(module.exports, "useDebounce", function () { return (parcelRequire("gaj8U")).useDebounce; });
$parcel$export(module.exports, "useDebounceContent", function () { return (parcelRequire("gaj8U")).useDebounceContent; });
$parcel$export(module.exports, "usePreference", function () { return (parcelRequire("eK8Q4")).usePreference; });
$parcel$export(module.exports, "useSessionState", function () { return (parcelRequire("eK8Q4")).useSessionState; });
$parcel$export(module.exports, "useChangeNotifications", function () { return (parcelRequire("3SKqX")).useChangeNotifications; });
$parcel$export(module.exports, "WebSocketContext", function () { return (parcelRequire("3SKqX")).WebSocketContext; });
$parcel$export(module.exports, "WebSocketContextProvider", function () { return (parcelRequire("3SKqX")).WebSocketContextProvider; });
$parcel$export(module.exports, "useStateContainer", function () { return (parcelRequire("cCNWd")).useStateContainer; });
parcelRequire("cWF8g");
parcelRequire("gaj8U");
parcelRequire("jg1lX");
parcelRequire("eK8Q4");
parcelRequire("3SKqX");
parcelRequire("cCNWd");

});
parcelRegister("cWF8g", function(module, exports) {

$parcel$export(module.exports, "getQuery", function () { return $96caced927e146db$export$71eec30d9db46a56; });
$parcel$export(module.exports, "useQueryString", function () { return $96caced927e146db$export$5d88e6cb5cd2f422; });
$parcel$export(module.exports, "useQueryNumber", function () { return $96caced927e146db$export$1650421d65c0c1c0; });

var $eeH7J = parcelRequire("eeH7J");

var $kEB1E = parcelRequire("kEB1E");

var $lDBHC = parcelRequire("lDBHC");
function $96caced927e146db$export$796b81a51be0b38a(qsValue, options) {
    const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + qsValue + window.location.hash;
    if (options === null || options === void 0 ? void 0 : options.replace) window.history.replaceState({
        path: newUrl
    }, "", newUrl);
    else window.history.pushState({
        path: newUrl
    }, "", newUrl);
    $96caced927e146db$var$listeners.forEach((x)=>x());
}
function $96caced927e146db$export$8c7da94d5c72705a(path, options) {
    const newUrl = window.location.protocol + "//" + window.location.host + path + window.location.search + window.location.hash;
    if (options === null || options === void 0 ? void 0 : options.replace) window.history.replaceState({
        path: newUrl
    }, "", newUrl);
    else window.history.pushState({
        path: newUrl
    }, "", newUrl);
    $96caced927e146db$var$listeners.forEach((x)=>x());
}
function $96caced927e146db$export$71eec30d9db46a56() {
    if ((0, $lDBHC.IsNode)()) return {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($kEB1E))).parse(window.location.search);
}
function $96caced927e146db$var$setQueryStringValue(key, value, queryString = window.location.search, options) {
    const values = (0, (/*@__PURE__*/$parcel$interopDefault($kEB1E))).parse(queryString);
    if (values[key] !== value) {
        const newQsValue = (0, (/*@__PURE__*/$parcel$interopDefault($kEB1E))).stringify(Object.assign(Object.assign({}, values), {
            [key]: value
        }));
        $96caced927e146db$export$796b81a51be0b38a(`?${newQsValue}`, options);
    }
}
function $96caced927e146db$var$getQueryStringValue(key, queryString) {
    const values = (0, (/*@__PURE__*/$parcel$interopDefault($kEB1E))).parse(queryString || (0, $lDBHC.IsNode)() ? "0" : window.location.search);
    return values[key];
}
const $96caced927e146db$var$listeners = [];
function $96caced927e146db$export$5d88e6cb5cd2f422(key, initialValue) {
    const [value, setValue] = (0, $eeH7J.useState)(key && $96caced927e146db$var$getQueryStringValue(key) || initialValue);
    const onSetValue = (0, $eeH7J.useCallback)((newValue, options)=>{
        setValue(newValue);
        $96caced927e146db$var$setQueryStringValue(key, newValue, undefined, options);
        $96caced927e146db$var$listeners.forEach((x)=>x());
    }, [
        key
    ]);
    (0, $eeH7J.useEffect)(()=>{
        function listen() {
            setValue($96caced927e146db$var$getQueryStringValue(key) || initialValue);
        }
        window.addEventListener("popstate", listen);
        $96caced927e146db$var$listeners.push(listen);
        return ()=>{
            window.removeEventListener("popstate", listen);
            $96caced927e146db$var$listeners.splice($96caced927e146db$var$listeners.indexOf(listen), 1);
        };
    }, [
        key
    ]);
    return [
        value instanceof Array ? "" + value : value,
        onSetValue
    ];
}
function $96caced927e146db$export$1650421d65c0c1c0(key, initialValue) {
    const [valueStr, setValueStr] = $96caced927e146db$export$5d88e6cb5cd2f422(key, initialValue ? "" + initialValue : undefined);
    function setValue(newValue) {
        setValueStr(newValue === undefined ? undefined : "" + newValue);
    }
    const value = valueStr ? parseInt(valueStr) : initialValue;
    return [
        value === undefined || isNaN(value) ? initialValue : value,
        setValue
    ];
}

});
parcelRegister("kEB1E", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $f09443988f46afe0$export$f9380c9a627682d3; }, function (v) { return $f09443988f46afe0$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $f09443988f46afe0$export$98e6a39c04603d36; }, function (v) { return $f09443988f46afe0$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $f09443988f46afe0$export$fac44ee5b035f737; }, function (v) { return $f09443988f46afe0$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $f09443988f46afe0$export$7a5253c0f62e0150; }, function (v) { return $f09443988f46afe0$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $f09443988f46afe0$export$a8c1621ea79325d3; }, function (v) { return $f09443988f46afe0$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $f09443988f46afe0$export$357523c63a2253b9; }, function (v) { return $f09443988f46afe0$export$357523c63a2253b9 = v; });
$parcel$export(module.exports, "exclude", function () { return $f09443988f46afe0$export$44c361b8ec72ef7f; }, function (v) { return $f09443988f46afe0$export$44c361b8ec72ef7f = v; });
var $f09443988f46afe0$export$f9380c9a627682d3;
var $f09443988f46afe0$export$98e6a39c04603d36;
var $f09443988f46afe0$export$fac44ee5b035f737;
var $f09443988f46afe0$export$7a5253c0f62e0150;
var $f09443988f46afe0$export$a8c1621ea79325d3;
var $f09443988f46afe0$export$357523c63a2253b9;
var $f09443988f46afe0$export$44c361b8ec72ef7f;
"use strict";

var $3D7b0 = parcelRequire("3D7b0");

var $fHWdY = parcelRequire("fHWdY");

var $dejnV = parcelRequire("dejnV");

var $ktOwS = parcelRequire("ktOwS");
const $f09443988f46afe0$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $f09443988f46afe0$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $f09443988f46afe0$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            "[",
                            $f09443988f46afe0$var$encode(index, options),
                            "]=",
                            $f09443988f46afe0$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            "[]=",
                            $f09443988f46afe0$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            ":list=",
                            $f09443988f46afe0$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $f09443988f46afe0$var$encode(key, options),
                                keyValueSep,
                                $f09443988f46afe0$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $f09443988f46afe0$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $f09443988f46afe0$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            "=",
                            $f09443988f46afe0$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $f09443988f46afe0$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $f09443988f46afe0$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $f09443988f46afe0$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$f09443988f46afe0$var$decode(item, options)) : value === null ? value : $f09443988f46afe0$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $f09443988f46afe0$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$f09443988f46afe0$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $f09443988f46afe0$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $f09443988f46afe0$var$encode(value, options) {
    if (options.encode) return options.strict ? $3D7b0(value) : encodeURIComponent(value);
    return value;
}
function $f09443988f46afe0$var$decode(value, options) {
    if (options.decode) return $fHWdY(value);
    return value;
}
function $f09443988f46afe0$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $f09443988f46afe0$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $f09443988f46afe0$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $f09443988f46afe0$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $f09443988f46afe0$var$extract(input) {
    input = $f09443988f46afe0$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $f09443988f46afe0$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $f09443988f46afe0$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $f09443988f46afe0$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $f09443988f46afe0$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $dejnV(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $f09443988f46afe0$var$decode(value, options);
        formatter($f09443988f46afe0$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $f09443988f46afe0$var$parseValue(value[k], options);
        else ret[key] = $f09443988f46afe0$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $f09443988f46afe0$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$f09443988f46afe0$export$f9380c9a627682d3 = $f09443988f46afe0$var$extract;
$f09443988f46afe0$export$98e6a39c04603d36 = $f09443988f46afe0$var$parse;
$f09443988f46afe0$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $f09443988f46afe0$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $f09443988f46afe0$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $f09443988f46afe0$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $f09443988f46afe0$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $f09443988f46afe0$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $f09443988f46afe0$var$encode(key, options) + "=" + $f09443988f46afe0$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$f09443988f46afe0$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $dejnV(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $f09443988f46afe0$var$parse($f09443988f46afe0$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $f09443988f46afe0$var$decode(hash, options)
    } : {});
};
$f09443988f46afe0$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$f09443988f46afe0$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $f09443988f46afe0$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $f09443988f46afe0$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $f09443988f46afe0$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $f09443988f46afe0$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $f09443988f46afe0$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$f09443988f46afe0$var$encodeFragmentIdentifier] ? $f09443988f46afe0$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$f09443988f46afe0$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$f09443988f46afe0$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $f09443988f46afe0$export$7a5253c0f62e0150(input, options);
    return $f09443988f46afe0$export$a8c1621ea79325d3({
        url: url,
        query: $ktOwS(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$f09443988f46afe0$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $f09443988f46afe0$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("3D7b0", function(module, exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("fHWdY", function(module, exports) {
"use strict";
var $b6f80952369f3352$var$token = "%[a-f0-9]{2}";
var $b6f80952369f3352$var$singleMatcher = new RegExp("(" + $b6f80952369f3352$var$token + ")|([^%]+?)", "gi");
var $b6f80952369f3352$var$multiMatcher = new RegExp("(" + $b6f80952369f3352$var$token + ")+", "gi");
function $b6f80952369f3352$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $b6f80952369f3352$var$decodeComponents(left), $b6f80952369f3352$var$decodeComponents(right));
}
function $b6f80952369f3352$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($b6f80952369f3352$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $b6f80952369f3352$var$decodeComponents(tokens, i).join("");
            tokens = input.match($b6f80952369f3352$var$singleMatcher) || [];
        }
        return input;
    }
}
function $b6f80952369f3352$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $b6f80952369f3352$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $b6f80952369f3352$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $b6f80952369f3352$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $b6f80952369f3352$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("dejnV", function(module, exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("ktOwS", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});



parcelRegister("gaj8U", function(module, exports) {

$parcel$export(module.exports, "useDebounce", function () { return $bc4c6dd8bc02cf10$export$21805fee57372823; });
$parcel$export(module.exports, "useDebounceContent", function () { return $bc4c6dd8bc02cf10$export$3c99bec7f5d8d03c; });

var $eeH7J = parcelRequire("eeH7J");
function $bc4c6dd8bc02cf10$export$21805fee57372823(state /** How many milliseconds the signal must be idle before we fire. */ , milliseconds = 500, /** Whether the debounce is currently suspended. It will not fire until un-suspened. */ suspend = false, /**
 * The initial state to use before the first debounce. If not provided, the
 * initial state will be the same as the current state.
 */ initialState) {
    const [debounced, setDebounced] = (0, $eeH7J.useState)(initialState !== undefined ? initialState : state);
    (0, $eeH7J.useEffect)(()=>{
        if (suspend) return;
        const timeout = setTimeout(()=>setDebounced(state), milliseconds);
        return ()=>clearTimeout(timeout);
    }, [
        state,
        milliseconds,
        suspend
    ]);
    return debounced;
}
function $bc4c6dd8bc02cf10$export$3c99bec7f5d8d03c(object, /** How many milliseconds the signal must be idle before we fire. */ milliseconds = 500, /** Whether the debounce is currently suspended. It will not fire until un-suspened. */ suspend = false) {
    const str = JSON.stringify(object);
    const res = $bc4c6dd8bc02cf10$export$21805fee57372823(str, milliseconds, suspend);
    if (res === str) return object;
    else return JSON.parse(res);
}

});

parcelRegister("jg1lX", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");
function $e0508fa916efea46$export$69f38700ea0cb3b9(value, milliseconds, shouldDelay) {
    const [delayedValue, setDelayedValue] = (0, $eeH7J.useState)(value);
    (0, $eeH7J.useEffect)(()=>{
        if (delayedValue !== value) {
            if (!shouldDelay || shouldDelay(value)) setTimeout(()=>setDelayedValue(value), milliseconds);
            else setDelayedValue(value);
        }
    }, [
        value
    ]);
    return !shouldDelay || shouldDelay(value) ? delayedValue : value;
}

});

parcelRegister("cCNWd", function(module, exports) {

$parcel$export(module.exports, "useStateContainer", function () { return $930fc549b97c0fee$export$352ab317a531d821; });

var $eeH7J = parcelRequire("eeH7J");
function $930fc549b97c0fee$export$352ab317a531d821(/** A function that creates the state container. Will be called once for the lifetime of the
 * component. Returns an object that reflects a piece of state. */ create) {
    const [, setVersion] = (0, $eeH7J.useState)({});
    const [state, setState] = (0, $eeH7J.useState)();
    (0, $eeH7J.useEffect)(()=>{
        const sc = create(()=>setVersion({}));
        setState(sc);
        return ()=>{
            var _a;
            (_a = sc.destroy) === null || _a === void 0 || _a.call(sc);
        };
    }, // Intentional empty dependency array, we want this effect to run
    // EXACTLY once when the component is mounted/unmounted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return state;
}

});


parcelRegister("lPiLr", function(module, exports) {


module.exports = (parcelRequire("hYRbp"))((parcelRequire("3ueMA")).resolve("gTjXO"));

});
parcelRegister("hYRbp", function(module, exports) {
"use strict";

var $1BYLw = parcelRequire("1BYLw");
module.exports = $1BYLw(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("1BYLw", function(module, exports) {
"use strict";
var $12c861ed33d66216$var$cachedBundles = {};
var $12c861ed33d66216$var$cachedPreloads = {};
var $12c861ed33d66216$var$cachedPrefetches = {};
function $12c861ed33d66216$var$getCache(type) {
    switch(type){
        case "preload":
            return $12c861ed33d66216$var$cachedPreloads;
        case "prefetch":
            return $12c861ed33d66216$var$cachedPrefetches;
        default:
            return $12c861ed33d66216$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $12c861ed33d66216$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("iz9uZ", function(module, exports) {


module.exports = (parcelRequire("hYRbp"))((parcelRequire("3ueMA")).resolve("2pb92"));

});

parcelRegister("2ewgS", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("baOZu").then(()=>parcelRequire("jRYEP"));

});

parcelRegister("8vTN8", function(module, exports) {

$parcel$export(module.exports, "useNavigate", function () { return $632c7f077da66289$export$9770f232ac06a008; });
parcelRequire("5K1mb");
var $18Pjr = parcelRequire("18Pjr");

var $cSf8f = parcelRequire("cSf8f");
function $632c7f077da66289$export$9770f232ac06a008() {
    const routerNavigate = (0, $18Pjr.useNavigate)();
    return function(to, options) {
        if ($632c7f077da66289$export$9770f232ac06a008.unsavedChanges.size > 0) {
            if (!confirm((0, $cSf8f.ClientSideLocalize)({
                en: "You have unsaved changes, that will stay as draft but not be applied if you leave. Are you sure you want to leave?",
                no: "Du har endringer som ikke er lagret, men som forblir som utkast hvis du forlater siden. Er du sikker p\xe5 at du vil forlate siden?",
                sv: "Du har \xe4ndringar som inte \xe4r sparade, men som f\xf6rblir som utkast om du l\xe4mnar sidan. \xc4r du s\xe4ker p\xe5 att du vill l\xe4mna sidan?",
                da: "Du har \xe6ndringer, der ikke er gemt, men som forbliver som kladde, hvis du forlader siden. Er du sikker p\xe5, at du vil forlade siden?"
            }))) return;
        }
        // Call the right overload for "number"
        if (typeof to === "number") routerNavigate(to);
        else routerNavigate(to, options);
    };
}
/**
 * A set of things that contain unsaved changes, that should be checked before
 * navigating away from the page. If this set is non-empty, the user will be
 * prompted to confirm navigation.
 */ $632c7f077da66289$export$9770f232ac06a008.unsavedChanges = new Set();

});

parcelRegister("gssTr", function(module, exports) {

$parcel$export(module.exports, "LocalesContext", function () { return $bfb5ac729b0000a2$export$106919b855e045f7; });
$parcel$export(module.exports, "useLocalesContext", function () { return $bfb5ac729b0000a2$export$f4bfbb366fc3bb33; });
$parcel$export(module.exports, "LocalesProvider", function () { return $bfb5ac729b0000a2$export$af5ff3ef761dd229; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $dUDPg = parcelRequire("dUDPg");
const $bfb5ac729b0000a2$export$106919b855e045f7 = /*#__PURE__*/ (0, $eeH7J.createContext)("not set");
function $bfb5ac729b0000a2$export$f4bfbb366fc3bb33() {
    const locales = (0, $eeH7J.useContext)($bfb5ac729b0000a2$export$106919b855e045f7);
    if (locales === "not set") throw new Error("Missing LocalesProvider - Did you forget to wrap your app in <LocalesProvider>?");
    if (locales === "loading") return undefined;
    return locales;
}
function $bfb5ac729b0000a2$export$af5ff3ef761dd229({ children: children }) {
    const { data: locales } = (0, $dUDPg.useLocales)();
    return (0, $4vwom.jsx)($bfb5ac729b0000a2$export$106919b855e045f7.Provider, {
        value: locales !== null && locales !== void 0 ? locales : "loading",
        children: children
    });
}

});

parcelRegister("btSzs", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("jixPX").then(()=>parcelRequire("epaGf"));

});

parcelRegister("jwy4G", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("fkdgT").then(()=>parcelRequire("55M9p"));

});

parcelRegister("hV5w0", function(module, exports) {

$parcel$export(module.exports, "WidgetContext", function () { return $d0bc09c0ad65b593$export$a0936c9989b92d74; });
$parcel$export(module.exports, "useWidgetState", function () { return $d0bc09c0ad65b593$export$b323c00015b1e5c6; });
$parcel$export(module.exports, "useQueryWidgetState", function () { return $d0bc09c0ad65b593$export$9dcbef1d878cbdab; });
$parcel$export(module.exports, "usePerformWidgetAction", function () { return $d0bc09c0ad65b593$export$d11f059ac44ffa64; });
$parcel$export(module.exports, "useExecuteClientEffects", function () { return $d0bc09c0ad65b593$export$39be389e71712c16; });

var $4vwom = parcelRequire("4vwom");

var $xQZCR = parcelRequire("xQZCR");

var $eeH7J = parcelRequire("eeH7J");

var $8vTN8 = parcelRequire("8vTN8");

var $ikBJm = parcelRequire("ikBJm");

var $4rY0U = parcelRequire("4rY0U");

var $9SFXB = parcelRequire("9SFXB");

var $bUDfc = parcelRequire("bUDfc");
parcelRequire("jniej");
var $cWF8g = parcelRequire("cWF8g");
const $d0bc09c0ad65b593$export$a0936c9989b92d74 = /*#__PURE__*/ (0, $eeH7J.createContext)({
    state: {},
    setState () {
        throw new Error("No widget context");
    },
    refresh () {
        throw new Error("No widget context");
    },
    performAction () {
        throw new Error("No widget context");
    },
    root: null
});
function $d0bc09c0ad65b593$var$useWidgetContext() {
    return (0, $eeH7J.useContext)($d0bc09c0ad65b593$export$a0936c9989b92d74);
}
function $d0bc09c0ad65b593$export$af108391d0e7838c(key) {
    const { state: state, setState: setState } = $d0bc09c0ad65b593$var$useWidgetContext();
    if (!(key in state)) state[key] = {};
    return [
        state[key],
        (value)=>{
            return setState(Object.assign(Object.assign({}, state), {
                [key]: value
            }));
        }
    ];
}
function $d0bc09c0ad65b593$export$b323c00015b1e5c6(key, name, defaultValue) {
    const [state, setState] = $d0bc09c0ad65b593$export$af108391d0e7838c(key);
    const setter = (0, $eeH7J.useCallback)(async (value)=>{
        if (value === defaultValue) {
            const newState = Object.assign({}, state);
            delete newState[name];
            await setState(newState);
        } else await setState(Object.assign(Object.assign({}, state), {
            [name]: value
        }));
    }, // The `setState` function returned from useWidgetStateObject is not
    // stable, so we don't include it in the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        name,
        defaultValue,
        state
    ]);
    return [
        state[name] || defaultValue,
        setter
    ];
}
function $d0bc09c0ad65b593$export$9dcbef1d878cbdab(key, name, defaultValue, /**
 * Whether the caller is the page master widget. If true, the name of the
 * state will be used directly for a prettier URL. If false, the name will
 * be prefixed with the key to avoid conflicts with other widgets on the
 * same page.
 */ isPageMaster = false, disabled = false) {
    const [state, setState] = $d0bc09c0ad65b593$export$b323c00015b1e5c6(key, name, defaultValue);
    const [masterState, setMasterState] = (0, $eeH7J.useState)(state);
    if (disabled) return [
        state !== null && state !== void 0 ? state : defaultValue,
        setState
    ];
    const query = isPageMaster ? name : `${key}.${name}`;
    const [queryValue, setQueryValue] = // eslint-disable-next-line react-hooks/rules-of-hooks
    typeof defaultValue === "string" ? (0, $cWF8g.useQueryString)(query) : (0, $cWF8g.useQueryNumber)(query);
    if (queryValue === undefined) // If the query value is not set, revert to the default value
    {
        if (state !== defaultValue) {
            setMasterState(defaultValue);
            setState(defaultValue);
        }
    } else if (queryValue !== masterState) {
        setMasterState(queryValue);
        setState(queryValue);
    }
    return [
        queryValue !== null && queryValue !== void 0 ? queryValue : defaultValue,
        (value)=>{
            if (value === defaultValue) setQueryValue(undefined, {
                replace: true
            });
            else setQueryValue(value, {
                replace: true
            });
            setMasterState(value);
            setState(value);
        }
    ];
}
function $d0bc09c0ad65b593$export$d11f059ac44ffa64() {
    return $d0bc09c0ad65b593$var$useWidgetContext().performAction;
}
function $d0bc09c0ad65b593$export$39be389e71712c16() {
    const navigate = (0, $8vTN8.useNavigate)();
    const { modal: modal, showModal: showModal } = (0, $ikBJm.useContextualModal)();
    return {
        modal: modal,
        showModal: showModal,
        executeClientEffects: (0, $eeH7J.useCallback)((effects)=>{
            var _a;
            for (const effect of effects)switch(effect.type){
                case "Navigate":
                    navigate(effect.to.valueOf());
                    break;
                case "NavigateOpen":
                    window.open(effect.to.valueOf(), "");
                    break;
                case "SaveFile":
                    /**
                         * Directly sending a blob as the fileContent does not work
                         * The fileContent will always be a string and if the file type is
                         * pdf, it will be converted to Uint8Array to be transformed in blob
                         */ (0, $xQZCR.saveAs)(new Blob([
                        effect.contentType === "application/pdf" ? $d0bc09c0ad65b593$var$mapUriToUIntArray(effect.fileContent) : effect.fileContent
                    ], {
                        type: (_a = effect.contentType) !== null && _a !== void 0 ? _a : "text/plain;charset=utf-8"
                    }), effect.fileName);
                    break;
                case "MessageBox":
                    alert(effect.message);
                    break;
                case "OpenModal":
                    showModal(()=>(0, $4vwom.jsx)($d0bc09c0ad65b593$var$WidgetKeyView, {
                            widgetKey: effect.widgetKey
                        }));
                    break;
                case "CloseModal":
                    (0, $ikBJm.closeContextualModal)();
                    break;
                default:
                    alert("Unimplemented client effect: " + JSON.stringify(effect));
                    break;
            }
        }, [
            navigate,
            (0, $xQZCR.saveAs)
        ])
    };
}
function $d0bc09c0ad65b593$var$WidgetKeyView(props) {
    const { root: root } = $d0bc09c0ad65b593$var$useWidgetContext();
    const widget = (0, $9SFXB.FindWidgetByKey)(root, props.widgetKey);
    if (!widget) return (0, $4vwom.jsxs)("div", {
        children: [
            "Widget not found: ",
            props.widgetKey
        ]
    });
    if (!(0, $bUDfc.IsModal)(widget)) return (0, $4vwom.jsxs)("div", {
        children: [
            "Widget is not modal: ",
            props.widgetKey
        ]
    });
    return (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
        value: widget.widget
    });
}
function $d0bc09c0ad65b593$var$mapUriToUIntArray(uri) {
    const base64String = uri.split(",")[1];
    const binaryString = atob(base64String);
    return Uint8Array.from([
        ...binaryString
    ].map((char)=>char.charCodeAt(0)));
}

});
parcelRegister("xQZCR", function(module, exports) {
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(module.exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, module.exports = g;
});

});

parcelRegister("4rY0U", function(module, exports) {

$parcel$export(module.exports, "WidgetView", function () { return $33d83c7f9591d66d$export$ae6a4a1be5e9cbfc; });
$parcel$export(module.exports, "RegisterWidget", function () { return $33d83c7f9591d66d$export$4848b266ceb89698; });

var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");

var $9Q5xE = parcelRequire("9Q5xE");

var $bUDfc = parcelRequire("bUDfc");
const $33d83c7f9591d66d$var$widgets = [];
function $33d83c7f9591d66d$export$ae6a4a1be5e9cbfc(props) {
    if (props.value === undefined) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    // Modals are not rendered in the normal widget tree, so we don't want to
    // display them here.
    if (props.value && (0, $bUDfc.IsModal)(props.value)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    for (const widget of $33d83c7f9591d66d$var$widgets){
        const res = widget(props);
        if (res) return res;
    }
    try {
        return (0, $4vwom.jsx)("div", {
            style: {
                color: "orangered"
            },
            children: JSON.stringify(props)
        });
    } catch (_a) {
        return (0, $4vwom.jsx)("div", {
            style: {
                color: "orangered"
            },
            children: "(There was a problem displaying this widget)"
        });
    }
}
function $33d83c7f9591d66d$export$4848b266ceb89698(type, widget) {
    if (type) $33d83c7f9591d66d$var$widgets.push((props)=>{
        if (props.value === null) return;
        if (props.value instanceof Array) return;
        if (typeof props.value !== "object") return;
        if (!("type" in props.value)) return;
        if (props.value.type !== type) return;
        return widget(props);
    });
    else $33d83c7f9591d66d$var$widgets.push(widget);
}
$33d83c7f9591d66d$export$4848b266ceb89698(undefined, ({ value: value, tableCell: tableCell })=>{
    if (typeof value === "string") {
        if (tableCell) return (0, $4vwom.jsx)("div", {
            style: {
                fontSize: 14,
                color: tableCell ? (0, $9Q5xE.ColorStyles).gray[500] : undefined
            },
            children: value
        });
        else return (0, $4vwom.jsx)("div", {
            style: {
                marginLeft: 16,
                marginRight: 16
            },
            children: value
        });
    }
});
$33d83c7f9591d66d$export$4848b266ceb89698(undefined, ({ value: value, tableCell: tableCell })=>{
    if (typeof value === "number") {
        if (tableCell) return (0, $4vwom.jsx)("div", {
            style: {
                fontSize: 14,
                color: tableCell ? (0, $9Q5xE.ColorStyles).gray[500] : undefined
            },
            children: value
        });
        else return (0, $4vwom.jsx)("div", {
            style: {
                marginLeft: 16,
                marginRight: 16
            },
            children: value.toString()
        });
    }
});
$33d83c7f9591d66d$export$4848b266ceb89698(undefined, ({ value: value })=>{
    if (value === null) return (0, $4vwom.jsx)("code", {
        children: "null"
    });
});
$33d83c7f9591d66d$export$4848b266ceb89698(undefined, (props)=>{
    if (props.value === undefined) return (0, $4vwom.jsx)("code", {
        children: "undefined"
    });
});

});
parcelRegister("bUDfc", function(module, exports) {

$parcel$export(module.exports, "IsTableRow", function () { return $8ac35dc18aa11ea5$export$8f761ebef3f2c9fc; });
$parcel$export(module.exports, "IsTable", function () { return $8ac35dc18aa11ea5$export$dbad54f406b7fd2a; });
$parcel$export(module.exports, "IsItem", function () { return $8ac35dc18aa11ea5$export$3904c07b31859f10; });
$parcel$export(module.exports, "IsButton", function () { return $8ac35dc18aa11ea5$export$26d3ab61f34a55fe; });
$parcel$export(module.exports, "IsModal", function () { return $8ac35dc18aa11ea5$export$ce54036c659cba49; });
$parcel$export(module.exports, "IsWidgetBase", function () { return $8ac35dc18aa11ea5$export$6613534c3ddf540a; });
function $8ac35dc18aa11ea5$export$8f761ebef3f2c9fc(w) {
    return w !== null && !(w instanceof Array) && typeof w === "object" && !("type" in w);
}
function $8ac35dc18aa11ea5$export$dbad54f406b7fd2a(w) {
    return w !== null && typeof w === "object" && "type" in w && w.type === "Table";
}
function $8ac35dc18aa11ea5$export$3904c07b31859f10(w) {
    return !!(w && typeof w === "object" && "type" in w && w.type === "Item");
}
function $8ac35dc18aa11ea5$export$26d3ab61f34a55fe(widget) {
    return !!(widget && typeof widget === "object" && "type" in widget && widget.type === "Button");
}
function $8ac35dc18aa11ea5$export$ce54036c659cba49(widget) {
    return !!(widget && typeof widget === "object" && "type" in widget && widget.type === "Modal");
}
function $8ac35dc18aa11ea5$export$6613534c3ddf540a(widget) {
    return widget && typeof widget === "object";
}

});


parcelRegister("9SFXB", function(module, exports) {

$parcel$export(module.exports, "FindWidgetByKey", function () { return $7319b4ab976d7169$export$8877d2178be5a8e9; });
$parcel$export(module.exports, "ExtractPrimaryItemFromWidget", function () { return $7319b4ab976d7169$export$b3961701b234014; });
$parcel$export(module.exports, "ExtractPropFromWidget", function () { return $7319b4ab976d7169$export$c7c832d3f94b6f1f; });

var $fQXMV = parcelRequire("fQXMV");

var $bUDfc = parcelRequire("bUDfc");
function $7319b4ab976d7169$export$11228c853abac5c6(row) {
    if (row instanceof Promise) return row;
    if ((0, $bUDfc.IsTableRow)(row)) {
        const res = {};
        let promises;
        for (const key of Object.keys(row))try {
            const fn = row[key];
            if (fn instanceof Function) res[key] = fn();
            else res[key] = fn;
            const widget = res[key];
            if (widget instanceof Promise) {
                promises !== null && promises !== void 0 ? promises : promises = [];
                promises.push(widget);
                // Avoid global unhandled promise rejection (which would
                // crash the entire server). Instead we catch the error
                // and display the error message in place of the widget
                widget.catch((e)=>{
                    res[key] = (0, $fQXMV.Empty)(e.message, "Error");
                });
            }
        } catch (e) {
            res[key] = [
                "This tab failed to render because of an error",
                e.message
            ].concat(e.stack.split("\n"));
        }
        if (promises) return Promise.all(promises).then(()=>res);
        return res;
    }
    return row;
}
function $7319b4ab976d7169$var$isWidget(obj) {
    return !!obj && typeof obj === "object" && "type" in obj && "widgetKey" in obj && typeof obj.widgetKey === "string";
}
function $7319b4ab976d7169$export$40fb48d0451e4a99(root, res = [], seen = new Set()) {
    if (seen.has(root)) return res;
    seen.add(root);
    if ($7319b4ab976d7169$var$isWidget(root)) res.push(root);
    if (typeof root === "object") for(const prop in root)$7319b4ab976d7169$export$40fb48d0451e4a99(root[prop], res, seen);
    return res;
}
function $7319b4ab976d7169$export$b2ecdf4402c9d7eb(root) {
    const widgets = $7319b4ab976d7169$export$40fb48d0451e4a99(root);
    const keys = new Set();
    for (const widget of widgets){
        if (keys.has(widget.widgetKey)) throw new Error(`Duplicate widgetKey '${widget.widgetKey}'`);
        keys.add(widget.widgetKey);
    }
}
function $7319b4ab976d7169$export$8877d2178be5a8e9(root, key) {
    const res = [];
    $7319b4ab976d7169$var$FindMultipleWidgetsByKey(root, key, res);
    if (res.length > 1) throw new Error(`Multiple widgets with key '${key}' - please provide unique widgetKey to disambiguate`);
    if (res.length === 0) return undefined;
    return res[0];
}
function $7319b4ab976d7169$var$FindMultipleWidgetsByKey(root, key, result) {
    if ((0, $bUDfc.IsWidgetBase)(root) && root.widgetKey === key) result.push(root);
    if (root instanceof Array) {
        for (const child of root)$7319b4ab976d7169$var$FindMultipleWidgetsByKey(child, key, result);
        return;
    }
    if ((0, $bUDfc.IsButton)(root)) {
        if (root.dropdown) {
            for (const subButton of root.dropdown)$7319b4ab976d7169$var$FindMultipleWidgetsByKey(subButton, key, result);
            return;
        }
    }
    if ((0, $bUDfc.IsModal)(root)) {
        $7319b4ab976d7169$var$FindMultipleWidgetsByKey(root.widget, key, result);
        return;
    }
    if ((0, $bUDfc.IsTable)(root)) {
        $7319b4ab976d7169$var$FindMultipleWidgetsByKey(root.buttons, key, result);
        $7319b4ab976d7169$var$FindMultipleWidgetsByKey(root.widget, key, result);
        for (const row of root.rows)for (const column of Object.keys(row)){
            const cell = row[column];
            $7319b4ab976d7169$var$FindMultipleWidgetsByKey(cell, key, result);
        }
        return;
    }
    // Table row case
    if (root !== null && typeof root === "object") for(const field in root)$7319b4ab976d7169$var$FindMultipleWidgetsByKey(root[field], key, result);
}
function $7319b4ab976d7169$export$cbbb192622182f06(root, key, method = "action") {
    const widget = $7319b4ab976d7169$export$8877d2178be5a8e9(root, key);
    return widget && typeof widget === "object" && method in widget && widget[method] instanceof Function ? widget[method] : undefined;
}
function $7319b4ab976d7169$export$b3961701b234014(view) {
    var _a;
    if (view === undefined) return (0, $fQXMV.Empty)("Not specified");
    if ((0, $bUDfc.IsItem)(view)) return view;
    if (view && typeof view === "object") for (const col of Object.keys(view)){
        const w = view[col];
        if ((0, $bUDfc.IsItem)(w)) return w;
    }
    const text = (_a = $7319b4ab976d7169$export$c7c832d3f94b6f1f(view, "primary")) !== null && _a !== void 0 ? _a : "(no text)";
    return {
        type: "Item",
        primary: text
    };
}
function $7319b4ab976d7169$export$c7c832d3f94b6f1f(view, field = "primary") {
    if ((0, $bUDfc.IsItem)(view)) return view[field];
    if (view && typeof view === "object") for (const col of Object.keys(view)){
        const w = view[col];
        if ((0, $bUDfc.IsItem)(w)) return w[field];
    }
    if (view && typeof view === "object") for (const col of Object.keys(view)){
        const w = view[col];
        if (typeof w === "string") return w;
        if (typeof w === "number") return "" + w;
    }
    if (typeof view === "string") return view;
    if (typeof view === "number") return "" + view;
    return "" + JSON.stringify(view);
}

});
parcelRegister("fQXMV", function(module, exports) {

$parcel$export(module.exports, "Empty", function () { return $b8aa17044d722db5$export$1f74963c34e8bfec; });

var $5cQqO = parcelRequire("5cQqO");
(0, $5cQqO.TSQFunction)($b8aa17044d722db5$export$1f74963c34e8bfec);
function $b8aa17044d722db5$export$1f74963c34e8bfec(widget, variant) {
    return {
        type: "Empty",
        widget: widget !== null && widget !== void 0 ? widget : "Empty",
        variant: variant
    };
}

});



parcelRegister("7v7E9", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("cPuQK"),
    $Ks0wJ("7twdE"),
    $Ks0wJ("2Hd1P"),
    $Ks0wJ("2tSsB"),
    $Ks0wJ("80vMu"),
    $Ks0wJ("kEDuT"),
    $Ks0wJ("bGtNJ"),
    $Ks0wJ("02XaR"),
    $Ks0wJ("8Crgg")
]).then(()=>parcelRequire("3ZE9P"));

});

parcelRegister("f0wM3", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("5PmKX"),
    $Ks0wJ("cPuQK"),
    $Ks0wJ("7twdE"),
    $Ks0wJ("2Hd1P"),
    $Ks0wJ("2tSsB"),
    $Ks0wJ("80vMu"),
    $Ks0wJ("kEDuT"),
    $Ks0wJ("bGtNJ"),
    $Ks0wJ("02XaR"),
    $Ks0wJ("3J0uB")
]).then(()=>parcelRequire("5Wt7y"));

});

parcelRegister("cewlD", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("2tSsB"),
    $Ks0wJ("5fZO2")
]).then(()=>parcelRequire("aRRkE"));

});

parcelRegister("5k9Zg", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("cPuQK"),
    $Ks0wJ("7twdE"),
    $Ks0wJ("2Hd1P"),
    $Ks0wJ("2tSsB"),
    $Ks0wJ("80vMu"),
    $Ks0wJ("kEDuT"),
    $Ks0wJ("bGtNJ"),
    $Ks0wJ("02XaR"),
    $Ks0wJ("6gAYS")
]).then(()=>parcelRequire("jhIQl"));

});

parcelRegister("ii2We", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("bsxF7").then(()=>parcelRequire("c4Sut"));

});

parcelRegister("2g57I", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("ayYuL").then(()=>parcelRequire("6Sp7a"));

});

parcelRegister("flxzf", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("2Hd1P"),
    $Ks0wJ("kXikT")
]).then(()=>parcelRequire("4FbLI"));

});

parcelRegister("6noo6", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("5PmKX"),
    $Ks0wJ("cPuQK"),
    $Ks0wJ("7twdE"),
    $Ks0wJ("2Hd1P"),
    $Ks0wJ("2tSsB"),
    $Ks0wJ("80vMu"),
    $Ks0wJ("kEDuT"),
    $Ks0wJ("bGtNJ"),
    $Ks0wJ("02XaR"),
    $Ks0wJ("39fzk")
]).then(()=>parcelRequire("5tTvz"));

});

parcelRegister("dwPtD", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("5PmKX"),
    $Ks0wJ("cPuQK"),
    $Ks0wJ("7twdE"),
    $Ks0wJ("2Hd1P"),
    $Ks0wJ("2tSsB"),
    $Ks0wJ("80vMu"),
    $Ks0wJ("kEDuT"),
    $Ks0wJ("bGtNJ"),
    $Ks0wJ("02XaR"),
    $Ks0wJ("lOOBd")
]).then(()=>parcelRequire("7Fezt"));

});

parcelRegister("3kELz", function(module, exports) {

$parcel$export(module.exports, "MarkdownEditor", function () { return $26d2dcaeddf4c8de$export$18a9461578883ec4; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $jF6Vs = parcelRequire("jF6Vs");

var $14q7s = parcelRequire("14q7s");

var $4SGh4 = parcelRequire("4SGh4");

var $dUDPg = parcelRequire("dUDPg");

var $9Q5xE = parcelRequire("9Q5xE");

var $aIeEI = parcelRequire("aIeEI");

var $cSf8f = parcelRequire("cSf8f");

var $6sp4J = parcelRequire("6sp4J");

var $ikBJm = parcelRequire("ikBJm");

var $fT6Pt = parcelRequire("fT6Pt");

var $8MAXm = parcelRequire("8MAXm");

var $2chu2 = parcelRequire("2chu2");


function $26d2dcaeddf4c8de$export$18a9461578883ec4(props) {
    const [editor, setEditor] = (0, $eeH7J.useState)(null);
    (0, $eeH7J.useEffect)(()=>{
        async function load() {
            const draftJs = await (parcelRequire("cUDOr"));
            const draftJsMdConverter = await (parcelRequire("hPh1J"));
            setEditor((0, $4vwom.jsx)($26d2dcaeddf4c8de$var$MarkdownEditorInternal, Object.assign({}, props, {
                draftJs: draftJs,
                draftJsMdConverter: draftJsMdConverter,
                style: props.style,
                autoFocus: props.autoFocus !== undefined ? props.autoFocus : props.style === "wysiwyg",
                markdownSnippetId: props.markdownSnippetId
            })));
        }
        load();
    }, [
        props.value,
        props.onChanged,
        props.onDrop,
        props.onDone,
        props.markdownSnippetId
    ]);
    return editor;
}
function $26d2dcaeddf4c8de$var$MarkdownEditorInternal(props) {
    const [ref, setRef] = (0, $eeH7J.useState)(null);
    const [focus, setFocus] = (0, $eeH7J.useState)(false);
    const getEditorStateFromProps = ()=>{
        var _a;
        return props.draftJs.EditorState.createWithContent(props.draftJs.convertFromRaw(props.draftJsMdConverter.mdToDraftjs(((_a = props.value) === null || _a === void 0 ? void 0 : _a.valueOf()) || "")));
    };
    const [editorState, setEditorState] = (0, $eeH7J.useState)(getEditorStateFromProps);
    function onNewEditorState(e) {
        setEditorState(e);
        const newValue = props.draftJsMdConverter.draftjsToMd(props.draftJs.convertToRaw(e.getCurrentContent()));
        // If the value is undefined and the new value is an empty string, we
        // don't want to call onChanged, because that would mark the document as
        // dirty before we have started typing anything
        if (props.value === undefined && newValue.valueOf() === "") return;
        if (props.value !== newValue) props.onChanged(newValue);
    }
    // Detect changes in the value prop and update the editor state accordingly
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        if (!focus) setEditorState(props.draftJs.EditorState.createWithContent(props.draftJs.convertFromRaw(props.draftJsMdConverter.mdToDraftjs(((_a = props.value) === null || _a === void 0 ? void 0 : _a.valueOf()) || ""))));
    }, [
        focus,
        props.value
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (props.autoFocus && ref) ref.focus();
    }, [
        ref,
        props.autoFocus
    ]);
    return (0, $4vwom.jsxs)("div", {
        className: props.style === "studio" ? "form-control" : undefined,
        style: {
            display: "flex",
            flexDirection: "column",
            padding: 0,
            position: "relative",
            border: props.style === "wysiwyg" ? "1px solid " + (0, $9Q5xE.ColorStyles).primary[400] : undefined
        },
        children: [
            (0, $4vwom.jsx)((0, $jF6Vs.Toolbar), {
                editorState: editorState,
                setEditorState: onNewEditorState,
                draftJs: props.draftJs,
                style: props.style,
                currentMarkdownSnippet: props.markdownSnippetId,
                onDone: props.onDone
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    padding: props.style === "studio" ? 16 : 0
                },
                onDrop: async (e)=>{
                    const file = await props.onDrop(e);
                    if (file) {
                        const fileInfo = await (0, $dUDPg.getFileInfo)(file.id.valueOf());
                        onNewEditorState((0, $4SGh4.InsertImage)(props.draftJs, editorState, fileInfo.mimetype.startsWith("image") ? (0, $14q7s.ImageToUrl)(file.id) : (0, $14q7s.FileToUrl)(file.id), file.name));
                    }
                },
                children: (0, $4vwom.jsx)(props.draftJs.Editor, {
                    ref: setRef,
                    customStyleMap: $26d2dcaeddf4c8de$export$18a9461578883ec4.customStyleMap,
                    editorState: editorState,
                    onChange: onNewEditorState,
                    onFocus: ()=>setFocus(true),
                    onBlur: ()=>setFocus(false),
                    blockRendererFn: (b)=>{
                        if (b.getType() === "atomic") return {
                            component: $26d2dcaeddf4c8de$var$AtomicBlock,
                            editable: false
                        };
                        return null;
                    }
                })
            })
        ]
    });
}
/**
 * Allows the model to override the default style map for Draft.js.
 */ $26d2dcaeddf4c8de$export$18a9461578883ec4.customStyleMap = undefined; // Draft.Component.Base.DraftStyleMap | undefined
function $26d2dcaeddf4c8de$var$AtomicBlock(props) {
    const entity = props.contentState.getEntity(props.block.getEntityAt(0));
    const type = entity.getType();
    if (type === "IMAGE") {
        const { src: src, alt: alt, fileName: fileName } = entity.getData();
        return (0, $4vwom.jsx)($26d2dcaeddf4c8de$var$Media, {
            src: src,
            // Due to a quirk in draftjs-md-converter, the alt text is placed in
            // fileName instead of alt. This is a workaround.
            alt: fileName
        });
    } else return (0, $4vwom.jsx)("div", {
        children: "Unknown atomic block type"
    });
}

function $26d2dcaeddf4c8de$var$Media(props) {
    var _a, _b, _c, _d;
    const id = (0, $14q7s.UndoImageToUrl)(props.src);
    const needFileInfo = !((_a = props.alt) === null || _a === void 0 ? void 0 : _a.startsWith("#IFRAME")) && !((_b = props.alt) === null || _b === void 0 ? void 0 : _b.startsWith("#MARKDOWN_SNIPPET"));
    const { data: fileInfo } = (0, $dUDPg.useFileInfo)(needFileInfo ? id : null);
    if ((_c = props.alt) === null || _c === void 0 ? void 0 : _c.startsWith("#IFRAME")) {
        // Styles are encoded like this: #IFRAME{"width":100,"height":400}
        const style = props.alt.length > 7 ? JSON.parse(props.alt.slice(7)) : {};
        if (props.src.startsWith("/") && !props.src.startsWith("//")) return (0, $4vwom.jsx)("iframe", {
            src: props.src,
            style: Object.assign({
                width: "100%",
                maxWidth: 480,
                height: 500
            }, style)
        });
        else return (0, $4vwom.jsx)("div", {
            style: {
                padding: 8,
                backgroundColor: "#eee",
                color: "red"
            },
            children: "Only relative URLs are supported for embedding"
        });
    }
    if ((_d = props.alt) === null || _d === void 0 ? void 0 : _d.startsWith("#MARKDOWN_SNIPPET")) {
        const id = props.src;
        return (0, $4vwom.jsx)($26d2dcaeddf4c8de$var$EditableMarkdownSnippetView, {
            id: id
        });
    }
    if (fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.mimetype.startsWith("video")) return (0, $4vwom.jsx)("video", {
        muted: true,
        autoPlay: true,
        controls: true,
        src: props.src,
        style: {
            width: "100%",
            maxWidth: 480
        }
    });
    if (fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.mimetype.startsWith("application/lottie+json")) return (0, $4vwom.jsx)("div", {
        children: (0, $4vwom.jsx)((0, $2chu2.Lazy), {
            target: async ()=>{
                const Lottie = (await (parcelRequire("cUbQe"))).Lottie;
                return ()=>(0, $4vwom.jsx)(Lottie, {
                        file: id,
                        style: {
                            width: 400,
                            height: 400
                        }
                    });
            }
        })
    });
    if ((fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.mimetype.startsWith("image")) || props.src.includes("/api/images")) return (0, $4vwom.jsx)("img", {
        src: props.src,
        style: {
            width: "100%",
            maxWidth: 480
        }
    });
    return (0, $4vwom.jsx)("div", {
        children: "Loading..."
    });
}
function $26d2dcaeddf4c8de$var$EditableMarkdownSnippetView({ id: id }) {
    const { data: data } = (0, $dUDPg.useMarkdownSnippet)(id);
    const locale = (0, $aIeEI.useCurrentLocale)();
    const { modal: modal, showModal: showModal } = (0, $ikBJm.useContextualModal)();
    if (!data) return (0, $4vwom.jsx)("div", {
        children: "Loading..."
    });
    return (0, $4vwom.jsxs)("div", {
        style: {
            border: `1px dashed ${(0, $9Q5xE.ColorStyles).primary[600]}`,
            position: "relative"
        },
        onClick: async ()=>await showModal((close)=>(0, $4vwom.jsx)($26d2dcaeddf4c8de$var$MarkdownSnippetModal, {
                    data: data,
                    close: ()=>close(undefined)
                })),
        children: [
            modal,
            (0, $4vwom.jsxs)("div", {
                style: {
                    fontSize: 10,
                    backgroundColor: (0, $9Q5xE.ColorStyles).primary[600],
                    color: "white",
                    paddingLeft: 4,
                    paddingRight: 4,
                    position: "absolute",
                    top: -16,
                    left: -1,
                    height: 16
                },
                children: [
                    (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                        icon: "ui-sticker-square",
                        size: 10,
                        style: {
                            marginRight: 4,
                            marginTop: -2
                        }
                    }),
                    (0, $cSf8f.ClientSideLocalize)(data.name)
                ]
            }),
            (0, $4vwom.jsx)((0, $8MAXm.MarkdownView), {
                value: data.hydratedSnippet[locale.valueOf()]
            })
        ]
    });
}
function $26d2dcaeddf4c8de$var$MarkdownSnippetModal({ close: close, data: data }) {
    const locale = (0, $aIeEI.useCurrentLocale)();
    return (0, $4vwom.jsxs)("div", {
        style: {
            background: "white",
            borderRadius: 8,
            minWidth: 800,
            minHeight: 480
        },
        children: [
            (0, $4vwom.jsx)($26d2dcaeddf4c8de$export$18a9461578883ec4, {
                style: "studio",
                onDrop: async ()=>undefined,
                value: data.snippet[locale.valueOf()],
                autoFocus: true,
                onChanged: (newValue)=>{
                    data.snippet[locale.valueOf()] = newValue;
                },
                markdownSnippetId: data.id
            }),
            (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                onClick: close,
                children: "Close"
            })
        ]
    });
}

});
parcelRegister("jF6Vs", function(module, exports) {

$parcel$export(module.exports, "Toolbar", function () { return $e50737f8aa2c85a4$export$4c260019440d418f; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $fTlTn = parcelRequire("fTlTn");

var $14q7s = parcelRequire("14q7s");

var $fz3r9 = parcelRequire("fz3r9");

var $4SGh4 = parcelRequire("4SGh4");

var $ikBJm = parcelRequire("ikBJm");

var $9SFXB = parcelRequire("9SFXB");

var $6sp4J = parcelRequire("6sp4J");

var $9Q5xE = parcelRequire("9Q5xE");
function $e50737f8aa2c85a4$var$ToolbarButton(props) {
    const [elementTarget, setElementTarget] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(null);
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const [showPopup, setShowPopup] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(false);
    const popup = props.popup;
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            popup && (0, $4vwom.jsx)((0, $fTlTn.default), {
                target: elementTarget,
                show: showPopup,
                placement: "bottom-start",
                children: (p)=>(0, $4vwom.jsx)("div", Object.assign({
                        onMouseLeave: ()=>setShowPopup(false)
                    }, p, {
                        children: popup(()=>setShowPopup(false))
                    }))
            }),
            (0, $4vwom.jsxs)("div", Object.assign({
                ref: setElementTarget
            }, hoverProps, {
                style: {
                    marginBottom: 2,
                    marginTop: 2,
                    padding: 2,
                    paddingLeft: 8,
                    paddingRight: 8,
                    borderRadius: 4,
                    cursor: "pointer",
                    backgroundColor: hover ? "#ddd" : undefined,
                    color: props.primary ? (0, $9Q5xE.ColorStyles).primary[600] : undefined,
                    fontSize: 12
                },
                // This prevents the markdown editor from losing focus when
                // clicking on the toolbar
                onMouseDown: (e)=>e.preventDefault(),
                onClick: (e)=>{
                    if (props.popup) setShowPopup(!showPopup);
                    if (props.onClick) props.onClick();
                },
                children: [
                    props.icon && (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                        icon: props.icon,
                        size: 12,
                        style: {
                            marginRight: props.text ? 4 : 0
                        }
                    }),
                    props.text && (0, $4vwom.jsx)("span", {
                        onMouseEnter: ()=>setShowPopup(true),
                        style: props.style,
                        children: props.text
                    }),
                    props.children
                ]
            }))
        ]
    });
}
function $e50737f8aa2c85a4$var$ToolbarSeparator() {
    return (0, $4vwom.jsx)("div", {
        style: {
            width: 1,
            marginLeft: 4,
            marginRight: 4,
            height: 16,
            backgroundColor: "#aaa",
            alignSelf: "center"
        }
    });
}


function $e50737f8aa2c85a4$export$4c260019440d418f({ currentMarkdownSnippet: currentMarkdownSnippet, editorState: editorState, setEditorState: setEditorState, draftJs: draftJs, style: style, onDone: onDone }) {
    async function pickFile() {
        var _a;
        const { DocumentPicker: DocumentPicker } = await (parcelRequire("e2IHD"));
        const doc = await (0, $ikBJm.Modal)((close)=>(0, $4vwom.jsx)(DocumentPicker, {
                collection: "FileRecords",
                current: undefined,
                cancel: ()=>close(undefined),
                itemName: {
                    en: "Image",
                    no: "Bilde",
                    sv: "Bild"
                },
                itemSelected: (row)=>close(row)
            }));
        if (doc) {
            const name = (0, $9SFXB.ExtractPropFromWidget)(doc, "primary");
            const id = (_a = doc._primaryKey) === null || _a === void 0 ? void 0 : _a.toString();
            if (id && name) return {
                id: id,
                name: name
            };
        }
    }
    async function pickSnippet() {
        var _a;
        const { DocumentPicker: DocumentPicker } = await (parcelRequire("e2IHD"));
        const doc = await (0, $ikBJm.Modal)((close)=>(0, $4vwom.jsx)(DocumentPicker, {
                collection: "MarkdownSnippets",
                current: undefined,
                cancel: ()=>close(undefined),
                itemName: {
                    en: "Markdown snippet"
                },
                itemSelected: (row)=>close(row),
                excludePrimaryKeys: // Avoid making it easy to create a circular reference
                currentMarkdownSnippet ? [
                    currentMarkdownSnippet.valueOf()
                ] : undefined
            }));
        if (doc) {
            const name = (0, $9SFXB.ExtractPropFromWidget)(doc, "primary");
            const id = (_a = doc._primaryKey) === null || _a === void 0 ? void 0 : _a.toString();
            if (id && name) return {
                id: id,
                name: name
            };
        }
    }
    return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            borderBottom: "1px solid #ddd",
            backgroundColor: "#f8f8f8",
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            position: style === "wysiwyg" ? "absolute" : undefined,
            bottom: style === "wysiwyg" ? "100%" : undefined,
            boxShadow: style === "wysiwyg" ? "0px 0px 4px 0px rgba(0,0,0,0.2)" : undefined,
            color: "#333",
            paddingLeft: 3,
            paddingRight: 3
        },
        children: [
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                text: "Heading",
                popup: (close)=>(0, $4vwom.jsxs)("div", {
                        style: {
                            backgroundColor: "#fff",
                            padding: 8,
                            boxShadow: "0px 0px 4px 0px rgba(0,0,0,0.2)",
                            zIndex: 100
                        },
                        children: [
                            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                                onClick: ()=>{
                                    setEditorState(draftJs.RichUtils.toggleBlockType(editorState, "header-two"));
                                    close();
                                },
                                children: (0, $4vwom.jsx)("h2", {
                                    children: "Heading 2"
                                })
                            }),
                            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                                onClick: ()=>{
                                    setEditorState(draftJs.RichUtils.toggleBlockType(editorState, "header-three"));
                                    close();
                                },
                                children: (0, $4vwom.jsx)("h3", {
                                    children: "Heading 3"
                                })
                            }),
                            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                                onClick: ()=>{
                                    setEditorState(draftJs.RichUtils.toggleBlockType(editorState, "header-four"));
                                    close();
                                },
                                children: (0, $4vwom.jsx)("h4", {
                                    children: "Heading 4"
                                })
                            }),
                            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                                onClick: ()=>{
                                    // Remove heading style
                                    setEditorState(draftJs.RichUtils.toggleBlockType(editorState, "unstyled"));
                                    close();
                                },
                                children: (0, $4vwom.jsx)((0, $4vwom.Fragment), {
                                    children: "Regular text"
                                })
                            })
                        ]
                    }),
                style: {
                    marginTop: 9
                }
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarSeparator, {}),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-bold-01",
                onClick: ()=>setEditorState(draftJs.RichUtils.toggleInlineStyle(editorState, "BOLD"))
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-italic-01",
                onClick: ()=>setEditorState(draftJs.RichUtils.toggleInlineStyle(editorState, "ITALIC"))
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-underline-01",
                style: {
                    marginTop: 9
                },
                onClick: ()=>setEditorState(draftJs.RichUtils.toggleInlineStyle(editorState, "UNDERLINE"))
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarSeparator, {}),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-dotpoints-01",
                style: {
                    marginTop: 9
                },
                onClick: ()=>setEditorState(draftJs.RichUtils.toggleBlockType(editorState, "unordered-list-item"))
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-image-01",
                style: {
                    marginTop: 9
                },
                onClick: async ()=>{
                    const file = await pickFile();
                    if (!file) return;
                    setEditorState((0, $4SGh4.InsertImage)(draftJs, editorState, (0, $14q7s.ImageToUrl)(file.id), file.name));
                }
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-sticker-square",
                style: {
                    marginTop: 9
                },
                onClick: async ()=>{
                    const snippet = await pickSnippet();
                    if (!snippet) return;
                    setEditorState((0, $4SGh4.InsertImage)(draftJs, editorState, snippet.id, "#MARKDOWN_SNIPPET"));
                }
            }),
            onDone && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarSeparator, {}),
                    (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                        icon: "ui-check",
                        text: "Done",
                        primary: true,
                        onClick: onDone
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("fTlTn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b91cf96b1a229d59$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $aienp = parcelRequire("aienp");

var $dMkHl = parcelRequire("dMkHl");

var $fP80V = parcelRequire("fP80V");

var $ezE35 = parcelRequire("ezE35");

var $4NnQi = parcelRequire("4NnQi");
var $b91cf96b1a229d59$var$_excluded = [
    "children",
    "transition",
    "popperConfig"
], $b91cf96b1a229d59$var$_excluded2 = [
    "props",
    "arrowProps",
    "show",
    "update",
    "forceUpdate",
    "placement",
    "state"
];
var $b91cf96b1a229d59$var$defaultProps = {
    transition: (0, $4NnQi.default),
    rootClose: false,
    show: false,
    placement: "top"
};
function $b91cf96b1a229d59$var$wrapRefs(props, arrowProps) {
    var ref = props.ref;
    var aRef = arrowProps.ref;
    props.ref = ref.__wrapped || (ref.__wrapped = function(r) {
        return ref((0, $fP80V.default)(r));
    });
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = function(r) {
        return aRef((0, $fP80V.default)(r));
    });
}
function $b91cf96b1a229d59$var$Overlay(_ref) {
    var overlay = _ref.children, transition = _ref.transition, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig, outerProps = (0, $fbOaB.default)(_ref, $b91cf96b1a229d59$var$_excluded);
    var popperRef = (0, $eeH7J.useRef)({});
    var _usePopperMarginModif = (0, $ezE35.default)(), ref = _usePopperMarginModif[0], marginModifiers = _usePopperMarginModif[1];
    var actualTransition = transition === true ? (0, $4NnQi.default) : transition || null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $dMkHl.default), (0, $h4XE0.default)({}, outerProps, {
        ref: ref,
        popperConfig: (0, $h4XE0.default)({}, popperConfig, {
            modifiers: marginModifiers.concat(popperConfig.modifiers || [])
        }),
        transition: actualTransition
    }), function(_ref2) {
        var _state$modifiersData$;
        var overlayProps = _ref2.props, arrowProps = _ref2.arrowProps, show = _ref2.show, update = _ref2.update, _ = _ref2.forceUpdate, placement = _ref2.placement, state = _ref2.state, props = (0, $fbOaB.default)(_ref2, $b91cf96b1a229d59$var$_excluded2);
        $b91cf96b1a229d59$var$wrapRefs(overlayProps, arrowProps);
        var popper = Object.assign(popperRef.current, {
            state: state,
            scheduleUpdate: update,
            placement: placement,
            outOfBoundaries: (state == null ? void 0 : (_state$modifiersData$ = state.modifiersData.hide) == null ? void 0 : _state$modifiersData$.isReferenceHidden) || false
        });
        if (typeof overlay === "function") return overlay((0, $h4XE0.default)({}, props, overlayProps, {
            placement: placement,
            show: show
        }, !transition && show && {
            className: "show"
        }, {
            popper: popper,
            arrowProps: arrowProps
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).cloneElement(overlay, (0, $h4XE0.default)({}, props, overlayProps, {
            placement: placement,
            arrowProps: arrowProps,
            popper: popper,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(overlay.props.className, !transition && show && "show"),
            style: (0, $h4XE0.default)({}, overlay.props.style, overlayProps.style)
        }));
    });
}
$b91cf96b1a229d59$var$Overlay.defaultProps = $b91cf96b1a229d59$var$defaultProps;
var $b91cf96b1a229d59$export$2e2bcd8739ae039 = $b91cf96b1a229d59$var$Overlay;

});
parcelRegister("fbOaB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0eeccd462f407d6$export$2e2bcd8739ae039; });
function $b0eeccd462f407d6$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("aienp", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("dMkHl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a07fd04508a326a6$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $4yBem = parcelRequire("4yBem");

var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $boXcK = parcelRequire("boXcK");

var $kTadk = parcelRequire("kTadk");

var $d2T2o = parcelRequire("d2T2o");

var $5zGaS = parcelRequire("5zGaS");

var $1xBVt = parcelRequire("1xBVt");

var $7EllR = parcelRequire("7EllR");

var $9Wxjw = parcelRequire("9Wxjw");
/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ var $a07fd04508a326a6$var$Overlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(props, outerRef) {
    var flip = props.flip, offset = props.offset, placement = props.placement, _props$containerPaddi = props.containerPadding, containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi, _props$popperConfig = props.popperConfig, popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig, Transition = props.transition;
    var _useCallbackRef = (0, $boXcK.default)(), rootElement = _useCallbackRef[0], attachRef = _useCallbackRef[1];
    var _useCallbackRef2 = (0, $boXcK.default)(), arrowElement = _useCallbackRef2[0], attachArrowRef = _useCallbackRef2[1];
    var mergedRef = (0, $kTadk.default)(attachRef, outerRef);
    var container = (0, $7EllR.default)(props.container);
    var target = (0, $7EllR.default)(props.target);
    var _useState = (0, $eeH7J.useState)(!props.show), exited = _useState[0], setExited = _useState[1];
    var _usePopper = (0, $5zGaS.default)(target, rootElement, (0, $9Wxjw.default)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    })), styles = _usePopper.styles, attributes = _usePopper.attributes, popper = (0, $fbOaB.default)(_usePopper, [
        "styles",
        "attributes"
    ]);
    if (props.show) {
        if (exited) setExited(false);
    } else if (!props.transition && !exited) setExited(true);
    var handleHidden = function handleHidden() {
        setExited(true);
        if (props.onExited) props.onExited.apply(props, arguments);
    }; // Don't un-render the overlay while it's transitioning out.
    var mountOverlay = props.show || Transition && !exited;
    (0, $1xBVt.default)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    var child = props.children((0, $h4XE0.default)({}, popper, {
        show: !!props.show,
        props: (0, $h4XE0.default)({}, attributes.popper, {
            style: styles.popper,
            ref: mergedRef
        }),
        arrowProps: (0, $h4XE0.default)({}, attributes.arrow, {
            style: styles.arrow,
            ref: attachArrowRef
        })
    }));
    if (Transition) {
        var onExit = props.onExit, onExiting = props.onExiting, onEnter = props.onEnter, onEntering = props.onEntering, onEntered = props.onEntered;
        child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Transition, {
            "in": props.show,
            appear: true,
            onExit: onExit,
            onExiting: onExiting,
            onExited: handleHidden,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
        }, child);
    }
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).createPortal(child, container) : null;
});
$a07fd04508a326a6$var$Overlay.displayName = "Overlay";
$a07fd04508a326a6$var$Overlay.propTypes = {
    /**
   * Set the visibility of the Overlay
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /** Specify where the overlay element is positioned in relation to the target element */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf((0, $d2T2o.placements)),
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */ target: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func.isRequired,
    /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */ containerPadding: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */ popperConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */ rootClose: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Specify event for toggling overlay
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        "click",
        "mousedown"
    ]),
    /**
   * Specify disabled for disable RootCloseWrapper
   */ rootCloseDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */ onHide: function onHide(props) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (props.rootClose) {
            var _PropTypes$func;
            return (_PropTypes$func = (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func).isRequired.apply(_PropTypes$func, [
                props
            ].concat(args));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func.apply((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))), [
            props
        ].concat(args));
    },
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */ // @ts-ignore
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Callback fired before the Overlay transitions in
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired as the Overlay begins to transition in
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired after the Overlay finishes transitioning in
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired right before the Overlay transitions out
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired as the Overlay begins to transition out
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired after the Overlay finishes transitioning out
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
};
var $a07fd04508a326a6$export$2e2bcd8739ae039 = $a07fd04508a326a6$var$Overlay;

});
parcelRegister("boXcK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84cfdc60e57a1506$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
function $84cfdc60e57a1506$export$2e2bcd8739ae039() {
    return (0, $eeH7J.useState)(null);
}

});

parcelRegister("kTadk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f350ddfb99b7887d$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
const $f350ddfb99b7887d$var$toFnRef = (ref)=>!ref || typeof ref === "function" ? ref : (value)=>{
        ref.current = value;
    };
function $f350ddfb99b7887d$export$c9058316764c140e(refA, refB) {
    const a = $f350ddfb99b7887d$var$toFnRef(refA);
    const b = $f350ddfb99b7887d$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $f350ddfb99b7887d$var$useMergedRefs(refA, refB) {
    return (0, $eeH7J.useMemo)(()=>$f350ddfb99b7887d$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $f350ddfb99b7887d$export$2e2bcd8739ae039 = $f350ddfb99b7887d$var$useMergedRefs;

});

parcelRegister("d2T2o", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $97f6279b6bda8f09$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $97f6279b6bda8f09$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $97f6279b6bda8f09$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $97f6279b6bda8f09$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $97f6279b6bda8f09$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $97f6279b6bda8f09$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $97f6279b6bda8f09$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $97f6279b6bda8f09$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $97f6279b6bda8f09$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $97f6279b6bda8f09$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $97f6279b6bda8f09$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $97f6279b6bda8f09$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $97f6279b6bda8f09$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $97f6279b6bda8f09$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $97f6279b6bda8f09$export$d087d3878fdf71d5; });
var $97f6279b6bda8f09$export$1e95b668f3b82d = "top";
var $97f6279b6bda8f09$export$40e543e69a8b3fbb = "bottom";
var $97f6279b6bda8f09$export$79ffe56a765070d2 = "right";
var $97f6279b6bda8f09$export$eabcd2c8791e7bf4 = "left";
var $97f6279b6bda8f09$export$dfb5619354ba860 = "auto";
var $97f6279b6bda8f09$export$aec2ce47c367b8c3 = [
    $97f6279b6bda8f09$export$1e95b668f3b82d,
    $97f6279b6bda8f09$export$40e543e69a8b3fbb,
    $97f6279b6bda8f09$export$79ffe56a765070d2,
    $97f6279b6bda8f09$export$eabcd2c8791e7bf4
];
var $97f6279b6bda8f09$export$b3571188c770cc5a = "start";
var $97f6279b6bda8f09$export$bd5df0f255a350f8 = "end";
var $97f6279b6bda8f09$export$390fd549c5303b4d = "clippingParents";
var $97f6279b6bda8f09$export$d7b7311ec04a3e8f = "viewport";
var $97f6279b6bda8f09$export$ae5ab1c730825774 = "popper";
var $97f6279b6bda8f09$export$ca50aac9f3ba507f = "reference";
var $97f6279b6bda8f09$export$368f9a87e87fa4e1 = /*#__PURE__*/ $97f6279b6bda8f09$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $97f6279b6bda8f09$export$b3571188c770cc5a,
        placement + "-" + $97f6279b6bda8f09$export$bd5df0f255a350f8
    ]);
}, []);
var $97f6279b6bda8f09$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($97f6279b6bda8f09$export$aec2ce47c367b8c3, [
    $97f6279b6bda8f09$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $97f6279b6bda8f09$export$b3571188c770cc5a,
        placement + "-" + $97f6279b6bda8f09$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $97f6279b6bda8f09$export$421679a7c3d56e = "beforeRead";
var $97f6279b6bda8f09$export$aafa59e2e03f2942 = "read";
var $97f6279b6bda8f09$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $97f6279b6bda8f09$export$c65e99957a05207c = "beforeMain";
var $97f6279b6bda8f09$export$f22da7240b7add18 = "main";
var $97f6279b6bda8f09$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $97f6279b6bda8f09$export$8d4d2d70e7d46032 = "beforeWrite";
var $97f6279b6bda8f09$export$68d8715fc104d294 = "write";
var $97f6279b6bda8f09$export$70a6e5159acce2e6 = "afterWrite";
var $97f6279b6bda8f09$export$d087d3878fdf71d5 = [
    $97f6279b6bda8f09$export$421679a7c3d56e,
    $97f6279b6bda8f09$export$aafa59e2e03f2942,
    $97f6279b6bda8f09$export$6964f6c886723980,
    $97f6279b6bda8f09$export$c65e99957a05207c,
    $97f6279b6bda8f09$export$f22da7240b7add18,
    $97f6279b6bda8f09$export$bab79516f2d662fe,
    $97f6279b6bda8f09$export$8d4d2d70e7d46032,
    $97f6279b6bda8f09$export$68d8715fc104d294,
    $97f6279b6bda8f09$export$70a6e5159acce2e6
];

});

parcelRegister("5zGaS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40f0ef952b109bf1$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $fNi2x = parcelRequire("fNi2x");

var $bKRFj = parcelRequire("bKRFj");
var $40f0ef952b109bf1$var$initialPopperStyles = function initialPopperStyles(position) {
    return {
        position: position,
        top: "0",
        left: "0",
        opacity: "0",
        pointerEvents: "none"
    };
};
var $40f0ef952b109bf1$var$disabledApplyStylesModifier = {
    name: "applyStyles",
    enabled: false
}; // In order to satisfy the current usage of options, including undefined
var $40f0ef952b109bf1$var$ariaDescribedByModifier = {
    name: "ariaDescribedBy",
    enabled: true,
    phase: "afterWrite",
    effect: function effect(_ref) {
        var state = _ref.state;
        return function() {
            var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
            if ("removeAttribute" in reference) {
                var ids = (reference.getAttribute("aria-describedby") || "").split(",").filter(function(id) {
                    return id.trim() !== popper.id;
                });
                if (!ids.length) reference.removeAttribute("aria-describedby");
                else reference.setAttribute("aria-describedby", ids.join(","));
            }
        };
    },
    fn: function fn(_ref2) {
        var _popper$getAttribute;
        var state = _ref2.state;
        var _state$elements2 = state.elements, popper = _state$elements2.popper, reference = _state$elements2.reference;
        var role = (_popper$getAttribute = popper.getAttribute("role")) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === "tooltip" && "setAttribute" in reference) {
            var ids = reference.getAttribute("aria-describedby");
            if (ids && ids.split(",").indexOf(popper.id) !== -1) return;
            reference.setAttribute("aria-describedby", ids ? ids + "," + popper.id : popper.id);
        }
    }
};
var $40f0ef952b109bf1$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $40f0ef952b109bf1$var$usePopper(referenceElement, popperElement, _temp) {
    var _ref3 = _temp === void 0 ? {} : _temp, _ref3$enabled = _ref3.enabled, enabled = _ref3$enabled === void 0 ? true : _ref3$enabled, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? "bottom" : _ref3$placement, _ref3$strategy = _ref3.strategy, strategy = _ref3$strategy === void 0 ? "absolute" : _ref3$strategy, _ref3$modifiers = _ref3.modifiers, modifiers = _ref3$modifiers === void 0 ? $40f0ef952b109bf1$var$EMPTY_MODIFIERS : _ref3$modifiers, config = (0, $fbOaB.default)(_ref3, [
        "enabled",
        "placement",
        "strategy",
        "modifiers"
    ]);
    var popperInstanceRef = (0, $eeH7J.useRef)();
    var update = (0, $eeH7J.useCallback)(function() {
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    var forceUpdate = (0, $eeH7J.useCallback)(function() {
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    var _useSafeState = (0, $fNi2x.default)((0, $eeH7J.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: $40f0ef952b109bf1$var$initialPopperStyles(strategy),
            arrow: {}
        }
    })), popperState = _useSafeState[0], setState = _useSafeState[1];
    var updateModifier = (0, $eeH7J.useMemo)(function() {
        return {
            name: "updateStateModifier",
            enabled: true,
            phase: "write",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref4) {
                var state = _ref4.state;
                var styles = {};
                var attributes = {};
                Object.keys(state.elements).forEach(function(element) {
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        };
    }, [
        update,
        forceUpdate,
        setState
    ]);
    (0, $eeH7J.useEffect)(function() {
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                updateModifier,
                $40f0ef952b109bf1$var$disabledApplyStylesModifier
            ])
        }); // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        strategy,
        placement,
        updateModifier,
        enabled
    ]);
    (0, $eeH7J.useEffect)(function() {
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $bKRFj.createPopper)(referenceElement, popperElement, (0, $h4XE0.default)({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                $40f0ef952b109bf1$var$ariaDescribedByModifier,
                updateModifier
            ])
        }));
        return function() {
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState(function(s) {
                    return (0, $h4XE0.default)({}, s, {
                        attributes: {},
                        styles: {
                            popper: $40f0ef952b109bf1$var$initialPopperStyles(strategy)
                        }
                    });
                });
            }
        }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $40f0ef952b109bf1$export$2e2bcd8739ae039 = $40f0ef952b109bf1$var$usePopper;

});
parcelRegister("fNi2x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7f96cf498fad852$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $gUToj = parcelRequire("gUToj");
/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $b7f96cf498fad852$var$useSafeState(state) {
    const isMounted = (0, $gUToj.default)();
    return [
        state[0],
        (0, $eeH7J.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $b7f96cf498fad852$export$2e2bcd8739ae039 = $b7f96cf498fad852$var$useSafeState;

});
parcelRegister("gUToj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c50cd7d4ec6cf7bc$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
function $c50cd7d4ec6cf7bc$export$2e2bcd8739ae039() {
    const mounted = (0, $eeH7J.useRef)(true);
    const isMounted = (0, $eeH7J.useRef)(()=>mounted.current);
    (0, $eeH7J.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

});


parcelRegister("bKRFj", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $88ed9e6bab58ab8c$export$8f7491d57c8f97a9; });

var $aQoIM = parcelRequire("aQoIM");

var $6yP7f = parcelRequire("6yP7f");

var $f63Hh = parcelRequire("f63Hh");

var $bgNku = parcelRequire("bgNku");

var $j3jMG = parcelRequire("j3jMG");

var $gXYWO = parcelRequire("gXYWO");

var $5CAqp = parcelRequire("5CAqp");

var $919wP = parcelRequire("919wP");

var $d2T2o = parcelRequire("d2T2o");

var $1dXwT = parcelRequire("1dXwT");
var $88ed9e6bab58ab8c$export$8f7491d57c8f97a9 = (0, $1dXwT.popperGenerator)({
    defaultModifiers: [
        (0, $j3jMG.default),
        (0, $5CAqp.default),
        (0, $6yP7f.default),
        (0, $f63Hh.default),
        (0, $gXYWO.default),
        (0, $bgNku.default),
        (0, $919wP.default),
        (0, $aQoIM.default)
    ]
});

});
parcelRegister("aQoIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e51efda9e6180a8$export$2e2bcd8739ae039; });

var $a98ZV = parcelRequire("a98ZV");

var $iaeAc = parcelRequire("iaeAc");

var $hjcJU = parcelRequire("hjcJU");

var $ferRV = parcelRequire("ferRV");

var $bS91E = parcelRequire("bS91E");

var $czvfC = parcelRequire("czvfC");

var $9z3Qe = parcelRequire("9z3Qe");

var $4NkCO = parcelRequire("4NkCO");

var $d2T2o = parcelRequire("d2T2o");
var $7e51efda9e6180a8$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $9z3Qe.default)(typeof padding !== "number" ? padding : (0, $4NkCO.default)(padding, (0, $d2T2o.basePlacements)));
};
function $7e51efda9e6180a8$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $a98ZV.default)(state.placement);
    var axis = (0, $bS91E.default)(basePlacement);
    var isVertical = [
        (0, $d2T2o.left),
        (0, $d2T2o.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $7e51efda9e6180a8$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $iaeAc.default)(arrowElement);
    var minProp = axis === "y" ? (0, $d2T2o.top) : (0, $d2T2o.left);
    var maxProp = axis === "y" ? (0, $d2T2o.bottom) : (0, $d2T2o.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $ferRV.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $czvfC.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $7e51efda9e6180a8$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $hjcJU.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $7e51efda9e6180a8$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $7e51efda9e6180a8$var$arrow,
    effect: $7e51efda9e6180a8$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});
parcelRegister("a98ZV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7631b9671a26e6a6$export$2e2bcd8739ae039; });

function $7631b9671a26e6a6$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("iaeAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3947904e79cb06b$export$2e2bcd8739ae039; });

var $7LHdV = parcelRequire("7LHdV");
function $d3947904e79cb06b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $7LHdV.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("7LHdV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a7e7382b73c29b9$export$2e2bcd8739ae039; });

var $58Qwv = parcelRequire("58Qwv");

var $dEzG4 = parcelRequire("dEzG4");

var $6TTa5 = parcelRequire("6TTa5");

var $bkw0z = parcelRequire("bkw0z");
function $5a7e7382b73c29b9$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $58Qwv.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $dEzG4.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $dEzG4.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $58Qwv.isElement)(element) ? (0, $6TTa5.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bkw0z.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("58Qwv", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $3be67126bd9b4dac$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $3be67126bd9b4dac$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $3be67126bd9b4dac$export$af51f0f06c0f328a; });

var $6TTa5 = parcelRequire("6TTa5");
function $3be67126bd9b4dac$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6TTa5.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $3be67126bd9b4dac$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6TTa5.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $3be67126bd9b4dac$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6TTa5.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("6TTa5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5062ab1154804816$export$2e2bcd8739ae039; });
function $5062ab1154804816$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("dEzG4", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $9f0aaf9815ede3ec$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $9f0aaf9815ede3ec$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $9f0aaf9815ede3ec$export$2077e0241d6afd3c; });
var $9f0aaf9815ede3ec$export$8960430cfd85939f = Math.max;
var $9f0aaf9815ede3ec$export$96ec731ed4dcb222 = Math.min;
var $9f0aaf9815ede3ec$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("bkw0z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83fa64234a2d533a$export$2e2bcd8739ae039; });

var $iKeNn = parcelRequire("iKeNn");
function $83fa64234a2d533a$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $iKeNn.default)());
}

});
parcelRegister("iKeNn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da57ffef1a6cfc98$export$2e2bcd8739ae039; });
function $da57ffef1a6cfc98$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});




parcelRegister("hjcJU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c99e17cd1650e2ac$export$2e2bcd8739ae039; });

var $58Qwv = parcelRequire("58Qwv");
function $c99e17cd1650e2ac$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $58Qwv.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ferRV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b16dc7f6a8cdadb3$export$2e2bcd8739ae039; });

var $6TTa5 = parcelRequire("6TTa5");

var $1kiMy = parcelRequire("1kiMy");

var $2Ib3u = parcelRequire("2Ib3u");

var $58Qwv = parcelRequire("58Qwv");

var $jKun1 = parcelRequire("jKun1");

var $9MvYu = parcelRequire("9MvYu");

var $iKeNn = parcelRequire("iKeNn");
function $b16dc7f6a8cdadb3$var$getTrueOffsetParent(element) {
    if (!(0, $58Qwv.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $2Ib3u.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $b16dc7f6a8cdadb3$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $iKeNn.default)());
    var isIE = /Trident/i.test((0, $iKeNn.default)());
    if (isIE && (0, $58Qwv.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $2Ib3u.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $9MvYu.default)(element);
    if ((0, $58Qwv.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $58Qwv.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $1kiMy.default)(currentNode)) < 0){
        var css = (0, $2Ib3u.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $b16dc7f6a8cdadb3$export$2e2bcd8739ae039(element) {
    var window = (0, $6TTa5.default)(element);
    var offsetParent = $b16dc7f6a8cdadb3$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $jKun1.default)(offsetParent) && (0, $2Ib3u.default)(offsetParent).position === "static")offsetParent = $b16dc7f6a8cdadb3$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $1kiMy.default)(offsetParent) === "html" || (0, $1kiMy.default)(offsetParent) === "body" && (0, $2Ib3u.default)(offsetParent).position === "static")) return window;
    return offsetParent || $b16dc7f6a8cdadb3$var$getContainingBlock(element) || window;
}

});
parcelRegister("1kiMy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f763a778cdfb4f7$export$2e2bcd8739ae039; });
function $0f763a778cdfb4f7$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("2Ib3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f98442955c0287f$export$2e2bcd8739ae039; });

var $6TTa5 = parcelRequire("6TTa5");
function $1f98442955c0287f$export$2e2bcd8739ae039(element) {
    return (0, $6TTa5.default)(element).getComputedStyle(element);
}

});

parcelRegister("jKun1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e609df1e643ee305$export$2e2bcd8739ae039; });

var $1kiMy = parcelRequire("1kiMy");
function $e609df1e643ee305$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $1kiMy.default)(element)) >= 0;
}

});

parcelRegister("9MvYu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71f1663d3b2ae7fc$export$2e2bcd8739ae039; });

var $1kiMy = parcelRequire("1kiMy");

var $7D7XN = parcelRequire("7D7XN");

var $58Qwv = parcelRequire("58Qwv");
function $71f1663d3b2ae7fc$export$2e2bcd8739ae039(element) {
    if ((0, $1kiMy.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $58Qwv.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7D7XN.default)(element) // fallback
    );
}

});
parcelRegister("7D7XN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58e25a4811883d5e$export$2e2bcd8739ae039; });

var $58Qwv = parcelRequire("58Qwv");
function $58e25a4811883d5e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $58Qwv.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("bS91E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a4bbd2407e0bd00$export$2e2bcd8739ae039; });
function $8a4bbd2407e0bd00$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});

parcelRegister("czvfC", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $9270feb2329bc5b0$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $9270feb2329bc5b0$export$86c8af6d3ef0b4a; });

var $dEzG4 = parcelRequire("dEzG4");
function $9270feb2329bc5b0$export$f28d906d67a997f3(min, value, max) {
    return (0, $dEzG4.max)(min, (0, $dEzG4.min)(value, max));
}
function $9270feb2329bc5b0$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $9270feb2329bc5b0$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("9z3Qe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f6a5cc1e66b5e82$export$2e2bcd8739ae039; });

var $hCncA = parcelRequire("hCncA");
function $6f6a5cc1e66b5e82$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $hCncA.default)(), paddingObject);
}

});
parcelRegister("hCncA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd37fbb3bc42b26b$export$2e2bcd8739ae039; });
function $cd37fbb3bc42b26b$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("4NkCO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37dbbcbe71d27e14$export$2e2bcd8739ae039; });
function $37dbbcbe71d27e14$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("6yP7f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c6d919568662c13$export$2e2bcd8739ae039; });

var $d2T2o = parcelRequire("d2T2o");

var $ferRV = parcelRequire("ferRV");

var $6TTa5 = parcelRequire("6TTa5");

var $7D7XN = parcelRequire("7D7XN");

var $2Ib3u = parcelRequire("2Ib3u");

var $a98ZV = parcelRequire("a98ZV");

var $2wRyc = parcelRequire("2wRyc");

var $dEzG4 = parcelRequire("dEzG4");
var $4c6d919568662c13$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $4c6d919568662c13$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $dEzG4.round)(x * dpr) / dpr || 0,
        y: (0, $dEzG4.round)(y * dpr) / dpr || 0
    };
}
function $4c6d919568662c13$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $d2T2o.left);
    var sideY = (0, $d2T2o.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $ferRV.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6TTa5.default)(popper)) {
            offsetParent = (0, $7D7XN.default)(popper);
            if ((0, $2Ib3u.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $d2T2o.top) || (placement === (0, $d2T2o.left) || placement === (0, $d2T2o.right)) && variation === (0, $d2T2o.end)) {
            sideY = (0, $d2T2o.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $d2T2o.left) || (placement === (0, $d2T2o.top) || placement === (0, $d2T2o.bottom)) && variation === (0, $d2T2o.end)) {
            sideX = (0, $d2T2o.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $4c6d919568662c13$var$unsetSides);
    var _ref4 = roundOffsets === true ? $4c6d919568662c13$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6TTa5.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $4c6d919568662c13$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $a98ZV.default)(state.placement),
        variation: (0, $2wRyc.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $4c6d919568662c13$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $4c6d919568662c13$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $4c6d919568662c13$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $4c6d919568662c13$var$computeStyles,
    data: {}
};

});
parcelRegister("2wRyc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d781bfd78c28180$export$2e2bcd8739ae039; });
function $1d781bfd78c28180$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});


parcelRegister("f63Hh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afda48b4f33d0664$export$2e2bcd8739ae039; });

var $6TTa5 = parcelRequire("6TTa5");
var $afda48b4f33d0664$var$passive = {
    passive: true
};
function $afda48b4f33d0664$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6TTa5.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $afda48b4f33d0664$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $afda48b4f33d0664$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $afda48b4f33d0664$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $afda48b4f33d0664$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $afda48b4f33d0664$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $afda48b4f33d0664$var$effect,
    data: {}
};

});

parcelRegister("bgNku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8347741fa45ac751$export$2e2bcd8739ae039; });

var $dbBDc = parcelRequire("dbBDc");

var $a98ZV = parcelRequire("a98ZV");

var $fPRet = parcelRequire("fPRet");

var $gEFKV = parcelRequire("gEFKV");

var $frI8X = parcelRequire("frI8X");

var $d2T2o = parcelRequire("d2T2o");

var $2wRyc = parcelRequire("2wRyc");
function $8347741fa45ac751$var$getExpandedFallbackPlacements(placement) {
    if ((0, $a98ZV.default)(placement) === (0, $d2T2o.auto)) return [];
    var oppositePlacement = (0, $dbBDc.default)(placement);
    return [
        (0, $fPRet.default)(placement),
        oppositePlacement,
        (0, $fPRet.default)(oppositePlacement)
    ];
}
function $8347741fa45ac751$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $a98ZV.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $dbBDc.default)(preferredPlacement)
    ] : $8347741fa45ac751$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $a98ZV.default)(placement) === (0, $d2T2o.auto) ? (0, $frI8X.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $a98ZV.default)(placement);
        var isStartVariation = (0, $2wRyc.default)(placement) === (0, $d2T2o.start);
        var isVertical = [
            (0, $d2T2o.top),
            (0, $d2T2o.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $gEFKV.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $d2T2o.right) : (0, $d2T2o.left) : isStartVariation ? (0, $d2T2o.bottom) : (0, $d2T2o.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $dbBDc.default)(mainVariationSide);
        var altVariationSide = (0, $dbBDc.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $8347741fa45ac751$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $8347741fa45ac751$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("dbBDc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99997e3aabfce6f4$export$2e2bcd8739ae039; });
var $99997e3aabfce6f4$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $99997e3aabfce6f4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $99997e3aabfce6f4$var$hash[matched];
    });
}

});

parcelRegister("fPRet", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b874e944140421a8$export$2e2bcd8739ae039; });
var $b874e944140421a8$var$hash = {
    start: "end",
    end: "start"
};
function $b874e944140421a8$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b874e944140421a8$var$hash[matched];
    });
}

});

parcelRegister("gEFKV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c200c59b1c59e334$export$2e2bcd8739ae039; });

var $dFPka = parcelRequire("dFPka");

var $7D7XN = parcelRequire("7D7XN");

var $7LHdV = parcelRequire("7LHdV");

var $gstCb = parcelRequire("gstCb");

var $ldIhZ = parcelRequire("ldIhZ");

var $d2T2o = parcelRequire("d2T2o");

var $58Qwv = parcelRequire("58Qwv");

var $9z3Qe = parcelRequire("9z3Qe");

var $4NkCO = parcelRequire("4NkCO");
function $c200c59b1c59e334$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $d2T2o.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $d2T2o.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $d2T2o.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $9z3Qe.default)(typeof padding !== "number" ? padding : (0, $4NkCO.default)(padding, (0, $d2T2o.basePlacements)));
    var altContext = elementContext === (0, $d2T2o.popper) ? (0, $d2T2o.reference) : (0, $d2T2o.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $dFPka.default)((0, $58Qwv.isElement)(element) ? element : element.contextElement || (0, $7D7XN.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $7LHdV.default)(state.elements.reference);
    var popperOffsets = (0, $gstCb.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $ldIhZ.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $d2T2o.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $d2T2o.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $d2T2o.right),
                (0, $d2T2o.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $d2T2o.top),
                (0, $d2T2o.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("dFPka", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f46eaa0437a5d7f$export$2e2bcd8739ae039; });

var $d2T2o = parcelRequire("d2T2o");

var $ahYfF = parcelRequire("ahYfF");

var $6Wb1F = parcelRequire("6Wb1F");

var $6L2NG = parcelRequire("6L2NG");

var $ferRV = parcelRequire("ferRV");

var $7D7XN = parcelRequire("7D7XN");

var $2Ib3u = parcelRequire("2Ib3u");

var $58Qwv = parcelRequire("58Qwv");

var $7LHdV = parcelRequire("7LHdV");

var $9MvYu = parcelRequire("9MvYu");

var $hjcJU = parcelRequire("hjcJU");

var $1kiMy = parcelRequire("1kiMy");

var $ldIhZ = parcelRequire("ldIhZ");

var $dEzG4 = parcelRequire("dEzG4");
function $9f46eaa0437a5d7f$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $7LHdV.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $9f46eaa0437a5d7f$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $d2T2o.viewport) ? (0, $ldIhZ.default)((0, $ahYfF.default)(element, strategy)) : (0, $58Qwv.isElement)(clippingParent) ? $9f46eaa0437a5d7f$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ldIhZ.default)((0, $6Wb1F.default)((0, $7D7XN.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $9f46eaa0437a5d7f$var$getClippingParents(element) {
    var clippingParents = (0, $6L2NG.default)((0, $9MvYu.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $2Ib3u.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $58Qwv.isHTMLElement)(element) ? (0, $ferRV.default)(element) : element;
    if (!(0, $58Qwv.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $58Qwv.isElement)(clippingParent) && (0, $hjcJU.default)(clippingParent, clipperElement) && (0, $1kiMy.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $9f46eaa0437a5d7f$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $9f46eaa0437a5d7f$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $9f46eaa0437a5d7f$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $dEzG4.max)(rect.top, accRect.top);
        accRect.right = (0, $dEzG4.min)(rect.right, accRect.right);
        accRect.bottom = (0, $dEzG4.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $dEzG4.max)(rect.left, accRect.left);
        return accRect;
    }, $9f46eaa0437a5d7f$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("ahYfF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77da3a9ff5c0c00a$export$2e2bcd8739ae039; });

var $6TTa5 = parcelRequire("6TTa5");

var $7D7XN = parcelRequire("7D7XN");

var $5vIv3 = parcelRequire("5vIv3");

var $bkw0z = parcelRequire("bkw0z");
function $77da3a9ff5c0c00a$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6TTa5.default)(element);
    var html = (0, $7D7XN.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bkw0z.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $5vIv3.default)(element),
        y: y
    };
}

});
parcelRegister("5vIv3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40325dba5ebcfc53$export$2e2bcd8739ae039; });

var $7LHdV = parcelRequire("7LHdV");

var $7D7XN = parcelRequire("7D7XN");

var $031S4 = parcelRequire("031S4");
function $40325dba5ebcfc53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $7LHdV.default)((0, $7D7XN.default)(element)).left + (0, $031S4.default)(element).scrollLeft;
}

});
parcelRegister("031S4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0091bb8083db7897$export$2e2bcd8739ae039; });

var $6TTa5 = parcelRequire("6TTa5");
function $0091bb8083db7897$export$2e2bcd8739ae039(node) {
    var win = (0, $6TTa5.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("6Wb1F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50d0b65a65510f94$export$2e2bcd8739ae039; });

var $7D7XN = parcelRequire("7D7XN");

var $2Ib3u = parcelRequire("2Ib3u");

var $5vIv3 = parcelRequire("5vIv3");

var $031S4 = parcelRequire("031S4");

var $dEzG4 = parcelRequire("dEzG4");
function $50d0b65a65510f94$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7D7XN.default)(element);
    var winScroll = (0, $031S4.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $dEzG4.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $dEzG4.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $5vIv3.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $2Ib3u.default)(body || html).direction === "rtl") x += (0, $dEzG4.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("6L2NG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eb94df7a2b1652b$export$2e2bcd8739ae039; });

var $01cxl = parcelRequire("01cxl");

var $9MvYu = parcelRequire("9MvYu");

var $6TTa5 = parcelRequire("6TTa5");

var $3cb7c = parcelRequire("3cb7c");
function $4eb94df7a2b1652b$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $01cxl.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6TTa5.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $3cb7c.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($4eb94df7a2b1652b$export$2e2bcd8739ae039((0, $9MvYu.default)(target)));
}

});
parcelRegister("01cxl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0039d1aed561a14a$export$2e2bcd8739ae039; });

var $9MvYu = parcelRequire("9MvYu");

var $3cb7c = parcelRequire("3cb7c");

var $1kiMy = parcelRequire("1kiMy");

var $58Qwv = parcelRequire("58Qwv");
function $0039d1aed561a14a$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $1kiMy.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $58Qwv.isHTMLElement)(node) && (0, $3cb7c.default)(node)) return node;
    return $0039d1aed561a14a$export$2e2bcd8739ae039((0, $9MvYu.default)(node));
}

});
parcelRegister("3cb7c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $253b1d530d9fc7c9$export$2e2bcd8739ae039; });

var $2Ib3u = parcelRequire("2Ib3u");
function $253b1d530d9fc7c9$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $2Ib3u.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("ldIhZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f72d2aca653c44b2$export$2e2bcd8739ae039; });
function $f72d2aca653c44b2$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("gstCb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfb63bbfa459ee48$export$2e2bcd8739ae039; });

var $a98ZV = parcelRequire("a98ZV");

var $2wRyc = parcelRequire("2wRyc");

var $bS91E = parcelRequire("bS91E");

var $d2T2o = parcelRequire("d2T2o");
function $bfb63bbfa459ee48$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $a98ZV.default)(placement) : null;
    var variation = placement ? (0, $2wRyc.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $d2T2o.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $d2T2o.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $d2T2o.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $d2T2o.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $bS91E.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $d2T2o.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $d2T2o.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("frI8X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3eb9ea1beb1c95a$export$2e2bcd8739ae039; });

var $2wRyc = parcelRequire("2wRyc");

var $d2T2o = parcelRequire("d2T2o");

var $gEFKV = parcelRequire("gEFKV");

var $a98ZV = parcelRequire("a98ZV");
function $b3eb9ea1beb1c95a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $d2T2o.placements) : _options$allowedAutoP;
    var variation = (0, $2wRyc.default)(placement);
    var placements = variation ? flipVariations ? (0, $d2T2o.variationPlacements) : (0, $d2T2o.variationPlacements).filter(function(placement) {
        return (0, $2wRyc.default)(placement) === variation;
    }) : (0, $d2T2o.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gEFKV.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $a98ZV.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("j3jMG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddeda4e2671100b0$export$2e2bcd8739ae039; });

var $d2T2o = parcelRequire("d2T2o");

var $gEFKV = parcelRequire("gEFKV");
function $ddeda4e2671100b0$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $ddeda4e2671100b0$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $d2T2o.top),
        (0, $d2T2o.right),
        (0, $d2T2o.bottom),
        (0, $d2T2o.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $ddeda4e2671100b0$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gEFKV.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $gEFKV.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $ddeda4e2671100b0$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $ddeda4e2671100b0$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $ddeda4e2671100b0$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $ddeda4e2671100b0$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $ddeda4e2671100b0$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $ddeda4e2671100b0$var$hide
};

});

parcelRegister("gXYWO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5a16ef44d34e30a$export$2e2bcd8739ae039; });

var $a98ZV = parcelRequire("a98ZV");

var $d2T2o = parcelRequire("d2T2o");
function $c5a16ef44d34e30a$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $a98ZV.default)(placement);
    var invertDistance = [
        (0, $d2T2o.left),
        (0, $d2T2o.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $d2T2o.left),
        (0, $d2T2o.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $c5a16ef44d34e30a$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $d2T2o.placements).reduce(function(acc, placement) {
        acc[placement] = $c5a16ef44d34e30a$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c5a16ef44d34e30a$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $c5a16ef44d34e30a$var$offset
};

});

parcelRegister("5CAqp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $417cc193dc0883b1$export$2e2bcd8739ae039; });

var $gstCb = parcelRequire("gstCb");
function $417cc193dc0883b1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $gstCb.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $417cc193dc0883b1$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $417cc193dc0883b1$var$popperOffsets,
    data: {}
};

});

parcelRegister("919wP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $690b99350124879d$export$2e2bcd8739ae039; });

var $d2T2o = parcelRequire("d2T2o");

var $a98ZV = parcelRequire("a98ZV");

var $bS91E = parcelRequire("bS91E");

var $1eQu3 = parcelRequire("1eQu3");

var $czvfC = parcelRequire("czvfC");

var $iaeAc = parcelRequire("iaeAc");

var $ferRV = parcelRequire("ferRV");

var $gEFKV = parcelRequire("gEFKV");

var $2wRyc = parcelRequire("2wRyc");

var $hCncA = parcelRequire("hCncA");

var $dEzG4 = parcelRequire("dEzG4");
function $690b99350124879d$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gEFKV.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $a98ZV.default)(state.placement);
    var variation = (0, $2wRyc.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $bS91E.default)(basePlacement);
    var altAxis = (0, $1eQu3.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $d2T2o.top) : (0, $d2T2o.left);
        var altSide = mainAxis === "y" ? (0, $d2T2o.bottom) : (0, $d2T2o.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $d2T2o.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $d2T2o.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $iaeAc.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $hCncA.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $czvfC.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $ferRV.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $czvfC.within)(tether ? (0, $dEzG4.min)(min, tetherMin) : min, offset, tether ? (0, $dEzG4.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $d2T2o.top) : (0, $d2T2o.left);
        var _altSide = mainAxis === "x" ? (0, $d2T2o.bottom) : (0, $d2T2o.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $d2T2o.top),
            (0, $d2T2o.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $czvfC.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $czvfC.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $690b99350124879d$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $690b99350124879d$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("1eQu3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e6fcf6842904e1b$export$2e2bcd8739ae039; });
function $0e6fcf6842904e1b$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});


parcelRegister("1dXwT", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $0e452eaeef801f41$export$ed5e13716264f202; });

var $3Lz9a = parcelRequire("3Lz9a");

var $iaeAc = parcelRequire("iaeAc");

var $6L2NG = parcelRequire("6L2NG");

var $ferRV = parcelRequire("ferRV");

var $aTD1P = parcelRequire("aTD1P");

var $GmSWC = parcelRequire("GmSWC");

var $kOwWT = parcelRequire("kOwWT");


var $58Qwv = parcelRequire("58Qwv");
var $0e452eaeef801f41$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $0e452eaeef801f41$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $0e452eaeef801f41$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $0e452eaeef801f41$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $0e452eaeef801f41$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $58Qwv.isElement)(reference) ? (0, $6L2NG.default)(reference) : reference.contextElement ? (0, $6L2NG.default)(reference.contextElement) : [],
                    popper: (0, $6L2NG.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $aTD1P.default)((0, $kOwWT.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$0e452eaeef801f41$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $3Lz9a.default)(reference, (0, $ferRV.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $iaeAc.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $GmSWC.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$0e452eaeef801f41$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $0e452eaeef801f41$export$8f7491d57c8f97a9 = /*#__PURE__*/ $0e452eaeef801f41$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("3Lz9a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2be1064b9c8a4d4e$export$2e2bcd8739ae039; });

var $7LHdV = parcelRequire("7LHdV");

var $kOhUS = parcelRequire("kOhUS");

var $1kiMy = parcelRequire("1kiMy");

var $58Qwv = parcelRequire("58Qwv");

var $5vIv3 = parcelRequire("5vIv3");

var $7D7XN = parcelRequire("7D7XN");

var $3cb7c = parcelRequire("3cb7c");

var $dEzG4 = parcelRequire("dEzG4");
function $2be1064b9c8a4d4e$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $dEzG4.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $dEzG4.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $2be1064b9c8a4d4e$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $58Qwv.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $58Qwv.isHTMLElement)(offsetParent) && $2be1064b9c8a4d4e$var$isElementScaled(offsetParent);
    var documentElement = (0, $7D7XN.default)(offsetParent);
    var rect = (0, $7LHdV.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1kiMy.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $3cb7c.default)(documentElement)) scroll = (0, $kOhUS.default)(offsetParent);
        if ((0, $58Qwv.isHTMLElement)(offsetParent)) {
            offsets = (0, $7LHdV.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $5vIv3.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("kOhUS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2665ffdcfb247eb$export$2e2bcd8739ae039; });

var $031S4 = parcelRequire("031S4");

var $6TTa5 = parcelRequire("6TTa5");

var $58Qwv = parcelRequire("58Qwv");

var $2Hb3X = parcelRequire("2Hb3X");
function $f2665ffdcfb247eb$export$2e2bcd8739ae039(node) {
    if (node === (0, $6TTa5.default)(node) || !(0, $58Qwv.isHTMLElement)(node)) return (0, $031S4.default)(node);
    else return (0, $2Hb3X.default)(node);
}

});
parcelRegister("2Hb3X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f682dc8f3467c95$export$2e2bcd8739ae039; });
function $1f682dc8f3467c95$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("aTD1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $020c15f23ea3ef06$export$2e2bcd8739ae039; });

var $d2T2o = parcelRequire("d2T2o");
function $020c15f23ea3ef06$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $020c15f23ea3ef06$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $020c15f23ea3ef06$var$order(modifiers); // order based on phase
    return (0, $d2T2o.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("GmSWC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07f5ace1f6980bf8$export$2e2bcd8739ae039; });
function $07f5ace1f6980bf8$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("kOwWT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2720922427b522a$export$2e2bcd8739ae039; });
function $f2720922427b522a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});




parcelRegister("1xBVt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11f64ad8eb11c439$export$2e2bcd8739ae039; });

var $4yFOi = parcelRequire("4yFOi");

var $insCM = parcelRequire("insCM");

var $eeH7J = parcelRequire("eeH7J");

var $jw1K9 = parcelRequire("jw1K9");

var $bVrkV = parcelRequire("bVrkV");

var $37Z19 = parcelRequire("37Z19");
var $11f64ad8eb11c439$var$escapeKeyCode = 27;
var $11f64ad8eb11c439$var$noop = function noop() {};
function $11f64ad8eb11c439$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $11f64ad8eb11c439$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $11f64ad8eb11c439$var$getRefTarget = function getRefTarget(ref) {
    return ref && ("current" in ref ? ref.current : ref);
};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $11f64ad8eb11c439$var$useRootClose(ref, onRootClose, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, disabled = _ref.disabled, _ref$clickTrigger = _ref.clickTrigger, clickTrigger = _ref$clickTrigger === void 0 ? "click" : _ref$clickTrigger;
    var preventMouseRootCloseRef = (0, $eeH7J.useRef)(false);
    var onClose = onRootClose || $11f64ad8eb11c439$var$noop;
    var handleMouseCapture = (0, $eeH7J.useCallback)(function(e) {
        var _e$composedPath$;
        var currentTarget = $11f64ad8eb11c439$var$getRefTarget(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($bVrkV)))(!!currentTarget, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node");
        preventMouseRootCloseRef.current = !currentTarget || $11f64ad8eb11c439$var$isModifiedEvent(e) || !$11f64ad8eb11c439$var$isLeftClickEvent(e) || !!(0, $4yFOi.default)(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
    }, [
        ref
    ]);
    var handleMouse = (0, $jw1K9.default)(function(e) {
        if (!preventMouseRootCloseRef.current) onClose(e);
    });
    var handleKeyUp = (0, $jw1K9.default)(function(e) {
        if (e.keyCode === $11f64ad8eb11c439$var$escapeKeyCode) onClose(e);
    });
    (0, $eeH7J.useEffect)(function() {
        if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        var currentEvent = window.event;
        var doc = (0, $37Z19.default)($11f64ad8eb11c439$var$getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $insCM.default)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $insCM.default)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var removeKeyupListener = (0, $insCM.default)(doc, "keyup", function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        var mobileSafariHackListeners = [];
        if ("ontouchstart" in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $insCM.default)(el, "mousemove", $11f64ad8eb11c439$var$noop);
        });
        return function() {
            removeMouseCaptureListener();
            removeMouseListener();
            removeKeyupListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleMouse,
        handleKeyUp
    ]);
}
var $11f64ad8eb11c439$export$2e2bcd8739ae039 = $11f64ad8eb11c439$var$useRootClose;

});
parcelRegister("4yFOi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $351ac50e48019a88$export$2e2bcd8739ae039; });
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $351ac50e48019a88$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

});

parcelRegister("insCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d61094350546bb71$export$2e2bcd8739ae039; });

var $4EL4i = parcelRequire("4EL4i");

var $hDfEg = parcelRequire("hDfEg");
function $d61094350546bb71$var$listen(node, eventName, handler, options) {
    (0, $4EL4i.default)(node, eventName, handler, options);
    return function() {
        (0, $hDfEg.default)(node, eventName, handler, options);
    };
}
var $d61094350546bb71$export$2e2bcd8739ae039 = $d61094350546bb71$var$listen;

});
parcelRegister("4EL4i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $363f68a8cb702929$export$2e2bcd8739ae039; });
/* eslint-disable no-return-assign */ 
var $jRSSO = parcelRequire("jRSSO");
var $363f68a8cb702929$export$63fefd044b2bc624 = false;
var $363f68a8cb702929$export$a614c6b395900f69 = false;
try {
    var $363f68a8cb702929$var$options = {
        get passive () {
            return $363f68a8cb702929$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $363f68a8cb702929$export$a614c6b395900f69 = $363f68a8cb702929$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $jRSSO.default) {
        window.addEventListener("test", $363f68a8cb702929$var$options, $363f68a8cb702929$var$options);
        window.removeEventListener("test", $363f68a8cb702929$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $363f68a8cb702929$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$363f68a8cb702929$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$363f68a8cb702929$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $363f68a8cb702929$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $363f68a8cb702929$export$2e2bcd8739ae039 = $363f68a8cb702929$var$addEventListener;

});
parcelRegister("jRSSO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e76d8a2e01758481$export$2e2bcd8739ae039; });
var $e76d8a2e01758481$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);

});


parcelRegister("hDfEg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd6237a4b7546442$export$2e2bcd8739ae039; });
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $cd6237a4b7546442$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $cd6237a4b7546442$export$2e2bcd8739ae039 = $cd6237a4b7546442$var$removeEventListener;

});


parcelRegister("jw1K9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3525ba9bbcddb4f$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $8fyfJ = parcelRequire("8fyfJ");
function $e3525ba9bbcddb4f$export$2e2bcd8739ae039(fn) {
    const ref = (0, $8fyfJ.default)(fn);
    return (0, $eeH7J.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("8fyfJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $601a4b53b1c202fc$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $601a4b53b1c202fc$var$useCommittedRef(value) {
    const ref = (0, $eeH7J.useRef)(value);
    (0, $eeH7J.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $601a4b53b1c202fc$export$2e2bcd8739ae039 = $601a4b53b1c202fc$var$useCommittedRef;

});


parcelRegister("bVrkV", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $8aea3910c4b32633$var$__DEV__ = false;
var $8aea3910c4b32633$var$warning = function() {};
if ($8aea3910c4b32633$var$__DEV__) {
    var $8aea3910c4b32633$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $8aea3910c4b32633$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $8aea3910c4b32633$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $8aea3910c4b32633$var$warning;

});

parcelRegister("37Z19", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24715b5e7821742f$export$2e2bcd8739ae039; });

var $84cPa = parcelRequire("84cPa");

var $fP80V = parcelRequire("fP80V");
var $24715b5e7821742f$export$2e2bcd8739ae039 = function(componentOrElement) {
    return (0, $84cPa.default)((0, $fP80V.default)(componentOrElement));
};

});
parcelRegister("84cPa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5df8a51b8ef3525e$export$2e2bcd8739ae039; });
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $5df8a51b8ef3525e$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("fP80V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b851d5d1240cd882$export$2e2bcd8739ae039; });

var $iMJCh = parcelRequire("iMJCh");
function $b851d5d1240cd882$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

});



parcelRegister("7EllR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $591cd4d58e0d9c64$export$2e2bcd8739ae039; });

var $84cPa = parcelRequire("84cPa");

var $eeH7J = parcelRequire("eeH7J");
var $591cd4d58e0d9c64$export$c91fd81e6d65f84a = function resolveContainerRef(ref) {
    var _ref;
    if (typeof document === "undefined") return null;
    if (ref == null) return (0, $84cPa.default)().body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if ((_ref = ref) != null && _ref.nodeType) return ref || null;
    return null;
};
function $591cd4d58e0d9c64$export$2e2bcd8739ae039(ref, onResolved) {
    var _useState = (0, $eeH7J.useState)(function() {
        return $591cd4d58e0d9c64$export$c91fd81e6d65f84a(ref);
    }), resolvedRef = _useState[0], setRef = _useState[1];
    if (!resolvedRef) {
        var earlyRef = $591cd4d58e0d9c64$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $eeH7J.useEffect)(function() {
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $eeH7J.useEffect)(function() {
        var nextRef = $591cd4d58e0d9c64$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}

});

parcelRegister("9Wxjw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73d35f4b00b17fc6$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");
function $73d35f4b00b17fc6$export$ba6dad097c8f5c38(modifiers) {
    var result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
     // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach(function(m) {
        result[m.name] = m;
    });
    return result;
}
function $73d35f4b00b17fc6$export$af3a999d4a134c86(map) {
    if (map === void 0) map = {};
    if (Array.isArray(map)) return map;
    return Object.keys(map).map(function(k) {
        map[k].name = k;
        return map[k];
    });
}
function $73d35f4b00b17fc6$export$2e2bcd8739ae039(_ref) {
    var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    var enabled = _ref.enabled, enableEvents = _ref.enableEvents, placement = _ref.placement, flip = _ref.flip, offset = _ref.offset, fixed = _ref.fixed, containerPadding = _ref.containerPadding, arrowElement = _ref.arrowElement, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
    var modifiers = $73d35f4b00b17fc6$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return (0, $h4XE0.default)({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? "fixed" : popperConfig.strategy,
        modifiers: $73d35f4b00b17fc6$export$af3a999d4a134c86((0, $h4XE0.default)({}, modifiers, {
            eventListeners: {
                enabled: enableEvents
            },
            preventOverflow: (0, $h4XE0.default)({}, modifiers.preventOverflow, {
                options: containerPadding ? (0, $h4XE0.default)({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: (0, $h4XE0.default)({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: (0, $h4XE0.default)({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: (0, $h4XE0.default)({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: (0, $h4XE0.default)({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}

});


parcelRegister("ezE35", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9c3666bc8130731$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $8fwbf = parcelRequire("8fwbf");

var $57SUk = parcelRequire("57SUk");
function $a9c3666bc8130731$var$getMargins(element) {
    var styles = window.getComputedStyle(element);
    var top = parseFloat(styles.marginTop) || 0;
    var right = parseFloat(styles.marginRight) || 0;
    var bottom = parseFloat(styles.marginBottom) || 0;
    var left = parseFloat(styles.marginLeft) || 0;
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
}
function $a9c3666bc8130731$export$2e2bcd8739ae039() {
    var overlayRef = (0, $eeH7J.useRef)(null);
    var margins = (0, $eeH7J.useRef)(null);
    var arrowMargins = (0, $eeH7J.useRef)(null);
    var popoverClass = (0, $57SUk.useBootstrapPrefix)(undefined, "popover");
    var dropdownMenuClass = (0, $57SUk.useBootstrapPrefix)(undefined, "dropdown-menu");
    var callback = (0, $eeH7J.useCallback)(function(overlay) {
        if (!overlay || !((0, $8fwbf.default)(overlay, popoverClass) || (0, $8fwbf.default)(overlay, dropdownMenuClass))) return;
        margins.current = $a9c3666bc8130731$var$getMargins(overlay);
        overlay.style.margin = "0";
        overlayRef.current = overlay;
    }, [
        popoverClass,
        dropdownMenuClass
    ]);
    var offset = (0, $eeH7J.useMemo)(function() {
        return {
            name: "offset",
            options: {
                offset: function offset(_ref) {
                    var placement = _ref.placement;
                    if (!margins.current) return [
                        0,
                        0
                    ];
                    var _margins$current = margins.current, top = _margins$current.top, left = _margins$current.left, bottom = _margins$current.bottom, right = _margins$current.right;
                    switch(placement.split("-")[0]){
                        case "top":
                            return [
                                0,
                                bottom
                            ];
                        case "left":
                            return [
                                0,
                                right
                            ];
                        case "bottom":
                            return [
                                0,
                                top
                            ];
                        case "right":
                            return [
                                0,
                                left
                            ];
                        default:
                            return [
                                0,
                                0
                            ];
                    }
                }
            }
        };
    }, [
        margins
    ]);
    var arrow = (0, $eeH7J.useMemo)(function() {
        return {
            name: "arrow",
            options: {
                padding: function padding() {
                    // The options here are used for Popper 2.8.4 and up.
                    // For earlier version, padding is handled in popoverArrowMargins below.
                    if (!arrowMargins.current) return 0;
                    var _arrowMargins$current = arrowMargins.current, top = _arrowMargins$current.top, right = _arrowMargins$current.right;
                    var padding = top || right;
                    return {
                        top: padding,
                        left: padding,
                        right: padding,
                        bottom: padding
                    };
                }
            }
        };
    }, [
        arrowMargins
    ]); // Converts popover arrow margin to arrow modifier padding
    var popoverArrowMargins = (0, $eeH7J.useMemo)(function() {
        return {
            name: "popoverArrowMargins",
            enabled: true,
            phase: "main",
            fn: function fn() {
                return undefined;
            },
            requiresIfExists: [
                "arrow"
            ],
            effect: function effect(_ref2) {
                var state = _ref2.state;
                if (!overlayRef.current || !state.elements.arrow || !(0, $8fwbf.default)(overlayRef.current, popoverClass)) return undefined;
                if (state.modifiersData["arrow#persistent"]) {
                    // @popperjs/core <= 2.8.3 uses arrow#persistent to pass padding to arrow modifier.
                    var _getMargins = $a9c3666bc8130731$var$getMargins(state.elements.arrow), top = _getMargins.top, right = _getMargins.right;
                    var padding = top || right;
                    state.modifiersData["arrow#persistent"].padding = {
                        top: padding,
                        left: padding,
                        right: padding,
                        bottom: padding
                    };
                } else // @popperjs/core >= 2.8.4 gets the padding from the arrow modifier options,
                // so we'll get the margins here, and let the arrow modifier above pass
                // it to popper.
                arrowMargins.current = $a9c3666bc8130731$var$getMargins(state.elements.arrow);
                state.elements.arrow.style.margin = "0";
                return function() {
                    if (state.elements.arrow) state.elements.arrow.style.margin = "";
                };
            }
        };
    }, [
        popoverClass
    ]);
    return [
        callback,
        [
            offset,
            arrow,
            popoverArrowMargins
        ]
    ];
}

});
parcelRegister("8fwbf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6018afd3224e0a55$export$2e2bcd8739ae039; });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $6018afd3224e0a55$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});

parcelRegister("57SUk", function(module, exports) {

$parcel$export(module.exports, "useBootstrapPrefix", function () { return $3bb832a98a20d43f$export$7f387860ebffb32c; });

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");
var $3bb832a98a20d43f$var$ThemeContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext({});
var $3bb832a98a20d43f$export$b631efc24e9d5e2f = $3bb832a98a20d43f$var$ThemeContext.Consumer, $3bb832a98a20d43f$var$Provider = $3bb832a98a20d43f$var$ThemeContext.Provider;
function $3bb832a98a20d43f$var$ThemeProvider(_ref) {
    var prefixes = _ref.prefixes, children = _ref.children;
    var copiedPrefixes = (0, $eeH7J.useMemo)(function() {
        return (0, $h4XE0.default)({}, prefixes);
    }, [
        prefixes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($3bb832a98a20d43f$var$Provider, {
        value: copiedPrefixes
    }, children);
}
function $3bb832a98a20d43f$export$7f387860ebffb32c(prefix, defaultPrefix) {
    var prefixes = (0, $eeH7J.useContext)($3bb832a98a20d43f$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $3bb832a98a20d43f$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref
    var _opts = opts, prefix = _opts.prefix, _opts$forwardRefAs = _opts.forwardRefAs, forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? "ref" : "innerRef" : _opts$forwardRefAs;
    var Wrapped = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref2, ref) {
        var props = (0, $h4XE0.default)({}, _ref2);
        props[forwardRefAs] = ref;
        var bsPrefix = $3bb832a98a20d43f$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({}, props, {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = "Bootstrap(" + (Component.displayName || Component.name) + ")";
    return Wrapped;
}
var $3bb832a98a20d43f$export$2e2bcd8739ae039 = $3bb832a98a20d43f$var$ThemeProvider;

});


parcelRegister("4NnQi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37de3ba95f4cd307$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $dgdSM = parcelRequire("dgdSM");

var $kYTG4 = parcelRequire("kYTG4");

var $u31lg = parcelRequire("u31lg");
var $37de3ba95f4cd307$var$_excluded = [
    "className",
    "children"
];
var $37de3ba95f4cd307$var$_fadeStyles;
var $37de3ba95f4cd307$var$defaultProps = {
    in: false,
    timeout: 300,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false
};
var $37de3ba95f4cd307$var$fadeStyles = ($37de3ba95f4cd307$var$_fadeStyles = {}, $37de3ba95f4cd307$var$_fadeStyles[0, $dgdSM.ENTERING] = "show", $37de3ba95f4cd307$var$_fadeStyles[0, $dgdSM.ENTERED] = "show", $37de3ba95f4cd307$var$_fadeStyles);
var $37de3ba95f4cd307$var$Fade = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var className = _ref.className, children = _ref.children, props = (0, $fbOaB.default)(_ref, $37de3ba95f4cd307$var$_excluded);
    var handleEnter = (0, $eeH7J.useCallback)(function(node) {
        (0, $u31lg.default)(node);
        if (props.onEnter) props.onEnter(node);
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $dgdSM.default), (0, $h4XE0.default)({
        ref: ref,
        addEndListener: (0, $kYTG4.default)
    }, props, {
        onEnter: handleEnter
    }), function(status, innerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).cloneElement(children, (0, $h4XE0.default)({}, innerProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))("fade", className, children.props.className, $37de3ba95f4cd307$var$fadeStyles[status])
        }));
    });
});
$37de3ba95f4cd307$var$Fade.defaultProps = $37de3ba95f4cd307$var$defaultProps;
$37de3ba95f4cd307$var$Fade.displayName = "Fade";
var $37de3ba95f4cd307$export$2e2bcd8739ae039 = $37de3ba95f4cd307$var$Fade;

});
parcelRegister("dgdSM", function(module, exports) {

$parcel$export(module.exports, "EXITED", function () { return $9a7789c95be58aaf$export$84cbff306f539230; });
$parcel$export(module.exports, "ENTERING", function () { return $9a7789c95be58aaf$export$df38205c966be359; });
$parcel$export(module.exports, "ENTERED", function () { return $9a7789c95be58aaf$export$78e9e6e3e014d60a; });
$parcel$export(module.exports, "EXITING", function () { return $9a7789c95be58aaf$export$4aacc83d4d59139f; });
$parcel$export(module.exports, "default", function () { return $9a7789c95be58aaf$export$2e2bcd8739ae039; });

var $fbOaB = parcelRequire("fbOaB");

var $ltdWF = parcelRequire("ltdWF");


var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $dCkbE = parcelRequire("dCkbE");


var $kABMZ = parcelRequire("kABMZ");

var $gzx7L = parcelRequire("gzx7L");
var $9a7789c95be58aaf$export$bb38bb9a1161268 = "unmounted";
var $9a7789c95be58aaf$export$84cbff306f539230 = "exited";
var $9a7789c95be58aaf$export$df38205c966be359 = "entering";
var $9a7789c95be58aaf$export$78e9e6e3e014d60a = "entered";
var $9a7789c95be58aaf$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $9a7789c95be58aaf$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $ltdWF.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $9a7789c95be58aaf$export$84cbff306f539230;
                _this.appearStatus = $9a7789c95be58aaf$export$df38205c966be359;
            } else initialStatus = $9a7789c95be58aaf$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $9a7789c95be58aaf$export$bb38bb9a1161268;
        else initialStatus = $9a7789c95be58aaf$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $9a7789c95be58aaf$export$bb38bb9a1161268) return {
            status: $9a7789c95be58aaf$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $9a7789c95be58aaf$export$df38205c966be359 && status !== $9a7789c95be58aaf$export$78e9e6e3e014d60a) nextStatus = $9a7789c95be58aaf$export$df38205c966be359;
            } else if (status === $9a7789c95be58aaf$export$df38205c966be359 || status === $9a7789c95be58aaf$export$78e9e6e3e014d60a) nextStatus = $9a7789c95be58aaf$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $9a7789c95be58aaf$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $gzx7L.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $9a7789c95be58aaf$export$84cbff306f539230) this.setState({
            status: $9a7789c95be58aaf$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dCkbE.default).disabled) {
            this.safeSetState({
                status: $9a7789c95be58aaf$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $9a7789c95be58aaf$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $9a7789c95be58aaf$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dCkbE.default).disabled) {
            this.safeSetState({
                status: $9a7789c95be58aaf$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $9a7789c95be58aaf$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $9a7789c95be58aaf$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $9a7789c95be58aaf$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $fbOaB.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $kABMZ.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
$9a7789c95be58aaf$var$Transition.contextType = (0, $kABMZ.default);
$9a7789c95be58aaf$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $9a7789c95be58aaf$var$noop() {}
$9a7789c95be58aaf$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $9a7789c95be58aaf$var$noop,
    onEntering: $9a7789c95be58aaf$var$noop,
    onEntered: $9a7789c95be58aaf$var$noop,
    onExit: $9a7789c95be58aaf$var$noop,
    onExiting: $9a7789c95be58aaf$var$noop,
    onExited: $9a7789c95be58aaf$var$noop
};
$9a7789c95be58aaf$var$Transition.UNMOUNTED = $9a7789c95be58aaf$export$bb38bb9a1161268;
$9a7789c95be58aaf$var$Transition.EXITED = $9a7789c95be58aaf$export$84cbff306f539230;
$9a7789c95be58aaf$var$Transition.ENTERING = $9a7789c95be58aaf$export$df38205c966be359;
$9a7789c95be58aaf$var$Transition.ENTERED = $9a7789c95be58aaf$export$78e9e6e3e014d60a;
$9a7789c95be58aaf$var$Transition.EXITING = $9a7789c95be58aaf$export$4aacc83d4d59139f;
var $9a7789c95be58aaf$export$2e2bcd8739ae039 = $9a7789c95be58aaf$var$Transition;

});
parcelRegister("ltdWF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa171fa37ae5504e$export$2e2bcd8739ae039; });

var $1SHDq = parcelRequire("1SHDq");
function $fa171fa37ae5504e$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $1SHDq.default)(t, o);
}

});
parcelRegister("1SHDq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15ecae95fe777e95$export$2e2bcd8739ae039; });
function $15ecae95fe777e95$export$2e2bcd8739ae039(t, e) {
    return $15ecae95fe777e95$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $15ecae95fe777e95$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("dCkbE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e9e7bae783ed0bd$export$2e2bcd8739ae039; });
var $9e9e7bae783ed0bd$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("kABMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efd47b99065a7704$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
var $efd47b99065a7704$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext(null);

});

parcelRegister("gzx7L", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $c1099c01480d60c0$export$7d26bbb1236dafd6; });
var $c1099c01480d60c0$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("kYTG4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f46499abb6168b12$export$2e2bcd8739ae039; });

var $5u0qA = parcelRequire("5u0qA");

var $ljFof = parcelRequire("ljFof");
function $f46499abb6168b12$var$parseDuration(node, property) {
    var str = (0, $5u0qA.default)(node, property) || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $f46499abb6168b12$export$2e2bcd8739ae039(element, handler) {
    var duration = $f46499abb6168b12$var$parseDuration(element, "transitionDuration");
    var delay = $f46499abb6168b12$var$parseDuration(element, "transitionDelay");
    var remove = (0, $ljFof.default)(element, function(e) {
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}

});
parcelRegister("5u0qA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fe01611bb49f91e$export$2e2bcd8739ae039; });

var $2Sp6S = parcelRequire("2Sp6S");

var $4Sp77 = parcelRequire("4Sp77");

var $ht0jY = parcelRequire("ht0jY");
function $3fe01611bb49f91e$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $4Sp77.default)(property)) || (0, $2Sp6S.default)(node).getPropertyValue((0, $4Sp77.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $4Sp77.default)(key));
        else if ((0, $ht0jY.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $4Sp77.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $3fe01611bb49f91e$export$2e2bcd8739ae039 = $3fe01611bb49f91e$var$style;

});
parcelRegister("2Sp6S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21841a3c38daf6fb$export$2e2bcd8739ae039; });

var $6lE56 = parcelRequire("6lE56");
function $21841a3c38daf6fb$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $6lE56.default)(node).getComputedStyle(node, psuedoElement);
}

});
parcelRegister("6lE56", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49f3cb8b52c700bb$export$2e2bcd8739ae039; });

var $84cPa = parcelRequire("84cPa");
function $49f3cb8b52c700bb$export$2e2bcd8739ae039(node) {
    var doc = (0, $84cPa.default)(node);
    return doc && doc.defaultView || window;
}

});


parcelRegister("4Sp77", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38cfafa288feede8$export$2e2bcd8739ae039; });
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ 
var $dFJJa = parcelRequire("dFJJa");
var $38cfafa288feede8$var$msPattern = /^ms-/;
function $38cfafa288feede8$export$2e2bcd8739ae039(string) {
    return (0, $dFJJa.default)(string).replace($38cfafa288feede8$var$msPattern, "-ms-");
}

});
parcelRegister("dFJJa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f4293402fe8d4ea$export$2e2bcd8739ae039; });
var $9f4293402fe8d4ea$var$rUpper = /([A-Z])/g;
function $9f4293402fe8d4ea$export$2e2bcd8739ae039(string) {
    return string.replace($9f4293402fe8d4ea$var$rUpper, "-$1").toLowerCase();
}

});


parcelRegister("ht0jY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb7564e3206732b8$export$2e2bcd8739ae039; });
var $cb7564e3206732b8$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $cb7564e3206732b8$export$2e2bcd8739ae039(value) {
    return !!(value && $cb7564e3206732b8$var$supportedTransforms.test(value));
}

});


parcelRegister("ljFof", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f84b7a8775eb2c4a$export$2e2bcd8739ae039; });

var $5u0qA = parcelRequire("5u0qA");

var $insCM = parcelRequire("insCM");

var $faZXm = parcelRequire("faZXm");
function $f84b7a8775eb2c4a$var$parseDuration(node) {
    var str = (0, $5u0qA.default)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $f84b7a8775eb2c4a$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $faZXm.default)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $insCM.default)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $f84b7a8775eb2c4a$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $f84b7a8775eb2c4a$var$parseDuration(element) || 0;
    var removeEmulate = $f84b7a8775eb2c4a$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $insCM.default)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}

});
parcelRegister("faZXm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0c7d97643588a9e$export$2e2bcd8739ae039; });
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $b0c7d97643588a9e$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

});



parcelRegister("u31lg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a5254b267ceee7$export$2e2bcd8739ae039; });
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $05a5254b267ceee7$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

});



parcelRegister("4SGh4", function(module, exports) {

$parcel$export(module.exports, "InsertImage", function () { return $38dcff59e0b191e5$export$4ff79810d1c58efe; });
function $38dcff59e0b191e5$export$4ff79810d1c58efe(draftJs, editorState, src, alt) {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity("IMAGE", "IMMUTABLE", {
        src: src,
        alt: alt,
        // This is a workaround for a quirk in draftjs-md-converter, which
        // expects the image to have a fileName property, which in turn is
        // passet as "alt"
        fileName: alt
    });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = draftJs.EditorState.set(editorState, {
        currentContent: contentStateWithEntity
    });
    return draftJs.AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
}

});

parcelRegister("6sp4J", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $4b38cf077d3cd72a$export$f04a61298a47a40f; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $7m9cQ = parcelRequire("7m9cQ");
function $4b38cf077d3cd72a$export$f04a61298a47a40f({ icon: icon, width: width, height: height, color: color, size: size, style: style }) {
    width !== null && width !== void 0 ? width : width = size;
    height !== null && height !== void 0 ? height : height = size;
    if (icon.startsWith("ui-")) {
        const iconUrl = `${(0, $7m9cQ.server)()}/ui-icons/${icon.slice(3)}${color ? `?stroke=${encodeURIComponent(color)}` : ""}`;
        // Untitled UI icons
        return (0, $4vwom.jsx)($4b38cf077d3cd72a$var$Svg, {
            url: iconUrl,
            width: width,
            height: height,
            color: color,
            style: style
        });
    }
    return (0, $4vwom.jsx)("i", {
        className: "fas fa-" + icon,
        style: Object.assign({
            width: width,
            height: height,
            color: color
        }, style)
    });
}
const $4b38cf077d3cd72a$var$iconCache = new Map();
function $4b38cf077d3cd72a$var$Svg({ url: url, width: width, height: height, style: style, color: color }) {
    const [data, setData] = (0, $eeH7J.useState)($4b38cf077d3cd72a$var$iconCache.get(url));
    (0, $eeH7J.useEffect)(()=>{
        if (!$4b38cf077d3cd72a$var$iconCache.has(url)) {
            const listeners = [];
            $4b38cf077d3cd72a$var$iconCache.set(url, listeners);
            listeners.push(setData);
            fetch(url).then((res)=>res.text()).then((d)=>{
                $4b38cf077d3cd72a$var$iconCache.set(url, d);
                listeners.forEach((listener)=>listener(d));
            });
        }
        const cacheEntry = $4b38cf077d3cd72a$var$iconCache.get(url);
        if (cacheEntry instanceof Array) {
            if (!cacheEntry.includes(setData)) cacheEntry.push(setData);
        } else setData(cacheEntry);
    }, [
        color,
        url,
        style
    ]);
    return typeof data === "string" ? (0, $4vwom.jsx)("svg", {
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        fill: "none",
        dangerouslySetInnerHTML: {
            __html: data
        },
        style: style
    }) : null;
}

});


parcelRegister("fT6Pt", function(module, exports) {

$parcel$export(module.exports, "RButton", function () { return $b9114a3b4926548e$export$b4ae8418df2fbc; });
$parcel$export(module.exports, "ContextButton", function () { return $b9114a3b4926548e$export$d937a95be28526bd; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $fTlTn = parcelRequire("fTlTn");
var $1rVia = parcelRequire("1rVia");
var $gLzHS = parcelRequire("gLzHS");

var $fz3r9 = parcelRequire("fz3r9");

var $gaj8U = parcelRequire("gaj8U");

var $6sp4J = parcelRequire("6sp4J");

var $5K1mb = parcelRequire("5K1mb");

var $9Q5xE = parcelRequire("9Q5xE");
var $b9114a3b4926548e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $b9114a3b4926548e$export$b4ae8418df2fbc(props) {
    var _a, _b;
    const [popupVisible, setPopupVisible] = (0, $eeH7J.useState)(false);
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const [busy, setBusy] = (0, $eeH7J.useState)(false);
    const busyIndicatorVisible = (0, $gaj8U.useDebounce)(busy, 250);
    const style = props.style instanceof Function ? props.style(hover) : props.style;
    const highlight = hover && !props.disabled;
    let backgroundColor = props.variant === "primary" ? highlight ? (0, $9Q5xE.ColorStyles).primary[700] : (0, $9Q5xE.ColorStyles).primary[800] : highlight ? (0, $9Q5xE.ColorStyles).gray[100] : undefined;
    const active = props.active || popupVisible;
    let color = (0, $9Q5xE.ColorStyles).gray[700];
    if (active) color = (0, $9Q5xE.ColorStyles).primary[700];
    if (props.variant === "secondary") color = (0, $9Q5xE.ColorStyles).primary[700];
    if (props.variant === "primary") color = "white";
    if (props.variant === "link") {
        backgroundColor = undefined;
        color = hover ? (0, $9Q5xE.ColorStyles).primary[700] : (0, $9Q5xE.ColorStyles).primary[500];
    }
    if (props.variant === "danger" && hover) {
        backgroundColor = (0, $9Q5xE.ColorStyles).error[500];
        color = "white";
    }
    if (props.color) color = props.color;
    const anyContent = props.children !== undefined && (props.children instanceof Array ? props.children.some((x)=>!!x) : true);
    const { popup: popup } = props;
    const elementTarget = (0, $eeH7J.useRef)(null);
    const hoverDelayed = (0, $gaj8U.useDebounce)(hover, 1000);
    const iconSize = (_a = props.iconSize) !== null && _a !== void 0 ? _a : 22;
    const btn = (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            props.tooltip && (0, $4vwom.jsx)((0, $fTlTn.default), {
                target: elementTarget,
                show: hover && hoverDelayed,
                placement: (_b = props.tooltipPlacement) !== null && _b !== void 0 ? _b : "top",
                children: (p)=>(0, $4vwom.jsx)((0, $gLzHS.default), Object.assign({
                        id: "overlay-example"
                    }, p, {
                        children: props.tooltip
                    }))
            }),
            (0, $4vwom.jsxs)("div", Object.assign({
                ref: elementTarget,
                onClick: props.link && !props.onClick ? undefined : async (e)=>{
                    e.stopPropagation();
                    if (props.disabled) return;
                    if (props.onClick) {
                        setBusy(true);
                        await props.onClick();
                        setBusy(false);
                    }
                    if (popup) setPopupVisible(!popupVisible);
                }
            }, hoverProps, {
                className: props.className ? props.className + " hide-in-print" : "hide-in-print",
                style: Object.assign({
                    flexDirection: "row",
                    alignItems: "center",
                    opacity: props.disabled ? 0.6 : 1,
                    borderRadius: 8,
                    borderStyle: props.variant === "link" ? undefined : "solid",
                    borderWidth: props.borderColor ? 1 : 0,
                    borderColor: props.borderColor,
                    userSelect: "none",
                    padding: "0.5rem",
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                    fontSize: 16,
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: props.disabled ? undefined : "pointer"
                }, style),
                children: [
                    props.icon && (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                        icon: props.icon,
                        color: color,
                        size: iconSize,
                        style: {
                            marginTop: 0,
                            color: color,
                            fontSize: iconSize,
                            width: iconSize,
                            height: iconSize
                        }
                    }),
                    props.children && (0, $4vwom.jsx)("div", {
                        className: props.icon ? "studio-button-content-with-icon" : undefined,
                        children: props.children
                    }),
                    busyIndicatorVisible && (0, $4vwom.jsx)((0, $1rVia.default), {
                        animation: "grow",
                        size: "sm",
                        style: {
                            marginLeft: 8
                        }
                    }),
                    (popup || props.chevron) && !props.hideChevron && (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                        color: (0, $9Q5xE.ColorStyles).gray[700],
                        icon: props.chevron || "chevron-down",
                        style: {
                            marginLeft: anyContent ? 16 : 0,
                            color: color,
                            fontSize: 14,
                            maxWidth: 24,
                            maxHeight: 24
                        }
                    })
                ]
            })),
            popup && (0, $4vwom.jsx)((0, $fTlTn.default), {
                target: elementTarget,
                show: popupVisible,
                placement: props.popupPlacement || "bottom-start",
                children: (_a)=>{
                    var { placement: placement, arrowProps: arrowProps, show: _show, popper: popper } = _a, popperProps = $b9114a3b4926548e$var$__rest(_a, [
                        "placement",
                        "arrowProps",
                        "show",
                        "popper"
                    ]);
                    return (0, $4vwom.jsx)("div", Object.assign({
                        onMouseLeave: ()=>setPopupVisible(false)
                    }, popperProps, {
                        style: Object.assign({
                            backgroundColor: "white",
                            padding: "0.5rem",
                            boxShadow: (0, $9Q5xE.OverlayShadow),
                            borderRadius: 3,
                            zIndex: 110
                        }, popperProps.style),
                        children: popup(()=>setPopupVisible(false))
                    }));
                }
            })
        ]
    });
    if (props.link && !props.disabled) return (0, $4vwom.jsx)((0, $5K1mb.Link), {
        to: props.link,
        target: props.openLinkInNewTab ? "_blank" : undefined,
        style: {
            textDecoration: "none"
        },
        children: btn
    });
    else return btn;
}
function $b9114a3b4926548e$export$d6f68d0fe29f8050({ onClick: onClick, style: style }) {
    return (0, $4vwom.jsx)($b9114a3b4926548e$export$b4ae8418df2fbc, {
        variant: "danger",
        onClick: onClick,
        icon: "trash",
        color: (0, $9Q5xE.ColorStyles).gray[300],
        style: Object.assign({
            borderWidth: 0
        }, style)
    });
}
function $b9114a3b4926548e$export$a74f9e4ec49e14f8({ onClick: onClick }) {
    return (0, $4vwom.jsx)($b9114a3b4926548e$export$b4ae8418df2fbc, {
        variant: "primary",
        icon: "bars",
        onClick: onClick
    });
}
function $b9114a3b4926548e$export$6d88ebe453be59d7({ onClick: onClick, text: text, style: style }) {
    return (0, $4vwom.jsx)($b9114a3b4926548e$export$b4ae8418df2fbc, {
        style: style,
        variant: "secondary",
        icon: "plus",
        onClick: onClick,
        className: "reactor-form-small-label",
        children: text
    });
}
function $b9114a3b4926548e$export$d937a95be28526bd(props) {
    return (0, $4vwom.jsx)($b9114a3b4926548e$export$b4ae8418df2fbc, {
        icon: "ui-dots-horizontal",
        hideChevron: true,
        style: {
            borderWidth: 0,
            padding: 4,
            margin: 0
        },
        popup: ()=>props.buttons,
        iconSize: 16,
        popupPlacement: "left-start"
    });
}
function $b9114a3b4926548e$export$e475faf34e2d9799({ text: text, buttons: buttons }) {
    return (0, $4vwom.jsx)($b9114a3b4926548e$export$b4ae8418df2fbc, {
        variant: "secondary",
        icon: "plus",
        popup: ()=>buttons,
        children: text
    });
}

});
parcelRegister("1rVia", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10e4c1119a20bf51$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $57SUk = parcelRequire("57SUk");
var $10e4c1119a20bf51$var$_excluded = [
    "bsPrefix",
    "variant",
    "animation",
    "size",
    "children",
    "as",
    "className"
];
var $10e4c1119a20bf51$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, variant = _ref.variant, animation = _ref.animation, size = _ref.size, children = _ref.children, _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, className = _ref.className, props = (0, $fbOaB.default)(_ref, $10e4c1119a20bf51$var$_excluded);
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "spinner");
    var bsSpinnerPrefix = bsPrefix + "-" + animation;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsSpinnerPrefix, size && bsSpinnerPrefix + "-" + size, variant && "text-" + variant)
    }), children);
});
$10e4c1119a20bf51$var$Spinner.displayName = "Spinner";
var $10e4c1119a20bf51$export$2e2bcd8739ae039 = $10e4c1119a20bf51$var$Spinner;

});

parcelRegister("gLzHS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c34cbbbca6dc5c29$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");
parcelRequire("eKizm");

var $57SUk = parcelRequire("57SUk");
var $c34cbbbca6dc5c29$var$_excluded = [
    "bsPrefix",
    "placement",
    "className",
    "style",
    "children",
    "arrowProps",
    "popper",
    "show"
];
var $c34cbbbca6dc5c29$var$defaultProps = {
    placement: "right"
};
var $c34cbbbca6dc5c29$var$Tooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, placement = _ref.placement, className = _ref.className, style = _ref.style, children = _ref.children, arrowProps = _ref.arrowProps, _ = _ref.popper, _2 = _ref.show, props = (0, $fbOaB.default)(_ref, $c34cbbbca6dc5c29$var$_excluded);
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "tooltip");
    var _ref2 = (placement == null ? void 0 : placement.split("-")) || [], primaryPlacement = _ref2[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", (0, $h4XE0.default)({
        ref: ref,
        style: style,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsPrefix, "bs-tooltip-" + primaryPlacement)
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", (0, $h4XE0.default)({
        className: "arrow"
    }, arrowProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: bsPrefix + "-inner"
    }, children));
});
$c34cbbbca6dc5c29$var$Tooltip.defaultProps = $c34cbbbca6dc5c29$var$defaultProps;
$c34cbbbca6dc5c29$var$Tooltip.displayName = "Tooltip";
var $c34cbbbca6dc5c29$export$2e2bcd8739ae039 = $c34cbbbca6dc5c29$var$Tooltip;

});
parcelRegister("eKizm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $abc3c40975986791$var$isRequiredForA11y;
function $abc3c40975986791$var$isRequiredForA11y(validator) {
    return function validate(props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) return new Error("The " + location + " `" + propFullNameSafe + "` is required to make " + ("`" + componentNameSafe + "` accessible for users of assistive ") + "technologies such as screen readers.");
        for(var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)args[_key - 5] = arguments[_key];
        return validator.apply(undefined, [
            props,
            propName,
            componentName,
            location,
            propFullName
        ].concat(args));
    };
}
module.exports = module.exports["default"];

});



parcelRegister("2chu2", function(module, exports) {

$parcel$export(module.exports, "Lazy", function () { return $199a43a1a56c24a6$export$b624eff549462981; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
function $199a43a1a56c24a6$export$b624eff549462981(props) {
    const [comp, setComponent] = (0, $eeH7J.useState)();
    (0, $eeH7J.useEffect)(()=>{
        if (props.load !== false) {
            const res = props.target();
            res.then((comp)=>{
                setComponent({
                    comp: comp
                });
            });
        }
    }, [
        props.load
    ]);
    if (comp) return (0, $4vwom.jsx)(comp.comp, {});
    else if (props.fallback) return (0, $4vwom.jsx)(props.fallback, {});
    else return (0, $4vwom.jsx)("div", {
        children: "Loading..."
    });
}

});

parcelRegister("cUDOr", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("5xFdn").then(()=>parcelRequire("a7Voa"));

});

parcelRegister("hPh1J", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("1veE1").then(()=>parcelRequire("latBp"));

});

parcelRegister("cUbQe", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("7twdE").then(()=>parcelRequire("2vh9S"));

});


parcelRegister("joIUH", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("cPuQK"),
    $Ks0wJ("kEDuT"),
    $Ks0wJ("izP8j"),
    $Ks0wJ("bGtNJ"),
    $Ks0wJ("f7hWB")
]).then(()=>parcelRequire("alItr"));

});

parcelRegister("5gIPd", function(module, exports) {

$parcel$export(module.exports, "SidebarTheme", function () { return $3d6137b067c87476$export$54af0ae22283becb; });

var $lDBHC = parcelRequire("lDBHC");
let $3d6137b067c87476$var$light = true;
const $3d6137b067c87476$export$54af0ae22283becb = {
    get light () {
        return $3d6137b067c87476$var$light;
    },
    set light (value){
        if (!(0, $lDBHC.IsNode)() && value) document.head.insertAdjacentHTML("beforeend", `<style>::-webkit-calendar-picker-indicator {
            filter: invert(1);
        }</style>`);
        $3d6137b067c87476$var$light = value;
    },
    /** A CSS background string.
     *
     *  Any combination of CSS backgrounds is supported, for example:
     *
     *  `"linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url('/static/bg.png") no-repeat center center/cover"`
     */ background: undefined
};

});


var $4vwom = parcelRequire("4vwom");

var $5K1mb = parcelRequire("5K1mb");
"use strict";
globalThis.ssrTransaction = {};



var $4DHNO = parcelRequire("4DHNO");

var $8jB4x = parcelRequire("8jB4x");

var $7m9cQ = parcelRequire("7m9cQ");
var $e18f565b44c7bc7d$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $e18f565b44c7bc7d$var$__await ? (this.v = v, this) : new $e18f565b44c7bc7d$var$__await(v);
};
var $e18f565b44c7bc7d$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e18f565b44c7bc7d$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
const $e18f565b44c7bc7d$export$ebe90cb607ad99e = {
    baseUrl: (0, $7m9cQ.server)(),
    fetch (input, init) {
        // fetch() really wants to be called like this, treating it as a
        // value won't work
        return fetch(input, init);
    },
    headers: {
        "Content-Type": "application/json"
    }
};
// Creates an adapter so browser and node streams can be used interchangeably
function $e18f565b44c7bc7d$var$readStream(stream) {
    return $e18f565b44c7bc7d$var$__asyncGenerator(this, arguments, function* readStream_1() {
        const reader = stream.getReader();
        while(true){
            const { done: done, value: value } = yield $e18f565b44c7bc7d$var$__await(reader.read());
            if (done) break;
            yield yield $e18f565b44c7bc7d$var$__await(value);
        }
    });
}
/** Registers a link in the email system and returns a URL that can be used to
access the link with tracking. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getEmailLinkRegister",
    func: $e18f565b44c7bc7d$export$f41793ac729e4ee9
});
async function $e18f565b44c7bc7d$export$f41793ac729e4ee9(link, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (link !== undefined) queryArgs.push("link=" + encodeURIComponent(link.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/email/link-register${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$bacd462009012de5 = (0, $8jB4x.SSRHook)("getEmailLinkRegister", undefined, undefined, $e18f565b44c7bc7d$export$f41793ac729e4ee9, [
    "link"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getAnalyticsCachePerformanceStats",
    func: $e18f565b44c7bc7d$export$ceb54ea1fc375c3a
});
async function $e18f565b44c7bc7d$export$ceb54ea1fc375c3a(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/analytics-cache-monitor/stats`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$3492893e85f47f53 = (0, $8jB4x.SSRHook)("getAnalyticsCachePerformanceStats", undefined, undefined, $e18f565b44c7bc7d$export$ceb54ea1fc375c3a, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getShippingOptions",
    func: $e18f565b44c7bc7d$export$5472db18491ba3b8
});
async function $e18f565b44c7bc7d$export$5472db18491ba3b8(countryCode, zipCode, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (countryCode !== undefined) queryArgs.push("countryCode=" + encodeURIComponent(countryCode.valueOf()));
        if (zipCode !== undefined) queryArgs.push("zipCode=" + encodeURIComponent(zipCode.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/shipping-options${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$2019485bfe6f9ed5 = (0, $8jB4x.SSRHook)("getShippingOptions", "GetShippingOptionsDto", undefined, $e18f565b44c7bc7d$export$5472db18491ba3b8, [
    "countryCode",
    "zipCode"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getRenewalOptions",
    func: $e18f565b44c7bc7d$export$1fda0dbbcc42bfdc
});
async function $e18f565b44c7bc7d$export$1fda0dbbcc42bfdc(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders/${id}/renewal-options`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$7a27aaf538106e3e(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "UnauthorizedWithVipps");
}
const $e18f565b44c7bc7d$export$cd3361f95bba4719 = (0, $8jB4x.SSRHook)("getRenewalOptions", "GetRenewalOptionsDto", undefined, $e18f565b44c7bc7d$export$1fda0dbbcc42bfdc, [
    "id"
], undefined);
/** Renews a phone order with the given number of months.

The months must be one of the renewal options available for the phone model,
returned by `getRenewalOptions`. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postRenewal",
    func: $e18f565b44c7bc7d$export$e88ba7c9a7cf1f6
});
async function $e18f565b44c7bc7d$export$e88ba7c9a7cf1f6(id, months, tnc, tncInsurance, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (months !== undefined) queryArgs.push("months=" + encodeURIComponent(months.valueOf()));
        if (tnc !== undefined) queryArgs.push("tnc=" + encodeURIComponent(tnc.valueOf()));
        if (tncInsurance !== undefined) queryArgs.push("tncInsurance=" + encodeURIComponent(tncInsurance.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders/${id}/renewal${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$ff1ce19ba9dc49ae(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "UnauthorizedWithVipps");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneOrders",
    func: $e18f565b44c7bc7d$export$cb8b42d135ef9214
});
async function $e18f565b44c7bc7d$export$cb8b42d135ef9214(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$5b6bce39f9daa63f(e) {
    return e && typeof e === "object" && "type" in e && e.type === "UnauthorizedWithVipps";
}
const $e18f565b44c7bc7d$export$25a35ae850463813 = (0, $8jB4x.SSRHook)("getPhoneOrders", "GetPhoneOrdersDto", undefined, $e18f565b44c7bc7d$export$cb8b42d135ef9214, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneOrder",
    func: $e18f565b44c7bc7d$export$b2d4561583563d44
});
async function $e18f565b44c7bc7d$export$b2d4561583563d44(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$dae43a8e729c9b52(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $e18f565b44c7bc7d$export$42d4e273b2226793 = (0, $8jB4x.SSRHook)("getPhoneOrder", "GetPhoneOrderDto", undefined, $e18f565b44c7bc7d$export$b2d4561583563d44, [
    "id"
], undefined);
/** Validates, checks availability and calculates the price of a phone order. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postPhoneOrderPrice",
    func: $e18f565b44c7bc7d$export$3645f875e233981
});
async function $e18f565b44c7bc7d$export$3645f875e233981(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-order/price`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$ddc48e3763c09f34(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Conflict" || e.type === "NoPhoneWithSpecifiedProperties" || e.type === "NotFound" || e.type === "BadTradeInResponse");
}
const $e18f565b44c7bc7d$export$541c7c1cebe5b937 = (0, $8jB4x.SSRHook)("postPhoneOrderPrice", "PhoneOrderPrice", undefined, $e18f565b44c7bc7d$export$3645f875e233981, [
    "body"
], undefined);
/** Places a phone order for the current user. This implies consent to the terms
and conditions. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postPhoneOrder",
    func: $e18f565b44c7bc7d$export$6cb3fb5ed3274c4c
});
async function $e18f565b44c7bc7d$export$6cb3fb5ed3274c4c(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-order`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$3a3bb931e8cd5a6f(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "BadRequest" || e.type === "UnauthorizedWithVipps" || e.type === "Conflict" || e.type === "NoPhoneWithSpecifiedProperties" || e.type === "NotFound" || e.type === "BadTradeInResponse" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postOrderTradeIn",
    func: $e18f565b44c7bc7d$export$6b2bf9023d89c7d6
});
async function $e18f565b44c7bc7d$export$6b2bf9023d89c7d6(id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-order/${id}/trade-in`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$26b6f4574ce244f6(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest" || e.type === "BadTradeInResponse");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postExpirePhoneReservationOrder",
    func: $e18f565b44c7bc7d$export$a2c4756bb6719a7
});
async function $e18f565b44c7bc7d$export$a2c4756bb6719a7(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (id !== undefined) queryArgs.push("id=" + encodeURIComponent(id.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/expire/phone/reservation/order${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$c3abc700d4edc9c9(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "UnauthorizedWithVipps");
}
/** Returns offers for the phones available for sale.
Pass models argument to limit which models to get offers for. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneOffers",
    func: $e18f565b44c7bc7d$export$aa261a0b4ba6dd2c
});
async function $e18f565b44c7bc7d$export$aa261a0b4ba6dd2c(models, sizes, colors, rentalPeriod, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (models !== undefined) queryArgs.push(...models.map((x)=>"models=" + encodeURIComponent(x.valueOf())));
        if (sizes !== undefined) queryArgs.push(...sizes.map((x)=>"sizes=" + encodeURIComponent(x.valueOf())));
        if (colors !== undefined) queryArgs.push(...colors.map((x)=>"colors=" + encodeURIComponent(x.valueOf())));
        if (rentalPeriod !== undefined) queryArgs.push("rentalPeriod=" + encodeURIComponent(rentalPeriod.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-offers${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$7d28afe3114a6582(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $e18f565b44c7bc7d$export$88e20cfc122b8557 = (0, $8jB4x.SSRHook)("getPhoneOffers", undefined, undefined, $e18f565b44c7bc7d$export$aa261a0b4ba6dd2c, [
    "models",
    "sizes",
    "colors",
    "rentalPeriod"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneColors",
    func: $e18f565b44c7bc7d$export$f2c7748945d71cf1
});
async function $e18f565b44c7bc7d$export$f2c7748945d71cf1(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-colors`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$b75b9022126d533b = (0, $8jB4x.SSRHook)("getPhoneColors", undefined, undefined, $e18f565b44c7bc7d$export$f2c7748945d71cf1, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneStorageSizes",
    func: $e18f565b44c7bc7d$export$21629c2e15e3054f
});
async function $e18f565b44c7bc7d$export$21629c2e15e3054f(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-storage-sizes`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$4df04d41a3cf32b1 = (0, $8jB4x.SSRHook)("getPhoneStorageSizes", undefined, undefined, $e18f565b44c7bc7d$export$21629c2e15e3054f, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhonesPriceHistogram",
    func: $e18f565b44c7bc7d$export$12862f047242a8bf
});
async function $e18f565b44c7bc7d$export$12862f047242a8bf(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-price-histogram`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$fb6a4d4f8fc41d21(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "PhoneModelSoldOut" || e.type === "BadRequest");
}
const $e18f565b44c7bc7d$export$ada9abdd52b4cf46 = (0, $8jB4x.SSRHook)("getPhonesPriceHistogram", "GetPhonesPriceHistogramDto", undefined, $e18f565b44c7bc7d$export$12862f047242a8bf, [], undefined);
/** Returns a particular phone offer, including the available model specific configuration
options. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneOffer",
    func: $e18f565b44c7bc7d$export$3cb82d8424b9fdf6
});
async function $e18f565b44c7bc7d$export$3cb82d8424b9fdf6(id, rentalPeriod, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (rentalPeriod !== undefined) queryArgs.push("rentalPeriod=" + encodeURIComponent(rentalPeriod.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-offers/${id}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$b41bea5887a2cdec(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "PhoneModelSoldOut" || e.type === "BadRequest");
}
const $e18f565b44c7bc7d$export$b1c43cd413897984 = (0, $8jB4x.SSRHook)("getPhoneOffer", "GetPhoneOfferDto", undefined, $e18f565b44c7bc7d$export$3cb82d8424b9fdf6, [
    "id",
    "rentalPeriod"
], undefined);
/** Requests an updated phone offer after a user has modified it, e.g. selected a
different color or storage size. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postPhoneOffer",
    func: $e18f565b44c7bc7d$export$a5ae59f6dafb10b4
});
async function $e18f565b44c7bc7d$export$a5ae59f6dafb10b4(prop, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (prop !== undefined) queryArgs.push("prop=" + encodeURIComponent(prop.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-offers${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$201f3ad37fbc711f(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NoPhoneWithSpecifiedProperties" || e.type === "NotFound" || e.type === "BadRequest");
}
/** Returns information about a phone model, including the different attributes
and their possible values. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneModel",
    func: $e18f565b44c7bc7d$export$b3b8a99f0257f07b
});
async function $e18f565b44c7bc7d$export$b3b8a99f0257f07b(modelId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-models/${modelId}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$c59e944d78f7ce56 = (0, $8jB4x.SSRHook)("getPhoneModel", "GetPhoneModelDto", undefined, $e18f565b44c7bc7d$export$b3b8a99f0257f07b, [
    "modelId"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneModels",
    func: $e18f565b44c7bc7d$export$7eea0acc64eabf2c
});
async function $e18f565b44c7bc7d$export$7eea0acc64eabf2c(modelIds, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (modelIds !== undefined) queryArgs.push(...modelIds.map((x)=>"modelIds=" + encodeURIComponent(x.valueOf())));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-models${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$b99855a9ac1ee5b2 = (0, $8jB4x.SSRHook)("getPhoneModels", undefined, undefined, $e18f565b44c7bc7d$export$7eea0acc64eabf2c, [
    "modelIds"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getCountries",
    func: $e18f565b44c7bc7d$export$44f7508c6c352cc6
});
async function $e18f565b44c7bc7d$export$44f7508c6c352cc6(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/countries`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$1984d0199e312f12 = (0, $8jB4x.SSRHook)("getCountries", undefined, undefined, $e18f565b44c7bc7d$export$44f7508c6c352cc6, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getConditionGrades",
    func: $e18f565b44c7bc7d$export$e84835c21140fc65
});
async function $e18f565b44c7bc7d$export$e84835c21140fc65(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/condition/grades`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$713f13fb69b50c52 = (0, $8jB4x.SSRHook)("getConditionGrades", undefined, undefined, $e18f565b44c7bc7d$export$e84835c21140fc65, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getTradeInForm",
    func: $e18f565b44c7bc7d$export$54cccb78c371bb41
});
async function $e18f565b44c7bc7d$export$54cccb78c371bb41(type, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/trade-in-forms/${type}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$f8778ca18805596d = (0, $8jB4x.SSRHook)("getTradeInForm", "GetTradeInFormDto", undefined, $e18f565b44c7bc7d$export$54cccb78c371bb41, [
    "type"
], undefined);
/** Computes the value of your trade-in device. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postTradeInFormsValue",
    func: $e18f565b44c7bc7d$export$8f2b94717249315f
});
async function $e18f565b44c7bc7d$export$8f2b94717249315f(type, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/trade-in-forms/${type}/value`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$e802dabdf78fb12f(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadTradeInResponse" || e.type === "BadRequest");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getInsuranceOptions",
    func: $e18f565b44c7bc7d$export$633da977d987cf8f
});
async function $e18f565b44c7bc7d$export$633da977d987cf8f(model, storageSize, color, rentalPeriod, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (model !== undefined) queryArgs.push("model=" + encodeURIComponent(model.valueOf()));
        if (storageSize !== undefined) queryArgs.push("storageSize=" + encodeURIComponent(storageSize.valueOf()));
        if (color !== undefined) queryArgs.push("color=" + encodeURIComponent(color.valueOf()));
        if (rentalPeriod !== undefined) queryArgs.push("rentalPeriod=" + encodeURIComponent(rentalPeriod.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/insurance-options${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$efd5e43623a258fb(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $e18f565b44c7bc7d$export$fd8b73cd610fc548 = (0, $8jB4x.SSRHook)("getInsuranceOptions", undefined, undefined, $e18f565b44c7bc7d$export$633da977d987cf8f, [
    "model",
    "storageSize",
    "color",
    "rentalPeriod"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getMe",
    func: $e18f565b44c7bc7d$export$dd7946daa6163e94
});
async function $e18f565b44c7bc7d$export$dd7946daa6163e94(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/me`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$f637e1cf42d15a62 = (0, $8jB4x.SSRHook)("getMe", "GetMeDto", undefined, $e18f565b44c7bc7d$export$dd7946daa6163e94, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStoredPaymentMethods",
    func: $e18f565b44c7bc7d$export$1b242df43ef46728
});
async function $e18f565b44c7bc7d$export$1b242df43ef46728(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/me/payment-methods`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$4dab25304feab9ac(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "InternalServerError" || e.type === "UnauthorizedWithVipps");
}
const $e18f565b44c7bc7d$export$b66da2e92981394 = (0, $8jB4x.SSRHook)("getStoredPaymentMethods", undefined, undefined, $e18f565b44c7bc7d$export$1b242df43ef46728, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putMarketingConsent",
    func: $e18f565b44c7bc7d$export$97519be7b2793f54
});
async function $e18f565b44c7bc7d$export$97519be7b2793f54(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/me/marketing-consent`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$6ee92823d5224d38(e) {
    return e && typeof e === "object" && "type" in e && e.type === "UnauthorizedWithVipps";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putPreferredStoredPaymentMethod",
    func: $e18f565b44c7bc7d$export$d1167dfb180ea832
});
async function $e18f565b44c7bc7d$export$d1167dfb180ea832(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/me/preferred-stored-payment-method`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$19f075e049d800cd(e) {
    return e && typeof e === "object" && "type" in e && e.type === "UnauthorizedWithVipps";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getFrequentlyAskedQuestions",
    func: $e18f565b44c7bc7d$export$c2e4b7ca62d48533
});
async function $e18f565b44c7bc7d$export$c2e4b7ca62d48533(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/frequently/asked/questions`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$6eb271ef04c4063b = (0, $8jB4x.SSRHook)("getFrequentlyAskedQuestions", "FrequentlyAskedQuestions", undefined, $e18f565b44c7bc7d$export$c2e4b7ca62d48533, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getNewsletterUnsubscribePage",
    func: $e18f565b44c7bc7d$export$60549a259bcd51fc
});
async function $e18f565b44c7bc7d$export$60549a259bcd51fc(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/newsletter/unsubscribe-page`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$61180300cc91551d = (0, $8jB4x.SSRHook)("getNewsletterUnsubscribePage", "NewsletterUnsubscribePage", undefined, $e18f565b44c7bc7d$export$60549a259bcd51fc, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postNewsletterUnsubscribe",
    func: $e18f565b44c7bc7d$export$bc4051c7d3b69526
});
async function $e18f565b44c7bc7d$export$bc4051c7d3b69526(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/newsletter/unsubscribe`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getReviews",
    func: $e18f565b44c7bc7d$export$cf31305e89293b23
});
async function $e18f565b44c7bc7d$export$cf31305e89293b23(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/reviews`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$dfd0f591c1636cc4 = (0, $8jB4x.SSRHook)("getReviews", "Reviews", undefined, $e18f565b44c7bc7d$export$cf31305e89293b23, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getMoreReasonsToRedoit",
    func: $e18f565b44c7bc7d$export$16c7d461b2b40264
});
async function $e18f565b44c7bc7d$export$16c7d461b2b40264(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/more/reasons/to/redoit`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$3b68074ea3526841 = (0, $8jB4x.SSRHook)("getMoreReasonsToRedoit", "MoreReasonsToRedoit", undefined, $e18f565b44c7bc7d$export$16c7d461b2b40264, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getNotificationsClosed",
    func: $e18f565b44c7bc7d$export$afb894a8ae834f5b
});
async function $e18f565b44c7bc7d$export$afb894a8ae834f5b(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/notifications/closed`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$b1798547582b81c2 = (0, $8jB4x.SSRHook)("getNotificationsClosed", undefined, undefined, $e18f565b44c7bc7d$export$afb894a8ae834f5b, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postNotificationsClosed",
    func: $e18f565b44c7bc7d$export$87c93287defb9514
});
async function $e18f565b44c7bc7d$export$87c93287defb9514(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/notifications/closed`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getHeader",
    func: $e18f565b44c7bc7d$export$47ed31abc613cf55
});
async function $e18f565b44c7bc7d$export$47ed31abc613cf55(pageId, sectionId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (pageId !== undefined) queryArgs.push("pageId=" + encodeURIComponent(pageId.valueOf()));
        if (sectionId !== undefined) queryArgs.push("sectionId=" + encodeURIComponent(sectionId.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/header${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$ae602290ebd82f8e = (0, $8jB4x.SSRHook)("getHeader", "GetHeaderDto", undefined, $e18f565b44c7bc7d$export$47ed31abc613cf55, [
    "pageId",
    "sectionId"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getFooter",
    func: $e18f565b44c7bc7d$export$d65aa1cbf7afefff
});
async function $e18f565b44c7bc7d$export$d65aa1cbf7afefff(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/footer`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$d07da6ac6fc160b0 = (0, $8jB4x.SSRHook)("getFooter", "GetFooterDto", undefined, $e18f565b44c7bc7d$export$d65aa1cbf7afefff, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getCancellationTerms",
    func: $e18f565b44c7bc7d$export$2818e468f9045037
});
async function $e18f565b44c7bc7d$export$2818e468f9045037(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders/${id}/cancellation-terms`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$faccc0828c028929(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $e18f565b44c7bc7d$export$7a4a3d03ee7c067f = (0, $8jB4x.SSRHook)("getCancellationTerms", "GetCancellationTermsDto", undefined, $e18f565b44c7bc7d$export$2818e468f9045037, [
    "id"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "cancelSubscription",
    func: $e18f565b44c7bc7d$export$8061bbc383a29848
});
async function $e18f565b44c7bc7d$export$8061bbc383a29848(id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders/${id}`, {
            method: "delete",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$d25d32ed4f0ae875(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "BadRequest" || e.type === "UnauthorizedWithVipps");
}
/** Previews the terms and conditions for a phone order. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getGeneralPhoneOrderTermsAndConditions",
    func: $e18f565b44c7bc7d$export$60ebb89cc4bc9755
});
async function $e18f565b44c7bc7d$export$60ebb89cc4bc9755(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/terms-and-conditions/phone-order`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$23e8c26267d65867 = (0, $8jB4x.SSRHook)("getGeneralPhoneOrderTermsAndConditions", "GetGeneralPhoneOrderTermsAndConditionsDto", undefined, $e18f565b44c7bc7d$export$60ebb89cc4bc9755, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getTermsAndConditions",
    func: $e18f565b44c7bc7d$export$e9c540bc402f485f
});
async function $e18f565b44c7bc7d$export$e9c540bc402f485f(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/terms-and-conditions/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$8a333b178941277 = (0, $8jB4x.SSRHook)("getTermsAndConditions", "Localized", undefined, $e18f565b44c7bc7d$export$e9c540bc402f485f, [
    "id"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWellKnownAppleDeveloperMerchantidDomainAssociation",
    func: $e18f565b44c7bc7d$export$3dfbf19357781ac
});
async function $e18f565b44c7bc7d$export$3dfbf19357781ac(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/well/known/apple/developer/merchantid/domain/association`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$3eca391ca641a01(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $e18f565b44c7bc7d$export$b0856adccc7071a9 = (0, $8jB4x.SSRHook)("getWellKnownAppleDeveloperMerchantidDomainAssociation", undefined, undefined, $e18f565b44c7bc7d$export$3dfbf19357781ac, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postWaitingListModalOpen",
    func: $e18f565b44c7bc7d$export$a5a1f41fba9e8ed4
});
async function $e18f565b44c7bc7d$export$a5a1f41fba9e8ed4(source, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (source !== undefined) queryArgs.push("source=" + encodeURIComponent(source.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/waiting-list/modal-open${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postWaitingListSignup",
    func: $e18f565b44c7bc7d$export$2884e3ad03eef48
});
async function $e18f565b44c7bc7d$export$2884e3ad03eef48(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/waiting-list/signup`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$efd52de24b0e5de0(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}



var $dUDPg = parcelRequire("dUDPg");

var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");
var $edca1cc69f99f492$exports = {};

$parcel$export($edca1cc69f99f492$exports, "createRoot", function () { return $edca1cc69f99f492$export$882461b6382ed46c; }, function (v) { return $edca1cc69f99f492$export$882461b6382ed46c = v; });
$parcel$export($edca1cc69f99f492$exports, "hydrateRoot", function () { return $edca1cc69f99f492$export$757ceba2d55c277e; }, function (v) { return $edca1cc69f99f492$export$757ceba2d55c277e = v; });
var $edca1cc69f99f492$export$882461b6382ed46c;
var $edca1cc69f99f492$export$757ceba2d55c277e;
"use strict";

var $iMJCh = parcelRequire("iMJCh");
var $edca1cc69f99f492$var$i;
$edca1cc69f99f492$export$882461b6382ed46c = $iMJCh.createRoot;
$edca1cc69f99f492$export$757ceba2d55c277e = $iMJCh.hydrateRoot;



var $gc3M0 = parcelRequire("gc3M0");

var $8ZuUP = parcelRequire("8ZuUP");
const $19ea5142dc1f8ebf$var$cache = (0, $gc3M0.default)({
    key: "emotion-cache"
});
function $19ea5142dc1f8ebf$export$e547c4fd78449aad(RootComponent, /** ID of the DOM root element */ rootId = "root") {
    const rootEl = document.getElementById(rootId);
    if (rootEl) (0, (/*@__PURE__*/$parcel$interopDefault($edca1cc69f99f492$exports))).hydrateRoot(rootEl, (0, $4vwom.jsx)((0, $8ZuUP.C), {
        value: $19ea5142dc1f8ebf$var$cache,
        children: (0, $4vwom.jsx)(RootComponent, {})
    }));
}



var $4vwom = parcelRequire("4vwom");

var $18Pjr = parcelRequire("18Pjr");

var $lhaLc = parcelRequire("lhaLc");

var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");
parcelRequire("2LTO8");
var $fR074 = parcelRequire("fR074");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
"use client";
const $7e832de67499b416$export$a3579ca508007a95 = (0, $eeH7J.createContext)({});



var $eeH7J = parcelRequire("eeH7J");
/**
 * Note: Still used by components generated by old versions of Framer
 *
 * @deprecated
 */ const $d668ee93a17394d4$export$f3b8df5418bf8d44 = (0, $eeH7J.createContext)(null);



var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
const $8cf061ae720cd83e$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $17cc282998a57b95$export$700979bc83e7db82 = (0, $8cf061ae720cd83e$export$4e09c449d6c407f7) ? (0, $eeH7J.useLayoutEffect) : (0, $eeH7J.useEffect);


function $aa149596850bdc81$export$80c2a3957bcb42ea() {
    const isMounted = (0, $eeH7J.useRef)(false);
    (0, $17cc282998a57b95$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


const $c90734627ed96e3f$export$8793edee2d425525 = (any)=>any;


const $d3f03766da854ace$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


function $9e4d57345f27c35c$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $3e80ba1fbbf06577$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $3e80ba1fbbf06577$var$maxElapsed = 40;
function $3e80ba1fbbf06577$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $3e80ba1fbbf06577$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $9e4d57345f27c35c$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $d3f03766da854ace$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $3e80ba1fbbf06577$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $3e80ba1fbbf06577$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $3e80ba1fbbf06577$export$71ecace0a033b35a.length; i++)steps[$3e80ba1fbbf06577$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $2668c8a722676613$export$2cef06c20297c17d, cancel: $2668c8a722676613$export$ec99c0ef4978dccb, state: $2668c8a722676613$export$fff89137e9e818ce, steps: $2668c8a722676613$export$be3f796aed065412 } = (0, $3e80ba1fbbf06577$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $c90734627ed96e3f$export$8793edee2d425525), true);


function $d4efb7ad8dfd4b3f$export$91db9bc4f8ac944a() {
    const isMounted = (0, $aa149596850bdc81$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $eeH7J.useState)(0);
    const forceRender = (0, $eeH7J.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $eeH7J.useCallback)(()=>(0, $2668c8a722676613$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}


const $09145c077538a501$var$notify = (node)=>!node.isLayoutDirty && node.willUpdate(false);
function $09145c077538a501$export$df39f9da6f278ce7() {
    const nodes = new Set();
    const subscriptions = new WeakMap();
    const dirtyAll = ()=>nodes.forEach($09145c077538a501$var$notify);
    return {
        add: (node)=>{
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: (node)=>{
            nodes.delete(node);
            const unsubscribe = subscriptions.get(node);
            if (unsubscribe) {
                unsubscribe();
                subscriptions.delete(node);
            }
            dirtyAll();
        },
        dirty: dirtyAll
    };
}


"use client";
const $5358b7a8389876c7$var$shouldInheritGroup = (inherit)=>inherit === true;
const $5358b7a8389876c7$var$shouldInheritId = (inherit)=>$5358b7a8389876c7$var$shouldInheritGroup(inherit === true) || inherit === "id";
const $5358b7a8389876c7$export$7fe0cbe305f29bb4 = ({ children: children, id: id, inherit: inherit = true })=>{
    const layoutGroupContext = (0, $eeH7J.useContext)((0, $7e832de67499b416$export$a3579ca508007a95));
    const deprecatedLayoutGroupContext = (0, $eeH7J.useContext)((0, $d668ee93a17394d4$export$f3b8df5418bf8d44));
    const [forceRender, key] = (0, $d4efb7ad8dfd4b3f$export$91db9bc4f8ac944a)();
    const context = (0, $eeH7J.useRef)(null);
    const upstreamId = layoutGroupContext.id || deprecatedLayoutGroupContext;
    if (context.current === null) {
        if ($5358b7a8389876c7$var$shouldInheritId(inherit) && upstreamId) id = id ? upstreamId + "-" + id : upstreamId;
        context.current = {
            id: id,
            group: $5358b7a8389876c7$var$shouldInheritGroup(inherit) ? layoutGroupContext.group || (0, $09145c077538a501$export$df39f9da6f278ce7)() : (0, $09145c077538a501$export$df39f9da6f278ce7)()
        };
    }
    const memoizedContext = (0, $eeH7J.useMemo)(()=>({
            ...context.current,
            forceRender: forceRender
        }), [
        key
    ]);
    return (0, $dRzna.jsx)((0, $7e832de67499b416$export$a3579ca508007a95).Provider, {
        value: memoizedContext,
        children: children
    });
};


function $56c547a84798143f$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}


function $f29cdb74f4d8f17d$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $854bd2f427254747$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


function $618fd2d39a7e62c4$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $bfdcb20e850e14f7$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $195eed3b69cf8a61$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $195eed3b69cf8a61$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $195eed3b69cf8a61$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $195eed3b69cf8a61$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $e92cd1cec7066d98$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $195eed3b69cf8a61$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $7526b0a811789693$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $7526b0a811789693$export$1405a65085f40b9 = [
    "initial",
    ...$7526b0a811789693$export$16e45afcc206d3a8
];



/**
 * Generate a list of every possible transform key.
 */ const $ea8236087cf451dc$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ea8236087cf451dc$export$7b42a0094fb00b6e = new Set($ea8236087cf451dc$export$280dc01950909d86);


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $64e5667fa478a387$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $64e5667fa478a387$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $a714041f9b68b288$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $a714041f9b68b288$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $a714041f9b68b288$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $a714041f9b68b288$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $a714041f9b68b288$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $a714041f9b68b288$var$keyframesTransition;
    else if ((0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $a714041f9b68b288$var$criticallyDampedSpring(keyframes[1]) : $a714041f9b68b288$var$underDampedSpring;
    return $a714041f9b68b288$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $453e5e72c39cf7c2$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $453e5e72c39cf7c2$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $4f333d9188f46157$export$888a3d84909f9e3d = {
    current: false
};


const $3ca01ac9e8cf1f66$var$isNotNull = (value)=>value !== null;
function $3ca01ac9e8cf1f66$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($3ca01ac9e8cf1f66$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $ad0677d01318a032$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $17feb55ffe87f155$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $ad0677d01318a032$export$ade84c85e44a6cb1)(value);
    else return true;
}



let $2b9100c03bd61cb5$export$491112666e282270 = (0, $c90734627ed96e3f$export$8793edee2d425525);
let $2b9100c03bd61cb5$export$f5708dca728d7177 = (0, $c90734627ed96e3f$export$8793edee2d425525);
var $2b9100c03bd61cb5$var$check, $2b9100c03bd61cb5$var$message, $2b9100c03bd61cb5$var$check1, $2b9100c03bd61cb5$var$message1;


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $a9d0c51dad3a3292$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


const $7b632f63647c186c$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $7b632f63647c186c$export$9de1236619d9e756 = $7b632f63647c186c$var$checkStringStartsWith("--");
const $7b632f63647c186c$var$startsAsVariableToken = $7b632f63647c186c$var$checkStringStartsWith("var(--");
const $7b632f63647c186c$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $7b632f63647c186c$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $7b632f63647c186c$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $7b632f63647c186c$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $a5eac11b2abb9c45$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $a5eac11b2abb9c45$export$b9f0c1f373aee2b0(current) {
    const match = $a5eac11b2abb9c45$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $a5eac11b2abb9c45$var$maxDepth = 4;
function $a5eac11b2abb9c45$export$289398774300c991(current, element, depth = 1) {
    (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(depth <= $a5eac11b2abb9c45$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $a5eac11b2abb9c45$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $a9d0c51dad3a3292$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $7b632f63647c186c$export$31f9caa2600b5723)(fallback) ? $a5eac11b2abb9c45$export$289398774300c991(fallback, element, depth + 1) : fallback;
}




const $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $2a216475fc6839a7$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $2a216475fc6839a7$export$58f0f39f63f3cf42 = {
    ...$2a216475fc6839a7$export$98e628dec113755e,
    transform: (v)=>(0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $2a216475fc6839a7$export$dcdf75081b88279d = {
    ...$2a216475fc6839a7$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $08c2e9dc5cfbd69e$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $08c2e9dc5cfbd69e$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $08c2e9dc5cfbd69e$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $08c2e9dc5cfbd69e$export$844ec244b1367d54(v) {
    return typeof v === "string";
}
function $08c2e9dc5cfbd69e$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $2e2cc09c72ffc0aa$var$createUnitType = (unit)=>({
        test: (v)=>(0, $08c2e9dc5cfbd69e$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $2e2cc09c72ffc0aa$export$41fc368e1a942b97 = /*@__PURE__*/ $2e2cc09c72ffc0aa$var$createUnitType("deg");
const $2e2cc09c72ffc0aa$export$626336c2cd4b14de = /*@__PURE__*/ $2e2cc09c72ffc0aa$var$createUnitType("%");
const $2e2cc09c72ffc0aa$export$91c0eda1d06bf008 = /*@__PURE__*/ $2e2cc09c72ffc0aa$var$createUnitType("px");
const $2e2cc09c72ffc0aa$export$f91e8c45a95a32f2 = /*@__PURE__*/ $2e2cc09c72ffc0aa$var$createUnitType("vh");
const $2e2cc09c72ffc0aa$export$aed3d7b7d206c196 = /*@__PURE__*/ $2e2cc09c72ffc0aa$var$createUnitType("vw");
const $2e2cc09c72ffc0aa$export$44e2e1705876d7ed = {
    ...$2e2cc09c72ffc0aa$export$626336c2cd4b14de,
    parse: (v)=>$2e2cc09c72ffc0aa$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$2e2cc09c72ffc0aa$export$626336c2cd4b14de.transform(v * 100)
};


const $dc5c7ac2258c6333$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $dc5c7ac2258c6333$export$8e5250d1aa9bf370 = (v)=>v === (0, $2a216475fc6839a7$export$98e628dec113755e) || v === (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008);
const $dc5c7ac2258c6333$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $dc5c7ac2258c6333$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $dc5c7ac2258c6333$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $dc5c7ac2258c6333$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $dc5c7ac2258c6333$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $dc5c7ac2258c6333$var$nonTranslationalTransformKeys = (0, $ea8236087cf451dc$export$280dc01950909d86).filter((key)=>!$dc5c7ac2258c6333$var$transformKeys.has(key));
function $dc5c7ac2258c6333$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $dc5c7ac2258c6333$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $dc5c7ac2258c6333$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $dc5c7ac2258c6333$var$getTranslateFromMatrix(4, 13),
    y: $dc5c7ac2258c6333$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$dc5c7ac2258c6333$export$781d46a8aa670d52.translateX = $dc5c7ac2258c6333$export$781d46a8aa670d52.x;
$dc5c7ac2258c6333$export$781d46a8aa670d52.translateY = $dc5c7ac2258c6333$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $7da4e5401aa12761$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $5bbd82f4ea4afe8a$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $1c32a536829b8c8a$export$d176691c1998a1f5 = [
    (0, $2a216475fc6839a7$export$98e628dec113755e),
    (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    (0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de),
    (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    (0, $2e2cc09c72ffc0aa$export$aed3d7b7d206c196),
    (0, $2e2cc09c72ffc0aa$export$f91e8c45a95a32f2),
    (0, $5bbd82f4ea4afe8a$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $1c32a536829b8c8a$export$eefdd52e3ccae428 = (v)=>$1c32a536829b8c8a$export$d176691c1998a1f5.find((0, $7da4e5401aa12761$export$6eae4d0a6a7ca7cd)(v));




const $b1026f81549deb9c$var$toResolve = new Set();
let $b1026f81549deb9c$var$isScheduled = false;
let $b1026f81549deb9c$var$anyNeedsMeasurement = false;
function $b1026f81549deb9c$var$measureAllKeyframes() {
    if ($b1026f81549deb9c$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($b1026f81549deb9c$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $dc5c7ac2258c6333$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $b1026f81549deb9c$var$anyNeedsMeasurement = false;
    $b1026f81549deb9c$var$isScheduled = false;
    $b1026f81549deb9c$var$toResolve.forEach((resolver)=>resolver.complete());
    $b1026f81549deb9c$var$toResolve.clear();
}
function $b1026f81549deb9c$var$readAllKeyframes() {
    $b1026f81549deb9c$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $b1026f81549deb9c$var$anyNeedsMeasurement = true;
    });
}
function $b1026f81549deb9c$export$78b96d2a12593b05() {
    $b1026f81549deb9c$var$readAllKeyframes();
    $b1026f81549deb9c$var$measureAllKeyframes();
}
class $b1026f81549deb9c$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $b1026f81549deb9c$var$toResolve.add(this);
            if (!$b1026f81549deb9c$var$isScheduled) {
                $b1026f81549deb9c$var$isScheduled = true;
                (0, $2668c8a722676613$export$2cef06c20297c17d).read($b1026f81549deb9c$var$readAllKeyframes);
                (0, $2668c8a722676613$export$2cef06c20297c17d).resolveKeyframes($b1026f81549deb9c$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $b1026f81549deb9c$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $b1026f81549deb9c$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}







/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $d9f7e69c7de5bbb2$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $08c2e9dc5cfbd69e$export$844ec244b1367d54)(v) && (0, $08c2e9dc5cfbd69e$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $08c2e9dc5cfbd69e$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $d9f7e69c7de5bbb2$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $08c2e9dc5cfbd69e$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $08c2e9dc5cfbd69e$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $72a82e60c8da202c$var$clampRgbUnit = (v)=>(0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(0, 255, v);
const $72a82e60c8da202c$export$7a99c86b5b1f4c9e = {
    ...(0, $2a216475fc6839a7$export$98e628dec113755e),
    transform: (v)=>Math.round($72a82e60c8da202c$var$clampRgbUnit(v))
};
const $72a82e60c8da202c$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $d9f7e69c7de5bbb2$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $d9f7e69c7de5bbb2$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $72a82e60c8da202c$export$7a99c86b5b1f4c9e.transform(red) + ", " + $72a82e60c8da202c$export$7a99c86b5b1f4c9e.transform(green) + ", " + $72a82e60c8da202c$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed)((0, $2a216475fc6839a7$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $d72f3ee0fc88882a$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $d72f3ee0fc88882a$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $d9f7e69c7de5bbb2$export$2c8400d58aca05e)("#"),
    parse: $d72f3ee0fc88882a$var$parseHex,
    transform: (0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).transform
};






const $62184c9fdaf92bae$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $d9f7e69c7de5bbb2$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $d9f7e69c7de5bbb2$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).transform((0, $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).transform((0, $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed)((0, $2a216475fc6839a7$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $7028c17a7a695b13$export$35e9368ef982300f = {
    test: (v)=>(0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).test(v) || (0, $d72f3ee0fc88882a$export$834dfc94dde4b3d8).test(v) || (0, $62184c9fdaf92bae$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).test(v)) return (0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $62184c9fdaf92bae$export$810b04175080204c).test(v)) return (0, $62184c9fdaf92bae$export$810b04175080204c).parse(v);
        else return (0, $d72f3ee0fc88882a$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $08c2e9dc5cfbd69e$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).transform(v) : (0, $62184c9fdaf92bae$export$810b04175080204c).transform(v);
    }
};



function $4c282419bf833d7f$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $08c2e9dc5cfbd69e$export$844ec244b1367d54)(v) && (((_a = v.match((0, $08c2e9dc5cfbd69e$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $08c2e9dc5cfbd69e$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $4c282419bf833d7f$var$NUMBER_TOKEN = "number";
const $4c282419bf833d7f$var$COLOR_TOKEN = "color";
const $4c282419bf833d7f$var$VAR_TOKEN = "var";
const $4c282419bf833d7f$var$VAR_FUNCTION_TOKEN = "var(";
const $4c282419bf833d7f$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $4c282419bf833d7f$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $4c282419bf833d7f$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($4c282419bf833d7f$var$complexRegex, (parsedValue)=>{
        if ((0, $7028c17a7a695b13$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($4c282419bf833d7f$var$COLOR_TOKEN);
            values.push((0, $7028c17a7a695b13$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($4c282419bf833d7f$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($4c282419bf833d7f$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($4c282419bf833d7f$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $4c282419bf833d7f$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($4c282419bf833d7f$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $4c282419bf833d7f$var$parseComplexValue(v) {
    return $4c282419bf833d7f$export$b61fc7c44bf646d5(v).values;
}
function $4c282419bf833d7f$var$createTransformer(source) {
    const { split: split, types: types } = $4c282419bf833d7f$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $4c282419bf833d7f$var$NUMBER_TOKEN) output += (0, $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $4c282419bf833d7f$var$COLOR_TOKEN) output += (0, $7028c17a7a695b13$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $4c282419bf833d7f$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $4c282419bf833d7f$var$getAnimatableNone(v) {
    const parsed = $4c282419bf833d7f$var$parseComplexValue(v);
    const transformer = $4c282419bf833d7f$var$createTransformer(v);
    return transformer(parsed.map($4c282419bf833d7f$var$convertNumbersToZero));
}
const $4c282419bf833d7f$export$83a0e34f1302825b = {
    test: $4c282419bf833d7f$var$test,
    parse: $4c282419bf833d7f$var$parseComplexValue,
    createTransformer: $4c282419bf833d7f$var$createTransformer,
    getAnimatableNone: $4c282419bf833d7f$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $86bc5fae81d2f8f7$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $86bc5fae81d2f8f7$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $08c2e9dc5cfbd69e$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $86bc5fae81d2f8f7$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $86bc5fae81d2f8f7$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $86bc5fae81d2f8f7$export$3dea766d36a8935f = {
    ...(0, $4c282419bf833d7f$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($86bc5fae81d2f8f7$var$functionRegex);
        return functions ? functions.map($86bc5fae81d2f8f7$var$applyDefaultFilter).join(" ") : v;
    }
};







const $89729b3a34a4860f$export$7d260a2a5f8bc19e = {
    ...(0, $2a216475fc6839a7$export$98e628dec113755e),
    transform: Math.round
};


const $0f29681014396523$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderTopWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderRightWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderRadius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    radius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    maxWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    height: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    maxHeight: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    size: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    top: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    right: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    bottom: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    left: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    paddingTop: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    paddingRight: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    paddingBottom: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    paddingLeft: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    margin: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    marginTop: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    marginRight: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    marginBottom: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    marginLeft: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    rotateX: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    rotateY: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    rotateZ: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    scale: $2a216475fc6839a7$export$dcdf75081b88279d,
    scaleX: (0, $2a216475fc6839a7$export$dcdf75081b88279d),
    scaleY: (0, $2a216475fc6839a7$export$dcdf75081b88279d),
    scaleZ: (0, $2a216475fc6839a7$export$dcdf75081b88279d),
    skew: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    skewX: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    skewY: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    distance: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    translateX: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    translateY: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    translateZ: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    x: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    y: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    z: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    perspective: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    transformPerspective: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    opacity: (0, $2a216475fc6839a7$export$58f0f39f63f3cf42),
    originX: (0, $2e2cc09c72ffc0aa$export$44e2e1705876d7ed),
    originY: (0, $2e2cc09c72ffc0aa$export$44e2e1705876d7ed),
    originZ: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $89729b3a34a4860f$export$7d260a2a5f8bc19e),
    backgroundPositionX: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $2a216475fc6839a7$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $2a216475fc6839a7$export$58f0f39f63f3cf42),
    numOctaves: (0, $89729b3a34a4860f$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $a3e8133ab555f880$export$98cd7c72c5a731fb = {
    ...(0, $0f29681014396523$export$eec14432cd1cb67b),
    color: // Color props
    $7028c17a7a695b13$export$35e9368ef982300f,
    backgroundColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    outlineColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    fill: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    stroke: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    borderTopColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    borderRightColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    borderBottomColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    borderLeftColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    filter: $86bc5fae81d2f8f7$export$3dea766d36a8935f,
    WebkitFilter: (0, $86bc5fae81d2f8f7$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $a3e8133ab555f880$export$67d1babe0338d23b = (key)=>$a3e8133ab555f880$export$98cd7c72c5a731fb[key];


function $e50050333fd23e17$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $a3e8133ab555f880$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $86bc5fae81d2f8f7$export$3dea766d36a8935f)) defaultValueType = (0, $4c282419bf833d7f$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $1d575d46915e7d9e$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $1d575d46915e7d9e$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$1d575d46915e7d9e$var$invalidTemplates.has(keyframe) && (0, $4c282419bf833d7f$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $e50050333fd23e17$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $7a5a5700acca8750$export$4983792d11b61017 extends (0, $b1026f81549deb9c$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $7b632f63647c186c$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $a5eac11b2abb9c45$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $dc5c7ac2258c6333$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $1c32a536829b8c8a$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $1c32a536829b8c8a$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $dc5c7ac2258c6333$export$8e5250d1aa9bf370)(originType) && (0, $dc5c7ac2258c6333$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $17feb55ffe87f155$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $1d575d46915e7d9e$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $dc5c7ac2258c6333$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $dc5c7ac2258c6333$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}


function $134d1d2e49b301fc$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}






let $3a6da39b219d0ac7$var$now;
function $3a6da39b219d0ac7$var$clearTime() {
    $3a6da39b219d0ac7$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $3a6da39b219d0ac7$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($3a6da39b219d0ac7$var$now === undefined) $3a6da39b219d0ac7$export$2da9be4cfdb689b1.set((0, $2668c8a722676613$export$fff89137e9e818ce).isProcessing || (0, $d3f03766da854ace$export$dd826089e3c5e502).useManualTiming ? (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp : performance.now());
        return $3a6da39b219d0ac7$var$now;
    },
    set: (newTime)=>{
        $3a6da39b219d0ac7$var$now = newTime;
        queueMicrotask($3a6da39b219d0ac7$var$clearTime);
    }
};






/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $07e3a74163131a68$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $4c282419bf833d7f$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $c4420626c4434de8$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $c4420626c4434de8$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $07e3a74163131a68$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $07e3a74163131a68$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $2b9100c03bd61cb5$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $c4420626c4434de8$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}



/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $e933a795f7f32123$var$MAX_RESOLVE_DELAY = 40;
class $e933a795f7f32123$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $e933a795f7f32123$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $b1026f81549deb9c$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $c4420626c4434de8$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $4f333d9188f46157$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $3ca01ac9e8cf1f66$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}




/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $01416ecd35dd4fe1$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $21bb4a1bea7afdc8$var$velocitySampleDuration = 5; // ms
function $21bb4a1bea7afdc8$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $21bb4a1bea7afdc8$var$velocitySampleDuration, 0);
    return (0, $01416ecd35dd4fe1$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $b7737875d953277f$var$safeMin = 0.001;
const $b7737875d953277f$export$a3cdb76e84ee608e = 0.01;
const $b7737875d953277f$export$1824b851fad8862b = 10.0;
const $b7737875d953277f$export$ff08f2d53484465 = 0.05;
const $b7737875d953277f$export$201ca48e54038115 = 1;
function $b7737875d953277f$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $2b9100c03bd61cb5$export$491112666e282270)(duration <= (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)($b7737875d953277f$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)($b7737875d953277f$export$ff08f2d53484465, $b7737875d953277f$export$201ca48e54038115, dampingRatio);
    duration = (0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)($b7737875d953277f$export$a3cdb76e84ee608e, $b7737875d953277f$export$1824b851fad8862b, (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $b7737875d953277f$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $b7737875d953277f$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $b7737875d953277f$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $b7737875d953277f$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$b7737875d953277f$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $b7737875d953277f$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $b7737875d953277f$var$rootIterations = 12;
function $b7737875d953277f$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $b7737875d953277f$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $b7737875d953277f$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $f2ee4de28e47ead0$var$durationKeys = [
    "duration",
    "bounce"
];
const $f2ee4de28e47ead0$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $f2ee4de28e47ead0$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $f2ee4de28e47ead0$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$f2ee4de28e47ead0$var$isSpringType(options, $f2ee4de28e47ead0$var$physicsKeys) && $f2ee4de28e47ead0$var$isSpringType(options, $f2ee4de28e47ead0$var$durationKeys)) {
        const derived = (0, $b7737875d953277f$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $f2ee4de28e47ead0$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $f2ee4de28e47ead0$var$getSpringOptions({
        ...options,
        velocity: -(0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $b7737875d953277f$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $21bb4a1bea7afdc8$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $d3675ca8f6e28248$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $f2ee4de28e47ead0$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $21bb4a1bea7afdc8$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $a263c687dd63c6c5$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $a263c687dd63c6c5$var$subdivisionPrecision = 0.0000001;
const $a263c687dd63c6c5$var$subdivisionMaxIterations = 12;
function $a263c687dd63c6c5$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $a263c687dd63c6c5$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $a263c687dd63c6c5$var$subdivisionPrecision && ++i < $a263c687dd63c6c5$var$subdivisionMaxIterations);
    return currentT;
}
function $a263c687dd63c6c5$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $c90734627ed96e3f$export$8793edee2d425525;
    const getTForX = (aX)=>$a263c687dd63c6c5$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $a263c687dd63c6c5$var$calcBezier(getTForX(t), mY1, mY2);
}


const $a3d2a640a7819290$export$929e5a82286172a6 = /*@__PURE__*/ (0, $a263c687dd63c6c5$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $a3d2a640a7819290$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $a263c687dd63c6c5$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $a3d2a640a7819290$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $a263c687dd63c6c5$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $cdb960b4abd00d82$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $7570a191f3c94b31$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $00e1a8b2dd3e9bbc$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $fefb9f2108604c18$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $fefb9f2108604c18$export$c8d67a19199d1a50 = (0, $00e1a8b2dd3e9bbc$export$2c07eeff45156d4d)($fefb9f2108604c18$export$e444123e42d03385);
const $fefb9f2108604c18$export$30d3455eee55bed5 = (0, $7570a191f3c94b31$export$f946554fb8aeaf0d)($fefb9f2108604c18$export$e444123e42d03385);





const $1842475697f9ee9b$export$77edfce482316a60 = /*@__PURE__*/ (0, $a263c687dd63c6c5$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $1842475697f9ee9b$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $00e1a8b2dd3e9bbc$export$2c07eeff45156d4d)($1842475697f9ee9b$export$77edfce482316a60);
const $1842475697f9ee9b$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $7570a191f3c94b31$export$f946554fb8aeaf0d)($1842475697f9ee9b$export$b01116c84cdfe1a2);



const $49ff884946fb36c8$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $1842475697f9ee9b$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $6fcfc72f21f48ad3$var$easingLookup = {
    linear: (0, $c90734627ed96e3f$export$8793edee2d425525),
    easeIn: $a3d2a640a7819290$export$929e5a82286172a6,
    easeInOut: $a3d2a640a7819290$export$c07234257a03d5e9,
    easeOut: $a3d2a640a7819290$export$57636bb43b1ccbb0,
    circIn: $fefb9f2108604c18$export$e444123e42d03385,
    circInOut: $fefb9f2108604c18$export$30d3455eee55bed5,
    circOut: $fefb9f2108604c18$export$c8d67a19199d1a50,
    backIn: $1842475697f9ee9b$export$b01116c84cdfe1a2,
    backInOut: $1842475697f9ee9b$export$ddc5fd596f6c71b2,
    backOut: $1842475697f9ee9b$export$77edfce482316a60,
    anticipate: $49ff884946fb36c8$export$6b0af63b873d419e
};
const $6fcfc72f21f48ad3$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $a263c687dd63c6c5$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $2b9100c03bd61cb5$export$f5708dca728d7177)($6fcfc72f21f48ad3$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $6fcfc72f21f48ad3$var$easingLookup[definition];
    }
    return definition;
};




/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $a510fe5631c50899$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $a510fe5631c50899$export$a4627e546088548d = (...transformers)=>transformers.reduce($a510fe5631c50899$var$combineFunctions);


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $482d3e1965098f2a$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $4defff8a09cc16c4$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $eab0eb3f5b7dcae9$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $eab0eb3f5b7dcae9$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $eab0eb3f5b7dcae9$var$hueToRgb(p, q, hue + 1 / 3);
        green = $eab0eb3f5b7dcae9$var$hueToRgb(p, q, hue);
        blue = $eab0eb3f5b7dcae9$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $f209ea4761c1391b$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $386cd07540afa3bb$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $386cd07540afa3bb$var$colorTypes = [
    (0, $d72f3ee0fc88882a$export$834dfc94dde4b3d8),
    (0, $72a82e60c8da202c$export$4e46ac54fc82cf3b),
    (0, $62184c9fdaf92bae$export$810b04175080204c)
];
const $386cd07540afa3bb$var$getColorType = (v)=>$386cd07540afa3bb$var$colorTypes.find((type)=>type.test(v));
function $386cd07540afa3bb$var$asRGBA(color) {
    const type = $386cd07540afa3bb$var$getColorType(color);
    (0, $2b9100c03bd61cb5$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $62184c9fdaf92bae$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $eab0eb3f5b7dcae9$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $386cd07540afa3bb$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $386cd07540afa3bb$var$asRGBA(from);
    const toRGBA = $386cd07540afa3bb$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $f209ea4761c1391b$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $386cd07540afa3bb$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $386cd07540afa3bb$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $386cd07540afa3bb$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $f0008624fb6aaa61$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $f0008624fb6aaa61$export$fed62ccc3fb1a568(origin, target) {
    if ($f0008624fb6aaa61$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $27c586932f07923b$var$mixNumber(a, b) {
    return (p)=>(0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $27c586932f07923b$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $27c586932f07923b$var$mixNumber;
    else if (typeof a === "string") return (0, $7b632f63647c186c$export$31f9caa2600b5723)(a) ? (0, $f209ea4761c1391b$export$a6f92d4bae65c0f1) : (0, $7028c17a7a695b13$export$35e9368ef982300f).test(a) ? (0, $386cd07540afa3bb$export$51e568cf5c039bac) : $27c586932f07923b$export$65516310a87d8205;
    else if (Array.isArray(a)) return $27c586932f07923b$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $7028c17a7a695b13$export$35e9368ef982300f).test(a) ? (0, $386cd07540afa3bb$export$51e568cf5c039bac) : $27c586932f07923b$export$ebc23b6840c51ba1;
    return 0, $f209ea4761c1391b$export$a6f92d4bae65c0f1;
}
function $27c586932f07923b$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$27c586932f07923b$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $27c586932f07923b$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $27c586932f07923b$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $27c586932f07923b$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $27c586932f07923b$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $4c282419bf833d7f$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $4c282419bf833d7f$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $4c282419bf833d7f$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $f0008624fb6aaa61$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $f0008624fb6aaa61$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $f0008624fb6aaa61$export$fed62ccc3fb1a568)(origin, target);
        return (0, $a510fe5631c50899$export$a4627e546088548d)($27c586932f07923b$export$3bbefa2f402845c4($27c586932f07923b$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $2b9100c03bd61cb5$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $f209ea4761c1391b$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $272f05917dcf54fe$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $27c586932f07923b$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $5afc3475e21af585$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $272f05917dcf54fe$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $c90734627ed96e3f$export$8793edee2d425525) : ease;
            mixer = (0, $a510fe5631c50899$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $5afc3475e21af585$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $5afc3475e21af585$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $482d3e1965098f2a$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $90bfe69fb9e7beb2$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $482d3e1965098f2a$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $8866a142868d9f49$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $90bfe69fb9e7beb2$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $a5ba9f2c64b839e4$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $d4f03167cf0fe9a0$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $a3d2a640a7819290$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $d4f03167cf0fe9a0$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $cdb960b4abd00d82$export$216948827bbdc797)(ease) ? ease.map((0, $6fcfc72f21f48ad3$export$ef97fe084f156ca4)) : (0, $6fcfc72f21f48ad3$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $a5ba9f2c64b839e4$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $8866a142868d9f49$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $5afc3475e21af585$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $d4f03167cf0fe9a0$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $63989eadef3836dd$export$f4ff70a5b4808fd8 = 20000;
function $63989eadef3836dd$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $63989eadef3836dd$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $63989eadef3836dd$export$f4ff70a5b4808fd8 ? Infinity : duration;
}







const $305de1905df24e19$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $2668c8a722676613$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $2668c8a722676613$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $2668c8a722676613$export$fff89137e9e818ce).isProcessing ? (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp : (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now()
    };
};



const $6a91611bc4894f12$var$generators = {
    decay: (0, $d3675ca8f6e28248$export$ee3ff3a17106998),
    inertia: $d3675ca8f6e28248$export$ee3ff3a17106998,
    tween: (0, $d4f03167cf0fe9a0$export$d25ddfdf17c3ad3e),
    keyframes: (0, $d4f03167cf0fe9a0$export$d25ddfdf17c3ad3e),
    spring: $f2ee4de28e47ead0$export$b36281d89752ae66
};
const $6a91611bc4894f12$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $6a91611bc4894f12$export$fd98d9cca67a58bc extends (0, $e933a795f7f32123$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $b1026f81549deb9c$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = $6a91611bc4894f12$var$generators[type] || (0, $d4f03167cf0fe9a0$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $d4f03167cf0fe9a0$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $a510fe5631c50899$export$a4627e546088548d)($6a91611bc4894f12$var$percentToProgress, (0, $272f05917dcf54fe$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $63989eadef3836dd$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $3ca01ac9e8cf1f66$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $305de1905df24e19$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $6a91611bc4894f12$export$ee9b76de7353d815(options) {
    return new $6a91611bc4894f12$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $172b3a0adea9e962$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);


const $3fcf0b2fb191c4b5$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $0e0db63839e02520$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $0e0db63839e02520$export$2cf569f5e2221176 || (0, $3fcf0b2fb191c4b5$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($0e0db63839e02520$export$fcdd8f3f2160beda));
}
const $0e0db63839e02520$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $0e0db63839e02520$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $0e0db63839e02520$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $0e0db63839e02520$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $0e0db63839e02520$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $0e0db63839e02520$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $0e0db63839e02520$var$mapEasingToNativeEasingWithDefault(easing) {
    return $0e0db63839e02520$export$916ea73bcd3a6030(easing) || $0e0db63839e02520$export$2cf569f5e2221176.easeOut;
}
function $0e0db63839e02520$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $3fcf0b2fb191c4b5$export$ff43f99925d7366b)(easing)) return $0e0db63839e02520$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($0e0db63839e02520$var$mapEasingToNativeEasingWithDefault);
    else return $0e0db63839e02520$export$2cf569f5e2221176[easing];
}


function $804e3d24c23afefa$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $0e0db63839e02520$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}




const $7f14ff9d0367db28$var$supportsWaapi = /*@__PURE__*/ (0, $134d1d2e49b301fc$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $7f14ff9d0367db28$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $7f14ff9d0367db28$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $7f14ff9d0367db28$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || !(0, $0e0db63839e02520$export$fcdd8f3f2160beda)(options.ease);
}
function $7f14ff9d0367db28$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $6a91611bc4894f12$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $7f14ff9d0367db28$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $7f14ff9d0367db28$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $7f14ff9d0367db28$var$sampleDelta,
        ease: "linear"
    };
}
class $7f14ff9d0367db28$export$2a45abb4e6513325 extends (0, $e933a795f7f32123$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $7a5a5700acca8750$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($7f14ff9d0367db28$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $7f14ff9d0367db28$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $804e3d24c23afefa$export$c76cd972d26986f9)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $3ca01ac9e8cf1f66$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $c90734627ed96e3f$export$8793edee2d425525;
            const { animation: animation } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $c90734627ed96e3f$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $6a91611bc4894f12$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $7f14ff9d0367db28$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $7f14ff9d0367db28$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return $7f14ff9d0367db28$var$supportsWaapi() && name && (0, $172b3a0adea9e962$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}




function $7879bdc6f40836e5$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $2668c8a722676613$export$2cef06c20297c17d).update(onFrame, true);
    return ()=>(0, $2668c8a722676613$export$ec99c0ef4978dccb)(onFrame);
}



const $b2ad65e0ee9722e6$export$20d68f04f30763a5 = (0, $134d1d2e49b301fc$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $ea560ce4dcc095f2$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $b2ad65e0ee9722e6$export$20d68f04f30763a5)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $7879bdc6f40836e5$export$b4f1bbab0c442a76)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


const $30c44ca59ad5e77f$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff, /**
 * Currently used to remove values from will-change when an animation ends.
 * Preferably this would be handled by event listeners on the MotionValue
 * but these aren't consistent enough yet when considering the different ways
 * an animation can be cancelled.
 */ onEnd)=>(onComplete)=>{
        const valueTransition = (0, $453e5e72c39cf7c2$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
                onEnd && onEnd();
            },
            onStop: onEnd,
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $453e5e72c39cf7c2$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $a714041f9b68b288$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $4f333d9188f46157$export$888a3d84909f9e3d).current || (0, $d3f03766da854ace$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $3ca01ac9e8cf1f66$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $2668c8a722676613$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $ea560ce4dcc095f2$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $7f14ff9d0367db28$export$2a45abb4e6513325).supports(options)) return new (0, $7f14ff9d0367db28$export$2a45abb4e6513325)(options);
        else return new (0, $6a91611bc4894f12$export$fd98d9cca67a58bc)(options);
    };



const $5886206991be4714$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $5886206991be4714$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $854bd2f427254747$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};


function $51a4ba498ba1dae1$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $51a4ba498ba1dae1$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $51a4ba498ba1dae1$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $f9d7e2b4cbfd436c$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $51a4ba498ba1dae1$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $51a4ba498ba1dae1$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $ebb6b8b1a738bf1d$var$MAX_VELOCITY_DELTA = 30;
const $ebb6b8b1a738bf1d$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $ebb6b8b1a738bf1d$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $ebb6b8b1a738bf1d$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.5.4";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $ebb6b8b1a738bf1d$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $f9d7e2b4cbfd436c$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $2668c8a722676613$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($ebb6b8b1a738bf1d$export$67fcd818a264039d.current) $ebb6b8b1a738bf1d$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $ebb6b8b1a738bf1d$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $ebb6b8b1a738bf1d$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $01416ecd35dd4fe1$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $ebb6b8b1a738bf1d$export$ce8bdc721e76545f(init, options) {
    return new $ebb6b8b1a738bf1d$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $c0d70cfd424dc995$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(value));
}
function $c0d70cfd424dc995$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $e92cd1cec7066d98$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $5886206991be4714$export$5485128c47bd48bb)(target[key]);
        $c0d70cfd424dc995$var$setMotionValue(visualElement, key, value);
    }
}



/**
 * Convert camelCase to dash-case properties.
 */ const $76d837a31980cd1f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $bd1f6e057be11122$export$ed7b8fa9dbf0105d = "framerAppearId";
const $bd1f6e057be11122$export$8592e1c077c890a6 = "data-" + (0, $76d837a31980cd1f$export$9fd24a634729c672)($bd1f6e057be11122$export$ed7b8fa9dbf0105d);


function $355e745a41ba8ef0$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $bd1f6e057be11122$export$8592e1c077c890a6];
}






function $747b8e31f6efe634$export$b3f9dd865b560c6(name) {
    if ((0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(name)) return "transform";
    else if ((0, $172b3a0adea9e962$export$a27eefbd8fb5e404).has(name)) return (0, $76d837a31980cd1f$export$9fd24a634729c672)(name);
}



class $c247f1eb6e965883$export$3fe5fa490af65f85 extends (0, $ebb6b8b1a738bf1d$export$8cea36d14ee64562) {
    constructor(){
        super(...arguments);
        this.output = [];
        this.counts = new Map();
    }
    add(name) {
        const styleName = (0, $747b8e31f6efe634$export$b3f9dd865b560c6)(name);
        if (!styleName) return;
        /**
         * Update counter. Each value has an indepdent counter
         * as multiple sources could be requesting the same value
         * gets added to will-change.
         */ const prevCount = this.counts.get(styleName) || 0;
        this.counts.set(styleName, prevCount + 1);
        if (prevCount === 0) {
            this.output.push(styleName);
            this.update();
        }
        /**
         * Prevents the remove function from being called multiple times.
         */ let hasRemoved = false;
        return ()=>{
            if (hasRemoved) return;
            hasRemoved = true;
            const newCount = this.counts.get(styleName) - 1;
            this.counts.set(styleName, newCount);
            if (newCount === 0) {
                (0, $51a4ba498ba1dae1$export$fe2d9b4e03920b4c)(this.output, styleName);
                this.update();
            }
        };
    }
    update() {
        this.set(this.output.length ? this.output.join(", ") : "auto");
    }
}


const $97dfd46cf2e43daf$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $bd1b34552c3879fa$export$98397f3adbf6259f(value) {
    return Boolean((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value) && value.add);
}


function $b79c001af895beaa$export$3ac5aed310be0bee(visualElement, key) {
    var _a;
    if (!visualElement.applyWillChange) return;
    let willChange = visualElement.getValue("willChange");
    /**
     * If we haven't created a willChange MotionValue, and the we haven't been
     * manually provided one, create one.
     */ if (!willChange && !((_a = visualElement.props.style) === null || _a === void 0 ? void 0 : _a.willChange)) {
        willChange = new (0, $c247f1eb6e965883$export$3fe5fa490af65f85)("auto");
        visualElement.addValue("willChange", willChange);
    }
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $bd1b34552c3879fa$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $71617090e716925b$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $71617090e716925b$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $71617090e716925b$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $453e5e72c39cf7c2$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $355e745a41ba8ef0$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $2668c8a722676613$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $30c44ca59ad5e77f$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff, (0, $b79c001af895beaa$export$3ac5aed310be0bee)(visualElement, key)));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $2668c8a722676613$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $c0d70cfd424dc995$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $54ae2260007dcfeb$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $e92cd1cec7066d98$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $71617090e716925b$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $54ae2260007dcfeb$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $54ae2260007dcfeb$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($54ae2260007dcfeb$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($54ae2260007dcfeb$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $54ae2260007dcfeb$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $b926866dbb79ab9d$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $54ae2260007dcfeb$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $54ae2260007dcfeb$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $e92cd1cec7066d98$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $71617090e716925b$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}


const $c110d9d5c06f1d5f$var$reversePriorityOrder = [
    ...(0, $7526b0a811789693$export$16e45afcc206d3a8)
].reverse();
const $c110d9d5c06f1d5f$var$numAnimationTypes = (0, $7526b0a811789693$export$16e45afcc206d3a8).length;
function $c110d9d5c06f1d5f$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $b926866dbb79ab9d$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $c110d9d5c06f1d5f$export$bb53502b7a672aa8(visualElement) {
    let animate = $c110d9d5c06f1d5f$var$animateList(visualElement);
    let state = $c110d9d5c06f1d5f$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $e92cd1cec7066d98$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $c110d9d5c06f1d5f$var$numAnimationTypes; i++){
            const type = $c110d9d5c06f1d5f$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $bfdcb20e850e14f7$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $f29cdb74f4d8f17d$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $c110d9d5c06f1d5f$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $854bd2f427254747$export$9153ad4c4999f4a0)(next) && (0, $854bd2f427254747$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $618fd2d39a7e62c4$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $c110d9d5c06f1d5f$var$createState();
            isInitialRender = true;
        }
    };
}
function $c110d9d5c06f1d5f$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $618fd2d39a7e62c4$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $c110d9d5c06f1d5f$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $c110d9d5c06f1d5f$var$createState() {
    return {
        animate: $c110d9d5c06f1d5f$var$createTypeState(true),
        whileInView: $c110d9d5c06f1d5f$var$createTypeState(),
        whileHover: $c110d9d5c06f1d5f$var$createTypeState(),
        whileTap: $c110d9d5c06f1d5f$var$createTypeState(),
        whileDrag: $c110d9d5c06f1d5f$var$createTypeState(),
        whileFocus: $c110d9d5c06f1d5f$var$createTypeState(),
        exit: $c110d9d5c06f1d5f$var$createTypeState()
    };
}


class $0e2551b19b8df95b$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $e2f22a6aa88b0350$export$b45b3fe5caabdca extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $c110d9d5c06f1d5f$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $f29cdb74f4d8f17d$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $5bf10a71bd460830$var$id = 0;
class $5bf10a71bd460830$export$4989d1eb6104cc6c extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $5bf10a71bd460830$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $2d0cdac558a97e2e$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $e2f22a6aa88b0350$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $5bf10a71bd460830$export$4989d1eb6104cc6c)
    }
};





const $d6ded8eb30673083$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $bb2968ceabdf7aba$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $bb2968ceabdf7aba$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $d6ded8eb30673083$export$a4cf9c8a4b063a6e)(event) && handler(event, $bb2968ceabdf7aba$export$12f84bb882d06e1a(event));
};



function $52bbcc091bf26590$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



function $a2f9971c4d7d6c59$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(target, eventName, (0, $bb2968ceabdf7aba$export$c404e80f92c98d29)(handler), options);
}



const $25738ceb266d6fb4$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $25738ceb266d6fb4$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $25738ceb266d6fb4$export$9f17032d917177de(a.x, b.x);
    const yDelta = $25738ceb266d6fb4$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $4f540b18fadbcd47$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $4f540b18fadbcd47$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $25738ceb266d6fb4$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $2668c8a722676613$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $4f540b18fadbcd47$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $2668c8a722676613$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $4f540b18fadbcd47$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $4f540b18fadbcd47$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $d6ded8eb30673083$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $bb2968ceabdf7aba$export$12f84bb882d06e1a)(event);
        const initialInfo = $4f540b18fadbcd47$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $2668c8a722676613$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $4f540b18fadbcd47$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $a510fe5631c50899$export$a4627e546088548d)((0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $2668c8a722676613$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $4f540b18fadbcd47$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $4f540b18fadbcd47$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $4f540b18fadbcd47$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $4f540b18fadbcd47$var$subtractPoint(point, $4f540b18fadbcd47$var$lastDevicePoint(history)),
        offset: $4f540b18fadbcd47$var$subtractPoint(point, $4f540b18fadbcd47$var$startDevicePoint(history)),
        velocity: $4f540b18fadbcd47$var$getVelocity(history, 0.1)
    };
}
function $4f540b18fadbcd47$var$startDevicePoint(history) {
    return history[0];
}
function $4f540b18fadbcd47$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $4f540b18fadbcd47$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $4f540b18fadbcd47$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}


function $b620b19e58064217$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $b620b19e58064217$var$globalHorizontalLock = $b620b19e58064217$export$518c5fc2dcb7974b("dragHorizontal");
const $b620b19e58064217$var$globalVerticalLock = $b620b19e58064217$export$518c5fc2dcb7974b("dragVertical");
function $b620b19e58064217$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $b620b19e58064217$var$globalVerticalLock();
    else if (drag === "x") lock = $b620b19e58064217$var$globalHorizontalLock();
    else {
        const openHorizontal = $b620b19e58064217$var$globalHorizontalLock();
        const openVertical = $b620b19e58064217$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $b620b19e58064217$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $b620b19e58064217$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


function $ed6b374e0bfa2f8b$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}





const $85a652ec5cd36319$var$SCALE_PRECISION = 0.0001;
const $85a652ec5cd36319$var$SCALE_MIN = 1 - $85a652ec5cd36319$var$SCALE_PRECISION;
const $85a652ec5cd36319$var$SCALE_MAX = 1 + $85a652ec5cd36319$var$SCALE_PRECISION;
const $85a652ec5cd36319$var$TRANSLATE_PRECISION = 0.01;
const $85a652ec5cd36319$var$TRANSLATE_MIN = 0 - $85a652ec5cd36319$var$TRANSLATE_PRECISION;
const $85a652ec5cd36319$var$TRANSLATE_MAX = 0 + $85a652ec5cd36319$var$TRANSLATE_PRECISION;
function $85a652ec5cd36319$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $85a652ec5cd36319$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $85a652ec5cd36319$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $85a652ec5cd36319$export$c1c127004b72a37(target) / $85a652ec5cd36319$export$c1c127004b72a37(source);
    delta.translate = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $85a652ec5cd36319$var$SCALE_MIN && delta.scale <= $85a652ec5cd36319$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $85a652ec5cd36319$var$TRANSLATE_MIN && delta.translate <= $85a652ec5cd36319$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $85a652ec5cd36319$export$c0d25e96fc67d310(delta, source, target, origin) {
    $85a652ec5cd36319$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $85a652ec5cd36319$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $85a652ec5cd36319$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $85a652ec5cd36319$export$c1c127004b72a37(relative);
}
function $85a652ec5cd36319$export$426154f9d100f99(target, relative, parent) {
    $85a652ec5cd36319$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $85a652ec5cd36319$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $85a652ec5cd36319$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $85a652ec5cd36319$export$c1c127004b72a37(layout);
}
function $85a652ec5cd36319$export$2785bfcc929c5650(target, layout, parent) {
    $85a652ec5cd36319$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $85a652ec5cd36319$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $bd193a823137bfc4$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $bd193a823137bfc4$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $bd193a823137bfc4$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $bd193a823137bfc4$export$690c180aa5775042(layoutBox.x, left, right),
        y: $bd193a823137bfc4$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $bd193a823137bfc4$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $bd193a823137bfc4$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $bd193a823137bfc4$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $bd193a823137bfc4$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $bd193a823137bfc4$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $85a652ec5cd36319$export$c1c127004b72a37)(source);
    const targetLength = (0, $85a652ec5cd36319$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $482d3e1965098f2a$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $482d3e1965098f2a$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $bd193a823137bfc4$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $bd193a823137bfc4$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $bd193a823137bfc4$export$7c5eaef8f4723d22(dragElastic = $bd193a823137bfc4$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $bd193a823137bfc4$export$a3366d3bac43a742;
    return {
        x: $bd193a823137bfc4$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $bd193a823137bfc4$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $bd193a823137bfc4$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $bd193a823137bfc4$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $bd193a823137bfc4$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $bd193a823137bfc4$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $a33f96272a0f3ced$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a33f96272a0f3ced$export$3d227df54007d73a = ()=>({
        x: $a33f96272a0f3ced$export$ff25708b37f72782(),
        y: $a33f96272a0f3ced$export$ff25708b37f72782()
    });
const $a33f96272a0f3ced$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a33f96272a0f3ced$export$6459fc9e86be362e = ()=>({
        x: $a33f96272a0f3ced$export$6db76765312617ac(),
        y: $a33f96272a0f3ced$export$6db76765312617ac()
    });


function $80571038c05c2614$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $853b10d6dae64020$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $853b10d6dae64020$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $853b10d6dae64020$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $d3d101fc7fd68aaf$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $d3d101fc7fd68aaf$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$d3d101fc7fd68aaf$var$isIdentityScale(scale) || !$d3d101fc7fd68aaf$var$isIdentityScale(scaleX) || !$d3d101fc7fd68aaf$var$isIdentityScale(scaleY);
}
function $d3d101fc7fd68aaf$export$a545127cf1fbb600(values) {
    return $d3d101fc7fd68aaf$export$bdf30dca883ea463(values) || $d3d101fc7fd68aaf$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $d3d101fc7fd68aaf$export$bf80f5f8f4dc327f(values) {
    return $d3d101fc7fd68aaf$var$is2DTranslate(values.x) || $d3d101fc7fd68aaf$var$is2DTranslate(values.y);
}
function $d3d101fc7fd68aaf$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d81381f648f60915$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d81381f648f60915$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d81381f648f60915$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d81381f648f60915$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d81381f648f60915$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d81381f648f60915$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d81381f648f60915$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d81381f648f60915$export$d80074982803af5c(box, { x: x, y: y }) {
    $d81381f648f60915$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d81381f648f60915$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $d81381f648f60915$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $d81381f648f60915$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d81381f648f60915$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d81381f648f60915$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d81381f648f60915$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(node.latestValues)) $d81381f648f60915$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $d81381f648f60915$var$TREE_SCALE_SNAP_MAX && treeScale.x > $d81381f648f60915$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $d81381f648f60915$var$TREE_SCALE_SNAP_MAX && treeScale.y > $d81381f648f60915$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $d81381f648f60915$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d81381f648f60915$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d81381f648f60915$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d81381f648f60915$export$58b16271041fbfb(box, transform) {
    $d81381f648f60915$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $d81381f648f60915$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $d134b85ec35c9730$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $853b10d6dae64020$export$d3955c6a8f65a36b)((0, $853b10d6dae64020$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $d134b85ec35c9730$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $d134b85ec35c9730$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d81381f648f60915$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d81381f648f60915$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $10bda2e49bcd94d9$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $d1b0e1e998c2fee3$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $d1b0e1e998c2fee3$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $bb2968ceabdf7aba$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $b620b19e58064217$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $85a652ec5cd36319$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
            this.removeWillChange = (0, $b79c001af895beaa$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $d1b0e1e998c2fee3$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $4f540b18fadbcd47$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $10bda2e49bcd94d9$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        var _a;
        (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$d1b0e1e998c2fee3$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $bd193a823137bfc4$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $bd193a823137bfc4$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $bd193a823137bfc4$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $bd193a823137bfc4$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $d134b85ec35c9730$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $bd193a823137bfc4$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $853b10d6dae64020$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $853b10d6dae64020$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            if (!$d1b0e1e998c2fee3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $30c44ca59ad5e77f$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false, (0, $b79c001af895beaa$export$3ac5aed310be0bee)(this.visualElement, axis)));
    }
    stopAnimation() {
        (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$d1b0e1e998c2fee3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $bd193a823137bfc4$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            if (!$d1b0e1e998c2fee3$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $d1b0e1e998c2fee3$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $2668c8a722676613$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $bd193a823137bfc4$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $d1b0e1e998c2fee3$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $d1b0e1e998c2fee3$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $775cbfbec7f3e7b1$export$5d97dc2872682820 extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $c90734627ed96e3f$export$8793edee2d425525);
        this.removeListeners = (0, $c90734627ed96e3f$export$8793edee2d425525);
        this.controls = new (0, $d1b0e1e998c2fee3$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $c90734627ed96e3f$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $eb5b67e8076eeec3$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $eb5b67e8076eeec3$export$b4f8f1ee75ce5859 extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $c90734627ed96e3f$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $4f540b18fadbcd47$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $10bda2e49bcd94d9$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $eb5b67e8076eeec3$var$asyncHandler(onPanSessionStart),
            onStart: $eb5b67e8076eeec3$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
"use client";
/**
 * @public
 */ const $2026c3a36ffa4174$export$f224e4635b6f8ce2 = (0, $eeH7J.createContext)(null);


/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $d9315986bafdadde$export$2a8c16d82a0a0e26() {
    const context = (0, $eeH7J.useContext)((0, $2026c3a36ffa4174$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $eeH7J.useId)();
    (0, $eeH7J.useEffect)(()=>register(id), []);
    const safeToRemove = (0, $eeH7J.useCallback)(()=>onExitComplete && onExitComplete(id), [
        id,
        onExitComplete
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $d9315986bafdadde$export$8249053f690ea39a() {
    return $d9315986bafdadde$export$ee27c052bca048fb((0, $eeH7J.useContext)((0, $2026c3a36ffa4174$export$f224e4635b6f8ce2)));
}
function $d9315986bafdadde$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




var $eeH7J = parcelRequire("eeH7J");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $d06770095535cbfe$export$da5f7b802957459a = (0, $eeH7J.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $dd7235250d7597e1$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $888b4d29b2b48cec$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $888b4d29b2b48cec$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $888b4d29b2b48cec$export$fafff692be55225d(latest, node.target.x);
        const y = $888b4d29b2b48cec$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $df3eae19b27a85ae$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $4c282419bf833d7f$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $4c282419bf833d7f$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $5a27ca56288b5194$export$91ddd985b97788d1 = {};
function $5a27ca56288b5194$export$de9e7791c71225fd(correctors) {
    Object.assign($5a27ca56288b5194$export$91ddd985b97788d1, correctors);
}



const { schedule: $56c6f990d38070fe$export$bb76eed83315504c, cancel: $56c6f990d38070fe$export$3252729004b8456e } = (0, $3e80ba1fbbf06577$export$510b0596a933801a)(queueMicrotask, false);



"use client";
class $6d3ffb27b820752c$var$MeasureLayoutWithContext extends (0, $eeH7J.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $5a27ca56288b5194$export$de9e7791c71225fd)($6d3ffb27b820752c$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $dd7235250d7597e1$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $56c6f990d38070fe$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $6d3ffb27b820752c$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $d9315986bafdadde$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $eeH7J.useContext)((0, $7e832de67499b416$export$a3579ca508007a95));
    return (0, $dRzna.jsx)($6d3ffb27b820752c$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $eeH7J.useContext)((0, $d06770095535cbfe$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $6d3ffb27b820752c$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $888b4d29b2b48cec$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $888b4d29b2b48cec$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $888b4d29b2b48cec$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $888b4d29b2b48cec$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $888b4d29b2b48cec$export$5eafb6257a5844c),
    boxShadow: (0, $df3eae19b27a85ae$export$eb0bc629e74dcf8)
};








const $21f9a46747b133ed$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $21f9a46747b133ed$var$numBorders = $21f9a46747b133ed$var$borders.length;
const $21f9a46747b133ed$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $21f9a46747b133ed$var$isPx = (value)=>typeof value === "number" || (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).test(value);
function $21f9a46747b133ed$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $21f9a46747b133ed$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $21f9a46747b133ed$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $21f9a46747b133ed$var$numBorders; i++){
        const borderLabel = `border${$21f9a46747b133ed$var$borders[i]}Radius`;
        let followRadius = $21f9a46747b133ed$var$getRadius(follow, borderLabel);
        let leadRadius = $21f9a46747b133ed$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $21f9a46747b133ed$var$isPx(followRadius) === $21f9a46747b133ed$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)($21f9a46747b133ed$var$asNumber(followRadius), $21f9a46747b133ed$var$asNumber(leadRadius), progress), 0);
            if ((0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).test(leadRadius) || (0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $21f9a46747b133ed$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $21f9a46747b133ed$var$easeCrossfadeIn = /*@__PURE__*/ $21f9a46747b133ed$var$compress(0, 0.5, (0, $fefb9f2108604c18$export$c8d67a19199d1a50));
const $21f9a46747b133ed$var$easeCrossfadeOut = /*@__PURE__*/ $21f9a46747b133ed$var$compress(0.5, 0.95, (0, $c90734627ed96e3f$export$8793edee2d425525));
function $21f9a46747b133ed$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $482d3e1965098f2a$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $eb323b55846adefd$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $eb323b55846adefd$export$c53fd88f45d77e4b(box, originBox) {
    $eb323b55846adefd$export$a0230ae482601ae8(box.x, originBox.x);
    $eb323b55846adefd$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $eb323b55846adefd$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $3cca3361c07be144$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d81381f648f60915$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d81381f648f60915$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $3cca3361c07be144$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $3cca3361c07be144$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $3cca3361c07be144$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $3cca3361c07be144$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $3cca3361c07be144$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $3cca3361c07be144$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $3cca3361c07be144$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $3cca3361c07be144$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $3cca3361c07be144$export$42b76f1d0d16d5b(box.x, transforms, $3cca3361c07be144$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $3cca3361c07be144$export$42b76f1d0d16d5b(box.y, transforms, $3cca3361c07be144$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $6ce12b205c4c79ac$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $6ce12b205c4c79ac$export$a7ec7642fe550fb6(delta) {
    return $6ce12b205c4c79ac$var$isAxisDeltaZero(delta.x) && $6ce12b205c4c79ac$var$isAxisDeltaZero(delta.y);
}
function $6ce12b205c4c79ac$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $6ce12b205c4c79ac$export$8d5cf76bb7daff09(a, b) {
    return $6ce12b205c4c79ac$export$7a9a6f114ddd0fdb(a.x, b.x) && $6ce12b205c4c79ac$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $6ce12b205c4c79ac$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $6ce12b205c4c79ac$export$ef641b782d85522(a, b) {
    return $6ce12b205c4c79ac$export$22adf28bfca1c186(a.x, b.x) && $6ce12b205c4c79ac$export$22adf28bfca1c186(a.y, b.y);
}
function $6ce12b205c4c79ac$export$c5706146bc63213(box) {
    return (0, $85a652ec5cd36319$export$c1c127004b72a37)(box.x) / (0, $85a652ec5cd36319$export$c1c127004b72a37)(box.y);
}
function $6ce12b205c4c79ac$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $46c35e490a5123a4$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $51a4ba498ba1dae1$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $51a4ba498ba1dae1$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $262abd317fffbdb0$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $c4735a9fd08448c1$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $bc96ab5be3a8112a$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $51a4ba498ba1dae1$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $51a4ba498ba1dae1$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $c4735a9fd08448c1$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}




/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $afcd820fe2a95f42$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $5886206991be4714$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}





/**
 * Timeout defined in ms
 */ function $9eaf236b0880c674$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $2668c8a722676613$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $2668c8a722676613$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $2668c8a722676613$export$ec99c0ef4978dccb)(checkElapsed);
}



function $cd7f8f0ad0976f3a$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $0840febc4398c738$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value) ? value : (0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $30c44ca59ad5e77f$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}









const $484678f694ff2da1$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $484678f694ff2da1$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $484678f694ff2da1$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $484678f694ff2da1$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $484678f694ff2da1$var$animationTarget = 1000;
let $484678f694ff2da1$var$id = 0;
function $484678f694ff2da1$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $484678f694ff2da1$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $355e745a41ba8ef0$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $2668c8a722676613$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $484678f694ff2da1$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $484678f694ff2da1$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $484678f694ff2da1$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($484678f694ff2da1$var$isDebug) $484678f694ff2da1$var$metrics.totalNodes = $484678f694ff2da1$var$metrics.resolvedTargetDeltas = $484678f694ff2da1$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($484678f694ff2da1$export$131f2f0cc5fe9609);
                this.nodes.forEach($484678f694ff2da1$var$resolveTargetDelta);
                this.nodes.forEach($484678f694ff2da1$var$calcProjection);
                this.nodes.forEach($484678f694ff2da1$export$c2664f37bc951031);
                if ($484678f694ff2da1$var$isDebug) window.MotionDebug.record($484678f694ff2da1$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $bc96ab5be3a8112a$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $f9d7e2b4cbfd436c$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $cd7f8f0ad0976f3a$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $9eaf236b0880c674$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $dd7235250d7597e1$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $dd7235250d7597e1$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($484678f694ff2da1$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $484678f694ff2da1$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $6ce12b205c4c79ac$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $453e5e72c39cf7c2$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $484678f694ff2da1$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $2668c8a722676613$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($484678f694ff2da1$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $484678f694ff2da1$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($484678f694ff2da1$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($484678f694ff2da1$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($484678f694ff2da1$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($484678f694ff2da1$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($484678f694ff2da1$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
            (0, $2668c8a722676613$export$fff89137e9e818ce).delta = (0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp);
            (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp = now;
            (0, $2668c8a722676613$export$fff89137e9e818ce).isProcessing = true;
            (0, $2668c8a722676613$export$be3f796aed065412).update.process((0, $2668c8a722676613$export$fff89137e9e818ce));
            (0, $2668c8a722676613$export$be3f796aed065412).preRender.process((0, $2668c8a722676613$export$fff89137e9e818ce));
            (0, $2668c8a722676613$export$be3f796aed065412).render.process((0, $2668c8a722676613$export$fff89137e9e818ce));
            (0, $2668c8a722676613$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $56c6f990d38070fe$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($484678f694ff2da1$var$clearSnapshot);
            this.sharedNodes.forEach($484678f694ff2da1$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $2668c8a722676613$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $6ce12b205c4c79ac$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $484678f694ff2da1$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($484678f694ff2da1$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $d81381f648f60915$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $d81381f648f60915$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $d81381f648f60915$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d81381f648f60915$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d81381f648f60915$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d81381f648f60915$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(this.latestValues)) (0, $d81381f648f60915$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d3d101fc7fd68aaf$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $3cca3361c07be144$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(this.latestValues)) (0, $3cca3361c07be144$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    (0, $85a652ec5cd36319$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $85a652ec5cd36319$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d81381f648f60915$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    (0, $85a652ec5cd36319$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($484678f694ff2da1$var$isDebug) $484678f694ff2da1$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $d3d101fc7fd68aaf$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $d3d101fc7fd68aaf$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d81381f648f60915$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $eb323b55846adefd$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $eb323b55846adefd$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $85a652ec5cd36319$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $6ce12b205c4c79ac$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $6ce12b205c4c79ac$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($484678f694ff2da1$var$isDebug) $484678f694ff2da1$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
            this.projectionDelta = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($484678f694ff2da1$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $484678f694ff2da1$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $484678f694ff2da1$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $85a652ec5cd36319$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $484678f694ff2da1$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $6ce12b205c4c79ac$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $21f9a46747b133ed$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $2668c8a722676613$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $2668c8a722676613$export$2cef06c20297c17d).update(()=>{
                (0, $dd7235250d7597e1$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $0840febc4398c738$export$335a17c977067b99)(0, $484678f694ff2da1$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($484678f694ff2da1$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $484678f694ff2da1$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                const xLength = (0, $85a652ec5cd36319$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $85a652ec5cd36319$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d81381f648f60915$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $85a652ec5cd36319$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $46c35e490a5123a4$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $484678f694ff2da1$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $484678f694ff2da1$var$transformAxes.length; i++){
                $484678f694ff2da1$var$resetDistortingTransform(`rotate${$484678f694ff2da1$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $484678f694ff2da1$var$resetDistortingTransform(`skew${$484678f694ff2da1$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $484678f694ff2da1$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $afcd820fe2a95f42$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $afcd820fe2a95f42$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $262abd317fffbdb0$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $5a27ca56288b5194$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $5a27ca56288b5194$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $afcd820fe2a95f42$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($484678f694ff2da1$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $484678f694ff2da1$var$updateLayout(node) {
    node.updateLayout();
}
function $484678f694ff2da1$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $85a652ec5cd36319$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($484678f694ff2da1$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $85a652ec5cd36319$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
        (0, $85a652ec5cd36319$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
        if (isShared) (0, $85a652ec5cd36319$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $85a652ec5cd36319$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $6ce12b205c4c79ac$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    (0, $85a652ec5cd36319$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    (0, $85a652ec5cd36319$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $6ce12b205c4c79ac$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $484678f694ff2da1$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($484678f694ff2da1$var$isDebug) $484678f694ff2da1$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $484678f694ff2da1$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $484678f694ff2da1$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $484678f694ff2da1$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $484678f694ff2da1$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $484678f694ff2da1$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $484678f694ff2da1$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $484678f694ff2da1$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $484678f694ff2da1$var$calcProjection(node) {
    node.calcProjection();
}
function $484678f694ff2da1$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $484678f694ff2da1$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $484678f694ff2da1$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $484678f694ff2da1$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $484678f694ff2da1$export$6ffd3e6ae339a132(output, from, to, p) {
    $484678f694ff2da1$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $484678f694ff2da1$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $484678f694ff2da1$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $484678f694ff2da1$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $484678f694ff2da1$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $484678f694ff2da1$var$roundPoint = $484678f694ff2da1$var$userAgentContains("applewebkit/") && !$484678f694ff2da1$var$userAgentContains("chrome/") ? Math.round : (0, $c90734627ed96e3f$export$8793edee2d425525);
function $484678f694ff2da1$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $484678f694ff2da1$var$roundPoint(axis.min);
    axis.max = $484678f694ff2da1$var$roundPoint(axis.max);
}
function $484678f694ff2da1$var$roundBox(box) {
    $484678f694ff2da1$var$roundAxis(box.x);
    $484678f694ff2da1$var$roundAxis(box.y);
}
function $484678f694ff2da1$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $85a652ec5cd36319$export$28d0384c4b79bde2)((0, $6ce12b205c4c79ac$export$c5706146bc63213)(snapshot), (0, $6ce12b205c4c79ac$export$c5706146bc63213)(layout), 0.2);
}
function $484678f694ff2da1$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $2e704cfa3544bdc6$export$2d029a49a09b6177 = (0, $484678f694ff2da1$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $52bbcc091bf26590$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $9f0cd6e302f97046$export$b91509fcf893b648 = {
    current: undefined
};
const $9f0cd6e302f97046$export$b61a9eb3dbde8858 = (0, $484678f694ff2da1$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$9f0cd6e302f97046$export$b91509fcf893b648.current) {
            const documentNode = new (0, $2e704cfa3544bdc6$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $9f0cd6e302f97046$export$b91509fcf893b648.current = documentNode;
        }
        return $9f0cd6e302f97046$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $4f797dc01d53a48c$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $eb5b67e8076eeec3$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $775cbfbec7f3e7b1$export$5d97dc2872682820),
        ProjectionNode: (0, $9f0cd6e302f97046$export$b61a9eb3dbde8858),
        MeasureLayout: $6d3ffb27b820752c$export$779f5fb01ad751cd
    }
};







function $11dc5bd2645fc825$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $b620b19e58064217$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>callback(event, info));
    };
    return (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $11dc5bd2645fc825$export$93a81ea037eac456 extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $a510fe5631c50899$export$a4627e546088548d)($11dc5bd2645fc825$var$addHoverEvent(this.node, true), $11dc5bd2645fc825$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $1ab18cc01ec74d34$export$d4826db40d47595b extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $a510fe5631c50899$export$a4627e546088548d)((0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $0f852327d576566c$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $0f852327d576566c$export$e841ada32ff745b(parent, child.parentElement);
};




function $9c45cdbc6fb4c44c$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $bb2968ceabdf7aba$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $9c45cdbc6fb4c44c$export$f026abdbba7f0c9e extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $c90734627ed96e3f$export$8793edee2d425525);
        this.removeEndListeners = (0, $c90734627ed96e3f$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $c90734627ed96e3f$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $0f852327d576566c$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $2668c8a722676613$export$2cef06c20297c17d).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $a510fe5631c50899$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $9c45cdbc6fb4c44c$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $9c45cdbc6fb4c44c$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $9c45cdbc6fb4c44c$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $a510fe5631c50899$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $b620b19e58064217$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $a510fe5631c50899$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $848b825b11da1e75$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $848b825b11da1e75$var$observers = new WeakMap();
const $848b825b11da1e75$var$fireObserverCallback = (entry)=>{
    const callback = $848b825b11da1e75$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $848b825b11da1e75$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($848b825b11da1e75$var$fireObserverCallback);
};
function $848b825b11da1e75$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$848b825b11da1e75$var$observers.has(lookupRoot)) $848b825b11da1e75$var$observers.set(lookupRoot, {});
    const rootObservers = $848b825b11da1e75$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($848b825b11da1e75$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $848b825b11da1e75$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $848b825b11da1e75$var$initIntersectionObserver(options);
    $848b825b11da1e75$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $848b825b11da1e75$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $fdd2d91840e134f5$var$thresholdNames = {
    some: 0,
    all: 1
};
class $fdd2d91840e134f5$export$150851c8cc2f0c72 extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $fdd2d91840e134f5$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $848b825b11da1e75$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($fdd2d91840e134f5$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $fdd2d91840e134f5$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $977cf784158004df$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $fdd2d91840e134f5$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $9c45cdbc6fb4c44c$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $1ab18cc01ec74d34$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $11dc5bd2645fc825$export$93a81ea037eac456)
    }
};




const $b5d3ffa854a4de95$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $9f0cd6e302f97046$export$b61a9eb3dbde8858),
        MeasureLayout: $6d3ffb27b820752c$export$779f5fb01ad751cd
    }
};



var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
"use client";
/**
 * @public
 */ const $f79c9a1bd76bed7c$export$22a697fb29aac98d = (0, $eeH7J.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $eeH7J = parcelRequire("eeH7J");
"use client";
const $10cb616f5ff4f925$export$2285bbca2c666415 = (0, $eeH7J.createContext)({});



var $eeH7J = parcelRequire("eeH7J");




var $eeH7J = parcelRequire("eeH7J");
"use client";
const $9be1ba1cdd29066b$export$40f10139ecf1f171 = (0, $eeH7J.createContext)({
    strict: false
});







let $b8ea47d48372d11c$var$scheduleHandoffComplete = false;
function $b8ea47d48372d11c$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a;
    const { visualElement: parent } = (0, $eeH7J.useContext)((0, $10cb616f5ff4f925$export$2285bbca2c666415));
    const lazyContext = (0, $eeH7J.useContext)((0, $9be1ba1cdd29066b$export$40f10139ecf1f171));
    const presenceContext = (0, $eeH7J.useContext)((0, $2026c3a36ffa4174$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $eeH7J.useContext)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $eeH7J.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $eeH7J.useContext)((0, $d06770095535cbfe$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $b8ea47d48372d11c$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    (0, $eeH7J.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $bd1f6e057be11122$export$8592e1c077c890a6];
    const wantsHandoff = (0, $eeH7J.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete && ((_a = window.MotionHasOptimisedAnimation) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)));
    (0, $17cc282998a57b95$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        (0, $56c6f990d38070fe$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $eeH7J.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        wantsHandoff.current = false;
        // This ensures all future calls to animateChanges() will run in useEffect
        if (!$b8ea47d48372d11c$var$scheduleHandoffComplete) {
            $b8ea47d48372d11c$var$scheduleHandoffComplete = true;
            queueMicrotask($b8ea47d48372d11c$var$completeHandoff);
        }
    });
    return visualElement;
}
function $b8ea47d48372d11c$var$completeHandoff() {
    window.MotionHandoffIsComplete = true;
}
function $b8ea47d48372d11c$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $b8ea47d48372d11c$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $b8ea47d48372d11c$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $b8ea47d48372d11c$var$getClosestProjectingNode(visualElement.parent);
}



var $eeH7J = parcelRequire("eeH7J");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $8e604e026e1c0cf4$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $eeH7J.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $eeH7J = parcelRequire("eeH7J");





function $db35ba61420c0bc2$export$4b3c3bd8d910d78d(props) {
    return (0, $f29cdb74f4d8f17d$export$aa71198ceeaf53ce)(props.animate) || (0, $7526b0a811789693$export$1405a65085f40b9).some((name)=>(0, $bfdcb20e850e14f7$export$720b90e312cea233)(props[name]));
}
function $db35ba61420c0bc2$export$ce46fa4165cdec40(props) {
    return Boolean($db35ba61420c0bc2$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $e749979db1576994$export$12fc32fc096a04a3(props, context) {
    if ((0, $db35ba61420c0bc2$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $bfdcb20e850e14f7$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $bfdcb20e850e14f7$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $95feffab0212c423$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $e749979db1576994$export$12fc32fc096a04a3)(props, (0, $eeH7J.useContext)((0, $10cb616f5ff4f925$export$2285bbca2c666415)));
    return (0, $eeH7J.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $95feffab0212c423$var$variantLabelsAsDependency(initial),
        $95feffab0212c423$var$variantLabelsAsDependency(animate)
    ]);
}
function $95feffab0212c423$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $217bebd9cdd21726$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $217bebd9cdd21726$export$65570e08d843624d = {};
for(const key in $217bebd9cdd21726$var$featureProps)$217bebd9cdd21726$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$217bebd9cdd21726$var$featureProps[key].some((name)=>!!props[name])
};


function $47c02d192793b5df$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $217bebd9cdd21726$export$65570e08d843624d)[key] = {
        ...(0, $217bebd9cdd21726$export$65570e08d843624d)[key],
        ...features[key]
    };
}





const $fc3933eda9c7ed40$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $dfb7729452da4dad$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $47c02d192793b5df$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $eeH7J.useContext)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d)),
            ...props,
            layoutId: $dfb7729452da4dad$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $95feffab0212c423$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $8cf061ae720cd83e$export$4e09c449d6c407f7)) {
            $dfb7729452da4dad$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $dfb7729452da4dad$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $b8ea47d48372d11c$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $dRzna.jsxs)((0, $10cb616f5ff4f925$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $dRzna.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $8e604e026e1c0cf4$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefMotionComponent = (0, $eeH7J.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $fc3933eda9c7ed40$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $dfb7729452da4dad$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $eeH7J.useContext)((0, $7e832de67499b416$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $dfb7729452da4dad$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $eeH7J.useContext)((0, $9be1ba1cdd29066b$export$40f10139ecf1f171)).strict;
}
function $dfb7729452da4dad$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $217bebd9cdd21726$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $a770698d5d6425cb$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $fa075626af2c10ee$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $a770698d5d6425cb$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



function $8731e770a6b2e9fa$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $aa386d96766cdbf4$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $41e5124bd72f0d4a$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $8731e770a6b2e9fa$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $aa386d96766cdbf4$export$28931db5d57958e5).has(key) ? (0, $76d837a31980cd1f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $28b30eb12c17b65c$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $5a27ca56288b5194$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $ba4595c2b86ce2ce$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(prevProps.style[key]) || (0, $28b30eb12c17b65c$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    /**
     * If the willChange style has been manually set as a string, set
     * applyWillChange to false to prevent it from automatically being applied.
     */ if (visualElement && style && typeof style.willChange === "string") visualElement.applyWillChange = false;
    return newValues;
}



function $feed3de2ce0df473$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $ba4595c2b86ce2ce$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(props[key]) || (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $ea8236087cf451dc$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $eeH7J = parcelRequire("eeH7J");




var $eeH7J = parcelRequire("eeH7J");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $450f33b6a8740b8a$export$fe4300aa8eebea86(init) {
    const ref = (0, $eeH7J.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}







function $d16d9c952a878d05$var$makeState({ applyWillChange: applyWillChange = false, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext, isStatic) {
    const state = {
        latestValues: $d16d9c952a878d05$var$makeLatestValues(props, context, presenceContext, isStatic ? false : applyWillChange, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $d16d9c952a878d05$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $eeH7J.useContext)((0, $10cb616f5ff4f925$export$2285bbca2c666415));
        const presenceContext = (0, $eeH7J.useContext)((0, $2026c3a36ffa4174$export$f224e4635b6f8ce2));
        const make = ()=>$d16d9c952a878d05$var$makeState(config, props, context, presenceContext, isStatic);
        return isStatic ? make() : (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(make);
    };
function $d16d9c952a878d05$var$addWillChange(willChange, name) {
    const memberName = (0, $747b8e31f6efe634$export$b3f9dd865b560c6)(name);
    if (memberName) (0, $51a4ba498ba1dae1$export$20e507e47fae79fd)(willChange, memberName);
}
function $d16d9c952a878d05$var$forEachDefinition(props, definition, callback) {
    const list = Array.isArray(definition) ? definition : [
        definition
    ];
    for(let i = 0; i < list.length; i++){
        const resolved = (0, $195eed3b69cf8a61$export$d68f140c4d9b48bc)(props, list[i]);
        if (resolved) {
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            callback(target, transitionEnd);
        }
    }
}
function $d16d9c952a878d05$var$makeLatestValues(props, context, presenceContext, shouldApplyWillChange, scrapeMotionValues) {
    var _a;
    const values = {};
    const willChange = [];
    const applyWillChange = shouldApplyWillChange && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.willChange) === undefined;
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $afcd820fe2a95f42$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $db35ba61420c0bc2$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $db35ba61420c0bc2$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $f29cdb74f4d8f17d$export$aa71198ceeaf53ce)(variantToSet)) $d16d9c952a878d05$var$forEachDefinition(props, variantToSet, (target, transitionEnd)=>{
        for(const key in target){
            let valueTarget = target[key];
            if (Array.isArray(valueTarget)) {
                /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                valueTarget = valueTarget[index];
            }
            if (valueTarget !== null) values[key] = valueTarget;
        }
        for(const key in transitionEnd)values[key] = transitionEnd[key];
    });
    // Add animating values to will-change
    if (applyWillChange) {
        if (animate && initial !== false && !(0, $f29cdb74f4d8f17d$export$aa71198ceeaf53ce)(animate)) $d16d9c952a878d05$var$forEachDefinition(props, animate, (target)=>{
            for(const key in target)$d16d9c952a878d05$var$addWillChange(willChange, key);
        });
        if (willChange.length) values.willChange = willChange.join(",");
    }
    return values;
}


const $a242b898221e1c57$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


const $cba5405fa7def0ce$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $a242b898221e1c57$export$8940b483cf52eeda)(),
        attrs: {}
    });



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $6f5fcd0543f6d6f5$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $8d6e9a01f9ac58ef$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $8d6e9a01f9ac58ef$var$numTransforms = (0, $ea8236087cf451dc$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $8d6e9a01f9ac58ef$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $8d6e9a01f9ac58ef$var$numTransforms; i++){
        const key = (0, $ea8236087cf451dc$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $6f5fcd0543f6d6f5$export$453ef540a9a1bd6b)(value, (0, $0f29681014396523$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $8d6e9a01f9ac58ef$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}






function $6be340daa9519b5b$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $7b632f63647c186c$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $6f5fcd0543f6d6f5$export$453ef540a9a1bd6b)(value, (0, $0f29681014396523$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $8d6e9a01f9ac58ef$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



function $d0dfe8914d333ceb$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $d0dfe8914d333ceb$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $d0dfe8914d333ceb$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $d0dfe8914d333ceb$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $0035c5f0bff34fc0$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $0035c5f0bff34fc0$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $0035c5f0bff34fc0$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $0035c5f0bff34fc0$var$dashKeys : $0035c5f0bff34fc0$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $673009f839505ee8$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $6be340daa9519b5b$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $d0dfe8914d333ceb$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $0035c5f0bff34fc0$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


const $cd906bb243395b56$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";



const $8a7257aec4d71f16$export$44dabd3fae512e85 = {
    useVisualState: (0, $d16d9c952a878d05$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $feed3de2ce0df473$export$16da615486abaa45),
        createRenderState: (0, $cba5405fa7def0ce$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $2668c8a722676613$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $2668c8a722676613$export$2cef06c20297c17d).render(()=>{
                (0, $673009f839505ee8$export$5475d24f125d7053)(renderState, latestValues, (0, $cd906bb243395b56$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $41e5124bd72f0d4a$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $e87a55166044f2ec$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $d16d9c952a878d05$export$e91e107bc6d03a8e)({
        applyWillChange: true,
        scrapeMotionValuesFromProps: $ba4595c2b86ce2ce$export$16da615486abaa45,
        createRenderState: (0, $a242b898221e1c57$export$8940b483cf52eeda)
    })
};



var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");




function $ab4fa5d37ab85604$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $97dfd46cf2e43daf$export$605d60a2578142d3)(source[key]) && !(0, $28b30eb12c17b65c$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $ab4fa5d37ab85604$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $eeH7J.useMemo)(()=>{
        const state = (0, $a242b898221e1c57$export$8940b483cf52eeda)();
        (0, $6be340daa9519b5b$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $ab4fa5d37ab85604$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $ab4fa5d37ab85604$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $ab4fa5d37ab85604$var$useInitialMotionValues(props, visualState));
    return style;
}
function $ab4fa5d37ab85604$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $ab4fa5d37ab85604$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $9473e8e46bff55a6$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $9473e8e46bff55a6$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $9473e8e46bff55a6$var$validMotionProps.has(key);
}


let $d3983d2add71cd91$var$shouldForward = (key)=>!(0, $9473e8e46bff55a6$export$2f9c46555243bf04)(key);
function $d3983d2add71cd91$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $d3983d2add71cd91$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $9473e8e46bff55a6$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $d3983d2add71cd91$export$59d6962c470509a5($d3983d2add71cd91$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $d3983d2add71cd91$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($d3983d2add71cd91$var$shouldForward(key) || forwardMotionProps === true && (0, $9473e8e46bff55a6$export$2f9c46555243bf04)(key) || !isDom && !(0, $9473e8e46bff55a6$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $eeH7J = parcelRequire("eeH7J");




function $87d25680db1d6ce7$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $eeH7J.useMemo)(()=>{
        const state = (0, $cba5405fa7def0ce$export$41be8b43e1c4d4f9)();
        (0, $673009f839505ee8$export$5475d24f125d7053)(state, visualState, (0, $cd906bb243395b56$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $ab4fa5d37ab85604$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $e6261c6903ecedcf$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $fa075626af2c10ee$export$88f3fc2fd3766989)(Component) ? (0, $87d25680db1d6ce7$export$84309c4f53cb1bd5) : (0, $ab4fa5d37ab85604$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $d3983d2add71cd91$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $eeH7J.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $eeH7J.useMemo)(()=>(0, $97dfd46cf2e43daf$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $eeH7J.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


function $f107d1fb53628652$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $fa075626af2c10ee$export$88f3fc2fd3766989)(Component) ? (0, $8a7257aec4d71f16$export$44dabd3fae512e85) : (0, $e87a55166044f2ec$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $e6261c6903ecedcf$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $dfb7729452da4dad$export$c3ad4a902bccc2d8)(config);
    };
}



var $eeH7J = parcelRequire("eeH7J");








// Does this device prefer reduced motion? Returns `null` server-side.
const $64357612add0cc85$export$ff7706047246b98b = {
    current: null
};
const $64357612add0cc85$export$6476d16e2fd2d0db = {
    current: false
};


function $8948a8adab9203a8$export$ca9f41fb23dded3d() {
    (0, $64357612add0cc85$export$6476d16e2fd2d0db).current = true;
    if (!(0, $8cf061ae720cd83e$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $64357612add0cc85$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $64357612add0cc85$export$ff7706047246b98b).current = false;
}












function $fb79b5c51ae0a68c$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $64861684472349e0$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $f6428ebb310200da$var$valueTypes = [
    ...(0, $1c32a536829b8c8a$export$d176691c1998a1f5),
    (0, $7028c17a7a695b13$export$35e9368ef982300f),
    (0, $4c282419bf833d7f$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $f6428ebb310200da$export$950e7e59ea1ffed7 = (v)=>$f6428ebb310200da$var$valueTypes.find((0, $7da4e5401aa12761$export$6eae4d0a6a7ca7cd)(v));






const $22752ef207ffd3f4$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $22752ef207ffd3f4$var$numVariantProps = (0, $7526b0a811789693$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $22752ef207ffd3f4$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * If true, will-change will be applied to the element. Only HTMLVisualElements
         * currently support this.
         */ this.applyWillChange = false;
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $b1026f81549deb9c$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            this.isRenderScheduled = false;
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.isRenderScheduled = false;
        this.scheduleRender = ()=>{
            if (!this.isRenderScheduled) {
                this.isRenderScheduled = true;
                (0, $2668c8a722676613$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $db35ba61420c0bc2$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $db35ba61420c0bc2$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $64861684472349e0$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $64357612add0cc85$export$6476d16e2fd2d0db).current) (0, $8948a8adab9203a8$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $64357612add0cc85$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $64861684472349e0$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $2668c8a722676613$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $2668c8a722676613$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $2668c8a722676613$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $217bebd9cdd21726$export$65570e08d843624d){
            const featureDefinition = (0, $217bebd9cdd21726$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $22752ef207ffd3f4$var$propEventHandlers.length; i++){
            const key = $22752ef207ffd3f4$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $fb79b5c51ae0a68c$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $22752ef207ffd3f4$var$numVariantProps; i++){
            const name = (0, $7526b0a811789693$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $bfdcb20e850e14f7$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $a9d0c51dad3a3292$export$65583ed5a868f2d9)(value) || (0, $ad0677d01318a032$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $f6428ebb310200da$export$950e7e59ea1ffed7)(value) && (0, $4c282419bf833d7f$export$83a0e34f1302825b).test(target)) value = (0, $e50050333fd23e17$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $195eed3b69cf8a61$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $97dfd46cf2e43daf$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $f9d7e2b4cbfd436c$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}



class $2391caa4d241ec31$export$e49735c2a366bdc7 extends (0, $22752ef207ffd3f4$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $7a5a5700acca8750$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}



function $dc98d0848c7498cf$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $dc98d0848c7498cf$export$23fea75b03ac16b3 extends (0, $2391caa4d241ec31$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.applyWillChange = true;
        this.renderInstance = (0, $8731e770a6b2e9fa$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $a3e8133ab555f880$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $dc98d0848c7498cf$export$3735103072e4a80(instance);
            const value = ((0, $7b632f63647c186c$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $d134b85ec35c9730$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $6be340daa9519b5b$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $ba4595c2b86ce2ce$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}












class $b30b20e17f4658dd$export$86bcdffbaf733d84 extends (0, $2391caa4d241ec31$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $a33f96272a0f3ced$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $a3e8133ab555f880$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $aa386d96766cdbf4$export$28931db5d57958e5).has(key) ? (0, $76d837a31980cd1f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $feed3de2ce0df473$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $673009f839505ee8$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $41e5124bd72f0d4a$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $cd906bb243395b56$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $d87daa37df3bb6bf$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $fa075626af2c10ee$export$88f3fc2fd3766989)(Component) ? new (0, $b30b20e17f4658dd$export$86bcdffbaf733d84)(options) : new (0, $dc98d0848c7498cf$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $eeH7J.Fragment)
    });
};


const $b2ade50ab272b8e8$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $f107d1fb53628652$export$d86feac869a7f0d5)({
    ...(0, $2d0cdac558a97e2e$export$7f9953c70dacfd7f),
    ...(0, $977cf784158004df$export$e5b72898e5a201f1),
    ...(0, $4f797dc01d53a48c$export$d7d5d435647ed5a0),
    ...(0, $b5d3ffa854a4de95$export$b3219800bda33a1f)
}, (0, $d87daa37df3bb6bf$export$56ba0183203348f5));


const $ad7a054f4530c130$export$e25e478948902b8b = /*@__PURE__*/ (0, $56c547a84798143f$export$3af29c0efb268f04)((0, $b2ade50ab272b8e8$export$46b7e4b9dc6110c3));



var $lhaLc = parcelRequire("lhaLc");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");
var $gGZ2r = parcelRequire("gGZ2r");
var $fR074 = parcelRequire("fR074");

var $eSiQ2 = parcelRequire("eSiQ2");

var $7m9cQ = parcelRequire("7m9cQ");

var $lhaLc = parcelRequire("lhaLc");


var $lhaLc = parcelRequire("lhaLc");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");
/**
 * Defines the set of keywords used to specify the direction or condition for limiting a
 * media query based on the viewport size.
 */ const $dc53c17a4a911fba$var$limitTypes = [
    "min",
    "max",
    "only"
];
function $dc53c17a4a911fba$export$25d302a5b900a763(config) {
    const { screenSizes: screenSizes, spacingSizes: spacingSizes, headingLevels: headingLevels, borderRadiuses: borderRadiuses } = config;
    /**
     * Helper function that returns a media query for a given screen size and limit type.
     *
     * @param limitType The type of limit to apply
     * @param screenSize The screen size to apply the styles to
     * @returns A media query string
     */ function mediaQuery(limitType, screenSize) {
        switch(limitType){
            case "min":
                return `@media (min-width: ${screenSizes[screenSize]}px)`;
            case "max":
                {
                    const sizesKeysArr = Object.keys(screenSizes);
                    const sizeIndex = sizesKeysArr.indexOf(screenSize);
                    if (sizeIndex + 1 === sizesKeysArr.length) return "@media";
                    const nextSize = sizesKeysArr[sizeIndex + 1];
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    if (!nextSize) return "@media";
                    return `@media (max-width: ${screenSizes[nextSize] - 1}px)`;
                }
            case "only":
                {
                    const sizesKeysArr = Object.keys(screenSizes);
                    const sizeIndex = sizesKeysArr.indexOf(screenSize);
                    if (sizeIndex + 1 === sizesKeysArr.length) return "@media";
                    const nextSize = sizesKeysArr[sizeIndex + 1];
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    if (!nextSize) return `@media (min-width: ${screenSizes[screenSize]}px)`;
                    return `@media (min-width: ${screenSizes[screenSize]}px and max-width: ${screenSizes[nextSize] - 1}px)`;
                }
            default:
                return "";
        }
    }
    /**
     * A hook that returns a boolean indicating whether the screen matches or not.
     *
     * @param limitType The type of limit to apply
     * @param screenSize The screen size to apply the styles to
     * @returns A media query string
     */ function useMediaQuery(limitType, screenSize) {
        const [matches, setMatches] = (0, $eeH7J.useState)(false);
        const query = mediaQuery(limitType, screenSize).replace("@media", "");
        (0, $eeH7J.useEffect)(()=>{
            const media = window.matchMedia(query);
            if (media.matches !== matches) setMatches(media.matches);
            const listener = ()=>{
                setMatches(media.matches);
            };
            media.addEventListener("change", listener);
            return ()=>{
                media.removeEventListener("change", listener);
            };
        }, [
            matches,
            query
        ]);
        return matches;
    }
    /**
     * Helper function that returns a media query and styles for a given screen size.
     *
     * @param limitType The type of limit to apply
     * @param screenSize The screen size to apply the styles to
     * @param styles The styles to apply to the given screen size limit
     * @returns `SerializedStyles` to be used in an Emotion `css` prop
     */ function responsiveCss(limitType, screenSize, s) {
        return (0, $lhaLc.css)({
            [mediaQuery(limitType, screenSize)]: s
        });
    }
    function isVariantInVariants(variant, variants) {
        return Object.keys(variants).includes(variant);
    }
    function isVariantMediaQuery(variant) {
        return variant instanceof Array && variant.length === 3 && typeof variant[0] === "string" && $dc53c17a4a911fba$var$limitTypes.includes(variant[0]) && typeof variant[1] === "string" && (typeof variant[2] === "string" || typeof variant[2] === "number");
    }
    /**
     * Returns responsive CSS for a responsive variant that does not have a responsive dimension.
     */ function variantCss(variants, variant) {
        if (isVariantInVariants(variant, variants) || typeof variant === "string" || typeof variant === "number") return (0, $lhaLc.css)(variants[variant]);
        else if (isVariantMediaQuery(variant)) {
            const variantMediaQuery = variant;
            const [limitType, screenSize, v] = variantMediaQuery;
            const style = variants[v];
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (style) return (0, $lhaLc.css)(responsiveCss(limitType, screenSize, style));
        } else if (variant instanceof Array) return (0, $lhaLc.css)(variant.map((v)=>variantCss(variants, v)));
        return;
    }
    // Helper function to get the screen sizes based on min/max and the provided size
    function getScreenSizes(limitType, screenSize) {
        const order = Object.keys(screenSizes);
        const index = order.indexOf(screenSize);
        if (limitType === "min") return order.slice(index);
        else return order.slice(0, index + 1);
    }
    function getStyleForScreenSize(screenSize, screenSizeStyles) {
        return getScreenSizes("max", screenSize).reduce((acc, curr)=>{
            var _a;
            return Object.assign(acc, (_a = screenSizeStyles[curr]) !== null && _a !== void 0 ? _a : {});
        }, {});
    }
    function getCssForScreenSize(screenSize, screenSizeStyles) {
        const sss = getScreenSizes("max", screenSize);
        return (0, $lhaLc.css)(sss.map((ss)=>screenSizeStyles[ss]));
    }
    /**
     * Type guard for checking if a string is a screen size.
     */ function isScreenSize(screenSize) {
        return Object.keys(screenSizes).includes(screenSize);
    }
    /**
     * Returns responsive CSS for a set of ResponsiveStyles.
     */ function responsiveVariantToCss(variant) {
        const ss = [];
        for(const screenSize in variant)if (variant[screenSize]) ss.push(responsiveCss("min", screenSize, variant[screenSize]));
        return (0, $lhaLc.css)(ss);
    }
    function isMediaQuery(v) {
        if (v instanceof Array === false) return false;
        const [limitType, screenSize, variant] = v;
        if (!$dc53c17a4a911fba$var$limitTypes.includes(limitType)) return false;
        if (!isScreenSize(screenSize)) return false;
        if (typeof variant !== "string" && typeof variant !== "number") return false;
        return true;
    }
    function fixedVariantCss(variants, variant) {
        const baseScreenSize = Object.keys(screenSizes)[0];
        const [, screenSize, variantKey] = variant;
        if (!baseScreenSize || // Allow variantKey of type number as well, to support heading levels being numbers.
        typeof variantKey !== "string" && typeof variantKey !== "number" || typeof screenSize !== "string" || !variants[variantKey]) return;
        return getCssForScreenSize(screenSize, variants[variantKey]);
    }
    /**
     * Returns responsive CSS for a responsive variant that has a responsive dimension.
     */ function responsiveVariantsCss(variants, variant) {
        function isVariant(v) {
            return typeof v === "string" || typeof v === "number";
        }
        if (isVariant(variant) && !!variants[variant]) return responsiveVariantToCss(variants[variant]);
        else if (variant instanceof Array) {
            const [baseVariant, ...rest] = variant.filter(isVariant);
            // Specifying more than one variant without media query does not make sense.
            if (rest.length) // eslint-disable-next-line no-console
            console.warn("Should not use more than one string.", variant);
            const overrides = variant.filter((v)=>isMediaQuery(v));
            // Check if used a combination of min and max which is not advisable.
            if (overrides.find((o)=>o[0] === "min") && overrides.find((o)=>o[0] === "max")) // eslint-disable-next-line no-console
            console.warn("Combining min and max is not recommended. Try a base + min overrides instead for example.");
            if (!(isVariant(baseVariant) && variants[baseVariant])) return;
            const baseSizeStyles = Object.assign({}, variants[baseVariant]);
            overrides.forEach((o)=>{
                if (typeof o === "string" || typeof o === "number") return;
                const [limitType, screenSize, v] = o;
                const screenSizesToOverride = getScreenSizes(limitType, screenSize);
                screenSizesToOverride.forEach((ss)=>{
                    const responsiveStyles = variants[v];
                    if (!responsiveStyles) return;
                    baseSizeStyles[ss] = getStyleForScreenSize(ss, responsiveStyles);
                });
            });
            const ss = [];
            for(const screenSize in baseSizeStyles)if (baseSizeStyles[screenSize]) ss.push(responsiveCss("min", screenSize, baseSizeStyles[screenSize]));
            return (0, $lhaLc.css)(ss);
        }
        return;
    }
    function responsivePropCss(values, prop, responsiveValues) {
        if (typeof responsiveValues === "string") return (0, $lhaLc.css)({
            [prop]: values[responsiveValues]
        });
        return (0, $lhaLc.css)(responsiveValues.map((rv)=>{
            if (typeof rv === "string") return {
                [prop]: values[rv]
            };
            else if (rv) {
                const [limitType, screenSize, value] = rv;
                return responsiveCss(limitType, screenSize, {
                    [prop]: values[value]
                });
            }
        }));
    }
    function responsiveValueCss(prop, responsiveValues) {
        if (typeof responsiveValues === "string" || typeof responsiveValues === "number") return (0, $lhaLc.css)({
            [prop]: responsiveValues
        });
        return (0, $lhaLc.css)(responsiveValues.map((rv)=>{
            if (typeof rv === "string" || typeof rv === "number") return {
                [prop]: rv
            };
            else if (rv) {
                const [limitType, screenSize, value] = rv;
                return responsiveCss(limitType, screenSize, {
                    [prop]: value
                });
            }
        }));
    }
    function responsiveSpacing(variant, type) {
        if (typeof spacingSizes[variant] === "object") return (0, $lhaLc.css)(Object.entries(spacingSizes[variant]).map(([screenSize, val])=>responsiveCss("min", screenSize, type instanceof Array ? Object.fromEntries(type.map((t)=>[
                    t,
                    val
                ])) : {
                [type]: typeof val === "number" ? `${val}px` : val
            })));
    }
    /**
     * Helper function that returns a media query with responsive CSS for a given heading level, based
     * on sizes defined in the `headingLevels` theme config.
     *
     * @param level The border radius variant
     * @returns `SerializedStyles` to be used in an Emotion `css` prop
     */ function responsiveHeadingLevel(level) {
        if (typeof headingLevels[level] === "object") return (0, $lhaLc.css)(Object.entries(headingLevels[level]).map(([screenSize, headingStyle])=>responsiveCss("min", screenSize, headingStyle)));
    }
    /**
     * Determines whether a variant is fixed, i.e. ["fixed", "sm", "md"] – always rendered as
     * medium variant on small screen.
     */ function isFixedVariant(variant) {
        return Array.isArray(variant) && variant.length === 3 && variant[0] === "fixed";
    }
    function responsiveHeadingCss(headingLevel) {
        if (isFixedVariant(headingLevel)) return fixedVariantCss(headingLevels, headingLevel);
        return responsiveVariantsCss(headingLevels, headingLevel);
    }
    function responsiveHidden(mq) {
        return responsiveCss(...mq, {
            display: "none"
        });
    }
    function axisOrSideToProps(axisOrSide, type) {
        const axis = {
            x: [
                `${type}Left`,
                `${type}Right`
            ],
            y: [
                `${type}Top`,
                `${type}Bottom`
            ],
            top: `${type}Top`,
            bottom: `${type}Bottom`,
            left: `${type}Left`,
            right: `${type}Right`
        };
        return axis[axisOrSide];
    }
    function isSpacingSize(val) {
        if (typeof val === "number") return false;
        return Object.keys(spacingSizes).includes(val);
    }
    /**
     * Helper function to convert a Spacing prop to CSS.
     *
     * @param type The type of spacing to return rules for, either margin or padding.
     * @param spacing A valid spacing object or single value. Supports both pixels and SpacingSize.
     *
     * @returns An Emotion SerializedStyles object
     */ function spacingToCss(type, spacing) {
        var _a, _b, _c, _d, _e, _f;
        function spacingVal(axisOrSide, val) {
            if (isSpacingSize(val)) return responsiveSpacing(val, axisOrSideToProps(axisOrSide, type));
        }
        return (0, $lhaLc.css)([
            typeof spacing === "number" || typeof spacing === "string" ? isSpacingSize(spacing) ? responsiveSpacing(spacing, type) : {
                [type]: spacing
            } : [
                spacing.x && ((_a = spacingVal("x", spacing.x)) !== null && _a !== void 0 ? _a : {
                    [`${type}Left`]: spacing.x,
                    [`${type}Right`]: spacing.x
                }),
                spacing.y && ((_b = spacingVal("y", spacing.y)) !== null && _b !== void 0 ? _b : {
                    [`${type}Top`]: spacing.y,
                    [`${type}Bottom`]: spacing.y
                }),
                spacing.top && ((_c = spacingVal("top", spacing.top)) !== null && _c !== void 0 ? _c : {
                    [`${type}Top`]: spacing.top
                }),
                spacing.right && ((_d = spacingVal("right", spacing.right)) !== null && _d !== void 0 ? _d : {
                    [`${type}Right`]: spacing.right
                }),
                spacing.bottom && ((_e = spacingVal("bottom", spacing.bottom)) !== null && _e !== void 0 ? _e : {
                    [`${type}Bottom`]: spacing.bottom
                }),
                spacing.left && ((_f = spacingVal("left", spacing.left)) !== null && _f !== void 0 ? _f : {
                    [`${type}Left`]: spacing.left
                })
            ]
        ]);
    }
    function responsiveBodyCss(size) {
        if (isFixedVariant(size)) return fixedVariantCss(config.bodySizes, size);
        return responsiveVariantsCss(config.bodySizes, size);
    }
    /**
     * Helper function that returns a media query with responsive styles for a given border radius
     * variant for different screen sizes as specified in the border radius variants constant.
     *
     * @param variant The border radius variant
     * @returns `SerializedStyles` to be used in an Emotion `css` prop
     */ function responsiveBorderRadius(variant) {
        const borderRadiusVariant = borderRadiuses[variant];
        // Not always truthy, there might be 0 border radiuses.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (borderRadiusVariant && typeof borderRadiusVariant === "object") return (0, $lhaLc.css)(Object.entries(borderRadiuses[variant]).map(([screenSize, borderRadius])=>responsiveCss("min", screenSize, {
                borderRadius: borderRadius
            })));
    }
    function textCss(variant, size) {
        const textVariant = config.textVariants[variant];
        return isFixedVariant(size) ? fixedVariantCss(textVariant, size) : responsiveVariantsCss(textVariant, size);
    }
    const helpers = {
        fixedVariantCss: fixedVariantCss,
        mediaQuery: mediaQuery,
        responsiveCss: responsiveCss,
        responsiveVariantsCss: responsiveVariantsCss,
        responsiveVariantToCss: responsiveVariantToCss,
        responsiveHidden: responsiveHidden,
        responsivePropCss: responsivePropCss,
        responsiveValueCss: responsiveValueCss,
        responsiveSpacing: responsiveSpacing,
        responsiveBorderRadius: responsiveBorderRadius,
        responsiveHeadingLevel: responsiveHeadingLevel,
        responsiveHeadingCss: responsiveHeadingCss,
        responsiveBodyCss: responsiveBodyCss,
        spacingToCss: spacingToCss,
        useMediaQuery: useMediaQuery,
        variantCss: variantCss,
        textCss: textCss
    };
    return Object.assign(Object.assign({}, config), {
        responsiveCss: responsiveCss,
        helpers: helpers
    });
}
/**
 * `ThemeContext` is a context object used to provide and consume the current theme
 * throughout the application. It holds the theme value, which can be accessed by any
 * component wrapped inside the `ThemeProvider`.
 */ const $dc53c17a4a911fba$var$ThemeContext = /*#__PURE__*/ (0, $eeH7J.createContext)(null);
const $dc53c17a4a911fba$export$d8964aec282183a3 = (props)=>{
    return (0, $4vwom.jsx)($dc53c17a4a911fba$var$ThemeContext.Provider, {
        value: props.theme,
        children: props.children
    });
};
function $dc53c17a4a911fba$export$93d4e7f90805808f() {
    const theme = (0, $eeH7J.useContext)($dc53c17a4a911fba$var$ThemeContext);
    if (!theme) throw new Error("useTheme must be used within a ThemeProvider");
    return theme;
}



var $4vwom = parcelRequire("4vwom");

var $5qU69 = parcelRequire("5qU69");

var $lhaLc = parcelRequire("lhaLc");


var $lhaLc = parcelRequire("lhaLc");
/**
 * A base reset that should be applied to all elements that is reset.
 */ const $e82ba787de72625c$var$baseReset = (0, $lhaLc.css)({
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    font: "inherit",
    verticalAlign: "baseline"
});
function $e82ba787de72625c$export$6b6f359a824920a4(element) {
    switch(element){
        case "button":
            return (0, $lhaLc.css)($e82ba787de72625c$var$baseReset, (0, $lhaLc.css)({
                background: "none",
                border: "none",
                padding: 0,
                font: "inherit",
                cursor: "pointer",
                outline: "inherit"
            }));
        case "input":
            return (0, $lhaLc.css)($e82ba787de72625c$var$baseReset, {
                border: "none",
                background: "none",
                font: "inherit",
                outline: "none",
                webkitAppearance: "none",
                MozAppearance: "none",
                appearance: "none"
            });
        case "ol":
        case "ul":
            return (0, $lhaLc.css)($e82ba787de72625c$var$baseReset, (0, $lhaLc.css)({
                listStyle: "none"
            }));
        default:
            return $e82ba787de72625c$var$baseReset;
    }
}
const $e82ba787de72625c$export$425327af25286e5e = (0, $lhaLc.css)({
    textDecoration: "underline",
    textDecorationSkipInk: "none",
    textUnderlineOffset: "20%"
});
function $e82ba787de72625c$export$2c2533fee2945415(styles) {
    const mq = `@media
        only screen and (-webkit-min-device-pixel-ratio: 2),
        only screen and (min--moz-device-pixel-ratio: 2),
        only screen and (-o-min-device-pixel-ratio: 2/1),
        only screen and (min-device-pixel-ratio: 2),
        only screen and (min-resolution: 192dpi),
        only screen and (min-resolution: 2dppx)
    `;
    return (0, $lhaLc.css)({
        [mq]: styles
    });
}
function $e82ba787de72625c$export$c874afaabcd4d5bc(styles) {
    return (0, $lhaLc.css)({
        "@media (hover: none)": styles
    });
}
function $e82ba787de72625c$export$601469075a80284e(styles) {
    return (0, $lhaLc.css)({
        "@media (hover: hover)": styles
    });
}
const $e82ba787de72625c$var$cssVars = [
    "accent-color",
    "accent-color-light",
    "body-padding"
];
function $e82ba787de72625c$export$f1757f6a9a61f8c6(name) {
    return `--${name}`;
}
function $e82ba787de72625c$export$ac1d356ad2ecf90f(name) {
    return `var(--${name})`;
}



const $1c2a8fb378443a1d$export$f988485815015380 = 1;
const $1c2a8fb378443a1d$export$330a64de1bbc7059 = 0.8;
const $1c2a8fb378443a1d$export$488117a5011aa9e = 0.8;
const $1c2a8fb378443a1d$export$adc5746a202ff4b = 0.9;
const $1c2a8fb378443a1d$export$a9ddfd01863914a9 = {
    xs: {
        width: "100%",
        maxWidth: 1296,
        paddingLeft: 16,
        paddingRight: 16,
        scrollPaddingLeft: 16,
        scrollPaddingRight: 16
    },
    md: {
        paddingLeft: 24,
        paddingRight: 24,
        scrollPaddingLeft: 24,
        scrollPaddingRight: 24
    }
};
const $1c2a8fb378443a1d$export$3a40bd8b0ff0173c = {
    xs: Object.assign(Object.assign({}, $1c2a8fb378443a1d$export$a9ddfd01863914a9.xs), {
        paddingBottom: 16
    }),
    md: Object.assign(Object.assign({}, $1c2a8fb378443a1d$export$a9ddfd01863914a9.md), {
        paddingBottom: 24
    })
};
const $1c2a8fb378443a1d$export$d98ecea1201f13ea = {
    xs: 8,
    sm: 16,
    md: 24,
    lg: 32,
    xl: 40
};
const $1c2a8fb378443a1d$export$dd07c5170cc9e3b1 = {
    xs: (0, $756948b644e82cf2$export$981516ee4691055c)(36),
    md: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
};



var $4vwom = parcelRequire("4vwom");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

function $320473f3a1ec63d7$export$274edc73af1ae9c8() {
    return function Icon(props) {
        const theme = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const fillColor = props.color ? theme.colors[props.color] : "currentColor";
        return (0, $4vwom.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            className: props.className,
            css: (0, $lhaLc.css)(props.hidden instanceof Array && theme.helpers.responsiveHidden(props.hidden), !!props.margin && theme.helpers.spacingToCss("margin", props.margin), props.onClick && {
                cursor: "pointer"
            }, props.size ? [
                theme.helpers.responsiveValueCss("height", props.size),
                theme.helpers.responsiveValueCss("width", props.size)
            ] : {
                height: 24,
                width: 24
            }),
            style: Object.assign({
                color: fillColor,
                flexShrink: 0,
                display: props.hidden === true ? "none" : undefined
            }, props.style || {}),
            onClick: props.onClick ? props.onClick : undefined,
            children: theme.icons[props.icon]
        });
    };
}


var $f8cdd04128a131cf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f8cdd04128a131cf$var$ThemedIcon = (0, $320473f3a1ec63d7$export$274edc73af1ae9c8)();
function $f8cdd04128a131cf$export$f04a61298a47a40f(_a) {
    var { color: color } = _a, rest = $f8cdd04128a131cf$var$__rest(_a, [
        "color"
    ]);
    return (0, $4vwom.jsx)($f8cdd04128a131cf$var$ThemedIcon, Object.assign({
        color: rest.icon === "trustpilot" ? "_trustpilot" : color
    }, rest));
}


const $756948b644e82cf2$var$screenSizes = {
    xs: 0,
    sm: 480,
    md: 840,
    lg: 1200,
    xl: 1600
};
/**
 * The colors in Redoit design system
 *
 * Do not shorten to less than 6 chars, to ensure setting opacity using 2 char hex.
 */ const $756948b644e82cf2$var$colors = {
    // Primary
    brand: "#9b64e1",
    brandLight: "#f4e3ff",
    brandDark: "#7248a8",
    // Grays
    grayWhite: "#ffffff",
    gray100: "#f6f6f6",
    gray200: "#e9e6ea",
    gray300: "#868589",
    // For gray text on gray100 background, use this to satisfy WCAG AA requirements.
    gray350: "#717075",
    gray400: "#4d4852",
    gray500: "#150624",
    // Secondary
    forest: "#155c58",
    forestLight: "#c7d8d7",
    sky: "#347cff",
    skyLight: "#e5e3ff",
    sand: "#b49469",
    sandLight: "#f7f2ef",
    highlight: "#c5ffaa",
    error: "#ff4c34",
    warning: "#ff4c34",
    warningLight: "#ffedeb",
    vippsOrange: "#ff5b24",
    // Colors used in specific components that are not defined in the design system
    _productsSeeAllBg: "#efeae7",
    _trustpilot: "#63d793"
};
const $756948b644e82cf2$var$icons = {
    asterisk: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M20.143 16.886a.748.748 0 0 1-1.031.257l-6.362-3.818v6.925a.75.75 0 1 1-1.5 0v-6.925l-6.364 3.818a.749.749 0 1 1-.771-1.286L10.542 12 4.115 8.143a.75.75 0 1 1 .771-1.286l6.364 3.818V3.75a.75.75 0 1 1 1.5 0v6.925l6.364-3.818a.75.75 0 1 1 .771 1.286L13.458 12l6.427 3.857a.749.749 0 0 1 .258 1.03Z"
    }),
    at: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2.25a9.75 9.75 0 0 0 0 19.5c2.017 0 4.134-.608 5.665-1.625a.748.748 0 0 0 .003-1.247.751.751 0 0 0-.833-.002c-1.273.847-3.128 1.374-4.835 1.374A8.25 8.25 0 1 1 20.25 12c0 2.48-1.02 3-1.875 3s-1.875-.52-1.875-3V8.25a.75.75 0 0 0-1.5 0v.4a4.5 4.5 0 1 0 .556 6.102c.562 1.125 1.533 1.748 2.819 1.748 2.113 0 3.375-1.682 3.375-4.5A9.76 9.76 0 0 0 12 2.25ZM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
    }),
    arrowUp: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M10.295 20.485V7.345l-6.07 6.07-1.42-1.42 8.49-8.48 8.49 8.48-1.42 1.42-6.07-6.07v13.14h-2Z"
    }),
    arrowRight: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M2.811 13h13.14l-6.07 6.07 1.42 1.42 8.48-8.49-8.48-8.49-1.42 1.42 6.07 6.07H2.811v2Z"
    }),
    arrowDown: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M10.295 3.515v13.14l-6.07-6.07-1.42 1.42 8.49 8.48 8.49-8.48-1.42-1.42-6.07 6.07V3.515h-2Z"
    }),
    arrowLeft: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M19.78 13H6.64l6.07 6.07-1.42 1.42L2.81 12l8.48-8.49 1.42 1.42L6.64 11h13.14v2Z"
    }),
    calendar: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M19.5 3h-2.25v-.75a.75.75 0 1 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3ZM6.75 4.5v.75a.75.75 0 0 0 1.5 0V4.5h7.5v.75a.75.75 0 1 0 1.5 0V4.5h2.25v3h-15v-3h2.25Zm12.75 15h-15V9h15v10.5Z"
    }),
    calendarFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M19.5 3h-2.25v-.75a.75.75 0 1 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Zm0 4.5h-15v-3h2.25v.75a.75.75 0 0 0 1.5 0V4.5h7.5v.75a.75.75 0 1 0 1.5 0V4.5h2.25v3Z"
    }),
    check: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M9.457 14.293 6.164 11 4.75 12.414l4.707 4.707 9.707-9.707L17.75 6l-8.293 8.293Z"
    }),
    checkBadge: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21.174 9.64c-.353-.37-.719-.75-.857-1.085-.127-.307-.134-.815-.142-1.307-.014-.915-.03-1.952-.75-2.673-.72-.72-1.758-.736-2.673-.75-.492-.008-1-.015-1.307-.143-.333-.137-.715-.503-1.084-.856C13.714 2.204 12.979 1.5 12 1.5c-.979 0-1.713.704-2.36 1.326-.37.353-.75.719-1.085.857-.305.127-.815.135-1.307.142-.915.014-1.952.03-2.673.75-.72.72-.731 1.758-.75 2.673-.008.492-.015 1-.143 1.307-.137.333-.503.715-.856 1.084C2.204 10.286 1.5 11.021 1.5 12c0 .979.704 1.713 1.326 2.36.353.37.719.75.857 1.085.127.307.135.815.142 1.307.014.915.03 1.952.75 2.673.72.72 1.758.736 2.673.75.492.008 1 .015 1.307.142.333.138.715.504 1.084.857.647.622 1.382 1.326 2.361 1.326.979 0 1.713-.704 2.36-1.326.37-.353.75-.719 1.085-.857.307-.127.815-.134 1.307-.142.915-.014 1.952-.03 2.673-.75.72-.72.736-1.758.75-2.673.008-.492.015-1 .142-1.307.138-.333.504-.715.857-1.084.622-.647 1.326-1.382 1.326-2.361 0-.979-.704-1.713-1.326-2.36Zm-1.082 3.683c-.45.469-.915.953-1.161 1.549-.236.571-.247 1.225-.256 1.858-.01.656-.02 1.343-.311 1.634-.292.29-.974.302-1.634.311-.633.01-1.287.02-1.858.256-.596.246-1.08.711-1.55 1.16-.468.45-.947.909-1.322.909-.375 0-.858-.461-1.323-.908-.465-.448-.953-.915-1.549-1.161-.571-.236-1.225-.247-1.858-.256-.656-.01-1.343-.02-1.634-.311-.29-.292-.302-.974-.311-1.634-.01-.633-.02-1.287-.256-1.858-.247-.596-.712-1.08-1.16-1.55C3.458 12.855 3 12.376 3 12c0-.375.461-.858.908-1.323.448-.465.914-.953 1.161-1.549.236-.571.247-1.225.256-1.858.01-.656.02-1.343.311-1.634.292-.29.974-.302 1.634-.311.633-.01 1.287-.02 1.858-.256.596-.247 1.08-.712 1.55-1.16C11.145 3.458 11.624 3 12 3c.375 0 .858.461 1.323.908.465.448.953.914 1.549 1.161.571.236 1.225.247 1.858.256.656.01 1.343.02 1.634.311.29.292.302.974.311 1.634.01.633.02 1.287.256 1.858.246.596.711 1.08 1.16 1.55.45.468.909.947.909 1.322 0 .375-.461.858-.908 1.323ZM16.28 9.219a.748.748 0 0 1 0 1.062l-5.25 5.25a.747.747 0 0 1-1.062 0l-2.25-2.25a.75.75 0 1 1 1.062-1.062l1.719 1.72 4.72-4.72a.749.749 0 0 1 1.06 0Z"
    }),
    checkBadgeFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21.174 9.64c-.353-.37-.719-.75-.857-1.085-.127-.307-.134-.815-.142-1.307-.014-.915-.03-1.952-.75-2.673-.72-.72-1.758-.736-2.673-.75-.492-.008-1-.015-1.307-.143-.333-.137-.715-.503-1.084-.856C13.714 2.204 12.979 1.5 12 1.5c-.979 0-1.713.704-2.36 1.326-.37.353-.75.719-1.085.857-.305.127-.815.135-1.307.142-.915.014-1.952.03-2.673.75-.72.72-.731 1.758-.75 2.673-.008.492-.015 1-.143 1.307-.137.333-.503.715-.856 1.084C2.204 10.286 1.5 11.021 1.5 12c0 .979.704 1.713 1.326 2.36.353.37.719.75.857 1.085.127.307.135.815.142 1.307.014.915.03 1.952.75 2.673.72.72 1.758.736 2.673.75.492.008 1 .015 1.307.142.333.138.715.504 1.084.857.647.622 1.382 1.326 2.361 1.326.979 0 1.713-.704 2.36-1.326.37-.353.75-.719 1.085-.857.307-.127.815-.134 1.307-.142.915-.014 1.952-.03 2.673-.75.72-.72.736-1.758.75-2.673.008-.492.015-1 .142-1.307.138-.333.504-.715.857-1.084.622-.647 1.326-1.382 1.326-2.361 0-.979-.704-1.713-1.326-2.36Zm-4.893.64-5.25 5.25a.747.747 0 0 1-1.062 0l-2.25-2.25a.75.75 0 1 1 1.062-1.06l1.719 1.72 4.72-4.72a.751.751 0 0 1 1.06 1.06Z"
    }),
    checkSquareOffset: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-6.75a.75.75 0 0 1 0-1.5h6.75v-15h-15v9a.75.75 0 1 1-1.5 0v-9A1.5 1.5 0 0 1 4.5 3h15A1.5 1.5 0 0 1 21 4.5Zm-9.22 9.97a.749.749 0 0 0-1.06 0L6 19.19l-1.72-1.72a.75.75 0 1 0-1.06 1.06l2.25 2.25a.748.748 0 0 0 1.06 0l5.25-5.25a.748.748 0 0 0 0-1.06Z"
    }),
    chevronUp: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 15.586 4.414 17l7.293-7.293L19 17l1.414-1.414-8.707-8.707L3 15.586Z",
        clipRule: "evenodd"
    }),
    chevronRight: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.414 3.3 8 4.714l7.293 7.293L8 19.3l1.414 1.414 8.707-8.707L9.414 3.3Z",
        clipRule: "evenodd"
    }),
    chevronDown: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.3 9.014 4.714 7.6l7.293 7.293L19.3 7.6l1.414 1.414-8.707 8.707L3.3 9.014Z",
        clipRule: "evenodd"
    }),
    chevronLeft: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.586 3.3 16 4.714l-7.293 7.293L16 19.3l-1.414 1.414-8.707-8.707L14.586 3.3Z",
        clipRule: "evenodd"
    }),
    close: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M19.28 18.22a.752.752 0 0 1-.53 1.28.75.75 0 0 1-.53-.22L12 13.06l-6.22 6.22a.75.75 0 1 1-1.06-1.06L10.94 12 4.72 5.78a.75.75 0 0 1 1.06-1.06L12 10.94l6.22-6.22a.75.75 0 1 1 1.06 1.06L13.06 12l6.22 6.22Z"
    }),
    creditCard: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21 4.5H3A1.5 1.5 0 0 0 1.5 6v12A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 21 4.5ZM21 6v2.25H3V6h18Zm0 12H3V9.75h18V18Zm-1.5-2.25a.75.75 0 0 1-.75.75h-3a.75.75 0 1 1 0-1.5h3a.75.75 0 0 1 .75.75Zm-6 0a.75.75 0 0 1-.75.75h-1.5a.75.75 0 1 1 0-1.5h1.5a.75.75 0 0 1 .75.75Z"
    }),
    data: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2.25c-5.047 0-9 2.306-9 5.25v9c0 2.944 3.953 5.25 9 5.25 5.047 0 9-2.306 9-5.25v-9c0-2.944-3.953-5.25-9-5.25ZM19.5 12c0 .902-.739 1.822-2.026 2.524-1.45.79-3.394 1.226-5.474 1.226s-4.025-.436-5.474-1.226C5.239 13.822 4.5 12.902 4.5 12v-1.56c1.6 1.406 4.334 2.31 7.5 2.31 3.166 0 5.9-.908 7.5-2.31V12ZM6.526 4.976C7.976 4.186 9.92 3.75 12 3.75s4.025.436 5.474 1.226C18.761 5.678 19.5 6.598 19.5 7.5c0 .902-.739 1.822-2.026 2.524-1.45.79-3.394 1.226-5.474 1.226s-4.025-.436-5.474-1.226C5.239 9.322 4.5 8.402 4.5 7.5c0-.902.739-1.822 2.026-2.524Zm10.948 14.048c-1.45.79-3.394 1.226-5.474 1.226s-4.025-.436-5.474-1.226C5.239 18.322 4.5 17.402 4.5 16.5v-1.56c1.6 1.406 4.334 2.31 7.5 2.31 3.166 0 5.9-.907 7.5-2.31v1.56c0 .902-.739 1.822-2.026 2.524Z"
    }),
    dataFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2.25c-5.047 0-9 2.306-9 5.25v9c0 2.944 3.953 5.25 9 5.25 5.047 0 9-2.306 9-5.25v-9c0-2.944-3.953-5.25-9-5.25ZM19.5 12c0 .902-.739 1.822-2.026 2.524-1.45.79-3.394 1.226-5.474 1.226s-4.025-.436-5.474-1.226C5.239 13.822 4.5 12.902 4.5 12v-1.56c1.6 1.406 4.334 2.31 7.5 2.31 3.166 0 5.9-.908 7.5-2.31V12Zm-2.026 7.024c-1.45.79-3.394 1.226-5.474 1.226s-4.025-.436-5.474-1.226C5.239 18.322 4.5 17.402 4.5 16.5v-1.56c1.6 1.406 4.334 2.31 7.5 2.31 3.166 0 5.9-.907 7.5-2.31v1.56c0 .902-.739 1.822-2.026 2.524Z"
    }),
    desktop: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21 6.938h-1.688V6a2.062 2.062 0 0 0-2.062-2.063H3.75A2.063 2.063 0 0 0 1.687 6v9a2.063 2.063 0 0 0 2.063 2.063h10.688V18a2.062 2.062 0 0 0 2.062 2.063H21A2.062 2.062 0 0 0 23.063 18V9A2.062 2.062 0 0 0 21 6.937Zm-17.25 9A.938.938 0 0 1 2.812 15V6a.937.937 0 0 1 .938-.938h13.5a.937.937 0 0 1 .938.938v.938H16.5A2.063 2.063 0 0 0 14.437 9v6.938H3.75ZM21.938 18a.938.938 0 0 1-.938.938h-4.5a.938.938 0 0 1-.938-.938V9a.938.938 0 0 1 .938-.938H21a.937.937 0 0 1 .938.938v9Zm-9.375 1.5a.562.562 0 0 1-.563.563H8.25a.563.563 0 0 1 0-1.125H12a.562.562 0 0 1 .563.562Zm7.5-9a.562.562 0 0 1-.563.563H18a.562.562 0 1 1 0-1.126h1.5a.562.562 0 0 1 .563.563Z"
    }),
    device: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M7.5 22.5h9a2.25 2.25 0 0 0 2.25-2.25V3.75A2.25 2.25 0 0 0 16.5 1.5h-9a2.25 2.25 0 0 0-2.25 2.25v16.5A2.25 2.25 0 0 0 7.5 22.5ZM6.75 3.75A.75.75 0 0 1 7.5 3h9a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1-.75-.75V3.75Zm4.125 14.625a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z"
    }),
    deviceFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M7.5 22.5h9a2.25 2.25 0 0 0 2.25-2.25V3.75A2.25 2.25 0 0 0 16.5 1.5h-9a2.25 2.25 0 0 0-2.25 2.25v16.5A2.25 2.25 0 0 0 7.5 22.5Zm4.5-5.25a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Z"
    }),
    delivery: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m20.97 6.202-8.25-4.514a1.489 1.489 0 0 0-1.44 0L3.03 6.202a1.5 1.5 0 0 0-.78 1.313v8.966a1.5 1.5 0 0 0 .78 1.313l8.25 4.516a1.489 1.489 0 0 0 1.44 0l8.25-4.516a1.5 1.5 0 0 0 .78-1.313V7.517a1.5 1.5 0 0 0-.78-1.315ZM12 3l7.532 4.125-2.791 1.528-7.533-4.125L12 3Zm0 8.25L4.468 7.125l3.178-1.74 7.532 4.125L12 11.25ZM3.75 8.437l7.5 4.105v8.043l-7.5-4.102V8.437Zm16.5 8.042-7.5 4.106v-8.04l3-1.64v3.345a.75.75 0 1 0 1.5 0v-4.167l3-1.646v8.042Z"
    }),
    deliveryFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m20.97 6.202-8.25-4.514a1.489 1.489 0 0 0-1.44 0L3.03 6.202a1.5 1.5 0 0 0-.78 1.313v8.966a1.5 1.5 0 0 0 .78 1.313l8.25 4.516a1.489 1.489 0 0 0 1.44 0l8.25-4.516a1.5 1.5 0 0 0 .78-1.313V7.517a1.5 1.5 0 0 0-.78-1.315ZM12 3l7.533 4.125-2.792 1.527-7.533-4.125L12 3Zm0 8.25L4.467 7.125l3.18-1.74 7.532 4.124L12 11.25Zm8.25 5.236-7.5 4.105v-8.044l3-1.642v3.345a.75.75 0 1 0 1.5 0v-4.166l3-1.642V16.486Z"
    }),
    eraser: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m21.094 7.537-3.882-3.88a2.25 2.25 0 0 0-3.181 0L2.906 14.78a2.25 2.25 0 0 0 0 3.181l2.818 2.819a.75.75 0 0 0 .533.219H20.25a.75.75 0 1 0 0-1.5h-7.94l8.784-8.78a2.25 2.25 0 0 0 0-3.183ZM10.189 19.5H6.567l-2.599-2.599a.75.75 0 0 1 0-1.06L9 10.81l4.94 4.939-3.751 3.75Zm9.843-9.844L15 14.69l-4.94-4.94 5.034-5.03a.749.749 0 0 1 1.061 0l3.88 3.879a.75.75 0 0 1 0 1.06l-.003-.003Z"
    }),
    filter: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M18.75 12.25A.75.75 0 0 1 18 13H6a.75.75 0 1 1 0-1.5h12a.75.75 0 0 1 .75.75Zm3-5.25H2.25a.75.75 0 0 0 0 1.5h19.5a.75.75 0 1 0 0-1.5Zm-7.5 9h-4.5a.75.75 0 1 0 0 1.5h4.5a.75.75 0 1 0 0-1.5Z"
    }),
    globe: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25ZM20.25 12a8.214 8.214 0 0 1-.6 3.088l-4.19-2.577a1.494 1.494 0 0 0-.586-.21l-2.139-.288a1.51 1.51 0 0 0-1.5.737h-.817l-.357-.737A1.492 1.492 0 0 0 9.03 11.2l-.75-.162.733-1.288h1.567c.253 0 .502-.065.724-.188l1.149-.633c.1-.056.195-.124.281-.2l2.523-2.283a1.494 1.494 0 0 0 .306-1.843l-.034-.06A8.26 8.26 0 0 1 20.25 12Zm-6.815-8.124.815 1.458-2.523 2.282-1.147.634H9.013A1.5 1.5 0 0 0 7.712 9l-.819 1.428-.951-2.535 1.026-2.425a8.238 8.238 0 0 1 6.468-1.594v.002ZM3.75 12a8.206 8.206 0 0 1 .8-3.544l1.064 2.838a1.5 1.5 0 0 0 1.09.938l2.008.432.357.742a1.508 1.508 0 0 0 1.35.844h.14l-.679 1.522a1.5 1.5 0 0 0 .268 1.628l.014.013L12 19.307l-.182.937A8.26 8.26 0 0 1 3.75 12Zm9.617 8.136.106-.545a1.507 1.507 0 0 0-.388-1.316l-1.835-1.893 1.284-2.882 2.14.289 4.286 2.636a8.268 8.268 0 0 1-5.593 3.71Z"
    }),
    globeFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25ZM20.25 12a8.214 8.214 0 0 1-.6 3.088l-4.19-2.577a1.494 1.494 0 0 0-.586-.21l-2.139-.288a1.51 1.51 0 0 0-1.5.737h-.817l-.357-.737A1.492 1.492 0 0 0 9.03 11.2l-.75-.162.733-1.288h1.567c.253 0 .502-.065.724-.188l1.149-.633c.1-.056.195-.124.281-.2l2.523-2.283a1.494 1.494 0 0 0 .306-1.843l-.034-.06A8.26 8.26 0 0 1 20.25 12Zm-16.5 0a8.206 8.206 0 0 1 .8-3.544l1.064 2.838a1.5 1.5 0 0 0 1.09.938l2.008.432.357.742a1.508 1.508 0 0 0 1.35.844h.14l-.679 1.522a1.5 1.5 0 0 0 .268 1.628l.014.013L12 19.307l-.182.937A8.26 8.26 0 0 1 3.75 12Z"
    }),
    handCoins: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M22.343 13.974a2.29 2.29 0 0 0-1.99-.396l-3.923.902a2.625 2.625 0 0 0-2.555-3.23H9.182a2.982 2.982 0 0 0-2.122.878L4.94 14.25H2.25a1.5 1.5 0 0 0-1.5 1.5v3.75a1.5 1.5 0 0 0 1.5 1.5H12a.744.744 0 0 0 .182-.023l6-1.5a.653.653 0 0 0 .111-.037l3.645-1.55.04-.02a2.306 2.306 0 0 0 .37-3.896h-.005ZM2.25 15.75H4.5v3.75H2.25v-3.75Zm19.072.77-3.563 1.517-5.853 1.463H6v-4.19l2.122-2.12a1.487 1.487 0 0 1 1.06-.44h4.693a1.125 1.125 0 1 1 0 2.25H11.25a.75.75 0 1 0 0 1.5h3a.782.782 0 0 0 .168-.019l6.281-1.444.03-.008a.806.806 0 0 1 .59 1.49h.003Zm-5.197-6.77c.185 0 .37-.015.553-.045a3.376 3.376 0 1 0 2.646-4.406 3.375 3.375 0 1 0-3.199 4.451Zm5.625-1.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0ZM16.125 4.5a1.875 1.875 0 0 1 1.805 1.37 3.376 3.376 0 0 0-1.407 2.337 1.875 1.875 0 1 1-.398-3.707Z"
    }),
    menu: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.8 14h-16v2h16v-2Zm0-6h-16v2h16V8Z",
        clipRule: "evenodd"
    }),
    more: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M13.125 12a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm5.25-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm-12.75 0a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z"
    }),
    navigationArrow: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21.5 9.207 5.007 3.094l-.015-.005A1.5 1.5 0 0 0 3.09 5.007L9.207 21.5a1.478 1.478 0 0 0 1.413 1h.028a1.478 1.478 0 0 0 1.406-1.058l2.21-7.178 7.177-2.209a1.5 1.5 0 0 0 .058-2.848Zm-.5 1.415-7.178 2.209a1.5 1.5 0 0 0-.991.992L10.62 21l-.005-.016L4.5 4.5l16.483 6.114.015.006.002.002Z"
    }),
    placeholder: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.485 5.515h-8.97a2 2 0 0 0-2 2v8.97a2 2 0 0 0 2 2h8.97a2 2 0 0 0 2-2v-8.97a2 2 0 0 0-2-2Zm-8.97-2a4 4 0 0 0-4 4v8.97a4 4 0 0 0 4 4h8.97a4 4 0 0 0 4-4v-8.97a4 4 0 0 0-4-4h-8.97Z",
        clipRule: "evenodd"
    }),
    plus: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12.75 21.546a.75.75 0 1 1-1.5 0V12.75H2.454a.75.75 0 0 1 0-1.5h8.796V2.454a.75.75 0 1 1 1.5 0v8.796h8.796a.75.75 0 1 1 0 1.5H12.75v8.796Z"
    }),
    piggybank: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M18 10.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0ZM14.25 6H10.5a.75.75 0 1 0 0 1.5h3.75a.75.75 0 1 0 0-1.5Zm9 4.5v3A2.25 2.25 0 0 1 21 15.75h-.221l-1.52 4.254a1.5 1.5 0 0 1-1.413.996h-1.192a1.5 1.5 0 0 1-1.413-.996l-.18-.504H9.689l-.18.504A1.5 1.5 0 0 1 8.096 21H6.904a1.5 1.5 0 0 1-1.413-.996l-1.178-3.296a8.22 8.22 0 0 1-2.01-4.535A1.5 1.5 0 0 0 1.5 13.5a.75.75 0 1 1-1.5 0 3 3 0 0 1 2.276-2.906A8.261 8.261 0 0 1 10.5 3h9.75a.75.75 0 1 1 0 1.5h-2.005a8.243 8.243 0 0 1 2.945 3.75 2.25 2.25 0 0 1 2.06 2.25Zm-1.5 0a.75.75 0 0 0-.75-.75h-.343a.75.75 0 0 1-.716-.525A6.74 6.74 0 0 0 13.5 4.5h-3a6.75 6.75 0 0 0-4.977 11.31.75.75 0 0 1 .154.254L6.904 19.5h1.192l.358-1.002A.75.75 0 0 1 9.16 18h6.43a.75.75 0 0 1 .706.498l.358 1.002h1.192l1.698-4.752a.75.75 0 0 1 .706-.498H21a.75.75 0 0 0 .75-.75v-3Z"
    }),
    pin: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 6a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 6Zm0 6a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5Zm0-10.5a8.26 8.26 0 0 0-8.25 8.25c0 2.944 1.36 6.064 3.938 9.023a23.837 23.837 0 0 0 3.885 3.591.75.75 0 0 0 .861 0 23.835 23.835 0 0 0 3.879-3.59c2.573-2.96 3.937-6.08 3.937-9.024A8.26 8.26 0 0 0 12 1.5Zm0 19.313c-1.55-1.22-6.75-5.696-6.75-11.063a6.75 6.75 0 0 1 13.5 0c0 5.365-5.2 9.844-6.75 11.063Z"
    }),
    receipt: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M6.75 9.75A.75.75 0 0 1 7.5 9h9a.75.75 0 1 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 3.75h9a.75.75 0 1 0 0-1.5h-9a.75.75 0 1 0 0 1.5Zm14.25-8.25V19.5a.75.75 0 0 1-1.086.67L18 18.838l-2.664 1.332a.75.75 0 0 1-.672 0L12 18.838 9.336 20.17a.75.75 0 0 1-.672 0L6 18.838 3.336 20.17a.75.75 0 0 1-1.086-.67V5.25a1.5 1.5 0 0 1 1.5-1.5h16.5a1.5 1.5 0 0 1 1.5 1.5Zm-1.5 0H3.75v13.037l1.914-.958a.75.75 0 0 1 .672 0L9 18.662l2.664-1.333a.75.75 0 0 1 .672 0L15 18.662l2.664-1.333a.75.75 0 0 1 .672 0l1.914.958V5.25Z"
    }),
    shield: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M7.553 10.219a.75.75 0 0 1 .978-.416l2.719 1.089V8.25a.75.75 0 1 1 1.5 0v2.642l2.719-1.089a.75.75 0 1 1 .562 1.394l-2.841 1.136 1.66 2.217a.75.75 0 0 1-1.2.9L12 13.25l-1.65 2.2a.75.75 0 1 1-1.2-.9l1.663-2.217-2.844-1.136a.75.75 0 0 1-.416-.978ZM21 4.5v5.51c0 8.402-7.108 11.188-8.531 11.661a1.446 1.446 0 0 1-.938 0C10.106 21.203 3 18.413 3 10.011V4.5A1.5 1.5 0 0 1 4.5 3h15A1.5 1.5 0 0 1 21 4.5Zm-1.5 0h-15v5.512c0 7.359 6.232 9.813 7.5 10.235 1.28-.427 7.5-2.884 7.5-10.235V4.5Z"
    }),
    shuffle: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M22.28 16.72a.747.747 0 0 1 0 1.06l-2.25 2.25a.75.75 0 0 1-1.06-1.06l.97-.97h-1.102a6.762 6.762 0 0 1-5.493-2.827l-3.91-5.475A5.26 5.26 0 0 0 5.161 7.5H3A.75.75 0 0 1 3 6h2.162a6.761 6.761 0 0 1 5.493 2.827l3.91 5.475a5.26 5.26 0 0 0 4.273 2.198h1.102l-.97-.97a.75.75 0 1 1 1.06-1.06l2.25 2.25Zm-8.874-6.689a.75.75 0 0 0 1.046-.174l.113-.157a5.26 5.26 0 0 1 4.273-2.2h1.102l-.97.97a.75.75 0 1 0 1.06 1.06l2.25-2.25a.748.748 0 0 0 0-1.06l-2.25-2.25a.75.75 0 1 0-1.06 1.06l.97.97h-1.102a6.762 6.762 0 0 0-5.493 2.827l-.112.156a.749.749 0 0 0 .173 1.048Zm-2.812 3.938a.75.75 0 0 0-1.046.174l-.113.157a5.259 5.259 0 0 1-4.273 2.2H3A.75.75 0 1 0 3 18h2.162a6.762 6.762 0 0 0 5.493-2.827l.112-.156a.75.75 0 0 0-.173-1.048Z"
    }),
    simCard: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M7.72 3.97 2.47 9.22a.75.75 0 0 0-.22.53v9a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5h-12a.75.75 0 0 0-.53.22Zm12.53 1.28v13.5H3.75v-8.69l4.81-4.81h11.69ZM10.5 7.5v9a.75.75 0 0 0 .75.75H18a.75.75 0 0 0 .75-.75v-9a.75.75 0 0 0-.75-.75h-6.75a.75.75 0 0 0-.75.75Zm6.75.75v1.5h-3a.75.75 0 1 0 0 1.5h3v1.5h-3a.75.75 0 1 0 0 1.5h3v1.5H12v-7.5h5.25Z"
    }),
    star: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M22.423 9.118a1.536 1.536 0 0 0-1.337-1.056l-5.53-.446-2.137-5.164a1.533 1.533 0 0 0-2.837 0L8.448 7.615l-5.534.447a1.543 1.543 0 0 0-.879 2.706l4.22 3.64-1.286 5.444a1.536 1.536 0 0 0 2.297 1.67L12 18.608l4.737 2.914a1.537 1.537 0 0 0 2.294-1.67l-1.29-5.444 4.22-3.64a1.541 1.541 0 0 0 .462-1.65Zm-1.438.513-4.566 3.937a.751.751 0 0 0-.24.742l1.395 5.888a.035.035 0 0 1-.016.044c-.016.014-.021.01-.035 0l-5.13-3.154a.75.75 0 0 0-.786 0l-5.13 3.156c-.014.009-.018.012-.035 0a.035.035 0 0 1-.016-.045l1.395-5.887a.75.75 0 0 0-.24-.742L3.015 9.633c-.011-.01-.022-.018-.012-.047.01-.03.017-.025.03-.027l5.993-.484a.75.75 0 0 0 .63-.463l2.308-5.589c.008-.016.01-.023.033-.023s.026.007.033.023l2.314 5.589a.75.75 0 0 0 .633.461l5.992.484c.014 0 .023 0 .031.027.009.027 0 .038-.015.047Z"
    }),
    starFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m21.984 10.723-4.228 3.69 1.267 5.494a1.5 1.5 0 0 1-2.235 1.625l-4.792-2.906-4.78 2.906a1.5 1.5 0 0 1-2.236-1.625l1.265-5.488-4.23-3.696a1.5 1.5 0 0 1 .855-2.63l5.574-.483 2.176-5.19a1.495 1.495 0 0 1 2.76 0l2.183 5.19 5.572.482a1.5 1.5 0 0 1 .854 2.631h-.005Z"
    }),
    tablet: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M18 2.438H6A2.063 2.063 0 0 0 3.937 4.5v15A2.063 2.063 0 0 0 6 21.563h12a2.062 2.062 0 0 0 2.063-2.063v-15A2.062 2.062 0 0 0 18 2.437ZM5.062 6.561h13.875v10.875H5.063V6.563Zm.938-3h12a.937.937 0 0 1 .938.938v.938H5.063V4.5A.937.937 0 0 1 6 3.562Zm12 16.875H6a.938.938 0 0 1-.938-.937v-.938h13.875v.938a.938.938 0 0 1-.937.938Z"
    }),
    truck: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m23.196 10.969-1.313-3.281a1.493 1.493 0 0 0-1.391-.938H17.25V6a.75.75 0 0 0-.75-.75H2.25a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h1.594a3 3 0 0 0 5.812 0h4.688a3 3 0 0 0 5.812 0h1.594a1.5 1.5 0 0 0 1.5-1.5v-6a.742.742 0 0 0-.054-.281ZM17.25 8.25h3.242l.9 2.25H17.25V8.25Zm-15-1.5h13.5v6H2.25v-6Zm4.5 12.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm7.594-2.25H9.656a3 3 0 0 0-5.812 0H2.25v-3h13.5v1.154a3.008 3.008 0 0 0-1.406 1.846Zm2.906 2.25a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4.5-2.25h-1.594A3.007 3.007 0 0 0 17.25 15v-3h4.5v5.25Z"
    }),
    trustpilot: (0, $4vwom.jsx)("path", {
        fill: $756948b644e82cf2$var$colors._trustpilot,
        d: "m11.566 17.252 4.591-1.164L18.076 22l-6.51-4.748ZM22.132 9.61H14.05L11.566 2 9.082 9.61H1l6.54 4.717-2.483 7.61 6.54-4.717 4.026-2.893 6.51-4.717Z"
    }),
    vipps: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12.656 16.282c2.97 0 4.656-1.445 6.262-3.532.883-1.124 2.007-1.365 2.81-.723.802.643.882 1.847 0 2.97-2.329 3.051-5.299 4.898-9.072 4.898-4.094 0-7.706-2.248-10.195-6.182-.722-1.043-.562-2.167.241-2.729.803-.562 2.007-.321 2.73.803 1.766 2.649 4.174 4.495 7.224 4.495Zm5.54-9.874c0 1.445-1.125 2.409-2.409 2.409-1.284 0-2.408-.964-2.408-2.409C13.379 4.963 14.503 4 15.787 4c1.284 0 2.408 1.044 2.408 2.408Z"
    }),
    warning: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2a9.75 9.75 0 1 0 9.75 9.75A9.76 9.76 0 0 0 12 2Zm-.75 5.25a.75.75 0 1 1 1.5 0v5.25a.75.75 0 1 1-1.5 0V7.25ZM12 17a1.125 1.125 0 1 1 0-2.25A1.125 1.125 0 0 1 12 17Z"
    }),
    watch: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M19.312 12a7.306 7.306 0 0 0-3.05-5.935l-.597-3.3a1.312 1.312 0 0 0-1.291-1.078H9.626a1.313 1.313 0 0 0-1.292 1.079l-.597 3.299a7.3 7.3 0 0 0 0 11.87l.597 3.3a1.313 1.313 0 0 0 1.292 1.078h4.748a1.313 1.313 0 0 0 1.291-1.079l.598-3.299A7.306 7.306 0 0 0 19.313 12Zm-9.87-9.034a.187.187 0 0 1 .187-.154h4.748a.187.187 0 0 1 .187.154l.428 2.362a7.283 7.283 0 0 0-5.972 0l.421-2.362Zm5.116 18.068a.188.188 0 0 1-.187.154H9.626a.187.187 0 0 1-.187-.154l-.428-2.362a7.283 7.283 0 0 0 5.972 0l-.425 2.362ZM12 18.188A6.187 6.187 0 1 1 18.187 12 6.195 6.195 0 0 1 12 18.188Z"
    }),
    wave: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m20.64 9.375-1.622-2.813a2.625 2.625 0 0 0-3.585-.96 2.596 2.596 0 0 0-.844.781l-1.633-2.82a2.625 2.625 0 0 0-4.545 0 2.625 2.625 0 0 0-3.897 3.374l.15.26a2.625 2.625 0 0 0-2.06 3.928l3.748 6.498a8.2 8.2 0 0 0 5.01 3.844 8.25 8.25 0 0 0 9.28-12.094v.002Zm-.623 5.873a6.75 6.75 0 0 1-12.365 1.627l-3.75-6.499A1.125 1.125 0 0 1 5.85 9.251l1.803 3.124a.75.75 0 1 0 1.298-.75L5.812 6.187a1.125 1.125 0 1 1 1.949-1.125l2.926 5.063a.751.751 0 1 0 1.299-.75L9.71 5.437a1.125 1.125 0 1 1 1.948-1.125l3.133 5.429a4.5 4.5 0 0 0-.52 5.68.75.75 0 1 0 1.242-.843 3 3 0 0 1 .685-4.078.75.75 0 0 0 .2-.975l-.627-1.088a1.126 1.126 0 0 1 1.264-1.676 1.125 1.125 0 0 1 .684.551l1.622 2.813a6.707 6.707 0 0 1 .675 5.12v.003ZM17.273 2.973a.75.75 0 0 1 .914-.536 5.59 5.59 0 0 1 3.425 2.625l.031.054a.75.75 0 1 1-1.298.75l-.031-.054A4.094 4.094 0 0 0 17.8 3.891a.75.75 0 0 1-.528-.918Zm-9.69 19.246a.75.75 0 0 1-1.052.124 11.209 11.209 0 0 1-2.775-3.218.75.75 0 1 1 1.299-.75 9.72 9.72 0 0 0 2.404 2.786.75.75 0 0 1 .124 1.058Z"
    })
};
const $756948b644e82cf2$var$borderRadiuses = {
    xs: {
        xs: 6
    },
    sm: {
        xs: 12
    },
    md: {
        xs: 16,
        md: 24
    },
    lg: {
        xs: 24,
        md: 32
    }
};
const $756948b644e82cf2$var$spacingSizes = {
    xs: {
        xs: 4,
        sm: 12,
        md: 18,
        lg: 24
    },
    sm: {
        xs: 16,
        lg: 22
    },
    md: {
        xs: 16,
        sm: 22,
        md: 24,
        lg: 24,
        xl: 24
    },
    lg: {
        xs: 24,
        sm: 32,
        md: 56,
        lg: 60,
        xl: 64
    },
    xl: {
        xs: 40,
        sm: 56,
        md: 72,
        lg: 80,
        xl: 96
    }
};
const $756948b644e82cf2$var$headingLevels = {
    "1": {
        xs: {
            fontSize: 28 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 500,
            lineHeight: "100%",
            letterSpacing: -0.6
        },
        md: {
            fontSize: 40 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: -0.8
        },
        lg: {
            fontSize: 54 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: -0.8
        }
    },
    "2": {
        xs: {
            fontSize: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 400,
            lineHeight: "110%",
            letterSpacing: 0.24
        },
        md: {
            fontSize: 32 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: 0.3
        },
        lg: {
            fontSize: 40 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: 0.4
        }
    },
    "3": {
        xs: {
            fontSize: 18 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 400,
            lineHeight: "130%"
        },
        md: {
            fontSize: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        },
        lg: {
            fontSize: 28 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    },
    "4": {
        xs: {
            fontSize: 15,
            fontWeight: 600,
            lineHeight: "120%",
            letterSpacing: -0.15
        },
        md: {
            fontSize: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 500
        },
        lg: {
            fontSize: 18 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: -0.18
        }
    },
    "5": {
        xs: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "110%",
            letterSpacing: -0.14
        },
        md: {
            fontSize: 15 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        },
        lg: {
            fontSize: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: -0.18
        }
    }
};
const $756948b644e82cf2$var$buttonBase = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.30s",
    borderStyle: "solid",
    borderColor: "transparent",
    whiteSpace: "nowrap",
    borderRadius: "100vw",
    cursor: "pointer",
    gap: 8
};
const $756948b644e82cf2$var$disabledButton = {
    backgroundColor: $756948b644e82cf2$var$colors.gray100,
    color: $756948b644e82cf2$var$colors.gray300,
    cursor: "default"
};
const $756948b644e82cf2$var$buttonVariants = {
    primary: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.grayWhite,
        background: $756948b644e82cf2$var$colors.brand,
        "&:hover:not([disabled])": {
            color: $756948b644e82cf2$var$colors.grayWhite,
            backgroundColor: $756948b644e82cf2$var$colors.brandDark
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray500,
            backgroundColor: $756948b644e82cf2$var$colors.brandLight
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    secondary: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.gray500,
        backgroundColor: $756948b644e82cf2$var$colors.gray100,
        "&:hover:not([disabled])": {
            backgroundColor: $756948b644e82cf2$var$colors.gray200
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray500,
            borderWidth: 2,
            borderColor: $756948b644e82cf2$var$colors.gray500
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    dark: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.grayWhite,
        backgroundColor: $756948b644e82cf2$var$colors.gray500,
        "&:hover:not([disabled])": {
            color: $756948b644e82cf2$var$colors.grayWhite,
            backgroundColor: $756948b644e82cf2$var$colors.gray400
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray500,
            backgroundColor: $756948b644e82cf2$var$colors.gray200
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    light: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.gray500,
        backgroundColor: $756948b644e82cf2$var$colors.grayWhite,
        "&:hover:not([disabled])": {
            color: $756948b644e82cf2$var$colors.gray500,
            backgroundColor: $756948b644e82cf2$var$colors.gray100
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray500,
            backgroundColor: $756948b644e82cf2$var$colors.gray200
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    outlined: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.gray500,
        borderColor: $756948b644e82cf2$var$colors.gray200,
        "&:hover:not([disabled])": {
            borderColor: $756948b644e82cf2$var$colors.gray400
        },
        "&:focus": {
            borderColor: $756948b644e82cf2$var$colors.gray500
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    select: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.gray500,
        borderColor: $756948b644e82cf2$var$colors.gray200,
        "&[data-selected=false]": {
            borderWidth: 1
        },
        "&:hover:not([disabled])": {
            borderColor: $756948b644e82cf2$var$colors.brand
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray500,
            backgroundColor: $756948b644e82cf2$var$colors.gray200
        },
        "&[data-selected=true]": {
            borderWidth: 2,
            borderColor: $756948b644e82cf2$var$colors.brand,
            backgroundColor: $756948b644e82cf2$var$colors.brandLight
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    option: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.gray400,
        borderColor: $756948b644e82cf2$var$colors.gray200,
        background: $756948b644e82cf2$var$colors.grayWhite,
        paddingLeft: `${$756948b644e82cf2$export$981516ee4691055c(16)} !important`,
        paddingRight: `${$756948b644e82cf2$export$981516ee4691055c(16)} !important`,
        borderRadius: $756948b644e82cf2$export$981516ee4691055c(12),
        "&[data-selected=false]": {
            borderWidth: 1,
            fontWeight: 400
        },
        "&:hover:not([disabled])": {
            borderColor: $756948b644e82cf2$var$colors.brand
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray400,
            backgroundColor: $756948b644e82cf2$var$colors.gray100
        },
        "&[data-selected=true]": {
            borderColor: $756948b644e82cf2$var$colors.brand,
            backgroundColor: $756948b644e82cf2$var$colors.brandLight
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    profile: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.brand,
        backgroundColor: $756948b644e82cf2$var$colors.brandLight
    })
};
const $756948b644e82cf2$var$buttonSizes = {
    xs: {
        xs: {
            height: 36 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            padding: `0 ${12 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
        }
    },
    sm: {
        xs: {
            height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            padding: `0 ${24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
        }
    },
    md: {
        xs: {
            height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            padding: `0 ${24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
        },
        lg: {
            height: 64 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            padding: `0 ${32 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
        }
    }
};
const $756948b644e82cf2$var$bodySizes = {
    xs: {
        xs: {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "135%"
        },
        md: {
            fontSize: 15,
            fontWeight: 300
        }
    },
    sm: {
        xs: {
            fontSize: 15,
            fontWeight: 400,
            lineHeight: "135%"
        },
        md: {
            fontSize: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 300
        },
        xl: {
            fontSize: 17 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    },
    md: {
        xs: {
            fontSize: 16,
            fontWeight: 400,
            lineHeight: "135%"
        },
        md: {
            fontSize: 17 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 300
        },
        xl: {
            fontSize: 18 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    },
    lg: {
        xs: {
            fontSize: 17,
            fontWeight: 300,
            lineHeight: "135%"
        },
        md: {
            fontSize: 22 * (0, $1c2a8fb378443a1d$export$488117a5011aa9e)
        },
        xl: {
            fontSize: 22 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    },
    xl: {
        xs: {
            fontSize: 18,
            fontWeight: 300,
            lineHeight: "130%"
        },
        md: {
            fontSize: 21 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        },
        lg: {
            fontSize: 28 * (0, $1c2a8fb378443a1d$export$488117a5011aa9e)
        },
        xl: {
            fontSize: 28 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    }
};
const $756948b644e82cf2$var$textVariants = {
    body: $756948b644e82cf2$var$bodySizes,
    label: {
        md: {
            xs: {
                fontSize: 12,
                fontWeight: 500,
                letterSpacing: 0.96,
                textTransform: "uppercase",
                lineHeight: "115%"
            },
            md: {
                fontSize: 12
            },
            lg: {
                fontSize: 14,
                letterSpacing: 1.28
            },
            xl: {
                fontSize: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
            }
        }
    }
};
const $756948b644e82cf2$export$92c840cda8ec752c = (0, $dc53c17a4a911fba$export$25d302a5b900a763)({
    textVariants: $756948b644e82cf2$var$textVariants,
    screenSizes: $756948b644e82cf2$var$screenSizes,
    bodySizes: $756948b644e82cf2$var$bodySizes,
    borderRadiuses: $756948b644e82cf2$var$borderRadiuses,
    spacingSizes: $756948b644e82cf2$var$spacingSizes,
    headingLevels: $756948b644e82cf2$var$headingLevels,
    iconSizes: [
        16,
        24,
        32,
        40,
        48,
        64,
        96
    ],
    colors: $756948b644e82cf2$var$colors,
    icons: $756948b644e82cf2$var$icons,
    buttonVariants: $756948b644e82cf2$var$buttonVariants,
    buttonSizes: $756948b644e82cf2$var$buttonSizes
});
const $756948b644e82cf2$export$559a0f07c8df6570 = (0, $dc53c17a4a911fba$export$93d4e7f90805808f);
const $756948b644e82cf2$export$aa0e86c7c0d2f400 = (0, $lhaLc.css)({
    html: {
        boxSizing: "border-box"
    },
    "*, *:before, *:after": {
        boxSizing: "inherit",
        margin: 0,
        padding: 0,
        border: 0,
        verticalAlign: "baseline"
    },
    button: {
        background: "none",
        border: "none",
        font: "inherit",
        cursor: "pointer",
        outline: "inherit"
    },
    body: {
        fontFamily: "Catalogue, sans-serif",
        color: $756948b644e82cf2$export$92c840cda8ec752c.colors.gray500,
        fontSize: 18,
        "--scale-factor": (0, $1c2a8fb378443a1d$export$f988485815015380)
    },
    "p a": {
        textDecoration: "underline",
        textDecorationSkipInk: "none",
        textUnderlineOffset: "20%"
    },
    "p:last-child": {
        marginBottom: 0
    },
    strong: {
        fontWeight: 600
    },
    em: {
        fontStyle: "italic"
    },
    a: {
        textDecoration: "none",
        color: "inherit"
    },
    "td, th": {
        verticalAlign: "middle"
    }
}, $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "md", {
    body: {
        "--scale-factor": (0, $1c2a8fb378443a1d$export$330a64de1bbc7059)
    }
}), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "lg", {
    body: {
        "--scale-factor": (0, $1c2a8fb378443a1d$export$488117a5011aa9e)
    }
}), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "xl", {
    body: {
        "--scale-factor": (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
    }
}), (0, $e82ba787de72625c$export$2c2533fee2945415)({
    body: {
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        fontSmooth: "never"
    }
}));
function $756948b644e82cf2$export$981516ee4691055c(value) {
    return `calc(${typeof value === "number" ? `${value}px` : value} * var(--scale-factor))`;
}
function $756948b644e82cf2$export$65d8eafb3b383037() {
    return $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveVariantToCss((0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c));
}
function $756948b644e82cf2$export$629e292a677297c2() {
    return $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveVariantToCss((0, $1c2a8fb378443a1d$export$a9ddfd01863914a9));
}
function $756948b644e82cf2$export$27430441855376b9(prop, responsiveValues) {
    if (typeof responsiveValues === "string" || typeof responsiveValues === "number") return (0, $lhaLc.css)({
        [prop]: $756948b644e82cf2$export$981516ee4691055c(responsiveValues)
    });
    return (0, $lhaLc.css)(responsiveValues.map((rv)=>{
        if (typeof rv === "string" || typeof rv === "number") return {
            [prop]: rv
        };
        else if (rv) {
            const [limitType, screenSize, value] = rv;
            return $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss(limitType, screenSize, {
                [prop]: $756948b644e82cf2$export$981516ee4691055c(value)
            });
        }
    }));
}
function $756948b644e82cf2$export$88d2c1aa53be97d2(variableName) {
    // eslint-disable-next-line no-console
    if (!variableName.startsWith("--")) console.warn("CSS-variables should start with `--`.");
    return (0, $lhaLc.css)({
        [variableName]: "0px 2px 12px 0px rgba(21, 6, 36, 0.12)"
    }, $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "md", {
        [variableName]: "0px 3px 18px 0px rgba(21, 6, 36, 0.12)"
    }), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "lg", {
        [variableName]: "0px 4px 24px 0px rgba(21, 6, 36, 0.12)"
    }), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "xl", {
        [variableName]: "0px 4px 32px 0px rgba(21, 6, 36, 0.12)"
    }));
}
function $756948b644e82cf2$export$4c4a64d4bfa41e73() {
    return (0, $lhaLc.css)({
        boxShadow: "0px 2px 12px 0px rgba(21, 6, 36, 0.12)"
    }, $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "md", {
        boxShadow: "0px 3px 18px 0px rgba(21, 6, 36, 0.12)"
    }), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "lg", {
        boxShadow: "0px 4px 24px 0px rgba(21, 6, 36, 0.12)"
    }), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "xl", {
        boxShadow: "0px 4px 32px 0px rgba(21, 6, 36, 0.12)"
    }));
}
const $756948b644e82cf2$var$sectionSpacing = {
    xs: $756948b644e82cf2$export$981516ee4691055c(36),
    md: $756948b644e82cf2$export$981516ee4691055c(48)
};
function $756948b644e82cf2$export$f1cf1885b6bfef23() {
    return Object.entries($756948b644e82cf2$var$sectionSpacing).map(([screenSize, spacing])=>$756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", screenSize, {
            paddingTop: spacing,
            paddingBottom: spacing
        }));
}
const $756948b644e82cf2$export$682f474bed45e419 = (0, $lhaLc.css)({
    ".adyen-checkout-form-instruction": {
        display: "none",
        fontSize: 16,
        color: $756948b644e82cf2$var$colors.gray300
    },
    ".adyen-checkout-input__inline-validation": {
        height: 24,
        width: 24
    },
    ".adyen-checkout-input__inline-validation img": {
        display: "none"
    },
    ".adyen-checkout-input__inline-validation.adyen-checkout-input__inline-validation--valid:after": {
        display: "block",
        content: `url("data:image/svg+xml,${encodeURIComponent((0, (/*@__PURE__*/$parcel$interopDefault($5qU69))).renderToString((0, $4vwom.jsx)((0, $dc53c17a4a911fba$export$d8964aec282183a3), {
            theme: $756948b644e82cf2$export$92c840cda8ec752c,
            children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: "check",
                color: "forest"
            })
        })))}")`,
        width: 24,
        height: 24
    },
    ".adyen-checkout__payment-method": {
        backgroundColor: "#fff",
        padding: 0,
        border: 0
    },
    "li.adyen-checkout__payment-method": {
        marginBottom: 16
    },
    "li.adyen-checkout__payment-method:last-of-type": {
        marginBottom: 0
    },
    ".adyen-checkout__payment-method__header": {
        padding: 0,
        marginBottom: 16,
        display: "flex",
        justifyContent: "space-between"
    },
    "li.adyen-checkout__payment-method:last-of-type:not(.adyen-checkout__payment-method--selected) .adyen-checkout__payment-method__header": {
        marginBottom: 0
    },
    ".adyen-checkout__payment-method__details": {
        padding: 0
    },
    "button.adyen-checkout__payment-method__header__title": {
        display: "flex",
        padding: 0,
        alignItems: "stretch"
    },
    ".adyen-checkout__payment-method__name_wrapper": {
        display: "flex",
        alignItems: "stretch",
        justifyContent: "center"
    },
    ".adyen-checkout__payment-method__radio": {
        opacity: 0
    },
    ".adyen-checkout__payment-method__name": {
        lineHeight: "120%"
    },
    ".adyen-checkout__button.adyen-checkout__button--pay": (0, $lhaLc.css)({
        marginTop: 16
    }, // responsiveButtonCss("primary", "md"),
    {
        borderRadius: "100px"
    }),
    ".adyen-checkout__button__icon": {
        display: "none"
    },
    ".adyen-checkout__button__text": {
        lineHeight: "120%"
    },
    [[
        ".adyen-checkout__button:hover",
        ".adyen-checkout__button:focus",
        ".adyen-checkout__button:focus:hover"
    ].join(",")]: {
        boxShadow: "none"
    },
    ".adyen-checkout__payment-method__image__wrapper--outline:after": {
        display: "none"
    },
    ".adyen-checkout__input": {
        borderColor: $756948b644e82cf2$var$colors.gray200,
        borderWidth: 2,
        height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
        padding: `6px ${20 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        fontWeight: "300",
        WebkitFontSmoothing: "auto",
        MozOsxFontSmoothing: "auto",
        fontSmooth: "auto",
        fontSize: "16px"
    },
    "input.adyen-checkout__input::placeholder": {
        fontWeight: "300",
        color: $756948b644e82cf2$var$colors.gray300
    },
    ".adyen-checkout__input:hover": {
        borderColor: $756948b644e82cf2$var$colors.gray200,
        borderWidth: 2,
        boxShadow: "none"
    },
    ".adyen-checkout__input:focus, .adyen-checkout__input--focus": {
        borderColor: $756948b644e82cf2$var$colors.brand,
        borderStyle: "solid",
        borderWidth: 2,
        boxShadow: "none"
    },
    [[
        ".adyen-checkout__input:focus:hover",
        ".adyen-checkout__input:active",
        ".adyen-checkout__input:active:hover",
        ".adyen-checkout__input--focus:hover"
    ].join(",")]: {
        border: `2px solid ${$756948b644e82cf2$var$colors.brand}`,
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: $756948b644e82cf2$var$colors.brand,
        boxShadow: "none"
    },
    ".adyen-checkout__applepay__button": {
        borderRadius: "100px"
    },
    ".adyen-checkout__label, .adyen-checkout__card__brands": {
        display: "none"
    },
    ".adyen-checkout__label__text": {
        fontSize: "16px",
        marginBottom: 8
    },
    ".adyen-checkout__label--focused .adyen-checkout__label__text": {
        color: $756948b644e82cf2$var$colors.gray500
    },
    ".adyen-checkout__card__cardNumber__brandIcon": {
        right: 16
    },
    "img.adyen-checkout__field__exp-date_hint": {
        marginRight: 0
    },
    ".adyen-checkout__field__exp-date_hint_wrapper": {
        marginRight: 0,
        right: 16
    },
    ".adyen-checkout__card__cvc__hint__wrapper": {
        marginRight: 0,
        right: 16
    },
    [[
        ".adyen-checkout__label__text--error",
        ".adyen-checkout__error-text"
    ].join(",")]: {
        color: $756948b644e82cf2$var$colors.error
    },
    ".adyen-checkout__error-text": {
        margin: 0
    },
    ".adyen-checkout__field--error .adyen-checkout__error-text": {
        marginTop: 16,
        marginBottom: 16
    },
    ".adyen-checkout__field--error .adyen-checkout__card__brands": {
        marginTop: 0
    },
    ".adyen-checkout__field--error .adyen-checkout__error-text:before": {
        display: "block",
        content: `url("data:image/svg+xml,${encodeURIComponent((0, (/*@__PURE__*/$parcel$interopDefault($5qU69))).renderToString((0, $4vwom.jsx)((0, $dc53c17a4a911fba$export$d8964aec282183a3), {
            theme: $756948b644e82cf2$export$92c840cda8ec752c,
            children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: "warning",
                color: "error"
            })
        })))}")`,
        width: 24,
        height: 24,
        marginRight: 8
    },
    [[
        ".adyen-checkout__input--error",
        ".adyen-checkout__input--error:hover",
        ".adyen-checkout__input--error:active",
        ".adyen-checkout__input--error:active:hover",
        ".adyen-checkout__input--error:focus:hover",
        ".adyen-checkout__input--error--focus:hover",
        ".adyen-checkout__field--error input"
    ].join(",")]: {
        borderColor: $756948b644e82cf2$var$colors.error
    },
    [[
        ".adyen-checkout__input--valid",
        ".adyen-checkout__input--valid:hover",
        ".adyen-checkout__input--valid:active",
        ".adyen-checkout__input--valid:active:hover",
        ".adyen-checkout__input--valid:focus:hover",
        ".adyen-checkout__input--valid--focus:hover"
    ].join(",")]: {
        borderColor: $756948b644e82cf2$var$colors.forest
    },
    ".adyen-checkout__payment-method__details__content": {
        margin: 0
    },
    ".error-description": {
        display: "none"
    }
}, $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "md", {
    ".adyen-checkout__input": {
        height: 64 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
    }
}), (0, $lhaLc.css)`
        .adyen-checkout__input {
            ${$756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveBorderRadius("sm")};
        }
    `);


var $f9a768b134f2a07e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $f9a768b134f2a07e$export$6459fc9e86be362e() {
    return function Box(_a) {
        var { as: as, motion: motion, backgroundColor: backgroundColor, borderColor: borderColor, borderWidth: borderWidth, borderRadius: borderRadius, color: color, elevation: elevation, padding: padding, margin: margin, elementRef: boxRef, children: children } = _a, rest = $f9a768b134f2a07e$var$__rest(_a, [
            "as",
            "motion",
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "borderRadius",
            "color",
            "elevation",
            "padding",
            "margin",
            "elementRef",
            "children"
        ]);
        const { colors: colors, helpers: helpers } = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const { responsivePropCss: responsivePropCss, responsiveValueCss: responsiveValueCss, responsiveBorderRadius: responsiveBorderRadius, spacingToCss: spacingToCss } = helpers;
        const props = {
            style: rest.style,
            css: (0, $lhaLc.css)(color && {
                color: colors[color]
            }, backgroundColor && responsivePropCss(colors, "backgroundColor", backgroundColor), borderColor && {
                borderStyle: "solid",
                borderWidth: 1
            }, borderWidth && responsiveValueCss("borderWidth", borderWidth), borderColor && responsivePropCss(colors, "borderColor", borderColor), borderRadius && responsiveBorderRadius(borderRadius), padding && spacingToCss("padding", padding), margin && spacingToCss("margin", margin), elevation && (0, $756948b644e82cf2$export$4c4a64d4bfa41e73)(), rest.css)
        };
        const el = as !== null && as !== void 0 ? as : "div";
        if (typeof motion !== "undefined") return (0, $lhaLc.jsx)(typeof motion !== "undefined" ? (0, $ad7a054f4530c130$export$e25e478948902b8b)[el] : el, Object.assign(Object.assign(Object.assign(Object.assign({}, motion), rest), props), {
            ref: boxRef
        }), children);
        return (0, $lhaLc.jsx)(el, Object.assign(Object.assign(Object.assign({}, rest), props), {
            ref: boxRef
        }), children);
    };
}



var $b2ae362371ef43d7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b2ae362371ef43d7$var$Box = (0, $f9a768b134f2a07e$export$6459fc9e86be362e)();
function $b2ae362371ef43d7$export$88139892c6e1adf4() {
    return function Flex(_a) {
        var { direction: direction, flex: flex, basis: basis, grow: grow, shrink: shrink, alignItems: alignItems, justifyContent: justifyContent, alignSelf: alignSelf, gap: gap, children: children } = _a, rest = $b2ae362371ef43d7$var$__rest(_a, [
            "direction",
            "flex",
            "basis",
            "grow",
            "shrink",
            "alignItems",
            "justifyContent",
            "alignSelf",
            "gap",
            "children"
        ]);
        const theme = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        return (0, $lhaLc.jsx)($b2ae362371ef43d7$var$Box, Object.assign(Object.assign({}, rest), {
            css: (0, $lhaLc.css)({
                display: "flex",
                flex: flex,
                flexBasis: basis,
                flexGrow: grow,
                flexShrink: shrink,
                flexDirection: direction,
                alignItems: alignItems,
                justifyContent: justifyContent,
                alignSelf: alignSelf
            }, gap && theme.helpers.responsiveValueCss("gap", gap)),
            children: children
        }));
    };
}


const $6aab0c65d5445347$export$f51f4c4ede09e011 = (0, $b2ae362371ef43d7$export$88139892c6e1adf4)();




const { responsiveCss: $aace75a797ac78f1$export$cb4ef526fe7dcbbb, responsiveVariantsCss: $aace75a797ac78f1$export$716706c0ad38c83c, responsiveVariantToCss: $aace75a797ac78f1$export$d8d3ea2a3535365e, responsiveHidden: $aace75a797ac78f1$export$853675f96f4d5cc0, responsivePropCss: $aace75a797ac78f1$export$bd547c6f5ab3c0aa, responsiveValueCss: $aace75a797ac78f1$export$4842074a718b7c, responsiveSpacing: $aace75a797ac78f1$export$9c33585a37942ee0, responsiveBorderRadius: $aace75a797ac78f1$export$ae2d933239aa09a1, responsiveHeadingLevel: $aace75a797ac78f1$export$70aad56e3e56b3f3, responsiveHeadingCss: $aace75a797ac78f1$export$a7ac14f5090840b7, responsiveBodyCss: $aace75a797ac78f1$export$1da95120b6ada65d, spacingToCss: $aace75a797ac78f1$export$e402f9c533b5a526, useMediaQuery: $aace75a797ac78f1$export$32d5543ab307c01, variantCss: $aace75a797ac78f1$export$bb20750b66f96163 } = (0, $756948b644e82cf2$export$92c840cda8ec752c).helpers;


/**
 * The animation defined in the design system in Figma is set with the physical attributes
 * stiffness: 720, damping: 60, and mass: 1. This is roughly translated to the following
 * cubic-bezier function, which probably needs some adjustments, or be replaced by Framer
 * motion, where we can set the intended variables.
 */ const $7f851218870bc850$var$defaultDuration = 200;
const $7f851218870bc850$export$5cc90842f5a0bf76 = "cubic-bezier(0.4, 0, 0.2, 1)";
const $7f851218870bc850$export$c820717c055e5a6 = `all ${$7f851218870bc850$var$defaultDuration}ms ${$7f851218870bc850$export$5cc90842f5a0bf76}`;
function $7f851218870bc850$export$d5639c01d489b0c(props = [
    "all"
], duration = $7f851218870bc850$var$defaultDuration) {
    return `${props.join(" ")} ${duration}ms ${$7f851218870bc850$export$5cc90842f5a0bf76}`;
}
const $7f851218870bc850$export$f1ff28cd2162b6d5 = {
    card: {
        type: "spring",
        stiffness: 1400,
        damping: 100,
        mass: 1
    },
    carousel: {
        type: "spring",
        duration: 0.9,
        bounce: 0,
        velocity: 6
    }
};
const $7f851218870bc850$export$f4e4ad51b471de36 = {
    "200": {
        type: "spring",
        stiffness: 720,
        damping: 60,
        mass: 1
    },
    "400": {
        type: "spring",
        stiffness: 180,
        damping: 30,
        mass: 1
    },
    "600": {
        type: "spring",
        stiffness: 80,
        damping: 20,
        mass: 1
    }
};



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");


function $ac6e084dc3a06362$export$412e0f8c020cec3() {
    return function Text(props) {
        var _a;
        const { helpers: helpers, colors: colors } = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const { spacingToCss: spacingToCss, responsiveHeadingCss: responsiveHeadingCss, textCss: textCss } = helpers;
        const El = (_a = props.as) !== null && _a !== void 0 ? _a : "div";
        return (0, $4vwom.jsx)(El, {
            ref: props.elementRef,
            onClick: props.onClick,
            style: Object.assign({
                fontSize: props.fontSize
            }, props.style || {}),
            css: (0, $lhaLc.css)({
                "& a": (0, $e82ba787de72625c$export$425327af25286e5e)
            }, props.color && {
                color: colors[props.color]
            }, props.lineHeight && {
                lineHeight: props.lineHeight
            }, !!props.variant && (props.variant === "heading" ? !!props.level && responsiveHeadingCss(props.level) : props.variant && props.size ? textCss(props.variant, props.size) : undefined), typeof props.lineClamp !== "undefined" && {
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: `${props.lineClamp}`,
                lineClamp: `${props.lineClamp}`,
                textOverflow: "ellipsis",
                WebkitBoxOrient: "vertical"
            }, props.truncate && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "100%"
            }, props.margin && spacingToCss("margin", props.margin), props.underline && (0, $e82ba787de72625c$export$425327af25286e5e)),
            className: props.className,
            children: props.children
        });
    };
}


var $38bb2c2712b5525d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $38bb2c2712b5525d$var$RedoitText = (0, $ac6e084dc3a06362$export$412e0f8c020cec3)();
function $38bb2c2712b5525d$export$5f1af8db9871e1d6(_a) {
    var { fontWeight: fontWeight, children: children } = _a, rest = $38bb2c2712b5525d$var$__rest(_a, [
        "fontWeight",
        "children"
    ]);
    return (0, $4vwom.jsx)($38bb2c2712b5525d$var$RedoitText, Object.assign({
        css: !!fontWeight && (0, $lhaLc.css)({
            "&&": {
                fontWeight: fontWeight
            }
        })
    }, rest, {
        children: children
    }));
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $8MAXm = parcelRequire("8MAXm");

function $82d66b15b8f4758d$export$d5163f1ce1e6a5f9(props) {
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveHeadingCss: responsiveHeadingCss } = helpers;
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)({
            "table, tr, td, th": {
                borderColor: colors.gray200,
                borderWidth: 1
            },
            table: {
                marginBottom: 16
            },
            "th, td": {
                padding: 8
            },
            th: {
                fontWeight: 500,
                backgroundColor: colors.gray100
            },
            h1: (0, $lhaLc.css)(responsiveHeadingCss(1), {
                marginTop: ".4em",
                marginBottom: ".4em"
            }),
            h2: (0, $lhaLc.css)(responsiveHeadingCss(2), {
                marginTop: ".4em",
                marginBottom: ".4em"
            }),
            h3: (0, $lhaLc.css)(responsiveHeadingCss(3), {
                marginTop: ".4em",
                marginBottom: ".4em"
            }),
            h4: (0, $lhaLc.css)(responsiveHeadingCss(4), {
                marginTop: ".4em",
                marginBottom: ".4em"
            })
        }),
        children: (0, $4vwom.jsx)((0, $8MAXm.MarkdownView), Object.assign({}, props))
    });
}



function $0273ae0bc8f90076$export$5fbe01e9406810ee(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const [isOpen, setIsOpen] = (0, $eeH7J.useState)(false);
    const mouseDownX = (0, $eeH7J.useRef)(0);
    const mouseUpX = (0, $eeH7J.useRef)(0);
    const handleMouseDown = (0, $eeH7J.useCallback)((e)=>{
        mouseDownX.current = e.clientX;
    }, []);
    const handleMouseUp = (0, $eeH7J.useCallback)((e)=>{
        mouseUpX.current = e.clientX;
    }, []);
    const toggleOpen = (0, $eeH7J.useCallback)(()=>{
        // Don't open card if the click was a drag event (meaning cursor was moved between
        // mouse down and up events). May want to add some move tolerance.
        if (mouseDownX.current === mouseUpX.current) setIsOpen(!isOpen);
        mouseDownX.current = 0;
        mouseUpX.current = 0;
    }, [
        isOpen
    ]);
    return (0, $4vwom.jsx)((0, $5358b7a8389876c7$export$7fe0cbe305f29bb4), {
        children: (0, $4vwom.jsxs)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, Object.assign({
            onMouseDown: handleMouseDown,
            onMouseUp: handleMouseUp,
            style: {
                overflow: "hidden"
            },
            initial: {
                paddingLeft: "0px",
                paddingRight: "0px"
            },
            animate: isOpen ? "open" : "closed",
            variants: {
                open: {
                    paddingLeft: "var(--spacing)",
                    paddingRight: "var(--spacing)"
                },
                closed: {
                    paddingLeft: "0px",
                    paddingRight: "0px"
                }
            },
            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
            css: (0, $lhaLc.css)({
                "--top-height": "236px",
                "--bottom-height": "94px",
                "--spacing": "20px",
                "--height": "330px",
                minWidth: 240,
                width: "100%",
                height: "var(--height)",
                position: "relative"
            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                minWidth: 264,
                width: "100%",
                "--top-height": "284px",
                "--bottom-height": "94px",
                "--height": "378px"
            }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "xl", {
                "--top-height": "326px",
                "--bottom-height": "98px",
                "--spacing": "21px",
                "--height": "424px"
            }))
        }, isOpen ? {} : {
            onClick: toggleOpen,
            role: "button",
            "aria-label": `${props.readMoreAriaPrefix} ${props.title}`
        }, {
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    backgroundColor: "gray100",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "md",
                    css: (0, $lhaLc.css)({
                        position: "relative",
                        height: "var(--top-height)",
                        overflow: "hidden"
                    }),
                    children: [
                        props.number ? (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            backgroundColor: "grayWhite",
                            alignItems: "center",
                            justifyContent: "center",
                            css: (0, $lhaLc.css)({
                                position: "absolute",
                                top: "var(--spacing)",
                                left: "var(--spacing)",
                                borderRadius: 24,
                                height: 36,
                                width: 36
                            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                height: (0, $756948b644e82cf2$export$981516ee4691055c)(48),
                                width: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                            })),
                            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 4,
                                children: props.number.valueOf()
                            })
                        }) : null,
                        props.image ? (0, $4vwom.jsx)("img", {
                            draggable: "false",
                            src: (0, $14q7s.FileToUrl)(props.image),
                            style: {
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                                objectPosition: "center"
                            }
                        }) : null
                    ]
                }),
                (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    animate: isOpen ? "open" : "closed",
                    variants: {
                        open: {
                            height: `calc(100% - ${(0, $756948b644e82cf2$export$981516ee4691055c)(20)}`
                        },
                        closed: {
                            height: "var(--bottom-height)"
                        }
                    },
                    transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                    onClick: isOpen ? toggleOpen : undefined,
                    css: (0, $lhaLc.css)({
                        backgroundColor: colors.gray500,
                        display: "flex",
                        flexDirection: "column",
                        position: "absolute",
                        cursor: "pointer",
                        bottom: 0,
                        left: 0,
                        right: 0
                    }, (0, $aace75a797ac78f1$export$ae2d933239aa09a1)("md")),
                    children: (0, $4vwom.jsxs)("div", {
                        css: (0, $lhaLc.css)({
                            padding: "var(--spacing)",
                            height: "var(--bottom-height)"
                        }),
                        children: [
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                color: "grayWhite",
                                justifyContent: "space-between",
                                alignItems: isOpen ? "flex-start" : "center",
                                flex: `0 0 ${isOpen ? "auto" : 60}px`,
                                css: (0, $lhaLc.css)({
                                    height: isOpen ? "auto" : "100%"
                                }),
                                children: [
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: [
                                            "fixed",
                                            "lg",
                                            4
                                        ],
                                        lineClamp: 3,
                                        children: props.title
                                    }),
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: "plus",
                                        margin: {
                                            left: 12
                                        },
                                        style: {
                                            flex: "0 0 auto",
                                            transform: `rotate(${isOpen ? 45 : 0}deg)`,
                                            transition: (0, $7f851218870bc850$export$c820717c055e5a6)
                                        }
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                css: (0, $lhaLc.css)({
                                    paddingTop: "var(--spacing)",
                                    opacity: isOpen ? 0.8 : 0,
                                    transition: (0, $7f851218870bc850$export$d5639c01d489b0c)([
                                        "opacity"
                                    ], 200)
                                }),
                                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: [
                                        "fixed",
                                        "lg",
                                        "md"
                                    ],
                                    color: "grayWhite",
                                    as: "div",
                                    children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                        value: props.text
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        }))
    });
}
(0, $eSiQ2.Component)($0273ae0bc8f90076$export$5fbe01e9406810ee, {
    name: "WithOverlayCard",
    gallery: {
        path: "Cards/WithOverlayCard",
        items: [
            {
                title: "Card with overlay",
                variants: [
                    {
                        props: {
                            number: (0, $fR074.NonNegativeInteger)(1),
                            title: "Velg hvilken telefon du vil leie",
                            text: (0, $gGZ2r.Markdown)("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."),
                            image: `${(0, $7m9cQ.server)()}/static/redoit/how-it-works-card-illustration-1.svg`,
                            readMoreAriaPrefix: `Read more about`,
                            runningAnimation: true
                        }
                    },
                    {
                        props: {
                            number: (0, $fR074.NonNegativeInteger)(2),
                            title: "Velg hvilken telefon du vil leie",
                            text: (0, $gGZ2r.Markdown)("Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur."),
                            image: `${(0, $7m9cQ.server)()}/static/redoit/how-it-works-card-illustration-2.svg`,
                            readMoreAriaPrefix: `Read more about`
                        }
                    },
                    {
                        props: {
                            number: (0, $fR074.NonNegativeInteger)(3),
                            title: "Velg hvilken telefon du vil leie",
                            text: (0, $gGZ2r.Markdown)("Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."),
                            image: `${(0, $7m9cQ.server)()}/static/redoit/how-it-works-card-illustration-3.svg`,
                            readMoreAriaPrefix: `Read more about`
                        }
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");

function $b93688f4b1374f47$export$90ceba2564a894f8(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = root.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}


const $2ffb79a4f9b32f4b$var$thresholds = {
    some: 0,
    all: 1
};
function $2ffb79a4f9b32f4b$export$acb1e9cb9ce4ca56(elementOrSelector, onStart, { root: root, margin: rootMargin, amount: amount = "some" } = {}) {
    const elements = (0, $b93688f4b1374f47$export$90ceba2564a894f8)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (typeof newOnEnd === "function") activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : $2ffb79a4f9b32f4b$var$thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}


function $3e2475e44b27c8d2$export$2f62ee6831462844(ref, { root: root, margin: margin, amount: amount, once: once = false } = {}) {
    const [isInView, setInView] = (0, $eeH7J.useState)(false);
    (0, $eeH7J.useEffect)(()=>{
        if (!ref.current || once && isInView) return;
        const onEnter = ()=>{
            setInView(true);
            return once ? undefined : ()=>setInView(false);
        };
        const options = {
            root: root && root.current || undefined,
            margin: margin,
            amount: amount
        };
        return (0, $2ffb79a4f9b32f4b$export$acb1e9cb9ce4ca56)(ref.current, onEnter, options);
    }, [
        root,
        ref,
        margin,
        once,
        amount
    ]);
    return isInView;
}



var $lhaLc = parcelRequire("lhaLc");



var $eSiQ2 = parcelRequire("eSiQ2");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");


var $31d9e20b147e8c7e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $31d9e20b147e8c7e$export$219d2fdcce27358d() {
    return function Heading(_a) {
        var { level: level, color: color, margin: margin, padding: padding, truncate: truncate, children: children } = _a, rest = $31d9e20b147e8c7e$var$__rest(_a, [
            "level",
            "color",
            "margin",
            "padding",
            "truncate",
            "children"
        ]);
        const HeadingTag = `h${level}`;
        const { helpers: helpers, colors: colors } = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const { spacingToCss: spacingToCss, responsiveHeadingLevel: responsiveHeadingLevel } = helpers;
        return (0, $4vwom.jsx)(HeadingTag, Object.assign({
            css: (0, $lhaLc.css)((0, $e82ba787de72625c$export$6b6f359a824920a4)(HeadingTag), {
                "& a": (0, $e82ba787de72625c$export$425327af25286e5e)
            }, responsiveHeadingLevel(level), truncate && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            }, color && {
                color: colors[color]
            }, margin && spacingToCss("margin", margin), padding && spacingToCss("padding", padding))
        }, rest, {
            children: children
        }));
    };
}


const $789b8639be592288$export$a8a3e93435678ff9 = (0, $31d9e20b147e8c7e$export$219d2fdcce27358d)();
(0, $eSiQ2.Component)($789b8639be592288$export$a8a3e93435678ff9, {
    name: "Heading",
    gallery: {
        path: "Typography/Heading",
        about: "Using headers to organize and arrange designs in Figma is a great way to visually group components, while providing space for notes and context.",
        items: [
            {
                title: "Title 1",
                variants: [
                    {
                        props: {
                            level: 1,
                            children: "Hello, world!"
                        }
                    }
                ]
            },
            {
                title: "Title 2",
                variants: [
                    {
                        props: {
                            level: 2,
                            children: "The new wave"
                        }
                    }
                ]
            },
            {
                title: "Title 3",
                variants: [
                    {
                        props: {
                            level: 3,
                            children: "We take on the complexities of leasing"
                        }
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $f301b516e89c5a3f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $f301b516e89c5a3f$export$9b6d6ca62970729f() {
    return function Button(_a) {
        var { as: as, variant: variant, size: size, onClick: onClick, margin: margin, fullwidth: fullwidth, children: children, elementRef: elementRef, className: className } = _a, rest = $f301b516e89c5a3f$var$__rest(_a, [
            "as",
            "variant",
            "size",
            "onClick",
            "margin",
            "fullwidth",
            "children",
            "elementRef",
            "className"
        ]);
        const { helpers: helpers, buttonSizes: buttonSizes, buttonVariants: buttonVariants } = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const { variantCss: variantCss, responsiveVariantsCss: responsiveVariantsCss, spacingToCss: spacingToCss } = helpers;
        const buttonCss = (0, $lhaLc.css)([
            variantCss(buttonVariants, variant),
            margin && spacingToCss("margin", margin),
            responsiveVariantsCss(buttonSizes, size),
            {
                width: fullwidth ? "100%" : "auto"
            }
        ]);
        const ref = elementRef !== null && elementRef !== void 0 ? elementRef : /*#__PURE__*/ (0, $eeH7J.createRef)();
        const handleClick = (0, $eeH7J.useCallback)((e)=>{
            var _a;
            onClick === null || onClick === void 0 || onClick(e);
            (_a = ref.current) === null || _a === void 0 || _a.blur();
        }, [
            onClick,
            ref
        ]);
        const commonProps = Object.assign({
            css: buttonCss,
            onClick: handleClick,
            className: className ? className : "",
            disabled: rest.disabled
        }, rest);
        // TODO: Render as <Link to={props.href} /> if as === "a". Only problem is ref type error.
        const El = as !== null && as !== void 0 ? as : "button";
        return (0, $lhaLc.jsx)(El, Object.assign(Object.assign(Object.assign({}, rest), commonProps), {
            ref: ref
        }), children);
    };
}




var $4b4086f8a1c6b2f8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4b4086f8a1c6b2f8$export$f67fb575035cc7d0 = (0, $f301b516e89c5a3f$export$9b6d6ca62970729f)();
function $4b4086f8a1c6b2f8$export$353f5b6fc5456de1(_a) {
    var { iconStart: iconStart, iconEnd: iconEnd, selected: selected, children: children, variant: variant, size: size } = _a, rest = $4b4086f8a1c6b2f8$var$__rest(_a, [
        "iconStart",
        "iconEnd",
        "selected",
        "children",
        "variant",
        "size"
    ]);
    const c = (0, $lhaLc.css)({
        borderWidth: size === "md" ? 2 : 1,
        width: rest.fullwidth ? "100%" : "auto"
    }, // Icon only buttons should be circular, so just remove all x padding and ensure
    // width === height using aspect-ratio. && ensures higher specificity than the default
    // styles for the Button.
    // TODO: Auto prefix incoming css to base Button component with &&.
    !children && {
        "&&": {
            paddingLeft: 0,
            paddingRight: 0,
            aspectRatio: "1"
        }
    }, (0, $aace75a797ac78f1$export$70aad56e3e56b3f3)("4"));
    return (0, $4vwom.jsxs)($4b4086f8a1c6b2f8$export$f67fb575035cc7d0, Object.assign({
        css: c,
        "data-selected": !!selected,
        size: size !== null && size !== void 0 ? size : "md",
        variant: variant !== null && variant !== void 0 ? variant : "primary"
    }, rest, {
        children: [
            iconStart && (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: iconStart
            }),
            children,
            iconEnd && (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: iconEnd
            })
        ]
    }));
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $7m9cQ = parcelRequire("7m9cQ");
parcelRequire("2LTO8");
var $gGZ2r = parcelRequire("gGZ2r");

var $eSiQ2 = parcelRequire("eSiQ2");


var $lhaLc = parcelRequire("lhaLc");
const $62fa897e2e43b923$export$962d61ddac85577e = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function CardsCarousel(props, ref) {
    const dragContainerRef = (0, $eeH7J.useRef)(null);
    const cardsContainerRef = (0, $eeH7J.useRef)(null);
    const cardsRef = (0, $eeH7J.useRef)(props.items.map(()=>/*#__PURE__*/ (0, $eeH7J.createRef)()));
    const scrollContainerRef = (0, $eeH7J.useRef)(null);
    const [position, setPosition] = (0, $eeH7J.useState)({
        atStart: true,
        atEnd: false
    });
    // Returns a set of DOMRects used frequently in the component.
    function getRects() {
        var _a, _b, _c, _d, _e, _f;
        const container = (_a = dragContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const grid = (_b = cardsContainerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        const firstCard = (_d = (_c = cardsRef.current[0]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect();
        const lastCard = (_f = (_e = cardsRef.current[cardsRef.current.length - 1]) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect();
        if (!container || !grid || !firstCard || !lastCard) {
            // eslint-disable-next-line no-console
            console.warn("Missing reference to container, card, or grid.");
            return;
        }
        return {
            container: container,
            grid: grid,
            firstCard: firstCard,
            lastCard: lastCard
        };
    }
    const updatePosition = (0, $eeH7J.useCallback)(()=>{
        const rects = getRects();
        if (!rects || !scrollContainerRef.current) return;
        const newPosition = {
            atStart: Math.floor(scrollContainerRef.current.scrollLeft) === 0,
            atEnd: Math.floor(scrollContainerRef.current.scrollWidth - scrollContainerRef.current.scrollLeft - rects.container.width) === 0
        };
        if (newPosition.atStart === position.atStart && newPosition.atEnd === position.atEnd) return;
        setPosition(newPosition);
    }, [
        position,
        setPosition
    ]);
    const handleScrollEnd = (0, $eeH7J.useCallback)(()=>{
        updatePosition();
    }, [
        updatePosition
    ]);
    (0, $eeH7J.useEffect)(()=>{
        const currentScrollContainerRef = scrollContainerRef.current;
        if (currentScrollContainerRef) {
            currentScrollContainerRef.addEventListener("scrollend", handleScrollEnd);
            return ()=>{
                currentScrollContainerRef.removeEventListener("scrollend", handleScrollEnd);
            };
        }
    }, [
        handleScrollEnd
    ]);
    // Call onPositionChange when position changes.
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        (_a = props.onPositionChange) === null || _a === void 0 || _a.call(props, position);
    }, [
        position,
        props
    ]);
    // Ref functions that allow other components consuming this one to trigger next/prev switch.
    (0, $eeH7J.useImperativeHandle)(ref, ()=>({
            next () {
                handleSlideClick("next");
            },
            prev () {
                handleSlideClick("prev");
            }
        }));
    const debouncedUpdatePosition = (0, $eeH7J.useMemo)(()=>$62fa897e2e43b923$var$debounce(updatePosition, 500), [
        updatePosition
    ]);
    (0, $eeH7J.useEffect)(()=>{
        // The intersection observer is used to observe when any of the cards intersect with
        // the container.
        const intersectionObserver = new IntersectionObserver(debouncedUpdatePosition, {
            root: dragContainerRef.current,
            rootMargin: "0px",
            threshold: 1.0
        });
        for (const c of cardsRef.current)if (c.current) intersectionObserver.observe(c.current);
        // We need the mutation observer to observe for changes in position controlled by style
        // attribute of child elements. Because of that it's difficult to trigger in a better way.
        const mutationObserver = new MutationObserver(debouncedUpdatePosition);
        if (cardsContainerRef.current) mutationObserver.observe(cardsContainerRef.current, {
            attributes: true,
            subtree: true
        });
        return ()=>{
            mutationObserver.disconnect();
            intersectionObserver.disconnect();
        };
    }, [
        debouncedUpdatePosition
    ]);
    // Just copied from CardsBlock, probably a good candidate for rafactoring.
    const handleSlideClick = (0, $eeH7J.useCallback)((direction)=>{
        if (!dragContainerRef.current) return;
        // Direction is the direction the cards will slide in, which is the opposite of the way the
        // arrow on the button is pointing.
        const slideDirection = direction === "prev" ? "right" : "left";
        const containerRect = dragContainerRef.current.getBoundingClientRect();
        try {
            // Find first card that is partially on the inside and partially on the outside of
            // container. Or the card before a card that is just inside the container This is
            // the card we'll want to move to the edge of the container.
            const nextCardIndex = cardsRef.current.findIndex((item, index)=>{
                var _a, _b, _c;
                const itemRect = (_a = item.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                if (!itemRect) throw new Error(`No element for card item at index ${index}.`);
                if (slideDirection === "left") return itemRect.right > containerRect.right;
                else {
                    const nextRect = (_c = (_b = cardsRef.current[index + 1]) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
                    if (!nextRect) return true;
                    return(// If the next card is on the edge of the container, this is the next.
                    itemRect.left < containerRect.left && Math.round(nextRect.left) === Math.round(containerRect.left) || // Left edge of element is outside, but has right edge inside container
                    itemRect.left < containerRect.left && itemRect.right > containerRect.left || // Entire element is outside, but next is inside, return this
                    itemRect.left < containerRect.left && nextRect.left >= containerRect.left);
                }
            });
            const nextCard = cardsRef.current[nextCardIndex];
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (nextCard === null || nextCard === void 0 ? void 0 : nextCard.current) nextCard.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: nextCardIndex === props.items.length - 1 ? "end" : "start"
            });
        } catch (err) {
            //eslint-disable-next-line no-console
            console.warn(err);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, $4vwom.jsx)("div", {
        ref: dragContainerRef,
        children: (0, $4vwom.jsx)("div", {
            ref: cardsContainerRef,
            children: props.renderContainer(props.items.map((item, index)=>(0, $4vwom.jsx)("div", {
                    ref: cardsRef.current[index],
                    css: (0, $lhaLc.css)({
                        scrollSnapAlign: index === props.items.length - 1 ? "end" : "start"
                    }),
                    children: props.renderItem(item, index)
                }, index)), scrollContainerRef)
        })
    });
});
const $62fa897e2e43b923$var$arr = [
    ...new Array(3)
].map(()=>"Hello, World!");
(0, $eSiQ2.Component)($62fa897e2e43b923$export$962d61ddac85577e, {
    name: "CardsCarousel",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            items: $62fa897e2e43b923$var$arr,
                            renderContainer: (children)=>(0, $4vwom.jsx)("div", {
                                    style: {
                                        display: "grid",
                                        gridAutoFlow: "column",
                                        gap: 16,
                                        gridAutoColumns: "min-content"
                                    },
                                    children: children
                                }),
                            renderItem: (_, index)=>(0, $4vwom.jsx)((0, $0273ae0bc8f90076$export$5fbe01e9406810ee), {
                                    title: `Hello ${index}${index}${index}${index}`,
                                    text: (0, $gGZ2r.Markdown)(`${index}`),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/how-it-works-card-illustration-3.svg`,
                                    readMoreAriaPrefix: "Read more"
                                })
                        }
                    }
                ]
            }
        ]
    }
});
function $62fa897e2e43b923$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        if (typeof window === "undefined") callback(...args);
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>{
            callback(...args);
        }, wait);
    };
}




const $8160ea1f3816c70f$var$GRID_COLUMN_COUNT = 4;
function $8160ea1f3816c70f$export$e0b2a4a0e3a11a62(props) {
    const { responsiveCss: responsiveCss, helpers: helpers, screenSizes: screenSizes } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveSpacing: responsiveSpacing } = helpers;
    const containerRef = (0, $eeH7J.useRef)(null);
    const isInView = (0, $3e2475e44b27c8d2$export$2f62ee6831462844)(containerRef, {
        once: true,
        amount: 0.25
    });
    const [position, setPosition] = (0, $eeH7J.useState)({
        atStart: true,
        atEnd: false
    });
    const carouselBaseRef = (0, $eeH7J.useRef)(null);
    return (0, $4vwom.jsxs)("div", {
        ref: containerRef,
        css: (0, $lhaLc.css)({
            display: "flex",
            flexDirection: "column"
        }, (0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                justifyContent: "space-between",
                css: (0, $lhaLc.css)({
                    marginBottom: 16
                }, responsiveCss("min", "md", {
                    marginBottom: 24
                })),
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        padding: {
                            y: 8
                        },
                        truncate: true,
                        children: props.heading
                    }),
                    props.showSlideButtons && (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        shrink: 0,
                        margin: {
                            left: 16
                        },
                        children: [
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                size: "sm",
                                variant: "secondary",
                                iconStart: "chevronLeft",
                                margin: {
                                    right: 4
                                },
                                disabled: position.atStart,
                                onClick: ()=>{
                                    var _a;
                                    return (_a = carouselBaseRef.current) === null || _a === void 0 ? void 0 : _a.prev();
                                }
                            }),
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                size: "sm",
                                variant: "secondary",
                                iconStart: "chevronRight",
                                disabled: position.atEnd,
                                onClick: ()=>{
                                    var _a;
                                    return (_a = carouselBaseRef.current) === null || _a === void 0 ? void 0 : _a.next();
                                }
                            })
                        ]
                    })
                ]
            }),
            (0, $4vwom.jsx)("div", {
                css: responsiveSpacing("sm", "--gap"),
                style: {
                    overflow: "hidden",
                    width: "100vw",
                    marginLeft: "calc(50% - 50vw)"
                },
                children: (0, $4vwom.jsx)((0, $62fa897e2e43b923$export$962d61ddac85577e), {
                    ref: carouselBaseRef,
                    onPositionChange: (p)=>{
                        if (p.atStart !== position.atStart || p.atEnd !== position.atEnd) setPosition(p);
                    },
                    items: props.cards,
                    renderContainer: (children, scrollContainerRef)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                            ref: scrollContainerRef,
                            style: {
                                overflowX: "scroll",
                                scrollSnapType: "x mandatory",
                                scrollbarWidth: "none"
                            },
                            css: (0, $lhaLc.css)((0, $lhaLc.css)`
                                --padding-inline: ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).xs.paddingLeft}px;
                                @media (min-width: ${screenSizes.md}px) {
                                    --padding-inline: ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).md.paddingLeft}px;
                                }
                                @media (min-width: ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).xs.maxWidth}px) {
                                    --padding-inline: calc(
                                        ((100vw - ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).xs.maxWidth}px) / 2) +
                                            ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).md.paddingLeft}px
                                    );
                                }
                                min-width: 100%;
                                padding: 0 var(--padding-inline);
                                scroll-padding: 0 var(--padding-inline);
                                &::-webkit-scrollbar {
                                    display: none;
                                }
                                display: grid;
                                grid-auto-flow: column;
                                grid-auto-columns: minmax(min-content, 1fr);
                                @media (min-width: ${screenSizes.md}px) {
                                    grid-auto-columns: calc(
                                        calc(
                                                ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).xs.maxWidth}px -
                                                    ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).md.paddingLeft}px -
                                                    ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).md.paddingRight}px - calc(
                                                        var(--gap) * ${$8160ea1f3816c70f$var$GRID_COLUMN_COUNT - 1}
                                                    )
                                            ) / ${$8160ea1f3816c70f$var$GRID_COLUMN_COUNT}
                                    );
                                }
                            `),
                            initial: {
                                transform: "translateX(200px)",
                                gap: "64px",
                                opacity: 0
                            },
                            animate: (isInView || !props.enterAnimation) && {
                                transform: "translateX(0px)",
                                gap: "var(--gap)",
                                opacity: 1
                            },
                            transition: props.enterAnimation ? (0, $7f851218870bc850$export$f4e4ad51b471de36)["600"] : {
                                duration: 0
                            },
                            children: children
                        }),
                    renderItem: props.renderCard
                })
            })
        ]
    });
}


/**
 * Shows a set of cards side by side which the user can click to get more info about something.
 *
 * @icon ui-info-square
 */ function $8e58be2eee2f201e$var$CardsWithMoreInfo(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)((0, $8160ea1f3816c70f$export$e0b2a4a0e3a11a62), {
        heading: localize(section.heading),
        showSlideButtons: true,
        cards: section.cards.map((c)=>Object.assign(Object.assign({}, c), {
                id: c.id.valueOf()
            })),
        enterAnimation: true,
        renderCard: (c, i)=>(0, $4vwom.jsx)((0, $0273ae0bc8f90076$export$5fbe01e9406810ee), {
                title: localize(c.heading),
                text: localize(c.text),
                image: c.image,
                number: section.showCardNumber ? (0, $fR074.NonNegativeInteger)(i + 1) : undefined,
                readMoreAriaPrefix: localize(section.readMoreAriaPrefix),
                runningAnimation: i === 0
            })
    });
}
(0, $9G56J.Section)($8e58be2eee2f201e$var$CardsWithMoreInfo);



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $dUDPg = parcelRequire("dUDPg");

var $aIeEI = parcelRequire("aIeEI");
function $2e171bb7176b2346$export$3e75343ff9861e57(pageIds) {
    var _a, _b;
    const pagesInfos = (0, $dUDPg.useWebPagesInfos)({
        ids: pageIds
    });
    const localize = (0, $aIeEI.useLocalize)();
    const currentLocale = (0, $aIeEI.useCurrentLocale)();
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const localePath = currentLocale === defaultLocale ? "" : `/${currentLocale}`;
    const paths = (_b = pagesInfos.data) === null || _b === void 0 ? void 0 : _b.map((item)=>!item ? item : {
            title: localize(item.title),
            path: item.slug ? `${localePath}/${localize(item.slug)}` : "/"
        });
    return paths;
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");


var $7m9cQ = parcelRequire("7m9cQ");

var $eSiQ2 = parcelRequire("eSiQ2");

const $bee1a5e35c892a21$export$e71c4d32a2263218 = (0, $f9a768b134f2a07e$export$6459fc9e86be362e)();




var $eSiQ2 = parcelRequire("eSiQ2");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");


function $01e320efe3155383$export$1cade971dfb58d96() {
    return function Body(props) {
        const { colors: colors, helpers: helpers } = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const { responsiveBodyCss: responsiveBodyCss } = helpers;
        return (0, $4vwom.jsx)("p", {
            css: (0, $lhaLc.css)((0, $e82ba787de72625c$export$6b6f359a824920a4)("p"), {
                "& a": (0, $e82ba787de72625c$export$425327af25286e5e)
            }, responsiveBodyCss(props.size), props.color && {
                color: colors[props.color]
            }, props.truncate && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "100%"
            }, props.margin && helpers.spacingToCss("margin", props.margin), props.underline && (0, $e82ba787de72625c$export$425327af25286e5e), typeof props.opacity === "number" && {
                opacity: props.opacity
            }),
            style: Object.assign({}, props.style || {}),
            children: props.children
        });
    };
}


const $72c5ae9e0017e167$export$4b2c32e08f77ff18 = (0, $01e320efe3155383$export$1cade971dfb58d96)();
(0, $eSiQ2.Component)($72c5ae9e0017e167$export$4b2c32e08f77ff18, {
    name: "Body",
    gallery: {
        path: "Typography/Body",
        items: [
            {
                variants: [
                    {
                        props: {
                            size: "md",
                            children: "Hello, world!"
                        }
                    }
                ]
            },
            {
                title: "Fixed size",
                variants: [
                    {
                        props: {
                            size: [
                                "fixed",
                                "md",
                                "md"
                            ],
                            children: "Hello, world!"
                        }
                    }
                ]
            },
            {
                title: "Media Query Responsive Sizes",
                variants: [
                    {
                        props: {
                            size: [
                                "lg",
                                [
                                    "min",
                                    "md",
                                    "xs"
                                ]
                            ],
                            children: "Hello, world!"
                        }
                    }
                ]
            },
            {
                variants: [
                    {
                        props: {
                            size: "lg",
                            children: "Our mission is to accelerate the transition to a circular economy. Consumers and retailers will only make that transition if it is cost effective and simple. That's where we come in. Our technology platform enables the lease-and-reuse of consumer goods, which makes them more sustainable, accessible and affordable."
                        }
                    }
                ]
            }
        ]
    }
});







var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");
var $6a1a23ca93758ec8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $6a1a23ca93758ec8$export$686e15a6b88a698c(props) {
    const { image: image, width: width } = props, rest = $6a1a23ca93758ec8$var$__rest(props, [
        "image",
        "width"
    ]);
    return (0, $4vwom.jsx)("img", Object.assign({
        srcSet: [
            1,
            1.5,
            2,
            3
        ].map((x)=>`${(0, $14q7s.ImageToUrl)(image, {
                width: Math.ceil(width * x),
                format: props.format
            })} ${x}x`).join(", "),
        src: (0, $14q7s.ImageToUrl)(props.image, {
            width: width
        })
    }, rest));
}
function $6a1a23ca93758ec8$export$8b235cefb9710a9e(props) {
    return (0, $lhaLc.css)([
        1,
        1.5,
        2,
        3
    ].map((x)=>({
            [`@media (min-resolution: ${x}dppx)`]: {
                backgroundImage: `url('${(0, $14q7s.ImageToUrl)(props.image, {
                    width: Math.ceil(props.width * x),
                    format: props.format
                })}')`
            }
        })));
}



const $5f9967f24e231168$var$progress = (0, $lhaLc.keyframes)({
    from: {
        width: "0%"
    },
    to: {
        width: "100%"
    }
});
function $5f9967f24e231168$export$df5a8e831e8fbbb0(props) {
    var _a;
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const timePerSlide = props.timePerSlide || 5000;
    const [currentIndex, setCurrentIndex] = (0, $eeH7J.useState)(0);
    const [isPaused, setIsPaused] = (0, $eeH7J.useState)(false);
    const [panned, setPanned] = (0, $eeH7J.useState)(0);
    const [isPanning, setIsPanning] = (0, $eeH7J.useState)(false);
    // Used to temporary disable animations when resetting to index 0 from extra last slide
    const slideAnimationDisabled = (0, $eeH7J.useRef)(false);
    const touchPanStartX = (0, $eeH7J.useRef)(null);
    const carouselRef = (0, $eeH7J.useRef)(null);
    const carouselWidth = (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width;
    const currentTheme = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = props.slides[currentIndex]) === null || _a === void 0 ? void 0 : _a.theme;
    }, [
        currentIndex,
        props.slides
    ]);
    const xOffset = (0, $eeH7J.useMemo)(()=>{
        return `-${currentIndex * 100}%`;
    }, [
        currentIndex
    ]);
    const goToNext = (0, $eeH7J.useCallback)(()=>{
        slideAnimationDisabled.current = false;
        if (currentIndex + 1 === props.slides.length) setCurrentIndex(0);
        else setCurrentIndex(currentIndex + 1);
    }, [
        currentIndex,
        props.slides.length
    ]);
    const handleTouchStart = (0, $eeH7J.useCallback)((e)=>{
        var _a, _b;
        if (props.slides.length > 1) {
            setIsPanning(true);
            touchPanStartX.current = (_b = (_a = e.touches[0]) === null || _a === void 0 ? void 0 : _a.clientX) !== null && _b !== void 0 ? _b : null;
            e.stopPropagation();
        }
    }, [
        props.slides.length
    ]);
    const handleTouchMove = (0, $eeH7J.useCallback)((e)=>{
        var _a, _b, _c;
        if (touchPanStartX.current) {
            // No need to update for changes < than a pixel, so floor before checking if moved
            const offset = (_c = Math.floor((touchPanStartX.current - ((_b = (_a = e.touches[0]) === null || _a === void 0 ? void 0 : _a.clientX) !== null && _b !== void 0 ? _b : 0)) * -1)) !== null && _c !== void 0 ? _c : null;
            if (panned !== offset) setPanned(offset);
        }
        e.stopPropagation();
    }, [
        panned
    ]);
    const handleTouchEnd = (0, $eeH7J.useCallback)(()=>{
        // If user has panned more than 1/3 of the carousel, switch to the next slide
        // in the direction they've panned towards
        // Reset restart variables
        slideAnimationDisabled.current = false;
        if (carouselWidth && panned < carouselWidth / 3 * -1 && currentIndex < props.slides.length - 1) setCurrentIndex(currentIndex + 1);
        else if (carouselWidth && panned > carouselWidth / 3 && currentIndex > 0) setCurrentIndex(currentIndex - 1);
        // End of panning, reset state and ref variables
        setIsPanning(false);
        setPanned(0);
        touchPanStartX.current = null;
    }, [
        carouselWidth,
        panned,
        currentIndex,
        props.slides.length
    ]);
    const isMobile = (0, $756948b644e82cf2$export$92c840cda8ec752c).helpers.useMediaQuery("max", "sm");
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsxs)("div", {
            onTouchStart: handleTouchStart,
            onTouchMove: handleTouchMove,
            onTouchEnd: handleTouchEnd,
            onMouseEnter: ()=>{
                setIsPaused(true);
            },
            onMouseLeave: ()=>{
                setIsPaused(false);
            },
            css: (0, $lhaLc.css)({
                display: "flex",
                overflow: "clip",
                width: "100%",
                flexWrap: "nowrap",
                position: "relative",
                touchAction: "pan-y",
                userSelect: "none",
                MozUserSelect: "none",
                msUserSelect: "none",
                WebkitTouchCallout: "none",
                WebkitUserSelect: "none"
            }, (0, $aace75a797ac78f1$export$ae2d933239aa09a1)("lg")),
            ref: carouselRef,
            children: [
                props.slides.map((slide, index)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                        animate: {
                            transform: `translateX(${xOffset}) translateX(${panned}px)`
                        },
                        transition: slideAnimationDisabled.current || isPanning || index < currentIndex - 1 || index > currentIndex + 1 ? {
                            duration: 0
                        } : (0, $7f851218870bc850$export$f1ff28cd2162b6d5).carousel,
                        style: {
                            maxWidth: "100%",
                            flex: "0 0 100%"
                        },
                        children: (0, $4vwom.jsx)($5f9967f24e231168$var$Slide, Object.assign({}, slide))
                    }, slide.id || index)),
                (0, $4vwom.jsx)("div", {
                    css: (0, $lhaLc.css)({
                        position: "absolute",
                        bottom: 10,
                        left: "50%",
                        transform: "translateX(-50%)",
                        display: "flex"
                    }),
                    children: props.slides.length > 1 && props.slides.map((_, index)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                            onClick: ()=>setCurrentIndex(index),
                            animate: {
                                width: props.autoSlide && index === currentIndex ? isMobile ? 16 : 56 : 8
                            },
                            css: (0, $lhaLc.css)({
                                height: 8,
                                backgroundColor: `${currentTheme === "dark" ? colors.grayWhite : colors.gray500}66`,
                                borderRadius: 4,
                                marginRight: 8,
                                overflow: "hidden",
                                ":last-of-type": {
                                    marginRight: 0
                                }
                            }),
                            children: props.autoSlide && index === currentIndex && (0, $4vwom.jsx)("div", {
                                onAnimationEnd: goToNext,
                                css: (0, $lhaLc.css)({
                                    backgroundColor: currentTheme === "dark" ? colors.grayWhite : colors.gray500,
                                    height: "100%"
                                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                                    animationName: props.autoSlide ? $5f9967f24e231168$var$progress : undefined,
                                    animationDuration: `${timePerSlide}ms`,
                                    animationTimingFunction: "linear",
                                    animationPlayState: isPaused ? "paused" : "playing",
                                    borderTopRightRadius: 4,
                                    borderBottomRightRadius: 4
                                }))
                            })
                        }, index))
                })
            ]
        })
    });
}
function $5f9967f24e231168$var$Slide(props) {
    return (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
        as: "section",
        color: props.theme === "dark" ? "grayWhite" : "gray500",
        backgroundColor: props.theme === "dark" ? "gray500" : "sandLight",
        borderRadius: "lg",
        css: (0, $lhaLc.css)({
            position: "relative",
            flexDirection: "column",
            height: 400,
            maxHeight: "100%",
            overflow: "hidden",
            display: "flex",
            flex: "1 0 100%",
            justifyContent: $5f9967f24e231168$var$alignToFlex(props.textAlign)
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
            flexDirection: props.textAlign === "right" ? "row-reverse" : "row"
        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "lg", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(600)
        })),
        children: [
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundPosition: `center ${props.imageSize === "auto" ? "left" : "right"} ${props.imageAlign}%`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: props.imageSize === "cover" ? "cover" : "auto 100%"
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                    top: "40%",
                    backgroundPosition: `bottom left ${props.imageAlign}%`
                }), props.image ? (0, $6a1a23ca93758ec8$export$8b235cefb9710a9e)({
                    image: props.image,
                    width: 1200
                }) : undefined)
            }),
            (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                css: (0, $lhaLc.css)({
                    flex: "1 1 0%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: props.textAlign,
                    zIndex: 1
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                    alignItems: $5f9967f24e231168$var$alignToFlex(props.textAlign),
                    justifyContent: "center"
                }), props.textAlign === "center" && {
                    justifyContent: "center"
                }),
                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: $5f9967f24e231168$var$alignToFlex(props.textAlign),
                    css: (0, $lhaLc.css)({
                        textAlign: "center",
                        alignItems: "center",
                        padding: (0, $756948b644e82cf2$export$981516ee4691055c)(56),
                        paddingBottom: 0
                    }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                        padding: "56px 96px",
                        maxWidth: (0, $756948b644e82cf2$export$981516ee4691055c)(540)
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                        textAlign: props.textAlign,
                        alignItems: $5f9967f24e231168$var$alignToFlex(props.textAlign),
                        padding: 0,
                        paddingLeft: props.textAlign === "center" || props.textAlign === "right" ? 0 : 80,
                        paddingRight: props.textAlign === "center" || props.textAlign === "left" ? 0 : 80,
                        maxWidth: (0, $756948b644e82cf2$export$981516ee4691055c)(360)
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        paddingLeft: props.textAlign === "center" || props.textAlign === "right" ? 0 : (0, $756948b644e82cf2$export$981516ee4691055c)(100),
                        paddingRight: props.textAlign === "center" || props.textAlign === "left" ? 0 : (0, $756948b644e82cf2$export$981516ee4691055c)(100),
                        maxWidth: (0, $756948b644e82cf2$export$981516ee4691055c)(props.textAlign === "center" ? 400 : 540)
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "lg", {
                        textAlign: props.textAlign,
                        alignItems: $5f9967f24e231168$var$alignToFlex(props.textAlign),
                        padding: 0,
                        paddingLeft: props.textAlign === "center" || props.textAlign === "right" ? 0 : (0, $756948b644e82cf2$export$981516ee4691055c)(120),
                        paddingRight: props.textAlign === "center" || props.textAlign === "left" ? 0 : (0, $756948b644e82cf2$export$981516ee4691055c)(120),
                        maxWidth: (0, $756948b644e82cf2$export$981516ee4691055c)(540)
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 1,
                            margin: {
                                bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                            },
                            children: props.heading
                        }),
                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                            size: "lg",
                            margin: {
                                bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                            },
                            children: props.text
                        }),
                        props.cta ? (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                            size: "md",
                            variant: "primary",
                            as: "a",
                            href: props.cta.href,
                            children: props.cta.text
                        }) : null
                    ]
                })
            }),
            props.textAlign !== "center" && (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                css: (0, $lhaLc.css)({
                    flex: "1 1 0%",
                    overflow: "visible",
                    display: "flex",
                    position: "relative",
                    zIndex: 0
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                    alignItems: "flex-end",
                    justifyContent: "flex-end"
                }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                    position: "absolute",
                    height: "50%",
                    width: "100%",
                    bottom: 0
                }))
            })
        ]
    });
}
(0, $eSiQ2.Component)($5f9967f24e231168$export$df5a8e831e8fbbb0, {
    name: "HighlightCarousel",
    gallery: {
        items: [
            {
                title: "Two slides, with auto slide",
                variants: [
                    {
                        props: {
                            autoSlide: true,
                            slides: [
                                {
                                    heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                    text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/md.",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/carousel-highlight-iphone.png`,
                                    textAlign: "left",
                                    theme: "dark",
                                    cta: {
                                        text: "Begynn \xe5 lease",
                                        href: "/"
                                    },
                                    imageSize: "auto"
                                },
                                {
                                    heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                    text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/md.",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/carousel-highlight-light-iphones.png`,
                                    textAlign: "center",
                                    theme: "light",
                                    imageSize: "auto"
                                }
                            ]
                        }
                    }
                ]
            },
            {
                title: "Single slide",
                variants: [
                    {
                        props: {
                            slides: [
                                {
                                    heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                    text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/md.",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/carousel-highlight-light-iphones.png`,
                                    textAlign: "center",
                                    theme: "light",
                                    cta: {
                                        text: "Begynn \xe5 lease",
                                        href: "/"
                                    },
                                    imageSize: "auto"
                                }
                            ]
                        }
                    }
                ]
            },
            {
                title: "Background with right side focus",
                variants: [
                    {
                        props: (state = {
                            left: 0
                        }, setState)=>({
                                slides: [
                                    {
                                        heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                        text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/mnd.",
                                        image: `${(0, $7m9cQ.server)()}/static/redoit/bannerbilde.png`,
                                        textAlign: "left",
                                        imageAlign: state.left,
                                        theme: "light",
                                        cta: {
                                            text: "Begynn \xe5 lease",
                                            url: "/order"
                                        }
                                    }
                                ]
                            }),
                        render: (cmp, state = {
                            left: 0
                        }, setState)=>(0, $4vwom.jsxs)("div", {
                                children: [
                                    (0, $4vwom.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            marginBottom: 12
                                        },
                                        children: [
                                            (0, $4vwom.jsx)("label", {
                                                style: {
                                                    marginRight: 8
                                                },
                                                children: "Alignment:"
                                            }),
                                            (0, $4vwom.jsx)("input", {
                                                type: "range",
                                                min: "0",
                                                max: "100",
                                                value: state.left,
                                                onChange: (e)=>setState({
                                                        left: parseInt(e.target.value)
                                                    })
                                            })
                                        ]
                                    }),
                                    cmp
                                ]
                            })
                    }
                ]
            },
            {
                title: "Two slides, no auto slide",
                variants: [
                    {
                        props: {
                            slides: [
                                {
                                    heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                    text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/md.",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/carousel-highlight-iphone.png`,
                                    textAlign: "left",
                                    theme: "dark",
                                    imageAlign: 90,
                                    cta: {
                                        text: "Begynn \xe5 lease",
                                        href: "/"
                                    },
                                    imageSize: "auto"
                                },
                                {
                                    heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                    text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/md.",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/carousel-highlight-light-iphones.png`,
                                    textAlign: "center",
                                    theme: "light",
                                    imageSize: "auto"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});
function $5f9967f24e231168$var$alignToFlex(align) {
    return align === "left" ? "flex-start" : align === "right" ? "flex-end" : "center";
}


/**
 * @icon ui-arrow-square-right
 */ function $4eef2fa3060ffec2$var$Carousel(section) {
    const localize = (0, $aIeEI.useLocalize)();
    const ctaPageLink = (0, $2e171bb7176b2346$export$3e75343ff9861e57)(section.slides.map((slide)=>{
        var _a, _b;
        return (_b = (_a = slide.cta) === null || _a === void 0 ? void 0 : _a.page) !== null && _b !== void 0 ? _b : null;
    }));
    return (0, $4vwom.jsx)((0, $5f9967f24e231168$export$df5a8e831e8fbbb0), {
        autoSlide: typeof section.timePerSlide !== "undefined",
        timePerSlide: section.timePerSlide ? section.timePerSlide.valueOf() * 1000 : undefined,
        slides: section.slides.map((s, i)=>{
            var _a, _b;
            return {
                id: s.id.valueOf(),
                heading: localize(s.heading),
                text: localize(s.text),
                textAlign: s.textAlign,
                theme: s.theme,
                cta: s.cta ? {
                    text: localize(s.cta.text),
                    href: (_a = ctaPageLink === null || ctaPageLink === void 0 ? void 0 : ctaPageLink[i]) === null || _a === void 0 ? void 0 : _a.path
                } : undefined,
                image: s.image,
                imageSize: s.imageSize,
                imageAlign: (_b = s.imageAlign) === null || _b === void 0 ? void 0 : _b.valueOf()
            };
        })
    });
}
(0, $9G56J.Section)($4eef2fa3060ffec2$var$Carousel);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");


var $4vwom = parcelRequire("4vwom");

var $67cf5539992d1dd3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $67cf5539992d1dd3$export$e6ff31bff12b7ff4(_a) {
    var { color: color } = _a, rest = $67cf5539992d1dd3$var$__rest(_a, [
        "color"
    ]);
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const fillColor = color ? colors[color] : "#000";
    return (0, $4vwom.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1086 268",
        width: 1086,
        height: 268,
        fill: "none"
    }, rest, {
        children: (0, $4vwom.jsx)("path", {
            fill: fillColor,
            d: "M1036.23 263.837c-12.78 0-22.92-1.677-30.42-5.03-7.35-3.354-12.7-8.784-16.053-16.29-3.354-7.506-5.031-17.726-5.031-30.662V107.172h-37.369V71.24h26.11c2.556 0 4.632-.399 6.229-1.197 1.756-.959 3.034-2.316 3.832-4.073.959-1.757 1.438-3.833 1.438-6.228V27.163h42.404V71.24h57.73v35.932h-57.26v102.767c0 7.506 1.28 12.536 3.84 15.091 2.55 2.555 7.42 3.833 14.61 3.833h38.81v34.974h-48.87ZM880.304 71.238h43.119v192.597h-43.119V71.238Zm21.56-18.924c-6.388 0-11.659-.878-15.811-2.635-3.992-1.916-7.026-4.791-9.102-8.624-1.917-3.833-2.875-8.703-2.875-14.612 0-6.069.958-11.02 2.875-14.852 2.076-3.833 5.11-6.628 9.102-8.384 4.152-1.917 9.423-2.875 15.811-2.875 6.387 0 11.578.958 15.57 2.875 4.152 1.756 7.187 4.551 9.103 8.384 2.076 3.833 3.114 8.783 3.114 14.852 0 5.909-1.038 10.78-3.114 14.612-1.916 3.833-4.951 6.708-9.103 8.624-3.992 1.757-9.183 2.635-15.57 2.635ZM756.652 267.663c-19.483 0-36.571-4.152-51.263-12.456-14.532-8.304-25.791-20.042-33.776-35.214-7.825-15.331-11.738-33.217-11.738-53.659 0-19.962 3.913-37.369 11.738-52.221 7.985-15.012 19.244-26.51 33.776-34.495 14.692-8.145 31.78-12.217 51.263-12.217 19.484 0 36.571 4.072 51.264 12.217 14.692 7.985 25.951 19.483 33.776 34.495 7.985 14.852 11.978 32.259 11.978 52.221 0 20.442-3.993 38.328-11.978 53.659-7.825 15.172-19.084 26.91-33.776 35.214-14.693 8.304-31.78 12.456-51.264 12.456Zm0-35.932c16.929 0 30.104-5.669 39.526-17.008 9.582-11.498 14.373-27.468 14.373-47.909 0-19.963-4.791-35.533-14.373-46.712-9.422-11.179-22.597-16.769-39.526-16.769-16.928 0-30.103 5.59-39.525 16.769-9.422 11.179-14.133 26.749-14.133 46.712 0 20.441 4.711 36.411 14.133 47.909 9.422 11.339 22.597 17.008 39.525 17.008ZM533.521 267.668c-17.087 0-32.179-3.913-45.274-11.738-13.096-7.985-23.316-19.403-30.662-34.255-7.187-14.852-10.78-32.499-10.78-52.94v-.719c0-20.921 3.433-38.887 10.301-53.898 7.026-15.172 17.007-26.75 29.943-34.735 13.095-7.985 28.586-11.977 46.472-11.977 19.484 0 35.214 4.87 47.191 14.612 12.138 9.582 21.32 24.514 27.548 44.796h-13.175V8.237h43.119v255.598l-43.358.24.958-60.606 19.164.24c-6.708 15.171-14.054 27.468-22.039 36.89-7.985 9.422-16.848 16.289-26.589 20.601-9.742 4.312-20.681 6.468-32.819 6.468Zm8.624-35.693c16.449 0 29.225-5.669 38.328-17.008 9.262-11.498 13.894-27.468 13.894-47.909 0-20.122-4.632-35.773-13.894-46.952-9.103-11.179-21.879-16.768-38.328-16.768s-29.225 5.669-38.328 17.008c-9.102 11.179-13.654 26.909-13.654 47.191 0 20.282 4.552 36.092 13.654 47.43 9.103 11.339 21.879 17.008 38.328 17.008ZM336.508 267.663c-19.324 0-36.092-4.152-50.306-12.456-14.213-8.304-25.152-20.042-32.818-35.214-7.506-15.171-11.259-32.738-11.259-52.7 0-20.122 3.913-37.689 11.738-52.701 7.826-15.171 18.925-26.83 33.298-34.974 14.532-8.145 31.46-12.217 50.784-12.217 18.365 0 34.255 3.753 47.67 11.259 13.574 7.346 24.114 18.525 31.62 33.537 7.506 14.852 11.259 33.137 11.259 54.856v12.457H263.445v-29.944h129.356l-4.072 16.529c0-21.4-4.392-37.609-13.175-48.628-8.784-11.179-21.799-16.769-39.046-16.769-16.769 0-29.784 5.19-39.047 15.571-9.262 10.38-13.894 25.152-13.894 44.316l-.239 3.114c0 24.275 5.19 42.001 15.57 53.18 10.541 11.019 24.355 16.529 41.442 16.529 14.533 0 25.233-3.274 32.1-9.822 7.026-6.707 11.817-15.171 14.373-25.392h40.483c-2.395 15.331-7.985 28.187-16.768 38.568-8.784 10.38-19.643 18.125-32.579 23.236-12.776 5.11-26.59 7.665-41.441 7.665ZM.903 5.607H140.8c17.727 0 33.218 3.274 46.473 9.822 13.414 6.548 23.715 15.89 30.901 28.027 7.187 11.977 10.78 26.031 10.78 42.16 0 13.415-2.875 25.153-8.624 35.214-5.589 9.901-13.574 17.567-23.955 22.997-10.38 5.43-22.517 8.144-36.411 8.144v-2.395c16.13 0 28.586 2.076 37.37 6.228 8.943 4.152 15.011 9.502 18.205 16.05 3.194 6.548 4.791 14.053 4.791 22.517v69.469h-43.118v-64.917c0-8.304-1.518-14.852-4.552-19.643-2.874-4.791-7.346-8.225-13.415-10.301-6.068-2.076-14.053-3.114-23.954-3.114h-34.256l5.27-9.103 45.514 56.534h-41.681l-51.742-64.678 51.503-64.678h41.92l-45.514 56.533-5.27-9.582h37.849c14.532 0 26.031-4.072 34.495-12.217 8.624-8.144 12.935-19.084 12.935-32.818 0-14.053-4.711-24.993-14.133-32.818-9.262-7.985-22.278-11.977-39.046-11.977H44.022V263.84H.903V5.607Z",
            style: {
                fill: fillColor,
                fillOpacity: 1
            }
        })
    }));
}






var $eeH7J = parcelRequire("eeH7J");

var $dUDPg = parcelRequire("dUDPg");
parcelRequire("2LTO8");
var $iXeBy = parcelRequire("iXeBy");
/**
 * Section displaying logo and some links on the bottom of the page.
 *
 * @icon ui-flex-align-bottom
 */ function $f25dbc93d677f9bb$var$Footer(section) {
    var _a, _b;
    const localize = (0, $aIeEI.useLocalize)();
    const footer = (0, $e18f565b44c7bc7d$export$d07da6ac6fc160b0)();
    const currentLocale = (0, $aIeEI.useCurrentLocale)();
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const footerItems = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return ((_a = footer.data) === null || _a === void 0 ? void 0 : _a.items.map((item)=>{
            const localePath = currentLocale === defaultLocale ? "" : `/${currentLocale}`;
            const path = item.slug ? `${localePath}/${localize(item.slug)}` : "/";
            const fragment = item.section ? `#${item.section}` : "";
            const href = item.url && !item.slug ? item.url : (0, $iXeBy.Url)(`${path}${fragment}`);
            return {
                id: item.id.valueOf(),
                href: item.slug || item.section || item.url ? href : undefined,
                text: localize(item.text)
            };
        })) || [];
    }, [
        (_b = footer.data) === null || _b === void 0 ? void 0 : _b.items,
        currentLocale,
        defaultLocale,
        localize
    ]);
    if (!footer.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)("div", {
        css: (0, $lhaLc.css)({
            paddingTop: (0, $1c2a8fb378443a1d$export$dd07c5170cc9e3b1).xs,
            paddingBottom: (0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingBottom
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
            paddingTop: (0, $1c2a8fb378443a1d$export$dd07c5170cc9e3b1).md,
            paddingBottom: (0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).md.paddingBottom
        })),
        children: [
            (0, $4vwom.jsx)((0, $67cf5539992d1dd3$export$e6ff31bff12b7ff4), {
                css: (0, $lhaLc.css)({
                    width: "100%",
                    height: "auto"
                })
            }),
            (0, $4vwom.jsxs)("div", {
                css: (0, $lhaLc.css)({
                    display: "flex",
                    marginTop: 32,
                    flexDirection: "column"
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 24
                })),
                children: [
                    (0, $4vwom.jsx)("div", {
                        css: (0, $lhaLc.css)({
                            display: "grid",
                            gap: 16
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            gridAutoFlow: "column",
                            gap: 24
                        })),
                        children: footerItems.map((item)=>{
                            var _a;
                            return (0, $4vwom.jsx)("a", {
                                href: (_a = item.href) === null || _a === void 0 ? void 0 : _a.valueOf(),
                                style: {
                                    cursor: "pointer"
                                },
                                children: (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                    size: "md",
                                    children: item.text
                                })
                            }, item.id.valueOf());
                        })
                    }),
                    (0, $4vwom.jsx)("div", {
                        css: (0, $lhaLc.css)({
                            opacity: 0.6,
                            textAlign: "right",
                            marginTop: 32
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            marginTop: 0
                        })),
                        children: (0, $4vwom.jsxs)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                            size: "md",
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " Redoit \xb7 All rights reserved"
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
(0, $9G56J.Section)($f25dbc93d677f9bb$var$Footer);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");



var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");




var $4vwom = parcelRequire("4vwom");

var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");



"use client";
/**
 * `MotionConfig` is used to set configuration options for all children `motion` components.
 *
 * ```jsx
 * import { motion, MotionConfig } from "framer-motion"
 *
 * export function App() {
 *   return (
 *     <MotionConfig transition={{ type: "spring" }}>
 *       <motion.div animate={{ x: 100 }} />
 *     </MotionConfig>
 *   )
 * }
 * ```
 *
 * @public
 */ function $4292e3b361a44985$export$caa69d61d2de10d9({ children: children, isValidProp: isValidProp, ...config }) {
    isValidProp && (0, $d3983d2add71cd91$export$59d6962c470509a5)(isValidProp);
    /**
     * Inherit props from any parent MotionConfig components
     */ config = {
        ...(0, $eeH7J.useContext)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d)),
        ...config
    };
    /**
     * Don't allow isStatic to change between renders as it affects how many hooks
     * motion components fire.
     */ config.isStatic = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(()=>config.isStatic);
    /**
     * Creating a new config context object will re-render every `motion` component
     * every time it renders. So we only want to create a new one sparingly.
     */ const context = (0, $eeH7J.useMemo)(()=>config, [
        JSON.stringify(config.transition),
        config.transformPagePoint,
        config.reducedMotion
    ]);
    return (0, $dRzna.jsx)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d).Provider, {
        value: context,
        children: children
    });
}



var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");






parcelRequire("2LTO8");
var $gGZ2r = parcelRequire("gGZ2r");



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");


var $eeH7J = parcelRequire("eeH7J");
function $785176c560affa66$export$f3a192d0cbd30b96(callback) {
    return (0, $eeH7J.useEffect)(()=>()=>callback(), []);
}






function $796736c2678ffd9a$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}







function $5409af5f0cd4392d$export$f2911d8192f464a8(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $cd7f8f0ad0976f3a$export$17eda790a720ec57)(element) ? new (0, $b30b20e17f4658dd$export$86bcdffbaf733d84)(options) : new (0, $dc98d0848c7498cf$export$23fea75b03ac16b3)(options);
    node.mount(element);
    (0, $64861684472349e0$export$bc2a978a17abfdde).set(element, node);
}






/**
 * Create a progress => progress easing function from a generator.
 */ function $125374a79ac9fd53$export$7f1511d09ee75a99(options, scale = 100) {
    const generator = (0, $f2ee4de28e47ead0$export$b36281d89752ae66)({
        keyframes: [
            0,
            scale
        ],
        ...options
    });
    const duration = Math.min((0, $63989eadef3836dd$export$cbdd6b3d40ea54e2)(generator), (0, $63989eadef3836dd$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>generator.next(duration * progress).value / scale,
        duration: (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(duration)
    };
}








/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $55b280437a57388f$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}


const $808faea7a4cc1063$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};



function $d1ef1ece22d99d8c$export$41c5e731255a462(easing, i) {
    return (0, $cdb960b4abd00d82$export$216948827bbdc797)(easing) ? easing[(0, $808faea7a4cc1063$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}




function $65b1287f681ccaf3$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $51a4ba498ba1dae1$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $65b1287f681ccaf3$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $65b1287f681ccaf3$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(startTime, endTime, offset[i]),
        easing: (0, $d1ef1ece22d99d8c$export$41c5e731255a462)(easing, i)
    });
}


function $c7a24a15c230270c$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}


const $463f5e123a487b82$var$defaultSegmentEasing = "easeInOut";
function $463f5e123a487b82$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $55b280437a57388f$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $55b280437a57388f$export$83ccd85155ba9791)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numElements = 0)=>{
            const valueKeyframesAsList = $463f5e123a487b82$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $8866a142868d9f49$export$24dbcec0b26e6d9d)(valueKeyframesAsList), type: type = "keyframes", ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numElements) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            if (numKeyframes <= 2 && type === "spring") {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $463f5e123a487b82$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(duration);
                const springEasing = (0, $125374a79ac9fd53$export$7f1511d09ee75a99)(springTransition, absoluteDelta);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            const startTime = currentTime + calculatedDelay;
            const targetTime = startTime + duration;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $90bfe69fb9e7beb2$export$dafee61230cf05c6)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $65b1287f681ccaf3$export$89dfa6760a9f76e7)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(subject)) {
            const subjectSequence = $463f5e123a487b82$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $463f5e123a487b82$var$getValueSequence("default", subjectSequence));
        } else {
            /**
             * Find all the elements specified in the definition and parse value
             * keyframes from their timeline definitions.
             */ const elements = (0, $b93688f4b1374f47$export$90ceba2564a894f8)(subject, scope, elementCache);
            const numElements = elements.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let elementIndex = 0; elementIndex < numElements; elementIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                const element = elements[elementIndex];
                const subjectSequence = $463f5e123a487b82$var$getSubjectSequence(element, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $463f5e123a487b82$export$7c1391340308742e(transition, key), $463f5e123a487b82$var$getValueSequence(key, subjectSequence), elementIndex, numElements);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $c7a24a15c230270c$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $482d3e1965098f2a$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($463f5e123a487b82$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            definition.transition[key] = {
                ...defaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $463f5e123a487b82$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $463f5e123a487b82$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $463f5e123a487b82$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $463f5e123a487b82$export$7c1391340308742e(transition, key) {
    return transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $463f5e123a487b82$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $463f5e123a487b82$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($463f5e123a487b82$var$isNumber);



function $b53be6a7dd33d25f$var$animateElements(elementOrSelector, keyframes, options, scope) {
    const elements = (0, $b93688f4b1374f47$export$90ceba2564a894f8)(elementOrSelector, scope);
    const numElements = elements.length;
    (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(Boolean(numElements), "No valid element provided.");
    const animations = [];
    for(let i = 0; i < numElements; i++){
        const element = elements[i];
        /**
         * Check each element for an associated VisualElement. If none exists,
         * we need to create one.
         */ if (!(0, $64861684472349e0$export$bc2a978a17abfdde).has(element)) /**
             * TODO: We only need render-specific parts of the VisualElement.
             * With some additional work the size of the animate() function
             * could be reduced significantly.
             */ (0, $5409af5f0cd4392d$export$f2911d8192f464a8)(element);
        const visualElement = (0, $64861684472349e0$export$bc2a978a17abfdde).get(element);
        const transition = {
            ...options
        };
        /**
         * Resolve stagger function if provided.
         */ if (typeof transition.delay === "function") transition.delay = transition.delay(i, numElements);
        animations.push(...(0, $71617090e716925b$export$68cacfeee78d98d2)(visualElement, {
            ...keyframes,
            transition: transition
        }, {}));
    }
    return new (0, $ea560ce4dcc095f2$export$c1e41718f71efe41)(animations);
}
const $b53be6a7dd33d25f$var$isSequence = (value)=>Array.isArray(value) && Array.isArray(value[0]);
function $b53be6a7dd33d25f$var$animateSequence(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = (0, $463f5e123a487b82$export$1f0f44b51a4b2f73)(sequence, options, scope);
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        let animation;
        if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(subject)) animation = (0, $0840febc4398c738$export$335a17c977067b99)(subject, keyframes.default, transition.default);
        else animation = $b53be6a7dd33d25f$var$animateElements(subject, keyframes, transition);
        animations.push(animation);
    });
    return new (0, $ea560ce4dcc095f2$export$c1e41718f71efe41)(animations);
}
const $b53be6a7dd33d25f$export$c17e592002be9b90 = (scope)=>{
    /**
     * Implementation
     */ function scopedAnimate(valueOrElementOrSequence, keyframes, options) {
        let animation;
        if ($b53be6a7dd33d25f$var$isSequence(valueOrElementOrSequence)) animation = $b53be6a7dd33d25f$var$animateSequence(valueOrElementOrSequence, keyframes, scope);
        else if ((0, $796736c2678ffd9a$export$d276bfce3b1077ca)(keyframes)) animation = $b53be6a7dd33d25f$var$animateElements(valueOrElementOrSequence, keyframes, options, scope);
        else animation = (0, $0840febc4398c738$export$335a17c977067b99)(valueOrElementOrSequence, keyframes, options);
        if (scope) scope.animations.push(animation);
        return animation;
    }
    return scopedAnimate;
};
const $b53be6a7dd33d25f$export$e3607ec2d7a891c4 = $b53be6a7dd33d25f$export$c17e592002be9b90();


function $4c4e7486a769eecb$export$9f387b98a73b1511() {
    const scope = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(()=>({
            current: null,
            animations: []
        }));
    const animate = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(()=>(0, $b53be6a7dd33d25f$export$c17e592002be9b90)(scope));
    (0, $785176c560affa66$export$f3a192d0cbd30b96)(()=>{
        scope.animations.forEach((animation)=>animation.stop());
    });
    return [
        scope,
        animate
    ];
}



var $eeH7J = parcelRequire("eeH7J");
function $efb0893865373669$export$6eb0f7ddcda6131f({ collapsed: collapsed, children: children }) {
    const containerRef = (0, $eeH7J.useRef)(null);
    const [scope, animate] = (0, $4c4e7486a769eecb$export$9f387b98a73b1511)();
    const [autoHeight, setAutoHeight] = (0, $eeH7J.useState)(false);
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        if (!((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight)) return;
        const height = containerRef.current.clientHeight;
        setAutoHeight(false);
        animate(scope.current, {
            height: collapsed ? 0 : `${height}px`,
            opacity: collapsed ? 0 : 1
        }).then(()=>{
            if (!collapsed) setAutoHeight(true);
        });
    }, [
        animate,
        collapsed,
        scope
    ]);
    return (0, $4vwom.jsx)("div", {
        ref: scope,
        css: (0, $lhaLc.css)({
            overflow: collapsed ? "hidden" : "visible",
            height: autoHeight ? "auto !important" : undefined
        }),
        children: (0, $4vwom.jsx)("div", {
            ref: containerRef,
            children: children
        })
    });
}



function $931621612d6fcf0d$export$eb463a824a473e05(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
        transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
        children: (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
            onClick: props.onClick,
            borderRadius: "md",
            motion: {
                initial: {
                    backgroundColor: props.isOpen ? colors.gray100 : colors.grayWhite,
                    borderColor: props.isOpen ? colors.gray100 : colors.gray200
                },
                animate: {
                    backgroundColor: props.isOpen ? colors.gray100 : colors.grayWhite,
                    borderColor: props.isOpen ? colors.gray100 : colors.gray200
                }
            },
            css: (0, $lhaLc.css)({
                borderStyle: "solid",
                borderWidth: 1,
                padding: 24,
                cursor: "pointer",
                overflow: "clip",
                transition: (0, $7f851218870bc850$export$d5639c01d489b0c)([
                    "border-color"
                ], 200),
                "&:hover": {
                    borderColor: !props.isOpen ? `${colors.gray300} !important` : "transparent"
                }
            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                paddingTop: "calc(40px * var(--scale-factor))",
                paddingBottom: "calc(40px * var(--scale-factor))"
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    justifyContent: "space-between",
                    children: [
                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                            size: "lg",
                            children: props.question
                        }),
                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                            icon: props.isOpen ? "arrowUp" : "arrowDown",
                            margin: {
                                left: 20
                            }
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    initial: {
                        marginTop: props.isOpen ? "calc(20px * var(--scale-factor))" : 0
                    },
                    animate: {
                        marginTop: props.isOpen ? "calc(20px * var(--scale-factor))" : 0
                    },
                    children: (0, $4vwom.jsx)((0, $efb0893865373669$export$6eb0f7ddcda6131f), {
                        collapsed: !props.isOpen,
                        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "md",
                            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: props.answer
                            })
                        })
                    })
                })
            ]
        })
    });
}
(0, $eSiQ2.Component)($931621612d6fcf0d$export$eb463a824a473e05, {
    name: "FaqItem",
    gallery: {
        path: "Blocks/FAQ",
        items: [
            {
                variants: [
                    {
                        label: "Closed state",
                        props: (state = {
                            isOpen: false
                        }, setState)=>({
                                question: "How does this work?",
                                answer: (0, $gGZ2r.Markdown)("Proin consectetur nunc non augue rhoncus, eget scelerisque massa tempor. Integer tincidunt, leo eget sagittis eleifend, turpis magna vehicula massa, sed pharetra arcu tellus eget tortor."),
                                isOpen: state.isOpen,
                                onClick: ()=>{
                                    setState({
                                        isOpen: !state.isOpen
                                    });
                                }
                            })
                    }
                ]
            },
            {
                variants: [
                    {
                        label: "Open state",
                        props: (state = {
                            isOpen: true
                        }, setState)=>({
                                question: "More questions?",
                                answer: (0, $gGZ2r.Markdown)("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed porta, magna eu efficitur pretium, nisi tellus gravida mauris, vel venenatis sem magna nec massa. Vivamus laoreet, dui vitae elementum viverra, mauris nisl aliquam erat, in feugiat purus lorem ac odio. Fusce venenatis vel dui at vestibulum. Praesent ut lectus a felis ullamcorper auctor. Etiam non malesuada diam. In hac habitasse platea dictumst. Praesent in dolor rhoncus, euismod sapien nec, rhoncus justo. Duis vitae arcu ligula."),
                                isOpen: state.isOpen,
                                onClick: ()=>{
                                    setState({
                                        isOpen: !state.isOpen
                                    });
                                }
                            })
                    }
                ]
            }
        ]
    }
});


function $27039c694c31ccef$export$91f5553634f65df6(props) {
    var _a;
    const [openQuestions, setOpenQuestions] = (0, $eeH7J.useState)([]);
    const [showAll, setShowAll] = (0, $eeH7J.useState)(false);
    const handleClick = (0, $eeH7J.useCallback)((id)=>()=>{
            const alreadyOpen = openQuestions.includes(id);
            setOpenQuestions(alreadyOpen ? openQuestions.filter((q)=>q !== id) : [
                ...openQuestions,
                id
            ]);
        }, [
        openQuestions
    ]);
    const containerRef = (0, $eeH7J.useRef)(null);
    const [restQuestionsHeight, setRestQuestionsHeight] = (0, $eeH7J.useState)(0);
    const updateHeight = (0, $eeH7J.useCallback)(()=>{
        var _a;
        setRestQuestionsHeight(((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0);
    }, []);
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        if (showAll && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight)) updateHeight();
    }, [
        showAll,
        updateHeight
    ]);
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                justifyContent: "space-between",
                css: (0, $lhaLc.css)({
                    marginBottom: 16
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    marginBottom: 24
                })),
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        children: props.heading
                    }),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        shrink: 0,
                        margin: {
                            left: 16
                        },
                        css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                            display: "none"
                        }),
                        children: typeof props.maxInitialQuestions === "number" && props.questions.length > props.maxInitialQuestions ? (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                            size: "sm",
                            variant: "secondary",
                            onClick: ()=>setShowAll(true),
                            disabled: showAll,
                            children: props.showAllButtonText
                        }) : null
                    })
                ]
            }),
            props.questions.slice(0, (_a = props.maxInitialQuestions) !== null && _a !== void 0 ? _a : props.questions.length).map((q)=>(0, $4vwom.jsx)("div", {
                    onClick: handleClick(q.id),
                    css: (0, $lhaLc.css)({
                        marginBottom: 8,
                        "&:last-of-type": {
                            marginBottom: 0
                        }
                    }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        marginBottom: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                    })),
                    children: (0, $4vwom.jsx)((0, $931621612d6fcf0d$export$eb463a824a473e05), {
                        question: q.question,
                        answer: q.answer,
                        isOpen: openQuestions.includes(q.id)
                    })
                }, q.id.valueOf())),
            showAll && (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                initial: {
                    height: 0
                },
                animate: {
                    height: restQuestionsHeight
                },
                onAnimationComplete: ()=>{
                    var _a;
                    // After animation is done, set height to auto, to automatically get the
                    // correct height when opening questions or window is resized.
                    setRestQuestionsHeight("auto");
                    (_a = containerRef.current) === null || _a === void 0 || _a.scrollIntoView({
                        behavior: "smooth",
                        block: "end"
                    });
                },
                children: (0, $4vwom.jsx)("div", {
                    ref: containerRef,
                    style: {
                        scrollMarginBottom: 24
                    },
                    children: props.questions.slice(props.maxInitialQuestions, props.questions.length).map((q, index)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                            initial: {
                                opacity: 0,
                                transform: `translateY(-${index + 80}px)`
                            },
                            animate: {
                                opacity: 1,
                                transform: "translateY(0px)"
                            },
                            onAnimationComplete: ()=>{},
                            onClick: handleClick(q.id),
                            css: (0, $lhaLc.css)({
                                marginBottom: 8,
                                "&:last-of-type": {
                                    marginBottom: 0
                                }
                            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                marginBottom: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                            })),
                            children: (0, $4vwom.jsx)((0, $931621612d6fcf0d$export$eb463a824a473e05), {
                                question: q.question,
                                answer: q.answer,
                                isOpen: openQuestions.includes(q.id)
                            })
                        }, q.id.valueOf()))
                })
            }),
            typeof props.maxInitialQuestions === "number" && props.questions.length > props.maxInitialQuestions ? (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                size: "sm",
                variant: "dark",
                onClick: ()=>setShowAll(true),
                disabled: showAll,
                fullwidth: true,
                margin: {
                    top: 8
                },
                css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                    display: "none"
                }),
                children: props.showAllButtonText
            }) : null
        ]
    });
}




/**
 * @icon ui-message-question-circle
 */ function $d4b0be373b0d3669$var$FrequentlyAskedQuestions(section) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const frequentlyAskedQuestions = (0, $e18f565b44c7bc7d$export$6eb271ef04c4063b)();
    if (!frequentlyAskedQuestions.loading && !frequentlyAskedQuestions.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: ((_a = frequentlyAskedQuestions.data) === null || _a === void 0 ? void 0 : _a.questions.length) && (0, $4vwom.jsx)((0, $27039c694c31ccef$export$91f5553634f65df6), {
            heading: localize(section.heading),
            questions: frequentlyAskedQuestions.data.questions.map((item)=>({
                    id: item.id,
                    question: localize(item.question),
                    answer: localize(item.answer)
                })),
            showAllButtonText: localize(section.showAllButtonText),
            maxInitialQuestions: section.maxInitialQuestions.valueOf()
        })
    });
}
(0, $9G56J.Section)($d4b0be373b0d3669$var$FrequentlyAskedQuestions);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $9G56J = parcelRequire("9G56J");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");




const $06eb0d21a8b1f440$var$lightTextColorBackgrounds = [
    "gray350",
    "gray400",
    "gray500",
    "forest",
    "brand",
    "brandDark",
    "vippsOrange",
    "sky",
    "sand",
    "warning",
    "error"
];
const { colors: $06eb0d21a8b1f440$export$8f45430ccf837300 } = (0, $756948b644e82cf2$export$92c840cda8ec752c);
function $06eb0d21a8b1f440$export$ae620eaddefec402(backgroundColor) {
    if ($06eb0d21a8b1f440$var$lightTextColorBackgrounds.includes(backgroundColor)) return "grayWhite";
    return "gray500";
}




function $192171ee7c657b77$export$14834abbfce3b8cd(props) {
    var _a;
    const theme = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = theme.helpers;
    const backgroundColor = (_a = props.color) !== null && _a !== void 0 ? _a : "forest";
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        backgroundColor: backgroundColor,
        color: (0, $06eb0d21a8b1f440$export$ae620eaddefec402)(backgroundColor),
        alignItems: "center",
        gap: 8,
        style: props.full ? {
            width: "100vw",
            marginLeft: "calc(50% - 50vw)"
        } : {
            borderRadius: 16,
            justifyContent: "flex-start"
        },
        css: (0, $lhaLc.css)({
            padding: `${props.full ? 20 : 16}px 16px`
        }, responsiveCss("min", "md", {
            padding: props.full ? "12px 24px" : 16
        })),
        children: [
            props.icon ? (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: props.icon
            }) : null,
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                grow: 1,
                justifyContent: props.full ? "center" : "flex-start",
                style: {
                    textAlign: "left"
                },
                children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                    value: props.text,
                    renderers: {
                        paragraph: (p)=>(0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: p.children
                            })
                    }
                })
            }),
            props.onClose && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                justifyContent: "center",
                children: (0, $4vwom.jsx)("button", {
                    style: {
                        marginLeft: 40
                    },
                    onClick: props.onClose,
                    children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: "close",
                        color: "gray100"
                    })
                })
            })
        ]
    });
}




var $aIeEI = parcelRequire("aIeEI");
/**
 * @icon ui-announcement-03
 */ function $671abeb8be446186$var$FullNotification(section) {
    var _a;
    const notificationsClosed = (0, $e18f565b44c7bc7d$export$b1798547582b81c2)();
    const [justClosed, setJustClosed] = (0, $eeH7J.useState)(false);
    const localize = (0, $aIeEI.useLocalize)();
    const handleClose = (0, $eeH7J.useCallback)(async ()=>{
        (0, $e18f565b44c7bc7d$export$87c93287defb9514)({
            id: section.id.valueOf()
        });
        setJustClosed(true);
    }, [
        section.id
    ]);
    return ((_a = notificationsClosed.data) === null || _a === void 0 ? void 0 : _a.includes(section.id.valueOf())) || justClosed ? (0, $4vwom.jsx)((0, $4vwom.Fragment), {}) : (0, $4vwom.jsx)((0, $192171ee7c657b77$export$14834abbfce3b8cd), {
        full: true,
        color: section.color,
        onClose: section.allowClose ? handleClose : undefined,
        text: typeof section.text === "string" ? section.text : localize(section.text)
    });
}
(0, $9G56J.Section)($671abeb8be446186$var$FullNotification);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5K1mb = parcelRequire("5K1mb");
var $18Pjr = parcelRequire("18Pjr");

var $lhaLc = parcelRequire("lhaLc");


var $dUDPg = parcelRequire("dUDPg");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $7FrRx = parcelRequire("7FrRx");






var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $4vwom = parcelRequire("4vwom");

var $eSiQ2 = parcelRequire("eSiQ2");

var $34f1974b2dd65db4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $34f1974b2dd65db4$export$7998e98dfdedb157(_a) {
    var { css: css } = _a, rest = $34f1974b2dd65db4$var$__rest(_a, [
        "css"
    ]);
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, rest, {
        children: (0, $4vwom.jsx)("path", {
            fill: colors._trustpilot,
            d: "m11.566 17.252 4.591-1.164L18.076 22l-6.51-4.748ZM22.132 9.61H14.05L11.566 2 9.082 9.61H1l6.54 4.717-2.483 7.61 6.54-4.717 4.026-2.893 6.51-4.717Z"
        })
    }));
}
function $34f1974b2dd65db4$export$681b028df1bc0b68(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    /**
     * Colors for different ratings. 0 is default background color for stars > rating, the rest is for
     * all filled stars for ratings 1-5.
     */ const ratingColors = [
        "#dcdce6",
        "#ff3722",
        "#ff8622",
        "#ffce00",
        "#73cf11",
        colors._trustpilot
    ];
    if (props.rating < 0 || props.rating > 5) // eslint-disable-next-line no-console
    console.warn("Prop `rating` should be between 1 and 5.");
    return (0, $4vwom.jsx)("div", {
        style: {
            display: "grid",
            gap: 2,
            gridAutoFlow: "column"
        },
        children: [
            1,
            2,
            3,
            4,
            5
        ].map((i)=>(0, $4vwom.jsx)("div", {
                style: {
                    display: "flex",
                    height: 20,
                    width: 20,
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: i > props.rating ? ratingColors[0] : ratingColors[props.rating]
                },
                children: (0, $4vwom.jsx)("svg", Object.assign({
                    xmlns: "http://www.w3.org/2000/svg",
                    width: 14,
                    height: 14,
                    viewBox: "0 0 14 14"
                }, props, {
                    children: (0, $4vwom.jsx)("path", {
                        fill: "#fff",
                        d: "m7 10.676 3.042-.814L11.312 14 7 10.676Zm7-5.349H8.646L7 0 5.354 5.327H0l4.333 3.302-1.646 5.327 4.334-3.302L9.688 8.63 14 5.327Z"
                    })
                }))
            }, i))
    });
}
(0, $eSiQ2.Component)($34f1974b2dd65db4$export$681b028df1bc0b68, {
    name: "TrustpilotStars",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            rating: 1
                        }
                    },
                    {
                        props: {
                            rating: 2
                        }
                    },
                    {
                        props: {
                            rating: 3
                        }
                    },
                    {
                        props: {
                            rating: 4
                        }
                    },
                    {
                        props: {
                            rating: 5
                        }
                    }
                ]
            }
        ]
    }
});





var $d459a7d0faaadece$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d459a7d0faaadece$export$3f8d6a825279800d(_a) {
    var { as: as, score: score, text: text } = _a, rest = $d459a7d0faaadece$var$__rest(_a, [
        "as",
        "score",
        "text"
    ]);
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const style = {
        default: {
            color: colors.gray500,
            borderColor: colors.gray200
        },
        hover: {
            borderColor: colors.gray400
        },
        focus: {
            borderColor: colors.gray500
        }
    };
    const El = as !== null && as !== void 0 ? as : "div";
    return (0, $4vwom.jsxs)(El, Object.assign({
        css: (0, $lhaLc.css)({
            display: "flex",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: 1,
            height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            borderRadius: 24,
            paddingLeft: 16,
            paddingRight: 16,
            paddingBottom: 1,
            backgroundColor: colors.grayWhite
        }, (0, $aace75a797ac78f1$export$70aad56e3e56b3f3)("4"), style.default)
    }, rest, {
        children: [
            score.toString().replace(".", ","),
            (0, $4vwom.jsx)((0, $34f1974b2dd65db4$export$7998e98dfdedb157), {
                css: (0, $lhaLc.css)({
                    marginLeft: 6,
                    marginRight: 6
                })
            }),
            text
        ]
    }));
}




var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $eSiQ2 = parcelRequire("eSiQ2");

var $34lt5 = parcelRequire("34lt5");

var $4vwom = parcelRequire("4vwom");
function $7d490944797b9db6$export$48ea269755562084(props) {
    switch(props.flag){
        case "en":
            return (0, $4vwom.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: 22,
                height: 16,
                fill: "none",
                style: props.style,
                children: [
                    (0, $4vwom.jsxs)("g", {
                        clipPath: "url(#a)",
                        children: [
                            (0, $4vwom.jsx)("rect", {
                                width: 21,
                                height: 15,
                                x: 0.5,
                                y: 0.5,
                                fill: "#1A47B8",
                                rx: 3
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#fff",
                                fillRule: "evenodd",
                                d: "M2.734.5H.5V3l18.754 12.5H21.5V13L2.734.5Z",
                                clipRule: "evenodd"
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#F93939",
                                d: "M1.245.5 21.5 14.035V15.5h-.728L.5 1.95V.5h.745Z"
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#fff",
                                fillRule: "evenodd",
                                d: "M19.5.5h2V3s-12.99 8.328-19 12.5h-2V13L19.5.5Z",
                                clipRule: "evenodd"
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#F93939",
                                d: "M21.5.5h-.678L.5 14.047V15.5h.745L21.5 1.962V.5Z"
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#fff",
                                fillRule: "evenodd",
                                d: "M8.137.5h5.743v4.627h7.62v5.743h-7.62v4.63H8.137v-4.63H.5V5.127h7.637V.5Z",
                                clipRule: "evenodd"
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#F93939",
                                fillRule: "evenodd",
                                d: "M9.342.5h3.316v5.77H21.5v3.46h-8.842v5.77H9.342V9.73H.5V6.27h8.842V.5Z",
                                clipRule: "evenodd"
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)("defs", {
                        children: (0, $4vwom.jsx)("clipPath", {
                            id: "a",
                            children: (0, $4vwom.jsx)("rect", {
                                width: 21,
                                height: 15,
                                x: 0.5,
                                y: 0.5,
                                fill: "#fff",
                                rx: 3
                            })
                        })
                    })
                ]
            });
        case "no":
            return (0, $4vwom.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 22 16",
                width: 22,
                height: 16,
                fill: "none",
                style: props.style,
                children: [
                    (0, $4vwom.jsxs)("g", {
                        clipPath: "url(#a)",
                        children: [
                            (0, $4vwom.jsx)("rect", {
                                width: 21,
                                height: 15,
                                x: 0.5,
                                y: 0.5,
                                fill: "#af010d",
                                rx: 3
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#fff",
                                fillRule: "evenodd",
                                d: "M6.5 9.5h-6v-3h6v-6h3v6h12v3h-12v6h-3v-6Z",
                                clipRule: "evenodd",
                                style: {
                                    fill: "#fff",
                                    fillOpacity: 1
                                }
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#1a47b8",
                                fillRule: "evenodd",
                                d: "M7.5 8.5h-7v-1h7v-7h1v7h13v1h-13v7h-1v-7Z",
                                clipRule: "evenodd"
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)("defs", {
                        children: (0, $4vwom.jsx)("clipPath", {
                            id: "a",
                            children: (0, $4vwom.jsx)("rect", {
                                width: 21,
                                height: 15,
                                x: 0.5,
                                y: 0.5,
                                fill: "#fff",
                                rx: 3
                            })
                        })
                    })
                ]
            });
        default:
            return null;
    }
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");


var $eSiQ2 = parcelRequire("eSiQ2");
function $f8bb6ad0e871adee$export$931cbfb6bfb85fc(props) {
    var _a, _b, _c;
    const selectRef = (0, $eeH7J.useRef)(null);
    const handleChange = (0, $eeH7J.useCallback)((e)=>{
        var _a;
        (_a = props.onChange) === null || _a === void 0 || _a.call(props, e, e.target.value);
    }, [
        props
    ]);
    return (0, $4vwom.jsxs)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
        variant: "outlined",
        iconEnd: "chevronDown",
        size: "sm",
        css: $f8bb6ad0e871adee$var$buttonCss,
        children: [
            (_b = (_a = props.renderValue) === null || _a === void 0 ? void 0 : _a.call(props, props.value)) !== null && _b !== void 0 ? _b : (_c = props.options.find((opt)=>opt.value === props.value)) === null || _c === void 0 ? void 0 : _c.text,
            (0, $4vwom.jsx)("select", {
                css: $f8bb6ad0e871adee$var$dropdownCss,
                ref: selectRef,
                value: props.value.valueOf(),
                onChange: handleChange,
                children: props.options.map((o)=>(0, $4vwom.jsx)("option", {
                        value: o.value.valueOf(),
                        children: o.text
                    }, o.value.valueOf()))
            })
        ]
    });
}
const $f8bb6ad0e871adee$var$buttonCss = (0, $lhaLc.css)({
    position: "relative"
});
const $f8bb6ad0e871adee$var$dropdownCss = (0, $lhaLc.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    minWidth: 0,
    appearance: "none",
    opacity: 0,
    cursor: "pointer"
});
(0, $eSiQ2.Component)($f8bb6ad0e871adee$export$931cbfb6bfb85fc, {
    name: "Dropdown",
    gallery: {
        path: "Buttons/Dropdown",
        items: [
            {
                variants: [
                    {
                        props: {
                            value: "foo",
                            options: [
                                {
                                    value: "foo",
                                    text: "Foo"
                                },
                                {
                                    value: "bar",
                                    text: "Bar"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});


function $7d8a294407b9f7e2$export$aa53e71df758134e(props) {
    const options = (0, $eeH7J.useMemo)(()=>props.locales.map((l)=>({
                value: l.key.toString(),
                // Is typed as Localized<string> but is already localized in API.
                text: l.displayName
            })), [
        props.locales
    ]);
    const handleSelectChange = (0, $eeH7J.useCallback)((e)=>{
        var _a;
        (_a = props.onLocaleChange) === null || _a === void 0 || _a.call(props, e.target.value);
    }, [
        props
    ]);
    return (0, $4vwom.jsx)((0, $f8bb6ad0e871adee$export$931cbfb6bfb85fc), {
        options: options,
        value: props.currentLocale.toString(),
        onChange: handleSelectChange,
        renderValue: (val)=>val === "en" || val === "no" ? (0, $4vwom.jsx)((0, $7d490944797b9db6$export$48ea269755562084), {
                flag: val
            }) : null
    });
}
(0, $eSiQ2.Component)($7d8a294407b9f7e2$export$aa53e71df758134e, {
    name: "LocaleSelect",
    gallery: {
        path: "Controllers/LocaleSelect",
        items: [
            {
                variants: [
                    {
                        props: {
                            currentLocale: (0, $34lt5.LocaleKey)("no"),
                            onLocaleChange: (l)=>{
                                // eslint-disable-next-line no-console
                                console.log("Changed locale to", l);
                            },
                            locales: [
                                {
                                    flag: "\uD83C\uDDEC\uD83C\uDDE7",
                                    key: (0, $34lt5.LocaleKey)("en"),
                                    displayName: "English",
                                    fallback: (0, $34lt5.LocaleKey)("no")
                                },
                                {
                                    flag: "\uD83C\uDDF3\uD83C\uDDF4",
                                    key: (0, $34lt5.LocaleKey)("no"),
                                    displayName: "Norwegian"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $5K1mb = parcelRequire("5K1mb");


var $eSiQ2 = parcelRequire("eSiQ2");



const $e665a5c3bf2ac3f6$export$16e1fc8de5cd9687 = "0px 4px 24px 0px rgba(21, 6, 36, 0.12)";
const $e665a5c3bf2ac3f6$export$e60c3527c0af1c42 = "drop-shadow(0px 4px 18px rgba(21, 6, 36, 0.12))";



var $4vwom = parcelRequire("4vwom");

var $df8c0007eabe8257$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $df8c0007eabe8257$export$45c9c5c7ee057bfb(_a) {
    var { color: color } = _a, rest = $df8c0007eabe8257$var$__rest(_a, [
        "color"
    ]);
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const fillColor = color ? colors[color] : "#000";
    return (0, $4vwom.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 47",
        width: 50,
        height: 47,
        fill: "none"
    }, rest, {
        children: (0, $4vwom.jsxs)("g", {
            fill: fillColor,
            children: [
                (0, $4vwom.jsx)("path", {
                    fillRule: "evenodd",
                    d: "m11.933 44.499-.09-.043c-3.692-1.78-6.565-4.503-8.506-8.101l-.032-.06-.03-.062C1.497 32.666.734 28.4.734 23.648c0-4.846.756-9.18 2.54-12.76l.03-.062.032-.06c1.95-3.616 4.853-6.305 8.598-7.968C15.678 1.071 20.163.321 25.191.321c4.994 0 9.432.739 13.085 2.477 3.828 1.649 6.773 4.34 8.628 8.028 1.927 3.603 2.745 7.962 2.745 12.822 0 4.766-.826 9.058-2.745 12.647-1.853 3.687-4.788 6.423-8.596 8.188l-.034.016-.034.015c-3.63 1.603-8.051 2.286-13.049 2.286-5.007 0-9.457-.686-13.169-2.263l-.09-.038Zm31.282-10.133c1.517-2.811 2.275-6.384 2.275-10.718 0-4.45-.758-8.081-2.275-10.892-1.4-2.811-3.616-4.861-6.649-6.15-2.916-1.405-6.707-2.108-11.374-2.108-4.666 0-8.515.703-11.548 2.108-2.916 1.289-5.133 3.339-6.65 6.15-1.399 2.81-2.099 6.442-2.099 10.892 0 4.334.7 7.907 2.1 10.718 1.516 2.81 3.733 4.919 6.649 6.325 3.033 1.288 6.882 1.932 11.548 1.932 4.667 0 8.458-.644 11.374-1.932 3.033-1.406 5.25-3.514 6.65-6.325Z",
                    clipRule: "evenodd",
                    style: {
                        fill: fillColor,
                        fillOpacity: 1
                    }
                }),
                (0, $4vwom.jsx)("path", {
                    d: "M13.872 10.69h13.889c1.76 0 3.297.326 4.613.979 1.332.653 2.354 1.584 3.068 2.794.713 1.194 1.07 2.595 1.07 4.202 0 1.338-.285 2.508-.856 3.51a5.707 5.707 0 0 1-2.378 2.293c-1.03.541-2.236.812-3.615.812v-.239c1.601 0 2.838.207 3.71.62.888.415 1.49.948 1.807 1.6.317.653.476 1.402.476 2.245v6.925h-4.28V29.96c0-.828-.151-1.48-.453-1.958-.285-.478-.729-.82-1.331-1.027-.603-.207-1.395-.31-2.378-.31h-3.401l.523-.908 4.519 5.636h-4.139l-5.136-6.448 5.113-6.447h4.162l-4.519 5.636-.523-.956h3.757c1.443 0 2.584-.405 3.425-1.217.856-.812 1.284-1.903 1.284-3.272 0-1.4-.468-2.491-1.403-3.271-.92-.796-2.212-1.194-3.877-1.194h-8.846v22.207h-4.28V10.69Z",
                    style: {
                        fill: fillColor,
                        fillOpacity: 1
                    }
                })
            ]
        })
    }));
}





var $lhaLc = parcelRequire("lhaLc");





var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

function $749455cffd38c931$export$36a4adf75fa19dd1(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const fillColor = props.color ? colors[props.color] : "currentColor";
    return (0, $4vwom.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        css: (0, $lhaLc.css)($749455cffd38c931$var$svgCss, props.state === "close" ? (0, $lhaLc.css)`
                          > rect {
                              transform-origin: center;
                              animation: ${$749455cffd38c931$var$animation} ${props.duration || "400ms"} normal forwards;
                          }
                      ` : {}),
        children: [
            (0, $4vwom.jsx)("rect", {
                className: "top",
                x: "4",
                y: "8",
                width: "16",
                height: "2",
                fill: fillColor
            }),
            (0, $4vwom.jsx)("rect", {
                className: "bottom",
                x: "4",
                y: "14",
                width: "16",
                height: "2",
                fill: fillColor
            })
        ]
    });
}
const $749455cffd38c931$var$animation = (0, $lhaLc.keyframes)`
    0% {
        transform: rotate(0deg) translate(0px);
    }
    40% {
        transform: 
            rotate(0deg)
            translate(0, calc(var(--icon-translation-size) * var(--factor) * 1px));
    }
    100% {
        transform: 
            rotate(calc(45deg * var(--factor)))
            translate(0, calc(var(--icon-translation-size) * var(--factor) * 1px));
    }
`;
const $749455cffd38c931$var$svgCss = (0, $lhaLc.css)`
    --icon-size: 9;
    --icon-bar-size: 3;
    --icon-translation-size: calc((var(--icon-size) - var(--icon-bar-size)) / 2);

    .top {
        --factor: 1;
    }

    .bottom {
        --factor: -1;
    }
`;



var $34lt5 = parcelRequire("34lt5");
parcelRequire("2LTO8");
var $iXeBy = parcelRequire("iXeBy");


function $9333a111b536c412$export$a2e1539ef2c4f956(props) {
    var _a;
    const { colors: colors, helpers: helpers, screenSizes: screenSizes } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const [isOpen, setIsOpen] = (0, $eeH7J.useState)(false);
    const [openAnimationComplete, setOpenAnimationComplete] = (0, $eeH7J.useState)(false);
    const [modalContentRef, animateModalContent] = (0, $4c4e7486a769eecb$export$9f387b98a73b1511)();
    const [modalRef, animateModal] = (0, $4c4e7486a769eecb$export$9f387b98a73b1511)();
    const triggerButtonRef = (0, $eeH7J.useRef)(null);
    const getModalWidth = (0, $eeH7J.useCallback)(()=>{
        var _a;
        if (triggerButtonRef.current) {
            const rect = triggerButtonRef.current.getBoundingClientRect();
            const viewportWidth = document.body.clientWidth;
            if (viewportWidth < screenSizes.sm) {
                const marginRight = viewportWidth - rect.right;
                const modalWidth = viewportWidth - marginRight * 2;
                return modalWidth;
            }
        }
        return ((_a = modalContentRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0;
    }, [
        screenSizes.sm,
        modalContentRef
    ]);
    const toggleOpen = (0, $eeH7J.useCallback)(()=>{
        var _a;
        if (!isOpen) {
            const modalWidth = getModalWidth();
            animateModal(modalRef.current, {
                boxShadow: $e665a5c3bf2ac3f6$export$16e1fc8de5cd9687,
                backgroundColor: colors.grayWhite,
                height: ((_a = modalContentRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0,
                width: modalWidth
            }, {
                onComplete: ()=>{
                    setOpenAnimationComplete(true);
                    animateModalContent(modalContentRef.current, {
                        opacity: 1
                    });
                }
            });
        } else animateModal(modalRef.current, {
            opacity: 0
        }, {
            onComplete: ()=>{
                setOpenAnimationComplete(false);
                animateModalContent(modalContentRef.current, {
                    opacity: 0
                }, {
                    duration: 0
                });
                animateModal(modalRef.current, {
                    boxShadow: "none",
                    backgroundColor: colors.gray100,
                    height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                    width: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                    opacity: 1
                }, {
                    duration: 0
                });
            }
        });
        setIsOpen(!isOpen);
    }, [
        isOpen,
        getModalWidth,
        animateModal,
        modalRef,
        colors.grayWhite,
        colors.gray100,
        modalContentRef,
        animateModalContent
    ]);
    const handleResize = (0, $eeH7J.useCallback)(()=>{
        if (isOpen && openAnimationComplete) animateModal(modalRef.current, {
            width: getModalWidth()
        }, {
            duration: 0
        });
    }, [
        getModalWidth,
        isOpen,
        animateModal,
        modalRef,
        openAnimationComplete
    ]);
    (0, $eeH7J.useEffect)(()=>{
        const resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(document.body);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        getModalWidth,
        handleResize
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (typeof window !== "undefined") {
            if (isOpen) document.body.style.overflow = "hidden";
            else document.body.style.overflow = "";
        }
    }, [
        isOpen
    ]);
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsxs)("div", {
            ref: triggerButtonRef,
            style: {
                position: "relative",
                height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                width: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
            },
            children: [
                (0, $4vwom.jsx)("div", {
                    style: {
                        height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                        width: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        zIndex: 1,
                        position: "relative",
                        backgroundColor: colors.gray100,
                        borderRadius: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                    },
                    children: (0, $4vwom.jsx)((0, $749455cffd38c931$export$36a4adf75fa19dd1), {
                        state: "menu"
                    })
                }),
                (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
                    transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                    children: (0, $4vwom.jsxs)("div", {
                        ref: modalRef,
                        style: {
                            boxShadow: "none",
                            backgroundColor: colors.gray100,
                            height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                            width: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                            opacity: 1,
                            overflow: "hidden",
                            display: "flex",
                            position: "absolute",
                            borderRadius: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                            top: 0,
                            right: 0,
                            zIndex: 10
                        },
                        children: [
                            (0, $4vwom.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    top: 0,
                                    right: 0
                                },
                                children: (0, $4vwom.jsx)("div", {
                                    style: {
                                        height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                                        width: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        zIndex: 15,
                                        position: "relative"
                                    },
                                    onClick: toggleOpen,
                                    children: (0, $4vwom.jsx)((0, $749455cffd38c931$export$36a4adf75fa19dd1), {
                                        state: isOpen ? "close" : "menu",
                                        duration: "200ms"
                                    })
                                })
                            }),
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                direction: "column",
                                style: {
                                    zIndex: 10,
                                    position: "absolute"
                                },
                                css: responsiveCss("max", "xs", {
                                    width: "100%"
                                }),
                                children: (0, $4vwom.jsxs)("div", {
                                    ref: modalContentRef,
                                    style: {
                                        flexDirection: "column",
                                        display: "flex",
                                        padding: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                                        opacity: 0
                                    },
                                    children: [
                                        (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            justifyContent: "space-between",
                                            margin: {
                                                bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(20)
                                            },
                                            children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                alignItems: "center",
                                                children: [
                                                    (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                                        animate: openAnimationComplete ? {
                                                            transform: "translateX(0px)"
                                                        } : {
                                                            transform: "translateX(-5px)"
                                                        },
                                                        children: (0, $4vwom.jsx)((0, $5K1mb.Link), {
                                                            to: "/",
                                                            onClick: toggleOpen,
                                                            children: (0, $4vwom.jsx)((0, $df8c0007eabe8257$export$45c9c5c7ee057bfb), {
                                                                width: 40,
                                                                style: {
                                                                    marginRight: 8
                                                                }
                                                            })
                                                        })
                                                    }),
                                                    props.trustpilot ? (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                                        animate: openAnimationComplete ? {
                                                            transform: "translateX(0px)"
                                                        } : {
                                                            transform: "translateX(-10px)"
                                                        },
                                                        children: (0, $4vwom.jsx)((0, $d459a7d0faaadece$export$3f8d6a825279800d), {
                                                            as: "a",
                                                            href: (_a = props.trustpilot.url) === null || _a === void 0 ? void 0 : _a.valueOf(),
                                                            score: props.trustpilot.score.valueOf(),
                                                            onClick: toggleOpen,
                                                            text: props.trustpilot.text
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        }),
                                        (0, $4vwom.jsx)("div", {
                                            children: props.items.slice(props.isLoggedIn ? 0 : 1, props.items.length).map((item, i)=>{
                                                var _a;
                                                return (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).a, {
                                                    animate: openAnimationComplete ? {
                                                        transform: `translateX(0px)`
                                                    } : {
                                                        transform: `translateX(-${(props.items.length - i) * 5}px)`
                                                    },
                                                    onClick: ()=>{
                                                        if (!item.href && item.onClick) item.onClick();
                                                        toggleOpen();
                                                    },
                                                    href: (_a = item.href) === null || _a === void 0 ? void 0 : _a.valueOf(),
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        whiteSpace: "nowrap"
                                                    },
                                                    css: (0, $lhaLc.css)({
                                                        height: (0, $756948b644e82cf2$export$981516ee4691055c)(64)
                                                    }),
                                                    children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "heading",
                                                        level: [
                                                            "fixed",
                                                            "xs",
                                                            2
                                                        ],
                                                        children: item.text
                                                    })
                                                }, item.id);
                                            })
                                        }),
                                        (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                            motion: {
                                                animate: openAnimationComplete ? {
                                                    transform: "translateX(0px)"
                                                } : {
                                                    transform: "translateX(-5px)"
                                                }
                                            },
                                            padding: {
                                                y: (0, $756948b644e82cf2$export$981516ee4691055c)(20)
                                            },
                                            css: (0, $lhaLc.css)({
                                                borderTop: `1px solid ${colors.gray200}`,
                                                borderBottom: `1px solid ${colors.gray200}`,
                                                display: "grid",
                                                gridAutoFlow: "column",
                                                gridAutoColumns: "minmax(0, 1fr)",
                                                gap: (0, $756948b644e82cf2$export$981516ee4691055c)(20)
                                            }),
                                            children: [
                                                !props.isLoggedIn && props.login && props.account && (0, $4vwom.jsx)((0, $cc8ebb6ca3ee944d$export$235493e82cf65451), {
                                                    account: props.account,
                                                    login: props.login
                                                }),
                                                (0, $4vwom.jsx)((0, $7d8a294407b9f7e2$export$aa53e71df758134e), {
                                                    locales: props.locales || [],
                                                    currentLocale: props.currentLocale,
                                                    onLocaleChange: (l)=>{
                                                        var _a;
                                                        toggleOpen();
                                                        (_a = props.onLocaleChange) === null || _a === void 0 || _a.call(props, l);
                                                    }
                                                })
                                            ]
                                        }),
                                        (0, $4vwom.jsxs)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            color: "gray500",
                                            size: "md",
                                            margin: {
                                                top: (0, $756948b644e82cf2$export$981516ee4691055c)(20)
                                            },
                                            style: {
                                                opacity: 0.6,
                                                whiteSpace: "nowrap"
                                            },
                                            children: [
                                                "\xa9 ",
                                                new Date().getFullYear(),
                                                " Redoit \u2022 All rights reserved"
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                isOpen && /*#__PURE__*/ (0, $iMJCh.createPortal)((0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        zIndex: 0
                    },
                    animate: {
                        backgroundColor: "rgba(0, 0, 0, 0.32)"
                    }
                }), document.body)
            ]
        })
    });
}
(0, $eSiQ2.Component)($9333a111b536c412$export$a2e1539ef2c4f956, {
    name: "NavigationModal",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            items: [
                                {
                                    id: "1",
                                    text: "Skipped",
                                    href: (0, $iXeBy.Url)("")
                                },
                                {
                                    id: "2",
                                    text: "Hvordan det fungerer",
                                    href: (0, $iXeBy.Url)("#")
                                },
                                {
                                    id: "3",
                                    text: "Vanlige sp\xf8rsm\xe5l",
                                    href: (0, $iXeBy.Url)("#")
                                },
                                {
                                    id: "4",
                                    text: "Kontakt oss",
                                    href: (0, $iXeBy.Url)("#")
                                }
                            ],
                            trustpilot: {
                                score: 5,
                                text: "Trustpilot"
                            },
                            currentLocale: (0, $34lt5.LocaleKey)("no"),
                            onLocaleChange: (l)=>{
                                // eslint-disable-next-line no-console
                                console.log("Changed locale to", l);
                            },
                            locales: [
                                {
                                    flag: "\uD83C\uDDEC\uD83C\uDDE7",
                                    key: (0, $34lt5.LocaleKey)("en"),
                                    displayName: "English",
                                    fallback: (0, $34lt5.LocaleKey)("no")
                                },
                                {
                                    flag: "\uD83C\uDDF3\uD83C\uDDF4",
                                    key: (0, $34lt5.LocaleKey)("no"),
                                    displayName: "Norwegian"
                                }
                            ]
                        },
                        render: (cmp)=>(0, $4vwom.jsx)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "flex-end"
                                },
                                children: cmp
                            })
                    }
                ]
            }
        ]
    }
});




var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
parcelRequire("5K1mb");
var $18Pjr = parcelRequire("18Pjr");
var $18Pjr = parcelRequire("18Pjr");

var $alVaN = parcelRequire("alVaN");

var $7KZCj = parcelRequire("7KZCj");

var $dUDPg = parcelRequire("dUDPg");

var $34lt5 = parcelRequire("34lt5");

var $7FrRx = parcelRequire("7FrRx");

var $4vwom = parcelRequire("4vwom");
parcelRequire("2LTO8");
var $8h5s0 = parcelRequire("8h5s0");
/** Holds the current status code for the ongoing SSR rendering pass.
 *
 *  Changing this value will cause the current rendering to return the given status code.
 */ const $f3376239f4cdc33f$export$18dc2edb475b04ff = {
    code: 200
};


function $5fb7d8fdb47c7fea$export$38cf3de59bf684f4({ error: error }) {
    var _a, _b;
    (0, $f3376239f4cdc33f$export$18dc2edb475b04ff).code = (_a = error.status) !== null && _a !== void 0 ? _a : 500;
    const emoji = {
        401: "\uD83E\uDEE5",
        403: "\uD83D\uDEAB",
        404: "\uD83E\uDD14",
        500: "\uD83E\uDD15"
    }[(_b = error.status) !== null && _b !== void 0 ? _b : 500];
    return (0, $4vwom.jsxs)("div", {
        style: {
            padding: 64,
            height: "100%",
            width: "100%",
            position: "relative"
        },
        children: [
            (0, $4vwom.jsx)("img", {
                src: "/static/fuse.png",
                style: {
                    position: "absolute",
                    width: 94,
                    height: 42,
                    right: 64,
                    bottom: 64
                }
            }),
            (0, $4vwom.jsxs)("h1", {
                style: {
                    color: "#555"
                },
                children: [
                    emoji,
                    " ",
                    error.status,
                    " ",
                    (0, $8h5s0.prettyCamel)(error.type)
                ]
            }),
            (0, $4vwom.jsx)("p", {
                children: error.detail
            })
        ]
    });
}



var $aIeEI = parcelRequire("aIeEI");



function $9fe8ccb750b589bb$export$32c792df021ab666(props) {
    var _a, _b, _c, _d, _e, _f;
    const navigate = (0, $18Pjr.useNavigate)();
    const params = (0, $18Pjr.useParams)();
    const localize = (0, $aIeEI.useLocalize)();
    const currentLocaleContext = (0, $eeH7J.useContext)((0, $7FrRx.CurrentLocaleContext));
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const page = (0, $dUDPg.useWebPage)((_b = props.locale) !== null && _b !== void 0 ? _b : currentLocaleContext.locale, params.slug);
    const { data: data, error: error } = page;
    const locale = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = props.locale) !== null && _a !== void 0 ? _a : currentLocaleContext.locale;
    }, [
        currentLocaleContext.locale,
        props.locale
    ]);
    const isNavigating = (0, $eeH7J.useMemo)(()=>{
        var _a, _b;
        return params.slug !== localize((_b = (_a = page.data) === null || _a === void 0 ? void 0 : _a.page.slug) !== null && _b !== void 0 ? _b : {});
    }, [
        localize,
        (_c = page.data) === null || _c === void 0 ? void 0 : _c.page.slug,
        params.slug
    ]);
    const setLocale = (0, $eeH7J.useCallback)((l)=>{
        var _a, _b, _c, _d;
        if (currentLocaleContext.setLocale) currentLocaleContext.setLocale(l);
        if (!data) return;
        // Redirect to new locale specific path.
        const newPath = l === defaultLocale ? `/${(_b = (_a = data.page.slug) === null || _a === void 0 ? void 0 : _a[defaultLocale.toString()]) !== null && _b !== void 0 ? _b : ""}` : `/${l}/${(_d = (_c = data.page.slug) === null || _c === void 0 ? void 0 : _c[l.toString()]) !== null && _d !== void 0 ? _d : ""}`;
        navigate(newPath);
    }, [
        currentLocaleContext,
        data,
        defaultLocale,
        navigate
    ]);
    if ((data === null || data === void 0 ? void 0 : data.page.redirect) && typeof window !== "undefined") window.location.href = data.page.redirect.valueOf();
    (0, $eeH7J.useEffect)(()=>{
        const dayjsLocale = locale === (0, $34lt5.LocaleKey)("no") ? "nb" : locale.valueOf();
        const getDayjsLocale = {
            nb: ()=>(parcelRequire("jzNZd")),
            en: ()=>(parcelRequire("8Xuux")),
            sv: ()=>(parcelRequire("hiCoo"))
        };
        async function updateDayjsLocale() {
            if (typeof getDayjsLocale[dayjsLocale] === "function") {
                await getDayjsLocale[dayjsLocale]();
                (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).locale(dayjsLocale);
            }
        }
        updateDayjsLocale();
    }, [
        locale
    ]);
    if (error) {
        const ErrorScreen = (_d = props.errorScreen) !== null && _d !== void 0 ? _d : (0, $5fb7d8fdb47c7fea$export$38cf3de59bf684f4);
        return (0, $4vwom.jsx)(ErrorScreen, {
            error: error
        });
    }
    if (!data || data.page.redirect) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $7FrRx.CurrentLocaleContext).Provider, {
        value: {
            get locale () {
                // In context of a page, always return the locale passed to the WebPage, which
                // should be determined by the URL.
                return locale;
            },
            setLocale: setLocale
        },
        children: [
            (0, $4vwom.jsx)("meta", {
                lang: (_f = (_e = props.locale) === null || _e === void 0 ? void 0 : _e.valueOf()) !== null && _f !== void 0 ? _f : currentLocaleContext.locale.valueOf()
            }),
            (0, $4vwom.jsx)($9fe8ccb750b589bb$export$6245f31671de0b04.Provider, {
                value: {
                    id: data.page.id,
                    breadcrumb: data.breadcrumb,
                    isNavigating: isNavigating
                },
                children: (0, $4vwom.jsx)((0, $7KZCj.EditableSections), Object.assign({
                    sections: data.page.sections
                }, props.EditableSectionsProps || {}))
            })
        ]
    });
}
const $9fe8ccb750b589bb$export$6245f31671de0b04 = /*#__PURE__*/ (0, $eeH7J.createContext)({
    id: undefined,
    breadcrumb: [],
    isNavigating: undefined
});


parcelRequire("2LTO8");
var $iXeBy = parcelRequire("iXeBy");

var $eeH7J = parcelRequire("eeH7J");

var $7m9cQ = parcelRequire("7m9cQ");
let $f2e2333c5543d6d8$var$loggingInWithVipps = false;
async function $f2e2333c5543d6d8$export$5eda4f58d84268b6(redirectUrl, failedRedirectUrl, serviceName = "vipps") {
    var _a;
    // Prevent multiple login attempts at the same time
    if ($f2e2333c5543d6d8$var$loggingInWithVipps) return true;
    $f2e2333c5543d6d8$var$loggingInWithVipps = true;
    try {
        const res = await fetch(`${(0, $7m9cQ.server)()}/api/${serviceName}/auth/url?redirectUrl=${encodeURIComponent(redirectUrl)}&failedRedirectUrl=${encodeURIComponent(failedRedirectUrl)}`);
        if (res.status === 200) {
            const json = await res.json();
            window.location.href = json.authUrl;
        } else {
            const error = await res.json();
            alert("Failed to start Vipps login: " + error.detail);
            return false;
        }
    } catch (e) {
        alert((_a = e.message) !== null && _a !== void 0 ? _a : e.detail);
    } finally{
        $f2e2333c5543d6d8$var$loggingInWithVipps = false;
    }
    // Should be unreachable, as the browser will be redirected to the Vipps login page in
    // the success case above
    throw new Error("Unreachable code reached in loginWithVipps");
}
function $f2e2333c5543d6d8$export$403f2aca3002ba0e(redirectUrl, failedRedirectUrl, /** In case of multiple vipps service instances, this can be used to disambiguate. */ serviceName = "vipps") {
    return (0, $eeH7J.useCallback)(async ()=>$f2e2333c5543d6d8$export$5eda4f58d84268b6(redirectUrl, failedRedirectUrl, serviceName), [
        redirectUrl,
        serviceName
    ]);
}
function $f2e2333c5543d6d8$export$7a6e57dc0a3ed9e2(/** In case of multiple vipps service instances, this can be used to disambiguate. */ serviceName = "vipps") {
    return (0, $eeH7J.useCallback)(async ()=>{
        var _a;
        try {
            const url = `${(0, $7m9cQ.server)()}/api/${serviceName}/auth/session`;
            await fetch(url, {
                method: "DELETE"
            });
        } catch (e) {
            alert((_a = e.message) !== null && _a !== void 0 ? _a : e.detail);
        }
    }, [
        serviceName
    ]);
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
function $87d2193cf0695c20$export$8f2dc74599543279(text, values) {
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: typeof text === "string" ? text.split("{{").flatMap((part)=>{
            if (part.includes("}}")) {
                const [key, ...rest] = part.split("}}");
                return [
                    values[key],
                    ...rest
                ];
            } else return (0, $4vwom.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, {
                children: part
            }, part);
        }) : undefined
    });
}
function $87d2193cf0695c20$export$4493d2932fe76cf8(text, values, start = "{{", end = "}}") {
    return text.split(start).flatMap((part)=>{
        if (part.includes(end)) {
            const [key, ...rest] = part.split(end);
            return values[key] + rest.join(end);
        } else return part;
    }).join("");
}



/**
 * The header for the site. Renders the first item separate from the rest, as they are
 * to be rendered in a hamburger popup menu on mobile, while the first item should be visible
 * outside of the popup menu.
 *
 * @icon ui-menu-01
 */ function $cc8ebb6ca3ee944d$var$Header(section) {
    var _a, _b, _c, _d;
    const theme = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = theme.helpers;
    const webPageContext = (0, $eeH7J.useContext)((0, $9fe8ccb750b589bb$export$6245f31671de0b04));
    const locales = (0, $dUDPg.useLocales)();
    const localize = (0, $aIeEI.useLocalize)();
    const header = (0, $e18f565b44c7bc7d$export$ae602290ebd82f8e)(webPageContext.id, section.id);
    const { locale: currentLocale, setLocale: setLocale } = (0, $eeH7J.useContext)((0, $7FrRx.CurrentLocaleContext));
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const menuItems = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return ((_a = header.data) === null || _a === void 0 ? void 0 : _a.items.map((item)=>{
            const localePath = currentLocale === defaultLocale ? "" : `/${currentLocale}`;
            const path = item.slug ? `${localePath}/${localize(item.slug)}` : "/";
            const fragment = item.section ? `#${item.section}` : "";
            const href = item.url && !item.slug ? item.url : (0, $iXeBy.Url)(`${path}${fragment}`);
            // During pre launch period, fragments and external links (items with url property)
            // should work as intended, while other links should trigger open waiting list
            // modal.
            return {
                id: item.id.valueOf(),
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                href: (item.slug || item.section || item.url) && href ? href : undefined,
                text: localize(item.text),
                icon: item.icon
            };
        })) || [];
    }, [
        (_b = header.data) === null || _b === void 0 ? void 0 : _b.items,
        currentLocale,
        defaultLocale,
        localize
    ]);
    const handleLocaleChange = (0, $eeH7J.useCallback)((l)=>{
        if (setLocale) setLocale(l);
    }, [
        setLocale
    ]);
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    if (header.loading || !header.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        as: "nav",
        alignItems: "center",
        css: (0, $lhaLc.css)({
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(100)
        }),
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                style: {
                    width: "100%"
                },
                children: [
                    (0, $4vwom.jsx)((0, $5K1mb.Link), {
                        to: `/${currentLocale === defaultLocale ? "" : currentLocale}`,
                        children: (0, $4vwom.jsx)((0, $67cf5539992d1dd3$export$e6ff31bff12b7ff4), {
                            css: (0, $lhaLc.css)({
                                width: (0, $756948b644e82cf2$export$981516ee4691055c)(114),
                                height: "auto",
                                marginRight: (0, $756948b644e82cf2$export$981516ee4691055c)(8)
                            }, responsiveCss("min", "md", {
                                marginRight: $cc8ebb6ca3ee944d$var$scale16
                            }))
                        })
                    }),
                    header.data.trustpilot ? (0, $4vwom.jsx)("div", {
                        css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                            display: "none"
                        })),
                        children: (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                            margin: {
                                right: $cc8ebb6ca3ee944d$var$scale16
                            },
                            children: (0, $4vwom.jsx)((0, $d459a7d0faaadece$export$3f8d6a825279800d), Object.assign({
                                score: header.data.trustpilot.score.valueOf(),
                                text: localize(header.data.trustpilot.text)
                            }, header.data.trustpilot.url ? {
                                as: "a",
                                href: header.data.trustpilot.url.valueOf(),
                                target: "_blank"
                            } : {}))
                        })
                    }) : null,
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        css: (0, $lhaLc.css)(responsiveCss("max", "lg", {
                            display: "none"
                        })),
                        children: [
                            !!menuItems[0] && (0, $4vwom.jsx)($cc8ebb6ca3ee944d$var$MenuItem, Object.assign({}, menuItems[0])),
                            menuItems.slice(1, menuItems.length).map((item)=>(0, $4vwom.jsx)($cc8ebb6ca3ee944d$var$MenuItem, Object.assign({}, item), item.id))
                        ]
                    })
                ]
            }),
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)(responsiveCss("max", "lg", {
                    display: "none"
                })),
                children: header.data.login && header.data.account ? (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 8,
                    children: [
                        (0, $4vwom.jsx)((0, $7d8a294407b9f7e2$export$aa53e71df758134e), {
                            locales: locales.data || [],
                            currentLocale: currentLocale,
                            onLocaleChange: handleLocaleChange
                        }),
                        (0, $4vwom.jsx)($cc8ebb6ca3ee944d$export$235493e82cf65451, {
                            user: me.data,
                            account: header.data.account,
                            login: header.data.login
                        })
                    ]
                }) : null
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 6,
                css: (0, $lhaLc.css)(responsiveCss("min", "xl", {
                    display: "none"
                })),
                children: [
                    !me.loading && (((_c = me.data) === null || _c === void 0 ? void 0 : _c.anonymous) ? !!menuItems[0] && (0, $4vwom.jsx)($cc8ebb6ca3ee944d$var$MenuItem, Object.assign({}, menuItems[0])) : header.data.account && header.data.login ? (0, $4vwom.jsx)($cc8ebb6ca3ee944d$export$235493e82cf65451, {
                        user: me.data,
                        account: header.data.account,
                        login: header.data.login
                    }) : null),
                    (0, $4vwom.jsx)((0, $9333a111b536c412$export$a2e1539ef2c4f956), {
                        items: menuItems,
                        isLoggedIn: !((_d = me.data) === null || _d === void 0 ? void 0 : _d.anonymous),
                        trustpilot: header.data.trustpilot ? {
                            score: header.data.trustpilot.score,
                            text: localize(header.data.trustpilot.text),
                            url: header.data.trustpilot.url
                        } : undefined,
                        locales: locales.data || [],
                        currentLocale: currentLocale,
                        onLocaleChange: handleLocaleChange,
                        account: header.data.account,
                        login: header.data.login
                    })
                ]
            })
        ]
    });
}
function $cc8ebb6ca3ee944d$var$MenuItem(props) {
    var _a;
    const { colors: colors, helpers: helpers, buttonSizes: buttonSizes, buttonVariants: buttonVariants } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveHeadingLevel: responsiveHeadingLevel, responsiveCss: responsiveCss, variantCss: variantCss, responsiveVariantsCss: responsiveVariantsCss } = helpers;
    const { menuItemCss: menuItemCss, spacer: spacer } = (0, $eeH7J.useMemo)(()=>({
            menuItemCss: (0, $lhaLc.css)([
                {
                    cursor: "pointer",
                    height: (0, $756948b644e82cf2$export$981516ee4691055c)(48),
                    textDecoration: "none",
                    whiteSpace: "nowrap"
                },
                responsiveHeadingLevel(4),
                responsiveCss("max", "lg", (0, $lhaLc.css)(variantCss(buttonVariants, "secondary"), responsiveVariantsCss(buttonSizes, "sm")))
            ]),
            spacer: (0, $lhaLc.css)({
                alignItems: "center"
            }, helpers.responsiveCss("min", "xl", {
                ":after": {
                    content: '""',
                    width: 1,
                    height: 20,
                    backgroundColor: colors.gray200,
                    marginLeft: $cc8ebb6ca3ee944d$var$scale16,
                    marginRight: $cc8ebb6ca3ee944d$var$scale16
                },
                ":last-of-type:after": {
                    display: "none"
                }
            }))
        }), [
        responsiveHeadingLevel,
        responsiveCss,
        variantCss,
        buttonVariants,
        responsiveVariantsCss,
        buttonSizes,
        helpers,
        colors.gray200
    ]);
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        css: (0, $lhaLc.css)(spacer),
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            as: "a",
            href: (_a = props.href) === null || _a === void 0 ? void 0 : _a.valueOf(),
            padding: {
                y: (0, $756948b644e82cf2$export$981516ee4691055c)(12),
                x: $cc8ebb6ca3ee944d$var$scale16
            },
            alignItems: "center",
            css: menuItemCss,
            onClick: props.onClick,
            children: [
                props.icon && (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                    icon: props.icon,
                    margin: {
                        right: (0, $756948b644e82cf2$export$981516ee4691055c)(8)
                    }
                }),
                props.text
            ]
        })
    });
}
const $cc8ebb6ca3ee944d$var$scale16 = (0, $756948b644e82cf2$export$981516ee4691055c)(16);
function $cc8ebb6ca3ee944d$export$235493e82cf65451(props) {
    var _a, _b, _c, _d, _e;
    const location = (0, $18Pjr.useLocation)();
    const localize = (0, $aIeEI.useLocalize)();
    const accountPageInfo = (0, $dUDPg.useWebPageInfo)(props.account.page);
    const loginWithVipps = (0, $f2e2333c5543d6d8$export$403f2aca3002ba0e)(((_a = accountPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) ? "/" + localize(accountPageInfo.data.slug) : "/", location.pathname // Go back where we came from if login fails
    );
    return !!props.user && !props.user.anonymous ? (0, $4vwom.jsx)("div", {
        children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
            variant: "profile",
            size: "sm",
            onClick: ((_b = accountPageInfo.data) === null || _b === void 0 ? void 0 : _b.slug) ? undefined : ()=>alert("Missing account page config in header config."),
            as: "a",
            href: ((_c = accountPageInfo.data) === null || _c === void 0 ? void 0 : _c.slug) ? `/${localize(accountPageInfo.data.slug)}` : undefined,
            iconStart: props.account.icon,
            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.account.text), {
                givenName: (_d = props.user.givenName) !== null && _d !== void 0 ? _d : "",
                familyName: (_e = props.user.familyName) !== null && _e !== void 0 ? _e : ""
            })
        })
    }) : (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
        variant: "dark",
        size: "sm",
        onClick: ()=>{
            loginWithVipps();
        },
        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
            variant: "heading",
            level: 4,
            children: localize(props.login.text)
        })
    });
}
(0, $9G56J.Section)("Header", $cc8ebb6ca3ee944d$var$Header);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");
var $iXeBy = parcelRequire("iXeBy");
var $dAwef = parcelRequire("dAwef");

var $7m9cQ = parcelRequire("7m9cQ");



var $eeH7J = parcelRequire("eeH7J");
const $52a8e4eb4bf14158$var$defaultSpeed = 30;
function $52a8e4eb4bf14158$export$a5e58535c47c4073(props) {
    const ref = (0, $eeH7J.useRef)(null);
    const [width, setWidth] = (0, $eeH7J.useState)(0);
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        setWidth(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0);
    }, []);
    const animationDuration = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return `${width / ((_a = props.speed) !== null && _a !== void 0 ? _a : $52a8e4eb4bf14158$var$defaultSpeed) * 1000}ms`;
    }, [
        props.speed,
        width
    ]);
    return (0, $4vwom.jsxs)("div", {
        style: {
            position: "relative",
            overflow: "hidden",
            flexWrap: "nowrap",
            display: "flex"
        },
        css: $52a8e4eb4bf14158$var$containerCss,
        children: [
            (0, $4vwom.jsx)("div", {
                ref: ref,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $52a8e4eb4bf14158$var$responsiveGridCss,
                    $52a8e4eb4bf14158$var$animationCss
                ],
                children: props.logos.map((l)=>(0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), Object.assign({
                        css: $52a8e4eb4bf14158$var$responsiveItemCss
                    }, l.url ? {
                        as: "a",
                        href: l.url.valueOf(),
                        target: "_blank"
                    } : {}, {
                        children: (0, $4vwom.jsx)("img", {
                            src: (0, $14q7s.ImageToUrl)(l.image, {
                                width: 300
                            })
                        })
                    }), l.id.valueOf()))
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $52a8e4eb4bf14158$var$responsiveGridCss,
                    $52a8e4eb4bf14158$var$animationCss
                ],
                children: props.logos.map((l)=>(0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), Object.assign({
                        css: $52a8e4eb4bf14158$var$responsiveItemCss
                    }, l.url ? {
                        as: "a",
                        href: l.url.valueOf(),
                        target: "_blank"
                    } : {}, {
                        children: (0, $4vwom.jsx)("img", {
                            src: (0, $14q7s.ImageToUrl)(l.image, {
                                width: 300
                            })
                        })
                    }), l.id.valueOf()))
            })
        ]
    });
}
const $52a8e4eb4bf14158$var$marquee = (0, $lhaLc.keyframes)({
    from: {
        transform: "translateX(-100%)"
    },
    to: {
        transform: "translateX(0%)"
    }
});
const $52a8e4eb4bf14158$var$animationCss = (0, $lhaLc.css)({
    animationName: $52a8e4eb4bf14158$var$marquee
});
const $52a8e4eb4bf14158$var$responsiveGridCss = (0, $lhaLc.css)({
    display: "inline-flex",
    alignItems: "center",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear"
});
const $52a8e4eb4bf14158$var$containerCss = (0, $lhaLc.css)({
    maxHeight: 64,
    "&:hover div": {
        animationPlayState: "paused"
    },
    "&:before, &:after": {
        content: '""',
        position: "absolute",
        top: 0,
        bottom: 0,
        width: 50,
        zIndex: 1,
        pointerEvents: "none"
    },
    "&:before": {
        left: 0,
        background: "linear-gradient(270deg, rgba(255, 255,255,0), rgba(255, 255,255,1))"
    },
    "&:after": {
        right: 0,
        background: "linear-gradient(90deg, rgba(255, 255,255,0), rgba(255, 255,255,1))"
    }
}, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
    "&:before, &:after": {
        width: 360,
        maxHeight: 80
    }
}));
const $52a8e4eb4bf14158$var$responsiveItemCss = (0, $lhaLc.css)({
    display: "flex",
    justifyContent: "center",
    margin: "0 16px",
    minWidth: 200
}, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
    margin: "0 50px",
    minWidth: 240
}));
(0, $eSiQ2.Component)($52a8e4eb4bf14158$export$a5e58535c47c4073, {
    name: "PressLogosCarousel",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            logos: [
                                {
                                    id: (0, $dAwef.Uuid)(),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/press-logo-1.svg`,
                                    url: (0, $iXeBy.Url)("https://www.hollywoodreporter.com")
                                },
                                {
                                    id: (0, $dAwef.Uuid)(),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/press-logo-2.svg`
                                },
                                {
                                    id: (0, $dAwef.Uuid)(),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/press-logo-3.svg`
                                },
                                {
                                    id: (0, $dAwef.Uuid)(),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/press-logo-4.svg`
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});






var $aIeEI = parcelRequire("aIeEI");

function $5604714ee1f91832$var$PressLogos(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsxs)("div", {
        css: (0, $lhaLc.css)({
            display: "flex",
            flexDirection: "column"
        }, (0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: [
            !!section.heading && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                justifyContent: "space-between",
                children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                    level: 2,
                    padding: {
                        y: 8
                    },
                    truncate: true,
                    children: localize(section.heading)
                })
            }),
            !!section.text && (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                size: "lg",
                color: "gray400",
                margin: {
                    bottom: "sm"
                },
                children: localize(section.text)
            }),
            (0, $4vwom.jsx)((0, $52a8e4eb4bf14158$export$a5e58535c47c4073), {
                logos: section.logos,
                speed: section.carouselSpeed
            })
        ]
    });
}
(0, $9G56J.Section)($5604714ee1f91832$var$PressLogos);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5K1mb = parcelRequire("5K1mb");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");


var $aIeEI = parcelRequire("aIeEI");

var $dUDPg = parcelRequire("dUDPg");

var $7FrRx = parcelRequire("7FrRx");

var $aIeEI = parcelRequire("aIeEI");

var $eeH7J = parcelRequire("eeH7J");
function $02ba3a727a0f8ecd$export$32f719dfac03c1cb() {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const { locale: locale } = (0, $eeH7J.useContext)((0, $7FrRx.CurrentLocaleContext));
    const localePath = locale === defaultLocale ? "" : `/${locale}`;
    return (slug)=>slug ? `${localePath}/${localize(slug)}` : "/";
}




var $dUDPg = parcelRequire("dUDPg");


var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5K1mb = parcelRequire("5K1mb");

var $lhaLc = parcelRequire("lhaLc");
parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");
parcelRequire("2LTO8");
var $dAwef = parcelRequire("dAwef");


var $aIeEI = parcelRequire("aIeEI");

var $9G56J = parcelRequire("9G56J");

var $eeH7J = parcelRequire("eeH7J");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");








function $fc70c197a228049f$export$ecfb84f4ec12058a(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        role: "button",
        "aria-label": props.primary,
        onClick: props.onClick,
        backgroundColor: props.selected ? "brandLight" : "grayWhite",
        borderColor: props.selected ? "brand" : "gray200",
        borderRadius: "md",
        padding: "md",
        style: Object.assign({
            cursor: "pointer",
            transitionProperty: "background-color, border-color",
            transitionDuration: "0.30s"
        }, props.style),
        children: (0, $4vwom.jsxs)("div", {
            style: {
                display: "grid",
                width: "100%"
            },
            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                gap: 8
            }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                gridTemplateColumns: "0.56fr 1fr",
                gap: 40
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 8,
                    justifyContent: "space-between",
                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                        flexDirection: "column-reverse"
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        flexDirection: "column"
                    })),
                    children: [
                        typeof props.primary !== "undefined" && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "heading",
                            level: 3,
                            color: "brand",
                            children: props.primary
                        }),
                        typeof props.secondary !== "undefined" && (typeof props.secondary === "string" ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "xl",
                            children: props.secondary
                        }) : (0, $4vwom.jsxs)("span", {
                            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                color: colors.brand,
                                fontWeight: 600
                            })),
                            children: [
                                (0, $4vwom.jsxs)("span", {
                                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                        display: "none"
                                    })),
                                    children: [
                                        (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                            as: "span",
                                            variant: "heading",
                                            level: 3,
                                            children: [
                                                props.secondary.price,
                                                " ",
                                                props.secondary.currency
                                            ]
                                        }),
                                        "/",
                                        props.secondary.period
                                    ]
                                }),
                                (0, $4vwom.jsx)("span", {
                                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                        display: "none"
                                    })),
                                    children: (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        as: "span",
                                        variant: "heading",
                                        level: 3,
                                        style: {
                                            fontWeight: 600
                                        },
                                        children: [
                                            props.secondary.price,
                                            " ",
                                            props.secondary.currency,
                                            " ",
                                            props.secondary.period,
                                            "."
                                        ]
                                    })
                                })
                            ]
                        }))
                    ]
                }),
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    justifyContent: "space-between",
                    children: [
                        typeof props.list !== "undefined" ? (0, $4vwom.jsx)("ul", {
                            css: (0, $e82ba787de72625c$export$6b6f359a824920a4)("ul"),
                            children: props.list.map((item)=>{
                                var _a;
                                return (0, $4vwom.jsxs)("li", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                        marginBottom: 2
                                    },
                                    children: [
                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                            icon: (_a = item.icon) !== null && _a !== void 0 ? _a : "check",
                                            color: "brand"
                                        }),
                                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            color: "gray400",
                                            children: item.text
                                        })
                                    ]
                                }, item.id);
                            })
                        }) : null,
                        typeof props.text !== "undefined" && (0, $4vwom.jsxs)("div", {
                            css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                display: "flex",
                                alignItems: "center",
                                gap: 8
                            }),
                            children: [
                                (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                    icon: "check",
                                    css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                        display: "none"
                                    }),
                                    style: {
                                        opacity: 0
                                    },
                                    "aria-hidden": true
                                }),
                                (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                    size: "md",
                                    color: "gray400",
                                    children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                        value: props.text
                                    })
                                })
                            ]
                        }),
                        typeof props.link !== "undefined" && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            justifyContent: "flex-end",
                            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                marginTop: 8
                            }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                marginTop: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                            })),
                            children: "onClick" in props.link ? (0, $4vwom.jsx)("button", {
                                onClick: props.link.onClick,
                                css: (0, $lhaLc.css)((0, $e82ba787de72625c$export$6b6f359a824920a4)("button")),
                                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "sm",
                                    color: "gray400",
                                    underline: true,
                                    children: props.link.text
                                })
                            }) : (0, $4vwom.jsx)("a", {
                                href: "url" in props.link ? props.link.url : undefined,
                                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "sm",
                                    color: "gray400",
                                    underline: true,
                                    children: props.link.text
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
(0, $eSiQ2.Component)($fc70c197a228049f$export$ecfb84f4ec12058a, {
    name: "BoxSelection",
    gallery: {
        path: "Controllers/BoxSelection",
        items: [
            {
                title: "Selected",
                variants: [
                    {
                        props: {
                            primary: "Trygghetspakke",
                            secondary: "50 kr/md",
                            list: [
                                {
                                    id: "abc123",
                                    text: "Erstatning ved tyveri/tap mot egenandel."
                                },
                                {
                                    id: "abc456",
                                    text: "Send mobilen inn gratis."
                                },
                                {
                                    id: "abc789",
                                    text: "Motta direkte betaling til din konto."
                                }
                            ],
                            link: {
                                text: "Vilk\xe5r og betingelser",
                                url: "#"
                            },
                            selected: true
                        }
                    }
                ]
            },
            {
                title: "Not selected",
                variants: [
                    {
                        props: {
                            secondary: "Ingen trygghetspakke",
                            text: "Du er selv ansvarlig for verdien av mobilen, som er 10 000 kr, hvis den blir skadet, mistet eller stj\xe5let."
                        }
                    }
                ]
            }
        ]
    }
});








var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $lhaLc = parcelRequire("lhaLc");


var $eSiQ2 = parcelRequire("eSiQ2");

var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");

var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");



var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");

"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $52e1d3df9689883d$var$PopChildMeasure extends $eeH7J.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $52e1d3df9689883d$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $eeH7J.useId)();
    const ref = (0, $eeH7J.useRef)(null);
    const size = (0, $eeH7J.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $eeH7J.useContext)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $eeH7J.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $dRzna.jsx)($52e1d3df9689883d$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $eeH7J.cloneElement(children, {
            ref: ref
        })
    });
}


"use client";
const $00fc35aff96a3476$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)($00fc35aff96a3476$var$newChildrenMap);
    const id = (0, $eeH7J.useId)();
    const context = (0, $eeH7J.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random()
    ] : [
        isPresent
    ]);
    (0, $eeH7J.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $eeH7J.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $dRzna.jsx)((0, $52e1d3df9689883d$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        children: children
    });
    return (0, $dRzna.jsx)((0, $2026c3a36ffa4174$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $00fc35aff96a3476$var$newChildrenMap() {
    return new Map();
}






var $eeH7J = parcelRequire("eeH7J");
const $33f0c4b420d1e939$export$10e61aed958678dd = (child)=>child.key || "";
function $33f0c4b420d1e939$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $eeH7J.Children).forEach(children, (child)=>{
        if ((0, $eeH7J.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}



"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $0df0f0e5b644e49a$export$3ae376d12526dd6f = ({ children: children, exitBeforeEnter: exitBeforeEnter, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $eeH7J.useMemo)(()=>(0, $33f0c4b420d1e939$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = presentChildren.map((0, $33f0c4b420d1e939$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $eeH7J.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $eeH7J.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $eeH7J.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $eeH7J.useState)(presentChildren);
    (0, $17cc282998a57b95$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $33f0c4b420d1e939$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $33f0c4b420d1e939$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $33f0c4b420d1e939$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $eeH7J.useContext)((0, $7e832de67499b416$export$a3579ca508007a95));
    return (0, $dRzna.jsx)((0, $dRzna.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $33f0c4b420d1e939$export$10e61aed958678dd)(child);
            const isPresent = presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $dRzna.jsx)((0, $00fc35aff96a3476$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                children: child
            }, key);
        })
    });
};







/**
 * Returns a random lorem ipsum string with the specified number of words. Adds a period to the
 * end of the string.
 *
 * @param wc Word count
 * @returns string
 */ function $5b6268f74fe7cc2e$export$69315a173ec7de2f(wc) {
    const arr = $5b6268f74fe7cc2e$var$text.split(" ");
    const rand = Math.max(Math.floor(Math.random() * arr.length) - wc, 0);
    const res = arr.slice(rand, rand + wc);
    const str = res.join(" ");
    return `${str.charAt(0).toUpperCase()}${(str.endsWith(".") ? str : `${str.endsWith(",") ? str.slice(0, str.length) : str}.`).slice(1, str.length + 1)}`;
}
const $5b6268f74fe7cc2e$var$text = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean iaculis rutrum quam, commodo pulvinar libero ultricies quis. Phasellus sollicitudin mauris nec libero posuere pretium. Donec egestas justo vitae enim aliquet, vel auctor nunc vulputate. Proin scelerisque quis ex ut commodo. Vivamus eleifend erat pretium velit lacinia, sit amet pharetra tellus dignissim. Maecenas pulvinar imperdiet lobortis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Quisque quis vehicula dui. Proin a fringilla enim. Cras id aliquet tellus. Donec sit amet diam eu lorem pulvinar varius at id urna. Integer volutpat dolor eu egestas pharetra. Quisque vehicula aliquam dignissim. Pellentesque ac nisi vitae felis accumsan tristique. Vestibulum a ex id nulla semper posuere. Quisque lobortis nulla nulla, at pharetra nunc pharetra consequat. Nullam dignissim imperdiet dolor sit amet tempor. Nulla feugiat urna hendrerit, maximus dolor id, imperdiet diam. Suspendisse potenti. Aenean et rutrum nunc, vel cursus erat. Praesent vitae consectetur turpis. Quisque mollis vel est non laoreet. Aenean pulvinar nisi vitae velit maximus finibus. Aenean imperdiet vulputate posuere. Maecenas metus tortor, egestas ut ultricies et, aliquet vel arcu. Donec consequat a mauris porttitor ultrices. Donec vel sem non quam luctus dignissim. Morbi accumsan, mi vitae consectetur aliquet, erat tortor congue dolor, consequat venenatis nulla nibh sed lacus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Sed ipsum nisi, vulputate blandit est a, scelerisque posuere orci. Quisque semper tortor quis fermentum pharetra. Proin orci tellus, iaculis in quam quis, ullamcorper pellentesque nisl. Sed viverra, massa ac consectetur convallis, massa tellus venenatis lectus, nec aliquam ligula libero quis ex. Donec a interdum quam, quis consequat mauris. Curabitur lacinia, nulla sed bibendum mattis, elit purus ultricies nibh, id sagittis dolor eros eu quam. Ut at nisi nec erat sollicitudin bibendum nec faucibus metus. Sed lectus metus, semper ac lorem et, bibendum suscipit arcu. Donec mauris lorem, tempor ut accumsan a, finibus non diam. Ut tincidunt malesuada metus, et viverra nisi tristique sit amet. Morbi congue vehicula est, in pretium mi vestibulum vel. Aenean et enim urna. Praesent vel neque a enim ullamcorper fringilla quis et arcu. Phasellus orci augue, posuere sit amet iaculis vitae, bibendum nec lorem. Nulla eu arcu vitae lorem gravida fringilla. Nulla vitae felis ac risus porttitor pellentesque a quis ipsum. Morbi eu vestibulum erat, sit amet semper sem. Donec sit amet magna eget dolor sagittis vulputate in id libero. Ut sagittis interdum nulla vitae viverra. In hac habitasse platea dictumst. Mauris maximus nulla in convallis placerat. Aliquam tempus aliquam magna quis hendrerit. Aliquam at augue aliquam, auctor neque at, scelerisque dolor. Pellentesque lacinia nulla dolor. Suspendisse potenti. Praesent luctus urna ut erat hendrerit pretium. Aliquam non massa quis est euismod maximus a et neque. Integer in consequat tellus. Nulla auctor elit in dui egestas, sed semper eros feugiat. Praesent facilisis nibh sed sem elementum convallis. Maecenas vel vehicula tellus, sed porta ligula. In tempor ac dui eleifend pretium. Nunc sem lorem, elementum vitae imperdiet in, porta in turpis. Nam lorem justo, congue quis nibh hendrerit, aliquet hendrerit felis. Sed dui eros, auctor sed sodales sit amet, blandit nec justo. Suspendisse nibh neque, sodales quis ligula a, dapibus faucibus dolor. In purus enim, bibendum non leo ac, imperdiet eleifend enim. Aenean consectetur tortor ut ex tincidunt luctus.";




var $aIeEI = parcelRequire("aIeEI");

const $2e602d91f6817609$export$dcfd5621ca9623a7 = {
    "100": "FF",
    "99": "FC",
    "98": "FA",
    "97": "F7",
    "96": "F5",
    "95": "F2",
    "94": "F0",
    "93": "ED",
    "92": "EB",
    "91": "E8",
    "90": "E6",
    "89": "E3",
    "88": "E0",
    "87": "DE",
    "86": "DB",
    "85": "D9",
    "84": "D6",
    "83": "D4",
    "82": "D1",
    "81": "CF",
    "80": "CC",
    "79": "C9",
    "78": "C7",
    "77": "C4",
    "76": "C2",
    "75": "BF",
    "74": "BD",
    "73": "BA",
    "72": "B8",
    "71": "B5",
    "70": "B3",
    "69": "B0",
    "68": "AD",
    "67": "AB",
    "66": "A8",
    "65": "A6",
    "64": "A3",
    "63": "A1",
    "62": "9E",
    "61": "9C",
    "60": "99",
    "59": "96",
    "58": "94",
    "57": "91",
    "56": "8F",
    "55": "8C",
    "54": "8A",
    "53": "87",
    "52": "85",
    "51": "82",
    "50": "80",
    "49": "7D",
    "48": "7A",
    "47": "78",
    "46": "75",
    "45": "73",
    "44": "70",
    "43": "6E",
    "42": "6B",
    "41": "69",
    "40": "66",
    "39": "63",
    "38": "61",
    "37": "5E",
    "36": "5C",
    "35": "59",
    "34": "57",
    "33": "54",
    "32": "52",
    "31": "4F",
    "30": "4D",
    "29": "4A",
    "28": "47",
    "27": "45",
    "26": "42",
    "25": "40",
    "24": "3D",
    "23": "3B",
    "22": "38",
    "21": "36",
    "20": "33",
    "19": "30",
    "18": "2E",
    "17": "2B",
    "16": "29",
    "15": "26",
    "14": "24",
    "13": "21",
    "12": "1F",
    "11": "1C",
    "10": "1A",
    "9": "17",
    "8": "14",
    "7": "12",
    "6": "0F",
    "5": "0D",
    "4": "0A",
    "3": "08",
    "2": "05",
    "1": "03",
    "0": "00"
};



function $37d4981a6b4c97c0$export$2b77a92f1a5ad772(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : "md";
    const localize = (0, $aIeEI.useLocalize)();
    const backdropRef = (0, $eeH7J.useRef)(null);
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss, responsiveSpacing: responsiveSpacing } = helpers;
    const [currentStep, setCurrentStep] = (0, $eeH7J.useState)((_b = props.step) !== null && _b !== void 0 ? _b : 0);
    const [stepTransition, setStepTransition] = (0, $eeH7J.useState)();
    const [promptClose, setPromptClose] = (0, $eeH7J.useState)();
    const containerCss = (0, $eeH7J.useMemo)(()=>(0, $lhaLc.css)({
            "--container-padding": "16px",
            padding: "var(--container-padding)"
        }, responsiveCss("min", "md", {
            "--container-padding": "64px"
        })), [
        responsiveCss
    ]);
    const modalCss = (0, $eeH7J.useMemo)(()=>(0, $lhaLc.css)({
            position: "relative",
            overflow: "hidden",
            backgroundColor: colors.grayWhite,
            maxHeight: "calc(100svh - var(--container-padding) - var(--container-padding))",
            "--modal-padding": "16px",
            padding: "var(--modal-padding)"
        }, responsiveCss("min", "sm", {
            "--modal-padding": "24px"
        }), responsiveCss("min", "md", {
            maxWidth: 960,
            "--modal-padding": "40px"
        })), [
        colors.grayWhite,
        responsiveCss
    ]);
    const handlePrevStep = (0, $eeH7J.useCallback)(()=>{
        var _a;
        setStepTransition("prev");
        setCurrentStep(currentStep - 1);
        (_a = props.onStepChange) === null || _a === void 0 || _a.call(props, currentStep - 1);
    }, [
        currentStep,
        props
    ]);
    const handleNextStep = (0, $eeH7J.useCallback)(()=>{
        var _a;
        setStepTransition("next");
        setCurrentStep(currentStep + 1);
        (_a = props.onStepChange) === null || _a === void 0 || _a.call(props, currentStep + 1);
    }, [
        currentStep,
        props
    ]);
    const handleBack = (0, $eeH7J.useCallback)(()=>{
        handlePrevStep();
        if (typeof props.onBack === "function") props.onBack();
    }, [
        props,
        handlePrevStep
    ]);
    const handleClose = (0, $eeH7J.useCallback)((e, reason)=>{
        var _a;
        if (props.closePrompt && !promptClose) setPromptClose(reason);
        else (_a = props.onClose) === null || _a === void 0 || _a.call(props, e, reason);
    }, [
        props,
        promptClose
    ]);
    const handleKeydown = (0, $eeH7J.useCallback)((e)=>{
        if (e.key === "Escape") {
            if (promptClose) setPromptClose(undefined);
            else handleClose(e, "escapeKeyDown");
        }
    }, [
        promptClose,
        handleClose
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (typeof window !== "undefined") {
            if (props.isOpen) document.body.style.overflow = "hidden";
            else document.body.style.overflow = "";
        }
    }, [
        props.isOpen
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (typeof window !== "undefined") {
            window.addEventListener("keydown", handleKeydown);
            return ()=>{
                window.removeEventListener("keydown", handleKeydown);
            };
        }
    }, [
        handleKeydown
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (!props.isOpen) setPromptClose(undefined);
    }, [
        props.isOpen
    ]);
    const [scrollContainerRef, scrollContainerAnimate] = (0, $4c4e7486a769eecb$export$9f387b98a73b1511)();
    const [overflowTop, setOverflowTop] = (0, $eeH7J.useState)(false);
    const [overflowBottom, setOverflowBottom] = (0, $eeH7J.useState)(false);
    const handleScroll = (0, $eeH7J.useCallback)((e)=>{
        if (e.currentTarget.scrollTop === 0 && overflowTop) setOverflowTop(false);
        else if (e.currentTarget.scrollTop > 0 && !overflowTop) setOverflowTop(true);
        const hasScrolledToBottom = Math.ceil(e.currentTarget.scrollTop + e.currentTarget.clientHeight) === e.currentTarget.scrollHeight;
        if (hasScrolledToBottom && overflowBottom) setOverflowBottom(false);
        else if (!hasScrolledToBottom && !overflowBottom) setOverflowBottom(true);
    }, [
        overflowBottom,
        overflowTop
    ]);
    const icon = (0, $eeH7J.useMemo)(()=>{
        var _a, _b, _c, _d, _e;
        return (_d = (_c = (_b = (_a = props.steps) === null || _a === void 0 ? void 0 : _a[currentStep]) === null || _b === void 0 ? void 0 : _b.header) === null || _c === void 0 ? void 0 : _c.icon) !== null && _d !== void 0 ? _d : (_e = props.header) === null || _e === void 0 ? void 0 : _e.icon;
    }, [
        currentStep,
        (_c = props.header) === null || _c === void 0 ? void 0 : _c.icon,
        props.steps
    ]);
    const closePromptRef = (0, $eeH7J.useRef)(null);
    const minHeightForClosePrompt = (0, $eeH7J.useMemo)(()=>{
        var _a;
        if (promptClose) return (_a = closePromptRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height;
    }, [
        promptClose
    ]);
    if (typeof window === "undefined") return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return /*#__PURE__*/ (0, $iMJCh.createPortal)((0, $4vwom.jsx)($37d4981a6b4c97c0$export$ab57792b9b6974a6.Provider, {
        value: {
            scrollContainerRef: scrollContainerRef,
            scrollContainerAnimate: scrollContainerAnimate
        },
        children: (0, $4vwom.jsxs)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
            children: [
                props.isOpen ? (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    style: {
                        position: "fixed",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        zIndex: 100,
                        opacity: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.32)"
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    },
                    onClick: (e)=>handleClose(e, "backdropClick")
                }, "backdrop") : null,
                props.isOpen ? (0, $4vwom.jsx)("div", {
                    ref: backdropRef,
                    style: {
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 200,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start"
                    },
                    css: containerCss,
                    onClick: (e)=>{
                        if (e.target === backdropRef.current) handleClose(e, "backdropClick");
                    },
                    children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        motion: {
                            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                            variants: {
                                open: {
                                    transform: "translateY(0px)",
                                    scale: 1,
                                    opacity: 1
                                },
                                close: {
                                    opacity: 0
                                }
                            },
                            initial: {
                                transform: "translateY(50px)",
                                scale: 0.75,
                                opacity: 0
                            },
                            animate: "open",
                            exit: "close",
                            onAnimationComplete: (definition)=>{
                                var _a;
                                if (definition === "open" && props.onOpenAnimationEnd) props.onOpenAnimationEnd();
                                else if (definition === "close") (_a = props.onCloseAnimationEnd) === null || _a === void 0 || _a.call(props);
                            }
                        },
                        direction: "column",
                        backgroundColor: "grayWhite",
                        borderRadius: "lg",
                        elevation: true,
                        style: {
                            width: (_d = props.width) !== null && _d !== void 0 ? _d : "auto",
                            minHeight: minHeightForClosePrompt
                        },
                        css: modalCss,
                        children: [
                            (0, $4vwom.jsxs)("div", {
                                style: {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    opacity: promptClose ? "100" : "0",
                                    zIndex: promptClose ? "100" : "-1"
                                },
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        elementRef: closePromptRef,
                                        direction: "column",
                                        gap: 24,
                                        style: {
                                            zIndex: "10001"
                                        },
                                        css: (0, $lhaLc.css)({
                                            padding: "var(--modal-padding)"
                                        }, responsiveCss("min", "md", {
                                            width: "80%"
                                        })),
                                        motion: {
                                            initial: {
                                                opacity: 0,
                                                translateY: "8px"
                                            },
                                            animate: promptClose ? {
                                                opacity: 1,
                                                translateY: "0px"
                                            } : undefined,
                                            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"]
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                level: 2,
                                                children: (_e = props.closePrompt) === null || _e === void 0 ? void 0 : _e.heading
                                            }),
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "md",
                                                children: (_f = props.closePrompt) === null || _f === void 0 ? void 0 : _f.text
                                            }),
                                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                gap: 8,
                                                justifyContent: "flex-end",
                                                css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                                                    flexDirection: "column",
                                                    justifyContent: "stretch"
                                                })),
                                                children: [
                                                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                        variant: "secondary",
                                                        size: "sm",
                                                        onClick: ()=>setPromptClose(undefined),
                                                        children: (_g = props.closePrompt) === null || _g === void 0 ? void 0 : _g.cancelButtonText
                                                    }),
                                                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                        variant: "dark",
                                                        size: "sm",
                                                        onClick: (e)=>// Should always be called because close prompt
                                                            // will not be visible unless promptClose is set.
                                                            promptClose ? handleClose(e, promptClose) : undefined,
                                                        children: (_h = props.closePrompt) === null || _h === void 0 ? void 0 : _h.confirmButtonText
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                        initial: {
                                            opacity: 0,
                                            backdropFilter: "blur(20px)",
                                            WebkitBackdropFilter: "blur(20px)"
                                        },
                                        animate: {
                                            opacity: 1,
                                            backdropFilter: "blur(40px)",
                                            WebkitBackdropFilter: "blur(40px)",
                                            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"]
                                        },
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: `${colors.grayWhite}${(0, $2e602d91f6817609$export$dcfd5621ca9623a7)["50"]}`,
                                            zIndex: 10000
                                        }
                                    })
                                ]
                            }),
                            props.header ? (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                justifyContent: "space-between",
                                style: size === "lg" ? {
                                    paddingBottom: 24,
                                    marginBottom: 24,
                                    borderBottom: `1px solid ${colors.gray200}`
                                } : {
                                    marginBottom: 24
                                },
                                css: props.header.divider ? (0, $lhaLc.css)({
                                    borderBottom: `1px solid ${colors.gray200}`
                                }, responsiveSpacing("sm", "padding-bottom")) : undefined,
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        alignItems: "center",
                                        children: [
                                            (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                                                mode: "popLayout",
                                                children: ((_m = (_l = (_k = (_j = props.steps) === null || _j === void 0 ? void 0 : _j[currentStep]) === null || _k === void 0 ? void 0 : _k.header) === null || _l === void 0 ? void 0 : _l.backButton) !== null && _m !== void 0 ? _m : props.header.backButton) ? (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                                    initial: {
                                                        opacity: 0
                                                    },
                                                    animate: {
                                                        opacity: 1
                                                    },
                                                    exit: {
                                                        opacity: 0
                                                    },
                                                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                        iconStart: "arrowLeft",
                                                        variant: "secondary",
                                                        size: "sm",
                                                        onClick: handleBack,
                                                        margin: {
                                                            right: (0, $756948b644e82cf2$export$981516ee4691055c)(32)
                                                        },
                                                        "aria-label": localize({
                                                            no: "Tilbake",
                                                            en: "Back"
                                                        })
                                                    }, "backButton")
                                                }) : null
                                            }),
                                            (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                                                mode: "popLayout",
                                                children: (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                                    initial: {
                                                        opacity: 0
                                                    },
                                                    animate: {
                                                        opacity: 1
                                                    },
                                                    exit: {
                                                        opacity: 0
                                                    },
                                                    children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                        alignItems: "center",
                                                        children: [
                                                            icon ? (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                                icon: icon,
                                                                size: [
                                                                    24,
                                                                    [
                                                                        "min",
                                                                        "md",
                                                                        32
                                                                    ]
                                                                ],
                                                                css: (0, $lhaLc.css)({
                                                                    marginRight: 8
                                                                }, responsiveCss("min", "md", {
                                                                    marginRight: 12
                                                                }))
                                                            }) : null,
                                                            ((_r = (_q = (_p = (_o = props.steps) === null || _o === void 0 ? void 0 : _o[currentStep]) === null || _p === void 0 ? void 0 : _p.header) === null || _q === void 0 ? void 0 : _q.title) !== null && _r !== void 0 ? _r : props.header.title) ? (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                                level: 2,
                                                                children: (_v = (_u = (_t = (_s = props.steps) === null || _s === void 0 ? void 0 : _s[currentStep]) === null || _t === void 0 ? void 0 : _t.header) === null || _u === void 0 ? void 0 : _u.title) !== null && _v !== void 0 ? _v : props.header.title
                                                            }) : null
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                                        children: props.header.closeButton ? (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                            initial: {
                                                opacity: 0
                                            },
                                            animate: {
                                                opacity: 1
                                            },
                                            exit: {
                                                opacity: 0
                                            },
                                            children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                iconStart: "close",
                                                variant: "secondary",
                                                size: "sm",
                                                onClick: (e)=>handleClose(e, "closeButton"),
                                                margin: {
                                                    left: (0, $756948b644e82cf2$export$981516ee4691055c)(40)
                                                },
                                                "aria-label": localize({
                                                    no: "Lukk denne popupen",
                                                    en: "Close this popup"
                                                })
                                            }, "closeButton")
                                        }) : null
                                    })
                                ]
                            }) : null,
                            !props.steps && (0, $4vwom.jsx)($37d4981a6b4c97c0$var$OverflowGradient, {
                                top: true,
                                show: overflowTop
                            }),
                            (0, $4vwom.jsx)("div", {
                                style: Object.assign({
                                    overflowY: props.steps ? "hidden" : "auto",
                                    maxHeight: "100%",
                                    flex: "1 1 auto",
                                    display: "flex",
                                    flexDirection: props.steps ? "row" : "column"
                                }, props.steps ? {
                                    width: "calc(100% + calc(var(--modal-padding) * 2))",
                                    transform: "translateX(calc(var(--modal-padding) * -1))"
                                } : {}),
                                ref: props.steps ? null : scrollContainerRef,
                                onScroll: props.steps ? undefined : handleScroll,
                                children: props.steps && props.renderSteps ? (0, $4vwom.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        width: "100%",
                                        paddingLeft: "var(--modal-padding)",
                                        paddingRight: "var(--modal-padding)"
                                    },
                                    children: props.renderSteps((0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                                        initial: false,
                                        mode: "popLayout",
                                        custom: stepTransition,
                                        children: (0, $4vwom.jsxs)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                            initial: "initial",
                                            animate: "target",
                                            exit: "exit",
                                            style: {
                                                flex: "1 0 100%"
                                            },
                                            variants: {
                                                initial: (st)=>!st ? {} : {
                                                        opacity: 0,
                                                        translateX: st === "next" ? "100px" : "-100px"
                                                    },
                                                target: (st)=>!st ? {} : {
                                                        opacity: 1,
                                                        translateX: "0px"
                                                    },
                                                exit: (st)=>st ? {
                                                        translateX: st === "next" ? "-100px" : "100px",
                                                        opacity: 0
                                                    } : {}
                                            },
                                            custom: stepTransition,
                                            children: [
                                                (0, $4vwom.jsx)($37d4981a6b4c97c0$var$OverflowGradient, {
                                                    top: true,
                                                    show: overflowTop
                                                }),
                                                (0, $4vwom.jsx)("div", {
                                                    ref: scrollContainerRef,
                                                    onScroll: handleScroll,
                                                    style: {
                                                        overflowY: "scroll",
                                                        maxHeight: "100%",
                                                        overflowX: "visible"
                                                    },
                                                    css: responsiveCss("min", "md", {
                                                        paddingRight: 20
                                                    }),
                                                    children: (_x = props.steps[(_w = props.step) !== null && _w !== void 0 ? _w : currentStep]) === null || _x === void 0 ? void 0 : _x.render(handleNextStep, handlePrevStep)
                                                }),
                                                (0, $4vwom.jsx)($37d4981a6b4c97c0$var$OverflowGradient, {
                                                    bottom: true,
                                                    show: overflowBottom
                                                })
                                            ]
                                        }, `step${currentStep}`)
                                    }), props.children, setCurrentStep)
                                }) : props.children
                            }),
                            !props.steps && (0, $4vwom.jsx)($37d4981a6b4c97c0$var$OverflowGradient, {
                                bottom: true,
                                show: overflowBottom
                            })
                        ]
                    }, "modal")
                }, "container") : (0, $4vwom.jsx)((0, $4vwom.Fragment), {})
            ]
        })
    }), document.body);
}
function $37d4981a6b4c97c0$var$OverflowGradient(props) {
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)({
            position: "relative",
            "&:before": {
                content: '""',
                position: "absolute",
                ["top" in props ? "top" : "bottom"]: 0,
                width: "100%",
                height: 12,
                background: `linear-gradient(${"top" in props ? "0" : "180"}deg, rgba(255, 255,255,0) 10%, rgba(255, 255,255,.8) 80%, rgba(255, 255,255,1))`,
                opacity: props.show ? 1 : 0,
                transition: "all ease-in-out 200ms",
                zIndex: 10,
                pointerEvents: "none"
            }
        })
    });
}
const $37d4981a6b4c97c0$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eeH7J.createContext)({});
(0, $eSiQ2.Component)($37d4981a6b4c97c0$export$2b77a92f1a5ad772, {
    name: "Modal",
    gallery: {
        path: "Modal/Modal",
        items: [
            {
                variants: [
                    {
                        props: (state = {
                            isOpen: true
                        }, setState)=>({
                                isOpen: state.isOpen,
                                onClose: ()=>setState({
                                        isOpen: false
                                    }),
                                header: {
                                    title: "Trade-in",
                                    icon: "handCoins",
                                    closeButton: true
                                },
                                children: (0, $4vwom.jsxs)("div", {
                                    children: [
                                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                            level: 4,
                                            margin: {
                                                bottom: 8
                                            },
                                            children: (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(3)
                                        }),
                                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            margin: {
                                                bottom: 32
                                            },
                                            children: (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(100)
                                        }),
                                        (0, $4vwom.jsxs)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                            level: 4,
                                            margin: {
                                                bottom: 8
                                            },
                                            children: [
                                                " ",
                                                (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(3),
                                                " "
                                            ]
                                        }),
                                        (0, $4vwom.jsxs)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            margin: {
                                                bottom: 32
                                            },
                                            children: [
                                                " ",
                                                (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(100),
                                                " "
                                            ]
                                        }),
                                        (0, $4vwom.jsxs)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                            level: 4,
                                            margin: {
                                                bottom: 8
                                            },
                                            children: [
                                                " ",
                                                (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(3),
                                                " "
                                            ]
                                        }),
                                        (0, $4vwom.jsxs)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            margin: {
                                                bottom: 32
                                            },
                                            children: [
                                                " ",
                                                (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(100),
                                                " "
                                            ]
                                        }),
                                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                            level: 4,
                                            margin: {
                                                bottom: 8
                                            },
                                            children: (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(3)
                                        }),
                                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            margin: {
                                                bottom: 32
                                            },
                                            children: (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(100)
                                        }),
                                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                            level: 4,
                                            margin: {
                                                bottom: 8
                                            },
                                            children: (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(3)
                                        }),
                                        (0, $4vwom.jsxs)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            children: [
                                                (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(100),
                                                " "
                                            ]
                                        })
                                    ]
                                })
                            }),
                        render: (cmp, _, setState)=>(0, $4vwom.jsxs)("div", {
                                children: [
                                    (0, $4vwom.jsx)("button", {
                                        onClick: ()=>{
                                            setState({
                                                isOpen: true
                                            });
                                        },
                                        children: "Open modal"
                                    }),
                                    cmp
                                ]
                            })
                    }
                ]
            }
        ]
    }
});





function $be6bc11d8e8cab8d$export$90b6e87e315e2927(props) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const { offer: offer, setOffer: setOffer, setStep: setStep, skipAuthStep: skipAuthStep, insuranceOptions: insuranceOptions } = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const selected = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = insuranceOptions.data) === null || _a === void 0 ? void 0 : _a.findIndex((io)=>io.id === offer.insurance);
    }, [
        insuranceOptions.data,
        offer.insurance
    ]);
    const [insuranceTermsMarkdown, setInsuranceTermsMarkdown] = (0, $eeH7J.useState)();
    const next = (0, $eeH7J.useCallback)(()=>{
        if (skipAuthStep) setStep("Shipping");
        else setStep("Login");
    }, [
        setStep,
        skipAuthStep
    ]);
    const handleTermsAndConditionsLinkClick = (0, $eeH7J.useCallback)((id)=>async (e)=>{
            const md = await (0, $e18f565b44c7bc7d$export$e9c540bc402f485f)(id);
            setInsuranceTermsMarkdown(md);
            e.preventDefault();
            e.stopPropagation();
        }, []);
    if (insuranceOptions.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: [
            16,
            [
                "min",
                "md",
                32
            ]
        ],
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: localize(props.headline)
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 16,
                children: [
                    (_a = insuranceOptions.data) === null || _a === void 0 ? void 0 : _a.map((option, i)=>{
                        var _a, _b;
                        return (0, $4vwom.jsx)((0, $fc70c197a228049f$export$ecfb84f4ec12058a), {
                            onClick: ()=>setOffer(Object.assign(Object.assign({}, offer), {
                                    insurance: option.id
                                })),
                            selected: selected === i,
                            primary: localize(option.displayName),
                            secondary: {
                                price: (_b = (_a = option.pricePerMonth) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "",
                                currency: localize({
                                    en: "NOK",
                                    no: "kr"
                                }),
                                period: localize({
                                    en: "month",
                                    no: "m\xe5ned"
                                })
                            },
                            list: option.sellingPoints.map((sp)=>({
                                    id: sp.id.valueOf(),
                                    icon: sp.icon,
                                    text: localize(sp.text)
                                })),
                            link: option.termsAndConditions.id ? {
                                onClick: handleTermsAndConditionsLinkClick(option.termsAndConditions.id),
                                text: localize(props.termsAndConditionsLinkText)
                            } : undefined
                        }, option.id.valueOf());
                    }),
                    (0, $4vwom.jsx)((0, $fc70c197a228049f$export$ecfb84f4ec12058a), {
                        onClick: ()=>setOffer(Object.assign(Object.assign({}, offer), {
                                insurance: undefined
                            })),
                        selected: selected === -1,
                        secondary: localize(props.noInsuranceHeader),
                        text: localize(props.noInsuranceText)
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                isOpen: !!insuranceTermsMarkdown,
                header: {
                    title: localize(props.termsAndConditionsLinkText),
                    closeButton: true
                },
                onClose: ()=>setInsuranceTermsMarkdown(undefined),
                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                    variant: "body",
                    size: "sm",
                    children: insuranceTermsMarkdown ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: localize(insuranceTermsMarkdown)
                    }) : null
                })
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 8,
                css: (0, $lhaLc.css)({
                    flexWrap: "wrap-reverse"
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                    flexDirection: "column-reverse"
                })),
                children: [
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                            display: "none"
                        })),
                        variant: "secondary",
                        onClick: ()=>{
                            setOffer(Object.assign(Object.assign({}, offer), {
                                insurance: undefined
                            }));
                            next();
                        },
                        children: localize(props.notThisTimeButton)
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: next,
                        children: localize(props.primaryCta)
                    })
                ]
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");
parcelRequire("5K1mb");
var $18Pjr = parcelRequire("18Pjr");

var $lhaLc = parcelRequire("lhaLc");


var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $aIeEI = parcelRequire("aIeEI");

function $902f603f96e1e919$export$f01c4f29d500ea93({ onClick: onClick }) {
    const locale = (0, $aIeEI.useCurrentLocale)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("vipps-mobilepay-button", {
        style: {
            width: "100%"
        },
        onClick: onClick,
        type: "button",
        brand: "vipps",
        language: locale.valueOf(),
        variant: "primary",
        rounded: "true",
        verb: "register",
        stretched: "true",
        branded: "true"
    });
}
function $902f603f96e1e919$export$34e49827c0cd090b({ width: width = 128, height: height = 32, color: color = "vippsOrange" }) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 64 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $4vwom.jsx)("path", {
            fillRule: "evenodd",
            d: "M64 3.83839C63.2798 1.09068 61.5314 0 59.1447 0C57.2111 0 54.7842 1.09068 54.7842 3.71715C54.7842 5.41401 55.9565 6.7476 57.8694 7.09117L59.6797 7.41418C60.9141 7.63629 61.2639 8.1011 61.2639 8.72741C61.2639 9.43447 60.5027 9.83844 59.3713 9.83844C57.8904 9.83844 56.9646 9.31324 56.8205 7.83828L54.2081 8.24247C54.6193 11.0908 57.17 12.2629 59.4739 12.2629C61.6547 12.2629 63.9792 11.0101 63.9792 8.48494C63.9792 6.76751 62.9298 5.51533 60.9756 5.15119L58.9805 4.78792C57.8694 4.58593 57.4993 4.04038 57.4993 3.51517C57.4993 2.84837 58.2191 2.42449 59.2066 2.42449C60.4616 2.42449 61.3461 2.84837 61.3872 4.24236L64 3.83839ZM5.925 8.16128L8.6399 0.302869H11.8283L7.09686 11.9594H4.73146L0 0.303088H3.18843L5.925 8.16128ZM22.6084 3.6364C22.6084 4.56558 21.8678 5.21202 21.0037 5.21202C20.1397 5.21202 19.3994 4.56558 19.3994 3.6364C19.3994 2.70701 20.1397 2.06078 21.0037 2.06078C21.8678 2.06078 22.6086 2.70701 22.6086 3.6364H22.6084ZM23.102 7.75775C22.0321 9.13111 20.9007 10.0806 18.9053 10.0807C16.8693 10.0807 15.2849 8.86856 14.0507 7.09095C13.5568 6.36354 12.7957 6.20204 12.2402 6.58588C11.726 6.94959 11.6028 7.71726 12.0757 8.38406C13.783 10.9497 16.1486 12.4443 18.9051 12.4443C21.4356 12.4443 23.4106 11.2324 24.9532 9.21213C25.5291 8.46481 25.5085 7.69713 24.9532 7.27281C24.4388 6.8684 23.6777 7.01042 23.102 7.75775ZM30.2 6.10094C30.2 8.48494 31.5989 9.73756 33.1625 9.73756C34.6434 9.73756 36.1659 8.56569 36.1659 6.10094C36.1659 3.67645 34.6434 2.50502 33.1828 2.50502C31.5989 2.50502 30.2 3.61605 30.2 6.10094ZM30.2 1.91941V0.323002H27.2996V16H30.2V10.424C31.1669 11.7172 32.4217 12.2629 33.8409 12.2629C36.495 12.2629 39.0868 10.2021 39.0868 5.95979C39.0868 1.89884 36.392 0.000218836 34.0879 0.000218836C32.257 0.000218836 31.0024 0.828296 30.2 1.91941ZM44.1275 6.10094C44.1275 8.48494 45.5262 9.73756 47.0898 9.73756C48.5707 9.73756 50.093 8.56569 50.093 6.10094C50.093 3.67645 48.5707 2.50502 47.1102 2.50502C45.5262 2.50502 44.1273 3.61605 44.1273 6.10094H44.1275ZM44.1275 1.91941V0.323002H44.1273H41.2269V16H44.1273V10.424C45.0943 11.7172 46.349 12.2629 47.7683 12.2629C50.4222 12.2629 53.0142 10.2021 53.0142 5.95979C53.0142 1.89884 50.3194 0.000218836 48.0152 0.000218836C46.1843 0.000218836 44.9298 0.828296 44.1275 1.91941Z",
            fill: colors[color]
        })
    });
}










function $9acc7a9b3b60d30b$export$b14e3cb78859f2c6(props) {
    var _a, _b, _c, _d, _e;
    const { responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { setStep: setStep, postAnalyticsCheckoutEvent: postAnalyticsCheckoutEvent } = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const localize = (0, $aIeEI.useLocalize)();
    const { pathname: pathname } = (0, $18Pjr.useLocation)();
    const login = (0, $f2e2333c5543d6d8$export$403f2aca3002ba0e)(`${pathname}?auth=success`, `${pathname}?auth=failed`);
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    if (me.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    if (((_a = me.data) === null || _a === void 0 ? void 0 : _a.canSkipLoginInCheckout) && !me.data.anonymous) return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        style: {
            width: "100%",
            height: "100%"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                padding: "16px 0"
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: "center",
                    gap: 12,
                    css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                        gap: 8,
                        marginBottom: 32
                    }), responsiveCss("min", "md", {
                        padding: "0 40px",
                        gap: 12,
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            color: "gray500",
                            level: 2,
                            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.loggedIn.headline), {
                                givenName: (_b = me.data.givenName) !== null && _b !== void 0 ? _b : "",
                                familyName: (_c = me.data.familyName) !== null && _c !== void 0 ? _c : ""
                            })
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            color: "gray400",
                            variant: "body",
                            size: "md",
                            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.loggedIn.text), {
                                givenName: (_d = me.data.givenName) !== null && _d !== void 0 ? _d : "",
                                familyName: (_e = me.data.familyName) !== null && _e !== void 0 ? _e : ""
                            })
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "primary",
                    size: "md",
                    onClick: ()=>setStep("Shipping"),
                    children: localize(props.loggedIn.nextStepButtonText)
                })
            ]
        })
    });
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        style: {
            width: "100%",
            height: "100%"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                padding: "16px 0"
            })),
            children: [
                (0, $4vwom.jsx)("div", {
                    style: {
                        marginBottom: 24
                    },
                    children: (0, $4vwom.jsx)((0, $902f603f96e1e919$export$34e49827c0cd090b), {
                        width: 80
                    })
                }),
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: "center",
                    gap: 12,
                    css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                        gap: 8,
                        marginBottom: 32
                    }), responsiveCss("min", "md", {
                        padding: "0 40px",
                        gap: 12,
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            color: "gray500",
                            level: 2,
                            children: localize(props.headline)
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            color: "gray400",
                            variant: "body",
                            size: "md",
                            children: localize(props.subHeadline)
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $902f603f96e1e919$export$f01c4f29d500ea93), {
                    onClick: ()=>{
                        postAnalyticsCheckoutEvent([
                            "step",
                            "login",
                            "init"
                        ]);
                        login();
                    }
                })
            ]
        })
    });
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");
var $cddd760e1f8ca7cc$exports = {};
!function(e, t) {
    $cddd760e1f8ca7cc$exports = t();
}($cddd760e1f8ca7cc$exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});



var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $18Pjr = parcelRequire("18Pjr");
var $5K1mb = parcelRequire("5K1mb");

var $8h5s0 = parcelRequire("8h5s0");

var $dUDPg = parcelRequire("dUDPg");

var $aIeEI = parcelRequire("aIeEI");
function $648bbd5693a5c2fa$export$9f60001f130da957(type) {
    const appEnv = type;
    if ($648bbd5693a5c2fa$var$appEnvironments.includes(appEnv)) return appEnv;
    throw new Error(`${type} is not a recognized adyen app environment`);
}
const $648bbd5693a5c2fa$var$appEnvironments = [
    "test",
    "live-eu",
    "live-us",
    "live-au",
    "live-apse",
    "live-in"
];
function $648bbd5693a5c2fa$export$42183f55bf1a9bfb(type) {
    const webEnv = type;
    if ($648bbd5693a5c2fa$var$webEnvironments.includes(webEnv)) return webEnv;
    throw new Error(`${type} is not a recognized adyen web environment`);
}
const $648bbd5693a5c2fa$var$webEnvironments = [
    "test",
    "live",
    "live-us",
    "live-au",
    "live-apse",
    "live-in"
];
function $648bbd5693a5c2fa$export$bbd3602d366ad96a(environment) {
    const appEnv = $648bbd5693a5c2fa$export$9f60001f130da957(environment);
    if (appEnv === "live-eu") return "live";
    return appEnv;
}



var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");

var $ikBJm = parcelRequire("ikBJm");
const $646bd1948001fb7a$export$23ec8986ee72eea6 = (errorText)=>{
    return (0, $ikBJm.Modal)((close)=>{
        return (0, $4vwom.jsx)("div", {
            className: "container",
            style: {
                backgroundColor: "white",
                padding: 20,
                paddingBottom: 30,
                borderRadius: 8,
                maxHeight: 400,
                width: 500
            },
            children: (0, $4vwom.jsxs)("div", {
                className: "row",
                children: [
                    (0, $4vwom.jsx)("div", {
                        className: "col-10",
                        children: errorText.map((t, i)=>{
                            return (0, $4vwom.jsxs)("div", {
                                children: [
                                    t,
                                    (0, $4vwom.jsx)("br", {})
                                ]
                            }, i);
                        })
                    }),
                    (0, $4vwom.jsx)("div", {
                        className: "col-2",
                        children: $646bd1948001fb7a$var$CloseButton(close)
                    })
                ]
            })
        });
    });
};
const $646bd1948001fb7a$var$CloseButton = (close)=>{
    return (0, $4vwom.jsx)("div", {
        className: "row",
        onClick: ()=>{
            close(undefined);
            window.location.reload();
        },
        style: {
            cursor: "pointer"
        },
        children: (0, $4vwom.jsxs)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $4vwom.jsx)("rect", {
                    x: "1",
                    y: "15.1406",
                    width: "20",
                    height: "3",
                    rx: "1.5",
                    transform: "rotate(-45 1 15.1406)",
                    fill: "#2A134E"
                }),
                (0, $4vwom.jsx)("rect", {
                    width: "20",
                    height: "3",
                    rx: "1.5",
                    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 17.2617 15.1406)",
                    fill: "#2A134E"
                })
            ]
        })
    });
};


// Adyen result code source: https://docs.adyen.com/online-payments/build-your-integration/payment-result-codes/
const $ceb61c869c7a4551$var$paymentSuccessful = [
    "Authorised"
];
const $ceb61c869c7a4551$var$paymentPending = [
    "Pending",
    "Received",
    "PresentToShopper"
];
const $ceb61c869c7a4551$var$orderStatusPaid = [
    "pending",
    "capturable",
    "complete",
    "refundable",
    "amendable",
    "faulty"
];
const $ceb61c869c7a4551$var$orderStatusSimpleError = [
    "inProgress",
    "refused"
];


function $ceb61c869c7a4551$export$8917e58bffe5ae62({ onSubmitCallback: onSubmitCallback, onSuccess: onSuccess, onError: onError, onActionHandled: onActionHandled, onConfigSuccess: onConfigSuccess, adyenOrder: adyenOrder, adyenOrderId: adyenOrderId, enableStoreDetails: enableStoreDetails, styles: styles, translations: translations, DropinElementProps: DropinElementProps, disableSuccessAnimation: disableSuccessAnimation, filterPaymentMethods: filterPaymentMethods, filterStoredPaymentMethods: filterStoredPaymentMethods }) {
    const [searchParams] = (0, $5K1mb.useSearchParams)();
    const routeAdyenOrder = (0, $18Pjr.useParams)().adyenOrder;
    const routeAdyenOrderId = (0, $18Pjr.useParams)().adyenOrderId;
    adyenOrder = (0, $8h5s0.Assert)(adyenOrder !== null && adyenOrder !== void 0 ? adyenOrder : routeAdyenOrder);
    adyenOrderId = (0, $8h5s0.Assert)(adyenOrderId !== null && adyenOrderId !== void 0 ? adyenOrderId : routeAdyenOrderId);
    const locale = (0, $aIeEI.useCurrentLocale)();
    const { data: paymentStatus } = (0, $dUDPg.usePaymentStatus)(adyenOrder, adyenOrderId);
    const { data: merchantConfig } = (0, $dUDPg.useMerchantConfig)(adyenOrder, adyenOrderId);
    const [errorDescription, setErrorDescription] = (0, $eeH7J.useState)();
    const adyenContainer = (0, $eeH7J.useRef)(null);
    const { auth3ds: auth3ds, testCode: testCode } = $ceb61c869c7a4551$var$getSearchParams(searchParams);
    const [adyenComponent, setComponent] = (0, $eeH7J.useState)(undefined);
    const [complete, setComplete] = (0, $eeH7J.useState)(false);
    const handleError = (0, $eeH7J.useCallback)((err)=>onError ? onError(err) : void (0, $646bd1948001fb7a$export$23ec8986ee72eea6)([
            "We could not process your payment at this time.",
            "Please try again in a few minutes."
        ]), [
        onError
    ]);
    (0, $eeH7J.useEffect)(()=>{
        // This flag counteracts double rendering of the Adyen component, which causes issues.
        // Source: https://github.com/adyen-examples/adyen-react-online-payments/blob/main/src/features/payment/Payment.js#L66
        let renderFlag = true;
        const shouldLoadAdyen = adyenContainer.current !== null && merchantConfig !== undefined && adyenOrder !== undefined && adyenOrderId !== undefined;
        if (!shouldLoadAdyen) return;
        const adyenFields = {
            adyenOrder: adyenOrder,
            adyenOrderId: adyenOrderId,
            locale: locale,
            merchantConfig: merchantConfig,
            setComplete: setComplete,
            auth3ds: auth3ds,
            testCode: testCode,
            enableStoreDetails: enableStoreDetails
        };
        (parcelRequire("lPiLr"));
        (parcelRequire("iz9uZ"));
        $ceb61c869c7a4551$var$loadAdyen({
            adyenFields: adyenFields,
            styles: styles,
            onActionHandled: onActionHandled,
            onConfigSuccess: onConfigSuccess,
            onSubmitCallback: onSubmitCallback,
            translations: translations,
            onError: handleError,
            filterPaymentMethods: filterPaymentMethods,
            filterStoredPaymentMethods: filterStoredPaymentMethods
        }).then((adyenObject)=>{
            if (adyenContainer.current !== null && adyenObject !== undefined && renderFlag) setComponent(adyenObject.create("dropin", Object.assign({}, DropinElementProps !== null && DropinElementProps !== void 0 ? DropinElementProps : {})).mount(adyenContainer.current));
        }).catch(handleError);
        return ()=>{
            renderFlag = false;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        paymentStatus,
        merchantConfig,
        enableStoreDetails
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        const paymentMade = $ceb61c869c7a4551$var$orderStatusPaid.includes((_a = paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.status) !== null && _a !== void 0 ? _a : "") || complete;
        const paymentFailed = $ceb61c869c7a4551$var$orderStatusSimpleError.includes((_b = paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.status) !== null && _b !== void 0 ? _b : "");
        if (paymentMade && adyenComponent !== undefined && disableSuccessAnimation) onSuccess();
        else if (paymentMade && adyenComponent !== undefined && !disableSuccessAnimation) {
            adyenComponent.setStatus("success");
            setTimeout(()=>onSuccess(), 2000);
        } else if (paymentFailed) setErrorDescription("There was an error processing your previous payment.");
    }, [
        adyenComponent,
        paymentStatus,
        complete,
        disableSuccessAnimation,
        onSuccess
    ]);
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            errorDescription && (0, $4vwom.jsx)("div", {
                className: "fuse-adyen-package error-description",
                children: errorDescription
            }),
            (0, $4vwom.jsx)("div", {
                className: "fuse-adyen-package dropin-container",
                ref: adyenContainer
            })
        ]
    });
}
function $ceb61c869c7a4551$var$getSearchParams(searchParams) {
    var _a;
    let auth3ds;
    let testCode;
    if (searchParams.get("auth3ds") === "true") auth3ds = true;
    const parsedInt = parseInt((_a = searchParams.get("testCode")) !== null && _a !== void 0 ? _a : "");
    if (!isNaN(parsedInt)) testCode = parsedInt;
    return {
        auth3ds: auth3ds,
        testCode: testCode
    };
}

async function $ceb61c869c7a4551$var$loadAdyen(options) {
    var _a, _b, _c;
    // Seems the typing is wrong in the Adyen NPM package, hence this ugly cast
    const AdyenCheckout = await (parcelRequire("2ewgS"));
    const { adyenOrder: adyenOrder, adyenOrderId: adyenOrderId, locale: locale, merchantConfig: merchantConfig } = options.adyenFields;
    try {
        const response = await (0, $dUDPg.getPaymentMethods)(adyenOrder, adyenOrderId, locale, "Web");
        const paymentMethods = response.result;
        const filteredPaymentMethodsResponse = {
            paymentMethods: options.filterPaymentMethods ? ((_a = paymentMethods.paymentMethods) !== null && _a !== void 0 ? _a : []).filter(options.filterPaymentMethods) : paymentMethods.paymentMethods,
            storedPaymentMethods: options.filterStoredPaymentMethods ? ((_b = paymentMethods.storedPaymentMethods) !== null && _b !== void 0 ? _b : []).filter(options.filterStoredPaymentMethods) : paymentMethods.storedPaymentMethods
        };
        const applePayConfig = !!((_c = filteredPaymentMethodsResponse.paymentMethods) === null || _c === void 0 ? void 0 : _c.some((pm)=>pm.type === "applepay")) ? {
            applepay: {
                amount: response.amount,
                countryCode: "NO"
            }
        } : {};
        return AdyenCheckout({
            onActionHandled: options.onActionHandled,
            amount: response.amount,
            paymentMethodsResponse: filteredPaymentMethodsResponse,
            clientKey: merchantConfig.adyenClientKey,
            locale: response.adyenLocale,
            environment: (0, $648bbd5693a5c2fa$export$bbd3602d366ad96a)(merchantConfig.adyenEnvironment),
            onSubmit: $ceb61c869c7a4551$var$onSubmit(options.adyenFields, options.onError),
            onAdditionalDetails: $ceb61c869c7a4551$var$onAdditionalDetails(options.adyenFields, options.onError),
            translations: options.translations,
            paymentMethodsConfiguration: Object.assign({
                card: {
                    styles: options.styles,
                    enableStoreDetails: options.adyenFields.enableStoreDetails,
                    hasHolderName: true,
                    onConfigSuccess: options.onConfigSuccess,
                    holderNameRequired: true
                }
            }, applePayConfig)
        });
    } catch (_error) {
        options.onError(_error);
    }
}
function $ceb61c869c7a4551$var$onSubmit(adyenFields, onError, callback) {
    const { adyenOrder: adyenOrder, adyenOrderId: adyenOrderId, locale: locale, auth3ds: auth3ds, testCode: testCode } = adyenFields;
    return async (state, adyenComponent)=>{
        callback === null || callback === void 0 || callback(state);
        if (!(state === null || state === void 0 ? void 0 : state.isValid)) {
            onError();
            return;
        }
        try {
            const body = {
                locale: locale,
                adyenData: state === null || state === void 0 ? void 0 : state.data,
                channel: "Web",
                auth3ds: auth3ds,
                testCode: testCode
            };
            const response = await (0, $dUDPg.postPayment)(adyenOrder, adyenOrderId, body);
            $ceb61c869c7a4551$var$handleAdyenResponse(adyenComponent, response.result, adyenFields, onError);
        } catch (_error) {
            onError(_error);
        }
    };
}
function $ceb61c869c7a4551$var$onAdditionalDetails(adyenFields, onError) {
    return async (state, adyenComponent)=>{
        try {
            const response = await (0, $dUDPg.postAdditionalDetails)(adyenFields.adyenOrder, adyenFields.adyenOrderId, state === null || state === void 0 ? void 0 : state.data);
            $ceb61c869c7a4551$var$handleAdyenResponse(adyenComponent, response.result, adyenFields, onError);
        } catch (_error) {
            onError(_error);
        }
    };
}
function $ceb61c869c7a4551$var$handleAdyenResponse(adyenComponent, response, adyenFields, onError) {
    const resultCode = response === null || response === void 0 ? void 0 : response.resultCode;
    const paymentMade = $ceb61c869c7a4551$var$paymentSuccessful.includes(resultCode) || $ceb61c869c7a4551$var$paymentPending.includes(resultCode);
    if ((response === null || response === void 0 ? void 0 : response.action) !== undefined) adyenComponent === null || adyenComponent === void 0 || adyenComponent.handleAction(response === null || response === void 0 ? void 0 : response.action);
    else if (paymentMade) adyenFields.setComplete(true);
    else onError(response);
}







var $4vwom = parcelRequire("4vwom");







var $4vwom = parcelRequire("4vwom");

function $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb({ horizontal: horizontal, weight: weight = 1, spacing: spacing = 8 }) {
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)("div", {
        css: helpers.spacingToCss("padding", {
            [horizontal ? "y" : "x"]: spacing
        }),
        children: (0, $4vwom.jsx)("div", {
            style: {
                [horizontal ? "height" : "width"]: weight,
                backgroundColor: colors.gray200,
                borderRadius: weight
            }
        })
    });
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");




const $1c19a55e13f5780a$var$sizes = {
    md: {
        xs: {
            height: 30,
            paddingLeft: 12,
            paddingRight: 12
        },
        lg: {
            height: 32,
            paddingLeft: 14,
            paddingRight: 14
        },
        xl: {
            height: 36 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            paddingLeft: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            paddingRight: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    }
};
const $1c19a55e13f5780a$export$48c441fbee531268 = function LabelNotification(props) {
    var _a;
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { fixedVariantCss: fixedVariantCss, responsiveVariantsCss: responsiveVariantsCss } = helpers;
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        elementRef: props.elementRef,
        alignItems: "center",
        backgroundColor: props.color,
        color: "grayWhite",
        borderRadius: "md",
        css: (0, $lhaLc.css)({
            display: "inline-flex"
        }, // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        props.size instanceof Array && props.size[0] === "fixed" ? fixedVariantCss($1c19a55e13f5780a$var$sizes, props.size) : responsiveVariantsCss($1c19a55e13f5780a$var$sizes, "md")),
        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
            variant: "label",
            size: (_a = props.size) !== null && _a !== void 0 ? _a : "md",
            children: props.children
        })
    });
};


function $ad78a5ecb6406b10$export$ac61754cc5f685a7(props) {
    var _a;
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        borderRadius: "md",
        padding: "md",
        borderColor: "gray200",
        direction: "column",
        gap: 16,
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 8,
                        alignItems: "center",
                        children: [
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: props.icon
                            }),
                            " ",
                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                level: 4,
                                children: props.step
                            })
                        ]
                    }),
                    !!props.label && (0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                        size: [
                            "fixed",
                            "md",
                            "md"
                        ],
                        color: "gray500",
                        children: props.label
                    }),
                    !!props.cta && (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        size: "sm",
                        variant: "secondary",
                        onClick: ()=>alert("Not implemented"),
                        children: props.cta.text
                    })
                ]
            }),
            (0, $4vwom.jsxs)("div", {
                children: [
                    !!props.title && (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 3,
                        children: props.title
                    }),
                    !!props.price && (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        alignItems: "baseline",
                        gap: 2,
                        children: [
                            !!props.originalPrice && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                color: "gray300",
                                style: {
                                    textDecoration: "underline",
                                    textUnderlineOffset: "-5px",
                                    textDecorationSkipInk: "none"
                                },
                                children: props.originalPrice
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 3,
                                color: "brand",
                                children: props.price
                            })
                        ]
                    }),
                    !!props.subtitle && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        color: "gray300",
                        margin: {
                            top: 8
                        },
                        children: props.subtitle
                    })
                ]
            }),
            !!((_a = props.list) === null || _a === void 0 ? void 0 : _a.length) && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                        horizontal: true,
                        spacing: 0
                    }),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: (0, $756948b644e82cf2$export$981516ee4691055c)(8),
                        children: props.list.map((li)=>{
                            var _a;
                            return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                gap: (0, $756948b644e82cf2$export$981516ee4691055c)(8),
                                children: [
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: (_a = li.icon) !== null && _a !== void 0 ? _a : "check",
                                        color: "forest"
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: li.text
                                    })
                                ]
                            }, li.id);
                        })
                    })
                ]
            }),
            !!props.text && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                        horizontal: true,
                        spacing: 0
                    }),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: (0, $756948b644e82cf2$export$981516ee4691055c)(8),
                        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "md",
                            children: props.text
                        })
                    })
                ]
            })
        ]
    });
}


parcelRequire("2LTO8");
var $8h5s0 = parcelRequire("8h5s0");
var $97R5C = parcelRequire("97R5C");






var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");




var $4vwom = parcelRequire("4vwom");

var $eSiQ2 = parcelRequire("eSiQ2");



function $a9f507254d800340$export$fbbf1dbfdbfcef12(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsxs)("div", {
        style: Object.assign(Object.assign({}, typeof props.margin === "undefined" ? {
            marginTop: 12,
            marginBottom: 16
        } : {}), {
            color: colors.warning,
            display: "flex"
        }),
        children: [
            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: "warning",
                color: "warning",
                margin: {
                    right: 8
                }
            }),
            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "md",
                children: props.children
            })
        ]
    });
}
(0, $eSiQ2.Component)($a9f507254d800340$export$fbbf1dbfdbfcef12, {
    name: "WarningMessage"
});




const $46d788785e7b9d76$var$borderColors = {
    default: "gray200",
    active: "brand",
    error: "error",
    completed: "forestLight"
};
const $46d788785e7b9d76$export$c86715117507e8e5 = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function TextInput(props, ref) {
    var _a;
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss, responsiveBodyCss: responsiveBodyCss } = helpers;
    const [isActive, setIsActive] = (0, $eeH7J.useState)(false);
    const state = (0, $eeH7J.useMemo)(()=>{
        if (props.state) return props.state;
        if (isActive) return "active";
        return "default";
    }, [
        props.state,
        isActive
    ]);
    const handleChange = (0, $eeH7J.useCallback)((e)=>{
        if (typeof props.onChange === "function") props.onChange(e);
    }, [
        props
    ]);
    const handleBlur = (0, $eeH7J.useCallback)((e)=>{
        var _a;
        setIsActive(false);
        (_a = props.onBlur) === null || _a === void 0 || _a.call(props, e);
    }, [
        setIsActive,
        props
    ]);
    const inputCss = (0, $eeH7J.useMemo)(()=>(0, $lhaLc.css)((0, $e82ba787de72625c$export$6b6f359a824920a4)("input"), {
            "::placeholder": {
                color: colors.gray300
            }
        }, responsiveBodyCss("md")), [
        colors.gray300,
        responsiveBodyCss
    ]);
    return (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
        style: props.fullwidth ? {
            width: "100%"
        } : {},
        children: [
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                borderColor: $46d788785e7b9d76$var$borderColors[state],
                borderRadius: "sm",
                css: (0, $lhaLc.css)({
                    height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                }, responsiveCss("min", "md", {
                    height: 64 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                })),
                style: {
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: 20 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                    paddingRight: 20 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                    borderWidth: 2,
                    backgroundColor: props.disabled ? colors.gray100 : undefined
                },
                children: [
                    !!props.icon && (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: props.icon,
                        style: {
                            marginRight: 10
                        }
                    }),
                    (0, $4vwom.jsx)("input", {
                        disabled: props.disabled,
                        ref: ref,
                        onFocus: ()=>setIsActive(true),
                        onBlur: handleBlur,
                        type: (_a = props.type) !== null && _a !== void 0 ? _a : "text",
                        autoComplete: props.autoComplete,
                        placeholder: props.label,
                        css: inputCss,
                        size: 2,
                        style: {
                            height: "100%",
                            width: "100%",
                            backgroundColor: "transparent",
                            paddingBottom: 2,
                            color: state === "error" ? colors.error : undefined
                        },
                        value: props.value,
                        onChange: handleChange
                    }),
                    state === "completed" && (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: "check",
                        color: "forest",
                        style: {
                            marginLeft: 10
                        }
                    })
                ]
            }),
            props.warning ? (0, $4vwom.jsx)((0, $a9f507254d800340$export$fbbf1dbfdbfcef12), {
                children: props.warning
            }) : null
        ]
    });
});
(0, $eSiQ2.Component)($46d788785e7b9d76$export$c86715117507e8e5, {
    name: "TextInput",
    gallery: {
        path: "Controllers/TextInput",
        items: [
            {
                title: "Empty",
                variants: [
                    {
                        props: (state = {
                            value: ""
                        }, setState)=>({
                                value: state.value,
                                label: "First name",
                                onChange: (e)=>setState(e.target.value)
                            })
                    }
                ]
            },
            {
                title: "With value",
                variants: [
                    {
                        props: (state = {
                            value: "Jane"
                        }, setState)=>({
                                value: state.value,
                                onChange: (e)=>setState(e.target.value)
                            })
                    }
                ]
            },
            {
                title: "With icon",
                variants: [
                    {
                        props: (state = {
                            value: "Oslo"
                        }, setState)=>({
                                value: state.value,
                                icon: "navigationArrow",
                                onChange: (e)=>setState(e.target.value)
                            })
                    }
                ]
            },
            {
                title: "Completed",
                variants: [
                    {
                        props: (state = {
                            value: "John Doe"
                        }, setState)=>({
                                value: state.value,
                                state: "completed",
                                onChange: (e)=>setState(e.target.value)
                            })
                    }
                ]
            },
            {
                title: "Error",
                variants: [
                    {
                        props: (state = {
                            value: "John Doe"
                        }, setState)=>({
                                value: state.value,
                                state: "error",
                                onChange: (e)=>setState(e.target.value)
                            })
                    }
                ]
            }
        ]
    }
});



var $34lt5 = parcelRequire("34lt5");


var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");





var $aIeEI = parcelRequire("aIeEI");


var $dUDPg = parcelRequire("dUDPg");
function $440c4b5b9e7400e5$export$55aa795759f227b9(props) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const primaryActionPageInfo = (0, $dUDPg.useWebPageInfo)(props.primaryAction.page);
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        style: {
            width: "100%",
            height: "100%"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                padding: "16px 0"
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: "center",
                    gap: 12,
                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                        gap: 8,
                        marginBottom: 32
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        padding: "0 40px",
                        gap: 12,
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            color: "gray500",
                            level: 2,
                            children: localize(props.heading)
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            color: "gray400",
                            variant: "body",
                            size: "md",
                            children: localize(props.text)
                        })
                    ]
                }),
                ((_a = primaryActionPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) ? (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "primary",
                    size: "md",
                    as: "a",
                    href: `/${localize(primaryActionPageInfo.data.slug)}`,
                    children: localize(props.primaryAction.buttonText)
                }) : null
            ]
        })
    });
}




var $8vTN8 = parcelRequire("8vTN8");

var $dUDPg = parcelRequire("dUDPg");

var $eeH7J = parcelRequire("eeH7J");

var $aIeEI = parcelRequire("aIeEI");
parcelRequire("2LTO8");
var $2zTLn = parcelRequire("2zTLn");
const $b274814d74f89bd0$export$2bb3eb27682a776 = {
    no: "m\xe5neder",
    en: "months"
};
const $b274814d74f89bd0$export$b4b23bfab2f68498 = {
    no: "md",
    en: "mo"
};
const $b274814d74f89bd0$export$91d51a43b638ef12 = {
    [(0, $2zTLn.CurrencyCode)("NOK")]: {
        no: "kr",
        en: "kr"
    }
};
function $b274814d74f89bd0$export$2daf9f30efa60400() {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $eeH7J.useCallback)((cc)=>{
        var _a;
        return `${localize((_a = $b274814d74f89bd0$export$91d51a43b638ef12[cc]) !== null && _a !== void 0 ? _a : {
            no: cc
        })}`;
    }, [
        localize
    ]);
}
function $b274814d74f89bd0$export$cd05f017078a61a8() {
    const localize = (0, $aIeEI.useLocalize)();
    const currentLocale = (0, $aIeEI.useCurrentLocale)();
    return (0, $eeH7J.useCallback)((a)=>{
        var _a;
        return `${Intl.NumberFormat(currentLocale.valueOf(), {
            minimumFractionDigits: Number.isInteger(a.majorUnits) ? 0 : 2,
            maximumFractionDigits: 2
        }).format(a.majorUnits)} ${localize((_a = $b274814d74f89bd0$export$91d51a43b638ef12[a.currency]) !== null && _a !== void 0 ? _a : {
            no: a.currency
        })}`;
    }, [
        currentLocale,
        localize
    ]);
}




function $f6289446464b7da6$export$20c36f2f8fe0d441(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    const context = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const navigate = (0, $8vTN8.useNavigate)();
    const { useOrder: useOrder } = context;
    const localize = (0, $aIeEI.useLocalize)();
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const [checkoutShippingState] = (0, $047f6f355e30d7d1$export$4a755370e8335b36)();
    const [checkoutTradeInPriceRequest] = (0, $047f6f355e30d7d1$export$b7eadabbf1e81c9b)();
    const [checkoutTradeInForm] = (0, $047f6f355e30d7d1$export$d42da32bb85d5739)();
    const [checkoutTradeInResult] = (0, $047f6f355e30d7d1$export$db65bad7d1fa5d6f)();
    const { data: tnc, loading: tncIsLoading } = (0, $e18f565b44c7bc7d$export$23e8c26267d65867)();
    const { order: order, ensureOrder: ensureOrder, isLoading: isLoading, errorMessage: errorMessage } = useOrder();
    const [phoneIsNotAvailable, setPhoneIsNotAvailable] = (0, $eeH7J.useState)(undefined);
    const [dropinIsReady, setDropinIsReady] = (0, $eeH7J.useState)(false);
    const [multiplePaymentMethods, setMultiplePaymentMethods] = (0, $eeH7J.useState)(false);
    const adyenDropinContainerRef = (0, $eeH7J.useRef)(null);
    const [paymentError, setPaymentError] = (0, $eeH7J.useState)(false);
    const [creditCheckError, setCreditCheckError] = (0, $eeH7J.useState)(undefined);
    const confirmationPageInfo = (0, $dUDPg.useWebPageInfo)(props.orderConfirmationPage);
    const theme = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { colors: colors } = theme;
    const handleDropinReady = (0, $eeH7J.useCallback)(()=>{
        var _a, _b;
        const numberOfPaymentMethods = (_b = (_a = adyenDropinContainerRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(".adyen-checkout__payment-method").length) !== null && _b !== void 0 ? _b : 0;
        setMultiplePaymentMethods(numberOfPaymentMethods > 1);
        setDropinIsReady(true);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($cddd760e1f8ca7cc$exports))));
    const postAnalyticsCheckoutPaymentEvent = (0, $eeH7J.useCallback)(async (event, data)=>{
        context.postAnalyticsCheckoutEvent([
            "step",
            "payment",
            event
        ], data);
    }, [
        context
    ]);
    const shippingSlotId = ((_a = checkoutShippingState.selectedOption) === null || _a === void 0 ? void 0 : _a.type) === "Manual" ? (_b = checkoutShippingState.selectedOption.selectedSlot) === null || _b === void 0 ? void 0 : _b.id : undefined;
    const ensureCheckoutOrder = (0, $eeH7J.useCallback)(async ()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        ensureOrder({
            phone: context.offer,
            shippingAddress: {
                street: (_b = (_a = context.shipping.form) === null || _a === void 0 ? void 0 : _a.street.value) !== null && _b !== void 0 ? _b : "",
                unit: (_c = context.shipping.form) === null || _c === void 0 ? void 0 : _c.unit.value,
                city: (_e = (_d = context.shipping.form) === null || _d === void 0 ? void 0 : _d.region.value) !== null && _e !== void 0 ? _e : "",
                zip: (_g = (_f = context.shipping.form) === null || _f === void 0 ? void 0 : _f.postalCode.value) !== null && _g !== void 0 ? _g : "",
                country: (0, $97R5C.CountryCode)((_j = (_h = context.shipping.form) === null || _h === void 0 ? void 0 : _h.countryCode.value) !== null && _j !== void 0 ? _j : "")
            },
            shippingType: (0, $8h5s0.Assert)((_k = checkoutShippingState.selectedOption) === null || _k === void 0 ? void 0 : _k.type),
            shippingSlot: ((_l = checkoutShippingState.selectedOption) === null || _l === void 0 ? void 0 : _l.type) === "Manual" ? shippingSlotId : undefined,
            tradeIn: checkoutTradeInPriceRequest,
            termsAndConditions: (0, $8h5s0.Assert)(tnc === null || tnc === void 0 ? void 0 : tnc.phoneOrder.id),
            insuranceTermsAndConditions: (0, $8h5s0.Assert)(tnc === null || tnc === void 0 ? void 0 : tnc.insurance.id)
        }).then(()=>{
            setPhoneIsNotAvailable(false);
        }).catch(()=>{
            setPhoneIsNotAvailable(true);
        });
    }, [
        shippingSlotId,
        (_c = checkoutShippingState.selectedOption) === null || _c === void 0 ? void 0 : _c.type,
        checkoutTradeInPriceRequest,
        context.offer,
        (_d = context.shipping.form) === null || _d === void 0 ? void 0 : _d.countryCode.value,
        (_e = context.shipping.form) === null || _e === void 0 ? void 0 : _e.postalCode.value,
        (_f = context.shipping.form) === null || _f === void 0 ? void 0 : _f.region.value,
        (_g = context.shipping.form) === null || _g === void 0 ? void 0 : _g.street.value,
        (_h = context.shipping.form) === null || _h === void 0 ? void 0 : _h.unit.value,
        ensureOrder,
        tnc === null || tnc === void 0 ? void 0 : tnc.insurance.id,
        tnc === null || tnc === void 0 ? void 0 : tnc.phoneOrder.id
    ]);
    const handlePaymentError = (0, $eeH7J.useCallback)((err)=>{
        // Check if payment error is due to failed credit check.
        if ((err === null || err === void 0 ? void 0 : err.type) === "CreditCheckBlocked") {
            setCreditCheckError("blocked");
            postAnalyticsCheckoutPaymentEvent("credit-check-blocked");
        } else if ((err === null || err === void 0 ? void 0 : err.type) === "CreditCheckManualProcessing") setCreditCheckError("manual");
        else if ((err === null || err === void 0 ? void 0 : err.type) === "CreditScoreTooLow") setCreditCheckError("tooLow");
        else postAnalyticsCheckoutPaymentEvent("error");
        setPaymentError(true);
        setDropinIsReady(false);
        ensureCheckoutOrder();
    }, [
        ensureCheckoutOrder,
        postAnalyticsCheckoutPaymentEvent
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (isLoading || tncIsLoading) return;
        if (phoneIsNotAvailable !== undefined) return;
        ensureCheckoutOrder();
    }, [
        isLoading,
        ensureCheckoutOrder,
        phoneIsNotAvailable,
        tncIsLoading
    ]);
    const selectedInsurance = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = context.insuranceOptions.data) === null || _a === void 0 ? void 0 : _a.find((insurance)=>insurance.id === context.offer.insurance);
    }, [
        context.insuranceOptions.data,
        context.offer.insurance
    ]);
    const creditCheckErrorMessage = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return !!creditCheckError && ((_a = props.creditCheckMessages) === null || _a === void 0 ? void 0 : _a[creditCheckError]) ? localize(props.creditCheckMessages[creditCheckError]) : undefined;
    }, [
        creditCheckError,
        localize,
        props.creditCheckMessages
    ]);
    if (isLoading || tncIsLoading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    if (!order && ((_j = checkoutShippingState.selectedOption) === null || _j === void 0 ? void 0 : _j.type) === "Manual" && !shippingSlotId) return (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
        size: "md",
        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
            value: localize(props.payment.missingShippingMethod)
        })
    });
    if (errorMessage) return (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
        size: "md",
        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
            value: localize(props.payment.orderReservationError)
        })
    });
    if (!order) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    if (phoneIsNotAvailable) return (0, $4vwom.jsx)((0, $440c4b5b9e7400e5$export$55aa795759f227b9), Object.assign({}, context.props.SoldOut));
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 32,
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: localize(props.heading)
            }),
            (0, $4vwom.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    !dropinIsReady && !paymentError && (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 16,
                        direction: "column",
                        alignItems: "stretch",
                        children: [
                            (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                disabled: true
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                gap: 16,
                                children: [
                                    (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                        fullwidth: true,
                                        disabled: true
                                    }),
                                    (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                        fullwidth: true,
                                        disabled: true
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                disabled: true
                            }),
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                size: "md",
                                variant: "primary",
                                disabled: true
                            })
                        ]
                    }),
                    !!creditCheckErrorMessage && (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: creditCheckErrorMessage
                    }),
                    paymentError && !creditCheckErrorMessage && (0, $4vwom.jsxs)("div", {
                        children: [
                            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(props.payment.paymentErrorMessage)
                            }),
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                variant: "dark",
                                margin: {
                                    top: 16
                                },
                                size: "sm",
                                onClick: ()=>setPaymentError(false),
                                children: localize({
                                    no: "Pr\xf8v igjen",
                                    en: "Try again"
                                })
                            })
                        ]
                    }),
                    phoneIsNotAvailable === false && !paymentError && (0, $4vwom.jsx)("div", {
                        ref: adyenDropinContainerRef,
                        css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$682f474bed45e419), !multiplePaymentMethods ? (0, $lhaLc.css)({
                            ".adyen-checkout__payment-method__header": {
                                display: "none"
                            }
                        }) : {}),
                        style: !dropinIsReady ? {
                            position: "absolute",
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            opacity: 0
                        } : {},
                        children: (0, $4vwom.jsx)((0, $ceb61c869c7a4551$export$8917e58bffe5ae62), {
                            onSuccess: ()=>{
                                var _a;
                                postAnalyticsCheckoutPaymentEvent("success");
                                if ((_a = confirmationPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) navigate(`/${localize(confirmationPageInfo.data.slug)}?o=${order.id}`);
                                else alert("Missing confirmation page configuration.");
                            },
                            onConfigSuccess: ()=>{
                                postAnalyticsCheckoutPaymentEvent("card-form-ready");
                            },
                            onSubmitCallback: (state)=>{
                                postAnalyticsCheckoutPaymentEvent("submit");
                            },
                            onError: handlePaymentError,
                            adyenOrder: "phone-subscription",
                            adyenOrderId: // The Adyen Order ID is encoded as
                            // `${orderId}_${periodIndex}`. We are paying for the
                            // first period (0).
                            `${order.id.valueOf()}_0`,
                            DropinElementProps: {
                                onReady: handleDropinReady,
                                instantPaymentTypes: [
                                    "applepay"
                                ]
                            },
                            onActionHandled: (data)=>{
                                postAnalyticsCheckoutPaymentEvent("action-handled", {
                                    componentType: data.componentType,
                                    actionDescription: data.actionDescription
                                });
                            },
                            translations: {
                                "no-NO": {
                                    "creditCard.holderName.placeholder": localize(props.payment.cardholderNamePlaceholder, (0, $34lt5.LocaleKey).no)
                                },
                                "en-US": {
                                    "creditCard.holderName.placeholder": localize(props.payment.cardholderNamePlaceholder, (0, $34lt5.LocaleKey).en)
                                }
                            },
                            filterPaymentMethods: ((_k = me.data) === null || _k === void 0 ? void 0 : _k.disabledPaymentMethods) ? (pm)=>{
                                var _a, _b;
                                return !((_b = (_a = me.data) === null || _a === void 0 ? void 0 : _a.disabledPaymentMethods) === null || _b === void 0 ? void 0 : _b.includes(pm.type));
                            } : undefined,
                            styles: {
                                base: {
                                    color: colors.gray500,
                                    fontWeight: "300",
                                    fontSize: "16px"
                                },
                                placeholder: {
                                    color: colors.gray300,
                                    fontWeight: "300",
                                    fontSize: "16px"
                                }
                            }
                        })
                    })
                ]
            }),
            !creditCheckErrorMessage && (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                backgroundColor: "gray100",
                borderRadius: "md",
                padding: "md",
                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                    variant: "body",
                    size: "md",
                    color: "gray400",
                    children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: localize(props.payment.paymentDetailsWillBeStoredText)
                    })
                })
            }),
            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                horizontal: true,
                spacing: 0
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 24,
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 3,
                        children: localize(props.summary.heading)
                    }),
                    (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                        icon: "device",
                        step: localize((_l = props.summary.device.stepName) !== null && _l !== void 0 ? _l : {}),
                        title: localize(context.offer.name),
                        price: ((_m = context.price) === null || _m === void 0 ? void 0 : _m.monthlyCost.phone) ? `${formatAmount(context.price.monthlyCost.phone)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}` : undefined,
                        subtitle: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.summary.device.rentalPeriodTotalPrice), {
                            rentalPeriod: `${context.offer.rentalPeriod.valueOf()} ${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                            totalPrice: context.price ? `${formatAmount({
                                minorUnits: context.price.monthlyCost.phone.minorUnits * context.offer.rentalPeriod.valueOf(),
                                majorUnits: context.price.monthlyCost.phone.majorUnits * context.offer.rentalPeriod.valueOf(),
                                currency: context.price.monthlyCost.phone.currency
                            })}` : ""
                        })
                    }),
                    checkoutTradeInForm && checkoutTradeInPriceRequest && typeof (checkoutTradeInResult === null || checkoutTradeInResult === void 0 ? void 0 : checkoutTradeInResult.value) !== "undefined" && ((_o = order.tradeIn) === null || _o === void 0 ? void 0 : _o.discount.amount) && checkoutTradeInResult.deviceName ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                        icon: "handCoins",
                        step: localize(context.props.TradeIn.name),
                        title: localize(checkoutTradeInResult.deviceName),
                        subtitle: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.summary.tradeIn.text), {
                            monthlyDiscount: formatAmount(checkoutTradeInResult.monthlyDiscount),
                            discountPeriod: `${checkoutTradeInResult.months.valueOf()}`
                        }),
                        price: formatAmount(checkoutTradeInResult.value),
                        list: (_p = props.summary.tradeIn.list) === null || _p === void 0 ? void 0 : _p.map((li)=>({
                                id: li.id.valueOf(),
                                text: localize(li.text)
                            }))
                    }) : null,
                    selectedInsurance && ((_q = context.price) === null || _q === void 0 ? void 0 : _q.monthlyCost.insurance) ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                        icon: "shield",
                        step: localize(context.props.Insurance.name),
                        title: localize(selectedInsurance.displayName),
                        price: `${formatAmount(context.price.monthlyCost.insurance)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                        list: selectedInsurance.sellingPoints.map((isp)=>({
                                id: isp.id.valueOf(),
                                text: localize(isp.text)
                            }))
                    }) : null,
                    checkoutShippingState.selectedOption ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                        icon: "truck",
                        step: localize(context.props.Shipping.name),
                        title: localize(checkoutShippingState.selectedOption.name),
                        subtitle: checkoutShippingState.selectedOption.type === "Manual" && checkoutShippingState.selectedOption.selectedSlot ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.summary.shipping.deliverySlotText), {
                            deliveryDate: (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(checkoutShippingState.selectedOption.selectedSlot.date).format("dddd Do MMMM"),
                            deliverySlotFrom: checkoutShippingState.selectedOption.selectedSlot.from,
                            deliverySlotTo: checkoutShippingState.selectedOption.selectedSlot.to
                        }) : props.summary.shipping.otherDeliveryOptionText ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.summary.shipping.otherDeliveryOptionText), {
                            deliveryOptionName: localize(checkoutShippingState.selectedOption.name),
                            deliveryOptionDescription: localize(checkoutShippingState.selectedOption.description)
                        }) : localize(checkoutShippingState.selectedOption.description),
                        price: context.price && context.price.shippingCost.majorUnits.valueOf() > 0 ? formatAmount(context.price.shippingCost) : localize({
                            no: "Gratis",
                            en: "Free"
                        }),
                        text: [
                            (_r = checkoutShippingState.form) === null || _r === void 0 ? void 0 : _r.street.value,
                            `${(_s = checkoutShippingState.form) === null || _s === void 0 ? void 0 : _s.postalCode.value} ${(_t = checkoutShippingState.form) === null || _t === void 0 ? void 0 : _t.region.value}`
                        ].filter((t)=>!!t).join(", ")
                    }) : null
                ]
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");





var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");





const $5d11cd7f4673d445$var$boxStyle = (0, $lhaLc.css)({
    borderStyle: "solid",
    borderWidth: 2,
    borderRadius: 24,
    height: 24,
    width: 24,
    display: "flex"
});
function $5d11cd7f4673d445$export$f4422ae58352e179(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const handleClick = (0, $eeH7J.useCallback)((e)=>{
        if (typeof props.onClick === "function") props.onClick(e);
    }, [
        props.checked
    ]);
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        as: "label",
        alignItems: "center",
        style: {
            cursor: props.disabled ? "default" : "pointer",
            position: "relative"
        },
        padding: props.padding,
        children: [
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                onClick: handleClick,
                backgroundColor: props.disabled ? props.checked ? "gray200" : "gray100" : props.checked ? "brand" : "grayWhite",
                borderColor: props.disabled ? "gray200" : props.checked ? "brand" : "gray200",
                css: (0, $lhaLc.css)($5d11cd7f4673d445$var$boxStyle, {
                    cursor: props.disabled ? "default" : "pointer"
                }),
                children: [
                    (0, $4vwom.jsx)("input", {
                        type: "radio",
                        disabled: props.disabled,
                        style: {
                            opacity: 0,
                            position: "absolute",
                            cursor: "inherit"
                        }
                    }),
                    props.checked && (0, $4vwom.jsx)("div", {
                        css: (0, $lhaLc.css)({
                            height: "100%",
                            width: "100%",
                            borderRadius: 24,
                            border: `2px solid ${colors.grayWhite}`
                        })
                    })
                ]
            }),
            props.label && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "md",
                margin: {
                    left: 16
                },
                children: typeof props.label === "string" ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                    value: props.label,
                    renderers: {
                        paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                children: p.children
                            })
                    }
                }) : props.label
            })
        ]
    });
}
(0, $eSiQ2.Component)($5d11cd7f4673d445$export$f4422ae58352e179, {
    name: "RadioButton",
    gallery: {
        path: "Controllers/RadioButton",
        items: [
            {
                title: "Enabled",
                variants: [
                    {
                        label: "Interactive",
                        props: (state = {
                            checked: false
                        }, setState)=>({
                                checked: state.checked,
                                onClick: ()=>{
                                    setState({
                                        checked: !state.checked
                                    });
                                }
                            })
                    },
                    {
                        label: "Checked",
                        props: {
                            checked: true
                        }
                    }
                ]
            },
            {
                title: "Disabled",
                variants: [
                    {
                        label: "Unchecked",
                        props: {
                            checked: false,
                            disabled: true
                        }
                    },
                    {
                        label: "Checked",
                        props: {
                            checked: true,
                            disabled: true
                        }
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eeH7J = parcelRequire("eeH7J");

var $eSiQ2 = parcelRequire("eSiQ2");




const $06e3a36d2d83b339$var$boxStyle = (0, $lhaLc.css)({
    flexGrow: 0,
    flexShrink: 0,
    borderStyle: "solid",
    borderWidth: 2,
    borderRadius: 6,
    height: 24,
    width: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
function $06e3a36d2d83b339$export$48513f6b9f8ce62d(props) {
    const inputRef = (0, $eeH7J.useRef)(null);
    const handleChange = (0, $eeH7J.useCallback)((e)=>{
        if (typeof props.onChange === "function") props.onChange(e);
    }, [
        props
    ]);
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        as: "label",
        alignItems: "center",
        style: {
            cursor: props.disabled ? "default" : "pointer",
            position: "relative"
        },
        padding: props.padding,
        children: [
            (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                backgroundColor: props.disabled ? props.checked ? "gray200" : "gray100" : props.checked ? "brand" : "grayWhite",
                borderColor: props.disabled ? "gray200" : props.checked ? "brand" : "gray200",
                css: $06e3a36d2d83b339$var$boxStyle,
                children: props.checked && (0, $4vwom.jsx)($06e3a36d2d83b339$var$Checkmark, {})
            }),
            props.label && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "md",
                margin: {
                    left: 16
                },
                children: typeof props.label === "string" ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                    value: props.label,
                    renderers: {
                        paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                children: p.children
                            })
                    }
                }) : props.label
            }),
            (0, $4vwom.jsx)("input", {
                type: "checkbox",
                ref: inputRef,
                onChange: handleChange,
                disabled: props.disabled,
                style: {
                    opacity: 0,
                    cursor: "inherit",
                    position: "absolute",
                    zIndex: -1
                }
            })
        ]
    });
}
(0, $eSiQ2.Component)($06e3a36d2d83b339$export$48513f6b9f8ce62d, {
    name: "Checkbox",
    gallery: {
        path: "Controllers/Checkbox",
        items: [
            {
                title: "Enabled",
                variants: [
                    {
                        label: "Interactive",
                        props: (state = {
                            checked: false
                        }, setState)=>({
                                checked: state.checked,
                                onChange: (e)=>{
                                    setState({
                                        checked: e.target.checked
                                    });
                                }
                            })
                    },
                    {
                        label: "Checked",
                        props: {
                            checked: true
                        }
                    }
                ]
            },
            {
                title: "Disabled",
                variants: [
                    {
                        label: "Unchecked",
                        props: {
                            checked: false,
                            disabled: true
                        }
                    },
                    {
                        label: "Checked",
                        props: {
                            checked: true,
                            disabled: true
                        }
                    }
                ]
            },
            {
                title: "With label",
                variants: [
                    {
                        props: (state = {
                            checked: false
                        }, setState)=>({
                                checked: state.checked,
                                label: "Jeg vil gjerne vite mer om b\xe6rekraft og Redoits tilbud. [Les vilk\xe5r](https://google.com)",
                                onChange: (e)=>{
                                    setState({
                                        checked: e.target.checked
                                    });
                                }
                            })
                    }
                ]
            }
        ]
    }
});
const $06e3a36d2d83b339$var$Checkmark = (props)=>(0, $4vwom.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 12,
        fill: "none"
    }, props, {
        children: (0, $4vwom.jsx)("path", {
            fill: "#fff",
            d: "M5.457 8.293 2.164 5 .75 6.414l4.707 4.707 9.707-9.707L13.75 0 5.457 8.293Z",
            style: {
                fill: "#fff",
                fillOpacity: 1
            }
        })
    }));







parcelRequire("2LTO8");
var $2uVAW = parcelRequire("2uVAW");
var $4QAvl = parcelRequire("4QAvl");

var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");






function $e48c64b19d1de698$export$a7c3797c5ed1e851(props) {
    return (0, $4vwom.jsxs)("div", {
        children: [
            !!props.heading && (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 3,
                margin: {
                    bottom: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).sm
                },
                children: props.heading
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 12,
                children: props.steps.map((s)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).sm,
                        backgroundColor: "gray100",
                        padding: "md",
                        borderRadius: "md",
                        alignItems: "center",
                        children: [
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: s.icon,
                                size: 32
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: typeof s.text === "string" ? s.text : (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                    value: s.text
                                })
                            })
                        ]
                    }, s.id))
            })
        ]
    });
}






var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $lhaLc = parcelRequire("lhaLc");






// Size (or rather height) of the arrow pointing towards the trigger element. Width is 2x height.
const $cf418bf541887e36$var$ARROW_SIZE = 8;
// Distance from the trigger element to the tooltip (arrow).
const $cf418bf541887e36$var$TOOLTIP_TRIGGER_MARGIN = 4;
// Distance from the trigger element edge to the trigger arrow, for left or right aligned tooltips.
const $cf418bf541887e36$var$TRIGGER_ARROW_OFFSET = 16;
// Distance from tooltip edge to the arrow, for left or right aligned tooltips.
const $cf418bf541887e36$var$TOOLTIP_ARROW_OFFSET = 32;
// Tooltip max width.
const $cf418bf541887e36$var$TOOLTIP_MAX_WIDTH = "400px";
const $cf418bf541887e36$var$DEFAULT_PLACEMENT = "bottom-center";
const $cf418bf541887e36$var$DEFAULT_ALIGNMENT = "right";
const $cf418bf541887e36$export$28c660c63b792dea = (props)=>{
    var _a;
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const preferredPlacement = (0, $eeH7J.useMemo)(()=>{
        var _a, _b;
        return {
            x: ((_a = props.placement) !== null && _a !== void 0 ? _a : $cf418bf541887e36$var$DEFAULT_PLACEMENT).split("-")[1],
            y: ((_b = props.placement) !== null && _b !== void 0 ? _b : $cf418bf541887e36$var$DEFAULT_PLACEMENT).split("-")[0]
        };
    }, [
        props.placement
    ]);
    const preferredAlignment = (_a = props.alignment) !== null && _a !== void 0 ? _a : $cf418bf541887e36$var$DEFAULT_ALIGNMENT;
    const [tooltipPlacement, setTooltipPlacement] = (0, $eeH7J.useState)();
    const [tooltipAlignment, setTooltipAlignment] = (0, $eeH7J.useState)();
    const [tooltipCoordinates, setTooltipCoordinates] = (0, $eeH7J.useState)();
    const [showTooltip, setShowTooltip] = (0, $eeH7J.useState)(false);
    const [enterAnimationComplete, setEnterAnimationComplete] = (0, $eeH7J.useState)(false);
    // This is used in case of fullwidth placement, where the constant arrow offset is not sufficient.
    const [arrowOffsetOverride, setArrowOffsetOverride] = (0, $eeH7J.useState)();
    const tooltipRef = (0, $eeH7J.useRef)(null);
    const tooltipPreRenderRef = (0, $eeH7J.useRef)(null);
    const triggerRef = (0, $eeH7J.useRef)(null);
    const mouseOverRef = (0, $eeH7J.useRef)(false);
    // Returns the relevant DOMRects used in the component if refs are set as expected.
    function getRects() {
        var _a, _b;
        const triggerRect = (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const tooltipRect = (_b = tooltipPreRenderRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        if (tooltipRect && triggerRect) return {
            triggerRect: triggerRect,
            tooltipRect: tooltipRect
        };
    }
    const getTooltipElementCoordinates = (0, $eeH7J.useCallback)((placement, alignment)=>{
        const { y: y, x: x } = placement;
        const rects = getRects();
        if (rects) {
            const { triggerRect: triggerRect, tooltipRect: tooltipRect } = rects;
            const alignmentOffset = alignment === "right" ? 0 - $cf418bf541887e36$var$TOOLTIP_ARROW_OFFSET : alignment === "center" ? rects.tooltipRect.width / 2 * -1 : alignment === "left" ? rects.tooltipRect.width * -1 + $cf418bf541887e36$var$TOOLTIP_ARROW_OFFSET : alignment === "fullwidth" ? triggerRect.x * -1 - triggerRect.width / 2 + (0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft : 0;
            const triggerX = x === "left" ? triggerRect.left + $cf418bf541887e36$var$TRIGGER_ARROW_OFFSET : x === "right" ? triggerRect.right - $cf418bf541887e36$var$TRIGGER_ARROW_OFFSET : Math.round(triggerRect.x + triggerRect.width / 2);
            const triggerY = y === "top" ? triggerRect.top - tooltipRect.height - $cf418bf541887e36$var$ARROW_SIZE - $cf418bf541887e36$var$TOOLTIP_TRIGGER_MARGIN : triggerRect.bottom + $cf418bf541887e36$var$ARROW_SIZE + $cf418bf541887e36$var$TOOLTIP_TRIGGER_MARGIN;
            return {
                x: triggerX + alignmentOffset,
                y: triggerY
            };
        }
    }, []);
    function getTriggerXForPlacement(triggerRect, placement) {
        return placement === "center" ? triggerRect.left + triggerRect.width / 2 : triggerRect[placement];
    }
    function getAlignmentSpanX(tooltipRect, alignment) {
        return alignment === "center" ? [
            (tooltipRect.left + tooltipRect.width / 2) * -1,
            tooltipRect.left + tooltipRect.width / 2
        ] : alignment === "left" ? [
            tooltipRect.width * -1,
            0
        ] : [
            0,
            tooltipRect.width
        ];
    }
    function getTriggerYForPlacement(triggerRect, placement) {
        return placement === "top" ? triggerRect.top : triggerRect.bottom;
    }
    function getPlacementSpanY(tooltipRect, placement) {
        return placement === "top" ? [
            tooltipRect.height * -1,
            0
        ] : [
            0,
            tooltipRect.height
        ];
    }
    const checkCombinationSpaceX = (0, $eeH7J.useCallback)((rects, placement, alignment)=>{
        const x = getTriggerXForPlacement(rects.triggerRect, placement.x);
        const asx = getAlignmentSpanX(rects.tooltipRect, alignment);
        return [
            x + asx[0],
            x + asx[1]
        ];
    }, []);
    const checkCombinationSpaceY = (0, $eeH7J.useCallback)((rects, placement)=>{
        const y = getTriggerYForPlacement(rects.triggerRect, placement);
        const py = getPlacementSpanY(rects.tooltipRect, placement);
        return [
            y + py[0],
            y + py[1]
        ];
    }, []);
    function fitsInViewportX(xx) {
        return xx.filter((x)=>x > 0 && x < window.innerWidth).length === 2;
    }
    function fitsInViewportY(yy) {
        return yy.filter((y)=>y > 0 && y < window.innerHeight).length === 2;
    }
    const updatePosition = (0, $eeH7J.useCallback)(()=>{
        const rects = getRects();
        if (rects) {
            const yPlacements = [
                "top",
                "bottom"
            ];
            const yPlacement = yPlacements.sort((p1)=>p1 === preferredPlacement.y ? -1 : 1).find((p)=>fitsInViewportY(checkCombinationSpaceY(rects, p)));
            const alignments = [
                "left",
                "center",
                "right"
            ];
            const alignment = alignments// Prioritize perferred alignment and center.
            .sort((a1, a2)=>a1 === preferredAlignment ? -1 : a1 === "center" && a2 !== preferredAlignment ? -1 : 1).find((a)=>fitsInViewportX(checkCombinationSpaceX(rects, preferredPlacement, a)));
            if (alignment && yPlacement) {
                const coordinates = getTooltipElementCoordinates({
                    x: preferredPlacement.x,
                    y: yPlacement
                }, alignment);
                if (coordinates) {
                    setTooltipPlacement({
                        x: preferredPlacement.x,
                        y: yPlacement
                    });
                    setTooltipAlignment(alignment);
                    setTooltipCoordinates(coordinates);
                }
            } else if (yPlacement) {
                // If we found an yPlacement but no aligntment, we're assuming it was because the
                // tooltip was placed partially outside of the screen width for all the preferred
                // alignments. So try to get coordinates for a fullwith alignment, where we try to
                // position it around x = 0 + page left padding.
                const coordinates = getTooltipElementCoordinates({
                    x: preferredPlacement.x,
                    y: yPlacement
                }, "fullwidth");
                if (coordinates) {
                    setTooltipPlacement({
                        x: preferredPlacement.x,
                        y: yPlacement
                    });
                    setTooltipAlignment("fullwidth");
                    setTooltipCoordinates(coordinates);
                    setArrowOffsetOverride(rects.triggerRect.x + rects.triggerRect.width / 2 - coordinates.x);
                }
            } else // eslint-disable-next-line no-console
            console.warn("Could not find alignment or placement for tooltip.");
        }
    }, [
        checkCombinationSpaceX,
        checkCombinationSpaceY,
        getTooltipElementCoordinates,
        preferredAlignment,
        preferredPlacement
    ]);
    const handlePointerOver = (0, $eeH7J.useCallback)(()=>{
        mouseOverRef.current = true;
        updatePosition();
        if (!showTooltip) setShowTooltip(true);
    }, [
        showTooltip,
        updatePosition
    ]);
    const handlePointerLeave = (0, $eeH7J.useCallback)(()=>{
        mouseOverRef.current = false;
        if (enterAnimationComplete) setShowTooltip(false);
    }, [
        enterAnimationComplete
    ]);
    const handleScroll = (0, $eeH7J.useCallback)(()=>{
        if (showTooltip) updatePosition();
    }, [
        showTooltip,
        updatePosition
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (!props.children) return;
        const triggerRefCurrent = triggerRef.current;
        if (triggerRefCurrent) {
            triggerRefCurrent.addEventListener("pointerover", handlePointerOver);
            triggerRefCurrent.addEventListener("pointerleave", handlePointerLeave);
            triggerRefCurrent.addEventListener("click", handlePointerLeave);
            triggerRefCurrent.addEventListener("touchstart", handlePointerOver);
            triggerRefCurrent.addEventListener("touchend", handlePointerLeave);
            if (typeof window !== "undefined") window.addEventListener("scroll", handleScroll);
            return ()=>{
                triggerRefCurrent.removeEventListener("pointerover", handlePointerOver);
                triggerRefCurrent.removeEventListener("pointerleave", handlePointerLeave);
                triggerRefCurrent.removeEventListener("click", handlePointerLeave);
                triggerRefCurrent.removeEventListener("touchstart", handlePointerOver);
                triggerRefCurrent.removeEventListener("touchend", handlePointerLeave);
                if (typeof window !== "undefined") window.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        props.children,
        handlePointerOver,
        handlePointerLeave,
        handleScroll
    ]);
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            props.renderTrigger(triggerRef),
            showTooltip && (0, $4vwom.jsx)((0, $lhaLc.Global), {
                styles: (0, $lhaLc.css)({
                    "*, *:before, *:after": {
                        userSelect: "none",
                        MozUserSelect: "none",
                        msUserSelect: "none",
                        WebkitTouchCallout: "none",
                        WebkitUserSelect: "none"
                    }
                })
            }),
            props.children && typeof window !== "undefined" && /*#__PURE__*/ (0, $iMJCh.createPortal)((0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)("div", {
                        "aria-hidden": true,
                        ref: tooltipPreRenderRef,
                        css: (0, $lhaLc.css)({
                            position: "absolute",
                            top: 0,
                            left: 0,
                            opacity: 0,
                            zIndex: -1,
                            maxWidth: `min(calc(100vw - ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px - ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px), ${$cf418bf541887e36$var$TOOLTIP_MAX_WIDTH})`,
                            padding: "16px 24px"
                        }),
                        children: props.children
                    }),
                    (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
                        transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                        children: (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                            children: showTooltip && tooltipCoordinates && tooltipPlacement && (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                motion: {
                                    variants: {
                                        hide: {
                                            opacity: 0,
                                            translateY: tooltipPlacement.y === "top" ? 12 : -12
                                        },
                                        show: {
                                            opacity: 1,
                                            translateY: 0
                                        }
                                    },
                                    initial: "hide",
                                    animate: "show",
                                    exit: "hide",
                                    onAnimationComplete: (variant)=>{
                                        setEnterAnimationComplete(variant === "show" ? true : false);
                                        if (variant === "show" && mouseOverRef.current === false) setShowTooltip(false);
                                    }
                                },
                                elementRef: tooltipRef,
                                css: (0, $lhaLc.css)({
                                    opacity: 1,
                                    top: tooltipCoordinates.y,
                                    left: tooltipCoordinates.x
                                }, {
                                    position: "fixed",
                                    maxWidth: `min(calc(100vw - ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px - ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px), ${$cf418bf541887e36$var$TOOLTIP_MAX_WIDTH})`,
                                    backgroundColor: colors.grayWhite,
                                    padding: "16px 24px",
                                    borderRadius: 16,
                                    boxShadow: $e665a5c3bf2ac3f6$export$16e1fc8de5cd9687,
                                    whiteSpace: "normal",
                                    zIndex: 10000,
                                    "::after": {
                                        content: "''",
                                        position: "absolute",
                                        top: tooltipPlacement.y === "top" ? "100%" : $cf418bf541887e36$var$ARROW_SIZE * -2,
                                        left: typeof arrowOffsetOverride !== "undefined" ? arrowOffsetOverride : tooltipAlignment === "right" ? $cf418bf541887e36$var$TOOLTIP_ARROW_OFFSET : tooltipAlignment === "left" ? `calc(100% - ${$cf418bf541887e36$var$TOOLTIP_ARROW_OFFSET}px)` : "50%",
                                        transform: "translateX(-50%)",
                                        borderWidth: $cf418bf541887e36$var$ARROW_SIZE,
                                        borderStyle: "solid",
                                        borderColor: tooltipPlacement.y === "bottom" ? `transparent transparent ${colors.grayWhite} transparent` : `${colors.grayWhite} transparent transparent transparent`
                                    }
                                }),
                                children: props.children
                            }, "tooltip")
                        })
                    })
                ]
            }), document.body)
        ]
    });
};




const $fe97b132bdc7c14c$var$initialState = {
    name: {
        value: ""
    },
    email: {
        value: ""
    },
    phoneNumber: {
        value: ""
    },
    street: {
        value: ""
    },
    unit: {
        value: ""
    },
    region: {
        value: ""
    },
    postalCode: {
        value: ""
    },
    countryCode: {
        value: ""
    }
};
function $fe97b132bdc7c14c$var$formReducer(state, action) {
    if (action.type === "email") try {
        (0, $2uVAW.Email)(action.payload);
        return Object.assign(Object.assign({}, state), {
            email: {
                value: action.payload,
                valid: true,
                dirty: true
            }
        });
    } catch (e) {
        return Object.assign(Object.assign({}, state), {
            email: {
                value: action.payload,
                valid: false,
                dirty: true
            }
        });
    }
    if (action.type === "phoneNumber") try {
        (0, $4QAvl.PhoneNumber)(action.payload);
        return Object.assign(Object.assign({}, state), {
            phoneNumber: {
                value: action.payload,
                valid: true,
                dirty: true
            }
        });
    } catch (e) {
        return Object.assign(Object.assign({}, state), {
            phoneNumber: {
                value: action.payload,
                valid: false,
                dirty: true
            }
        });
    }
    if (action.type === "unit") return Object.assign(Object.assign({}, state), {
        unit: {
            value: action.payload,
            valid: true,
            dirty: true
        }
    });
    if (action.type !== "SET_ALL") return Object.assign(Object.assign({}, state), {
        [action.type]: {
            value: action.payload,
            dirty: true,
            valid: !!action.payload
        }
    });
    else return Object.assign(Object.assign({}, state), Object.keys(action.payload).reduce((acc, key)=>{
        acc[key] = {
            value: action.payload[key],
            valid: true,
            dirty: true
        };
        return acc;
    }, {}));
}
function $fe97b132bdc7c14c$export$f86ab37791746a56({ contactInfo: c, address: a, nextSteps: nextSteps, pageHeading: pageHeading, personalInformationHeading: personalInformationHeading, personalInformationFromVippsNotice: personalInformationFromVippsNotice, addressHeading: addressHeading, deliveryOptionsHeading: deliveryOptionsHeading, noDeliveryOptions: noDeliveryOptions, noDeliverySlots: noDeliverySlots, deliverySlotFull: deliverySlotFull, marketingCheckbox: marketingCheckbox, termsCheckbox: termsCheckbox, nextStep: nextStep, nextStepsHeading: nextStepsHeading }) {
    var _a, _b, _c, _d, _e, _f;
    const { helpers: helpers, colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    const localize = (0, $aIeEI.useLocalize)();
    const { setStep: setStep, shipping: shipping, setShipping: setShipping, price: price, checkoutState: checkoutState, setCheckoutState: setCheckoutState } = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const [consents, setConsents] = (0, $047f6f355e30d7d1$export$5a952ffba9a79dc5)();
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($cddd760e1f8ca7cc$exports))));
    const [state, dispatch] = (0, $eeH7J.useReducer)($fe97b132bdc7c14c$var$formReducer, Object.assign(Object.assign({}, $fe97b132bdc7c14c$var$initialState), (_a = shipping.form) !== null && _a !== void 0 ? _a : {}));
    const validate = (0, $eeH7J.useCallback)(()=>!Object.keys(state).some((key)=>!state[key].valid || !state[key].dirty), [
        state
    ]);
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const contactInfo = $fe97b132bdc7c14c$var$groupAndSort(c);
    const address = $fe97b132bdc7c14c$var$groupAndSort(a);
    // Don't request shipping options unless complete zip code is provided, to avoid unnecessary
    // requests and also the UI from showing "no options" while typing (if switching form one
    // valid zip code to another).
    const shippingOptions = (0, $e18f565b44c7bc7d$export$2019485bfe6f9ed5)("NO", state.postalCode.value.length === 4 ? state.postalCode.value : null);
    (0, $eeH7J.useEffect)(()=>{
        if (typeof fbq !== "undefined") fbq("track", "InitiateCheckout", {
            content_ids: [
                price === null || price === void 0 ? void 0 : price.phoneOffer.id.valueOf()
            ],
            content_name: price === null || price === void 0 ? void 0 : price.phoneOffer.name.en,
            content_type: "product",
            value: price === null || price === void 0 ? void 0 : price.monthlyCost.discountedTotal.majorUnits,
            currency: price === null || price === void 0 ? void 0 : price.monthlyCost.discountedTotal.currency
        });
    }, // Should only trigger once, when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const availableShippingOptions = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = shippingOptions.data) === null || _a === void 0 ? void 0 : _a.options.filter((so)=>{
            if (so.type === "Manual") return so.slots.filter((s)=>!s.full).length > 0;
            return true;
        });
    }, [
        (_b = shippingOptions.data) === null || _b === void 0 ? void 0 : _b.options
    ]);
    // When shipping options are ready, update the options and auto-select first
    // option (that is not full).
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        let updatedState;
        if (!availableShippingOptions) // If data?.options is undefined, it means no options have been fetched, which should be
        // because zip code is incomplete. When that's the case, we don't want to change the
        // presented options.
        return;
        else if (!availableShippingOptions.length) // Shipping options are fetched, but came up empty, update state to show
        // "no options available".
        updatedState = Object.assign(Object.assign({}, shipping), {
            options: [],
            selectedOption: undefined
        });
        else {
            // Keep selection, or select first if none was set.
            const selectedOption = (_a = shipping.selectedOption ? availableShippingOptions.find((o)=>{
                var _a;
                return o.type === ((_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type);
            }) : undefined) !== null && _a !== void 0 ? _a : availableShippingOptions[0];
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!selectedOption) return;
            const previouslySelectedSlot = selectedOption.type === "Manual" ? selectedOption.slots.find((s)=>{
                var _a, _b;
                return ((_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type) === "Manual" && s.id === ((_b = shipping.selectedOption.selectedSlot) === null || _b === void 0 ? void 0 : _b.id);
            }) : undefined;
            updatedState = Object.assign(Object.assign({}, shipping), {
                options: availableShippingOptions,
                selectedOption: Object.assign(Object.assign({}, selectedOption), ((_b = shipping.selectedOption) === null || _b === void 0 ? void 0 : _b.type) === "Manual" ? {
                    selectedSlot: previouslySelectedSlot !== null && previouslySelectedSlot !== void 0 ? previouslySelectedSlot : selectedOption.type === "Manual" ? selectedOption.slots.find((s)=>!s.full) : undefined
                } : {})
            });
        }
        if (JSON.stringify(updatedState) !== JSON.stringify(shipping.options)) setShipping(updatedState);
    }, [
        availableShippingOptions,
        setShipping,
        shipping
    ]);
    // Ensures the CheckoutShippingState stored on the session is up to date with the form state.
    (0, $eeH7J.useEffect)(()=>{
        if (JSON.stringify(state) === JSON.stringify($fe97b132bdc7c14c$var$initialState)) return;
        const updatedShipping = Object.assign(Object.assign({}, shipping), {
            form: state
        });
        if (JSON.stringify(updatedShipping) !== JSON.stringify(shipping)) setShipping(updatedShipping);
    }, [
        setShipping,
        shipping,
        state
    ]);
    const shippingSlotId = ((_c = shipping.selectedOption) === null || _c === void 0 ? void 0 : _c.type) === "Manual" ? (_d = shipping.selectedOption.selectedSlot) === null || _d === void 0 ? void 0 : _d.id : undefined;
    const shippingIsValid = (0, $eeH7J.useMemo)(()=>{
        var _a;
        if (((_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type) === "Manual") return !!shippingSlotId;
        return !!shipping.selectedOption;
    }, [
        shipping.selectedOption,
        shippingSlotId
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (!me.data) return;
        if (shipping.form) return;
        dispatch({
            type: "SET_ALL",
            payload: {
                name: `${me.data.givenName} ${me.data.familyName}`,
                email: (_b = (_a = me.data.email) === null || _a === void 0 ? void 0 : _a.valueOf()) !== null && _b !== void 0 ? _b : "",
                phoneNumber: me.data.phoneNumber ? me.data.phoneNumber.valueOf().startsWith("+") ? me.data.phoneNumber.valueOf() : "+" + me.data.phoneNumber.valueOf() : "",
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                street: (_d = (_c = me.data.address) === null || _c === void 0 ? void 0 : _c.street) !== null && _d !== void 0 ? _d : "",
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                unit: (_f = (_e = me.data.address) === null || _e === void 0 ? void 0 : _e.unit) !== null && _f !== void 0 ? _f : "",
                countryCode: (_h = (_g = me.data.address) === null || _g === void 0 ? void 0 : _g.country.valueOf()) !== null && _h !== void 0 ? _h : "",
                postalCode: (_k = (_j = me.data.address) === null || _j === void 0 ? void 0 : _j.zip) !== null && _k !== void 0 ? _k : "",
                region: (_m = (_l = me.data.address) === null || _l === void 0 ? void 0 : _l.city) !== null && _m !== void 0 ? _m : ""
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(me.data)
    ]);
    const handleShippingSelect = (0, $eeH7J.useCallback)((shippingType)=>()=>{
            var _a;
            const opt = (_a = shipping.options) === null || _a === void 0 ? void 0 : _a.find((so)=>so.type === shippingType);
            if (opt) setShipping(Object.assign(Object.assign({}, shipping), {
                selectedOption: opt
            }));
        }, [
        setShipping,
        shipping
    ]);
    return (0, $4vwom.jsx)("div", {
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            css: (0, $lhaLc.css)({
                gap: 32
            }),
            children: [
                (0, $4vwom.jsx)("span", {
                    css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                        display: "none"
                    })),
                    children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        children: localize(pageHeading)
                    })
                }),
                (0, $4vwom.jsxs)($fe97b132bdc7c14c$var$SectionHeading, {
                    title: localize(personalInformationHeading),
                    children: [
                        (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            gap: 8,
                            children: contactInfo.map((g)=>{
                                if (Array.isArray(g)) return (0, $4vwom.jsx)($fe97b132bdc7c14c$var$InputGroup, {
                                    group: g,
                                    state: state,
                                    localize: localize,
                                    dispatch: dispatch
                                }, g.join(""));
                                else return (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                    type: g.type,
                                    label: localize(g.label),
                                    value: state[g.formKey].value,
                                    disabled: [
                                        "name",
                                        "email",
                                        "phoneNumber"
                                    ].includes(g.formKey),
                                    onChange: (e)=>dispatch({
                                            type: g.formKey,
                                            payload: e.target.value
                                        }),
                                    warning: $fe97b132bdc7c14c$var$setFormFieldState(state, g.formKey) === "error" && g.errorMessage ? localize(g.errorMessage) : undefined,
                                    state: $fe97b132bdc7c14c$var$setFormFieldState(state, g.formKey)
                                }, g.formKey);
                            })
                        }),
                        personalInformationFromVippsNotice ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "md",
                            color: "gray300",
                            margin: {
                                top: 16
                            },
                            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(personalInformationFromVippsNotice)
                            })
                        }) : null
                    ]
                }),
                (0, $4vwom.jsx)($fe97b132bdc7c14c$var$SectionHeading, {
                    title: localize(addressHeading),
                    children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: 8,
                        children: address.map((g)=>{
                            if (Array.isArray(g)) return (0, $4vwom.jsx)($fe97b132bdc7c14c$var$InputGroup, {
                                group: g,
                                state: state,
                                localize: localize,
                                dispatch: dispatch
                            }, g.join(""));
                            else return (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                type: g.type,
                                label: localize(g.label),
                                value: state[g.formKey].value,
                                onChange: (e)=>dispatch({
                                        type: g.formKey,
                                        payload: e.target.value
                                    }),
                                state: $fe97b132bdc7c14c$var$setFormFieldState(state, g.formKey)
                            }, g.formKey);
                        })
                    })
                }),
                (0, $4vwom.jsx)($fe97b132bdc7c14c$var$SectionHeading, {
                    title: localize(deliveryOptionsHeading),
                    children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        borderRadius: "md",
                        direction: "column",
                        css: (0, $lhaLc.css)(responsiveCss("min", "md", {
                            padding: (0, $756948b644e82cf2$export$981516ee4691055c)(40),
                            background: colors.gray100,
                            border: "1px solid",
                            borderColor: colors.gray200
                        })),
                        children: ((_e = shipping.options) === null || _e === void 0 ? void 0 : _e.length) === 0 ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "md",
                            children: localize(noDeliveryOptions)
                        }) : (_f = shipping.options) === null || _f === void 0 ? void 0 : _f.map((option, index)=>{
                            var _a, _b;
                            return (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                children: [
                                    index > 0 && (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: 24
                                    }),
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        direction: "column",
                                        gap: 24,
                                        css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                                            gap: 16
                                        }), responsiveCss("min", "md", {
                                            gap: 24
                                        })),
                                        children: [
                                            (0, $4vwom.jsx)((0, $5d11cd7f4673d445$export$f4422ae58352e179), {
                                                checked: ((_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type) === option.type,
                                                onClick: handleShippingSelect(option.type),
                                                label: (0, $4vwom.jsxs)("div", {
                                                    children: [
                                                        (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                            variant: "heading",
                                                            level: [
                                                                3,
                                                                [
                                                                    "min",
                                                                    "md",
                                                                    4
                                                                ]
                                                            ],
                                                            color: ((_b = shipping.selectedOption) === null || _b === void 0 ? void 0 : _b.type) === option.type ? "brand" : undefined,
                                                            children: [
                                                                localize(option.name),
                                                                " -",
                                                                " ",
                                                                !option.price.minorUnits.valueOf() ? localize({
                                                                    no: "Gratis",
                                                                    en: "Free"
                                                                }) : formatAmount(option.price)
                                                            ]
                                                        }),
                                                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                            variant: "body",
                                                            size: "sm",
                                                            color: "gray350",
                                                            children: localize(option.description)
                                                        })
                                                    ]
                                                })
                                            }),
                                            option.type === "Manual" ? (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                gap: 8,
                                                css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                                                    flexWrap: "nowrap",
                                                    overflowX: "auto",
                                                    width: "calc(100% + var(--padding-x) + var(--padding-x))",
                                                    transform: "translateX(calc(var(--padding-x) * -1))",
                                                    paddingLeft: "var(--padding-x)",
                                                    paddingRight: "var(--padding-x)",
                                                    minWidth: 0
                                                }), {
                                                    flexWrap: "wrap"
                                                }),
                                                children: [
                                                    option.slots.map((slot)=>(0, $4vwom.jsx)((0, $cf418bf541887e36$export$28c660c63b792dea), {
                                                            placement: "bottom-center",
                                                            renderTrigger: (ref)=>{
                                                                var _a, _b;
                                                                return (0, $4vwom.jsx)("div", {
                                                                    ref: ref,
                                                                    children: (0, $4vwom.jsxs)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                                        size: "sm",
                                                                        variant: "option",
                                                                        selected: ((_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type) === "Manual" && ((_b = shipping.selectedOption.selectedSlot) === null || _b === void 0 ? void 0 : _b.id) === slot.id,
                                                                        disabled: slot.full,
                                                                        onClick: slot.full ? undefined : ()=>setShipping(Object.assign(Object.assign({}, shipping), {
                                                                                selectedOption: Object.assign(Object.assign({}, option), {
                                                                                    selectedSlot: slot
                                                                                })
                                                                            })),
                                                                        children: [
                                                                            (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(slot.date).format("dddd Do MMMM"),
                                                                            ", ",
                                                                            slot.from,
                                                                            " - ",
                                                                            slot.to
                                                                        ]
                                                                    }, slot.id.valueOf())
                                                                });
                                                            },
                                                            children: slot.full ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: localize(deliverySlotFull)
                                                            }) : null
                                                        }, slot.id.valueOf())),
                                                    option.slots.length === 0 && (0, $4vwom.jsx)("div", {
                                                        style: {
                                                            padding: 32
                                                        },
                                                        children: localize(noDeliverySlots)
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                ]
                            }, localize(option.name));
                        })
                    })
                }),
                nextSteps.length > 0 && (0, $4vwom.jsx)($fe97b132bdc7c14c$var$SectionHeading, {
                    title: localize(nextStepsHeading),
                    children: (0, $4vwom.jsx)((0, $e48c64b19d1de698$export$a7c3797c5ed1e851), {
                        steps: nextSteps.map((s)=>({
                                id: s.id.valueOf(),
                                icon: s.icon,
                                text: localize(s.text)
                            }))
                    })
                }),
                (0, $4vwom.jsxs)("div", {
                    children: [
                        !consents.marketing.preConsented && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                            children: [
                                (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                    checked: consents.marketing.consentGiven,
                                    onChange: ()=>{
                                        setConsents(Object.assign(Object.assign({}, consents), {
                                            marketing: {
                                                consentGiven: !consents.marketing.consentGiven,
                                                preConsented: false
                                            }
                                        }));
                                    },
                                    label: localize(marketingCheckbox)
                                }),
                                (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                    horizontal: true,
                                    spacing: 24
                                })
                            ]
                        }),
                        (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                            checked: checkoutState.termsAccepted,
                            onChange: ()=>setCheckoutState(Object.assign(Object.assign({}, checkoutState), {
                                    termsAccepted: !checkoutState.termsAccepted
                                })),
                            label: localize(termsCheckbox)
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "primary",
                    onClick: ()=>{
                        setStep("Payment");
                    },
                    disabled: !validate() || !shippingIsValid || !checkoutState.termsAccepted || !shipping.selectedOption,
                    children: localize(nextStep)
                })
            ]
        })
    });
}
function $fe97b132bdc7c14c$var$SectionHeading({ title: title, children: children }) {
    const { responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsxs)("div", {
                css: (0, $lhaLc.css)(responsiveCss("min", "md", {
                    display: "none"
                })),
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        margin: {
                            bottom: 16
                        },
                        children: title
                    }),
                    children
                ]
            }),
            (0, $4vwom.jsxs)("div", {
                css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                    display: "none"
                })),
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 3,
                        margin: {
                            bottom: 16
                        },
                        children: title
                    }),
                    children
                ]
            })
        ]
    });
}
function $fe97b132bdc7c14c$var$InputGroup({ group: group, state: state, localize: localize, dispatch: dispatch }) {
    const { responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        gap: 8,
        css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
            flexDirection: "column"
        })),
        children: group.map((field)=>(0, $4vwom.jsx)("div", {
                style: {
                    flex: 1
                },
                children: (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                    type: field.type,
                    disabled: [
                        "name",
                        "email",
                        "phoneNumber"
                    ].includes(field.formKey),
                    label: localize(field.label),
                    value: state[field.formKey].value,
                    onChange: (e)=>dispatch({
                            type: field.formKey,
                            payload: e.target.value
                        }),
                    state: $fe97b132bdc7c14c$var$setFormFieldState(state, field.formKey),
                    warning: $fe97b132bdc7c14c$var$setFormFieldState(state, field.formKey) === "error" && field.errorMessage ? localize(field.errorMessage) : undefined
                })
            }, field.formKey))
    });
}
const $fe97b132bdc7c14c$var$setFormFieldState = (state, key)=>{
    return state[key].dirty ? !state[key].valid ? "error" : state[key].value ? "completed" : undefined : undefined;
};
function $fe97b132bdc7c14c$var$groupAndSort(data) {
    const sortedItems = Object.keys(data).map((key)=>{
        var _a, _b;
        const value = data[key];
        // TypeScript claims value is always falsy, but this is not the case.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!value) return;
        return {
            formKey: key,
            label: value.label,
            group: (_a = value.group) !== null && _a !== void 0 ? _a : 0,
            order: (_b = value.order) !== null && _b !== void 0 ? _b : 0,
            type: value.type,
            errorMessage: value.errorMessage
        };
    }).filter(Boolean).sort((a, b)=>a.order - b.order);
    return sortedItems.reduce((acc, item)=>{
        var _a;
        if (!item.group) acc.push(item);
        else {
            const groupIndex = acc.findIndex((group)=>{
                var _a;
                return Array.isArray(group) && ((_a = group[0]) === null || _a === void 0 ? void 0 : _a.group) === item.group;
            });
            if (groupIndex === -1) acc.push([
                item
            ]);
            else if (Array.isArray(acc[groupIndex])) (_a = acc[groupIndex]) === null || _a === void 0 || _a.push(item);
        }
        return acc;
    }, []);
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $aIeEI = parcelRequire("aIeEI");










var $dAwef = parcelRequire("dAwef");
parcelRequire("2LTO8");
var $8h5s0 = parcelRequire("8h5s0");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");





const $50112aaf62b7ce57$var$borderColors = {
    default: "gray200",
    active: "gray500",
    error: "error",
    completed: "forest"
};
function $50112aaf62b7ce57$export$ef9b1a59e592288f(props) {
    var _a, _b, _c;
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveBodyCss: responsiveBodyCss, responsiveCss: responsiveCss, responsiveHeadingCss: responsiveHeadingCss } = helpers;
    const selectRef = (0, $eeH7J.useRef)(null);
    const [isActive, setIsActive] = (0, $eeH7J.useState)(false);
    const state = (0, $eeH7J.useMemo)(()=>{
        if (props.state) return props.state;
        if (isActive) return "active";
        return "default";
    }, [
        props.state,
        isActive
    ]);
    const handleChange = (0, $eeH7J.useCallback)((e)=>{
        var _a;
        (_a = props.onChange) === null || _a === void 0 || _a.call(props, e, e.target.value);
    }, [
        props
    ]);
    const handleFocus = (0, $eeH7J.useCallback)(()=>{
        setIsActive(true);
    }, [
        setIsActive
    ]);
    const handleBlur = (0, $eeH7J.useCallback)(()=>{
        setIsActive(false);
    }, [
        setIsActive
    ]);
    const renderPlaceholder = (0, $eeH7J.useMemo)(()=>{
        return props.placeholder && !props.value;
    }, [
        props.placeholder,
        props.value
    ]);
    const valueTextCss = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (0, $lhaLc.css)(responsiveHeadingCss(5), responsiveCss("min", "md", (_a = responsiveBodyCss("md")) !== null && _a !== void 0 ? _a : {}));
    }, [
        responsiveBodyCss,
        responsiveCss,
        responsiveHeadingCss
    ]);
    return (0, $4vwom.jsxs)("div", {
        children: [
            props.label ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "md",
                style: {
                    marginBottom: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                },
                children: props.label
            }) : null,
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                borderColor: $50112aaf62b7ce57$var$borderColors[state],
                borderWidth: 2,
                borderRadius: "sm",
                css: $50112aaf62b7ce57$var$selectCss,
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    (0, $4vwom.jsx)("div", {
                        css: valueTextCss,
                        style: renderPlaceholder ? {
                            color: colors.gray300
                        } : {},
                        children: renderPlaceholder ? props.placeholder : (_b = (_a = props.renderValue) === null || _a === void 0 ? void 0 : _a.call(props, props.value)) !== null && _b !== void 0 ? _b : (_c = props.options.find((opt)=>$50112aaf62b7ce57$var$valueToString(opt.value) === $50112aaf62b7ce57$var$valueToString(props.value))) === null || _c === void 0 ? void 0 : _c.text
                    }),
                    (0, $4vwom.jsxs)("select", {
                        tabIndex: 0,
                        css: $50112aaf62b7ce57$var$dropdownCss,
                        ref: selectRef,
                        value: renderPlaceholder ? props.placeholder : $50112aaf62b7ce57$var$valueToString(props.value),
                        onChange: handleChange,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        children: [
                            props.placeholder ? (0, $4vwom.jsx)("option", {
                                disabled: true,
                                value: props.placeholder,
                                children: props.placeholder
                            }) : null,
                            props.options.map((o)=>{
                                var _a;
                                return (0, $4vwom.jsx)("option", {
                                    value: $50112aaf62b7ce57$var$valueToString(o.value),
                                    disabled: (_a = o.disabled) !== null && _a !== void 0 ? _a : false,
                                    children: o.text
                                }, $50112aaf62b7ce57$var$valueToString(o.value));
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: "chevronDown"
                    })
                ]
            })
        ]
    });
}
const $50112aaf62b7ce57$var$selectCss = (0, $lhaLc.css)`
    position: relative;
    height: ${48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px;
    padding: ${12 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px ${20 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px;
`;
const $50112aaf62b7ce57$var$dropdownCss = (0, $lhaLc.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    minWidth: 0,
    appearance: "none",
    opacity: 0,
    cursor: "pointer"
});
(0, $eSiQ2.Component)($50112aaf62b7ce57$export$ef9b1a59e592288f, {
    name: "Select",
    gallery: {
        path: "Inputs/Select",
        items: [
            {
                variants: [
                    {
                        props: {
                            value: "foo",
                            options: [
                                {
                                    value: "foo",
                                    text: "Foo"
                                },
                                {
                                    value: "bar",
                                    text: "Bar"
                                }
                            ]
                        }
                    }
                ]
            },
            {
                variants: [
                    {
                        props: {
                            value: "",
                            placeholder: "Select an option",
                            options: [
                                {
                                    value: "foo",
                                    text: "Foo"
                                },
                                {
                                    value: "bar",
                                    text: "Bar"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});
function $50112aaf62b7ce57$var$valueToString(o) {
    return typeof o === "string" ? o : JSON.stringify(o);
}







var $4vwom = parcelRequire("4vwom");

var $eSiQ2 = parcelRequire("eSiQ2");






var $lhaLc = parcelRequire("lhaLc");
function $aab0dbc639a1af01$export$42100d7f568e8c11(props) {
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        children: [
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                margin: {
                    bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                },
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: props.question
                    }),
                    props.description ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "sm",
                        color: "gray300",
                        children: props.description
                    }) : null
                ]
            }),
            (0, $4vwom.jsx)("fieldset", {
                children: (0, $4vwom.jsx)("div", {
                    role: "radiocontainer",
                    style: {
                        display: "grid",
                        gap: 8
                    },
                    css: (0, $lhaLc.css)({
                        gridTemplateColumns: "1fr"
                    }, // If options has texts longer than arbitrary character count 16, leave
                    // them in stacked layout to avoid component becoming too wide. Else,
                    // add grid layout for larger screens.
                    !props.options.find((o)=>o.text.length > 16) && (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                        gridTemplateColumns: props.options.length % 3 === 0 ? "1fr 1fr 1fr" : "1fr 1fr"
                    })),
                    children: props.options.map((o)=>(0, $4vwom.jsx)("div", {
                            style: {
                                position: "relative"
                            },
                            children: (0, $4vwom.jsxs)("label", {
                                style: {
                                    position: "relative",
                                    width: "100%"
                                },
                                children: [
                                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                        as: "div",
                                        size: "sm",
                                        variant: "select",
                                        selected: props.value === o.value,
                                        fullwidth: true,
                                        children: o.text
                                    }, o.text),
                                    (0, $4vwom.jsx)("input", {
                                        type: "radio",
                                        name: props.question,
                                        checked: props.value === o.value,
                                        style: {
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            height: "100%",
                                            width: "100%",
                                            opacity: "0",
                                            zIndex: -1
                                        },
                                        onChange: (e)=>{
                                            props.onChange(e, o.value);
                                        }
                                    })
                                ]
                            })
                        }, JSON.stringify(o.value)))
                })
            })
        ]
    });
}
(0, $eSiQ2.Component)($aab0dbc639a1af01$export$42100d7f568e8c11, {
    name: "MultipleChoiceQuestion",
    gallery: {
        path: "Forms/MultipleChoiceQuestion",
        items: [
            {
                variants: [
                    {
                        props: (state = "foo", setState)=>({
                                label: "Which one?",
                                options: [
                                    {
                                        value: "foo",
                                        text: "Foo"
                                    },
                                    {
                                        value: "bar",
                                        text: "Bar"
                                    },
                                    {
                                        value: "baz",
                                        text: "Baz"
                                    }
                                ],
                                value: state,
                                onChange: (e, val)=>{
                                    setState(val);
                                }
                            })
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $2zTLn = parcelRequire("2zTLn");



function $9ef1a37a4c2e6964$export$161a6b098fcc9bc6(props) {
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        borderColor: "gray200",
        borderRadius: "md",
        padding: "md",
        direction: "column",
        gap: 8,
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                justifyContent: "space-between",
                alignItems: "flex-start",
                children: [
                    (0, $4vwom.jsxs)("div", {
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 4,
                                children: props.itemName
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                alignItems: "baseline",
                                gap: 2,
                                children: [
                                    props.originalPrice === props.discountedPrice ? null : (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        color: "gray300",
                                        style: {
                                            textDecoration: "underline",
                                            textUnderlineOffset: "-5px",
                                            textDecorationSkipInk: "none"
                                        },
                                        children: props.originalPrice
                                    }),
                                    (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 3,
                                        color: "brand",
                                        children: [
                                            props.discountedPrice,
                                            " ",
                                            props.currency,
                                            "/",
                                            props.rentalPeriodUnit
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                        color: "gray500",
                        size: [
                            "fixed",
                            "xs",
                            "md"
                        ],
                        children: props.label
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "sm",
                color: "gray300",
                children: props.text
            })
        ]
    });
}
(0, $eSiQ2.Component)($9ef1a37a4c2e6964$export$161a6b098fcc9bc6, {
    name: "PaymentSummary",
    gallery: {
        path: "Forms/PaymentSummary",
        items: [
            {
                variants: [
                    {
                        props: {
                            itemName: "iPhone 15 Pro",
                            label: "Etter innbytte",
                            text: "V\xe5r estimerte telefonverdi er 3 000 NOK. Dette betyr at du vil f\xe5 50 NOK i avslag per m\xe5ned p\xe5 avtalen din de neste 24 m\xe5nedene etter at du har byttet inn enheten din.",
                            originalPrice: 300,
                            discountedPrice: 250,
                            rentalPeriodUnit: "md",
                            currency: (0, $2zTLn.CurrencyCode)("NOK")
                        }
                    }
                ]
            }
        ]
    }
});






parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");




function $0eca38a3f9eebfa7$export$a8febc64537a0214(props) {
    var _a;
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const localize = (0, $aIeEI.useLocalize)();
    const { setStep: setStep } = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const [modalOpen, setModalOpen] = (0, $eK8Q4.useSessionState)("tradein-modal-open", false);
    const [form] = (0, $047f6f355e30d7d1$export$d42da32bb85d5739)();
    const [tradeInId, setTradeInId] = (0, $eK8Q4.useSessionState)("tradein-modal-id", undefined);
    function startTradeIn() {
        setTradeInId((0, $dAwef.Uuid)().valueOf());
        setModalOpen(true);
    }
    const [responses] = (0, $eK8Q4.useSessionState)("tradein-responses", []);
    const [, setCheckoutTradeInPriceRequest] = (0, $047f6f355e30d7d1$export$b7eadabbf1e81c9b)();
    const context = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const handleNextClick = (0, $eeH7J.useCallback)(()=>{
        context.setStep("Insurance");
    }, [
        context
    ]);
    const [, setResult] = (0, $047f6f355e30d7d1$export$db65bad7d1fa5d6f)();
    return !!responses.length && responses.filter((r)=>!!r).length === responses.length && form && ((_a = context.price) === null || _a === void 0 ? void 0 : _a.monthlyCost.tradeInDiscount) ? (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 32,
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: "Innbytte"
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 16,
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 3,
                        children: localize(props.modal.summary.answersSummaryHeading)
                    }),
                    (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                        borderColor: "gray200",
                        borderRadius: "md",
                        padding: "md",
                        children: form.questions.map((q, qi)=>{
                            var _a, _b;
                            return (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                children: [
                                    qi > 0 ? (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: "md"
                                    }) : null,
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "sm",
                                        children: localize(q.question)
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 4,
                                        children: localize((_b = (_a = q.responses.find((r)=>r.id === responses[qi])) === null || _a === void 0 ? void 0 : _a.response) !== null && _b !== void 0 ? _b : {})
                                    })
                                ]
                            }, q.id.valueOf());
                        })
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 8,
                children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    onClick: handleNextClick,
                    children: localize(props.stepWithTradeInCompleted.nextStepButtonText)
                })
            })
        ]
    }) : (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        justifyContent: "center",
        gap: (0, $756948b644e82cf2$export$981516ee4691055c)(32),
        css: (0, $lhaLc.css)({
            height: "100%"
        }),
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: localize(props.headline)
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 20,
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "xl",
                        children: localize(props.leadText)
                    }),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: [
                            4,
                            [
                                "min",
                                "md",
                                8
                            ]
                        ],
                        children: props.steps.map((item, i)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                gap: 8,
                                alignItems: "center",
                                children: [
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: "check",
                                        color: "forest"
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        color: "gray300",
                                        size: "md",
                                        children: localize(item.text)
                                    })
                                ]
                            }, item.id.valueOf()))
                    })
                ]
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 8,
                css: (0, $lhaLc.css)({
                    flexWrap: "wrap-reverse",
                    justifyContent: "stretch"
                }, responsiveCss("max", "sm", {
                    flexDirection: "column-reverse"
                })),
                children: [
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "secondary",
                        onClick: ()=>{
                            setStep("Insurance");
                        },
                        children: localize(props.notThisTimeButton)
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: startTradeIn,
                        children: localize(props.primaryCta)
                    })
                ]
            }),
            !!form && !!tradeInId && (0, $4vwom.jsx)($0eca38a3f9eebfa7$export$9e5a8dc8aab6dd64, Object.assign({
                id: tradeInId,
                form: form,
                open: modalOpen,
                onClose: ()=>{
                    setModalOpen(false);
                },
                onCloseAnimationEnd: ()=>{
                    context.setStep("Insurance");
                },
                productName: localize(context.offer.name),
                months: context.offer.rentalPeriod,
                originalPrice: context.offer.monthlyPrice,
                onTradeInConfirm: (form2, responses2, result2)=>{
                    setResult(result2);
                    setCheckoutTradeInPriceRequest({
                        form: form2.id,
                        responses: responses2.map((r)=>(0, $8h5s0.Assert)(r)),
                        version: form.version
                    });
                }
            }, props.modal))
        ]
    });
}
function $0eca38a3f9eebfa7$export$9e5a8dc8aab6dd64(props) {
    const { form: form } = props;
    const localize = (0, $aIeEI.useLocalize)();
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss, responsiveBorderRadius: responsiveBorderRadius } = helpers;
    const [responses, setResponses] = (0, $eK8Q4.useSessionState)(`tradein-${props.id}-responses`, []);
    const [result, setResult] = (0, $eK8Q4.useSessionState)(`tradein-${props.id}-result`, undefined);
    const answerImage = (0, $eeH7J.useMemo)(()=>{
        const rr = [
            ...responses
        ].reverse();
        const qr = [
            ...form.questions
        ].reverse();
        return qr.reduce((acc, curr, index)=>{
            // Question hasn't been answered yet, don't check for image.
            if (!rr[index]) return undefined;
            // We started from the last question, so if already set, keep it.
            if (acc) return acc;
            // Return if selected response for question has an image
            return curr.responses.find((r)=>r.id === rr[index] && r.image);
        }, undefined);
    }, [
        responses,
        form
    ]);
    const localizeCurrency = (0, $b274814d74f89bd0$export$2daf9f30efa60400)();
    const PaymentSummaryRendered = (0, $eeH7J.useMemo)(()=>result ? (0, $4vwom.jsx)((0, $9ef1a37a4c2e6964$export$161a6b098fcc9bc6), {
            itemName: props.productName,
            text: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.summary.priceSummaryText), {
                currency: localizeCurrency(result.value.currency),
                itemValue: result.value.majorUnits.toString(),
                discountAmount: result.monthlyDiscount.majorUnits.toString(),
                discountMonths: result.months.toString(),
                monthsShort: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
                monthsLong: localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))
            }),
            originalPrice: props.originalPrice.itemsTotal.majorUnits,
            discountedPrice: // Can't use discountedTotal yet, as the trade-in is not added to the order.
            props.originalPrice.itemsTotal.majorUnits - result.monthlyDiscount.majorUnits,
            rentalPeriodUnit: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
            currency: localizeCurrency(result.value.currency),
            label: localize(props.summary.priceSummaryLabel)
        }) : null, [
        result,
        props.productName,
        props.summary.priceSummaryText,
        props.summary.priceSummaryLabel,
        props.originalPrice.itemsTotal.majorUnits,
        localize,
        localizeCurrency
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (responses.length !== form.questions.length) setResponses(form.questions.map(()=>undefined));
    }, [
        form.questions,
        responses.length,
        setResponses
    ]);
    const [currentStep, setCurrentStep] = (0, $eK8Q4.useSessionState)(`tradein-${props.id}-modal-step`, undefined);
    return (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
        isOpen: props.open,
        onClose: ()=>{
            setResponses([]);
            setCurrentStep(undefined);
            props.onClose();
        },
        width: "100%",
        onCloseAnimationEnd: props.onCloseAnimationEnd,
        header: {
            closeButton: true
        },
        closePrompt: props.closePrompt ? {
            heading: localize(props.closePrompt.heading),
            text: localize(props.closePrompt.text),
            cancelButtonText: localize(props.closePrompt.cancelButtonText),
            confirmButtonText: localize(props.closePrompt.confirmButtonText)
        } : undefined,
        step: currentStep,
        onStepChange: (val)=>setCurrentStep(val),
        steps: [
            {
                header: {
                    title: localize(props.questions.heading)
                },
                render: (next, prev)=>(0, $4vwom.jsx)($0eca38a3f9eebfa7$var$QuestionsStep, Object.assign({}, props, {
                        form: form,
                        responsesState: [
                            responses,
                            setResponses
                        ],
                        onSubmitAnswers: async ()=>{
                            try {
                                const response = await (0, $e18f565b44c7bc7d$export$8f2b94717249315f)("Phones", {
                                    months: props.months,
                                    responses: responses.map((r)=>(0, $8h5s0.Assert)(r))
                                });
                                setResult(response);
                                next();
                            } catch (e) {
                                if ("detail" in e) alert(e.detail);
                                else alert("An error occurred");
                            }
                        }
                    }))
            },
            {
                header: {
                    backButton: true,
                    title: localize(props.summary.heading)
                },
                render: (next, prev)=>(0, $4vwom.jsx)($0eca38a3f9eebfa7$var$SummaryStep, Object.assign({}, props, {
                        form: form,
                        responsesState: [
                            responses,
                            setResponses
                        ],
                        PaymentSummaryRendered: PaymentSummaryRendered,
                        onNextClick: next
                    }))
            },
            {
                header: {
                    backButton: true
                },
                render: (next, prev)=>(0, $4vwom.jsx)($0eca38a3f9eebfa7$var$ConfirmationStep, Object.assign({}, props, {
                        form: form,
                        PaymentSummaryRendered: PaymentSummaryRendered,
                        onTradeInConfirm: ()=>{
                            const rs = responses.filter((r)=>!!r);
                            if (!result || rs.length < responses.length) {
                                // NOTE: At this point, no responses should be undefined,
                                // hence the basic error handling.
                                alert("Could not complete trade-in, as not all questions have been answered.");
                                return;
                            }
                            props.onTradeInConfirm(form, rs, result);
                            props.onClose();
                        }
                    }))
            }
        ],
        renderSteps: (step)=>(0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
                transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                children: (0, $4vwom.jsxs)("div", {
                    style: {
                        display: "flex",
                        gap: 20,
                        width: "100%"
                    },
                    children: [
                        (0, $4vwom.jsx)("div", {
                            css: (0, $lhaLc.css)({
                                display: "flex",
                                flex: "5 0 0",
                                position: "relative"
                            }),
                            children: step
                        }),
                        form.image ? (0, $4vwom.jsx)("div", {
                            css: (0, $lhaLc.css)({
                                flex: "2 0 0"
                            }, responsiveCss("max", "sm", {
                                display: "none"
                            }), responsiveCss("min", "md", {
                                flexGrow: 3
                            }), responsiveCss("min", "lg", {
                                flexGrow: 4
                            })),
                            children: (0, $4vwom.jsx)("div", {
                                style: {
                                    position: "sticky",
                                    top: 0,
                                    right: 0
                                },
                                children: (0, $4vwom.jsxs)("div", {
                                    style: {
                                        position: "relative",
                                        overflow: "hidden",
                                        aspectRatio: "1/1"
                                    },
                                    css: responsiveBorderRadius("md"),
                                    children: [
                                        (answerImage === null || answerImage === void 0 ? void 0 : answerImage.image) && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            motion: {
                                                initial: {
                                                    opacity: 0
                                                },
                                                animate: {
                                                    opacity: 1
                                                }
                                            },
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "gray100",
                                            style: {
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%"
                                            },
                                            children: (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                                width: 400,
                                                image: answerImage.image,
                                                style: {
                                                    width: "50%"
                                                }
                                            })
                                        }),
                                        (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                            animate: (answerImage === null || answerImage === void 0 ? void 0 : answerImage.image) ? {
                                                opacity: 0
                                            } : {},
                                            children: (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                                width: 400,
                                                image: form.image,
                                                style: {
                                                    objectFit: "cover",
                                                    width: "100%",
                                                    aspectRatio: "1/1"
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        }) : null
                    ]
                })
            })
    });
}
function $0eca38a3f9eebfa7$var$QuestionsStep(props) {
    const localize = (0, $aIeEI.useLocalize)();
    const questionRefs = (0, $eeH7J.useRef)([]);
    const [responses, setResponses] = props.responsesState;
    questionRefs.current = props.form.questions.map((_, i)=>{
        var _a;
        return (_a = questionRefs.current[i]) !== null && _a !== void 0 ? _a : /*#__PURE__*/ (0, $eeH7J.createRef)();
    });
    const modalContext = (0, $eeH7J.useContext)((0, $37d4981a6b4c97c0$export$ab57792b9b6974a6));
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            props.form.questions.map((q, qi)=>{
                var _a, _b;
                return (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    style: {
                        overflow: "hidden"
                    },
                    initial: qi > 0 && responses.filter((r)=>r).length < qi ? {
                        height: 0,
                        opacity: 0,
                        translateY: -20
                    } : {
                        height: "auto"
                    },
                    animate: qi > 0 && responses.filter((r)=>r).length >= qi ? {
                        height: (_b = (_a = questionRefs.current[qi]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height,
                        opacity: 1,
                        translateY: 0
                    } : qi > 0 ? {
                        height: 0,
                        opacity: 0,
                        translateY: -20
                    } : {},
                    onAnimationComplete: ()=>{
                        var _a;
                        const scrollContainer = (_a = modalContext.scrollContainerRef) === null || _a === void 0 ? void 0 : _a.current;
                        if (scrollContainer) scrollContainer.scroll({
                            top: scrollContainer.scrollHeight,
                            behavior: "smooth"
                        });
                    },
                    children: (0, $4vwom.jsxs)("div", {
                        ref: questionRefs.current[qi],
                        children: [
                            q.type === "buttons" ? (0, $4vwom.jsx)((0, $aab0dbc639a1af01$export$42100d7f568e8c11), {
                                question: localize(q.question),
                                description: q.description ? localize(q.description) : undefined,
                                options: q.responses.map((r)=>({
                                        value: r.id,
                                        text: localize(r.response)
                                    })),
                                value: responses[qi],
                                onChange: (e, val)=>{
                                    setResponses(responses.map((r, i)=>i === qi ? val : r));
                                }
                            }) : q.type === "dropdown" ? (0, $4vwom.jsxs)("div", {
                                children: [
                                    (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                        margin: {
                                            bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                                size: "md",
                                                margin: {
                                                    bottom: 16
                                                },
                                                children: localize(q.question)
                                            }),
                                            q.description ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "sm",
                                                color: "gray300",
                                                children: localize(q.description)
                                            }) : null
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $50112aaf62b7ce57$export$ef9b1a59e592288f), {
                                        value: responses[qi],
                                        placeholder: localize({
                                            en: "Please select",
                                            no: "Vennligst velg"
                                        }),
                                        onChange: (e, val)=>{
                                            if (qi === 0) setResponses(responses.map((r, ri)=>ri === 0 ? val : undefined));
                                            else setResponses(responses.map((r, i)=>i === qi ? val : r));
                                        },
                                        options: [
                                            ...q.responses.map((r)=>({
                                                    value: r.id,
                                                    text: localize(r.response)
                                                }))
                                        ],
                                        renderValue: (val)=>{
                                            var _a, _b;
                                            return localize((_b = (_a = q.responses.find((x)=>x.id === val)) === null || _a === void 0 ? void 0 : _a.response) !== null && _b !== void 0 ? _b : {});
                                        }
                                    })
                                ]
                            }) : (0, $4vwom.jsxs)("div", {
                                children: [
                                    "Unsupported question type: ",
                                    q.type
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 32
                            })
                        ]
                    })
                }, q.id.valueOf());
            }),
            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                variant: "primary",
                onClick: ()=>{
                    try {
                        props.onSubmitAnswers();
                    } catch (err) {}
                },
                iconEnd: "arrowRight",
                disabled: responses.some((r)=>!r),
                fullwidth: true,
                children: localize({
                    en: "Continue",
                    no: "Fortsett"
                })
            })
        ]
    });
}
function $0eca38a3f9eebfa7$var$SummaryStep(props) {
    const localize = (0, $aIeEI.useLocalize)();
    const [responses] = props.responsesState;
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            gap: 40,
            children: (0, $4vwom.jsxs)("div", {
                css: (0, $lhaLc.css)({
                    flex: "5 0 0"
                }),
                children: [
                    props.PaymentSummaryRendered,
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 3,
                        margin: {
                            top: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).lg,
                            bottom: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).sm
                        },
                        children: localize(props.summary.answersSummaryHeading)
                    }),
                    (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                        borderColor: "gray200",
                        borderRadius: "md",
                        padding: "md",
                        margin: {
                            bottom: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).lg
                        },
                        children: props.form.questions.map((q, qi)=>{
                            var _a, _b;
                            return (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                children: [
                                    qi > 0 ? (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: "md"
                                    }) : null,
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "sm",
                                        children: localize(q.question)
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 4,
                                        children: localize((_b = (_a = q.responses.find((r)=>r.id === responses[qi])) === null || _a === void 0 ? void 0 : _a.response) !== null && _b !== void 0 ? _b : {})
                                    })
                                ]
                            }, q.id.valueOf());
                        })
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        iconEnd: "arrowRight",
                        onClick: props.onNextClick,
                        fullwidth: true,
                        children: localize(props.summary.continueButtonText)
                    })
                ]
            })
        })
    });
}
function $0eca38a3f9eebfa7$var$ConfirmationStep(props) {
    const localize = (0, $aIeEI.useLocalize)();
    const [checkedAcknowledgements, setCheckedAcknowledgements] = (0, $eeH7J.useState)([]);
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            gap: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).lg,
            children: [
                props.PaymentSummaryRendered,
                (0, $4vwom.jsxs)("div", {
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 3,
                            margin: {
                                bottom: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).sm
                            },
                            children: localize(props.confirmation.nextStepsHeading)
                        }),
                        (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            gap: 12,
                            children: props.confirmation.nextSteps.map((ns)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    gap: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).sm,
                                    backgroundColor: "gray100",
                                    padding: "md",
                                    borderRadius: "md",
                                    alignItems: "center",
                                    children: [
                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                            icon: ns.icon,
                                            size: 32
                                        }),
                                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                            variant: "body",
                                            size: "md",
                                            children: localize(ns.text)
                                        })
                                    ]
                                }, ns.id.valueOf()))
                        })
                    ]
                }),
                (0, $4vwom.jsx)("div", {
                    children: props.confirmation.acknowledgements.map((a, ai)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                            children: [
                                ai > 0 ? (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                    horizontal: true,
                                    spacing: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).md
                                }) : null,
                                (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                    label: localize(a.text),
                                    checked: checkedAcknowledgements.includes(a.id),
                                    onChange: ()=>setCheckedAcknowledgements(checkedAcknowledgements.includes(a.id) ? checkedAcknowledgements.filter((ca)=>ca !== a.id) : [
                                            ...checkedAcknowledgements,
                                            a.id
                                        ])
                                })
                            ]
                        }, a.id.valueOf()))
                }),
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    fullwidth: true,
                    disabled: checkedAcknowledgements.length < props.confirmation.acknowledgements.length,
                    variant: "primary",
                    onClick: props.onTradeInConfirm,
                    children: localize(props.confirmation.continueButtonText)
                })
            ]
        })
    });
}


const $c90be680bf4410a3$export$68c0e99bc234a4d = {
    TradeIn: (0, $0eca38a3f9eebfa7$export$a8febc64537a0214),
    Insurance: (0, $be6bc11d8e8cab8d$export$90b6e87e315e2927),
    Login: (0, $9acc7a9b3b60d30b$export$b14e3cb78859f2c6),
    Shipping: (0, $fe97b132bdc7c14c$export$f86ab37791746a56),
    Payment: (0, $f6289446464b7da6$export$20c36f2f8fe0d441)
};
const $c90be680bf4410a3$export$c81bc4f691c81d42 = [
    {
        id: "TradeIn",
        icon: "handCoins"
    },
    {
        id: "Insurance",
        icon: "shield"
    },
    {
        id: "Login",
        icon: "vipps"
    },
    {
        id: "Shipping",
        icon: "truck"
    },
    {
        id: "Payment",
        icon: "receipt"
    }
];
const $c90be680bf4410a3$export$5558864fbda6a534 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $c90be680bf4410a3$export$b75716bfd8405073() {
    const context = (0, $eeH7J.useContext)($c90be680bf4410a3$export$5558864fbda6a534);
    if (!context) throw new Error("CheckoutContext not found");
    return context;
}




var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");







var $eSiQ2 = parcelRequire("eSiQ2");



const $c4ee9fc699106494$var$CURRENT_ICON_DIMENSION = 48;
const $c4ee9fc699106494$var$MOBILE_OUTER_ICON_DIMENSION = 16;
const $c4ee9fc699106494$var$MOBILE_INNER_ICON_DIMENSION = 12;
const $c4ee9fc699106494$var$DESKTOP_OUTER_ICON_DIMENSION = 40;
const $c4ee9fc699106494$var$DESKTOP_INNER_ICON_DIMENSION = 32;
function $c4ee9fc699106494$export$2a0ca3f7657e279({ steps: steps, currentStep: currentStep }) {
    const checkoutContext = (0, $eeH7J.useContext)((0, $c90be680bf4410a3$export$5558864fbda6a534));
    const getStatus = (step, index)=>{
        const currentIndex = steps.findIndex((s)=>s.id === step);
        if (currentIndex === index) return "current";
        if (currentIndex > index) return "completed";
        return "future";
    };
    const getPosition = (index, length)=>{
        if (index === 0) return "first";
        if (index === length) return "last";
        return "middle";
    };
    const handleClick = (0, $eeH7J.useCallback)((s)=>{
        checkoutContext === null || checkoutContext === void 0 || checkoutContext.setStep(s);
    }, [
        checkoutContext
    ]);
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        flex: "1",
        alignItems: "center",
        justifyContent: "space-between",
        style: {
            position: "relative"
        },
        children: [
            (0, $4vwom.jsx)($c4ee9fc699106494$var$StepSeparator, {
                currentStepIndex: steps.findIndex((s)=>s.id === currentStep),
                totalSteps: steps.length
            }),
            steps.map((step, index)=>{
                const status = getStatus(currentStep, index);
                return (0, $4vwom.jsx)($c4ee9fc699106494$var$StepIcon, {
                    onClick: step.isAvailable ? ()=>handleClick(step.id) : undefined,
                    step: step,
                    status: status,
                    position: getPosition(index, steps.length - 1)
                }, step.id);
            })
        ]
    });
}
const $c4ee9fc699106494$var$stepIndicatorColorMap = {
    completed: "forest",
    current: "grayWhite",
    future: "gray200"
};
function $c4ee9fc699106494$var$StepIcon({ step: step, status: status, position: position, onClick: onClick }) {
    const getDimension = (dimension)=>(0, $756948b644e82cf2$export$981516ee4691055c)(status === "current" ? $c4ee9fc699106494$var$CURRENT_ICON_DIMENSION : dimension);
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    return (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
        onClick: onClick,
        css: (0, $lhaLc.css)({
            backgroundColor: colors.gray100,
            cursor: onClick ? "pointer" : "inherit",
            boxShadow: status === "current" ? (0, $e665a5c3bf2ac3f6$export$16e1fc8de5cd9687) : "none",
            height: getDimension($c4ee9fc699106494$var$DESKTOP_OUTER_ICON_DIMENSION),
            width: getDimension($c4ee9fc699106494$var$DESKTOP_OUTER_ICON_DIMENSION),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            borderRadius: "50%"
        }, responsiveCss("max", "sm", {
            height: getDimension($c4ee9fc699106494$var$MOBILE_OUTER_ICON_DIMENSION),
            width: getDimension($c4ee9fc699106494$var$MOBILE_OUTER_ICON_DIMENSION),
            marginRight: status !== "current" && position === "last" ? (0, $756948b644e82cf2$export$981516ee4691055c)(($c4ee9fc699106494$var$CURRENT_ICON_DIMENSION - $c4ee9fc699106494$var$MOBILE_OUTER_ICON_DIMENSION) / 2) : undefined,
            marginLeft: status !== "current" && position === "first" ? (0, $756948b644e82cf2$export$981516ee4691055c)(($c4ee9fc699106494$var$CURRENT_ICON_DIMENSION - $c4ee9fc699106494$var$MOBILE_OUTER_ICON_DIMENSION) / 2) : undefined
        })),
        children: (0, $4vwom.jsx)((0, $cf418bf541887e36$export$28c660c63b792dea), {
            alignment: "center",
            renderTrigger: (ref)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    whileHover: "hover",
                    variants: {
                        hover: status === "future" ? {
                            backgroundColor: colors.grayWhite,
                            transition: {
                                duration: 0.2
                            }
                        } : {}
                    },
                    ref: ref,
                    css: (0, $lhaLc.css)({
                        backgroundColor: colors[$c4ee9fc699106494$var$stepIndicatorColorMap[status]],
                        height: getDimension($c4ee9fc699106494$var$DESKTOP_INNER_ICON_DIMENSION),
                        width: getDimension($c4ee9fc699106494$var$DESKTOP_INNER_ICON_DIMENSION),
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "50%"
                    }, responsiveCss("max", "sm", {
                        height: getDimension($c4ee9fc699106494$var$MOBILE_INNER_ICON_DIMENSION),
                        width: getDimension($c4ee9fc699106494$var$MOBILE_INNER_ICON_DIMENSION)
                    })),
                    children: status === "completed" ? (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        hidden: [
                            "max",
                            "sm"
                        ],
                        icon: "check",
                        color: "grayWhite"
                    }) : status === "current" ? (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: step.icon
                    }) : (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                        style: {
                            opacity: 0,
                            scale: 0.1
                        },
                        variants: {
                            hover: {
                                opacity: 1,
                                scale: 0.8,
                                transition: {
                                    duration: 0.2
                                }
                            }
                        },
                        children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                            icon: step.icon
                        })
                    })
                }),
            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "heading",
                level: 4,
                children: step.name
            })
        })
    });
}
const $c4ee9fc699106494$var$StepSeparator = ({ currentStepIndex: currentStepIndex, totalSteps: totalSteps })=>{
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const percentage = currentStepIndex / (totalSteps - 1) * 100;
    const uncompletedBarWidth = `${100 - percentage}%`;
    const completedBarWidth = `${percentage}%`;
    return (0, $4vwom.jsxs)("div", {
        css: (0, $lhaLc.css)({
            height: 4,
            position: "absolute",
            right: `${$c4ee9fc699106494$var$CURRENT_ICON_DIMENSION / 2}px`,
            left: `${$c4ee9fc699106494$var$CURRENT_ICON_DIMENSION / 2}px`,
            display: "flex",
            overflow: "hidden"
        }),
        children: [
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)({
                    height: "100%",
                    width: completedBarWidth,
                    backgroundColor: colors.forest,
                    transition: "width 0.8s ease-in-out",
                    borderRadius: "2px"
                }, responsiveCss("min", "md", {
                    width: `calc(${completedBarWidth} + ${2 * $c4ee9fc699106494$var$CURRENT_ICON_DIMENSION / 3}px)`
                }))
            }),
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)({
                    height: "100%",
                    width: uncompletedBarWidth,
                    backgroundColor: colors.gray200,
                    transition: "width 0.8s ease-in-out"
                }, responsiveCss("min", "md", {
                    width: `calc(${uncompletedBarWidth} - ${2 * $c4ee9fc699106494$var$CURRENT_ICON_DIMENSION / 3}px)`
                }))
            })
        ]
    });
};
const $c4ee9fc699106494$var$navigationMock = [
    {
        id: "TradeIn",
        name: "TradeIn",
        icon: "handCoins",
        tooltip: "Bytte inn",
        isAvailable: true
    },
    {
        id: "Insurance",
        name: "Insurance",
        icon: "shield",
        tooltip: "Trygghetspakke",
        isAvailable: true
    },
    {
        id: "Login",
        name: "Login",
        icon: "vipps",
        tooltip: "Vipps ID",
        isAvailable: false
    },
    {
        id: "Shipping",
        name: "Shipping",
        icon: "truck",
        tooltip: "Shipping",
        isAvailable: false
    }
];
(0, $eSiQ2.Component)($c4ee9fc699106494$export$2a0ca3f7657e279, {
    name: "Steps",
    gallery: {
        path: "Navigation/Steps",
        items: [
            {
                title: "First Step",
                variants: [
                    {
                        props: {
                            steps: $c4ee9fc699106494$var$navigationMock,
                            currentStep: "TradeIn"
                        }
                    }
                ]
            },
            {
                title: "Second Step",
                variants: [
                    {
                        props: {
                            steps: $c4ee9fc699106494$var$navigationMock,
                            currentStep: "Insurance"
                        }
                    }
                ]
            },
            {
                title: "Third Step",
                variants: [
                    {
                        props: {
                            steps: $c4ee9fc699106494$var$navigationMock,
                            currentStep: "Login"
                        }
                    }
                ]
            },
            {
                title: "Last Step",
                variants: [
                    {
                        props: {
                            steps: $c4ee9fc699106494$var$navigationMock,
                            currentStep: "Shipping"
                        }
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");


var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");

var $7m9cQ = parcelRequire("7m9cQ");










function $6b5c692995a5ffa5$export$d175a07b9db3024e(props) {
    var _a;
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const isDiscountedPrice = (0, $eeH7J.useMemo)(()=>props.checkout.originalPrice > props.checkout.discountedPrice, [
        props.checkout.originalPrice,
        props.checkout.discountedPrice
    ]);
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        backgroundColor: "gray500",
        borderRadius: "lg",
        color: "grayWhite",
        css: (0, $lhaLc.css)({
            position: "relative",
            padding: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
            flexDirection: "column-reverse",
            gap: 24
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(800),
            gap: 40,
            maxHeight: `calc(100vh - 24px - ${(0, $756948b644e82cf2$export$981516ee4691055c)(48)} - 24px - 24px)`,
            padding: (0, $756948b644e82cf2$export$981516ee4691055c)(40),
            paddingTop: (0, $756948b644e82cf2$export$981516ee4691055c)(60),
            flexDirection: "column"
        })),
        children: [
            props.label && (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)({
                    position: "absolute"
                }, (0, $aace75a797ac78f1$export$9c33585a37942ee0)("lg", [
                    "top",
                    "right"
                ])),
                children: (0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                    color: "brand",
                    children: props.label
                })
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                flex: "1 1 auto",
                alignItems: "center",
                justifyContent: "space-between",
                shrink: 1,
                css: (0, $lhaLc.css)({
                    flexDirection: "column-reverse",
                    gap: 24
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    flexDirection: "column",
                    gap: 40
                })),
                children: [
                    (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: 1
                        },
                        exit: {
                            opacity: 0
                        },
                        style: {
                            maxHeight: (0, $756948b644e82cf2$export$981516ee4691055c)(416),
                            display: "flex",
                            flex: "1 0 auto",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            scrollSnapAlign: "center"
                        },
                        children: (0, $4vwom.jsx)("div", {
                            css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                minHeight: 264
                            }),
                            style: {
                                display: "flex",
                                height: "100%",
                                width: "100%",
                                flexDirection: "column",
                                backgroundImage: (0, $14q7s.ImageToCSS)(props.product.image, {
                                    width: 900
                                }),
                                backgroundPosition: "center",
                                objectFit: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "auto 100%",
                                maxHeight: (0, $756948b644e82cf2$export$981516ee4691055c)(420)
                            }
                        })
                    }, props.product.image.valueOf()),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: 8,
                        style: {
                            width: "100%"
                        },
                        children: (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
                            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                            children: (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                                initial: false,
                                children: (_a = props.infoItems) === null || _a === void 0 ? void 0 : _a.map((item)=>(0, $4vwom.jsx)($6b5c692995a5ffa5$var$AppearingItem, {
                                        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                            style: {
                                                backgroundColor: "#31253f"
                                            },
                                            css: (0, $lhaLc.css)({
                                                borderRadius: 8,
                                                padding: 16
                                            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                                borderRadius: 20
                                            })),
                                            gap: [
                                                8,
                                                [
                                                    "min",
                                                    "md",
                                                    12
                                                ]
                                            ],
                                            children: [
                                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                                        backgroundColor: `${colors.grayWhite}${(0, $2e602d91f6817609$export$dcfd5621ca9623a7)["10"]}`,
                                                        borderRadius: 8,
                                                        height: (0, $756948b644e82cf2$export$981516ee4691055c)(48),
                                                        width: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                                                    }),
                                                    children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                        icon: item.icon
                                                    })
                                                }),
                                                (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                                            size: "sm",
                                                            children: item.title
                                                        }),
                                                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                                            size: "xs",
                                                            style: {
                                                                opacity: 0.6
                                                            },
                                                            children: item.text
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, item.id))
                            })
                        })
                    })
                ]
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                flex: "0 0 auto",
                justifyContent: "space-between",
                alignItems: "flex-end",
                children: [
                    (0, $4vwom.jsxs)("div", {
                        children: [
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                alignItems: "center",
                                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "heading",
                                    level: 3,
                                    children: props.checkout.monthlyTotalPriceLabel
                                })
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "xs",
                                style: {
                                    opacity: 0.6
                                },
                                children: props.checkout.rentalPeriodTotalPriceText
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        alignItems: "flex-end",
                        children: [
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                alignItems: "baseline",
                                children: [
                                    isDiscountedPrice && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "sm",
                                        color: "gray200",
                                        style: {
                                            textDecoration: "line-through",
                                            marginRight: 4
                                        },
                                        children: props.checkout.originalPrice
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 2,
                                        color: isDiscountedPrice ? "brand" : undefined,
                                        children: props.checkout.discountedPrice
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                size: "sm",
                                style: {
                                    opacity: 0.6,
                                    textTransform: "lowercase"
                                },
                                children: props.checkout.rentalPeriodCurrencyPeriodUnit
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $6b5c692995a5ffa5$var$AppearingItem(props) {
    const [isPresent, safeToRemove] = (0, $d9315986bafdadde$export$2a8c16d82a0a0e26)();
    const [scope, animate] = (0, $4c4e7486a769eecb$export$9f387b98a73b1511)();
    const ref = (0, $eeH7J.useRef)(null);
    const [height, setHeight] = (0, $eeH7J.useState)(0);
    const updateHeight = (0, $eeH7J.useCallback)(()=>{
        var _a, _b;
        setHeight((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0);
    }, [
        setHeight
    ]);
    const heightRef = (0, $eeH7J.useRef)(0);
    (0, $eeH7J.useEffect)(()=>{
        if (isPresent) {
            const enterAnimation = async ()=>{
                var _a, _b;
                await animate(scope.current, {
                    opacity: 1,
                    height: (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0,
                    transform: `translateY(0px)`
                });
            };
            enterAnimation();
        } else {
            const exitAnimation = async ()=>{
                var _a, _b;
                await animate(scope.current, {
                    opacity: 0,
                    height: 0,
                    transform: `translateY(-${((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) - 16}px)`
                });
                safeToRemove();
            };
            exitAnimation();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPresent
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        heightRef.current = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0;
        updateHeight();
    }, [
        updateHeight
    ]);
    return (0, $4vwom.jsx)("div", {
        ref: scope,
        style: {
            opacity: 0,
            height: 0,
            transform: `translateY(${height * -1 + 16}px)`
        },
        children: (0, $4vwom.jsx)("div", {
            ref: ref,
            children: props.children
        })
    });
}
(0, $eSiQ2.Component)($6b5c692995a5ffa5$export$d175a07b9db3024e, {
    name: "DeviceCheckoutCard",
    gallery: {
        path: "Cards/DeviceCheckoutCard",
        items: [
            {
                variants: [
                    {
                        props: {
                            product: {
                                image: `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image3.png`,
                                color: "Midnight",
                                storageSize: "256 GB"
                            },
                            subscription: {
                                duration: 24,
                                unit: "months lease"
                            },
                            checkout: {
                                originalPrice: 320,
                                discountedPrice: 250,
                                rentalPeriodCurrencyPeriodUnit: "kr/md.",
                                monthlyTotalPriceLabel: "Totalt 3400 NOK for leieperiode p\xe5 12 m\xe5neder",
                                rentalPeriodTotalPriceText: "Pris per m\xe5ned"
                            },
                            infoItems: [
                                {
                                    id: "trade-in",
                                    title: "Trade-in cashback",
                                    text: "We will deduct 50 kr. for the next 20 months.",
                                    icon: "device"
                                }
                            ],
                            label: "Trade-in"
                        }
                    }
                ]
            }
        ]
    }
});












var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");





var $aIeEI = parcelRequire("aIeEI");


var $dUDPg = parcelRequire("dUDPg");

function $652a00d43f507d25$export$13d90034f51c5979(props) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const primaryActionPageInfo = (0, $dUDPg.useWebPageInfo)(props.primaryAction.page);
    const localizeSlug = (0, $02ba3a727a0f8ecd$export$32f719dfac03c1cb)();
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        style: {
            width: "100%",
            height: "100%"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                padding: "16px 0"
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: "center",
                    gap: 12,
                    css: (0, $lhaLc.css)({
                        textAlign: "center"
                    }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                        gap: 8,
                        marginBottom: 32
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        padding: "0 40px",
                        gap: 12,
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            color: "gray500",
                            level: 2,
                            children: localize(props.heading)
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            color: "gray400",
                            variant: "body",
                            size: "md",
                            children: localize(props.text)
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "primary",
                    size: "md",
                    as: "a",
                    href: ((_a = primaryActionPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) ? localizeSlug(primaryActionPageInfo.data.slug) : "/",
                    children: localize(props.primaryAction.buttonText)
                })
            ]
        })
    });
}



var $4vwom = parcelRequire("4vwom");



var $aIeEI = parcelRequire("aIeEI");

function $b97c03a91b0e5a47$export$c120a0e80fd44ca6() {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        alignItems: "center",
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            style: {
                width: "100%",
                maxWidth: 640,
                textAlign: "center"
            },
            gap: 32,
            direction: "column",
            alignItems: "center",
            children: [
                (0, $4vwom.jsx)("div", {
                    style: {
                        width: "100%",
                        maxWidth: 480,
                        padding: "40px 32px 0 32px"
                    },
                    children: (0, $4vwom.jsx)($b97c03a91b0e5a47$var$Error404Svg, {
                        width: "100%",
                        height: "auto"
                    })
                }),
                (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                    size: "lg",
                    children: localize({
                        no: "Kunne ikke finne siden du lette etter.",
                        en: "Could not find the page you were looking for."
                    })
                }),
                (0, $4vwom.jsx)("div", {
                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "primary",
                        as: "a",
                        href: "/",
                        children: localize({
                            no: "G\xe5 til forsiden",
                            en: "Go to home page"
                        })
                    })
                })
            ]
        })
    });
}
const $b97c03a91b0e5a47$var$Error404Svg = (props)=>(0, $4vwom.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1841 1129",
        width: 1841,
        height: 1129,
        fill: "none"
    }, props, {
        children: [
            (0, $4vwom.jsx)("path", {
                fill: "#F6F6F6",
                d: "M927.87 1128.2c311.44 0 563.92-252.476 563.92-563.92C1491.79 252.836 1239.31.36 927.87.36c-311.444 0-563.92 252.476-563.92 563.92 0 311.444 252.476 563.92 563.92 563.92Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#a)",
                d: "M1538.64 1023.47c166.99 0 302.37-18.44 302.37-41.18 0-22.743-135.38-41.18-302.37-41.18s-302.37 18.437-302.37 41.18c0 22.74 135.38 41.18 302.37 41.18Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#b)",
                d: "M1509.8 988.78c118.22 0 214.05-4.589 214.05-10.25s-95.83-10.25-214.05-10.25c-118.22 0-214.05 4.589-214.05 10.25s95.83 10.25 214.05 10.25Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#c)",
                d: "M1509.8 988.78c118.22 0 214.05-4.589 214.05-10.25s-95.83-10.25-214.05-10.25c-118.22 0-214.05 4.589-214.05 10.25s95.83 10.25 214.05 10.25Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#d)",
                d: "M932.24 1023.47c237.57 0 430.16-18.44 430.16-41.18 0-22.743-192.59-41.18-430.16-41.18-237.571 0-430.16 18.437-430.16 41.18 0 22.74 192.589 41.18 430.16 41.18Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#e)",
                d: "M482.05 1023.47c166.994 0 302.37-18.44 302.37-41.18 0-22.743-135.376-41.18-302.37-41.18s-302.37 18.437-302.37 41.18c0 22.74 135.376 41.18 302.37 41.18Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#f)",
                d: "M897.53 1023.02h-80.19l39.83 15.81 40.36-15.81Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#g)",
                d: "M762.85 992.79h-41.79l39.82 15.81 1.97-15.81Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#h)",
                d: "M1134.71 1002.69h50.82l13.55-13.91h-53.61l-10.76 13.91Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#i)",
                d: "M1526.24 1023.57h50.82l-36.14-6.95-58.46-6.96 43.78 13.91Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#j)",
                d: "M1204.08 941.7h50.82l-12.52-3.39-13.93-3.56-24.37 6.95Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#k)",
                d: "M1386.85 941.7h50.83l-12.53-3.39-13.92-3.56-24.38 6.95Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#l)",
                d: "M1628.41 948.66h50.82l-12.52-3.39-30.68-3.57-7.62 6.96Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#m)",
                d: "M1770.33 965.74h38.22l-17.28-6.96-26.35 3.48 5.41 3.48Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#n)",
                d: "M1042.47 1016.62h16.19l7.91 6.4-21.08 2.63-3.02-9.03Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#o)",
                d: "M897.53 1038.83h20.62l-4.81 7.15-19.57-3.57 3.76-3.58Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#p)",
                d: "M658.85 930.41h-56.09l11.29 11.29h22.21l22.59-11.29Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#q)",
                d: "m232.83 930.41-38.35 5.64-6.45 5.65h22.21l22.59-11.29Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#r)",
                d: "M110 1002.41H53.91l-4.42 11.29H71.7l38.3-11.29Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#s)",
                d: "M19.39 933.27.78 941.11l15.01.59H38l-18.61-8.43Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#t)",
                d: "m352.72 950.45-20.62 1.93 15.32 5.65h22.21l-16.91-7.58Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#u)",
                d: "M655.46 911.58h19.96v-4.14l-16.57-4.14-3.39 8.28Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#v)",
                d: "M992.53 1004.67h-8.32l4.16 4.23 20.97-2.12-16.81-2.11Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#w)",
                d: "M1159.27 959.49h9.89l-2.26-2.92-20.62 1.46 12.99 1.46Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#x)",
                d: "M1305.81 938.31h24.29l-4.87 7.91-19.42-3.95v-3.96Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#y)",
                d: "M557.58 995.73h24.28l7.34-6.95-31.62 6.95Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#z)",
                d: "M1201.34 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2h-122.85V761.16h-260.9Zm260.89-424.27-146.91 310.29h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9B64E1",
                d: "M1201.34 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2h-122.85V761.16h-260.9Zm260.89-424.27-146.91 310.29h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#A)",
                d: "M1232.34 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2h-122.85V761.16h-260.9Zm260.89-424.27-146.91 310.29h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9B64E1",
                d: "M1232.34 629.45h-31v131.71h31V629.45Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#B)",
                d: "M875.69 988.78c118.216 0 214.05-4.589 214.05-10.25s-95.834-10.25-214.05-10.25c-118.217 0-214.05 4.589-214.05 10.25s95.833 10.25 214.05 10.25Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#C)",
                d: "M498.98 988.78c118.217 0 214.05-4.589 214.05-10.25s-95.833-10.25-214.05-10.25c-118.217 0-214.05 4.589-214.05 10.25s95.833 10.25 214.05 10.25Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#D)",
                d: "M498.98 988.78c118.217 0 214.05-4.589 214.05-10.25s-95.833-10.25-214.05-10.25c-118.217 0-214.05 4.589-214.05 10.25s95.833 10.25 214.05 10.25Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#CCADF2",
                d: "M176.73 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2H437.63V761.16h-260.9Zm260.9-424.27L290.72 647.18h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9B64E1",
                d: "M176.73 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2H437.63V761.16h-260.9Zm260.9-424.27L290.72 647.18h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#E)",
                d: "M144.66 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2H405.56V761.16h-260.9Zm260.9-424.27L258.65 647.18h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9964DF",
                d: "m908.34 49.33-292.855 98.386c-36.119 12.134-55.562 51.25-43.428 87.369l233.727 695.708c12.134 36.119 51.25 55.562 87.369 43.428l292.857-98.386c36.12-12.134 55.56-51.251 43.42-87.369L995.709 92.757C983.574 56.64 944.458 37.196 908.34 49.33Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#130722",
                d: "M1207.68 808.66c8.95 26.65-5.44 55.62-32.1 64.57l-292.86 98.38c-26.65 8.95-55.62-5.45-64.57-32.1L584.43 243.79c-8.95-26.65 5.44-55.62 32.1-64.57l292.86-98.38c26.65-8.95 55.62 5.44 64.57 32.1l233.72 695.72Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9B64E1",
                d: "M1186.94 802.27c8.95 26.65-5.44 55.62-32.1 64.57l-292.86 98.38c-26.65 8.95-55.62-5.45-64.57-32.1L563.69 237.4c-8.95-26.65 5.44-55.62 32.1-64.57l292.86-98.38c26.65-8.95 55.62 5.44 64.57 32.1l233.72 695.72Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#F)",
                d: "M893.658 53.764 600.803 152.15c-36.118 12.134-55.561 51.25-43.427 87.369l233.726 695.708c12.134 36.119 51.251 55.562 87.369 43.428l292.859-98.386c36.11-12.134 55.56-51.251 43.42-87.369L981.027 97.191c-12.134-36.118-51.251-55.561-87.369-43.427Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#B489EA",
                d: "M893.658 53.764 600.803 152.15c-36.118 12.134-55.561 51.25-43.427 87.369l233.726 695.708c12.134 36.119 51.251 55.562 87.369 43.428l292.859-98.386c36.11-12.134 55.56-51.251 43.42-87.369L981.027 97.191c-12.134-36.118-51.251-55.561-87.369-43.427Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#G)",
                d: "m1051.24 393.19 30.45 3.67-1.41-4.2-67.74-8.16 1.86-26.36 30.07-55.51-3.52-1.91-29.1 53.71-.48-3.21-28.48 4.27-7.54-22.45 71.08-41.14-1.3-3.87-73.35 42.46-7.17-2.23 32.14-24.83 30.34-69.11-1.89-5.64-31.7 72.2-33.56 25.93-10.65-3.31 18.24-34.52 11.49 13.42-9.62-16.97 45.76-86.61-1.76-5.24-68.32 129.31-7.67 1.32 29.96-110.75.03-.1 17.61-104.27-.65-1.93-1.01-3.01-41.86 92.35-12.06-.05-2.19 94.61-10.47.24-26.15-147.47 26.2-93.66c-1.39-.02-2.78 0-4.17.06l-26 92.96-.12.44 32.65 184.12-7.44 3.09-67.14-130.96-.11-.22-87.72-99.93-4.11 1.38 88.49 100.82 9.66 18.85-19.42 10.17-55.72-34.56-50.85-85.93-3.88 1.3 94.64 159.92 12.87 5.89-17.6 17.93-68.48-37.84-133.85-108.14-4.5 1.51 19.56 15.8-.76.31L666.51 273l-26.64 67.64-51.01-7.3 1.43 4.24 49.75 7.12 58.89 80.23-73.01 18.7 1.28 3.8 179.7-46.03 54.21-9.89-.24 16.85-65.11 25.35-151.03 65.9 1.28 3.81 87.39-38.13-.38.3 14.71 18.23-89.41 56.26 1.31 3.9 90.62-57.03 28.03 34.75-29.71 29.79-24.42-.09h-.79l-46.61 43.57 1.4 4.17 46.78-43.74 75.7.27-11.94 53.49 7.51 22.36-54.57 156.56 2.08 6.19 56.72-162.73-7.59-22.6 12.78-57.25-51.42-.19 68.21-68.4 25.19 111.4-22.56 69.89 21.35 19.14-37.35 142.96-39.81 43.78 1.46 4.34 40.62-44.68 55.22 27.59-59.2 104.17c.97.98 1.97 1.92 2.99 2.84l60.73-106.86.17-.3 23.03-130.93 41.72 37.4.76-.85 1.14 31.73-28.53 173.51 4.29-1.44 28.21-171.61.03-.2-2.63-72.85 59.56-68.01 21.33-4.26 10.21 46.9-27.94 55.67-1.17 184.92 4.01-1.35 1.16-182.61 24.46-48.74 5.61 103.64.04.76 86.44 87.41 4.22-1.42-86.75-87.72-3.97-73.35 132.92 26.81 43.86 79.88c.67-1.65 1.27-3.32 1.81-5.01l-77.4-140.97-.23-.42L1095 665.6l-91.11-158.11 41.21-20 46.21 54.43-21.93 20.01 24.36-17.15 61.33 70.67-2.56-7.62-100.09-117.89 13.03-24.37-15.55 21.4-36.81-43.36 23.06-18.83 15.03-31.62.06.03Zm-67.56-33.76 27.72-4.16-.73 1.35-.21.38-1.9 27.02-23.06-2.78-1.83-21.81h.01Zm-25.86 141.68-17.66-83.8.6.08 5.99-1.13 36.33 63.04 13.88 63.76-12.97 3.25-12.38-36.86-13.79-8.35v.01Zm-62.65-119.82-2.78-10.32 24.09-4.94-.82 8.46-20.03 7.98-.22-1.23-.23.04-.01.01Zm-28.56-50.38 27.69 15.3-5.96 20.82-27.04-1.65 5.31-34.46v-.01Zm-9.32 34.22-62.7-3.83 33.03-17.44 2.68-33.01 32.58 18-5.59 36.28Zm66.84-8.4 13.79-4.63 10.36 19.46-24.15-14.83Zm23.84 19.33-17.55 8.35 6.5-15.13 11.05 6.78Zm-14.49-8.9-7.22 16.8-6.67-8.65 1.39-14.25.1.12.11-1.56 12.29 7.54Zm-16.6-5.3-24.33 4.98 3.63-12.69 21.09 3.69-.39 4.02Zm-19.59-11.57 1.19-4.17 4.44-6.13 11.37 13.27-17-2.98v.01Zm-1.21-7.67-25.03-13.83-1.51-19.29 30.24 28-3.71 5.12h.01Zm20.78 35.7 7.61 9.88-15.48 18.94-5.07-5.75-6.88-15.17 19.81-7.9h.01Zm10.15 13.09 17.14 21.28-3.49.66-28.35-3.95 14.71-17.99h-.01Zm8.94 25.32 18.31 86.91 14.02 8.49 11.82 35.18-46.67 11.71-5.17-143.36 7.68 1.07h.01Zm14.76-1.6 22.53-12.32 24.21 28.52-23.57 24.01-23.17-40.21Zm-2.17-3.37-18.37-22.81 22.97-10.92 27.53 5.47-6.76 14.4-25.36 13.86h-.01Zm5.66-37.6-.31-.57 21.24-28.6 4.42 13.15 1.79 21.41-27.15-5.39h.01Zm19.39-33.8-21.77 29.31-10.18-19.12 30.44-14.71 1.52 4.52h-.01Zm-28.45-13.4 1.82.96.42-.8 20.42 6.34-29.67 14.34-4.48 1.51 2.71-20.84 8.78-1.51Zm-27.65-31.64 13.67-.32 2.19-94.51 10.73.04 33.07-72.95-13.65 84.96-30.42 112.45-10.02 1.73-5.57-31.39v-.01Zm5.82 35.4 8.93-1.54-2.81 21.54-7.78 2.61 1.66-22.62v.01Zm-4.11 1.39-1.4 19.1-11.7-13.65 13.1-5.45Zm-11.16.31-5.42 2.25-37.91-35.1 15.68-21.1 27.66 53.95h-.01Zm-89.64-63.81-38.31-64.74 51.15 31.72 21.41-11.22 25.7 50.13-16.6 22.34-17.96-16.63-25.39-11.61v.01Zm13.94 10.77 9.21 4.21 23.67 21.91 1.64 20.98-52.35-28.93 17.83-18.17Zm-161.48-6.37-42.09-101.97 111.25 89.88.14.11 86.3 47.69-2.65 32.62-36.9 19.48-10.9-.67-132.03-18.89 26.88-68.25Zm135.28 124.52h-.07l-102.94 26.38-57.52-78.37 129.9 18.59 112.74 6.9 2.96 10.98-85.07 15.52Zm59.01-6.7 27.34-4.99 3.96 8.73-31.52 12.27.23-16.01h-.01Zm32.95 7.39 1.07 2.36-56.51 56.66-22.49-28.68 77.93-30.34ZM781.16 518.89l-44.39-55.02 60.54-26.42 18.96-7.38 23.53 30.02-58.65 58.8h.01Zm44.64-39.09 75.34-75.54 5.81 6.59-15.83 49.04-25.65-14.08 24.47 17.76-39.86 123.51-24.26-107.28h-.02Zm54 28.17c11.08 13.16 22.46 27.23 24.28 30.49-.38 2.03-.33 6.71 0 18.2.18 6.19.46 13.98.84 23.23l-18.21-28.76-24.72 12.02 17.81-55.17v-.01Zm-11.94 345.78-54.61-27.29 16.91-64.7 45.54 47.47-7.83 44.52h-.01Zm8.69-49.4-45.21-47.13 18.46-70.63 41 36.76-14.25 81ZM829.69 663.2l30.6-94.79 24.95-12.13 20.01 31.61c.11 2.54.22 5.16.34 7.88 1.18 26.71 2.56 53.69 2.71 56.46l-12.61 70.15-66-59.17v-.01Zm106.95 95.88-37.45-33.57 13.13-73.03v-.23c-2.24-43.12-5.24-108.79-4.33-112.99-.05.24-.37.94-1.2 1.22l1.35-1.43c.36-1.29.6-2.14-13.79-19.78-5.53-6.77-11.15-13.47-13.1-15.78l29.15-90.32 13.84 1.93 12.4 343.99v-.01Zm58.92-107.19-56.45 64.46-3.35-92.86 28.39 16.56h27.44l3.97 11.83v.01Zm3.59-1.85-4.69-13.97h-29.23l-29.64-17.31-2.01-55.66 64.23-16.12 21.55 99.02-20.21 4.04Zm92.68 18 .23.4 42.37 28.64 32.49 59.17-130.62-26.35-1.78-32.93v-.16l-15.93-73.15 33.13-25.24 40.11 69.61v.01Zm-42.12-73.11-32.05 24.42-28-128.62 60.05 104.2Zm-32.96-140.87-16.32 14.96 18.69-12.16 23.36 27.52-40.54 19.68-26-45.11 24.09-24.55 16.7 19.67.02-.01Zm-6.19-13.47-33.73-39.73.14-.08 7.35-15.65 62.73 7.56-14.07 29.59-22.42 18.31Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#H)",
                d: "m797.021 117.589-81.011 27.216c-9.46 3.178-14.552 13.423-11.374 22.883 3.178 9.461 13.423 14.553 22.884 11.375l81.01-27.216c9.46-3.178 14.553-13.423 11.375-22.884-3.179-9.46-13.424-14.552-22.884-11.374Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9964DF",
                d: "M803.94 139.99a5.65 5.65 0 1 0-.001-11.301 5.65 5.65 0 0 0 .001 11.301Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#fff",
                d: "m921.38 417.41 13.18-26.51 26.51 13.18 17.81-35.82-26.51-13.18 13.18-26.51-35.82-17.8-13.18 26.51-26.51-13.18-17.8 35.82 26.51 13.18-13.18 26.51 35.82 17.8h-.01Zm-162.83 54.7 13.18-26.51 26.51 13.18 17.8-35.82-26.51-13.18 13.18-26.51-35.82-17.8-13.18 26.51-26.51-13.18-17.8 35.82 26.51 13.18-13.18 26.51 35.82 17.8Zm159.83 140.33c-.14.05-.3.1-.45.15-75.92 25.7-109.61 87.75-118.12 106.15l36.3 16.8c6.82-14.75 33.82-64.47 94.65-85.06l.36-.12c61.07-20.52 112.76 2.88 127.16 10.55l18.8-35.31c-17.98-9.57-82.47-38.77-158.7-13.16Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#F6F6F6",
                d: "M1069.93 622.03c-1.88-.88-3.95-1.82-6.23-2.79l8.71 15.11 2.22-4.16-4.7-8.16ZM831.77 670.44l14.67 13.15-13.22 50.61 2.89 1.34c.52-1.13 1.18-2.48 1.94-3.99l11.75-44.95 11.71 10.5c.87-.99 1.76-1.98 2.67-2.98l-29.73-26.65c-.91.99-1.8 1.99-2.67 2.98l-.01-.01ZM1023.82 647.69l-5.23-24.02 18.17-13.84c-1.6-.44-3.24-.87-4.9-1.29l-14.2 10.82-3.14-14.43c-1.39-.23-2.81-.45-4.24-.65l9.08 41.73-1.37.27c1.99.45 3.94.92 5.83 1.41ZM908.3 652.23l-1.56 8.68c1.47-.79 2.96-1.56 4.48-2.31l1.1-6.12v-.23c-.6-11.28-1.23-24.11-1.84-36.97-1.32.51-2.63 1.03-3.92 1.56.87 18.37 1.64 33.37 1.74 35.39ZM937.41 324.23l2.3-8.49-3.65-1.82-2.99 11.05-10.02 1.73-.33-1.86-3.63 7.31.11-.04-1.4 19.1-11.7-13.65 5.99-2.49-4.75-2.36-4.72 1.96-10.06-9.31-2.52-1.25-1.49 2.99 11.24 10.4-3.71 5.12-11.96-6.61-1.78 3.59 11.96 6.61-5.96 20.82-2.08-.13 7.58 3.77 22.64-4.64-.82 8.46-20.03 7.98-.22-1.23-.23.04-.18-.65-2.6 5.22.09-.02 3.96 8.73-10.39 4.04-.49 1 3.94 1.96 8.6-3.35 1.07 2.36-3.86 3.87 3.78 1.88 2.05-2.06 4.83 5.48 7.83 3.89 8.85 1.23 1.88-3.78-12.21-1.7 14.71-17.99 4.51 5.6 1.96-3.94-3.31-4.11 22.97-10.92 19 3.77 1.85-3.71-19.78-3.93-.31-.57 9.62-12.95-3.64-1.81-8.06 10.86-10.18-19.12 17.09-8.26 2.91-5.85-23.49 11.36-4.48 1.51 2.71-20.84 8.78-1.51 1.82.96.42-.8 16.35 5.08 1.8-3.62-.07-.03-.87-.27.13-.1-3.98-1.98-.81.63-10.65-3.31 1.26-2.39-3.58-1.78-1.88 3.56-7.67 1.32-.05-.01Zm-38.93 21.89 4.44-6.13 11.37 13.27-17-2.98 1.19-4.17v.01Zm-5.93 20.73 3.63-12.69 21.09 3.69-.39 4.02-24.33 4.98Zm16.44 40.28-5.07-5.75-6.88-15.17 19.81-7.9 7.61 9.88-15.48 18.94h.01Zm17.27-23.17-6.67-8.65 1.39-14.25.1.12.11-1.56 12.29 7.54-7.22 16.8Zm4.16.44 6.5-15.13 11.05 6.78-17.55 8.35Zm7.5-32.31 10.36 19.46-24.15-14.83 13.79-4.63Zm-8.49-1.36-7.78 2.61 1.66-22.62 8.93-1.54-2.81 21.54v.01ZM936.66 648.6l-.91-25.11 28.39 16.56h27.44l.82 2.47c1.46.1 2.91.22 4.34.35l-2.29-6.81h-29.23l-29.64-17.31-.4-11.16c-1.32.32-2.64.65-3.97 1l1.49 41.25c1.32-.43 2.64-.86 3.96-1.25v.01ZM769.82 449.45l1.91-3.84 3.22 1.6 22.36-9.76 14.29-5.56 2.65-5.32-18.46 7.19-60.92 26.58 4.67 2.32 30.28-13.21ZM794.09 400.61l-74.49 19.08 5.48 2.73 66.66-17.08 2.35-4.73Z"
            }),
            (0, $4vwom.jsxs)("defs", {
                children: [
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "f",
                        x1: 857.44,
                        x2: 857.44,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "g",
                        x1: 741.96,
                        x2: 741.96,
                        y1: 881.54,
                        y2: 1010.31,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "h",
                        x1: 1166.9,
                        x2: 1166.9,
                        y1: 911.771,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "i",
                        x1: 1529.76,
                        x2: 1529.76,
                        y1: 932.661,
                        y2: 1061.42,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "j",
                        x1: 1229.49,
                        x2: 1229.49,
                        y1: 896.24,
                        y2: 960.62,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "k",
                        x1: 1412.26,
                        x2: 1412.26,
                        y1: 896.24,
                        y2: 960.62,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "l",
                        x1: 1653.82,
                        x2: 1653.82,
                        y1: 903.199,
                        y2: 967.58,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "m",
                        x1: 1786.73,
                        x2: 1786.73,
                        y1: 920.28,
                        y2: 984.66,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "n",
                        x1: 1054.52,
                        x2: 1054.52,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "o",
                        x1: 905.96,
                        x2: 905.96,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "p",
                        x1: 630.8,
                        x2: 630.8,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "q",
                        x1: 210.43,
                        x2: 210.43,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "r",
                        x1: 79.74,
                        x2: 79.74,
                        y1: 983.77,
                        y2: 1112.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "s",
                        x1: 19.39,
                        x2: 19.39,
                        y1: 919.36,
                        y2: 1015.47,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "t",
                        x1: 350.87,
                        x2: 350.87,
                        y1: 937.93,
                        y2: 1024.4,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "u",
                        x1: 665.44,
                        x2: 665.44,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "v",
                        x1: 996.78,
                        x2: 996.78,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "w",
                        x1: 1157.72,
                        x2: 1157.72,
                        y1: 911.769,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "x",
                        x1: 1317.96,
                        x2: 1317.96,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "y",
                        x1: 573.39,
                        x2: 573.39,
                        y1: 911.771,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "z",
                        x1: 1440.7,
                        x2: 1440.7,
                        y1: -858.58,
                        y2: 472.99,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#D6BDF4"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B087E9"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "A",
                        x1: 1805.7,
                        x2: 1378.78,
                        y1: 889.87,
                        y2: 392.93,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#A776E5"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B489EA"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "E",
                        x1: 193.05,
                        x2: 586.09,
                        y1: 259.45,
                        y2: 769.94,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#D8BFF6"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B087E9"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "F",
                        x1: 971.436,
                        x2: 833.865,
                        y1: 63.871,
                        y2: 792.783,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#D6BDF4"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B087E9"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "H",
                        x1: 854.248,
                        x2: 667.761,
                        y1: 117.425,
                        y2: 180.077,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#B489EA"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#9B64E1"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "a",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(302.497 0 0 41.855 1539.79 985.001)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E9E4E0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0.03
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "b",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(213.954 0 0 10.4137 1508.18 979.989)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#DAD3CF"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(213.954 0 0 10.4137 1508.18 979.989)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E9E4E0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0.03
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "d",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(429.965 0 0 41.855 930.862 817.04)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E9E4E0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0.03
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "e",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(302.498 0 0 41.855 482.756 817.04)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E9E4E0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0.03
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "B",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(213.954 0 0 10.4137 874.339 979.989)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#DAD3CF"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "C",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(213.954 0 0 10.4137 497.8 979.989)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E9E4E0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "D",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(213.954 0 0 10.4137 497.8 889.415)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#DAD3CF"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "G",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(-18.57 1571.958 -2650.385) scale(304.52)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#CAABF0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#fff",
                                stopOpacity: 0
                            })
                        ]
                    })
                ]
            })
        ]
    }));



var $dUDPg = parcelRequire("dUDPg");
function $047f6f355e30d7d1$var$useCurrentPhoneOffer() {
    return (0, $eK8Q4.useSessionState)("offer", undefined);
}
function $047f6f355e30d7d1$export$5b1a6a2d762c097c() {
    return (0, $eK8Q4.useSessionState)("currentPhoneOfferOptions", undefined);
}
function $047f6f355e30d7d1$export$d42da32bb85d5739() {
    return (0, $eK8Q4.useSessionState)("checkoutTradeInForm", undefined);
}
function $047f6f355e30d7d1$export$b7eadabbf1e81c9b() {
    return (0, $eK8Q4.useSessionState)("checkoutTradeInPriceRequest", undefined);
}
function $047f6f355e30d7d1$export$db65bad7d1fa5d6f() {
    return (0, $eK8Q4.useSessionState)("checkoutTradeInResult", undefined);
}
function $047f6f355e30d7d1$var$useCurrentShippingOption() {
    return (0, $eK8Q4.useSessionState)("shippingOption", undefined);
}
function $047f6f355e30d7d1$export$4a755370e8335b36() {
    return (0, $eK8Q4.useSessionState)("checkoutShippingState", {
        options: [],
        selectedOption: undefined,
        form: undefined
    });
}
function $047f6f355e30d7d1$export$7643def88ccd06be() {
    return (0, $eK8Q4.useSessionState)("checkoutState", {
        id: (0, $dAwef.Uuid)(),
        currentStep: "TradeIn",
        availableSteps: [],
        marketingAccepted: false,
        termsAccepted: false
    });
}
/**
 * Used to store whether or not user need to log in during checkout flow. Is set based on
 * login state when the checkout flow is entered.
 */ function $047f6f355e30d7d1$var$useCheckoutSkipAuthStep() {
    return (0, $eK8Q4.useSessionState)("checkoutSkipAuthStep", undefined);
}
function $047f6f355e30d7d1$var$useCheckoutCalculatedOrderPrice() {
    return (0, $eK8Q4.useSessionState)("checkoutCalculatedOrderPrice", undefined);
}
function $047f6f355e30d7d1$export$800784442c3f48f8() {
    const [offer, setOffer] = $047f6f355e30d7d1$var$useCurrentPhoneOffer();
    const [, setShippingOption] = $047f6f355e30d7d1$var$useCurrentShippingOption();
    const [, setCheckoutState] = $047f6f355e30d7d1$export$7643def88ccd06be();
    const [, setCurrentTradeInStep] = (0, $eK8Q4.useSessionState)("tradein-modal-step", undefined);
    const id = (0, $dAwef.Uuid)();
    const [, setTradeInResponses] = (0, $eK8Q4.useSessionState)("tradein-responses", []);
    const [, setTradeInResult] = (0, $eK8Q4.useSessionState)("tradein-result", undefined);
    const [, setTradeInModalOpen] = (0, $eK8Q4.useSessionState)("tradein-modal-open", false);
    const [, setSkipAuthStep] = $047f6f355e30d7d1$var$useCheckoutSkipAuthStep();
    const [, setShippingState] = $047f6f355e30d7d1$export$4a755370e8335b36();
    const [, setCheckoutTradeInForm] = $047f6f355e30d7d1$export$d42da32bb85d5739();
    const [, setCheckoutTradeInPriceRequest] = $047f6f355e30d7d1$export$b7eadabbf1e81c9b();
    const [, setCheckoutTradeInResult] = $047f6f355e30d7d1$export$db65bad7d1fa5d6f();
    const [, , resetConsents] = $047f6f355e30d7d1$export$5a952ffba9a79dc5();
    return [
        offer,
        (phoneOffer)=>{
            setCheckoutState({
                id: id,
                currentStep: "TradeIn",
                availableSteps: [
                    "TradeIn"
                ],
                marketingAccepted: false,
                termsAccepted: false
            });
            setOffer(phoneOffer);
            setShippingState({});
            setCurrentTradeInStep(0);
            setTradeInResponses([]);
            setTradeInResult(undefined);
            setTradeInModalOpen(false);
            setShippingOption(undefined);
            setSkipAuthStep(undefined);
            setCheckoutTradeInForm(undefined);
            setCheckoutTradeInPriceRequest(undefined);
            setCheckoutTradeInResult(undefined);
            resetConsents();
        }
    ];
}
function $047f6f355e30d7d1$export$5a952ffba9a79dc5() {
    const [consents, setConsents] = (0, $eK8Q4.useSessionState)("checkout-consents", {
        marketing: {
            consentGiven: false,
            preConsented: undefined
        }
    });
    const getFromUser = (0, $eeH7J.useCallback)(()=>{
        if (consents.marketing.preConsented === undefined) (0, $e18f565b44c7bc7d$export$dd7946daa6163e94)().then((result)=>{
            setConsents({
                marketing: {
                    consentGiven: !!result.marketingConsent,
                    preConsented: !!result.marketingConsent
                }
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eeH7J.useEffect)(()=>{
        getFromUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        consents,
        (val)=>{
            setConsents(val);
            (0, $e18f565b44c7bc7d$export$97519be7b2793f54)({
                consent: val.marketing.consentGiven
            });
        },
        ()=>{
            setConsents({
                marketing: {
                    consentGiven: false,
                    preConsented: undefined
                }
            });
            getFromUser();
        }
    ];
}
function $047f6f355e30d7d1$export$cba61477bceac75() {
    const [order, setOrder] = (0, $eK8Q4.useSessionState)("CheckoutOrder", undefined);
    const [errorMessage, setErrorMessage] = (0, $eeH7J.useState)();
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const ensureOrder = (0, $eeH7J.useCallback)(async (orderRequest)=>{
        if (isLoading) return;
        setIsLoading(true);
        // If the phone is unchanged, check if current order exists. If the order doesn't
        // exist anymore, or we want an order for a different phone, we'll try to create
        // a new order below.
        if (order && order.phone.id === orderRequest.phone.id) try {
            const o = await (0, $e18f565b44c7bc7d$export$b2d4561583563d44)(order.id);
            setOrder(o);
            setIsLoading(false);
            return;
        } catch (err) {
        // Order does not exist any more and is expired, will try to create new one
        // below, so no further error handling is needed.
        }
        // Create new order, based on the config.
        try {
            const postOrderResult = await (0, $e18f565b44c7bc7d$export$6cb3fb5ed3274c4c)(orderRequest);
            const getOrderResult = await (0, $e18f565b44c7bc7d$export$b2d4561583563d44)(postOrderResult.id);
            if (getOrderResult.id !== (order === null || order === void 0 ? void 0 : order.id)) setOrder(getOrderResult);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            setErrorMessage(JSON.stringify(err));
            throw err;
        } finally{
            setIsLoading(false);
        }
    }, [
        isLoading,
        order,
        setOrder
    ]);
    const deleteOrder = (0, $eeH7J.useCallback)(async ()=>{
        if (order === null || order === void 0 ? void 0 : order.id) try {
            await (0, $e18f565b44c7bc7d$export$a2c4756bb6719a7)(order.id);
        } catch (err) {
        // If this fails it is most likely because of an order id that should not have been
        // set anyway. It was probably deleted server side because of reservation
        // expiration set in order settings. So no more handling than just unsetting the
        // order, which we'll also do if the request succeeds.
        } finally{
            setOrder(undefined);
        }
    }, [
        order === null || order === void 0 ? void 0 : order.id,
        setOrder
    ]);
    return {
        order: order,
        ensureOrder: ensureOrder,
        deleteOrder: deleteOrder,
        isLoading: isLoading,
        errorMessage: errorMessage
    };
}
function $047f6f355e30d7d1$var$Checkout(section) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const localize = (0, $aIeEI.useLocalize)();
    const [searchParams, setSearchParams] = (0, $5K1mb.useSearchParams)();
    const [phoneOfferOptions] = $047f6f355e30d7d1$export$5b1a6a2d762c097c();
    const tradeInForm = (0, $e18f565b44c7bc7d$export$f8778ca18805596d)("Phones");
    const webPageContext = (0, $eeH7J.useContext)((0, $9fe8ccb750b589bb$export$6245f31671de0b04));
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const localizeCurrency = (0, $b274814d74f89bd0$export$2daf9f30efa60400)();
    const [checkoutState, setCheckoutState] = $047f6f355e30d7d1$export$7643def88ccd06be();
    const [offer, setOffer] = $047f6f355e30d7d1$var$useCurrentPhoneOffer();
    const [checkoutTradeInForm, setCheckoutTradeInForm] = $047f6f355e30d7d1$export$d42da32bb85d5739();
    const [checkoutTradeInPriceRequest] = $047f6f355e30d7d1$export$b7eadabbf1e81c9b();
    const [checkoutTradeInResult] = $047f6f355e30d7d1$export$db65bad7d1fa5d6f();
    const [shipping, setShipping] = $047f6f355e30d7d1$export$4a755370e8335b36();
    const [checkoutShippingState] = $047f6f355e30d7d1$export$4a755370e8335b36();
    const [skipAuthStep, setSkipAuthStep] = $047f6f355e30d7d1$var$useCheckoutSkipAuthStep();
    const currentStep = (0, $eeH7J.useMemo)(()=>checkoutState.currentStep, [
        checkoutState.currentStep
    ]);
    const setCurrentStep = (0, $eeH7J.useCallback)((s)=>{
        setCheckoutState(Object.assign(Object.assign({}, checkoutState), {
            currentStep: s
        }));
    }, [
        checkoutState,
        setCheckoutState
    ]);
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    // Need a way to determine if the page is rendered client side and checkout state should be
    // available, so that an error can be presented if checkout state is missing.
    const [offerShouldBeLoaded, setOfferShouldBeLoaded] = (0, $eeH7J.useState)(false);
    (0, $eeH7J.useEffect)(()=>{
        setOfferShouldBeLoaded(true);
    }, []);
    const { order: order, ensureOrder: ensureOrder, deleteOrder: deleteOrder, isLoading: isLoading, errorMessage: errorMessage } = $047f6f355e30d7d1$export$cba61477bceac75();
    // Don't request updated price if we have an order, as it will result in not found error.
    const price = (0, $e18f565b44c7bc7d$export$541c7c1cebe5b937)(offer && !(order === null || order === void 0 ? void 0 : order.id) ? {
        phone: offer,
        shippingType: (_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type,
        shippingSlot: ((_b = shipping.selectedOption) === null || _b === void 0 ? void 0 : _b.type) === "Manual" ? (_c = shipping.selectedOption.selectedSlot) === null || _c === void 0 ? void 0 : _c.id : undefined,
        tradeIn: checkoutTradeInPriceRequest
    } : null);
    const [calculatedOrderPrice, setCalculatedOrderPrice] = $047f6f355e30d7d1$var$useCheckoutCalculatedOrderPrice();
    (0, $eeH7J.useEffect)(()=>{
        if (price.data && JSON.stringify(price.data) !== JSON.stringify(calculatedOrderPrice)) setCalculatedOrderPrice(price.data);
    }, [
        calculatedOrderPrice,
        price.data,
        setCalculatedOrderPrice
    ]);
    const currentStepBySearchParam = (0, $eeH7J.useMemo)(()=>{
        const stepParam = searchParams.get("s");
        const s = Object.keys((0, $c90be680bf4410a3$export$68c0e99bc234a4d)).find((k)=>{
            const stepProps = section[k];
            return localize(stepProps.slug) === stepParam;
        });
        return s;
    }, [
        localize,
        searchParams,
        section
    ]);
    // Sets the step search param "s" to the slug defined for the provided CheckoutStep.
    const setSearchParamStep = (0, $eeH7J.useCallback)((s, options)=>{
        const sp = Object.fromEntries(searchParams);
        delete sp.auth;
        setSearchParams(Object.assign(Object.assign({}, sp), {
            s: localize(section[s].slug)
        }), options);
    }, [
        localize,
        searchParams,
        section,
        setSearchParams
    ]);
    // If changing step to a different step than Payment, delete the order to be able
    // to modify it and get updated prices from usePhoneOrderPrice.
    (0, $eeH7J.useEffect)(()=>{
        if (currentStep !== "Payment" && (order === null || order === void 0 ? void 0 : order.id)) deleteOrder();
    }, [
        currentStep,
        deleteOrder,
        order === null || order === void 0 ? void 0 : order.id
    ]);
    const postAnalyticsCheckoutEvent = (0, $eeH7J.useCallback)(async (entity, data)=>{
        var _a, _b;
        (0, $dUDPg.postAnalyticsEvent)("checkout", {
            entity: entity,
            data: data
        }, // Override default Fuse Analytics session id with the current checkout id,
        // to get a unique Fuse Analytics session per checkout and not mixed with other
        // checkouts from same user during the same "user session".
        {
            "Fuse-Analytics-Session": (_b = (_a = checkoutState.id) === null || _a === void 0 ? void 0 : _a.valueOf()) !== null && _b !== void 0 ? _b : ""
        });
    }, [
        checkoutState.id
    ]);
    // It appears that it is a good idea to both set the step and update the search param, rather
    // than setting search param and relying on the effect to set current step by search param,
    // so use this function to set step.
    const setStep = (0, $eeH7J.useCallback)((s, options)=>{
        var _a, _b;
        setCurrentStep(s);
        setSearchParamStep(s, options);
        if (!checkoutState.availableSteps.includes(s)) setCheckoutState(Object.assign(Object.assign({}, checkoutState), {
            availableSteps: [
                ...checkoutState.availableSteps,
                s
            ]
        }));
        // Ensure page is scrolled to top after changing step.
        if (typeof window !== "undefined") window.scrollTo({
            top: 0,
            behavior: "instant"
        });
        postAnalyticsCheckoutEvent([
            "step",
            s.toLowerCase(),
            "enter"
        ], {
            userId: (_b = (_a = me.data) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.valueOf(),
            phoneId: offer === null || offer === void 0 ? void 0 : offer.id.valueOf(),
            rentalPeriod: offer === null || offer === void 0 ? void 0 : offer.rentalPeriod.toString()
        });
    }, [
        checkoutState,
        (_d = me.data) === null || _d === void 0 ? void 0 : _d.id,
        offer === null || offer === void 0 ? void 0 : offer.id,
        offer === null || offer === void 0 ? void 0 : offer.rentalPeriod,
        postAnalyticsCheckoutEvent,
        setCheckoutState,
        setCurrentStep,
        setSearchParamStep
    ]);
    // When first entering the checkout flow, the search param "s" might not be set. This effect
    // sets the param as a replacement, to ensure back button takes the user back to the previous
    // page and not checkout without the "s" search param.
    (0, $eeH7J.useEffect)(()=>{
        const auth = searchParams.get("auth");
        if (auth === "success") {
            postAnalyticsCheckoutEvent([
                "step",
                "login",
                "success"
            ]);
            setStep("Shipping");
        } else if (auth === "failed") {
            postAnalyticsCheckoutEvent([
                "step",
                "login",
                "failed"
            ]);
            setStep("Login");
        } else if (!currentStepBySearchParam && !webPageContext.isNavigating) setStep("TradeIn", {
            replace: true
        });
    }, [
        checkoutState.id,
        currentStepBySearchParam,
        postAnalyticsCheckoutEvent,
        searchParams,
        setStep,
        webPageContext.isNavigating
    ]);
    // Effect to keep current step up to date with the step defined by the step search param "s".
    (0, $eeH7J.useEffect)(()=>{
        if (currentStepBySearchParam && currentStepBySearchParam !== currentStep) setCurrentStep(currentStepBySearchParam);
    }, [
        currentStepBySearchParam,
        setCurrentStep,
        currentStep
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (skipAuthStep === undefined) {
            async function setSkipAuthIfLoggedIn() {
                const checkMe = await (0, $e18f565b44c7bc7d$export$dd7946daa6163e94)();
                setSkipAuthStep(checkMe.canSkipLoginInCheckout);
            }
            setSkipAuthIfLoggedIn();
        }
    }, [
        skipAuthStep,
        setSkipAuthStep
    ]);
    const insuranceOptions = (0, $e18f565b44c7bc7d$export$fd8b73cd610fc548)((_e = offer === null || offer === void 0 ? void 0 : offer.model) !== null && _e !== void 0 ? _e : null, (_f = offer === null || offer === void 0 ? void 0 : offer.storage) !== null && _f !== void 0 ? _f : null, (_g = offer === null || offer === void 0 ? void 0 : offer.color) !== null && _g !== void 0 ? _g : null, (_h = offer === null || offer === void 0 ? void 0 : offer.rentalPeriod) !== null && _h !== void 0 ? _h : null);
    const purchasedInsurance = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (offer === null || offer === void 0 ? void 0 : offer.insurance) ? (_a = insuranceOptions.data) === null || _a === void 0 ? void 0 : _a.find((io)=>io.id === offer.insurance) : null;
    }, [
        insuranceOptions.data,
        offer === null || offer === void 0 ? void 0 : offer.insurance
    ]);
    const deviceCheckoutCardInfoItems = (0, $eeH7J.useMemo)(()=>{
        var _a, _b, _c, _d;
        const infoItems = [];
        if (offer) {
            const ii = {
                id: "device",
                icon: "device",
                title: localize(offer.name),
                text: [
                    localize((_b = (_a = phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.colors.find((c)=>c.name === offer.color)) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : {}),
                    localize((_d = (_c = phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.storageSizes.find((ss)=>ss.name === offer.storage)) === null || _c === void 0 ? void 0 : _c.displayName) !== null && _d !== void 0 ? _d : {}),
                    `${offer.rentalPeriod} ${localize({
                        no: "m\xe5neder",
                        en: "months"
                    })}`
                ].join(" \xb7 ")
            };
            infoItems.push(ii);
        }
        if (checkoutTradeInPriceRequest && checkoutTradeInResult) {
            const ii = {
                id: "trade-in",
                icon: "handCoins",
                title: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.CheckoutDeviceCard.tradeInInfoItem.title), {
                    cashback: formatAmount(checkoutTradeInResult.value)
                }),
                text: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.CheckoutDeviceCard.tradeInInfoItem.text), {
                    monthlyDiscount: formatAmount(checkoutTradeInResult.monthlyDiscount),
                    discountPeriod: `${checkoutTradeInResult.months.valueOf()}`
                })
            };
            infoItems.push(ii);
        }
        if ((offer === null || offer === void 0 ? void 0 : offer.insurance) && (calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.insurance) && purchasedInsurance) {
            const ii = {
                id: "protection-plan",
                icon: "shield",
                title: localize(section.CheckoutDeviceCard.insuranceInfoItem.title),
                text: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.CheckoutDeviceCard.insuranceInfoItem.text), {
                    insuranceName: localize(purchasedInsurance.displayName),
                    amount: `${formatAmount(calculatedOrderPrice.monthlyCost.insurance)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`
                })
            };
            infoItems.push(ii);
        }
        if (checkoutShippingState.selectedOption && checkoutShippingState.form) {
            const ii = {
                id: "shipping",
                icon: "truck",
                title: localize(checkoutShippingState.selectedOption.name),
                text: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(!checkoutShippingState.selectedOption.cost.valueOf() && section.CheckoutDeviceCard.shippingInfoItem.freeShippingText ? localize(section.CheckoutDeviceCard.shippingInfoItem.freeShippingText) : localize(section.CheckoutDeviceCard.shippingInfoItem.text), {
                    shippingPrice: formatAmount({
                        minorUnits: checkoutShippingState.selectedOption.cost * 10,
                        majorUnits: checkoutShippingState.selectedOption.cost,
                        currency: "NOK"
                    }),
                    shippingName: localize(checkoutShippingState.selectedOption.name),
                    shippingDescription: localize(checkoutShippingState.selectedOption.description)
                })
            };
            infoItems.push(ii);
        }
        return infoItems;
    }, [
        calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.insurance,
        checkoutShippingState,
        checkoutTradeInPriceRequest,
        checkoutTradeInResult,
        formatAmount,
        localize,
        offer,
        phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.colors,
        phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.storageSizes,
        purchasedInsurance,
        section.CheckoutDeviceCard.insuranceInfoItem.text,
        section.CheckoutDeviceCard.insuranceInfoItem.title,
        section.CheckoutDeviceCard.shippingInfoItem.freeShippingText,
        section.CheckoutDeviceCard.shippingInfoItem.text,
        section.CheckoutDeviceCard.tradeInInfoItem.text,
        section.CheckoutDeviceCard.tradeInInfoItem.title
    ]);
    const checkoutNavigationInclStepName = (0, $eeH7J.useMemo)(()=>(0, $c90be680bf4410a3$export$c81bc4f691c81d42).map((cn)=>Object.assign(Object.assign({}, cn), {
                name: localize(section[cn.id].name),
                isAvailable: checkoutState.availableSteps.includes(cn.id)
            })), [
        checkoutState.availableSteps,
        localize,
        section
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (tradeInForm.data && !checkoutTradeInForm) setCheckoutTradeInForm(tradeInForm.data);
    }, [
        checkoutTradeInForm,
        setCheckoutTradeInForm,
        tradeInForm.data
    ]);
    if (offerShouldBeLoaded && !offer) return (0, $4vwom.jsx)((0, $b97c03a91b0e5a47$export$c120a0e80fd44ca6), {});
    if (!offer || skipAuthStep === undefined || me.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    // If current step is not up to date with search param step, wait with rendering until they
    // are aligned to prevent flash of incorrect step.
    if (currentStepBySearchParam !== currentStep) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    const StepContent = (0, $c90be680bf4410a3$export$68c0e99bc234a4d)[currentStep];
    return (0, $4vwom.jsxs)((0, $c90be680bf4410a3$export$5558864fbda6a534).Provider, {
        value: {
            props: {
                TradeIn: section.TradeIn,
                Insurance: section.Insurance,
                Login: section.Login,
                Shipping: section.Shipping,
                Payment: section.Payment,
                SoldOut: section.SoldOut
            },
            insuranceOptions: insuranceOptions,
            skipAuthStep: skipAuthStep,
            offer: offer,
            setOffer: setOffer,
            shipping: shipping,
            setShipping: setShipping,
            price: calculatedOrderPrice,
            step: currentStep,
            setStep: setStep,
            checkoutState: checkoutState,
            setCheckoutState: setCheckoutState,
            postAnalyticsCheckoutEvent: postAnalyticsCheckoutEvent,
            useOrder: ()=>({
                    order: order,
                    ensureOrder: ensureOrder,
                    deleteOrder: deleteOrder,
                    isLoading: isLoading,
                    errorMessage: errorMessage
                })
        },
        children: [
            (0, $4vwom.jsx)((0, $lhaLc.Global), {
                styles: {
                    body: {
                        backgroundColor: (0, $06eb0d21a8b1f440$export$8f45430ccf837300).gray100
                    }
                }
            }),
            (0, $4vwom.jsxs)("div", {
                css: (0, $lhaLc.css)({
                    display: "grid",
                    gridTemplateAreas: '"logo" "progress" "content" "device"',
                    gap: 16,
                    paddingTop: 16,
                    marginBottom: 16
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    gridTemplateAreas: '"progress logo" "content device"',
                    gridTemplateColumns: "1fr 0.68fr",
                    gap: 24,
                    paddingTop: 24,
                    marginBottom: 24
                })),
                children: [
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 8,
                        style: {
                            gridArea: "logo",
                            minWidth: 0
                        },
                        justifyContent: "flex-end",
                        children: [
                            !section.Trustpilot.hide ? (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                css: (0, $lhaLc.css)({
                                    height: (0, $756948b644e82cf2$export$981516ee4691055c)(48),
                                    borderRadius: 100
                                }),
                                alignItems: "center",
                                padding: {
                                    left: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                                    right: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                                },
                                gap: 8,
                                backgroundColor: "grayWhite",
                                children: [
                                    typeof section.Trustpilot.rating !== "undefined" ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 4,
                                        children: section.Trustpilot.rating
                                    }) : null,
                                    (0, $4vwom.jsx)((0, $34f1974b2dd65db4$export$7998e98dfdedb157), {})
                                ]
                            }) : null,
                            (0, $4vwom.jsx)((0, $df8c0007eabe8257$export$45c9c5c7ee057bfb), {
                                style: {
                                    height: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                                }
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            gridArea: "progress",
                            minWidth: 0
                        },
                        children: (0, $4vwom.jsx)((0, $c4ee9fc699106494$export$2a0ca3f7657e279), {
                            steps: skipAuthStep ? checkoutNavigationInclStepName.filter((s)=>s.id !== "Login") : checkoutNavigationInclStepName,
                            currentStep: currentStep
                        })
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            gridArea: "device",
                            minWidth: 0
                        },
                        children: offer.images && offer.images[0] ? (0, $4vwom.jsx)("div", {
                            style: {
                                position: "sticky",
                                top: 24
                            },
                            children: (0, $4vwom.jsx)((0, $6b5c692995a5ffa5$export$d175a07b9db3024e), {
                                subscription: {
                                    duration: offer.rentalPeriod,
                                    unit: "months"
                                },
                                checkout: {
                                    rentalPeriodCurrencyPeriodUnit: (calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.itemsTotal.currency) ? `${localizeCurrency(calculatedOrderPrice.monthlyCost.itemsTotal.currency)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}` : "",
                                    originalPrice: (_j = calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.itemsTotal.majorUnits) !== null && _j !== void 0 ? _j : 0,
                                    discountedPrice: (_k = calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.discountedTotal.majorUnits) !== null && _k !== void 0 ? _k : 0,
                                    monthlyTotalPriceLabel: localize(section.CheckoutDeviceCard.monthlyTotalPriceLabel),
                                    rentalPeriodTotalPriceText: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.CheckoutDeviceCard.rentalPeriodTotalPriceText), {
                                        rentalPeriod: `${offer.rentalPeriod.valueOf()} ${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                                        totalPrice: calculatedOrderPrice ? formatAmount(calculatedOrderPrice.rentalPeriodTotalPrice) : ""
                                    })
                                },
                                infoItems: deviceCheckoutCardInfoItems,
                                product: {
                                    image: offer.images[0],
                                    color: localize((_m = (_l = phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.colors.find((c)=>c.name === offer.color)) === null || _l === void 0 ? void 0 : _l.displayName) !== null && _m !== void 0 ? _m : {}),
                                    storageSize: localize((_p = (_o = phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.storageSizes.find((ss)=>ss.name === offer.storage)) === null || _o === void 0 ? void 0 : _o.displayName) !== null && _p !== void 0 ? _p : {})
                                }
                            })
                        }) : null
                    }),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        borderRadius: "lg",
                        backgroundColor: "grayWhite",
                        css: (0, $lhaLc.css)({
                            "--padding-x": "16px",
                            padding: "20px var(--padding-x)",
                            gridArea: "content",
                            minWidth: 0,
                            borderRadius: 16
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            "--padding-x": "80px",
                            padding: (0, $756948b644e82cf2$export$981516ee4691055c)(80)
                        })),
                        children: ((_q = me.data) === null || _q === void 0 ? void 0 : _q.orderLimitReached) ? (0, $4vwom.jsx)((0, $652a00d43f507d25$export$13d90034f51c5979), Object.assign({}, section.OrderLimitReached)) : price.error ? // Sure enough, there could be other reasons for price error, but let's
                        // assume it's sold out for now.
                        (0, $4vwom.jsx)((0, $440c4b5b9e7400e5$export$55aa795759f227b9), Object.assign({}, section.SoldOut)) : (0, $4vwom.jsx)(StepContent, Object.assign({}, section[currentStep]))
                    })
                ]
            })
        ]
    });
}
(0, $9G56J.Section)($047f6f355e30d7d1$var$Checkout);




var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");

var $7m9cQ = parcelRequire("7m9cQ");



var $eeH7J = parcelRequire("eeH7J");



function $3128e8049110e334$export$35bf746fc814fa9a(props) {
    const { colors: colors, responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const [currentIndex, setCurrentIndex] = (0, $eeH7J.useState)(0);
    const containerRef = (0, $eeH7J.useRef)(null);
    const scrollRef = (0, $eeH7J.useRef)(null);
    const imageRefs = (0, $eeH7J.useRef)([]);
    const imageRefsMap = (0, $eeH7J.useRef)(new Map());
    const handleIntersectionChange = (0, $eeH7J.useCallback)((entries)=>{
        const intersectingEntry = entries.find((entry)=>entry.isIntersecting);
        if (!intersectingEntry) return;
        for (const [key, value] of imageRefsMap.current.entries())if (value === intersectingEntry.target) {
            const index = props.images.findIndex((ir)=>ir.valueOf() === key);
            setCurrentIndex(index);
            break;
        }
    }, [
        setCurrentIndex,
        props.images
    ]);
    // Keep track of which image is the first image, to be able to only scroll into view if first
    // image has actually changed.
    const [firstImage, setFirstImage] = (0, $eeH7J.useState)();
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b, _c, _d, _e;
        const fi = (_a = props.images[0]) === null || _a === void 0 ? void 0 : _a.valueOf();
        if (fi && fi !== firstImage) {
            setFirstImage(fi);
            if (((_c = (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top) !== null && _c !== void 0 ? _c : 0) > window.scrollY) (_d = imageRefsMap.current.get(fi)) === null || _d === void 0 || _d.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
            else if ((_e = scrollRef.current) === null || _e === void 0 ? void 0 : _e.scrollLeft) scrollRef.current.scrollLeft = 0;
        }
    }, [
        firstImage,
        props.images
    ]);
    // Does not use props.images directly, but depend on it to update the observers whenever
    // props.images changes.
    (0, $eeH7J.useEffect)(()=>{
        const observer = new IntersectionObserver(handleIntersectionChange, {
            root: containerRef.current,
            // Reduce threshold to fire a little before the scroll is ended.
            threshold: 0.8
        });
        props.images.forEach((image)=>{
            const ir = imageRefsMap.current.get(image.valueOf());
            if (ir) observer.observe(ir);
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        handleIntersectionChange,
        containerRef,
        imageRefs,
        props.images
    ]);
    return (0, $4vwom.jsx)("div", {
        ref: containerRef,
        style: {
            flex: "1 1 auto",
            position: "relative",
            overflow: "hidden"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            elementRef: scrollRef,
            backgroundColor: "gray100",
            borderRadius: "md",
            padding: {
                top: 40,
                bottom: props.images.length > 1 ? 64 : 40
            },
            style: {
                overflowX: "scroll",
                scrollSnapType: "x mandatory",
                scrollbarWidth: "none",
                height: "100%",
                width: "100%"
            },
            css: (0, $lhaLc.css)`
                    &::-webkit-scrollbar {
                        display: none;
                    }
                `,
            children: [
                (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
                    transition: {
                        duration: 0.2
                    },
                    children: (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                        mode: "popLayout",
                        initial: false,
                        children: props.images.map((image, index)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                style: {
                                    display: "flex",
                                    flex: "1 0 100%",
                                    width: "100%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    scrollSnapAlign: "center"
                                },
                                children: (0, $4vwom.jsx)("div", {
                                    ref: (el)=>{
                                        if (el) imageRefsMap.current.set(image.valueOf(), el);
                                        else imageRefsMap.current.delete(image.valueOf());
                                    },
                                    style: {
                                        display: "flex",
                                        height: "100%",
                                        width: "100%",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        maxHeight: (0, $756948b644e82cf2$export$981516ee4691055c)(420),
                                        overflow: "hidden"
                                    },
                                    children: (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                        style: {
                                            width: "auto",
                                            height: "auto",
                                            maxWidth: "100%",
                                            maxHeight: "100%"
                                        },
                                        image: image,
                                        width: 304
                                    })
                                })
                            }, (0, $14q7s.ImageToUrl)(image)))
                    })
                }),
                props.images.length > 1 && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    style: {
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0
                    },
                    padding: 12,
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                    css: (0, $lhaLc.css)({
                        "--current-indicator-width": "16px"
                    }, responsiveCss("min", "md", {
                        "--current-indicator-width": "48px"
                    })),
                    children: (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                        initial: false,
                        children: props.images.map((image, index)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                initial: {
                                    width: 0,
                                    height: 0
                                },
                                animate: {
                                    height: 8,
                                    width: index === currentIndex ? "var(--current-indicator-width)" : 8,
                                    backgroundColor: index === currentIndex ? colors.gray500 : `${colors.gray500}66`
                                },
                                exit: {
                                    opacity: 0,
                                    width: 0,
                                    height: 0
                                },
                                css: (0, $lhaLc.css)({
                                    height: 8,
                                    borderRadius: 4,
                                    overflow: "hidden"
                                })
                            }, index))
                    })
                })
            ]
        })
    });
}
(0, $eSiQ2.Component)($3128e8049110e334$export$35bf746fc814fa9a, {
    name: "ProductCarousel",
    gallery: {
        path: "Carousel/Product",
        items: [
            {
                variants: [
                    {
                        props: {
                            images: [
                                `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image3.png`,
                                `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image4.png`
                            ]
                        },
                        render: (cmp)=>(0, $4vwom.jsx)("div", {
                                style: {
                                    width: 600
                                },
                                children: cmp
                            })
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eeH7J = parcelRequire("eeH7J");

var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");

var $7m9cQ = parcelRequire("7m9cQ");







function $be4b37daa90ce555$export$dc2f2ee2b949f61f(props) {
    const [modalIsOpen, setModalIsOpen] = (0, $eeH7J.useState)(false);
    if (props.compact) return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 8,
                alignItems: "center",
                borderRadius: "md",
                borderColor: "gray200",
                padding: 16,
                role: "button",
                onClick: ()=>setModalIsOpen(true),
                style: {
                    cursor: "pointer"
                },
                children: [
                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: "delivery"
                    }),
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        underline: true,
                        children: props.heading
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                isOpen: modalIsOpen,
                onClose: ()=>setModalIsOpen(false),
                header: {
                    title: props.heading,
                    closeButton: true,
                    icon: "delivery"
                },
                children: (0, $4vwom.jsx)($be4b37daa90ce555$var$BoxItems, {
                    items: props.items
                })
            })
        ]
    });
    return (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
        borderRadius: "md",
        borderColor: "gray200",
        padding: 24,
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 8,
                margin: {
                    bottom: 24
                },
                alignItems: "center",
                children: [
                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: "delivery"
                    }),
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 4,
                        children: props.heading
                    })
                ]
            }),
            (0, $4vwom.jsx)($be4b37daa90ce555$var$BoxItems, {
                items: props.items
            })
        ]
    });
}
function $be4b37daa90ce555$var$BoxItems(props) {
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)({
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 8,
            gridAutoRows: "1fr",
            width: "100%"
        }, helpers.responsiveCss("min", "sm", {
            gridTemplateColumns: "1fr 1fr"
        })),
        children: props.items.map((item, index)=>(0, $4vwom.jsx)($be4b37daa90ce555$var$BoxItem, Object.assign({}, item), `${index}${item.heading}`))
    });
}
function $be4b37daa90ce555$var$BoxItem(props) {
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        backgroundColor: "gray100",
        borderRadius: "sm",
        padding: 20,
        gap: 16,
        alignItems: "center",
        children: [
            (0, $4vwom.jsx)("img", {
                src: (0, $14q7s.ImageToUrl)(props.image),
                style: {
                    width: 32,
                    maxHeight: 40
                }
            }),
            (0, $4vwom.jsx)("div", {
                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                    variant: "body",
                    size: "md",
                    children: props.heading
                })
            })
        ]
    });
}
(0, $eSiQ2.Component)($be4b37daa90ce555$export$dc2f2ee2b949f61f, {
    name: "WhatsInTheBoxBlock",
    gallery: {
        path: "Blocks/WhatsInTheBoxBlock",
        items: [
            {
                variants: [
                    {
                        props: {
                            heading: "What\u2019s in the box?",
                            items: [
                                {
                                    heading: "Phone",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-phone.svg`
                                },
                                {
                                    heading: "Booklet",
                                    text: "Pellentesque quis erat id enim elementum molestie quis sit amet neque",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-booklet.svg`
                                },
                                {
                                    heading: "Protective case",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-case.svg`
                                },
                                {
                                    heading: "Charging cable",
                                    text: "Donec faucibus fermentum turpis, vitae pulvinar tortor semper non",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-chargingcable.svg`
                                },
                                {
                                    heading: "Redoit gurantee",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-redoitguarantee.svg`
                                },
                                {
                                    heading: "Screen protector",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-screenprotector.svg`
                                }
                            ]
                        }
                    }
                ]
            },
            {
                variants: [
                    {
                        props: {
                            heading: "What\u2019s in the box?",
                            compact: true,
                            items: [
                                {
                                    heading: "Phone",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-phone.svg`
                                },
                                {
                                    heading: "Booklet",
                                    text: "Pellentesque quis erat id enim elementum molestie quis sit amet neque",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-booklet.svg`
                                },
                                {
                                    heading: "Protective case",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-case.svg`
                                },
                                {
                                    heading: "Charging cable",
                                    text: "Donec faucibus fermentum turpis, vitae pulvinar tortor semper non",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-chargingcable.svg`
                                },
                                {
                                    heading: "Redoit gurantee",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-redoitguarantee.svg`
                                },
                                {
                                    heading: "Screen protector",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-screenprotector.svg`
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});








var $4vwom = parcelRequire("4vwom");
function $8e85e0d8eea1dda5$export$a98f0dcb43a68a25(props) {
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: props.options.map((o)=>(0, $4vwom.jsxs)("label", {
                style: {
                    position: "relative"
                },
                children: [
                    props.renderOption(o, props.value === o.value),
                    (0, $4vwom.jsx)("input", {
                        type: "radio",
                        checked: props.value === o.value,
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: "100%",
                            width: "100%",
                            opacity: "0",
                            zIndex: -1
                        },
                        onChange: (e)=>{
                            props.onChange(e, o.value);
                        }
                    })
                ]
            }, JSON.stringify(o.value)))
    });
}






var $4vwom = parcelRequire("4vwom");






function $c886ce39010e35d8$export$5c260416423351e0(props) {
    return (0, $4vwom.jsxs)("div", {
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                margin: {
                    bottom: "md"
                },
                children: props.heading
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                padding: "md",
                borderColor: "gray200",
                style: {
                    borderRadius: 16
                },
                children: props.items.map((item, index)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        children: [
                            index > 0 && (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: "md"
                            }),
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                size: 32,
                                icon: item.icon,
                                margin: {
                                    bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                                }
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "lg",
                                margin: {
                                    bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(8)
                                },
                                children: item.heading
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                color: "gray300",
                                children: item.text
                            })
                        ]
                    }, item.id))
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");






function $02316f5bb92deb21$export$4f8c96a4412d9797(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        as: "section",
        direction: "column",
        gap: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: props.heading
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: [
                    8,
                    [
                        "min",
                        "md",
                        12
                    ]
                ],
                children: props.items.map((item, index)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 24,
                        backgroundColor: "gray100",
                        padding: "md",
                        style: {
                            borderRadius: 16
                        },
                        alignItems: "center",
                        children: [
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                backgroundColor: "gray500",
                                alignItems: "center",
                                justifyContent: "center",
                                style: {
                                    flexShrink: 0,
                                    color: colors.grayWhite,
                                    borderRadius: 100
                                },
                                css: (0, $lhaLc.css)({
                                    width: 24,
                                    height: 24
                                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                    height: (0, $756948b644e82cf2$export$981516ee4691055c)(48),
                                    width: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                                })),
                                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "heading",
                                    level: [
                                        5,
                                        [
                                            "min",
                                            "md",
                                            4
                                        ]
                                    ],
                                    children: index + 1
                                })
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: item.text
                            })
                        ]
                    }, item.id))
            }),
            props.image && (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                image: props.image,
                width: 560,
                style: {
                    borderRadius: 16,
                    width: "100%"
                }
            })
        ]
    });
}







const $f4c4c9282b17128a$var$searchParamsSlugs = {
    phoneId: "phone"
};
function $f4c4c9282b17128a$export$cefacdcddab7996c(params) {
    return Object.entries(params).map(([k, v])=>{
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!v) return;
        if (k in $f4c4c9282b17128a$var$searchParamsSlugs === false) return;
        // Assert k as a key of searchParamsKeys to satisfy TypeScript
        const key = k;
        return `${$f4c4c9282b17128a$var$searchParamsSlugs[key]}=${v.valueOf()}`;
    }).filter((s)=>!!s).join("&");
}
(0, $9G56J.Section)($f4c4c9282b17128a$var$ProductDetails);
function $f4c4c9282b17128a$var$ProductDetails(section) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const localize = (0, $aIeEI.useLocalize)();
    const conditionGrades = (0, $e18f565b44c7bc7d$export$713f13fb69b50c52)();
    const [phoneState, setPhone] = (0, $047f6f355e30d7d1$export$800784442c3f48f8)();
    const [offerOptions, setOfferOptions] = (0, $047f6f355e30d7d1$export$5b1a6a2d762c097c)();
    const frequentlyAskedQuestions = (0, $e18f565b44c7bc7d$export$6eb271ef04c4063b)();
    const [searchParams] = (0, $5K1mb.useSearchParams)();
    const phoneId = searchParams.get($f4c4c9282b17128a$var$searchParamsSlugs.phoneId);
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    // Just pass 0 to get the shortest available rental period.
    const phoneOffer = (0, $e18f565b44c7bc7d$export$b1c43cd413897984)(phoneId !== null && phoneId !== void 0 ? phoneId : null, 0);
    const [descriptionModalIsOpen, setDescriptionModalIsOpen] = (0, $eeH7J.useState)(false);
    const checkoutPage = (0, $dUDPg.useWebPageInfo)(section.configure.cta.page);
    const localizeSlug = (0, $02ba3a727a0f8ecd$export$32f719dfac03c1cb)();
    const [sessionStateReset, setSessionStateReset] = (0, $eeH7J.useState)(false);
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const [showOrderLimitReachedModal, setShowOrderLimitReachedModal] = (0, $eeH7J.useState)(false);
    const [checkoutState] = (0, $047f6f355e30d7d1$export$7643def88ccd06be)();
    const handleOrderLimitReachedCtaClick = (0, $eeH7J.useCallback)(()=>{
        setShowOrderLimitReachedModal(true);
    }, []);
    // Effect to ensure checkout state is reset whenever returning to product details page.
    // Might want to move to the checkout section.
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        if (!sessionStateReset && ((_a = phoneOffer.data) === null || _a === void 0 ? void 0 : _a.offer)) {
            setPhone(phoneOffer.data.offer);
            setSessionStateReset(true);
        }
    }, [
        (_a = phoneOffer.data) === null || _a === void 0 ? void 0 : _a.offer,
        sessionStateReset,
        setPhone
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        // Keep options session state up do date for use later in checkout flow.
        if ((_a = phoneOffer.data) === null || _a === void 0 ? void 0 : _a.options) setOfferOptions(phoneOffer.data.options);
    }, [
        (_b = phoneOffer.data) === null || _b === void 0 ? void 0 : _b.options,
        setOfferOptions
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        // If phoneState is for a different model than currently viewing, replace it.
        if (((_a = phoneOffer.data) === null || _a === void 0 ? void 0 : _a.offer) && (phoneState === null || phoneState === void 0 ? void 0 : phoneState.model) !== phoneOffer.data.offer.model) setPhone(phoneOffer.data.offer);
    }, [
        (_c = phoneOffer.data) === null || _c === void 0 ? void 0 : _c.offer,
        phoneState === null || phoneState === void 0 ? void 0 : phoneState.model,
        setOfferOptions,
        setPhone
    ]);
    // Reset phone state when the current state is for a different model than currently viewed.
    (0, $eeH7J.useEffect)(()=>{
        if (phoneOffer.data && phoneOffer.data.offer.model !== (phoneState === null || phoneState === void 0 ? void 0 : phoneState.model)) {
            setPhone(phoneOffer.data.offer);
            setOfferOptions(phoneOffer.data.options);
        }
    }, [
        phoneOffer.data,
        phoneState === null || phoneState === void 0 ? void 0 : phoneState.model,
        setOfferOptions,
        setPhone
    ]);
    // Primarily use the state stored in session storage,
    // fall back to intial data from hook for SSR support.
    const phone = phoneState !== null && phoneState !== void 0 ? phoneState : (_d = phoneOffer.data) === null || _d === void 0 ? void 0 : _d.offer;
    const options = offerOptions !== null && offerOptions !== void 0 ? offerOptions : (_e = phoneOffer.data) === null || _e === void 0 ? void 0 : _e.options;
    const phoneConditionGrade = (_f = conditionGrades.data) === null || _f === void 0 ? void 0 : _f.find((cid)=>cid.id === (phone === null || phone === void 0 ? void 0 : phone.condition));
    if (!phone || !options || !frequentlyAskedQuestions.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    if (!((_g = checkoutPage.data) === null || _g === void 0 ? void 0 : _g.slug)) return (0, $4vwom.jsx)("div", {
        children: "Missing checkout page slug, or product details configure CTA page."
    });
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        css: (0, $lhaLc.css)({
            flexDirection: "column",
            gap: 32
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
            flexDirection: "row"
        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "lg", {
            gap: (0, $756948b644e82cf2$export$981516ee4691055c)(144)
        }), (0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    flex: "1 0 0"
                },
                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 48,
                    direction: "column",
                    alignSelf: "flex-start",
                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                        maxHeight: 372
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        position: "sticky",
                        top: 24,
                        left: 0,
                        height: "calc(100vh - 24px - 24px)",
                        maxHeight: "calc(100vh - 24px - 24px)"
                    })),
                    children: [
                        (0, $4vwom.jsx)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                aspectRatio: "1 / 1",
                                minHeight: 0
                            },
                            children: (0, $4vwom.jsx)((0, $3128e8049110e334$export$35bf746fc814fa9a), {
                                images: (_h = phone.images) !== null && _h !== void 0 ? _h : []
                            })
                        }),
                        section.whatsInTheBox ? (0, $4vwom.jsx)("div", {
                            style: {
                                flex: "0 0 auto"
                            },
                            "aria-hidden": true,
                            css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                display: "none"
                            }),
                            children: (0, $4vwom.jsx)((0, $be4b37daa90ce555$export$dc2f2ee2b949f61f), {
                                heading: localize(section.whatsInTheBox.heading),
                                items: section.whatsInTheBox.items.map((item)=>({
                                        image: item.image,
                                        heading: localize(item.heading),
                                        text: localize(item.text)
                                    }))
                            })
                        }) : null
                    ]
                })
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                flex: "1 0 0",
                direction: "column",
                gap: 48,
                children: [
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: 16,
                        children: [
                            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                children: [
                                    !!phoneConditionGrade && (0, $4vwom.jsx)("div", {
                                        style: {
                                            marginBottom: 8
                                        },
                                        children: (0, $4vwom.jsxs)((0, $cf418bf541887e36$export$28c660c63b792dea), {
                                            renderTrigger: (ref)=>(0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                                                    color: "sand",
                                                    elementRef: ref,
                                                    children: localize(phoneConditionGrade.name)
                                                }),
                                            children: [
                                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                    variant: "label",
                                                    size: "md",
                                                    color: "sand",
                                                    margin: {
                                                        bottom: 4
                                                    },
                                                    children: localize(phoneConditionGrade.name)
                                                }),
                                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                    variant: "body",
                                                    size: "sm",
                                                    children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                                        value: localize(phoneConditionGrade.description)
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $4vwom.jsx)("div", {
                                        children: (0, $4vwom.jsxs)("div", {
                                            css: (0, $lhaLc.css)({
                                                display: "grid",
                                                gridTemplateAreas: phone.features && phone.features.length > 0 ? '"heading button" "features button"' : '"heading button"',
                                                gridTemplateColumns: "1fr auto",
                                                gridTemplateRows: "auto auto",
                                                gap: 8
                                            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "lg", {
                                                gridTemplateAreas: phone.features && phone.features.length > 0 ? '"heading heading" "features button"' : '"heading button"',
                                                gap: "0px 16px",
                                                marginBottom: 16
                                            })),
                                            children: [
                                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    style: {
                                                        gridArea: "heading",
                                                        height: "100%"
                                                    },
                                                    alignItems: "center",
                                                    children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                        level: 1,
                                                        children: localize(phone.name)
                                                    })
                                                }),
                                                phone.features && phone.features.length > 0 && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    gap: 8,
                                                    alignItems: "center",
                                                    style: {
                                                        gridArea: "features",
                                                        overflow: "hidden"
                                                    },
                                                    children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "body",
                                                        size: "xl",
                                                        color: "gray300",
                                                        css: (0, $lhaLc.css)({
                                                            display: "inline-block",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            flex: "1 1 auto"
                                                        }),
                                                        children: phone.features.map((feature, index)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                                children: [
                                                                    index > 0 && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                        variant: "body",
                                                                        size: [
                                                                            "lg",
                                                                            [
                                                                                "min",
                                                                                "lg",
                                                                                "xl"
                                                                            ]
                                                                        ],
                                                                        color: "gray300",
                                                                        css: (0, $lhaLc.css)({
                                                                            display: "inline-block",
                                                                            marginLeft: 8,
                                                                            marginRight: 8
                                                                        }),
                                                                        children: "\xb7"
                                                                    }),
                                                                    localize(feature.text)
                                                                ]
                                                            }, feature.id.valueOf()))
                                                    })
                                                }),
                                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    style: {
                                                        gridArea: "button",
                                                        height: "100%"
                                                    },
                                                    alignItems: "center",
                                                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                        size: "sm",
                                                        variant: "secondary",
                                                        iconStart: "chevronDown",
                                                        onClick: ()=>setDescriptionModalIsOpen(true)
                                                    })
                                                }),
                                                phone.description && (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                                                    header: {
                                                        icon: "device",
                                                        title: localize(section.productDetailsModalHeading),
                                                        closeButton: true
                                                    },
                                                    isOpen: descriptionModalIsOpen,
                                                    onClose: ()=>setDescriptionModalIsOpen(false),
                                                    children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "body",
                                                        size: "sm",
                                                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                                            value: localize(phone.description)
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            section.whatsInTheBox ? (0, $4vwom.jsx)("div", {
                                "aria-hidden": true,
                                css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                    display: "none"
                                }),
                                children: (0, $4vwom.jsx)((0, $be4b37daa90ce555$export$dc2f2ee2b949f61f), {
                                    compact: true,
                                    heading: localize(section.whatsInTheBox.heading),
                                    items: section.whatsInTheBox.items.map((item)=>({
                                            image: item.image,
                                            heading: localize(item.heading),
                                            text: localize(item.text)
                                        }))
                                })
                            }) : null,
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                borderRadius: "lg",
                                borderColor: "gray200",
                                padding: "md",
                                direction: "column",
                                css: (0, $lhaLc.css)({
                                    gap: 24
                                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                    gap: 28
                                })),
                                children: [
                                    (0, $4vwom.jsxs)("div", {
                                        children: [
                                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                level: 4,
                                                margin: {
                                                    bottom: 16
                                                },
                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.configure.colorLabel), {
                                                    selectedColor: localize((_k = (_j = options.colors.find((c)=>c.name === phone.color)) === null || _j === void 0 ? void 0 : _j.displayName) !== null && _k !== void 0 ? _k : {})
                                                })
                                            }),
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                gap: 16,
                                                children: (0, $4vwom.jsx)((0, $8e85e0d8eea1dda5$export$a98f0dcb43a68a25), {
                                                    options: options.colors.map((color)=>({
                                                            value: color.name,
                                                            text: localize(color.displayName),
                                                            disabled: !color.inStock
                                                        })),
                                                    value: phone.color,
                                                    renderOption: (option, selected)=>{
                                                        const color = options.colors.find((c)=>c.name === option.value);
                                                        // Show limited availability tooltip selectin this config
                                                        // option is not compatible with other selected options, and
                                                        // will cause a change in the selected config.
                                                        const limitedAvailability = color && color.storageSizes.length && options.storageSizes.length > color.storageSizes.length ? color.storageSizes.map((ss)=>{
                                                            var _a;
                                                            const ssdn = (_a = options.storageSizes.find((oss)=>oss.name === ss)) === null || _a === void 0 ? void 0 : _a.displayName;
                                                            if (ssdn) return {
                                                                id: ss,
                                                                displayName: localize(ssdn)
                                                            };
                                                        }).filter((ss)=>!!ss) : undefined;
                                                        const showLimitedAvailability = !selected && !(limitedAvailability === null || limitedAvailability === void 0 ? void 0 : limitedAvailability.filter((ss)=>ss.id === phone.storage).length);
                                                        return color && (0, $4vwom.jsx)((0, $cf418bf541887e36$export$28c660c63b792dea), {
                                                            renderTrigger: (ref)=>(0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                                    elementRef: ref,
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    borderWidth: 2,
                                                                    borderColor: selected ? "brand" : undefined,
                                                                    css: (0, $lhaLc.css)({
                                                                        borderRadius: 100,
                                                                        height: 38,
                                                                        width: 38
                                                                    }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "xl", {
                                                                        height: 44,
                                                                        width: 44
                                                                    })),
                                                                    children: (0, $4vwom.jsx)("div", {
                                                                        role: "radio",
                                                                        "aria-label": localize(color.displayName),
                                                                        style: {
                                                                            backgroundColor: color.color,
                                                                            opacity: option.disabled ? 0.2 : 1,
                                                                            cursor: option.disabled ? "not-allowed" : "pointer"
                                                                        },
                                                                        css: (0, $lhaLc.css)({
                                                                            borderRadius: 100,
                                                                            height: 30,
                                                                            width: 30
                                                                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "xl", {
                                                                            height: 36,
                                                                            width: 36
                                                                        }))
                                                                    })
                                                                }),
                                                            children: (limitedAvailability === null || limitedAvailability === void 0 ? void 0 : limitedAvailability.length) && showLimitedAvailability ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.configure.limitedStorageSizesAvailabilityTooltip), {
                                                                    storageSizes: limitedAvailability.map((la)=>la.displayName).join(", ")
                                                                })
                                                            }) : option.disabled ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: localize(section.configure.outOfStockTooltip)
                                                            }) : null
                                                        });
                                                    },
                                                    onChange: async (e, val)=>{
                                                        setPhone(await (0, $e18f565b44c7bc7d$export$a5ae59f6dafb10b4)("color", Object.assign(Object.assign({}, phone), {
                                                            color: val
                                                        })));
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: 0
                                    }),
                                    (0, $4vwom.jsxs)("div", {
                                        children: [
                                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                level: 4,
                                                margin: {
                                                    bottom: 16
                                                },
                                                children: localize(section.configure.storageSizeLabel)
                                            }),
                                            (0, $4vwom.jsx)("div", {
                                                style: {
                                                    gap: 8,
                                                    display: "flex"
                                                },
                                                css: (0, $lhaLc.css)({
                                                    "> *": {
                                                        flex: "1 0 0"
                                                    }
                                                }),
                                                children: (0, $4vwom.jsx)((0, $8e85e0d8eea1dda5$export$a98f0dcb43a68a25), {
                                                    value: phone.storage,
                                                    options: options.storageSizes.map((storage)=>({
                                                            value: storage.name,
                                                            text: localize(storage.displayName),
                                                            disabled: !storage.inStock
                                                        })),
                                                    renderOption: (option, selected)=>{
                                                        const storageSize = options.storageSizes.find((ss)=>ss.name === option.value);
                                                        // Show limited availability tooltip selectin this config
                                                        // option is not compatible with other selected options, and
                                                        // will cause a change in the selected config.
                                                        const limitedAvailability = storageSize && storageSize.colors.length && options.colors.length > storageSize.colors.length ? storageSize.colors.map((c)=>{
                                                            var _a;
                                                            const cdn = (_a = options.colors.find((colorOption)=>colorOption.name === c)) === null || _a === void 0 ? void 0 : _a.displayName;
                                                            if (cdn) return {
                                                                id: c,
                                                                displayName: localize(cdn)
                                                            };
                                                        }).filter((c)=>!!c) : undefined;
                                                        const showLimitedAvailability = !selected && !(limitedAvailability === null || limitedAvailability === void 0 ? void 0 : limitedAvailability.filter((c)=>c.id === phone.color).length);
                                                        return storageSize && (0, $4vwom.jsx)((0, $cf418bf541887e36$export$28c660c63b792dea), {
                                                            renderTrigger: (ref)=>(0, $4vwom.jsx)("div", {
                                                                    ref: ref,
                                                                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                                        variant: "select",
                                                                        selected: selected,
                                                                        fullwidth: true,
                                                                        as: "div",
                                                                        size: "sm",
                                                                        disabled: option.disabled,
                                                                        children: option.text
                                                                    })
                                                                }),
                                                            children: showLimitedAvailability && (limitedAvailability === null || limitedAvailability === void 0 ? void 0 : limitedAvailability.length) ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.configure.limitedColorsAvailabilityTooltip), {
                                                                    colors: limitedAvailability.map((la)=>la.displayName).join(", ")
                                                                })
                                                            }) : option.disabled ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: localize(section.configure.outOfStockTooltip)
                                                            }) : null
                                                        });
                                                    },
                                                    onChange: async (e, val)=>{
                                                        setPhone(await (0, $e18f565b44c7bc7d$export$a5ae59f6dafb10b4)("storage", Object.assign(Object.assign({}, phone), {
                                                            storage: val
                                                        })));
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: 0
                                    }),
                                    (0, $4vwom.jsxs)("div", {
                                        children: [
                                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                level: 4,
                                                margin: {
                                                    bottom: 16
                                                },
                                                children: localize(section.configure.rentalPeriodLabel)
                                            }),
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                direction: "column",
                                                gap: 8,
                                                css: (0, $lhaLc.css)({
                                                    "> *": {
                                                        flex: "1 0 0"
                                                    }
                                                }),
                                                children: (0, $4vwom.jsx)((0, $8e85e0d8eea1dda5$export$a98f0dcb43a68a25), {
                                                    value: phone.rentalPeriod,
                                                    options: options.rentalPeriods.map((rp)=>({
                                                            value: rp.months,
                                                            text: localize(rp.displayName)
                                                        })),
                                                    renderOption: (option, selected)=>{
                                                        const rentalPeriodPrice = phone.monthlyPrices.find((rpp)=>rpp.rentalPeriod === option.value);
                                                        if (!rentalPeriodPrice) return null;
                                                        return (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                            variant: "select",
                                                            selected: selected,
                                                            fullwidth: true,
                                                            as: "div",
                                                            size: "md",
                                                            children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                                style: {
                                                                    width: "100%"
                                                                },
                                                                justifyContent: "space-between",
                                                                children: [
                                                                    (0, $4vwom.jsxs)("div", {
                                                                        style: !selected ? {
                                                                            fontWeight: 300
                                                                        } : {},
                                                                        children: [
                                                                            option.value,
                                                                            " ",
                                                                            localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))
                                                                        ]
                                                                    }),
                                                                    (0, $4vwom.jsxs)("div", {
                                                                        children: [
                                                                            formatAmount(rentalPeriodPrice.price.discountedTotal),
                                                                            "/",
                                                                            localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    },
                                                    onChange: async (e, val)=>{
                                                        setPhone(await (0, $e18f565b44c7bc7d$export$a5ae59f6dafb10b4)("rentalPeriod", Object.assign(Object.assign({}, phone), {
                                                            rentalPeriod: val
                                                        })));
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: 0
                                    }),
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        alignItems: "baseline",
                                        gap: "4px 8px",
                                        style: {
                                            whiteSpace: "nowrap",
                                            flexWrap: "wrap"
                                        },
                                        children: [
                                            (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "heading",
                                                level: [
                                                    2,
                                                    [
                                                        "min",
                                                        "md",
                                                        3
                                                    ]
                                                ],
                                                color: "brand",
                                                children: [
                                                    formatAmount(phone.monthlyPrice.itemsTotal),
                                                    "/",
                                                    localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                ]
                                            }),
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "md",
                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.configure.totalPricePostFix), {
                                                    rentalPeriod: `${phone.rentalPeriod}`
                                                })
                                            }),
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "sm",
                                                color: "gray300",
                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.configure.rentalPeriodTotalPrice), {
                                                    rentalPeriod: `${phone.rentalPeriod.valueOf()}`,
                                                    totalPrice: `${formatAmount(phone.rentalPeriodTotalPrice)}`,
                                                    monthsShort: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
                                                    monthsLong: localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                        as: "a",
                                        variant: "primary",
                                        href: ((_l = me.data) === null || _l === void 0 ? void 0 : _l.orderLimitReached) ? undefined : localizeSlug(checkoutPage.data.slug),
                                        fullwidth: true,
                                        onClick: ((_m = me.data) === null || _m === void 0 ? void 0 : _m.orderLimitReached) ? handleOrderLimitReachedCtaClick : ()=>{
                                            var _a, _b, _c, _d;
                                            (0, $dUDPg.postAnalyticsEvent)("checkout", {
                                                entity: [
                                                    "init"
                                                ],
                                                data: {
                                                    userId: (_b = (_a = me.data) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.valueOf(),
                                                    phoneId: phone.id.valueOf(),
                                                    rentalPeriod: phone.rentalPeriod.toString()
                                                }
                                            }, {
                                                "Fuse-Analytics-Session": (_d = (_c = checkoutState.id) === null || _c === void 0 ? void 0 : _c.valueOf()) !== null && _d !== void 0 ? _d : ""
                                            });
                                            if (typeof fbq !== "undefined") fbq("track", "AddToCart", {
                                                content_ids: [
                                                    phone.id.valueOf()
                                                ],
                                                content_name: localize(phone.name),
                                                content_type: "product",
                                                value: phone.monthlyPrice.itemsTotal.majorUnits,
                                                currency: phone.monthlyPrice.itemsTotal.currency,
                                                num_items: 1
                                            });
                                            if (typeof snaptr !== "undefined") snaptr("track", "ADD_CART", {
                                                price: phone.monthlyPrice.itemsTotal.majorUnits,
                                                currency: phone.monthlyPrice.itemsTotal.currency,
                                                item_ids: [
                                                    phone.id
                                                ],
                                                item_category: "phone",
                                                number_items: 1
                                            });
                                        },
                                        children: localize(section.configure.cta.buttonText)
                                    }),
                                    (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                                        width: 600,
                                        isOpen: showOrderLimitReachedModal,
                                        header: {
                                            title: localize(section.orderLimitReachedModal.title)
                                        },
                                        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: 24,
                                            children: [
                                                (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                                    value: localize(section.orderLimitReachedModal.text)
                                                }),
                                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    justifyContent: "flex-end",
                                                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                        variant: "primary",
                                                        size: "md",
                                                        onClick: ()=>setShowOrderLimitReachedModal(false),
                                                        children: localize(section.orderLimitReachedModal.closeButtonText)
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (_o = section.notifications) === null || _o === void 0 ? void 0 : _o.map((n)=>(0, $4vwom.jsx)((0, $192171ee7c657b77$export$14834abbfce3b8cd), {
                            icon: n.icon,
                            text: localize(n.text),
                            color: n.color
                        }, n.id.valueOf())),
                    section.steps && (0, $4vwom.jsx)((0, $02316f5bb92deb21$export$4f8c96a4412d9797), {
                        heading: localize(section.steps.heading),
                        items: section.steps.items.map((item)=>({
                                id: item.id.valueOf(),
                                text: localize(item.text)
                            })),
                        image: section.steps.image
                    }),
                    section.benefits && (0, $4vwom.jsx)((0, $c886ce39010e35d8$export$5c260416423351e0), {
                        heading: localize(section.benefits.heading),
                        items: section.benefits.items.map((item)=>({
                                id: item.id.valueOf(),
                                icon: item.icon,
                                heading: localize(item.heading),
                                text: localize(item.text)
                            }))
                    }),
                    !!section.frequentlyAskedQuestions && frequentlyAskedQuestions.data.questions.length > 0 && (0, $4vwom.jsx)((0, $27039c694c31ccef$export$91f5553634f65df6), {
                        heading: localize(section.frequentlyAskedQuestions.heading),
                        questions: frequentlyAskedQuestions.data.questions.map((item)=>({
                                id: item.id,
                                question: localize(item.question),
                                answer: localize(item.answer)
                            })),
                        showAllButtonText: localize(section.frequentlyAskedQuestions.showAllButtonText),
                        maxInitialQuestions: (_p = section.frequentlyAskedQuestions.maxInitialQuestions) === null || _p === void 0 ? void 0 : _p.valueOf()
                    })
                ]
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $dUDPg = parcelRequire("dUDPg");


var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");


var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");

var $7m9cQ = parcelRequire("7m9cQ");










function $b7d6468cd3704e06$export$e6cbe35324ccf844(props) {
    var _a, _b, _c;
    const [hover, setHover] = (0, $eeH7J.useState)(false);
    const { helpers: helpers, colors: colors, responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveSpacing: responsiveSpacing, responsiveBodyCss: responsiveBodyCss } = helpers;
    const href = props.onClick || !props.cta ? undefined : props.cta.url;
    if (props.compact) return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        backgroundColor: "gray100",
        padding: "sm",
        borderRadius: "md",
        grow: 1,
        css: (0, $lhaLc.css)({
            position: "relative",
            "&:hover": {
                cursor: props.disabled ? "default" : "pointer"
            }
        }),
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                as: "a",
                grow: 1,
                href: href,
                onClick: props.onClick,
                children: [
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        css: (0, $lhaLc.css)({
                            width: 96,
                            height: 112,
                            marginRight: 24
                        }),
                        alignItems: "center",
                        justifyContent: "center",
                        children: props.image ? (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                            image: props.image,
                            width: 100,
                            style: {
                                flex: "0 0 0",
                                height: "auto",
                                width: "auto",
                                maxHeight: `${(_a = props.relativePhysicalSize) !== null && _a !== void 0 ? _a : 100}%`,
                                maxWidth: "100%"
                            }
                        }) : null
                    }),
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        justifyContent: "space-between",
                        grow: 1,
                        style: {
                            paddingTop: 12,
                            paddingBottom: 12
                        },
                        children: [
                            (0, $4vwom.jsxs)("div", {
                                children: [
                                    props.label ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "label",
                                        size: "md",
                                        color: props.label.color,
                                        children: props.label.text
                                    }) : null,
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "xl",
                                        children: props.name
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "sm",
                                        color: "gray350",
                                        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            gap: 4,
                                            children: props.features.slice(0, 2).map((f, i)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                    children: [
                                                        i > 0 ? (0, $4vwom.jsx)("div", {
                                                            children: "\xb7"
                                                        }) : null,
                                                        (0, $4vwom.jsx)("div", {
                                                            children: f
                                                        })
                                                    ]
                                                }, f))
                                        })
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "xl",
                                fontWeight: 600,
                                color: props.disabled ? "gray350" : props.highlightPrice ? "brand" : undefined,
                                children: props.price
                            })
                        ]
                    })
                ]
            }),
            !props.disabled && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "grayWhite",
                style: {
                    position: "absolute",
                    bottom: 16,
                    right: 16,
                    borderRadius: "100vw",
                    width: 40,
                    height: 40,
                    pointerEvents: "none"
                },
                children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                    icon: "arrowRight"
                })
            })
        ]
    });
    return (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
        transition: (0, $7f851218870bc850$export$f1ff28cd2162b6d5).card,
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            as: "a",
            href: props.disabled ? undefined : href,
            onClick: props.disabled ? undefined : props.onClick,
            role: "button",
            "aria-labelledby": props.cta ? props.cta.text : undefined,
            motion: {
                initial: {
                    backgroundColor: colors.gray100,
                    boxShadow: "none"
                },
                animate: hover ? {
                    backgroundColor: colors.grayWhite,
                    boxShadow: "var(--product-card-box-shadow)"
                } : {
                    backgroundColor: colors.gray100,
                    boxShadow: "none"
                }
            },
            "aria-disabled": (_b = props.disabled) !== null && _b !== void 0 ? _b : false,
            borderRadius: "md",
            alignItems: "center",
            justifyContent: "space-between",
            onMouseOver: props.disabled ? undefined : ()=>setHover(true),
            onMouseOut: props.disabled ? undefined : ()=>setHover(false),
            css: (0, $lhaLc.css)({
                position: "relative",
                containerSize: "size",
                containerName: "card",
                "&:hover": {
                    cursor: props.disabled ? "default" : "pointer"
                },
                height: "100%",
                flexDirection: "column",
                paddingTop: 50,
                paddingBottom: 30
            }, responsiveCss("min", "lg", {
                paddingBottom: 38
            }), responsiveCss("min", "xl", {
                paddingTop: 64 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                paddingBottom: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
            }), responsiveSpacing("md", [
                "paddingLeft",
                "paddingRight"
            ]), (0, $756948b644e82cf2$export$88d2c1aa53be97d2)("--product-card-box-shadow")),
            children: [
                (0, $4vwom.jsx)("div", {
                    css: (0, $lhaLc.css)({
                        position: "absolute",
                        top: 19,
                        right: 19
                    }, responsiveCss("min", "xl", {
                        top: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                        right: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                    })),
                    children: props.label ? (0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                        color: props.label.color,
                        children: props.label.text
                    }) : null
                }),
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    style: {
                        maxWidth: "100%"
                    },
                    children: [
                        (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                            css: (0, $lhaLc.css)({
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "flex-end",
                                height: 192,
                                marginBottom: 30,
                                transform: props.alwaysShowCta ? "translateY(var(--product-card-image-translate-y))" : "",
                                "--product-card-image-translate-y": `${8 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b) * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
                            }, responsiveCss("min", "lg", {
                                height: 220,
                                marginBottom: 38,
                                "--product-card-image-translate-y": `${8 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
                            }), responsiveCss("min", "xl", {
                                height: 284 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                                marginBottom: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                                "--product-card-image-translate-y": `${8}px`
                            })),
                            animate: !props.alwaysShowCta ? hover ? {
                                translateY: "var(--product-card-image-translate-y)"
                            } : {
                                translateY: 0
                            } : {},
                            children: props.image ? (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                image: props.image,
                                width: 220,
                                style: {
                                    height: "auto",
                                    width: "auto",
                                    maxHeight: `${(_c = props.relativePhysicalSize) !== null && _c !== void 0 ? _c : 100}%`,
                                    maxWidth: "100%"
                                }
                            }) : null
                        }),
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            alignItems: "center",
                            css: (0, $lhaLc.css)({
                                marginBottom: 30
                            }, responsiveCss("min", "lg", {
                                marginBottom: 38
                            }), responsiveCss("min", "xl", {
                                marginBottom: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                            })),
                            children: [
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "xl",
                                    margin: {
                                        bottom: 4
                                    },
                                    truncate: true,
                                    children: props.name
                                }),
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "md",
                                    color: "gray400",
                                    truncate: true,
                                    children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        gap: 4,
                                        children: props.features.length ? props.features.slice(0, 2).map((f, i)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                children: [
                                                    i > 0 ? (0, $4vwom.jsx)("div", {
                                                        children: "\xb7"
                                                    }) : null,
                                                    (0, $4vwom.jsx)("div", {
                                                        children: f
                                                    })
                                                ]
                                            }, f)) : "\xa0"
                                    })
                                })
                            ]
                        }),
                        (0, $4vwom.jsxs)("div", {
                            children: [
                                (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                    animate: hover && !props.alwaysShowCta ? {
                                        translateY: "var(--product-card-price-translate-y)"
                                    } : {},
                                    css: (0, $lhaLc.css)({
                                        "--product-card-price-translate-y": `-${16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b) * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`,
                                        transform: props.alwaysShowCta ? "translateY(var(--product-card-price-translate-y))" : ""
                                    }, responsiveCss("min", "lg", {
                                        "--product-card-price-translate-y": `-${16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
                                    }), responsiveCss("min", "xl", {
                                        "--product-card-price-translate-y": "-16px"
                                    })),
                                    children: (0, $4vwom.jsx)("div", {
                                        css: (0, $lhaLc.css)(props.highlightPrice && {
                                            color: colors.brand
                                        }, props.disabled && {
                                            color: colors.gray350
                                        }, responsiveBodyCss("xl"), {
                                            fontFamily: "Catalogue",
                                            fontWeight: "600 !important",
                                            textAlign: "center"
                                        }),
                                        children: props.price
                                    })
                                }),
                                !!props.cta && (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                    css: (0, $lhaLc.css)({
                                        textAlign: "center",
                                        "--initial-button-opacity": 0,
                                        "--initial-button-transform": `${8 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b) * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`,
                                        "--initial-button-margin-top": "4px",
                                        pointerEvents: props.alwaysShowCta || hover ? "all" : "none"
                                    }, responsiveCss("min", "lg", {
                                        "--initial-button-transform": `${8 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
                                    }), responsiveCss("min", "xl", {
                                        "--initial-button-transform": "8px"
                                    }), (0, $e82ba787de72625c$export$c874afaabcd4d5bc)({
                                        "--initial-button-opacity": 1,
                                        "--initial-button-transform": "none",
                                        "--initial-button-margin-top": "20px",
                                        pointerEvents: "all"
                                    })),
                                    initial: props.alwaysShowCta ? {
                                        opacity: 1,
                                        translateY: 0
                                    } : {
                                        opacity: "var(--initial-button-opacity)",
                                        translateY: "var(--initial-button-transform)",
                                        marginTop: "var(--initial-button-margin-top)"
                                    },
                                    animate: !props.alwaysShowCta && hover ? {
                                        opacity: 1,
                                        translateY: 0
                                    } : {},
                                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                        variant: "primary",
                                        iconEnd: "arrowRight",
                                        children: props.cta.text
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
(0, $eSiQ2.Component)($b7d6468cd3704e06$export$e6cbe35324ccf844, {
    name: "ProductCard",
    gallery: {
        path: "Cards/ProductCard",
        items: [
            {
                variants: [
                    {
                        props: {
                            name: "iPhone 15 Pro",
                            features: [
                                "6,7\u201D Skjerm",
                                "48MP Kamera"
                            ],
                            price: "Fra kr 163 /m",
                            cta: {
                                text: "Kj\xf8p n\xe5",
                                url: "/devices/iphone-15-pro"
                            },
                            label: {
                                color: "sky",
                                text: "New"
                            },
                            image: `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image1.png`
                        }
                    },
                    {
                        props: {
                            name: "iPhone 15 Pro",
                            features: [
                                "6,7\u201D Skjerm",
                                "48MP Kamera"
                            ],
                            price: "Fra kr 163 /m",
                            cta: {
                                text: "Kj\xf8p n\xe5",
                                url: "/devices/iphone-15-pro"
                            },
                            label: {
                                color: "brand",
                                text: "Deal"
                            },
                            highlightPrice: true,
                            image: `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image3.png`
                        }
                    },
                    {
                        props: {
                            name: "iPhone 15 Pro",
                            features: [
                                "6,7\u201D Skjerm",
                                "48MP Kamera"
                            ],
                            price: "Fra kr 163 /m",
                            cta: {
                                text: "Kj\xf8p n\xe5",
                                url: "/devices/iphone-15-pro"
                            },
                            image: `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image2.png`
                        }
                    }
                ]
            }
        ]
    }
});



var $aIeEI = parcelRequire("aIeEI");





var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");



var $eSiQ2 = parcelRequire("eSiQ2");




var $7m9cQ = parcelRequire("7m9cQ");

function $aa16a84e4a514505$export$b60a58e8d2266310(props) {
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        as: "a",
        href: props.cta.url,
        direction: "column",
        justifyContent: "space-between",
        borderRadius: "md",
        backgroundColor: "_productsSeeAllBg",
        style: {
            position: "relative",
            height: "100%",
            overflow: "clip",
            flexGrow: 0
        },
        "aria-label": props.cta.text,
        children: [
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                css: (0, $lhaLc.css)({
                    padding: 32
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    padding: 64
                })),
                style: {
                    zIndex: 1
                },
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        margin: {
                            bottom: 16
                        },
                        children: props.heading
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "dark",
                        children: props.cta.text
                    })
                ]
            }),
            props.image ? (0, $4vwom.jsx)("div", {
                style: {
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    overflow: "hidden",
                    backgroundPosition: "bottom",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat"
                },
                css: (0, $lhaLc.css)({
                    marginLeft: 32,
                    marginRight: 32
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    marginLeft: 64,
                    marginRight: 64
                }), (0, $6a1a23ca93758ec8$export$8b235cefb9710a9e)({
                    image: props.image,
                    width: 700,
                    format: "webp"
                }))
            }) : null
        ]
    });
}
(0, $eSiQ2.Component)($aa16a84e4a514505$export$b60a58e8d2266310, {
    name: "SeeAllCard",
    gallery: {
        path: "Cards/SeeAllCard",
        items: [
            {
                variants: [
                    {
                        props: {
                            heading: "Se hele v\xe5rt utvalg",
                            cta: {
                                text: "Vis alt (14)",
                                url: ""
                            },
                            image: `${(0, $7m9cQ.server)()}/static/redoit/see-all-card.png`
                        }
                    }
                ]
            }
        ]
    }
});





var $34lt5 = parcelRequire("34lt5");


/**
 * Same as PromotedProducts, presenting 4 promoted products from the product catalogue, but with
 * the products automatically selected based on some criteria.
 */ function $75e14dce901ce6bb$var$PromotedProductsAuto(section) {
    var _a;
    const offers = (0, $e18f565b44c7bc7d$export$88e20cfc122b8557)(section.phoneModels, undefined, undefined, undefined);
    const localize = (0, $aIeEI.useLocalize)();
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const phoneModels = (0, $e18f565b44c7bc7d$export$b99855a9ac1ee5b2)((_a = section.phoneModels) !== null && _a !== void 0 ? _a : null);
    if (!offers.data || !phoneModels.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)($75e14dce901ce6bb$var$PromotedProducts, Object.assign({}, section, {
        products: phoneModels.data.map((pm)=>{
            var _a, _b, _c, _d, _e, _f, _g;
            const offer = (_a = offers.data) === null || _a === void 0 ? void 0 : _a.find((o)=>o.model === pm.id);
            if (!offer) return {
                phoneModelId: pm.id,
                name: pm.name,
                features: (_c = (_b = pm.features) === null || _b === void 0 ? void 0 : _b.map((f)=>f.text)) !== null && _c !== void 0 ? _c : [],
                price: {
                    no: "Utsolgt",
                    en: "Sold out"
                },
                image: (_d = pm.images) === null || _d === void 0 ? void 0 : _d[0],
                relativePhysicalSize: pm.relativePhysicalSize,
                soldOut: true
            };
            return {
                phoneModelId: pm.id,
                phoneId: offer.id,
                name: offer.name,
                features: (_f = (_e = offer.features) === null || _e === void 0 ? void 0 : _e.map((f)=>f.text)) !== null && _f !== void 0 ? _f : [],
                price: {
                    no: `Fra ${formatAmount(offer.monthlyPrice.itemsTotal)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498), (0, $34lt5.LocaleKey).no)}`,
                    en: `From ${formatAmount(offer.monthlyPrice.itemsTotal)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498), (0, $34lt5.LocaleKey).en)}`
                },
                image: (_g = offer.images) === null || _g === void 0 ? void 0 : _g[0],
                relativePhysicalSize: offer.relativePhysicalSize
            };
        })
    }));
}
(0, $9G56J.Section)($75e14dce901ce6bb$var$PromotedProductsAuto);
/**
 * Section presenting 4 promoted products from the product catalogue. Renders as a grid on desktop
 * and list on mobile.
 */ function $75e14dce901ce6bb$var$PromotedProducts(section) {
    var _a, _b, _c, _d;
    const localize = (0, $aIeEI.useLocalize)();
    // NOTE: Apparently, judging from all the console errors, these can be undefined.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const productCtaPageInfo = (0, $dUDPg.useWebPageInfo)((_a = section.productCta.page) !== null && _a !== void 0 ? _a : null);
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const seeAllCtaPageInfo = (0, $dUDPg.useWebPageInfo)((_b = section.seeAll.cta.page) !== null && _b !== void 0 ? _b : null);
    const localizeSlug = (0, $02ba3a727a0f8ecd$export$32f719dfac03c1cb)();
    if (!((_c = productCtaPageInfo.data) === null || _c === void 0 ? void 0 : _c.slug)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: [
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)({
                    marginBottom: 16
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    marginBottom: 24
                })),
                children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                    level: 2,
                    children: localize(section.heading)
                })
            }),
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                css: (0, $lhaLc.css)({
                    display: "grid",
                    gridAutoFlow: "row",
                    gridTemplateRows: "1fr"
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    gridTemplateAreas: '"C1 C2 C3" "C4 AA AA"',
                    gridTemplateRows: "1fr 1fr"
                }), (0, $aace75a797ac78f1$export$9c33585a37942ee0)("sm", "gap")),
                children: [
                    section.products.slice(0, 4).map((p, i)=>{
                        var _a, _b, _c, _d;
                        return (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                            children: [
                                (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                        display: "none"
                                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                        gridArea: `C${i + 1}`
                                    })),
                                    children: (0, $4vwom.jsx)((0, $b7d6468cd3704e06$export$e6cbe35324ccf844), {
                                        disabled: p.soldOut,
                                        alwaysShowCta: section.productCta.alwaysShow,
                                        name: localize(p.name),
                                        features: p.features.map((f)=>localize(f)),
                                        price: localize(p.price),
                                        highlightPrice: p.highlightPrice,
                                        image: p.image,
                                        cta: p.soldOut || !p.phoneId ? undefined : {
                                            text: localize(section.productCta.text),
                                            url: `${localizeSlug((_a = productCtaPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug)}?${(0, $f4c4c9282b17128a$export$cefacdcddab7996c)({
                                                phoneId: p.phoneId
                                            })}`
                                        },
                                        relativePhysicalSize: (_b = p.relativePhysicalSize) === null || _b === void 0 ? void 0 : _b.valueOf(),
                                        label: p.label ? {
                                            text: localize(p.label.text),
                                            color: p.label.color
                                        } : undefined
                                    })
                                }),
                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    direction: "column",
                                    gap: 16,
                                    css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                        display: "none"
                                    }),
                                    children: (0, $4vwom.jsx)((0, $b7d6468cd3704e06$export$e6cbe35324ccf844), {
                                        disabled: p.soldOut,
                                        name: localize(p.name),
                                        features: p.features.map((f)=>localize(f)),
                                        price: localize(p.price),
                                        image: p.image,
                                        highlightPrice: p.highlightPrice,
                                        relativePhysicalSize: (_c = p.relativePhysicalSize) === null || _c === void 0 ? void 0 : _c.valueOf(),
                                        label: p.label ? {
                                            text: localize(p.label.text),
                                            color: p.label.color
                                        } : undefined,
                                        cta: p.soldOut || !p.phoneId ? undefined : {
                                            text: localize(section.productCta.text),
                                            url: `${localizeSlug((_d = productCtaPageInfo.data) === null || _d === void 0 ? void 0 : _d.slug)}?${(0, $f4c4c9282b17128a$export$cefacdcddab7996c)({
                                                phoneId: p.phoneId
                                            })}`
                                        },
                                        compact: true
                                    })
                                })
                            ]
                        }, p.phoneModelId.valueOf());
                    }),
                    (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                        css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                            height: 280
                        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                            minHeight: 372
                        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            gridArea: "AA"
                        })),
                        children: (0, $4vwom.jsx)((0, $aa16a84e4a514505$export$b60a58e8d2266310), {
                            heading: localize(section.seeAll.heading),
                            cta: {
                                text: localize(section.seeAll.cta.text),
                                url: localizeSlug((_d = seeAllCtaPageInfo.data) === null || _d === void 0 ? void 0 : _d.slug)
                            },
                            image: section.seeAll.image
                        })
                    })
                ]
            })
        ]
    });
}
(0, $9G56J.Section)($75e14dce901ce6bb$var$PromotedProducts);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");
var $13a9f30e9fa4b734$exports = {};
!function(r, e) {
    $13a9f30e9fa4b734$exports = e();
}($13a9f30e9fa4b734$exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});



var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $dAwef = parcelRequire("dAwef");


var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");


var $4vwom = parcelRequire("4vwom");

var $eSiQ2 = parcelRequire("eSiQ2");

var $c886316c6bbfde71$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $c886316c6bbfde71$export$72aac81228d325e1(_a) {
    var { css: css } = _a, rest = $c886316c6bbfde71$var$__rest(_a, [
        "css"
    ]);
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, rest, {
        children: (0, $4vwom.jsx)("path", {
            fill: colors.forest,
            d: "M0 0v24h24V0H0Zm20.305 10.27c-1.473 1.25-2.946 2.5-4.424 3.745-.103.087-.111.162-.082.282.488 1.907.976 3.81 1.46 5.718.013.046.017.095.03.162-.071-.042-.12-.07-.175-.104-1.65-1.043-3.302-2.085-4.949-3.132-.111-.07-.19-.079-.306-.004-1.642 1.046-3.29 2.085-4.936 3.124-.054.033-.112.07-.203.124.178-.695.343-1.362.513-2.028.327-1.29.654-2.578.99-3.865.032-.124.016-.194-.084-.281-1.485-1.254-2.967-2.512-4.448-3.77-.033-.029-.062-.058-.124-.111.256-.021.476-.038.7-.05 1.245-.083 2.494-.161 3.74-.244.525-.033 1.055-.075 1.58-.1.125-.004.137-.086.17-.165l1.531-3.844c.215-.538.426-1.072.642-1.61.02-.054.045-.107.082-.186l.075.17c.724 1.825 1.452 3.645 2.176 5.47.046.12.108.161.236.17 1.457.09 2.913.19 4.366.285.414.03.823.05 1.237.079.108.008.215.016.356.029-.066.058-.108.1-.153.136Z"
        })
    }));
}
function $c886316c6bbfde71$export$67d4fc5adb232641(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    if (props.rating < 0 || props.rating > 5) // eslint-disable-next-line no-console
    console.warn("Prop `rating` should be between 1 and 5.");
    return (0, $4vwom.jsx)("div", {
        style: {
            display: "grid",
            gap: 2,
            gridAutoFlow: "column"
        },
        children: [
            1,
            2,
            3,
            4,
            5
        ].map((i)=>(0, $4vwom.jsx)("div", {
                style: {
                    display: "flex",
                    height: 20,
                    width: 20,
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: colors.grayWhite
                },
                children: (0, $4vwom.jsx)($c886316c6bbfde71$export$72aac81228d325e1, {
                    style: {
                        height: "100%",
                        width: "100%"
                    }
                })
            }, i))
    });
}
(0, $eSiQ2.Component)($c886316c6bbfde71$export$67d4fc5adb232641, {
    name: "RedoitStars",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            rating: 1
                        }
                    },
                    {
                        props: {
                            rating: 2
                        }
                    },
                    {
                        props: {
                            rating: 3
                        }
                    },
                    {
                        props: {
                            rating: 4
                        }
                    },
                    {
                        props: {
                            rating: 5
                        }
                    }
                ]
            }
        ]
    }
});






function $a5c835cc32440a49$export$82cac57774882155(props) {
    var _a;
    const backgroundColor = (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : "gray100";
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        justifyContent: "space-between",
        backgroundColor: backgroundColor,
        borderRadius: "md",
        css: (0, $lhaLc.css)({
            height: 196,
            width: 296,
            padding: 16
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(280),
            width: (0, $756948b644e82cf2$export$981516ee4691055c)(480),
            padding: 24
        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "lg", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(290),
            width: (0, $756948b644e82cf2$export$981516ee4691055c)(550),
            padding: 24
        })),
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    (0, $4vwom.jsx)((0, $c886316c6bbfde71$export$67d4fc5adb232641), {
                        rating: props.rating
                    }),
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "label",
                        size: "md",
                        children: props.timestamp
                    })
                ]
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                margin: {
                    y: 20
                },
                shrink: 1,
                style: {
                    overflow: "hidden"
                },
                children: [
                    (0, $4vwom.jsx)("div", {
                        css: (0, $lhaLc.css)({
                            marginBottom: 4
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            marginBottom: 12
                        })),
                        children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 3,
                            children: props.title
                        })
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            flexShrink: 1
                        },
                        children: (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                            size: "md",
                            color: "gray400",
                            style: {
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitLineClamp: "3",
                                lineClamp: "3",
                                textOverflow: "ellipsis",
                                WebkitBoxOrient: "vertical"
                            },
                            children: props.text
                        })
                    })
                ]
            }),
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    padding: 10
                })),
                children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                    level: 4,
                    children: props.name
                })
            })
        ]
    });
}
(0, $eSiQ2.Component)($a5c835cc32440a49$export$82cac57774882155, {
    name: "ReviewCard",
    gallery: {
        path: "Cards/ReviewCard",
        items: [
            {
                variants: [
                    {
                        props: {
                            title: "Impressive!",
                            rating: 5,
                            name: "John",
                            text: "This service was so impressive, I won't hesitate to use it again.",
                            timestamp: "2 days ago"
                        }
                    }
                ]
            },
            {
                variants: [
                    {
                        props: {
                            title: "Impressive!",
                            rating: 5,
                            name: "John",
                            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla diam sem, sagittis et nisl eget, sagittis varius tortor. Aenean id arcu et erat tristique posuere. Integer quis leo dictum, iaculis augue at, fringilla augue. Nullam eu enim mauris.",
                            timestamp: "2 days ago"
                        }
                    }
                ]
            }
        ]
    }
});



var $e0d6729bf3c3c3ec$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e0d6729bf3c3c3ec$var$defaultSpeed = 30;
function $e0d6729bf3c3c3ec$export$a606a0d663523950(props) {
    var _a;
    const ref = (0, $eeH7J.useRef)(null);
    const [size, setSize] = (0, $eeH7J.useState)(0);
    const direction = (_a = props.direction) !== null && _a !== void 0 ? _a : "row";
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        const rect = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (rect) setSize(rect[direction === "row" ? "width" : "height"]);
    }, [
        direction
    ]);
    const animationDuration = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return `${size / ((_a = props.speed) !== null && _a !== void 0 ? _a : $e0d6729bf3c3c3ec$var$defaultSpeed) * 1000}ms`;
    }, [
        props.speed,
        size
    ]);
    const reviewElements = (0, $eeH7J.useMemo)(()=>/*#__PURE__*/ (0, $eeH7J.cloneElement)((0, $4vwom.jsx)((0, $4vwom.Fragment), {
            children: props.reviews.map((_a)=>{
                var _b;
                var { id: id } = _a, review = $e0d6729bf3c3c3ec$var$__rest(_a, [
                    "id"
                ]);
                return (0, $4vwom.jsx)("div", {
                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$9c33585a37942ee0)("sm", direction === "row" ? "marginLeft" : "marginTop")),
                    children: (0, $4vwom.jsx)((0, $a5c835cc32440a49$export$82cac57774882155), Object.assign({}, review, (_b = props.ReviewCardProps) !== null && _b !== void 0 ? _b : {}))
                }, id);
            })
        })), [
        props.ReviewCardProps,
        direction,
        props.reviews
    ]);
    const animationCss = (0, $lhaLc.css)({
        display: "flex",
        flexDirection: direction,
        animationName: direction === "row" ? $e0d6729bf3c3c3ec$var$horizontalScroll : $e0d6729bf3c3c3ec$var$verticalScroll
    });
    return (0, $4vwom.jsxs)("div", {
        style: {
            position: "relative",
            flexWrap: "nowrap",
            display: "flex",
            flexDirection: direction,
            [direction === "row" ? "width" : "height"]: "100%"
        },
        css: $e0d6729bf3c3c3ec$var$containerCss,
        children: [
            (0, $4vwom.jsx)("div", {
                ref: ref,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $e0d6729bf3c3c3ec$var$responsiveGridCss,
                    animationCss
                ],
                children: reviewElements
            }),
            (0, $4vwom.jsx)("div", {
                "aria-hidden": true,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $e0d6729bf3c3c3ec$var$responsiveGridCss,
                    animationCss
                ],
                children: reviewElements
            }),
            (0, $4vwom.jsx)("div", {
                "aria-hidden": true,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $e0d6729bf3c3c3ec$var$responsiveGridCss,
                    animationCss
                ],
                children: reviewElements
            }),
            (0, $4vwom.jsx)("div", {
                "aria-hidden": true,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $e0d6729bf3c3c3ec$var$responsiveGridCss,
                    animationCss
                ],
                children: reviewElements
            }),
            (0, $4vwom.jsx)("div", {
                "aria-hidden": true,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $e0d6729bf3c3c3ec$var$responsiveGridCss,
                    animationCss
                ],
                children: reviewElements
            })
        ]
    });
}
const $e0d6729bf3c3c3ec$var$verticalScroll = (0, $lhaLc.keyframes)({
    from: {
        transform: "translateY(-200%)"
    },
    to: {
        transform: "translateY(-300%)"
    }
});
const $e0d6729bf3c3c3ec$var$horizontalScroll = (0, $lhaLc.keyframes)({
    from: {
        transform: "translateX(-200%)"
    },
    to: {
        transform: "translateX(-300%)"
    }
});
const $e0d6729bf3c3c3ec$var$responsiveGridCss = (0, $lhaLc.css)({
    display: "inline-flex",
    alignItems: "center",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear"
});
const $e0d6729bf3c3c3ec$var$containerCss = (0, $e82ba787de72625c$export$601469075a80284e)({
    "&:hover div": {
        userSelect: "none",
        animationPlayState: "paused"
    }
});
(0, $eSiQ2.Component)($e0d6729bf3c3c3ec$export$a606a0d663523950, {
    name: "ReviewsCarousel",
    gallery: {
        path: "Carousel",
        items: [
            {
                variants: [
                    {
                        props: {
                            reviews: [
                                ...new Array(3)
                            ].map((_, index, arr)=>({
                                    id: (0, $dAwef.Uuid)().valueOf(),
                                    title: "Impressive!",
                                    rating: 5,
                                    name: "John",
                                    text: "This service was so impressive, I won't hesitate to use it again.",
                                    timestamp: `${arr.length - index} days ago`
                                }))
                        }
                    }
                ]
            }
        ]
    }
});









var $f757eace85782171$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * @icon ui-message-heart-square
 */ function $f757eace85782171$var$PromotedReviews(section) {
    var _a, _b;
    const localize = (0, $aIeEI.useLocalize)();
    const reviews = (0, $e18f565b44c7bc7d$export$dfd0f591c1636cc4)();
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($13a9f30e9fa4b734$exports))));
    if (reviews.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)("div", {
        css: (0, $lhaLc.css)({
            display: "flex",
            flexDirection: "column"
        }, (0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: [
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                justifyContent: "space-between",
                children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                    level: 2,
                    padding: {
                        y: 8
                    },
                    truncate: true,
                    children: localize(section.heading)
                })
            }),
            section.text && (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                size: "lg",
                color: "gray400",
                margin: {
                    bottom: "sm"
                },
                children: localize(section.text)
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    overflow: "hidden",
                    width: "100vw",
                    marginLeft: "calc(50% - 50vw)"
                },
                children: (0, $4vwom.jsx)((0, $e0d6729bf3c3c3ec$export$a606a0d663523950), {
                    reviews: (_b = (_a = reviews.data) === null || _a === void 0 ? void 0 : _a.reviews.map((_a)=>{
                        var { id: id, rating: rating } = _a, r = $f757eace85782171$var$__rest(_a, [
                            "id",
                            "rating"
                        ]);
                        return {
                            id: id.valueOf(),
                            rating: rating.valueOf(),
                            name: localize(r.name),
                            title: localize(r.title),
                            text: localize(r.text),
                            timestamp: (Date.now() - new Date(r.timestamp.valueOf()).valueOf()) / 86400000 > 7 ? (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(r.timestamp.valueOf()).format("DD.MM.YYYY") : (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(r.timestamp.valueOf()).fromNow()
                        };
                    })) !== null && _b !== void 0 ? _b : [],
                    speed: section.carouselSpeed
                })
            }),
            section.cta ? (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                margin: {
                    top: "sm"
                },
                children: (0, $4vwom.jsxs)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    size: "md",
                    variant: "secondary",
                    iconEnd: "arrowRight",
                    css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                        width: "100%"
                    }),
                    as: "a",
                    href: section.cta.url.valueOf(),
                    children: [
                        (0, $4vwom.jsx)("div", {
                            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                                display: "none"
                            })),
                            children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: "trustpilot",
                                margin: {
                                    right: 8
                                }
                            })
                        }),
                        localize(section.cta.text)
                    ]
                })
            }) : null
        ]
    });
}
(0, $9G56J.Section)($f757eace85782171$var$PromotedReviews);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");


var $eSiQ2 = parcelRequire("eSiQ2");




const $b5697d901823e04f$var$themes = {
    light: {
        backgroundColor: "gray100",
        textColor: "gray500",
        iconColor: "forest",
        borderColor: "gray200"
    },
    dark: {
        backgroundColor: "gray500",
        textColor: "grayWhite",
        iconColor: "highlight",
        borderColor: "gray400"
    }
};
function $b5697d901823e04f$export$d02301dd4aaaa084(props) {
    var _a, _b;
    const theme = (_a = props.theme) !== null && _a !== void 0 ? _a : "light";
    const { helpers: helpers, colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const stackBreakpoint = (_b = props.stackBreakpoint) !== null && _b !== void 0 ? _b : "md";
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        borderRadius: props.fullWidth ? undefined : "lg",
        justifyContent: "center",
        css: (0, $lhaLc.css)(props.fullWidth && {
            width: "100vw",
            marginLeft: "calc(50% - 50vw)"
        }, {
            backgroundColor: colors[$b5697d901823e04f$var$themes[theme].backgroundColor]
        }, theme === "light" && responsiveCss("max", stackBreakpoint, {
            backgroundColor: "transparent"
        }), theme === "dark" && responsiveCss("max", stackBreakpoint, {
            paddingTop: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
            paddingBottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
        })),
        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            justifyContent: "space-evenly",
            css: (0, $lhaLc.css)({
                flexDirection: "row",
                padding: (0, $756948b644e82cf2$export$981516ee4691055c)(18)
            }, responsiveCss("max", stackBreakpoint, {
                flexDirection: "column",
                padding: 0
            }), props.fullWidth ? (0, $756948b644e82cf2$export$629e292a677297c2)() : {
                width: "100%"
            }),
            children: props.items.map((item)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    margin: {
                        x: 12
                    },
                    css: responsiveCss("max", stackBreakpoint, {
                        borderTop: `1px solid ${colors[$b5697d901823e04f$var$themes[theme].borderColor]}`,
                        margin: 0,
                        paddingTop: 16,
                        paddingBottom: 16,
                        "&:first-of-type": {
                            borderTop: "none",
                            paddingTop: 0
                        },
                        "&:last-of-type": {
                            paddingBottom: 0
                        }
                    }),
                    alignItems: "center",
                    children: [
                        (0, $4vwom.jsx)("div", {
                            children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: "check",
                                color: $b5697d901823e04f$var$themes[theme].iconColor
                            })
                        }),
                        (0, $4vwom.jsx)("div", {
                            css: (0, $lhaLc.css)({
                                marginLeft: 10,
                                marginTop: 0,
                                color: colors[$b5697d901823e04f$var$themes[theme].textColor]
                            }, responsiveCss("max", stackBreakpoint, {
                                marginLeft: 8
                            })),
                            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: (0, $4vwom.jsx)("div", {
                                    style: {
                                        fontWeight: "normal"
                                    },
                                    children: item
                                })
                            })
                        })
                    ]
                }, item))
        })
    });
}
(0, $eSiQ2.Component)($b5697d901823e04f$export$d02301dd4aaaa084, {
    name: "UniqueSellingPoints",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            items: [
                                "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                                "Donec eget fermentum lorem. Phasellus vulputate tortor a augue commodo efficitur.",
                                "Vestibulum efficitur tortor ante, quis varius tortor blandit in."
                            ]
                        }
                    }
                ]
            }
        ]
    }
});



function $487a5c3b29120f99$var$UniqueSellingPoints(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)(section.fullWidth ? undefined : {
            paddingTop: (0, $756948b644e82cf2$export$981516ee4691055c)(28),
            paddingBottom: (0, $756948b644e82cf2$export$981516ee4691055c)(12)
        }, section.fullWidth ? undefined : (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
            paddingTop: (0, $756948b644e82cf2$export$981516ee4691055c)(28),
            paddingBottom: (0, $756948b644e82cf2$export$981516ee4691055c)(28)
        }), section.hideBreakpoint && (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", section.hideBreakpoint, {
            display: "none"
        })),
        children: (0, $4vwom.jsx)((0, $b5697d901823e04f$export$d02301dd4aaaa084), {
            fullWidth: section.fullWidth,
            theme: section.theme,
            stackBreakpoint: section.stackBreakpoint,
            items: section.uniqueSellingPoints.map((item)=>localize(item.text))
        })
    });
}
(0, $9G56J.Section)("UniqueSellingPoints", $487a5c3b29120f99$var$UniqueSellingPoints);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $eSiQ2 = parcelRequire("eSiQ2");

var $aIeEI = parcelRequire("aIeEI");





parcelRequire("2LTO8");
var $2uVAW = parcelRequire("2uVAW");
var $gGZ2r = parcelRequire("gGZ2r");




function $6fd7eb60c364c4b3$export$f844f713529fc0d1(props) {
    const emailInputRef = (0, $eeH7J.useRef)(null);
    const localize = (0, $aIeEI.useLocalize)();
    const [formValues, setFormValues] = (0, $eeH7J.useState)($6fd7eb60c364c4b3$var$initialFormValue);
    const setFormValue = (0, $eeH7J.useCallback)((key, value)=>{
        setFormValues(Object.assign(Object.assign({}, formValues), {
            [key]: value
        }));
    }, [
        formValues,
        setFormValues
    ]);
    const [emailIsValid, setEmailIsValid] = (0, $eeH7J.useState)();
    const validatedFormValues = (0, $eeH7J.useMemo)(()=>{
        try {
            return Object.assign(Object.assign({}, formValues), {
                email: (0, $2uVAW.Email)(formValues.email)
            });
        } catch (err) {
            return undefined;
        }
    }, [
        formValues
    ]);
    const validateEmail = (0, $eeH7J.useCallback)(()=>{
        try {
            (0, $2uVAW.Email)(formValues.email);
            setEmailIsValid(true);
            return true;
        } catch (err) {
            setEmailIsValid(false);
            return false;
        }
    }, [
        formValues.email
    ]);
    const handleSubmitButtonClick = (0, $eeH7J.useCallback)(()=>{
        var _a;
        if (validatedFormValues) props.onSubmit(validatedFormValues);
        else (_a = emailInputRef.current) === null || _a === void 0 || _a.focus();
    }, [
        props,
        validatedFormValues
    ]);
    const handleClose = (0, $eeH7J.useCallback)(()=>{
        var _a;
        setFormValues($6fd7eb60c364c4b3$var$initialFormValue);
        setEmailIsValid(undefined);
        (_a = props.onClose) === null || _a === void 0 || _a.call(props);
    }, [
        props
    ]);
    return (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
        isOpen: props.isOpen,
        header: {
            title: props.title,
            closeButton: true
        },
        onClose: handleClose,
        children: props.submitSuccess ? (0, $4vwom.jsxs)("div", {
            style: {
                display: "grid",
                gridAutoFlow: "row",
                gap: 24
            },
            children: [
                (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                    value: props.successMessage
                }),
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "secondary",
                    onClick: props.onClose,
                    children: localize({
                        no: "Lukk",
                        en: "Close"
                    })
                })
            ]
        }) : (0, $4vwom.jsxs)("div", {
            style: {
                display: "grid",
                gridAutoFlow: "row",
                gap: 24
            },
            children: [
                (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                    size: "xl",
                    children: props.text
                }),
                (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                    type: "email",
                    autoComplete: "email",
                    ref: emailInputRef,
                    label: props.form.email.label,
                    value: formValues.email,
                    state: emailIsValid === false ? "error" : emailIsValid === true ? "completed" : undefined,
                    onChange: (e)=>{
                        if (emailIsValid === false) validateEmail();
                        setFormValue("email", e.target.value);
                    },
                    onBlur: validateEmail,
                    warning: emailIsValid === false ? localize($6fd7eb60c364c4b3$var$invalidEmailMessage) : undefined
                }),
                (0, $4vwom.jsx)((0, $50112aaf62b7ce57$export$ef9b1a59e592288f), {
                    label: props.form.phoneModel.label,
                    placeholder: localize($6fd7eb60c364c4b3$var$optionalTextLocalized),
                    options: props.form.phoneModel.options.map((o)=>({
                            value: o,
                            text: o
                        })),
                    value: formValues.phoneModel,
                    onChange: (e)=>setFormValue("phoneModel", e.target.value)
                }),
                (0, $4vwom.jsx)((0, $50112aaf62b7ce57$export$ef9b1a59e592288f), {
                    label: props.form.rentalPeriod.label,
                    placeholder: localize($6fd7eb60c364c4b3$var$optionalTextLocalized),
                    options: props.form.rentalPeriod.options,
                    value: formValues.rentalPeriod,
                    onChange: (e)=>setFormValue("rentalPeriod", e.target.value)
                }),
                (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                    checked: formValues.newsletterConsent,
                    onChange: (e)=>setFormValue("newsletterConsent", e.target.checked),
                    label: props.form.newsletterConsent.label
                }),
                props.errorMessage ? (0, $4vwom.jsx)((0, $a9f507254d800340$export$fbbf1dbfdbfcef12), {
                    margin: 0,
                    children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: props.errorMessage,
                        renderers: {
                            paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                    children: p.children
                                })
                        }
                    })
                }) : null,
                (0, $4vwom.jsxs)("div", {
                    style: {
                        display: "grid",
                        gridAutoFlow: "row",
                        gap: 8
                    },
                    children: [
                        (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                            onClick: handleSubmitButtonClick,
                            children: props.submitButtonText
                        }),
                        props.submitButtonSubText ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "sm",
                            color: "gray300",
                            style: {
                                textAlign: "center"
                            },
                            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: props.submitButtonSubText,
                                renderers: {
                                    paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                            children: p.children
                                        })
                                }
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
}
const $6fd7eb60c364c4b3$var$optionalTextLocalized = {
    no: "Valgfritt",
    en: "Optional"
};
const $6fd7eb60c364c4b3$var$initialFormValue = {
    email: "",
    phoneModel: "",
    rentalPeriod: "",
    newsletterConsent: false
};
const $6fd7eb60c364c4b3$var$invalidEmailMessage = {
    no: "Ugyldig e-postadresse.",
    en: "Invalid email address."
};
(0, $eSiQ2.Component)($6fd7eb60c364c4b3$export$f844f713529fc0d1, {
    name: "WaitingListSignupModal",
    gallery: {
        path: "Modal/WaitingListSignupModal",
        items: [
            {
                variants: [
                    {
                        props: {
                            title: "Stay up to date",
                            text: (0, $gGZ2r.Markdown)("We're super excited to let you in on a little secret \u2013 something amazing is coming your way soon! Get ready to be wowed by the future of Redoing it. Stay in the loop by signing up for exclusive updates and be the first to know when we go live. Thanks for sticking with us \u2013 we promise it'll be worth the wait!"),
                            submitButtonText: "Sign up",
                            isOpen: true,
                            onSubmit: (consent)=>{
                                // eslint-disable-next-line no-console
                                console.log("Submitted", consent);
                            },
                            form: {
                                email: {
                                    label: "E-postadresse"
                                },
                                phoneModel: {
                                    label: "Velg telefonmodell",
                                    options: [
                                        "iPhone 12",
                                        "iPhone 13"
                                    ]
                                },
                                rentalPeriod: {
                                    label: "Velg leieperiode",
                                    options: [
                                        {
                                            value: "1",
                                            text: "1 \xe5r"
                                        },
                                        {
                                            value: "2",
                                            text: "2 \xe5r"
                                        }
                                    ]
                                },
                                newsletterConsent: {
                                    label: "Jeg \xf8nsker \xe5 motta nyhetsbrev fra Redoit"
                                }
                            },
                            successMessage: (0, $gGZ2r.Markdown)("Success!")
                        }
                    }
                ]
            }
        ]
    }
});



const $942ca7574d2f9349$var$waitingListSignupModalId = "waiting-list-signup-modal";
/**
 * @icon ui-at-sign
 */ function $942ca7574d2f9349$var$WaitingListSignupModal(section) {
    const localize = (0, $aIeEI.useLocalize)();
    const modalRef = (0, $eeH7J.useRef)(null);
    const [modalIsOpen, setModalIsOpen] = (0, $eeH7J.useState)(false);
    const [submitSuccess, setSubmitSuccess] = (0, $eeH7J.useState)(false);
    const [submitError, setSubmitError] = (0, $eeH7J.useState)(false);
    const openModal = (0, $eeH7J.useCallback)(()=>{
        setModalIsOpen(true);
    }, [
        setModalIsOpen
    ]);
    const closeModal = (0, $eeH7J.useCallback)(()=>{
        setModalIsOpen(false);
    }, [
        setModalIsOpen
    ]);
    (0, $eeH7J.useEffect)(()=>{
        const ref = modalRef.current;
        ref === null || ref === void 0 || ref.addEventListener("open", openModal);
        return ()=>{
            ref === null || ref === void 0 || ref.removeEventListener("open", openModal);
        };
    }, [
        openModal
    ]);
    const locale = (0, $aIeEI.useCurrentLocale)();
    const handleSubmit = (0, $eeH7J.useCallback)(async (formData)=>{
        const data = {
            email: formData.email,
            phoneModel: formData.phoneModel || undefined,
            rentalPeriod: formData.rentalPeriod ? parseInt(formData.rentalPeriod) : undefined,
            newsletterConsent: formData.newsletterConsent,
            locale: locale
        };
        try {
            setSubmitError(false);
            await (0, $e18f565b44c7bc7d$export$2884e3ad03eef48)(data);
            setSubmitSuccess(true);
        } catch (err) {
            setSubmitError(true);
        }
        if (typeof fbq !== "undefined") fbq("track", "Lead");
    }, [
        setSubmitSuccess,
        setSubmitError,
        locale
    ]);
    return (0, $4vwom.jsx)("div", {
        id: $942ca7574d2f9349$var$waitingListSignupModalId,
        ref: modalRef,
        children: (0, $4vwom.jsx)((0, $6fd7eb60c364c4b3$export$f844f713529fc0d1), {
            isOpen: modalIsOpen,
            onClose: closeModal,
            title: localize(section.title),
            text: section.text ? localize(section.text) : undefined,
            form: {
                email: {
                    label: localize(section.emailInputLabel)
                },
                phoneModel: {
                    label: localize(section.phoneModelLabel),
                    options: section.phoneModelOptions.map((pmo)=>localize(pmo))
                },
                rentalPeriod: {
                    label: localize(section.rentalPeriodLabel),
                    options: [
                        ...Array(section.rentalPeriodMax)
                    ].map((_, i)=>({
                            value: `${i + 1}`,
                            text: `${i + 1} ${localize(section.rentalPeriodUnitLabel)}`
                        }))
                },
                newsletterConsent: {
                    label: localize(section.consentCheckboxLabel)
                }
            },
            submitButtonText: localize(section.signupButtonText),
            submitButtonSubText: localize(section.signupButtonSubText),
            onSubmit: handleSubmit,
            submitSuccess: submitSuccess,
            successMessage: localize(section.successMessage),
            errorMessage: submitError ? localize(section.errorMessage) : undefined
        })
    });
}
function $942ca7574d2f9349$export$d0de6de1c3580f91(source, e) {
    if (typeof window !== "undefined") {
        (0, $e18f565b44c7bc7d$export$a5a1f41fba9e8ed4)(source);
        const el = window.document.getElementById($942ca7574d2f9349$var$waitingListSignupModalId);
        const openModalEvent = new Event("open");
        el === null || el === void 0 || el.dispatchEvent(openModalEvent);
    }
    e === null || e === void 0 || e.preventDefault();
}
(0, $9G56J.Section)($942ca7574d2f9349$var$WaitingListSignupModal);



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");







function $e44ce30914311b18$var$WaitingListTrigger(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)("div", {
        css: (0, $756948b644e82cf2$export$f1cf1885b6bfef23)(),
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "lg",
            direction: "column",
            padding: 24,
            style: Object.assign({
                textAlign: "center",
                height: 300
            }, section.backgroundImage ? {
                backgroundImage: (0, $14q7s.ImageToCSS)(section.backgroundImage),
                backgroundSize: "cover",
                backgroundPosition: "center"
            } : {}),
            backgroundColor: section.backgroundColor,
            children: [
                section.heading ? (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                    level: 1,
                    margin: {
                        bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                    },
                    color: section.textColor,
                    children: localize(section.heading)
                }) : null,
                section.text ? (0, $4vwom.jsx)("div", {
                    style: {
                        marginBottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                    },
                    children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "lg",
                        color: section.textColor,
                        children: localize(section.text)
                    })
                }) : null,
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "dark",
                    size: "md",
                    onClick: ()=>{
                        var _a;
                        return (0, $942ca7574d2f9349$export$d0de6de1c3580f91)((_a = section.source) !== null && _a !== void 0 ? _a : "waiting-list-trigger");
                    },
                    children: localize(section.ctaText)
                })
            ]
        })
    });
}
(0, $9G56J.Section)($e44ce30914311b18$var$WaitingListTrigger);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $aIeEI = parcelRequire("aIeEI");


var $dUDPg = parcelRequire("dUDPg");






var $9G56J = parcelRequire("9G56J");




var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

function $1516a01fcc6e5048$export$ce1fcb9bf7d61ea1(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const [lock, setLock] = (0, $eeH7J.useState)(null);
    return (0, $4vwom.jsxs)("div", {
        style: {
            height: 32,
            position: "relative"
        },
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    pointerEvents: "none",
                    userSelect: "none",
                    position: "absolute",
                    width: 32,
                    height: 32,
                    boxShadow: "0px 2px 8px 0px #1307221F",
                    borderRadius: 32,
                    top: 0,
                    left: `${props.left * 90}%`,
                    zIndex: 10,
                    backgroundColor: "white"
                }
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    pointerEvents: "none",
                    userSelect: "none",
                    position: "absolute",
                    width: 32,
                    height: 32,
                    boxShadow: "0px 2px 8px 0px #1307221F",
                    borderRadius: 32,
                    top: 0,
                    right: `${(1 - props.right) * 90}%`,
                    zIndex: 10,
                    backgroundColor: "white"
                }
            }),
            (0, $4vwom.jsx)("div", {
                onPointerDown: (e)=>{
                    e.currentTarget.setPointerCapture(e.pointerId);
                    const rect = e.currentTarget.getBoundingClientRect();
                    const x = (e.clientX - rect.left) / rect.width;
                    const distLeft = Math.abs(x - props.left);
                    const distRight = Math.abs(x - props.right);
                    if (distLeft < distRight) setLock("left");
                    else setLock("right");
                },
                onPointerUp: ()=>setLock(null),
                onPointerMove: (e)=>{
                    const rect = e.currentTarget.getBoundingClientRect();
                    const x = (e.clientX - rect.left) / rect.width;
                    if (lock === "left") props.setLeft(Math.max(0, Math.min(x, props.right - 0.1)));
                    if (lock === "right") props.setRight(Math.min(1, Math.max(x, props.left + 0.1)));
                },
                style: {
                    height: 32,
                    width: "100%"
                }
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: 4,
                    borderRadius: 4,
                    backgroundColor: colors.brand,
                    width: "100%",
                    zIndex: -1
                }
            })
        ]
    });
}













(0, $9G56J.Section)($8a1361c8e89a1a34$var$AllProducts);
/**
 * Section presenting all available products.
 */ function $8a1361c8e89a1a34$var$AllProducts(section) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { colors: colors, responsiveCss: responsiveCss, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveSpacing: responsiveSpacing } = helpers;
    const localize = (0, $aIeEI.useLocalize)();
    const productCtaPageInfo = (0, $dUDPg.useWebPageInfo)(section.productCta.page);
    const localizeSlug = (0, $02ba3a727a0f8ecd$export$32f719dfac03c1cb)();
    const allColors = (0, $e18f565b44c7bc7d$export$b75b9022126d533b)();
    const allSizes = (0, $e18f565b44c7bc7d$export$4df04d41a3cf32b1)();
    const priceHistogram = (0, $e18f565b44c7bc7d$export$ada9abdd52b4cf46)();
    const [selectedSizes, setSelectedSizes] = (0, $eeH7J.useState)([]);
    const [selectedColors, setSelectedColors] = (0, $eeH7J.useState)([]);
    const [minPrice, setMinPrice] = (0, $eeH7J.useState)((_b = (_a = priceHistogram.data) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : undefined);
    const [maxPrice, setMaxPrice] = (0, $eeH7J.useState)((_d = (_c = priceHistogram.data) === null || _c === void 0 ? void 0 : _c.max) !== null && _d !== void 0 ? _d : undefined);
    const [priceRangeCollsapsed, setPriceRangeCollsapsed] = (0, $eeH7J.useState)(false);
    const [colorsCollsapsed, setColorsCollapsed] = (0, $eeH7J.useState)(false);
    const [storageSizesCollapsed, setStorageSizesCollapsed] = (0, $eeH7J.useState)(false);
    (0, $eeH7J.useEffect)(()=>{
        if (priceHistogram.data) {
            setMinPrice(priceHistogram.data.min);
            setMaxPrice(priceHistogram.data.max);
        }
    }, [
        priceHistogram.data
    ]);
    const rangeMin = (_f = (_e = priceHistogram.data) === null || _e === void 0 ? void 0 : _e.min) !== null && _f !== void 0 ? _f : 0;
    const rangeMax = (_h = (_g = priceHistogram.data) === null || _g === void 0 ? void 0 : _g.max) !== null && _h !== void 0 ? _h : 1;
    const range = rangeMax - rangeMin;
    const left = ((minPrice !== null && minPrice !== void 0 ? minPrice : 0) - rangeMin) / range;
    const right = ((maxPrice !== null && maxPrice !== void 0 ? maxPrice : 0) - rangeMin) / range;
    const [sortOrder, setSortOrder] = (0, $eeH7J.useState)("desc");
    const products = (0, $e18f565b44c7bc7d$export$88e20cfc122b8557)(undefined, selectedSizes, selectedColors, undefined);
    const filteredAndSortedProducts = (0, $eeH7J.useMemo)(()=>{
        var _a, _b;
        const fp = (_b = (_a = products.data) === null || _a === void 0 ? void 0 : _a.filter((p)=>p.monthlyPrice.itemsTotal.majorUnits.valueOf() >= (minPrice !== null && minPrice !== void 0 ? minPrice : 0) && p.monthlyPrice.itemsTotal.majorUnits.valueOf() <= (maxPrice !== null && maxPrice !== void 0 ? maxPrice : 1000000)).sort((a, b)=>(a.modelReleaseDate ? Date.parse(a.modelReleaseDate.valueOf()) : 0) > (b.modelReleaseDate ? Date.parse(b.modelReleaseDate.valueOf()) : 0) ? 1 : -1)) !== null && _b !== void 0 ? _b : [];
        if (sortOrder === "asc") return fp.reverse();
        return fp;
    }, [
        maxPrice,
        minPrice,
        sortOrder,
        products.data
    ]);
    const sortOrderOptions = [
        {
            value: "desc",
            text: localize({
                no: "Nyeste f\xf8rst",
                en: "Newest first"
            })
        },
        {
            value: "asc",
            text: localize({
                no: "Eldste f\xf8rst",
                en: "Oldest first"
            })
        }
    ];
    const [showFiltersModal, setShowFiltersModal] = (0, $eeH7J.useState)(false);
    if (allColors.loading || allSizes.loading || priceHistogram.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    const Filters = (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 24,
        css: (0, $lhaLc.css)({
            gridColumn: "1"
        }),
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 24,
                children: [
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        justifyContent: "space-between",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: ()=>setPriceRangeCollsapsed(!priceRangeCollsapsed),
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 3,
                                children: localize(section.filters.priceRange.heading)
                            }),
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: "chevronDown",
                                style: {
                                    transform: `rotate(${priceRangeCollsapsed ? 180 : 0}deg)`,
                                    transition: "all 200ms linear"
                                }
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)((0, $efb0893865373669$export$6eb0f7ddcda6131f), {
                        collapsed: priceRangeCollsapsed,
                        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            gap: 24,
                            children: [
                                (0, $4vwom.jsxs)("div", {
                                    children: [
                                        (0, $4vwom.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "row",
                                                height: 102,
                                                alignItems: "flex-end",
                                                padding: "0 40px",
                                                marginBottom: 2,
                                                gap: 2,
                                                position: "relative",
                                                zIndex: 0
                                            },
                                            children: (_j = priceHistogram.data) === null || _j === void 0 ? void 0 : _j.bars.map((p, i)=>(0, $4vwom.jsx)("div", {
                                                    style: {
                                                        bottom: 0,
                                                        height: p * 100 + "%",
                                                        borderTopLeftRadius: 4,
                                                        borderTopRightRadius: 4,
                                                        backgroundColor: colors.brandLight,
                                                        flex: 1
                                                    },
                                                    css: (0, $lhaLc.css)`
                                            font-size: 500;
                                        `
                                                }, `${p.toString()}${i}`))
                                        }),
                                        (0, $4vwom.jsx)("div", {
                                            style: {
                                                marginTop: -14,
                                                position: "relative",
                                                zIndex: 10
                                            },
                                            children: (0, $4vwom.jsx)((0, $1516a01fcc6e5048$export$ce1fcb9bf7d61ea1), {
                                                left: left,
                                                setLeft: (newLeft)=>setMinPrice(newLeft * range + rangeMin),
                                                right: right,
                                                setRight: (newRight)=>setMaxPrice(newRight * range + rangeMin)
                                            })
                                        })
                                    ]
                                }),
                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    gap: 16,
                                    children: [
                                        (0, $4vwom.jsx)("div", {
                                            style: {
                                                flex: 1
                                            },
                                            children: (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                                label: localize(section.filters.priceRange.minLabel),
                                                value: Math.round(minPrice !== null && minPrice !== void 0 ? minPrice : 0).toString()
                                            })
                                        }),
                                        (0, $4vwom.jsx)("div", {
                                            style: {
                                                flex: 1
                                            },
                                            children: (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                                label: localize(section.filters.priceRange.maxLabel),
                                                value: Math.round(maxPrice !== null && maxPrice !== void 0 ? maxPrice : 0).toString()
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                horizontal: true,
                spacing: 0
            }),
            (0, $4vwom.jsx)("div", {
                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    children: [
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            justifyContent: "space-between",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: ()=>setColorsCollapsed(!colorsCollsapsed),
                            children: [
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "heading",
                                    level: 3,
                                    margin: {
                                        bottom: 24
                                    },
                                    children: localize(section.filters.colors.heading)
                                }),
                                (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                    icon: "chevronDown",
                                    style: {
                                        transform: `rotate(${colorsCollsapsed ? 180 : 0}deg)`,
                                        transition: "all 200ms linear"
                                    }
                                })
                            ]
                        }),
                        (0, $4vwom.jsx)((0, $efb0893865373669$export$6eb0f7ddcda6131f), {
                            collapsed: colorsCollsapsed,
                            children: (_k = allColors.data) === null || _k === void 0 ? void 0 : _k.map((c)=>(0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                    padding: (0, $756948b644e82cf2$export$981516ee4691055c)(20),
                                    label: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        gap: 16,
                                        children: [
                                            (0, $4vwom.jsx)("div", {
                                                style: {
                                                    flexShrink: 0,
                                                    backgroundColor: c.color,
                                                    height: 24,
                                                    width: 24,
                                                    borderRadius: 24
                                                }
                                            }),
                                            localize(c.displayName)
                                        ]
                                    }),
                                    checked: selectedColors.includes(c.name),
                                    onChange: (v)=>setSelectedColors(v.target.checked ? [
                                            ...selectedColors,
                                            c.name
                                        ] : selectedColors.filter((id)=>id !== c.name))
                                }, `${c.name}`))
                        })
                    ]
                })
            }),
            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                horizontal: true,
                spacing: 0
            }),
            (0, $4vwom.jsxs)("div", {
                children: [
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        justifyContent: "space-between",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: ()=>setStorageSizesCollapsed(!storageSizesCollapsed),
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 3,
                                margin: {
                                    bottom: 24
                                },
                                children: localize(section.filters.storageSizes.heading)
                            }),
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: "chevronDown",
                                style: {
                                    transform: `rotate(${storageSizesCollapsed ? 180 : 0}deg)`,
                                    transition: "all 200ms linear"
                                }
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)((0, $efb0893865373669$export$6eb0f7ddcda6131f), {
                        collapsed: storageSizesCollapsed,
                        children: (_l = allSizes.data) === null || _l === void 0 ? void 0 : _l.map((s)=>(0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                label: s.displayName,
                                checked: selectedSizes.includes(s.name),
                                onChange: (v)=>setSelectedSizes(v.target.checked ? [
                                        ...selectedSizes,
                                        s.name
                                    ] : selectedSizes.filter((id)=>id !== s.name)),
                                padding: (0, $756948b644e82cf2$export$981516ee4691055c)(20)
                            }, s.name))
                    })
                ]
            })
        ]
    });
    if (!((_m = productCtaPageInfo.data) === null || _m === void 0 ? void 0 : _m.slug)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    justifyContent: "space-between",
                    alignItems: "center",
                    css: (0, $lhaLc.css)({
                        marginBottom: 16
                    }, responsiveCss("min", "md", {
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 2,
                            children: localize(section.heading)
                        }),
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            gap: 16,
                            alignItems: "center",
                            children: [
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "md",
                                    css: responsiveCss("max", "md", {
                                        display: "none"
                                    }),
                                    children: localize({
                                        no: "Vis",
                                        en: "Show"
                                    })
                                }),
                                (0, $4vwom.jsx)((0, $f8bb6ad0e871adee$export$931cbfb6bfb85fc), {
                                    value: sortOrder,
                                    options: sortOrderOptions,
                                    onChange: (e, val)=>setSortOrder(val)
                                })
                            ]
                        })
                    ]
                }),
                (0, $4vwom.jsxs)("div", {
                    css: (0, $lhaLc.css)({
                        marginBottom: 16
                    }, responsiveCss("min", "md", {
                        display: "none"
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                            horizontal: true,
                            spacing: "sm"
                        }),
                        (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                            iconStart: "filter",
                            variant: "light",
                            css: (0, $lhaLc.css)({
                                boxShadow: $e665a5c3bf2ac3f6$export$16e1fc8de5cd9687
                            }),
                            fullwidth: true,
                            onClick: ()=>setShowFiltersModal(true),
                            children: localize({
                                no: "Filter",
                                en: "Filter"
                            })
                        }),
                        (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                            isOpen: showFiltersModal,
                            onClose: ()=>setShowFiltersModal(false),
                            header: {
                                icon: "filter",
                                closeButton: true,
                                title: localize({
                                    no: "Filter",
                                    en: "Filter"
                                }),
                                divider: true
                            },
                            width: "100%",
                            children: Filters
                        })
                    ]
                }),
                (0, $4vwom.jsxs)("div", {
                    css: (0, $lhaLc.css)({
                        display: "grid"
                    }, responsiveCss("max", "sm", {
                        gridAutoFlow: "row",
                        gridTemplateRows: "1fr"
                    }), responsiveCss("min", "md", {
                        gridTemplateColumns: "1fr 1fr 1fr",
                        alignItems: "start"
                    }), responsiveSpacing("sm", "gap")),
                    children: [
                        (0, $4vwom.jsx)("div", {
                            css: responsiveCss("max", "sm", {
                                display: "none"
                            }),
                            children: Filters
                        }),
                        (0, $4vwom.jsxs)("div", {
                            css: (0, $lhaLc.css)({
                                display: "grid"
                            }, responsiveCss("max", "sm", {
                                gridAutoFlow: "row",
                                gridTemplateRows: "1fr"
                            }), responsiveCss("min", "md", {
                                gridTemplateColumns: "1fr 1fr",
                                gridColumn: "2 / 4",
                                gridAutoRows: "1fr"
                            }), responsiveSpacing("sm", "gap")),
                            children: [
                                !filteredAndSortedProducts.length ? (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    gap: 32,
                                    direction: "column",
                                    style: {
                                        width: "100%",
                                        gridColumn: " span 2"
                                    },
                                    children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        backgroundColor: "gray100",
                                        justifyContent: "center",
                                        borderRadius: "md",
                                        padding: 64,
                                        children: [
                                            section.noMatches.image ? (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                                image: section.noMatches.image,
                                                width: 400
                                            }) : null,
                                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                gap: 16,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                direction: "column",
                                                children: [
                                                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                        level: 2,
                                                        children: localize(section.noMatches.heading)
                                                    }),
                                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "body",
                                                        size: "lg",
                                                        children: localize(section.noMatches.text)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }) : undefined,
                                filteredAndSortedProducts.map((p, i)=>{
                                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                                    return (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                        children: [
                                            (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                                css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                                                    display: "none"
                                                })),
                                                children: (0, $4vwom.jsx)((0, $b7d6468cd3704e06$export$e6cbe35324ccf844), {
                                                    alwaysShowCta: section.productCta.alwaysShow,
                                                    name: localize(p.name),
                                                    features: (_b = (_a = p.features) === null || _a === void 0 ? void 0 : _a.map((f)=>localize(f.text))) !== null && _b !== void 0 ? _b : [],
                                                    price: localize({
                                                        no: `Fra ${p.monthlyPrice.itemsTotal.majorUnits.toString()} kr/md`,
                                                        en: `From ${p.monthlyPrice.itemsTotal.majorUnits.toString()} NOK/mo`
                                                    }),
                                                    // highlightPrice={p.highlightPrice}
                                                    image: (_c = p.images) === null || _c === void 0 ? void 0 : _c[0],
                                                    cta: {
                                                        text: localize(section.productCta.text),
                                                        url: `${localizeSlug((_d = productCtaPageInfo.data) === null || _d === void 0 ? void 0 : _d.slug)}?${(0, $f4c4c9282b17128a$export$cefacdcddab7996c)({
                                                            phoneId: p.id
                                                        })}`
                                                    },
                                                    relativePhysicalSize: (_e = p.relativePhysicalSize) === null || _e === void 0 ? void 0 : _e.valueOf()
                                                })
                                            }),
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                direction: "column",
                                                gap: 16,
                                                css: responsiveCss("min", "md", {
                                                    display: "none"
                                                }),
                                                children: (0, $4vwom.jsx)((0, $b7d6468cd3704e06$export$e6cbe35324ccf844), {
                                                    alwaysShowCta: section.productCta.alwaysShow,
                                                    name: localize(p.name),
                                                    features: (_g = (_f = p.features) === null || _f === void 0 ? void 0 : _f.map((f)=>localize(f.text))) !== null && _g !== void 0 ? _g : [],
                                                    price: localize({
                                                        no: `Fra ${p.monthlyPrice.itemsTotal.majorUnits.toString()} kr/md`,
                                                        en: `From ${p.monthlyPrice.itemsTotal.majorUnits.toString()} NOK/mo`
                                                    }),
                                                    // highlightPrice={p.highlightPrice}
                                                    image: (_h = p.images) === null || _h === void 0 ? void 0 : _h[0],
                                                    cta: {
                                                        text: localize(section.productCta.text),
                                                        url: `${localizeSlug((_j = productCtaPageInfo.data) === null || _j === void 0 ? void 0 : _j.slug)}?${(0, $f4c4c9282b17128a$export$cefacdcddab7996c)({
                                                            phoneId: p.id
                                                        })}`
                                                    },
                                                    relativePhysicalSize: (_k = p.relativePhysicalSize) === null || _k === void 0 ? void 0 : _k.valueOf(),
                                                    compact: true
                                                })
                                            })
                                        ]
                                    }, p.id.valueOf());
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");


var $9G56J = parcelRequire("9G56J");


var $aIeEI = parcelRequire("aIeEI");









var $eeH7J = parcelRequire("eeH7J");


parcelRequire("2LTO8");
var $dAwef = parcelRequire("dAwef");



var $dUDPg = parcelRequire("dUDPg");


parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");

var $34lt5 = parcelRequire("34lt5");




(0, $9G56J.Section)($2446a2453fd6c8db$var$AccountOverview);
function $2446a2453fd6c8db$var$AccountOverview(section) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    const localize = (0, $aIeEI.useLocalize)();
    const logOutWithVipps = (0, $f2e2333c5543d6d8$export$7a6e57dc0a3ed9e2)();
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($cddd760e1f8ca7cc$exports))));
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        css: (0, $lhaLc.css)({
            paddingTop: 32,
            paddingBottom: 32
        }, responsiveCss("min", "md", {
            paddingTop: 64,
            paddingBottom: 64
        })),
        children: (0, $4vwom.jsxs)("div", {
            style: {
                width: "100%"
            },
            css: (0, $lhaLc.css)({
                display: "grid",
                gridTemplateAreas: '"text details" "menu details"',
                gridTemplateColumns: "56fr 70fr",
                gridTemplateRows: "minmax(0, auto)",
                columnGap: (0, $756948b644e82cf2$export$981516ee4691055c)(140)
            }, responsiveCss("max", "sm", {
                gridTemplateAreas: '"text" "details" "menu"',
                gridTemplateRows: "auto",
                gridTemplateColumns: "1fr",
                rowGap: 32
            }), responsiveCss("min", "lg", {
                paddingLeft: 96,
                paddingRight: 96
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    gap: 16,
                    style: {
                        gridArea: "text",
                        minWidth: 0
                    },
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 1,
                            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.heading), {
                                givenName: (_b = (_a = me.data) === null || _a === void 0 ? void 0 : _a.givenName) !== null && _b !== void 0 ? _b : "",
                                familyName: (_d = (_c = me.data) === null || _c === void 0 ? void 0 : _c.familyName) !== null && _d !== void 0 ? _d : ""
                            })
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "lg",
                            color: "gray400",
                            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.subheading), {
                                givenName: (_f = (_e = me.data) === null || _e === void 0 ? void 0 : _e.givenName) !== null && _f !== void 0 ? _f : "",
                                familyName: (_h = (_g = me.data) === null || _g === void 0 ? void 0 : _g.familyName) !== null && _h !== void 0 ? _h : ""
                            })
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 28,
                    direction: "column",
                    margin: {
                        top: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                    },
                    style: {
                        gridArea: "menu",
                        minWidth: 0
                    },
                    children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        style: {
                            cursor: "pointer"
                        },
                        justifyContent: "space-between",
                        alignItems: "center",
                        onClick: async ()=>{
                            await logOutWithVipps();
                            window.location.href = "/";
                        },
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 3,
                                children: localize({
                                    no: "Logg ut",
                                    en: "Sign out"
                                })
                            }),
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: "arrowRight"
                            })
                        ]
                    })
                }),
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    style: {
                        gridArea: "details",
                        minWidth: 0
                    },
                    children: [
                        (0, $4vwom.jsx)($2446a2453fd6c8db$var$ActiveSubscriptions, Object.assign({}, section.activeSubscriptions)),
                        (0, $4vwom.jsx)($2446a2453fd6c8db$var$PaymentMethods, Object.assign({}, section.paymentMethods))
                    ]
                })
            ]
        })
    });
}
function $2446a2453fd6c8db$var$ActiveSubscriptions(props) {
    var _a;
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const orders = (0, $e18f565b44c7bc7d$export$25a35ae850463813)();
    const localize = (0, $aIeEI.useLocalize)();
    const [descriptionModalIsOpen, setDescriptionModalIsOpen] = (0, $eeH7J.useState)();
    const detailsPageInfo = (0, $dUDPg.useWebPageInfo)(props.detailsPage);
    if (!((_a = orders.data) === null || _a === void 0 ? void 0 : _a.orders.length)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 3,
                margin: {
                    bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                },
                children: localize(props.heading)
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                direction: "column",
                children: orders.data.orders.map((order)=>{
                    var _a, _b, _c, _d;
                    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        as: "a",
                        backgroundColor: "gray100",
                        href: ((_a = detailsPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) ? `/${localize(detailsPageInfo.data.slug)}?id=${order.id.valueOf()}` : "",
                        direction: "column",
                        borderRadius: "md",
                        children: [
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                css: (0, $lhaLc.css)({
                                    padding: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                                    gap: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                                }, responsiveCss("min", "md", {
                                    padding: (0, $756948b644e82cf2$export$981516ee4691055c)(40),
                                    gap: (0, $756948b644e82cf2$export$981516ee4691055c)(32)
                                })),
                                children: [
                                    (0, $4vwom.jsx)("div", {
                                        css: (0, $lhaLc.css)({
                                            width: (0, $756948b644e82cf2$export$981516ee4691055c)(72),
                                            flex: "0 0 auto"
                                        }, responsiveCss("min", "md", {
                                            width: (0, $756948b644e82cf2$export$981516ee4691055c)(120)
                                        })),
                                        children: !!((_b = order.phone.images) === null || _b === void 0 ? void 0 : _b[0]) && (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                            image: order.phone.images[0],
                                            width: 120,
                                            style: {
                                                width: "100%"
                                            }
                                        })
                                    }),
                                    (0, $4vwom.jsx)("div", {
                                        style: {
                                            flexGrow: 1
                                        },
                                        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            css: (0, $lhaLc.css)({
                                                gap: 16
                                            }, responsiveCss("min", "md", {
                                                gap: 24
                                            })),
                                            children: [
                                                (0, $4vwom.jsxs)("div", {
                                                    css: (0, $lhaLc.css)({
                                                        display: "grid",
                                                        gridTemplateAreas: order.model.features && order.model.features.length > 0 ? '"heading button" "features button"' : '"heading button"',
                                                        gridTemplateColumns: "1fr auto",
                                                        gridTemplateRows: "auto auto",
                                                        columnGap: 8
                                                    }),
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                            style: {
                                                                gridArea: "heading"
                                                            },
                                                            alignItems: "center",
                                                            children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                                level: 4,
                                                                children: localize(order.model.name)
                                                            })
                                                        }),
                                                        order.model.features && order.model.features.length > 0 && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                            gap: 8,
                                                            alignItems: "center",
                                                            style: {
                                                                gridArea: "features",
                                                                overflow: "hidden"
                                                            },
                                                            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                color: "gray300",
                                                                css: (0, $lhaLc.css)({
                                                                    display: "inline-block",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    flex: "1 1 auto"
                                                                }),
                                                                children: order.model.features.map((feature, index)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                                        children: [
                                                                            index > 0 && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                                variant: "body",
                                                                                size: [
                                                                                    "lg",
                                                                                    [
                                                                                        "min",
                                                                                        "lg",
                                                                                        "xl"
                                                                                    ]
                                                                                ],
                                                                                color: "gray300",
                                                                                css: (0, $lhaLc.css)({
                                                                                    display: "inline-block",
                                                                                    marginLeft: 8,
                                                                                    marginRight: 8
                                                                                }),
                                                                                children: "\xb7"
                                                                            }),
                                                                            localize(feature.text)
                                                                        ]
                                                                    }, feature.id.valueOf()))
                                                            })
                                                        }),
                                                        (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                            style: {
                                                                gridArea: "button"
                                                            },
                                                            alignItems: "center",
                                                            children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                                size: [
                                                                    "xs",
                                                                    [
                                                                        "min",
                                                                        "md",
                                                                        "sm"
                                                                    ]
                                                                ],
                                                                iconStart: "chevronDown",
                                                                variant: "light",
                                                                onClick: (e)=>{
                                                                    setDescriptionModalIsOpen(order.id);
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                }
                                                            })
                                                        }),
                                                        order.model.description && (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                                                            header: {
                                                                icon: "device",
                                                                title: localize({
                                                                    no: "Produktdetaljer",
                                                                    en: "Product details"
                                                                }),
                                                                closeButton: true
                                                            },
                                                            isOpen: descriptionModalIsOpen === order.id,
                                                            onClose: ()=>setDescriptionModalIsOpen(undefined),
                                                            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                                                    value: localize(order.model.description)
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (0, $4vwom.jsx)("div", {
                                                    css: responsiveCss("max", "sm", {
                                                        display: "none"
                                                    }),
                                                    children: (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                                        horizontal: true,
                                                        spacing: 0
                                                    })
                                                }),
                                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    direction: "column",
                                                    gap: 4,
                                                    children: [
                                                        (0, $4vwom.jsx)("div", {
                                                            style: {
                                                                display: "inline-flex",
                                                                color: order.cancelled ? colors.gray300 : undefined
                                                            },
                                                            children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                                alignItems: "baseline",
                                                                gap: 4,
                                                                css: order.cancelled ? (0, $lhaLc.css)({
                                                                    position: "relative",
                                                                    ":after": {
                                                                        position: "absolute",
                                                                        content: '""',
                                                                        width: "100%",
                                                                        borderBottom: "1px solid",
                                                                        top: "56%"
                                                                    }
                                                                }) : undefined,
                                                                children: [
                                                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                        variant: "heading",
                                                                        level: 3,
                                                                        children: (_c = order.rentalPeriods[0]) === null || _c === void 0 ? void 0 : _c.monthlyPrice.itemsTotal.majorUnits.valueOf()
                                                                    }),
                                                                    (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                        variant: "body",
                                                                        size: "sm",
                                                                        children: [
                                                                            (_d = order.rentalPeriods[0]) === null || _d === void 0 ? void 0 : _d.monthlyPrice.itemsTotal.currency.toLowerCase(),
                                                                            "/",
                                                                            localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        order.nextChargeDate ? (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                            variant: "body",
                                                            size: "sm",
                                                            children: [
                                                                localize({
                                                                    no: "Neste forfall",
                                                                    en: "Lease due date"
                                                                }),
                                                                ":",
                                                                " ",
                                                                (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(order.nextChargeDate).format("Do MMMM YYYY")
                                                            ]
                                                        }) : null,
                                                        order.cancelled && (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                            gap: 4,
                                                            alignItems: "center",
                                                            children: [
                                                                (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                                    icon: "warning",
                                                                    color: "brand"
                                                                }),
                                                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                    variant: "body",
                                                                    size: "sm",
                                                                    color: "brand",
                                                                    children: localize(props.cancelledLabelText)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 0
                            }),
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                padding: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                                justifyContent: "flex-end",
                                children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                    variant: "dark",
                                    size: "sm",
                                    children: localize(props.detailsButtonText)
                                })
                            })
                        ]
                    }, order.id.valueOf());
                })
            })
        ]
    });
}
function $2446a2453fd6c8db$var$PaymentMethods(props) {
    var _a, _b, _c, _d;
    const theme = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { colors: colors, helpers: helpers } = theme;
    const { responsiveCss: responsiveCss } = helpers;
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    const localize = (0, $aIeEI.useLocalize)();
    const paymentOptions = (0, $e18f565b44c7bc7d$export$b66da2e92981394)();
    const orders = (0, $e18f565b44c7bc7d$export$25a35ae850463813)();
    // An id to provide as a parameter to the add card operation.
    const [addCardId, setAddCardId] = (0, $eK8Q4.useSessionState)("payment-methods-add-id", undefined);
    // For storing cards already added to the profile before adding a new one, so that we can set
    // the new card as the currently active automatically.
    const [originalCardIds, setOriginalCardIds] = (0, $eeH7J.useState)([]);
    const handleNewCardAdded = (0, $eeH7J.useCallback)(async ()=>{
        var _a;
        const newPaymentOption = (_a = paymentOptions.data) === null || _a === void 0 ? void 0 : _a.find((po)=>{
            var _a;
            return !originalCardIds.includes((_a = po.id) !== null && _a !== void 0 ? _a : "");
        });
        if (newPaymentOption === null || newPaymentOption === void 0 ? void 0 : newPaymentOption.id) {
            await (0, $e18f565b44c7bc7d$export$d1167dfb180ea832)({
                storedPaymentMethodId: newPaymentOption.id
            });
            me.refresh();
        }
    }, [
        paymentOptions.data,
        originalCardIds,
        me
    ]);
    const [optionsForId, setOptionsForId] = (0, $eeH7J.useState)();
    const [modalIsOpen, setModalIsOpen] = (0, $eeH7J.useState)(false);
    const [isError, setIsError] = (0, $eeH7J.useState)(false);
    if (!((_a = orders.data) === null || _a === void 0 ? void 0 : _a.orders.length) && !((_b = paymentOptions.data) === null || _b === void 0 ? void 0 : _b.length)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 3,
                margin: {
                    top: 32,
                    bottom: 16
                },
                children: localize(props.heading)
            }),
            !((_c = paymentOptions.data) === null || _c === void 0 ? void 0 : _c.length) && (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                margin: {
                    bottom: "md"
                },
                children: (0, $4vwom.jsx)((0, $192171ee7c657b77$export$14834abbfce3b8cd), {
                    text: localize(props.noPaymentMethods),
                    icon: "warning",
                    color: "gray350"
                })
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 24,
                children: [
                    (_d = paymentOptions.data) === null || _d === void 0 ? void 0 : _d.map((paymentOption)=>{
                        var _a, _b, _c, _d;
                        return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                width: "100%",
                                position: "relative"
                            },
                            borderColor: "gray200",
                            borderRadius: "md",
                            padding: "sm",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    alignItems: "center",
                                    css: (0, $lhaLc.css)({
                                        gap: 16
                                    }, responsiveCss("min", "lg", {
                                        gap: 24
                                    })),
                                    children: [
                                        paymentOption.brand === "visa" ? (0, $4vwom.jsx)($2446a2453fd6c8db$var$Visa, {}) : paymentOption.brand === "mc" ? (0, $4vwom.jsx)($2446a2453fd6c8db$var$MasterCard, {}) : /applepay/.test((_a = paymentOption.brand) !== null && _a !== void 0 ? _a : "") ? (0, $4vwom.jsx)($2446a2453fd6c8db$var$ApplePay, {}) : paymentOption.brand,
                                        ((_b = me.data) === null || _b === void 0 ? void 0 : _b.preferredStoredPaymentMethodId) === paymentOption.id ? (0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                                            color: "gray500",
                                            size: [
                                                "fixed",
                                                "xs",
                                                "md"
                                            ],
                                            children: localize(props.preferredLabel)
                                        }) : null
                                    ]
                                }),
                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    alignItems: "center",
                                    style: {
                                        fontVariantNumeric: "tabular-nums",
                                        position: "relative"
                                    },
                                    css: (0, $lhaLc.css)({
                                        gap: 16
                                    }, responsiveCss("min", "lg", {
                                        gap: 24
                                    })),
                                    children: [
                                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            alignItems: "center",
                                            gap: 8,
                                            children: [
                                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    alignItems: "center",
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                            icon: "asterisk",
                                                            size: 16,
                                                            color: "gray300"
                                                        }),
                                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                            icon: "asterisk",
                                                            size: 16,
                                                            color: "gray300"
                                                        }),
                                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                            icon: "asterisk",
                                                            size: 16,
                                                            color: "gray300"
                                                        }),
                                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                            icon: "asterisk",
                                                            size: 16,
                                                            color: "gray300"
                                                        })
                                                    ]
                                                }),
                                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                    variant: "body",
                                                    size: "md",
                                                    children: paymentOption.lastFour
                                                })
                                            ]
                                        }),
                                        (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                            variant: "body",
                                            size: "md",
                                            children: [
                                                paymentOption.expiryMonth,
                                                "/",
                                                paymentOption.expiryYear
                                            ]
                                        }),
                                        (0, $4vwom.jsx)("div", {
                                            style: {
                                                flexShrink: 0
                                            },
                                            children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                iconStart: "more",
                                                size: "xs",
                                                variant: "secondary",
                                                disabled: ((_c = me.data) === null || _c === void 0 ? void 0 : _c.preferredStoredPaymentMethodId) === paymentOption.id,
                                                onClick: ()=>setOptionsForId(paymentOption.id)
                                            })
                                        }),
                                        optionsForId === paymentOption.id && (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            style: {
                                                position: "absolute",
                                                right: 0,
                                                top: 0,
                                                bottom: 0
                                            },
                                            backgroundColor: "grayWhite",
                                            css: (0, $lhaLc.css)({
                                                gap: 16
                                            }, responsiveCss("min", "lg", {
                                                gap: 24
                                            }), {
                                                "&:before": {
                                                    content: '""',
                                                    height: "100%",
                                                    width: 48,
                                                    background: "linear-gradient(270deg, rgba(255, 255,255,0), rgba(255, 255,255,1))"
                                                }
                                            }),
                                            children: [
                                                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                    variant: "light",
                                                    size: "xs",
                                                    onClick: async ()=>{
                                                        if (paymentOption.id) {
                                                            await (0, $e18f565b44c7bc7d$export$d1167dfb180ea832)({
                                                                storedPaymentMethodId: paymentOption.id
                                                            });
                                                            me.refresh();
                                                            setOptionsForId(undefined);
                                                        }
                                                    },
                                                    children: localize(props.setAsPreferredButtonText)
                                                }),
                                                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                    iconStart: "close",
                                                    size: "xs",
                                                    variant: "secondary",
                                                    onClick: ()=>setOptionsForId(undefined),
                                                    disabled: ((_d = me.data) === null || _d === void 0 ? void 0 : _d.preferredStoredPaymentMethodId) === paymentOption.id
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, paymentOption.id);
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: ()=>{
                            setAddCardId((0, $dAwef.Uuid)().toString());
                            setModalIsOpen(true);
                        },
                        children: localize(props.addPaymentMethods.modalTriggerButtonText)
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                isOpen: modalIsOpen,
                width: 640,
                onClose: ()=>setModalIsOpen(false),
                header: {
                    title: localize(props.addPaymentMethods.modalTitle),
                    closeButton: true
                },
                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    gap: 24,
                    css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$682f474bed45e419), (0, $lhaLc.css)({
                        ".adyen-checkout__payment-method__header": {
                            display: "none"
                        }
                    })),
                    children: [
                        props.addPaymentMethods.modalText ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: localize(props.addPaymentMethods.modalText)
                        }) : null,
                        isError ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                            children: [
                                (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                    value: localize(props.addPaymentMethods.errorMessage)
                                }),
                                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                    variant: "dark",
                                    onClick: ()=>setIsError(false),
                                    children: localize({
                                        no: "Pr\xf8v igjen",
                                        en: "Try again"
                                    })
                                })
                            ]
                        }) : (0, $4vwom.jsx)((0, $ceb61c869c7a4551$export$8917e58bffe5ae62), {
                            onSuccess: async ()=>{
                                var _a, _b;
                                setOriginalCardIds((_b = (_a = paymentOptions.data) === null || _a === void 0 ? void 0 : _a.map((po)=>po.id)) !== null && _b !== void 0 ? _b : []);
                                await paymentOptions.refresh();
                                handleNewCardAdded();
                                setModalIsOpen(false);
                            },
                            onError: ()=>setIsError(true),
                            filterStoredPaymentMethods: ()=>false,
                            adyenOrder: "add-payment-method",
                            adyenOrderId: addCardId,
                            translations: {
                                "no-NO": {
                                    "creditCard.holderName.placeholder": localize(props.addPaymentMethods.cardholderNamePlaceholder, (0, $34lt5.LocaleKey).no)
                                },
                                "en-US": {
                                    "creditCard.holderName.placeholder": localize(props.addPaymentMethods.cardholderNamePlaceholder, (0, $34lt5.LocaleKey).en)
                                }
                            },
                            styles: {
                                base: {
                                    color: colors.gray500,
                                    fontWeight: "300",
                                    fontSize: "16px"
                                },
                                placeholder: {
                                    color: colors.gray300,
                                    fontWeight: "300",
                                    fontSize: "16px"
                                }
                            }
                        })
                    ]
                })
            })
        ]
    });
}
function $2446a2453fd6c8db$var$Visa(props) {
    return (0, $4vwom.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 26,
        viewBox: "0 0 40 26",
        fill: "none"
    }, props, {
        children: [
            (0, $4vwom.jsx)("path", {
                fill: "#fff",
                d: "M0 0h40v26H0z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#1434CB",
                d: "m15.9 7.7-4.43 10.6h-2.9l-2.2-8.47c-.13-.52-.25-.71-.65-.93C5.05 8.55 3.96 8.2 3 8l.07-.32h4.67c.6 0 1.13.4 1.27 1.09l1.15 6.14 2.86-7.23h2.89Zm11.39 7.15c0-2.8-3.88-2.96-3.85-4.21 0-.38.37-.79 1.16-.9a5.2 5.2 0 0 1 2.71.48l.48-2.25a7.4 7.4 0 0 0-2.57-.47c-2.71 0-4.62 1.44-4.64 3.51-.02 1.53 1.36 2.38 2.4 2.9 1.08.51 1.44.85 1.43 1.31 0 .71-.85 1.03-1.64 1.04-1.39.02-2.19-.37-2.82-.67l-.5 2.33c.64.29 1.82.55 3.05.56 2.89 0 4.78-1.42 4.79-3.63Zm7.17 3.46H37L34.78 7.7h-2.34c-.53 0-.98.3-1.17.78l-4.12 9.84h2.88l.57-1.58h3.53l.33 1.58Zm-3.07-3.76 1.45-3.99.83 4H31.4ZM19.83 7.7l-2.27 10.62h-2.74L17.09 7.7h2.74Z"
            })
        ]
    }));
}
function $2446a2453fd6c8db$var$MasterCard(props) {
    return (0, $4vwom.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 26,
        viewBox: "0 0 40 26"
    }, props, {
        children: [
            (0, $4vwom.jsx)("path", {
                fill: "#fff",
                d: "M0 0h40v26H0z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#F06022",
                d: "M16.13 19.29h7.74V6.7h-7.74v12.58z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#EA1D25",
                d: "M16.93 13A7.93 7.93 0 0 1 20 6.71a8.02 8.02 0 0 0-10.65.65 7.96 7.96 0 0 0 0 11.28 8.02 8.02 0 0 0 10.65.65A8.02 8.02 0 0 1 16.93 13"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#F79D1D",
                d: "M33 13c0 2.12-.84 4.15-2.34 5.65a8.1 8.1 0 0 1-10.66.64A8.05 8.05 0 0 0 23.07 13 7.96 7.96 0 0 0 20 6.71a8.02 8.02 0 0 1 10.66.64A7.93 7.93 0 0 1 33 13"
            })
        ]
    }));
}
function $2446a2453fd6c8db$var$ApplePay(props) {
    return (0, $4vwom.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 26,
        viewBox: "0 0 40 26"
    }, props, {
        children: [
            (0, $4vwom.jsx)("path", {
                fill: "#000",
                d: "M36.42 0H3.58a69.25 69.25 0 0 0-.75 0c-.25.01-.5.03-.76.07a2.51 2.51 0 0 0-1.32.7A2.43 2.43 0 0 0 .07 2.1 5.14 5.14 0 0 0 0 3.22v19.91c.01.25.03.51.07.76a2.6 2.6 0 0 0 .68 1.35 2.39 2.39 0 0 0 1.32.69 4.98 4.98 0 0 0 1.1.07h34a5 5 0 0 0 .76-.07 2.5 2.5 0 0 0 1.32-.7 2.44 2.44 0 0 0 .68-1.34 5.13 5.13 0 0 0 .07-1.11V2.87a6.5 6.5 0 0 0-.07-.76 2.58 2.58 0 0 0-.68-1.35 2.4 2.4 0 0 0-1.32-.69 4.96 4.96 0 0 0-1.1-.07h-.41Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#fff",
                d: "M36.42.87h.73c.2 0 .42.02.62.06a1.67 1.67 0 0 1 .88.44 1.58 1.58 0 0 1 .44.89 4.38 4.38 0 0 1 .06.97v19.55a14.67 14.67 0 0 1-.06.96 1.7 1.7 0 0 1-.44.89 1.54 1.54 0 0 1-.87.44 4.27 4.27 0 0 1-.96.06H2.85a3.7 3.7 0 0 1-.63-.06 1.66 1.66 0 0 1-.87-.45 1.56 1.56 0 0 1-.44-.88 4.35 4.35 0 0 1-.06-.97V2.9c.01-.2.02-.42.06-.63.03-.18.08-.34.16-.49A1.56 1.56 0 0 1 2.22.93a4.2 4.2 0 0 1 .96-.06h33.24"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#000",
                d: "M10.92 8.61c.34-.43.57-1 .51-1.59a2.21 2.21 0 0 0-1.99 2.3c.56.04 1.12-.3 1.48-.7Zm.51.81c-.82-.05-1.52.46-1.9.46-.4 0-1-.44-1.64-.42-.84 0-1.62.48-2.05 1.24-.88 1.52-.23 3.76.62 5 .42.6.92 1.27 1.58 1.25.62-.02.86-.4 1.62-.4.75 0 .97.4 1.63.39.69-.01 1.11-.61 1.53-1.22.47-.7.67-1.37.68-1.4-.01-.02-1.32-.52-1.33-2.02-.01-1.26 1.03-1.85 1.07-1.9a2.34 2.34 0 0 0-1.81-.98Zm7.11-1.7a2.87 2.87 0 0 1 3.02 3c0 1.8-1.27 3.03-3.06 3.03h-1.97v3.12h-1.42V7.72h3.43Zm-2 4.83h1.62c1.24 0 1.94-.66 1.94-1.82 0-1.15-.7-1.81-1.93-1.81h-1.64v3.63Zm5.39 2.43c0-1.17.9-1.89 2.48-1.98l1.83-.1v-.52c0-.74-.5-1.18-1.34-1.18-.8 0-1.3.38-1.41.97h-1.3c.08-1.2 1.1-2.09 2.76-2.09 1.62 0 2.65.86 2.65 2.2v4.6h-1.31v-1.1h-.04a2.38 2.38 0 0 1-2.1 1.2c-1.3 0-2.22-.8-2.22-2Zm4.3-.6v-.53l-1.64.1c-.82.06-1.28.42-1.28.99 0 .58.48.96 1.22.96.96 0 1.7-.66 1.7-1.52Zm2.61 4.95v-1.11c.1.03.33.03.44.03.64 0 .98-.27 1.19-.96l.12-.4-2.41-6.69h1.48l1.7 5.43h.02l1.69-5.43h1.44l-2.5 7.02c-.57 1.62-1.23 2.14-2.61 2.14-.12 0-.46-.01-.56-.03Z"
            })
        ]
    }));
}



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");



var $aIeEI = parcelRequire("aIeEI");



var $5K1mb = parcelRequire("5K1mb");

var $alVaN = parcelRequire("alVaN");

var $eeH7J = parcelRequire("eeH7J");



var $lhaLc = parcelRequire("lhaLc");







parcelRequire("2LTO8");
var $dAwef = parcelRequire("dAwef");





parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");
var $87baa387e4f39550$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
(0, $9G56J.Section)($87baa387e4f39550$var$SubscriptionOverview);
function $87baa387e4f39550$var$SubscriptionOverview(section) {
    var _a, _b, _c, _d;
    const [params, setParams] = (0, $5K1mb.useSearchParams)();
    const orderId = params.get("id");
    const order = (0, $e18f565b44c7bc7d$export$42d4e273b2226793)((_a = orderId) !== null && _a !== void 0 ? _a : null);
    const localize = (0, $aIeEI.useLocalize)();
    const [renewalModalIsOpen, setRenewalModalIsOpen] = (0, $eeH7J.useState)(false);
    const tradeInForm = (0, $e18f565b44c7bc7d$export$f8778ca18805596d)("Phones");
    const [tradeInId, setTradeInId] = (0, $eK8Q4.useSessionState)("tradein-modal-id", undefined);
    const [tradeInModalIsOpen, setTradeInModalIsOpen] = (0, $eK8Q4.useSessionState)("tradein-modal-open", false);
    const renewalOptions = (0, $e18f565b44c7bc7d$export$cd3361f95bba4719)(((_b = order.data) === null || _b === void 0 ? void 0 : _b.status) === "delivered" ? (_c = orderId) !== null && _c !== void 0 ? _c : null : null);
    const renewalAvailable = !!((_d = renewalOptions.data) === null || _d === void 0 ? void 0 : _d.options);
    const [cancellationModalIsOpen, setCancellationModalIsOpen] = (0, $eeH7J.useState)(false);
    // If no subscription id is provided, redirect to the most recently placed order. Reason for
    // this being implemented is Redoit want to be able to include a (standard) QR-code in the
    // box when shipping the phones, encouraging making a trade-in if they have not already, that
    // should lead to the subscription page.
    (0, $eeH7J.useEffect)(()=>{
        async function redirectToSubscription() {
            const orders = await (0, $e18f565b44c7bc7d$export$cb8b42d135ef9214)();
            const activeOrders = [
                ...orders.orders
            ].sort((a, b)=>a.placed < b.placed ? 1 : -1);
            if (!activeOrders[0]) return;
            const sp = Object.fromEntries(params);
            setParams(Object.assign(Object.assign({}, sp), {
                id: activeOrders[0].id.valueOf()
            }), {
                replace: true
            });
        }
        if (!orderId) redirectToSubscription();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!order.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    const { model: model } = order.data;
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            justifyContent: "center",
            css: (0, $lhaLc.css)({
                paddingTop: 32,
                paddingBottom: 32
            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                paddingTop: 64,
                paddingBottom: 64
            })),
            children: (0, $4vwom.jsxs)("div", {
                style: {
                    maxWidth: 1020,
                    width: "100%"
                },
                css: (0, $lhaLc.css)({
                    display: "grid",
                    gridTemplateAreas: '"text details" "menu details"',
                    gridTemplateColumns: "56fr 70fr",
                    gridTemplateRows: "minmax(0, auto)",
                    columnGap: (0, $756948b644e82cf2$export$981516ee4691055c)(140)
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                    gridTemplateAreas: '"text" "details" "menu"',
                    gridTemplateRows: "auto",
                    gridTemplateColumns: "1fr",
                    rowGap: 32
                })),
                children: [
                    (0, $4vwom.jsxs)("div", {
                        css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            marginBottom: 16
                        }),
                        children: [
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                alignItems: "center",
                                children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                    level: 1,
                                    truncate: true,
                                    children: localize(model.name)
                                })
                            }),
                            model.features && model.features.length > 0 && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                gap: 8,
                                alignItems: "center",
                                style: {
                                    overflow: "hidden"
                                },
                                children: (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "xl",
                                    color: "gray300",
                                    css: (0, $lhaLc.css)({
                                        display: "inline-block",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: "1 1 auto"
                                    }),
                                    children: [
                                        localize(section.orderNumberLabel),
                                        ": ",
                                        order.data.orderNumber
                                    ]
                                })
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 28,
                        direction: "column",
                        margin: {
                            top: (0, $756948b644e82cf2$export$981516ee4691055c)(32)
                        },
                        style: {
                            gridArea: "menu",
                            alignSelf: "start"
                        },
                        children: [
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                style: {
                                    cursor: !order.data.tradeIn ? "pointer" : "inherit"
                                },
                                justifyContent: "space-between",
                                color: order.data.tradeIn ? "gray300" : undefined,
                                alignItems: "center",
                                onClick: ()=>{
                                    var _a;
                                    if ((_a = order.data) === null || _a === void 0 ? void 0 : _a.tradeIn) return;
                                    setTradeInId((0, $dAwef.Uuid)().valueOf());
                                    setTradeInModalIsOpen(true);
                                },
                                children: [
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 3,
                                        children: localize(section.menu.tradeIn)
                                    }),
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: "arrowRight"
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 0
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                style: {
                                    cursor: renewalAvailable ? "pointer" : "inherit"
                                },
                                justifyContent: "space-between",
                                color: !renewalAvailable ? "gray300" : undefined,
                                alignItems: "center",
                                onClick: ()=>{
                                    var _a;
                                    if (!((_a = renewalOptions.data) === null || _a === void 0 ? void 0 : _a.options)) return;
                                    setRenewalModalIsOpen(true);
                                },
                                children: [
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 3,
                                        children: localize(section.menu.renewSubscription)
                                    }),
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: "arrowRight"
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 0
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                color: order.data.cancelled || order.data.cancellationRequested ? "gray300" : "warning",
                                style: {
                                    cursor: order.data.cancelled || order.data.cancellationRequested ? "inherit" : "pointer"
                                },
                                justifyContent: "space-between",
                                alignItems: "center",
                                onClick: order.data.cancelled || order.data.cancellationRequested ? undefined : ()=>setCancellationModalIsOpen(true),
                                children: [
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 3,
                                        children: localize(section.menu.cancelSubscription)
                                    }),
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: "arrowRight"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        flex: "566 0 0",
                        gap: 24,
                        style: {
                            gridArea: "details",
                            alignSelf: "stretch"
                        },
                        children: [
                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                level: 3,
                                children: localize(section.details.heading)
                            }),
                            order.data.cancelled ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                    value: section.details.subscriptionIsCancelled
                                })
                            }) : (0, $4vwom.jsx)($87baa387e4f39550$var$OrderSummary, Object.assign({
                                order: order.data
                            }, section.details)),
                            orderId && (0, $4vwom.jsx)($87baa387e4f39550$var$OrderReceipts, Object.assign({
                                order: order.data
                            }, section.details.receipts))
                        ]
                    }),
                    (0, $4vwom.jsx)($87baa387e4f39550$var$CancelSubscription, Object.assign({}, section.cancelSubscription, {
                        modalIsOpen: cancellationModalIsOpen,
                        setModalIsOpen: setCancellationModalIsOpen,
                        order: order.data,
                        refreshOrder: order.refresh
                    })),
                    (0, $4vwom.jsx)($87baa387e4f39550$var$RenewSubscription, Object.assign({}, section.renewSubscription, {
                        modalIsOpen: renewalModalIsOpen,
                        setModalIsOpen: setRenewalModalIsOpen,
                        order: order.data,
                        refreshOrder: order.refresh
                    })),
                    tradeInForm.data && !!tradeInId && (0, $4vwom.jsx)((0, $0eca38a3f9eebfa7$export$9e5a8dc8aab6dd64), Object.assign({
                        id: tradeInId,
                        form: tradeInForm.data,
                        onClose: ()=>{
                            setTradeInModalIsOpen(false);
                        },
                        open: tradeInModalIsOpen,
                        productName: localize(model.name),
                        months: order.data.monthsLeft,
                        originalPrice: order.data.rentalPeriod.monthlyPrice,
                        onTradeInConfirm: async (form, responses)=>{
                            if (!order.data) {
                                alert("Missing order");
                                return;
                            }
                            await (0, $e18f565b44c7bc7d$export$6b2bf9023d89c7d6)(order.data.id, {
                                tradeIn: {
                                    form: form.id,
                                    version: form.version,
                                    responses: responses
                                }
                            });
                            order.refresh();
                            setTradeInModalIsOpen(false);
                        }
                    }, section.tradeIn.modal))
                ]
            })
        })
    });
}
function $87baa387e4f39550$var$RenewSubscription(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var { order: order, modalIsOpen: modalIsOpen, setModalIsOpen: setModalIsOpen, refreshOrder: refreshOrder } = _a, props = $87baa387e4f39550$var$__rest(_a, [
        "order",
        "modalIsOpen",
        "setModalIsOpen",
        "refreshOrder"
    ]);
    const localize = (0, $aIeEI.useLocalize)();
    const [termsAccepted, setTermsAccepted] = (0, $eeH7J.useState)(false);
    const [state, setState] = (0, $eeH7J.useState)("form");
    const renewalOptions = (0, $e18f565b44c7bc7d$export$cd3361f95bba4719)(order.status === "delivered" ? (_b = order.id) !== null && _b !== void 0 ? _b : null : null);
    // Selected option is referring to the number of months.
    const [selectedOptionMonths, setSelectedOptionMonths] = (0, $eeH7J.useState)();
    const selectedOption = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = renewalOptions.data) === null || _a === void 0 ? void 0 : _a.options.find((o)=>o.months === selectedOptionMonths);
    }, [
        selectedOptionMonths,
        renewalOptions.data
    ]);
    const terms = (0, $e18f565b44c7bc7d$export$23e8c26267d65867)();
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        if (!selectedOptionMonths && ((_a = renewalOptions.data) === null || _a === void 0 ? void 0 : _a.options)) setSelectedOptionMonths((_b = renewalOptions.data.options.at(0)) === null || _b === void 0 ? void 0 : _b.months);
    }, [
        (_c = renewalOptions.data) === null || _c === void 0 ? void 0 : _c.options,
        selectedOptionMonths
    ]);
    const renewalPeriodTotalPrice = (0, $eeH7J.useMemo)(()=>{
        if (!selectedOption) return;
        return {
            minorUnits: selectedOption.months * selectedOption.price.itemsTotal.minorUnits,
            majorUnits: selectedOption.months * selectedOption.price.itemsTotal.majorUnits,
            currency: selectedOption.price.itemsTotal.currency
        };
    }, [
        selectedOption
    ]);
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const handleRenewConfirmation = (0, $eeH7J.useCallback)(async ()=>{
        try {
            if (!selectedOption || !terms.data) throw new Error("Missing data.");
            await (0, $e18f565b44c7bc7d$export$e88ba7c9a7cf1f6)(order.id, selectedOption.months, terms.data.phoneOrder.id, terms.data.insurance.id);
            refreshOrder();
            setModalIsOpen(false);
        } catch (err) {
            setState("error");
        }
    }, [
        order.id,
        refreshOrder,
        selectedOption,
        setModalIsOpen,
        terms.data
    ]);
    return (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
        width: 640,
        isOpen: modalIsOpen,
        header: {
            title: localize((_d = props.title) !== null && _d !== void 0 ? _d : {}),
            closeButton: true
        },
        onClose: ()=>setModalIsOpen(false),
        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            gap: 24,
            children: state === "error" ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: localize((_e = props.renewalErrorText) !== null && _e !== void 0 ? _e : {})
                        })
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "dark",
                        size: "md",
                        onClick: ()=>setState("form"),
                        children: localize({
                            no: "Pr\xf8v igjen",
                            en: "Try again"
                        })
                    })
                ]
            }) : (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    !!props.text && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: localize(props.text)
                    }),
                    ((_f = renewalOptions.data) === null || _f === void 0 ? void 0 : _f.options.length) === 0 && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: localize({
                            no: "Ingen fornyelsesalternativer tilgjengelig.",
                            en: "No renewal options available."
                        })
                    }),
                    renewalOptions.error && (0, $4vwom.jsx)("div", {
                        children: renewalOptions.error.detail
                    }),
                    renewalOptions.data && selectedOption && selectedOptionMonths && renewalPeriodTotalPrice && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                        children: [
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                borderRadius: "lg",
                                borderColor: "gray200",
                                padding: "md",
                                direction: "column",
                                css: (0, $lhaLc.css)({
                                    gap: 24
                                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                    gap: 28
                                })),
                                children: [
                                    (0, $4vwom.jsxs)("div", {
                                        children: [
                                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                level: 4,
                                                margin: {
                                                    bottom: 16
                                                },
                                                children: localize((_g = props.renewalOptionsLabel) !== null && _g !== void 0 ? _g : {})
                                            }),
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                direction: "column",
                                                gap: 8,
                                                css: (0, $lhaLc.css)({
                                                    "> *": {
                                                        flex: "1 0 0"
                                                    }
                                                }),
                                                children: (0, $4vwom.jsx)((0, $8e85e0d8eea1dda5$export$a98f0dcb43a68a25), {
                                                    value: selectedOptionMonths,
                                                    options: renewalOptions.data.options.map((rp)=>({
                                                            value: rp.months,
                                                            text: localize({
                                                                no: `${rp.months} m\xe5neder`,
                                                                en: `${rp.months} months`
                                                            })
                                                        })),
                                                    renderOption: (option, selected)=>{
                                                        var _a, _b;
                                                        const rentalPeriodPrice = (_b = (_a = renewalOptions.data) === null || _a === void 0 ? void 0 : _a.options.find((o)=>o.months === option.value)) === null || _b === void 0 ? void 0 : _b.price;
                                                        if (!rentalPeriodPrice) return null;
                                                        return (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                            variant: "select",
                                                            selected: selected,
                                                            fullwidth: true,
                                                            as: "div",
                                                            size: "md",
                                                            children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                                style: {
                                                                    width: "100%"
                                                                },
                                                                justifyContent: "space-between",
                                                                children: [
                                                                    (0, $4vwom.jsxs)("div", {
                                                                        style: !selected ? {
                                                                            fontWeight: 300
                                                                        } : {},
                                                                        children: [
                                                                            option.value,
                                                                            " ",
                                                                            localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))
                                                                        ]
                                                                    }),
                                                                    (0, $4vwom.jsxs)("div", {
                                                                        children: [
                                                                            formatAmount(rentalPeriodPrice.phone),
                                                                            "/",
                                                                            localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    },
                                                    onChange: async (e, val)=>{
                                                        setSelectedOptionMonths(val);
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: 0
                                    }),
                                    !!selectedOption.price.insurance && renewalOptions.data.insurance && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                                        children: [
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                direction: "column",
                                                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    gap: 8,
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                            icon: "shield"
                                                        }),
                                                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                            variant: "body",
                                                            size: "md",
                                                            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize((_h = props.renewInsuranceLabel) !== null && _h !== void 0 ? _h : {}), {
                                                                monthlyPrice: formatAmount(selectedOption.price.insurance),
                                                                monthsShort: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
                                                                insuranceName: localize(renewalOptions.data.insurance.displayName)
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                                horizontal: true,
                                                spacing: 0
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        direction: "column",
                                        gap: 4,
                                        children: [
                                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                alignItems: "baseline",
                                                gap: "4px 8px",
                                                style: {
                                                    whiteSpace: "nowrap",
                                                    flexWrap: "wrap"
                                                },
                                                children: [
                                                    (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "heading",
                                                        level: [
                                                            2,
                                                            [
                                                                "min",
                                                                "md",
                                                                3
                                                            ]
                                                        ],
                                                        color: "brand",
                                                        children: [
                                                            formatAmount(selectedOption.price.itemsTotal),
                                                            "/",
                                                            localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                        ]
                                                    }),
                                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "body",
                                                        size: "md",
                                                        children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize((_j = props.totalPricePostFix) !== null && _j !== void 0 ? _j : {}), {
                                                            rentalPeriod: `${selectedOptionMonths}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "sm",
                                                color: "gray300",
                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize((_k = props.rentalPeriodTotalPrice) !== null && _k !== void 0 ? _k : {}), {
                                                    rentalPeriod: `${selectedOptionMonths}`,
                                                    totalPrice: `${formatAmount(renewalPeriodTotalPrice)}`,
                                                    monthsShort: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
                                                    monthsLong: localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                label: localize((_l = props.termsAndConditionsLabel) !== null && _l !== void 0 ? _l : {}),
                                checked: termsAccepted,
                                onChange: ()=>setTermsAccepted(!termsAccepted)
                            }),
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                variant: "primary",
                                fullwidth: true,
                                disabled: !termsAccepted,
                                onClick: handleRenewConfirmation,
                                children: localize((_m = props.confirmButtonText) !== null && _m !== void 0 ? _m : {})
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function $87baa387e4f39550$var$CancelSubscription(_a) {
    var { order: order, modalIsOpen: modalIsOpen, setModalIsOpen: setModalIsOpen, refreshOrder: refreshOrder } = _a, props = $87baa387e4f39550$var$__rest(_a, [
        "order",
        "modalIsOpen",
        "setModalIsOpen",
        "refreshOrder"
    ]);
    const localize = (0, $aIeEI.useLocalize)();
    const cancellationTerms = (0, $e18f565b44c7bc7d$export$7a4a3d03ee7c067f)(order.id);
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const [state, setState] = (0, $eeH7J.useState)("prompt");
    const handleCancellationConfirmation = (0, $eeH7J.useCallback)(async ()=>{
        if (!cancellationTerms.data) {
            setState("error");
            return;
        }
        try {
            await (0, $e18f565b44c7bc7d$export$8061bbc383a29848)(order.id, {
                cancellationFee: cancellationTerms.data.cancellationFee,
                cancellationTerms: cancellationTerms.data.cancellationTerms
            });
            refreshOrder();
            setState("success");
        } catch (err) {
            setState("error");
        }
    }, [
        cancellationTerms.data,
        order.id,
        refreshOrder
    ]);
    if (!cancellationTerms.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
        isOpen: modalIsOpen,
        onClose: ()=>setModalIsOpen(false),
        header: {
            title: localize(props.title),
            closeButton: true
        },
        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            gap: 24,
            children: state === "prompt" ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.cancellationPrompt), {
                            cancellationFee: formatAmount(cancellationTerms.data.cancellationFee),
                            monthsRemaining: cancellationTerms.data.monthsRemaining.toString()
                        })
                    }),
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: cancellationTerms.data.cancellationTerms
                        })
                    }),
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 8,
                        css: (0, $lhaLc.css)({
                            flexWrap: "wrap"
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                            flexDirection: "column",
                            alignItems: "stretch"
                        })),
                        children: [
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                variant: "secondary",
                                size: "sm",
                                onClick: ()=>setModalIsOpen(false),
                                children: localize(props.cancelButtonText)
                            }),
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                variant: "dark",
                                size: "sm",
                                onClick: handleCancellationConfirmation,
                                children: localize(props.confirmButtonText)
                            })
                        ]
                    })
                ]
            }) : state === "error" ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: props.cancellationErrorText
                        })
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "secondary",
                        size: "sm",
                        onClick: ()=>setModalIsOpen(false),
                        children: localize(props.closeButtonText)
                    })
                ]
            }) : state === "success" ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: props.cancellationSuccessText
                        })
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "secondary",
                        size: "sm",
                        onClick: ()=>setModalIsOpen(false),
                        children: localize(props.closeButtonText)
                    })
                ]
            }) : null
        })
    });
}
function $87baa387e4f39550$var$OrderSummary(_a) {
    var _b, _c, _d;
    var { order: order } = _a, props = $87baa387e4f39550$var$__rest(_a, [
        "order"
    ]);
    const price = order.rentalPeriod.monthlyPrice;
    const localize = (0, $aIeEI.useLocalize)();
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const insuranceOptions = (0, $e18f565b44c7bc7d$export$fd8b73cd610fc548)(order.model.id, order.phone.storage, order.phone.color, order.rentalPeriod.months);
    const [showInsuranceTerms, setShowInsuranceTerms] = (0, $eeH7J.useState)(false);
    const insurance = (_b = insuranceOptions.data) === null || _b === void 0 ? void 0 : _b.find((io)=>io.id === order.insurance);
    const statusToDisplay = (0, $eeH7J.useMemo)(()=>{
        if (order.customStatus) return order.customStatus;
        if (order.cancellationRequested && props.status.cancellationRequestedStatusLabel) return props.status.cancellationRequestedStatusLabel;
        if (order.status && order.status in props.status.statusLabels) return props.status.statusLabels[order.status];
    }, [
        order.cancellationRequested,
        order.customStatus,
        order.status,
        props.status.cancellationRequestedStatusLabel,
        props.status.statusLabels
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($cddd760e1f8ca7cc$exports))));
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 24,
        children: [
            statusToDisplay ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                step: localize(props.status.heading),
                icon: props.status.icon,
                title: localize(statusToDisplay)
            }) : null,
            (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                step: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.subscriptionPeriod.heading), {
                    nextChargeDate: (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(order.nextChargeDate).format("DD.MM.YYYY")
                }),
                icon: "calendar",
                title: props.subscriptionPeriod.subtitle ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.subscriptionPeriod.subtitle), {
                    amount: formatAmount(order.nextCharge.total)
                }) : undefined,
                text: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.subscriptionPeriod.text), {
                    monthsLeft: order.monthsLeft.toString(),
                    rentalPeriodMonths: order.rentalPeriod.months.toString()
                }),
                subtitle: (_c = order.nextCharge.discounts) === null || _c === void 0 ? void 0 : _c.map((d)=>(0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        color: "brand",
                        children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.subscriptionPeriod.discountText), {
                            discountName: localize(d.name),
                            discountAmount: formatAmount(d.amount),
                            remainingMonths: d.remainingMonths.toString(),
                            totalMonths: d.totalMonths.toString()
                        })
                    })),
                label: props.subscriptionPeriod.label ? localize(props.subscriptionPeriod.label) : undefined
            }),
            (0, $4vwom.jsx)((0, $9ef1a37a4c2e6964$export$161a6b098fcc9bc6), {
                originalPrice: price.phone.majorUnits,
                discountedPrice: order.tradeIn && order.tradeIn.discount.remainingMonths > 0 ? price.phone.majorUnits - order.tradeIn.discount.amount.majorUnits : price.phone.majorUnits,
                currency: localize((_d = (0, $b274814d74f89bd0$export$91d51a43b638ef12)[price.itemsTotal.currency]) !== null && _d !== void 0 ? _d : {
                    no: price.itemsTotal.currency
                }),
                label: localize(props.payment.monthlyLabel),
                itemName: localize(order.model.name),
                rentalPeriodUnit: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
                text: order.tradeIn && order.tradeIn.discount.remainingMonths > 0 ? localize(props.payment.phonePriceWithTradeInText) : localize(props.payment.phonePriceText)
            }),
            insurance ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                        step: localize(props.insurance.heading),
                        icon: "shield",
                        title: localize(insurance.displayName),
                        price: price.insurance ? formatAmount(price.insurance) : undefined,
                        list: insurance.sellingPoints.map((sp)=>({
                                id: sp.id.valueOf(),
                                icon: sp.icon,
                                text: localize(sp.text)
                            })),
                        text: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "md",
                            onClick: ()=>setShowInsuranceTerms(true),
                            underline: true,
                            style: {
                                cursor: "pointer"
                            },
                            children: localize(props.insurance.showTermsLink)
                        }),
                        label: props.insurance.label ? localize(props.insurance.label) : undefined
                    }),
                    (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                        isOpen: showInsuranceTerms,
                        header: {
                            title: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.insurance.termsModalTitle), {
                                insuranceName: localize(insurance.displayName)
                            }),
                            closeButton: true
                        },
                        onClose: ()=>setShowInsuranceTerms(false),
                        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "sm",
                            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(insurance.termsAndConditions.content)
                            })
                        })
                    })
                ]
            }) : null
        ]
    });
}
function $87baa387e4f39550$var$OrderReceipts(_a) {
    var { order: order } = _a, props = $87baa387e4f39550$var$__rest(_a, [
        "order"
    ]);
    const localize = (0, $aIeEI.useLocalize)();
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($cddd760e1f8ca7cc$exports))));
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        borderRadius: "md",
        padding: "md",
        borderColor: "gray200",
        direction: "column",
        gap: 16,
        children: [
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                justifyContent: "space-between",
                alignItems: "center",
                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 8,
                    children: [
                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                            icon: "receipt"
                        }),
                        " ",
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 4,
                            children: localize(props.heading)
                        })
                    ]
                })
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 24,
                direction: "column",
                children: order.receipts.length ? order.receipts.map((receipt, index)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                        children: [
                            index > 0 && (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 0
                            }),
                            (0, $4vwom.jsxs)("a", {
                                href: `/api/phone-orders/${order.id}/pdf-receipts/${receipt.id}`,
                                style: {
                                    cursor: "pointer",
                                    display: "flex",
                                    flexDirection: "row",
                                    width: "100%",
                                    justifyContent: "space-between"
                                },
                                children: [
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(receipt.date.valueOf()).format(localize(props.dateFormat))
                                    }),
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        gap: 24,
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "md",
                                                children: formatAmount(receipt.total)
                                            }),
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "md",
                                                underline: true,
                                                children: localize(props.downloadLinkText)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, receipt.id.valueOf())) : (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                    variant: "body",
                    size: "sm",
                    color: "gray300",
                    children: localize(props.noReceiptsMessage)
                })
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");
parcelRequire("jniej");
var $cWF8g = parcelRequire("cWF8g");



var $aIeEI = parcelRequire("aIeEI");

var $f2yFo = parcelRequire("f2yFo");


var $eeH7J = parcelRequire("eeH7J");

(0, $9G56J.Section)($577c7fc3efab75b3$var$CancelView);
function $577c7fc3efab75b3$var$CancelView(section) {
    var _a, _b, _c;
    const orderId = (0, $cWF8g.useQueryString)("id")[0];
    const order = (0, $e18f565b44c7bc7d$export$42d4e273b2226793)(orderId !== null && orderId !== void 0 ? orderId : null);
    const cancelTerms = (0, $e18f565b44c7bc7d$export$7a4a3d03ee7c067f)(orderId !== null && orderId !== void 0 ? orderId : null);
    const [accepted, setAccepted] = (0, $eeH7J.useState)(false);
    const localize = (0, $aIeEI.useLocalize)();
    if (!order.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    const { model: model } = order.data;
    async function cancel() {
        if (!orderId) {
            alert("No order ID");
            return;
        }
        if (!cancelTerms.data) {
            alert("No cancel terms");
            return;
        }
        await (0, $e18f565b44c7bc7d$export$8061bbc383a29848)(orderId, {
            cancellationFee: cancelTerms.data.cancellationFee,
            cancellationTerms: cancelTerms.data.cancellationTerms
        });
        alert(localize(section.confirmText));
        location.pathname = "/account";
    }
    return (0, $4vwom.jsxs)("div", {
        style: {
            backgroundColor: "#fee",
            padding: 32
        },
        children: [
            (0, $4vwom.jsxs)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: [
                    "Cancel your subscription - ",
                    localize(model.name)
                ]
            }),
            (0, $4vwom.jsx)("div", {
                children: cancelTerms.data && (0, $4vwom.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f2yFo))), {
                    children: localize((_a = cancelTerms.data) === null || _a === void 0 ? void 0 : _a.cancellationTerms).valueOf()
                })
            }),
            (0, $4vwom.jsxs)("div", {
                children: [
                    localize(section.cancelFee),
                    ": ",
                    (_b = cancelTerms.data) === null || _b === void 0 ? void 0 : _b.cancellationFee.majorUnits,
                    " ",
                    (_c = cancelTerms.data) === null || _c === void 0 ? void 0 : _c.cancellationFee.currency
                ]
            }),
            (0, $4vwom.jsxs)("div", {
                children: [
                    (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                        disabled: !cancelTerms.data,
                        checked: accepted,
                        onChange: ()=>setAccepted(!accepted)
                    }),
                    (0, $4vwom.jsx)("div", {
                        children: localize(section.iAcceptTheTerms)
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                disabled: !cancelTerms.data && accepted,
                onClick: cancel,
                children: localize(section.confirmButton)
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $5K1mb = parcelRequire("5K1mb");


var $9G56J = parcelRequire("9G56J");

var $dUDPg = parcelRequire("dUDPg");
parcelRequire("2LTO8");
var $iXeBy = parcelRequire("iXeBy");

var $aIeEI = parcelRequire("aIeEI");



/**
 * @icon ui-slash-divider
 */ function $2e164f197f37655e$var$Breadcrumb(section) {
    var _a;
    const { colors: colors, responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const pageContext = (0, $eeH7J.useContext)((0, $9fe8ccb750b589bb$export$6245f31671de0b04));
    const localize = (0, $aIeEI.useLocalize)();
    const currentLocale = (0, $aIeEI.useCurrentLocale)();
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const items = (0, $eeH7J.useMemo)(()=>pageContext.breadcrumb.map((item)=>{
            const localePath = currentLocale === defaultLocale ? "" : `/${currentLocale}`;
            const path = item.slug ? `${localePath}/${localize(item.slug)}` : "/";
            const href = (0, $iXeBy.Url)(path);
            return Object.assign(Object.assign({}, item), {
                href: href
            });
        }), [
        currentLocale,
        defaultLocale,
        localize,
        pageContext.breadcrumb
    ]);
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        css: (0, $lhaLc.css)({
            borderTop: `1px solid ${colors.gray200}`,
            borderBottom: `1px solid ${colors.gray200}`,
            width: "100vw",
            marginLeft: "calc(50% - 50vw)"
        }),
        children: (0, $4vwom.jsx)("div", {
            style: {
                paddingTop: 16,
                paddingBottom: 16
            },
            css: (0, $756948b644e82cf2$export$629e292a677297c2)(),
            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "md",
                color: "gray300",
                css: responsiveCss("min", "md", {
                    fontWeight: 500
                }),
                children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 8,
                    children: items.map((page, index)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                            children: [
                                index > 0 && "/",
                                " ",
                                (0, $4vwom.jsx)("div", {
                                    style: index === pageContext.breadcrumb.length - 1 ? {
                                        color: colors.gray500
                                    } : {},
                                    children: index < items.length - 1 ? (0, $4vwom.jsx)((0, $5K1mb.Link), {
                                        to: page.href.valueOf(),
                                        style: {
                                            textDecoration: "none"
                                        },
                                        children: localize(page.title)
                                    }) : localize(page.title)
                                })
                            ]
                        }, page.id.valueOf()))
                })
            })
        })
    });
}
(0, $9G56J.Section)("Breadcrumb", $2e164f197f37655e$var$Breadcrumb);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");



var $lhaLc = parcelRequire("lhaLc");

function $45e35837a0ab7745$export$7e05df66519e325f(section) {
    return (0, $lhaLc.css)(section.margin && (0, $756948b644e82cf2$export$92c840cda8ec752c).helpers.spacingToCss("margin", section.margin), {
        "li::marker": {
            fontWeight: 600
        },
        maxWidth: section.maxWidth
    });
}




/**
 * @icon ui-align-left
 */ function $a9adfc42e654df60$var$TextContent(section) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)((0, $45e35837a0ab7745$export$7e05df66519e325f)(section), {
            // Workaround for emotions reluctance to allow :first-child selector.
            [`${[
                "h1",
                "h2",
                "h3",
                "h4"
            ].map((h)=>`${h}:not(:first-of-type:not(style):not(:first-of-type ~ *))`)}`]: {
                marginTop: ".8em"
            },
            a: {
                color: colors.brand,
                textDecoration: "none"
            },
            "a:hover": {
                color: colors.brand
            }
        }),
        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
            variant: "body",
            size: section.bodyTextSize,
            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                value: localize(section.text),
                renderers: {
                    paragraph: (p)=>(0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                            size: section.bodyTextSize,
                            color: section.bodyTextColor,
                            children: p.children
                        })
                }
            })
        })
    });
}
(0, $9G56J.Section)("TextContent", $a9adfc42e654df60$var$TextContent);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");



/**
 * @icon ui-image-01
 */ function $d94ba389b32d537a$var$ImageContent(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)((0, $45e35837a0ab7745$export$7e05df66519e325f)(section)),
        children: (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
            "aria-hidden": !section.altText,
            alt: section.altText ? localize(section.altText) : undefined,
            style: {
                width: "auto",
                height: "auto",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "cover",
                aspectRatio: section.aspectRatio
            },
            image: section.image,
            width: section.width,
            css: section.borderRadius ? (0, $aace75a797ac78f1$export$ae2d933239aa09a1)(section.borderRadius) : undefined
        })
    });
}
(0, $9G56J.Section)("ImageContent", $d94ba389b32d537a$var$ImageContent);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");







(0, $9G56J.Section)("ListWithIconsContent", $6defc054f4b82fac$var$ListWithIconsContent);
/**
 * @icon ui-dotpoints-02
 */ function $6defc054f4b82fac$var$ListWithIconsContent(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
        variant: "body",
        size: section.bodyTextSize,
        css: (0, $lhaLc.css)([
            (0, $45e35837a0ab7745$export$7e05df66519e325f)(section)
        ]),
        children: (0, $4vwom.jsx)("ul", {
            css: (0, $lhaLc.css)((0, $e82ba787de72625c$export$6b6f359a824920a4)("ul")),
            style: {
                display: "flex",
                flexDirection: "column",
                gap: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
            },
            children: section.items.map((li)=>(0, $4vwom.jsx)("li", {
                    css: (0, $e82ba787de72625c$export$6b6f359a824920a4)("li"),
                    children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        alignItems: "center",
                        gap: 24,
                        children: [
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                style: {
                                    flex: "0 0 auto"
                                },
                                borderRadius: "md",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "gray100",
                                padding: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                                children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                    icon: li.icon,
                                    size: 48
                                })
                            }),
                            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(li.text),
                                renderers: {
                                    paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                            children: p.children
                                        })
                                }
                            })
                        ]
                    })
                }, li.id.valueOf()))
        })
    });
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");






(0, $9G56J.Section)("ListWithStepsContent", $feabaebffd5687e7$var$ListWithStepsContent);
/**
 * @icon ui-dotpoints-01
 */ function $feabaebffd5687e7$var$ListWithStepsContent(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: [
            8,
            [
                "min",
                "md",
                12
            ]
        ],
        css: (0, $lhaLc.css)((0, $45e35837a0ab7745$export$7e05df66519e325f)(section)),
        children: section.items.map((item, index)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 24,
                backgroundColor: "gray100",
                padding: "md",
                style: {
                    borderRadius: 16
                },
                alignItems: "center",
                children: [
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        backgroundColor: "gray500",
                        alignItems: "center",
                        justifyContent: "center",
                        style: {
                            flexShrink: 0,
                            color: (0, $06eb0d21a8b1f440$export$8f45430ccf837300).grayWhite,
                            borderRadius: 100
                        },
                        css: (0, $lhaLc.css)({
                            width: 24,
                            height: 24
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            height: (0, $756948b644e82cf2$export$981516ee4691055c)(48),
                            width: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                        })),
                        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "heading",
                            level: [
                                5,
                                [
                                    "min",
                                    "md",
                                    4
                                ]
                            ],
                            children: index + 1
                        })
                    }),
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: localize(item.text),
                            renderers: {
                                paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                        children: p.children
                                    })
                            }
                        })
                    })
                ]
            }, item.id.valueOf()))
    });
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $7KZCj = parcelRequire("7KZCj");

var $9G56J = parcelRequire("9G56J");


(0, $9G56J.Section)($d13e58e07b0e8c39$var$ContentGroup);
/**
 * Combine a group of content sections side by side and/or stacked.
 *
 * @icon ui-columns-01
 */ function $d13e58e07b0e8c39$var$ContentGroup(section) {
    const sections = (0, $4vwom.jsx)((0, $7KZCj.EditableSections), {
        sections: section.contents.flatMap((c)=>c.sections),
        itemCss: (index)=>{
            var _a;
            return ((_a = section.contents[index]) === null || _a === void 0 ? void 0 : _a.hideBreakpoint) ? (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", section.contents[index].hideBreakpoint, {
                display: "none !important"
            }) : (0, $lhaLc.css)();
        }
    });
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)((0, $45e35837a0ab7745$export$7e05df66519e325f)(section), {
            display: "grid",
            gridAutoFlow: "column",
            gridAutoColumns: "minmax(0, 1fr)"
        }, section.gap && (0, $aace75a797ac78f1$export$9c33585a37942ee0)(section.gap, "gap"), section.stackingBreakpoint && (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", section.stackingBreakpoint, {
            gridAutoFlow: "row",
            gridAutoRows: "auto"
        })),
        children: sections
    });
}



var $4vwom = parcelRequire("4vwom");


var $9G56J = parcelRequire("9G56J");
/**
 * @icon ui-divider
 * @param section
 * @returns
 */ function $6dd6bf1d6cf26135$var$ContentDivider(section) {
    return (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
        horizontal: true,
        spacing: section.spacing
    });
}
(0, $9G56J.Section)($6dd6bf1d6cf26135$var$ContentDivider);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5K1mb = parcelRequire("5K1mb");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");


var $9G56J = parcelRequire("9G56J");


var $aIeEI = parcelRequire("aIeEI");








var $dUDPg = parcelRequire("dUDPg");







var $eeH7J = parcelRequire("eeH7J");
/**
 * Registers a script (JavScript snippet) to be injected into each WebPage's <head>
 * during server-side rendering based on the user's consent.
 */ function $a41bfcd45003050d$export$4e6c8cb53e2bac7e(script) {
    $a41bfcd45003050d$export$4e6c8cb53e2bac7e.all.push(script);
}
$a41bfcd45003050d$export$4e6c8cb53e2bac7e.all = [];



var $dUDPg = parcelRequire("dUDPg");
const $a04e75f6851d0b20$var$OFFER_SID = "vfc15f";
const $a04e75f6851d0b20$var$EVENT_SID = "wj0bj2";
// Inject script for Cirlcewise / TargetCircle to be included on every page.
(0, $a41bfcd45003050d$export$4e6c8cb53e2bac7e)({
    consent: "marketing",
    key: "target-circle-entrypoint",
    code: `
        window.tmt_offer_sid = '${$a04e75f6851d0b20$var$OFFER_SID}';
        (function() {
            var timestamp = +new Date;
            var po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;
            po.src = 'https://cdn.tmtarget.com/tracking/s/entrypoint_v2.min.js?t=' + timestamp;
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s);
        })();
    `
});
function $a04e75f6851d0b20$export$4d5dcc1e958e7f7e(orderNumber) {
    var _a, _b;
    const cookieConsents = (0, $dUDPg.useCookieConsents)();
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        if (orderNumber && ((_b = (_a = cookieConsents.data) === null || _a === void 0 ? void 0 : _a.consents) === null || _b === void 0 ? void 0 : _b.marketing) && typeof document !== "undefined" && // Avoid appending this script more than once.
        !document.querySelector('script[src*="cdn.trackmytarget.com/tracking/s/checkout.min.js"]')) {
            const el = document.createElement("script");
            el.setAttribute("src", "https://cdn.trackmytarget.com/tracking/s/checkout.min.js");
            el.setAttribute("data-type", "sale");
            el.setAttribute("data-offer-sid", $a04e75f6851d0b20$var$OFFER_SID);
            el.setAttribute("data-event-sid", $a04e75f6851d0b20$var$EVENT_SID);
            el.setAttribute("data-id", orderNumber);
            document.body.appendChild(el);
        }
    }, [
        (_b = (_a = cookieConsents.data) === null || _a === void 0 ? void 0 : _a.consents) === null || _b === void 0 ? void 0 : _b.marketing,
        orderNumber
    ]);
}


(0, $9G56J.Section)($002abb89de0ca022$var$OrderConfirmation);
function $002abb89de0ca022$var$OrderConfirmation(section) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const localize = (0, $aIeEI.useLocalize)();
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const [phone] = (0, $047f6f355e30d7d1$export$800784442c3f48f8)();
    const [options] = (0, $047f6f355e30d7d1$export$5b1a6a2d762c097c)();
    const [searchParams] = (0, $5K1mb.useSearchParams)();
    const { order: order } = (0, $047f6f355e30d7d1$export$cba61477bceac75)();
    const [checkoutShippingState] = (0, $047f6f355e30d7d1$export$4a755370e8335b36)();
    const [checkoutTradeInPriceRequest] = (0, $047f6f355e30d7d1$export$b7eadabbf1e81c9b)();
    const [checkoutTradeInForm] = (0, $047f6f355e30d7d1$export$d42da32bb85d5739)();
    const [checkoutTradeInResult] = (0, $047f6f355e30d7d1$export$db65bad7d1fa5d6f)();
    (0, $a04e75f6851d0b20$export$4d5dcc1e958e7f7e)(order === null || order === void 0 ? void 0 : order.orderNumber);
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($cddd760e1f8ca7cc$exports))));
    (0, $eeH7J.useEffect)(()=>{
        if (typeof fbq !== "undefined") fbq("track", "Purchase", {
            content_ids: [
                phone === null || phone === void 0 ? void 0 : phone.id.valueOf()
            ],
            content_name: (phone === null || phone === void 0 ? void 0 : phone.name) ? localize(phone.name) : undefined,
            content_type: "product",
            value: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.majorUnits,
            currency: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.currency
        });
        if (typeof snaptr !== "undefined") snaptr("track", "PURCHASE", {
            price: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.majorUnits,
            currency: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.currency,
            transaction_id: order === null || order === void 0 ? void 0 : order.id,
            item_ids: [
                phone === null || phone === void 0 ? void 0 : phone.id.valueOf()
            ],
            item_category: "phone",
            number_items: 1
        });
        if (typeof ttq !== "undefined") ttq.track("Purchase", {
            contents: [
                {
                    content_id: phone === null || phone === void 0 ? void 0 : phone.id.valueOf(),
                    content_type: "phone",
                    content_name: order === null || order === void 0 ? void 0 : order.model.name
                }
            ],
            value: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.majorUnits,
            currency: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.currency
        });
        // Check of `dataLayer` (global array used by Google Tag Manager to track events)
        // exists before trying to push the event. If it does, push the conversion event
        // including Google Ads reference.
        if (typeof dataLayer !== "undefined" && dataLayer instanceof Array) dataLayer.push({
            event: "conversion",
            send_to: "AW-16797113852/fQOfCKbFq-8ZEPy7vsk-",
            value: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.majorUnits,
            currency: "NOK",
            transaction_id: ""
        });
    }, // Should only trigger once, when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const insuranceOptions = (0, $e18f565b44c7bc7d$export$fd8b73cd610fc548)((_a = order === null || order === void 0 ? void 0 : order.model.id) !== null && _a !== void 0 ? _a : null, (_b = order === null || order === void 0 ? void 0 : order.phone.storage) !== null && _b !== void 0 ? _b : null, (_c = order === null || order === void 0 ? void 0 : order.phone.color) !== null && _c !== void 0 ? _c : null, (_d = order === null || order === void 0 ? void 0 : order.rentalPeriod.months) !== null && _d !== void 0 ? _d : null);
    const selectedInsurance = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = insuranceOptions.data) === null || _a === void 0 ? void 0 : _a.find((insurance)=>insurance.id === (order === null || order === void 0 ? void 0 : order.insurance));
    }, [
        insuranceOptions.data,
        order === null || order === void 0 ? void 0 : order.insurance
    ]);
    if (!phone || !options || !order) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    const orderParam = searchParams.get("o");
    if (order.id.valueOf() !== orderParam) return (0, $4vwom.jsx)($002abb89de0ca022$export$dd3ed613a7315750, Object.assign({}, section.orderMismatchError));
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            gap: 24,
            style: {
                minWidth: 0,
                maxWidth: 560
            },
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    gap: 24,
                    children: [
                        section.topImage ? (0, $4vwom.jsx)("div", {
                            css: (0, $lhaLc.css)({
                                paddingLeft: 12,
                                paddingRight: 12
                            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                                paddingLeft: 32,
                                paddingRight: 32
                            }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                paddingLeft: 48,
                                paddingRight: 48
                            })),
                            children: (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                image: section.topImage,
                                width: 560,
                                style: {
                                    width: "100%"
                                }
                            })
                        }) : null,
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            gap: 12,
                            children: [
                                (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                    level: 2,
                                    children: localize(section.heading)
                                }),
                                (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                    level: 3,
                                    children: localize(section.subheading)
                                })
                            ]
                        }),
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            borderColor: "gray200",
                            borderRadius: "md",
                            padding: "md",
                            direction: "column",
                            gap: 8,
                            children: [
                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    children: (0, $4vwom.jsxs)("div", {
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "heading",
                                                level: 4,
                                                children: localize(section.monthlyTotalPrice.heading)
                                            }),
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                alignItems: "baseline",
                                                gap: 2,
                                                children: (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                    variant: "heading",
                                                    level: 3,
                                                    color: "brand",
                                                    children: [
                                                        formatAmount(order.rentalPeriod.monthlyPrice.itemsTotal),
                                                        "/",
                                                        localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "sm",
                                    color: "gray300",
                                    children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.monthlyTotalPrice.text), {
                                        rentalPeriod: `${order.rentalPeriod.months.valueOf()}`,
                                        monthsShort: `${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                                        monthlyPrice: formatAmount(order.rentalPeriod.monthlyPrice.itemsTotal),
                                        totalPrice: `${formatAmount({
                                            minorUnits: order.rentalPeriod.monthlyPrice.phone.minorUnits * order.rentalPeriod.months.valueOf(),
                                            majorUnits: order.rentalPeriod.monthlyPrice.phone.majorUnits * order.rentalPeriod.months.valueOf(),
                                            currency: order.rentalPeriod.monthlyPrice.phone.currency
                                        })}`
                                    })
                                })
                            ]
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                    horizontal: true,
                    spacing: 0
                }),
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    gap: 24,
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 3,
                            children: localize(section.summary.heading)
                        }),
                        (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                            icon: "device",
                            step: localize((_e = section.summary.device.stepName) !== null && _e !== void 0 ? _e : {}),
                            title: localize(order.model.name),
                            price: `${formatAmount(order.rentalPeriod.monthlyPrice.phone)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                            subtitle: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.summary.device.rentalPeriodTotalPrice), {
                                rentalPeriod: `${order.rentalPeriod.months.valueOf()}`,
                                monthsShort: `${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                                monthsLong: `${localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))}`,
                                totalPrice: `${formatAmount({
                                    minorUnits: order.rentalPeriod.monthlyPrice.phone.minorUnits * order.rentalPeriod.months.valueOf(),
                                    majorUnits: order.rentalPeriod.monthlyPrice.phone.majorUnits * order.rentalPeriod.months.valueOf(),
                                    currency: order.rentalPeriod.monthlyPrice.phone.currency
                                })}`
                            })
                        }),
                        checkoutTradeInForm && checkoutTradeInPriceRequest && typeof (checkoutTradeInResult === null || checkoutTradeInResult === void 0 ? void 0 : checkoutTradeInResult.value) !== "undefined" && order.tradeIn && checkoutTradeInResult.deviceName ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                            icon: "handCoins",
                            step: localize(section.summary.tradeIn.stepName),
                            title: localize(checkoutTradeInResult.deviceName),
                            subtitle: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.summary.tradeIn.text), {
                                monthlyDiscount: formatAmount(checkoutTradeInResult.monthlyDiscount),
                                discountPeriod: `${checkoutTradeInResult.months.valueOf()}`
                            }),
                            price: formatAmount(checkoutTradeInResult.value),
                            list: (_f = section.summary.tradeIn.list) === null || _f === void 0 ? void 0 : _f.map((li)=>({
                                    id: li.id.valueOf(),
                                    text: localize(li.text)
                                }))
                        }) : null,
                        selectedInsurance && order.rentalPeriod.monthlyPrice.insurance ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                            icon: "shield",
                            step: localize(section.summary.insurance.stepName),
                            title: localize(selectedInsurance.displayName),
                            price: `${formatAmount(order.rentalPeriod.monthlyPrice.insurance)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                            list: selectedInsurance.sellingPoints.map((isp)=>({
                                    id: isp.id.valueOf(),
                                    text: localize(isp.text)
                                }))
                        }) : null,
                        checkoutShippingState.selectedOption ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                            icon: "truck",
                            step: localize(section.summary.shipping.stepName),
                            title: localize(checkoutShippingState.selectedOption.name),
                            subtitle: checkoutShippingState.selectedOption.type === "Manual" && checkoutShippingState.selectedOption.selectedSlot ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.summary.shipping.deliverySlotText), {
                                deliveryDate: (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(checkoutShippingState.selectedOption.selectedSlot.date).format("dddd Do MMMM"),
                                deliverySlotFrom: checkoutShippingState.selectedOption.selectedSlot.from,
                                deliverySlotTo: checkoutShippingState.selectedOption.selectedSlot.to
                            }) : section.summary.shipping.otherDeliveryOptionText ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.summary.shipping.otherDeliveryOptionText), {
                                deliveryOptionName: localize(checkoutShippingState.selectedOption.name),
                                deliveryOptionDescription: localize(checkoutShippingState.selectedOption.description)
                            }) : localize(checkoutShippingState.selectedOption.description),
                            price: order.shippingCost.majorUnits.valueOf() > 0 ? formatAmount(order.shippingCost) : localize({
                                no: "Gratis",
                                en: "Free"
                            }),
                            text: [
                                (_g = checkoutShippingState.form) === null || _g === void 0 ? void 0 : _g.street.value,
                                `${(_h = checkoutShippingState.form) === null || _h === void 0 ? void 0 : _h.postalCode.value} ${(_j = checkoutShippingState.form) === null || _j === void 0 ? void 0 : _j.region.value}`
                            ].filter((t)=>!!t).join(", ")
                        }) : null,
                        section.summary.image ? (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                            image: section.summary.image,
                            width: 600,
                            css: (0, $aace75a797ac78f1$export$ae2d933239aa09a1)("md")
                        }) : null
                    ]
                })
            ]
        })
    });
}
function $002abb89de0ca022$export$dd3ed613a7315750(props) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const primaryActionPageInfo = (0, $dUDPg.useWebPageInfo)(props.primaryAction.page);
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        alignItems: "center",
        style: {
            width: "100%",
            height: "100%",
            padding: "80px 0"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                padding: "16px 0"
            }), {
                maxWidth: 600
            }),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: "center",
                    gap: 12,
                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                        gap: 8,
                        marginBottom: 32
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        padding: "0 40px",
                        gap: 12,
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            color: "gray500",
                            level: 2,
                            children: localize(props.heading)
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            color: "gray400",
                            variant: "body",
                            size: "md",
                            style: {
                                textAlign: "center"
                            },
                            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(props.text)
                            })
                        })
                    ]
                }),
                ((_a = primaryActionPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) ? (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "primary",
                    size: "md",
                    as: "a",
                    href: `/${localize(primaryActionPageInfo.data.slug)}`,
                    children: localize(props.primaryAction.buttonText)
                }) : null
            ]
        })
    });
}



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $dUDPg = parcelRequire("dUDPg");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");




var $eSiQ2 = parcelRequire("eSiQ2");



var $7m9cQ = parcelRequire("7m9cQ");

function $e502eb7414347b57$export$ad00a5af021e778b(props) {
    var _a, _b, _c;
    const p = {
        css: (0, $lhaLc.css)({
            height: 360
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(440)
        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(600)
        })),
        color: (_a = props.textColor) !== null && _a !== void 0 ? _a : "gray500",
        direction: "column",
        justifyContent: "space-between",
        borderRadius: "md",
        style: {
            backgroundColor: (_b = props.backgroundColor) === null || _b === void 0 ? void 0 : _b.valueOf(),
            position: "relative",
            overflow: "clip",
            flexGrow: 0
        }
    };
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), Object.assign({}, p, props.soldOut ? {} : {
        as: "a",
        href: props.cta.url,
        "aria-label": props.cta.text
    }, {
        children: [
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                css: (0, $lhaLc.css)({
                    padding: 32
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    padding: 48
                })),
                style: {
                    zIndex: 1
                },
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        margin: {
                            bottom: 24
                        },
                        children: props.heading
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: (_c = props.cta.buttonVariant) !== null && _c !== void 0 ? _c : "dark",
                        size: "md",
                        disabled: props.soldOut,
                        children: props.cta.text
                    })
                ]
            }),
            props.image ? (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                image: props.image,
                width: 640
            }) : null
        ]
    }));
}
(0, $eSiQ2.Component)($e502eb7414347b57$export$ad00a5af021e778b, {
    name: "SeeAllCard",
    gallery: {
        path: "Cards/SeeAllCard",
        items: [
            {
                variants: [
                    {
                        props: {
                            heading: "Se hele v\xe5rt utvalg",
                            cta: {
                                text: "Vis alt (14)",
                                url: "",
                                buttonVariant: "light"
                            },
                            image: `${(0, $7m9cQ.server)()}/static/redoit/see-all-card.png`
                        }
                    }
                ]
            }
        ]
    }
});






function $9edbed8e79cbd892$var$PromoCard(section) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const ctaPageInfo = (0, $dUDPg.useWebPageInfo)(section.cta.page);
    const phoneOffers = (0, $e18f565b44c7bc7d$export$88e20cfc122b8557)([
        section.cta.phone
    ], undefined, undefined, undefined);
    const phoneOffer = (_a = phoneOffers.data) === null || _a === void 0 ? void 0 : _a.at(0);
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    if (!ctaPageInfo.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)((0, $e502eb7414347b57$export$ad00a5af021e778b), {
        heading: localize(section.heading),
        image: section.image,
        backgroundColor: section.backgroundColor,
        cta: {
            buttonVariant: section.cta.buttonVariant,
            url: phoneOffer && ctaPageInfo.data.slug ? `/${localize(ctaPageInfo.data.slug)}?${(0, $f4c4c9282b17128a$export$cefacdcddab7996c)({
                phoneId: phoneOffer.id
            })}` : "/",
            text: !phoneOffer ? localize(section.cta.soldOutText) : (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.cta.text), {
                fromPrice: formatAmount(phoneOffer.monthlyPrice.phone),
                monthsShort: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
            })
        },
        soldOut: !phoneOffer
    });
}
(0, $9G56J.Section)($9edbed8e79cbd892$var$PromoCard);



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");



/**
 * @icon ui-info-square
 */ function $fc55fad046a7eb48$var$MoreReasonsToRedoit(section) {
    const localize = (0, $aIeEI.useLocalize)();
    const moreReasonsToRedoit = (0, $e18f565b44c7bc7d$export$3b68074ea3526841)();
    if (moreReasonsToRedoit.loading || !moreReasonsToRedoit.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)((0, $8160ea1f3816c70f$export$e0b2a4a0e3a11a62), {
        heading: localize(moreReasonsToRedoit.data.heading),
        showSlideButtons: true,
        cards: moreReasonsToRedoit.data.cards.map((c)=>Object.assign(Object.assign({}, c), {
                id: c.id.valueOf()
            })),
        enterAnimation: true,
        renderCard: (c, i)=>{
            var _a, _b;
            return (0, $4vwom.jsx)((0, $0273ae0bc8f90076$export$5fbe01e9406810ee), {
                title: localize(c.heading),
                text: localize(c.text),
                image: c.image,
                readMoreAriaPrefix: localize((_b = (_a = moreReasonsToRedoit.data) === null || _a === void 0 ? void 0 : _a.readMoreAriaPrefix) !== null && _b !== void 0 ? _b : {}),
                runningAnimation: i === 0
            });
        }
    });
}
(0, $9G56J.Section)($fc55fad046a7eb48$var$MoreReasonsToRedoit);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");



var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");











var $a5492242b55a6dcc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const { useMediaQuery: $a5492242b55a6dcc$var$useMediaQuery } = (0, $756948b644e82cf2$export$92c840cda8ec752c).helpers;
/**
 * @icon ui-message-heart-square
 */ function $a5492242b55a6dcc$var$TrustpilotRateUs(section) {
    var _a, _b;
    const localize = (0, $aIeEI.useLocalize)();
    const reviews = (0, $e18f565b44c7bc7d$export$dfd0f591c1636cc4)();
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($13a9f30e9fa4b734$exports))));
    const isMobile = $a5492242b55a6dcc$var$useMediaQuery("max", "sm");
    if (reviews.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)({
            display: "flex",
            flexDirection: "column"
        }),
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            backgroundColor: "gray100",
            borderRadius: "lg",
            css: (0, $lhaLc.css)({
                overflow: "hidden",
                gap: 48,
                alignItems: "flex-start",
                flexDirection: "column",
                paddingTop: 24,
                paddingBottom: 24
            }, responsiveCss("min", "md", {
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 48,
                paddingRight: 48,
                gap: 64,
                alignItems: "center",
                flexDirection: "row",
                height: 560
            }), responsiveCss("min", "lg", {
                height: 680,
                paddingLeft: 96,
                paddingRight: 96,
                gap: 112
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    flex: "1 0 0",
                    alignItems: "flex-start",
                    style: {
                        minWidth: 0
                    },
                    css: responsiveCss("max", "sm", {
                        paddingLeft: 24,
                        paddingRight: 24
                    }),
                    children: [
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            gap: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                            children: [
                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    gap: 16,
                                    alignItems: "center",
                                    children: [
                                        (0, $4vwom.jsx)((0, $67cf5539992d1dd3$export$e6ff31bff12b7ff4), {
                                            width: 56,
                                            height: "auto"
                                        }),
                                        (0, $4vwom.jsx)((0, $34f1974b2dd65db4$export$681b028df1bc0b68), {
                                            rating: 5
                                        })
                                    ]
                                }),
                                (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                    level: 1,
                                    children: localize(section.heading)
                                }),
                                section.text && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "lg",
                                    color: "gray400",
                                    children: localize(section.text)
                                })
                            ]
                        }),
                        section.cta ? (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                            margin: {
                                top: "sm"
                            },
                            children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                as: "a",
                                href: section.cta.url.valueOf(),
                                target: "_blank",
                                variant: "primary",
                                css: responsiveCss("max", "xs", {
                                    width: "100%"
                                }),
                                children: localize(section.cta.text)
                            })
                        }) : null
                    ]
                }),
                (0, $4vwom.jsx)("div", {
                    style: {
                        overflow: "hidden",
                        height: "100%",
                        flex: "0 0 auto",
                        position: "relative"
                    },
                    css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                        width: "100%",
                        "&:after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            bottom: 0,
                            width: 220,
                            zIndex: 1,
                            pointerEvents: "none",
                            right: 0,
                            background: `linear-gradient(90deg, ${colors.gray100}${(0, $2e602d91f6817609$export$dcfd5621ca9623a7)["0"]}, ${colors.gray100}${(0, $2e602d91f6817609$export$dcfd5621ca9623a7)["100"]})`
                        }
                    }), responsiveCss("min", "md", {
                        "&:before, &:after": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            height: 180,
                            zIndex: 1,
                            pointerEvents: "none",
                            width: "100%"
                        },
                        "&:before": {
                            top: 0,
                            background: `linear-gradient(0deg, ${colors.gray100}${(0, $2e602d91f6817609$export$dcfd5621ca9623a7)["0"]}, ${colors.gray100}${(0, $2e602d91f6817609$export$dcfd5621ca9623a7)["100"]})`
                        },
                        "&:after": {
                            bottom: 0,
                            background: `linear-gradient(180deg, ${colors.gray100}${(0, $2e602d91f6817609$export$dcfd5621ca9623a7)["0"]}, ${colors.gray100}${(0, $2e602d91f6817609$export$dcfd5621ca9623a7)["100"]})`
                        }
                    })),
                    children: (0, $4vwom.jsx)((0, $e0d6729bf3c3c3ec$export$a606a0d663523950), {
                        ReviewCardProps: {
                            backgroundColor: "grayWhite"
                        },
                        direction: isMobile ? "row" : "column",
                        reviews: (_b = (_a = reviews.data) === null || _a === void 0 ? void 0 : _a.reviews.map((_a)=>{
                            var { id: id, rating: rating } = _a, r = $a5492242b55a6dcc$var$__rest(_a, [
                                "id",
                                "rating"
                            ]);
                            return {
                                id: id.valueOf(),
                                rating: rating.valueOf(),
                                name: localize(r.name),
                                title: localize(r.title),
                                text: localize(r.text),
                                timestamp: (Date.now() - new Date(r.timestamp.valueOf()).valueOf()) / 86400000 > 7 ? (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(r.timestamp.valueOf()).format("DD.MM.YYYY") : (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(r.timestamp.valueOf()).fromNow()
                            };
                        })) !== null && _b !== void 0 ? _b : [],
                        speed: section.autoScrollSpeed
                    })
                })
            ]
        })
    });
}
(0, $9G56J.Section)($a5492242b55a6dcc$var$TrustpilotRateUs);














var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");



/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */ function $43acddfce38ee705$export$15b697acf84c78b9(initial) {
    const value = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(()=>(0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */ const { isStatic: isStatic } = (0, $eeH7J.useContext)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d));
    if (isStatic) {
        const [, setLatest] = (0, $eeH7J.useState)(initial);
        (0, $eeH7J.useEffect)(()=>value.on("change", setLatest), []);
    }
    return value;
}



var $7m9cQ = parcelRequire("7m9cQ");
parcelRequire("2LTO8");
var $gGZ2r = parcelRequire("gGZ2r");

var $eSiQ2 = parcelRequire("eSiQ2");


// When swiping sideways, the minimum width of a card that should be visible before snapping to it.
const $451387dc0010b0f6$var$currentCardVisibleMinimum = 0.25;
const $451387dc0010b0f6$export$1ee075080fb07ea7 = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function CarouselBase(props, ref) {
    const dragContainerRef = (0, $eeH7J.useRef)(null);
    const cardsContainerRef = (0, $eeH7J.useRef)(null);
    const cardsRef = (0, $eeH7J.useRef)(props.items.map(()=>/*#__PURE__*/ (0, $eeH7J.createRef)()));
    const dragX = (0, $43acddfce38ee705$export$15b697acf84c78b9)(0);
    const [offsetX, setOffsetX] = (0, $eeH7J.useState)(0);
    const [dragOffsetX, setDragOffsetX] = (0, $eeH7J.useState)(0);
    const [position, setPosition] = (0, $eeH7J.useState)({
        atStart: true,
        atEnd: false
    });
    const updateOffsetX = (0, $eeH7J.useCallback)((o)=>{
        const newOffset = o;
        setOffsetX(newOffset);
        // As Framer Motion also keeps the drag offset applied, we need to store that.
        setDragOffsetX(dragX.get());
    }, [
        setOffsetX,
        dragX
    ]);
    // Returns a set of DOMRects used frequently in the component.
    function getRects() {
        var _a, _b, _c, _d, _e, _f;
        const container = (_a = dragContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const grid = (_b = cardsContainerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        const firstCard = (_d = (_c = cardsRef.current[0]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect();
        const lastCard = (_f = (_e = cardsRef.current[cardsRef.current.length - 1]) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect();
        if (!container || !grid || !firstCard || !lastCard) {
            // eslint-disable-next-line no-console
            console.warn("Missing reference to container, card, or grid.");
            return;
        }
        return {
            container: container,
            grid: grid,
            firstCard: firstCard,
            lastCard: lastCard
        };
    }
    const updatePosition = (0, $eeH7J.useCallback)(()=>{
        const rects = getRects();
        if (!rects) return;
        const newPosition = {
            atStart: Math.round(rects.container.left) === Math.round(rects.firstCard.left),
            atEnd: Math.round(rects.container.right) === Math.round(rects.lastCard.right)
        };
        if (newPosition.atStart === position.atStart && newPosition.atEnd === position.atEnd) return;
        setPosition(newPosition);
    }, [
        position
    ]);
    // Update position object whenever offsetX changes.
    (0, $eeH7J.useEffect)(()=>{
        updatePosition();
    }, [
        offsetX,
        updatePosition
    ]);
    const { onPositionChange: onPositionChange } = props;
    // Call onPositionChange when position changes.
    (0, $eeH7J.useEffect)(()=>{
        onPositionChange === null || onPositionChange === void 0 || onPositionChange(position);
    }, [
        position,
        onPositionChange
    ]);
    // Ref functions that allow other components consuming this one to trigger next/prev switch.
    (0, $eeH7J.useImperativeHandle)(ref, ()=>({
            next () {
                handleSlideClick("next");
            },
            prev () {
                handleSlideClick("prev");
            }
        }));
    const debouncedUpdatePosition = (0, $eeH7J.useMemo)(()=>$451387dc0010b0f6$var$debounce(updatePosition, 500), [
        updatePosition
    ]);
    const resizeHandler = (0, $eeH7J.useCallback)(()=>{
        const rects = getRects();
        if (!rects) return;
        const atEnd = rects.lastCard.right < rects.container.right;
        if (atEnd) {
            const newOffsetX = rects.firstCard.left - (rects.lastCard.right - rects.container.width);
            updateOffsetX(newOffsetX);
        }
        debouncedUpdatePosition();
    }, [
        updateOffsetX,
        debouncedUpdatePosition
    ]);
    (0, $eeH7J.useEffect)(()=>{
        const resizeObserver = new ResizeObserver(resizeHandler);
        resizeObserver.observe(document.body);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        resizeHandler
    ]);
    (0, $eeH7J.useEffect)(()=>{
        // The intersection observer is used to observe when any of the cards intersect with
        // the container.
        const intersectionObserver = new IntersectionObserver(debouncedUpdatePosition, {
            root: dragContainerRef.current,
            rootMargin: "0px",
            threshold: 1.0
        });
        for (const c of cardsRef.current)if (c.current) intersectionObserver.observe(c.current);
        // We need the mutation observer to observe for changes in position controlled by style
        // attribute of child elements. Because of that it's difficult to trigger in a better way.
        const mutationObserver = new MutationObserver(debouncedUpdatePosition);
        if (cardsContainerRef.current) mutationObserver.observe(cardsContainerRef.current, {
            attributes: true,
            subtree: true
        });
        return ()=>{
            mutationObserver.disconnect();
            intersectionObserver.disconnect();
        };
    }, [
        debouncedUpdatePosition
    ]);
    // Find the index of the (first) card that should be presented as the current card.
    const findCurrentCardIndex = (0, $eeH7J.useCallback)((info)=>{
        var _a;
        const containerRect = (_a = dragContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!containerRect) {
            // eslint-disable-next-line no-console
            console.warn("Unable to find current card index without a reference to the container element.");
            return;
        }
        let returnIndex;
        return cardsRef.current.findIndex((item, index)=>{
            var _a, _b, _c;
            if (returnIndex === index) {
                returnIndex = undefined;
                return true;
            }
            const itemRect = (_a = item.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (!itemRect) throw new Error(`No element for card item at index ${index}.`);
            // The first card is dragged to the right of the left edge of the container
            if (index === 0 && itemRect.left > containerRect.left) return true;
            const nextRect = (_c = (_b = cardsRef.current[index + 1]) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
            if (!nextRect) return true;
            const isLeftEdgeInside = itemRect.left > containerRect.left && itemRect.left < containerRect.right;
            const isRightEdgeInside = itemRect.right > containerRect.left && itemRect.right < containerRect.right;
            // If neither the left nor the right edge is inside this is not the card.
            if (!isLeftEdgeInside && !isRightEdgeInside) return false;
            // If the whole card is inside, this is it.
            if (isLeftEdgeInside && isRightEdgeInside) return true;
            if (info.offset.x < 0) {
                // Dragged towards the left.
                // Some but less than `currentCardVisibleMinimum` of right side is inside, move to next.
                const pmoveToNext = !isLeftEdgeInside && isRightEdgeInside;
                if (pmoveToNext) {
                    const moveToNext = itemRect.right - containerRect.left < itemRect.width - itemRect.width * $451387dc0010b0f6$var$currentCardVisibleMinimum;
                    if (moveToNext) {
                        returnIndex = index + 1;
                        return false;
                    }
                }
                // If more than right half is visible, this is it.
                const rightHalfPlusInside = isRightEdgeInside && itemRect.right - containerRect.left > itemRect.width * $451387dc0010b0f6$var$currentCardVisibleMinimum;
                if (rightHalfPlusInside) return true;
                // If none of the above is the case for any cards until now, this is the one.
                const leftHalfPlusInside = isLeftEdgeInside && containerRect.right - itemRect.left > itemRect.width * $451387dc0010b0f6$var$currentCardVisibleMinimum;
                if (leftHalfPlusInside) return true;
            } else if (info.offset.x > 0) {
                // Dragged towards the right
                const rightThirdPlusInside = isRightEdgeInside && itemRect.right - containerRect.left > itemRect.width * $451387dc0010b0f6$var$currentCardVisibleMinimum;
                if (rightThirdPlusInside) return true;
            }
            return false;
        });
    }, []);
    const handleDragEnd = (0, $eeH7J.useCallback)((e, info)=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const containerRect = (_a = dragContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const gridRect = (_b = cardsContainerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        const firstCardRect = (_d = (_c = cardsRef.current[0]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect();
        const lastCardRect = (_f = (_e = cardsRef.current[cardsRef.current.length - 1]) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect();
        if (!containerRect || !gridRect || !firstCardRect || !lastCardRect) {
            // eslint-disable-next-line no-console
            console.warn("Missing reference to container or grid.");
            return;
        }
        // The actual width of the cards. As opposed to the rect width, which is cut off at the
        // overflow point.
        const cardsContainerActualWidth = lastCardRect.right - firstCardRect.left;
        // If the whole grid is visible, no need to set any offset, but as always take dragX
        // into account.
        if (cardsContainerActualWidth <= containerRect.width) {
            updateOffsetX(0);
            return;
        }
        // Last card is to the right side of container edge.
        if (lastCardRect.right < containerRect.right) {
            const newOffsetX = firstCardRect.left - (lastCardRect.right - containerRect.width);
            updateOffsetX(newOffsetX);
            return;
        }
        const currentCardIndex = findCurrentCardIndex(info);
        if (typeof currentCardIndex === "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Couldn't find a current card index. Reset offset and dragX.");
            updateOffsetX(0);
            dragX.set(0);
            return;
        }
        const currCardRect = (_h = (_g = cardsRef.current[currentCardIndex]) === null || _g === void 0 ? void 0 : _g.current) === null || _h === void 0 ? void 0 : _h.getBoundingClientRect();
        if (!firstCardRect || !currCardRect) {
            // eslint-disable-next-line no-console
            console.warn("Missing reference to first card or current card.");
            return;
        }
        // If the width from the current card to the last card is less than the container, align
        // the last card to the right side.
        if (lastCardRect.right - currCardRect.left < containerRect.width) {
            const newOffsetX = firstCardRect.left - (lastCardRect.right - containerRect.width);
            updateOffsetX(newOffsetX);
            return;
        }
        // Find new offset. It is usually the distance from the first card to the current card.
        // Except if current card is the last card, as that should not be aligned with the left
        // side of the container, but the right side.
        const newOffsetX = firstCardRect.left - (currentCardIndex === props.items.length - 1 ? currCardRect.right - containerRect.width : currCardRect.left);
        updateOffsetX(newOffsetX);
    }, [
        updateOffsetX,
        findCurrentCardIndex,
        dragX,
        props.items.length
    ]);
    // Just copied from CardsBlock, probably a good candidate for rafactoring.
    const handleSlideClick = (0, $eeH7J.useCallback)((direction)=>{
        var _a, _b, _c;
        if (!dragContainerRef.current) return;
        // Direction is the direction the cards will slide in, which is the opposite of the way the
        // arrow on the button is pointing.
        const slideDirection = direction === "prev" ? "right" : "left";
        const containerRect = dragContainerRef.current.getBoundingClientRect();
        try {
            // Find first card that is partially on the inside and partially on the outside of
            // container. Or the card before a card that is just inside the container This is
            // the card we'll want to move to the edge of the container.
            const firstCardPartiallyOutside = cardsRef.current.find((item, index)=>{
                var _a, _b, _c;
                const itemRect = (_a = item.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                if (!itemRect) throw new Error(`No element for card item at index ${index}.`);
                if (slideDirection === "left") return itemRect.right > containerRect.right;
                else {
                    const nextRect = (_c = (_b = cardsRef.current[index + 1]) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
                    if (!nextRect) return true;
                    return itemRect.left < containerRect.left && Math.round(nextRect.left) === Math.round(containerRect.left) || itemRect.left < containerRect.left && itemRect.right > containerRect.left;
                }
            });
            const firstCardPartiallyOutsideRect = (_a = firstCardPartiallyOutside === null || firstCardPartiallyOutside === void 0 ? void 0 : firstCardPartiallyOutside.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (!firstCardPartiallyOutsideRect) throw new Error("Couldn't find rect for first card outside container.");
            // Find if remaining width outside is less than will fit in container.
            const outerMostCardRect = (_c = (_b = slideDirection === "left" ? cardsRef.current[cardsRef.current.length - 1] : cardsRef.current[0]) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
            if (!outerMostCardRect) throw new Error("No outermost card.");
            const remainingWidthOutside = slideDirection === "left" ? outerMostCardRect.right - containerRect.right : containerRect.left - outerMostCardRect.left;
            if (remainingWidthOutside < containerRect.width) updateOffsetX(slideDirection === "left" ? offsetX - remainingWidthOutside : 0);
            else {
                // Else, scroll to where the first card partially outside, will be at the
                // container edge in the slide direction.
                const distanceFromCardToContainerEdge = containerRect[slideDirection] - firstCardPartiallyOutsideRect[slideDirection];
                updateOffsetX(offsetX + distanceFromCardToContainerEdge);
                return;
            }
            return;
        } catch (err) {
            //eslint-disable-next-line no-console
            console.log(err);
        }
    }, [
        offsetX,
        updateOffsetX
    ]);
    return (0, $4vwom.jsx)("div", {
        ref: dragContainerRef,
        children: (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
            drag: "x",
            dragDirectionLock: true,
            dragMomentum: false,
            onDragEnd: handleDragEnd,
            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
            animate: {
                translateX: `${offsetX - dragOffsetX}px`
            },
            onAnimationComplete: ()=>updatePosition(),
            style: {
                x: dragX
            },
            children: (0, $4vwom.jsx)("div", {
                ref: cardsContainerRef,
                children: props.renderContainer(props.items.map((item, index)=>(0, $4vwom.jsx)("div", {
                        ref: cardsRef.current[index],
                        children: props.renderItem(item, index)
                    }, index)))
            })
        })
    });
});
const $451387dc0010b0f6$var$arr = [
    ...new Array(3)
].map(()=>"Hello, World!");
(0, $eSiQ2.Component)($451387dc0010b0f6$export$1ee075080fb07ea7, {
    name: "CarouselBase",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            items: $451387dc0010b0f6$var$arr,
                            renderContainer: (children)=>(0, $4vwom.jsx)("div", {
                                    style: {
                                        display: "grid",
                                        gridAutoFlow: "column",
                                        gap: 16,
                                        gridAutoColumns: "min-content"
                                    },
                                    children: children
                                }),
                            renderItem: (_, index)=>(0, $4vwom.jsx)((0, $0273ae0bc8f90076$export$5fbe01e9406810ee), {
                                    title: `Hello ${index}${index}${index}${index}`,
                                    text: (0, $gGZ2r.Markdown)(`${index}`),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/how-it-works-card-illustration-3.svg`,
                                    readMoreAriaPrefix: "Read more"
                                })
                        }
                    }
                ]
            }
        ]
    }
});
function $451387dc0010b0f6$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        if (typeof window === "undefined") callback(...args);
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>{
            callback(...args);
        }, wait);
    };
}













var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");

function $d69bccca6c93b4b8$export$20d89a4afa1a58fa(props) {
    const { responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const containerCss = (0, $eeH7J.useMemo)(()=>(0, $lhaLc.css)({
            maxHeight: 64,
            "&:hover div": {
                animationPlayState: "paused"
            },
            "&:before, &:after": {
                content: '""',
                position: "absolute",
                top: 0,
                bottom: 0,
                width: 50,
                zIndex: 1,
                pointerEvents: "none"
            },
            "&:before": {
                left: 0,
                background: "linear-gradient(270deg, rgba(255, 255,255,0), rgba(255, 255,255,1))"
            },
            "&:after": {
                right: 0,
                background: "linear-gradient(90deg, rgba(255, 255,255,0), rgba(255, 255,255,1))"
            }
        }, responsiveCss("min", "md", {
            "&:before, &:after": {
                width: 360,
                maxHeight: 80
            }
        })), [
        responsiveCss
    ]);
    return (0, $4vwom.jsxs)("div", {
        style: {
            position: "relative",
            overflow: "hidden",
            whiteSpace: "nowrap"
        },
        css: containerCss,
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    animationDuration: `${props.items.length * 5}s`
                },
                css: [
                    $d69bccca6c93b4b8$var$responsiveGridCss,
                    $d69bccca6c93b4b8$var$animationCss
                ],
                children: props.items.map((item, index)=>(0, $4vwom.jsx)("div", {
                        children: item
                    }, index))
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    animationDuration: `${props.items.length * 5}s`
                },
                css: [
                    $d69bccca6c93b4b8$var$responsiveGridCss,
                    $d69bccca6c93b4b8$var$animationCss
                ],
                children: props.items.map((item, index)=>(0, $4vwom.jsx)("div", {
                        children: item
                    }, index))
            })
        ]
    });
}
const $d69bccca6c93b4b8$var$marquee = (0, $lhaLc.keyframes)({
    from: {
        transform: "translateX(0%)"
    },
    to: {
        transform: "translateX(-100%)"
    }
});
const $d69bccca6c93b4b8$var$animationCss = (0, $lhaLc.css)({
    animationName: $d69bccca6c93b4b8$var$marquee
});
const $d69bccca6c93b4b8$var$responsiveGridCss = (0, $lhaLc.css)({
    display: "inline-flex",
    alignItems: "center",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear"
});
(0, $eSiQ2.Component)($d69bccca6c93b4b8$export$20d89a4afa1a58fa, {
    name: "ContinuousSlideCarousel",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            items: [
                                ...new Array(5)
                            ].map((item, index)=>(0, $4vwom.jsx)("div", {
                                    children: "Hello, world!"
                                }, index))
                        }
                    }
                ]
            }
        ]
    }
});







var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $18Pjr = parcelRequire("18Pjr");

var $lhaLc = parcelRequire("lhaLc");

var $gssTr = parcelRequire("gssTr");

var $ikBJm = parcelRequire("ikBJm");

var $4vwom = parcelRequire("4vwom");

var $18Pjr = parcelRequire("18Pjr");

var $lhaLc = parcelRequire("lhaLc");

var $2chu2 = parcelRequire("2chu2");
function $a2a649cb2a0219fd$export$ace63239d21d36e() {
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsxs)((0, $18Pjr.Route), {
            path: "/gallery",
            element: (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $lhaLc.Global), {
                        styles: (0, $lhaLc.css)`
                                @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap");

                                *,
                                *:before,
                                *:after {
                                    box-sizing: border-box;
                                }

                                html,
                                body {
                                    font-family: "Inter", sans-serif;
                                    background-color: "#f4f5f7";
                                }
                            `
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Outlet), {})
                ]
            }),
            children: [
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    index: true,
                    element: (0, $4vwom.jsx)($a2a649cb2a0219fd$var$IndexLazy, {})
                }),
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "components/*",
                    element: (0, $4vwom.jsx)($a2a649cb2a0219fd$var$ComponentLazy, {})
                })
            ]
        })
    });
}

function $a2a649cb2a0219fd$var$IndexLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("btSzs"))).Index
    });
}

function $a2a649cb2a0219fd$var$ComponentLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("jwy4G"))).ComponentPage
    });
}



var $4vwom = parcelRequire("4vwom");

var $2chu2 = parcelRequire("2chu2");

var $18Pjr = parcelRequire("18Pjr");


var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $dUDPg = parcelRequire("dUDPg");

var $18Pjr = parcelRequire("18Pjr");
function $32200496962fa240$export$415e2b10a0b89d5b(pathParam) {
    const params = (0, $18Pjr.useParams)();
    const value = params[pathParam];
    if (typeof value !== "string") throw new Error("Path parameter not found: " + pathParam);
    return value;
}



var $hV5w0 = parcelRequire("hV5w0");

var $4rY0U = parcelRequire("4rY0U");
function $c2d74f90fd30fcae$export$5b5b1e59dd8f64fe() {
    var _a;
    const urlSecret = (0, $32200496962fa240$export$415e2b10a0b89d5b)("urlSecret");
    const [state, setState] = (0, $eeH7J.useState)({});
    const body = (0, $eeH7J.useMemo)(()=>({
            state: state
        }), [
        state
    ]);
    const { data: data, refresh: refresh } = (0, $dUDPg.useSharedWidget)((_a = urlSecret) !== null && _a !== void 0 ? _a : null, body);
    return (0, $4vwom.jsx)((0, $hV5w0.WidgetContext).Provider, {
        value: {
            root: data === null || data === void 0 ? void 0 : data.content,
            async performAction () {
                alert("Not implemented");
            },
            refresh: refresh,
            state: Object.assign(Object.assign({}, data === null || data === void 0 ? void 0 : data.defaultState), state),
            async setState (newState) {
                setState((state)=>Object.assign(Object.assign({}, state), newState));
            }
        },
        children: (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
            value: data === null || data === void 0 ? void 0 : data.content
        })
    });
}



var $3SKqX = parcelRequire("3SKqX");
function $f6fc29e20a2ebf5b$export$83fb124b13439b08(plugins) {
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsx)((0, $18Pjr.Route), {
                path: "shared-widgets/:urlSecret",
                element: (0, $4vwom.jsx)((0, $c2d74f90fd30fcae$export$5b5b1e59dd8f64fe), {})
            }),
            (0, $4vwom.jsx)((0, $18Pjr.Route), {
                path: "print/:collection/:document/:widgetKey",
                element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PrintLazy, {})
            }),
            (0, $4vwom.jsxs)((0, $18Pjr.Route), {
                path: "/studio",
                element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$DatasetLazy, {
                    plugins: plugins
                }),
                children: [
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        index: true,
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PageLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "post/:endpoint/*",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PostLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "search",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$SearchLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "diagnostics",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$DiagnosticsLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "import",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$ImportLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "console",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$ConsoleLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "console/:id",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$ConsoleLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: ":page",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PageLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: ":page/:doc/:slug",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PageLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: ":page/:doc",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PageLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "*",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$NotFoundView, {})
                    })
                ]
            })
        ]
    });
}


function $f6fc29e20a2ebf5b$var$DatasetLazy({ plugins: plugins }) {
    return (0, $4vwom.jsx)((0, $3SKqX.WebSocketContextProvider), {
        children: (0, $4vwom.jsx)((0, $2chu2.Lazy), {
            target: async ()=>{
                if (plugins) await plugins();
                await (parcelRequire("7v7E9"));
                return (await (parcelRequire("f0wM3"))).Dataset;
            }
        })
    });
}

function $f6fc29e20a2ebf5b$var$PageLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("f0wM3"))).Page
    });
}

function $f6fc29e20a2ebf5b$var$ConsoleLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("cewlD"))).ConsoleView
    });
}

function $f6fc29e20a2ebf5b$var$PostLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("5k9Zg"))).PostView
    });
}

function $f6fc29e20a2ebf5b$var$SearchLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("ii2We"))).SearchResults
    });
}

function $f6fc29e20a2ebf5b$var$DiagnosticsLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("2g57I"))).Diagnostics
    });
}

function $f6fc29e20a2ebf5b$var$ImportLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("flxzf"))).ImportView
    });
}

function $f6fc29e20a2ebf5b$var$PrintLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("6noo6"))).TablePrint
    });
}
function $f6fc29e20a2ebf5b$var$NotFoundView() {
    (0, $f3376239f4cdc33f$export$18dc2edb475b04ff).code = 404;
    const path = (0, $18Pjr.useParams)()["*"];
    return (0, $4vwom.jsxs)("div", {
        children: [
            "There is no page at this location: ",
            path
        ]
    });
}



var $dUDPg = parcelRequire("dUDPg");

var $4vwom = parcelRequire("4vwom");

var $2chu2 = parcelRequire("2chu2");

var $18Pjr = parcelRequire("18Pjr");

var $7FrRx = parcelRequire("7FrRx");

var $knIBr = parcelRequire("knIBr");
parcelRequire("jniej");
var $3SKqX = parcelRequire("3SKqX");

function $bc2d4ca19ef81dfc$export$e2ae8835b525498d(props) {
    return (0, $4vwom.jsx)((0, $3SKqX.WebSocketContextProvider), {
        children: (0, $4vwom.jsx)((0, $2chu2.Lazy), {
            load: props.condition,
            target: async ()=>{
                if (props.plugins) await props.plugins();
                return (await (parcelRequire("dwPtD"))).EditableSite;
            },
            fallback: $bc2d4ca19ef81dfc$var$NonEditableSite
        })
    });
}
function $bc2d4ca19ef81dfc$var$NonEditableSite() {
    return (0, $4vwom.jsx)((0, $7FrRx.CurrentLocaleProvider), {
        children: (0, $4vwom.jsx)((0, $knIBr.SelectionContext).Provider, {
            value: (0, $knIBr.DummySelectionContext),
            children: (0, $4vwom.jsx)((0, $18Pjr.Outlet), {})
        })
    });
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $dUDPg = parcelRequire("dUDPg");

var $9Q5xE = parcelRequire("9Q5xE");

var $eeH7J = parcelRequire("eeH7J");

var $aIeEI = parcelRequire("aIeEI");
function $ff100056042ab63c$export$27cef3a4b5908de4() {
    const { data: data, refresh: refresh } = (0, $dUDPg.useCookieConsents)();
    const localize = (0, $aIeEI.useLocalize)();
    const [necessary, setNecessary] = (0, $eeH7J.useState)(true);
    const [preferences, setPreferences] = (0, $eeH7J.useState)(false);
    const [statistics, setStatistics] = (0, $eeH7J.useState)(false);
    const [marketing, setMarketing] = (0, $eeH7J.useState)(false);
    if ((data === null || data === void 0 ? void 0 : data.consents) || !(data === null || data === void 0 ? void 0 : data.info)) return null;
    return (0, $4vwom.jsxs)("div", {
        css: (0, $lhaLc.css)`
                position: fixed;
                bottom: 0;
                left: 0;
                right: 0;
                padding: 32px;
                background-color: ${data.info.colorMode === "dark" ? "#000e" : "#fff"};
                color: ${data.info.colorMode === "light" ? "black" : "white"};
                display: flex;
                flex-direction: row;
                z-index: 1000;
                box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.1);
                overflow-y: scroll;

                @media (max-width: 600px) {
                    flex-direction: column;
                    top: 0;
                    margin: 16px;
                    margin-top: 32px;
                    margin-bottom: 32px;
                    border-radius: 8px;
                    font-size: 12px;
                }
            `,
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    flex: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: data.info.logo && (0, $4vwom.jsx)("img", {
                    src: data.info.logo.valueOf(),
                    alt: "",
                    css: (0, $lhaLc.css)`
                            width: 50%;
                            max-width: 96px;

                            @media (max-width: 600px) {
                                max-width: 64px;
                                margin-bottom: 16px;
                            }
                        `
                })
            }),
            (0, $4vwom.jsxs)("div", {
                style: {
                    flex: 2,
                    paddingRight: 32,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                },
                children: [
                    (0, $4vwom.jsx)("div", {
                        style: {
                            marginBottom: 8
                        },
                        children: (0, $4vwom.jsx)("b", {
                            children: localize(data.info.title)
                        })
                    }),
                    (0, $4vwom.jsx)("div", {
                        children: localize(data.info.description)
                    }),
                    (0, $4vwom.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-evenly",
                            marginTop: 16,
                            flexWrap: "wrap"
                        },
                        children: [
                            (0, $4vwom.jsx)($ff100056042ab63c$var$Switch, {
                                label: localize(data.info.necessary),
                                value: necessary,
                                onChange: setNecessary,
                                disabled: true
                            }),
                            (0, $4vwom.jsx)($ff100056042ab63c$var$Switch, {
                                label: localize(data.info.preferences),
                                value: preferences,
                                onChange: setPreferences
                            }),
                            (0, $4vwom.jsx)($ff100056042ab63c$var$Switch, {
                                label: localize(data.info.statistics),
                                value: statistics,
                                onChange: setStatistics
                            }),
                            (0, $4vwom.jsx)($ff100056042ab63c$var$Switch, {
                                label: localize(data.info.marketing),
                                value: marketing,
                                onChange: setMarketing
                            })
                        ]
                    })
                ]
            }),
            (0, $4vwom.jsxs)("div", {
                style: {
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    padding: 32
                },
                children: [
                    (0, $4vwom.jsx)("div", {
                        style: {
                            backgroundColor: (0, $9Q5xE.ColorStyles).primary[700],
                            borderRadius: 8,
                            color: "white",
                            marginBottom: 8,
                            textAlign: "center",
                            padding: 12,
                            cursor: "pointer"
                        },
                        onClick: async ()=>{
                            await (0, $dUDPg.putCookieConsents)({
                                necessary: true,
                                marketing: true,
                                preferences: true,
                                statistics: true
                            });
                            if (GiveCookieConsent) {
                                // Calling GiveCookieConsent will execute all
                                // callbacks registered with WithCookieConsent for
                                // the specified type. This allows the consents to
                                // take effect without reloading the page.
                                GiveCookieConsent("necessary");
                                GiveCookieConsent("marketing");
                                GiveCookieConsent("preferences");
                                GiveCookieConsent("statistics");
                            }
                            await refresh();
                        },
                        children: localize(data.info.allowAll)
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            backgroundColor: (0, $9Q5xE.ColorStyles).primary[100],
                            borderRadius: 8,
                            color: "#333",
                            marginBottom: 8,
                            textAlign: "center",
                            padding: 12,
                            cursor: "pointer"
                        },
                        onClick: async ()=>{
                            await (0, $dUDPg.putCookieConsents)({
                                necessary: true,
                                marketing: marketing,
                                preferences: preferences,
                                statistics: statistics
                            });
                            await refresh();
                            if (GiveCookieConsent && necessary) GiveCookieConsent("necessary");
                            if (GiveCookieConsent && preferences) GiveCookieConsent("preferences");
                            if (GiveCookieConsent && statistics) GiveCookieConsent("statistics");
                            if (GiveCookieConsent && marketing) GiveCookieConsent("marketing");
                        },
                        children: localize(data.info.allowSelection)
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            backgroundColor: (0, $9Q5xE.ColorStyles).primary[100],
                            borderRadius: 8,
                            color: "#333",
                            marginBottom: 8,
                            textAlign: "center",
                            padding: 12,
                            cursor: "pointer"
                        },
                        onClick: async ()=>{
                            await (0, $dUDPg.putCookieConsents)({
                                necessary: true,
                                marketing: false,
                                preferences: false,
                                statistics: false
                            });
                            await refresh();
                            if (GiveCookieConsent) GiveCookieConsent("necessary");
                        },
                        children: localize(data.info.deny)
                    })
                ]
            })
        ]
    });
}
// A sliding switch component that can be used to toggle a boolean value.
function $ff100056042ab63c$var$Switch({ label: label, value: value, onChange: onChange, disabled: disabled }) {
    return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
        },
        children: [
            label,
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)`
                    position: relative;
                    margin: 8px;
                    width: 50px;
                    height: 24px;
                    background-color: ${value ? (0, $9Q5xE.ColorStyles).primary[700] : (0, $9Q5xE.ColorStyles).gray[300]};
                    transition: background-color 0.2s;
                    border-radius: 12px;
                    cursor: ${disabled ? "not-allowed" : "pointer"};
                    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.4);
                `,
                onClick: ()=>{
                    if (!disabled) onChange(!value);
                },
                children: (0, $4vwom.jsx)("div", {
                    css: (0, $lhaLc.css)`
                        position: absolute;
                        top: 0;
                        left: ${value ? "26px" : "0"};
                        width: 24px;
                        height: 24px;
                        background-color: white;
                        border-radius: 50%;
                        transition: left 0.2s;
                        box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
                    `
                })
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
parcelRequire("2LTO8");
var $2uVAW = parcelRequire("2uVAW");
var $lDBHC = parcelRequire("lDBHC");
var $dAwef = parcelRequire("dAwef");

var $7m9cQ = parcelRequire("7m9cQ");
parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");
var $cWF8g = parcelRequire("cWF8g");

var $9Q5xE = parcelRequire("9Q5xE");

var $dUDPg = parcelRequire("dUDPg");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $8h5s0 = parcelRequire("8h5s0");

var $8vTN8 = parcelRequire("8vTN8");


var $cSf8f = parcelRequire("cSf8f");

var $aIeEI = parcelRequire("aIeEI");

var $3kELz = parcelRequire("3kELz");

var $8MAXm = parcelRequire("8MAXm");

var $dOFTp = parcelRequire("dOFTp");
function $1d62341d1bbfd0c5$export$a0dcf0ef8dc3ae26({ obj: obj, prop: prop, className: className, style: style, link: link, defaultText: defaultText, placeholder: placeholder, isMarkdown: isMarkdown, numberFormat: numberFormat, maxLength: maxLength, isLocalized: isLocalized, onClick: onClick, display: display, macros: macros, markdownMacros: markdownMacros }) {
    const ref = (0, $eeH7J.useRef)(null);
    let value = obj[prop];
    const editing = (0, $dOFTp.useObserveYProxy)(isLocalized ? value : obj);
    const locale = (0, $aIeEI.useCurrentLocale)();
    const [focused, setFocused] = (0, $eeH7J.useState)(false);
    const navigate = (0, $8vTN8.useNavigate)();
    if (macros && isMarkdown) return (0, $4vwom.jsx)("div", {
        style: {
            color: "red"
        },
        children: "Macros not supported in markdown"
    });
    if (isLocalized && value === undefined) value = {};
    const wasLocalized = typeof value === "object";
    if (wasLocalized) value = (0, $cSf8f.ClientSideLocalize)(value, locale);
    if (!value) value = defaultText;
    if (editing && !value) value = placeholder;
    if (typeof value === "number") {
        if (numberFormat) value = numberFormat.format(value);
    }
    if (value !== undefined && typeof value !== "string") value = "" + value;
    if (!editing && maxLength && typeof value === "string" && value.length > maxLength) value = (0, $8h5s0.ellipsize)(value, maxLength);
    const giveFocus = editing ? ()=>{
        setFocused(true);
        // Need to wait for re-render, then attempt to give focus to editable content
        setTimeout(()=>{
            var _a;
            return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 10);
    } : undefined;
    if (macros) display = (v)=>(0, $87d2193cf0695c20$export$8f2dc74599543279)(v, macros);
    const onClickHandler = (e)=>{
        if (editing) {
            e.stopPropagation();
            e.preventDefault();
        }
        if (giveFocus) giveFocus();
        else if (onClick) onClick();
        else if (link && !editing) navigate(link.toString());
    };
    return focused ? isMarkdown ? (0, $4vwom.jsxs)("div", {
        className: className,
        style: style,
        children: [
            (0, $4vwom.jsx)((0, $3kELz.MarkdownEditor), {
                value: value,
                onChanged: (newValue)=>{
                    var _a;
                    var _b;
                    if (wasLocalized) {
                        (_a = (_b = obj)[prop]) !== null && _a !== void 0 ? _a : _b[prop] = {};
                        obj[prop][locale] = newValue;
                    } else obj[prop] = newValue;
                },
                onDone: ()=>setFocused(false),
                onDrop: async (fileDropped)=>{
                    return undefined;
                },
                style: "wysiwyg"
            }),
            editing && !!macros ? (0, $4vwom.jsx)($1d62341d1bbfd0c5$var$MacrosView, {
                macros: macros
            }) : undefined
        ]
    }) : (0, $4vwom.jsx)("textarea", {
        className: className,
        style: Object.assign({
            backgroundColor: "transparent",
            border: "none",
            outline: "none"
        }, style),
        value: value,
        onBlur: ()=>setFocused(false),
        onChange: (e)=>{
            var _a;
            var _b;
            if (wasLocalized) {
                (_a = (_b = obj)[prop]) !== null && _a !== void 0 ? _a : _b[prop] = {};
                obj[prop][locale] = e.target.value;
            } else obj[prop] = e.target.value;
        }
    }) : display ? (0, $4vwom.jsx)("div", {
        onClick: onClickHandler,
        className: className,
        style: style,
        children: display(value)
    }) : (0, $4vwom.jsx)("div", {
        onClick: onClickHandler,
        className: className,
        style: style,
        children: isMarkdown ? (0, $4vwom.jsx)((0, $8MAXm.MarkdownView), {
            value: markdownMacros ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(value, markdownMacros) : value
        }) : value
    });
}
function $1d62341d1bbfd0c5$var$MacrosView({ macros: macros }) {
    const [show, setShow] = (0, $eeH7J.useState)(false);
    return (0, $4vwom.jsx)("div", {
        onMouseOver: ()=>setShow(true),
        style: {
            backgroundColor: "#ffa",
            padding: 2,
            borderRadius: 2,
            fontSize: 10,
            width: show ? undefined : 12,
            height: show ? undefined : 12
        },
        children: show ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
            children: [
                "Available macros:",
                (0, $4vwom.jsx)("table", {
                    children: Object.keys(macros).filter((m)=>!!macros[m]).map((m)=>(0, $4vwom.jsxs)("tr", {
                            children: [
                                (0, $4vwom.jsx)("td", {
                                    children: `{{${m}}}`
                                }),
                                (0, $4vwom.jsx)("td", {
                                    children: (0, $4vwom.jsx)("div", {
                                        style: {
                                            padding: 4
                                        },
                                        children: macros[m]
                                    })
                                })
                            ]
                        }, m))
                })
            ]
        }) : (0, $4vwom.jsx)((0, $4vwom.Fragment), {
            children: "+"
        })
    });
}


function $de0ebc18cc685286$export$21a94553ffa41578() {
    const { data: props } = (0, $dUDPg.useLoginPageConfig)();
    const [redirect] = (0, $cWF8g.useQueryString)("redirect");
    const [renew] = (0, $cWF8g.useQueryString)("renew");
    const [reason] = (0, $cWF8g.useQueryString)("reason");
    const [email, setEmail] = (0, $eK8Q4.usePreference)("login-email", "");
    const [emailValid, setEmailValid] = (0, $eeH7J.useState)(false);
    const [sent, setSent] = (0, $eeH7J.useState)(false);
    const [hide, setHide] = (0, $eeH7J.useState)(false);
    // For some reason computing emailValid directly as a derived state from
    // `email` didn't work (the button was stuck on disabled), but computing it
    // in a useEffect did. Some weird React bug?
    (0, $eeH7J.useEffect)(()=>{
        if (email) try {
            (0, $2uVAW.Email)(email);
            setEmailValid(true);
        } catch (err) {
            setEmailValid(false);
        }
    }, [
        email
    ]);
    const sendLoginLink = (0, $eeH7J.useCallback)(async ()=>{
        if (email && emailValid) try {
            // Since the sendLoginLink endpoint is
            // conditionally included in the server
            // we cannot import in from client.ts
            await fetch(`${(0, $7m9cQ.server)()}/api/studio/auth/send-login-link`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: (0, $2uVAW.Email)(email),
                    nonce: (0, $dAwef.Uuid)().valueOf(),
                    redirect: redirect ? redirect : undefined,
                    renew: renew ? (0, $dAwef.Uuid)(renew) : undefined
                })
            });
        } catch (e) {
            alert("detail" in e ? e.detail : JSON.stringify(e));
        }
        setSent(true);
        setTimeout(()=>setHide(true), 500);
    }, [
        email,
        emailValid,
        redirect,
        renew,
        setSent,
        setHide
    ]);
    // Intro animation
    const [frame, setFrame] = (0, $eeH7J.useState)(0);
    const [startTime] = (0, $eeH7J.useState)(Date.now());
    const time = Date.now() - startTime;
    if (time < 1500 && !(0, $lDBHC.IsNode)()) requestAnimationFrame(()=>setFrame(frame + 1));
    if (!props) return null;
    return (0, $4vwom.jsxs)("div", {
        style: {
            height: "100vh",
            width: "100%",
            position: "relative",
            background: props.background
        },
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    backgroundImage: props.logo ? `url('${(0, $7m9cQ.server)()}${props.logo}')` : undefined,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    height: 64,
                    width: 180,
                    marginLeft: 32,
                    marginTop: 16,
                    position: "absolute",
                    opacity: time > 250 ? 1 : 0,
                    transform: `translateY(${time > 250 ? 0 : -32}px)`,
                    transition: "all  0.375s ease"
                }
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    width: "100%",
                    position: "absolute"
                },
                children: (0, $4vwom.jsxs)("div", {
                    style: {
                        color: props.light ? (0, $9Q5xE.ColorStyles)["gray-cool"][600] : "white",
                        opacity: sent ? 1 : 0,
                        transform: sent ? `translateY(0)` : `translatey(-100px)`,
                        transition: "all 0.375s ease",
                        textAlign: "center"
                    },
                    children: [
                        (0, $4vwom.jsx)((0, $1d62341d1bbfd0c5$export$a0dcf0ef8dc3ae26), {
                            obj: props,
                            prop: "thanksYouWillReceiveAnEmail",
                            isMarkdown: true,
                            isLocalized: true,
                            style: {
                                marginBottom: 32
                            }
                        }),
                        (0, $4vwom.jsx)((0, $1d62341d1bbfd0c5$export$a0dcf0ef8dc3ae26), {
                            obj: props,
                            prop: "didntReceiveEmail",
                            isMarkdown: true,
                            isLocalized: true,
                            style: {
                                color: props.light ? (0, $9Q5xE.ColorStyles)[props.primaryColor][500] : (0, $9Q5xE.ColorStyles)[props.primaryColor][200]
                            }
                        }),
                        (0, $4vwom.jsx)("button", {
                            style: {
                                background: emailValid ? (0, $9Q5xE.ColorStyles)[props.primaryColor][500] : "#ccc6",
                                color: "white",
                                marginTop: 32,
                                border: "none",
                                padding: 8,
                                paddingLeft: 32,
                                paddingRight: 32,
                                borderRadius: 8,
                                opacity: time > 1000 ? 1 : 0,
                                transform: `translateY(${time > 1000 ? 0 : 32}px)`,
                                transition: "all 0.375s ease",
                                zIndex: 2
                            },
                            onClick: async ()=>{
                                setSent(false);
                                setHide(false);
                            },
                            children: (0, $4vwom.jsx)((0, $1d62341d1bbfd0c5$export$a0dcf0ef8dc3ae26), {
                                obj: props,
                                prop: "tryAnotherEmail",
                                isLocalized: true
                            })
                        })
                    ]
                })
            }),
            !hide && (0, $4vwom.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    height: "100%",
                    width: "100%",
                    position: "absolute"
                },
                children: (0, $4vwom.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        opacity: sent ? 0 : 1,
                        transform: sent ? `translateY(100px)` : undefined,
                        transition: "all 0.375s ease"
                    },
                    children: [
                        reason && (0, $4vwom.jsx)("div", {
                            style: {
                                color: (0, $9Q5xE.ColorStyles).error[600],
                                backgroundColor: (0, $9Q5xE.ColorStyles).error[100],
                                padding: 16,
                                borderRadius: 8,
                                marginBottom: 32,
                                maxWidth: 300,
                                textAlign: "center"
                            },
                            children: reason === "already-used" ? "The login link you used was already used. Please request a new one." : reason === "expired" ? "The login link you used was expired. Please request a new one." : reason === "invalid" ? "The login link you used was invalid." : reason
                        }, "reason"),
                        (0, $4vwom.jsx)((0, $1d62341d1bbfd0c5$export$a0dcf0ef8dc3ae26), {
                            obj: props,
                            prop: "pleaseEnterYourEmailAddress",
                            isMarkdown: true,
                            isLocalized: true,
                            style: {
                                marginBottom: 32,
                                opacity: time > 500 ? 1 : 0,
                                transform: `translateY(${time > 500 ? 0 : -32}px)`,
                                transition: "all 0.375s ease",
                                color: props.light ? (0, $9Q5xE.ColorStyles)["gray-cool"][600] : "white"
                            }
                        }),
                        (0, $4vwom.jsx)("input", {
                            className: "form-control",
                            type: "text",
                            value: email,
                            onChange: (e)=>setEmail(e.target.value),
                            onKeyDown: (e)=>{
                                if (emailValid && e.key === "Enter") sendLoginLink();
                            },
                            placeholder: "your-email@company.com",
                            autoFocus: true,
                            style: {
                                padding: 8,
                                borderRadius: 8,
                                width: 300,
                                textAlign: "center",
                                fontSize: 18,
                                border: "none",
                                background: (0, $9Q5xE.ColorStyles)["gray-cool"][100],
                                color: (0, $9Q5xE.ColorStyles)["gray-cool"][600],
                                marginBottom: 32,
                                opacity: time > 750 ? 1 : 0,
                                transform: `translateX(${time > 750 ? 0 : -32}px)`,
                                transition: "all 0.375s ease"
                            }
                        }),
                        (0, $4vwom.jsx)("button", {
                            disabled: !emailValid,
                            style: {
                                background: emailValid ? (0, $9Q5xE.ColorStyles)[props.primaryColor][500] : "#ccc6",
                                color: "white",
                                border: "none",
                                padding: 8,
                                paddingLeft: 32,
                                paddingRight: 32,
                                borderRadius: 8,
                                opacity: time > 1000 ? 1 : 0,
                                transform: `translateY(${time > 1000 ? 0 : 32}px)`,
                                transition: "all 0.375s ease"
                            },
                            onClick: sendLoginLink,
                            children: (0, $4vwom.jsx)((0, $1d62341d1bbfd0c5$export$a0dcf0ef8dc3ae26), {
                                obj: props,
                                prop: "sendMeALoginLink",
                                isLocalized: true
                            })
                        })
                    ]
                })
            }, "login")
        ]
    });
}




var $7FrRx = parcelRequire("7FrRx");


var $4vwom = parcelRequire("4vwom");

var $eK8Q4 = parcelRequire("eK8Q4");

var $dUDPg = parcelRequire("dUDPg");
function $a8ed3ba28c9b5ed3$export$61adcb461425a0d7(props) {
    var _a;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const permissions = (_a = props.permissions) !== null && _a !== void 0 ? _a : (0, $dUDPg.useWebPermissions)().data;
    const env = permissions === null || permissions === void 0 ? void 0 : permissions.environment;
    const [hideEnvironmentSticker, setHideEnvironmentSticker] = (0, $eK8Q4.useSessionState)("hideEnvironmentSticker", false);
    return env && env !== "production" && !hideEnvironmentSticker ? (0, $4vwom.jsx)("div", {
        onClick: ()=>{
            alert("This will hide the environment sticker for this session. Close the tab and reopen to see it again.");
            setHideEnvironmentSticker(true);
        },
        style: {
            position: "absolute",
            left: 0,
            top: 0,
            backgroundColor: env === "staging" ? "yellow" : "skyblue",
            width: 90,
            zIndex: 1000,
            textAlign: "center",
            transform: "translate(-25%,70%) rotate(-45deg)",
            fontSize: 12
        },
        children: env.toUpperCase()
    }) : null;
}


function $1c5aafb56c97617e$export$8fde984557d8b466(config) {
    var _a, _b, _c;
    const ErrorScreen = (_a = config.errorScreen) !== null && _a !== void 0 ? _a : (0, $5fb7d8fdb47c7fea$export$38cf3de59bf684f4);
    const { data: locales } = (0, $dUDPg.useLocales)();
    const { data: permissions } = (0, $dUDPg.useWebPermissions)();
    const defaultLocale = (_b = (0, $dUDPg.useDefaultLocale)().data) === null || _b === void 0 ? void 0 : _b.defaultLocale;
    const PageComponent = (_c = config.pageComponent) !== null && _c !== void 0 ? _c : (0, $9fe8ccb750b589bb$export$32c792df021ab666);
    if (!locales || !permissions || !defaultLocale) return null;
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsx)((0, $a8ed3ba28c9b5ed3$export$61adcb461425a0d7), {
                permissions: permissions
            }),
            (0, $4vwom.jsxs)((0, $ikBJm.ModalProvider), {
                children: [
                    config.globalStyles ? (0, $4vwom.jsx)((0, $lhaLc.Global), {
                        styles: config.globalStyles
                    }) : null,
                    (0, $4vwom.jsx)((0, $gssTr.LocalesContext).Provider, {
                        value: locales,
                        children: (0, $4vwom.jsxs)((0, $18Pjr.Routes), {
                            children: [
                                config.studio && (0, $f6fc29e20a2ebf5b$export$83fb124b13439b08)(config.studioPlugins),
                                config.gallery && (0, $a2a649cb2a0219fd$export$ace63239d21d36e)(),
                                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                    path: "/login",
                                    element: config.renderLogin ? config.renderLogin() : (0, $4vwom.jsx)((0, $de0ebc18cc685286$export$21a94553ffa41578), {})
                                }),
                                (0, $4vwom.jsxs)((0, $18Pjr.Route), {
                                    element: (0, $4vwom.jsx)((0, $4vwom.Fragment), {
                                        children: (0, $4vwom.jsx)((0, $bc2d4ca19ef81dfc$export$e2ae8835b525498d), {
                                            condition: !!permissions.canEditWebsite,
                                            plugins: config.studioPlugins
                                        })
                                    }),
                                    children: [
                                        locales.map((l)=>{
                                            var _a, _b, _c, _d;
                                            return l.key === defaultLocale ? (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                element: (0, $4vwom.jsxs)((0, $7FrRx.CurrentLocaleContext).Provider, {
                                                    value: {
                                                        get locale () {
                                                            return l.key;
                                                        }
                                                    },
                                                    children: [
                                                        (_b = (_a = config.renderCookieConsentView) === null || _a === void 0 ? void 0 : _a.call(config)) !== null && _b !== void 0 ? _b : (0, $4vwom.jsx)((0, $ff100056042ab63c$export$27cef3a4b5908de4), {}),
                                                        (0, $4vwom.jsx)((0, $18Pjr.Outlet), {})
                                                    ]
                                                }),
                                                children: (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                            index: true,
                                                            element: (0, $4vwom.jsx)(PageComponent, {
                                                                errorScreen: ErrorScreen,
                                                                EditableSectionsProps: config.EditableSectionsProps,
                                                                locale: l.key
                                                            })
                                                        }),
                                                        (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                            path: "/:slug",
                                                            element: (0, $4vwom.jsx)(PageComponent, {
                                                                errorScreen: ErrorScreen,
                                                                locale: l.key,
                                                                EditableSectionsProps: config.EditableSectionsProps
                                                            })
                                                        })
                                                    ]
                                                }, l.key.toString())
                                            }, l.key.valueOf()) : (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                element: (0, $4vwom.jsxs)((0, $7FrRx.CurrentLocaleContext).Provider, {
                                                    value: {
                                                        get locale () {
                                                            return l.key;
                                                        }
                                                    },
                                                    children: [
                                                        (_d = (_c = config.renderCookieConsentView) === null || _c === void 0 ? void 0 : _c.call(config)) !== null && _d !== void 0 ? _d : (0, $4vwom.jsx)((0, $ff100056042ab63c$export$27cef3a4b5908de4), {}),
                                                        (0, $4vwom.jsx)((0, $18Pjr.Outlet), {})
                                                    ]
                                                }),
                                                children: (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                            index: true,
                                                            path: `/${l.key.toString()}`,
                                                            element: (0, $4vwom.jsx)(PageComponent, {
                                                                errorScreen: ErrorScreen,
                                                                EditableSectionsProps: config.EditableSectionsProps,
                                                                locale: l.key
                                                            })
                                                        }),
                                                        (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                            path: `/${l.key.toString()}/:slug`,
                                                            element: (0, $4vwom.jsx)(PageComponent, {
                                                                errorScreen: ErrorScreen,
                                                                EditableSectionsProps: config.EditableSectionsProps,
                                                                locale: l.key
                                                            })
                                                        })
                                                    ]
                                                }, l.key.toString())
                                            }, l.key.valueOf());
                                        }),
                                        config.children,
                                        (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                            path: "*",
                                            element: (0, $4vwom.jsx)(ErrorScreen, {
                                                error: {
                                                    status: 404,
                                                    type: "Not found",
                                                    detail: "No page exists at this path"
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}



var $eeH7J = parcelRequire("eeH7J");
parcelRequire("5K1mb");
var $18Pjr = parcelRequire("18Pjr");

var $dUDPg = parcelRequire("dUDPg");
function $1685c589a1400a85$export$61e35ff362657020() {
    const location = (0, $18Pjr.useLocation)();
    // This should be resolved at SSR time so in practice, if analytics is
    // disabled, no API calls will be made by this hook.
    const status = (0, $dUDPg.useAnalyticsEventStatus)("web");
    const [disabled, setDisabled] = (0, $eeH7J.useState)(status.data ? status.data.disabled : false);
    (0, $eeH7J.useEffect)(()=>{
        async function postIt() {
            const path = location.pathname.split("/").filter((p)=>p !== "");
            const res = await (0, $dUDPg.postAnalyticsEvent)("web", {
                entity: path.slice(0, 4)
            });
            if ("disabled" in res && res.disabled) // Analytics is disabled, so we should disable the logger
            setDisabled(true);
        }
        if (!disabled) postIt();
    }, [
        location.pathname,
        disabled
    ]);
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5K1mb = parcelRequire("5K1mb");

var $aIeEI = parcelRequire("aIeEI");







var $lhaLc = parcelRequire("lhaLc");


function $40092465e16f7bc3$export$c10f6b7a0de7b58a(props) {
    const l = (0, $aIeEI.useLocalize)();
    const page = (0, $e18f565b44c7bc7d$export$61180300cc91551d)();
    const [searchParams] = (0, $5K1mb.useSearchParams)();
    const [errorMessage, setErrorMessage] = (0, $eeH7J.useState)();
    const [success, setSuccess] = (0, $eeH7J.useState)(false);
    const id = searchParams.get("id");
    const { locale: locale } = props;
    const localize = (val)=>l(val, locale);
    const handleUnsubscribeClick = (0, $eeH7J.useCallback)(async ()=>{
        if (id && page.data) try {
            await (0, $e18f565b44c7bc7d$export$bc4051c7d3b69526)({
                id: id
            });
            setSuccess(true);
        } catch (err) {
            setErrorMessage(page.data.errorMessage);
        }
    }, [
        id,
        page.data
    ]);
    if (!page.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        padding: {
            x: 24
        },
        children: [
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                style: {
                    height: (0, $756948b644e82cf2$export$981516ee4691055c)(100)
                },
                children: (0, $4vwom.jsx)((0, $67cf5539992d1dd3$export$e6ff31bff12b7ff4), {
                    css: (0, $lhaLc.css)({
                        width: (0, $756948b644e82cf2$export$981516ee4691055c)(114),
                        height: "auto",
                        marginRight: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                    })
                })
            }),
            (0, $4vwom.jsxs)("div", {
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        margin: {
                            bottom: "sm"
                        },
                        children: localize(page.data.heading)
                    }),
                    !id ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: localize(page.data.missingParameterMessage)
                    }) : success ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: localize(page.data.successMessage)
                    }) : (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                        children: [
                            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(page.data.text)
                            }),
                            errorMessage ? (0, $4vwom.jsx)((0, $a9f507254d800340$export$fbbf1dbfdbfcef12), {
                                children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                    value: localize(errorMessage)
                                })
                            }) : null,
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                variant: "dark",
                                onClick: handleUnsubscribeClick,
                                children: localize(page.data.buttonText)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $34lt5 = parcelRequire("34lt5");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $dUDPg = parcelRequire("dUDPg");









var $aIeEI = parcelRequire("aIeEI");


var $5K1mb = parcelRequire("5K1mb");
function $8d4f21e1d9bbd8d8$export$27cef3a4b5908de4() {
    var _a, _b, _c, _d, _e, _f;
    const { data: data, refresh: refresh } = (0, $dUDPg.useCookieConsents)();
    const localize = (0, $aIeEI.useLocalize)();
    const [necessary, setNecessary] = (0, $eeH7J.useState)(true);
    const [preferences, setPreferences] = (0, $eeH7J.useState)(false);
    const [statistics, setStatistics] = (0, $eeH7J.useState)(false);
    const [marketing, setMarketing] = (0, $eeH7J.useState)(false);
    const [isCustomize, setIsCustomize] = (0, $eeH7J.useState)(false);
    const defaultRef = (0, $eeH7J.useRef)(null);
    const customizeRef = (0, $eeH7J.useRef)(null);
    const privacyPolicyPageInfo = (0, $dUDPg.useWebPageInfo)((_b = (_a = data === null || data === void 0 ? void 0 : data.info) === null || _a === void 0 ? void 0 : _a.privacyPolicyPage) !== null && _b !== void 0 ? _b : null);
    const handleAllowAllClick = (0, $eeH7J.useCallback)(async ()=>{
        await (0, $dUDPg.putCookieConsents)({
            necessary: true,
            marketing: true,
            preferences: true,
            statistics: true
        });
        if (GiveCookieConsent) {
            // Calling GiveCookieConsent will execute all
            // callbacks registered with WithCookieConsent for
            // the specified type. This allows the consents to
            // take effect without reloading the page.
            GiveCookieConsent("necessary");
            GiveCookieConsent("marketing");
            GiveCookieConsent("preferences");
            GiveCookieConsent("statistics");
        }
        await refresh();
    }, [
        refresh
    ]);
    const handleDenyClick = (0, $eeH7J.useCallback)(async ()=>{
        await (0, $dUDPg.putCookieConsents)({
            necessary: true,
            marketing: false,
            preferences: false,
            statistics: false
        });
        await refresh();
        if (GiveCookieConsent) GiveCookieConsent("necessary");
    }, [
        refresh
    ]);
    const handleAllowSelectionClick = (0, $eeH7J.useCallback)(async ()=>{
        await (0, $dUDPg.putCookieConsents)({
            necessary: true,
            marketing: marketing,
            preferences: preferences,
            statistics: statistics
        });
        await refresh();
        if (GiveCookieConsent && necessary) GiveCookieConsent("necessary");
        if (GiveCookieConsent && preferences) GiveCookieConsent("preferences");
        if (GiveCookieConsent && statistics) GiveCookieConsent("statistics");
        if (GiveCookieConsent && marketing) GiveCookieConsent("marketing");
    }, [
        marketing,
        preferences,
        statistics,
        refresh,
        necessary
    ]);
    return (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
        children: (data === null || data === void 0 ? void 0 : data.consents) || !(data === null || data === void 0 ? void 0 : data.info) ? (0, $4vwom.jsx)((0, $4vwom.Fragment), {}) : (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            css: $8d4f21e1d9bbd8d8$var$popupCss,
            backgroundColor: "grayWhite",
            borderRadius: "lg",
            elevation: true,
            direction: "column",
            motion: {
                transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                initial: {
                    transform: "translateY(50px)",
                    scale: 0.75,
                    opacity: 0
                },
                animate: {
                    transform: "translateY(0px)",
                    scale: 1,
                    opacity: 1
                },
                exit: {
                    opacity: 0
                }
            },
            children: [
                (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    animate: isCustomize ? {
                        translateY: ((_d = (_c = defaultRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight) !== null && _d !== void 0 ? _d : 0) * -1,
                        opacity: 0,
                        height: 0
                    } : {},
                    children: (0, $4vwom.jsxs)("div", {
                        ref: defaultRef,
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: [
                                    "fixed",
                                    "md",
                                    3
                                ],
                                style: {
                                    marginBottom: 16
                                },
                                children: localize(data.info.title)
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: localize(data.info.description)
                            }),
                            ((_e = privacyPolicyPageInfo.data) === null || _e === void 0 ? void 0 : _e.slug) && privacyPolicyPageInfo.data.title ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                style: {
                                    marginTop: 8,
                                    marginBottom: 24
                                },
                                children: (0, $4vwom.jsx)((0, $5K1mb.Link), {
                                    to: `/${localize(privacyPolicyPageInfo.data.slug)}`,
                                    children: localize(privacyPolicyPageInfo.data.title)
                                })
                            }) : null,
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                margin: {
                                    top: 16
                                },
                                children: [
                                    (0, $4vwom.jsx)("div", {
                                        style: {
                                            flex: "1 0 0"
                                        },
                                        children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                            size: "sm",
                                            variant: "secondary",
                                            fullwidth: true,
                                            onClick: ()=>setIsCustomize(true),
                                            children: localize(data.info.customize)
                                        })
                                    }),
                                    (0, $4vwom.jsx)("div", {
                                        style: {
                                            marginLeft: 8,
                                            flex: "1 0 0"
                                        },
                                        children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                            size: "sm",
                                            onClick: handleAllowAllClick,
                                            fullwidth: true,
                                            children: localize(data.info.allowAll)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    initial: {
                        height: 0,
                        overflow: "hidden",
                        opacity: 0
                    },
                    animate: isCustomize ? {
                        height: (_f = customizeRef.current) === null || _f === void 0 ? void 0 : _f.clientHeight,
                        opacity: 1
                    } : {},
                    children: (0, $4vwom.jsxs)("div", {
                        ref: customizeRef,
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: [
                                    "fixed",
                                    "md",
                                    3
                                ],
                                style: {
                                    marginBottom: 16
                                },
                                children: localize(data.info.customize)
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                as: "label",
                                margin: {
                                    bottom: 16
                                },
                                direction: "column",
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: {
                                            bottom: 8
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "lg",
                                                children: localize(data.info.necessary)
                                            }),
                                            (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                                disabled: true,
                                                checked: necessary,
                                                onChange: (e)=>setNecessary(e.target.checked)
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: localize(data.info.necessaryDescription)
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 16
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                as: "label",
                                margin: {
                                    bottom: 16
                                },
                                direction: "column",
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: {
                                            bottom: 8
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "lg",
                                                children: localize(data.info.preferences)
                                            }),
                                            (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                                checked: preferences,
                                                onChange: (e)=>setPreferences(e.target.checked)
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: localize(data.info.preferencesDescription)
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 16
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                as: "label",
                                margin: {
                                    bottom: 16
                                },
                                direction: "column",
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: {
                                            bottom: 8
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "lg",
                                                children: localize(data.info.statistics)
                                            }),
                                            (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                                checked: statistics,
                                                onChange: (e)=>setStatistics(e.target.checked)
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: localize(data.info.statisticsDescription)
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 16
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                as: "label",
                                margin: {
                                    bottom: 16
                                },
                                direction: "column",
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: {
                                            bottom: 8
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "lg",
                                                children: localize(data.info.marketing)
                                            }),
                                            (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                                checked: marketing,
                                                onChange: (e)=>setMarketing(e.target.checked)
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: localize(data.info.marketingDescription)
                                    })
                                ]
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                margin: {
                                    top: 16
                                },
                                children: [
                                    (0, $4vwom.jsx)("div", {
                                        style: {
                                            flex: "1 0 0"
                                        },
                                        children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                            size: "sm",
                                            variant: "secondary",
                                            fullwidth: true,
                                            onClick: handleDenyClick,
                                            children: localize(data.info.deny)
                                        })
                                    }),
                                    (0, $4vwom.jsx)("div", {
                                        style: {
                                            marginLeft: 8,
                                            flex: "1 0 0"
                                        },
                                        children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                            size: "sm",
                                            onClick: handleAllowSelectionClick,
                                            fullwidth: true,
                                            children: localize(data.info.allowSelection)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        }, "cookie-consent-view")
    });
}
const $8d4f21e1d9bbd8d8$var$popupCss = (0, $lhaLc.css)((0, $lhaLc.css)`
        z-index: 3000000000; // Extreme z-index to get above Intercom at 2147483000.
        position: fixed;
        bottom: ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingBottom}px;
        left: ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px;
        right: ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px;
        padding: 16px;
        overflow: hidden;
    `, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", (0, $lhaLc.css)`
            width: 400px;
        `), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", (0, $lhaLc.css)`
            bottom: ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).md.paddingBottom}px;
            left: ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).md.paddingLeft}px;
            padding: 24px;
            width: 400px;
        `));




var $501397ab7dd8f562$exports = {};
"use strict";
var $501397ab7dd8f562$var$__rest = $501397ab7dd8f562$exports && $501397ab7dd8f562$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($501397ab7dd8f562$exports, "__esModule", {
    value: true
});
$501397ab7dd8f562$exports.onUserEmailSupplied = $501397ab7dd8f562$exports.showConversation = $501397ab7dd8f562$exports.showTicket = $501397ab7dd8f562$exports.startChecklist = $501397ab7dd8f562$exports.startSurvey = $501397ab7dd8f562$exports.showNews = $501397ab7dd8f562$exports.showArticle = $501397ab7dd8f562$exports.startTour = $501397ab7dd8f562$exports.getVisitorId = $501397ab7dd8f562$exports.trackEvent = $501397ab7dd8f562$exports.onUnreadCountChange = $501397ab7dd8f562$exports.onShow = $501397ab7dd8f562$exports.onHide = $501397ab7dd8f562$exports.showNewMessage = $501397ab7dd8f562$exports.showMessages = $501397ab7dd8f562$exports.showSpace = $501397ab7dd8f562$exports.show = $501397ab7dd8f562$exports.hide = $501397ab7dd8f562$exports.update = $501397ab7dd8f562$exports.shutdown = $501397ab7dd8f562$exports.boot = $501397ab7dd8f562$exports.Intercom = void 0;
var $cb398febf310f866$exports = {};
"use strict";
Object.defineProperty($cb398febf310f866$exports, "__esModule", {
    value: true
});
$cb398febf310f866$exports.regionAPIs = void 0;
$cb398febf310f866$exports.regionAPIs = new Map([
    [
        "us",
        "https://api-iam.intercom.io"
    ],
    [
        "eu",
        "https://api-iam.eu.intercom.io"
    ],
    [
        "ap",
        "https://api-iam.au.intercom.io"
    ]
]);


var $27cc9c13607bafed$exports = {};
"use strict";
var $27cc9c13607bafed$var$__awaiter = $27cc9c13607bafed$exports && $27cc9c13607bafed$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty($27cc9c13607bafed$exports, "__esModule", {
    value: true
});
$27cc9c13607bafed$exports.ref = $27cc9c13607bafed$exports.init = void 0;
const $27cc9c13607bafed$var$scriptElementId = "_intercom_npm_loader";
// This holds a queue of commands to be passed to the messenger widget API after it is added to the page
const $27cc9c13607bafed$var$queueHolder = function() {
    $27cc9c13607bafed$var$queueHolder.loaderQueue(arguments);
};
$27cc9c13607bafed$var$queueHolder.q = [];
$27cc9c13607bafed$var$queueHolder.loaderQueue = function(args) {
    $27cc9c13607bafed$var$queueHolder.q.push(args);
};
const $27cc9c13607bafed$var$addWidgetToPage = function() {
    var _a, _b;
    var d = document;
    if (d.getElementById($27cc9c13607bafed$var$scriptElementId)) // script is already in DOM
    return;
    var s = d.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.id = $27cc9c13607bafed$var$scriptElementId;
    s.src = "https://widget.intercom.io/widget/" + ((_a = window.intercomSettings) === null || _a === void 0 ? void 0 : _a.app_id);
    var x = d.getElementsByTagName("script")[0];
    (_b = x.parentNode) === null || _b === void 0 || _b.insertBefore(s, x);
};
const $27cc9c13607bafed$var$isDocumentReady = ()=>document.readyState === "complete" || document.readyState === "interactive";
const $27cc9c13607bafed$var$init = ()=>$27cc9c13607bafed$var$__awaiter(void 0, void 0, void 0, function*() {
        var w = window;
        var ic = w.Intercom;
        if (w.intercomSettings) w.intercomSettings.installation_type = "npm-package";
        if (typeof ic === "function") {
            ic("reattach_activator");
            ic("update", w.intercomSettings);
        } else {
            w.Intercom = $27cc9c13607bafed$var$queueHolder;
            if ($27cc9c13607bafed$var$isDocumentReady()) $27cc9c13607bafed$var$addWidgetToPage();
            else {
                document.addEventListener("readystatechange", function() {
                    if ($27cc9c13607bafed$var$isDocumentReady()) $27cc9c13607bafed$var$addWidgetToPage();
                });
                if (w.attachEvent) w.attachEvent("onload", $27cc9c13607bafed$var$addWidgetToPage);
                else w.addEventListener("load", $27cc9c13607bafed$var$addWidgetToPage, false);
            }
        }
    });
$27cc9c13607bafed$exports.init = $27cc9c13607bafed$var$init;
$27cc9c13607bafed$exports.ref = undefined;


const $501397ab7dd8f562$var$callIntercomMethod = (method, ...args)=>{
    // window is undefined on server-side and this breaks our widget
    if (0, window.Intercom) window.Intercom(method, ...args);
    else console.warn("Please ensure Intercom is setup and running on client-side!");
};
const $501397ab7dd8f562$var$Intercom = (props)=>{
    if (typeof props !== "object") {
        console.warn("Intercom initialiser called with invalid parameters.");
        return;
    }
    const { region: region = "us" } = props, args = $501397ab7dd8f562$var$__rest(props, [
        "region"
    ]);
    if (typeof window !== "undefined" && !$27cc9c13607bafed$exports.ref) {
        window.intercomSettings = Object.assign(Object.assign({}, args), {
            api_base: $cb398febf310f866$exports.regionAPIs.get(region)
        });
        (0, $27cc9c13607bafed$exports.init)();
    }
};
$501397ab7dd8f562$exports.Intercom = $501397ab7dd8f562$var$Intercom;
// Public functions that can be called from outside the module
$501397ab7dd8f562$exports.default = $501397ab7dd8f562$exports.Intercom;
const $501397ab7dd8f562$var$boot = (arg)=>$501397ab7dd8f562$var$callIntercomMethod("boot", arg);
$501397ab7dd8f562$exports.boot = $501397ab7dd8f562$var$boot;
const $501397ab7dd8f562$var$shutdown = ()=>$501397ab7dd8f562$var$callIntercomMethod("shutdown");
$501397ab7dd8f562$exports.shutdown = $501397ab7dd8f562$var$shutdown;
const $501397ab7dd8f562$var$update = (arg)=>$501397ab7dd8f562$var$callIntercomMethod("update", arg);
$501397ab7dd8f562$exports.update = $501397ab7dd8f562$var$update;
const $501397ab7dd8f562$var$hide = ()=>$501397ab7dd8f562$var$callIntercomMethod("hide");
$501397ab7dd8f562$exports.hide = $501397ab7dd8f562$var$hide;
const $501397ab7dd8f562$var$show = ()=>$501397ab7dd8f562$var$callIntercomMethod("show");
$501397ab7dd8f562$exports.show = $501397ab7dd8f562$var$show;
const $501397ab7dd8f562$var$showSpace = (spaceName)=>$501397ab7dd8f562$var$callIntercomMethod("showSpace", spaceName);
$501397ab7dd8f562$exports.showSpace = $501397ab7dd8f562$var$showSpace;
const $501397ab7dd8f562$var$showMessages = ()=>$501397ab7dd8f562$var$callIntercomMethod("showMessages");
$501397ab7dd8f562$exports.showMessages = $501397ab7dd8f562$var$showMessages;
const $501397ab7dd8f562$var$showNewMessage = (prePopulatedContent)=>$501397ab7dd8f562$var$callIntercomMethod("showNewMessage", prePopulatedContent);
$501397ab7dd8f562$exports.showNewMessage = $501397ab7dd8f562$var$showNewMessage;
const $501397ab7dd8f562$var$onHide = (callback)=>$501397ab7dd8f562$var$callIntercomMethod("onHide", callback);
$501397ab7dd8f562$exports.onHide = $501397ab7dd8f562$var$onHide;
const $501397ab7dd8f562$var$onShow = (callback)=>$501397ab7dd8f562$var$callIntercomMethod("onShow", callback);
$501397ab7dd8f562$exports.onShow = $501397ab7dd8f562$var$onShow;
const $501397ab7dd8f562$var$onUnreadCountChange = (callback)=>$501397ab7dd8f562$var$callIntercomMethod("onUnreadCountChange", callback);
$501397ab7dd8f562$exports.onUnreadCountChange = $501397ab7dd8f562$var$onUnreadCountChange;
const $501397ab7dd8f562$var$trackEvent = (...args)=>$501397ab7dd8f562$var$callIntercomMethod("trackEvent", ...args);
$501397ab7dd8f562$exports.trackEvent = $501397ab7dd8f562$var$trackEvent;
const $501397ab7dd8f562$var$getVisitorId = ()=>$501397ab7dd8f562$var$callIntercomMethod("getVisitorId");
$501397ab7dd8f562$exports.getVisitorId = $501397ab7dd8f562$var$getVisitorId;
const $501397ab7dd8f562$var$startTour = (tourId)=>$501397ab7dd8f562$var$callIntercomMethod("startTour", tourId);
$501397ab7dd8f562$exports.startTour = $501397ab7dd8f562$var$startTour;
const $501397ab7dd8f562$var$showArticle = (articleId)=>$501397ab7dd8f562$var$callIntercomMethod("showArticle", articleId);
$501397ab7dd8f562$exports.showArticle = $501397ab7dd8f562$var$showArticle;
const $501397ab7dd8f562$var$showNews = (newsItemId)=>$501397ab7dd8f562$var$callIntercomMethod("showNews", newsItemId);
$501397ab7dd8f562$exports.showNews = $501397ab7dd8f562$var$showNews;
const $501397ab7dd8f562$var$startSurvey = (surveyId)=>$501397ab7dd8f562$var$callIntercomMethod("startSurvey", surveyId);
$501397ab7dd8f562$exports.startSurvey = $501397ab7dd8f562$var$startSurvey;
const $501397ab7dd8f562$var$startChecklist = (checklistId)=>$501397ab7dd8f562$var$callIntercomMethod("startChecklist", checklistId);
$501397ab7dd8f562$exports.startChecklist = $501397ab7dd8f562$var$startChecklist;
const $501397ab7dd8f562$var$showTicket = (ticketId)=>$501397ab7dd8f562$var$callIntercomMethod("showTicket", ticketId);
$501397ab7dd8f562$exports.showTicket = $501397ab7dd8f562$var$showTicket;
const $501397ab7dd8f562$var$showConversation = (conversationId)=>$501397ab7dd8f562$var$callIntercomMethod("showConversation", conversationId);
$501397ab7dd8f562$exports.showConversation = $501397ab7dd8f562$var$showConversation;
const $501397ab7dd8f562$var$onUserEmailSupplied = (callback)=>$501397ab7dd8f562$var$callIntercomMethod("onUserEmailSupplied", callback);
$501397ab7dd8f562$exports.onUserEmailSupplied = $501397ab7dd8f562$var$onUserEmailSupplied;



var $4vwom = parcelRequire("4vwom");

var $18Pjr = parcelRequire("18Pjr");

var $lhaLc = parcelRequire("lhaLc");


var $cSf8f = parcelRequire("cSf8f");


const $219dea6263a37832$var$styles = `
@page {
    /* General print page margin */
    margin: 20mm;
}

@media print {
    body {
        font-size: 12px;
    }

    h1 {
        font-size: 2em;
    }
    
    h2 {
        margin-top: 1.6em;
        font-size: 1.6em;
    }
    
    h3 {
        font-size: 1.4em;
    }
}

@media screen {
    body {
        margin: 20px; /* Set margin for screen */
        max-width: 800px;
        font-size: 16px;
    }
}
    h1 {
        font-size: 2em;
        margin-top: 32px;
    }

    h2 {
        margin-top: 24px;
        font-size: 2em;
    }
`;
function $219dea6263a37832$export$71c56c718a357b5() {
    var _a, _b, _c, _d, _e, _f, _g;
    const orderId = (0, $18Pjr.useParams)().id;
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveHeadingCss: responsiveHeadingCss } = helpers;
    const order = (0, $e18f565b44c7bc7d$export$42d4e273b2226793)((_a = orderId) !== null && _a !== void 0 ? _a : null);
    if (!order.data) return null;
    const { user: user, model: model, colorDisplayName: colorDisplayName, storageDisplayName: storageDisplayName, gradeDisplayName: gradeDisplayName, invoiceDateOfMonth: invoiceDateOfMonth, shippingAddress: shippingAddress, shippingSlot: shippingSlot, rentalPeriods: rentalPeriods, rentalPeriod: rentalPeriod } = order.data;
    return (0, $4vwom.jsxs)("div", {
        css: {
            h1: (0, $lhaLc.css)(responsiveHeadingCss(1), {
                marginBottom: ".4em",
                marginTop: ".4em"
            }),
            h2: (0, $lhaLc.css)(responsiveHeadingCss(2), {
                marginBottom: ".4em",
                marginTop: ".4em"
            }),
            h3: (0, $lhaLc.css)(responsiveHeadingCss(3), {
                marginBottom: ".4em",
                marginTop: ".4em"
            }),
            h4: (0, $lhaLc.css)(responsiveHeadingCss(4), {
                marginBottom: ".4em",
                marginTop: ".4em"
            })
        },
        style: {
            display: "flex",
            justifyContent: "center"
        },
        children: [
            (0, $4vwom.jsx)("style", {
                children: $219dea6263a37832$var$styles
            }),
            (0, $4vwom.jsxs)("div", {
                style: {
                    maxWidth: 800
                },
                children: [
                    (0, $4vwom.jsxs)("div", {
                        style: {
                            pageBreakAfter: "always",
                            marginBottom: 64
                        },
                        children: [
                            (0, $4vwom.jsx)("img", {
                                src: "/static/redoit-black.svg",
                                style: {
                                    width: 200,
                                    marginTop: 64
                                }
                            }),
                            (0, $4vwom.jsx)("h2", {
                                children: "Ordreskjema"
                            }),
                            (0, $4vwom.jsx)("h3", {
                                style: {
                                    fontWeight: 600
                                },
                                children: "Kontaktinformasjon"
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Navn",
                                value: `${user.givenName} ${user.familyName}`
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Telefonnummer",
                                value: (_b = user.phoneNumber) === null || _b === void 0 ? void 0 : _b.valueOf()
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "E-post",
                                value: (_c = user.email) === null || _c === void 0 ? void 0 : _c.valueOf()
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Adresse",
                                value: `${(_d = user.address) === null || _d === void 0 ? void 0 : _d.street}, ${(_e = user.address) === null || _e === void 0 ? void 0 : _e.zip} ${(_f = user.address) === null || _f === void 0 ? void 0 : _f.city}`
                            }),
                            (0, $4vwom.jsx)("h3", {
                                style: {
                                    fontWeight: 600
                                },
                                children: "Beskrivelse av Utstyret"
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Modell",
                                value: model.name
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Farge",
                                value: colorDisplayName
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Lagring",
                                value: storageDisplayName
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Tilstandsgrad",
                                value: gradeDisplayName
                            }),
                            (0, $4vwom.jsx)("h3", {
                                style: {
                                    fontWeight: 600
                                },
                                children: "Pris og varighet"
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "M\xe5nedsbel\xf8p",
                                value: `kr ${(_g = rentalPeriods[rentalPeriods.length - 1]) === null || _g === void 0 ? void 0 : _g.monthlyPrice.itemsTotal.majorUnits}`
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Faktureringsdato",
                                value: `M\xe5nedlig den ${invoiceDateOfMonth}.`
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Bindingstid",
                                value: `${rentalPeriod.months} m\xe5neder`
                            }),
                            (0, $4vwom.jsx)("h3", {
                                style: {
                                    fontWeight: 600
                                },
                                children: "Levering av Utstyret"
                            }),
                            shippingSlot ? (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Leveringsdato",
                                value: shippingSlot.startDate.valueOf()
                            }) : null,
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Leveringsadresse",
                                value: `${shippingAddress.street}, ${shippingAddress.zip} ${shippingAddress.city}`
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)($219dea6263a37832$export$556363f0b1068104, {})
                ]
            })
        ]
    });
}
function $219dea6263a37832$export$66802dd86d4b9603() {
    const r = (0, $e18f565b44c7bc7d$export$23e8c26267d65867)();
    if (!r.data) return null;
    return (0, $4vwom.jsxs)("div", {
        style: {
            maxWidth: 800
        },
        children: [
            (0, $4vwom.jsx)("style", {
                children: $219dea6263a37832$var$styles
            }),
            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                value: r.data.insurance.content
            })
        ]
    });
}
function $219dea6263a37832$export$556363f0b1068104() {
    const r = (0, $e18f565b44c7bc7d$export$23e8c26267d65867)();
    if (!r.data) return null;
    return (0, $4vwom.jsxs)("div", {
        style: {
            maxWidth: 800
        },
        children: [
            (0, $4vwom.jsx)("style", {
                children: $219dea6263a37832$var$styles
            }),
            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                value: r.data.phoneOrder.content
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    pageBreakAfter: "always"
                }
            }),
            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                value: r.data.insurance.content
            })
        ]
    });
}
function $219dea6263a37832$var$Row({ label: label, value: value }) {
    return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-strt"
        },
        children: [
            (0, $4vwom.jsxs)("div", {
                style: {
                    fontWeight: "bold",
                    marginRight: 16,
                    width: 200
                },
                children: [
                    label,
                    ": "
                ]
            }),
            (0, $4vwom.jsx)("div", {
                children: typeof value === "object" ? (0, $cSf8f.ClientSideLocalize)(value) : value
            })
        ]
    });
}





function $ca337ff74984d5af$var$sectionItemCss() {
    return (0, $lhaLc.css)({
        margin: "0 auto",
        // Override Bootstrap line height variable.
        "--bs-body-line-height": "1",
        lineHeight: "1"
    }, (0, $756948b644e82cf2$export$629e292a677297c2)());
}

function $ca337ff74984d5af$export$86fbec116b87613f() {
    (0, $1685c589a1400a85$export$61e35ff362657020)();
    return (0, $4vwom.jsx)((0, $dc53c17a4a911fba$export$d8964aec282183a3), {
        theme: (0, $756948b644e82cf2$export$92c840cda8ec752c),
        children: (0, $4vwom.jsxs)((0, $1c5aafb56c97617e$export$8fde984557d8b466), {
            gallery: true,
            studio: true,
            studioPlugins: async ()=>{
                await (parcelRequire("joIUH"));
            },
            globalStyles: (0, $756948b644e82cf2$export$aa0e86c7c0d2f400),
            EditableSectionsProps: {
                itemCss: $ca337ff74984d5af$var$sectionItemCss
            },
            pageComponent: $ca337ff74984d5af$var$RedoitPage,
            renderCookieConsentView: ()=>(0, $4vwom.jsx)((0, $8d4f21e1d9bbd8d8$export$27cef3a4b5908de4), {}),
            errorScreen: ()=>(0, $4vwom.jsx)((0, $b97c03a91b0e5a47$export$c120a0e80fd44ca6), {}),
            children: [
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "/terms-and-conditions/phone-order/:id",
                    element: (0, $4vwom.jsx)((0, $219dea6263a37832$export$71c56c718a357b5), {})
                }),
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "/terms-and-conditions/phone-protection-plan",
                    element: (0, $4vwom.jsx)((0, $219dea6263a37832$export$66802dd86d4b9603), {})
                }),
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "/terms-and-conditions/phone-order",
                    element: (0, $4vwom.jsx)((0, $219dea6263a37832$export$556363f0b1068104), {})
                }),
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "/system/nyhetsbrev-meld-av",
                    element: (0, $4vwom.jsx)((0, $40092465e16f7bc3$export$c10f6b7a0de7b58a), {
                        locale: (0, $34lt5.LocaleKey).no
                    })
                }),
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "/system/en/newsletter-unsubscribe",
                    element: (0, $4vwom.jsx)((0, $40092465e16f7bc3$export$c10f6b7a0de7b58a), {
                        locale: (0, $34lt5.LocaleKey).en
                    })
                })
            ]
        })
    });
}
function $ca337ff74984d5af$var$RedoitPage(props) {
    var _a, _b;
    const user = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    if (user.data && user.data.anonymous === false) (0, (/*@__PURE__*/$parcel$interopDefault($501397ab7dd8f562$exports)))({
        app_id: "wve6w27x",
        user_id: (_a = user.data.id) === null || _a === void 0 ? void 0 : _a.valueOf(),
        name: `${user.data.givenName} ${user.data.familyName}`,
        email: (_b = user.data.email) === null || _b === void 0 ? void 0 : _b.valueOf(),
        created_at: user.data.createdAt
    });
    else (0, (/*@__PURE__*/$parcel$interopDefault($501397ab7dd8f562$exports)))({
        app_id: "wve6w27x"
    });
    return (0, $4vwom.jsx)((0, $9fe8ccb750b589bb$export$32c792df021ab666), Object.assign({}, props));
}



var $9Q5xE = parcelRequire("9Q5xE");

var $5gIPd = parcelRequire("5gIPd");
(0, $9Q5xE.ColorStyles).primary = (0, $9Q5xE.ColorStyles).teal;
(0, $5gIPd.SidebarTheme).light = false;
(0, $5gIPd.SidebarTheme).background = "#130722";



(0, $19ea5142dc1f8ebf$export$e547c4fd78449aad)(()=>(0, $4vwom.jsx)((0, $4DHNO.Login), {
        always: false,
        tokenReady: (token)=>{
            (0, $e18f565b44c7bc7d$export$ebe90cb607ad99e).headers.Authorization = `Bearer ${token}`;
            (0, $dUDPg.defaults).headers.Authorization = `Bearer ${token}`;
        },
        clearTokens: ()=>{
            (0, $e18f565b44c7bc7d$export$ebe90cb607ad99e).headers.Authorization = "";
            (0, $dUDPg.defaults).headers.Authorization = "";
        },
        login: async (defaultLogin, returnTo, error)=>{
            if ((error === null || error === void 0 ? void 0 : error.type) === "UnauthorizedWithVipps") {
                if (await (0, $f2e2333c5543d6d8$export$5eda4f58d84268b6)(returnTo !== null && returnTo !== void 0 ? returnTo : "/", returnTo !== null && returnTo !== void 0 ? returnTo : "/")) return;
                else window.history.back();
            } else defaultLogin(returnTo);
        },
        children: (0, $4vwom.jsx)((0, $5K1mb.BrowserRouter), {
            children: (0, $4vwom.jsx)((0, $ca337ff74984d5af$export$86fbec116b87613f), {})
        })
    }));


//# sourceMappingURL=index.c646167d.js.map
